export const dmaData = {
  "10001": {
    DMA: 501,
  },
  "10002": {
    DMA: 501,
  },
  "10003": {
    DMA: 501,
  },
  "10004": {
    DMA: 501,
  },
  "10005": {
    DMA: 501,
  },
  "10006": {
    DMA: 501,
  },
  "10007": {
    DMA: 501,
  },
  "10008": {
    DMA: 501,
  },
  "10009": {
    DMA: 501,
  },
  "10010": {
    DMA: 501,
  },
  "10011": {
    DMA: 501,
  },
  "10012": {
    DMA: 501,
  },
  "10013": {
    DMA: 501,
  },
  "10014": {
    DMA: 501,
  },
  "10015": {
    DMA: 501,
  },
  "10016": {
    DMA: 501,
  },
  "10017": {
    DMA: 501,
  },
  "10018": {
    DMA: 501,
  },
  "10019": {
    DMA: 501,
  },
  "10020": {
    DMA: 501,
  },
  "10021": {
    DMA: 501,
  },
  "10022": {
    DMA: 501,
  },
  "10023": {
    DMA: 501,
  },
  "10024": {
    DMA: 501,
  },
  "10025": {
    DMA: 501,
  },
  "10026": {
    DMA: 501,
  },
  "10027": {
    DMA: 501,
  },
  "10028": {
    DMA: 501,
  },
  "10029": {
    DMA: 501,
  },
  "10030": {
    DMA: 501,
  },
  "10031": {
    DMA: 501,
  },
  "10032": {
    DMA: 501,
  },
  "10033": {
    DMA: 501,
  },
  "10034": {
    DMA: 501,
  },
  "10035": {
    DMA: 501,
  },
  "10036": {
    DMA: 501,
  },
  "10037": {
    DMA: 501,
  },
  "10038": {
    DMA: 501,
  },
  "10039": {
    DMA: 501,
  },
  "10040": {
    DMA: 501,
  },
  "10041": {
    DMA: 501,
  },
  "10043": {
    DMA: 501,
  },
  "10044": {
    DMA: 501,
  },
  "10045": {
    DMA: 501,
  },
  "10046": {
    DMA: 501,
  },
  "10047": {
    DMA: 501,
  },
  "10048": {
    DMA: 501,
  },
  "10055": {
    DMA: 501,
  },
  "10060": {
    DMA: 501,
  },
  "10065": {
    DMA: 501,
  },
  "10069": {
    DMA: 501,
  },
  "10072": {
    DMA: 501,
  },
  "10075": {
    DMA: 501,
  },
  "10079": {
    DMA: 501,
  },
  "10080": {
    DMA: 501,
  },
  "10081": {
    DMA: 501,
  },
  "10082": {
    DMA: 501,
  },
  "10087": {
    DMA: 501,
  },
  "10090": {
    DMA: 501,
  },
  "10094": {
    DMA: 501,
  },
  "10095": {
    DMA: 501,
  },
  "10096": {
    DMA: 501,
  },
  "10098": {
    DMA: 501,
  },
  "10099": {
    DMA: 501,
  },
  "10101": {
    DMA: 501,
  },
  "10102": {
    DMA: 501,
  },
  "10103": {
    DMA: 501,
  },
  "10104": {
    DMA: 501,
  },
  "10105": {
    DMA: 501,
  },
  "10106": {
    DMA: 501,
  },
  "10107": {
    DMA: 501,
  },
  "10108": {
    DMA: 501,
  },
  "10109": {
    DMA: 501,
  },
  "10110": {
    DMA: 501,
  },
  "10111": {
    DMA: 501,
  },
  "10112": {
    DMA: 501,
  },
  "10113": {
    DMA: 501,
  },
  "10114": {
    DMA: 501,
  },
  "10115": {
    DMA: 501,
  },
  "10116": {
    DMA: 501,
  },
  "10117": {
    DMA: 501,
  },
  "10118": {
    DMA: 501,
  },
  "10119": {
    DMA: 501,
  },
  "10120": {
    DMA: 501,
  },
  "10121": {
    DMA: 501,
  },
  "10122": {
    DMA: 501,
  },
  "10123": {
    DMA: 501,
  },
  "10124": {
    DMA: 501,
  },
  "10125": {
    DMA: 501,
  },
  "10126": {
    DMA: 501,
  },
  "10128": {
    DMA: 501,
  },
  "10129": {
    DMA: 501,
  },
  "10130": {
    DMA: 501,
  },
  "10131": {
    DMA: 501,
  },
  "10132": {
    DMA: 501,
  },
  "10133": {
    DMA: 501,
  },
  "10138": {
    DMA: 501,
  },
  "10149": {
    DMA: 501,
  },
  "10150": {
    DMA: 501,
  },
  "10151": {
    DMA: 501,
  },
  "10152": {
    DMA: 501,
  },
  "10153": {
    DMA: 501,
  },
  "10154": {
    DMA: 501,
  },
  "10155": {
    DMA: 501,
  },
  "10156": {
    DMA: 501,
  },
  "10157": {
    DMA: 501,
  },
  "10158": {
    DMA: 501,
  },
  "10159": {
    DMA: 501,
  },
  "10160": {
    DMA: 501,
  },
  "10161": {
    DMA: 501,
  },
  "10162": {
    DMA: 501,
  },
  "10163": {
    DMA: 501,
  },
  "10164": {
    DMA: 501,
  },
  "10165": {
    DMA: 501,
  },
  "10166": {
    DMA: 501,
  },
  "10167": {
    DMA: 501,
  },
  "10168": {
    DMA: 501,
  },
  "10169": {
    DMA: 501,
  },
  "10170": {
    DMA: 501,
  },
  "10171": {
    DMA: 501,
  },
  "10172": {
    DMA: 501,
  },
  "10173": {
    DMA: 501,
  },
  "10174": {
    DMA: 501,
  },
  "10175": {
    DMA: 501,
  },
  "10176": {
    DMA: 501,
  },
  "10177": {
    DMA: 501,
  },
  "10178": {
    DMA: 501,
  },
  "10179": {
    DMA: 501,
  },
  "10184": {
    DMA: 501,
  },
  "10185": {
    DMA: 501,
  },
  "10196": {
    DMA: 501,
  },
  "10197": {
    DMA: 501,
  },
  "10199": {
    DMA: 501,
  },
  "10200": {
    DMA: 501,
  },
  "10203": {
    DMA: 501,
  },
  "10211": {
    DMA: 501,
  },
  "10212": {
    DMA: 501,
  },
  "10213": {
    DMA: 501,
  },
  "10242": {
    DMA: 501,
  },
  "10249": {
    DMA: 501,
  },
  "10256": {
    DMA: 501,
  },
  "10257": {
    DMA: 501,
  },
  "10258": {
    DMA: 501,
  },
  "10259": {
    DMA: 501,
  },
  "10260": {
    DMA: 501,
  },
  "10261": {
    DMA: 501,
  },
  "10265": {
    DMA: 501,
  },
  "10268": {
    DMA: 501,
  },
  "10269": {
    DMA: 501,
  },
  "10270": {
    DMA: 501,
  },
  "10271": {
    DMA: 501,
  },
  "10272": {
    DMA: 501,
  },
  "10273": {
    DMA: 501,
  },
  "10274": {
    DMA: 501,
  },
  "10275": {
    DMA: 501,
  },
  "10276": {
    DMA: 501,
  },
  "10277": {
    DMA: 501,
  },
  "10278": {
    DMA: 501,
  },
  "10279": {
    DMA: 501,
  },
  "10280": {
    DMA: 501,
  },
  "10281": {
    DMA: 501,
  },
  "10282": {
    DMA: 501,
  },
  "10285": {
    DMA: 501,
  },
  "10286": {
    DMA: 501,
  },
  "10292": {
    DMA: 501,
  },
  "10301": {
    DMA: 501,
  },
  "10302": {
    DMA: 501,
  },
  "10303": {
    DMA: 501,
  },
  "10304": {
    DMA: 501,
  },
  "10305": {
    DMA: 501,
  },
  "10306": {
    DMA: 501,
  },
  "10307": {
    DMA: 501,
  },
  "10308": {
    DMA: 501,
  },
  "10309": {
    DMA: 501,
  },
  "10310": {
    DMA: 501,
  },
  "10311": {
    DMA: 501,
  },
  "10312": {
    DMA: 501,
  },
  "10313": {
    DMA: 501,
  },
  "10314": {
    DMA: 501,
  },
  "10451": {
    DMA: 501,
  },
  "10452": {
    DMA: 501,
  },
  "10453": {
    DMA: 501,
  },
  "10454": {
    DMA: 501,
  },
  "10455": {
    DMA: 501,
  },
  "10456": {
    DMA: 501,
  },
  "10457": {
    DMA: 501,
  },
  "10458": {
    DMA: 501,
  },
  "10459": {
    DMA: 501,
  },
  "10460": {
    DMA: 501,
  },
  "10461": {
    DMA: 501,
  },
  "10462": {
    DMA: 501,
  },
  "10463": {
    DMA: 501,
  },
  "10464": {
    DMA: 501,
  },
  "10465": {
    DMA: 501,
  },
  "10466": {
    DMA: 501,
  },
  "10467": {
    DMA: 501,
  },
  "10468": {
    DMA: 501,
  },
  "10469": {
    DMA: 501,
  },
  "10470": {
    DMA: 501,
  },
  "10471": {
    DMA: 501,
  },
  "10472": {
    DMA: 501,
  },
  "10473": {
    DMA: 501,
  },
  "10474": {
    DMA: 501,
  },
  "10475": {
    DMA: 501,
  },
  "10499": {
    DMA: 501,
  },
  "10501": {
    DMA: 501,
  },
  "10502": {
    DMA: 501,
  },
  "10503": {
    DMA: 501,
  },
  "10504": {
    DMA: 501,
  },
  "10505": {
    DMA: 501,
  },
  "10506": {
    DMA: 501,
  },
  "10507": {
    DMA: 501,
  },
  "10509": {
    DMA: 501,
  },
  "10510": {
    DMA: 501,
  },
  "10511": {
    DMA: 501,
  },
  "10512": {
    DMA: 501,
  },
  "10514": {
    DMA: 501,
  },
  "10516": {
    DMA: 501,
  },
  "10517": {
    DMA: 501,
  },
  "10518": {
    DMA: 501,
  },
  "10519": {
    DMA: 501,
  },
  "10520": {
    DMA: 501,
  },
  "10521": {
    DMA: 501,
  },
  "10522": {
    DMA: 501,
  },
  "10523": {
    DMA: 501,
  },
  "10524": {
    DMA: 501,
  },
  "10526": {
    DMA: 501,
  },
  "10527": {
    DMA: 501,
  },
  "10528": {
    DMA: 501,
  },
  "10530": {
    DMA: 501,
  },
  "10532": {
    DMA: 501,
  },
  "10533": {
    DMA: 501,
  },
  "10535": {
    DMA: 501,
  },
  "10536": {
    DMA: 501,
  },
  "10537": {
    DMA: 501,
  },
  "10538": {
    DMA: 501,
  },
  "10540": {
    DMA: 501,
  },
  "10541": {
    DMA: 501,
  },
  "10542": {
    DMA: 501,
  },
  "10543": {
    DMA: 501,
  },
  "10545": {
    DMA: 501,
  },
  "10546": {
    DMA: 501,
  },
  "10547": {
    DMA: 501,
  },
  "10548": {
    DMA: 501,
  },
  "10549": {
    DMA: 501,
  },
  "10550": {
    DMA: 501,
  },
  "10551": {
    DMA: 501,
  },
  "10552": {
    DMA: 501,
  },
  "10553": {
    DMA: 501,
  },
  "10557": {
    DMA: 501,
  },
  "10558": {
    DMA: 501,
  },
  "10560": {
    DMA: 501,
  },
  "10562": {
    DMA: 501,
  },
  "10566": {
    DMA: 501,
  },
  "10567": {
    DMA: 501,
  },
  "10570": {
    DMA: 501,
  },
  "10571": {
    DMA: 501,
  },
  "10572": {
    DMA: 501,
  },
  "10573": {
    DMA: 501,
  },
  "10576": {
    DMA: 501,
  },
  "10577": {
    DMA: 501,
  },
  "10578": {
    DMA: 501,
  },
  "10579": {
    DMA: 501,
  },
  "10580": {
    DMA: 501,
  },
  "10583": {
    DMA: 501,
  },
  "10587": {
    DMA: 501,
  },
  "10588": {
    DMA: 501,
  },
  "10589": {
    DMA: 501,
  },
  "10590": {
    DMA: 501,
  },
  "10591": {
    DMA: 501,
  },
  "10594": {
    DMA: 501,
  },
  "10595": {
    DMA: 501,
  },
  "10596": {
    DMA: 501,
  },
  "10597": {
    DMA: 501,
  },
  "10598": {
    DMA: 501,
  },
  "10601": {
    DMA: 501,
  },
  "10602": {
    DMA: 501,
  },
  "10603": {
    DMA: 501,
  },
  "10604": {
    DMA: 501,
  },
  "10605": {
    DMA: 501,
  },
  "10606": {
    DMA: 501,
  },
  "10607": {
    DMA: 501,
  },
  "10610": {
    DMA: 501,
  },
  "10701": {
    DMA: 501,
  },
  "10702": {
    DMA: 501,
  },
  "10703": {
    DMA: 501,
  },
  "10704": {
    DMA: 501,
  },
  "10705": {
    DMA: 501,
  },
  "10706": {
    DMA: 501,
  },
  "10707": {
    DMA: 501,
  },
  "10708": {
    DMA: 501,
  },
  "10709": {
    DMA: 501,
  },
  "10710": {
    DMA: 501,
  },
  "10801": {
    DMA: 501,
  },
  "10802": {
    DMA: 501,
  },
  "10803": {
    DMA: 501,
  },
  "10804": {
    DMA: 501,
  },
  "10805": {
    DMA: 501,
  },
  "10901": {
    DMA: 501,
  },
  "10910": {
    DMA: 501,
  },
  "10911": {
    DMA: 501,
  },
  "10912": {
    DMA: 501,
  },
  "10913": {
    DMA: 501,
  },
  "10914": {
    DMA: 501,
  },
  "10915": {
    DMA: 501,
  },
  "10916": {
    DMA: 501,
  },
  "10917": {
    DMA: 501,
  },
  "10918": {
    DMA: 501,
  },
  "10919": {
    DMA: 501,
  },
  "10920": {
    DMA: 501,
  },
  "10921": {
    DMA: 501,
  },
  "10922": {
    DMA: 501,
  },
  "10923": {
    DMA: 501,
  },
  "10924": {
    DMA: 501,
  },
  "10925": {
    DMA: 501,
  },
  "10926": {
    DMA: 501,
  },
  "10927": {
    DMA: 501,
  },
  "10928": {
    DMA: 501,
  },
  "10930": {
    DMA: 501,
  },
  "10931": {
    DMA: 501,
  },
  "10932": {
    DMA: 501,
  },
  "10933": {
    DMA: 501,
  },
  "10940": {
    DMA: 501,
  },
  "10941": {
    DMA: 501,
  },
  "10943": {
    DMA: 501,
  },
  "10949": {
    DMA: 501,
  },
  "10950": {
    DMA: 501,
  },
  "10952": {
    DMA: 501,
  },
  "10953": {
    DMA: 501,
  },
  "10954": {
    DMA: 501,
  },
  "10956": {
    DMA: 501,
  },
  "10958": {
    DMA: 501,
  },
  "10959": {
    DMA: 501,
  },
  "10960": {
    DMA: 501,
  },
  "10962": {
    DMA: 501,
  },
  "10963": {
    DMA: 501,
  },
  "10964": {
    DMA: 501,
  },
  "10965": {
    DMA: 501,
  },
  "10968": {
    DMA: 501,
  },
  "10969": {
    DMA: 501,
  },
  "10970": {
    DMA: 501,
  },
  "10973": {
    DMA: 501,
  },
  "10974": {
    DMA: 501,
  },
  "10975": {
    DMA: 501,
  },
  "10976": {
    DMA: 501,
  },
  "10977": {
    DMA: 501,
  },
  "10979": {
    DMA: 501,
  },
  "10980": {
    DMA: 501,
  },
  "10981": {
    DMA: 501,
  },
  "10982": {
    DMA: 501,
  },
  "10983": {
    DMA: 501,
  },
  "10984": {
    DMA: 501,
  },
  "10985": {
    DMA: 501,
  },
  "10986": {
    DMA: 501,
  },
  "10987": {
    DMA: 501,
  },
  "10988": {
    DMA: 501,
  },
  "10989": {
    DMA: 501,
  },
  "10990": {
    DMA: 501,
  },
  "10992": {
    DMA: 501,
  },
  "10993": {
    DMA: 501,
  },
  "10994": {
    DMA: 501,
  },
  "10996": {
    DMA: 501,
  },
  "10997": {
    DMA: 501,
  },
  "10998": {
    DMA: 501,
  },
  "11001": {
    DMA: 501,
  },
  "11002": {
    DMA: 501,
  },
  "11003": {
    DMA: 501,
  },
  "11004": {
    DMA: 501,
  },
  "11005": {
    DMA: 501,
  },
  "11010": {
    DMA: 501,
  },
  "11020": {
    DMA: 501,
  },
  "11021": {
    DMA: 501,
  },
  "11022": {
    DMA: 501,
  },
  "11023": {
    DMA: 501,
  },
  "11024": {
    DMA: 501,
  },
  "11025": {
    DMA: 501,
  },
  "11026": {
    DMA: 501,
  },
  "11027": {
    DMA: 501,
  },
  "11030": {
    DMA: 501,
  },
  "11040": {
    DMA: 501,
  },
  "11041": {
    DMA: 501,
  },
  "11042": {
    DMA: 501,
  },
  "11043": {
    DMA: 501,
  },
  "11044": {
    DMA: 501,
  },
  "11050": {
    DMA: 501,
  },
  "11051": {
    DMA: 501,
  },
  "11052": {
    DMA: 501,
  },
  "11053": {
    DMA: 501,
  },
  "11054": {
    DMA: 501,
  },
  "11055": {
    DMA: 501,
  },
  "11096": {
    DMA: 501,
  },
  "11099": {
    DMA: 501,
  },
  "11101": {
    DMA: 501,
  },
  "11102": {
    DMA: 501,
  },
  "11103": {
    DMA: 501,
  },
  "11104": {
    DMA: 501,
  },
  "11105": {
    DMA: 501,
  },
  "11106": {
    DMA: 501,
  },
  "11109": {
    DMA: 501,
  },
  "11120": {
    DMA: 501,
  },
  "11201": {
    DMA: 501,
  },
  "11202": {
    DMA: 501,
  },
  "11203": {
    DMA: 501,
  },
  "11204": {
    DMA: 501,
  },
  "11205": {
    DMA: 501,
  },
  "11206": {
    DMA: 501,
  },
  "11207": {
    DMA: 501,
  },
  "11208": {
    DMA: 501,
  },
  "11209": {
    DMA: 501,
  },
  "11210": {
    DMA: 501,
  },
  "11211": {
    DMA: 501,
  },
  "11212": {
    DMA: 501,
  },
  "11213": {
    DMA: 501,
  },
  "11214": {
    DMA: 501,
  },
  "11215": {
    DMA: 501,
  },
  "11216": {
    DMA: 501,
  },
  "11217": {
    DMA: 501,
  },
  "11218": {
    DMA: 501,
  },
  "11219": {
    DMA: 501,
  },
  "11220": {
    DMA: 501,
  },
  "11221": {
    DMA: 501,
  },
  "11222": {
    DMA: 501,
  },
  "11223": {
    DMA: 501,
  },
  "11224": {
    DMA: 501,
  },
  "11225": {
    DMA: 501,
  },
  "11226": {
    DMA: 501,
  },
  "11228": {
    DMA: 501,
  },
  "11229": {
    DMA: 501,
  },
  "11230": {
    DMA: 501,
  },
  "11231": {
    DMA: 501,
  },
  "11232": {
    DMA: 501,
  },
  "11233": {
    DMA: 501,
  },
  "11234": {
    DMA: 501,
  },
  "11235": {
    DMA: 501,
  },
  "11236": {
    DMA: 501,
  },
  "11237": {
    DMA: 501,
  },
  "11238": {
    DMA: 501,
  },
  "11239": {
    DMA: 501,
  },
  "11240": {
    DMA: 501,
  },
  "11241": {
    DMA: 501,
  },
  "11242": {
    DMA: 501,
  },
  "11243": {
    DMA: 501,
  },
  "11244": {
    DMA: 501,
  },
  "11245": {
    DMA: 501,
  },
  "11247": {
    DMA: 501,
  },
  "11248": {
    DMA: 501,
  },
  "11249": {
    DMA: 501,
  },
  "11251": {
    DMA: 501,
  },
  "11252": {
    DMA: 501,
  },
  "11254": {
    DMA: 501,
  },
  "11255": {
    DMA: 501,
  },
  "11256": {
    DMA: 501,
  },
  "11351": {
    DMA: 501,
  },
  "11352": {
    DMA: 501,
  },
  "11354": {
    DMA: 501,
  },
  "11355": {
    DMA: 501,
  },
  "11356": {
    DMA: 501,
  },
  "11357": {
    DMA: 501,
  },
  "11358": {
    DMA: 501,
  },
  "11359": {
    DMA: 501,
  },
  "11360": {
    DMA: 501,
  },
  "11361": {
    DMA: 501,
  },
  "11362": {
    DMA: 501,
  },
  "11363": {
    DMA: 501,
  },
  "11364": {
    DMA: 501,
  },
  "11365": {
    DMA: 501,
  },
  "11366": {
    DMA: 501,
  },
  "11367": {
    DMA: 501,
  },
  "11368": {
    DMA: 501,
  },
  "11369": {
    DMA: 501,
  },
  "11370": {
    DMA: 501,
  },
  "11371": {
    DMA: 501,
  },
  "11372": {
    DMA: 501,
  },
  "11373": {
    DMA: 501,
  },
  "11374": {
    DMA: 501,
  },
  "11375": {
    DMA: 501,
  },
  "11377": {
    DMA: 501,
  },
  "11378": {
    DMA: 501,
  },
  "11379": {
    DMA: 501,
  },
  "11380": {
    DMA: 501,
  },
  "11381": {
    DMA: 501,
  },
  "11385": {
    DMA: 501,
  },
  "11386": {
    DMA: 501,
  },
  "11390": {
    DMA: 501,
  },
  "11405": {
    DMA: 501,
  },
  "11411": {
    DMA: 501,
  },
  "11412": {
    DMA: 501,
  },
  "11413": {
    DMA: 501,
  },
  "11414": {
    DMA: 501,
  },
  "11415": {
    DMA: 501,
  },
  "11416": {
    DMA: 501,
  },
  "11417": {
    DMA: 501,
  },
  "11418": {
    DMA: 501,
  },
  "11419": {
    DMA: 501,
  },
  "11420": {
    DMA: 501,
  },
  "11421": {
    DMA: 501,
  },
  "11422": {
    DMA: 501,
  },
  "11423": {
    DMA: 501,
  },
  "11424": {
    DMA: 501,
  },
  "11425": {
    DMA: 501,
  },
  "11426": {
    DMA: 501,
  },
  "11427": {
    DMA: 501,
  },
  "11428": {
    DMA: 501,
  },
  "11429": {
    DMA: 501,
  },
  "11430": {
    DMA: 501,
  },
  "11431": {
    DMA: 501,
  },
  "11432": {
    DMA: 501,
  },
  "11433": {
    DMA: 501,
  },
  "11434": {
    DMA: 501,
  },
  "11435": {
    DMA: 501,
  },
  "11436": {
    DMA: 501,
  },
  "11437": {
    DMA: 501,
  },
  "11439": {
    DMA: 501,
  },
  "11451": {
    DMA: 501,
  },
  "11499": {
    DMA: 501,
  },
  "11501": {
    DMA: 501,
  },
  "11507": {
    DMA: 501,
  },
  "11509": {
    DMA: 501,
  },
  "11510": {
    DMA: 501,
  },
  "11514": {
    DMA: 501,
  },
  "11516": {
    DMA: 501,
  },
  "11518": {
    DMA: 501,
  },
  "11520": {
    DMA: 501,
  },
  "11530": {
    DMA: 501,
  },
  "11531": {
    DMA: 501,
  },
  "11535": {
    DMA: 501,
  },
  "11536": {
    DMA: 501,
  },
  "11542": {
    DMA: 501,
  },
  "11545": {
    DMA: 501,
  },
  "11547": {
    DMA: 501,
  },
  "11548": {
    DMA: 501,
  },
  "11549": {
    DMA: 501,
  },
  "11550": {
    DMA: 501,
  },
  "11551": {
    DMA: 501,
  },
  "11552": {
    DMA: 501,
  },
  "11553": {
    DMA: 501,
  },
  "11554": {
    DMA: 501,
  },
  "11555": {
    DMA: 501,
  },
  "11556": {
    DMA: 501,
  },
  "11557": {
    DMA: 501,
  },
  "11558": {
    DMA: 501,
  },
  "11559": {
    DMA: 501,
  },
  "11560": {
    DMA: 501,
  },
  "11561": {
    DMA: 501,
  },
  "11563": {
    DMA: 501,
  },
  "11565": {
    DMA: 501,
  },
  "11566": {
    DMA: 501,
  },
  "11568": {
    DMA: 501,
  },
  "11569": {
    DMA: 501,
  },
  "11570": {
    DMA: 501,
  },
  "11571": {
    DMA: 501,
  },
  "11572": {
    DMA: 501,
  },
  "11575": {
    DMA: 501,
  },
  "11576": {
    DMA: 501,
  },
  "11577": {
    DMA: 501,
  },
  "11579": {
    DMA: 501,
  },
  "11580": {
    DMA: 501,
  },
  "11581": {
    DMA: 501,
  },
  "11582": {
    DMA: 501,
  },
  "11590": {
    DMA: 501,
  },
  "11592": {
    DMA: 501,
  },
  "11594": {
    DMA: 501,
  },
  "11595": {
    DMA: 501,
  },
  "11596": {
    DMA: 501,
  },
  "11597": {
    DMA: 501,
  },
  "11598": {
    DMA: 501,
  },
  "11599": {
    DMA: 501,
  },
  "11690": {
    DMA: 501,
  },
  "11691": {
    DMA: 501,
  },
  "11692": {
    DMA: 501,
  },
  "11693": {
    DMA: 501,
  },
  "11694": {
    DMA: 501,
  },
  "11695": {
    DMA: 501,
  },
  "11697": {
    DMA: 501,
  },
  "11701": {
    DMA: 501,
  },
  "11702": {
    DMA: 501,
  },
  "11703": {
    DMA: 501,
  },
  "11704": {
    DMA: 501,
  },
  "11705": {
    DMA: 501,
  },
  "11706": {
    DMA: 501,
  },
  "11707": {
    DMA: 501,
  },
  "11708": {
    DMA: 501,
  },
  "11709": {
    DMA: 501,
  },
  "11710": {
    DMA: 501,
  },
  "11713": {
    DMA: 501,
  },
  "11714": {
    DMA: 501,
  },
  "11715": {
    DMA: 501,
  },
  "11716": {
    DMA: 501,
  },
  "11717": {
    DMA: 501,
  },
  "11718": {
    DMA: 501,
  },
  "11719": {
    DMA: 501,
  },
  "11720": {
    DMA: 501,
  },
  "11721": {
    DMA: 501,
  },
  "11722": {
    DMA: 501,
  },
  "11724": {
    DMA: 501,
  },
  "11725": {
    DMA: 501,
  },
  "11726": {
    DMA: 501,
  },
  "11727": {
    DMA: 501,
  },
  "11729": {
    DMA: 501,
  },
  "11730": {
    DMA: 501,
  },
  "11731": {
    DMA: 501,
  },
  "11732": {
    DMA: 501,
  },
  "11733": {
    DMA: 501,
  },
  "11735": {
    DMA: 501,
  },
  "11736": {
    DMA: 501,
  },
  "11737": {
    DMA: 501,
  },
  "11738": {
    DMA: 501,
  },
  "11739": {
    DMA: 501,
  },
  "11740": {
    DMA: 501,
  },
  "11741": {
    DMA: 501,
  },
  "11742": {
    DMA: 501,
  },
  "11743": {
    DMA: 501,
  },
  "11746": {
    DMA: 501,
  },
  "11747": {
    DMA: 501,
  },
  "11749": {
    DMA: 501,
  },
  "11750": {
    DMA: 501,
  },
  "11751": {
    DMA: 501,
  },
  "11752": {
    DMA: 501,
  },
  "11753": {
    DMA: 501,
  },
  "11754": {
    DMA: 501,
  },
  "11755": {
    DMA: 501,
  },
  "11756": {
    DMA: 501,
  },
  "11757": {
    DMA: 501,
  },
  "11758": {
    DMA: 501,
  },
  "11760": {
    DMA: 501,
  },
  "11762": {
    DMA: 501,
  },
  "11763": {
    DMA: 501,
  },
  "11764": {
    DMA: 501,
  },
  "11765": {
    DMA: 501,
  },
  "11766": {
    DMA: 501,
  },
  "11767": {
    DMA: 501,
  },
  "11768": {
    DMA: 501,
  },
  "11769": {
    DMA: 501,
  },
  "11770": {
    DMA: 501,
  },
  "11771": {
    DMA: 501,
  },
  "11772": {
    DMA: 501,
  },
  "11773": {
    DMA: 501,
  },
  "11774": {
    DMA: 501,
  },
  "11775": {
    DMA: 501,
  },
  "11776": {
    DMA: 501,
  },
  "11777": {
    DMA: 501,
  },
  "11778": {
    DMA: 501,
  },
  "11779": {
    DMA: 501,
  },
  "11780": {
    DMA: 501,
  },
  "11782": {
    DMA: 501,
  },
  "11783": {
    DMA: 501,
  },
  "11784": {
    DMA: 501,
  },
  "11786": {
    DMA: 501,
  },
  "11787": {
    DMA: 501,
  },
  "11788": {
    DMA: 501,
  },
  "11789": {
    DMA: 501,
  },
  "11790": {
    DMA: 501,
  },
  "11791": {
    DMA: 501,
  },
  "11792": {
    DMA: 501,
  },
  "11793": {
    DMA: 501,
  },
  "11794": {
    DMA: 501,
  },
  "11795": {
    DMA: 501,
  },
  "11796": {
    DMA: 501,
  },
  "11797": {
    DMA: 501,
  },
  "11798": {
    DMA: 501,
  },
  "11801": {
    DMA: 501,
  },
  "11802": {
    DMA: 501,
  },
  "11803": {
    DMA: 501,
  },
  "11804": {
    DMA: 501,
  },
  "11815": {
    DMA: 501,
  },
  "11819": {
    DMA: 501,
  },
  "11853": {
    DMA: 501,
  },
  "11854": {
    DMA: 501,
  },
  "11855": {
    DMA: 501,
  },
  "11901": {
    DMA: 501,
  },
  "11930": {
    DMA: 501,
  },
  "11931": {
    DMA: 501,
  },
  "11932": {
    DMA: 501,
  },
  "11933": {
    DMA: 501,
  },
  "11934": {
    DMA: 501,
  },
  "11935": {
    DMA: 501,
  },
  "11937": {
    DMA: 501,
  },
  "11939": {
    DMA: 501,
  },
  "11940": {
    DMA: 501,
  },
  "11941": {
    DMA: 501,
  },
  "11942": {
    DMA: 501,
  },
  "11944": {
    DMA: 501,
  },
  "11946": {
    DMA: 501,
  },
  "11947": {
    DMA: 501,
  },
  "11948": {
    DMA: 501,
  },
  "11949": {
    DMA: 501,
  },
  "11950": {
    DMA: 501,
  },
  "11951": {
    DMA: 501,
  },
  "11952": {
    DMA: 501,
  },
  "11953": {
    DMA: 501,
  },
  "11954": {
    DMA: 501,
  },
  "11955": {
    DMA: 501,
  },
  "11956": {
    DMA: 501,
  },
  "11957": {
    DMA: 501,
  },
  "11958": {
    DMA: 501,
  },
  "11959": {
    DMA: 501,
  },
  "11960": {
    DMA: 501,
  },
  "11961": {
    DMA: 501,
  },
  "11962": {
    DMA: 501,
  },
  "11963": {
    DMA: 501,
  },
  "11964": {
    DMA: 501,
  },
  "11965": {
    DMA: 501,
  },
  "11967": {
    DMA: 501,
  },
  "11968": {
    DMA: 501,
  },
  "11969": {
    DMA: 501,
  },
  "11970": {
    DMA: 501,
  },
  "11971": {
    DMA: 501,
  },
  "11972": {
    DMA: 501,
  },
  "11973": {
    DMA: 501,
  },
  "11975": {
    DMA: 501,
  },
  "11976": {
    DMA: 501,
  },
  "11977": {
    DMA: 501,
  },
  "11978": {
    DMA: 501,
  },
  "11980": {
    DMA: 501,
  },
  "12007": {
    DMA: 532,
  },
  "12008": {
    DMA: 532,
  },
  "12009": {
    DMA: 532,
  },
  "12010": {
    DMA: 532,
  },
  "12015": {
    DMA: 532,
  },
  "12016": {
    DMA: 532,
  },
  "12017": {
    DMA: 532,
  },
  "12018": {
    DMA: 532,
  },
  "12019": {
    DMA: 532,
  },
  "12020": {
    DMA: 532,
  },
  "12022": {
    DMA: 532,
  },
  "12023": {
    DMA: 532,
  },
  "12024": {
    DMA: 532,
  },
  "12025": {
    DMA: 532,
  },
  "12027": {
    DMA: 532,
  },
  "12028": {
    DMA: 532,
  },
  "12029": {
    DMA: 532,
  },
  "12031": {
    DMA: 532,
  },
  "12032": {
    DMA: 532,
  },
  "12033": {
    DMA: 532,
  },
  "12035": {
    DMA: 532,
  },
  "12036": {
    DMA: 532,
  },
  "12037": {
    DMA: 532,
  },
  "12040": {
    DMA: 532,
  },
  "12041": {
    DMA: 532,
  },
  "12042": {
    DMA: 532,
  },
  "12043": {
    DMA: 532,
  },
  "12045": {
    DMA: 532,
  },
  "12046": {
    DMA: 532,
  },
  "12047": {
    DMA: 532,
  },
  "12050": {
    DMA: 532,
  },
  "12051": {
    DMA: 532,
  },
  "12052": {
    DMA: 532,
  },
  "12053": {
    DMA: 532,
  },
  "12054": {
    DMA: 532,
  },
  "12055": {
    DMA: 532,
  },
  "12056": {
    DMA: 532,
  },
  "12057": {
    DMA: 532,
  },
  "12058": {
    DMA: 532,
  },
  "12059": {
    DMA: 532,
  },
  "12060": {
    DMA: 532,
  },
  "12061": {
    DMA: 532,
  },
  "12062": {
    DMA: 532,
  },
  "12063": {
    DMA: 532,
  },
  "12064": {
    DMA: 526,
  },
  "12065": {
    DMA: 532,
  },
  "12066": {
    DMA: 532,
  },
  "12067": {
    DMA: 532,
  },
  "12068": {
    DMA: 532,
  },
  "12069": {
    DMA: 532,
  },
  "12070": {
    DMA: 532,
  },
  "12071": {
    DMA: 532,
  },
  "12072": {
    DMA: 532,
  },
  "12073": {
    DMA: 532,
  },
  "12074": {
    DMA: 532,
  },
  "12075": {
    DMA: 532,
  },
  "12076": {
    DMA: 532,
  },
  "12077": {
    DMA: 532,
  },
  "12078": {
    DMA: 532,
  },
  "12082": {
    DMA: 532,
  },
  "12083": {
    DMA: 532,
  },
  "12084": {
    DMA: 532,
  },
  "12085": {
    DMA: 532,
  },
  "12086": {
    DMA: 532,
  },
  "12087": {
    DMA: 532,
  },
  "12089": {
    DMA: 532,
  },
  "12090": {
    DMA: 532,
  },
  "12092": {
    DMA: 532,
  },
  "12093": {
    DMA: 532,
  },
  "12094": {
    DMA: 532,
  },
  "12095": {
    DMA: 532,
  },
  "12106": {
    DMA: 532,
  },
  "12107": {
    DMA: 532,
  },
  "12108": {
    DMA: 532,
  },
  "12110": {
    DMA: 532,
  },
  "12115": {
    DMA: 532,
  },
  "12116": {
    DMA: 526,
  },
  "12117": {
    DMA: 532,
  },
  "12118": {
    DMA: 532,
  },
  "12120": {
    DMA: 532,
  },
  "12121": {
    DMA: 532,
  },
  "12122": {
    DMA: 532,
  },
  "12123": {
    DMA: 532,
  },
  "12124": {
    DMA: 532,
  },
  "12125": {
    DMA: 532,
  },
  "12128": {
    DMA: 532,
  },
  "12130": {
    DMA: 532,
  },
  "12131": {
    DMA: 532,
  },
  "12132": {
    DMA: 532,
  },
  "12133": {
    DMA: 532,
  },
  "12134": {
    DMA: 532,
  },
  "12136": {
    DMA: 532,
  },
  "12137": {
    DMA: 532,
  },
  "12138": {
    DMA: 532,
  },
  "12139": {
    DMA: 532,
  },
  "12140": {
    DMA: 532,
  },
  "12141": {
    DMA: 532,
  },
  "12143": {
    DMA: 532,
  },
  "12144": {
    DMA: 532,
  },
  "12147": {
    DMA: 532,
  },
  "12148": {
    DMA: 532,
  },
  "12149": {
    DMA: 532,
  },
  "12150": {
    DMA: 532,
  },
  "12151": {
    DMA: 532,
  },
  "12153": {
    DMA: 532,
  },
  "12154": {
    DMA: 532,
  },
  "12155": {
    DMA: 526,
  },
  "12156": {
    DMA: 532,
  },
  "12157": {
    DMA: 532,
  },
  "12158": {
    DMA: 532,
  },
  "12159": {
    DMA: 532,
  },
  "12160": {
    DMA: 532,
  },
  "12161": {
    DMA: 532,
  },
  "12164": {
    DMA: 532,
  },
  "12165": {
    DMA: 532,
  },
  "12166": {
    DMA: 532,
  },
  "12167": {
    DMA: 502,
  },
  "12168": {
    DMA: 532,
  },
  "12169": {
    DMA: 532,
  },
  "12170": {
    DMA: 532,
  },
  "12172": {
    DMA: 532,
  },
  "12173": {
    DMA: 532,
  },
  "12174": {
    DMA: 532,
  },
  "12175": {
    DMA: 532,
  },
  "12176": {
    DMA: 532,
  },
  "12177": {
    DMA: 532,
  },
  "12180": {
    DMA: 532,
  },
  "12181": {
    DMA: 532,
  },
  "12182": {
    DMA: 532,
  },
  "12183": {
    DMA: 532,
  },
  "12184": {
    DMA: 532,
  },
  "12185": {
    DMA: 532,
  },
  "12186": {
    DMA: 532,
  },
  "12187": {
    DMA: 532,
  },
  "12188": {
    DMA: 532,
  },
  "12189": {
    DMA: 532,
  },
  "12190": {
    DMA: 532,
  },
  "12192": {
    DMA: 532,
  },
  "12193": {
    DMA: 532,
  },
  "12194": {
    DMA: 532,
  },
  "12195": {
    DMA: 532,
  },
  "12196": {
    DMA: 532,
  },
  "12197": {
    DMA: 526,
  },
  "12198": {
    DMA: 532,
  },
  "12201": {
    DMA: 532,
  },
  "12202": {
    DMA: 532,
  },
  "12203": {
    DMA: 532,
  },
  "12204": {
    DMA: 532,
  },
  "12205": {
    DMA: 532,
  },
  "12206": {
    DMA: 532,
  },
  "12207": {
    DMA: 532,
  },
  "12208": {
    DMA: 532,
  },
  "12209": {
    DMA: 532,
  },
  "12210": {
    DMA: 532,
  },
  "12211": {
    DMA: 532,
  },
  "12212": {
    DMA: 532,
  },
  "12214": {
    DMA: 532,
  },
  "12220": {
    DMA: 532,
  },
  "12222": {
    DMA: 532,
  },
  "12223": {
    DMA: 532,
  },
  "12224": {
    DMA: 532,
  },
  "12225": {
    DMA: 532,
  },
  "12226": {
    DMA: 532,
  },
  "12227": {
    DMA: 532,
  },
  "12228": {
    DMA: 532,
  },
  "12229": {
    DMA: 532,
  },
  "12230": {
    DMA: 532,
  },
  "12231": {
    DMA: 532,
  },
  "12232": {
    DMA: 532,
  },
  "12233": {
    DMA: 532,
  },
  "12234": {
    DMA: 532,
  },
  "12235": {
    DMA: 532,
  },
  "12236": {
    DMA: 532,
  },
  "12237": {
    DMA: 532,
  },
  "12238": {
    DMA: 532,
  },
  "12239": {
    DMA: 532,
  },
  "12240": {
    DMA: 532,
  },
  "12241": {
    DMA: 532,
  },
  "12242": {
    DMA: 532,
  },
  "12243": {
    DMA: 532,
  },
  "12244": {
    DMA: 532,
  },
  "12245": {
    DMA: 532,
  },
  "12246": {
    DMA: 532,
  },
  "12247": {
    DMA: 532,
  },
  "12248": {
    DMA: 532,
  },
  "12249": {
    DMA: 532,
  },
  "12250": {
    DMA: 532,
  },
  "12252": {
    DMA: 532,
  },
  "12255": {
    DMA: 532,
  },
  "12256": {
    DMA: 532,
  },
  "12257": {
    DMA: 532,
  },
  "12260": {
    DMA: 532,
  },
  "12261": {
    DMA: 532,
  },
  "12288": {
    DMA: 532,
  },
  "12301": {
    DMA: 532,
  },
  "12302": {
    DMA: 532,
  },
  "12303": {
    DMA: 532,
  },
  "12304": {
    DMA: 532,
  },
  "12305": {
    DMA: 532,
  },
  "12306": {
    DMA: 532,
  },
  "12307": {
    DMA: 532,
  },
  "12308": {
    DMA: 532,
  },
  "12309": {
    DMA: 532,
  },
  "12325": {
    DMA: 532,
  },
  "12345": {
    DMA: 532,
  },
  "12401": {
    DMA: 501,
  },
  "12402": {
    DMA: 501,
  },
  "12404": {
    DMA: 501,
  },
  "12405": {
    DMA: 532,
  },
  "12406": {
    DMA: 502,
  },
  "12407": {
    DMA: 532,
  },
  "12409": {
    DMA: 501,
  },
  "12410": {
    DMA: 501,
  },
  "12411": {
    DMA: 501,
  },
  "12412": {
    DMA: 501,
  },
  "12413": {
    DMA: 532,
  },
  "12414": {
    DMA: 532,
  },
  "12416": {
    DMA: 501,
  },
  "12417": {
    DMA: 501,
  },
  "12418": {
    DMA: 532,
  },
  "12419": {
    DMA: 501,
  },
  "12420": {
    DMA: 501,
  },
  "12421": {
    DMA: 502,
  },
  "12422": {
    DMA: 532,
  },
  "12423": {
    DMA: 532,
  },
  "12424": {
    DMA: 532,
  },
  "12427": {
    DMA: 532,
  },
  "12428": {
    DMA: 501,
  },
  "12429": {
    DMA: 501,
  },
  "12430": {
    DMA: 502,
  },
  "12431": {
    DMA: 532,
  },
  "12432": {
    DMA: 501,
  },
  "12433": {
    DMA: 501,
  },
  "12434": {
    DMA: 502,
  },
  "12435": {
    DMA: 501,
  },
  "12436": {
    DMA: 532,
  },
  "12438": {
    DMA: 502,
  },
  "12439": {
    DMA: 532,
  },
  "12440": {
    DMA: 501,
  },
  "12441": {
    DMA: 501,
  },
  "12442": {
    DMA: 532,
  },
  "12443": {
    DMA: 501,
  },
  "12444": {
    DMA: 532,
  },
  "12446": {
    DMA: 501,
  },
  "12448": {
    DMA: 501,
  },
  "12449": {
    DMA: 501,
  },
  "12450": {
    DMA: 532,
  },
  "12451": {
    DMA: 532,
  },
  "12452": {
    DMA: 532,
  },
  "12453": {
    DMA: 501,
  },
  "12454": {
    DMA: 532,
  },
  "12455": {
    DMA: 502,
  },
  "12456": {
    DMA: 501,
  },
  "12457": {
    DMA: 501,
  },
  "12458": {
    DMA: 501,
  },
  "12459": {
    DMA: 502,
  },
  "12460": {
    DMA: 532,
  },
  "12461": {
    DMA: 501,
  },
  "12463": {
    DMA: 532,
  },
  "12464": {
    DMA: 501,
  },
  "12465": {
    DMA: 501,
  },
  "12466": {
    DMA: 501,
  },
  "12468": {
    DMA: 532,
  },
  "12469": {
    DMA: 532,
  },
  "12470": {
    DMA: 532,
  },
  "12471": {
    DMA: 501,
  },
  "12472": {
    DMA: 501,
  },
  "12473": {
    DMA: 532,
  },
  "12474": {
    DMA: 502,
  },
  "12475": {
    DMA: 501,
  },
  "12477": {
    DMA: 501,
  },
  "12480": {
    DMA: 501,
  },
  "12481": {
    DMA: 501,
  },
  "12482": {
    DMA: 532,
  },
  "12483": {
    DMA: 501,
  },
  "12484": {
    DMA: 501,
  },
  "12485": {
    DMA: 532,
  },
  "12486": {
    DMA: 501,
  },
  "12487": {
    DMA: 501,
  },
  "12489": {
    DMA: 501,
  },
  "12490": {
    DMA: 501,
  },
  "12491": {
    DMA: 501,
  },
  "12492": {
    DMA: 532,
  },
  "12493": {
    DMA: 501,
  },
  "12494": {
    DMA: 501,
  },
  "12495": {
    DMA: 501,
  },
  "12496": {
    DMA: 532,
  },
  "12498": {
    DMA: 501,
  },
  "12501": {
    DMA: 501,
  },
  "12502": {
    DMA: 532,
  },
  "12503": {
    DMA: 532,
  },
  "12504": {
    DMA: 501,
  },
  "12506": {
    DMA: 501,
  },
  "12507": {
    DMA: 501,
  },
  "12508": {
    DMA: 501,
  },
  "12510": {
    DMA: 501,
  },
  "12511": {
    DMA: 501,
  },
  "12512": {
    DMA: 501,
  },
  "12513": {
    DMA: 532,
  },
  "12514": {
    DMA: 501,
  },
  "12515": {
    DMA: 501,
  },
  "12516": {
    DMA: 532,
  },
  "12517": {
    DMA: 532,
  },
  "12518": {
    DMA: 501,
  },
  "12520": {
    DMA: 501,
  },
  "12521": {
    DMA: 532,
  },
  "12522": {
    DMA: 501,
  },
  "12523": {
    DMA: 532,
  },
  "12524": {
    DMA: 501,
  },
  "12525": {
    DMA: 501,
  },
  "12526": {
    DMA: 532,
  },
  "12527": {
    DMA: 501,
  },
  "12528": {
    DMA: 501,
  },
  "12529": {
    DMA: 532,
  },
  "12530": {
    DMA: 532,
  },
  "12531": {
    DMA: 501,
  },
  "12533": {
    DMA: 501,
  },
  "12534": {
    DMA: 532,
  },
  "12537": {
    DMA: 501,
  },
  "12538": {
    DMA: 501,
  },
  "12540": {
    DMA: 501,
  },
  "12541": {
    DMA: 532,
  },
  "12542": {
    DMA: 501,
  },
  "12543": {
    DMA: 501,
  },
  "12544": {
    DMA: 532,
  },
  "12545": {
    DMA: 501,
  },
  "12546": {
    DMA: 501,
  },
  "12547": {
    DMA: 501,
  },
  "12548": {
    DMA: 501,
  },
  "12549": {
    DMA: 501,
  },
  "12550": {
    DMA: 501,
  },
  "12551": {
    DMA: 501,
  },
  "12552": {
    DMA: 501,
  },
  "12553": {
    DMA: 501,
  },
  "12555": {
    DMA: 501,
  },
  "12561": {
    DMA: 501,
  },
  "12563": {
    DMA: 501,
  },
  "12564": {
    DMA: 501,
  },
  "12565": {
    DMA: 532,
  },
  "12566": {
    DMA: 501,
  },
  "12567": {
    DMA: 501,
  },
  "12568": {
    DMA: 501,
  },
  "12569": {
    DMA: 501,
  },
  "12570": {
    DMA: 501,
  },
  "12571": {
    DMA: 501,
  },
  "12572": {
    DMA: 501,
  },
  "12574": {
    DMA: 501,
  },
  "12575": {
    DMA: 501,
  },
  "12577": {
    DMA: 501,
  },
  "12578": {
    DMA: 501,
  },
  "12580": {
    DMA: 501,
  },
  "12581": {
    DMA: 501,
  },
  "12582": {
    DMA: 501,
  },
  "12583": {
    DMA: 501,
  },
  "12584": {
    DMA: 501,
  },
  "12585": {
    DMA: 501,
  },
  "12586": {
    DMA: 501,
  },
  "12588": {
    DMA: 501,
  },
  "12589": {
    DMA: 501,
  },
  "12590": {
    DMA: 501,
  },
  "12592": {
    DMA: 501,
  },
  "12593": {
    DMA: 532,
  },
  "12594": {
    DMA: 501,
  },
  "12601": {
    DMA: 501,
  },
  "12602": {
    DMA: 501,
  },
  "12603": {
    DMA: 501,
  },
  "12604": {
    DMA: 501,
  },
  "12701": {
    DMA: 501,
  },
  "12719": {
    DMA: 501,
  },
  "12720": {
    DMA: 501,
  },
  "12721": {
    DMA: 501,
  },
  "12722": {
    DMA: 501,
  },
  "12723": {
    DMA: 501,
  },
  "12724": {
    DMA: 501,
  },
  "12725": {
    DMA: 501,
  },
  "12726": {
    DMA: 501,
  },
  "12727": {
    DMA: 501,
  },
  "12729": {
    DMA: 501,
  },
  "12732": {
    DMA: 501,
  },
  "12733": {
    DMA: 501,
  },
  "12734": {
    DMA: 501,
  },
  "12736": {
    DMA: 501,
  },
  "12737": {
    DMA: 501,
  },
  "12738": {
    DMA: 501,
  },
  "12740": {
    DMA: 501,
  },
  "12741": {
    DMA: 501,
  },
  "12742": {
    DMA: 501,
  },
  "12743": {
    DMA: 501,
  },
  "12745": {
    DMA: 501,
  },
  "12746": {
    DMA: 501,
  },
  "12747": {
    DMA: 501,
  },
  "12748": {
    DMA: 501,
  },
  "12749": {
    DMA: 501,
  },
  "12750": {
    DMA: 501,
  },
  "12751": {
    DMA: 501,
  },
  "12752": {
    DMA: 501,
  },
  "12754": {
    DMA: 501,
  },
  "12758": {
    DMA: 501,
  },
  "12759": {
    DMA: 501,
  },
  "12760": {
    DMA: 501,
  },
  "12762": {
    DMA: 501,
  },
  "12763": {
    DMA: 501,
  },
  "12764": {
    DMA: 501,
  },
  "12765": {
    DMA: 501,
  },
  "12766": {
    DMA: 501,
  },
  "12767": {
    DMA: 501,
  },
  "12768": {
    DMA: 501,
  },
  "12769": {
    DMA: 501,
  },
  "12770": {
    DMA: 501,
  },
  "12771": {
    DMA: 501,
  },
  "12775": {
    DMA: 501,
  },
  "12776": {
    DMA: 501,
  },
  "12777": {
    DMA: 501,
  },
  "12778": {
    DMA: 501,
  },
  "12779": {
    DMA: 501,
  },
  "12780": {
    DMA: 501,
  },
  "12781": {
    DMA: 501,
  },
  "12783": {
    DMA: 501,
  },
  "12784": {
    DMA: 501,
  },
  "12785": {
    DMA: 501,
  },
  "12786": {
    DMA: 501,
  },
  "12787": {
    DMA: 501,
  },
  "12788": {
    DMA: 501,
  },
  "12789": {
    DMA: 501,
  },
  "12790": {
    DMA: 501,
  },
  "12791": {
    DMA: 501,
  },
  "12792": {
    DMA: 501,
  },
  "12801": {
    DMA: 532,
  },
  "12803": {
    DMA: 532,
  },
  "12804": {
    DMA: 532,
  },
  "12808": {
    DMA: 532,
  },
  "12809": {
    DMA: 532,
  },
  "12810": {
    DMA: 532,
  },
  "12811": {
    DMA: 532,
  },
  "12812": {
    DMA: 532,
  },
  "12814": {
    DMA: 532,
  },
  "12815": {
    DMA: 532,
  },
  "12816": {
    DMA: 532,
  },
  "12817": {
    DMA: 532,
  },
  "12819": {
    DMA: 532,
  },
  "12820": {
    DMA: 532,
  },
  "12821": {
    DMA: 532,
  },
  "12822": {
    DMA: 532,
  },
  "12823": {
    DMA: 532,
  },
  "12824": {
    DMA: 532,
  },
  "12827": {
    DMA: 532,
  },
  "12828": {
    DMA: 532,
  },
  "12831": {
    DMA: 532,
  },
  "12832": {
    DMA: 532,
  },
  "12833": {
    DMA: 532,
  },
  "12834": {
    DMA: 532,
  },
  "12835": {
    DMA: 532,
  },
  "12836": {
    DMA: 532,
  },
  "12837": {
    DMA: 532,
  },
  "12838": {
    DMA: 532,
  },
  "12839": {
    DMA: 532,
  },
  "12841": {
    DMA: 532,
  },
  "12842": {
    DMA: 532,
  },
  "12843": {
    DMA: 532,
  },
  "12844": {
    DMA: 532,
  },
  "12845": {
    DMA: 532,
  },
  "12846": {
    DMA: 532,
  },
  "12847": {
    DMA: 532,
  },
  "12848": {
    DMA: 532,
  },
  "12849": {
    DMA: 532,
  },
  "12850": {
    DMA: 532,
  },
  "12851": {
    DMA: 523,
  },
  "12852": {
    DMA: 523,
  },
  "12853": {
    DMA: 532,
  },
  "12854": {
    DMA: 532,
  },
  "12855": {
    DMA: 523,
  },
  "12856": {
    DMA: 532,
  },
  "12857": {
    DMA: 523,
  },
  "12858": {
    DMA: 523,
  },
  "12859": {
    DMA: 532,
  },
  "12860": {
    DMA: 532,
  },
  "12861": {
    DMA: 532,
  },
  "12862": {
    DMA: 532,
  },
  "12863": {
    DMA: 532,
  },
  "12864": {
    DMA: 532,
  },
  "12865": {
    DMA: 532,
  },
  "12866": {
    DMA: 532,
  },
  "12870": {
    DMA: 523,
  },
  "12871": {
    DMA: 532,
  },
  "12872": {
    DMA: 523,
  },
  "12873": {
    DMA: 532,
  },
  "12874": {
    DMA: 532,
  },
  "12878": {
    DMA: 532,
  },
  "12879": {
    DMA: 523,
  },
  "12883": {
    DMA: 523,
  },
  "12884": {
    DMA: 532,
  },
  "12885": {
    DMA: 532,
  },
  "12886": {
    DMA: 532,
  },
  "12887": {
    DMA: 532,
  },
  "12901": {
    DMA: 523,
  },
  "12903": {
    DMA: 523,
  },
  "12910": {
    DMA: 523,
  },
  "12911": {
    DMA: 523,
  },
  "12912": {
    DMA: 523,
  },
  "12913": {
    DMA: 523,
  },
  "12914": {
    DMA: 523,
  },
  "12915": {
    DMA: 523,
  },
  "12916": {
    DMA: 523,
  },
  "12917": {
    DMA: 523,
  },
  "12918": {
    DMA: 523,
  },
  "12919": {
    DMA: 523,
  },
  "12920": {
    DMA: 523,
  },
  "12921": {
    DMA: 523,
  },
  "12922": {
    DMA: 549,
  },
  "12923": {
    DMA: 523,
  },
  "12924": {
    DMA: 523,
  },
  "12926": {
    DMA: 523,
  },
  "12927": {
    DMA: 549,
  },
  "12928": {
    DMA: 523,
  },
  "12929": {
    DMA: 523,
  },
  "12930": {
    DMA: 523,
  },
  "12932": {
    DMA: 523,
  },
  "12933": {
    DMA: 523,
  },
  "12934": {
    DMA: 523,
  },
  "12935": {
    DMA: 523,
  },
  "12936": {
    DMA: 523,
  },
  "12937": {
    DMA: 523,
  },
  "12939": {
    DMA: 523,
  },
  "12941": {
    DMA: 523,
  },
  "12942": {
    DMA: 523,
  },
  "12943": {
    DMA: 523,
  },
  "12944": {
    DMA: 523,
  },
  "12945": {
    DMA: 523,
  },
  "12946": {
    DMA: 523,
  },
  "12949": {
    DMA: 549,
  },
  "12950": {
    DMA: 523,
  },
  "12952": {
    DMA: 523,
  },
  "12953": {
    DMA: 523,
  },
  "12955": {
    DMA: 523,
  },
  "12956": {
    DMA: 523,
  },
  "12957": {
    DMA: 523,
  },
  "12958": {
    DMA: 523,
  },
  "12959": {
    DMA: 523,
  },
  "12960": {
    DMA: 523,
  },
  "12961": {
    DMA: 523,
  },
  "12962": {
    DMA: 523,
  },
  "12964": {
    DMA: 523,
  },
  "12965": {
    DMA: 549,
  },
  "12966": {
    DMA: 523,
  },
  "12967": {
    DMA: 549,
  },
  "12969": {
    DMA: 523,
  },
  "12970": {
    DMA: 523,
  },
  "12972": {
    DMA: 523,
  },
  "12973": {
    DMA: 549,
  },
  "12974": {
    DMA: 523,
  },
  "12975": {
    DMA: 523,
  },
  "12976": {
    DMA: 523,
  },
  "12977": {
    DMA: 523,
  },
  "12978": {
    DMA: 523,
  },
  "12979": {
    DMA: 523,
  },
  "12980": {
    DMA: 523,
  },
  "12981": {
    DMA: 523,
  },
  "12983": {
    DMA: 523,
  },
  "12985": {
    DMA: 523,
  },
  "12986": {
    DMA: 523,
  },
  "12987": {
    DMA: 523,
  },
  "12989": {
    DMA: 523,
  },
  "12992": {
    DMA: 523,
  },
  "12993": {
    DMA: 523,
  },
  "12995": {
    DMA: 523,
  },
  "12996": {
    DMA: 523,
  },
  "12997": {
    DMA: 523,
  },
  "12998": {
    DMA: 523,
  },
  "13020": {
    DMA: 555,
  },
  "13021": {
    DMA: 555,
  },
  "13022": {
    DMA: 555,
  },
  "13024": {
    DMA: 555,
  },
  "13026": {
    DMA: 555,
  },
  "13027": {
    DMA: 555,
  },
  "13028": {
    DMA: 555,
  },
  "13029": {
    DMA: 555,
  },
  "13030": {
    DMA: 555,
  },
  "13031": {
    DMA: 555,
  },
  "13032": {
    DMA: 555,
  },
  "13033": {
    DMA: 555,
  },
  "13034": {
    DMA: 555,
  },
  "13035": {
    DMA: 555,
  },
  "13036": {
    DMA: 555,
  },
  "13037": {
    DMA: 555,
  },
  "13039": {
    DMA: 555,
  },
  "13040": {
    DMA: 555,
  },
  "13041": {
    DMA: 555,
  },
  "13042": {
    DMA: 555,
  },
  "13043": {
    DMA: 555,
  },
  "13044": {
    DMA: 555,
  },
  "13045": {
    DMA: 555,
  },
  "13051": {
    DMA: 555,
  },
  "13052": {
    DMA: 555,
  },
  "13053": {
    DMA: 555,
  },
  "13054": {
    DMA: 526,
  },
  "13056": {
    DMA: 555,
  },
  "13057": {
    DMA: 555,
  },
  "13060": {
    DMA: 555,
  },
  "13061": {
    DMA: 555,
  },
  "13062": {
    DMA: 555,
  },
  "13063": {
    DMA: 555,
  },
  "13064": {
    DMA: 555,
  },
  "13065": {
    DMA: 555,
  },
  "13066": {
    DMA: 555,
  },
  "13068": {
    DMA: 555,
  },
  "13069": {
    DMA: 555,
  },
  "13071": {
    DMA: 555,
  },
  "13072": {
    DMA: 555,
  },
  "13073": {
    DMA: 555,
  },
  "13074": {
    DMA: 555,
  },
  "13076": {
    DMA: 555,
  },
  "13077": {
    DMA: 555,
  },
  "13078": {
    DMA: 555,
  },
  "13080": {
    DMA: 555,
  },
  "13081": {
    DMA: 555,
  },
  "13082": {
    DMA: 555,
  },
  "13083": {
    DMA: 555,
  },
  "13084": {
    DMA: 555,
  },
  "13087": {
    DMA: 555,
  },
  "13088": {
    DMA: 555,
  },
  "13089": {
    DMA: 555,
  },
  "13090": {
    DMA: 555,
  },
  "13092": {
    DMA: 555,
  },
  "13093": {
    DMA: 555,
  },
  "13101": {
    DMA: 555,
  },
  "13102": {
    DMA: 555,
  },
  "13103": {
    DMA: 555,
  },
  "13104": {
    DMA: 555,
  },
  "13107": {
    DMA: 555,
  },
  "13108": {
    DMA: 555,
  },
  "13110": {
    DMA: 555,
  },
  "13111": {
    DMA: 555,
  },
  "13112": {
    DMA: 555,
  },
  "13113": {
    DMA: 555,
  },
  "13114": {
    DMA: 555,
  },
  "13115": {
    DMA: 555,
  },
  "13116": {
    DMA: 555,
  },
  "13117": {
    DMA: 555,
  },
  "13118": {
    DMA: 555,
  },
  "13119": {
    DMA: 555,
  },
  "13120": {
    DMA: 555,
  },
  "13121": {
    DMA: 555,
  },
  "13122": {
    DMA: 555,
  },
  "13123": {
    DMA: 526,
  },
  "13124": {
    DMA: 502,
  },
  "13126": {
    DMA: 555,
  },
  "13131": {
    DMA: 555,
  },
  "13132": {
    DMA: 555,
  },
  "13134": {
    DMA: 555,
  },
  "13135": {
    DMA: 555,
  },
  "13136": {
    DMA: 502,
  },
  "13137": {
    DMA: 555,
  },
  "13138": {
    DMA: 555,
  },
  "13139": {
    DMA: 555,
  },
  "13140": {
    DMA: 555,
  },
  "13141": {
    DMA: 555,
  },
  "13142": {
    DMA: 555,
  },
  "13143": {
    DMA: 538,
  },
  "13144": {
    DMA: 555,
  },
  "13145": {
    DMA: 555,
  },
  "13146": {
    DMA: 538,
  },
  "13147": {
    DMA: 555,
  },
  "13148": {
    DMA: 555,
  },
  "13152": {
    DMA: 555,
  },
  "13153": {
    DMA: 555,
  },
  "13154": {
    DMA: 538,
  },
  "13155": {
    DMA: 502,
  },
  "13156": {
    DMA: 555,
  },
  "13157": {
    DMA: 526,
  },
  "13158": {
    DMA: 555,
  },
  "13159": {
    DMA: 555,
  },
  "13160": {
    DMA: 555,
  },
  "13162": {
    DMA: 526,
  },
  "13163": {
    DMA: 555,
  },
  "13164": {
    DMA: 555,
  },
  "13165": {
    DMA: 555,
  },
  "13166": {
    DMA: 555,
  },
  "13167": {
    DMA: 555,
  },
  "13201": {
    DMA: 555,
  },
  "13202": {
    DMA: 555,
  },
  "13203": {
    DMA: 555,
  },
  "13204": {
    DMA: 555,
  },
  "13205": {
    DMA: 555,
  },
  "13206": {
    DMA: 555,
  },
  "13207": {
    DMA: 555,
  },
  "13208": {
    DMA: 555,
  },
  "13209": {
    DMA: 555,
  },
  "13210": {
    DMA: 555,
  },
  "13211": {
    DMA: 555,
  },
  "13212": {
    DMA: 555,
  },
  "13214": {
    DMA: 555,
  },
  "13215": {
    DMA: 555,
  },
  "13217": {
    DMA: 555,
  },
  "13218": {
    DMA: 555,
  },
  "13219": {
    DMA: 555,
  },
  "13220": {
    DMA: 555,
  },
  "13221": {
    DMA: 555,
  },
  "13224": {
    DMA: 555,
  },
  "13225": {
    DMA: 555,
  },
  "13235": {
    DMA: 555,
  },
  "13244": {
    DMA: 555,
  },
  "13250": {
    DMA: 555,
  },
  "13251": {
    DMA: 555,
  },
  "13252": {
    DMA: 555,
  },
  "13261": {
    DMA: 555,
  },
  "13290": {
    DMA: 555,
  },
  "13301": {
    DMA: 526,
  },
  "13302": {
    DMA: 555,
  },
  "13303": {
    DMA: 526,
  },
  "13304": {
    DMA: 526,
  },
  "13305": {
    DMA: 549,
  },
  "13308": {
    DMA: 526,
  },
  "13309": {
    DMA: 526,
  },
  "13310": {
    DMA: 555,
  },
  "13312": {
    DMA: 549,
  },
  "13313": {
    DMA: 526,
  },
  "13314": {
    DMA: 555,
  },
  "13315": {
    DMA: 526,
  },
  "13316": {
    DMA: 526,
  },
  "13317": {
    DMA: 532,
  },
  "13318": {
    DMA: 526,
  },
  "13319": {
    DMA: 526,
  },
  "13320": {
    DMA: 526,
  },
  "13321": {
    DMA: 526,
  },
  "13322": {
    DMA: 526,
  },
  "13323": {
    DMA: 526,
  },
  "13324": {
    DMA: 526,
  },
  "13325": {
    DMA: 549,
  },
  "13326": {
    DMA: 526,
  },
  "13327": {
    DMA: 549,
  },
  "13328": {
    DMA: 526,
  },
  "13329": {
    DMA: 526,
  },
  "13331": {
    DMA: 526,
  },
  "13332": {
    DMA: 502,
  },
  "13333": {
    DMA: 526,
  },
  "13334": {
    DMA: 555,
  },
  "13335": {
    DMA: 526,
  },
  "13337": {
    DMA: 526,
  },
  "13338": {
    DMA: 526,
  },
  "13339": {
    DMA: 532,
  },
  "13340": {
    DMA: 526,
  },
  "13341": {
    DMA: 526,
  },
  "13342": {
    DMA: 526,
  },
  "13343": {
    DMA: 549,
  },
  "13345": {
    DMA: 549,
  },
  "13346": {
    DMA: 555,
  },
  "13348": {
    DMA: 526,
  },
  "13350": {
    DMA: 526,
  },
  "13352": {
    DMA: 526,
  },
  "13353": {
    DMA: 532,
  },
  "13354": {
    DMA: 526,
  },
  "13355": {
    DMA: 555,
  },
  "13357": {
    DMA: 526,
  },
  "13360": {
    DMA: 532,
  },
  "13361": {
    DMA: 526,
  },
  "13362": {
    DMA: 526,
  },
  "13363": {
    DMA: 526,
  },
  "13364": {
    DMA: 555,
  },
  "13365": {
    DMA: 526,
  },
  "13367": {
    DMA: 549,
  },
  "13368": {
    DMA: 549,
  },
  "13401": {
    DMA: 526,
  },
  "13402": {
    DMA: 555,
  },
  "13403": {
    DMA: 526,
  },
  "13404": {
    DMA: 549,
  },
  "13406": {
    DMA: 526,
  },
  "13407": {
    DMA: 526,
  },
  "13408": {
    DMA: 555,
  },
  "13409": {
    DMA: 555,
  },
  "13410": {
    DMA: 532,
  },
  "13411": {
    DMA: 502,
  },
  "13413": {
    DMA: 526,
  },
  "13415": {
    DMA: 526,
  },
  "13416": {
    DMA: 526,
  },
  "13417": {
    DMA: 526,
  },
  "13418": {
    DMA: 555,
  },
  "13420": {
    DMA: 526,
  },
  "13421": {
    DMA: 555,
  },
  "13424": {
    DMA: 526,
  },
  "13425": {
    DMA: 526,
  },
  "13426": {
    DMA: 555,
  },
  "13428": {
    DMA: 532,
  },
  "13431": {
    DMA: 526,
  },
  "13433": {
    DMA: 549,
  },
  "13435": {
    DMA: 526,
  },
  "13436": {
    DMA: 532,
  },
  "13437": {
    DMA: 555,
  },
  "13438": {
    DMA: 526,
  },
  "13439": {
    DMA: 526,
  },
  "13440": {
    DMA: 526,
  },
  "13441": {
    DMA: 526,
  },
  "13442": {
    DMA: 526,
  },
  "13449": {
    DMA: 526,
  },
  "13450": {
    DMA: 526,
  },
  "13452": {
    DMA: 532,
  },
  "13454": {
    DMA: 526,
  },
  "13455": {
    DMA: 526,
  },
  "13456": {
    DMA: 526,
  },
  "13457": {
    DMA: 526,
  },
  "13459": {
    DMA: 532,
  },
  "13460": {
    DMA: 502,
  },
  "13461": {
    DMA: 526,
  },
  "13464": {
    DMA: 502,
  },
  "13465": {
    DMA: 555,
  },
  "13468": {
    DMA: 526,
  },
  "13469": {
    DMA: 526,
  },
  "13470": {
    DMA: 532,
  },
  "13471": {
    DMA: 526,
  },
  "13472": {
    DMA: 526,
  },
  "13473": {
    DMA: 549,
  },
  "13475": {
    DMA: 526,
  },
  "13476": {
    DMA: 526,
  },
  "13477": {
    DMA: 526,
  },
  "13478": {
    DMA: 526,
  },
  "13479": {
    DMA: 526,
  },
  "13480": {
    DMA: 526,
  },
  "13482": {
    DMA: 526,
  },
  "13483": {
    DMA: 526,
  },
  "13484": {
    DMA: 555,
  },
  "13485": {
    DMA: 555,
  },
  "13486": {
    DMA: 526,
  },
  "13488": {
    DMA: 526,
  },
  "13489": {
    DMA: 549,
  },
  "13490": {
    DMA: 526,
  },
  "13491": {
    DMA: 526,
  },
  "13492": {
    DMA: 526,
  },
  "13493": {
    DMA: 555,
  },
  "13494": {
    DMA: 526,
  },
  "13495": {
    DMA: 526,
  },
  "13501": {
    DMA: 526,
  },
  "13502": {
    DMA: 526,
  },
  "13503": {
    DMA: 526,
  },
  "13504": {
    DMA: 526,
  },
  "13505": {
    DMA: 526,
  },
  "13599": {
    DMA: 526,
  },
  "13601": {
    DMA: 549,
  },
  "13602": {
    DMA: 549,
  },
  "13603": {
    DMA: 549,
  },
  "13605": {
    DMA: 549,
  },
  "13606": {
    DMA: 549,
  },
  "13607": {
    DMA: 549,
  },
  "13608": {
    DMA: 549,
  },
  "13611": {
    DMA: 549,
  },
  "13612": {
    DMA: 549,
  },
  "13613": {
    DMA: 549,
  },
  "13614": {
    DMA: 549,
  },
  "13615": {
    DMA: 549,
  },
  "13616": {
    DMA: 549,
  },
  "13617": {
    DMA: 549,
  },
  "13618": {
    DMA: 549,
  },
  "13619": {
    DMA: 549,
  },
  "13620": {
    DMA: 549,
  },
  "13621": {
    DMA: 549,
  },
  "13622": {
    DMA: 549,
  },
  "13623": {
    DMA: 549,
  },
  "13624": {
    DMA: 549,
  },
  "13625": {
    DMA: 549,
  },
  "13626": {
    DMA: 549,
  },
  "13627": {
    DMA: 549,
  },
  "13628": {
    DMA: 549,
  },
  "13630": {
    DMA: 549,
  },
  "13631": {
    DMA: 549,
  },
  "13632": {
    DMA: 549,
  },
  "13633": {
    DMA: 549,
  },
  "13634": {
    DMA: 549,
  },
  "13635": {
    DMA: 549,
  },
  "13636": {
    DMA: 549,
  },
  "13637": {
    DMA: 549,
  },
  "13638": {
    DMA: 549,
  },
  "13639": {
    DMA: 549,
  },
  "13640": {
    DMA: 549,
  },
  "13641": {
    DMA: 549,
  },
  "13642": {
    DMA: 549,
  },
  "13643": {
    DMA: 549,
  },
  "13645": {
    DMA: 549,
  },
  "13646": {
    DMA: 549,
  },
  "13647": {
    DMA: 549,
  },
  "13648": {
    DMA: 549,
  },
  "13649": {
    DMA: 549,
  },
  "13650": {
    DMA: 549,
  },
  "13651": {
    DMA: 549,
  },
  "13652": {
    DMA: 549,
  },
  "13654": {
    DMA: 549,
  },
  "13655": {
    DMA: 523,
  },
  "13656": {
    DMA: 549,
  },
  "13657": {
    DMA: 549,
  },
  "13658": {
    DMA: 549,
  },
  "13659": {
    DMA: 549,
  },
  "13660": {
    DMA: 549,
  },
  "13661": {
    DMA: 549,
  },
  "13662": {
    DMA: 549,
  },
  "13664": {
    DMA: 549,
  },
  "13665": {
    DMA: 549,
  },
  "13666": {
    DMA: 549,
  },
  "13667": {
    DMA: 549,
  },
  "13668": {
    DMA: 549,
  },
  "13669": {
    DMA: 549,
  },
  "13670": {
    DMA: 549,
  },
  "13671": {
    DMA: 549,
  },
  "13672": {
    DMA: 549,
  },
  "13673": {
    DMA: 549,
  },
  "13674": {
    DMA: 549,
  },
  "13675": {
    DMA: 549,
  },
  "13676": {
    DMA: 549,
  },
  "13677": {
    DMA: 549,
  },
  "13678": {
    DMA: 549,
  },
  "13679": {
    DMA: 549,
  },
  "13680": {
    DMA: 549,
  },
  "13681": {
    DMA: 549,
  },
  "13682": {
    DMA: 549,
  },
  "13683": {
    DMA: 549,
  },
  "13684": {
    DMA: 549,
  },
  "13685": {
    DMA: 549,
  },
  "13687": {
    DMA: 549,
  },
  "13690": {
    DMA: 549,
  },
  "13691": {
    DMA: 549,
  },
  "13692": {
    DMA: 549,
  },
  "13693": {
    DMA: 549,
  },
  "13694": {
    DMA: 549,
  },
  "13695": {
    DMA: 549,
  },
  "13696": {
    DMA: 549,
  },
  "13697": {
    DMA: 549,
  },
  "13699": {
    DMA: 549,
  },
  "13730": {
    DMA: 502,
  },
  "13731": {
    DMA: 502,
  },
  "13732": {
    DMA: 502,
  },
  "13733": {
    DMA: 502,
  },
  "13734": {
    DMA: 502,
  },
  "13736": {
    DMA: 502,
  },
  "13737": {
    DMA: 502,
  },
  "13738": {
    DMA: 555,
  },
  "13739": {
    DMA: 502,
  },
  "13740": {
    DMA: 502,
  },
  "13743": {
    DMA: 502,
  },
  "13744": {
    DMA: 502,
  },
  "13745": {
    DMA: 502,
  },
  "13746": {
    DMA: 502,
  },
  "13747": {
    DMA: 526,
  },
  "13748": {
    DMA: 502,
  },
  "13749": {
    DMA: 502,
  },
  "13750": {
    DMA: 502,
  },
  "13751": {
    DMA: 502,
  },
  "13752": {
    DMA: 502,
  },
  "13753": {
    DMA: 502,
  },
  "13754": {
    DMA: 502,
  },
  "13755": {
    DMA: 502,
  },
  "13756": {
    DMA: 502,
  },
  "13757": {
    DMA: 502,
  },
  "13758": {
    DMA: 502,
  },
  "13760": {
    DMA: 502,
  },
  "13761": {
    DMA: 502,
  },
  "13762": {
    DMA: 502,
  },
  "13763": {
    DMA: 502,
  },
  "13774": {
    DMA: 502,
  },
  "13775": {
    DMA: 502,
  },
  "13776": {
    DMA: 526,
  },
  "13777": {
    DMA: 502,
  },
  "13778": {
    DMA: 502,
  },
  "13780": {
    DMA: 502,
  },
  "13782": {
    DMA: 502,
  },
  "13783": {
    DMA: 502,
  },
  "13784": {
    DMA: 555,
  },
  "13786": {
    DMA: 502,
  },
  "13787": {
    DMA: 502,
  },
  "13788": {
    DMA: 502,
  },
  "13790": {
    DMA: 502,
  },
  "13794": {
    DMA: 502,
  },
  "13795": {
    DMA: 502,
  },
  "13796": {
    DMA: 526,
  },
  "13797": {
    DMA: 502,
  },
  "13801": {
    DMA: 502,
  },
  "13802": {
    DMA: 502,
  },
  "13803": {
    DMA: 555,
  },
  "13804": {
    DMA: 502,
  },
  "13806": {
    DMA: 502,
  },
  "13807": {
    DMA: 526,
  },
  "13808": {
    DMA: 526,
  },
  "13809": {
    DMA: 502,
  },
  "13810": {
    DMA: 526,
  },
  "13811": {
    DMA: 502,
  },
  "13812": {
    DMA: 502,
  },
  "13813": {
    DMA: 502,
  },
  "13814": {
    DMA: 502,
  },
  "13815": {
    DMA: 502,
  },
  "13820": {
    DMA: 526,
  },
  "13825": {
    DMA: 526,
  },
  "13826": {
    DMA: 502,
  },
  "13827": {
    DMA: 502,
  },
  "13830": {
    DMA: 502,
  },
  "13832": {
    DMA: 502,
  },
  "13833": {
    DMA: 502,
  },
  "13834": {
    DMA: 526,
  },
  "13835": {
    DMA: 502,
  },
  "13837": {
    DMA: 502,
  },
  "13838": {
    DMA: 502,
  },
  "13839": {
    DMA: 502,
  },
  "13840": {
    DMA: 502,
  },
  "13841": {
    DMA: 502,
  },
  "13842": {
    DMA: 502,
  },
  "13843": {
    DMA: 502,
  },
  "13844": {
    DMA: 502,
  },
  "13845": {
    DMA: 502,
  },
  "13846": {
    DMA: 502,
  },
  "13847": {
    DMA: 502,
  },
  "13848": {
    DMA: 502,
  },
  "13849": {
    DMA: 526,
  },
  "13850": {
    DMA: 502,
  },
  "13851": {
    DMA: 502,
  },
  "13856": {
    DMA: 502,
  },
  "13859": {
    DMA: 526,
  },
  "13860": {
    DMA: 502,
  },
  "13861": {
    DMA: 526,
  },
  "13862": {
    DMA: 502,
  },
  "13863": {
    DMA: 555,
  },
  "13864": {
    DMA: 502,
  },
  "13865": {
    DMA: 502,
  },
  "13901": {
    DMA: 502,
  },
  "13902": {
    DMA: 502,
  },
  "13903": {
    DMA: 502,
  },
  "13904": {
    DMA: 502,
  },
  "13905": {
    DMA: 502,
  },
  "14001": {
    DMA: 514,
  },
  "14004": {
    DMA: 514,
  },
  "14005": {
    DMA: 514,
  },
  "14006": {
    DMA: 514,
  },
  "14008": {
    DMA: 514,
  },
  "14009": {
    DMA: 514,
  },
  "14010": {
    DMA: 514,
  },
  "14011": {
    DMA: 514,
  },
  "14012": {
    DMA: 514,
  },
  "14013": {
    DMA: 514,
  },
  "14020": {
    DMA: 514,
  },
  "14021": {
    DMA: 514,
  },
  "14024": {
    DMA: 514,
  },
  "14025": {
    DMA: 514,
  },
  "14026": {
    DMA: 514,
  },
  "14027": {
    DMA: 514,
  },
  "14028": {
    DMA: 514,
  },
  "14029": {
    DMA: 514,
  },
  "14030": {
    DMA: 514,
  },
  "14031": {
    DMA: 514,
  },
  "14032": {
    DMA: 514,
  },
  "14033": {
    DMA: 514,
  },
  "14034": {
    DMA: 514,
  },
  "14035": {
    DMA: 514,
  },
  "14036": {
    DMA: 514,
  },
  "14037": {
    DMA: 514,
  },
  "14038": {
    DMA: 514,
  },
  "14039": {
    DMA: 514,
  },
  "14040": {
    DMA: 514,
  },
  "14041": {
    DMA: 514,
  },
  "14042": {
    DMA: 514,
  },
  "14043": {
    DMA: 514,
  },
  "14047": {
    DMA: 514,
  },
  "14048": {
    DMA: 514,
  },
  "14051": {
    DMA: 514,
  },
  "14052": {
    DMA: 514,
  },
  "14054": {
    DMA: 514,
  },
  "14055": {
    DMA: 514,
  },
  "14056": {
    DMA: 514,
  },
  "14057": {
    DMA: 514,
  },
  "14058": {
    DMA: 514,
  },
  "14059": {
    DMA: 514,
  },
  "14060": {
    DMA: 514,
  },
  "14061": {
    DMA: 514,
  },
  "14062": {
    DMA: 514,
  },
  "14063": {
    DMA: 514,
  },
  "14065": {
    DMA: 514,
  },
  "14066": {
    DMA: 514,
  },
  "14067": {
    DMA: 514,
  },
  "14068": {
    DMA: 514,
  },
  "14069": {
    DMA: 514,
  },
  "14070": {
    DMA: 514,
  },
  "14072": {
    DMA: 514,
  },
  "14075": {
    DMA: 514,
  },
  "14080": {
    DMA: 514,
  },
  "14081": {
    DMA: 514,
  },
  "14082": {
    DMA: 514,
  },
  "14083": {
    DMA: 514,
  },
  "14085": {
    DMA: 514,
  },
  "14086": {
    DMA: 514,
  },
  "14091": {
    DMA: 514,
  },
  "14092": {
    DMA: 514,
  },
  "14094": {
    DMA: 514,
  },
  "14095": {
    DMA: 514,
  },
  "14098": {
    DMA: 514,
  },
  "14101": {
    DMA: 514,
  },
  "14102": {
    DMA: 514,
  },
  "14103": {
    DMA: 514,
  },
  "14105": {
    DMA: 514,
  },
  "14107": {
    DMA: 514,
  },
  "14108": {
    DMA: 514,
  },
  "14109": {
    DMA: 514,
  },
  "14110": {
    DMA: 514,
  },
  "14111": {
    DMA: 514,
  },
  "14112": {
    DMA: 514,
  },
  "14113": {
    DMA: 514,
  },
  "14120": {
    DMA: 514,
  },
  "14125": {
    DMA: 514,
  },
  "14126": {
    DMA: 514,
  },
  "14127": {
    DMA: 514,
  },
  "14129": {
    DMA: 514,
  },
  "14130": {
    DMA: 514,
  },
  "14131": {
    DMA: 514,
  },
  "14132": {
    DMA: 514,
  },
  "14133": {
    DMA: 514,
  },
  "14134": {
    DMA: 514,
  },
  "14135": {
    DMA: 514,
  },
  "14136": {
    DMA: 514,
  },
  "14138": {
    DMA: 514,
  },
  "14139": {
    DMA: 514,
  },
  "14140": {
    DMA: 514,
  },
  "14141": {
    DMA: 514,
  },
  "14143": {
    DMA: 514,
  },
  "14144": {
    DMA: 514,
  },
  "14145": {
    DMA: 514,
  },
  "14150": {
    DMA: 514,
  },
  "14151": {
    DMA: 514,
  },
  "14166": {
    DMA: 514,
  },
  "14167": {
    DMA: 514,
  },
  "14168": {
    DMA: 514,
  },
  "14169": {
    DMA: 514,
  },
  "14170": {
    DMA: 514,
  },
  "14171": {
    DMA: 514,
  },
  "14172": {
    DMA: 514,
  },
  "14173": {
    DMA: 514,
  },
  "14174": {
    DMA: 514,
  },
  "14201": {
    DMA: 514,
  },
  "14202": {
    DMA: 514,
  },
  "14203": {
    DMA: 514,
  },
  "14204": {
    DMA: 514,
  },
  "14205": {
    DMA: 514,
  },
  "14206": {
    DMA: 514,
  },
  "14207": {
    DMA: 514,
  },
  "14208": {
    DMA: 514,
  },
  "14209": {
    DMA: 514,
  },
  "14210": {
    DMA: 514,
  },
  "14211": {
    DMA: 514,
  },
  "14212": {
    DMA: 514,
  },
  "14213": {
    DMA: 514,
  },
  "14214": {
    DMA: 514,
  },
  "14215": {
    DMA: 514,
  },
  "14216": {
    DMA: 514,
  },
  "14217": {
    DMA: 514,
  },
  "14218": {
    DMA: 514,
  },
  "14219": {
    DMA: 514,
  },
  "14220": {
    DMA: 514,
  },
  "14221": {
    DMA: 514,
  },
  "14222": {
    DMA: 514,
  },
  "14223": {
    DMA: 514,
  },
  "14224": {
    DMA: 514,
  },
  "14225": {
    DMA: 514,
  },
  "14226": {
    DMA: 514,
  },
  "14227": {
    DMA: 514,
  },
  "14228": {
    DMA: 514,
  },
  "14231": {
    DMA: 514,
  },
  "14233": {
    DMA: 514,
  },
  "14240": {
    DMA: 514,
  },
  "14241": {
    DMA: 514,
  },
  "14260": {
    DMA: 514,
  },
  "14261": {
    DMA: 514,
  },
  "14263": {
    DMA: 514,
  },
  "14264": {
    DMA: 514,
  },
  "14265": {
    DMA: 514,
  },
  "14267": {
    DMA: 514,
  },
  "14269": {
    DMA: 514,
  },
  "14270": {
    DMA: 514,
  },
  "14272": {
    DMA: 514,
  },
  "14273": {
    DMA: 514,
  },
  "14276": {
    DMA: 514,
  },
  "14280": {
    DMA: 514,
  },
  "14301": {
    DMA: 514,
  },
  "14302": {
    DMA: 514,
  },
  "14303": {
    DMA: 514,
  },
  "14304": {
    DMA: 514,
  },
  "14305": {
    DMA: 514,
  },
  "14410": {
    DMA: 538,
  },
  "14411": {
    DMA: 514,
  },
  "14413": {
    DMA: 538,
  },
  "14414": {
    DMA: 538,
  },
  "14415": {
    DMA: 538,
  },
  "14416": {
    DMA: 514,
  },
  "14418": {
    DMA: 538,
  },
  "14420": {
    DMA: 538,
  },
  "14422": {
    DMA: 514,
  },
  "14423": {
    DMA: 538,
  },
  "14424": {
    DMA: 538,
  },
  "14425": {
    DMA: 538,
  },
  "14427": {
    DMA: 514,
  },
  "14428": {
    DMA: 538,
  },
  "14429": {
    DMA: 514,
  },
  "14430": {
    DMA: 538,
  },
  "14432": {
    DMA: 538,
  },
  "14433": {
    DMA: 538,
  },
  "14435": {
    DMA: 538,
  },
  "14437": {
    DMA: 538,
  },
  "14441": {
    DMA: 538,
  },
  "14443": {
    DMA: 538,
  },
  "14445": {
    DMA: 538,
  },
  "14449": {
    DMA: 538,
  },
  "14450": {
    DMA: 538,
  },
  "14452": {
    DMA: 514,
  },
  "14453": {
    DMA: 538,
  },
  "14454": {
    DMA: 538,
  },
  "14456": {
    DMA: 538,
  },
  "14461": {
    DMA: 538,
  },
  "14462": {
    DMA: 538,
  },
  "14463": {
    DMA: 538,
  },
  "14464": {
    DMA: 538,
  },
  "14466": {
    DMA: 538,
  },
  "14467": {
    DMA: 538,
  },
  "14468": {
    DMA: 538,
  },
  "14469": {
    DMA: 538,
  },
  "14470": {
    DMA: 514,
  },
  "14471": {
    DMA: 538,
  },
  "14472": {
    DMA: 538,
  },
  "14475": {
    DMA: 538,
  },
  "14476": {
    DMA: 514,
  },
  "14477": {
    DMA: 514,
  },
  "14478": {
    DMA: 538,
  },
  "14479": {
    DMA: 514,
  },
  "14480": {
    DMA: 538,
  },
  "14481": {
    DMA: 538,
  },
  "14482": {
    DMA: 514,
  },
  "14485": {
    DMA: 538,
  },
  "14486": {
    DMA: 514,
  },
  "14487": {
    DMA: 538,
  },
  "14488": {
    DMA: 538,
  },
  "14489": {
    DMA: 538,
  },
  "14502": {
    DMA: 538,
  },
  "14504": {
    DMA: 538,
  },
  "14505": {
    DMA: 538,
  },
  "14506": {
    DMA: 538,
  },
  "14507": {
    DMA: 538,
  },
  "14508": {
    DMA: 538,
  },
  "14510": {
    DMA: 538,
  },
  "14511": {
    DMA: 538,
  },
  "14512": {
    DMA: 538,
  },
  "14513": {
    DMA: 538,
  },
  "14514": {
    DMA: 538,
  },
  "14515": {
    DMA: 538,
  },
  "14516": {
    DMA: 538,
  },
  "14517": {
    DMA: 538,
  },
  "14518": {
    DMA: 538,
  },
  "14519": {
    DMA: 538,
  },
  "14520": {
    DMA: 538,
  },
  "14521": {
    DMA: 555,
  },
  "14522": {
    DMA: 538,
  },
  "14525": {
    DMA: 514,
  },
  "14526": {
    DMA: 538,
  },
  "14527": {
    DMA: 538,
  },
  "14529": {
    DMA: 565,
  },
  "14530": {
    DMA: 514,
  },
  "14532": {
    DMA: 538,
  },
  "14533": {
    DMA: 538,
  },
  "14534": {
    DMA: 538,
  },
  "14536": {
    DMA: 514,
  },
  "14537": {
    DMA: 538,
  },
  "14538": {
    DMA: 538,
  },
  "14539": {
    DMA: 538,
  },
  "14541": {
    DMA: 555,
  },
  "14542": {
    DMA: 538,
  },
  "14543": {
    DMA: 538,
  },
  "14544": {
    DMA: 538,
  },
  "14545": {
    DMA: 538,
  },
  "14546": {
    DMA: 538,
  },
  "14547": {
    DMA: 538,
  },
  "14548": {
    DMA: 538,
  },
  "14549": {
    DMA: 514,
  },
  "14550": {
    DMA: 514,
  },
  "14551": {
    DMA: 538,
  },
  "14555": {
    DMA: 538,
  },
  "14556": {
    DMA: 538,
  },
  "14557": {
    DMA: 514,
  },
  "14558": {
    DMA: 538,
  },
  "14559": {
    DMA: 538,
  },
  "14560": {
    DMA: 538,
  },
  "14561": {
    DMA: 538,
  },
  "14563": {
    DMA: 538,
  },
  "14564": {
    DMA: 538,
  },
  "14568": {
    DMA: 538,
  },
  "14569": {
    DMA: 514,
  },
  "14571": {
    DMA: 514,
  },
  "14572": {
    DMA: 565,
  },
  "14580": {
    DMA: 538,
  },
  "14585": {
    DMA: 538,
  },
  "14586": {
    DMA: 538,
  },
  "14588": {
    DMA: 555,
  },
  "14589": {
    DMA: 538,
  },
  "14590": {
    DMA: 538,
  },
  "14591": {
    DMA: 514,
  },
  "14592": {
    DMA: 538,
  },
  "14602": {
    DMA: 538,
  },
  "14603": {
    DMA: 538,
  },
  "14604": {
    DMA: 538,
  },
  "14605": {
    DMA: 538,
  },
  "14606": {
    DMA: 538,
  },
  "14607": {
    DMA: 538,
  },
  "14608": {
    DMA: 538,
  },
  "14609": {
    DMA: 538,
  },
  "14610": {
    DMA: 538,
  },
  "14611": {
    DMA: 538,
  },
  "14612": {
    DMA: 538,
  },
  "14613": {
    DMA: 538,
  },
  "14614": {
    DMA: 538,
  },
  "14615": {
    DMA: 538,
  },
  "14616": {
    DMA: 538,
  },
  "14617": {
    DMA: 538,
  },
  "14618": {
    DMA: 538,
  },
  "14619": {
    DMA: 538,
  },
  "14620": {
    DMA: 538,
  },
  "14621": {
    DMA: 538,
  },
  "14622": {
    DMA: 538,
  },
  "14623": {
    DMA: 538,
  },
  "14624": {
    DMA: 538,
  },
  "14625": {
    DMA: 538,
  },
  "14626": {
    DMA: 538,
  },
  "14627": {
    DMA: 538,
  },
  "14638": {
    DMA: 538,
  },
  "14639": {
    DMA: 538,
  },
  "14642": {
    DMA: 538,
  },
  "14643": {
    DMA: 538,
  },
  "14644": {
    DMA: 538,
  },
  "14645": {
    DMA: 538,
  },
  "14646": {
    DMA: 538,
  },
  "14647": {
    DMA: 538,
  },
  "14649": {
    DMA: 538,
  },
  "14650": {
    DMA: 538,
  },
  "14651": {
    DMA: 538,
  },
  "14652": {
    DMA: 538,
  },
  "14653": {
    DMA: 538,
  },
  "14664": {
    DMA: 538,
  },
  "14673": {
    DMA: 538,
  },
  "14683": {
    DMA: 538,
  },
  "14692": {
    DMA: 538,
  },
  "14694": {
    DMA: 538,
  },
  "14701": {
    DMA: 514,
  },
  "14702": {
    DMA: 514,
  },
  "14706": {
    DMA: 514,
  },
  "14707": {
    DMA: 514,
  },
  "14708": {
    DMA: 514,
  },
  "14709": {
    DMA: 514,
  },
  "14710": {
    DMA: 514,
  },
  "14711": {
    DMA: 514,
  },
  "14712": {
    DMA: 514,
  },
  "14714": {
    DMA: 514,
  },
  "14715": {
    DMA: 514,
  },
  "14716": {
    DMA: 514,
  },
  "14717": {
    DMA: 514,
  },
  "14718": {
    DMA: 514,
  },
  "14719": {
    DMA: 514,
  },
  "14720": {
    DMA: 514,
  },
  "14721": {
    DMA: 514,
  },
  "14722": {
    DMA: 514,
  },
  "14723": {
    DMA: 514,
  },
  "14724": {
    DMA: 514,
  },
  "14726": {
    DMA: 514,
  },
  "14727": {
    DMA: 514,
  },
  "14728": {
    DMA: 514,
  },
  "14729": {
    DMA: 514,
  },
  "14730": {
    DMA: 514,
  },
  "14731": {
    DMA: 514,
  },
  "14732": {
    DMA: 514,
  },
  "14733": {
    DMA: 514,
  },
  "14735": {
    DMA: 514,
  },
  "14736": {
    DMA: 514,
  },
  "14737": {
    DMA: 514,
  },
  "14738": {
    DMA: 514,
  },
  "14739": {
    DMA: 514,
  },
  "14740": {
    DMA: 514,
  },
  "14741": {
    DMA: 514,
  },
  "14742": {
    DMA: 514,
  },
  "14743": {
    DMA: 514,
  },
  "14744": {
    DMA: 514,
  },
  "14745": {
    DMA: 514,
  },
  "14747": {
    DMA: 514,
  },
  "14748": {
    DMA: 514,
  },
  "14750": {
    DMA: 514,
  },
  "14751": {
    DMA: 514,
  },
  "14752": {
    DMA: 514,
  },
  "14753": {
    DMA: 514,
  },
  "14754": {
    DMA: 514,
  },
  "14755": {
    DMA: 514,
  },
  "14756": {
    DMA: 514,
  },
  "14757": {
    DMA: 514,
  },
  "14758": {
    DMA: 514,
  },
  "14760": {
    DMA: 514,
  },
  "14766": {
    DMA: 514,
  },
  "14767": {
    DMA: 514,
  },
  "14769": {
    DMA: 514,
  },
  "14770": {
    DMA: 514,
  },
  "14772": {
    DMA: 514,
  },
  "14774": {
    DMA: 514,
  },
  "14775": {
    DMA: 514,
  },
  "14777": {
    DMA: 514,
  },
  "14778": {
    DMA: 514,
  },
  "14779": {
    DMA: 514,
  },
  "14781": {
    DMA: 514,
  },
  "14782": {
    DMA: 514,
  },
  "14783": {
    DMA: 514,
  },
  "14784": {
    DMA: 514,
  },
  "14785": {
    DMA: 514,
  },
  "14786": {
    DMA: 514,
  },
  "14787": {
    DMA: 514,
  },
  "14788": {
    DMA: 514,
  },
  "14801": {
    DMA: 565,
  },
  "14802": {
    DMA: 514,
  },
  "14803": {
    DMA: 514,
  },
  "14804": {
    DMA: 514,
  },
  "14805": {
    DMA: 565,
  },
  "14806": {
    DMA: 514,
  },
  "14807": {
    DMA: 565,
  },
  "14808": {
    DMA: 565,
  },
  "14809": {
    DMA: 565,
  },
  "14810": {
    DMA: 565,
  },
  "14812": {
    DMA: 565,
  },
  "14813": {
    DMA: 514,
  },
  "14814": {
    DMA: 565,
  },
  "14815": {
    DMA: 565,
  },
  "14816": {
    DMA: 565,
  },
  "14817": {
    DMA: 555,
  },
  "14818": {
    DMA: 565,
  },
  "14819": {
    DMA: 565,
  },
  "14820": {
    DMA: 565,
  },
  "14821": {
    DMA: 565,
  },
  "14822": {
    DMA: 514,
  },
  "14823": {
    DMA: 565,
  },
  "14824": {
    DMA: 565,
  },
  "14825": {
    DMA: 565,
  },
  "14826": {
    DMA: 565,
  },
  "14827": {
    DMA: 565,
  },
  "14830": {
    DMA: 565,
  },
  "14831": {
    DMA: 565,
  },
  "14836": {
    DMA: 538,
  },
  "14837": {
    DMA: 538,
  },
  "14838": {
    DMA: 565,
  },
  "14839": {
    DMA: 565,
  },
  "14840": {
    DMA: 565,
  },
  "14841": {
    DMA: 565,
  },
  "14842": {
    DMA: 538,
  },
  "14843": {
    DMA: 565,
  },
  "14845": {
    DMA: 565,
  },
  "14846": {
    DMA: 538,
  },
  "14847": {
    DMA: 555,
  },
  "14850": {
    DMA: 555,
  },
  "14851": {
    DMA: 555,
  },
  "14852": {
    DMA: 555,
  },
  "14853": {
    DMA: 555,
  },
  "14854": {
    DMA: 555,
  },
  "14855": {
    DMA: 565,
  },
  "14856": {
    DMA: 565,
  },
  "14857": {
    DMA: 538,
  },
  "14858": {
    DMA: 565,
  },
  "14859": {
    DMA: 502,
  },
  "14860": {
    DMA: 555,
  },
  "14861": {
    DMA: 565,
  },
  "14863": {
    DMA: 565,
  },
  "14864": {
    DMA: 565,
  },
  "14865": {
    DMA: 565,
  },
  "14867": {
    DMA: 555,
  },
  "14869": {
    DMA: 565,
  },
  "14870": {
    DMA: 565,
  },
  "14871": {
    DMA: 565,
  },
  "14872": {
    DMA: 565,
  },
  "14873": {
    DMA: 565,
  },
  "14874": {
    DMA: 565,
  },
  "14876": {
    DMA: 565,
  },
  "14877": {
    DMA: 565,
  },
  "14878": {
    DMA: 565,
  },
  "14879": {
    DMA: 565,
  },
  "14880": {
    DMA: 514,
  },
  "14881": {
    DMA: 555,
  },
  "14882": {
    DMA: 555,
  },
  "14883": {
    DMA: 502,
  },
  "14884": {
    DMA: 514,
  },
  "14885": {
    DMA: 565,
  },
  "14886": {
    DMA: 555,
  },
  "14887": {
    DMA: 565,
  },
  "14889": {
    DMA: 565,
  },
  "14891": {
    DMA: 565,
  },
  "14892": {
    DMA: 502,
  },
  "14893": {
    DMA: 565,
  },
  "14894": {
    DMA: 565,
  },
  "14895": {
    DMA: 514,
  },
  "14897": {
    DMA: 514,
  },
  "14898": {
    DMA: 565,
  },
  "14901": {
    DMA: 565,
  },
  "14902": {
    DMA: 565,
  },
  "14903": {
    DMA: 565,
  },
  "14904": {
    DMA: 565,
  },
  "14905": {
    DMA: 565,
  },
  "14925": {
    DMA: 565,
  },
  "15001": {
    DMA: 508,
  },
  "15003": {
    DMA: 508,
  },
  "15004": {
    DMA: 508,
  },
  "15005": {
    DMA: 508,
  },
  "15006": {
    DMA: 508,
  },
  "15007": {
    DMA: 508,
  },
  "15009": {
    DMA: 508,
  },
  "15010": {
    DMA: 508,
  },
  "15012": {
    DMA: 508,
  },
  "15014": {
    DMA: 508,
  },
  "15015": {
    DMA: 508,
  },
  "15017": {
    DMA: 508,
  },
  "15018": {
    DMA: 508,
  },
  "15019": {
    DMA: 508,
  },
  "15020": {
    DMA: 508,
  },
  "15021": {
    DMA: 508,
  },
  "15022": {
    DMA: 508,
  },
  "15024": {
    DMA: 508,
  },
  "15025": {
    DMA: 508,
  },
  "15026": {
    DMA: 508,
  },
  "15027": {
    DMA: 508,
  },
  "15028": {
    DMA: 508,
  },
  "15030": {
    DMA: 508,
  },
  "15031": {
    DMA: 508,
  },
  "15032": {
    DMA: 508,
  },
  "15033": {
    DMA: 508,
  },
  "15034": {
    DMA: 508,
  },
  "15035": {
    DMA: 508,
  },
  "15037": {
    DMA: 508,
  },
  "15038": {
    DMA: 508,
  },
  "15042": {
    DMA: 508,
  },
  "15043": {
    DMA: 508,
  },
  "15044": {
    DMA: 508,
  },
  "15045": {
    DMA: 508,
  },
  "15046": {
    DMA: 508,
  },
  "15047": {
    DMA: 508,
  },
  "15049": {
    DMA: 508,
  },
  "15050": {
    DMA: 508,
  },
  "15051": {
    DMA: 508,
  },
  "15052": {
    DMA: 508,
  },
  "15053": {
    DMA: 508,
  },
  "15054": {
    DMA: 508,
  },
  "15055": {
    DMA: 508,
  },
  "15056": {
    DMA: 508,
  },
  "15057": {
    DMA: 508,
  },
  "15059": {
    DMA: 508,
  },
  "15060": {
    DMA: 508,
  },
  "15061": {
    DMA: 508,
  },
  "15062": {
    DMA: 508,
  },
  "15063": {
    DMA: 508,
  },
  "15064": {
    DMA: 508,
  },
  "15065": {
    DMA: 508,
  },
  "15066": {
    DMA: 508,
  },
  "15067": {
    DMA: 508,
  },
  "15068": {
    DMA: 508,
  },
  "15069": {
    DMA: 508,
  },
  "15071": {
    DMA: 508,
  },
  "15072": {
    DMA: 508,
  },
  "15074": {
    DMA: 508,
  },
  "15075": {
    DMA: 508,
  },
  "15076": {
    DMA: 508,
  },
  "15077": {
    DMA: 508,
  },
  "15078": {
    DMA: 508,
  },
  "15081": {
    DMA: 508,
  },
  "15082": {
    DMA: 508,
  },
  "15083": {
    DMA: 508,
  },
  "15084": {
    DMA: 508,
  },
  "15085": {
    DMA: 508,
  },
  "15086": {
    DMA: 508,
  },
  "15087": {
    DMA: 508,
  },
  "15088": {
    DMA: 508,
  },
  "15089": {
    DMA: 508,
  },
  "15090": {
    DMA: 508,
  },
  "15091": {
    DMA: 508,
  },
  "15095": {
    DMA: 508,
  },
  "15096": {
    DMA: 508,
  },
  "15101": {
    DMA: 508,
  },
  "15102": {
    DMA: 508,
  },
  "15104": {
    DMA: 508,
  },
  "15106": {
    DMA: 508,
  },
  "15108": {
    DMA: 508,
  },
  "15110": {
    DMA: 508,
  },
  "15112": {
    DMA: 508,
  },
  "15116": {
    DMA: 508,
  },
  "15120": {
    DMA: 508,
  },
  "15122": {
    DMA: 508,
  },
  "15123": {
    DMA: 508,
  },
  "15126": {
    DMA: 508,
  },
  "15127": {
    DMA: 508,
  },
  "15129": {
    DMA: 508,
  },
  "15131": {
    DMA: 508,
  },
  "15132": {
    DMA: 508,
  },
  "15133": {
    DMA: 508,
  },
  "15134": {
    DMA: 508,
  },
  "15135": {
    DMA: 508,
  },
  "15136": {
    DMA: 508,
  },
  "15137": {
    DMA: 508,
  },
  "15139": {
    DMA: 508,
  },
  "15140": {
    DMA: 508,
  },
  "15142": {
    DMA: 508,
  },
  "15143": {
    DMA: 508,
  },
  "15144": {
    DMA: 508,
  },
  "15145": {
    DMA: 508,
  },
  "15146": {
    DMA: 508,
  },
  "15147": {
    DMA: 508,
  },
  "15148": {
    DMA: 508,
  },
  "15201": {
    DMA: 508,
  },
  "15202": {
    DMA: 508,
  },
  "15203": {
    DMA: 508,
  },
  "15204": {
    DMA: 508,
  },
  "15205": {
    DMA: 508,
  },
  "15206": {
    DMA: 508,
  },
  "15207": {
    DMA: 508,
  },
  "15208": {
    DMA: 508,
  },
  "15209": {
    DMA: 508,
  },
  "15210": {
    DMA: 508,
  },
  "15211": {
    DMA: 508,
  },
  "15212": {
    DMA: 508,
  },
  "15213": {
    DMA: 508,
  },
  "15214": {
    DMA: 508,
  },
  "15215": {
    DMA: 508,
  },
  "15216": {
    DMA: 508,
  },
  "15217": {
    DMA: 508,
  },
  "15218": {
    DMA: 508,
  },
  "15219": {
    DMA: 508,
  },
  "15220": {
    DMA: 508,
  },
  "15221": {
    DMA: 508,
  },
  "15222": {
    DMA: 508,
  },
  "15223": {
    DMA: 508,
  },
  "15224": {
    DMA: 508,
  },
  "15225": {
    DMA: 508,
  },
  "15226": {
    DMA: 508,
  },
  "15227": {
    DMA: 508,
  },
  "15228": {
    DMA: 508,
  },
  "15229": {
    DMA: 508,
  },
  "15230": {
    DMA: 508,
  },
  "15231": {
    DMA: 508,
  },
  "15232": {
    DMA: 508,
  },
  "15233": {
    DMA: 508,
  },
  "15234": {
    DMA: 508,
  },
  "15235": {
    DMA: 508,
  },
  "15236": {
    DMA: 508,
  },
  "15237": {
    DMA: 508,
  },
  "15238": {
    DMA: 508,
  },
  "15239": {
    DMA: 508,
  },
  "15240": {
    DMA: 508,
  },
  "15241": {
    DMA: 508,
  },
  "15242": {
    DMA: 508,
  },
  "15243": {
    DMA: 508,
  },
  "15244": {
    DMA: 508,
  },
  "15250": {
    DMA: 508,
  },
  "15251": {
    DMA: 508,
  },
  "15252": {
    DMA: 508,
  },
  "15253": {
    DMA: 508,
  },
  "15254": {
    DMA: 508,
  },
  "15255": {
    DMA: 508,
  },
  "15257": {
    DMA: 508,
  },
  "15258": {
    DMA: 508,
  },
  "15259": {
    DMA: 508,
  },
  "15260": {
    DMA: 508,
  },
  "15261": {
    DMA: 508,
  },
  "15262": {
    DMA: 508,
  },
  "15263": {
    DMA: 508,
  },
  "15264": {
    DMA: 508,
  },
  "15265": {
    DMA: 508,
  },
  "15266": {
    DMA: 508,
  },
  "15267": {
    DMA: 508,
  },
  "15268": {
    DMA: 508,
  },
  "15270": {
    DMA: 508,
  },
  "15272": {
    DMA: 508,
  },
  "15273": {
    DMA: 508,
  },
  "15274": {
    DMA: 508,
  },
  "15275": {
    DMA: 508,
  },
  "15276": {
    DMA: 508,
  },
  "15277": {
    DMA: 508,
  },
  "15278": {
    DMA: 508,
  },
  "15279": {
    DMA: 508,
  },
  "15281": {
    DMA: 508,
  },
  "15282": {
    DMA: 508,
  },
  "15283": {
    DMA: 508,
  },
  "15285": {
    DMA: "#N/A",
  },
  "15286": {
    DMA: 508,
  },
  "15288": {
    DMA: 508,
  },
  "15289": {
    DMA: 508,
  },
  "15290": {
    DMA: 508,
  },
  "15295": {
    DMA: 508,
  },
  "15301": {
    DMA: 508,
  },
  "15310": {
    DMA: 508,
  },
  "15311": {
    DMA: 508,
  },
  "15312": {
    DMA: 508,
  },
  "15313": {
    DMA: 508,
  },
  "15314": {
    DMA: 508,
  },
  "15315": {
    DMA: 508,
  },
  "15316": {
    DMA: 508,
  },
  "15317": {
    DMA: 508,
  },
  "15320": {
    DMA: 508,
  },
  "15321": {
    DMA: 508,
  },
  "15322": {
    DMA: 508,
  },
  "15323": {
    DMA: 508,
  },
  "15324": {
    DMA: 508,
  },
  "15325": {
    DMA: 508,
  },
  "15327": {
    DMA: 508,
  },
  "15329": {
    DMA: 508,
  },
  "15330": {
    DMA: 508,
  },
  "15331": {
    DMA: 508,
  },
  "15332": {
    DMA: 508,
  },
  "15333": {
    DMA: 508,
  },
  "15334": {
    DMA: 508,
  },
  "15336": {
    DMA: 508,
  },
  "15337": {
    DMA: 508,
  },
  "15338": {
    DMA: 508,
  },
  "15339": {
    DMA: 508,
  },
  "15340": {
    DMA: 508,
  },
  "15341": {
    DMA: 508,
  },
  "15342": {
    DMA: 508,
  },
  "15344": {
    DMA: 508,
  },
  "15345": {
    DMA: 508,
  },
  "15346": {
    DMA: 508,
  },
  "15347": {
    DMA: 508,
  },
  "15348": {
    DMA: 508,
  },
  "15349": {
    DMA: 508,
  },
  "15350": {
    DMA: 508,
  },
  "15351": {
    DMA: 508,
  },
  "15352": {
    DMA: 508,
  },
  "15353": {
    DMA: 508,
  },
  "15357": {
    DMA: 508,
  },
  "15358": {
    DMA: 508,
  },
  "15359": {
    DMA: 508,
  },
  "15360": {
    DMA: 508,
  },
  "15361": {
    DMA: 508,
  },
  "15362": {
    DMA: 508,
  },
  "15363": {
    DMA: 508,
  },
  "15364": {
    DMA: 508,
  },
  "15365": {
    DMA: 508,
  },
  "15366": {
    DMA: 508,
  },
  "15367": {
    DMA: 508,
  },
  "15368": {
    DMA: 508,
  },
  "15370": {
    DMA: 508,
  },
  "15376": {
    DMA: 508,
  },
  "15377": {
    DMA: 508,
  },
  "15378": {
    DMA: 508,
  },
  "15379": {
    DMA: 508,
  },
  "15380": {
    DMA: 508,
  },
  "15401": {
    DMA: 508,
  },
  "15410": {
    DMA: 508,
  },
  "15411": {
    DMA: 574,
  },
  "15412": {
    DMA: 508,
  },
  "15413": {
    DMA: 508,
  },
  "15415": {
    DMA: 508,
  },
  "15416": {
    DMA: 508,
  },
  "15417": {
    DMA: 508,
  },
  "15419": {
    DMA: 508,
  },
  "15420": {
    DMA: 508,
  },
  "15421": {
    DMA: 508,
  },
  "15422": {
    DMA: 508,
  },
  "15423": {
    DMA: 508,
  },
  "15424": {
    DMA: 574,
  },
  "15425": {
    DMA: 508,
  },
  "15427": {
    DMA: 508,
  },
  "15428": {
    DMA: 508,
  },
  "15429": {
    DMA: 508,
  },
  "15430": {
    DMA: 508,
  },
  "15431": {
    DMA: 508,
  },
  "15432": {
    DMA: 508,
  },
  "15433": {
    DMA: 508,
  },
  "15434": {
    DMA: 508,
  },
  "15435": {
    DMA: 508,
  },
  "15436": {
    DMA: 508,
  },
  "15437": {
    DMA: 508,
  },
  "15438": {
    DMA: 508,
  },
  "15439": {
    DMA: 508,
  },
  "15440": {
    DMA: 508,
  },
  "15442": {
    DMA: 508,
  },
  "15443": {
    DMA: 508,
  },
  "15444": {
    DMA: 508,
  },
  "15445": {
    DMA: 508,
  },
  "15446": {
    DMA: 508,
  },
  "15447": {
    DMA: 508,
  },
  "15448": {
    DMA: 508,
  },
  "15449": {
    DMA: 508,
  },
  "15450": {
    DMA: 508,
  },
  "15451": {
    DMA: 508,
  },
  "15454": {
    DMA: 508,
  },
  "15455": {
    DMA: 508,
  },
  "15456": {
    DMA: 508,
  },
  "15458": {
    DMA: 508,
  },
  "15459": {
    DMA: 508,
  },
  "15460": {
    DMA: 508,
  },
  "15461": {
    DMA: 508,
  },
  "15462": {
    DMA: 508,
  },
  "15463": {
    DMA: 508,
  },
  "15464": {
    DMA: 508,
  },
  "15465": {
    DMA: 508,
  },
  "15466": {
    DMA: 508,
  },
  "15467": {
    DMA: 508,
  },
  "15468": {
    DMA: 508,
  },
  "15469": {
    DMA: 508,
  },
  "15470": {
    DMA: 508,
  },
  "15472": {
    DMA: 508,
  },
  "15473": {
    DMA: 508,
  },
  "15474": {
    DMA: 508,
  },
  "15475": {
    DMA: 508,
  },
  "15476": {
    DMA: 508,
  },
  "15477": {
    DMA: 508,
  },
  "15478": {
    DMA: 508,
  },
  "15479": {
    DMA: 508,
  },
  "15480": {
    DMA: 508,
  },
  "15482": {
    DMA: 508,
  },
  "15483": {
    DMA: 508,
  },
  "15484": {
    DMA: 508,
  },
  "15485": {
    DMA: 574,
  },
  "15486": {
    DMA: 508,
  },
  "15488": {
    DMA: 508,
  },
  "15489": {
    DMA: 508,
  },
  "15490": {
    DMA: 508,
  },
  "15492": {
    DMA: 508,
  },
  "15501": {
    DMA: 574,
  },
  "15502": {
    DMA: 574,
  },
  "15510": {
    DMA: 574,
  },
  "15520": {
    DMA: 574,
  },
  "15521": {
    DMA: 574,
  },
  "15522": {
    DMA: 574,
  },
  "15530": {
    DMA: 574,
  },
  "15531": {
    DMA: 574,
  },
  "15532": {
    DMA: 574,
  },
  "15533": {
    DMA: 574,
  },
  "15534": {
    DMA: 574,
  },
  "15535": {
    DMA: 574,
  },
  "15536": {
    DMA: 511,
  },
  "15537": {
    DMA: 574,
  },
  "15538": {
    DMA: 574,
  },
  "15539": {
    DMA: 574,
  },
  "15540": {
    DMA: 574,
  },
  "15541": {
    DMA: 574,
  },
  "15542": {
    DMA: 574,
  },
  "15544": {
    DMA: 574,
  },
  "15545": {
    DMA: 574,
  },
  "15546": {
    DMA: 574,
  },
  "15547": {
    DMA: 574,
  },
  "15548": {
    DMA: 574,
  },
  "15549": {
    DMA: 574,
  },
  "15550": {
    DMA: 574,
  },
  "15551": {
    DMA: 574,
  },
  "15552": {
    DMA: 574,
  },
  "15553": {
    DMA: 574,
  },
  "15554": {
    DMA: 574,
  },
  "15555": {
    DMA: 574,
  },
  "15557": {
    DMA: 574,
  },
  "15558": {
    DMA: 574,
  },
  "15559": {
    DMA: 574,
  },
  "15560": {
    DMA: 574,
  },
  "15561": {
    DMA: 574,
  },
  "15562": {
    DMA: 574,
  },
  "15563": {
    DMA: 574,
  },
  "15564": {
    DMA: 574,
  },
  "15565": {
    DMA: 574,
  },
  "15601": {
    DMA: 508,
  },
  "15605": {
    DMA: 508,
  },
  "15606": {
    DMA: 508,
  },
  "15610": {
    DMA: 508,
  },
  "15611": {
    DMA: 508,
  },
  "15612": {
    DMA: 508,
  },
  "15613": {
    DMA: 508,
  },
  "15615": {
    DMA: 508,
  },
  "15616": {
    DMA: 508,
  },
  "15617": {
    DMA: 508,
  },
  "15618": {
    DMA: 508,
  },
  "15619": {
    DMA: 508,
  },
  "15620": {
    DMA: 508,
  },
  "15621": {
    DMA: 508,
  },
  "15622": {
    DMA: 508,
  },
  "15623": {
    DMA: 508,
  },
  "15624": {
    DMA: 508,
  },
  "15625": {
    DMA: 508,
  },
  "15626": {
    DMA: 508,
  },
  "15627": {
    DMA: 508,
  },
  "15628": {
    DMA: 508,
  },
  "15629": {
    DMA: 508,
  },
  "15631": {
    DMA: 508,
  },
  "15632": {
    DMA: 508,
  },
  "15633": {
    DMA: 508,
  },
  "15634": {
    DMA: 508,
  },
  "15635": {
    DMA: 508,
  },
  "15636": {
    DMA: 508,
  },
  "15637": {
    DMA: 508,
  },
  "15638": {
    DMA: 508,
  },
  "15639": {
    DMA: 508,
  },
  "15640": {
    DMA: 508,
  },
  "15641": {
    DMA: 508,
  },
  "15642": {
    DMA: 508,
  },
  "15644": {
    DMA: 508,
  },
  "15646": {
    DMA: 508,
  },
  "15647": {
    DMA: 508,
  },
  "15650": {
    DMA: 508,
  },
  "15655": {
    DMA: 508,
  },
  "15656": {
    DMA: 508,
  },
  "15658": {
    DMA: 508,
  },
  "15660": {
    DMA: 508,
  },
  "15661": {
    DMA: 508,
  },
  "15662": {
    DMA: 508,
  },
  "15663": {
    DMA: 508,
  },
  "15664": {
    DMA: 508,
  },
  "15665": {
    DMA: 508,
  },
  "15666": {
    DMA: 508,
  },
  "15668": {
    DMA: 508,
  },
  "15670": {
    DMA: 508,
  },
  "15671": {
    DMA: 508,
  },
  "15672": {
    DMA: 508,
  },
  "15673": {
    DMA: 508,
  },
  "15674": {
    DMA: 508,
  },
  "15675": {
    DMA: 508,
  },
  "15676": {
    DMA: 508,
  },
  "15677": {
    DMA: 508,
  },
  "15678": {
    DMA: 508,
  },
  "15679": {
    DMA: 508,
  },
  "15680": {
    DMA: 508,
  },
  "15681": {
    DMA: 508,
  },
  "15682": {
    DMA: 508,
  },
  "15683": {
    DMA: 508,
  },
  "15684": {
    DMA: 508,
  },
  "15685": {
    DMA: 508,
  },
  "15686": {
    DMA: 508,
  },
  "15687": {
    DMA: 508,
  },
  "15688": {
    DMA: 508,
  },
  "15689": {
    DMA: 508,
  },
  "15690": {
    DMA: 508,
  },
  "15691": {
    DMA: 508,
  },
  "15692": {
    DMA: 508,
  },
  "15693": {
    DMA: 508,
  },
  "15695": {
    DMA: 508,
  },
  "15696": {
    DMA: 508,
  },
  "15697": {
    DMA: 508,
  },
  "15698": {
    DMA: 508,
  },
  "15701": {
    DMA: 508,
  },
  "15705": {
    DMA: 508,
  },
  "15710": {
    DMA: 508,
  },
  "15711": {
    DMA: 574,
  },
  "15712": {
    DMA: 508,
  },
  "15713": {
    DMA: 508,
  },
  "15714": {
    DMA: 574,
  },
  "15715": {
    DMA: 574,
  },
  "15716": {
    DMA: 508,
  },
  "15717": {
    DMA: 508,
  },
  "15720": {
    DMA: 508,
  },
  "15721": {
    DMA: 574,
  },
  "15722": {
    DMA: 574,
  },
  "15723": {
    DMA: 508,
  },
  "15724": {
    DMA: 508,
  },
  "15725": {
    DMA: 508,
  },
  "15727": {
    DMA: 508,
  },
  "15728": {
    DMA: 508,
  },
  "15729": {
    DMA: 508,
  },
  "15730": {
    DMA: 574,
  },
  "15731": {
    DMA: 508,
  },
  "15732": {
    DMA: 508,
  },
  "15733": {
    DMA: 574,
  },
  "15734": {
    DMA: 508,
  },
  "15736": {
    DMA: 508,
  },
  "15737": {
    DMA: 574,
  },
  "15738": {
    DMA: 574,
  },
  "15739": {
    DMA: 508,
  },
  "15740": {
    DMA: 574,
  },
  "15741": {
    DMA: 508,
  },
  "15742": {
    DMA: 508,
  },
  "15744": {
    DMA: 574,
  },
  "15745": {
    DMA: 508,
  },
  "15746": {
    DMA: 508,
  },
  "15747": {
    DMA: 508,
  },
  "15748": {
    DMA: 508,
  },
  "15750": {
    DMA: 508,
  },
  "15752": {
    DMA: 508,
  },
  "15753": {
    DMA: 574,
  },
  "15754": {
    DMA: 508,
  },
  "15756": {
    DMA: 508,
  },
  "15757": {
    DMA: 574,
  },
  "15758": {
    DMA: 508,
  },
  "15759": {
    DMA: 508,
  },
  "15760": {
    DMA: 574,
  },
  "15761": {
    DMA: 508,
  },
  "15762": {
    DMA: 574,
  },
  "15763": {
    DMA: 508,
  },
  "15764": {
    DMA: 574,
  },
  "15765": {
    DMA: 508,
  },
  "15767": {
    DMA: 574,
  },
  "15770": {
    DMA: 574,
  },
  "15771": {
    DMA: 508,
  },
  "15772": {
    DMA: 508,
  },
  "15773": {
    DMA: 574,
  },
  "15774": {
    DMA: 508,
  },
  "15775": {
    DMA: 574,
  },
  "15776": {
    DMA: 574,
  },
  "15777": {
    DMA: 508,
  },
  "15778": {
    DMA: 574,
  },
  "15779": {
    DMA: 508,
  },
  "15780": {
    DMA: 574,
  },
  "15781": {
    DMA: 574,
  },
  "15783": {
    DMA: 508,
  },
  "15784": {
    DMA: 574,
  },
  "15801": {
    DMA: 574,
  },
  "15821": {
    DMA: 574,
  },
  "15822": {
    DMA: 574,
  },
  "15823": {
    DMA: 574,
  },
  "15824": {
    DMA: 574,
  },
  "15825": {
    DMA: 574,
  },
  "15827": {
    DMA: 574,
  },
  "15828": {
    DMA: 508,
  },
  "15829": {
    DMA: 574,
  },
  "15831": {
    DMA: 574,
  },
  "15832": {
    DMA: 574,
  },
  "15834": {
    DMA: 574,
  },
  "15840": {
    DMA: 574,
  },
  "15841": {
    DMA: 574,
  },
  "15845": {
    DMA: 574,
  },
  "15846": {
    DMA: 574,
  },
  "15847": {
    DMA: 574,
  },
  "15848": {
    DMA: 574,
  },
  "15849": {
    DMA: 574,
  },
  "15851": {
    DMA: 574,
  },
  "15853": {
    DMA: 574,
  },
  "15856": {
    DMA: 574,
  },
  "15857": {
    DMA: 574,
  },
  "15860": {
    DMA: 574,
  },
  "15861": {
    DMA: 574,
  },
  "15863": {
    DMA: 574,
  },
  "15864": {
    DMA: 574,
  },
  "15865": {
    DMA: 574,
  },
  "15866": {
    DMA: 574,
  },
  "15868": {
    DMA: 574,
  },
  "15870": {
    DMA: 574,
  },
  "15901": {
    DMA: 574,
  },
  "15902": {
    DMA: 574,
  },
  "15904": {
    DMA: 574,
  },
  "15905": {
    DMA: 574,
  },
  "15906": {
    DMA: 574,
  },
  "15907": {
    DMA: 574,
  },
  "15909": {
    DMA: 574,
  },
  "15915": {
    DMA: 574,
  },
  "15920": {
    DMA: 508,
  },
  "15921": {
    DMA: 574,
  },
  "15922": {
    DMA: 574,
  },
  "15923": {
    DMA: 508,
  },
  "15924": {
    DMA: 574,
  },
  "15925": {
    DMA: 574,
  },
  "15926": {
    DMA: 574,
  },
  "15927": {
    DMA: 574,
  },
  "15928": {
    DMA: 574,
  },
  "15929": {
    DMA: 508,
  },
  "15930": {
    DMA: 574,
  },
  "15931": {
    DMA: 574,
  },
  "15934": {
    DMA: 574,
  },
  "15935": {
    DMA: 574,
  },
  "15936": {
    DMA: 574,
  },
  "15937": {
    DMA: 574,
  },
  "15938": {
    DMA: 574,
  },
  "15940": {
    DMA: 574,
  },
  "15942": {
    DMA: 574,
  },
  "15943": {
    DMA: 574,
  },
  "15944": {
    DMA: 508,
  },
  "15945": {
    DMA: 574,
  },
  "15946": {
    DMA: 574,
  },
  "15948": {
    DMA: 574,
  },
  "15949": {
    DMA: 508,
  },
  "15951": {
    DMA: 574,
  },
  "15952": {
    DMA: 574,
  },
  "15953": {
    DMA: 574,
  },
  "15954": {
    DMA: 508,
  },
  "15955": {
    DMA: 574,
  },
  "15956": {
    DMA: 574,
  },
  "15957": {
    DMA: 508,
  },
  "15958": {
    DMA: 574,
  },
  "15959": {
    DMA: 574,
  },
  "15960": {
    DMA: 574,
  },
  "15961": {
    DMA: 574,
  },
  "15962": {
    DMA: 574,
  },
  "15963": {
    DMA: 574,
  },
  "16001": {
    DMA: 508,
  },
  "16002": {
    DMA: 508,
  },
  "16003": {
    DMA: 508,
  },
  "16016": {
    DMA: 508,
  },
  "16017": {
    DMA: 508,
  },
  "16018": {
    DMA: 508,
  },
  "16020": {
    DMA: 508,
  },
  "16021": {
    DMA: 508,
  },
  "16022": {
    DMA: 508,
  },
  "16023": {
    DMA: 508,
  },
  "16024": {
    DMA: 508,
  },
  "16025": {
    DMA: 508,
  },
  "16027": {
    DMA: 508,
  },
  "16028": {
    DMA: 508,
  },
  "16029": {
    DMA: 508,
  },
  "16030": {
    DMA: 508,
  },
  "16033": {
    DMA: 508,
  },
  "16034": {
    DMA: 508,
  },
  "16035": {
    DMA: 508,
  },
  "16036": {
    DMA: 508,
  },
  "16037": {
    DMA: 508,
  },
  "16038": {
    DMA: 508,
  },
  "16039": {
    DMA: 508,
  },
  "16040": {
    DMA: 508,
  },
  "16041": {
    DMA: 508,
  },
  "16045": {
    DMA: 508,
  },
  "16046": {
    DMA: 508,
  },
  "16048": {
    DMA: 508,
  },
  "16049": {
    DMA: 508,
  },
  "16050": {
    DMA: 508,
  },
  "16051": {
    DMA: 508,
  },
  "16052": {
    DMA: 508,
  },
  "16053": {
    DMA: 508,
  },
  "16054": {
    DMA: 508,
  },
  "16055": {
    DMA: 508,
  },
  "16056": {
    DMA: 508,
  },
  "16057": {
    DMA: 508,
  },
  "16058": {
    DMA: 508,
  },
  "16059": {
    DMA: 508,
  },
  "16061": {
    DMA: 508,
  },
  "16063": {
    DMA: 508,
  },
  "16066": {
    DMA: 508,
  },
  "16101": {
    DMA: 508,
  },
  "16102": {
    DMA: 508,
  },
  "16103": {
    DMA: 508,
  },
  "16105": {
    DMA: 508,
  },
  "16107": {
    DMA: 508,
  },
  "16108": {
    DMA: 508,
  },
  "16110": {
    DMA: 516,
  },
  "16111": {
    DMA: 516,
  },
  "16112": {
    DMA: 508,
  },
  "16113": {
    DMA: 536,
  },
  "16114": {
    DMA: 536,
  },
  "16115": {
    DMA: 508,
  },
  "16116": {
    DMA: 508,
  },
  "16117": {
    DMA: 508,
  },
  "16120": {
    DMA: 508,
  },
  "16121": {
    DMA: 536,
  },
  "16123": {
    DMA: 508,
  },
  "16124": {
    DMA: 536,
  },
  "16125": {
    DMA: 536,
  },
  "16127": {
    DMA: 536,
  },
  "16130": {
    DMA: 536,
  },
  "16131": {
    DMA: 516,
  },
  "16132": {
    DMA: 508,
  },
  "16133": {
    DMA: 536,
  },
  "16134": {
    DMA: 536,
  },
  "16136": {
    DMA: 508,
  },
  "16137": {
    DMA: 536,
  },
  "16140": {
    DMA: 508,
  },
  "16141": {
    DMA: 508,
  },
  "16142": {
    DMA: 508,
  },
  "16143": {
    DMA: 508,
  },
  "16145": {
    DMA: 536,
  },
  "16146": {
    DMA: 536,
  },
  "16148": {
    DMA: 536,
  },
  "16150": {
    DMA: 536,
  },
  "16151": {
    DMA: 536,
  },
  "16153": {
    DMA: 536,
  },
  "16154": {
    DMA: 536,
  },
  "16155": {
    DMA: 508,
  },
  "16156": {
    DMA: 508,
  },
  "16157": {
    DMA: 508,
  },
  "16159": {
    DMA: 536,
  },
  "16160": {
    DMA: 508,
  },
  "16161": {
    DMA: 536,
  },
  "16172": {
    DMA: 508,
  },
  "16201": {
    DMA: 508,
  },
  "16210": {
    DMA: 508,
  },
  "16211": {
    DMA: 508,
  },
  "16212": {
    DMA: 508,
  },
  "16213": {
    DMA: 508,
  },
  "16214": {
    DMA: 508,
  },
  "16215": {
    DMA: 508,
  },
  "16217": {
    DMA: 508,
  },
  "16218": {
    DMA: 508,
  },
  "16220": {
    DMA: 508,
  },
  "16221": {
    DMA: 508,
  },
  "16222": {
    DMA: 508,
  },
  "16223": {
    DMA: 508,
  },
  "16224": {
    DMA: 508,
  },
  "16225": {
    DMA: 508,
  },
  "16226": {
    DMA: 508,
  },
  "16228": {
    DMA: 508,
  },
  "16229": {
    DMA: 508,
  },
  "16230": {
    DMA: 508,
  },
  "16232": {
    DMA: 508,
  },
  "16233": {
    DMA: 508,
  },
  "16234": {
    DMA: 508,
  },
  "16235": {
    DMA: 508,
  },
  "16236": {
    DMA: 508,
  },
  "16238": {
    DMA: 508,
  },
  "16239": {
    DMA: 508,
  },
  "16240": {
    DMA: 508,
  },
  "16242": {
    DMA: 508,
  },
  "16244": {
    DMA: 508,
  },
  "16245": {
    DMA: 508,
  },
  "16246": {
    DMA: 508,
  },
  "16248": {
    DMA: 508,
  },
  "16249": {
    DMA: 508,
  },
  "16250": {
    DMA: 508,
  },
  "16253": {
    DMA: 508,
  },
  "16254": {
    DMA: 508,
  },
  "16255": {
    DMA: 508,
  },
  "16256": {
    DMA: 508,
  },
  "16257": {
    DMA: 508,
  },
  "16258": {
    DMA: 508,
  },
  "16259": {
    DMA: 508,
  },
  "16260": {
    DMA: 508,
  },
  "16261": {
    DMA: 508,
  },
  "16262": {
    DMA: 508,
  },
  "16263": {
    DMA: 508,
  },
  "16301": {
    DMA: 508,
  },
  "16311": {
    DMA: 536,
  },
  "16312": {
    DMA: 516,
  },
  "16313": {
    DMA: 516,
  },
  "16314": {
    DMA: 516,
  },
  "16316": {
    DMA: 516,
  },
  "16317": {
    DMA: 508,
  },
  "16319": {
    DMA: 508,
  },
  "16321": {
    DMA: 508,
  },
  "16322": {
    DMA: 508,
  },
  "16323": {
    DMA: 508,
  },
  "16326": {
    DMA: 508,
  },
  "16327": {
    DMA: 516,
  },
  "16328": {
    DMA: 516,
  },
  "16329": {
    DMA: 516,
  },
  "16331": {
    DMA: 508,
  },
  "16332": {
    DMA: 508,
  },
  "16333": {
    DMA: 514,
  },
  "16334": {
    DMA: 508,
  },
  "16335": {
    DMA: 516,
  },
  "16340": {
    DMA: 516,
  },
  "16341": {
    DMA: 508,
  },
  "16342": {
    DMA: 508,
  },
  "16343": {
    DMA: 508,
  },
  "16344": {
    DMA: 508,
  },
  "16345": {
    DMA: 516,
  },
  "16346": {
    DMA: 508,
  },
  "16347": {
    DMA: 516,
  },
  "16350": {
    DMA: 516,
  },
  "16351": {
    DMA: 516,
  },
  "16352": {
    DMA: 516,
  },
  "16353": {
    DMA: 508,
  },
  "16354": {
    DMA: 516,
  },
  "16360": {
    DMA: 516,
  },
  "16361": {
    DMA: 508,
  },
  "16362": {
    DMA: 508,
  },
  "16364": {
    DMA: 508,
  },
  "16365": {
    DMA: 516,
  },
  "16366": {
    DMA: 516,
  },
  "16367": {
    DMA: 516,
  },
  "16368": {
    DMA: 516,
  },
  "16369": {
    DMA: 516,
  },
  "16370": {
    DMA: 508,
  },
  "16371": {
    DMA: 516,
  },
  "16372": {
    DMA: 508,
  },
  "16373": {
    DMA: 508,
  },
  "16374": {
    DMA: 508,
  },
  "16375": {
    DMA: 508,
  },
  "16388": {
    DMA: 516,
  },
  "16401": {
    DMA: 516,
  },
  "16402": {
    DMA: 516,
  },
  "16403": {
    DMA: 516,
  },
  "16404": {
    DMA: 516,
  },
  "16405": {
    DMA: 516,
  },
  "16406": {
    DMA: 516,
  },
  "16407": {
    DMA: 516,
  },
  "16410": {
    DMA: 516,
  },
  "16411": {
    DMA: 516,
  },
  "16412": {
    DMA: 516,
  },
  "16413": {
    DMA: 516,
  },
  "16415": {
    DMA: 516,
  },
  "16416": {
    DMA: 516,
  },
  "16417": {
    DMA: 516,
  },
  "16420": {
    DMA: 516,
  },
  "16421": {
    DMA: 516,
  },
  "16422": {
    DMA: 516,
  },
  "16423": {
    DMA: 516,
  },
  "16424": {
    DMA: 516,
  },
  "16426": {
    DMA: 516,
  },
  "16427": {
    DMA: 516,
  },
  "16428": {
    DMA: 516,
  },
  "16430": {
    DMA: 516,
  },
  "16432": {
    DMA: 516,
  },
  "16433": {
    DMA: 516,
  },
  "16434": {
    DMA: 516,
  },
  "16435": {
    DMA: 516,
  },
  "16436": {
    DMA: 516,
  },
  "16438": {
    DMA: 516,
  },
  "16440": {
    DMA: 516,
  },
  "16441": {
    DMA: 516,
  },
  "16442": {
    DMA: 516,
  },
  "16443": {
    DMA: 516,
  },
  "16444": {
    DMA: 516,
  },
  "16475": {
    DMA: 516,
  },
  "16501": {
    DMA: 516,
  },
  "16502": {
    DMA: 516,
  },
  "16503": {
    DMA: 516,
  },
  "16504": {
    DMA: 516,
  },
  "16505": {
    DMA: 516,
  },
  "16506": {
    DMA: 516,
  },
  "16507": {
    DMA: 516,
  },
  "16508": {
    DMA: 516,
  },
  "16509": {
    DMA: 516,
  },
  "16510": {
    DMA: 516,
  },
  "16511": {
    DMA: 516,
  },
  "16512": {
    DMA: 516,
  },
  "16514": {
    DMA: 516,
  },
  "16515": {
    DMA: 516,
  },
  "16522": {
    DMA: 516,
  },
  "16530": {
    DMA: 516,
  },
  "16531": {
    DMA: 516,
  },
  "16532": {
    DMA: 516,
  },
  "16533": {
    DMA: 516,
  },
  "16534": {
    DMA: 516,
  },
  "16538": {
    DMA: 516,
  },
  "16541": {
    DMA: 516,
  },
  "16544": {
    DMA: 516,
  },
  "16546": {
    DMA: 516,
  },
  "16550": {
    DMA: 516,
  },
  "16553": {
    DMA: 516,
  },
  "16554": {
    DMA: 516,
  },
  "16563": {
    DMA: 516,
  },
  "16565": {
    DMA: 516,
  },
  "16601": {
    DMA: 574,
  },
  "16602": {
    DMA: 574,
  },
  "16603": {
    DMA: 574,
  },
  "16611": {
    DMA: 574,
  },
  "16613": {
    DMA: 574,
  },
  "16616": {
    DMA: 574,
  },
  "16617": {
    DMA: 574,
  },
  "16619": {
    DMA: 574,
  },
  "16620": {
    DMA: 574,
  },
  "16621": {
    DMA: 574,
  },
  "16622": {
    DMA: 574,
  },
  "16623": {
    DMA: 574,
  },
  "16624": {
    DMA: 574,
  },
  "16625": {
    DMA: 574,
  },
  "16627": {
    DMA: 574,
  },
  "16629": {
    DMA: 574,
  },
  "16630": {
    DMA: 574,
  },
  "16631": {
    DMA: 574,
  },
  "16633": {
    DMA: 574,
  },
  "16634": {
    DMA: 574,
  },
  "16635": {
    DMA: 574,
  },
  "16636": {
    DMA: 574,
  },
  "16637": {
    DMA: 574,
  },
  "16638": {
    DMA: 574,
  },
  "16639": {
    DMA: 574,
  },
  "16640": {
    DMA: 574,
  },
  "16641": {
    DMA: 574,
  },
  "16644": {
    DMA: 574,
  },
  "16645": {
    DMA: 574,
  },
  "16646": {
    DMA: 574,
  },
  "16647": {
    DMA: 574,
  },
  "16648": {
    DMA: 574,
  },
  "16650": {
    DMA: 574,
  },
  "16651": {
    DMA: 574,
  },
  "16652": {
    DMA: 574,
  },
  "16654": {
    DMA: 574,
  },
  "16655": {
    DMA: 574,
  },
  "16656": {
    DMA: 574,
  },
  "16657": {
    DMA: 574,
  },
  "16659": {
    DMA: 574,
  },
  "16660": {
    DMA: 574,
  },
  "16661": {
    DMA: 574,
  },
  "16662": {
    DMA: 574,
  },
  "16663": {
    DMA: 574,
  },
  "16664": {
    DMA: 574,
  },
  "16665": {
    DMA: 574,
  },
  "16666": {
    DMA: 574,
  },
  "16667": {
    DMA: 574,
  },
  "16668": {
    DMA: 574,
  },
  "16669": {
    DMA: 574,
  },
  "16670": {
    DMA: 574,
  },
  "16671": {
    DMA: 574,
  },
  "16672": {
    DMA: 574,
  },
  "16673": {
    DMA: 574,
  },
  "16674": {
    DMA: 574,
  },
  "16675": {
    DMA: 574,
  },
  "16677": {
    DMA: 574,
  },
  "16678": {
    DMA: 574,
  },
  "16679": {
    DMA: 574,
  },
  "16680": {
    DMA: 574,
  },
  "16681": {
    DMA: 574,
  },
  "16682": {
    DMA: 574,
  },
  "16683": {
    DMA: 574,
  },
  "16684": {
    DMA: 574,
  },
  "16685": {
    DMA: 574,
  },
  "16686": {
    DMA: 574,
  },
  "16689": {
    DMA: 511,
  },
  "16691": {
    DMA: 511,
  },
  "16692": {
    DMA: 574,
  },
  "16693": {
    DMA: 574,
  },
  "16694": {
    DMA: 574,
  },
  "16695": {
    DMA: 574,
  },
  "16698": {
    DMA: 574,
  },
  "16699": {
    DMA: 574,
  },
  "16701": {
    DMA: 514,
  },
  "16720": {
    DMA: 514,
  },
  "16724": {
    DMA: 514,
  },
  "16725": {
    DMA: 514,
  },
  "16726": {
    DMA: 514,
  },
  "16727": {
    DMA: 514,
  },
  "16728": {
    DMA: 574,
  },
  "16729": {
    DMA: 514,
  },
  "16730": {
    DMA: 514,
  },
  "16731": {
    DMA: 514,
  },
  "16732": {
    DMA: 514,
  },
  "16733": {
    DMA: 514,
  },
  "16734": {
    DMA: 574,
  },
  "16735": {
    DMA: 514,
  },
  "16738": {
    DMA: 514,
  },
  "16740": {
    DMA: 514,
  },
  "16743": {
    DMA: 514,
  },
  "16744": {
    DMA: 514,
  },
  "16745": {
    DMA: 514,
  },
  "16746": {
    DMA: 514,
  },
  "16748": {
    DMA: 514,
  },
  "16749": {
    DMA: 514,
  },
  "16750": {
    DMA: 514,
  },
  "16801": {
    DMA: 574,
  },
  "16802": {
    DMA: 574,
  },
  "16803": {
    DMA: 574,
  },
  "16804": {
    DMA: 574,
  },
  "16805": {
    DMA: 574,
  },
  "16820": {
    DMA: 574,
  },
  "16821": {
    DMA: 574,
  },
  "16822": {
    DMA: 577,
  },
  "16823": {
    DMA: 574,
  },
  "16825": {
    DMA: 574,
  },
  "16826": {
    DMA: 574,
  },
  "16827": {
    DMA: 574,
  },
  "16828": {
    DMA: 574,
  },
  "16829": {
    DMA: 574,
  },
  "16830": {
    DMA: 574,
  },
  "16832": {
    DMA: 574,
  },
  "16833": {
    DMA: 574,
  },
  "16834": {
    DMA: 574,
  },
  "16835": {
    DMA: 574,
  },
  "16836": {
    DMA: 574,
  },
  "16837": {
    DMA: 574,
  },
  "16838": {
    DMA: 574,
  },
  "16839": {
    DMA: 574,
  },
  "16840": {
    DMA: 574,
  },
  "16841": {
    DMA: 574,
  },
  "16843": {
    DMA: 574,
  },
  "16844": {
    DMA: 574,
  },
  "16845": {
    DMA: 574,
  },
  "16847": {
    DMA: 574,
  },
  "16848": {
    DMA: 577,
  },
  "16849": {
    DMA: 574,
  },
  "16850": {
    DMA: 574,
  },
  "16851": {
    DMA: 574,
  },
  "16852": {
    DMA: 574,
  },
  "16853": {
    DMA: 574,
  },
  "16854": {
    DMA: 574,
  },
  "16855": {
    DMA: 574,
  },
  "16856": {
    DMA: 574,
  },
  "16858": {
    DMA: 574,
  },
  "16859": {
    DMA: 574,
  },
  "16860": {
    DMA: 574,
  },
  "16861": {
    DMA: 574,
  },
  "16863": {
    DMA: 574,
  },
  "16864": {
    DMA: 574,
  },
  "16865": {
    DMA: 574,
  },
  "16866": {
    DMA: 574,
  },
  "16868": {
    DMA: 574,
  },
  "16870": {
    DMA: 574,
  },
  "16871": {
    DMA: 574,
  },
  "16872": {
    DMA: 574,
  },
  "16873": {
    DMA: 574,
  },
  "16874": {
    DMA: 574,
  },
  "16875": {
    DMA: 574,
  },
  "16876": {
    DMA: 574,
  },
  "16877": {
    DMA: 574,
  },
  "16878": {
    DMA: 574,
  },
  "16879": {
    DMA: 574,
  },
  "16881": {
    DMA: 574,
  },
  "16882": {
    DMA: 574,
  },
  "16901": {
    DMA: 565,
  },
  "16910": {
    DMA: 577,
  },
  "16911": {
    DMA: 565,
  },
  "16912": {
    DMA: 565,
  },
  "16914": {
    DMA: 577,
  },
  "16915": {
    DMA: 514,
  },
  "16917": {
    DMA: 565,
  },
  "16918": {
    DMA: 565,
  },
  "16920": {
    DMA: 565,
  },
  "16921": {
    DMA: 565,
  },
  "16922": {
    DMA: 514,
  },
  "16923": {
    DMA: 514,
  },
  "16925": {
    DMA: 577,
  },
  "16926": {
    DMA: 577,
  },
  "16927": {
    DMA: 514,
  },
  "16928": {
    DMA: 565,
  },
  "16929": {
    DMA: 565,
  },
  "16930": {
    DMA: 565,
  },
  "16932": {
    DMA: 565,
  },
  "16933": {
    DMA: 565,
  },
  "16935": {
    DMA: 565,
  },
  "16936": {
    DMA: 565,
  },
  "16937": {
    DMA: 514,
  },
  "16938": {
    DMA: 565,
  },
  "16939": {
    DMA: 565,
  },
  "16940": {
    DMA: 565,
  },
  "16941": {
    DMA: 514,
  },
  "16942": {
    DMA: 565,
  },
  "16943": {
    DMA: 565,
  },
  "16945": {
    DMA: 577,
  },
  "16946": {
    DMA: 565,
  },
  "16947": {
    DMA: 577,
  },
  "16948": {
    DMA: 514,
  },
  "16950": {
    DMA: 565,
  },
  "17001": {
    DMA: 566,
  },
  "17002": {
    DMA: 566,
  },
  "17003": {
    DMA: 566,
  },
  "17004": {
    DMA: 566,
  },
  "17005": {
    DMA: 566,
  },
  "17006": {
    DMA: 566,
  },
  "17007": {
    DMA: 566,
  },
  "17008": {
    DMA: 566,
  },
  "17009": {
    DMA: 566,
  },
  "17010": {
    DMA: 566,
  },
  "17011": {
    DMA: 566,
  },
  "17012": {
    DMA: 566,
  },
  "17013": {
    DMA: 566,
  },
  "17014": {
    DMA: 566,
  },
  "17015": {
    DMA: 566,
  },
  "17016": {
    DMA: 566,
  },
  "17017": {
    DMA: 577,
  },
  "17018": {
    DMA: 566,
  },
  "17019": {
    DMA: 566,
  },
  "17020": {
    DMA: 566,
  },
  "17021": {
    DMA: 566,
  },
  "17022": {
    DMA: 566,
  },
  "17023": {
    DMA: 566,
  },
  "17024": {
    DMA: 566,
  },
  "17025": {
    DMA: 566,
  },
  "17026": {
    DMA: 566,
  },
  "17027": {
    DMA: 566,
  },
  "17028": {
    DMA: 566,
  },
  "17029": {
    DMA: 566,
  },
  "17030": {
    DMA: 566,
  },
  "17032": {
    DMA: 566,
  },
  "17033": {
    DMA: 566,
  },
  "17034": {
    DMA: 566,
  },
  "17035": {
    DMA: 566,
  },
  "17036": {
    DMA: 566,
  },
  "17037": {
    DMA: 566,
  },
  "17038": {
    DMA: 566,
  },
  "17039": {
    DMA: 566,
  },
  "17040": {
    DMA: 566,
  },
  "17041": {
    DMA: 566,
  },
  "17042": {
    DMA: 566,
  },
  "17043": {
    DMA: 566,
  },
  "17044": {
    DMA: 566,
  },
  "17045": {
    DMA: 566,
  },
  "17046": {
    DMA: 566,
  },
  "17047": {
    DMA: 566,
  },
  "17048": {
    DMA: 566,
  },
  "17049": {
    DMA: 566,
  },
  "17050": {
    DMA: 566,
  },
  "17051": {
    DMA: 566,
  },
  "17052": {
    DMA: 574,
  },
  "17053": {
    DMA: 566,
  },
  "17054": {
    DMA: 566,
  },
  "17055": {
    DMA: 566,
  },
  "17056": {
    DMA: 566,
  },
  "17057": {
    DMA: 566,
  },
  "17058": {
    DMA: 566,
  },
  "17059": {
    DMA: 566,
  },
  "17060": {
    DMA: 574,
  },
  "17061": {
    DMA: 566,
  },
  "17062": {
    DMA: 566,
  },
  "17063": {
    DMA: 566,
  },
  "17064": {
    DMA: 566,
  },
  "17065": {
    DMA: 566,
  },
  "17066": {
    DMA: 574,
  },
  "17067": {
    DMA: 566,
  },
  "17068": {
    DMA: 566,
  },
  "17069": {
    DMA: 566,
  },
  "17070": {
    DMA: 566,
  },
  "17071": {
    DMA: 566,
  },
  "17072": {
    DMA: 566,
  },
  "17073": {
    DMA: 566,
  },
  "17074": {
    DMA: 566,
  },
  "17075": {
    DMA: 566,
  },
  "17076": {
    DMA: 566,
  },
  "17077": {
    DMA: 566,
  },
  "17078": {
    DMA: 566,
  },
  "17080": {
    DMA: 566,
  },
  "17081": {
    DMA: 566,
  },
  "17082": {
    DMA: 566,
  },
  "17083": {
    DMA: 566,
  },
  "17084": {
    DMA: 566,
  },
  "17085": {
    DMA: 566,
  },
  "17086": {
    DMA: 566,
  },
  "17087": {
    DMA: 566,
  },
  "17088": {
    DMA: 566,
  },
  "17089": {
    DMA: 566,
  },
  "17090": {
    DMA: 566,
  },
  "17091": {
    DMA: 566,
  },
  "17093": {
    DMA: 566,
  },
  "17094": {
    DMA: 566,
  },
  "17097": {
    DMA: 566,
  },
  "17098": {
    DMA: 566,
  },
  "17099": {
    DMA: 566,
  },
  "17101": {
    DMA: 566,
  },
  "17102": {
    DMA: 566,
  },
  "17103": {
    DMA: 566,
  },
  "17104": {
    DMA: 566,
  },
  "17105": {
    DMA: 566,
  },
  "17106": {
    DMA: 566,
  },
  "17107": {
    DMA: 566,
  },
  "17108": {
    DMA: 566,
  },
  "17109": {
    DMA: 566,
  },
  "17110": {
    DMA: 566,
  },
  "17111": {
    DMA: 566,
  },
  "17112": {
    DMA: 566,
  },
  "17113": {
    DMA: 566,
  },
  "17120": {
    DMA: 566,
  },
  "17121": {
    DMA: 566,
  },
  "17122": {
    DMA: 566,
  },
  "17123": {
    DMA: 566,
  },
  "17124": {
    DMA: 566,
  },
  "17125": {
    DMA: 566,
  },
  "17126": {
    DMA: 566,
  },
  "17127": {
    DMA: 566,
  },
  "17128": {
    DMA: 566,
  },
  "17129": {
    DMA: 566,
  },
  "17130": {
    DMA: 566,
  },
  "17140": {
    DMA: 566,
  },
  "17177": {
    DMA: 566,
  },
  "17201": {
    DMA: 566,
  },
  "17202": {
    DMA: 566,
  },
  "17210": {
    DMA: 566,
  },
  "17211": {
    DMA: 574,
  },
  "17212": {
    DMA: 511,
  },
  "17213": {
    DMA: 574,
  },
  "17214": {
    DMA: 566,
  },
  "17215": {
    DMA: 511,
  },
  "17217": {
    DMA: 566,
  },
  "17219": {
    DMA: 566,
  },
  "17220": {
    DMA: 566,
  },
  "17221": {
    DMA: 566,
  },
  "17222": {
    DMA: 566,
  },
  "17223": {
    DMA: 511,
  },
  "17224": {
    DMA: 566,
  },
  "17225": {
    DMA: 566,
  },
  "17228": {
    DMA: 511,
  },
  "17229": {
    DMA: 511,
  },
  "17231": {
    DMA: 566,
  },
  "17232": {
    DMA: 566,
  },
  "17233": {
    DMA: 511,
  },
  "17235": {
    DMA: 566,
  },
  "17236": {
    DMA: 566,
  },
  "17237": {
    DMA: 566,
  },
  "17238": {
    DMA: 511,
  },
  "17239": {
    DMA: 574,
  },
  "17240": {
    DMA: 566,
  },
  "17241": {
    DMA: 566,
  },
  "17243": {
    DMA: 574,
  },
  "17244": {
    DMA: 566,
  },
  "17246": {
    DMA: 566,
  },
  "17247": {
    DMA: 566,
  },
  "17249": {
    DMA: 574,
  },
  "17250": {
    DMA: 566,
  },
  "17251": {
    DMA: 566,
  },
  "17252": {
    DMA: 566,
  },
  "17253": {
    DMA: 574,
  },
  "17254": {
    DMA: 566,
  },
  "17255": {
    DMA: 574,
  },
  "17256": {
    DMA: 566,
  },
  "17257": {
    DMA: 566,
  },
  "17260": {
    DMA: 574,
  },
  "17261": {
    DMA: 566,
  },
  "17262": {
    DMA: 566,
  },
  "17263": {
    DMA: 566,
  },
  "17264": {
    DMA: 574,
  },
  "17265": {
    DMA: 566,
  },
  "17266": {
    DMA: 566,
  },
  "17267": {
    DMA: 511,
  },
  "17268": {
    DMA: 566,
  },
  "17270": {
    DMA: 566,
  },
  "17271": {
    DMA: 566,
  },
  "17272": {
    DMA: 566,
  },
  "17301": {
    DMA: 566,
  },
  "17302": {
    DMA: 566,
  },
  "17303": {
    DMA: 566,
  },
  "17304": {
    DMA: 566,
  },
  "17306": {
    DMA: 566,
  },
  "17307": {
    DMA: 566,
  },
  "17309": {
    DMA: 566,
  },
  "17310": {
    DMA: 566,
  },
  "17311": {
    DMA: 566,
  },
  "17312": {
    DMA: 566,
  },
  "17313": {
    DMA: 566,
  },
  "17314": {
    DMA: 566,
  },
  "17315": {
    DMA: 566,
  },
  "17316": {
    DMA: 566,
  },
  "17317": {
    DMA: 566,
  },
  "17318": {
    DMA: 566,
  },
  "17319": {
    DMA: 566,
  },
  "17320": {
    DMA: 566,
  },
  "17321": {
    DMA: 566,
  },
  "17322": {
    DMA: 566,
  },
  "17323": {
    DMA: 566,
  },
  "17324": {
    DMA: 566,
  },
  "17325": {
    DMA: 566,
  },
  "17326": {
    DMA: 566,
  },
  "17327": {
    DMA: 566,
  },
  "17329": {
    DMA: 566,
  },
  "17331": {
    DMA: 566,
  },
  "17332": {
    DMA: 566,
  },
  "17333": {
    DMA: 566,
  },
  "17334": {
    DMA: 566,
  },
  "17335": {
    DMA: 566,
  },
  "17337": {
    DMA: 566,
  },
  "17339": {
    DMA: 566,
  },
  "17340": {
    DMA: 566,
  },
  "17342": {
    DMA: 566,
  },
  "17343": {
    DMA: 566,
  },
  "17344": {
    DMA: 566,
  },
  "17345": {
    DMA: 566,
  },
  "17347": {
    DMA: 566,
  },
  "17349": {
    DMA: 566,
  },
  "17350": {
    DMA: 566,
  },
  "17352": {
    DMA: 566,
  },
  "17353": {
    DMA: 566,
  },
  "17354": {
    DMA: 566,
  },
  "17355": {
    DMA: 566,
  },
  "17356": {
    DMA: 566,
  },
  "17358": {
    DMA: 566,
  },
  "17360": {
    DMA: 566,
  },
  "17361": {
    DMA: 566,
  },
  "17362": {
    DMA: 566,
  },
  "17363": {
    DMA: 566,
  },
  "17364": {
    DMA: 566,
  },
  "17365": {
    DMA: 566,
  },
  "17366": {
    DMA: 566,
  },
  "17368": {
    DMA: 566,
  },
  "17370": {
    DMA: 566,
  },
  "17371": {
    DMA: 566,
  },
  "17372": {
    DMA: 566,
  },
  "17375": {
    DMA: 566,
  },
  "17401": {
    DMA: 566,
  },
  "17402": {
    DMA: 566,
  },
  "17403": {
    DMA: 566,
  },
  "17404": {
    DMA: 566,
  },
  "17405": {
    DMA: 566,
  },
  "17406": {
    DMA: 566,
  },
  "17407": {
    DMA: 566,
  },
  "17408": {
    DMA: 566,
  },
  "17415": {
    DMA: 566,
  },
  "17501": {
    DMA: 566,
  },
  "17502": {
    DMA: 566,
  },
  "17503": {
    DMA: 566,
  },
  "17504": {
    DMA: 566,
  },
  "17505": {
    DMA: 566,
  },
  "17506": {
    DMA: 566,
  },
  "17507": {
    DMA: 566,
  },
  "17508": {
    DMA: 566,
  },
  "17509": {
    DMA: 566,
  },
  "17512": {
    DMA: 566,
  },
  "17516": {
    DMA: 566,
  },
  "17517": {
    DMA: 566,
  },
  "17518": {
    DMA: 566,
  },
  "17519": {
    DMA: 566,
  },
  "17520": {
    DMA: 566,
  },
  "17521": {
    DMA: 566,
  },
  "17522": {
    DMA: 566,
  },
  "17527": {
    DMA: 566,
  },
  "17528": {
    DMA: 566,
  },
  "17529": {
    DMA: 566,
  },
  "17532": {
    DMA: 566,
  },
  "17533": {
    DMA: 566,
  },
  "17534": {
    DMA: 566,
  },
  "17535": {
    DMA: 566,
  },
  "17536": {
    DMA: 566,
  },
  "17537": {
    DMA: 566,
  },
  "17538": {
    DMA: 566,
  },
  "17540": {
    DMA: 566,
  },
  "17543": {
    DMA: 566,
  },
  "17545": {
    DMA: 566,
  },
  "17547": {
    DMA: 566,
  },
  "17549": {
    DMA: 566,
  },
  "17550": {
    DMA: 566,
  },
  "17551": {
    DMA: 566,
  },
  "17552": {
    DMA: 566,
  },
  "17554": {
    DMA: 566,
  },
  "17555": {
    DMA: 566,
  },
  "17557": {
    DMA: 566,
  },
  "17560": {
    DMA: 566,
  },
  "17562": {
    DMA: 566,
  },
  "17563": {
    DMA: 566,
  },
  "17564": {
    DMA: 566,
  },
  "17565": {
    DMA: 566,
  },
  "17566": {
    DMA: 566,
  },
  "17567": {
    DMA: 566,
  },
  "17568": {
    DMA: 566,
  },
  "17569": {
    DMA: 566,
  },
  "17570": {
    DMA: 566,
  },
  "17572": {
    DMA: 566,
  },
  "17573": {
    DMA: 566,
  },
  "17575": {
    DMA: 566,
  },
  "17576": {
    DMA: 566,
  },
  "17578": {
    DMA: 566,
  },
  "17579": {
    DMA: 566,
  },
  "17580": {
    DMA: 566,
  },
  "17581": {
    DMA: 566,
  },
  "17582": {
    DMA: 566,
  },
  "17583": {
    DMA: 566,
  },
  "17584": {
    DMA: 566,
  },
  "17585": {
    DMA: 566,
  },
  "17601": {
    DMA: 566,
  },
  "17602": {
    DMA: 566,
  },
  "17603": {
    DMA: 566,
  },
  "17604": {
    DMA: 566,
  },
  "17605": {
    DMA: 566,
  },
  "17606": {
    DMA: 566,
  },
  "17607": {
    DMA: 566,
  },
  "17608": {
    DMA: 566,
  },
  "17611": {
    DMA: 566,
  },
  "17622": {
    DMA: 566,
  },
  "17699": {
    DMA: 566,
  },
  "17701": {
    DMA: 577,
  },
  "17702": {
    DMA: 577,
  },
  "17703": {
    DMA: 577,
  },
  "17705": {
    DMA: 577,
  },
  "17720": {
    DMA: 577,
  },
  "17721": {
    DMA: 577,
  },
  "17723": {
    DMA: 577,
  },
  "17724": {
    DMA: 577,
  },
  "17726": {
    DMA: 577,
  },
  "17727": {
    DMA: 577,
  },
  "17728": {
    DMA: 577,
  },
  "17729": {
    DMA: 514,
  },
  "17730": {
    DMA: 577,
  },
  "17731": {
    DMA: 577,
  },
  "17735": {
    DMA: 577,
  },
  "17737": {
    DMA: 577,
  },
  "17738": {
    DMA: 577,
  },
  "17739": {
    DMA: 577,
  },
  "17740": {
    DMA: 577,
  },
  "17742": {
    DMA: 577,
  },
  "17744": {
    DMA: 577,
  },
  "17745": {
    DMA: 577,
  },
  "17747": {
    DMA: 577,
  },
  "17748": {
    DMA: 577,
  },
  "17749": {
    DMA: 577,
  },
  "17750": {
    DMA: 577,
  },
  "17751": {
    DMA: 577,
  },
  "17752": {
    DMA: 577,
  },
  "17754": {
    DMA: 577,
  },
  "17756": {
    DMA: 577,
  },
  "17758": {
    DMA: 577,
  },
  "17760": {
    DMA: 577,
  },
  "17762": {
    DMA: 577,
  },
  "17763": {
    DMA: 577,
  },
  "17764": {
    DMA: 577,
  },
  "17765": {
    DMA: 565,
  },
  "17767": {
    DMA: 577,
  },
  "17768": {
    DMA: 577,
  },
  "17769": {
    DMA: 577,
  },
  "17771": {
    DMA: 577,
  },
  "17772": {
    DMA: 577,
  },
  "17773": {
    DMA: 577,
  },
  "17774": {
    DMA: 577,
  },
  "17776": {
    DMA: 577,
  },
  "17777": {
    DMA: 577,
  },
  "17778": {
    DMA: 577,
  },
  "17779": {
    DMA: 577,
  },
  "17801": {
    DMA: 577,
  },
  "17810": {
    DMA: 577,
  },
  "17812": {
    DMA: 577,
  },
  "17813": {
    DMA: 577,
  },
  "17814": {
    DMA: 577,
  },
  "17815": {
    DMA: 577,
  },
  "17820": {
    DMA: 577,
  },
  "17821": {
    DMA: 577,
  },
  "17822": {
    DMA: 577,
  },
  "17823": {
    DMA: 577,
  },
  "17824": {
    DMA: 577,
  },
  "17827": {
    DMA: 577,
  },
  "17829": {
    DMA: 577,
  },
  "17830": {
    DMA: 577,
  },
  "17831": {
    DMA: 577,
  },
  "17832": {
    DMA: 577,
  },
  "17833": {
    DMA: 577,
  },
  "17834": {
    DMA: 577,
  },
  "17835": {
    DMA: 577,
  },
  "17836": {
    DMA: 577,
  },
  "17837": {
    DMA: 577,
  },
  "17839": {
    DMA: 577,
  },
  "17840": {
    DMA: 577,
  },
  "17841": {
    DMA: 566,
  },
  "17842": {
    DMA: 577,
  },
  "17843": {
    DMA: 577,
  },
  "17844": {
    DMA: 577,
  },
  "17845": {
    DMA: 577,
  },
  "17846": {
    DMA: 577,
  },
  "17847": {
    DMA: 577,
  },
  "17850": {
    DMA: 577,
  },
  "17851": {
    DMA: 577,
  },
  "17853": {
    DMA: 577,
  },
  "17855": {
    DMA: 577,
  },
  "17856": {
    DMA: 577,
  },
  "17857": {
    DMA: 577,
  },
  "17858": {
    DMA: 577,
  },
  "17859": {
    DMA: 577,
  },
  "17860": {
    DMA: 577,
  },
  "17861": {
    DMA: 577,
  },
  "17862": {
    DMA: 577,
  },
  "17864": {
    DMA: 577,
  },
  "17865": {
    DMA: 577,
  },
  "17866": {
    DMA: 577,
  },
  "17867": {
    DMA: 577,
  },
  "17868": {
    DMA: 577,
  },
  "17870": {
    DMA: 577,
  },
  "17872": {
    DMA: 577,
  },
  "17876": {
    DMA: 577,
  },
  "17877": {
    DMA: 577,
  },
  "17878": {
    DMA: 577,
  },
  "17880": {
    DMA: 577,
  },
  "17881": {
    DMA: 577,
  },
  "17882": {
    DMA: 577,
  },
  "17883": {
    DMA: 577,
  },
  "17884": {
    DMA: 577,
  },
  "17885": {
    DMA: 577,
  },
  "17886": {
    DMA: 577,
  },
  "17887": {
    DMA: 577,
  },
  "17888": {
    DMA: 577,
  },
  "17889": {
    DMA: 577,
  },
  "17901": {
    DMA: 577,
  },
  "17920": {
    DMA: 577,
  },
  "17921": {
    DMA: 577,
  },
  "17922": {
    DMA: 577,
  },
  "17923": {
    DMA: 577,
  },
  "17925": {
    DMA: 577,
  },
  "17929": {
    DMA: 577,
  },
  "17930": {
    DMA: 577,
  },
  "17931": {
    DMA: 577,
  },
  "17932": {
    DMA: 577,
  },
  "17933": {
    DMA: 577,
  },
  "17934": {
    DMA: 577,
  },
  "17935": {
    DMA: 577,
  },
  "17936": {
    DMA: 577,
  },
  "17938": {
    DMA: 577,
  },
  "17941": {
    DMA: 577,
  },
  "17942": {
    DMA: 577,
  },
  "17943": {
    DMA: 577,
  },
  "17944": {
    DMA: 577,
  },
  "17945": {
    DMA: 577,
  },
  "17946": {
    DMA: 577,
  },
  "17948": {
    DMA: 577,
  },
  "17949": {
    DMA: 577,
  },
  "17951": {
    DMA: 577,
  },
  "17952": {
    DMA: 577,
  },
  "17953": {
    DMA: 577,
  },
  "17954": {
    DMA: 577,
  },
  "17957": {
    DMA: 577,
  },
  "17959": {
    DMA: 577,
  },
  "17960": {
    DMA: 577,
  },
  "17961": {
    DMA: 577,
  },
  "17963": {
    DMA: 577,
  },
  "17964": {
    DMA: 577,
  },
  "17965": {
    DMA: 577,
  },
  "17966": {
    DMA: 577,
  },
  "17967": {
    DMA: 577,
  },
  "17968": {
    DMA: 577,
  },
  "17970": {
    DMA: 577,
  },
  "17972": {
    DMA: 577,
  },
  "17974": {
    DMA: 577,
  },
  "17976": {
    DMA: 577,
  },
  "17978": {
    DMA: 577,
  },
  "17979": {
    DMA: 577,
  },
  "17980": {
    DMA: 577,
  },
  "17981": {
    DMA: 577,
  },
  "17982": {
    DMA: 577,
  },
  "17983": {
    DMA: 577,
  },
  "17985": {
    DMA: 577,
  },
  "18001": {
    DMA: 504,
  },
  "18002": {
    DMA: 504,
  },
  "18003": {
    DMA: 504,
  },
  "18010": {
    DMA: 504,
  },
  "18011": {
    DMA: 504,
  },
  "18012": {
    DMA: 577,
  },
  "18013": {
    DMA: 504,
  },
  "18014": {
    DMA: 504,
  },
  "18015": {
    DMA: 504,
  },
  "18016": {
    DMA: 504,
  },
  "18017": {
    DMA: 504,
  },
  "18018": {
    DMA: 504,
  },
  "18020": {
    DMA: 504,
  },
  "18025": {
    DMA: 504,
  },
  "18030": {
    DMA: 577,
  },
  "18031": {
    DMA: 504,
  },
  "18032": {
    DMA: 504,
  },
  "18034": {
    DMA: 504,
  },
  "18035": {
    DMA: 504,
  },
  "18036": {
    DMA: 504,
  },
  "18037": {
    DMA: 504,
  },
  "18038": {
    DMA: 504,
  },
  "18039": {
    DMA: 504,
  },
  "18040": {
    DMA: 504,
  },
  "18041": {
    DMA: 504,
  },
  "18042": {
    DMA: 504,
  },
  "18043": {
    DMA: 504,
  },
  "18044": {
    DMA: 504,
  },
  "18045": {
    DMA: 504,
  },
  "18046": {
    DMA: 504,
  },
  "18049": {
    DMA: 504,
  },
  "18050": {
    DMA: 504,
  },
  "18051": {
    DMA: 504,
  },
  "18052": {
    DMA: 504,
  },
  "18053": {
    DMA: 504,
  },
  "18054": {
    DMA: 504,
  },
  "18055": {
    DMA: 504,
  },
  "18056": {
    DMA: 504,
  },
  "18058": {
    DMA: 577,
  },
  "18059": {
    DMA: 504,
  },
  "18060": {
    DMA: 504,
  },
  "18062": {
    DMA: 504,
  },
  "18063": {
    DMA: 504,
  },
  "18064": {
    DMA: 504,
  },
  "18065": {
    DMA: 504,
  },
  "18066": {
    DMA: 504,
  },
  "18067": {
    DMA: 504,
  },
  "18068": {
    DMA: 504,
  },
  "18069": {
    DMA: 504,
  },
  "18070": {
    DMA: 504,
  },
  "18071": {
    DMA: 577,
  },
  "18072": {
    DMA: 504,
  },
  "18073": {
    DMA: 504,
  },
  "18074": {
    DMA: 504,
  },
  "18076": {
    DMA: 504,
  },
  "18077": {
    DMA: 504,
  },
  "18078": {
    DMA: 504,
  },
  "18079": {
    DMA: 504,
  },
  "18080": {
    DMA: 504,
  },
  "18081": {
    DMA: 504,
  },
  "18083": {
    DMA: 504,
  },
  "18084": {
    DMA: 504,
  },
  "18085": {
    DMA: 504,
  },
  "18086": {
    DMA: 504,
  },
  "18087": {
    DMA: 504,
  },
  "18088": {
    DMA: 504,
  },
  "18091": {
    DMA: 504,
  },
  "18092": {
    DMA: 504,
  },
  "18098": {
    DMA: 504,
  },
  "18099": {
    DMA: 504,
  },
  "18101": {
    DMA: 504,
  },
  "18102": {
    DMA: 504,
  },
  "18103": {
    DMA: 504,
  },
  "18104": {
    DMA: 504,
  },
  "18105": {
    DMA: 504,
  },
  "18106": {
    DMA: 504,
  },
  "18109": {
    DMA: 504,
  },
  "18175": {
    DMA: 504,
  },
  "18195": {
    DMA: 504,
  },
  "18201": {
    DMA: 577,
  },
  "18202": {
    DMA: 577,
  },
  "18210": {
    DMA: 577,
  },
  "18211": {
    DMA: 577,
  },
  "18212": {
    DMA: 577,
  },
  "18214": {
    DMA: 577,
  },
  "18216": {
    DMA: 577,
  },
  "18218": {
    DMA: 577,
  },
  "18219": {
    DMA: 577,
  },
  "18220": {
    DMA: 577,
  },
  "18221": {
    DMA: 577,
  },
  "18222": {
    DMA: 577,
  },
  "18223": {
    DMA: 577,
  },
  "18224": {
    DMA: 577,
  },
  "18225": {
    DMA: 577,
  },
  "18229": {
    DMA: 577,
  },
  "18230": {
    DMA: 577,
  },
  "18231": {
    DMA: 577,
  },
  "18232": {
    DMA: 577,
  },
  "18234": {
    DMA: 577,
  },
  "18235": {
    DMA: 577,
  },
  "18237": {
    DMA: 577,
  },
  "18239": {
    DMA: 577,
  },
  "18240": {
    DMA: 577,
  },
  "18241": {
    DMA: 577,
  },
  "18242": {
    DMA: 577,
  },
  "18244": {
    DMA: 577,
  },
  "18245": {
    DMA: 577,
  },
  "18246": {
    DMA: 577,
  },
  "18247": {
    DMA: 577,
  },
  "18248": {
    DMA: 577,
  },
  "18249": {
    DMA: 577,
  },
  "18250": {
    DMA: 577,
  },
  "18251": {
    DMA: 577,
  },
  "18252": {
    DMA: 577,
  },
  "18254": {
    DMA: 577,
  },
  "18255": {
    DMA: 577,
  },
  "18256": {
    DMA: 577,
  },
  "18301": {
    DMA: 577,
  },
  "18302": {
    DMA: 577,
  },
  "18320": {
    DMA: 577,
  },
  "18321": {
    DMA: 577,
  },
  "18322": {
    DMA: 577,
  },
  "18323": {
    DMA: 577,
  },
  "18324": {
    DMA: 501,
  },
  "18325": {
    DMA: 577,
  },
  "18326": {
    DMA: 577,
  },
  "18327": {
    DMA: 577,
  },
  "18328": {
    DMA: 501,
  },
  "18330": {
    DMA: 577,
  },
  "18331": {
    DMA: 577,
  },
  "18332": {
    DMA: 577,
  },
  "18333": {
    DMA: 577,
  },
  "18334": {
    DMA: 577,
  },
  "18335": {
    DMA: 577,
  },
  "18336": {
    DMA: 501,
  },
  "18337": {
    DMA: 501,
  },
  "18340": {
    DMA: 501,
  },
  "18341": {
    DMA: 577,
  },
  "18342": {
    DMA: 577,
  },
  "18343": {
    DMA: 504,
  },
  "18344": {
    DMA: 577,
  },
  "18346": {
    DMA: 577,
  },
  "18347": {
    DMA: 577,
  },
  "18348": {
    DMA: 577,
  },
  "18349": {
    DMA: 577,
  },
  "18350": {
    DMA: 577,
  },
  "18351": {
    DMA: 504,
  },
  "18352": {
    DMA: 577,
  },
  "18353": {
    DMA: 577,
  },
  "18354": {
    DMA: 577,
  },
  "18355": {
    DMA: 577,
  },
  "18356": {
    DMA: 577,
  },
  "18357": {
    DMA: 577,
  },
  "18360": {
    DMA: 577,
  },
  "18370": {
    DMA: 577,
  },
  "18371": {
    DMA: 501,
  },
  "18372": {
    DMA: 577,
  },
  "18373": {
    DMA: 501,
  },
  "18403": {
    DMA: 577,
  },
  "18405": {
    DMA: 577,
  },
  "18407": {
    DMA: 577,
  },
  "18410": {
    DMA: 577,
  },
  "18411": {
    DMA: 577,
  },
  "18413": {
    DMA: 577,
  },
  "18414": {
    DMA: 577,
  },
  "18415": {
    DMA: 577,
  },
  "18416": {
    DMA: 577,
  },
  "18417": {
    DMA: 577,
  },
  "18419": {
    DMA: 577,
  },
  "18420": {
    DMA: 577,
  },
  "18421": {
    DMA: 577,
  },
  "18424": {
    DMA: 577,
  },
  "18425": {
    DMA: 501,
  },
  "18426": {
    DMA: 501,
  },
  "18427": {
    DMA: 577,
  },
  "18428": {
    DMA: 501,
  },
  "18430": {
    DMA: 577,
  },
  "18431": {
    DMA: 577,
  },
  "18433": {
    DMA: 577,
  },
  "18434": {
    DMA: 577,
  },
  "18435": {
    DMA: 501,
  },
  "18436": {
    DMA: 577,
  },
  "18437": {
    DMA: 577,
  },
  "18438": {
    DMA: 577,
  },
  "18439": {
    DMA: 577,
  },
  "18440": {
    DMA: 577,
  },
  "18441": {
    DMA: 577,
  },
  "18443": {
    DMA: 577,
  },
  "18444": {
    DMA: 577,
  },
  "18445": {
    DMA: 577,
  },
  "18446": {
    DMA: 577,
  },
  "18447": {
    DMA: 577,
  },
  "18448": {
    DMA: 577,
  },
  "18449": {
    DMA: 577,
  },
  "18451": {
    DMA: 501,
  },
  "18452": {
    DMA: 577,
  },
  "18453": {
    DMA: 577,
  },
  "18454": {
    DMA: 577,
  },
  "18455": {
    DMA: 577,
  },
  "18456": {
    DMA: 577,
  },
  "18457": {
    DMA: 501,
  },
  "18458": {
    DMA: 501,
  },
  "18459": {
    DMA: 577,
  },
  "18460": {
    DMA: 577,
  },
  "18461": {
    DMA: 577,
  },
  "18462": {
    DMA: 577,
  },
  "18463": {
    DMA: 577,
  },
  "18464": {
    DMA: 501,
  },
  "18465": {
    DMA: 577,
  },
  "18466": {
    DMA: 577,
  },
  "18469": {
    DMA: 577,
  },
  "18470": {
    DMA: 577,
  },
  "18471": {
    DMA: 577,
  },
  "18472": {
    DMA: 577,
  },
  "18473": {
    DMA: 577,
  },
  "18501": {
    DMA: 577,
  },
  "18502": {
    DMA: 577,
  },
  "18503": {
    DMA: 577,
  },
  "18504": {
    DMA: 577,
  },
  "18505": {
    DMA: 577,
  },
  "18507": {
    DMA: 577,
  },
  "18508": {
    DMA: 577,
  },
  "18509": {
    DMA: 577,
  },
  "18510": {
    DMA: 577,
  },
  "18512": {
    DMA: 577,
  },
  "18514": {
    DMA: 577,
  },
  "18515": {
    DMA: 577,
  },
  "18517": {
    DMA: 577,
  },
  "18518": {
    DMA: 577,
  },
  "18519": {
    DMA: 577,
  },
  "18522": {
    DMA: 577,
  },
  "18540": {
    DMA: 577,
  },
  "18577": {
    DMA: 577,
  },
  "18601": {
    DMA: 577,
  },
  "18602": {
    DMA: 577,
  },
  "18603": {
    DMA: 577,
  },
  "18610": {
    DMA: 577,
  },
  "18611": {
    DMA: 577,
  },
  "18612": {
    DMA: 577,
  },
  "18614": {
    DMA: 577,
  },
  "18615": {
    DMA: 577,
  },
  "18616": {
    DMA: 577,
  },
  "18617": {
    DMA: 577,
  },
  "18618": {
    DMA: 577,
  },
  "18619": {
    DMA: 577,
  },
  "18621": {
    DMA: 577,
  },
  "18622": {
    DMA: 577,
  },
  "18623": {
    DMA: 577,
  },
  "18624": {
    DMA: 577,
  },
  "18625": {
    DMA: 577,
  },
  "18626": {
    DMA: 577,
  },
  "18627": {
    DMA: 577,
  },
  "18628": {
    DMA: 577,
  },
  "18629": {
    DMA: 577,
  },
  "18630": {
    DMA: 577,
  },
  "18631": {
    DMA: 577,
  },
  "18632": {
    DMA: 577,
  },
  "18634": {
    DMA: 577,
  },
  "18635": {
    DMA: 577,
  },
  "18636": {
    DMA: 577,
  },
  "18640": {
    DMA: 577,
  },
  "18641": {
    DMA: 577,
  },
  "18642": {
    DMA: 577,
  },
  "18643": {
    DMA: 577,
  },
  "18644": {
    DMA: 577,
  },
  "18651": {
    DMA: 577,
  },
  "18653": {
    DMA: 577,
  },
  "18654": {
    DMA: 577,
  },
  "18655": {
    DMA: 577,
  },
  "18656": {
    DMA: 577,
  },
  "18657": {
    DMA: 577,
  },
  "18660": {
    DMA: 577,
  },
  "18661": {
    DMA: 577,
  },
  "18690": {
    DMA: 577,
  },
  "18701": {
    DMA: 577,
  },
  "18702": {
    DMA: 577,
  },
  "18703": {
    DMA: 577,
  },
  "18704": {
    DMA: 577,
  },
  "18705": {
    DMA: 577,
  },
  "18706": {
    DMA: 577,
  },
  "18707": {
    DMA: 577,
  },
  "18708": {
    DMA: 577,
  },
  "18709": {
    DMA: 577,
  },
  "18710": {
    DMA: 577,
  },
  "18711": {
    DMA: 577,
  },
  "18762": {
    DMA: 577,
  },
  "18764": {
    DMA: 577,
  },
  "18765": {
    DMA: 577,
  },
  "18766": {
    DMA: 577,
  },
  "18767": {
    DMA: 577,
  },
  "18769": {
    DMA: 577,
  },
  "18773": {
    DMA: 577,
  },
  "18801": {
    DMA: 577,
  },
  "18810": {
    DMA: 577,
  },
  "18812": {
    DMA: 577,
  },
  "18813": {
    DMA: 577,
  },
  "18814": {
    DMA: 577,
  },
  "18815": {
    DMA: 577,
  },
  "18816": {
    DMA: 577,
  },
  "18817": {
    DMA: 577,
  },
  "18818": {
    DMA: 577,
  },
  "18820": {
    DMA: 577,
  },
  "18821": {
    DMA: 577,
  },
  "18822": {
    DMA: 577,
  },
  "18823": {
    DMA: 577,
  },
  "18824": {
    DMA: 577,
  },
  "18825": {
    DMA: 577,
  },
  "18826": {
    DMA: 577,
  },
  "18827": {
    DMA: 577,
  },
  "18828": {
    DMA: 577,
  },
  "18829": {
    DMA: 577,
  },
  "18830": {
    DMA: 577,
  },
  "18831": {
    DMA: 577,
  },
  "18832": {
    DMA: 577,
  },
  "18833": {
    DMA: 577,
  },
  "18834": {
    DMA: 577,
  },
  "18837": {
    DMA: 577,
  },
  "18840": {
    DMA: 577,
  },
  "18842": {
    DMA: 577,
  },
  "18843": {
    DMA: 577,
  },
  "18844": {
    DMA: 577,
  },
  "18845": {
    DMA: 577,
  },
  "18846": {
    DMA: 577,
  },
  "18847": {
    DMA: 577,
  },
  "18848": {
    DMA: 577,
  },
  "18850": {
    DMA: 577,
  },
  "18851": {
    DMA: 577,
  },
  "18853": {
    DMA: 577,
  },
  "18854": {
    DMA: 577,
  },
  "18901": {
    DMA: 504,
  },
  "18902": {
    DMA: 504,
  },
  "18910": {
    DMA: 504,
  },
  "18911": {
    DMA: 504,
  },
  "18912": {
    DMA: 504,
  },
  "18913": {
    DMA: 504,
  },
  "18914": {
    DMA: 504,
  },
  "18915": {
    DMA: 504,
  },
  "18916": {
    DMA: 504,
  },
  "18917": {
    DMA: 504,
  },
  "18918": {
    DMA: 504,
  },
  "18920": {
    DMA: 504,
  },
  "18921": {
    DMA: 504,
  },
  "18922": {
    DMA: 504,
  },
  "18923": {
    DMA: 504,
  },
  "18924": {
    DMA: 504,
  },
  "18925": {
    DMA: 504,
  },
  "18926": {
    DMA: 504,
  },
  "18927": {
    DMA: 504,
  },
  "18928": {
    DMA: 504,
  },
  "18929": {
    DMA: 504,
  },
  "18930": {
    DMA: 504,
  },
  "18931": {
    DMA: 504,
  },
  "18932": {
    DMA: 504,
  },
  "18933": {
    DMA: 504,
  },
  "18934": {
    DMA: 504,
  },
  "18935": {
    DMA: 504,
  },
  "18936": {
    DMA: 504,
  },
  "18938": {
    DMA: 504,
  },
  "18940": {
    DMA: 504,
  },
  "18942": {
    DMA: 504,
  },
  "18943": {
    DMA: 504,
  },
  "18944": {
    DMA: 504,
  },
  "18946": {
    DMA: 504,
  },
  "18947": {
    DMA: 504,
  },
  "18949": {
    DMA: 504,
  },
  "18950": {
    DMA: 504,
  },
  "18951": {
    DMA: 504,
  },
  "18953": {
    DMA: 504,
  },
  "18954": {
    DMA: 504,
  },
  "18955": {
    DMA: 504,
  },
  "18956": {
    DMA: 504,
  },
  "18957": {
    DMA: 504,
  },
  "18958": {
    DMA: 504,
  },
  "18960": {
    DMA: 504,
  },
  "18962": {
    DMA: 504,
  },
  "18963": {
    DMA: 504,
  },
  "18964": {
    DMA: 504,
  },
  "18966": {
    DMA: 504,
  },
  "18968": {
    DMA: 504,
  },
  "18969": {
    DMA: 504,
  },
  "18970": {
    DMA: 504,
  },
  "18971": {
    DMA: 504,
  },
  "18972": {
    DMA: 504,
  },
  "18974": {
    DMA: 504,
  },
  "18976": {
    DMA: 504,
  },
  "18977": {
    DMA: 504,
  },
  "18979": {
    DMA: 504,
  },
  "18980": {
    DMA: 504,
  },
  "18981": {
    DMA: 504,
  },
  "18991": {
    DMA: 504,
  },
  "19001": {
    DMA: 504,
  },
  "19002": {
    DMA: 504,
  },
  "19003": {
    DMA: 504,
  },
  "19004": {
    DMA: 504,
  },
  "19006": {
    DMA: 504,
  },
  "19007": {
    DMA: 504,
  },
  "19008": {
    DMA: 504,
  },
  "19009": {
    DMA: 504,
  },
  "19010": {
    DMA: 504,
  },
  "19012": {
    DMA: 504,
  },
  "19013": {
    DMA: 504,
  },
  "19014": {
    DMA: 504,
  },
  "19015": {
    DMA: 504,
  },
  "19016": {
    DMA: 504,
  },
  "19017": {
    DMA: 504,
  },
  "19018": {
    DMA: 504,
  },
  "19019": {
    DMA: 504,
  },
  "19020": {
    DMA: 504,
  },
  "19021": {
    DMA: 504,
  },
  "19022": {
    DMA: 504,
  },
  "19023": {
    DMA: 504,
  },
  "19025": {
    DMA: 504,
  },
  "19026": {
    DMA: 504,
  },
  "19027": {
    DMA: 504,
  },
  "19028": {
    DMA: 504,
  },
  "19029": {
    DMA: 504,
  },
  "19030": {
    DMA: 504,
  },
  "19031": {
    DMA: 504,
  },
  "19032": {
    DMA: 504,
  },
  "19033": {
    DMA: 504,
  },
  "19034": {
    DMA: 504,
  },
  "19035": {
    DMA: 504,
  },
  "19036": {
    DMA: 504,
  },
  "19037": {
    DMA: 504,
  },
  "19038": {
    DMA: 504,
  },
  "19039": {
    DMA: 504,
  },
  "19040": {
    DMA: 504,
  },
  "19041": {
    DMA: 504,
  },
  "19043": {
    DMA: 504,
  },
  "19044": {
    DMA: 504,
  },
  "19046": {
    DMA: 504,
  },
  "19047": {
    DMA: 504,
  },
  "19048": {
    DMA: 504,
  },
  "19049": {
    DMA: 504,
  },
  "19050": {
    DMA: 504,
  },
  "19052": {
    DMA: 504,
  },
  "19053": {
    DMA: 504,
  },
  "19054": {
    DMA: 504,
  },
  "19055": {
    DMA: 504,
  },
  "19056": {
    DMA: 504,
  },
  "19057": {
    DMA: 504,
  },
  "19058": {
    DMA: 504,
  },
  "19060": {
    DMA: 504,
  },
  "19061": {
    DMA: 504,
  },
  "19063": {
    DMA: 504,
  },
  "19064": {
    DMA: 504,
  },
  "19065": {
    DMA: 504,
  },
  "19066": {
    DMA: 504,
  },
  "19067": {
    DMA: 504,
  },
  "19070": {
    DMA: 504,
  },
  "19072": {
    DMA: 504,
  },
  "19073": {
    DMA: 504,
  },
  "19074": {
    DMA: 504,
  },
  "19075": {
    DMA: 504,
  },
  "19076": {
    DMA: 504,
  },
  "19078": {
    DMA: 504,
  },
  "19079": {
    DMA: 504,
  },
  "19080": {
    DMA: 504,
  },
  "19081": {
    DMA: 504,
  },
  "19082": {
    DMA: 504,
  },
  "19083": {
    DMA: 504,
  },
  "19085": {
    DMA: 504,
  },
  "19086": {
    DMA: 504,
  },
  "19087": {
    DMA: 504,
  },
  "19088": {
    DMA: 504,
  },
  "19089": {
    DMA: 504,
  },
  "19090": {
    DMA: 504,
  },
  "19091": {
    DMA: 504,
  },
  "19092": {
    DMA: 504,
  },
  "19093": {
    DMA: 504,
  },
  "19094": {
    DMA: 504,
  },
  "19095": {
    DMA: 504,
  },
  "19096": {
    DMA: 504,
  },
  "19098": {
    DMA: 504,
  },
  "19099": {
    DMA: 504,
  },
  "19101": {
    DMA: 504,
  },
  "19102": {
    DMA: 504,
  },
  "19103": {
    DMA: 504,
  },
  "19104": {
    DMA: 504,
  },
  "19105": {
    DMA: 504,
  },
  "19106": {
    DMA: 504,
  },
  "19107": {
    DMA: 504,
  },
  "19108": {
    DMA: 504,
  },
  "19109": {
    DMA: 504,
  },
  "19110": {
    DMA: 504,
  },
  "19111": {
    DMA: 504,
  },
  "19112": {
    DMA: 504,
  },
  "19113": {
    DMA: 504,
  },
  "19114": {
    DMA: 504,
  },
  "19115": {
    DMA: 504,
  },
  "19116": {
    DMA: 504,
  },
  "19118": {
    DMA: 504,
  },
  "19119": {
    DMA: 504,
  },
  "19120": {
    DMA: 504,
  },
  "19121": {
    DMA: 504,
  },
  "19122": {
    DMA: 504,
  },
  "19123": {
    DMA: 504,
  },
  "19124": {
    DMA: 504,
  },
  "19125": {
    DMA: 504,
  },
  "19126": {
    DMA: 504,
  },
  "19127": {
    DMA: 504,
  },
  "19128": {
    DMA: 504,
  },
  "19129": {
    DMA: 504,
  },
  "19130": {
    DMA: 504,
  },
  "19131": {
    DMA: 504,
  },
  "19132": {
    DMA: 504,
  },
  "19133": {
    DMA: 504,
  },
  "19134": {
    DMA: 504,
  },
  "19135": {
    DMA: 504,
  },
  "19136": {
    DMA: 504,
  },
  "19137": {
    DMA: 504,
  },
  "19138": {
    DMA: 504,
  },
  "19139": {
    DMA: 504,
  },
  "19140": {
    DMA: 504,
  },
  "19141": {
    DMA: 504,
  },
  "19142": {
    DMA: 504,
  },
  "19143": {
    DMA: 504,
  },
  "19144": {
    DMA: 504,
  },
  "19145": {
    DMA: 504,
  },
  "19146": {
    DMA: 504,
  },
  "19147": {
    DMA: 504,
  },
  "19148": {
    DMA: 504,
  },
  "19149": {
    DMA: 504,
  },
  "19150": {
    DMA: 504,
  },
  "19151": {
    DMA: 504,
  },
  "19152": {
    DMA: 504,
  },
  "19153": {
    DMA: 504,
  },
  "19154": {
    DMA: 504,
  },
  "19155": {
    DMA: 504,
  },
  "19160": {
    DMA: 504,
  },
  "19161": {
    DMA: 504,
  },
  "19162": {
    DMA: 504,
  },
  "19170": {
    DMA: 504,
  },
  "19171": {
    DMA: 504,
  },
  "19172": {
    DMA: 504,
  },
  "19173": {
    DMA: 504,
  },
  "19175": {
    DMA: 504,
  },
  "19176": {
    DMA: 504,
  },
  "19177": {
    DMA: 504,
  },
  "19178": {
    DMA: 504,
  },
  "19179": {
    DMA: 504,
  },
  "19181": {
    DMA: 504,
  },
  "19182": {
    DMA: 504,
  },
  "19183": {
    DMA: 504,
  },
  "19184": {
    DMA: 504,
  },
  "19185": {
    DMA: 504,
  },
  "19187": {
    DMA: 504,
  },
  "19188": {
    DMA: 504,
  },
  "19190": {
    DMA: 504,
  },
  "19191": {
    DMA: 504,
  },
  "19192": {
    DMA: 504,
  },
  "19193": {
    DMA: 504,
  },
  "19194": {
    DMA: 504,
  },
  "19195": {
    DMA: 504,
  },
  "19196": {
    DMA: 504,
  },
  "19197": {
    DMA: 504,
  },
  "19244": {
    DMA: 504,
  },
  "19255": {
    DMA: 504,
  },
  "19301": {
    DMA: 504,
  },
  "19310": {
    DMA: 504,
  },
  "19311": {
    DMA: 504,
  },
  "19312": {
    DMA: 504,
  },
  "19316": {
    DMA: 504,
  },
  "19317": {
    DMA: 504,
  },
  "19318": {
    DMA: 504,
  },
  "19319": {
    DMA: 504,
  },
  "19320": {
    DMA: 504,
  },
  "19330": {
    DMA: 504,
  },
  "19331": {
    DMA: 504,
  },
  "19333": {
    DMA: 504,
  },
  "19335": {
    DMA: 504,
  },
  "19339": {
    DMA: 504,
  },
  "19340": {
    DMA: 504,
  },
  "19341": {
    DMA: 504,
  },
  "19342": {
    DMA: 504,
  },
  "19343": {
    DMA: 504,
  },
  "19344": {
    DMA: 504,
  },
  "19345": {
    DMA: 504,
  },
  "19346": {
    DMA: 504,
  },
  "19347": {
    DMA: 504,
  },
  "19348": {
    DMA: 504,
  },
  "19350": {
    DMA: 504,
  },
  "19351": {
    DMA: 504,
  },
  "19352": {
    DMA: 504,
  },
  "19353": {
    DMA: 504,
  },
  "19354": {
    DMA: 504,
  },
  "19355": {
    DMA: 504,
  },
  "19357": {
    DMA: 504,
  },
  "19358": {
    DMA: 504,
  },
  "19360": {
    DMA: 504,
  },
  "19362": {
    DMA: 504,
  },
  "19363": {
    DMA: 504,
  },
  "19365": {
    DMA: 504,
  },
  "19366": {
    DMA: 504,
  },
  "19367": {
    DMA: 504,
  },
  "19369": {
    DMA: 504,
  },
  "19371": {
    DMA: 504,
  },
  "19372": {
    DMA: 504,
  },
  "19373": {
    DMA: 504,
  },
  "19374": {
    DMA: 504,
  },
  "19375": {
    DMA: 504,
  },
  "19376": {
    DMA: 504,
  },
  "19380": {
    DMA: 504,
  },
  "19381": {
    DMA: 504,
  },
  "19382": {
    DMA: 504,
  },
  "19383": {
    DMA: 504,
  },
  "19388": {
    DMA: 504,
  },
  "19390": {
    DMA: 504,
  },
  "19395": {
    DMA: 504,
  },
  "19397": {
    DMA: 504,
  },
  "19398": {
    DMA: 504,
  },
  "19399": {
    DMA: 504,
  },
  "19401": {
    DMA: 504,
  },
  "19403": {
    DMA: 504,
  },
  "19404": {
    DMA: 504,
  },
  "19405": {
    DMA: 504,
  },
  "19406": {
    DMA: 504,
  },
  "19407": {
    DMA: 504,
  },
  "19408": {
    DMA: 504,
  },
  "19409": {
    DMA: 504,
  },
  "19415": {
    DMA: 504,
  },
  "19420": {
    DMA: 504,
  },
  "19421": {
    DMA: 504,
  },
  "19422": {
    DMA: 504,
  },
  "19423": {
    DMA: 504,
  },
  "19424": {
    DMA: 504,
  },
  "19425": {
    DMA: 504,
  },
  "19426": {
    DMA: 504,
  },
  "19428": {
    DMA: 504,
  },
  "19429": {
    DMA: 504,
  },
  "19430": {
    DMA: 504,
  },
  "19432": {
    DMA: 504,
  },
  "19435": {
    DMA: 504,
  },
  "19436": {
    DMA: 504,
  },
  "19437": {
    DMA: 504,
  },
  "19438": {
    DMA: 504,
  },
  "19440": {
    DMA: 504,
  },
  "19441": {
    DMA: 504,
  },
  "19442": {
    DMA: 504,
  },
  "19443": {
    DMA: 504,
  },
  "19444": {
    DMA: 504,
  },
  "19446": {
    DMA: 504,
  },
  "19450": {
    DMA: 504,
  },
  "19451": {
    DMA: 504,
  },
  "19453": {
    DMA: 504,
  },
  "19454": {
    DMA: 504,
  },
  "19455": {
    DMA: 504,
  },
  "19456": {
    DMA: 504,
  },
  "19457": {
    DMA: 504,
  },
  "19460": {
    DMA: 504,
  },
  "19462": {
    DMA: 504,
  },
  "19464": {
    DMA: 504,
  },
  "19465": {
    DMA: 504,
  },
  "19468": {
    DMA: 504,
  },
  "19470": {
    DMA: 504,
  },
  "19472": {
    DMA: 504,
  },
  "19473": {
    DMA: 504,
  },
  "19474": {
    DMA: 504,
  },
  "19475": {
    DMA: 504,
  },
  "19477": {
    DMA: 504,
  },
  "19478": {
    DMA: 504,
  },
  "19480": {
    DMA: 504,
  },
  "19481": {
    DMA: 504,
  },
  "19482": {
    DMA: 504,
  },
  "19483": {
    DMA: 504,
  },
  "19484": {
    DMA: 504,
  },
  "19485": {
    DMA: 504,
  },
  "19486": {
    DMA: 504,
  },
  "19487": {
    DMA: 504,
  },
  "19488": {
    DMA: 504,
  },
  "19489": {
    DMA: 504,
  },
  "19490": {
    DMA: 504,
  },
  "19492": {
    DMA: 504,
  },
  "19493": {
    DMA: 504,
  },
  "19494": {
    DMA: 504,
  },
  "19495": {
    DMA: 504,
  },
  "19496": {
    DMA: 504,
  },
  "19501": {
    DMA: 566,
  },
  "19503": {
    DMA: 504,
  },
  "19504": {
    DMA: 504,
  },
  "19505": {
    DMA: 504,
  },
  "19506": {
    DMA: 504,
  },
  "19507": {
    DMA: 504,
  },
  "19508": {
    DMA: 504,
  },
  "19510": {
    DMA: 504,
  },
  "19511": {
    DMA: 504,
  },
  "19512": {
    DMA: 504,
  },
  "19516": {
    DMA: 504,
  },
  "19518": {
    DMA: 504,
  },
  "19519": {
    DMA: 504,
  },
  "19520": {
    DMA: 504,
  },
  "19522": {
    DMA: 504,
  },
  "19523": {
    DMA: 504,
  },
  "19525": {
    DMA: 504,
  },
  "19526": {
    DMA: 504,
  },
  "19529": {
    DMA: 504,
  },
  "19530": {
    DMA: 504,
  },
  "19533": {
    DMA: 504,
  },
  "19534": {
    DMA: 504,
  },
  "19535": {
    DMA: 504,
  },
  "19536": {
    DMA: 504,
  },
  "19538": {
    DMA: 504,
  },
  "19539": {
    DMA: 504,
  },
  "19540": {
    DMA: 504,
  },
  "19541": {
    DMA: 504,
  },
  "19542": {
    DMA: 504,
  },
  "19543": {
    DMA: 504,
  },
  "19544": {
    DMA: 504,
  },
  "19545": {
    DMA: 504,
  },
  "19547": {
    DMA: 504,
  },
  "19548": {
    DMA: 504,
  },
  "19549": {
    DMA: 577,
  },
  "19550": {
    DMA: 504,
  },
  "19551": {
    DMA: 504,
  },
  "19554": {
    DMA: 504,
  },
  "19555": {
    DMA: 504,
  },
  "19559": {
    DMA: 504,
  },
  "19560": {
    DMA: 504,
  },
  "19562": {
    DMA: 504,
  },
  "19564": {
    DMA: 504,
  },
  "19565": {
    DMA: 504,
  },
  "19567": {
    DMA: 504,
  },
  "19601": {
    DMA: 504,
  },
  "19602": {
    DMA: 504,
  },
  "19603": {
    DMA: 504,
  },
  "19604": {
    DMA: 504,
  },
  "19605": {
    DMA: 504,
  },
  "19606": {
    DMA: 504,
  },
  "19607": {
    DMA: 504,
  },
  "19608": {
    DMA: 504,
  },
  "19609": {
    DMA: 504,
  },
  "19610": {
    DMA: 504,
  },
  "19611": {
    DMA: 504,
  },
  "19612": {
    DMA: 504,
  },
  "19640": {
    DMA: 504,
  },
  "19701": {
    DMA: 504,
  },
  "19702": {
    DMA: 504,
  },
  "19703": {
    DMA: 504,
  },
  "19706": {
    DMA: 504,
  },
  "19707": {
    DMA: 504,
  },
  "19708": {
    DMA: 504,
  },
  "19709": {
    DMA: 504,
  },
  "19710": {
    DMA: 504,
  },
  "19711": {
    DMA: 504,
  },
  "19712": {
    DMA: 504,
  },
  "19713": {
    DMA: 504,
  },
  "19714": {
    DMA: 504,
  },
  "19715": {
    DMA: 504,
  },
  "19716": {
    DMA: 504,
  },
  "19717": {
    DMA: 504,
  },
  "19718": {
    DMA: 504,
  },
  "19720": {
    DMA: 504,
  },
  "19721": {
    DMA: 504,
  },
  "19725": {
    DMA: 504,
  },
  "19726": {
    DMA: 504,
  },
  "19730": {
    DMA: 504,
  },
  "19731": {
    DMA: 504,
  },
  "19732": {
    DMA: 504,
  },
  "19733": {
    DMA: 504,
  },
  "19734": {
    DMA: 504,
  },
  "19735": {
    DMA: 504,
  },
  "19736": {
    DMA: 504,
  },
  "19801": {
    DMA: 504,
  },
  "19802": {
    DMA: 504,
  },
  "19803": {
    DMA: 504,
  },
  "19804": {
    DMA: 504,
  },
  "19805": {
    DMA: 504,
  },
  "19806": {
    DMA: 504,
  },
  "19807": {
    DMA: 504,
  },
  "19808": {
    DMA: 504,
  },
  "19809": {
    DMA: 504,
  },
  "19810": {
    DMA: 504,
  },
  "19850": {
    DMA: 504,
  },
  "19880": {
    DMA: 504,
  },
  "19884": {
    DMA: 504,
  },
  "19885": {
    DMA: 504,
  },
  "19886": {
    DMA: 504,
  },
  "19887": {
    DMA: 504,
  },
  "19889": {
    DMA: 504,
  },
  "19890": {
    DMA: 504,
  },
  "19891": {
    DMA: 504,
  },
  "19892": {
    DMA: 504,
  },
  "19893": {
    DMA: 504,
  },
  "19894": {
    DMA: 504,
  },
  "19895": {
    DMA: 504,
  },
  "19896": {
    DMA: 504,
  },
  "19897": {
    DMA: 504,
  },
  "19898": {
    DMA: 504,
  },
  "19899": {
    DMA: 504,
  },
  "19901": {
    DMA: 504,
  },
  "19902": {
    DMA: 504,
  },
  "19903": {
    DMA: 504,
  },
  "19904": {
    DMA: 504,
  },
  "19905": {
    DMA: 504,
  },
  "19906": {
    DMA: 504,
  },
  "19930": {
    DMA: 576,
  },
  "19931": {
    DMA: 576,
  },
  "19933": {
    DMA: 576,
  },
  "19934": {
    DMA: 504,
  },
  "19936": {
    DMA: 504,
  },
  "19938": {
    DMA: 504,
  },
  "19939": {
    DMA: 576,
  },
  "19940": {
    DMA: 576,
  },
  "19941": {
    DMA: 576,
  },
  "19943": {
    DMA: 504,
  },
  "19944": {
    DMA: 576,
  },
  "19945": {
    DMA: 576,
  },
  "19946": {
    DMA: 504,
  },
  "19947": {
    DMA: 576,
  },
  "19950": {
    DMA: 576,
  },
  "19951": {
    DMA: 576,
  },
  "19952": {
    DMA: 504,
  },
  "19953": {
    DMA: 504,
  },
  "19954": {
    DMA: 504,
  },
  "19955": {
    DMA: 504,
  },
  "19956": {
    DMA: 576,
  },
  "19958": {
    DMA: 576,
  },
  "19960": {
    DMA: 576,
  },
  "19961": {
    DMA: 504,
  },
  "19962": {
    DMA: 504,
  },
  "19963": {
    DMA: 576,
  },
  "19964": {
    DMA: 504,
  },
  "19966": {
    DMA: 576,
  },
  "19967": {
    DMA: 576,
  },
  "19968": {
    DMA: 576,
  },
  "19969": {
    DMA: 576,
  },
  "19970": {
    DMA: 576,
  },
  "19971": {
    DMA: 576,
  },
  "19973": {
    DMA: 576,
  },
  "19975": {
    DMA: 576,
  },
  "19977": {
    DMA: 504,
  },
  "19979": {
    DMA: 504,
  },
  "19980": {
    DMA: 504,
  },
  "20001": {
    DMA: 511,
  },
  "20002": {
    DMA: 511,
  },
  "20003": {
    DMA: 511,
  },
  "20004": {
    DMA: 511,
  },
  "20005": {
    DMA: 511,
  },
  "20006": {
    DMA: 511,
  },
  "20007": {
    DMA: 511,
  },
  "20008": {
    DMA: 511,
  },
  "20009": {
    DMA: 511,
  },
  "20010": {
    DMA: 511,
  },
  "20011": {
    DMA: 511,
  },
  "20012": {
    DMA: 511,
  },
  "20013": {
    DMA: 511,
  },
  "20015": {
    DMA: 511,
  },
  "20016": {
    DMA: 511,
  },
  "20017": {
    DMA: 511,
  },
  "20018": {
    DMA: 511,
  },
  "20019": {
    DMA: 511,
  },
  "20020": {
    DMA: 511,
  },
  "20022": {
    DMA: 511,
  },
  "20023": {
    DMA: "#N/A",
  },
  "20024": {
    DMA: 511,
  },
  "20026": {
    DMA: 511,
  },
  "20027": {
    DMA: 511,
  },
  "20029": {
    DMA: 511,
  },
  "20030": {
    DMA: 511,
  },
  "20032": {
    DMA: 511,
  },
  "20033": {
    DMA: 511,
  },
  "20035": {
    DMA: 511,
  },
  "20036": {
    DMA: 511,
  },
  "20037": {
    DMA: 511,
  },
  "20038": {
    DMA: 511,
  },
  "20039": {
    DMA: 511,
  },
  "20040": {
    DMA: 511,
  },
  "20041": {
    DMA: 511,
  },
  "20042": {
    DMA: 511,
  },
  "20043": {
    DMA: 511,
  },
  "20044": {
    DMA: 511,
  },
  "20045": {
    DMA: 511,
  },
  "20046": {
    DMA: 511,
  },
  "20047": {
    DMA: 511,
  },
  "20049": {
    DMA: 511,
  },
  "20050": {
    DMA: 511,
  },
  "20051": {
    DMA: 511,
  },
  "20052": {
    DMA: 511,
  },
  "20053": {
    DMA: 511,
  },
  "20055": {
    DMA: 511,
  },
  "20056": {
    DMA: 511,
  },
  "20057": {
    DMA: 511,
  },
  "20058": {
    DMA: 511,
  },
  "20059": {
    DMA: 511,
  },
  "20060": {
    DMA: 511,
  },
  "20061": {
    DMA: 511,
  },
  "20062": {
    DMA: 511,
  },
  "20063": {
    DMA: 511,
  },
  "20064": {
    DMA: 511,
  },
  "20065": {
    DMA: 511,
  },
  "20066": {
    DMA: 511,
  },
  "20067": {
    DMA: 511,
  },
  "20068": {
    DMA: 511,
  },
  "20069": {
    DMA: 511,
  },
  "20070": {
    DMA: 511,
  },
  "20071": {
    DMA: 511,
  },
  "20073": {
    DMA: 511,
  },
  "20074": {
    DMA: 511,
  },
  "20075": {
    DMA: 511,
  },
  "20076": {
    DMA: 511,
  },
  "20077": {
    DMA: 511,
  },
  "20078": {
    DMA: 511,
  },
  "20080": {
    DMA: 511,
  },
  "20081": {
    DMA: 511,
  },
  "20082": {
    DMA: 511,
  },
  "20088": {
    DMA: 511,
  },
  "20090": {
    DMA: 511,
  },
  "20091": {
    DMA: 511,
  },
  "20097": {
    DMA: 511,
  },
  "20098": {
    DMA: 511,
  },
  "20101": {
    DMA: 511,
  },
  "20102": {
    DMA: 511,
  },
  "20103": {
    DMA: 511,
  },
  "20104": {
    DMA: 511,
  },
  "20105": {
    DMA: 511,
  },
  "20106": {
    DMA: 511,
  },
  "20107": {
    DMA: 511,
  },
  "20108": {
    DMA: 511,
  },
  "20109": {
    DMA: 511,
  },
  "20110": {
    DMA: 511,
  },
  "20111": {
    DMA: 511,
  },
  "20112": {
    DMA: 511,
  },
  "20113": {
    DMA: 511,
  },
  "20115": {
    DMA: 511,
  },
  "20116": {
    DMA: 511,
  },
  "20117": {
    DMA: 511,
  },
  "20118": {
    DMA: 511,
  },
  "20119": {
    DMA: 511,
  },
  "20120": {
    DMA: 511,
  },
  "20121": {
    DMA: 511,
  },
  "20122": {
    DMA: 511,
  },
  "20124": {
    DMA: 511,
  },
  "20128": {
    DMA: 511,
  },
  "20129": {
    DMA: 511,
  },
  "20130": {
    DMA: 511,
  },
  "20131": {
    DMA: 511,
  },
  "20132": {
    DMA: 511,
  },
  "20134": {
    DMA: 511,
  },
  "20135": {
    DMA: 511,
  },
  "20136": {
    DMA: 511,
  },
  "20137": {
    DMA: 511,
  },
  "20138": {
    DMA: 511,
  },
  "20139": {
    DMA: 511,
  },
  "20140": {
    DMA: 511,
  },
  "20141": {
    DMA: 511,
  },
  "20142": {
    DMA: 511,
  },
  "20143": {
    DMA: 511,
  },
  "20144": {
    DMA: 511,
  },
  "20146": {
    DMA: 511,
  },
  "20147": {
    DMA: 511,
  },
  "20148": {
    DMA: 511,
  },
  "20149": {
    DMA: 511,
  },
  "20151": {
    DMA: 511,
  },
  "20152": {
    DMA: 511,
  },
  "20153": {
    DMA: 511,
  },
  "20155": {
    DMA: 511,
  },
  "20156": {
    DMA: 511,
  },
  "20158": {
    DMA: 511,
  },
  "20159": {
    DMA: 511,
  },
  "20160": {
    DMA: 511,
  },
  "20163": {
    DMA: 511,
  },
  "20164": {
    DMA: 511,
  },
  "20165": {
    DMA: 511,
  },
  "20166": {
    DMA: 511,
  },
  "20167": {
    DMA: 511,
  },
  "20168": {
    DMA: 511,
  },
  "20169": {
    DMA: 511,
  },
  "20170": {
    DMA: 511,
  },
  "20171": {
    DMA: 511,
  },
  "20172": {
    DMA: 511,
  },
  "20175": {
    DMA: 511,
  },
  "20176": {
    DMA: 511,
  },
  "20177": {
    DMA: 511,
  },
  "20178": {
    DMA: 511,
  },
  "20180": {
    DMA: 511,
  },
  "20181": {
    DMA: 511,
  },
  "20182": {
    DMA: 511,
  },
  "20184": {
    DMA: 511,
  },
  "20185": {
    DMA: 511,
  },
  "20186": {
    DMA: 511,
  },
  "20187": {
    DMA: 511,
  },
  "20188": {
    DMA: 511,
  },
  "20189": {
    DMA: 511,
  },
  "20190": {
    DMA: 511,
  },
  "20191": {
    DMA: 511,
  },
  "20192": {
    DMA: 511,
  },
  "20193": {
    DMA: 511,
  },
  "20194": {
    DMA: 511,
  },
  "20195": {
    DMA: 511,
  },
  "20196": {
    DMA: 511,
  },
  "20197": {
    DMA: 511,
  },
  "20198": {
    DMA: 511,
  },
  "20199": {
    DMA: 511,
  },
  "20201": {
    DMA: 511,
  },
  "20202": {
    DMA: 511,
  },
  "20203": {
    DMA: 511,
  },
  "20204": {
    DMA: 511,
  },
  "20206": {
    DMA: 511,
  },
  "20207": {
    DMA: 511,
  },
  "20208": {
    DMA: 511,
  },
  "20210": {
    DMA: 511,
  },
  "20211": {
    DMA: 511,
  },
  "20212": {
    DMA: 511,
  },
  "20213": {
    DMA: 511,
  },
  "20214": {
    DMA: 511,
  },
  "20215": {
    DMA: 511,
  },
  "20216": {
    DMA: 511,
  },
  "20217": {
    DMA: 511,
  },
  "20218": {
    DMA: 511,
  },
  "20219": {
    DMA: 511,
  },
  "20220": {
    DMA: 511,
  },
  "20221": {
    DMA: 511,
  },
  "20222": {
    DMA: 511,
  },
  "20223": {
    DMA: 511,
  },
  "20224": {
    DMA: 511,
  },
  "20226": {
    DMA: 511,
  },
  "20227": {
    DMA: 511,
  },
  "20228": {
    DMA: 511,
  },
  "20229": {
    DMA: 511,
  },
  "20230": {
    DMA: 511,
  },
  "20232": {
    DMA: 511,
  },
  "20233": {
    DMA: 511,
  },
  "20235": {
    DMA: 511,
  },
  "20237": {
    DMA: 511,
  },
  "20238": {
    DMA: 511,
  },
  "20239": {
    DMA: 511,
  },
  "20240": {
    DMA: 511,
  },
  "20241": {
    DMA: 511,
  },
  "20242": {
    DMA: 511,
  },
  "20244": {
    DMA: 511,
  },
  "20245": {
    DMA: 511,
  },
  "20250": {
    DMA: 511,
  },
  "20251": {
    DMA: 511,
  },
  "20252": {
    DMA: 511,
  },
  "20254": {
    DMA: 511,
  },
  "20260": {
    DMA: 511,
  },
  "20261": {
    DMA: 511,
  },
  "20262": {
    DMA: 511,
  },
  "20265": {
    DMA: 511,
  },
  "20266": {
    DMA: 511,
  },
  "20268": {
    DMA: 511,
  },
  "20270": {
    DMA: 511,
  },
  "20277": {
    DMA: 511,
  },
  "20289": {
    DMA: 511,
  },
  "20299": {
    DMA: 511,
  },
  "20301": {
    DMA: 511,
  },
  "20303": {
    DMA: 511,
  },
  "20306": {
    DMA: 511,
  },
  "20307": {
    DMA: 511,
  },
  "20310": {
    DMA: 511,
  },
  "20314": {
    DMA: 511,
  },
  "20317": {
    DMA: 511,
  },
  "20318": {
    DMA: 511,
  },
  "20319": {
    DMA: 511,
  },
  "20330": {
    DMA: 511,
  },
  "20340": {
    DMA: 511,
  },
  "20350": {
    DMA: 511,
  },
  "20355": {
    DMA: 511,
  },
  "20370": {
    DMA: 511,
  },
  "20372": {
    DMA: 511,
  },
  "20373": {
    DMA: 511,
  },
  "20374": {
    DMA: 511,
  },
  "20375": {
    DMA: 511,
  },
  "20376": {
    DMA: 511,
  },
  "20380": {
    DMA: 511,
  },
  "20388": {
    DMA: 511,
  },
  "20389": {
    DMA: 511,
  },
  "20390": {
    DMA: 511,
  },
  "20391": {
    DMA: 511,
  },
  "20392": {
    DMA: 511,
  },
  "20393": {
    DMA: 511,
  },
  "20394": {
    DMA: 511,
  },
  "20395": {
    DMA: 511,
  },
  "20398": {
    DMA: 511,
  },
  "20401": {
    DMA: 511,
  },
  "20402": {
    DMA: 511,
  },
  "20403": {
    DMA: 511,
  },
  "20404": {
    DMA: 511,
  },
  "20405": {
    DMA: 511,
  },
  "20406": {
    DMA: 511,
  },
  "20407": {
    DMA: 511,
  },
  "20408": {
    DMA: 511,
  },
  "20409": {
    DMA: 511,
  },
  "20410": {
    DMA: 511,
  },
  "20411": {
    DMA: 511,
  },
  "20412": {
    DMA: 511,
  },
  "20413": {
    DMA: 511,
  },
  "20414": {
    DMA: 511,
  },
  "20415": {
    DMA: 511,
  },
  "20416": {
    DMA: 511,
  },
  "20417": {
    DMA: 511,
  },
  "20418": {
    DMA: 511,
  },
  "20419": {
    DMA: 511,
  },
  "20420": {
    DMA: 511,
  },
  "20421": {
    DMA: 511,
  },
  "20422": {
    DMA: 511,
  },
  "20423": {
    DMA: 511,
  },
  "20424": {
    DMA: 511,
  },
  "20425": {
    DMA: 511,
  },
  "20426": {
    DMA: 511,
  },
  "20427": {
    DMA: 511,
  },
  "20428": {
    DMA: 511,
  },
  "20429": {
    DMA: 511,
  },
  "20431": {
    DMA: 511,
  },
  "20433": {
    DMA: 511,
  },
  "20434": {
    DMA: 511,
  },
  "20435": {
    DMA: 511,
  },
  "20436": {
    DMA: 511,
  },
  "20437": {
    DMA: 511,
  },
  "20439": {
    DMA: 511,
  },
  "20440": {
    DMA: 511,
  },
  "20441": {
    DMA: 511,
  },
  "20442": {
    DMA: 511,
  },
  "20444": {
    DMA: 511,
  },
  "20447": {
    DMA: 511,
  },
  "20451": {
    DMA: 511,
  },
  "20453": {
    DMA: 511,
  },
  "20456": {
    DMA: 511,
  },
  "20460": {
    DMA: 511,
  },
  "20463": {
    DMA: 511,
  },
  "20468": {
    DMA: 511,
  },
  "20469": {
    DMA: 511,
  },
  "20470": {
    DMA: 511,
  },
  "20472": {
    DMA: 511,
  },
  "20500": {
    DMA: 511,
  },
  "20501": {
    DMA: 511,
  },
  "20502": {
    DMA: 511,
  },
  "20503": {
    DMA: 511,
  },
  "20504": {
    DMA: 511,
  },
  "20505": {
    DMA: 511,
  },
  "20506": {
    DMA: 511,
  },
  "20507": {
    DMA: 511,
  },
  "20508": {
    DMA: 511,
  },
  "20509": {
    DMA: 511,
  },
  "20510": {
    DMA: 511,
  },
  "20511": {
    DMA: 511,
  },
  "20515": {
    DMA: 511,
  },
  "20520": {
    DMA: 511,
  },
  "20521": {
    DMA: 511,
  },
  "20522": {
    DMA: 511,
  },
  "20523": {
    DMA: 511,
  },
  "20524": {
    DMA: 511,
  },
  "20525": {
    DMA: 511,
  },
  "20526": {
    DMA: 511,
  },
  "20527": {
    DMA: 511,
  },
  "20528": {
    DMA: 511,
  },
  "20529": {
    DMA: 511,
  },
  "20530": {
    DMA: 511,
  },
  "20531": {
    DMA: 511,
  },
  "20532": {
    DMA: 511,
  },
  "20533": {
    DMA: 511,
  },
  "20534": {
    DMA: 511,
  },
  "20535": {
    DMA: 511,
  },
  "20536": {
    DMA: 511,
  },
  "20537": {
    DMA: 511,
  },
  "20538": {
    DMA: 511,
  },
  "20539": {
    DMA: 511,
  },
  "20540": {
    DMA: 511,
  },
  "20541": {
    DMA: 511,
  },
  "20542": {
    DMA: 511,
  },
  "20543": {
    DMA: 511,
  },
  "20544": {
    DMA: 511,
  },
  "20546": {
    DMA: 511,
  },
  "20547": {
    DMA: 511,
  },
  "20548": {
    DMA: 511,
  },
  "20549": {
    DMA: 511,
  },
  "20551": {
    DMA: 511,
  },
  "20552": {
    DMA: 511,
  },
  "20553": {
    DMA: 511,
  },
  "20554": {
    DMA: 511,
  },
  "20555": {
    DMA: 511,
  },
  "20557": {
    DMA: 511,
  },
  "20558": {
    DMA: 511,
  },
  "20559": {
    DMA: 511,
  },
  "20560": {
    DMA: 511,
  },
  "20565": {
    DMA: 511,
  },
  "20566": {
    DMA: 511,
  },
  "20570": {
    DMA: 511,
  },
  "20571": {
    DMA: 511,
  },
  "20572": {
    DMA: 511,
  },
  "20573": {
    DMA: 511,
  },
  "20575": {
    DMA: 511,
  },
  "20576": {
    DMA: 511,
  },
  "20577": {
    DMA: 511,
  },
  "20578": {
    DMA: 511,
  },
  "20579": {
    DMA: 511,
  },
  "20580": {
    DMA: 511,
  },
  "20581": {
    DMA: 511,
  },
  "20585": {
    DMA: 511,
  },
  "20586": {
    DMA: 511,
  },
  "20588": {
    DMA: 511,
  },
  "20590": {
    DMA: 511,
  },
  "20591": {
    DMA: 511,
  },
  "20593": {
    DMA: 511,
  },
  "20594": {
    DMA: 511,
  },
  "20597": {
    DMA: 511,
  },
  "20598": {
    DMA: 511,
  },
  "20599": {
    DMA: 511,
  },
  "20601": {
    DMA: 511,
  },
  "20602": {
    DMA: 511,
  },
  "20603": {
    DMA: 511,
  },
  "20604": {
    DMA: 511,
  },
  "20606": {
    DMA: 511,
  },
  "20607": {
    DMA: 511,
  },
  "20608": {
    DMA: 511,
  },
  "20609": {
    DMA: 511,
  },
  "20610": {
    DMA: 511,
  },
  "20611": {
    DMA: 511,
  },
  "20612": {
    DMA: 511,
  },
  "20613": {
    DMA: 511,
  },
  "20615": {
    DMA: 511,
  },
  "20616": {
    DMA: 511,
  },
  "20617": {
    DMA: 511,
  },
  "20618": {
    DMA: 511,
  },
  "20619": {
    DMA: 511,
  },
  "20620": {
    DMA: 511,
  },
  "20621": {
    DMA: 511,
  },
  "20622": {
    DMA: 511,
  },
  "20623": {
    DMA: 511,
  },
  "20624": {
    DMA: 511,
  },
  "20625": {
    DMA: 511,
  },
  "20626": {
    DMA: 511,
  },
  "20627": {
    DMA: 511,
  },
  "20628": {
    DMA: 511,
  },
  "20629": {
    DMA: 511,
  },
  "20630": {
    DMA: 511,
  },
  "20632": {
    DMA: 511,
  },
  "20634": {
    DMA: 511,
  },
  "20635": {
    DMA: 511,
  },
  "20636": {
    DMA: 511,
  },
  "20637": {
    DMA: 511,
  },
  "20639": {
    DMA: 511,
  },
  "20640": {
    DMA: 511,
  },
  "20643": {
    DMA: 511,
  },
  "20645": {
    DMA: 511,
  },
  "20646": {
    DMA: 511,
  },
  "20650": {
    DMA: 511,
  },
  "20653": {
    DMA: 511,
  },
  "20656": {
    DMA: 511,
  },
  "20657": {
    DMA: 511,
  },
  "20658": {
    DMA: 511,
  },
  "20659": {
    DMA: 511,
  },
  "20660": {
    DMA: 511,
  },
  "20661": {
    DMA: 511,
  },
  "20662": {
    DMA: 511,
  },
  "20664": {
    DMA: 511,
  },
  "20667": {
    DMA: 511,
  },
  "20670": {
    DMA: 511,
  },
  "20674": {
    DMA: 511,
  },
  "20675": {
    DMA: 511,
  },
  "20676": {
    DMA: 511,
  },
  "20677": {
    DMA: 511,
  },
  "20678": {
    DMA: 511,
  },
  "20680": {
    DMA: 511,
  },
  "20682": {
    DMA: 511,
  },
  "20684": {
    DMA: 511,
  },
  "20685": {
    DMA: 511,
  },
  "20686": {
    DMA: 511,
  },
  "20687": {
    DMA: 511,
  },
  "20688": {
    DMA: 511,
  },
  "20689": {
    DMA: 511,
  },
  "20690": {
    DMA: 511,
  },
  "20692": {
    DMA: 511,
  },
  "20693": {
    DMA: 511,
  },
  "20695": {
    DMA: 511,
  },
  "20697": {
    DMA: 511,
  },
  "20701": {
    DMA: 512,
  },
  "20703": {
    DMA: 511,
  },
  "20704": {
    DMA: 511,
  },
  "20705": {
    DMA: 511,
  },
  "20706": {
    DMA: 511,
  },
  "20707": {
    DMA: 511,
  },
  "20708": {
    DMA: 511,
  },
  "20709": {
    DMA: 511,
  },
  "20710": {
    DMA: 511,
  },
  "20711": {
    DMA: 512,
  },
  "20712": {
    DMA: 511,
  },
  "20714": {
    DMA: 511,
  },
  "20715": {
    DMA: 511,
  },
  "20716": {
    DMA: 511,
  },
  "20717": {
    DMA: 511,
  },
  "20718": {
    DMA: 511,
  },
  "20719": {
    DMA: 511,
  },
  "20720": {
    DMA: 511,
  },
  "20721": {
    DMA: 511,
  },
  "20722": {
    DMA: 511,
  },
  "20723": {
    DMA: 512,
  },
  "20724": {
    DMA: 512,
  },
  "20725": {
    DMA: 511,
  },
  "20726": {
    DMA: 511,
  },
  "20731": {
    DMA: 511,
  },
  "20732": {
    DMA: 511,
  },
  "20733": {
    DMA: 512,
  },
  "20735": {
    DMA: 511,
  },
  "20736": {
    DMA: 511,
  },
  "20737": {
    DMA: 511,
  },
  "20738": {
    DMA: 511,
  },
  "20740": {
    DMA: 511,
  },
  "20741": {
    DMA: 511,
  },
  "20742": {
    DMA: 511,
  },
  "20743": {
    DMA: 511,
  },
  "20744": {
    DMA: 511,
  },
  "20745": {
    DMA: 511,
  },
  "20746": {
    DMA: 511,
  },
  "20747": {
    DMA: 511,
  },
  "20748": {
    DMA: 511,
  },
  "20749": {
    DMA: 511,
  },
  "20750": {
    DMA: 511,
  },
  "20751": {
    DMA: 512,
  },
  "20752": {
    DMA: 511,
  },
  "20753": {
    DMA: 511,
  },
  "20754": {
    DMA: 511,
  },
  "20755": {
    DMA: 512,
  },
  "20757": {
    DMA: 511,
  },
  "20758": {
    DMA: 512,
  },
  "20759": {
    DMA: 512,
  },
  "20762": {
    DMA: 511,
  },
  "20763": {
    DMA: 512,
  },
  "20764": {
    DMA: 512,
  },
  "20765": {
    DMA: 512,
  },
  "20768": {
    DMA: 511,
  },
  "20769": {
    DMA: 511,
  },
  "20770": {
    DMA: 511,
  },
  "20771": {
    DMA: 511,
  },
  "20772": {
    DMA: 511,
  },
  "20773": {
    DMA: 511,
  },
  "20774": {
    DMA: 511,
  },
  "20775": {
    DMA: 511,
  },
  "20776": {
    DMA: 512,
  },
  "20777": {
    DMA: 512,
  },
  "20778": {
    DMA: 512,
  },
  "20779": {
    DMA: 512,
  },
  "20781": {
    DMA: 511,
  },
  "20782": {
    DMA: 511,
  },
  "20783": {
    DMA: 511,
  },
  "20784": {
    DMA: 511,
  },
  "20785": {
    DMA: 511,
  },
  "20787": {
    DMA: 511,
  },
  "20788": {
    DMA: 511,
  },
  "20790": {
    DMA: 511,
  },
  "20791": {
    DMA: 511,
  },
  "20792": {
    DMA: 511,
  },
  "20794": {
    DMA: 512,
  },
  "20797": {
    DMA: 511,
  },
  "20799": {
    DMA: 511,
  },
  "20810": {
    DMA: 511,
  },
  "20811": {
    DMA: 511,
  },
  "20812": {
    DMA: 511,
  },
  "20813": {
    DMA: 511,
  },
  "20814": {
    DMA: 511,
  },
  "20815": {
    DMA: 511,
  },
  "20816": {
    DMA: 511,
  },
  "20817": {
    DMA: 511,
  },
  "20818": {
    DMA: 511,
  },
  "20824": {
    DMA: 511,
  },
  "20825": {
    DMA: 511,
  },
  "20827": {
    DMA: 511,
  },
  "20830": {
    DMA: 511,
  },
  "20832": {
    DMA: 511,
  },
  "20833": {
    DMA: 511,
  },
  "20837": {
    DMA: 511,
  },
  "20838": {
    DMA: 511,
  },
  "20839": {
    DMA: 511,
  },
  "20841": {
    DMA: 511,
  },
  "20842": {
    DMA: 511,
  },
  "20847": {
    DMA: 511,
  },
  "20848": {
    DMA: 511,
  },
  "20849": {
    DMA: 511,
  },
  "20850": {
    DMA: 511,
  },
  "20851": {
    DMA: 511,
  },
  "20852": {
    DMA: 511,
  },
  "20853": {
    DMA: 511,
  },
  "20854": {
    DMA: 511,
  },
  "20855": {
    DMA: 511,
  },
  "20857": {
    DMA: 511,
  },
  "20859": {
    DMA: 511,
  },
  "20860": {
    DMA: 511,
  },
  "20861": {
    DMA: 511,
  },
  "20862": {
    DMA: 511,
  },
  "20866": {
    DMA: 511,
  },
  "20868": {
    DMA: 511,
  },
  "20871": {
    DMA: 511,
  },
  "20872": {
    DMA: 511,
  },
  "20874": {
    DMA: 511,
  },
  "20875": {
    DMA: 511,
  },
  "20876": {
    DMA: 511,
  },
  "20877": {
    DMA: 511,
  },
  "20878": {
    DMA: 511,
  },
  "20879": {
    DMA: 511,
  },
  "20880": {
    DMA: 511,
  },
  "20882": {
    DMA: 511,
  },
  "20883": {
    DMA: 511,
  },
  "20884": {
    DMA: 511,
  },
  "20885": {
    DMA: 511,
  },
  "20886": {
    DMA: 511,
  },
  "20889": {
    DMA: 511,
  },
  "20891": {
    DMA: 511,
  },
  "20892": {
    DMA: 511,
  },
  "20894": {
    DMA: 511,
  },
  "20895": {
    DMA: 511,
  },
  "20896": {
    DMA: 511,
  },
  "20897": {
    DMA: 511,
  },
  "20898": {
    DMA: 511,
  },
  "20899": {
    DMA: 511,
  },
  "20901": {
    DMA: 511,
  },
  "20902": {
    DMA: 511,
  },
  "20903": {
    DMA: 511,
  },
  "20904": {
    DMA: 511,
  },
  "20905": {
    DMA: 511,
  },
  "20906": {
    DMA: 511,
  },
  "20907": {
    DMA: 511,
  },
  "20908": {
    DMA: 511,
  },
  "20910": {
    DMA: 511,
  },
  "20911": {
    DMA: 511,
  },
  "20912": {
    DMA: 511,
  },
  "20913": {
    DMA: 511,
  },
  "20914": {
    DMA: 511,
  },
  "20915": {
    DMA: 511,
  },
  "20916": {
    DMA: 511,
  },
  "20918": {
    DMA: 511,
  },
  "20993": {
    DMA: 511,
  },
  "20997": {
    DMA: 511,
  },
  "21001": {
    DMA: 512,
  },
  "21005": {
    DMA: 512,
  },
  "21009": {
    DMA: 512,
  },
  "21010": {
    DMA: 512,
  },
  "21012": {
    DMA: 512,
  },
  "21013": {
    DMA: 512,
  },
  "21014": {
    DMA: 512,
  },
  "21015": {
    DMA: 512,
  },
  "21017": {
    DMA: 512,
  },
  "21018": {
    DMA: 512,
  },
  "21020": {
    DMA: 512,
  },
  "21022": {
    DMA: 512,
  },
  "21023": {
    DMA: 512,
  },
  "21027": {
    DMA: 512,
  },
  "21028": {
    DMA: 512,
  },
  "21029": {
    DMA: 512,
  },
  "21030": {
    DMA: 512,
  },
  "21031": {
    DMA: 512,
  },
  "21032": {
    DMA: 512,
  },
  "21034": {
    DMA: 512,
  },
  "21035": {
    DMA: 512,
  },
  "21036": {
    DMA: 512,
  },
  "21037": {
    DMA: 512,
  },
  "21040": {
    DMA: 512,
  },
  "21041": {
    DMA: 512,
  },
  "21042": {
    DMA: 512,
  },
  "21043": {
    DMA: 512,
  },
  "21044": {
    DMA: 512,
  },
  "21045": {
    DMA: 512,
  },
  "21046": {
    DMA: 512,
  },
  "21047": {
    DMA: 512,
  },
  "21048": {
    DMA: 512,
  },
  "21050": {
    DMA: 512,
  },
  "21051": {
    DMA: 512,
  },
  "21052": {
    DMA: 512,
  },
  "21053": {
    DMA: 512,
  },
  "21054": {
    DMA: 512,
  },
  "21056": {
    DMA: 512,
  },
  "21057": {
    DMA: 512,
  },
  "21060": {
    DMA: 512,
  },
  "21061": {
    DMA: 512,
  },
  "21062": {
    DMA: 512,
  },
  "21065": {
    DMA: 512,
  },
  "21071": {
    DMA: 512,
  },
  "21074": {
    DMA: 512,
  },
  "21075": {
    DMA: 512,
  },
  "21076": {
    DMA: 512,
  },
  "21077": {
    DMA: 512,
  },
  "21078": {
    DMA: 512,
  },
  "21082": {
    DMA: 512,
  },
  "21084": {
    DMA: 512,
  },
  "21085": {
    DMA: 512,
  },
  "21087": {
    DMA: 512,
  },
  "21088": {
    DMA: 512,
  },
  "21090": {
    DMA: 512,
  },
  "21092": {
    DMA: 512,
  },
  "21093": {
    DMA: 512,
  },
  "21094": {
    DMA: 512,
  },
  "21098": {
    DMA: 512,
  },
  "21102": {
    DMA: 512,
  },
  "21104": {
    DMA: 512,
  },
  "21105": {
    DMA: 512,
  },
  "21106": {
    DMA: 512,
  },
  "21108": {
    DMA: 512,
  },
  "21111": {
    DMA: 512,
  },
  "21113": {
    DMA: 512,
  },
  "21114": {
    DMA: 512,
  },
  "21117": {
    DMA: 512,
  },
  "21120": {
    DMA: 512,
  },
  "21122": {
    DMA: 512,
  },
  "21123": {
    DMA: 512,
  },
  "21128": {
    DMA: 512,
  },
  "21130": {
    DMA: 512,
  },
  "21131": {
    DMA: 512,
  },
  "21132": {
    DMA: 512,
  },
  "21133": {
    DMA: 512,
  },
  "21136": {
    DMA: 512,
  },
  "21139": {
    DMA: 512,
  },
  "21140": {
    DMA: 512,
  },
  "21144": {
    DMA: 512,
  },
  "21146": {
    DMA: 512,
  },
  "21150": {
    DMA: 512,
  },
  "21152": {
    DMA: 512,
  },
  "21153": {
    DMA: 512,
  },
  "21154": {
    DMA: 512,
  },
  "21155": {
    DMA: 512,
  },
  "21156": {
    DMA: 512,
  },
  "21157": {
    DMA: 512,
  },
  "21158": {
    DMA: 512,
  },
  "21160": {
    DMA: 512,
  },
  "21161": {
    DMA: 512,
  },
  "21162": {
    DMA: 512,
  },
  "21163": {
    DMA: 512,
  },
  "21201": {
    DMA: 512,
  },
  "21202": {
    DMA: 512,
  },
  "21203": {
    DMA: 512,
  },
  "21204": {
    DMA: 512,
  },
  "21205": {
    DMA: 512,
  },
  "21206": {
    DMA: 512,
  },
  "21207": {
    DMA: 512,
  },
  "21208": {
    DMA: 512,
  },
  "21209": {
    DMA: 512,
  },
  "21210": {
    DMA: 512,
  },
  "21211": {
    DMA: 512,
  },
  "21212": {
    DMA: 512,
  },
  "21213": {
    DMA: 512,
  },
  "21214": {
    DMA: 512,
  },
  "21215": {
    DMA: 512,
  },
  "21216": {
    DMA: 512,
  },
  "21217": {
    DMA: 512,
  },
  "21218": {
    DMA: 512,
  },
  "21219": {
    DMA: 512,
  },
  "21220": {
    DMA: 512,
  },
  "21221": {
    DMA: 512,
  },
  "21222": {
    DMA: 512,
  },
  "21223": {
    DMA: 512,
  },
  "21224": {
    DMA: 512,
  },
  "21225": {
    DMA: 512,
  },
  "21226": {
    DMA: 512,
  },
  "21227": {
    DMA: 512,
  },
  "21228": {
    DMA: 512,
  },
  "21229": {
    DMA: 512,
  },
  "21230": {
    DMA: 512,
  },
  "21231": {
    DMA: 512,
  },
  "21233": {
    DMA: 512,
  },
  "21234": {
    DMA: 512,
  },
  "21235": {
    DMA: 512,
  },
  "21236": {
    DMA: 512,
  },
  "21237": {
    DMA: 512,
  },
  "21239": {
    DMA: 512,
  },
  "21240": {
    DMA: 512,
  },
  "21241": {
    DMA: 512,
  },
  "21244": {
    DMA: 512,
  },
  "21250": {
    DMA: 512,
  },
  "21251": {
    DMA: 512,
  },
  "21252": {
    DMA: 512,
  },
  "21260": {
    DMA: 512,
  },
  "21261": {
    DMA: 512,
  },
  "21263": {
    DMA: 512,
  },
  "21264": {
    DMA: 512,
  },
  "21265": {
    DMA: 512,
  },
  "21268": {
    DMA: 512,
  },
  "21270": {
    DMA: 512,
  },
  "21273": {
    DMA: 512,
  },
  "21274": {
    DMA: 512,
  },
  "21275": {
    DMA: 512,
  },
  "21278": {
    DMA: 512,
  },
  "21279": {
    DMA: 512,
  },
  "21280": {
    DMA: 512,
  },
  "21281": {
    DMA: 512,
  },
  "21282": {
    DMA: 512,
  },
  "21283": {
    DMA: 512,
  },
  "21284": {
    DMA: 512,
  },
  "21285": {
    DMA: 512,
  },
  "21286": {
    DMA: 512,
  },
  "21287": {
    DMA: 512,
  },
  "21288": {
    DMA: 512,
  },
  "21289": {
    DMA: 512,
  },
  "21290": {
    DMA: 512,
  },
  "21297": {
    DMA: 512,
  },
  "21298": {
    DMA: 512,
  },
  "21401": {
    DMA: 512,
  },
  "21402": {
    DMA: 512,
  },
  "21403": {
    DMA: 512,
  },
  "21404": {
    DMA: 512,
  },
  "21405": {
    DMA: 512,
  },
  "21409": {
    DMA: 512,
  },
  "21411": {
    DMA: 512,
  },
  "21412": {
    DMA: 512,
  },
  "21501": {
    DMA: 511,
  },
  "21502": {
    DMA: 511,
  },
  "21503": {
    DMA: 511,
  },
  "21504": {
    DMA: 511,
  },
  "21505": {
    DMA: 511,
  },
  "21520": {
    DMA: 508,
  },
  "21521": {
    DMA: 511,
  },
  "21522": {
    DMA: 508,
  },
  "21523": {
    DMA: 508,
  },
  "21524": {
    DMA: 511,
  },
  "21528": {
    DMA: 511,
  },
  "21529": {
    DMA: 511,
  },
  "21530": {
    DMA: 511,
  },
  "21531": {
    DMA: 508,
  },
  "21532": {
    DMA: 511,
  },
  "21536": {
    DMA: 508,
  },
  "21538": {
    DMA: 508,
  },
  "21539": {
    DMA: 511,
  },
  "21540": {
    DMA: 511,
  },
  "21541": {
    DMA: 508,
  },
  "21542": {
    DMA: 511,
  },
  "21543": {
    DMA: 511,
  },
  "21545": {
    DMA: 511,
  },
  "21550": {
    DMA: 508,
  },
  "21555": {
    DMA: 511,
  },
  "21556": {
    DMA: 511,
  },
  "21557": {
    DMA: 511,
  },
  "21560": {
    DMA: 511,
  },
  "21561": {
    DMA: 508,
  },
  "21562": {
    DMA: 511,
  },
  "21601": {
    DMA: 512,
  },
  "21606": {
    DMA: 512,
  },
  "21607": {
    DMA: 512,
  },
  "21609": {
    DMA: 512,
  },
  "21610": {
    DMA: 512,
  },
  "21612": {
    DMA: 512,
  },
  "21613": {
    DMA: 576,
  },
  "21617": {
    DMA: 512,
  },
  "21619": {
    DMA: 512,
  },
  "21620": {
    DMA: 512,
  },
  "21622": {
    DMA: 576,
  },
  "21623": {
    DMA: 512,
  },
  "21624": {
    DMA: 512,
  },
  "21625": {
    DMA: 512,
  },
  "21626": {
    DMA: 576,
  },
  "21627": {
    DMA: 576,
  },
  "21628": {
    DMA: 512,
  },
  "21629": {
    DMA: 512,
  },
  "21631": {
    DMA: 576,
  },
  "21632": {
    DMA: 512,
  },
  "21634": {
    DMA: 576,
  },
  "21635": {
    DMA: 512,
  },
  "21636": {
    DMA: 512,
  },
  "21638": {
    DMA: 512,
  },
  "21639": {
    DMA: 512,
  },
  "21640": {
    DMA: 512,
  },
  "21641": {
    DMA: 512,
  },
  "21643": {
    DMA: 576,
  },
  "21644": {
    DMA: 512,
  },
  "21645": {
    DMA: 512,
  },
  "21647": {
    DMA: 512,
  },
  "21648": {
    DMA: 576,
  },
  "21649": {
    DMA: 512,
  },
  "21650": {
    DMA: 512,
  },
  "21651": {
    DMA: 512,
  },
  "21652": {
    DMA: 512,
  },
  "21653": {
    DMA: 512,
  },
  "21654": {
    DMA: 512,
  },
  "21655": {
    DMA: 512,
  },
  "21656": {
    DMA: 512,
  },
  "21657": {
    DMA: 512,
  },
  "21658": {
    DMA: 512,
  },
  "21659": {
    DMA: 576,
  },
  "21660": {
    DMA: 512,
  },
  "21661": {
    DMA: 512,
  },
  "21662": {
    DMA: 512,
  },
  "21663": {
    DMA: 512,
  },
  "21664": {
    DMA: 576,
  },
  "21665": {
    DMA: 512,
  },
  "21666": {
    DMA: 512,
  },
  "21667": {
    DMA: 512,
  },
  "21668": {
    DMA: 512,
  },
  "21669": {
    DMA: 576,
  },
  "21670": {
    DMA: 512,
  },
  "21671": {
    DMA: 512,
  },
  "21672": {
    DMA: 576,
  },
  "21673": {
    DMA: 512,
  },
  "21675": {
    DMA: 576,
  },
  "21676": {
    DMA: 512,
  },
  "21677": {
    DMA: 576,
  },
  "21678": {
    DMA: 512,
  },
  "21679": {
    DMA: 512,
  },
  "21681": {
    DMA: 512,
  },
  "21682": {
    DMA: 512,
  },
  "21683": {
    DMA: 512,
  },
  "21684": {
    DMA: 512,
  },
  "21685": {
    DMA: 512,
  },
  "21686": {
    DMA: 512,
  },
  "21687": {
    DMA: 512,
  },
  "21688": {
    DMA: 512,
  },
  "21690": {
    DMA: 512,
  },
  "21701": {
    DMA: 511,
  },
  "21702": {
    DMA: 511,
  },
  "21703": {
    DMA: 511,
  },
  "21704": {
    DMA: 511,
  },
  "21705": {
    DMA: 511,
  },
  "21709": {
    DMA: 511,
  },
  "21710": {
    DMA: 511,
  },
  "21711": {
    DMA: 511,
  },
  "21713": {
    DMA: 511,
  },
  "21714": {
    DMA: 511,
  },
  "21715": {
    DMA: 511,
  },
  "21716": {
    DMA: 511,
  },
  "21717": {
    DMA: 511,
  },
  "21718": {
    DMA: 511,
  },
  "21719": {
    DMA: 511,
  },
  "21720": {
    DMA: 511,
  },
  "21721": {
    DMA: 511,
  },
  "21722": {
    DMA: 511,
  },
  "21723": {
    DMA: 512,
  },
  "21727": {
    DMA: 511,
  },
  "21733": {
    DMA: 511,
  },
  "21734": {
    DMA: 511,
  },
  "21737": {
    DMA: 512,
  },
  "21738": {
    DMA: 512,
  },
  "21740": {
    DMA: 511,
  },
  "21741": {
    DMA: 511,
  },
  "21742": {
    DMA: 511,
  },
  "21746": {
    DMA: 511,
  },
  "21747": {
    DMA: 511,
  },
  "21748": {
    DMA: 511,
  },
  "21749": {
    DMA: 511,
  },
  "21750": {
    DMA: 511,
  },
  "21754": {
    DMA: 511,
  },
  "21755": {
    DMA: 511,
  },
  "21756": {
    DMA: 511,
  },
  "21757": {
    DMA: 512,
  },
  "21758": {
    DMA: 511,
  },
  "21759": {
    DMA: 511,
  },
  "21762": {
    DMA: 511,
  },
  "21765": {
    DMA: 512,
  },
  "21766": {
    DMA: 511,
  },
  "21767": {
    DMA: 511,
  },
  "21769": {
    DMA: 511,
  },
  "21770": {
    DMA: 511,
  },
  "21771": {
    DMA: 511,
  },
  "21773": {
    DMA: 511,
  },
  "21774": {
    DMA: 511,
  },
  "21775": {
    DMA: 511,
  },
  "21776": {
    DMA: 512,
  },
  "21777": {
    DMA: 511,
  },
  "21778": {
    DMA: 511,
  },
  "21779": {
    DMA: 511,
  },
  "21780": {
    DMA: 511,
  },
  "21781": {
    DMA: 511,
  },
  "21782": {
    DMA: 511,
  },
  "21783": {
    DMA: 511,
  },
  "21784": {
    DMA: 512,
  },
  "21787": {
    DMA: 512,
  },
  "21788": {
    DMA: 511,
  },
  "21790": {
    DMA: 511,
  },
  "21791": {
    DMA: 512,
  },
  "21792": {
    DMA: 511,
  },
  "21793": {
    DMA: 511,
  },
  "21794": {
    DMA: 512,
  },
  "21795": {
    DMA: 511,
  },
  "21797": {
    DMA: 512,
  },
  "21798": {
    DMA: 511,
  },
  "21801": {
    DMA: 576,
  },
  "21802": {
    DMA: 576,
  },
  "21803": {
    DMA: 576,
  },
  "21804": {
    DMA: 576,
  },
  "21810": {
    DMA: 576,
  },
  "21811": {
    DMA: 576,
  },
  "21813": {
    DMA: 576,
  },
  "21814": {
    DMA: 576,
  },
  "21817": {
    DMA: 576,
  },
  "21821": {
    DMA: 576,
  },
  "21822": {
    DMA: 576,
  },
  "21824": {
    DMA: 576,
  },
  "21826": {
    DMA: 576,
  },
  "21829": {
    DMA: 576,
  },
  "21830": {
    DMA: 576,
  },
  "21835": {
    DMA: 576,
  },
  "21836": {
    DMA: 576,
  },
  "21837": {
    DMA: 576,
  },
  "21838": {
    DMA: 576,
  },
  "21840": {
    DMA: 576,
  },
  "21841": {
    DMA: 576,
  },
  "21842": {
    DMA: 576,
  },
  "21843": {
    DMA: 576,
  },
  "21849": {
    DMA: 576,
  },
  "21850": {
    DMA: 576,
  },
  "21851": {
    DMA: 576,
  },
  "21852": {
    DMA: 576,
  },
  "21853": {
    DMA: 576,
  },
  "21856": {
    DMA: 576,
  },
  "21857": {
    DMA: 576,
  },
  "21861": {
    DMA: 576,
  },
  "21862": {
    DMA: 576,
  },
  "21863": {
    DMA: 576,
  },
  "21864": {
    DMA: 576,
  },
  "21865": {
    DMA: 576,
  },
  "21866": {
    DMA: 576,
  },
  "21867": {
    DMA: 576,
  },
  "21869": {
    DMA: 576,
  },
  "21871": {
    DMA: 576,
  },
  "21872": {
    DMA: 576,
  },
  "21874": {
    DMA: 576,
  },
  "21875": {
    DMA: 576,
  },
  "21890": {
    DMA: 576,
  },
  "21901": {
    DMA: 512,
  },
  "21902": {
    DMA: 512,
  },
  "21903": {
    DMA: 512,
  },
  "21904": {
    DMA: 512,
  },
  "21911": {
    DMA: 512,
  },
  "21912": {
    DMA: 512,
  },
  "21913": {
    DMA: 512,
  },
  "21914": {
    DMA: 512,
  },
  "21915": {
    DMA: 512,
  },
  "21916": {
    DMA: 512,
  },
  "21917": {
    DMA: 512,
  },
  "21918": {
    DMA: 512,
  },
  "21919": {
    DMA: 512,
  },
  "21920": {
    DMA: 512,
  },
  "21921": {
    DMA: 512,
  },
  "21922": {
    DMA: 512,
  },
  "21930": {
    DMA: 512,
  },
  "22003": {
    DMA: 511,
  },
  "22009": {
    DMA: 511,
  },
  "22015": {
    DMA: 511,
  },
  "22025": {
    DMA: 511,
  },
  "22026": {
    DMA: 511,
  },
  "22027": {
    DMA: 511,
  },
  "22030": {
    DMA: 511,
  },
  "22031": {
    DMA: 511,
  },
  "22032": {
    DMA: 511,
  },
  "22033": {
    DMA: 511,
  },
  "22034": {
    DMA: 511,
  },
  "22035": {
    DMA: 511,
  },
  "22036": {
    DMA: 511,
  },
  "22037": {
    DMA: 511,
  },
  "22038": {
    DMA: 511,
  },
  "22039": {
    DMA: 511,
  },
  "22040": {
    DMA: 511,
  },
  "22041": {
    DMA: 511,
  },
  "22042": {
    DMA: 511,
  },
  "22043": {
    DMA: 511,
  },
  "22044": {
    DMA: 511,
  },
  "22046": {
    DMA: 511,
  },
  "22047": {
    DMA: 511,
  },
  "22060": {
    DMA: 511,
  },
  "22066": {
    DMA: 511,
  },
  "22067": {
    DMA: 511,
  },
  "22079": {
    DMA: 511,
  },
  "22081": {
    DMA: 511,
  },
  "22082": {
    DMA: 511,
  },
  "22092": {
    DMA: 511,
  },
  "22093": {
    DMA: 511,
  },
  "22095": {
    DMA: 511,
  },
  "22096": {
    DMA: 511,
  },
  "22101": {
    DMA: 511,
  },
  "22102": {
    DMA: 511,
  },
  "22103": {
    DMA: 511,
  },
  "22106": {
    DMA: 511,
  },
  "22107": {
    DMA: 511,
  },
  "22108": {
    DMA: 511,
  },
  "22109": {
    DMA: 511,
  },
  "22116": {
    DMA: 511,
  },
  "22118": {
    DMA: 511,
  },
  "22119": {
    DMA: 511,
  },
  "22120": {
    DMA: 511,
  },
  "22121": {
    DMA: 511,
  },
  "22122": {
    DMA: 511,
  },
  "22124": {
    DMA: 511,
  },
  "22125": {
    DMA: 511,
  },
  "22134": {
    DMA: 511,
  },
  "22135": {
    DMA: 511,
  },
  "22150": {
    DMA: 511,
  },
  "22151": {
    DMA: 511,
  },
  "22152": {
    DMA: 511,
  },
  "22153": {
    DMA: 511,
  },
  "22156": {
    DMA: 511,
  },
  "22158": {
    DMA: 511,
  },
  "22159": {
    DMA: 511,
  },
  "22160": {
    DMA: 511,
  },
  "22161": {
    DMA: 511,
  },
  "22172": {
    DMA: 511,
  },
  "22180": {
    DMA: 511,
  },
  "22181": {
    DMA: 511,
  },
  "22182": {
    DMA: 511,
  },
  "22183": {
    DMA: 511,
  },
  "22184": {
    DMA: 511,
  },
  "22185": {
    DMA: 511,
  },
  "22191": {
    DMA: 511,
  },
  "22192": {
    DMA: 511,
  },
  "22193": {
    DMA: 511,
  },
  "22194": {
    DMA: 511,
  },
  "22195": {
    DMA: 511,
  },
  "22199": {
    DMA: 511,
  },
  "22201": {
    DMA: 511,
  },
  "22202": {
    DMA: 511,
  },
  "22203": {
    DMA: 511,
  },
  "22204": {
    DMA: 511,
  },
  "22205": {
    DMA: 511,
  },
  "22206": {
    DMA: 511,
  },
  "22207": {
    DMA: 511,
  },
  "22209": {
    DMA: 511,
  },
  "22210": {
    DMA: 511,
  },
  "22211": {
    DMA: 511,
  },
  "22212": {
    DMA: 511,
  },
  "22213": {
    DMA: 511,
  },
  "22214": {
    DMA: 511,
  },
  "22215": {
    DMA: 511,
  },
  "22216": {
    DMA: 511,
  },
  "22217": {
    DMA: 511,
  },
  "22218": {
    DMA: 511,
  },
  "22219": {
    DMA: 511,
  },
  "22222": {
    DMA: 511,
  },
  "22223": {
    DMA: 511,
  },
  "22225": {
    DMA: 511,
  },
  "22226": {
    DMA: 511,
  },
  "22227": {
    DMA: 511,
  },
  "22229": {
    DMA: 511,
  },
  "22230": {
    DMA: 511,
  },
  "22234": {
    DMA: 511,
  },
  "22240": {
    DMA: 511,
  },
  "22241": {
    DMA: 511,
  },
  "22242": {
    DMA: 511,
  },
  "22243": {
    DMA: 511,
  },
  "22244": {
    DMA: 511,
  },
  "22245": {
    DMA: 511,
  },
  "22246": {
    DMA: 511,
  },
  "22301": {
    DMA: 511,
  },
  "22302": {
    DMA: 511,
  },
  "22303": {
    DMA: 511,
  },
  "22304": {
    DMA: 511,
  },
  "22305": {
    DMA: 511,
  },
  "22306": {
    DMA: 511,
  },
  "22307": {
    DMA: 511,
  },
  "22308": {
    DMA: 511,
  },
  "22309": {
    DMA: 511,
  },
  "22310": {
    DMA: 511,
  },
  "22311": {
    DMA: 511,
  },
  "22312": {
    DMA: 511,
  },
  "22313": {
    DMA: 511,
  },
  "22314": {
    DMA: 511,
  },
  "22315": {
    DMA: 511,
  },
  "22320": {
    DMA: 511,
  },
  "22321": {
    DMA: 511,
  },
  "22331": {
    DMA: 511,
  },
  "22332": {
    DMA: 511,
  },
  "22333": {
    DMA: 511,
  },
  "22334": {
    DMA: 511,
  },
  "22336": {
    DMA: 511,
  },
  "22350": {
    DMA: 511,
  },
  "22401": {
    DMA: 511,
  },
  "22402": {
    DMA: 511,
  },
  "22403": {
    DMA: 511,
  },
  "22404": {
    DMA: 511,
  },
  "22405": {
    DMA: 511,
  },
  "22406": {
    DMA: 511,
  },
  "22407": {
    DMA: 511,
  },
  "22408": {
    DMA: 511,
  },
  "22412": {
    DMA: 511,
  },
  "22427": {
    DMA: 556,
  },
  "22428": {
    DMA: 556,
  },
  "22430": {
    DMA: 511,
  },
  "22432": {
    DMA: 556,
  },
  "22433": {
    DMA: 584,
  },
  "22435": {
    DMA: 556,
  },
  "22436": {
    DMA: 556,
  },
  "22437": {
    DMA: 556,
  },
  "22438": {
    DMA: 556,
  },
  "22442": {
    DMA: 511,
  },
  "22443": {
    DMA: 511,
  },
  "22446": {
    DMA: 556,
  },
  "22448": {
    DMA: 511,
  },
  "22451": {
    DMA: 511,
  },
  "22454": {
    DMA: 556,
  },
  "22456": {
    DMA: 556,
  },
  "22460": {
    DMA: 556,
  },
  "22463": {
    DMA: 511,
  },
  "22469": {
    DMA: 511,
  },
  "22471": {
    DMA: 511,
  },
  "22472": {
    DMA: 556,
  },
  "22473": {
    DMA: 556,
  },
  "22476": {
    DMA: 556,
  },
  "22480": {
    DMA: 556,
  },
  "22481": {
    DMA: 511,
  },
  "22482": {
    DMA: 556,
  },
  "22485": {
    DMA: 511,
  },
  "22488": {
    DMA: 511,
  },
  "22501": {
    DMA: 556,
  },
  "22503": {
    DMA: 556,
  },
  "22504": {
    DMA: 556,
  },
  "22507": {
    DMA: 556,
  },
  "22508": {
    DMA: 584,
  },
  "22509": {
    DMA: 556,
  },
  "22511": {
    DMA: 556,
  },
  "22513": {
    DMA: 556,
  },
  "22514": {
    DMA: 556,
  },
  "22517": {
    DMA: 556,
  },
  "22520": {
    DMA: 511,
  },
  "22523": {
    DMA: 556,
  },
  "22524": {
    DMA: 511,
  },
  "22526": {
    DMA: 511,
  },
  "22528": {
    DMA: 556,
  },
  "22529": {
    DMA: 511,
  },
  "22530": {
    DMA: 556,
  },
  "22534": {
    DMA: 511,
  },
  "22535": {
    DMA: 556,
  },
  "22538": {
    DMA: 556,
  },
  "22539": {
    DMA: 556,
  },
  "22542": {
    DMA: 584,
  },
  "22544": {
    DMA: 511,
  },
  "22545": {
    DMA: 511,
  },
  "22546": {
    DMA: 556,
  },
  "22547": {
    DMA: 511,
  },
  "22548": {
    DMA: 556,
  },
  "22551": {
    DMA: 511,
  },
  "22552": {
    DMA: 556,
  },
  "22553": {
    DMA: 511,
  },
  "22554": {
    DMA: 511,
  },
  "22555": {
    DMA: 511,
  },
  "22556": {
    DMA: 511,
  },
  "22558": {
    DMA: 511,
  },
  "22560": {
    DMA: 556,
  },
  "22565": {
    DMA: 511,
  },
  "22567": {
    DMA: 584,
  },
  "22570": {
    DMA: 556,
  },
  "22572": {
    DMA: 556,
  },
  "22576": {
    DMA: 556,
  },
  "22577": {
    DMA: 511,
  },
  "22578": {
    DMA: 556,
  },
  "22579": {
    DMA: 556,
  },
  "22580": {
    DMA: 556,
  },
  "22581": {
    DMA: 511,
  },
  "22601": {
    DMA: 511,
  },
  "22602": {
    DMA: 511,
  },
  "22603": {
    DMA: 511,
  },
  "22604": {
    DMA: 511,
  },
  "22610": {
    DMA: 511,
  },
  "22611": {
    DMA: 511,
  },
  "22620": {
    DMA: 511,
  },
  "22622": {
    DMA: 511,
  },
  "22623": {
    DMA: 511,
  },
  "22624": {
    DMA: 511,
  },
  "22625": {
    DMA: 511,
  },
  "22626": {
    DMA: 511,
  },
  "22627": {
    DMA: 511,
  },
  "22630": {
    DMA: 511,
  },
  "22637": {
    DMA: 511,
  },
  "22639": {
    DMA: 511,
  },
  "22640": {
    DMA: 511,
  },
  "22641": {
    DMA: 511,
  },
  "22642": {
    DMA: 511,
  },
  "22643": {
    DMA: 511,
  },
  "22644": {
    DMA: 511,
  },
  "22645": {
    DMA: 511,
  },
  "22646": {
    DMA: 511,
  },
  "22649": {
    DMA: 511,
  },
  "22650": {
    DMA: 511,
  },
  "22652": {
    DMA: 511,
  },
  "22654": {
    DMA: 511,
  },
  "22655": {
    DMA: 511,
  },
  "22656": {
    DMA: 511,
  },
  "22657": {
    DMA: 511,
  },
  "22660": {
    DMA: 511,
  },
  "22663": {
    DMA: 511,
  },
  "22664": {
    DMA: 511,
  },
  "22701": {
    DMA: 511,
  },
  "22709": {
    DMA: 584,
  },
  "22711": {
    DMA: 584,
  },
  "22712": {
    DMA: 511,
  },
  "22713": {
    DMA: 511,
  },
  "22714": {
    DMA: 511,
  },
  "22715": {
    DMA: 584,
  },
  "22716": {
    DMA: 511,
  },
  "22718": {
    DMA: 511,
  },
  "22719": {
    DMA: 584,
  },
  "22720": {
    DMA: 511,
  },
  "22721": {
    DMA: 584,
  },
  "22722": {
    DMA: 584,
  },
  "22723": {
    DMA: 584,
  },
  "22724": {
    DMA: 511,
  },
  "22725": {
    DMA: 584,
  },
  "22726": {
    DMA: 511,
  },
  "22727": {
    DMA: 584,
  },
  "22728": {
    DMA: 511,
  },
  "22729": {
    DMA: 511,
  },
  "22730": {
    DMA: 584,
  },
  "22731": {
    DMA: 584,
  },
  "22732": {
    DMA: 584,
  },
  "22733": {
    DMA: 511,
  },
  "22734": {
    DMA: 511,
  },
  "22735": {
    DMA: 584,
  },
  "22736": {
    DMA: 511,
  },
  "22737": {
    DMA: 511,
  },
  "22738": {
    DMA: 584,
  },
  "22739": {
    DMA: 511,
  },
  "22740": {
    DMA: 511,
  },
  "22741": {
    DMA: 511,
  },
  "22742": {
    DMA: 511,
  },
  "22743": {
    DMA: 584,
  },
  "22746": {
    DMA: 511,
  },
  "22747": {
    DMA: 511,
  },
  "22748": {
    DMA: 584,
  },
  "22749": {
    DMA: 511,
  },
  "22801": {
    DMA: 569,
  },
  "22802": {
    DMA: 569,
  },
  "22803": {
    DMA: 569,
  },
  "22807": {
    DMA: 569,
  },
  "22810": {
    DMA: 511,
  },
  "22811": {
    DMA: 569,
  },
  "22812": {
    DMA: 569,
  },
  "22815": {
    DMA: 569,
  },
  "22820": {
    DMA: 569,
  },
  "22821": {
    DMA: 569,
  },
  "22824": {
    DMA: 511,
  },
  "22827": {
    DMA: 569,
  },
  "22830": {
    DMA: 569,
  },
  "22831": {
    DMA: 569,
  },
  "22832": {
    DMA: 569,
  },
  "22833": {
    DMA: 569,
  },
  "22834": {
    DMA: 569,
  },
  "22835": {
    DMA: 511,
  },
  "22840": {
    DMA: 569,
  },
  "22841": {
    DMA: 569,
  },
  "22842": {
    DMA: 511,
  },
  "22843": {
    DMA: 569,
  },
  "22844": {
    DMA: 511,
  },
  "22845": {
    DMA: 511,
  },
  "22846": {
    DMA: 569,
  },
  "22847": {
    DMA: 511,
  },
  "22848": {
    DMA: 569,
  },
  "22849": {
    DMA: 511,
  },
  "22850": {
    DMA: 569,
  },
  "22851": {
    DMA: 511,
  },
  "22853": {
    DMA: 569,
  },
  "22901": {
    DMA: 584,
  },
  "22902": {
    DMA: 584,
  },
  "22903": {
    DMA: 584,
  },
  "22904": {
    DMA: 584,
  },
  "22905": {
    DMA: 584,
  },
  "22906": {
    DMA: 584,
  },
  "22907": {
    DMA: 584,
  },
  "22908": {
    DMA: 584,
  },
  "22909": {
    DMA: 584,
  },
  "22910": {
    DMA: 584,
  },
  "22911": {
    DMA: 584,
  },
  "22920": {
    DMA: 573,
  },
  "22922": {
    DMA: 573,
  },
  "22923": {
    DMA: 584,
  },
  "22924": {
    DMA: 584,
  },
  "22931": {
    DMA: 584,
  },
  "22932": {
    DMA: 584,
  },
  "22935": {
    DMA: 584,
  },
  "22936": {
    DMA: 584,
  },
  "22937": {
    DMA: 584,
  },
  "22938": {
    DMA: 573,
  },
  "22939": {
    DMA: 569,
  },
  "22940": {
    DMA: 584,
  },
  "22942": {
    DMA: 584,
  },
  "22943": {
    DMA: 584,
  },
  "22945": {
    DMA: 584,
  },
  "22946": {
    DMA: 584,
  },
  "22947": {
    DMA: 584,
  },
  "22948": {
    DMA: 584,
  },
  "22949": {
    DMA: 573,
  },
  "22952": {
    DMA: 569,
  },
  "22957": {
    DMA: 584,
  },
  "22958": {
    DMA: 573,
  },
  "22959": {
    DMA: 584,
  },
  "22960": {
    DMA: 584,
  },
  "22963": {
    DMA: 584,
  },
  "22964": {
    DMA: 573,
  },
  "22965": {
    DMA: 584,
  },
  "22967": {
    DMA: 573,
  },
  "22968": {
    DMA: 584,
  },
  "22969": {
    DMA: 573,
  },
  "22971": {
    DMA: 573,
  },
  "22972": {
    DMA: 584,
  },
  "22973": {
    DMA: 584,
  },
  "22974": {
    DMA: 584,
  },
  "22976": {
    DMA: 573,
  },
  "22980": {
    DMA: 569,
  },
  "22987": {
    DMA: 584,
  },
  "22989": {
    DMA: 584,
  },
  "23001": {
    DMA: 544,
  },
  "23002": {
    DMA: 556,
  },
  "23003": {
    DMA: 544,
  },
  "23004": {
    DMA: 556,
  },
  "23005": {
    DMA: 556,
  },
  "23009": {
    DMA: 556,
  },
  "23011": {
    DMA: 556,
  },
  "23014": {
    DMA: 556,
  },
  "23015": {
    DMA: 556,
  },
  "23018": {
    DMA: 544,
  },
  "23021": {
    DMA: 544,
  },
  "23022": {
    DMA: 584,
  },
  "23023": {
    DMA: 556,
  },
  "23024": {
    DMA: 556,
  },
  "23025": {
    DMA: 544,
  },
  "23027": {
    DMA: 556,
  },
  "23030": {
    DMA: 556,
  },
  "23031": {
    DMA: 556,
  },
  "23032": {
    DMA: 556,
  },
  "23035": {
    DMA: 544,
  },
  "23038": {
    DMA: 556,
  },
  "23039": {
    DMA: 556,
  },
  "23040": {
    DMA: 556,
  },
  "23043": {
    DMA: 556,
  },
  "23045": {
    DMA: 544,
  },
  "23047": {
    DMA: 556,
  },
  "23050": {
    DMA: 544,
  },
  "23055": {
    DMA: 584,
  },
  "23056": {
    DMA: 544,
  },
  "23058": {
    DMA: 556,
  },
  "23059": {
    DMA: 556,
  },
  "23060": {
    DMA: 556,
  },
  "23061": {
    DMA: 544,
  },
  "23062": {
    DMA: 544,
  },
  "23063": {
    DMA: 556,
  },
  "23064": {
    DMA: 544,
  },
  "23065": {
    DMA: 556,
  },
  "23066": {
    DMA: 544,
  },
  "23067": {
    DMA: 556,
  },
  "23068": {
    DMA: 544,
  },
  "23069": {
    DMA: 556,
  },
  "23070": {
    DMA: 556,
  },
  "23071": {
    DMA: 556,
  },
  "23072": {
    DMA: 544,
  },
  "23075": {
    DMA: 556,
  },
  "23076": {
    DMA: 544,
  },
  "23079": {
    DMA: 556,
  },
  "23081": {
    DMA: 544,
  },
  "23083": {
    DMA: 556,
  },
  "23084": {
    DMA: 584,
  },
  "23085": {
    DMA: 556,
  },
  "23086": {
    DMA: 556,
  },
  "23089": {
    DMA: 556,
  },
  "23090": {
    DMA: 544,
  },
  "23091": {
    DMA: 556,
  },
  "23092": {
    DMA: 556,
  },
  "23093": {
    DMA: 556,
  },
  "23101": {
    DMA: 556,
  },
  "23102": {
    DMA: 556,
  },
  "23103": {
    DMA: 556,
  },
  "23105": {
    DMA: 556,
  },
  "23106": {
    DMA: 556,
  },
  "23107": {
    DMA: 544,
  },
  "23108": {
    DMA: 556,
  },
  "23109": {
    DMA: 544,
  },
  "23110": {
    DMA: 556,
  },
  "23111": {
    DMA: 556,
  },
  "23112": {
    DMA: 556,
  },
  "23113": {
    DMA: 556,
  },
  "23114": {
    DMA: 556,
  },
  "23115": {
    DMA: 556,
  },
  "23116": {
    DMA: 556,
  },
  "23117": {
    DMA: 556,
  },
  "23119": {
    DMA: 544,
  },
  "23120": {
    DMA: 556,
  },
  "23123": {
    DMA: 556,
  },
  "23124": {
    DMA: 556,
  },
  "23125": {
    DMA: 544,
  },
  "23126": {
    DMA: 556,
  },
  "23127": {
    DMA: 544,
  },
  "23128": {
    DMA: 544,
  },
  "23129": {
    DMA: 556,
  },
  "23130": {
    DMA: 544,
  },
  "23131": {
    DMA: 544,
  },
  "23138": {
    DMA: 544,
  },
  "23139": {
    DMA: 556,
  },
  "23140": {
    DMA: 556,
  },
  "23141": {
    DMA: 556,
  },
  "23146": {
    DMA: 556,
  },
  "23147": {
    DMA: 556,
  },
  "23148": {
    DMA: 556,
  },
  "23149": {
    DMA: 556,
  },
  "23150": {
    DMA: 556,
  },
  "23153": {
    DMA: 556,
  },
  "23154": {
    DMA: 544,
  },
  "23155": {
    DMA: 544,
  },
  "23156": {
    DMA: 556,
  },
  "23160": {
    DMA: 556,
  },
  "23161": {
    DMA: 556,
  },
  "23162": {
    DMA: 556,
  },
  "23163": {
    DMA: 544,
  },
  "23168": {
    DMA: 544,
  },
  "23169": {
    DMA: 556,
  },
  "23170": {
    DMA: 556,
  },
  "23173": {
    DMA: 556,
  },
  "23175": {
    DMA: 556,
  },
  "23176": {
    DMA: 556,
  },
  "23177": {
    DMA: 556,
  },
  "23178": {
    DMA: 544,
  },
  "23180": {
    DMA: 556,
  },
  "23181": {
    DMA: 556,
  },
  "23183": {
    DMA: 544,
  },
  "23184": {
    DMA: 544,
  },
  "23185": {
    DMA: 544,
  },
  "23186": {
    DMA: 544,
  },
  "23187": {
    DMA: 544,
  },
  "23188": {
    DMA: 544,
  },
  "23190": {
    DMA: 544,
  },
  "23192": {
    DMA: 556,
  },
  "23218": {
    DMA: 556,
  },
  "23219": {
    DMA: 556,
  },
  "23220": {
    DMA: 556,
  },
  "23221": {
    DMA: 556,
  },
  "23222": {
    DMA: 556,
  },
  "23223": {
    DMA: 556,
  },
  "23224": {
    DMA: 556,
  },
  "23225": {
    DMA: 556,
  },
  "23226": {
    DMA: 556,
  },
  "23227": {
    DMA: 556,
  },
  "23228": {
    DMA: 556,
  },
  "23229": {
    DMA: 556,
  },
  "23230": {
    DMA: 556,
  },
  "23231": {
    DMA: 556,
  },
  "23232": {
    DMA: 556,
  },
  "23233": {
    DMA: 556,
  },
  "23234": {
    DMA: 556,
  },
  "23235": {
    DMA: 556,
  },
  "23236": {
    DMA: 556,
  },
  "23237": {
    DMA: 556,
  },
  "23238": {
    DMA: 556,
  },
  "23240": {
    DMA: 556,
  },
  "23241": {
    DMA: 556,
  },
  "23242": {
    DMA: 556,
  },
  "23249": {
    DMA: 556,
  },
  "23250": {
    DMA: 556,
  },
  "23255": {
    DMA: 556,
  },
  "23260": {
    DMA: 556,
  },
  "23261": {
    DMA: 556,
  },
  "23269": {
    DMA: 556,
  },
  "23273": {
    DMA: 556,
  },
  "23274": {
    DMA: 556,
  },
  "23276": {
    DMA: 556,
  },
  "23278": {
    DMA: 556,
  },
  "23279": {
    DMA: 556,
  },
  "23282": {
    DMA: 556,
  },
  "23284": {
    DMA: 556,
  },
  "23285": {
    DMA: 556,
  },
  "23286": {
    DMA: 556,
  },
  "23288": {
    DMA: 556,
  },
  "23289": {
    DMA: 556,
  },
  "23290": {
    DMA: 556,
  },
  "23291": {
    DMA: 556,
  },
  "23292": {
    DMA: 556,
  },
  "23293": {
    DMA: 556,
  },
  "23294": {
    DMA: 556,
  },
  "23295": {
    DMA: 556,
  },
  "23297": {
    DMA: 556,
  },
  "23298": {
    DMA: 556,
  },
  "23301": {
    DMA: 544,
  },
  "23302": {
    DMA: 544,
  },
  "23303": {
    DMA: 544,
  },
  "23304": {
    DMA: 544,
  },
  "23306": {
    DMA: 544,
  },
  "23307": {
    DMA: 544,
  },
  "23308": {
    DMA: 544,
  },
  "23310": {
    DMA: 544,
  },
  "23313": {
    DMA: 544,
  },
  "23314": {
    DMA: 544,
  },
  "23315": {
    DMA: 544,
  },
  "23316": {
    DMA: 544,
  },
  "23320": {
    DMA: 544,
  },
  "23321": {
    DMA: 544,
  },
  "23322": {
    DMA: 544,
  },
  "23323": {
    DMA: 544,
  },
  "23324": {
    DMA: 544,
  },
  "23325": {
    DMA: 544,
  },
  "23326": {
    DMA: 544,
  },
  "23327": {
    DMA: 544,
  },
  "23328": {
    DMA: 544,
  },
  "23336": {
    DMA: 544,
  },
  "23337": {
    DMA: 544,
  },
  "23341": {
    DMA: 544,
  },
  "23345": {
    DMA: 544,
  },
  "23347": {
    DMA: 544,
  },
  "23350": {
    DMA: 544,
  },
  "23354": {
    DMA: 544,
  },
  "23356": {
    DMA: 544,
  },
  "23357": {
    DMA: 544,
  },
  "23358": {
    DMA: 544,
  },
  "23359": {
    DMA: 544,
  },
  "23389": {
    DMA: 544,
  },
  "23395": {
    DMA: 544,
  },
  "23396": {
    DMA: 544,
  },
  "23397": {
    DMA: 544,
  },
  "23398": {
    DMA: 544,
  },
  "23399": {
    DMA: 544,
  },
  "23401": {
    DMA: 544,
  },
  "23404": {
    DMA: 544,
  },
  "23405": {
    DMA: 544,
  },
  "23407": {
    DMA: 544,
  },
  "23408": {
    DMA: 544,
  },
  "23409": {
    DMA: 544,
  },
  "23410": {
    DMA: 544,
  },
  "23412": {
    DMA: 544,
  },
  "23413": {
    DMA: 544,
  },
  "23414": {
    DMA: 544,
  },
  "23415": {
    DMA: 544,
  },
  "23416": {
    DMA: 544,
  },
  "23417": {
    DMA: 544,
  },
  "23418": {
    DMA: 544,
  },
  "23419": {
    DMA: 544,
  },
  "23420": {
    DMA: 544,
  },
  "23421": {
    DMA: 544,
  },
  "23422": {
    DMA: 544,
  },
  "23423": {
    DMA: 544,
  },
  "23424": {
    DMA: 544,
  },
  "23426": {
    DMA: 544,
  },
  "23427": {
    DMA: 544,
  },
  "23429": {
    DMA: 544,
  },
  "23430": {
    DMA: 544,
  },
  "23431": {
    DMA: 544,
  },
  "23432": {
    DMA: 544,
  },
  "23433": {
    DMA: 544,
  },
  "23434": {
    DMA: 544,
  },
  "23435": {
    DMA: 544,
  },
  "23436": {
    DMA: 544,
  },
  "23437": {
    DMA: 544,
  },
  "23438": {
    DMA: 544,
  },
  "23439": {
    DMA: 544,
  },
  "23440": {
    DMA: 544,
  },
  "23441": {
    DMA: 544,
  },
  "23442": {
    DMA: 544,
  },
  "23443": {
    DMA: 544,
  },
  "23450": {
    DMA: 544,
  },
  "23451": {
    DMA: 544,
  },
  "23452": {
    DMA: 544,
  },
  "23453": {
    DMA: 544,
  },
  "23454": {
    DMA: 544,
  },
  "23455": {
    DMA: 544,
  },
  "23456": {
    DMA: 544,
  },
  "23457": {
    DMA: 544,
  },
  "23458": {
    DMA: 544,
  },
  "23459": {
    DMA: 544,
  },
  "23460": {
    DMA: 544,
  },
  "23461": {
    DMA: 544,
  },
  "23462": {
    DMA: 544,
  },
  "23463": {
    DMA: 544,
  },
  "23464": {
    DMA: 544,
  },
  "23465": {
    DMA: 544,
  },
  "23466": {
    DMA: 544,
  },
  "23467": {
    DMA: 544,
  },
  "23471": {
    DMA: 544,
  },
  "23479": {
    DMA: 544,
  },
  "23480": {
    DMA: 544,
  },
  "23482": {
    DMA: 544,
  },
  "23483": {
    DMA: 544,
  },
  "23486": {
    DMA: 544,
  },
  "23487": {
    DMA: 544,
  },
  "23488": {
    DMA: 544,
  },
  "23501": {
    DMA: 544,
  },
  "23502": {
    DMA: 544,
  },
  "23503": {
    DMA: 544,
  },
  "23504": {
    DMA: 544,
  },
  "23505": {
    DMA: 544,
  },
  "23506": {
    DMA: 544,
  },
  "23507": {
    DMA: 544,
  },
  "23508": {
    DMA: 544,
  },
  "23509": {
    DMA: 544,
  },
  "23510": {
    DMA: 544,
  },
  "23511": {
    DMA: 544,
  },
  "23512": {
    DMA: 544,
  },
  "23513": {
    DMA: 544,
  },
  "23514": {
    DMA: 544,
  },
  "23515": {
    DMA: 544,
  },
  "23517": {
    DMA: 544,
  },
  "23518": {
    DMA: 544,
  },
  "23519": {
    DMA: 544,
  },
  "23520": {
    DMA: 544,
  },
  "23521": {
    DMA: 544,
  },
  "23523": {
    DMA: 544,
  },
  "23529": {
    DMA: 544,
  },
  "23541": {
    DMA: 544,
  },
  "23551": {
    DMA: 544,
  },
  "23601": {
    DMA: 544,
  },
  "23602": {
    DMA: 544,
  },
  "23603": {
    DMA: 544,
  },
  "23604": {
    DMA: 544,
  },
  "23605": {
    DMA: 544,
  },
  "23606": {
    DMA: 544,
  },
  "23607": {
    DMA: 544,
  },
  "23608": {
    DMA: 544,
  },
  "23609": {
    DMA: 544,
  },
  "23612": {
    DMA: 544,
  },
  "23628": {
    DMA: 544,
  },
  "23630": {
    DMA: 544,
  },
  "23651": {
    DMA: 544,
  },
  "23661": {
    DMA: 544,
  },
  "23662": {
    DMA: 544,
  },
  "23663": {
    DMA: 544,
  },
  "23664": {
    DMA: 544,
  },
  "23665": {
    DMA: 544,
  },
  "23666": {
    DMA: 544,
  },
  "23667": {
    DMA: 544,
  },
  "23668": {
    DMA: 544,
  },
  "23669": {
    DMA: 544,
  },
  "23670": {
    DMA: 544,
  },
  "23681": {
    DMA: 544,
  },
  "23690": {
    DMA: 544,
  },
  "23691": {
    DMA: 544,
  },
  "23692": {
    DMA: 544,
  },
  "23693": {
    DMA: 544,
  },
  "23694": {
    DMA: 544,
  },
  "23696": {
    DMA: 544,
  },
  "23701": {
    DMA: 544,
  },
  "23702": {
    DMA: 544,
  },
  "23703": {
    DMA: 544,
  },
  "23704": {
    DMA: 544,
  },
  "23705": {
    DMA: 544,
  },
  "23707": {
    DMA: 544,
  },
  "23708": {
    DMA: 544,
  },
  "23709": {
    DMA: 544,
  },
  "23801": {
    DMA: 556,
  },
  "23803": {
    DMA: 556,
  },
  "23804": {
    DMA: 556,
  },
  "23805": {
    DMA: 556,
  },
  "23806": {
    DMA: 556,
  },
  "23821": {
    DMA: 556,
  },
  "23822": {
    DMA: 556,
  },
  "23824": {
    DMA: 556,
  },
  "23825": {
    DMA: 556,
  },
  "23827": {
    DMA: 544,
  },
  "23828": {
    DMA: 544,
  },
  "23829": {
    DMA: 544,
  },
  "23830": {
    DMA: 556,
  },
  "23831": {
    DMA: 556,
  },
  "23832": {
    DMA: 556,
  },
  "23833": {
    DMA: 556,
  },
  "23834": {
    DMA: 556,
  },
  "23836": {
    DMA: 556,
  },
  "23837": {
    DMA: 544,
  },
  "23838": {
    DMA: 556,
  },
  "23839": {
    DMA: 544,
  },
  "23840": {
    DMA: 556,
  },
  "23841": {
    DMA: 556,
  },
  "23842": {
    DMA: 556,
  },
  "23843": {
    DMA: 556,
  },
  "23844": {
    DMA: 544,
  },
  "23845": {
    DMA: 556,
  },
  "23846": {
    DMA: 544,
  },
  "23847": {
    DMA: 556,
  },
  "23850": {
    DMA: 556,
  },
  "23851": {
    DMA: 544,
  },
  "23856": {
    DMA: 556,
  },
  "23857": {
    DMA: 556,
  },
  "23860": {
    DMA: 556,
  },
  "23866": {
    DMA: 544,
  },
  "23867": {
    DMA: 556,
  },
  "23868": {
    DMA: 556,
  },
  "23870": {
    DMA: 556,
  },
  "23872": {
    DMA: 556,
  },
  "23873": {
    DMA: 556,
  },
  "23874": {
    DMA: 544,
  },
  "23875": {
    DMA: 556,
  },
  "23876": {
    DMA: 556,
  },
  "23878": {
    DMA: 544,
  },
  "23879": {
    DMA: 556,
  },
  "23881": {
    DMA: 544,
  },
  "23882": {
    DMA: 556,
  },
  "23883": {
    DMA: 544,
  },
  "23884": {
    DMA: 556,
  },
  "23885": {
    DMA: 556,
  },
  "23887": {
    DMA: 556,
  },
  "23888": {
    DMA: 556,
  },
  "23889": {
    DMA: 556,
  },
  "23890": {
    DMA: 556,
  },
  "23891": {
    DMA: 556,
  },
  "23893": {
    DMA: 556,
  },
  "23894": {
    DMA: 556,
  },
  "23897": {
    DMA: 556,
  },
  "23898": {
    DMA: 544,
  },
  "23899": {
    DMA: 544,
  },
  "23901": {
    DMA: 556,
  },
  "23909": {
    DMA: 556,
  },
  "23915": {
    DMA: 560,
  },
  "23917": {
    DMA: 560,
  },
  "23919": {
    DMA: 560,
  },
  "23920": {
    DMA: 556,
  },
  "23921": {
    DMA: 556,
  },
  "23922": {
    DMA: 556,
  },
  "23923": {
    DMA: 573,
  },
  "23924": {
    DMA: 560,
  },
  "23927": {
    DMA: 560,
  },
  "23930": {
    DMA: 556,
  },
  "23934": {
    DMA: 573,
  },
  "23936": {
    DMA: 556,
  },
  "23937": {
    DMA: 573,
  },
  "23938": {
    DMA: 556,
  },
  "23939": {
    DMA: 573,
  },
  "23941": {
    DMA: 556,
  },
  "23942": {
    DMA: 556,
  },
  "23943": {
    DMA: 556,
  },
  "23944": {
    DMA: 556,
  },
  "23947": {
    DMA: 573,
  },
  "23950": {
    DMA: 560,
  },
  "23952": {
    DMA: 556,
  },
  "23954": {
    DMA: 556,
  },
  "23955": {
    DMA: 556,
  },
  "23958": {
    DMA: 573,
  },
  "23959": {
    DMA: 573,
  },
  "23960": {
    DMA: 556,
  },
  "23962": {
    DMA: 573,
  },
  "23963": {
    DMA: 573,
  },
  "23964": {
    DMA: 573,
  },
  "23966": {
    DMA: 556,
  },
  "23967": {
    DMA: 573,
  },
  "23968": {
    DMA: 560,
  },
  "23970": {
    DMA: 560,
  },
  "23974": {
    DMA: 556,
  },
  "23976": {
    DMA: 573,
  },
  "24001": {
    DMA: 573,
  },
  "24002": {
    DMA: 573,
  },
  "24003": {
    DMA: 573,
  },
  "24004": {
    DMA: 573,
  },
  "24005": {
    DMA: 573,
  },
  "24006": {
    DMA: 573,
  },
  "24007": {
    DMA: 573,
  },
  "24008": {
    DMA: 573,
  },
  "24009": {
    DMA: 573,
  },
  "24010": {
    DMA: 573,
  },
  "24011": {
    DMA: 573,
  },
  "24012": {
    DMA: 573,
  },
  "24013": {
    DMA: 573,
  },
  "24014": {
    DMA: 573,
  },
  "24015": {
    DMA: 573,
  },
  "24016": {
    DMA: 573,
  },
  "24017": {
    DMA: 573,
  },
  "24018": {
    DMA: 573,
  },
  "24019": {
    DMA: 573,
  },
  "24020": {
    DMA: 573,
  },
  "24022": {
    DMA: 573,
  },
  "24023": {
    DMA: 573,
  },
  "24024": {
    DMA: 573,
  },
  "24025": {
    DMA: 573,
  },
  "24026": {
    DMA: 573,
  },
  "24027": {
    DMA: 573,
  },
  "24028": {
    DMA: 573,
  },
  "24029": {
    DMA: 573,
  },
  "24030": {
    DMA: 573,
  },
  "24031": {
    DMA: 573,
  },
  "24032": {
    DMA: 573,
  },
  "24033": {
    DMA: 573,
  },
  "24034": {
    DMA: 573,
  },
  "24035": {
    DMA: 573,
  },
  "24036": {
    DMA: 573,
  },
  "24037": {
    DMA: 573,
  },
  "24038": {
    DMA: 573,
  },
  "24040": {
    DMA: 573,
  },
  "24042": {
    DMA: 573,
  },
  "24043": {
    DMA: 573,
  },
  "24044": {
    DMA: 573,
  },
  "24045": {
    DMA: 573,
  },
  "24048": {
    DMA: 573,
  },
  "24050": {
    DMA: 573,
  },
  "24053": {
    DMA: 518,
  },
  "24054": {
    DMA: 573,
  },
  "24055": {
    DMA: 573,
  },
  "24058": {
    DMA: 573,
  },
  "24059": {
    DMA: 573,
  },
  "24060": {
    DMA: 573,
  },
  "24061": {
    DMA: 573,
  },
  "24062": {
    DMA: 573,
  },
  "24063": {
    DMA: 573,
  },
  "24064": {
    DMA: 573,
  },
  "24065": {
    DMA: 573,
  },
  "24066": {
    DMA: 573,
  },
  "24067": {
    DMA: 573,
  },
  "24068": {
    DMA: 573,
  },
  "24069": {
    DMA: 573,
  },
  "24070": {
    DMA: 573,
  },
  "24072": {
    DMA: 573,
  },
  "24073": {
    DMA: 573,
  },
  "24076": {
    DMA: 518,
  },
  "24077": {
    DMA: 573,
  },
  "24078": {
    DMA: 573,
  },
  "24079": {
    DMA: 573,
  },
  "24082": {
    DMA: 518,
  },
  "24083": {
    DMA: 573,
  },
  "24084": {
    DMA: 573,
  },
  "24085": {
    DMA: 573,
  },
  "24086": {
    DMA: 573,
  },
  "24087": {
    DMA: 573,
  },
  "24088": {
    DMA: 573,
  },
  "24089": {
    DMA: 573,
  },
  "24090": {
    DMA: 573,
  },
  "24091": {
    DMA: 573,
  },
  "24092": {
    DMA: 573,
  },
  "24093": {
    DMA: 573,
  },
  "24095": {
    DMA: 573,
  },
  "24101": {
    DMA: 573,
  },
  "24102": {
    DMA: 573,
  },
  "24104": {
    DMA: 573,
  },
  "24105": {
    DMA: 573,
  },
  "24111": {
    DMA: 573,
  },
  "24112": {
    DMA: 573,
  },
  "24113": {
    DMA: 573,
  },
  "24114": {
    DMA: 573,
  },
  "24115": {
    DMA: 573,
  },
  "24120": {
    DMA: 518,
  },
  "24121": {
    DMA: 573,
  },
  "24122": {
    DMA: 573,
  },
  "24124": {
    DMA: 573,
  },
  "24126": {
    DMA: 573,
  },
  "24127": {
    DMA: 573,
  },
  "24128": {
    DMA: 573,
  },
  "24129": {
    DMA: 573,
  },
  "24130": {
    DMA: 573,
  },
  "24131": {
    DMA: 573,
  },
  "24132": {
    DMA: 573,
  },
  "24133": {
    DMA: 518,
  },
  "24134": {
    DMA: 573,
  },
  "24136": {
    DMA: 573,
  },
  "24137": {
    DMA: 573,
  },
  "24138": {
    DMA: 573,
  },
  "24139": {
    DMA: 573,
  },
  "24141": {
    DMA: 573,
  },
  "24142": {
    DMA: 573,
  },
  "24143": {
    DMA: 573,
  },
  "24146": {
    DMA: 573,
  },
  "24147": {
    DMA: 573,
  },
  "24148": {
    DMA: 573,
  },
  "24149": {
    DMA: 573,
  },
  "24150": {
    DMA: 573,
  },
  "24151": {
    DMA: 573,
  },
  "24153": {
    DMA: 573,
  },
  "24155": {
    DMA: 573,
  },
  "24157": {
    DMA: 573,
  },
  "24161": {
    DMA: 573,
  },
  "24162": {
    DMA: 573,
  },
  "24165": {
    DMA: 573,
  },
  "24167": {
    DMA: 573,
  },
  "24168": {
    DMA: 573,
  },
  "24171": {
    DMA: 518,
  },
  "24174": {
    DMA: 573,
  },
  "24175": {
    DMA: 573,
  },
  "24176": {
    DMA: 573,
  },
  "24177": {
    DMA: 518,
  },
  "24178": {
    DMA: 573,
  },
  "24179": {
    DMA: 573,
  },
  "24184": {
    DMA: 573,
  },
  "24185": {
    DMA: 518,
  },
  "24201": {
    DMA: 531,
  },
  "24202": {
    DMA: 531,
  },
  "24203": {
    DMA: 531,
  },
  "24205": {
    DMA: 531,
  },
  "24209": {
    DMA: 531,
  },
  "24210": {
    DMA: 531,
  },
  "24211": {
    DMA: 531,
  },
  "24212": {
    DMA: 531,
  },
  "24215": {
    DMA: 531,
  },
  "24216": {
    DMA: 531,
  },
  "24217": {
    DMA: 531,
  },
  "24218": {
    DMA: 531,
  },
  "24219": {
    DMA: 531,
  },
  "24220": {
    DMA: 531,
  },
  "24221": {
    DMA: 531,
  },
  "24224": {
    DMA: 531,
  },
  "24225": {
    DMA: 531,
  },
  "24226": {
    DMA: 531,
  },
  "24228": {
    DMA: 531,
  },
  "24230": {
    DMA: 531,
  },
  "24236": {
    DMA: 531,
  },
  "24237": {
    DMA: 531,
  },
  "24239": {
    DMA: 531,
  },
  "24243": {
    DMA: 531,
  },
  "24244": {
    DMA: 531,
  },
  "24245": {
    DMA: 531,
  },
  "24246": {
    DMA: 531,
  },
  "24248": {
    DMA: 531,
  },
  "24250": {
    DMA: 531,
  },
  "24251": {
    DMA: 531,
  },
  "24256": {
    DMA: 531,
  },
  "24258": {
    DMA: 531,
  },
  "24260": {
    DMA: 531,
  },
  "24263": {
    DMA: 531,
  },
  "24265": {
    DMA: 531,
  },
  "24266": {
    DMA: 531,
  },
  "24269": {
    DMA: 531,
  },
  "24270": {
    DMA: 531,
  },
  "24271": {
    DMA: 531,
  },
  "24272": {
    DMA: 531,
  },
  "24273": {
    DMA: 531,
  },
  "24277": {
    DMA: 531,
  },
  "24279": {
    DMA: 531,
  },
  "24280": {
    DMA: 531,
  },
  "24281": {
    DMA: 531,
  },
  "24282": {
    DMA: 531,
  },
  "24283": {
    DMA: 531,
  },
  "24290": {
    DMA: 531,
  },
  "24292": {
    DMA: 573,
  },
  "24293": {
    DMA: 531,
  },
  "24301": {
    DMA: 573,
  },
  "24311": {
    DMA: 531,
  },
  "24312": {
    DMA: 573,
  },
  "24313": {
    DMA: 573,
  },
  "24314": {
    DMA: 573,
  },
  "24315": {
    DMA: 573,
  },
  "24316": {
    DMA: 559,
  },
  "24317": {
    DMA: 573,
  },
  "24318": {
    DMA: 573,
  },
  "24319": {
    DMA: 531,
  },
  "24322": {
    DMA: 573,
  },
  "24323": {
    DMA: 573,
  },
  "24324": {
    DMA: 573,
  },
  "24325": {
    DMA: 573,
  },
  "24326": {
    DMA: 573,
  },
  "24327": {
    DMA: 531,
  },
  "24328": {
    DMA: 573,
  },
  "24330": {
    DMA: 573,
  },
  "24333": {
    DMA: 573,
  },
  "24340": {
    DMA: 531,
  },
  "24343": {
    DMA: 573,
  },
  "24347": {
    DMA: 573,
  },
  "24348": {
    DMA: 573,
  },
  "24350": {
    DMA: 573,
  },
  "24351": {
    DMA: 573,
  },
  "24352": {
    DMA: 573,
  },
  "24354": {
    DMA: 531,
  },
  "24360": {
    DMA: 573,
  },
  "24361": {
    DMA: 531,
  },
  "24363": {
    DMA: 573,
  },
  "24366": {
    DMA: 573,
  },
  "24368": {
    DMA: 573,
  },
  "24370": {
    DMA: 531,
  },
  "24374": {
    DMA: 573,
  },
  "24375": {
    DMA: 531,
  },
  "24377": {
    DMA: 559,
  },
  "24378": {
    DMA: 573,
  },
  "24380": {
    DMA: 573,
  },
  "24381": {
    DMA: 573,
  },
  "24382": {
    DMA: 573,
  },
  "24401": {
    DMA: 569,
  },
  "24402": {
    DMA: 569,
  },
  "24411": {
    DMA: 569,
  },
  "24412": {
    DMA: 573,
  },
  "24413": {
    DMA: 573,
  },
  "24415": {
    DMA: 573,
  },
  "24416": {
    DMA: 573,
  },
  "24421": {
    DMA: 569,
  },
  "24422": {
    DMA: 573,
  },
  "24426": {
    DMA: 573,
  },
  "24430": {
    DMA: 569,
  },
  "24431": {
    DMA: 569,
  },
  "24432": {
    DMA: 569,
  },
  "24433": {
    DMA: 573,
  },
  "24435": {
    DMA: 573,
  },
  "24437": {
    DMA: 569,
  },
  "24438": {
    DMA: 573,
  },
  "24439": {
    DMA: 573,
  },
  "24440": {
    DMA: 569,
  },
  "24441": {
    DMA: 569,
  },
  "24442": {
    DMA: 573,
  },
  "24445": {
    DMA: 573,
  },
  "24448": {
    DMA: 573,
  },
  "24450": {
    DMA: 573,
  },
  "24457": {
    DMA: 573,
  },
  "24458": {
    DMA: 573,
  },
  "24459": {
    DMA: 569,
  },
  "24460": {
    DMA: 573,
  },
  "24463": {
    DMA: 569,
  },
  "24464": {
    DMA: 573,
  },
  "24465": {
    DMA: 573,
  },
  "24467": {
    DMA: 569,
  },
  "24468": {
    DMA: 573,
  },
  "24469": {
    DMA: 569,
  },
  "24471": {
    DMA: 569,
  },
  "24472": {
    DMA: 573,
  },
  "24473": {
    DMA: 573,
  },
  "24474": {
    DMA: 573,
  },
  "24476": {
    DMA: 569,
  },
  "24477": {
    DMA: 569,
  },
  "24479": {
    DMA: 569,
  },
  "24482": {
    DMA: 569,
  },
  "24483": {
    DMA: 573,
  },
  "24484": {
    DMA: 573,
  },
  "24485": {
    DMA: 569,
  },
  "24486": {
    DMA: 569,
  },
  "24487": {
    DMA: 573,
  },
  "24501": {
    DMA: 573,
  },
  "24502": {
    DMA: 573,
  },
  "24503": {
    DMA: 573,
  },
  "24504": {
    DMA: 573,
  },
  "24505": {
    DMA: 573,
  },
  "24506": {
    DMA: 573,
  },
  "24512": {
    DMA: 573,
  },
  "24513": {
    DMA: 573,
  },
  "24514": {
    DMA: 573,
  },
  "24515": {
    DMA: 573,
  },
  "24517": {
    DMA: 573,
  },
  "24520": {
    DMA: 573,
  },
  "24521": {
    DMA: 573,
  },
  "24522": {
    DMA: 573,
  },
  "24523": {
    DMA: 573,
  },
  "24526": {
    DMA: 573,
  },
  "24527": {
    DMA: 573,
  },
  "24528": {
    DMA: 573,
  },
  "24529": {
    DMA: 560,
  },
  "24530": {
    DMA: 573,
  },
  "24531": {
    DMA: 573,
  },
  "24533": {
    DMA: 573,
  },
  "24534": {
    DMA: 573,
  },
  "24535": {
    DMA: 573,
  },
  "24536": {
    DMA: 573,
  },
  "24538": {
    DMA: 573,
  },
  "24539": {
    DMA: 573,
  },
  "24540": {
    DMA: 573,
  },
  "24541": {
    DMA: 573,
  },
  "24543": {
    DMA: 573,
  },
  "24544": {
    DMA: 573,
  },
  "24549": {
    DMA: 573,
  },
  "24550": {
    DMA: 573,
  },
  "24551": {
    DMA: 573,
  },
  "24553": {
    DMA: 573,
  },
  "24554": {
    DMA: 573,
  },
  "24555": {
    DMA: 573,
  },
  "24556": {
    DMA: 573,
  },
  "24557": {
    DMA: 573,
  },
  "24558": {
    DMA: 573,
  },
  "24562": {
    DMA: 556,
  },
  "24563": {
    DMA: 573,
  },
  "24565": {
    DMA: 573,
  },
  "24566": {
    DMA: 573,
  },
  "24569": {
    DMA: 573,
  },
  "24570": {
    DMA: 573,
  },
  "24571": {
    DMA: 573,
  },
  "24572": {
    DMA: 573,
  },
  "24574": {
    DMA: 573,
  },
  "24576": {
    DMA: 573,
  },
  "24577": {
    DMA: 573,
  },
  "24578": {
    DMA: 573,
  },
  "24579": {
    DMA: 573,
  },
  "24580": {
    DMA: 560,
  },
  "24581": {
    DMA: 573,
  },
  "24586": {
    DMA: 573,
  },
  "24588": {
    DMA: 573,
  },
  "24589": {
    DMA: 573,
  },
  "24590": {
    DMA: 584,
  },
  "24592": {
    DMA: 573,
  },
  "24593": {
    DMA: 573,
  },
  "24594": {
    DMA: 573,
  },
  "24595": {
    DMA: 573,
  },
  "24597": {
    DMA: 573,
  },
  "24598": {
    DMA: 573,
  },
  "24599": {
    DMA: 556,
  },
  "24601": {
    DMA: 559,
  },
  "24602": {
    DMA: 559,
  },
  "24603": {
    DMA: 531,
  },
  "24604": {
    DMA: 559,
  },
  "24605": {
    DMA: 559,
  },
  "24606": {
    DMA: 559,
  },
  "24607": {
    DMA: 531,
  },
  "24608": {
    DMA: 559,
  },
  "24609": {
    DMA: 559,
  },
  "24612": {
    DMA: 559,
  },
  "24613": {
    DMA: 559,
  },
  "24614": {
    DMA: 531,
  },
  "24619": {
    DMA: 559,
  },
  "24620": {
    DMA: 531,
  },
  "24622": {
    DMA: 559,
  },
  "24624": {
    DMA: 531,
  },
  "24627": {
    DMA: 531,
  },
  "24628": {
    DMA: 531,
  },
  "24630": {
    DMA: 559,
  },
  "24631": {
    DMA: 531,
  },
  "24634": {
    DMA: 531,
  },
  "24635": {
    DMA: 559,
  },
  "24637": {
    DMA: 559,
  },
  "24639": {
    DMA: 531,
  },
  "24640": {
    DMA: 559,
  },
  "24641": {
    DMA: 559,
  },
  "24646": {
    DMA: 531,
  },
  "24647": {
    DMA: 531,
  },
  "24649": {
    DMA: 531,
  },
  "24651": {
    DMA: 559,
  },
  "24656": {
    DMA: 531,
  },
  "24657": {
    DMA: 531,
  },
  "24658": {
    DMA: 531,
  },
  "24701": {
    DMA: 559,
  },
  "24712": {
    DMA: 559,
  },
  "24714": {
    DMA: 559,
  },
  "24715": {
    DMA: 559,
  },
  "24716": {
    DMA: 559,
  },
  "24719": {
    DMA: 559,
  },
  "24724": {
    DMA: 559,
  },
  "24726": {
    DMA: 559,
  },
  "24729": {
    DMA: 559,
  },
  "24731": {
    DMA: 559,
  },
  "24732": {
    DMA: 559,
  },
  "24733": {
    DMA: 559,
  },
  "24736": {
    DMA: 559,
  },
  "24737": {
    DMA: 559,
  },
  "24738": {
    DMA: 559,
  },
  "24739": {
    DMA: 559,
  },
  "24740": {
    DMA: 559,
  },
  "24747": {
    DMA: 559,
  },
  "24751": {
    DMA: 559,
  },
  "24801": {
    DMA: 559,
  },
  "24808": {
    DMA: 559,
  },
  "24811": {
    DMA: 559,
  },
  "24813": {
    DMA: 559,
  },
  "24815": {
    DMA: 559,
  },
  "24816": {
    DMA: 559,
  },
  "24817": {
    DMA: 559,
  },
  "24818": {
    DMA: 559,
  },
  "24822": {
    DMA: 559,
  },
  "24823": {
    DMA: 559,
  },
  "24826": {
    DMA: 559,
  },
  "24827": {
    DMA: 559,
  },
  "24828": {
    DMA: 559,
  },
  "24829": {
    DMA: 559,
  },
  "24830": {
    DMA: 559,
  },
  "24831": {
    DMA: 559,
  },
  "24834": {
    DMA: 559,
  },
  "24836": {
    DMA: 559,
  },
  "24839": {
    DMA: 559,
  },
  "24842": {
    DMA: 559,
  },
  "24843": {
    DMA: 559,
  },
  "24844": {
    DMA: 559,
  },
  "24845": {
    DMA: 559,
  },
  "24846": {
    DMA: 559,
  },
  "24847": {
    DMA: 559,
  },
  "24848": {
    DMA: 559,
  },
  "24849": {
    DMA: 559,
  },
  "24850": {
    DMA: 559,
  },
  "24851": {
    DMA: 564,
  },
  "24853": {
    DMA: 559,
  },
  "24854": {
    DMA: 559,
  },
  "24855": {
    DMA: 559,
  },
  "24857": {
    DMA: 559,
  },
  "24859": {
    DMA: 559,
  },
  "24860": {
    DMA: 559,
  },
  "24861": {
    DMA: 559,
  },
  "24862": {
    DMA: 559,
  },
  "24866": {
    DMA: 559,
  },
  "24867": {
    DMA: 559,
  },
  "24868": {
    DMA: 559,
  },
  "24869": {
    DMA: 559,
  },
  "24870": {
    DMA: 559,
  },
  "24871": {
    DMA: 559,
  },
  "24872": {
    DMA: 559,
  },
  "24873": {
    DMA: 559,
  },
  "24874": {
    DMA: 559,
  },
  "24878": {
    DMA: 559,
  },
  "24879": {
    DMA: 559,
  },
  "24880": {
    DMA: 559,
  },
  "24881": {
    DMA: 559,
  },
  "24882": {
    DMA: 559,
  },
  "24884": {
    DMA: 559,
  },
  "24887": {
    DMA: 559,
  },
  "24888": {
    DMA: 559,
  },
  "24892": {
    DMA: 559,
  },
  "24894": {
    DMA: 559,
  },
  "24895": {
    DMA: 559,
  },
  "24898": {
    DMA: 559,
  },
  "24901": {
    DMA: 559,
  },
  "24902": {
    DMA: 559,
  },
  "24910": {
    DMA: 559,
  },
  "24915": {
    DMA: 573,
  },
  "24916": {
    DMA: 559,
  },
  "24918": {
    DMA: 559,
  },
  "24920": {
    DMA: 573,
  },
  "24924": {
    DMA: 573,
  },
  "24925": {
    DMA: 559,
  },
  "24927": {
    DMA: 573,
  },
  "24931": {
    DMA: 559,
  },
  "24934": {
    DMA: 573,
  },
  "24935": {
    DMA: 559,
  },
  "24938": {
    DMA: 559,
  },
  "24941": {
    DMA: 559,
  },
  "24943": {
    DMA: 559,
  },
  "24944": {
    DMA: 573,
  },
  "24945": {
    DMA: 559,
  },
  "24946": {
    DMA: 573,
  },
  "24951": {
    DMA: 559,
  },
  "24954": {
    DMA: 573,
  },
  "24957": {
    DMA: 559,
  },
  "24961": {
    DMA: 559,
  },
  "24962": {
    DMA: 559,
  },
  "24963": {
    DMA: 559,
  },
  "24966": {
    DMA: 559,
  },
  "24970": {
    DMA: 559,
  },
  "24974": {
    DMA: 559,
  },
  "24976": {
    DMA: 559,
  },
  "24977": {
    DMA: 559,
  },
  "24981": {
    DMA: 559,
  },
  "24983": {
    DMA: 559,
  },
  "24984": {
    DMA: 559,
  },
  "24985": {
    DMA: 559,
  },
  "24986": {
    DMA: 559,
  },
  "24991": {
    DMA: 559,
  },
  "24993": {
    DMA: 559,
  },
  "25002": {
    DMA: 559,
  },
  "25003": {
    DMA: 564,
  },
  "25005": {
    DMA: 564,
  },
  "25007": {
    DMA: 559,
  },
  "25008": {
    DMA: 559,
  },
  "25009": {
    DMA: 564,
  },
  "25011": {
    DMA: 564,
  },
  "25015": {
    DMA: 564,
  },
  "25019": {
    DMA: 564,
  },
  "25021": {
    DMA: 564,
  },
  "25022": {
    DMA: 564,
  },
  "25024": {
    DMA: 564,
  },
  "25025": {
    DMA: 564,
  },
  "25026": {
    DMA: 564,
  },
  "25028": {
    DMA: 564,
  },
  "25030": {
    DMA: 564,
  },
  "25031": {
    DMA: 559,
  },
  "25033": {
    DMA: 564,
  },
  "25035": {
    DMA: 564,
  },
  "25036": {
    DMA: 559,
  },
  "25039": {
    DMA: 564,
  },
  "25040": {
    DMA: 559,
  },
  "25043": {
    DMA: 564,
  },
  "25044": {
    DMA: 559,
  },
  "25045": {
    DMA: 564,
  },
  "25047": {
    DMA: 564,
  },
  "25048": {
    DMA: 559,
  },
  "25049": {
    DMA: 564,
  },
  "25051": {
    DMA: 564,
  },
  "25053": {
    DMA: 564,
  },
  "25054": {
    DMA: 564,
  },
  "25057": {
    DMA: 559,
  },
  "25059": {
    DMA: 564,
  },
  "25060": {
    DMA: 559,
  },
  "25061": {
    DMA: 564,
  },
  "25062": {
    DMA: 559,
  },
  "25063": {
    DMA: 564,
  },
  "25064": {
    DMA: 564,
  },
  "25067": {
    DMA: 564,
  },
  "25070": {
    DMA: 564,
  },
  "25071": {
    DMA: 564,
  },
  "25075": {
    DMA: 564,
  },
  "25076": {
    DMA: 564,
  },
  "25079": {
    DMA: 564,
  },
  "25081": {
    DMA: 564,
  },
  "25082": {
    DMA: 564,
  },
  "25083": {
    DMA: 564,
  },
  "25085": {
    DMA: 559,
  },
  "25086": {
    DMA: 564,
  },
  "25088": {
    DMA: 564,
  },
  "25090": {
    DMA: 559,
  },
  "25093": {
    DMA: 564,
  },
  "25102": {
    DMA: 564,
  },
  "25103": {
    DMA: 564,
  },
  "25106": {
    DMA: 564,
  },
  "25107": {
    DMA: 564,
  },
  "25108": {
    DMA: 564,
  },
  "25109": {
    DMA: 564,
  },
  "25110": {
    DMA: 564,
  },
  "25111": {
    DMA: 564,
  },
  "25112": {
    DMA: 564,
  },
  "25113": {
    DMA: 564,
  },
  "25114": {
    DMA: 564,
  },
  "25115": {
    DMA: 559,
  },
  "25118": {
    DMA: 559,
  },
  "25119": {
    DMA: 559,
  },
  "25121": {
    DMA: 564,
  },
  "25123": {
    DMA: 564,
  },
  "25124": {
    DMA: 564,
  },
  "25125": {
    DMA: 564,
  },
  "25126": {
    DMA: 564,
  },
  "25130": {
    DMA: 564,
  },
  "25132": {
    DMA: 564,
  },
  "25133": {
    DMA: 564,
  },
  "25134": {
    DMA: 564,
  },
  "25136": {
    DMA: 559,
  },
  "25139": {
    DMA: 559,
  },
  "25140": {
    DMA: 559,
  },
  "25141": {
    DMA: 564,
  },
  "25142": {
    DMA: 564,
  },
  "25143": {
    DMA: 564,
  },
  "25148": {
    DMA: 564,
  },
  "25149": {
    DMA: 564,
  },
  "25152": {
    DMA: 559,
  },
  "25154": {
    DMA: 564,
  },
  "25156": {
    DMA: 564,
  },
  "25159": {
    DMA: 564,
  },
  "25160": {
    DMA: 564,
  },
  "25161": {
    DMA: 559,
  },
  "25162": {
    DMA: 564,
  },
  "25164": {
    DMA: 564,
  },
  "25165": {
    DMA: 564,
  },
  "25168": {
    DMA: 564,
  },
  "25169": {
    DMA: 564,
  },
  "25173": {
    DMA: 559,
  },
  "25174": {
    DMA: 559,
  },
  "25177": {
    DMA: 564,
  },
  "25180": {
    DMA: 564,
  },
  "25181": {
    DMA: 564,
  },
  "25183": {
    DMA: 564,
  },
  "25185": {
    DMA: 559,
  },
  "25186": {
    DMA: 559,
  },
  "25187": {
    DMA: 564,
  },
  "25193": {
    DMA: 564,
  },
  "25201": {
    DMA: 564,
  },
  "25202": {
    DMA: 564,
  },
  "25203": {
    DMA: 564,
  },
  "25204": {
    DMA: 564,
  },
  "25205": {
    DMA: 564,
  },
  "25206": {
    DMA: 564,
  },
  "25208": {
    DMA: 564,
  },
  "25209": {
    DMA: 564,
  },
  "25211": {
    DMA: 564,
  },
  "25213": {
    DMA: 564,
  },
  "25214": {
    DMA: 564,
  },
  "25231": {
    DMA: 564,
  },
  "25234": {
    DMA: 564,
  },
  "25235": {
    DMA: 564,
  },
  "25239": {
    DMA: 564,
  },
  "25241": {
    DMA: 564,
  },
  "25243": {
    DMA: 564,
  },
  "25244": {
    DMA: 564,
  },
  "25245": {
    DMA: 564,
  },
  "25247": {
    DMA: 564,
  },
  "25248": {
    DMA: 564,
  },
  "25251": {
    DMA: 564,
  },
  "25252": {
    DMA: 564,
  },
  "25253": {
    DMA: 564,
  },
  "25259": {
    DMA: 564,
  },
  "25260": {
    DMA: 564,
  },
  "25261": {
    DMA: 564,
  },
  "25262": {
    DMA: 564,
  },
  "25264": {
    DMA: 564,
  },
  "25265": {
    DMA: 564,
  },
  "25266": {
    DMA: 564,
  },
  "25267": {
    DMA: 598,
  },
  "25268": {
    DMA: 564,
  },
  "25270": {
    DMA: 564,
  },
  "25271": {
    DMA: 564,
  },
  "25275": {
    DMA: 564,
  },
  "25276": {
    DMA: 564,
  },
  "25285": {
    DMA: 564,
  },
  "25286": {
    DMA: 564,
  },
  "25287": {
    DMA: 564,
  },
  "25301": {
    DMA: 564,
  },
  "25302": {
    DMA: 564,
  },
  "25303": {
    DMA: 564,
  },
  "25304": {
    DMA: 564,
  },
  "25305": {
    DMA: 564,
  },
  "25306": {
    DMA: 564,
  },
  "25309": {
    DMA: 564,
  },
  "25311": {
    DMA: 564,
  },
  "25312": {
    DMA: 564,
  },
  "25313": {
    DMA: 564,
  },
  "25314": {
    DMA: 564,
  },
  "25315": {
    DMA: 564,
  },
  "25317": {
    DMA: 564,
  },
  "25320": {
    DMA: 564,
  },
  "25321": {
    DMA: 564,
  },
  "25322": {
    DMA: 564,
  },
  "25323": {
    DMA: 564,
  },
  "25324": {
    DMA: 564,
  },
  "25325": {
    DMA: 564,
  },
  "25326": {
    DMA: 564,
  },
  "25327": {
    DMA: 564,
  },
  "25328": {
    DMA: 564,
  },
  "25329": {
    DMA: 564,
  },
  "25330": {
    DMA: 564,
  },
  "25331": {
    DMA: 564,
  },
  "25332": {
    DMA: 564,
  },
  "25333": {
    DMA: 564,
  },
  "25334": {
    DMA: 564,
  },
  "25335": {
    DMA: 564,
  },
  "25336": {
    DMA: 564,
  },
  "25337": {
    DMA: 564,
  },
  "25338": {
    DMA: 564,
  },
  "25339": {
    DMA: 564,
  },
  "25350": {
    DMA: 564,
  },
  "25356": {
    DMA: 564,
  },
  "25357": {
    DMA: 564,
  },
  "25358": {
    DMA: 564,
  },
  "25360": {
    DMA: 564,
  },
  "25361": {
    DMA: 564,
  },
  "25362": {
    DMA: 564,
  },
  "25364": {
    DMA: 564,
  },
  "25365": {
    DMA: 564,
  },
  "25375": {
    DMA: 564,
  },
  "25387": {
    DMA: 564,
  },
  "25389": {
    DMA: 564,
  },
  "25392": {
    DMA: 564,
  },
  "25396": {
    DMA: 564,
  },
  "25401": {
    DMA: 511,
  },
  "25402": {
    DMA: 511,
  },
  "25403": {
    DMA: 511,
  },
  "25404": {
    DMA: 511,
  },
  "25405": {
    DMA: 511,
  },
  "25410": {
    DMA: 511,
  },
  "25411": {
    DMA: 511,
  },
  "25413": {
    DMA: 511,
  },
  "25414": {
    DMA: 511,
  },
  "25419": {
    DMA: 511,
  },
  "25420": {
    DMA: 511,
  },
  "25421": {
    DMA: 511,
  },
  "25422": {
    DMA: 511,
  },
  "25423": {
    DMA: 511,
  },
  "25425": {
    DMA: 511,
  },
  "25427": {
    DMA: 511,
  },
  "25428": {
    DMA: 511,
  },
  "25429": {
    DMA: 511,
  },
  "25430": {
    DMA: 511,
  },
  "25431": {
    DMA: 511,
  },
  "25432": {
    DMA: 511,
  },
  "25434": {
    DMA: 511,
  },
  "25437": {
    DMA: 511,
  },
  "25438": {
    DMA: 511,
  },
  "25440": {
    DMA: 511,
  },
  "25441": {
    DMA: 511,
  },
  "25442": {
    DMA: 511,
  },
  "25443": {
    DMA: 511,
  },
  "25444": {
    DMA: 511,
  },
  "25446": {
    DMA: 511,
  },
  "25501": {
    DMA: 564,
  },
  "25502": {
    DMA: 564,
  },
  "25503": {
    DMA: 564,
  },
  "25504": {
    DMA: 564,
  },
  "25505": {
    DMA: 564,
  },
  "25506": {
    DMA: 564,
  },
  "25507": {
    DMA: 564,
  },
  "25508": {
    DMA: 564,
  },
  "25510": {
    DMA: 564,
  },
  "25511": {
    DMA: 564,
  },
  "25512": {
    DMA: 564,
  },
  "25514": {
    DMA: 564,
  },
  "25515": {
    DMA: 564,
  },
  "25517": {
    DMA: 564,
  },
  "25520": {
    DMA: 564,
  },
  "25521": {
    DMA: 564,
  },
  "25523": {
    DMA: 564,
  },
  "25524": {
    DMA: 564,
  },
  "25526": {
    DMA: 564,
  },
  "25529": {
    DMA: 564,
  },
  "25530": {
    DMA: 564,
  },
  "25534": {
    DMA: 564,
  },
  "25535": {
    DMA: 564,
  },
  "25537": {
    DMA: 564,
  },
  "25540": {
    DMA: 564,
  },
  "25541": {
    DMA: 564,
  },
  "25544": {
    DMA: 564,
  },
  "25545": {
    DMA: 564,
  },
  "25547": {
    DMA: 564,
  },
  "25550": {
    DMA: 564,
  },
  "25555": {
    DMA: 564,
  },
  "25557": {
    DMA: 564,
  },
  "25559": {
    DMA: 564,
  },
  "25560": {
    DMA: 564,
  },
  "25562": {
    DMA: 564,
  },
  "25564": {
    DMA: 564,
  },
  "25565": {
    DMA: 564,
  },
  "25567": {
    DMA: 564,
  },
  "25569": {
    DMA: 564,
  },
  "25570": {
    DMA: 564,
  },
  "25571": {
    DMA: 564,
  },
  "25572": {
    DMA: 564,
  },
  "25573": {
    DMA: 564,
  },
  "25601": {
    DMA: 564,
  },
  "25606": {
    DMA: 564,
  },
  "25607": {
    DMA: 564,
  },
  "25608": {
    DMA: 564,
  },
  "25611": {
    DMA: 564,
  },
  "25612": {
    DMA: 564,
  },
  "25614": {
    DMA: 564,
  },
  "25617": {
    DMA: 564,
  },
  "25621": {
    DMA: 564,
  },
  "25624": {
    DMA: 564,
  },
  "25625": {
    DMA: 564,
  },
  "25628": {
    DMA: 564,
  },
  "25630": {
    DMA: 564,
  },
  "25632": {
    DMA: 564,
  },
  "25634": {
    DMA: 564,
  },
  "25635": {
    DMA: 564,
  },
  "25637": {
    DMA: 564,
  },
  "25638": {
    DMA: 564,
  },
  "25639": {
    DMA: 564,
  },
  "25644": {
    DMA: 564,
  },
  "25646": {
    DMA: 564,
  },
  "25647": {
    DMA: 564,
  },
  "25649": {
    DMA: 564,
  },
  "25650": {
    DMA: 564,
  },
  "25651": {
    DMA: 564,
  },
  "25652": {
    DMA: 564,
  },
  "25653": {
    DMA: 564,
  },
  "25654": {
    DMA: 564,
  },
  "25661": {
    DMA: 564,
  },
  "25665": {
    DMA: 564,
  },
  "25666": {
    DMA: 564,
  },
  "25667": {
    DMA: 564,
  },
  "25669": {
    DMA: 564,
  },
  "25670": {
    DMA: 564,
  },
  "25671": {
    DMA: 564,
  },
  "25672": {
    DMA: 564,
  },
  "25674": {
    DMA: 564,
  },
  "25676": {
    DMA: 564,
  },
  "25678": {
    DMA: 564,
  },
  "25685": {
    DMA: 564,
  },
  "25686": {
    DMA: 564,
  },
  "25688": {
    DMA: 564,
  },
  "25690": {
    DMA: 564,
  },
  "25691": {
    DMA: 564,
  },
  "25692": {
    DMA: 564,
  },
  "25696": {
    DMA: 564,
  },
  "25699": {
    DMA: 564,
  },
  "25701": {
    DMA: 564,
  },
  "25702": {
    DMA: 564,
  },
  "25703": {
    DMA: 564,
  },
  "25704": {
    DMA: 564,
  },
  "25705": {
    DMA: 564,
  },
  "25706": {
    DMA: 564,
  },
  "25707": {
    DMA: 564,
  },
  "25708": {
    DMA: 564,
  },
  "25709": {
    DMA: 564,
  },
  "25710": {
    DMA: 564,
  },
  "25711": {
    DMA: 564,
  },
  "25712": {
    DMA: 564,
  },
  "25713": {
    DMA: 564,
  },
  "25714": {
    DMA: 564,
  },
  "25715": {
    DMA: 564,
  },
  "25716": {
    DMA: 564,
  },
  "25717": {
    DMA: 564,
  },
  "25718": {
    DMA: 564,
  },
  "25719": {
    DMA: 564,
  },
  "25720": {
    DMA: 564,
  },
  "25721": {
    DMA: 564,
  },
  "25722": {
    DMA: 564,
  },
  "25723": {
    DMA: 564,
  },
  "25724": {
    DMA: 564,
  },
  "25725": {
    DMA: 564,
  },
  "25726": {
    DMA: 564,
  },
  "25727": {
    DMA: 564,
  },
  "25728": {
    DMA: 564,
  },
  "25729": {
    DMA: 564,
  },
  "25755": {
    DMA: 564,
  },
  "25770": {
    DMA: 564,
  },
  "25771": {
    DMA: 564,
  },
  "25772": {
    DMA: 564,
  },
  "25773": {
    DMA: 564,
  },
  "25774": {
    DMA: 564,
  },
  "25775": {
    DMA: 564,
  },
  "25776": {
    DMA: 564,
  },
  "25777": {
    DMA: 564,
  },
  "25778": {
    DMA: 564,
  },
  "25779": {
    DMA: 564,
  },
  "25801": {
    DMA: 559,
  },
  "25802": {
    DMA: 559,
  },
  "25810": {
    DMA: 559,
  },
  "25811": {
    DMA: 559,
  },
  "25812": {
    DMA: 559,
  },
  "25813": {
    DMA: 559,
  },
  "25817": {
    DMA: 559,
  },
  "25818": {
    DMA: 559,
  },
  "25820": {
    DMA: 559,
  },
  "25823": {
    DMA: 559,
  },
  "25825": {
    DMA: 559,
  },
  "25826": {
    DMA: 559,
  },
  "25827": {
    DMA: 559,
  },
  "25831": {
    DMA: 559,
  },
  "25832": {
    DMA: 559,
  },
  "25833": {
    DMA: 559,
  },
  "25836": {
    DMA: 559,
  },
  "25837": {
    DMA: 559,
  },
  "25839": {
    DMA: 559,
  },
  "25840": {
    DMA: 559,
  },
  "25841": {
    DMA: 559,
  },
  "25843": {
    DMA: 559,
  },
  "25844": {
    DMA: 559,
  },
  "25845": {
    DMA: 559,
  },
  "25846": {
    DMA: 559,
  },
  "25848": {
    DMA: 559,
  },
  "25849": {
    DMA: 559,
  },
  "25851": {
    DMA: 559,
  },
  "25853": {
    DMA: 559,
  },
  "25854": {
    DMA: 559,
  },
  "25855": {
    DMA: 559,
  },
  "25857": {
    DMA: 559,
  },
  "25860": {
    DMA: 559,
  },
  "25862": {
    DMA: 559,
  },
  "25864": {
    DMA: 559,
  },
  "25865": {
    DMA: 559,
  },
  "25866": {
    DMA: 559,
  },
  "25868": {
    DMA: 559,
  },
  "25870": {
    DMA: 559,
  },
  "25871": {
    DMA: 559,
  },
  "25873": {
    DMA: 559,
  },
  "25875": {
    DMA: 559,
  },
  "25876": {
    DMA: 559,
  },
  "25878": {
    DMA: 559,
  },
  "25879": {
    DMA: 559,
  },
  "25880": {
    DMA: 559,
  },
  "25882": {
    DMA: 559,
  },
  "25888": {
    DMA: 559,
  },
  "25901": {
    DMA: 559,
  },
  "25902": {
    DMA: 559,
  },
  "25904": {
    DMA: 559,
  },
  "25906": {
    DMA: 559,
  },
  "25907": {
    DMA: 559,
  },
  "25908": {
    DMA: 559,
  },
  "25909": {
    DMA: 559,
  },
  "25911": {
    DMA: 559,
  },
  "25913": {
    DMA: 559,
  },
  "25915": {
    DMA: 559,
  },
  "25916": {
    DMA: 559,
  },
  "25917": {
    DMA: 559,
  },
  "25918": {
    DMA: 559,
  },
  "25919": {
    DMA: 559,
  },
  "25920": {
    DMA: 559,
  },
  "25921": {
    DMA: 559,
  },
  "25922": {
    DMA: 559,
  },
  "25926": {
    DMA: 559,
  },
  "25927": {
    DMA: 559,
  },
  "25928": {
    DMA: 559,
  },
  "25932": {
    DMA: 559,
  },
  "25936": {
    DMA: 559,
  },
  "25938": {
    DMA: 559,
  },
  "25942": {
    DMA: 559,
  },
  "25943": {
    DMA: 559,
  },
  "25951": {
    DMA: 559,
  },
  "25958": {
    DMA: 559,
  },
  "25962": {
    DMA: 559,
  },
  "25965": {
    DMA: 559,
  },
  "25966": {
    DMA: 559,
  },
  "25969": {
    DMA: 559,
  },
  "25971": {
    DMA: 559,
  },
  "25972": {
    DMA: 559,
  },
  "25976": {
    DMA: 559,
  },
  "25977": {
    DMA: 559,
  },
  "25978": {
    DMA: 559,
  },
  "25979": {
    DMA: 559,
  },
  "25981": {
    DMA: 559,
  },
  "25984": {
    DMA: 559,
  },
  "25985": {
    DMA: 559,
  },
  "25986": {
    DMA: 559,
  },
  "25989": {
    DMA: 559,
  },
  "26003": {
    DMA: 554,
  },
  "26030": {
    DMA: 554,
  },
  "26031": {
    DMA: 554,
  },
  "26032": {
    DMA: 554,
  },
  "26033": {
    DMA: 554,
  },
  "26034": {
    DMA: 554,
  },
  "26035": {
    DMA: 554,
  },
  "26036": {
    DMA: 554,
  },
  "26037": {
    DMA: 554,
  },
  "26038": {
    DMA: 554,
  },
  "26039": {
    DMA: 554,
  },
  "26040": {
    DMA: 554,
  },
  "26041": {
    DMA: 554,
  },
  "26047": {
    DMA: 554,
  },
  "26050": {
    DMA: 554,
  },
  "26055": {
    DMA: 554,
  },
  "26056": {
    DMA: 554,
  },
  "26058": {
    DMA: 554,
  },
  "26059": {
    DMA: 554,
  },
  "26060": {
    DMA: 554,
  },
  "26062": {
    DMA: 554,
  },
  "26070": {
    DMA: 554,
  },
  "26074": {
    DMA: 554,
  },
  "26075": {
    DMA: 554,
  },
  "26101": {
    DMA: 597,
  },
  "26102": {
    DMA: 597,
  },
  "26103": {
    DMA: 597,
  },
  "26104": {
    DMA: 597,
  },
  "26105": {
    DMA: 597,
  },
  "26106": {
    DMA: 597,
  },
  "26120": {
    DMA: 597,
  },
  "26121": {
    DMA: 597,
  },
  "26133": {
    DMA: 597,
  },
  "26134": {
    DMA: 597,
  },
  "26136": {
    DMA: 564,
  },
  "26137": {
    DMA: 564,
  },
  "26138": {
    DMA: 564,
  },
  "26141": {
    DMA: 564,
  },
  "26142": {
    DMA: 597,
  },
  "26143": {
    DMA: 564,
  },
  "26146": {
    DMA: 554,
  },
  "26147": {
    DMA: 564,
  },
  "26148": {
    DMA: 598,
  },
  "26149": {
    DMA: 554,
  },
  "26150": {
    DMA: 597,
  },
  "26151": {
    DMA: 564,
  },
  "26152": {
    DMA: 564,
  },
  "26155": {
    DMA: 554,
  },
  "26159": {
    DMA: 554,
  },
  "26160": {
    DMA: 564,
  },
  "26161": {
    DMA: 598,
  },
  "26162": {
    DMA: 554,
  },
  "26164": {
    DMA: 564,
  },
  "26167": {
    DMA: 554,
  },
  "26169": {
    DMA: 597,
  },
  "26170": {
    DMA: 597,
  },
  "26175": {
    DMA: 554,
  },
  "26178": {
    DMA: 598,
  },
  "26180": {
    DMA: 597,
  },
  "26181": {
    DMA: 597,
  },
  "26184": {
    DMA: 597,
  },
  "26187": {
    DMA: 597,
  },
  "26201": {
    DMA: 598,
  },
  "26202": {
    DMA: 564,
  },
  "26203": {
    DMA: 598,
  },
  "26205": {
    DMA: 564,
  },
  "26206": {
    DMA: 598,
  },
  "26208": {
    DMA: 598,
  },
  "26209": {
    DMA: 573,
  },
  "26210": {
    DMA: 598,
  },
  "26215": {
    DMA: 598,
  },
  "26217": {
    DMA: 598,
  },
  "26218": {
    DMA: 598,
  },
  "26219": {
    DMA: 598,
  },
  "26222": {
    DMA: 598,
  },
  "26224": {
    DMA: 598,
  },
  "26228": {
    DMA: 598,
  },
  "26229": {
    DMA: 598,
  },
  "26230": {
    DMA: 598,
  },
  "26234": {
    DMA: 598,
  },
  "26236": {
    DMA: 598,
  },
  "26237": {
    DMA: 598,
  },
  "26238": {
    DMA: 598,
  },
  "26241": {
    DMA: 598,
  },
  "26250": {
    DMA: 598,
  },
  "26253": {
    DMA: 598,
  },
  "26254": {
    DMA: 598,
  },
  "26257": {
    DMA: 598,
  },
  "26259": {
    DMA: 598,
  },
  "26260": {
    DMA: 598,
  },
  "26261": {
    DMA: 564,
  },
  "26263": {
    DMA: 598,
  },
  "26264": {
    DMA: 573,
  },
  "26266": {
    DMA: 598,
  },
  "26267": {
    DMA: 598,
  },
  "26268": {
    DMA: 598,
  },
  "26269": {
    DMA: 598,
  },
  "26270": {
    DMA: 598,
  },
  "26271": {
    DMA: 598,
  },
  "26273": {
    DMA: 598,
  },
  "26275": {
    DMA: 598,
  },
  "26276": {
    DMA: 598,
  },
  "26278": {
    DMA: 598,
  },
  "26280": {
    DMA: 598,
  },
  "26282": {
    DMA: 598,
  },
  "26283": {
    DMA: 598,
  },
  "26285": {
    DMA: 598,
  },
  "26287": {
    DMA: 598,
  },
  "26288": {
    DMA: 598,
  },
  "26289": {
    DMA: 598,
  },
  "26291": {
    DMA: 573,
  },
  "26292": {
    DMA: 598,
  },
  "26293": {
    DMA: 598,
  },
  "26294": {
    DMA: 598,
  },
  "26296": {
    DMA: 598,
  },
  "26298": {
    DMA: 598,
  },
  "26301": {
    DMA: 598,
  },
  "26302": {
    DMA: 598,
  },
  "26306": {
    DMA: 598,
  },
  "26320": {
    DMA: 554,
  },
  "26321": {
    DMA: 598,
  },
  "26323": {
    DMA: 598,
  },
  "26325": {
    DMA: 598,
  },
  "26327": {
    DMA: 598,
  },
  "26330": {
    DMA: 598,
  },
  "26335": {
    DMA: 564,
  },
  "26337": {
    DMA: 598,
  },
  "26338": {
    DMA: 598,
  },
  "26339": {
    DMA: 598,
  },
  "26342": {
    DMA: 598,
  },
  "26343": {
    DMA: 598,
  },
  "26346": {
    DMA: 598,
  },
  "26347": {
    DMA: 598,
  },
  "26348": {
    DMA: 554,
  },
  "26349": {
    DMA: 598,
  },
  "26351": {
    DMA: 598,
  },
  "26354": {
    DMA: 598,
  },
  "26361": {
    DMA: 598,
  },
  "26362": {
    DMA: 598,
  },
  "26366": {
    DMA: 598,
  },
  "26369": {
    DMA: 598,
  },
  "26372": {
    DMA: 598,
  },
  "26374": {
    DMA: 508,
  },
  "26376": {
    DMA: 598,
  },
  "26377": {
    DMA: 554,
  },
  "26378": {
    DMA: 598,
  },
  "26384": {
    DMA: 598,
  },
  "26385": {
    DMA: 598,
  },
  "26386": {
    DMA: 598,
  },
  "26404": {
    DMA: 598,
  },
  "26405": {
    DMA: 598,
  },
  "26408": {
    DMA: 598,
  },
  "26410": {
    DMA: 508,
  },
  "26411": {
    DMA: 598,
  },
  "26412": {
    DMA: 598,
  },
  "26415": {
    DMA: 598,
  },
  "26416": {
    DMA: 598,
  },
  "26419": {
    DMA: 554,
  },
  "26421": {
    DMA: 598,
  },
  "26422": {
    DMA: 598,
  },
  "26424": {
    DMA: 598,
  },
  "26425": {
    DMA: 508,
  },
  "26426": {
    DMA: 598,
  },
  "26430": {
    DMA: 598,
  },
  "26431": {
    DMA: 598,
  },
  "26434": {
    DMA: 554,
  },
  "26435": {
    DMA: 598,
  },
  "26436": {
    DMA: 598,
  },
  "26437": {
    DMA: 554,
  },
  "26438": {
    DMA: 598,
  },
  "26440": {
    DMA: 598,
  },
  "26443": {
    DMA: 598,
  },
  "26444": {
    DMA: 508,
  },
  "26447": {
    DMA: 598,
  },
  "26448": {
    DMA: 598,
  },
  "26451": {
    DMA: 598,
  },
  "26452": {
    DMA: 598,
  },
  "26456": {
    DMA: 598,
  },
  "26461": {
    DMA: 598,
  },
  "26463": {
    DMA: 598,
  },
  "26501": {
    DMA: 508,
  },
  "26502": {
    DMA: 508,
  },
  "26504": {
    DMA: 508,
  },
  "26505": {
    DMA: 508,
  },
  "26506": {
    DMA: 508,
  },
  "26507": {
    DMA: 508,
  },
  "26508": {
    DMA: 508,
  },
  "26519": {
    DMA: 508,
  },
  "26520": {
    DMA: 508,
  },
  "26521": {
    DMA: 508,
  },
  "26524": {
    DMA: 508,
  },
  "26525": {
    DMA: 508,
  },
  "26527": {
    DMA: 508,
  },
  "26531": {
    DMA: 508,
  },
  "26534": {
    DMA: 508,
  },
  "26537": {
    DMA: 508,
  },
  "26541": {
    DMA: 508,
  },
  "26542": {
    DMA: 508,
  },
  "26543": {
    DMA: 508,
  },
  "26544": {
    DMA: 508,
  },
  "26546": {
    DMA: 508,
  },
  "26547": {
    DMA: 508,
  },
  "26554": {
    DMA: 598,
  },
  "26555": {
    DMA: 598,
  },
  "26559": {
    DMA: 598,
  },
  "26560": {
    DMA: 598,
  },
  "26561": {
    DMA: 554,
  },
  "26562": {
    DMA: 554,
  },
  "26563": {
    DMA: 598,
  },
  "26566": {
    DMA: 598,
  },
  "26568": {
    DMA: 598,
  },
  "26570": {
    DMA: 598,
  },
  "26571": {
    DMA: 598,
  },
  "26572": {
    DMA: 598,
  },
  "26574": {
    DMA: 598,
  },
  "26575": {
    DMA: 554,
  },
  "26576": {
    DMA: 598,
  },
  "26578": {
    DMA: 598,
  },
  "26581": {
    DMA: 554,
  },
  "26582": {
    DMA: 598,
  },
  "26585": {
    DMA: 598,
  },
  "26586": {
    DMA: 598,
  },
  "26587": {
    DMA: 598,
  },
  "26588": {
    DMA: 598,
  },
  "26590": {
    DMA: 508,
  },
  "26591": {
    DMA: 598,
  },
  "26601": {
    DMA: 564,
  },
  "26610": {
    DMA: 564,
  },
  "26611": {
    DMA: 598,
  },
  "26615": {
    DMA: 564,
  },
  "26617": {
    DMA: 564,
  },
  "26619": {
    DMA: 564,
  },
  "26621": {
    DMA: 564,
  },
  "26623": {
    DMA: 564,
  },
  "26624": {
    DMA: 564,
  },
  "26627": {
    DMA: 564,
  },
  "26629": {
    DMA: 564,
  },
  "26631": {
    DMA: 564,
  },
  "26636": {
    DMA: 598,
  },
  "26638": {
    DMA: 598,
  },
  "26651": {
    DMA: 564,
  },
  "26656": {
    DMA: 564,
  },
  "26660": {
    DMA: 564,
  },
  "26662": {
    DMA: 564,
  },
  "26667": {
    DMA: 564,
  },
  "26671": {
    DMA: 564,
  },
  "26675": {
    DMA: 564,
  },
  "26676": {
    DMA: 564,
  },
  "26678": {
    DMA: 564,
  },
  "26679": {
    DMA: 564,
  },
  "26680": {
    DMA: 559,
  },
  "26681": {
    DMA: 564,
  },
  "26684": {
    DMA: 564,
  },
  "26690": {
    DMA: 564,
  },
  "26691": {
    DMA: 564,
  },
  "26704": {
    DMA: 511,
  },
  "26705": {
    DMA: 508,
  },
  "26707": {
    DMA: 511,
  },
  "26710": {
    DMA: 511,
  },
  "26711": {
    DMA: 511,
  },
  "26714": {
    DMA: 511,
  },
  "26716": {
    DMA: 508,
  },
  "26717": {
    DMA: 511,
  },
  "26719": {
    DMA: 511,
  },
  "26720": {
    DMA: 511,
  },
  "26722": {
    DMA: 511,
  },
  "26726": {
    DMA: 511,
  },
  "26731": {
    DMA: 511,
  },
  "26739": {
    DMA: 511,
  },
  "26743": {
    DMA: 511,
  },
  "26750": {
    DMA: 511,
  },
  "26753": {
    DMA: 511,
  },
  "26755": {
    DMA: 511,
  },
  "26757": {
    DMA: 511,
  },
  "26761": {
    DMA: 511,
  },
  "26763": {
    DMA: 511,
  },
  "26764": {
    DMA: 508,
  },
  "26767": {
    DMA: 511,
  },
  "26801": {
    DMA: 511,
  },
  "26802": {
    DMA: 569,
  },
  "26804": {
    DMA: 569,
  },
  "26807": {
    DMA: 569,
  },
  "26808": {
    DMA: 511,
  },
  "26810": {
    DMA: 511,
  },
  "26812": {
    DMA: 511,
  },
  "26814": {
    DMA: 569,
  },
  "26815": {
    DMA: 569,
  },
  "26817": {
    DMA: 511,
  },
  "26818": {
    DMA: 511,
  },
  "26823": {
    DMA: 511,
  },
  "26833": {
    DMA: 511,
  },
  "26836": {
    DMA: 511,
  },
  "26838": {
    DMA: 511,
  },
  "26845": {
    DMA: 511,
  },
  "26847": {
    DMA: 511,
  },
  "26851": {
    DMA: 511,
  },
  "26852": {
    DMA: 511,
  },
  "26855": {
    DMA: 511,
  },
  "26865": {
    DMA: 511,
  },
  "26866": {
    DMA: 569,
  },
  "26884": {
    DMA: 569,
  },
  "26886": {
    DMA: 569,
  },
  "27006": {
    DMA: 518,
  },
  "27007": {
    DMA: 518,
  },
  "27009": {
    DMA: 518,
  },
  "27010": {
    DMA: 518,
  },
  "27011": {
    DMA: 518,
  },
  "27012": {
    DMA: 518,
  },
  "27013": {
    DMA: 517,
  },
  "27014": {
    DMA: 518,
  },
  "27016": {
    DMA: 518,
  },
  "27017": {
    DMA: 518,
  },
  "27018": {
    DMA: 518,
  },
  "27019": {
    DMA: 518,
  },
  "27020": {
    DMA: 518,
  },
  "27021": {
    DMA: 518,
  },
  "27022": {
    DMA: 518,
  },
  "27023": {
    DMA: 518,
  },
  "27024": {
    DMA: 518,
  },
  "27025": {
    DMA: 518,
  },
  "27027": {
    DMA: 518,
  },
  "27028": {
    DMA: 518,
  },
  "27030": {
    DMA: 518,
  },
  "27031": {
    DMA: 518,
  },
  "27040": {
    DMA: 518,
  },
  "27041": {
    DMA: 518,
  },
  "27042": {
    DMA: 518,
  },
  "27043": {
    DMA: 518,
  },
  "27045": {
    DMA: 518,
  },
  "27046": {
    DMA: 518,
  },
  "27047": {
    DMA: 518,
  },
  "27048": {
    DMA: 518,
  },
  "27049": {
    DMA: 518,
  },
  "27050": {
    DMA: 518,
  },
  "27051": {
    DMA: 518,
  },
  "27052": {
    DMA: 518,
  },
  "27053": {
    DMA: 518,
  },
  "27054": {
    DMA: 517,
  },
  "27055": {
    DMA: 518,
  },
  "27094": {
    DMA: 518,
  },
  "27098": {
    DMA: 518,
  },
  "27099": {
    DMA: 518,
  },
  "27101": {
    DMA: 518,
  },
  "27102": {
    DMA: 518,
  },
  "27103": {
    DMA: 518,
  },
  "27104": {
    DMA: 518,
  },
  "27105": {
    DMA: 518,
  },
  "27106": {
    DMA: 518,
  },
  "27107": {
    DMA: 518,
  },
  "27108": {
    DMA: 518,
  },
  "27109": {
    DMA: 518,
  },
  "27110": {
    DMA: 518,
  },
  "27111": {
    DMA: 518,
  },
  "27113": {
    DMA: 518,
  },
  "27114": {
    DMA: 518,
  },
  "27115": {
    DMA: 518,
  },
  "27116": {
    DMA: 518,
  },
  "27117": {
    DMA: 518,
  },
  "27120": {
    DMA: 518,
  },
  "27127": {
    DMA: 518,
  },
  "27130": {
    DMA: 518,
  },
  "27150": {
    DMA: 518,
  },
  "27151": {
    DMA: 518,
  },
  "27152": {
    DMA: 518,
  },
  "27155": {
    DMA: 518,
  },
  "27156": {
    DMA: 518,
  },
  "27157": {
    DMA: 518,
  },
  "27198": {
    DMA: 518,
  },
  "27199": {
    DMA: 518,
  },
  "27201": {
    DMA: 518,
  },
  "27202": {
    DMA: 518,
  },
  "27203": {
    DMA: 518,
  },
  "27204": {
    DMA: 518,
  },
  "27205": {
    DMA: 518,
  },
  "27207": {
    DMA: 560,
  },
  "27208": {
    DMA: 560,
  },
  "27209": {
    DMA: 518,
  },
  "27212": {
    DMA: 518,
  },
  "27213": {
    DMA: 560,
  },
  "27214": {
    DMA: 518,
  },
  "27215": {
    DMA: 518,
  },
  "27216": {
    DMA: 518,
  },
  "27217": {
    DMA: 518,
  },
  "27220": {
    DMA: 518,
  },
  "27228": {
    DMA: 560,
  },
  "27229": {
    DMA: 518,
  },
  "27230": {
    DMA: 518,
  },
  "27231": {
    DMA: 560,
  },
  "27233": {
    DMA: 518,
  },
  "27235": {
    DMA: 518,
  },
  "27237": {
    DMA: 560,
  },
  "27239": {
    DMA: 518,
  },
  "27242": {
    DMA: 560,
  },
  "27243": {
    DMA: 560,
  },
  "27244": {
    DMA: 518,
  },
  "27247": {
    DMA: 518,
  },
  "27248": {
    DMA: 518,
  },
  "27249": {
    DMA: 518,
  },
  "27252": {
    DMA: 560,
  },
  "27253": {
    DMA: 518,
  },
  "27256": {
    DMA: 560,
  },
  "27258": {
    DMA: 518,
  },
  "27259": {
    DMA: 560,
  },
  "27260": {
    DMA: 518,
  },
  "27261": {
    DMA: 518,
  },
  "27262": {
    DMA: 518,
  },
  "27263": {
    DMA: 518,
  },
  "27264": {
    DMA: 518,
  },
  "27265": {
    DMA: 518,
  },
  "27268": {
    DMA: 518,
  },
  "27278": {
    DMA: 560,
  },
  "27281": {
    DMA: 560,
  },
  "27282": {
    DMA: 518,
  },
  "27283": {
    DMA: 518,
  },
  "27284": {
    DMA: 518,
  },
  "27285": {
    DMA: 518,
  },
  "27288": {
    DMA: 518,
  },
  "27289": {
    DMA: 518,
  },
  "27291": {
    DMA: 518,
  },
  "27292": {
    DMA: 518,
  },
  "27293": {
    DMA: 518,
  },
  "27294": {
    DMA: 518,
  },
  "27295": {
    DMA: 518,
  },
  "27298": {
    DMA: 518,
  },
  "27299": {
    DMA: 518,
  },
  "27301": {
    DMA: 518,
  },
  "27302": {
    DMA: 518,
  },
  "27305": {
    DMA: 518,
  },
  "27306": {
    DMA: 518,
  },
  "27310": {
    DMA: 518,
  },
  "27311": {
    DMA: 518,
  },
  "27312": {
    DMA: 560,
  },
  "27313": {
    DMA: 518,
  },
  "27314": {
    DMA: 518,
  },
  "27315": {
    DMA: 518,
  },
  "27316": {
    DMA: 518,
  },
  "27317": {
    DMA: 518,
  },
  "27320": {
    DMA: 518,
  },
  "27321": {
    DMA: 518,
  },
  "27322": {
    DMA: 518,
  },
  "27323": {
    DMA: 518,
  },
  "27325": {
    DMA: 560,
  },
  "27326": {
    DMA: 518,
  },
  "27330": {
    DMA: 560,
  },
  "27331": {
    DMA: 560,
  },
  "27332": {
    DMA: 560,
  },
  "27340": {
    DMA: 518,
  },
  "27341": {
    DMA: 518,
  },
  "27342": {
    DMA: 518,
  },
  "27343": {
    DMA: 560,
  },
  "27344": {
    DMA: 560,
  },
  "27349": {
    DMA: 518,
  },
  "27350": {
    DMA: 518,
  },
  "27351": {
    DMA: 518,
  },
  "27355": {
    DMA: 518,
  },
  "27356": {
    DMA: 518,
  },
  "27357": {
    DMA: 518,
  },
  "27358": {
    DMA: 518,
  },
  "27359": {
    DMA: 518,
  },
  "27360": {
    DMA: 518,
  },
  "27361": {
    DMA: 518,
  },
  "27370": {
    DMA: 518,
  },
  "27371": {
    DMA: 518,
  },
  "27373": {
    DMA: 518,
  },
  "27374": {
    DMA: 518,
  },
  "27375": {
    DMA: 518,
  },
  "27376": {
    DMA: 560,
  },
  "27377": {
    DMA: 518,
  },
  "27379": {
    DMA: 518,
  },
  "27395": {
    DMA: 518,
  },
  "27401": {
    DMA: 518,
  },
  "27402": {
    DMA: 518,
  },
  "27403": {
    DMA: 518,
  },
  "27404": {
    DMA: 518,
  },
  "27405": {
    DMA: 518,
  },
  "27406": {
    DMA: 518,
  },
  "27407": {
    DMA: 518,
  },
  "27408": {
    DMA: 518,
  },
  "27409": {
    DMA: 518,
  },
  "27410": {
    DMA: 518,
  },
  "27411": {
    DMA: 518,
  },
  "27412": {
    DMA: 518,
  },
  "27413": {
    DMA: 518,
  },
  "27415": {
    DMA: 518,
  },
  "27416": {
    DMA: 518,
  },
  "27417": {
    DMA: 518,
  },
  "27419": {
    DMA: 518,
  },
  "27420": {
    DMA: 518,
  },
  "27425": {
    DMA: 518,
  },
  "27427": {
    DMA: 518,
  },
  "27429": {
    DMA: 518,
  },
  "27435": {
    DMA: 518,
  },
  "27438": {
    DMA: 518,
  },
  "27455": {
    DMA: 518,
  },
  "27480": {
    DMA: 518,
  },
  "27495": {
    DMA: 518,
  },
  "27497": {
    DMA: 518,
  },
  "27498": {
    DMA: 518,
  },
  "27499": {
    DMA: 518,
  },
  "27501": {
    DMA: 560,
  },
  "27502": {
    DMA: 560,
  },
  "27503": {
    DMA: 560,
  },
  "27504": {
    DMA: 560,
  },
  "27505": {
    DMA: 560,
  },
  "27506": {
    DMA: 560,
  },
  "27507": {
    DMA: 560,
  },
  "27508": {
    DMA: 560,
  },
  "27509": {
    DMA: 560,
  },
  "27510": {
    DMA: 560,
  },
  "27511": {
    DMA: 560,
  },
  "27512": {
    DMA: 560,
  },
  "27513": {
    DMA: 560,
  },
  "27514": {
    DMA: 560,
  },
  "27515": {
    DMA: 560,
  },
  "27516": {
    DMA: 560,
  },
  "27517": {
    DMA: 560,
  },
  "27518": {
    DMA: 560,
  },
  "27519": {
    DMA: 560,
  },
  "27520": {
    DMA: 560,
  },
  "27521": {
    DMA: 560,
  },
  "27522": {
    DMA: 560,
  },
  "27523": {
    DMA: 560,
  },
  "27524": {
    DMA: 560,
  },
  "27525": {
    DMA: 560,
  },
  "27526": {
    DMA: 560,
  },
  "27527": {
    DMA: 560,
  },
  "27528": {
    DMA: 560,
  },
  "27529": {
    DMA: 560,
  },
  "27530": {
    DMA: 560,
  },
  "27531": {
    DMA: 560,
  },
  "27532": {
    DMA: 560,
  },
  "27533": {
    DMA: 560,
  },
  "27534": {
    DMA: 560,
  },
  "27536": {
    DMA: 560,
  },
  "27537": {
    DMA: 560,
  },
  "27539": {
    DMA: 560,
  },
  "27540": {
    DMA: 560,
  },
  "27541": {
    DMA: 560,
  },
  "27542": {
    DMA: 560,
  },
  "27543": {
    DMA: 560,
  },
  "27544": {
    DMA: 560,
  },
  "27545": {
    DMA: 560,
  },
  "27546": {
    DMA: 560,
  },
  "27549": {
    DMA: 560,
  },
  "27551": {
    DMA: 560,
  },
  "27552": {
    DMA: 560,
  },
  "27553": {
    DMA: 560,
  },
  "27555": {
    DMA: 560,
  },
  "27556": {
    DMA: 560,
  },
  "27557": {
    DMA: 560,
  },
  "27559": {
    DMA: 560,
  },
  "27560": {
    DMA: 560,
  },
  "27562": {
    DMA: 560,
  },
  "27563": {
    DMA: 560,
  },
  "27564": {
    DMA: 560,
  },
  "27565": {
    DMA: 560,
  },
  "27568": {
    DMA: 560,
  },
  "27569": {
    DMA: 560,
  },
  "27570": {
    DMA: 560,
  },
  "27571": {
    DMA: 560,
  },
  "27572": {
    DMA: 560,
  },
  "27573": {
    DMA: 560,
  },
  "27574": {
    DMA: 560,
  },
  "27576": {
    DMA: 560,
  },
  "27577": {
    DMA: 560,
  },
  "27581": {
    DMA: 560,
  },
  "27582": {
    DMA: 560,
  },
  "27583": {
    DMA: 560,
  },
  "27584": {
    DMA: 560,
  },
  "27586": {
    DMA: 560,
  },
  "27587": {
    DMA: 560,
  },
  "27588": {
    DMA: 560,
  },
  "27589": {
    DMA: 560,
  },
  "27591": {
    DMA: 560,
  },
  "27592": {
    DMA: 560,
  },
  "27593": {
    DMA: 560,
  },
  "27594": {
    DMA: 560,
  },
  "27596": {
    DMA: 560,
  },
  "27597": {
    DMA: 560,
  },
  "27599": {
    DMA: 560,
  },
  "27601": {
    DMA: 560,
  },
  "27602": {
    DMA: 560,
  },
  "27603": {
    DMA: 560,
  },
  "27604": {
    DMA: 560,
  },
  "27605": {
    DMA: 560,
  },
  "27606": {
    DMA: 560,
  },
  "27607": {
    DMA: 560,
  },
  "27608": {
    DMA: 560,
  },
  "27609": {
    DMA: 560,
  },
  "27610": {
    DMA: 560,
  },
  "27611": {
    DMA: 560,
  },
  "27612": {
    DMA: 560,
  },
  "27613": {
    DMA: 560,
  },
  "27614": {
    DMA: 560,
  },
  "27615": {
    DMA: 560,
  },
  "27616": {
    DMA: 560,
  },
  "27617": {
    DMA: 560,
  },
  "27619": {
    DMA: 560,
  },
  "27620": {
    DMA: 560,
  },
  "27621": {
    DMA: 560,
  },
  "27622": {
    DMA: 560,
  },
  "27623": {
    DMA: 560,
  },
  "27624": {
    DMA: 560,
  },
  "27625": {
    DMA: 560,
  },
  "27626": {
    DMA: 560,
  },
  "27627": {
    DMA: 560,
  },
  "27628": {
    DMA: 560,
  },
  "27629": {
    DMA: 560,
  },
  "27634": {
    DMA: 560,
  },
  "27635": {
    DMA: 560,
  },
  "27636": {
    DMA: 560,
  },
  "27640": {
    DMA: 560,
  },
  "27650": {
    DMA: 560,
  },
  "27656": {
    DMA: 560,
  },
  "27658": {
    DMA: 560,
  },
  "27661": {
    DMA: 560,
  },
  "27668": {
    DMA: 560,
  },
  "27675": {
    DMA: 560,
  },
  "27676": {
    DMA: 560,
  },
  "27690": {
    DMA: 560,
  },
  "27695": {
    DMA: 560,
  },
  "27697": {
    DMA: 560,
  },
  "27698": {
    DMA: 560,
  },
  "27699": {
    DMA: 560,
  },
  "27701": {
    DMA: 560,
  },
  "27702": {
    DMA: 560,
  },
  "27703": {
    DMA: 560,
  },
  "27704": {
    DMA: 560,
  },
  "27705": {
    DMA: 560,
  },
  "27706": {
    DMA: 560,
  },
  "27707": {
    DMA: 560,
  },
  "27708": {
    DMA: 560,
  },
  "27709": {
    DMA: 560,
  },
  "27710": {
    DMA: 560,
  },
  "27711": {
    DMA: 560,
  },
  "27712": {
    DMA: 560,
  },
  "27713": {
    DMA: 560,
  },
  "27715": {
    DMA: 560,
  },
  "27717": {
    DMA: 560,
  },
  "27722": {
    DMA: 560,
  },
  "27801": {
    DMA: 560,
  },
  "27802": {
    DMA: 560,
  },
  "27803": {
    DMA: 560,
  },
  "27804": {
    DMA: 560,
  },
  "27805": {
    DMA: 545,
  },
  "27806": {
    DMA: 545,
  },
  "27807": {
    DMA: 560,
  },
  "27808": {
    DMA: 545,
  },
  "27809": {
    DMA: 560,
  },
  "27810": {
    DMA: 545,
  },
  "27811": {
    DMA: 545,
  },
  "27812": {
    DMA: 545,
  },
  "27813": {
    DMA: 560,
  },
  "27814": {
    DMA: 545,
  },
  "27815": {
    DMA: 560,
  },
  "27816": {
    DMA: 560,
  },
  "27817": {
    DMA: 545,
  },
  "27818": {
    DMA: 544,
  },
  "27819": {
    DMA: 560,
  },
  "27820": {
    DMA: 544,
  },
  "27821": {
    DMA: 545,
  },
  "27822": {
    DMA: 560,
  },
  "27823": {
    DMA: 560,
  },
  "27824": {
    DMA: 545,
  },
  "27825": {
    DMA: 545,
  },
  "27826": {
    DMA: 545,
  },
  "27827": {
    DMA: 545,
  },
  "27828": {
    DMA: 545,
  },
  "27829": {
    DMA: 545,
  },
  "27830": {
    DMA: 560,
  },
  "27831": {
    DMA: 544,
  },
  "27832": {
    DMA: 544,
  },
  "27833": {
    DMA: 545,
  },
  "27834": {
    DMA: 545,
  },
  "27835": {
    DMA: 545,
  },
  "27836": {
    DMA: 545,
  },
  "27837": {
    DMA: 545,
  },
  "27839": {
    DMA: 560,
  },
  "27840": {
    DMA: 545,
  },
  "27841": {
    DMA: 545,
  },
  "27842": {
    DMA: 544,
  },
  "27843": {
    DMA: 560,
  },
  "27844": {
    DMA: 560,
  },
  "27845": {
    DMA: 544,
  },
  "27846": {
    DMA: 545,
  },
  "27847": {
    DMA: 545,
  },
  "27849": {
    DMA: 545,
  },
  "27850": {
    DMA: 560,
  },
  "27851": {
    DMA: 560,
  },
  "27852": {
    DMA: 560,
  },
  "27853": {
    DMA: 544,
  },
  "27854": {
    DMA: 544,
  },
  "27855": {
    DMA: 544,
  },
  "27856": {
    DMA: 560,
  },
  "27857": {
    DMA: 545,
  },
  "27858": {
    DMA: 545,
  },
  "27860": {
    DMA: 545,
  },
  "27861": {
    DMA: 545,
  },
  "27862": {
    DMA: 544,
  },
  "27863": {
    DMA: 560,
  },
  "27864": {
    DMA: 560,
  },
  "27865": {
    DMA: 545,
  },
  "27866": {
    DMA: 544,
  },
  "27867": {
    DMA: 544,
  },
  "27868": {
    DMA: 560,
  },
  "27869": {
    DMA: 544,
  },
  "27870": {
    DMA: 560,
  },
  "27871": {
    DMA: 545,
  },
  "27872": {
    DMA: 545,
  },
  "27873": {
    DMA: 560,
  },
  "27874": {
    DMA: 560,
  },
  "27875": {
    DMA: 545,
  },
  "27876": {
    DMA: 544,
  },
  "27877": {
    DMA: 544,
  },
  "27878": {
    DMA: 560,
  },
  "27879": {
    DMA: 545,
  },
  "27880": {
    DMA: 560,
  },
  "27881": {
    DMA: 560,
  },
  "27882": {
    DMA: 560,
  },
  "27883": {
    DMA: 560,
  },
  "27884": {
    DMA: 545,
  },
  "27885": {
    DMA: 545,
  },
  "27886": {
    DMA: 560,
  },
  "27887": {
    DMA: 560,
  },
  "27888": {
    DMA: 545,
  },
  "27889": {
    DMA: 545,
  },
  "27890": {
    DMA: 560,
  },
  "27891": {
    DMA: 560,
  },
  "27892": {
    DMA: 545,
  },
  "27893": {
    DMA: 560,
  },
  "27894": {
    DMA: 560,
  },
  "27895": {
    DMA: 560,
  },
  "27896": {
    DMA: 560,
  },
  "27897": {
    DMA: 544,
  },
  "27906": {
    DMA: 544,
  },
  "27907": {
    DMA: 544,
  },
  "27909": {
    DMA: 544,
  },
  "27910": {
    DMA: 544,
  },
  "27915": {
    DMA: 544,
  },
  "27916": {
    DMA: 544,
  },
  "27917": {
    DMA: 544,
  },
  "27919": {
    DMA: 544,
  },
  "27920": {
    DMA: 544,
  },
  "27921": {
    DMA: 544,
  },
  "27922": {
    DMA: 544,
  },
  "27923": {
    DMA: 544,
  },
  "27924": {
    DMA: 545,
  },
  "27925": {
    DMA: 545,
  },
  "27926": {
    DMA: 544,
  },
  "27927": {
    DMA: 544,
  },
  "27928": {
    DMA: 545,
  },
  "27929": {
    DMA: 544,
  },
  "27930": {
    DMA: 544,
  },
  "27932": {
    DMA: 544,
  },
  "27935": {
    DMA: 544,
  },
  "27936": {
    DMA: 544,
  },
  "27937": {
    DMA: 544,
  },
  "27938": {
    DMA: 544,
  },
  "27939": {
    DMA: 544,
  },
  "27941": {
    DMA: 544,
  },
  "27942": {
    DMA: 544,
  },
  "27943": {
    DMA: 544,
  },
  "27944": {
    DMA: 544,
  },
  "27946": {
    DMA: 544,
  },
  "27947": {
    DMA: 544,
  },
  "27948": {
    DMA: 544,
  },
  "27949": {
    DMA: 544,
  },
  "27950": {
    DMA: 544,
  },
  "27953": {
    DMA: 544,
  },
  "27954": {
    DMA: 544,
  },
  "27956": {
    DMA: 544,
  },
  "27957": {
    DMA: 545,
  },
  "27958": {
    DMA: 544,
  },
  "27959": {
    DMA: 544,
  },
  "27960": {
    DMA: 545,
  },
  "27962": {
    DMA: 545,
  },
  "27964": {
    DMA: 544,
  },
  "27965": {
    DMA: 544,
  },
  "27966": {
    DMA: 544,
  },
  "27967": {
    DMA: 545,
  },
  "27968": {
    DMA: 544,
  },
  "27969": {
    DMA: 544,
  },
  "27970": {
    DMA: 545,
  },
  "27972": {
    DMA: 544,
  },
  "27973": {
    DMA: 544,
  },
  "27974": {
    DMA: 544,
  },
  "27976": {
    DMA: 544,
  },
  "27978": {
    DMA: 544,
  },
  "27979": {
    DMA: 544,
  },
  "27980": {
    DMA: 544,
  },
  "27981": {
    DMA: 544,
  },
  "27982": {
    DMA: 544,
  },
  "27983": {
    DMA: 545,
  },
  "27985": {
    DMA: 544,
  },
  "27986": {
    DMA: 544,
  },
  "28001": {
    DMA: 517,
  },
  "28002": {
    DMA: 517,
  },
  "28006": {
    DMA: 517,
  },
  "28007": {
    DMA: 517,
  },
  "28009": {
    DMA: 517,
  },
  "28010": {
    DMA: 517,
  },
  "28012": {
    DMA: 517,
  },
  "28016": {
    DMA: 517,
  },
  "28017": {
    DMA: 517,
  },
  "28018": {
    DMA: 567,
  },
  "28019": {
    DMA: 567,
  },
  "28020": {
    DMA: 517,
  },
  "28021": {
    DMA: 517,
  },
  "28023": {
    DMA: 517,
  },
  "28024": {
    DMA: 567,
  },
  "28025": {
    DMA: 517,
  },
  "28026": {
    DMA: 517,
  },
  "28027": {
    DMA: 517,
  },
  "28031": {
    DMA: 517,
  },
  "28032": {
    DMA: 517,
  },
  "28033": {
    DMA: 517,
  },
  "28034": {
    DMA: 517,
  },
  "28035": {
    DMA: 517,
  },
  "28036": {
    DMA: 517,
  },
  "28037": {
    DMA: 517,
  },
  "28038": {
    DMA: 517,
  },
  "28039": {
    DMA: 517,
  },
  "28040": {
    DMA: 567,
  },
  "28041": {
    DMA: 517,
  },
  "28042": {
    DMA: 517,
  },
  "28043": {
    DMA: 567,
  },
  "28052": {
    DMA: 517,
  },
  "28053": {
    DMA: 517,
  },
  "28054": {
    DMA: 517,
  },
  "28055": {
    DMA: 517,
  },
  "28056": {
    DMA: 517,
  },
  "28070": {
    DMA: 517,
  },
  "28071": {
    DMA: 517,
  },
  "28072": {
    DMA: 517,
  },
  "28073": {
    DMA: 517,
  },
  "28074": {
    DMA: 567,
  },
  "28075": {
    DMA: 517,
  },
  "28076": {
    DMA: 567,
  },
  "28077": {
    DMA: 517,
  },
  "28078": {
    DMA: 517,
  },
  "28079": {
    DMA: 517,
  },
  "28080": {
    DMA: 517,
  },
  "28081": {
    DMA: 517,
  },
  "28082": {
    DMA: 517,
  },
  "28083": {
    DMA: 517,
  },
  "28086": {
    DMA: 517,
  },
  "28088": {
    DMA: 517,
  },
  "28089": {
    DMA: 517,
  },
  "28090": {
    DMA: 517,
  },
  "28091": {
    DMA: 517,
  },
  "28092": {
    DMA: 517,
  },
  "28093": {
    DMA: 517,
  },
  "28097": {
    DMA: 517,
  },
  "28098": {
    DMA: 517,
  },
  "28101": {
    DMA: 517,
  },
  "28102": {
    DMA: 517,
  },
  "28103": {
    DMA: 517,
  },
  "28104": {
    DMA: 517,
  },
  "28105": {
    DMA: 517,
  },
  "28106": {
    DMA: 517,
  },
  "28107": {
    DMA: 517,
  },
  "28108": {
    DMA: 517,
  },
  "28109": {
    DMA: 517,
  },
  "28110": {
    DMA: 517,
  },
  "28111": {
    DMA: 517,
  },
  "28112": {
    DMA: 517,
  },
  "28114": {
    DMA: 517,
  },
  "28115": {
    DMA: 517,
  },
  "28117": {
    DMA: 517,
  },
  "28119": {
    DMA: 517,
  },
  "28120": {
    DMA: 517,
  },
  "28123": {
    DMA: 517,
  },
  "28124": {
    DMA: 517,
  },
  "28125": {
    DMA: 517,
  },
  "28126": {
    DMA: 517,
  },
  "28127": {
    DMA: 517,
  },
  "28128": {
    DMA: 517,
  },
  "28129": {
    DMA: 517,
  },
  "28130": {
    DMA: 517,
  },
  "28133": {
    DMA: 517,
  },
  "28134": {
    DMA: 517,
  },
  "28135": {
    DMA: 517,
  },
  "28136": {
    DMA: 517,
  },
  "28137": {
    DMA: 517,
  },
  "28138": {
    DMA: 517,
  },
  "28139": {
    DMA: 567,
  },
  "28144": {
    DMA: 517,
  },
  "28145": {
    DMA: 517,
  },
  "28146": {
    DMA: 517,
  },
  "28147": {
    DMA: 517,
  },
  "28150": {
    DMA: 517,
  },
  "28151": {
    DMA: 517,
  },
  "28152": {
    DMA: 517,
  },
  "28159": {
    DMA: 517,
  },
  "28160": {
    DMA: 567,
  },
  "28163": {
    DMA: 517,
  },
  "28164": {
    DMA: 517,
  },
  "28166": {
    DMA: 517,
  },
  "28167": {
    DMA: 567,
  },
  "28168": {
    DMA: 517,
  },
  "28169": {
    DMA: 517,
  },
  "28170": {
    DMA: 517,
  },
  "28173": {
    DMA: 517,
  },
  "28174": {
    DMA: 517,
  },
  "28201": {
    DMA: 517,
  },
  "28202": {
    DMA: 517,
  },
  "28203": {
    DMA: 517,
  },
  "28204": {
    DMA: 517,
  },
  "28205": {
    DMA: 517,
  },
  "28206": {
    DMA: 517,
  },
  "28207": {
    DMA: 517,
  },
  "28208": {
    DMA: 517,
  },
  "28209": {
    DMA: 517,
  },
  "28210": {
    DMA: 517,
  },
  "28211": {
    DMA: 517,
  },
  "28212": {
    DMA: 517,
  },
  "28213": {
    DMA: 517,
  },
  "28214": {
    DMA: 517,
  },
  "28215": {
    DMA: 517,
  },
  "28216": {
    DMA: 517,
  },
  "28217": {
    DMA: 517,
  },
  "28218": {
    DMA: 517,
  },
  "28219": {
    DMA: 517,
  },
  "28220": {
    DMA: 517,
  },
  "28221": {
    DMA: 517,
  },
  "28222": {
    DMA: 517,
  },
  "28223": {
    DMA: 517,
  },
  "28224": {
    DMA: 517,
  },
  "28226": {
    DMA: 517,
  },
  "28227": {
    DMA: 517,
  },
  "28228": {
    DMA: 517,
  },
  "28229": {
    DMA: 517,
  },
  "28230": {
    DMA: 517,
  },
  "28231": {
    DMA: 517,
  },
  "28232": {
    DMA: 517,
  },
  "28233": {
    DMA: 517,
  },
  "28234": {
    DMA: 517,
  },
  "28235": {
    DMA: 517,
  },
  "28236": {
    DMA: 517,
  },
  "28237": {
    DMA: 517,
  },
  "28241": {
    DMA: 517,
  },
  "28242": {
    DMA: 517,
  },
  "28243": {
    DMA: 517,
  },
  "28244": {
    DMA: 517,
  },
  "28246": {
    DMA: 517,
  },
  "28247": {
    DMA: 517,
  },
  "28250": {
    DMA: 517,
  },
  "28253": {
    DMA: 517,
  },
  "28254": {
    DMA: 517,
  },
  "28255": {
    DMA: 517,
  },
  "28256": {
    DMA: 517,
  },
  "28258": {
    DMA: 517,
  },
  "28260": {
    DMA: 517,
  },
  "28262": {
    DMA: 517,
  },
  "28263": {
    DMA: 517,
  },
  "28265": {
    DMA: 517,
  },
  "28266": {
    DMA: 517,
  },
  "28269": {
    DMA: 517,
  },
  "28270": {
    DMA: 517,
  },
  "28271": {
    DMA: 517,
  },
  "28272": {
    DMA: 517,
  },
  "28273": {
    DMA: 517,
  },
  "28274": {
    DMA: 517,
  },
  "28275": {
    DMA: 517,
  },
  "28277": {
    DMA: 517,
  },
  "28278": {
    DMA: 517,
  },
  "28280": {
    DMA: 517,
  },
  "28281": {
    DMA: 517,
  },
  "28282": {
    DMA: 517,
  },
  "28284": {
    DMA: 517,
  },
  "28285": {
    DMA: 517,
  },
  "28287": {
    DMA: 517,
  },
  "28288": {
    DMA: 517,
  },
  "28289": {
    DMA: 517,
  },
  "28290": {
    DMA: 517,
  },
  "28296": {
    DMA: 517,
  },
  "28297": {
    DMA: 517,
  },
  "28299": {
    DMA: 517,
  },
  "28301": {
    DMA: 560,
  },
  "28302": {
    DMA: 560,
  },
  "28303": {
    DMA: 560,
  },
  "28304": {
    DMA: 560,
  },
  "28305": {
    DMA: 560,
  },
  "28306": {
    DMA: 560,
  },
  "28307": {
    DMA: 560,
  },
  "28308": {
    DMA: 560,
  },
  "28309": {
    DMA: 560,
  },
  "28310": {
    DMA: 560,
  },
  "28311": {
    DMA: 560,
  },
  "28312": {
    DMA: 560,
  },
  "28314": {
    DMA: 560,
  },
  "28315": {
    DMA: 560,
  },
  "28318": {
    DMA: 560,
  },
  "28319": {
    DMA: 570,
  },
  "28320": {
    DMA: 550,
  },
  "28323": {
    DMA: 560,
  },
  "28325": {
    DMA: 545,
  },
  "28326": {
    DMA: 560,
  },
  "28327": {
    DMA: 560,
  },
  "28328": {
    DMA: 560,
  },
  "28329": {
    DMA: 560,
  },
  "28330": {
    DMA: 517,
  },
  "28331": {
    DMA: 560,
  },
  "28332": {
    DMA: 550,
  },
  "28333": {
    DMA: 560,
  },
  "28334": {
    DMA: 560,
  },
  "28335": {
    DMA: 560,
  },
  "28337": {
    DMA: 550,
  },
  "28338": {
    DMA: 517,
  },
  "28339": {
    DMA: 560,
  },
  "28340": {
    DMA: 570,
  },
  "28341": {
    DMA: 545,
  },
  "28342": {
    DMA: 560,
  },
  "28343": {
    DMA: 570,
  },
  "28344": {
    DMA: 560,
  },
  "28345": {
    DMA: 517,
  },
  "28347": {
    DMA: 517,
  },
  "28348": {
    DMA: 560,
  },
  "28349": {
    DMA: 545,
  },
  "28350": {
    DMA: 560,
  },
  "28351": {
    DMA: 570,
  },
  "28352": {
    DMA: 570,
  },
  "28353": {
    DMA: 570,
  },
  "28355": {
    DMA: 560,
  },
  "28356": {
    DMA: 560,
  },
  "28357": {
    DMA: 570,
  },
  "28358": {
    DMA: 570,
  },
  "28359": {
    DMA: 570,
  },
  "28360": {
    DMA: 570,
  },
  "28362": {
    DMA: 570,
  },
  "28363": {
    DMA: 517,
  },
  "28364": {
    DMA: 570,
  },
  "28365": {
    DMA: 560,
  },
  "28366": {
    DMA: 560,
  },
  "28367": {
    DMA: 517,
  },
  "28368": {
    DMA: 560,
  },
  "28369": {
    DMA: 570,
  },
  "28370": {
    DMA: 560,
  },
  "28371": {
    DMA: 570,
  },
  "28372": {
    DMA: 570,
  },
  "28373": {
    DMA: 560,
  },
  "28374": {
    DMA: 560,
  },
  "28375": {
    DMA: 570,
  },
  "28376": {
    DMA: 560,
  },
  "28377": {
    DMA: 570,
  },
  "28378": {
    DMA: 570,
  },
  "28379": {
    DMA: 517,
  },
  "28380": {
    DMA: 517,
  },
  "28382": {
    DMA: 560,
  },
  "28383": {
    DMA: 570,
  },
  "28384": {
    DMA: 570,
  },
  "28385": {
    DMA: 560,
  },
  "28386": {
    DMA: 570,
  },
  "28387": {
    DMA: 560,
  },
  "28388": {
    DMA: 560,
  },
  "28390": {
    DMA: 560,
  },
  "28391": {
    DMA: 560,
  },
  "28392": {
    DMA: 550,
  },
  "28393": {
    DMA: 560,
  },
  "28394": {
    DMA: 560,
  },
  "28395": {
    DMA: 560,
  },
  "28396": {
    DMA: 570,
  },
  "28398": {
    DMA: 545,
  },
  "28399": {
    DMA: 550,
  },
  "28401": {
    DMA: 550,
  },
  "28402": {
    DMA: 550,
  },
  "28403": {
    DMA: 550,
  },
  "28404": {
    DMA: 550,
  },
  "28405": {
    DMA: 550,
  },
  "28406": {
    DMA: 550,
  },
  "28407": {
    DMA: 550,
  },
  "28408": {
    DMA: 550,
  },
  "28409": {
    DMA: 550,
  },
  "28410": {
    DMA: 550,
  },
  "28411": {
    DMA: 550,
  },
  "28412": {
    DMA: 550,
  },
  "28420": {
    DMA: 550,
  },
  "28421": {
    DMA: 550,
  },
  "28422": {
    DMA: 550,
  },
  "28423": {
    DMA: 550,
  },
  "28424": {
    DMA: 550,
  },
  "28425": {
    DMA: 550,
  },
  "28428": {
    DMA: 550,
  },
  "28429": {
    DMA: 550,
  },
  "28430": {
    DMA: 550,
  },
  "28431": {
    DMA: 550,
  },
  "28432": {
    DMA: 550,
  },
  "28433": {
    DMA: 550,
  },
  "28434": {
    DMA: 550,
  },
  "28435": {
    DMA: 550,
  },
  "28436": {
    DMA: 550,
  },
  "28438": {
    DMA: 550,
  },
  "28439": {
    DMA: 550,
  },
  "28441": {
    DMA: 560,
  },
  "28442": {
    DMA: 550,
  },
  "28443": {
    DMA: 550,
  },
  "28444": {
    DMA: 560,
  },
  "28445": {
    DMA: 545,
  },
  "28447": {
    DMA: 560,
  },
  "28448": {
    DMA: 550,
  },
  "28449": {
    DMA: 550,
  },
  "28450": {
    DMA: 550,
  },
  "28451": {
    DMA: 550,
  },
  "28452": {
    DMA: 550,
  },
  "28453": {
    DMA: 545,
  },
  "28454": {
    DMA: 550,
  },
  "28455": {
    DMA: 550,
  },
  "28456": {
    DMA: 550,
  },
  "28457": {
    DMA: 550,
  },
  "28458": {
    DMA: 545,
  },
  "28459": {
    DMA: 550,
  },
  "28460": {
    DMA: 545,
  },
  "28461": {
    DMA: 550,
  },
  "28462": {
    DMA: 550,
  },
  "28463": {
    DMA: 550,
  },
  "28464": {
    DMA: 545,
  },
  "28465": {
    DMA: 550,
  },
  "28466": {
    DMA: 545,
  },
  "28467": {
    DMA: 550,
  },
  "28468": {
    DMA: 550,
  },
  "28469": {
    DMA: 550,
  },
  "28470": {
    DMA: 550,
  },
  "28472": {
    DMA: 550,
  },
  "28478": {
    DMA: 550,
  },
  "28479": {
    DMA: 550,
  },
  "28480": {
    DMA: 550,
  },
  "28501": {
    DMA: 545,
  },
  "28502": {
    DMA: 545,
  },
  "28503": {
    DMA: 545,
  },
  "28504": {
    DMA: 545,
  },
  "28508": {
    DMA: 545,
  },
  "28509": {
    DMA: 545,
  },
  "28510": {
    DMA: 545,
  },
  "28511": {
    DMA: 545,
  },
  "28512": {
    DMA: 545,
  },
  "28513": {
    DMA: 545,
  },
  "28515": {
    DMA: 545,
  },
  "28516": {
    DMA: 545,
  },
  "28518": {
    DMA: 545,
  },
  "28519": {
    DMA: 545,
  },
  "28520": {
    DMA: 545,
  },
  "28521": {
    DMA: 545,
  },
  "28522": {
    DMA: 545,
  },
  "28523": {
    DMA: 545,
  },
  "28524": {
    DMA: 545,
  },
  "28525": {
    DMA: 545,
  },
  "28526": {
    DMA: 545,
  },
  "28527": {
    DMA: 545,
  },
  "28528": {
    DMA: 545,
  },
  "28529": {
    DMA: 545,
  },
  "28530": {
    DMA: 545,
  },
  "28531": {
    DMA: 545,
  },
  "28532": {
    DMA: 545,
  },
  "28533": {
    DMA: 545,
  },
  "28537": {
    DMA: 545,
  },
  "28538": {
    DMA: 545,
  },
  "28539": {
    DMA: 545,
  },
  "28540": {
    DMA: 545,
  },
  "28541": {
    DMA: 545,
  },
  "28542": {
    DMA: 545,
  },
  "28543": {
    DMA: 545,
  },
  "28544": {
    DMA: 545,
  },
  "28545": {
    DMA: 545,
  },
  "28546": {
    DMA: 545,
  },
  "28547": {
    DMA: 545,
  },
  "28551": {
    DMA: 545,
  },
  "28552": {
    DMA: 545,
  },
  "28553": {
    DMA: 545,
  },
  "28554": {
    DMA: 545,
  },
  "28555": {
    DMA: 545,
  },
  "28556": {
    DMA: 545,
  },
  "28557": {
    DMA: 545,
  },
  "28560": {
    DMA: 545,
  },
  "28561": {
    DMA: 545,
  },
  "28562": {
    DMA: 545,
  },
  "28563": {
    DMA: 545,
  },
  "28564": {
    DMA: 545,
  },
  "28570": {
    DMA: 545,
  },
  "28571": {
    DMA: 545,
  },
  "28572": {
    DMA: 545,
  },
  "28573": {
    DMA: 545,
  },
  "28574": {
    DMA: 545,
  },
  "28575": {
    DMA: 545,
  },
  "28577": {
    DMA: 545,
  },
  "28578": {
    DMA: 560,
  },
  "28579": {
    DMA: 545,
  },
  "28580": {
    DMA: 545,
  },
  "28581": {
    DMA: 545,
  },
  "28582": {
    DMA: 545,
  },
  "28583": {
    DMA: 545,
  },
  "28584": {
    DMA: 545,
  },
  "28585": {
    DMA: 545,
  },
  "28586": {
    DMA: 545,
  },
  "28587": {
    DMA: 545,
  },
  "28589": {
    DMA: 545,
  },
  "28590": {
    DMA: 545,
  },
  "28594": {
    DMA: 545,
  },
  "28601": {
    DMA: 517,
  },
  "28602": {
    DMA: 517,
  },
  "28603": {
    DMA: 517,
  },
  "28604": {
    DMA: 517,
  },
  "28605": {
    DMA: 517,
  },
  "28606": {
    DMA: 518,
  },
  "28607": {
    DMA: 517,
  },
  "28608": {
    DMA: 517,
  },
  "28609": {
    DMA: 517,
  },
  "28610": {
    DMA: 517,
  },
  "28611": {
    DMA: 517,
  },
  "28612": {
    DMA: 517,
  },
  "28613": {
    DMA: 517,
  },
  "28615": {
    DMA: 517,
  },
  "28616": {
    DMA: 517,
  },
  "28617": {
    DMA: 517,
  },
  "28618": {
    DMA: 517,
  },
  "28619": {
    DMA: 517,
  },
  "28621": {
    DMA: 518,
  },
  "28622": {
    DMA: 517,
  },
  "28623": {
    DMA: 518,
  },
  "28624": {
    DMA: 518,
  },
  "28625": {
    DMA: 517,
  },
  "28626": {
    DMA: 517,
  },
  "28627": {
    DMA: 518,
  },
  "28628": {
    DMA: 517,
  },
  "28629": {
    DMA: 517,
  },
  "28630": {
    DMA: 517,
  },
  "28631": {
    DMA: 517,
  },
  "28633": {
    DMA: 517,
  },
  "28634": {
    DMA: 517,
  },
  "28635": {
    DMA: 518,
  },
  "28636": {
    DMA: 517,
  },
  "28637": {
    DMA: 517,
  },
  "28638": {
    DMA: 517,
  },
  "28640": {
    DMA: 517,
  },
  "28641": {
    DMA: 517,
  },
  "28642": {
    DMA: 518,
  },
  "28643": {
    DMA: 517,
  },
  "28644": {
    DMA: 518,
  },
  "28645": {
    DMA: 517,
  },
  "28646": {
    DMA: 517,
  },
  "28647": {
    DMA: 517,
  },
  "28649": {
    DMA: 518,
  },
  "28650": {
    DMA: 517,
  },
  "28651": {
    DMA: 518,
  },
  "28652": {
    DMA: 517,
  },
  "28653": {
    DMA: 517,
  },
  "28654": {
    DMA: 518,
  },
  "28655": {
    DMA: 517,
  },
  "28656": {
    DMA: 518,
  },
  "28657": {
    DMA: 517,
  },
  "28658": {
    DMA: 517,
  },
  "28659": {
    DMA: 518,
  },
  "28660": {
    DMA: 517,
  },
  "28661": {
    DMA: 517,
  },
  "28662": {
    DMA: 517,
  },
  "28663": {
    DMA: 518,
  },
  "28664": {
    DMA: 517,
  },
  "28665": {
    DMA: 518,
  },
  "28666": {
    DMA: 517,
  },
  "28667": {
    DMA: 517,
  },
  "28668": {
    DMA: 518,
  },
  "28669": {
    DMA: 518,
  },
  "28670": {
    DMA: 518,
  },
  "28671": {
    DMA: 517,
  },
  "28672": {
    DMA: 517,
  },
  "28673": {
    DMA: 517,
  },
  "28674": {
    DMA: 518,
  },
  "28675": {
    DMA: 518,
  },
  "28676": {
    DMA: 518,
  },
  "28677": {
    DMA: 517,
  },
  "28678": {
    DMA: 517,
  },
  "28679": {
    DMA: 517,
  },
  "28680": {
    DMA: 517,
  },
  "28681": {
    DMA: 517,
  },
  "28682": {
    DMA: 517,
  },
  "28683": {
    DMA: 518,
  },
  "28684": {
    DMA: 517,
  },
  "28685": {
    DMA: 518,
  },
  "28687": {
    DMA: 517,
  },
  "28688": {
    DMA: 517,
  },
  "28689": {
    DMA: 517,
  },
  "28690": {
    DMA: 517,
  },
  "28691": {
    DMA: 517,
  },
  "28692": {
    DMA: 517,
  },
  "28693": {
    DMA: 517,
  },
  "28694": {
    DMA: 517,
  },
  "28697": {
    DMA: 518,
  },
  "28698": {
    DMA: 517,
  },
  "28699": {
    DMA: 517,
  },
  "28701": {
    DMA: 567,
  },
  "28702": {
    DMA: 567,
  },
  "28704": {
    DMA: 567,
  },
  "28705": {
    DMA: 567,
  },
  "28707": {
    DMA: 567,
  },
  "28708": {
    DMA: 567,
  },
  "28709": {
    DMA: 567,
  },
  "28710": {
    DMA: 567,
  },
  "28711": {
    DMA: 567,
  },
  "28712": {
    DMA: 567,
  },
  "28713": {
    DMA: 567,
  },
  "28714": {
    DMA: 567,
  },
  "28715": {
    DMA: 567,
  },
  "28716": {
    DMA: 567,
  },
  "28717": {
    DMA: 567,
  },
  "28718": {
    DMA: 567,
  },
  "28719": {
    DMA: 567,
  },
  "28720": {
    DMA: 567,
  },
  "28721": {
    DMA: 567,
  },
  "28722": {
    DMA: 567,
  },
  "28723": {
    DMA: 567,
  },
  "28724": {
    DMA: 567,
  },
  "28725": {
    DMA: 567,
  },
  "28726": {
    DMA: 567,
  },
  "28727": {
    DMA: 567,
  },
  "28728": {
    DMA: 567,
  },
  "28729": {
    DMA: 567,
  },
  "28730": {
    DMA: 567,
  },
  "28731": {
    DMA: 567,
  },
  "28732": {
    DMA: 567,
  },
  "28733": {
    DMA: 567,
  },
  "28734": {
    DMA: 567,
  },
  "28735": {
    DMA: 567,
  },
  "28736": {
    DMA: 567,
  },
  "28737": {
    DMA: 567,
  },
  "28738": {
    DMA: 567,
  },
  "28739": {
    DMA: 567,
  },
  "28740": {
    DMA: 567,
  },
  "28741": {
    DMA: 567,
  },
  "28742": {
    DMA: 567,
  },
  "28743": {
    DMA: 567,
  },
  "28744": {
    DMA: 567,
  },
  "28745": {
    DMA: 567,
  },
  "28746": {
    DMA: 567,
  },
  "28747": {
    DMA: 567,
  },
  "28748": {
    DMA: 567,
  },
  "28749": {
    DMA: 567,
  },
  "28750": {
    DMA: 567,
  },
  "28751": {
    DMA: 567,
  },
  "28752": {
    DMA: 567,
  },
  "28753": {
    DMA: 567,
  },
  "28754": {
    DMA: 567,
  },
  "28755": {
    DMA: 567,
  },
  "28756": {
    DMA: 567,
  },
  "28757": {
    DMA: 567,
  },
  "28758": {
    DMA: 567,
  },
  "28759": {
    DMA: 567,
  },
  "28760": {
    DMA: 567,
  },
  "28761": {
    DMA: 567,
  },
  "28762": {
    DMA: 567,
  },
  "28763": {
    DMA: 567,
  },
  "28765": {
    DMA: 567,
  },
  "28766": {
    DMA: 567,
  },
  "28768": {
    DMA: 567,
  },
  "28770": {
    DMA: 567,
  },
  "28771": {
    DMA: 567,
  },
  "28772": {
    DMA: 567,
  },
  "28773": {
    DMA: 567,
  },
  "28774": {
    DMA: 567,
  },
  "28775": {
    DMA: 567,
  },
  "28776": {
    DMA: 567,
  },
  "28777": {
    DMA: 567,
  },
  "28778": {
    DMA: 567,
  },
  "28779": {
    DMA: 567,
  },
  "28781": {
    DMA: 575,
  },
  "28782": {
    DMA: 567,
  },
  "28783": {
    DMA: 567,
  },
  "28784": {
    DMA: 567,
  },
  "28785": {
    DMA: 567,
  },
  "28786": {
    DMA: 567,
  },
  "28787": {
    DMA: 567,
  },
  "28788": {
    DMA: 567,
  },
  "28789": {
    DMA: 567,
  },
  "28790": {
    DMA: 567,
  },
  "28791": {
    DMA: 567,
  },
  "28792": {
    DMA: 567,
  },
  "28793": {
    DMA: 567,
  },
  "28801": {
    DMA: 567,
  },
  "28802": {
    DMA: 567,
  },
  "28803": {
    DMA: 567,
  },
  "28804": {
    DMA: 567,
  },
  "28805": {
    DMA: 567,
  },
  "28806": {
    DMA: 567,
  },
  "28810": {
    DMA: 567,
  },
  "28813": {
    DMA: 567,
  },
  "28814": {
    DMA: 567,
  },
  "28815": {
    DMA: 567,
  },
  "28816": {
    DMA: 567,
  },
  "28901": {
    DMA: 575,
  },
  "28902": {
    DMA: 524,
  },
  "28903": {
    DMA: 575,
  },
  "28904": {
    DMA: 524,
  },
  "28905": {
    DMA: 575,
  },
  "28906": {
    DMA: 575,
  },
  "28909": {
    DMA: 524,
  },
  "29001": {
    DMA: 546,
  },
  "29002": {
    DMA: 546,
  },
  "29003": {
    DMA: 520,
  },
  "29006": {
    DMA: 546,
  },
  "29009": {
    DMA: 546,
  },
  "29010": {
    DMA: 546,
  },
  "29014": {
    DMA: 517,
  },
  "29015": {
    DMA: 546,
  },
  "29016": {
    DMA: 546,
  },
  "29018": {
    DMA: 546,
  },
  "29020": {
    DMA: 546,
  },
  "29021": {
    DMA: 546,
  },
  "29030": {
    DMA: 546,
  },
  "29031": {
    DMA: 567,
  },
  "29032": {
    DMA: 546,
  },
  "29033": {
    DMA: 546,
  },
  "29036": {
    DMA: 546,
  },
  "29037": {
    DMA: 546,
  },
  "29038": {
    DMA: 546,
  },
  "29039": {
    DMA: 546,
  },
  "29040": {
    DMA: 546,
  },
  "29041": {
    DMA: 546,
  },
  "29042": {
    DMA: 520,
  },
  "29044": {
    DMA: 546,
  },
  "29045": {
    DMA: 546,
  },
  "29046": {
    DMA: 546,
  },
  "29047": {
    DMA: 546,
  },
  "29048": {
    DMA: 546,
  },
  "29051": {
    DMA: 546,
  },
  "29052": {
    DMA: 546,
  },
  "29053": {
    DMA: 546,
  },
  "29054": {
    DMA: 546,
  },
  "29055": {
    DMA: 517,
  },
  "29056": {
    DMA: 519,
  },
  "29058": {
    DMA: 517,
  },
  "29059": {
    DMA: 546,
  },
  "29061": {
    DMA: 546,
  },
  "29062": {
    DMA: 546,
  },
  "29063": {
    DMA: 546,
  },
  "29065": {
    DMA: 546,
  },
  "29067": {
    DMA: 517,
  },
  "29069": {
    DMA: 570,
  },
  "29070": {
    DMA: 546,
  },
  "29071": {
    DMA: 546,
  },
  "29072": {
    DMA: 546,
  },
  "29073": {
    DMA: 546,
  },
  "29074": {
    DMA: 546,
  },
  "29075": {
    DMA: 546,
  },
  "29078": {
    DMA: 546,
  },
  "29079": {
    DMA: 570,
  },
  "29080": {
    DMA: 546,
  },
  "29081": {
    DMA: 520,
  },
  "29082": {
    DMA: 519,
  },
  "29101": {
    DMA: 517,
  },
  "29102": {
    DMA: 546,
  },
  "29104": {
    DMA: 546,
  },
  "29105": {
    DMA: 520,
  },
  "29107": {
    DMA: 546,
  },
  "29108": {
    DMA: 546,
  },
  "29111": {
    DMA: 546,
  },
  "29112": {
    DMA: 546,
  },
  "29113": {
    DMA: 546,
  },
  "29114": {
    DMA: 570,
  },
  "29115": {
    DMA: 546,
  },
  "29116": {
    DMA: 546,
  },
  "29117": {
    DMA: 546,
  },
  "29118": {
    DMA: 546,
  },
  "29122": {
    DMA: 546,
  },
  "29123": {
    DMA: 546,
  },
  "29125": {
    DMA: 546,
  },
  "29126": {
    DMA: 546,
  },
  "29127": {
    DMA: 546,
  },
  "29128": {
    DMA: 546,
  },
  "29129": {
    DMA: 546,
  },
  "29130": {
    DMA: 546,
  },
  "29132": {
    DMA: 546,
  },
  "29133": {
    DMA: 546,
  },
  "29135": {
    DMA: 546,
  },
  "29137": {
    DMA: 520,
  },
  "29138": {
    DMA: 546,
  },
  "29142": {
    DMA: 546,
  },
  "29143": {
    DMA: 546,
  },
  "29145": {
    DMA: 546,
  },
  "29146": {
    DMA: 546,
  },
  "29147": {
    DMA: 546,
  },
  "29148": {
    DMA: 546,
  },
  "29150": {
    DMA: 546,
  },
  "29151": {
    DMA: 546,
  },
  "29152": {
    DMA: 546,
  },
  "29153": {
    DMA: 546,
  },
  "29154": {
    DMA: 546,
  },
  "29160": {
    DMA: 546,
  },
  "29161": {
    DMA: 570,
  },
  "29162": {
    DMA: 546,
  },
  "29163": {
    DMA: 546,
  },
  "29164": {
    DMA: 520,
  },
  "29166": {
    DMA: 546,
  },
  "29168": {
    DMA: 546,
  },
  "29169": {
    DMA: 546,
  },
  "29170": {
    DMA: 546,
  },
  "29171": {
    DMA: 546,
  },
  "29172": {
    DMA: 546,
  },
  "29175": {
    DMA: 546,
  },
  "29177": {
    DMA: 546,
  },
  "29178": {
    DMA: 546,
  },
  "29180": {
    DMA: 546,
  },
  "29201": {
    DMA: 546,
  },
  "29202": {
    DMA: 546,
  },
  "29203": {
    DMA: 546,
  },
  "29204": {
    DMA: 546,
  },
  "29205": {
    DMA: 546,
  },
  "29206": {
    DMA: 546,
  },
  "29207": {
    DMA: 546,
  },
  "29208": {
    DMA: 546,
  },
  "29209": {
    DMA: 546,
  },
  "29210": {
    DMA: 546,
  },
  "29211": {
    DMA: 546,
  },
  "29212": {
    DMA: 546,
  },
  "29214": {
    DMA: 546,
  },
  "29215": {
    DMA: 546,
  },
  "29216": {
    DMA: 546,
  },
  "29217": {
    DMA: 546,
  },
  "29218": {
    DMA: 546,
  },
  "29219": {
    DMA: 546,
  },
  "29220": {
    DMA: 546,
  },
  "29221": {
    DMA: 546,
  },
  "29222": {
    DMA: 546,
  },
  "29223": {
    DMA: 546,
  },
  "29224": {
    DMA: 546,
  },
  "29225": {
    DMA: 546,
  },
  "29226": {
    DMA: 546,
  },
  "29227": {
    DMA: 546,
  },
  "29228": {
    DMA: 546,
  },
  "29229": {
    DMA: 546,
  },
  "29230": {
    DMA: 546,
  },
  "29240": {
    DMA: 546,
  },
  "29250": {
    DMA: 546,
  },
  "29260": {
    DMA: 546,
  },
  "29290": {
    DMA: 546,
  },
  "29292": {
    DMA: 546,
  },
  "29301": {
    DMA: 567,
  },
  "29302": {
    DMA: 567,
  },
  "29303": {
    DMA: 567,
  },
  "29304": {
    DMA: 567,
  },
  "29305": {
    DMA: 567,
  },
  "29306": {
    DMA: 567,
  },
  "29307": {
    DMA: 567,
  },
  "29316": {
    DMA: 567,
  },
  "29318": {
    DMA: 567,
  },
  "29319": {
    DMA: 567,
  },
  "29320": {
    DMA: 567,
  },
  "29321": {
    DMA: 567,
  },
  "29322": {
    DMA: 567,
  },
  "29323": {
    DMA: 567,
  },
  "29324": {
    DMA: 567,
  },
  "29325": {
    DMA: 567,
  },
  "29329": {
    DMA: 567,
  },
  "29330": {
    DMA: 567,
  },
  "29331": {
    DMA: 567,
  },
  "29332": {
    DMA: 567,
  },
  "29333": {
    DMA: 567,
  },
  "29334": {
    DMA: 567,
  },
  "29335": {
    DMA: 567,
  },
  "29336": {
    DMA: 567,
  },
  "29338": {
    DMA: 567,
  },
  "29340": {
    DMA: 567,
  },
  "29341": {
    DMA: 567,
  },
  "29342": {
    DMA: 567,
  },
  "29346": {
    DMA: 567,
  },
  "29348": {
    DMA: 567,
  },
  "29349": {
    DMA: 567,
  },
  "29351": {
    DMA: 567,
  },
  "29353": {
    DMA: 567,
  },
  "29355": {
    DMA: 546,
  },
  "29356": {
    DMA: 567,
  },
  "29360": {
    DMA: 567,
  },
  "29364": {
    DMA: 567,
  },
  "29365": {
    DMA: 567,
  },
  "29368": {
    DMA: 567,
  },
  "29369": {
    DMA: 567,
  },
  "29370": {
    DMA: 567,
  },
  "29372": {
    DMA: 567,
  },
  "29373": {
    DMA: 567,
  },
  "29374": {
    DMA: 567,
  },
  "29375": {
    DMA: 567,
  },
  "29376": {
    DMA: 567,
  },
  "29377": {
    DMA: 567,
  },
  "29378": {
    DMA: 567,
  },
  "29379": {
    DMA: 567,
  },
  "29384": {
    DMA: 567,
  },
  "29385": {
    DMA: 567,
  },
  "29386": {
    DMA: 567,
  },
  "29388": {
    DMA: 567,
  },
  "29390": {
    DMA: 567,
  },
  "29391": {
    DMA: 567,
  },
  "29395": {
    DMA: 567,
  },
  "29401": {
    DMA: 519,
  },
  "29402": {
    DMA: 519,
  },
  "29403": {
    DMA: 519,
  },
  "29404": {
    DMA: 519,
  },
  "29405": {
    DMA: 519,
  },
  "29406": {
    DMA: 519,
  },
  "29407": {
    DMA: 519,
  },
  "29409": {
    DMA: 519,
  },
  "29410": {
    DMA: 519,
  },
  "29412": {
    DMA: 519,
  },
  "29413": {
    DMA: 519,
  },
  "29414": {
    DMA: 519,
  },
  "29415": {
    DMA: 519,
  },
  "29416": {
    DMA: 519,
  },
  "29417": {
    DMA: 519,
  },
  "29418": {
    DMA: 519,
  },
  "29419": {
    DMA: 519,
  },
  "29420": {
    DMA: 519,
  },
  "29422": {
    DMA: 519,
  },
  "29423": {
    DMA: 519,
  },
  "29424": {
    DMA: 519,
  },
  "29425": {
    DMA: 519,
  },
  "29426": {
    DMA: 519,
  },
  "29429": {
    DMA: 519,
  },
  "29430": {
    DMA: 519,
  },
  "29431": {
    DMA: 519,
  },
  "29432": {
    DMA: 546,
  },
  "29433": {
    DMA: 519,
  },
  "29434": {
    DMA: 519,
  },
  "29435": {
    DMA: 519,
  },
  "29436": {
    DMA: 519,
  },
  "29437": {
    DMA: 519,
  },
  "29438": {
    DMA: 519,
  },
  "29439": {
    DMA: 519,
  },
  "29440": {
    DMA: 519,
  },
  "29442": {
    DMA: 519,
  },
  "29445": {
    DMA: 519,
  },
  "29446": {
    DMA: 519,
  },
  "29447": {
    DMA: 519,
  },
  "29448": {
    DMA: 519,
  },
  "29449": {
    DMA: 519,
  },
  "29450": {
    DMA: 519,
  },
  "29451": {
    DMA: 519,
  },
  "29452": {
    DMA: 519,
  },
  "29453": {
    DMA: 519,
  },
  "29455": {
    DMA: 519,
  },
  "29456": {
    DMA: 519,
  },
  "29457": {
    DMA: 519,
  },
  "29458": {
    DMA: 519,
  },
  "29461": {
    DMA: 519,
  },
  "29464": {
    DMA: 519,
  },
  "29465": {
    DMA: 519,
  },
  "29466": {
    DMA: 519,
  },
  "29468": {
    DMA: 519,
  },
  "29469": {
    DMA: 519,
  },
  "29470": {
    DMA: 519,
  },
  "29471": {
    DMA: 519,
  },
  "29472": {
    DMA: 519,
  },
  "29474": {
    DMA: 519,
  },
  "29475": {
    DMA: 519,
  },
  "29476": {
    DMA: 519,
  },
  "29477": {
    DMA: 519,
  },
  "29479": {
    DMA: 519,
  },
  "29481": {
    DMA: 519,
  },
  "29482": {
    DMA: 519,
  },
  "29483": {
    DMA: 519,
  },
  "29484": {
    DMA: 519,
  },
  "29485": {
    DMA: 519,
  },
  "29486": {
    DMA: 519,
  },
  "29487": {
    DMA: 519,
  },
  "29488": {
    DMA: 519,
  },
  "29492": {
    DMA: 519,
  },
  "29493": {
    DMA: 519,
  },
  "29501": {
    DMA: 570,
  },
  "29502": {
    DMA: 570,
  },
  "29503": {
    DMA: 570,
  },
  "29504": {
    DMA: 570,
  },
  "29505": {
    DMA: 570,
  },
  "29506": {
    DMA: 570,
  },
  "29510": {
    DMA: 519,
  },
  "29511": {
    DMA: 570,
  },
  "29512": {
    DMA: 570,
  },
  "29516": {
    DMA: 570,
  },
  "29518": {
    DMA: 519,
  },
  "29519": {
    DMA: 570,
  },
  "29520": {
    DMA: 517,
  },
  "29525": {
    DMA: 570,
  },
  "29526": {
    DMA: 570,
  },
  "29527": {
    DMA: 570,
  },
  "29528": {
    DMA: 570,
  },
  "29530": {
    DMA: 570,
  },
  "29532": {
    DMA: 570,
  },
  "29536": {
    DMA: 570,
  },
  "29540": {
    DMA: 570,
  },
  "29541": {
    DMA: 570,
  },
  "29543": {
    DMA: 570,
  },
  "29544": {
    DMA: 570,
  },
  "29545": {
    DMA: 570,
  },
  "29546": {
    DMA: 570,
  },
  "29547": {
    DMA: 570,
  },
  "29550": {
    DMA: 570,
  },
  "29551": {
    DMA: 570,
  },
  "29554": {
    DMA: 519,
  },
  "29555": {
    DMA: 570,
  },
  "29556": {
    DMA: 519,
  },
  "29560": {
    DMA: 570,
  },
  "29563": {
    DMA: 570,
  },
  "29564": {
    DMA: 519,
  },
  "29565": {
    DMA: 570,
  },
  "29566": {
    DMA: 570,
  },
  "29567": {
    DMA: 570,
  },
  "29568": {
    DMA: 570,
  },
  "29569": {
    DMA: 570,
  },
  "29570": {
    DMA: 570,
  },
  "29571": {
    DMA: 570,
  },
  "29572": {
    DMA: 570,
  },
  "29573": {
    DMA: 570,
  },
  "29574": {
    DMA: 570,
  },
  "29575": {
    DMA: 570,
  },
  "29576": {
    DMA: 570,
  },
  "29577": {
    DMA: 570,
  },
  "29578": {
    DMA: 570,
  },
  "29579": {
    DMA: 570,
  },
  "29580": {
    DMA: 519,
  },
  "29581": {
    DMA: 570,
  },
  "29582": {
    DMA: 570,
  },
  "29583": {
    DMA: 570,
  },
  "29584": {
    DMA: 517,
  },
  "29585": {
    DMA: 519,
  },
  "29587": {
    DMA: 570,
  },
  "29588": {
    DMA: 570,
  },
  "29589": {
    DMA: 570,
  },
  "29590": {
    DMA: 519,
  },
  "29591": {
    DMA: 570,
  },
  "29592": {
    DMA: 570,
  },
  "29593": {
    DMA: 570,
  },
  "29594": {
    DMA: 570,
  },
  "29596": {
    DMA: 570,
  },
  "29597": {
    DMA: 570,
  },
  "29598": {
    DMA: 570,
  },
  "29601": {
    DMA: 567,
  },
  "29602": {
    DMA: 567,
  },
  "29603": {
    DMA: 567,
  },
  "29604": {
    DMA: 567,
  },
  "29605": {
    DMA: 567,
  },
  "29606": {
    DMA: 567,
  },
  "29607": {
    DMA: 567,
  },
  "29608": {
    DMA: 567,
  },
  "29609": {
    DMA: 567,
  },
  "29610": {
    DMA: 567,
  },
  "29611": {
    DMA: 567,
  },
  "29612": {
    DMA: 567,
  },
  "29613": {
    DMA: 567,
  },
  "29614": {
    DMA: 567,
  },
  "29615": {
    DMA: 567,
  },
  "29616": {
    DMA: 567,
  },
  "29617": {
    DMA: 567,
  },
  "29620": {
    DMA: 567,
  },
  "29621": {
    DMA: 567,
  },
  "29622": {
    DMA: 567,
  },
  "29623": {
    DMA: 567,
  },
  "29624": {
    DMA: 567,
  },
  "29625": {
    DMA: 567,
  },
  "29626": {
    DMA: 567,
  },
  "29627": {
    DMA: 567,
  },
  "29628": {
    DMA: 567,
  },
  "29630": {
    DMA: 567,
  },
  "29631": {
    DMA: 567,
  },
  "29632": {
    DMA: 567,
  },
  "29633": {
    DMA: 567,
  },
  "29634": {
    DMA: 567,
  },
  "29635": {
    DMA: 567,
  },
  "29636": {
    DMA: 567,
  },
  "29638": {
    DMA: 567,
  },
  "29639": {
    DMA: 567,
  },
  "29640": {
    DMA: 567,
  },
  "29641": {
    DMA: 567,
  },
  "29642": {
    DMA: 567,
  },
  "29643": {
    DMA: 567,
  },
  "29644": {
    DMA: 567,
  },
  "29645": {
    DMA: 567,
  },
  "29646": {
    DMA: 567,
  },
  "29647": {
    DMA: 567,
  },
  "29648": {
    DMA: 567,
  },
  "29649": {
    DMA: 567,
  },
  "29650": {
    DMA: 567,
  },
  "29651": {
    DMA: 567,
  },
  "29652": {
    DMA: 567,
  },
  "29653": {
    DMA: 567,
  },
  "29654": {
    DMA: 567,
  },
  "29655": {
    DMA: 567,
  },
  "29656": {
    DMA: 567,
  },
  "29657": {
    DMA: 567,
  },
  "29658": {
    DMA: 567,
  },
  "29659": {
    DMA: 567,
  },
  "29661": {
    DMA: 567,
  },
  "29662": {
    DMA: 567,
  },
  "29664": {
    DMA: 567,
  },
  "29665": {
    DMA: 567,
  },
  "29666": {
    DMA: 567,
  },
  "29667": {
    DMA: 567,
  },
  "29669": {
    DMA: 567,
  },
  "29670": {
    DMA: 567,
  },
  "29671": {
    DMA: 567,
  },
  "29672": {
    DMA: 567,
  },
  "29673": {
    DMA: 567,
  },
  "29675": {
    DMA: 567,
  },
  "29676": {
    DMA: 567,
  },
  "29677": {
    DMA: 567,
  },
  "29678": {
    DMA: 567,
  },
  "29679": {
    DMA: 567,
  },
  "29680": {
    DMA: 567,
  },
  "29681": {
    DMA: 567,
  },
  "29682": {
    DMA: 567,
  },
  "29683": {
    DMA: 567,
  },
  "29684": {
    DMA: 567,
  },
  "29685": {
    DMA: 567,
  },
  "29686": {
    DMA: 567,
  },
  "29687": {
    DMA: 567,
  },
  "29688": {
    DMA: 567,
  },
  "29689": {
    DMA: 567,
  },
  "29690": {
    DMA: 567,
  },
  "29691": {
    DMA: 567,
  },
  "29692": {
    DMA: 567,
  },
  "29693": {
    DMA: 567,
  },
  "29695": {
    DMA: 567,
  },
  "29696": {
    DMA: 567,
  },
  "29697": {
    DMA: 567,
  },
  "29698": {
    DMA: 567,
  },
  "29702": {
    DMA: 567,
  },
  "29703": {
    DMA: 517,
  },
  "29704": {
    DMA: 517,
  },
  "29706": {
    DMA: 517,
  },
  "29707": {
    DMA: 517,
  },
  "29708": {
    DMA: 517,
  },
  "29709": {
    DMA: 517,
  },
  "29710": {
    DMA: 517,
  },
  "29712": {
    DMA: 517,
  },
  "29714": {
    DMA: 517,
  },
  "29715": {
    DMA: 517,
  },
  "29716": {
    DMA: 517,
  },
  "29717": {
    DMA: 517,
  },
  "29718": {
    DMA: 517,
  },
  "29720": {
    DMA: 517,
  },
  "29721": {
    DMA: 517,
  },
  "29722": {
    DMA: 517,
  },
  "29724": {
    DMA: 517,
  },
  "29726": {
    DMA: 517,
  },
  "29727": {
    DMA: 517,
  },
  "29728": {
    DMA: 517,
  },
  "29729": {
    DMA: 517,
  },
  "29730": {
    DMA: 517,
  },
  "29731": {
    DMA: 517,
  },
  "29732": {
    DMA: 517,
  },
  "29733": {
    DMA: 517,
  },
  "29734": {
    DMA: 517,
  },
  "29741": {
    DMA: 517,
  },
  "29742": {
    DMA: 517,
  },
  "29743": {
    DMA: 517,
  },
  "29744": {
    DMA: 517,
  },
  "29745": {
    DMA: 517,
  },
  "29801": {
    DMA: 520,
  },
  "29802": {
    DMA: 520,
  },
  "29803": {
    DMA: 520,
  },
  "29804": {
    DMA: 520,
  },
  "29805": {
    DMA: 520,
  },
  "29808": {
    DMA: 520,
  },
  "29809": {
    DMA: 520,
  },
  "29810": {
    DMA: 520,
  },
  "29812": {
    DMA: 520,
  },
  "29813": {
    DMA: 520,
  },
  "29816": {
    DMA: 520,
  },
  "29817": {
    DMA: 520,
  },
  "29819": {
    DMA: 567,
  },
  "29821": {
    DMA: 520,
  },
  "29822": {
    DMA: 520,
  },
  "29824": {
    DMA: 520,
  },
  "29826": {
    DMA: 520,
  },
  "29827": {
    DMA: 520,
  },
  "29828": {
    DMA: 520,
  },
  "29829": {
    DMA: 520,
  },
  "29831": {
    DMA: 520,
  },
  "29832": {
    DMA: 520,
  },
  "29834": {
    DMA: 520,
  },
  "29835": {
    DMA: 520,
  },
  "29836": {
    DMA: 520,
  },
  "29838": {
    DMA: 520,
  },
  "29839": {
    DMA: 520,
  },
  "29840": {
    DMA: 520,
  },
  "29841": {
    DMA: 520,
  },
  "29842": {
    DMA: 520,
  },
  "29843": {
    DMA: 520,
  },
  "29844": {
    DMA: 520,
  },
  "29845": {
    DMA: 520,
  },
  "29846": {
    DMA: 520,
  },
  "29847": {
    DMA: 520,
  },
  "29848": {
    DMA: 567,
  },
  "29849": {
    DMA: 520,
  },
  "29850": {
    DMA: 520,
  },
  "29851": {
    DMA: 520,
  },
  "29853": {
    DMA: 520,
  },
  "29856": {
    DMA: 520,
  },
  "29860": {
    DMA: 520,
  },
  "29861": {
    DMA: 520,
  },
  "29899": {
    DMA: 520,
  },
  "29901": {
    DMA: 507,
  },
  "29902": {
    DMA: 507,
  },
  "29903": {
    DMA: 507,
  },
  "29904": {
    DMA: 507,
  },
  "29905": {
    DMA: 507,
  },
  "29906": {
    DMA: 507,
  },
  "29907": {
    DMA: 507,
  },
  "29909": {
    DMA: 507,
  },
  "29910": {
    DMA: 507,
  },
  "29911": {
    DMA: 507,
  },
  "29912": {
    DMA: 507,
  },
  "29913": {
    DMA: 507,
  },
  "29914": {
    DMA: 507,
  },
  "29915": {
    DMA: 507,
  },
  "29916": {
    DMA: 507,
  },
  "29918": {
    DMA: 507,
  },
  "29920": {
    DMA: 507,
  },
  "29921": {
    DMA: 507,
  },
  "29922": {
    DMA: 507,
  },
  "29923": {
    DMA: 507,
  },
  "29924": {
    DMA: 507,
  },
  "29925": {
    DMA: 507,
  },
  "29926": {
    DMA: 507,
  },
  "29927": {
    DMA: 507,
  },
  "29928": {
    DMA: 507,
  },
  "29929": {
    DMA: 519,
  },
  "29931": {
    DMA: 507,
  },
  "29932": {
    DMA: 507,
  },
  "29933": {
    DMA: 507,
  },
  "29934": {
    DMA: 507,
  },
  "29935": {
    DMA: 507,
  },
  "29936": {
    DMA: 507,
  },
  "29938": {
    DMA: 507,
  },
  "29939": {
    DMA: 507,
  },
  "29940": {
    DMA: 507,
  },
  "29941": {
    DMA: 507,
  },
  "29943": {
    DMA: 507,
  },
  "29944": {
    DMA: 507,
  },
  "29945": {
    DMA: 507,
  },
  "30002": {
    DMA: 524,
  },
  "30003": {
    DMA: 524,
  },
  "30004": {
    DMA: 524,
  },
  "30005": {
    DMA: 524,
  },
  "30006": {
    DMA: 524,
  },
  "30007": {
    DMA: 524,
  },
  "30008": {
    DMA: 524,
  },
  "30009": {
    DMA: 524,
  },
  "30010": {
    DMA: 524,
  },
  "30011": {
    DMA: 524,
  },
  "30012": {
    DMA: 524,
  },
  "30013": {
    DMA: 524,
  },
  "30014": {
    DMA: 524,
  },
  "30015": {
    DMA: 524,
  },
  "30016": {
    DMA: 524,
  },
  "30017": {
    DMA: 524,
  },
  "30018": {
    DMA: 524,
  },
  "30019": {
    DMA: 524,
  },
  "30021": {
    DMA: 524,
  },
  "30022": {
    DMA: 524,
  },
  "30023": {
    DMA: 524,
  },
  "30024": {
    DMA: 524,
  },
  "30025": {
    DMA: 524,
  },
  "30026": {
    DMA: 524,
  },
  "30028": {
    DMA: 524,
  },
  "30029": {
    DMA: 524,
  },
  "30030": {
    DMA: 524,
  },
  "30031": {
    DMA: 524,
  },
  "30032": {
    DMA: 524,
  },
  "30033": {
    DMA: 524,
  },
  "30034": {
    DMA: 524,
  },
  "30035": {
    DMA: 524,
  },
  "30036": {
    DMA: 524,
  },
  "30037": {
    DMA: 524,
  },
  "30038": {
    DMA: 524,
  },
  "30039": {
    DMA: 524,
  },
  "30040": {
    DMA: 524,
  },
  "30041": {
    DMA: 524,
  },
  "30042": {
    DMA: 524,
  },
  "30043": {
    DMA: 524,
  },
  "30044": {
    DMA: 524,
  },
  "30045": {
    DMA: 524,
  },
  "30046": {
    DMA: 524,
  },
  "30047": {
    DMA: 524,
  },
  "30048": {
    DMA: 524,
  },
  "30049": {
    DMA: 524,
  },
  "30052": {
    DMA: 524,
  },
  "30054": {
    DMA: 524,
  },
  "30055": {
    DMA: 524,
  },
  "30056": {
    DMA: 524,
  },
  "30058": {
    DMA: 524,
  },
  "30060": {
    DMA: 524,
  },
  "30061": {
    DMA: 524,
  },
  "30062": {
    DMA: 524,
  },
  "30063": {
    DMA: 524,
  },
  "30064": {
    DMA: 524,
  },
  "30065": {
    DMA: 524,
  },
  "30066": {
    DMA: 524,
  },
  "30067": {
    DMA: 524,
  },
  "30068": {
    DMA: 524,
  },
  "30069": {
    DMA: 524,
  },
  "30070": {
    DMA: 524,
  },
  "30071": {
    DMA: 524,
  },
  "30072": {
    DMA: 524,
  },
  "30073": {
    DMA: 524,
  },
  "30074": {
    DMA: 524,
  },
  "30075": {
    DMA: 524,
  },
  "30076": {
    DMA: 524,
  },
  "30077": {
    DMA: 524,
  },
  "30078": {
    DMA: 524,
  },
  "30079": {
    DMA: 524,
  },
  "30080": {
    DMA: 524,
  },
  "30081": {
    DMA: 524,
  },
  "30082": {
    DMA: 524,
  },
  "30083": {
    DMA: 524,
  },
  "30084": {
    DMA: 524,
  },
  "30085": {
    DMA: 524,
  },
  "30086": {
    DMA: 524,
  },
  "30087": {
    DMA: 524,
  },
  "30088": {
    DMA: 524,
  },
  "30090": {
    DMA: 524,
  },
  "30091": {
    DMA: 524,
  },
  "30092": {
    DMA: 524,
  },
  "30093": {
    DMA: 524,
  },
  "30094": {
    DMA: 524,
  },
  "30095": {
    DMA: 524,
  },
  "30096": {
    DMA: 524,
  },
  "30097": {
    DMA: 524,
  },
  "30098": {
    DMA: 524,
  },
  "30099": {
    DMA: 524,
  },
  "30101": {
    DMA: 524,
  },
  "30102": {
    DMA: 524,
  },
  "30103": {
    DMA: 524,
  },
  "30104": {
    DMA: 524,
  },
  "30105": {
    DMA: 524,
  },
  "30106": {
    DMA: 524,
  },
  "30107": {
    DMA: 524,
  },
  "30108": {
    DMA: 524,
  },
  "30109": {
    DMA: 524,
  },
  "30110": {
    DMA: 524,
  },
  "30111": {
    DMA: 524,
  },
  "30112": {
    DMA: 524,
  },
  "30113": {
    DMA: 524,
  },
  "30114": {
    DMA: 524,
  },
  "30115": {
    DMA: 524,
  },
  "30116": {
    DMA: 524,
  },
  "30117": {
    DMA: 524,
  },
  "30118": {
    DMA: 524,
  },
  "30119": {
    DMA: 524,
  },
  "30120": {
    DMA: 524,
  },
  "30121": {
    DMA: 524,
  },
  "30122": {
    DMA: 524,
  },
  "30123": {
    DMA: 524,
  },
  "30124": {
    DMA: 524,
  },
  "30125": {
    DMA: 524,
  },
  "30126": {
    DMA: 524,
  },
  "30127": {
    DMA: 524,
  },
  "30129": {
    DMA: 524,
  },
  "30132": {
    DMA: 524,
  },
  "30133": {
    DMA: 524,
  },
  "30134": {
    DMA: 524,
  },
  "30135": {
    DMA: 524,
  },
  "30137": {
    DMA: 524,
  },
  "30138": {
    DMA: 524,
  },
  "30139": {
    DMA: 524,
  },
  "30140": {
    DMA: 524,
  },
  "30141": {
    DMA: 524,
  },
  "30142": {
    DMA: 524,
  },
  "30143": {
    DMA: 524,
  },
  "30144": {
    DMA: 524,
  },
  "30145": {
    DMA: 524,
  },
  "30146": {
    DMA: 524,
  },
  "30147": {
    DMA: 524,
  },
  "30148": {
    DMA: 524,
  },
  "30149": {
    DMA: 524,
  },
  "30150": {
    DMA: 524,
  },
  "30151": {
    DMA: 524,
  },
  "30152": {
    DMA: 524,
  },
  "30153": {
    DMA: 524,
  },
  "30154": {
    DMA: 524,
  },
  "30156": {
    DMA: 524,
  },
  "30157": {
    DMA: 524,
  },
  "30160": {
    DMA: 524,
  },
  "30161": {
    DMA: 524,
  },
  "30162": {
    DMA: 524,
  },
  "30163": {
    DMA: 524,
  },
  "30164": {
    DMA: 524,
  },
  "30165": {
    DMA: 524,
  },
  "30168": {
    DMA: 524,
  },
  "30169": {
    DMA: 524,
  },
  "30170": {
    DMA: 524,
  },
  "30171": {
    DMA: 524,
  },
  "30172": {
    DMA: 524,
  },
  "30173": {
    DMA: 524,
  },
  "30175": {
    DMA: 524,
  },
  "30176": {
    DMA: 524,
  },
  "30177": {
    DMA: 524,
  },
  "30178": {
    DMA: 524,
  },
  "30179": {
    DMA: 524,
  },
  "30180": {
    DMA: 524,
  },
  "30182": {
    DMA: 524,
  },
  "30183": {
    DMA: 524,
  },
  "30184": {
    DMA: 524,
  },
  "30185": {
    DMA: 524,
  },
  "30187": {
    DMA: 524,
  },
  "30188": {
    DMA: 524,
  },
  "30189": {
    DMA: 524,
  },
  "30204": {
    DMA: 524,
  },
  "30205": {
    DMA: 524,
  },
  "30206": {
    DMA: 524,
  },
  "30212": {
    DMA: 524,
  },
  "30213": {
    DMA: 524,
  },
  "30214": {
    DMA: 524,
  },
  "30215": {
    DMA: 524,
  },
  "30216": {
    DMA: 524,
  },
  "30217": {
    DMA: 524,
  },
  "30218": {
    DMA: 524,
  },
  "30219": {
    DMA: 524,
  },
  "30220": {
    DMA: 524,
  },
  "30222": {
    DMA: 524,
  },
  "30223": {
    DMA: 524,
  },
  "30224": {
    DMA: 524,
  },
  "30228": {
    DMA: 524,
  },
  "30229": {
    DMA: 524,
  },
  "30230": {
    DMA: 524,
  },
  "30233": {
    DMA: 524,
  },
  "30234": {
    DMA: 524,
  },
  "30236": {
    DMA: 524,
  },
  "30237": {
    DMA: 524,
  },
  "30238": {
    DMA: 524,
  },
  "30240": {
    DMA: 524,
  },
  "30241": {
    DMA: 524,
  },
  "30248": {
    DMA: 524,
  },
  "30250": {
    DMA: 524,
  },
  "30251": {
    DMA: 524,
  },
  "30252": {
    DMA: 524,
  },
  "30253": {
    DMA: 524,
  },
  "30256": {
    DMA: 524,
  },
  "30257": {
    DMA: 524,
  },
  "30258": {
    DMA: 524,
  },
  "30259": {
    DMA: 524,
  },
  "30260": {
    DMA: 524,
  },
  "30261": {
    DMA: 524,
  },
  "30263": {
    DMA: 524,
  },
  "30264": {
    DMA: 524,
  },
  "30265": {
    DMA: 524,
  },
  "30266": {
    DMA: 524,
  },
  "30268": {
    DMA: 524,
  },
  "30269": {
    DMA: 524,
  },
  "30270": {
    DMA: 524,
  },
  "30271": {
    DMA: 524,
  },
  "30272": {
    DMA: 524,
  },
  "30273": {
    DMA: 524,
  },
  "30274": {
    DMA: 524,
  },
  "30275": {
    DMA: 524,
  },
  "30276": {
    DMA: 524,
  },
  "30277": {
    DMA: 524,
  },
  "30281": {
    DMA: 524,
  },
  "30284": {
    DMA: 524,
  },
  "30285": {
    DMA: 524,
  },
  "30286": {
    DMA: 524,
  },
  "30287": {
    DMA: 524,
  },
  "30288": {
    DMA: 524,
  },
  "30289": {
    DMA: 524,
  },
  "30290": {
    DMA: 524,
  },
  "30291": {
    DMA: 524,
  },
  "30292": {
    DMA: 524,
  },
  "30293": {
    DMA: 524,
  },
  "30294": {
    DMA: 524,
  },
  "30295": {
    DMA: 524,
  },
  "30296": {
    DMA: 524,
  },
  "30297": {
    DMA: 524,
  },
  "30298": {
    DMA: 524,
  },
  "30301": {
    DMA: 524,
  },
  "30302": {
    DMA: 524,
  },
  "30303": {
    DMA: 524,
  },
  "30304": {
    DMA: 524,
  },
  "30305": {
    DMA: 524,
  },
  "30306": {
    DMA: 524,
  },
  "30307": {
    DMA: 524,
  },
  "30308": {
    DMA: 524,
  },
  "30309": {
    DMA: 524,
  },
  "30310": {
    DMA: 524,
  },
  "30311": {
    DMA: 524,
  },
  "30312": {
    DMA: 524,
  },
  "30313": {
    DMA: 524,
  },
  "30314": {
    DMA: 524,
  },
  "30315": {
    DMA: 524,
  },
  "30316": {
    DMA: 524,
  },
  "30317": {
    DMA: 524,
  },
  "30318": {
    DMA: 524,
  },
  "30319": {
    DMA: 524,
  },
  "30320": {
    DMA: 524,
  },
  "30321": {
    DMA: 524,
  },
  "30322": {
    DMA: 524,
  },
  "30324": {
    DMA: 524,
  },
  "30325": {
    DMA: 524,
  },
  "30326": {
    DMA: 524,
  },
  "30327": {
    DMA: 524,
  },
  "30328": {
    DMA: 524,
  },
  "30329": {
    DMA: 524,
  },
  "30330": {
    DMA: 524,
  },
  "30331": {
    DMA: 524,
  },
  "30332": {
    DMA: 524,
  },
  "30333": {
    DMA: 524,
  },
  "30334": {
    DMA: 524,
  },
  "30336": {
    DMA: 524,
  },
  "30337": {
    DMA: 524,
  },
  "30338": {
    DMA: 524,
  },
  "30339": {
    DMA: 524,
  },
  "30340": {
    DMA: 524,
  },
  "30341": {
    DMA: 524,
  },
  "30342": {
    DMA: 524,
  },
  "30343": {
    DMA: 524,
  },
  "30344": {
    DMA: 524,
  },
  "30345": {
    DMA: 524,
  },
  "30346": {
    DMA: 524,
  },
  "30347": {
    DMA: 524,
  },
  "30348": {
    DMA: 524,
  },
  "30349": {
    DMA: 524,
  },
  "30350": {
    DMA: 524,
  },
  "30353": {
    DMA: 524,
  },
  "30354": {
    DMA: 524,
  },
  "30355": {
    DMA: 524,
  },
  "30356": {
    DMA: 524,
  },
  "30357": {
    DMA: 524,
  },
  "30358": {
    DMA: 524,
  },
  "30359": {
    DMA: 524,
  },
  "30360": {
    DMA: 524,
  },
  "30361": {
    DMA: 524,
  },
  "30362": {
    DMA: 524,
  },
  "30363": {
    DMA: 524,
  },
  "30364": {
    DMA: 524,
  },
  "30366": {
    DMA: 524,
  },
  "30368": {
    DMA: 524,
  },
  "30369": {
    DMA: 524,
  },
  "30370": {
    DMA: 524,
  },
  "30371": {
    DMA: 524,
  },
  "30374": {
    DMA: 524,
  },
  "30375": {
    DMA: 524,
  },
  "30376": {
    DMA: 524,
  },
  "30377": {
    DMA: 524,
  },
  "30378": {
    DMA: 524,
  },
  "30379": {
    DMA: 524,
  },
  "30380": {
    DMA: 524,
  },
  "30384": {
    DMA: 524,
  },
  "30385": {
    DMA: 524,
  },
  "30386": {
    DMA: 524,
  },
  "30387": {
    DMA: 524,
  },
  "30388": {
    DMA: 524,
  },
  "30389": {
    DMA: 524,
  },
  "30390": {
    DMA: 524,
  },
  "30392": {
    DMA: 524,
  },
  "30394": {
    DMA: 524,
  },
  "30396": {
    DMA: 524,
  },
  "30398": {
    DMA: 524,
  },
  "30399": {
    DMA: 524,
  },
  "30401": {
    DMA: 520,
  },
  "30410": {
    DMA: 507,
  },
  "30411": {
    DMA: 503,
  },
  "30412": {
    DMA: 507,
  },
  "30413": {
    DMA: 520,
  },
  "30414": {
    DMA: 507,
  },
  "30415": {
    DMA: 507,
  },
  "30417": {
    DMA: 507,
  },
  "30420": {
    DMA: 507,
  },
  "30421": {
    DMA: 507,
  },
  "30423": {
    DMA: 507,
  },
  "30424": {
    DMA: 507,
  },
  "30425": {
    DMA: 520,
  },
  "30426": {
    DMA: 520,
  },
  "30427": {
    DMA: 507,
  },
  "30428": {
    DMA: 503,
  },
  "30429": {
    DMA: 507,
  },
  "30434": {
    DMA: 520,
  },
  "30436": {
    DMA: 507,
  },
  "30438": {
    DMA: 507,
  },
  "30439": {
    DMA: 507,
  },
  "30441": {
    DMA: 520,
  },
  "30442": {
    DMA: 520,
  },
  "30445": {
    DMA: 507,
  },
  "30446": {
    DMA: 507,
  },
  "30447": {
    DMA: 520,
  },
  "30448": {
    DMA: 520,
  },
  "30449": {
    DMA: 507,
  },
  "30450": {
    DMA: 507,
  },
  "30451": {
    DMA: 507,
  },
  "30452": {
    DMA: 507,
  },
  "30453": {
    DMA: 507,
  },
  "30454": {
    DMA: 503,
  },
  "30455": {
    DMA: 507,
  },
  "30456": {
    DMA: 520,
  },
  "30457": {
    DMA: 503,
  },
  "30458": {
    DMA: 507,
  },
  "30459": {
    DMA: 507,
  },
  "30460": {
    DMA: 507,
  },
  "30461": {
    DMA: 507,
  },
  "30464": {
    DMA: 520,
  },
  "30467": {
    DMA: 507,
  },
  "30470": {
    DMA: 507,
  },
  "30471": {
    DMA: 520,
  },
  "30473": {
    DMA: 507,
  },
  "30474": {
    DMA: 507,
  },
  "30475": {
    DMA: 507,
  },
  "30477": {
    DMA: 520,
  },
  "30499": {
    DMA: 507,
  },
  "30501": {
    DMA: 524,
  },
  "30502": {
    DMA: 524,
  },
  "30503": {
    DMA: 524,
  },
  "30504": {
    DMA: 524,
  },
  "30506": {
    DMA: 524,
  },
  "30507": {
    DMA: 524,
  },
  "30510": {
    DMA: 524,
  },
  "30511": {
    DMA: 524,
  },
  "30512": {
    DMA: 524,
  },
  "30513": {
    DMA: 524,
  },
  "30514": {
    DMA: 524,
  },
  "30515": {
    DMA: 524,
  },
  "30516": {
    DMA: 567,
  },
  "30517": {
    DMA: 524,
  },
  "30518": {
    DMA: 524,
  },
  "30519": {
    DMA: 524,
  },
  "30520": {
    DMA: 567,
  },
  "30521": {
    DMA: 567,
  },
  "30522": {
    DMA: 524,
  },
  "30523": {
    DMA: 524,
  },
  "30525": {
    DMA: 524,
  },
  "30527": {
    DMA: 524,
  },
  "30528": {
    DMA: 524,
  },
  "30529": {
    DMA: 524,
  },
  "30530": {
    DMA: 524,
  },
  "30531": {
    DMA: 524,
  },
  "30533": {
    DMA: 524,
  },
  "30534": {
    DMA: 524,
  },
  "30535": {
    DMA: 524,
  },
  "30536": {
    DMA: 524,
  },
  "30537": {
    DMA: 524,
  },
  "30538": {
    DMA: 567,
  },
  "30539": {
    DMA: 524,
  },
  "30540": {
    DMA: 524,
  },
  "30541": {
    DMA: 524,
  },
  "30542": {
    DMA: 524,
  },
  "30543": {
    DMA: 524,
  },
  "30544": {
    DMA: 524,
  },
  "30545": {
    DMA: 524,
  },
  "30546": {
    DMA: 524,
  },
  "30547": {
    DMA: 524,
  },
  "30548": {
    DMA: 524,
  },
  "30549": {
    DMA: 524,
  },
  "30552": {
    DMA: 524,
  },
  "30553": {
    DMA: 567,
  },
  "30554": {
    DMA: 524,
  },
  "30555": {
    DMA: 524,
  },
  "30557": {
    DMA: 567,
  },
  "30558": {
    DMA: 524,
  },
  "30559": {
    DMA: 524,
  },
  "30560": {
    DMA: 524,
  },
  "30562": {
    DMA: 524,
  },
  "30563": {
    DMA: 524,
  },
  "30564": {
    DMA: 524,
  },
  "30565": {
    DMA: 524,
  },
  "30566": {
    DMA: 524,
  },
  "30567": {
    DMA: 524,
  },
  "30568": {
    DMA: 524,
  },
  "30571": {
    DMA: 524,
  },
  "30572": {
    DMA: 524,
  },
  "30573": {
    DMA: 524,
  },
  "30575": {
    DMA: 524,
  },
  "30576": {
    DMA: 524,
  },
  "30577": {
    DMA: 567,
  },
  "30580": {
    DMA: 524,
  },
  "30581": {
    DMA: 524,
  },
  "30582": {
    DMA: 524,
  },
  "30596": {
    DMA: 524,
  },
  "30597": {
    DMA: 524,
  },
  "30598": {
    DMA: 567,
  },
  "30599": {
    DMA: 524,
  },
  "30601": {
    DMA: 524,
  },
  "30602": {
    DMA: 524,
  },
  "30603": {
    DMA: 524,
  },
  "30604": {
    DMA: 524,
  },
  "30605": {
    DMA: 524,
  },
  "30606": {
    DMA: 524,
  },
  "30607": {
    DMA: 524,
  },
  "30608": {
    DMA: 524,
  },
  "30609": {
    DMA: 524,
  },
  "30612": {
    DMA: 524,
  },
  "30619": {
    DMA: 524,
  },
  "30620": {
    DMA: 524,
  },
  "30621": {
    DMA: 524,
  },
  "30622": {
    DMA: 524,
  },
  "30623": {
    DMA: 524,
  },
  "30624": {
    DMA: 567,
  },
  "30625": {
    DMA: 524,
  },
  "30627": {
    DMA: 524,
  },
  "30628": {
    DMA: 524,
  },
  "30629": {
    DMA: 524,
  },
  "30630": {
    DMA: 524,
  },
  "30631": {
    DMA: 520,
  },
  "30633": {
    DMA: 524,
  },
  "30634": {
    DMA: 567,
  },
  "30635": {
    DMA: 567,
  },
  "30638": {
    DMA: 524,
  },
  "30639": {
    DMA: 567,
  },
  "30641": {
    DMA: 524,
  },
  "30642": {
    DMA: 524,
  },
  "30643": {
    DMA: 567,
  },
  "30645": {
    DMA: 524,
  },
  "30646": {
    DMA: 524,
  },
  "30647": {
    DMA: 524,
  },
  "30648": {
    DMA: 524,
  },
  "30650": {
    DMA: 524,
  },
  "30655": {
    DMA: 524,
  },
  "30656": {
    DMA: 524,
  },
  "30660": {
    DMA: 520,
  },
  "30662": {
    DMA: 567,
  },
  "30663": {
    DMA: 524,
  },
  "30664": {
    DMA: 520,
  },
  "30665": {
    DMA: 524,
  },
  "30666": {
    DMA: 524,
  },
  "30667": {
    DMA: 524,
  },
  "30668": {
    DMA: 520,
  },
  "30669": {
    DMA: 524,
  },
  "30671": {
    DMA: 524,
  },
  "30673": {
    DMA: 520,
  },
  "30677": {
    DMA: 524,
  },
  "30678": {
    DMA: 524,
  },
  "30680": {
    DMA: 524,
  },
  "30683": {
    DMA: 524,
  },
  "30701": {
    DMA: 524,
  },
  "30703": {
    DMA: 524,
  },
  "30705": {
    DMA: 575,
  },
  "30707": {
    DMA: 575,
  },
  "30708": {
    DMA: 575,
  },
  "30710": {
    DMA: 575,
  },
  "30711": {
    DMA: 575,
  },
  "30719": {
    DMA: 575,
  },
  "30720": {
    DMA: 575,
  },
  "30721": {
    DMA: 575,
  },
  "30722": {
    DMA: 575,
  },
  "30724": {
    DMA: 575,
  },
  "30725": {
    DMA: 575,
  },
  "30726": {
    DMA: 575,
  },
  "30728": {
    DMA: 575,
  },
  "30730": {
    DMA: 524,
  },
  "30731": {
    DMA: 524,
  },
  "30732": {
    DMA: 524,
  },
  "30733": {
    DMA: 524,
  },
  "30734": {
    DMA: 524,
  },
  "30735": {
    DMA: 524,
  },
  "30736": {
    DMA: 575,
  },
  "30738": {
    DMA: 575,
  },
  "30739": {
    DMA: 575,
  },
  "30740": {
    DMA: 575,
  },
  "30741": {
    DMA: 575,
  },
  "30742": {
    DMA: 575,
  },
  "30746": {
    DMA: 524,
  },
  "30747": {
    DMA: 524,
  },
  "30750": {
    DMA: 575,
  },
  "30751": {
    DMA: 575,
  },
  "30752": {
    DMA: 575,
  },
  "30753": {
    DMA: 524,
  },
  "30755": {
    DMA: 575,
  },
  "30756": {
    DMA: 575,
  },
  "30757": {
    DMA: 575,
  },
  "30802": {
    DMA: 520,
  },
  "30803": {
    DMA: 520,
  },
  "30805": {
    DMA: 520,
  },
  "30806": {
    DMA: 520,
  },
  "30807": {
    DMA: 520,
  },
  "30808": {
    DMA: 520,
  },
  "30809": {
    DMA: 520,
  },
  "30810": {
    DMA: 520,
  },
  "30811": {
    DMA: 520,
  },
  "30812": {
    DMA: 520,
  },
  "30813": {
    DMA: 520,
  },
  "30814": {
    DMA: 520,
  },
  "30815": {
    DMA: 520,
  },
  "30816": {
    DMA: 520,
  },
  "30817": {
    DMA: 520,
  },
  "30818": {
    DMA: 520,
  },
  "30819": {
    DMA: 520,
  },
  "30820": {
    DMA: 520,
  },
  "30821": {
    DMA: 520,
  },
  "30822": {
    DMA: 520,
  },
  "30823": {
    DMA: 520,
  },
  "30824": {
    DMA: 520,
  },
  "30828": {
    DMA: 520,
  },
  "30830": {
    DMA: 520,
  },
  "30833": {
    DMA: 520,
  },
  "30901": {
    DMA: 520,
  },
  "30903": {
    DMA: 520,
  },
  "30904": {
    DMA: 520,
  },
  "30905": {
    DMA: 520,
  },
  "30906": {
    DMA: 520,
  },
  "30907": {
    DMA: 520,
  },
  "30909": {
    DMA: 520,
  },
  "30911": {
    DMA: 520,
  },
  "30912": {
    DMA: 520,
  },
  "30913": {
    DMA: 520,
  },
  "30914": {
    DMA: 520,
  },
  "30916": {
    DMA: 520,
  },
  "30917": {
    DMA: 520,
  },
  "30919": {
    DMA: 520,
  },
  "30999": {
    DMA: 520,
  },
  "31001": {
    DMA: 503,
  },
  "31002": {
    DMA: 520,
  },
  "31003": {
    DMA: 503,
  },
  "31004": {
    DMA: 503,
  },
  "31005": {
    DMA: 503,
  },
  "31006": {
    DMA: 503,
  },
  "31007": {
    DMA: 503,
  },
  "31008": {
    DMA: 503,
  },
  "31009": {
    DMA: 503,
  },
  "31010": {
    DMA: 525,
  },
  "31011": {
    DMA: 503,
  },
  "31012": {
    DMA: 503,
  },
  "31013": {
    DMA: 503,
  },
  "31014": {
    DMA: 503,
  },
  "31015": {
    DMA: 525,
  },
  "31016": {
    DMA: 503,
  },
  "31017": {
    DMA: 503,
  },
  "31018": {
    DMA: 503,
  },
  "31019": {
    DMA: 503,
  },
  "31020": {
    DMA: 503,
  },
  "31021": {
    DMA: 503,
  },
  "31022": {
    DMA: 503,
  },
  "31023": {
    DMA: 503,
  },
  "31024": {
    DMA: 524,
  },
  "31025": {
    DMA: 503,
  },
  "31026": {
    DMA: 524,
  },
  "31027": {
    DMA: 503,
  },
  "31028": {
    DMA: 503,
  },
  "31029": {
    DMA: 503,
  },
  "31030": {
    DMA: 503,
  },
  "31031": {
    DMA: 503,
  },
  "31032": {
    DMA: 503,
  },
  "31033": {
    DMA: 503,
  },
  "31034": {
    DMA: 503,
  },
  "31035": {
    DMA: 503,
  },
  "31036": {
    DMA: 503,
  },
  "31037": {
    DMA: 503,
  },
  "31038": {
    DMA: 524,
  },
  "31039": {
    DMA: 503,
  },
  "31040": {
    DMA: 503,
  },
  "31041": {
    DMA: 503,
  },
  "31042": {
    DMA: 503,
  },
  "31044": {
    DMA: 503,
  },
  "31045": {
    DMA: 520,
  },
  "31046": {
    DMA: 503,
  },
  "31047": {
    DMA: 503,
  },
  "31049": {
    DMA: 503,
  },
  "31050": {
    DMA: 503,
  },
  "31051": {
    DMA: 503,
  },
  "31052": {
    DMA: 503,
  },
  "31054": {
    DMA: 503,
  },
  "31055": {
    DMA: 503,
  },
  "31057": {
    DMA: 503,
  },
  "31058": {
    DMA: 522,
  },
  "31059": {
    DMA: 503,
  },
  "31060": {
    DMA: 503,
  },
  "31061": {
    DMA: 503,
  },
  "31062": {
    DMA: 503,
  },
  "31063": {
    DMA: 503,
  },
  "31064": {
    DMA: 524,
  },
  "31065": {
    DMA: 503,
  },
  "31066": {
    DMA: 503,
  },
  "31067": {
    DMA: 503,
  },
  "31068": {
    DMA: 503,
  },
  "31069": {
    DMA: 503,
  },
  "31070": {
    DMA: 503,
  },
  "31071": {
    DMA: 503,
  },
  "31072": {
    DMA: 503,
  },
  "31075": {
    DMA: 503,
  },
  "31076": {
    DMA: 503,
  },
  "31077": {
    DMA: 503,
  },
  "31078": {
    DMA: 503,
  },
  "31079": {
    DMA: 503,
  },
  "31081": {
    DMA: 503,
  },
  "31082": {
    DMA: 503,
  },
  "31083": {
    DMA: 503,
  },
  "31084": {
    DMA: 503,
  },
  "31085": {
    DMA: 524,
  },
  "31086": {
    DMA: 503,
  },
  "31087": {
    DMA: 503,
  },
  "31088": {
    DMA: 503,
  },
  "31089": {
    DMA: 503,
  },
  "31090": {
    DMA: 503,
  },
  "31091": {
    DMA: 503,
  },
  "31092": {
    DMA: 503,
  },
  "31093": {
    DMA: 503,
  },
  "31094": {
    DMA: 503,
  },
  "31095": {
    DMA: 503,
  },
  "31096": {
    DMA: 503,
  },
  "31097": {
    DMA: 524,
  },
  "31098": {
    DMA: 503,
  },
  "31099": {
    DMA: 503,
  },
  "31106": {
    DMA: 524,
  },
  "31107": {
    DMA: 524,
  },
  "31119": {
    DMA: 524,
  },
  "31120": {
    DMA: 524,
  },
  "31126": {
    DMA: 524,
  },
  "31131": {
    DMA: 524,
  },
  "31136": {
    DMA: 524,
  },
  "31139": {
    DMA: 524,
  },
  "31141": {
    DMA: 524,
  },
  "31144": {
    DMA: 524,
  },
  "31145": {
    DMA: 524,
  },
  "31146": {
    DMA: 524,
  },
  "31150": {
    DMA: 524,
  },
  "31156": {
    DMA: 524,
  },
  "31169": {
    DMA: 524,
  },
  "31191": {
    DMA: 524,
  },
  "31192": {
    DMA: 524,
  },
  "31193": {
    DMA: 524,
  },
  "31195": {
    DMA: 524,
  },
  "31196": {
    DMA: 524,
  },
  "31197": {
    DMA: 524,
  },
  "31198": {
    DMA: 524,
  },
  "31199": {
    DMA: 524,
  },
  "31201": {
    DMA: 503,
  },
  "31202": {
    DMA: 503,
  },
  "31203": {
    DMA: 503,
  },
  "31204": {
    DMA: 503,
  },
  "31205": {
    DMA: 503,
  },
  "31206": {
    DMA: 503,
  },
  "31207": {
    DMA: 503,
  },
  "31208": {
    DMA: 503,
  },
  "31209": {
    DMA: 503,
  },
  "31210": {
    DMA: 503,
  },
  "31211": {
    DMA: 503,
  },
  "31212": {
    DMA: 503,
  },
  "31213": {
    DMA: 503,
  },
  "31216": {
    DMA: 503,
  },
  "31217": {
    DMA: 503,
  },
  "31220": {
    DMA: 503,
  },
  "31221": {
    DMA: 503,
  },
  "31294": {
    DMA: 503,
  },
  "31295": {
    DMA: 503,
  },
  "31296": {
    DMA: 503,
  },
  "31297": {
    DMA: 503,
  },
  "31301": {
    DMA: 507,
  },
  "31302": {
    DMA: 507,
  },
  "31303": {
    DMA: 507,
  },
  "31304": {
    DMA: 507,
  },
  "31305": {
    DMA: 507,
  },
  "31307": {
    DMA: 507,
  },
  "31308": {
    DMA: 507,
  },
  "31309": {
    DMA: 507,
  },
  "31310": {
    DMA: 507,
  },
  "31312": {
    DMA: 507,
  },
  "31313": {
    DMA: 507,
  },
  "31314": {
    DMA: 507,
  },
  "31315": {
    DMA: 507,
  },
  "31316": {
    DMA: 507,
  },
  "31318": {
    DMA: 507,
  },
  "31319": {
    DMA: 507,
  },
  "31320": {
    DMA: 507,
  },
  "31321": {
    DMA: 507,
  },
  "31322": {
    DMA: 507,
  },
  "31323": {
    DMA: 507,
  },
  "31324": {
    DMA: 507,
  },
  "31326": {
    DMA: 507,
  },
  "31327": {
    DMA: 507,
  },
  "31328": {
    DMA: 507,
  },
  "31329": {
    DMA: 507,
  },
  "31331": {
    DMA: 507,
  },
  "31333": {
    DMA: 507,
  },
  "31401": {
    DMA: 507,
  },
  "31402": {
    DMA: 507,
  },
  "31403": {
    DMA: 507,
  },
  "31404": {
    DMA: 507,
  },
  "31405": {
    DMA: 507,
  },
  "31406": {
    DMA: 507,
  },
  "31407": {
    DMA: 507,
  },
  "31408": {
    DMA: 507,
  },
  "31409": {
    DMA: 507,
  },
  "31410": {
    DMA: 507,
  },
  "31411": {
    DMA: 507,
  },
  "31412": {
    DMA: 507,
  },
  "31414": {
    DMA: 507,
  },
  "31415": {
    DMA: 507,
  },
  "31416": {
    DMA: 507,
  },
  "31418": {
    DMA: 507,
  },
  "31419": {
    DMA: 507,
  },
  "31420": {
    DMA: 507,
  },
  "31421": {
    DMA: 507,
  },
  "31501": {
    DMA: 561,
  },
  "31502": {
    DMA: 561,
  },
  "31503": {
    DMA: 561,
  },
  "31510": {
    DMA: 507,
  },
  "31512": {
    DMA: 525,
  },
  "31513": {
    DMA: 507,
  },
  "31515": {
    DMA: 507,
  },
  "31516": {
    DMA: 561,
  },
  "31518": {
    DMA: 561,
  },
  "31519": {
    DMA: 525,
  },
  "31520": {
    DMA: 561,
  },
  "31521": {
    DMA: 561,
  },
  "31522": {
    DMA: 561,
  },
  "31523": {
    DMA: 561,
  },
  "31524": {
    DMA: 561,
  },
  "31525": {
    DMA: 561,
  },
  "31527": {
    DMA: 561,
  },
  "31532": {
    DMA: 507,
  },
  "31533": {
    DMA: 525,
  },
  "31534": {
    DMA: 525,
  },
  "31535": {
    DMA: 525,
  },
  "31537": {
    DMA: 561,
  },
  "31539": {
    DMA: 507,
  },
  "31542": {
    DMA: 561,
  },
  "31543": {
    DMA: 561,
  },
  "31544": {
    DMA: 503,
  },
  "31545": {
    DMA: 507,
  },
  "31546": {
    DMA: 507,
  },
  "31547": {
    DMA: 561,
  },
  "31548": {
    DMA: 561,
  },
  "31549": {
    DMA: 503,
  },
  "31550": {
    DMA: 561,
  },
  "31551": {
    DMA: 561,
  },
  "31552": {
    DMA: 561,
  },
  "31553": {
    DMA: 561,
  },
  "31554": {
    DMA: 525,
  },
  "31555": {
    DMA: 507,
  },
  "31556": {
    DMA: 561,
  },
  "31557": {
    DMA: 561,
  },
  "31558": {
    DMA: 561,
  },
  "31560": {
    DMA: 507,
  },
  "31561": {
    DMA: 561,
  },
  "31562": {
    DMA: 561,
  },
  "31563": {
    DMA: 507,
  },
  "31564": {
    DMA: 561,
  },
  "31565": {
    DMA: 561,
  },
  "31566": {
    DMA: 561,
  },
  "31567": {
    DMA: 525,
  },
  "31568": {
    DMA: 561,
  },
  "31569": {
    DMA: 561,
  },
  "31598": {
    DMA: 507,
  },
  "31599": {
    DMA: 507,
  },
  "31601": {
    DMA: 530,
  },
  "31602": {
    DMA: 530,
  },
  "31603": {
    DMA: 530,
  },
  "31604": {
    DMA: 530,
  },
  "31605": {
    DMA: 530,
  },
  "31606": {
    DMA: 530,
  },
  "31620": {
    DMA: 525,
  },
  "31622": {
    DMA: 525,
  },
  "31623": {
    DMA: 530,
  },
  "31624": {
    DMA: 525,
  },
  "31625": {
    DMA: 530,
  },
  "31626": {
    DMA: 530,
  },
  "31627": {
    DMA: 525,
  },
  "31629": {
    DMA: 530,
  },
  "31630": {
    DMA: 530,
  },
  "31631": {
    DMA: 530,
  },
  "31632": {
    DMA: 530,
  },
  "31634": {
    DMA: 530,
  },
  "31635": {
    DMA: 530,
  },
  "31636": {
    DMA: 530,
  },
  "31637": {
    DMA: 525,
  },
  "31638": {
    DMA: 530,
  },
  "31639": {
    DMA: 525,
  },
  "31641": {
    DMA: 530,
  },
  "31642": {
    DMA: 525,
  },
  "31643": {
    DMA: 530,
  },
  "31645": {
    DMA: 525,
  },
  "31647": {
    DMA: 525,
  },
  "31648": {
    DMA: 530,
  },
  "31649": {
    DMA: 530,
  },
  "31650": {
    DMA: 525,
  },
  "31698": {
    DMA: 530,
  },
  "31699": {
    DMA: 530,
  },
  "31701": {
    DMA: 525,
  },
  "31702": {
    DMA: 525,
  },
  "31703": {
    DMA: 525,
  },
  "31704": {
    DMA: 525,
  },
  "31705": {
    DMA: 525,
  },
  "31706": {
    DMA: 525,
  },
  "31707": {
    DMA: 525,
  },
  "31708": {
    DMA: 525,
  },
  "31709": {
    DMA: 522,
  },
  "31711": {
    DMA: 522,
  },
  "31712": {
    DMA: 525,
  },
  "31714": {
    DMA: 525,
  },
  "31716": {
    DMA: 525,
  },
  "31719": {
    DMA: 522,
  },
  "31720": {
    DMA: 530,
  },
  "31721": {
    DMA: 525,
  },
  "31722": {
    DMA: 525,
  },
  "31727": {
    DMA: 525,
  },
  "31730": {
    DMA: 525,
  },
  "31733": {
    DMA: 525,
  },
  "31735": {
    DMA: 522,
  },
  "31738": {
    DMA: 530,
  },
  "31739": {
    DMA: 525,
  },
  "31743": {
    DMA: 522,
  },
  "31744": {
    DMA: 525,
  },
  "31747": {
    DMA: 525,
  },
  "31749": {
    DMA: 525,
  },
  "31750": {
    DMA: 525,
  },
  "31753": {
    DMA: 525,
  },
  "31756": {
    DMA: 525,
  },
  "31757": {
    DMA: 530,
  },
  "31758": {
    DMA: 530,
  },
  "31760": {
    DMA: 525,
  },
  "31763": {
    DMA: 525,
  },
  "31764": {
    DMA: 522,
  },
  "31765": {
    DMA: 530,
  },
  "31768": {
    DMA: 525,
  },
  "31769": {
    DMA: 525,
  },
  "31771": {
    DMA: 525,
  },
  "31772": {
    DMA: 525,
  },
  "31773": {
    DMA: 530,
  },
  "31774": {
    DMA: 525,
  },
  "31775": {
    DMA: 525,
  },
  "31776": {
    DMA: 525,
  },
  "31778": {
    DMA: 530,
  },
  "31779": {
    DMA: 525,
  },
  "31780": {
    DMA: 522,
  },
  "31781": {
    DMA: 525,
  },
  "31782": {
    DMA: 525,
  },
  "31783": {
    DMA: 525,
  },
  "31784": {
    DMA: 525,
  },
  "31787": {
    DMA: 525,
  },
  "31788": {
    DMA: 525,
  },
  "31789": {
    DMA: 525,
  },
  "31790": {
    DMA: 525,
  },
  "31791": {
    DMA: 525,
  },
  "31792": {
    DMA: 530,
  },
  "31793": {
    DMA: 525,
  },
  "31794": {
    DMA: 525,
  },
  "31795": {
    DMA: 525,
  },
  "31796": {
    DMA: 525,
  },
  "31798": {
    DMA: 525,
  },
  "31799": {
    DMA: 530,
  },
  "31801": {
    DMA: 522,
  },
  "31803": {
    DMA: 522,
  },
  "31804": {
    DMA: 522,
  },
  "31805": {
    DMA: 522,
  },
  "31806": {
    DMA: 522,
  },
  "31807": {
    DMA: 522,
  },
  "31808": {
    DMA: 522,
  },
  "31810": {
    DMA: 522,
  },
  "31811": {
    DMA: 522,
  },
  "31812": {
    DMA: 522,
  },
  "31814": {
    DMA: 522,
  },
  "31815": {
    DMA: 522,
  },
  "31816": {
    DMA: 524,
  },
  "31820": {
    DMA: 522,
  },
  "31821": {
    DMA: 522,
  },
  "31822": {
    DMA: 522,
  },
  "31823": {
    DMA: 522,
  },
  "31824": {
    DMA: 522,
  },
  "31825": {
    DMA: 522,
  },
  "31826": {
    DMA: 522,
  },
  "31827": {
    DMA: 522,
  },
  "31829": {
    DMA: 522,
  },
  "31830": {
    DMA: 524,
  },
  "31831": {
    DMA: 522,
  },
  "31832": {
    DMA: 522,
  },
  "31833": {
    DMA: 524,
  },
  "31836": {
    DMA: 522,
  },
  "31901": {
    DMA: 522,
  },
  "31902": {
    DMA: 522,
  },
  "31903": {
    DMA: 522,
  },
  "31904": {
    DMA: 522,
  },
  "31905": {
    DMA: 522,
  },
  "31906": {
    DMA: 522,
  },
  "31907": {
    DMA: 522,
  },
  "31908": {
    DMA: 522,
  },
  "31909": {
    DMA: 522,
  },
  "31914": {
    DMA: 522,
  },
  "31917": {
    DMA: 522,
  },
  "31993": {
    DMA: 522,
  },
  "31995": {
    DMA: 522,
  },
  "31997": {
    DMA: 522,
  },
  "31998": {
    DMA: 522,
  },
  "31999": {
    DMA: 522,
  },
  "32003": {
    DMA: 561,
  },
  "32004": {
    DMA: 561,
  },
  "32006": {
    DMA: 561,
  },
  "32007": {
    DMA: 561,
  },
  "32008": {
    DMA: 530,
  },
  "32009": {
    DMA: 561,
  },
  "32011": {
    DMA: 561,
  },
  "32013": {
    DMA: 530,
  },
  "32024": {
    DMA: 561,
  },
  "32025": {
    DMA: 561,
  },
  "32026": {
    DMA: 561,
  },
  "32030": {
    DMA: 561,
  },
  "32033": {
    DMA: 561,
  },
  "32034": {
    DMA: 561,
  },
  "32035": {
    DMA: 561,
  },
  "32038": {
    DMA: 561,
  },
  "32040": {
    DMA: 561,
  },
  "32041": {
    DMA: 561,
  },
  "32042": {
    DMA: 561,
  },
  "32043": {
    DMA: 561,
  },
  "32044": {
    DMA: 561,
  },
  "32046": {
    DMA: 561,
  },
  "32050": {
    DMA: 561,
  },
  "32052": {
    DMA: 530,
  },
  "32053": {
    DMA: 530,
  },
  "32054": {
    DMA: 561,
  },
  "32055": {
    DMA: 561,
  },
  "32056": {
    DMA: 561,
  },
  "32058": {
    DMA: 561,
  },
  "32059": {
    DMA: 530,
  },
  "32060": {
    DMA: 530,
  },
  "32061": {
    DMA: 561,
  },
  "32062": {
    DMA: 530,
  },
  "32063": {
    DMA: 561,
  },
  "32064": {
    DMA: 530,
  },
  "32065": {
    DMA: 561,
  },
  "32066": {
    DMA: 530,
  },
  "32067": {
    DMA: 561,
  },
  "32068": {
    DMA: 561,
  },
  "32071": {
    DMA: 530,
  },
  "32072": {
    DMA: 561,
  },
  "32073": {
    DMA: 561,
  },
  "32079": {
    DMA: 561,
  },
  "32080": {
    DMA: 561,
  },
  "32081": {
    DMA: 561,
  },
  "32082": {
    DMA: 561,
  },
  "32083": {
    DMA: 561,
  },
  "32084": {
    DMA: 561,
  },
  "32085": {
    DMA: 561,
  },
  "32086": {
    DMA: 561,
  },
  "32087": {
    DMA: 561,
  },
  "32091": {
    DMA: 561,
  },
  "32092": {
    DMA: 561,
  },
  "32094": {
    DMA: 530,
  },
  "32095": {
    DMA: 561,
  },
  "32096": {
    DMA: 530,
  },
  "32097": {
    DMA: 561,
  },
  "32099": {
    DMA: 561,
  },
  "32102": {
    DMA: 534,
  },
  "32105": {
    DMA: 534,
  },
  "32110": {
    DMA: 534,
  },
  "32111": {
    DMA: 534,
  },
  "32112": {
    DMA: 561,
  },
  "32113": {
    DMA: 534,
  },
  "32114": {
    DMA: 534,
  },
  "32115": {
    DMA: 534,
  },
  "32116": {
    DMA: 534,
  },
  "32117": {
    DMA: 534,
  },
  "32118": {
    DMA: 534,
  },
  "32119": {
    DMA: 534,
  },
  "32120": {
    DMA: 534,
  },
  "32121": {
    DMA: 534,
  },
  "32122": {
    DMA: 534,
  },
  "32123": {
    DMA: 534,
  },
  "32124": {
    DMA: 534,
  },
  "32125": {
    DMA: 534,
  },
  "32126": {
    DMA: 534,
  },
  "32127": {
    DMA: 534,
  },
  "32128": {
    DMA: 534,
  },
  "32129": {
    DMA: 534,
  },
  "32130": {
    DMA: 534,
  },
  "32131": {
    DMA: 561,
  },
  "32132": {
    DMA: 534,
  },
  "32133": {
    DMA: 534,
  },
  "32134": {
    DMA: 534,
  },
  "32135": {
    DMA: 534,
  },
  "32136": {
    DMA: 534,
  },
  "32137": {
    DMA: 534,
  },
  "32138": {
    DMA: 561,
  },
  "32139": {
    DMA: 561,
  },
  "32140": {
    DMA: 561,
  },
  "32141": {
    DMA: 534,
  },
  "32142": {
    DMA: 534,
  },
  "32143": {
    DMA: 534,
  },
  "32145": {
    DMA: 561,
  },
  "32147": {
    DMA: 561,
  },
  "32148": {
    DMA: 561,
  },
  "32149": {
    DMA: 561,
  },
  "32157": {
    DMA: 561,
  },
  "32158": {
    DMA: 534,
  },
  "32159": {
    DMA: 534,
  },
  "32160": {
    DMA: 561,
  },
  "32162": {
    DMA: 534,
  },
  "32163": {
    DMA: 534,
  },
  "32164": {
    DMA: 534,
  },
  "32168": {
    DMA: 534,
  },
  "32169": {
    DMA: 534,
  },
  "32170": {
    DMA: 534,
  },
  "32173": {
    DMA: 534,
  },
  "32174": {
    DMA: 534,
  },
  "32175": {
    DMA: 534,
  },
  "32176": {
    DMA: 534,
  },
  "32177": {
    DMA: 561,
  },
  "32178": {
    DMA: 561,
  },
  "32179": {
    DMA: 534,
  },
  "32180": {
    DMA: 534,
  },
  "32181": {
    DMA: 561,
  },
  "32182": {
    DMA: 534,
  },
  "32183": {
    DMA: 534,
  },
  "32185": {
    DMA: 561,
  },
  "32187": {
    DMA: 561,
  },
  "32189": {
    DMA: 561,
  },
  "32190": {
    DMA: 534,
  },
  "32192": {
    DMA: 534,
  },
  "32193": {
    DMA: 561,
  },
  "32195": {
    DMA: 534,
  },
  "32198": {
    DMA: 534,
  },
  "32201": {
    DMA: 561,
  },
  "32202": {
    DMA: 561,
  },
  "32203": {
    DMA: 561,
  },
  "32204": {
    DMA: 561,
  },
  "32205": {
    DMA: 561,
  },
  "32206": {
    DMA: 561,
  },
  "32207": {
    DMA: 561,
  },
  "32208": {
    DMA: 561,
  },
  "32209": {
    DMA: 561,
  },
  "32210": {
    DMA: 561,
  },
  "32211": {
    DMA: 561,
  },
  "32212": {
    DMA: 561,
  },
  "32214": {
    DMA: 561,
  },
  "32215": {
    DMA: 561,
  },
  "32216": {
    DMA: 561,
  },
  "32217": {
    DMA: 561,
  },
  "32218": {
    DMA: 561,
  },
  "32219": {
    DMA: 561,
  },
  "32220": {
    DMA: 561,
  },
  "32221": {
    DMA: 561,
  },
  "32222": {
    DMA: 561,
  },
  "32223": {
    DMA: 561,
  },
  "32224": {
    DMA: 561,
  },
  "32225": {
    DMA: 561,
  },
  "32226": {
    DMA: 561,
  },
  "32227": {
    DMA: 561,
  },
  "32228": {
    DMA: 561,
  },
  "32229": {
    DMA: 561,
  },
  "32230": {
    DMA: 561,
  },
  "32231": {
    DMA: 561,
  },
  "32232": {
    DMA: 561,
  },
  "32233": {
    DMA: 561,
  },
  "32234": {
    DMA: 561,
  },
  "32235": {
    DMA: 561,
  },
  "32236": {
    DMA: 561,
  },
  "32237": {
    DMA: 561,
  },
  "32238": {
    DMA: 561,
  },
  "32239": {
    DMA: 561,
  },
  "32240": {
    DMA: 561,
  },
  "32241": {
    DMA: 561,
  },
  "32244": {
    DMA: 561,
  },
  "32245": {
    DMA: 561,
  },
  "32246": {
    DMA: 561,
  },
  "32247": {
    DMA: 561,
  },
  "32250": {
    DMA: 561,
  },
  "32254": {
    DMA: 561,
  },
  "32255": {
    DMA: 561,
  },
  "32256": {
    DMA: 561,
  },
  "32257": {
    DMA: 561,
  },
  "32258": {
    DMA: 561,
  },
  "32259": {
    DMA: 561,
  },
  "32260": {
    DMA: 561,
  },
  "32266": {
    DMA: 561,
  },
  "32267": {
    DMA: 561,
  },
  "32277": {
    DMA: 561,
  },
  "32290": {
    DMA: 561,
  },
  "32301": {
    DMA: 530,
  },
  "32302": {
    DMA: 530,
  },
  "32303": {
    DMA: 530,
  },
  "32304": {
    DMA: 530,
  },
  "32305": {
    DMA: 530,
  },
  "32306": {
    DMA: 530,
  },
  "32307": {
    DMA: 530,
  },
  "32308": {
    DMA: 530,
  },
  "32309": {
    DMA: 530,
  },
  "32310": {
    DMA: 530,
  },
  "32311": {
    DMA: 530,
  },
  "32312": {
    DMA: 530,
  },
  "32313": {
    DMA: 530,
  },
  "32314": {
    DMA: 530,
  },
  "32315": {
    DMA: 530,
  },
  "32316": {
    DMA: 530,
  },
  "32317": {
    DMA: 530,
  },
  "32318": {
    DMA: 530,
  },
  "32320": {
    DMA: 656,
  },
  "32321": {
    DMA: 656,
  },
  "32322": {
    DMA: 656,
  },
  "32323": {
    DMA: 656,
  },
  "32324": {
    DMA: 530,
  },
  "32326": {
    DMA: 530,
  },
  "32327": {
    DMA: 530,
  },
  "32328": {
    DMA: 656,
  },
  "32329": {
    DMA: 656,
  },
  "32330": {
    DMA: 530,
  },
  "32331": {
    DMA: 530,
  },
  "32332": {
    DMA: 530,
  },
  "32333": {
    DMA: 530,
  },
  "32334": {
    DMA: 656,
  },
  "32335": {
    DMA: 656,
  },
  "32336": {
    DMA: 530,
  },
  "32337": {
    DMA: 530,
  },
  "32340": {
    DMA: 530,
  },
  "32341": {
    DMA: 530,
  },
  "32343": {
    DMA: 530,
  },
  "32344": {
    DMA: 530,
  },
  "32345": {
    DMA: 530,
  },
  "32346": {
    DMA: 530,
  },
  "32347": {
    DMA: 530,
  },
  "32348": {
    DMA: 530,
  },
  "32350": {
    DMA: 530,
  },
  "32351": {
    DMA: 530,
  },
  "32352": {
    DMA: 530,
  },
  "32353": {
    DMA: 530,
  },
  "32355": {
    DMA: 530,
  },
  "32356": {
    DMA: 530,
  },
  "32357": {
    DMA: 530,
  },
  "32358": {
    DMA: 530,
  },
  "32359": {
    DMA: 530,
  },
  "32360": {
    DMA: 656,
  },
  "32361": {
    DMA: 530,
  },
  "32362": {
    DMA: 530,
  },
  "32395": {
    DMA: 530,
  },
  "32399": {
    DMA: 530,
  },
  "32401": {
    DMA: 656,
  },
  "32402": {
    DMA: 656,
  },
  "32403": {
    DMA: 656,
  },
  "32404": {
    DMA: 656,
  },
  "32405": {
    DMA: 656,
  },
  "32406": {
    DMA: 656,
  },
  "32407": {
    DMA: 656,
  },
  "32408": {
    DMA: 656,
  },
  "32409": {
    DMA: 656,
  },
  "32410": {
    DMA: 656,
  },
  "32411": {
    DMA: 656,
  },
  "32412": {
    DMA: 656,
  },
  "32413": {
    DMA: 656,
  },
  "32417": {
    DMA: 656,
  },
  "32420": {
    DMA: 656,
  },
  "32421": {
    DMA: 656,
  },
  "32422": {
    DMA: 656,
  },
  "32423": {
    DMA: 656,
  },
  "32424": {
    DMA: 656,
  },
  "32425": {
    DMA: 656,
  },
  "32426": {
    DMA: 656,
  },
  "32427": {
    DMA: 656,
  },
  "32428": {
    DMA: 656,
  },
  "32430": {
    DMA: 656,
  },
  "32431": {
    DMA: 656,
  },
  "32432": {
    DMA: 656,
  },
  "32433": {
    DMA: 656,
  },
  "32434": {
    DMA: 656,
  },
  "32435": {
    DMA: 656,
  },
  "32437": {
    DMA: 656,
  },
  "32438": {
    DMA: 656,
  },
  "32439": {
    DMA: 656,
  },
  "32440": {
    DMA: 656,
  },
  "32442": {
    DMA: 656,
  },
  "32443": {
    DMA: 656,
  },
  "32444": {
    DMA: 656,
  },
  "32445": {
    DMA: 656,
  },
  "32446": {
    DMA: 656,
  },
  "32447": {
    DMA: 656,
  },
  "32448": {
    DMA: 656,
  },
  "32449": {
    DMA: 656,
  },
  "32452": {
    DMA: 656,
  },
  "32454": {
    DMA: 656,
  },
  "32455": {
    DMA: 656,
  },
  "32456": {
    DMA: 656,
  },
  "32457": {
    DMA: 656,
  },
  "32459": {
    DMA: 656,
  },
  "32460": {
    DMA: 656,
  },
  "32461": {
    DMA: 656,
  },
  "32462": {
    DMA: 656,
  },
  "32463": {
    DMA: 656,
  },
  "32464": {
    DMA: 656,
  },
  "32465": {
    DMA: 656,
  },
  "32466": {
    DMA: 656,
  },
  "32501": {
    DMA: 686,
  },
  "32502": {
    DMA: 686,
  },
  "32503": {
    DMA: 686,
  },
  "32504": {
    DMA: 686,
  },
  "32505": {
    DMA: 686,
  },
  "32506": {
    DMA: 686,
  },
  "32507": {
    DMA: 686,
  },
  "32508": {
    DMA: 686,
  },
  "32509": {
    DMA: 686,
  },
  "32511": {
    DMA: 686,
  },
  "32512": {
    DMA: 686,
  },
  "32513": {
    DMA: 686,
  },
  "32514": {
    DMA: 686,
  },
  "32516": {
    DMA: 686,
  },
  "32520": {
    DMA: 686,
  },
  "32521": {
    DMA: 686,
  },
  "32522": {
    DMA: 686,
  },
  "32523": {
    DMA: 686,
  },
  "32524": {
    DMA: 686,
  },
  "32526": {
    DMA: 686,
  },
  "32530": {
    DMA: 686,
  },
  "32531": {
    DMA: 686,
  },
  "32533": {
    DMA: 686,
  },
  "32534": {
    DMA: 686,
  },
  "32535": {
    DMA: 686,
  },
  "32536": {
    DMA: 686,
  },
  "32537": {
    DMA: 686,
  },
  "32538": {
    DMA: 656,
  },
  "32539": {
    DMA: 686,
  },
  "32540": {
    DMA: 686,
  },
  "32541": {
    DMA: 686,
  },
  "32542": {
    DMA: 686,
  },
  "32544": {
    DMA: 686,
  },
  "32547": {
    DMA: 686,
  },
  "32548": {
    DMA: 686,
  },
  "32549": {
    DMA: 686,
  },
  "32550": {
    DMA: 656,
  },
  "32559": {
    DMA: 686,
  },
  "32560": {
    DMA: 686,
  },
  "32561": {
    DMA: 686,
  },
  "32562": {
    DMA: 686,
  },
  "32563": {
    DMA: 686,
  },
  "32564": {
    DMA: 686,
  },
  "32565": {
    DMA: 686,
  },
  "32566": {
    DMA: 686,
  },
  "32567": {
    DMA: 686,
  },
  "32568": {
    DMA: 686,
  },
  "32569": {
    DMA: 686,
  },
  "32570": {
    DMA: 686,
  },
  "32571": {
    DMA: 686,
  },
  "32572": {
    DMA: 686,
  },
  "32577": {
    DMA: 686,
  },
  "32578": {
    DMA: 686,
  },
  "32579": {
    DMA: 686,
  },
  "32580": {
    DMA: 686,
  },
  "32583": {
    DMA: 686,
  },
  "32588": {
    DMA: 686,
  },
  "32590": {
    DMA: 686,
  },
  "32591": {
    DMA: 686,
  },
  "32592": {
    DMA: 686,
  },
  "32601": {
    DMA: 592,
  },
  "32602": {
    DMA: 592,
  },
  "32603": {
    DMA: 592,
  },
  "32604": {
    DMA: 592,
  },
  "32605": {
    DMA: 592,
  },
  "32606": {
    DMA: 592,
  },
  "32607": {
    DMA: 592,
  },
  "32608": {
    DMA: 592,
  },
  "32609": {
    DMA: 592,
  },
  "32610": {
    DMA: 592,
  },
  "32611": {
    DMA: 592,
  },
  "32612": {
    DMA: 592,
  },
  "32613": {
    DMA: 592,
  },
  "32614": {
    DMA: 592,
  },
  "32615": {
    DMA: 592,
  },
  "32616": {
    DMA: 592,
  },
  "32617": {
    DMA: 534,
  },
  "32618": {
    DMA: 592,
  },
  "32619": {
    DMA: 592,
  },
  "32621": {
    DMA: 592,
  },
  "32622": {
    DMA: 561,
  },
  "32625": {
    DMA: 592,
  },
  "32626": {
    DMA: 592,
  },
  "32627": {
    DMA: 592,
  },
  "32628": {
    DMA: 592,
  },
  "32631": {
    DMA: 592,
  },
  "32633": {
    DMA: 592,
  },
  "32634": {
    DMA: 534,
  },
  "32635": {
    DMA: 592,
  },
  "32639": {
    DMA: 592,
  },
  "32640": {
    DMA: 592,
  },
  "32641": {
    DMA: 592,
  },
  "32643": {
    DMA: 592,
  },
  "32644": {
    DMA: 592,
  },
  "32648": {
    DMA: 592,
  },
  "32653": {
    DMA: 592,
  },
  "32654": {
    DMA: 592,
  },
  "32655": {
    DMA: 592,
  },
  "32656": {
    DMA: 561,
  },
  "32658": {
    DMA: 592,
  },
  "32662": {
    DMA: 592,
  },
  "32663": {
    DMA: 534,
  },
  "32664": {
    DMA: 534,
  },
  "32666": {
    DMA: 561,
  },
  "32667": {
    DMA: 592,
  },
  "32668": {
    DMA: 592,
  },
  "32669": {
    DMA: 592,
  },
  "32680": {
    DMA: 592,
  },
  "32681": {
    DMA: 534,
  },
  "32683": {
    DMA: 592,
  },
  "32686": {
    DMA: 534,
  },
  "32692": {
    DMA: 592,
  },
  "32693": {
    DMA: 592,
  },
  "32694": {
    DMA: 592,
  },
  "32696": {
    DMA: 592,
  },
  "32697": {
    DMA: 561,
  },
  "32701": {
    DMA: 534,
  },
  "32702": {
    DMA: 534,
  },
  "32703": {
    DMA: 534,
  },
  "32704": {
    DMA: 534,
  },
  "32706": {
    DMA: 534,
  },
  "32707": {
    DMA: 534,
  },
  "32708": {
    DMA: 534,
  },
  "32709": {
    DMA: 534,
  },
  "32710": {
    DMA: 534,
  },
  "32712": {
    DMA: 534,
  },
  "32713": {
    DMA: 534,
  },
  "32714": {
    DMA: 534,
  },
  "32715": {
    DMA: 534,
  },
  "32716": {
    DMA: 534,
  },
  "32718": {
    DMA: 534,
  },
  "32719": {
    DMA: 534,
  },
  "32720": {
    DMA: 534,
  },
  "32721": {
    DMA: 534,
  },
  "32722": {
    DMA: 534,
  },
  "32723": {
    DMA: 534,
  },
  "32724": {
    DMA: 534,
  },
  "32725": {
    DMA: 534,
  },
  "32726": {
    DMA: 534,
  },
  "32727": {
    DMA: 534,
  },
  "32728": {
    DMA: 534,
  },
  "32730": {
    DMA: 534,
  },
  "32732": {
    DMA: 534,
  },
  "32733": {
    DMA: 534,
  },
  "32735": {
    DMA: 534,
  },
  "32736": {
    DMA: 534,
  },
  "32738": {
    DMA: 534,
  },
  "32739": {
    DMA: 534,
  },
  "32744": {
    DMA: 534,
  },
  "32745": {
    DMA: 534,
  },
  "32746": {
    DMA: 534,
  },
  "32747": {
    DMA: 534,
  },
  "32750": {
    DMA: 534,
  },
  "32751": {
    DMA: 534,
  },
  "32752": {
    DMA: 534,
  },
  "32753": {
    DMA: 534,
  },
  "32754": {
    DMA: 534,
  },
  "32756": {
    DMA: 534,
  },
  "32757": {
    DMA: 534,
  },
  "32759": {
    DMA: 534,
  },
  "32762": {
    DMA: 534,
  },
  "32763": {
    DMA: 534,
  },
  "32764": {
    DMA: 534,
  },
  "32765": {
    DMA: 534,
  },
  "32766": {
    DMA: 534,
  },
  "32767": {
    DMA: 534,
  },
  "32768": {
    DMA: 534,
  },
  "32771": {
    DMA: 534,
  },
  "32772": {
    DMA: 534,
  },
  "32773": {
    DMA: 534,
  },
  "32774": {
    DMA: 534,
  },
  "32775": {
    DMA: 534,
  },
  "32776": {
    DMA: 534,
  },
  "32777": {
    DMA: 534,
  },
  "32778": {
    DMA: 534,
  },
  "32779": {
    DMA: 534,
  },
  "32780": {
    DMA: 534,
  },
  "32781": {
    DMA: 534,
  },
  "32782": {
    DMA: 534,
  },
  "32783": {
    DMA: 534,
  },
  "32784": {
    DMA: 534,
  },
  "32789": {
    DMA: 534,
  },
  "32790": {
    DMA: 534,
  },
  "32791": {
    DMA: 534,
  },
  "32792": {
    DMA: 534,
  },
  "32793": {
    DMA: 534,
  },
  "32794": {
    DMA: 534,
  },
  "32795": {
    DMA: 534,
  },
  "32796": {
    DMA: 534,
  },
  "32798": {
    DMA: 534,
  },
  "32799": {
    DMA: 534,
  },
  "32801": {
    DMA: 534,
  },
  "32802": {
    DMA: 534,
  },
  "32803": {
    DMA: 534,
  },
  "32804": {
    DMA: 534,
  },
  "32805": {
    DMA: 534,
  },
  "32806": {
    DMA: 534,
  },
  "32807": {
    DMA: 534,
  },
  "32808": {
    DMA: 534,
  },
  "32809": {
    DMA: 534,
  },
  "32810": {
    DMA: 534,
  },
  "32811": {
    DMA: 534,
  },
  "32812": {
    DMA: 534,
  },
  "32814": {
    DMA: 534,
  },
  "32815": {
    DMA: 534,
  },
  "32816": {
    DMA: 534,
  },
  "32817": {
    DMA: 534,
  },
  "32818": {
    DMA: 534,
  },
  "32819": {
    DMA: 534,
  },
  "32820": {
    DMA: 534,
  },
  "32821": {
    DMA: 534,
  },
  "32822": {
    DMA: 534,
  },
  "32824": {
    DMA: 534,
  },
  "32825": {
    DMA: 534,
  },
  "32826": {
    DMA: 534,
  },
  "32827": {
    DMA: 534,
  },
  "32828": {
    DMA: 534,
  },
  "32829": {
    DMA: 534,
  },
  "32830": {
    DMA: 534,
  },
  "32831": {
    DMA: 534,
  },
  "32832": {
    DMA: 534,
  },
  "32833": {
    DMA: 534,
  },
  "32834": {
    DMA: 534,
  },
  "32835": {
    DMA: 534,
  },
  "32836": {
    DMA: 534,
  },
  "32837": {
    DMA: 534,
  },
  "32839": {
    DMA: 534,
  },
  "32853": {
    DMA: 534,
  },
  "32854": {
    DMA: 534,
  },
  "32855": {
    DMA: 534,
  },
  "32856": {
    DMA: 534,
  },
  "32857": {
    DMA: 534,
  },
  "32858": {
    DMA: 534,
  },
  "32859": {
    DMA: 534,
  },
  "32860": {
    DMA: 534,
  },
  "32861": {
    DMA: 534,
  },
  "32862": {
    DMA: 534,
  },
  "32867": {
    DMA: 534,
  },
  "32868": {
    DMA: 534,
  },
  "32869": {
    DMA: 534,
  },
  "32872": {
    DMA: 534,
  },
  "32877": {
    DMA: 534,
  },
  "32878": {
    DMA: 534,
  },
  "32885": {
    DMA: 534,
  },
  "32886": {
    DMA: 534,
  },
  "32887": {
    DMA: 534,
  },
  "32890": {
    DMA: 534,
  },
  "32891": {
    DMA: 534,
  },
  "32893": {
    DMA: 534,
  },
  "32896": {
    DMA: 534,
  },
  "32897": {
    DMA: 534,
  },
  "32898": {
    DMA: 534,
  },
  "32899": {
    DMA: 534,
  },
  "32901": {
    DMA: 534,
  },
  "32902": {
    DMA: 534,
  },
  "32903": {
    DMA: 534,
  },
  "32904": {
    DMA: 534,
  },
  "32905": {
    DMA: 534,
  },
  "32906": {
    DMA: 534,
  },
  "32907": {
    DMA: 534,
  },
  "32908": {
    DMA: 534,
  },
  "32909": {
    DMA: 534,
  },
  "32910": {
    DMA: 534,
  },
  "32911": {
    DMA: 534,
  },
  "32912": {
    DMA: 534,
  },
  "32919": {
    DMA: 534,
  },
  "32920": {
    DMA: 534,
  },
  "32922": {
    DMA: 534,
  },
  "32923": {
    DMA: 534,
  },
  "32924": {
    DMA: 534,
  },
  "32925": {
    DMA: 534,
  },
  "32926": {
    DMA: 534,
  },
  "32927": {
    DMA: 534,
  },
  "32931": {
    DMA: 534,
  },
  "32932": {
    DMA: 534,
  },
  "32934": {
    DMA: 534,
  },
  "32935": {
    DMA: 534,
  },
  "32936": {
    DMA: 534,
  },
  "32937": {
    DMA: 534,
  },
  "32940": {
    DMA: 534,
  },
  "32941": {
    DMA: 534,
  },
  "32948": {
    DMA: 548,
  },
  "32949": {
    DMA: 534,
  },
  "32950": {
    DMA: 534,
  },
  "32951": {
    DMA: 534,
  },
  "32952": {
    DMA: 534,
  },
  "32953": {
    DMA: 534,
  },
  "32954": {
    DMA: 534,
  },
  "32955": {
    DMA: 534,
  },
  "32956": {
    DMA: 534,
  },
  "32957": {
    DMA: 548,
  },
  "32958": {
    DMA: 548,
  },
  "32959": {
    DMA: 534,
  },
  "32960": {
    DMA: 548,
  },
  "32961": {
    DMA: 548,
  },
  "32962": {
    DMA: 548,
  },
  "32963": {
    DMA: 548,
  },
  "32964": {
    DMA: 548,
  },
  "32965": {
    DMA: 548,
  },
  "32966": {
    DMA: 548,
  },
  "32967": {
    DMA: 548,
  },
  "32968": {
    DMA: 548,
  },
  "32969": {
    DMA: 548,
  },
  "32970": {
    DMA: 548,
  },
  "32971": {
    DMA: 548,
  },
  "32976": {
    DMA: 534,
  },
  "32978": {
    DMA: 548,
  },
  "33001": {
    DMA: 528,
  },
  "33002": {
    DMA: 528,
  },
  "33004": {
    DMA: 528,
  },
  "33008": {
    DMA: 528,
  },
  "33009": {
    DMA: 528,
  },
  "33010": {
    DMA: 528,
  },
  "33011": {
    DMA: 528,
  },
  "33012": {
    DMA: 528,
  },
  "33013": {
    DMA: 528,
  },
  "33014": {
    DMA: 528,
  },
  "33015": {
    DMA: 528,
  },
  "33016": {
    DMA: 528,
  },
  "33017": {
    DMA: 528,
  },
  "33018": {
    DMA: 528,
  },
  "33019": {
    DMA: 528,
  },
  "33020": {
    DMA: 528,
  },
  "33021": {
    DMA: 528,
  },
  "33022": {
    DMA: 528,
  },
  "33023": {
    DMA: 528,
  },
  "33024": {
    DMA: 528,
  },
  "33025": {
    DMA: 528,
  },
  "33026": {
    DMA: 528,
  },
  "33027": {
    DMA: 528,
  },
  "33028": {
    DMA: 528,
  },
  "33029": {
    DMA: 528,
  },
  "33030": {
    DMA: 528,
  },
  "33031": {
    DMA: 528,
  },
  "33032": {
    DMA: 528,
  },
  "33033": {
    DMA: 528,
  },
  "33034": {
    DMA: 528,
  },
  "33035": {
    DMA: 528,
  },
  "33036": {
    DMA: 528,
  },
  "33037": {
    DMA: 528,
  },
  "33039": {
    DMA: 528,
  },
  "33040": {
    DMA: 528,
  },
  "33041": {
    DMA: 528,
  },
  "33042": {
    DMA: 528,
  },
  "33043": {
    DMA: 528,
  },
  "33045": {
    DMA: 528,
  },
  "33050": {
    DMA: 528,
  },
  "33051": {
    DMA: 528,
  },
  "33052": {
    DMA: 528,
  },
  "33054": {
    DMA: 528,
  },
  "33055": {
    DMA: 528,
  },
  "33056": {
    DMA: 528,
  },
  "33060": {
    DMA: 528,
  },
  "33061": {
    DMA: 528,
  },
  "33062": {
    DMA: 528,
  },
  "33063": {
    DMA: 528,
  },
  "33064": {
    DMA: 528,
  },
  "33065": {
    DMA: 528,
  },
  "33066": {
    DMA: 528,
  },
  "33067": {
    DMA: 528,
  },
  "33068": {
    DMA: 528,
  },
  "33069": {
    DMA: 528,
  },
  "33070": {
    DMA: 528,
  },
  "33071": {
    DMA: 528,
  },
  "33072": {
    DMA: 528,
  },
  "33073": {
    DMA: 528,
  },
  "33074": {
    DMA: 528,
  },
  "33075": {
    DMA: 528,
  },
  "33076": {
    DMA: 528,
  },
  "33077": {
    DMA: 528,
  },
  "33081": {
    DMA: 528,
  },
  "33082": {
    DMA: 528,
  },
  "33083": {
    DMA: 528,
  },
  "33084": {
    DMA: 528,
  },
  "33090": {
    DMA: 528,
  },
  "33092": {
    DMA: 528,
  },
  "33093": {
    DMA: 528,
  },
  "33097": {
    DMA: 528,
  },
  "33101": {
    DMA: 528,
  },
  "33102": {
    DMA: 528,
  },
  "33106": {
    DMA: 528,
  },
  "33107": {
    DMA: 528,
  },
  "33109": {
    DMA: 528,
  },
  "33110": {
    DMA: 528,
  },
  "33111": {
    DMA: 528,
  },
  "33112": {
    DMA: 528,
  },
  "33114": {
    DMA: 528,
  },
  "33116": {
    DMA: 528,
  },
  "33119": {
    DMA: 528,
  },
  "33121": {
    DMA: 528,
  },
  "33122": {
    DMA: 528,
  },
  "33124": {
    DMA: 528,
  },
  "33125": {
    DMA: 528,
  },
  "33126": {
    DMA: 528,
  },
  "33127": {
    DMA: 528,
  },
  "33128": {
    DMA: 528,
  },
  "33129": {
    DMA: 528,
  },
  "33130": {
    DMA: 528,
  },
  "33131": {
    DMA: 528,
  },
  "33132": {
    DMA: 528,
  },
  "33133": {
    DMA: 528,
  },
  "33134": {
    DMA: 528,
  },
  "33135": {
    DMA: 528,
  },
  "33136": {
    DMA: 528,
  },
  "33137": {
    DMA: 528,
  },
  "33138": {
    DMA: 528,
  },
  "33139": {
    DMA: 528,
  },
  "33140": {
    DMA: 528,
  },
  "33141": {
    DMA: 528,
  },
  "33142": {
    DMA: 528,
  },
  "33143": {
    DMA: 528,
  },
  "33144": {
    DMA: 528,
  },
  "33145": {
    DMA: 528,
  },
  "33146": {
    DMA: 528,
  },
  "33147": {
    DMA: 528,
  },
  "33148": {
    DMA: 528,
  },
  "33149": {
    DMA: 528,
  },
  "33150": {
    DMA: 528,
  },
  "33151": {
    DMA: 528,
  },
  "33152": {
    DMA: 528,
  },
  "33153": {
    DMA: 528,
  },
  "33154": {
    DMA: 528,
  },
  "33155": {
    DMA: 528,
  },
  "33156": {
    DMA: 528,
  },
  "33157": {
    DMA: 528,
  },
  "33158": {
    DMA: 528,
  },
  "33159": {
    DMA: 528,
  },
  "33160": {
    DMA: 528,
  },
  "33161": {
    DMA: 528,
  },
  "33162": {
    DMA: 528,
  },
  "33163": {
    DMA: 528,
  },
  "33164": {
    DMA: 528,
  },
  "33165": {
    DMA: 528,
  },
  "33166": {
    DMA: 528,
  },
  "33167": {
    DMA: 528,
  },
  "33168": {
    DMA: 528,
  },
  "33169": {
    DMA: 528,
  },
  "33170": {
    DMA: 528,
  },
  "33172": {
    DMA: 528,
  },
  "33173": {
    DMA: 528,
  },
  "33174": {
    DMA: 528,
  },
  "33175": {
    DMA: 528,
  },
  "33176": {
    DMA: 528,
  },
  "33177": {
    DMA: 528,
  },
  "33178": {
    DMA: 528,
  },
  "33179": {
    DMA: 528,
  },
  "33180": {
    DMA: 528,
  },
  "33181": {
    DMA: 528,
  },
  "33182": {
    DMA: 528,
  },
  "33183": {
    DMA: 528,
  },
  "33184": {
    DMA: 528,
  },
  "33185": {
    DMA: 528,
  },
  "33186": {
    DMA: 528,
  },
  "33187": {
    DMA: 528,
  },
  "33188": {
    DMA: 528,
  },
  "33189": {
    DMA: 528,
  },
  "33190": {
    DMA: 528,
  },
  "33191": {
    DMA: 528,
  },
  "33192": {
    DMA: 528,
  },
  "33193": {
    DMA: 528,
  },
  "33194": {
    DMA: 528,
  },
  "33195": {
    DMA: 528,
  },
  "33196": {
    DMA: 528,
  },
  "33197": {
    DMA: 528,
  },
  "33198": {
    DMA: 528,
  },
  "33199": {
    DMA: 528,
  },
  "33206": {
    DMA: 528,
  },
  "33222": {
    DMA: 528,
  },
  "33231": {
    DMA: 528,
  },
  "33233": {
    DMA: 528,
  },
  "33234": {
    DMA: 528,
  },
  "33238": {
    DMA: 528,
  },
  "33239": {
    DMA: 528,
  },
  "33242": {
    DMA: 528,
  },
  "33243": {
    DMA: 528,
  },
  "33245": {
    DMA: 528,
  },
  "33247": {
    DMA: 528,
  },
  "33255": {
    DMA: 528,
  },
  "33256": {
    DMA: 528,
  },
  "33257": {
    DMA: 528,
  },
  "33261": {
    DMA: 528,
  },
  "33265": {
    DMA: 528,
  },
  "33266": {
    DMA: 528,
  },
  "33269": {
    DMA: 528,
  },
  "33280": {
    DMA: 528,
  },
  "33283": {
    DMA: 528,
  },
  "33296": {
    DMA: 528,
  },
  "33299": {
    DMA: 528,
  },
  "33301": {
    DMA: 528,
  },
  "33302": {
    DMA: 528,
  },
  "33303": {
    DMA: 528,
  },
  "33304": {
    DMA: 528,
  },
  "33305": {
    DMA: 528,
  },
  "33306": {
    DMA: 528,
  },
  "33307": {
    DMA: 528,
  },
  "33308": {
    DMA: 528,
  },
  "33309": {
    DMA: 528,
  },
  "33310": {
    DMA: 528,
  },
  "33311": {
    DMA: 528,
  },
  "33312": {
    DMA: 528,
  },
  "33313": {
    DMA: 528,
  },
  "33314": {
    DMA: 528,
  },
  "33315": {
    DMA: 528,
  },
  "33316": {
    DMA: 528,
  },
  "33317": {
    DMA: 528,
  },
  "33318": {
    DMA: 528,
  },
  "33319": {
    DMA: 528,
  },
  "33320": {
    DMA: 528,
  },
  "33321": {
    DMA: 528,
  },
  "33322": {
    DMA: 528,
  },
  "33323": {
    DMA: 528,
  },
  "33324": {
    DMA: 528,
  },
  "33325": {
    DMA: 528,
  },
  "33326": {
    DMA: 528,
  },
  "33327": {
    DMA: 528,
  },
  "33328": {
    DMA: 528,
  },
  "33329": {
    DMA: 528,
  },
  "33330": {
    DMA: 528,
  },
  "33331": {
    DMA: 528,
  },
  "33332": {
    DMA: 528,
  },
  "33334": {
    DMA: 528,
  },
  "33335": {
    DMA: 528,
  },
  "33336": {
    DMA: 528,
  },
  "33337": {
    DMA: 528,
  },
  "33338": {
    DMA: 528,
  },
  "33339": {
    DMA: 528,
  },
  "33340": {
    DMA: 528,
  },
  "33345": {
    DMA: 528,
  },
  "33346": {
    DMA: 528,
  },
  "33348": {
    DMA: 528,
  },
  "33349": {
    DMA: 528,
  },
  "33351": {
    DMA: 528,
  },
  "33355": {
    DMA: 528,
  },
  "33359": {
    DMA: 528,
  },
  "33388": {
    DMA: 528,
  },
  "33394": {
    DMA: 528,
  },
  "33401": {
    DMA: 548,
  },
  "33402": {
    DMA: 548,
  },
  "33403": {
    DMA: 548,
  },
  "33404": {
    DMA: 548,
  },
  "33405": {
    DMA: 548,
  },
  "33406": {
    DMA: 548,
  },
  "33407": {
    DMA: 548,
  },
  "33408": {
    DMA: 548,
  },
  "33409": {
    DMA: 548,
  },
  "33410": {
    DMA: 548,
  },
  "33411": {
    DMA: 548,
  },
  "33412": {
    DMA: 548,
  },
  "33413": {
    DMA: 548,
  },
  "33414": {
    DMA: 548,
  },
  "33415": {
    DMA: 548,
  },
  "33416": {
    DMA: 548,
  },
  "33417": {
    DMA: 548,
  },
  "33418": {
    DMA: 548,
  },
  "33419": {
    DMA: 548,
  },
  "33420": {
    DMA: 548,
  },
  "33421": {
    DMA: 548,
  },
  "33422": {
    DMA: 548,
  },
  "33424": {
    DMA: 548,
  },
  "33425": {
    DMA: 548,
  },
  "33426": {
    DMA: 548,
  },
  "33427": {
    DMA: 548,
  },
  "33428": {
    DMA: 548,
  },
  "33429": {
    DMA: 548,
  },
  "33430": {
    DMA: 548,
  },
  "33431": {
    DMA: 548,
  },
  "33432": {
    DMA: 548,
  },
  "33433": {
    DMA: 548,
  },
  "33434": {
    DMA: 548,
  },
  "33435": {
    DMA: 548,
  },
  "33436": {
    DMA: 548,
  },
  "33437": {
    DMA: 548,
  },
  "33438": {
    DMA: 548,
  },
  "33439": {
    DMA: 548,
  },
  "33440": {
    DMA: 571,
  },
  "33441": {
    DMA: 528,
  },
  "33442": {
    DMA: 528,
  },
  "33443": {
    DMA: 528,
  },
  "33444": {
    DMA: 548,
  },
  "33445": {
    DMA: 548,
  },
  "33446": {
    DMA: 548,
  },
  "33447": {
    DMA: 548,
  },
  "33448": {
    DMA: 548,
  },
  "33449": {
    DMA: 548,
  },
  "33454": {
    DMA: 548,
  },
  "33455": {
    DMA: 548,
  },
  "33458": {
    DMA: 548,
  },
  "33459": {
    DMA: 548,
  },
  "33460": {
    DMA: 548,
  },
  "33461": {
    DMA: 548,
  },
  "33462": {
    DMA: 548,
  },
  "33463": {
    DMA: 548,
  },
  "33464": {
    DMA: 548,
  },
  "33465": {
    DMA: 548,
  },
  "33466": {
    DMA: 548,
  },
  "33467": {
    DMA: 548,
  },
  "33468": {
    DMA: 548,
  },
  "33469": {
    DMA: 548,
  },
  "33470": {
    DMA: 548,
  },
  "33471": {
    DMA: 571,
  },
  "33472": {
    DMA: 548,
  },
  "33473": {
    DMA: 548,
  },
  "33474": {
    DMA: 548,
  },
  "33475": {
    DMA: 548,
  },
  "33476": {
    DMA: 548,
  },
  "33477": {
    DMA: 548,
  },
  "33478": {
    DMA: 548,
  },
  "33480": {
    DMA: 548,
  },
  "33481": {
    DMA: 548,
  },
  "33482": {
    DMA: 548,
  },
  "33483": {
    DMA: 548,
  },
  "33484": {
    DMA: 548,
  },
  "33486": {
    DMA: 548,
  },
  "33487": {
    DMA: 548,
  },
  "33488": {
    DMA: 548,
  },
  "33493": {
    DMA: 548,
  },
  "33496": {
    DMA: 548,
  },
  "33497": {
    DMA: 548,
  },
  "33498": {
    DMA: 548,
  },
  "33499": {
    DMA: 548,
  },
  "33503": {
    DMA: 539,
  },
  "33508": {
    DMA: 539,
  },
  "33509": {
    DMA: 539,
  },
  "33510": {
    DMA: 539,
  },
  "33511": {
    DMA: 539,
  },
  "33513": {
    DMA: 534,
  },
  "33514": {
    DMA: 534,
  },
  "33521": {
    DMA: 534,
  },
  "33523": {
    DMA: 539,
  },
  "33524": {
    DMA: 539,
  },
  "33525": {
    DMA: 539,
  },
  "33526": {
    DMA: 539,
  },
  "33527": {
    DMA: 539,
  },
  "33530": {
    DMA: 539,
  },
  "33534": {
    DMA: 539,
  },
  "33537": {
    DMA: 539,
  },
  "33538": {
    DMA: 534,
  },
  "33539": {
    DMA: 539,
  },
  "33540": {
    DMA: 539,
  },
  "33541": {
    DMA: 539,
  },
  "33542": {
    DMA: 539,
  },
  "33543": {
    DMA: 539,
  },
  "33544": {
    DMA: 539,
  },
  "33545": {
    DMA: 539,
  },
  "33547": {
    DMA: 539,
  },
  "33548": {
    DMA: 539,
  },
  "33549": {
    DMA: 539,
  },
  "33550": {
    DMA: 539,
  },
  "33556": {
    DMA: 539,
  },
  "33558": {
    DMA: 539,
  },
  "33559": {
    DMA: 539,
  },
  "33563": {
    DMA: 539,
  },
  "33564": {
    DMA: 539,
  },
  "33565": {
    DMA: 539,
  },
  "33566": {
    DMA: 539,
  },
  "33567": {
    DMA: 539,
  },
  "33568": {
    DMA: 539,
  },
  "33569": {
    DMA: 539,
  },
  "33570": {
    DMA: 539,
  },
  "33571": {
    DMA: 539,
  },
  "33572": {
    DMA: 539,
  },
  "33573": {
    DMA: 539,
  },
  "33574": {
    DMA: 539,
  },
  "33575": {
    DMA: 539,
  },
  "33576": {
    DMA: 539,
  },
  "33578": {
    DMA: 539,
  },
  "33579": {
    DMA: 539,
  },
  "33583": {
    DMA: 539,
  },
  "33584": {
    DMA: 539,
  },
  "33585": {
    DMA: 534,
  },
  "33586": {
    DMA: 539,
  },
  "33587": {
    DMA: 539,
  },
  "33592": {
    DMA: 539,
  },
  "33593": {
    DMA: 539,
  },
  "33594": {
    DMA: 539,
  },
  "33595": {
    DMA: 539,
  },
  "33596": {
    DMA: 539,
  },
  "33597": {
    DMA: 534,
  },
  "33598": {
    DMA: 539,
  },
  "33601": {
    DMA: 539,
  },
  "33602": {
    DMA: 539,
  },
  "33603": {
    DMA: 539,
  },
  "33604": {
    DMA: 539,
  },
  "33605": {
    DMA: 539,
  },
  "33606": {
    DMA: 539,
  },
  "33607": {
    DMA: 539,
  },
  "33608": {
    DMA: 539,
  },
  "33609": {
    DMA: 539,
  },
  "33610": {
    DMA: 539,
  },
  "33611": {
    DMA: 539,
  },
  "33612": {
    DMA: 539,
  },
  "33613": {
    DMA: 539,
  },
  "33614": {
    DMA: 539,
  },
  "33615": {
    DMA: 539,
  },
  "33616": {
    DMA: 539,
  },
  "33617": {
    DMA: 539,
  },
  "33618": {
    DMA: 539,
  },
  "33619": {
    DMA: 539,
  },
  "33620": {
    DMA: 539,
  },
  "33621": {
    DMA: 539,
  },
  "33622": {
    DMA: 539,
  },
  "33623": {
    DMA: 539,
  },
  "33624": {
    DMA: 539,
  },
  "33625": {
    DMA: 539,
  },
  "33626": {
    DMA: 539,
  },
  "33629": {
    DMA: 539,
  },
  "33630": {
    DMA: 539,
  },
  "33631": {
    DMA: 539,
  },
  "33633": {
    DMA: 539,
  },
  "33634": {
    DMA: 539,
  },
  "33635": {
    DMA: 539,
  },
  "33637": {
    DMA: 539,
  },
  "33646": {
    DMA: 539,
  },
  "33647": {
    DMA: 539,
  },
  "33650": {
    DMA: 539,
  },
  "33651": {
    DMA: 539,
  },
  "33655": {
    DMA: 539,
  },
  "33660": {
    DMA: 539,
  },
  "33661": {
    DMA: 539,
  },
  "33662": {
    DMA: 539,
  },
  "33663": {
    DMA: 539,
  },
  "33664": {
    DMA: 539,
  },
  "33672": {
    DMA: 539,
  },
  "33673": {
    DMA: 539,
  },
  "33674": {
    DMA: 539,
  },
  "33675": {
    DMA: 539,
  },
  "33677": {
    DMA: 539,
  },
  "33679": {
    DMA: 539,
  },
  "33680": {
    DMA: 539,
  },
  "33681": {
    DMA: 539,
  },
  "33682": {
    DMA: 539,
  },
  "33684": {
    DMA: 539,
  },
  "33685": {
    DMA: 539,
  },
  "33686": {
    DMA: 539,
  },
  "33687": {
    DMA: 539,
  },
  "33688": {
    DMA: 539,
  },
  "33689": {
    DMA: 539,
  },
  "33690": {
    DMA: 539,
  },
  "33694": {
    DMA: 539,
  },
  "33701": {
    DMA: 539,
  },
  "33702": {
    DMA: 539,
  },
  "33703": {
    DMA: 539,
  },
  "33704": {
    DMA: 539,
  },
  "33705": {
    DMA: 539,
  },
  "33706": {
    DMA: 539,
  },
  "33707": {
    DMA: 539,
  },
  "33708": {
    DMA: 539,
  },
  "33709": {
    DMA: 539,
  },
  "33710": {
    DMA: 539,
  },
  "33711": {
    DMA: 539,
  },
  "33712": {
    DMA: 539,
  },
  "33713": {
    DMA: 539,
  },
  "33714": {
    DMA: 539,
  },
  "33715": {
    DMA: 539,
  },
  "33716": {
    DMA: 539,
  },
  "33729": {
    DMA: 539,
  },
  "33730": {
    DMA: 539,
  },
  "33731": {
    DMA: 539,
  },
  "33732": {
    DMA: 539,
  },
  "33733": {
    DMA: 539,
  },
  "33734": {
    DMA: 539,
  },
  "33736": {
    DMA: 539,
  },
  "33737": {
    DMA: 539,
  },
  "33738": {
    DMA: 539,
  },
  "33740": {
    DMA: 539,
  },
  "33741": {
    DMA: 539,
  },
  "33742": {
    DMA: 539,
  },
  "33743": {
    DMA: 539,
  },
  "33744": {
    DMA: 539,
  },
  "33747": {
    DMA: 539,
  },
  "33755": {
    DMA: 539,
  },
  "33756": {
    DMA: 539,
  },
  "33757": {
    DMA: 539,
  },
  "33758": {
    DMA: 539,
  },
  "33759": {
    DMA: 539,
  },
  "33760": {
    DMA: 539,
  },
  "33761": {
    DMA: 539,
  },
  "33762": {
    DMA: 539,
  },
  "33763": {
    DMA: 539,
  },
  "33764": {
    DMA: 539,
  },
  "33765": {
    DMA: 539,
  },
  "33766": {
    DMA: 539,
  },
  "33767": {
    DMA: 539,
  },
  "33769": {
    DMA: 539,
  },
  "33770": {
    DMA: 539,
  },
  "33771": {
    DMA: 539,
  },
  "33772": {
    DMA: 539,
  },
  "33773": {
    DMA: 539,
  },
  "33774": {
    DMA: 539,
  },
  "33775": {
    DMA: 539,
  },
  "33776": {
    DMA: 539,
  },
  "33777": {
    DMA: 539,
  },
  "33778": {
    DMA: 539,
  },
  "33779": {
    DMA: 539,
  },
  "33780": {
    DMA: 539,
  },
  "33781": {
    DMA: 539,
  },
  "33782": {
    DMA: 539,
  },
  "33784": {
    DMA: 539,
  },
  "33785": {
    DMA: 539,
  },
  "33786": {
    DMA: 539,
  },
  "33801": {
    DMA: 539,
  },
  "33802": {
    DMA: 539,
  },
  "33803": {
    DMA: 539,
  },
  "33804": {
    DMA: 539,
  },
  "33805": {
    DMA: 539,
  },
  "33806": {
    DMA: 539,
  },
  "33807": {
    DMA: 539,
  },
  "33809": {
    DMA: 539,
  },
  "33810": {
    DMA: 539,
  },
  "33811": {
    DMA: 539,
  },
  "33812": {
    DMA: 539,
  },
  "33813": {
    DMA: 539,
  },
  "33815": {
    DMA: 539,
  },
  "33820": {
    DMA: 539,
  },
  "33823": {
    DMA: 539,
  },
  "33825": {
    DMA: 539,
  },
  "33826": {
    DMA: 539,
  },
  "33827": {
    DMA: 539,
  },
  "33830": {
    DMA: 539,
  },
  "33831": {
    DMA: 539,
  },
  "33834": {
    DMA: 539,
  },
  "33835": {
    DMA: 539,
  },
  "33836": {
    DMA: 539,
  },
  "33837": {
    DMA: 539,
  },
  "33838": {
    DMA: 539,
  },
  "33839": {
    DMA: 539,
  },
  "33840": {
    DMA: 539,
  },
  "33841": {
    DMA: 539,
  },
  "33843": {
    DMA: 539,
  },
  "33844": {
    DMA: 539,
  },
  "33845": {
    DMA: 539,
  },
  "33846": {
    DMA: 539,
  },
  "33847": {
    DMA: 539,
  },
  "33848": {
    DMA: 534,
  },
  "33849": {
    DMA: 539,
  },
  "33850": {
    DMA: 539,
  },
  "33851": {
    DMA: 539,
  },
  "33852": {
    DMA: 539,
  },
  "33853": {
    DMA: 539,
  },
  "33854": {
    DMA: 539,
  },
  "33855": {
    DMA: 539,
  },
  "33856": {
    DMA: 539,
  },
  "33857": {
    DMA: 539,
  },
  "33858": {
    DMA: 539,
  },
  "33859": {
    DMA: 539,
  },
  "33860": {
    DMA: 539,
  },
  "33862": {
    DMA: 539,
  },
  "33863": {
    DMA: 539,
  },
  "33865": {
    DMA: 539,
  },
  "33867": {
    DMA: 539,
  },
  "33868": {
    DMA: 539,
  },
  "33870": {
    DMA: 539,
  },
  "33871": {
    DMA: 539,
  },
  "33872": {
    DMA: 539,
  },
  "33873": {
    DMA: 539,
  },
  "33875": {
    DMA: 539,
  },
  "33876": {
    DMA: 539,
  },
  "33877": {
    DMA: 539,
  },
  "33880": {
    DMA: 539,
  },
  "33881": {
    DMA: 539,
  },
  "33882": {
    DMA: 539,
  },
  "33883": {
    DMA: 539,
  },
  "33884": {
    DMA: 539,
  },
  "33885": {
    DMA: 539,
  },
  "33888": {
    DMA: 539,
  },
  "33890": {
    DMA: 539,
  },
  "33896": {
    DMA: 539,
  },
  "33897": {
    DMA: 539,
  },
  "33898": {
    DMA: 539,
  },
  "33900": {
    DMA: 571,
  },
  "33901": {
    DMA: 571,
  },
  "33902": {
    DMA: 571,
  },
  "33903": {
    DMA: 571,
  },
  "33904": {
    DMA: 571,
  },
  "33905": {
    DMA: 571,
  },
  "33906": {
    DMA: 571,
  },
  "33907": {
    DMA: 571,
  },
  "33908": {
    DMA: 571,
  },
  "33909": {
    DMA: 571,
  },
  "33910": {
    DMA: 571,
  },
  "33911": {
    DMA: 571,
  },
  "33912": {
    DMA: 571,
  },
  "33913": {
    DMA: 571,
  },
  "33914": {
    DMA: 571,
  },
  "33915": {
    DMA: 571,
  },
  "33916": {
    DMA: 571,
  },
  "33917": {
    DMA: 571,
  },
  "33918": {
    DMA: 571,
  },
  "33919": {
    DMA: 571,
  },
  "33920": {
    DMA: 571,
  },
  "33921": {
    DMA: 571,
  },
  "33922": {
    DMA: 571,
  },
  "33924": {
    DMA: 571,
  },
  "33927": {
    DMA: 571,
  },
  "33928": {
    DMA: 571,
  },
  "33929": {
    DMA: 571,
  },
  "33930": {
    DMA: 571,
  },
  "33931": {
    DMA: 571,
  },
  "33932": {
    DMA: 571,
  },
  "33935": {
    DMA: 571,
  },
  "33936": {
    DMA: 571,
  },
  "33938": {
    DMA: 571,
  },
  "33944": {
    DMA: 571,
  },
  "33945": {
    DMA: 571,
  },
  "33946": {
    DMA: 571,
  },
  "33947": {
    DMA: 571,
  },
  "33948": {
    DMA: 571,
  },
  "33949": {
    DMA: 571,
  },
  "33950": {
    DMA: 571,
  },
  "33951": {
    DMA: 571,
  },
  "33952": {
    DMA: 571,
  },
  "33953": {
    DMA: 571,
  },
  "33954": {
    DMA: 571,
  },
  "33955": {
    DMA: 571,
  },
  "33956": {
    DMA: 571,
  },
  "33957": {
    DMA: 571,
  },
  "33960": {
    DMA: 539,
  },
  "33965": {
    DMA: 571,
  },
  "33966": {
    DMA: 571,
  },
  "33967": {
    DMA: 571,
  },
  "33970": {
    DMA: 571,
  },
  "33971": {
    DMA: 571,
  },
  "33972": {
    DMA: 571,
  },
  "33973": {
    DMA: 571,
  },
  "33974": {
    DMA: 571,
  },
  "33975": {
    DMA: 571,
  },
  "33976": {
    DMA: 571,
  },
  "33980": {
    DMA: 571,
  },
  "33981": {
    DMA: 571,
  },
  "33982": {
    DMA: 571,
  },
  "33983": {
    DMA: 571,
  },
  "33990": {
    DMA: 571,
  },
  "33991": {
    DMA: 571,
  },
  "33993": {
    DMA: 571,
  },
  "33994": {
    DMA: 571,
  },
  "34001": {
    DMA: "MIL",
  },
  "34002": {
    DMA: "MIL",
  },
  "34004": {
    DMA: "MIL",
  },
  "34006": {
    DMA: "MIL",
  },
  "34007": {
    DMA: "MIL",
  },
  "34008": {
    DMA: "MIL",
  },
  "34009": {
    DMA: "MIL",
  },
  "34010": {
    DMA: "MIL",
  },
  "34011": {
    DMA: "MIL",
  },
  "34020": {
    DMA: "MIL",
  },
  "34021": {
    DMA: "MIL",
  },
  "34022": {
    DMA: "MIL",
  },
  "34023": {
    DMA: "MIL",
  },
  "34024": {
    DMA: "MIL",
  },
  "34025": {
    DMA: "MIL",
  },
  "34030": {
    DMA: "MIL",
  },
  "34031": {
    DMA: "MIL",
  },
  "34032": {
    DMA: "MIL",
  },
  "34033": {
    DMA: "MIL",
  },
  "34034": {
    DMA: "MIL",
  },
  "34035": {
    DMA: "MIL",
  },
  "34036": {
    DMA: "MIL",
  },
  "34037": {
    DMA: "MIL",
  },
  "34038": {
    DMA: "MIL",
  },
  "34039": {
    DMA: "MIL",
  },
  "34041": {
    DMA: "MIL",
  },
  "34042": {
    DMA: "MIL",
  },
  "34043": {
    DMA: "MIL",
  },
  "34044": {
    DMA: "MIL",
  },
  "34050": {
    DMA: "MIL",
  },
  "34051": {
    DMA: "MIL",
  },
  "34052": {
    DMA: "MIL",
  },
  "34053": {
    DMA: "MIL",
  },
  "34054": {
    DMA: "MIL",
  },
  "34055": {
    DMA: "MIL",
  },
  "34058": {
    DMA: "MIL",
  },
  "34060": {
    DMA: "MIL",
  },
  "34066": {
    DMA: "MIL",
  },
  "34067": {
    DMA: "MIL",
  },
  "34068": {
    DMA: "MIL",
  },
  "34069": {
    DMA: "MIL",
  },
  "34071": {
    DMA: "MIL",
  },
  "34076": {
    DMA: "MIL",
  },
  "34078": {
    DMA: "MIL",
  },
  "34079": {
    DMA: "MIL",
  },
  "34080": {
    DMA: "MIL",
  },
  "34081": {
    DMA: "MIL",
  },
  "34082": {
    DMA: "MIL",
  },
  "34083": {
    DMA: "MIL",
  },
  "34084": {
    DMA: "MIL",
  },
  "34085": {
    DMA: "MIL",
  },
  "34086": {
    DMA: "MIL",
  },
  "34087": {
    DMA: "MIL",
  },
  "34088": {
    DMA: "MIL",
  },
  "34089": {
    DMA: "MIL",
  },
  "34090": {
    DMA: "MIL",
  },
  "34091": {
    DMA: "MIL",
  },
  "34092": {
    DMA: "MIL",
  },
  "34093": {
    DMA: "MIL",
  },
  "34094": {
    DMA: "MIL",
  },
  "34095": {
    DMA: "MIL",
  },
  "34096": {
    DMA: "MIL",
  },
  "34098": {
    DMA: "MIL",
  },
  "34099": {
    DMA: "MIL",
  },
  "34101": {
    DMA: 571,
  },
  "34102": {
    DMA: 571,
  },
  "34103": {
    DMA: 571,
  },
  "34104": {
    DMA: 571,
  },
  "34105": {
    DMA: 571,
  },
  "34106": {
    DMA: 571,
  },
  "34107": {
    DMA: 571,
  },
  "34108": {
    DMA: 571,
  },
  "34109": {
    DMA: 571,
  },
  "34110": {
    DMA: 571,
  },
  "34112": {
    DMA: 571,
  },
  "34113": {
    DMA: 571,
  },
  "34114": {
    DMA: 571,
  },
  "34116": {
    DMA: 571,
  },
  "34117": {
    DMA: 571,
  },
  "34119": {
    DMA: 571,
  },
  "34120": {
    DMA: 571,
  },
  "34133": {
    DMA: 571,
  },
  "34134": {
    DMA: 571,
  },
  "34135": {
    DMA: 571,
  },
  "34136": {
    DMA: 571,
  },
  "34137": {
    DMA: 571,
  },
  "34138": {
    DMA: 571,
  },
  "34139": {
    DMA: 571,
  },
  "34140": {
    DMA: 571,
  },
  "34141": {
    DMA: 528,
  },
  "34142": {
    DMA: 571,
  },
  "34143": {
    DMA: 571,
  },
  "34145": {
    DMA: 571,
  },
  "34146": {
    DMA: 571,
  },
  "34201": {
    DMA: 539,
  },
  "34202": {
    DMA: 539,
  },
  "34203": {
    DMA: 539,
  },
  "34204": {
    DMA: 539,
  },
  "34205": {
    DMA: 539,
  },
  "34206": {
    DMA: 539,
  },
  "34207": {
    DMA: 539,
  },
  "34208": {
    DMA: 539,
  },
  "34209": {
    DMA: 539,
  },
  "34210": {
    DMA: 539,
  },
  "34211": {
    DMA: 539,
  },
  "34212": {
    DMA: 539,
  },
  "34215": {
    DMA: 539,
  },
  "34216": {
    DMA: 539,
  },
  "34217": {
    DMA: 539,
  },
  "34218": {
    DMA: 539,
  },
  "34219": {
    DMA: 539,
  },
  "34220": {
    DMA: 539,
  },
  "34221": {
    DMA: 539,
  },
  "34222": {
    DMA: 539,
  },
  "34223": {
    DMA: 539,
  },
  "34224": {
    DMA: 571,
  },
  "34228": {
    DMA: 539,
  },
  "34229": {
    DMA: 539,
  },
  "34230": {
    DMA: 539,
  },
  "34231": {
    DMA: 539,
  },
  "34232": {
    DMA: 539,
  },
  "34233": {
    DMA: 539,
  },
  "34234": {
    DMA: 539,
  },
  "34235": {
    DMA: 539,
  },
  "34236": {
    DMA: 539,
  },
  "34237": {
    DMA: 539,
  },
  "34238": {
    DMA: 539,
  },
  "34239": {
    DMA: 539,
  },
  "34240": {
    DMA: 539,
  },
  "34241": {
    DMA: 539,
  },
  "34242": {
    DMA: 539,
  },
  "34243": {
    DMA: 539,
  },
  "34249": {
    DMA: 539,
  },
  "34250": {
    DMA: 539,
  },
  "34251": {
    DMA: 539,
  },
  "34260": {
    DMA: 539,
  },
  "34264": {
    DMA: 539,
  },
  "34265": {
    DMA: 571,
  },
  "34266": {
    DMA: 571,
  },
  "34267": {
    DMA: 571,
  },
  "34268": {
    DMA: 571,
  },
  "34269": {
    DMA: 571,
  },
  "34270": {
    DMA: 539,
  },
  "34272": {
    DMA: 539,
  },
  "34274": {
    DMA: 539,
  },
  "34275": {
    DMA: 539,
  },
  "34276": {
    DMA: 539,
  },
  "34277": {
    DMA: 539,
  },
  "34278": {
    DMA: 539,
  },
  "34280": {
    DMA: 539,
  },
  "34281": {
    DMA: 539,
  },
  "34282": {
    DMA: 539,
  },
  "34284": {
    DMA: 539,
  },
  "34285": {
    DMA: 539,
  },
  "34286": {
    DMA: 539,
  },
  "34287": {
    DMA: 539,
  },
  "34288": {
    DMA: 539,
  },
  "34289": {
    DMA: 539,
  },
  "34290": {
    DMA: 539,
  },
  "34291": {
    DMA: 539,
  },
  "34292": {
    DMA: 539,
  },
  "34293": {
    DMA: 539,
  },
  "34295": {
    DMA: 539,
  },
  "34420": {
    DMA: 534,
  },
  "34421": {
    DMA: 534,
  },
  "34423": {
    DMA: 539,
  },
  "34428": {
    DMA: 539,
  },
  "34429": {
    DMA: 539,
  },
  "34430": {
    DMA: 534,
  },
  "34431": {
    DMA: 534,
  },
  "34432": {
    DMA: 534,
  },
  "34433": {
    DMA: 539,
  },
  "34434": {
    DMA: 539,
  },
  "34436": {
    DMA: 539,
  },
  "34441": {
    DMA: 539,
  },
  "34442": {
    DMA: 539,
  },
  "34445": {
    DMA: 539,
  },
  "34446": {
    DMA: 539,
  },
  "34447": {
    DMA: 539,
  },
  "34448": {
    DMA: 539,
  },
  "34449": {
    DMA: 592,
  },
  "34450": {
    DMA: 539,
  },
  "34451": {
    DMA: 539,
  },
  "34452": {
    DMA: 539,
  },
  "34453": {
    DMA: 539,
  },
  "34460": {
    DMA: 539,
  },
  "34461": {
    DMA: 539,
  },
  "34464": {
    DMA: 539,
  },
  "34465": {
    DMA: 539,
  },
  "34470": {
    DMA: 534,
  },
  "34471": {
    DMA: 534,
  },
  "34472": {
    DMA: 534,
  },
  "34473": {
    DMA: 534,
  },
  "34474": {
    DMA: 534,
  },
  "34475": {
    DMA: 534,
  },
  "34476": {
    DMA: 534,
  },
  "34477": {
    DMA: 534,
  },
  "34478": {
    DMA: 534,
  },
  "34479": {
    DMA: 534,
  },
  "34480": {
    DMA: 534,
  },
  "34481": {
    DMA: 534,
  },
  "34482": {
    DMA: 534,
  },
  "34483": {
    DMA: 534,
  },
  "34484": {
    DMA: 534,
  },
  "34487": {
    DMA: 539,
  },
  "34488": {
    DMA: 534,
  },
  "34489": {
    DMA: 534,
  },
  "34491": {
    DMA: 534,
  },
  "34492": {
    DMA: 534,
  },
  "34498": {
    DMA: 592,
  },
  "34601": {
    DMA: 539,
  },
  "34602": {
    DMA: 539,
  },
  "34603": {
    DMA: 539,
  },
  "34604": {
    DMA: 539,
  },
  "34605": {
    DMA: 539,
  },
  "34606": {
    DMA: 539,
  },
  "34607": {
    DMA: 539,
  },
  "34608": {
    DMA: 539,
  },
  "34609": {
    DMA: 539,
  },
  "34610": {
    DMA: 539,
  },
  "34611": {
    DMA: 539,
  },
  "34613": {
    DMA: 539,
  },
  "34614": {
    DMA: 539,
  },
  "34636": {
    DMA: 539,
  },
  "34637": {
    DMA: 539,
  },
  "34638": {
    DMA: 539,
  },
  "34639": {
    DMA: 539,
  },
  "34652": {
    DMA: 539,
  },
  "34653": {
    DMA: 539,
  },
  "34654": {
    DMA: 539,
  },
  "34655": {
    DMA: 539,
  },
  "34656": {
    DMA: 539,
  },
  "34660": {
    DMA: 539,
  },
  "34661": {
    DMA: 539,
  },
  "34667": {
    DMA: 539,
  },
  "34668": {
    DMA: 539,
  },
  "34669": {
    DMA: 539,
  },
  "34673": {
    DMA: 539,
  },
  "34674": {
    DMA: 539,
  },
  "34677": {
    DMA: 539,
  },
  "34679": {
    DMA: 539,
  },
  "34680": {
    DMA: 539,
  },
  "34681": {
    DMA: 539,
  },
  "34682": {
    DMA: 539,
  },
  "34683": {
    DMA: 539,
  },
  "34684": {
    DMA: 539,
  },
  "34685": {
    DMA: 539,
  },
  "34688": {
    DMA: 539,
  },
  "34689": {
    DMA: 539,
  },
  "34690": {
    DMA: 539,
  },
  "34691": {
    DMA: 539,
  },
  "34692": {
    DMA: 539,
  },
  "34695": {
    DMA: 539,
  },
  "34697": {
    DMA: 539,
  },
  "34698": {
    DMA: 539,
  },
  "34705": {
    DMA: 534,
  },
  "34711": {
    DMA: 534,
  },
  "34712": {
    DMA: 534,
  },
  "34713": {
    DMA: 534,
  },
  "34714": {
    DMA: 534,
  },
  "34715": {
    DMA: 534,
  },
  "34729": {
    DMA: 534,
  },
  "34731": {
    DMA: 534,
  },
  "34734": {
    DMA: 534,
  },
  "34736": {
    DMA: 534,
  },
  "34737": {
    DMA: 534,
  },
  "34739": {
    DMA: 534,
  },
  "34740": {
    DMA: 534,
  },
  "34741": {
    DMA: 534,
  },
  "34742": {
    DMA: 534,
  },
  "34743": {
    DMA: 534,
  },
  "34744": {
    DMA: 534,
  },
  "34745": {
    DMA: 534,
  },
  "34746": {
    DMA: 534,
  },
  "34747": {
    DMA: 534,
  },
  "34748": {
    DMA: 534,
  },
  "34749": {
    DMA: 534,
  },
  "34753": {
    DMA: 534,
  },
  "34755": {
    DMA: 534,
  },
  "34756": {
    DMA: 534,
  },
  "34758": {
    DMA: 534,
  },
  "34759": {
    DMA: 539,
  },
  "34760": {
    DMA: 534,
  },
  "34761": {
    DMA: 534,
  },
  "34762": {
    DMA: 534,
  },
  "34769": {
    DMA: 534,
  },
  "34770": {
    DMA: 534,
  },
  "34771": {
    DMA: 534,
  },
  "34772": {
    DMA: 534,
  },
  "34773": {
    DMA: 534,
  },
  "34777": {
    DMA: 534,
  },
  "34778": {
    DMA: 534,
  },
  "34785": {
    DMA: 534,
  },
  "34786": {
    DMA: 534,
  },
  "34787": {
    DMA: 534,
  },
  "34788": {
    DMA: 534,
  },
  "34789": {
    DMA: 534,
  },
  "34797": {
    DMA: 534,
  },
  "34945": {
    DMA: 548,
  },
  "34946": {
    DMA: 548,
  },
  "34947": {
    DMA: 548,
  },
  "34948": {
    DMA: 548,
  },
  "34949": {
    DMA: 548,
  },
  "34950": {
    DMA: 548,
  },
  "34951": {
    DMA: 548,
  },
  "34952": {
    DMA: 548,
  },
  "34953": {
    DMA: 548,
  },
  "34954": {
    DMA: 548,
  },
  "34956": {
    DMA: 548,
  },
  "34957": {
    DMA: 548,
  },
  "34958": {
    DMA: 548,
  },
  "34972": {
    DMA: 548,
  },
  "34973": {
    DMA: 548,
  },
  "34974": {
    DMA: 548,
  },
  "34979": {
    DMA: 548,
  },
  "34981": {
    DMA: 548,
  },
  "34982": {
    DMA: 548,
  },
  "34983": {
    DMA: 548,
  },
  "34984": {
    DMA: 548,
  },
  "34985": {
    DMA: 548,
  },
  "34986": {
    DMA: 548,
  },
  "34987": {
    DMA: 548,
  },
  "34988": {
    DMA: 548,
  },
  "34990": {
    DMA: 548,
  },
  "34991": {
    DMA: 548,
  },
  "34992": {
    DMA: 548,
  },
  "34994": {
    DMA: 548,
  },
  "34995": {
    DMA: 548,
  },
  "34996": {
    DMA: 548,
  },
  "34997": {
    DMA: 548,
  },
  "35004": {
    DMA: 630,
  },
  "35005": {
    DMA: 630,
  },
  "35006": {
    DMA: 630,
  },
  "35007": {
    DMA: 630,
  },
  "35010": {
    DMA: 698,
  },
  "35011": {
    DMA: 698,
  },
  "35013": {
    DMA: 630,
  },
  "35014": {
    DMA: 630,
  },
  "35015": {
    DMA: 630,
  },
  "35016": {
    DMA: 691,
  },
  "35019": {
    DMA: 630,
  },
  "35020": {
    DMA: 630,
  },
  "35021": {
    DMA: 630,
  },
  "35022": {
    DMA: 630,
  },
  "35023": {
    DMA: 630,
  },
  "35031": {
    DMA: 630,
  },
  "35032": {
    DMA: 630,
  },
  "35033": {
    DMA: 630,
  },
  "35034": {
    DMA: 630,
  },
  "35035": {
    DMA: 630,
  },
  "35036": {
    DMA: 630,
  },
  "35038": {
    DMA: 630,
  },
  "35040": {
    DMA: 630,
  },
  "35041": {
    DMA: 691,
  },
  "35042": {
    DMA: 630,
  },
  "35043": {
    DMA: 630,
  },
  "35044": {
    DMA: 630,
  },
  "35045": {
    DMA: 630,
  },
  "35046": {
    DMA: 630,
  },
  "35048": {
    DMA: 630,
  },
  "35049": {
    DMA: 630,
  },
  "35051": {
    DMA: 630,
  },
  "35052": {
    DMA: 630,
  },
  "35053": {
    DMA: 630,
  },
  "35054": {
    DMA: 630,
  },
  "35055": {
    DMA: 630,
  },
  "35056": {
    DMA: 630,
  },
  "35057": {
    DMA: 630,
  },
  "35058": {
    DMA: 630,
  },
  "35060": {
    DMA: 630,
  },
  "35061": {
    DMA: 630,
  },
  "35062": {
    DMA: 630,
  },
  "35063": {
    DMA: 630,
  },
  "35064": {
    DMA: 630,
  },
  "35068": {
    DMA: 630,
  },
  "35070": {
    DMA: 630,
  },
  "35071": {
    DMA: 630,
  },
  "35072": {
    DMA: 630,
  },
  "35073": {
    DMA: 630,
  },
  "35074": {
    DMA: 630,
  },
  "35077": {
    DMA: 630,
  },
  "35078": {
    DMA: 630,
  },
  "35079": {
    DMA: 630,
  },
  "35080": {
    DMA: 630,
  },
  "35082": {
    DMA: 630,
  },
  "35083": {
    DMA: 630,
  },
  "35085": {
    DMA: 630,
  },
  "35087": {
    DMA: 630,
  },
  "35089": {
    DMA: 630,
  },
  "35091": {
    DMA: 630,
  },
  "35094": {
    DMA: 630,
  },
  "35096": {
    DMA: 630,
  },
  "35097": {
    DMA: 630,
  },
  "35098": {
    DMA: 630,
  },
  "35111": {
    DMA: 630,
  },
  "35112": {
    DMA: 630,
  },
  "35114": {
    DMA: 630,
  },
  "35115": {
    DMA: 630,
  },
  "35116": {
    DMA: 630,
  },
  "35117": {
    DMA: 630,
  },
  "35118": {
    DMA: 630,
  },
  "35119": {
    DMA: 630,
  },
  "35120": {
    DMA: 630,
  },
  "35121": {
    DMA: 630,
  },
  "35123": {
    DMA: 630,
  },
  "35124": {
    DMA: 630,
  },
  "35125": {
    DMA: 630,
  },
  "35126": {
    DMA: 630,
  },
  "35127": {
    DMA: 630,
  },
  "35128": {
    DMA: 630,
  },
  "35130": {
    DMA: 630,
  },
  "35131": {
    DMA: 630,
  },
  "35133": {
    DMA: 630,
  },
  "35135": {
    DMA: 630,
  },
  "35136": {
    DMA: 630,
  },
  "35137": {
    DMA: 630,
  },
  "35139": {
    DMA: 630,
  },
  "35142": {
    DMA: 630,
  },
  "35143": {
    DMA: 630,
  },
  "35144": {
    DMA: 630,
  },
  "35146": {
    DMA: 630,
  },
  "35147": {
    DMA: 630,
  },
  "35148": {
    DMA: 630,
  },
  "35149": {
    DMA: 630,
  },
  "35150": {
    DMA: 630,
  },
  "35151": {
    DMA: 630,
  },
  "35160": {
    DMA: 630,
  },
  "35161": {
    DMA: 630,
  },
  "35171": {
    DMA: 630,
  },
  "35172": {
    DMA: 630,
  },
  "35173": {
    DMA: 630,
  },
  "35175": {
    DMA: 691,
  },
  "35176": {
    DMA: 630,
  },
  "35178": {
    DMA: 630,
  },
  "35179": {
    DMA: 630,
  },
  "35180": {
    DMA: 630,
  },
  "35181": {
    DMA: 630,
  },
  "35182": {
    DMA: 630,
  },
  "35183": {
    DMA: 630,
  },
  "35184": {
    DMA: 630,
  },
  "35185": {
    DMA: 630,
  },
  "35186": {
    DMA: 630,
  },
  "35187": {
    DMA: 630,
  },
  "35188": {
    DMA: 630,
  },
  "35201": {
    DMA: 630,
  },
  "35202": {
    DMA: 630,
  },
  "35203": {
    DMA: 630,
  },
  "35204": {
    DMA: 630,
  },
  "35205": {
    DMA: 630,
  },
  "35206": {
    DMA: 630,
  },
  "35207": {
    DMA: 630,
  },
  "35208": {
    DMA: 630,
  },
  "35209": {
    DMA: 630,
  },
  "35210": {
    DMA: 630,
  },
  "35211": {
    DMA: 630,
  },
  "35212": {
    DMA: 630,
  },
  "35213": {
    DMA: 630,
  },
  "35214": {
    DMA: 630,
  },
  "35215": {
    DMA: 630,
  },
  "35216": {
    DMA: 630,
  },
  "35217": {
    DMA: 630,
  },
  "35218": {
    DMA: 630,
  },
  "35219": {
    DMA: 630,
  },
  "35220": {
    DMA: 630,
  },
  "35221": {
    DMA: 630,
  },
  "35222": {
    DMA: 630,
  },
  "35223": {
    DMA: 630,
  },
  "35224": {
    DMA: 630,
  },
  "35225": {
    DMA: 630,
  },
  "35226": {
    DMA: 630,
  },
  "35228": {
    DMA: 630,
  },
  "35229": {
    DMA: 630,
  },
  "35230": {
    DMA: 630,
  },
  "35231": {
    DMA: 630,
  },
  "35232": {
    DMA: 630,
  },
  "35233": {
    DMA: 630,
  },
  "35234": {
    DMA: 630,
  },
  "35235": {
    DMA: 630,
  },
  "35236": {
    DMA: 630,
  },
  "35237": {
    DMA: 630,
  },
  "35238": {
    DMA: 630,
  },
  "35240": {
    DMA: 630,
  },
  "35242": {
    DMA: 630,
  },
  "35243": {
    DMA: 630,
  },
  "35244": {
    DMA: 630,
  },
  "35245": {
    DMA: 639,
  },
  "35246": {
    DMA: 630,
  },
  "35249": {
    DMA: 630,
  },
  "35253": {
    DMA: 630,
  },
  "35254": {
    DMA: 630,
  },
  "35255": {
    DMA: 630,
  },
  "35259": {
    DMA: 630,
  },
  "35260": {
    DMA: 630,
  },
  "35261": {
    DMA: 630,
  },
  "35263": {
    DMA: 630,
  },
  "35266": {
    DMA: 630,
  },
  "35270": {
    DMA: 630,
  },
  "35277": {
    DMA: 630,
  },
  "35278": {
    DMA: 630,
  },
  "35279": {
    DMA: 630,
  },
  "35280": {
    DMA: 630,
  },
  "35281": {
    DMA: 630,
  },
  "35282": {
    DMA: 630,
  },
  "35283": {
    DMA: 630,
  },
  "35285": {
    DMA: 630,
  },
  "35286": {
    DMA: 630,
  },
  "35287": {
    DMA: 630,
  },
  "35288": {
    DMA: 630,
  },
  "35289": {
    DMA: 630,
  },
  "35290": {
    DMA: 630,
  },
  "35291": {
    DMA: 630,
  },
  "35292": {
    DMA: 630,
  },
  "35293": {
    DMA: 630,
  },
  "35294": {
    DMA: 630,
  },
  "35295": {
    DMA: 630,
  },
  "35296": {
    DMA: 630,
  },
  "35297": {
    DMA: 630,
  },
  "35298": {
    DMA: 630,
  },
  "35299": {
    DMA: 630,
  },
  "35401": {
    DMA: 630,
  },
  "35402": {
    DMA: 630,
  },
  "35403": {
    DMA: 630,
  },
  "35404": {
    DMA: 630,
  },
  "35405": {
    DMA: 630,
  },
  "35406": {
    DMA: 630,
  },
  "35407": {
    DMA: 630,
  },
  "35440": {
    DMA: 630,
  },
  "35441": {
    DMA: 630,
  },
  "35442": {
    DMA: 630,
  },
  "35443": {
    DMA: 630,
  },
  "35444": {
    DMA: 630,
  },
  "35446": {
    DMA: 630,
  },
  "35447": {
    DMA: 630,
  },
  "35448": {
    DMA: 630,
  },
  "35449": {
    DMA: 630,
  },
  "35452": {
    DMA: 630,
  },
  "35453": {
    DMA: 630,
  },
  "35456": {
    DMA: 630,
  },
  "35457": {
    DMA: 630,
  },
  "35458": {
    DMA: 630,
  },
  "35459": {
    DMA: 711,
  },
  "35460": {
    DMA: 711,
  },
  "35461": {
    DMA: 630,
  },
  "35462": {
    DMA: 630,
  },
  "35463": {
    DMA: 630,
  },
  "35464": {
    DMA: 711,
  },
  "35466": {
    DMA: 630,
  },
  "35468": {
    DMA: 630,
  },
  "35469": {
    DMA: 630,
  },
  "35470": {
    DMA: 711,
  },
  "35471": {
    DMA: 630,
  },
  "35473": {
    DMA: 630,
  },
  "35474": {
    DMA: 630,
  },
  "35475": {
    DMA: 630,
  },
  "35476": {
    DMA: 630,
  },
  "35477": {
    DMA: 711,
  },
  "35478": {
    DMA: 630,
  },
  "35480": {
    DMA: 630,
  },
  "35481": {
    DMA: 630,
  },
  "35482": {
    DMA: 630,
  },
  "35485": {
    DMA: 630,
  },
  "35486": {
    DMA: 630,
  },
  "35487": {
    DMA: 630,
  },
  "35490": {
    DMA: 630,
  },
  "35491": {
    DMA: 630,
  },
  "35501": {
    DMA: 630,
  },
  "35502": {
    DMA: 630,
  },
  "35503": {
    DMA: 630,
  },
  "35504": {
    DMA: 630,
  },
  "35540": {
    DMA: 630,
  },
  "35541": {
    DMA: 630,
  },
  "35542": {
    DMA: 630,
  },
  "35543": {
    DMA: 630,
  },
  "35544": {
    DMA: 673,
  },
  "35545": {
    DMA: 630,
  },
  "35546": {
    DMA: 630,
  },
  "35548": {
    DMA: 630,
  },
  "35549": {
    DMA: 630,
  },
  "35550": {
    DMA: 630,
  },
  "35551": {
    DMA: 630,
  },
  "35552": {
    DMA: 673,
  },
  "35553": {
    DMA: 630,
  },
  "35554": {
    DMA: 630,
  },
  "35555": {
    DMA: 630,
  },
  "35559": {
    DMA: 630,
  },
  "35560": {
    DMA: 630,
  },
  "35563": {
    DMA: 630,
  },
  "35564": {
    DMA: 630,
  },
  "35565": {
    DMA: 630,
  },
  "35570": {
    DMA: 630,
  },
  "35571": {
    DMA: 691,
  },
  "35572": {
    DMA: 630,
  },
  "35573": {
    DMA: 630,
  },
  "35574": {
    DMA: 673,
  },
  "35575": {
    DMA: 630,
  },
  "35576": {
    DMA: 673,
  },
  "35577": {
    DMA: 630,
  },
  "35578": {
    DMA: 630,
  },
  "35579": {
    DMA: 630,
  },
  "35580": {
    DMA: 630,
  },
  "35581": {
    DMA: 691,
  },
  "35582": {
    DMA: 691,
  },
  "35584": {
    DMA: 630,
  },
  "35585": {
    DMA: 691,
  },
  "35586": {
    DMA: 673,
  },
  "35587": {
    DMA: 630,
  },
  "35592": {
    DMA: 673,
  },
  "35593": {
    DMA: 691,
  },
  "35594": {
    DMA: 630,
  },
  "35601": {
    DMA: 691,
  },
  "35602": {
    DMA: 691,
  },
  "35603": {
    DMA: 691,
  },
  "35609": {
    DMA: 691,
  },
  "35610": {
    DMA: 691,
  },
  "35611": {
    DMA: 691,
  },
  "35612": {
    DMA: 691,
  },
  "35613": {
    DMA: 691,
  },
  "35614": {
    DMA: 691,
  },
  "35615": {
    DMA: 691,
  },
  "35616": {
    DMA: 691,
  },
  "35617": {
    DMA: 691,
  },
  "35618": {
    DMA: 691,
  },
  "35619": {
    DMA: 691,
  },
  "35620": {
    DMA: 691,
  },
  "35621": {
    DMA: 691,
  },
  "35622": {
    DMA: 691,
  },
  "35630": {
    DMA: 691,
  },
  "35631": {
    DMA: 691,
  },
  "35632": {
    DMA: 691,
  },
  "35633": {
    DMA: 691,
  },
  "35634": {
    DMA: 691,
  },
  "35640": {
    DMA: 691,
  },
  "35643": {
    DMA: 691,
  },
  "35645": {
    DMA: 691,
  },
  "35646": {
    DMA: 691,
  },
  "35647": {
    DMA: 691,
  },
  "35648": {
    DMA: 691,
  },
  "35649": {
    DMA: 691,
  },
  "35650": {
    DMA: 691,
  },
  "35651": {
    DMA: 691,
  },
  "35652": {
    DMA: 691,
  },
  "35653": {
    DMA: 691,
  },
  "35654": {
    DMA: 691,
  },
  "35660": {
    DMA: 691,
  },
  "35661": {
    DMA: 691,
  },
  "35662": {
    DMA: 691,
  },
  "35670": {
    DMA: 691,
  },
  "35671": {
    DMA: 691,
  },
  "35672": {
    DMA: 691,
  },
  "35673": {
    DMA: 691,
  },
  "35674": {
    DMA: 691,
  },
  "35677": {
    DMA: 691,
  },
  "35699": {
    DMA: 691,
  },
  "35739": {
    DMA: 691,
  },
  "35740": {
    DMA: 691,
  },
  "35741": {
    DMA: 691,
  },
  "35742": {
    DMA: 691,
  },
  "35744": {
    DMA: 691,
  },
  "35745": {
    DMA: 691,
  },
  "35746": {
    DMA: 691,
  },
  "35747": {
    DMA: 691,
  },
  "35748": {
    DMA: 691,
  },
  "35749": {
    DMA: 691,
  },
  "35750": {
    DMA: 691,
  },
  "35751": {
    DMA: 691,
  },
  "35752": {
    DMA: 691,
  },
  "35754": {
    DMA: 691,
  },
  "35755": {
    DMA: 691,
  },
  "35756": {
    DMA: 691,
  },
  "35757": {
    DMA: 691,
  },
  "35758": {
    DMA: 691,
  },
  "35759": {
    DMA: 691,
  },
  "35760": {
    DMA: 691,
  },
  "35761": {
    DMA: 691,
  },
  "35762": {
    DMA: 691,
  },
  "35763": {
    DMA: 691,
  },
  "35764": {
    DMA: 691,
  },
  "35765": {
    DMA: 691,
  },
  "35766": {
    DMA: 691,
  },
  "35767": {
    DMA: 691,
  },
  "35768": {
    DMA: 691,
  },
  "35769": {
    DMA: 691,
  },
  "35771": {
    DMA: 691,
  },
  "35772": {
    DMA: 691,
  },
  "35773": {
    DMA: 691,
  },
  "35774": {
    DMA: 691,
  },
  "35775": {
    DMA: 691,
  },
  "35776": {
    DMA: 691,
  },
  "35801": {
    DMA: 691,
  },
  "35802": {
    DMA: 691,
  },
  "35803": {
    DMA: 691,
  },
  "35804": {
    DMA: 691,
  },
  "35805": {
    DMA: 691,
  },
  "35806": {
    DMA: 691,
  },
  "35807": {
    DMA: 691,
  },
  "35808": {
    DMA: 691,
  },
  "35809": {
    DMA: 691,
  },
  "35810": {
    DMA: 691,
  },
  "35811": {
    DMA: 691,
  },
  "35812": {
    DMA: 691,
  },
  "35813": {
    DMA: 691,
  },
  "35814": {
    DMA: 691,
  },
  "35815": {
    DMA: 691,
  },
  "35816": {
    DMA: 691,
  },
  "35824": {
    DMA: 691,
  },
  "35893": {
    DMA: 691,
  },
  "35894": {
    DMA: 691,
  },
  "35895": {
    DMA: 691,
  },
  "35896": {
    DMA: 691,
  },
  "35897": {
    DMA: 691,
  },
  "35898": {
    DMA: 691,
  },
  "35899": {
    DMA: 691,
  },
  "35901": {
    DMA: 630,
  },
  "35902": {
    DMA: 630,
  },
  "35903": {
    DMA: 630,
  },
  "35904": {
    DMA: 630,
  },
  "35905": {
    DMA: 630,
  },
  "35906": {
    DMA: 630,
  },
  "35907": {
    DMA: 630,
  },
  "35950": {
    DMA: 691,
  },
  "35951": {
    DMA: 691,
  },
  "35952": {
    DMA: 630,
  },
  "35953": {
    DMA: 630,
  },
  "35954": {
    DMA: 630,
  },
  "35956": {
    DMA: 630,
  },
  "35957": {
    DMA: 691,
  },
  "35958": {
    DMA: 691,
  },
  "35959": {
    DMA: 630,
  },
  "35960": {
    DMA: 630,
  },
  "35961": {
    DMA: 691,
  },
  "35962": {
    DMA: 691,
  },
  "35963": {
    DMA: 691,
  },
  "35964": {
    DMA: 691,
  },
  "35966": {
    DMA: 691,
  },
  "35967": {
    DMA: 691,
  },
  "35968": {
    DMA: 691,
  },
  "35971": {
    DMA: 691,
  },
  "35972": {
    DMA: 630,
  },
  "35973": {
    DMA: 630,
  },
  "35974": {
    DMA: 691,
  },
  "35975": {
    DMA: 691,
  },
  "35976": {
    DMA: 691,
  },
  "35978": {
    DMA: 691,
  },
  "35979": {
    DMA: 691,
  },
  "35980": {
    DMA: 691,
  },
  "35981": {
    DMA: 691,
  },
  "35983": {
    DMA: 630,
  },
  "35984": {
    DMA: 691,
  },
  "35986": {
    DMA: 691,
  },
  "35987": {
    DMA: 630,
  },
  "35988": {
    DMA: 691,
  },
  "35989": {
    DMA: 691,
  },
  "35990": {
    DMA: 630,
  },
  "36003": {
    DMA: 698,
  },
  "36005": {
    DMA: 698,
  },
  "36006": {
    DMA: 698,
  },
  "36008": {
    DMA: 698,
  },
  "36009": {
    DMA: 698,
  },
  "36010": {
    DMA: 698,
  },
  "36013": {
    DMA: 698,
  },
  "36015": {
    DMA: 698,
  },
  "36016": {
    DMA: 522,
  },
  "36017": {
    DMA: 522,
  },
  "36020": {
    DMA: 698,
  },
  "36022": {
    DMA: 698,
  },
  "36023": {
    DMA: 698,
  },
  "36024": {
    DMA: 698,
  },
  "36025": {
    DMA: 698,
  },
  "36026": {
    DMA: 630,
  },
  "36027": {
    DMA: 522,
  },
  "36028": {
    DMA: 698,
  },
  "36029": {
    DMA: 698,
  },
  "36030": {
    DMA: 698,
  },
  "36031": {
    DMA: 698,
  },
  "36032": {
    DMA: 698,
  },
  "36033": {
    DMA: 698,
  },
  "36034": {
    DMA: 698,
  },
  "36035": {
    DMA: 698,
  },
  "36036": {
    DMA: 698,
  },
  "36037": {
    DMA: 698,
  },
  "36038": {
    DMA: 698,
  },
  "36039": {
    DMA: 698,
  },
  "36040": {
    DMA: 698,
  },
  "36041": {
    DMA: 698,
  },
  "36042": {
    DMA: 698,
  },
  "36043": {
    DMA: 698,
  },
  "36045": {
    DMA: 698,
  },
  "36046": {
    DMA: 698,
  },
  "36047": {
    DMA: 698,
  },
  "36048": {
    DMA: 522,
  },
  "36049": {
    DMA: 698,
  },
  "36051": {
    DMA: 698,
  },
  "36052": {
    DMA: 698,
  },
  "36053": {
    DMA: 698,
  },
  "36054": {
    DMA: 698,
  },
  "36057": {
    DMA: 698,
  },
  "36061": {
    DMA: 698,
  },
  "36062": {
    DMA: 698,
  },
  "36064": {
    DMA: 698,
  },
  "36065": {
    DMA: 698,
  },
  "36066": {
    DMA: 698,
  },
  "36067": {
    DMA: 698,
  },
  "36068": {
    DMA: 698,
  },
  "36069": {
    DMA: 698,
  },
  "36071": {
    DMA: 698,
  },
  "36072": {
    DMA: 522,
  },
  "36075": {
    DMA: 698,
  },
  "36078": {
    DMA: 698,
  },
  "36079": {
    DMA: 698,
  },
  "36080": {
    DMA: 698,
  },
  "36081": {
    DMA: 698,
  },
  "36082": {
    DMA: 698,
  },
  "36083": {
    DMA: 698,
  },
  "36087": {
    DMA: 698,
  },
  "36088": {
    DMA: 698,
  },
  "36089": {
    DMA: 698,
  },
  "36091": {
    DMA: 630,
  },
  "36092": {
    DMA: 698,
  },
  "36093": {
    DMA: 698,
  },
  "36101": {
    DMA: 698,
  },
  "36102": {
    DMA: 698,
  },
  "36103": {
    DMA: 698,
  },
  "36104": {
    DMA: 698,
  },
  "36105": {
    DMA: 698,
  },
  "36106": {
    DMA: 698,
  },
  "36107": {
    DMA: 698,
  },
  "36108": {
    DMA: 698,
  },
  "36109": {
    DMA: 698,
  },
  "36110": {
    DMA: 698,
  },
  "36111": {
    DMA: 698,
  },
  "36112": {
    DMA: 698,
  },
  "36113": {
    DMA: 698,
  },
  "36114": {
    DMA: 698,
  },
  "36115": {
    DMA: 698,
  },
  "36116": {
    DMA: 698,
  },
  "36117": {
    DMA: 698,
  },
  "36118": {
    DMA: 698,
  },
  "36119": {
    DMA: 698,
  },
  "36120": {
    DMA: 698,
  },
  "36121": {
    DMA: 698,
  },
  "36123": {
    DMA: 698,
  },
  "36124": {
    DMA: 698,
  },
  "36125": {
    DMA: 698,
  },
  "36130": {
    DMA: 698,
  },
  "36131": {
    DMA: 698,
  },
  "36132": {
    DMA: 698,
  },
  "36133": {
    DMA: 698,
  },
  "36134": {
    DMA: 698,
  },
  "36135": {
    DMA: 698,
  },
  "36140": {
    DMA: 698,
  },
  "36141": {
    DMA: 698,
  },
  "36142": {
    DMA: 698,
  },
  "36177": {
    DMA: 698,
  },
  "36191": {
    DMA: 698,
  },
  "36201": {
    DMA: 630,
  },
  "36202": {
    DMA: 630,
  },
  "36203": {
    DMA: 630,
  },
  "36204": {
    DMA: 630,
  },
  "36205": {
    DMA: 630,
  },
  "36206": {
    DMA: 630,
  },
  "36207": {
    DMA: 630,
  },
  "36210": {
    DMA: 630,
  },
  "36250": {
    DMA: 630,
  },
  "36251": {
    DMA: 630,
  },
  "36253": {
    DMA: 630,
  },
  "36254": {
    DMA: 630,
  },
  "36255": {
    DMA: 630,
  },
  "36256": {
    DMA: 698,
  },
  "36257": {
    DMA: 630,
  },
  "36258": {
    DMA: 630,
  },
  "36260": {
    DMA: 630,
  },
  "36261": {
    DMA: 524,
  },
  "36262": {
    DMA: 524,
  },
  "36263": {
    DMA: 524,
  },
  "36264": {
    DMA: 524,
  },
  "36265": {
    DMA: 630,
  },
  "36266": {
    DMA: 630,
  },
  "36267": {
    DMA: 630,
  },
  "36268": {
    DMA: 630,
  },
  "36269": {
    DMA: 524,
  },
  "36271": {
    DMA: 630,
  },
  "36272": {
    DMA: 630,
  },
  "36273": {
    DMA: 524,
  },
  "36274": {
    DMA: 524,
  },
  "36275": {
    DMA: 630,
  },
  "36276": {
    DMA: 524,
  },
  "36277": {
    DMA: 630,
  },
  "36278": {
    DMA: 524,
  },
  "36279": {
    DMA: 630,
  },
  "36280": {
    DMA: 524,
  },
  "36301": {
    DMA: 606,
  },
  "36302": {
    DMA: 606,
  },
  "36303": {
    DMA: 606,
  },
  "36304": {
    DMA: 606,
  },
  "36305": {
    DMA: 606,
  },
  "36310": {
    DMA: 606,
  },
  "36311": {
    DMA: 606,
  },
  "36312": {
    DMA: 606,
  },
  "36313": {
    DMA: 606,
  },
  "36314": {
    DMA: 606,
  },
  "36316": {
    DMA: 606,
  },
  "36317": {
    DMA: 606,
  },
  "36318": {
    DMA: 606,
  },
  "36319": {
    DMA: 606,
  },
  "36320": {
    DMA: 606,
  },
  "36321": {
    DMA: 606,
  },
  "36322": {
    DMA: 606,
  },
  "36323": {
    DMA: 606,
  },
  "36330": {
    DMA: 606,
  },
  "36331": {
    DMA: 606,
  },
  "36340": {
    DMA: 606,
  },
  "36343": {
    DMA: 606,
  },
  "36344": {
    DMA: 606,
  },
  "36345": {
    DMA: 606,
  },
  "36346": {
    DMA: 606,
  },
  "36349": {
    DMA: 606,
  },
  "36350": {
    DMA: 606,
  },
  "36351": {
    DMA: 606,
  },
  "36352": {
    DMA: 606,
  },
  "36353": {
    DMA: 606,
  },
  "36360": {
    DMA: 606,
  },
  "36361": {
    DMA: 606,
  },
  "36362": {
    DMA: 606,
  },
  "36370": {
    DMA: 606,
  },
  "36371": {
    DMA: 606,
  },
  "36373": {
    DMA: 606,
  },
  "36374": {
    DMA: 606,
  },
  "36375": {
    DMA: 606,
  },
  "36376": {
    DMA: 606,
  },
  "36401": {
    DMA: 686,
  },
  "36420": {
    DMA: 698,
  },
  "36421": {
    DMA: 698,
  },
  "36425": {
    DMA: 686,
  },
  "36426": {
    DMA: 686,
  },
  "36427": {
    DMA: 686,
  },
  "36429": {
    DMA: 686,
  },
  "36432": {
    DMA: 686,
  },
  "36435": {
    DMA: 698,
  },
  "36436": {
    DMA: 686,
  },
  "36439": {
    DMA: 686,
  },
  "36441": {
    DMA: 686,
  },
  "36442": {
    DMA: 698,
  },
  "36444": {
    DMA: 686,
  },
  "36445": {
    DMA: 686,
  },
  "36446": {
    DMA: 686,
  },
  "36449": {
    DMA: 686,
  },
  "36451": {
    DMA: 686,
  },
  "36453": {
    DMA: 606,
  },
  "36454": {
    DMA: 686,
  },
  "36455": {
    DMA: 698,
  },
  "36456": {
    DMA: 698,
  },
  "36457": {
    DMA: 686,
  },
  "36458": {
    DMA: 686,
  },
  "36460": {
    DMA: 686,
  },
  "36461": {
    DMA: 686,
  },
  "36462": {
    DMA: 686,
  },
  "36467": {
    DMA: 698,
  },
  "36470": {
    DMA: 686,
  },
  "36471": {
    DMA: 686,
  },
  "36473": {
    DMA: 686,
  },
  "36474": {
    DMA: 698,
  },
  "36475": {
    DMA: 686,
  },
  "36476": {
    DMA: 698,
  },
  "36477": {
    DMA: 606,
  },
  "36480": {
    DMA: 686,
  },
  "36481": {
    DMA: 686,
  },
  "36482": {
    DMA: 686,
  },
  "36483": {
    DMA: 698,
  },
  "36501": {
    DMA: 686,
  },
  "36502": {
    DMA: 686,
  },
  "36503": {
    DMA: 686,
  },
  "36504": {
    DMA: 686,
  },
  "36505": {
    DMA: 686,
  },
  "36507": {
    DMA: 686,
  },
  "36509": {
    DMA: 686,
  },
  "36511": {
    DMA: 686,
  },
  "36512": {
    DMA: 686,
  },
  "36513": {
    DMA: 686,
  },
  "36515": {
    DMA: 630,
  },
  "36518": {
    DMA: 686,
  },
  "36521": {
    DMA: 686,
  },
  "36522": {
    DMA: 686,
  },
  "36523": {
    DMA: 686,
  },
  "36524": {
    DMA: 686,
  },
  "36525": {
    DMA: 686,
  },
  "36526": {
    DMA: 686,
  },
  "36527": {
    DMA: 686,
  },
  "36528": {
    DMA: 686,
  },
  "36529": {
    DMA: 686,
  },
  "36530": {
    DMA: 686,
  },
  "36532": {
    DMA: 686,
  },
  "36533": {
    DMA: 686,
  },
  "36535": {
    DMA: 686,
  },
  "36536": {
    DMA: 686,
  },
  "36538": {
    DMA: 686,
  },
  "36539": {
    DMA: 686,
  },
  "36540": {
    DMA: 686,
  },
  "36541": {
    DMA: 686,
  },
  "36542": {
    DMA: 686,
  },
  "36543": {
    DMA: 686,
  },
  "36544": {
    DMA: 686,
  },
  "36545": {
    DMA: 686,
  },
  "36547": {
    DMA: 686,
  },
  "36548": {
    DMA: 686,
  },
  "36549": {
    DMA: 686,
  },
  "36550": {
    DMA: 686,
  },
  "36551": {
    DMA: 686,
  },
  "36553": {
    DMA: 686,
  },
  "36555": {
    DMA: 686,
  },
  "36556": {
    DMA: 686,
  },
  "36558": {
    DMA: 686,
  },
  "36559": {
    DMA: 686,
  },
  "36560": {
    DMA: 686,
  },
  "36561": {
    DMA: 686,
  },
  "36562": {
    DMA: 686,
  },
  "36564": {
    DMA: 686,
  },
  "36567": {
    DMA: 686,
  },
  "36568": {
    DMA: 686,
  },
  "36569": {
    DMA: 686,
  },
  "36571": {
    DMA: 686,
  },
  "36572": {
    DMA: 686,
  },
  "36574": {
    DMA: 686,
  },
  "36575": {
    DMA: 686,
  },
  "36576": {
    DMA: 686,
  },
  "36577": {
    DMA: 686,
  },
  "36578": {
    DMA: 686,
  },
  "36579": {
    DMA: 686,
  },
  "36580": {
    DMA: 686,
  },
  "36581": {
    DMA: 686,
  },
  "36582": {
    DMA: 686,
  },
  "36583": {
    DMA: 686,
  },
  "36584": {
    DMA: 686,
  },
  "36585": {
    DMA: 686,
  },
  "36587": {
    DMA: 686,
  },
  "36590": {
    DMA: 686,
  },
  "36601": {
    DMA: 686,
  },
  "36602": {
    DMA: 686,
  },
  "36603": {
    DMA: 686,
  },
  "36604": {
    DMA: 686,
  },
  "36605": {
    DMA: 686,
  },
  "36606": {
    DMA: 686,
  },
  "36607": {
    DMA: 686,
  },
  "36608": {
    DMA: 686,
  },
  "36609": {
    DMA: 686,
  },
  "36610": {
    DMA: 686,
  },
  "36611": {
    DMA: 686,
  },
  "36612": {
    DMA: 686,
  },
  "36613": {
    DMA: 686,
  },
  "36615": {
    DMA: 686,
  },
  "36616": {
    DMA: 686,
  },
  "36617": {
    DMA: 686,
  },
  "36618": {
    DMA: 686,
  },
  "36619": {
    DMA: 686,
  },
  "36621": {
    DMA: 686,
  },
  "36622": {
    DMA: 686,
  },
  "36625": {
    DMA: 686,
  },
  "36628": {
    DMA: 686,
  },
  "36630": {
    DMA: 686,
  },
  "36633": {
    DMA: 686,
  },
  "36640": {
    DMA: 686,
  },
  "36641": {
    DMA: 686,
  },
  "36644": {
    DMA: 686,
  },
  "36652": {
    DMA: 686,
  },
  "36660": {
    DMA: 686,
  },
  "36663": {
    DMA: 686,
  },
  "36670": {
    DMA: 686,
  },
  "36671": {
    DMA: 686,
  },
  "36675": {
    DMA: 686,
  },
  "36685": {
    DMA: 686,
  },
  "36688": {
    DMA: 686,
  },
  "36689": {
    DMA: 686,
  },
  "36690": {
    DMA: 686,
  },
  "36691": {
    DMA: 686,
  },
  "36693": {
    DMA: 686,
  },
  "36695": {
    DMA: 686,
  },
  "36701": {
    DMA: 698,
  },
  "36702": {
    DMA: 698,
  },
  "36703": {
    DMA: 698,
  },
  "36720": {
    DMA: 698,
  },
  "36721": {
    DMA: 691,
  },
  "36722": {
    DMA: 698,
  },
  "36723": {
    DMA: 698,
  },
  "36726": {
    DMA: 698,
  },
  "36727": {
    DMA: 686,
  },
  "36728": {
    DMA: 698,
  },
  "36732": {
    DMA: 698,
  },
  "36736": {
    DMA: 698,
  },
  "36738": {
    DMA: 698,
  },
  "36740": {
    DMA: 630,
  },
  "36741": {
    DMA: 698,
  },
  "36742": {
    DMA: 698,
  },
  "36744": {
    DMA: 630,
  },
  "36745": {
    DMA: 698,
  },
  "36748": {
    DMA: 698,
  },
  "36749": {
    DMA: 698,
  },
  "36750": {
    DMA: 630,
  },
  "36751": {
    DMA: 698,
  },
  "36752": {
    DMA: 698,
  },
  "36753": {
    DMA: 698,
  },
  "36754": {
    DMA: 698,
  },
  "36756": {
    DMA: 698,
  },
  "36758": {
    DMA: 698,
  },
  "36759": {
    DMA: 698,
  },
  "36761": {
    DMA: 698,
  },
  "36762": {
    DMA: 686,
  },
  "36763": {
    DMA: 698,
  },
  "36764": {
    DMA: 698,
  },
  "36765": {
    DMA: 630,
  },
  "36766": {
    DMA: 698,
  },
  "36767": {
    DMA: 698,
  },
  "36768": {
    DMA: 698,
  },
  "36769": {
    DMA: 698,
  },
  "36773": {
    DMA: 698,
  },
  "36775": {
    DMA: 698,
  },
  "36776": {
    DMA: 630,
  },
  "36782": {
    DMA: 698,
  },
  "36783": {
    DMA: 698,
  },
  "36784": {
    DMA: 686,
  },
  "36785": {
    DMA: 698,
  },
  "36786": {
    DMA: 698,
  },
  "36790": {
    DMA: 630,
  },
  "36792": {
    DMA: 630,
  },
  "36793": {
    DMA: 630,
  },
  "36801": {
    DMA: 522,
  },
  "36802": {
    DMA: 522,
  },
  "36803": {
    DMA: 522,
  },
  "36804": {
    DMA: 522,
  },
  "36830": {
    DMA: 522,
  },
  "36831": {
    DMA: 522,
  },
  "36832": {
    DMA: 522,
  },
  "36849": {
    DMA: 522,
  },
  "36850": {
    DMA: 698,
  },
  "36851": {
    DMA: 522,
  },
  "36852": {
    DMA: 522,
  },
  "36853": {
    DMA: 698,
  },
  "36854": {
    DMA: 522,
  },
  "36855": {
    DMA: 522,
  },
  "36856": {
    DMA: 522,
  },
  "36858": {
    DMA: 522,
  },
  "36859": {
    DMA: 522,
  },
  "36860": {
    DMA: 522,
  },
  "36861": {
    DMA: 698,
  },
  "36862": {
    DMA: 522,
  },
  "36863": {
    DMA: 522,
  },
  "36865": {
    DMA: 522,
  },
  "36866": {
    DMA: 698,
  },
  "36867": {
    DMA: 522,
  },
  "36868": {
    DMA: 522,
  },
  "36869": {
    DMA: 522,
  },
  "36870": {
    DMA: 522,
  },
  "36871": {
    DMA: 522,
  },
  "36872": {
    DMA: 522,
  },
  "36874": {
    DMA: 522,
  },
  "36875": {
    DMA: 522,
  },
  "36877": {
    DMA: 522,
  },
  "36879": {
    DMA: 522,
  },
  "36901": {
    DMA: 711,
  },
  "36904": {
    DMA: 711,
  },
  "36907": {
    DMA: 711,
  },
  "36908": {
    DMA: 711,
  },
  "36910": {
    DMA: 711,
  },
  "36912": {
    DMA: 711,
  },
  "36913": {
    DMA: 711,
  },
  "36915": {
    DMA: 711,
  },
  "36916": {
    DMA: 711,
  },
  "36919": {
    DMA: 711,
  },
  "36921": {
    DMA: 711,
  },
  "36922": {
    DMA: 711,
  },
  "36925": {
    DMA: 711,
  },
  "37010": {
    DMA: 659,
  },
  "37011": {
    DMA: 659,
  },
  "37012": {
    DMA: 659,
  },
  "37013": {
    DMA: 659,
  },
  "37014": {
    DMA: 659,
  },
  "37015": {
    DMA: 659,
  },
  "37016": {
    DMA: 659,
  },
  "37018": {
    DMA: 659,
  },
  "37019": {
    DMA: 659,
  },
  "37020": {
    DMA: 659,
  },
  "37022": {
    DMA: 659,
  },
  "37023": {
    DMA: 659,
  },
  "37024": {
    DMA: 659,
  },
  "37025": {
    DMA: 659,
  },
  "37026": {
    DMA: 659,
  },
  "37027": {
    DMA: 659,
  },
  "37028": {
    DMA: 659,
  },
  "37029": {
    DMA: 659,
  },
  "37030": {
    DMA: 659,
  },
  "37031": {
    DMA: 659,
  },
  "37032": {
    DMA: 659,
  },
  "37033": {
    DMA: 659,
  },
  "37034": {
    DMA: 659,
  },
  "37035": {
    DMA: 659,
  },
  "37036": {
    DMA: 659,
  },
  "37037": {
    DMA: 659,
  },
  "37040": {
    DMA: 659,
  },
  "37041": {
    DMA: 659,
  },
  "37042": {
    DMA: 659,
  },
  "37043": {
    DMA: 659,
  },
  "37044": {
    DMA: 659,
  },
  "37046": {
    DMA: 659,
  },
  "37047": {
    DMA: 659,
  },
  "37048": {
    DMA: 659,
  },
  "37049": {
    DMA: 659,
  },
  "37050": {
    DMA: 659,
  },
  "37051": {
    DMA: 659,
  },
  "37052": {
    DMA: 659,
  },
  "37055": {
    DMA: 659,
  },
  "37056": {
    DMA: 659,
  },
  "37057": {
    DMA: 659,
  },
  "37058": {
    DMA: 659,
  },
  "37059": {
    DMA: 659,
  },
  "37060": {
    DMA: 659,
  },
  "37061": {
    DMA: 659,
  },
  "37062": {
    DMA: 659,
  },
  "37063": {
    DMA: 659,
  },
  "37064": {
    DMA: 659,
  },
  "37065": {
    DMA: 659,
  },
  "37066": {
    DMA: 659,
  },
  "37067": {
    DMA: 659,
  },
  "37068": {
    DMA: 659,
  },
  "37069": {
    DMA: 659,
  },
  "37070": {
    DMA: 659,
  },
  "37071": {
    DMA: 659,
  },
  "37072": {
    DMA: 659,
  },
  "37073": {
    DMA: 659,
  },
  "37074": {
    DMA: 659,
  },
  "37075": {
    DMA: 659,
  },
  "37076": {
    DMA: 659,
  },
  "37077": {
    DMA: 659,
  },
  "37078": {
    DMA: 659,
  },
  "37079": {
    DMA: 659,
  },
  "37080": {
    DMA: 659,
  },
  "37082": {
    DMA: 659,
  },
  "37083": {
    DMA: 659,
  },
  "37085": {
    DMA: 659,
  },
  "37086": {
    DMA: 659,
  },
  "37087": {
    DMA: 659,
  },
  "37088": {
    DMA: 659,
  },
  "37089": {
    DMA: 659,
  },
  "37090": {
    DMA: 659,
  },
  "37091": {
    DMA: 659,
  },
  "37095": {
    DMA: 659,
  },
  "37096": {
    DMA: 659,
  },
  "37097": {
    DMA: 659,
  },
  "37098": {
    DMA: 659,
  },
  "37101": {
    DMA: 659,
  },
  "37110": {
    DMA: 659,
  },
  "37111": {
    DMA: 659,
  },
  "37115": {
    DMA: 659,
  },
  "37116": {
    DMA: 659,
  },
  "37118": {
    DMA: 659,
  },
  "37119": {
    DMA: 659,
  },
  "37121": {
    DMA: 659,
  },
  "37122": {
    DMA: 659,
  },
  "37127": {
    DMA: 659,
  },
  "37128": {
    DMA: 659,
  },
  "37129": {
    DMA: 659,
  },
  "37130": {
    DMA: 659,
  },
  "37131": {
    DMA: 659,
  },
  "37132": {
    DMA: 659,
  },
  "37133": {
    DMA: 659,
  },
  "37134": {
    DMA: 659,
  },
  "37135": {
    DMA: 659,
  },
  "37136": {
    DMA: 659,
  },
  "37137": {
    DMA: 659,
  },
  "37138": {
    DMA: 659,
  },
  "37140": {
    DMA: 659,
  },
  "37141": {
    DMA: 659,
  },
  "37142": {
    DMA: 659,
  },
  "37143": {
    DMA: 659,
  },
  "37144": {
    DMA: 691,
  },
  "37145": {
    DMA: 659,
  },
  "37146": {
    DMA: 659,
  },
  "37148": {
    DMA: 659,
  },
  "37149": {
    DMA: 659,
  },
  "37150": {
    DMA: 659,
  },
  "37151": {
    DMA: 659,
  },
  "37152": {
    DMA: 659,
  },
  "37153": {
    DMA: 659,
  },
  "37160": {
    DMA: 659,
  },
  "37161": {
    DMA: 659,
  },
  "37162": {
    DMA: 659,
  },
  "37165": {
    DMA: 659,
  },
  "37166": {
    DMA: 659,
  },
  "37167": {
    DMA: 659,
  },
  "37171": {
    DMA: 659,
  },
  "37172": {
    DMA: 659,
  },
  "37174": {
    DMA: 659,
  },
  "37175": {
    DMA: 659,
  },
  "37178": {
    DMA: 659,
  },
  "37179": {
    DMA: 659,
  },
  "37180": {
    DMA: 659,
  },
  "37181": {
    DMA: 659,
  },
  "37183": {
    DMA: 659,
  },
  "37184": {
    DMA: 659,
  },
  "37185": {
    DMA: 659,
  },
  "37186": {
    DMA: 659,
  },
  "37187": {
    DMA: 659,
  },
  "37188": {
    DMA: 659,
  },
  "37189": {
    DMA: 659,
  },
  "37190": {
    DMA: 659,
  },
  "37191": {
    DMA: 659,
  },
  "37201": {
    DMA: 659,
  },
  "37202": {
    DMA: 659,
  },
  "37203": {
    DMA: 659,
  },
  "37204": {
    DMA: 659,
  },
  "37205": {
    DMA: 659,
  },
  "37206": {
    DMA: 659,
  },
  "37207": {
    DMA: 659,
  },
  "37208": {
    DMA: 659,
  },
  "37209": {
    DMA: 659,
  },
  "37210": {
    DMA: 659,
  },
  "37211": {
    DMA: 659,
  },
  "37212": {
    DMA: 659,
  },
  "37213": {
    DMA: 659,
  },
  "37214": {
    DMA: 659,
  },
  "37215": {
    DMA: 659,
  },
  "37216": {
    DMA: 659,
  },
  "37217": {
    DMA: 659,
  },
  "37218": {
    DMA: 659,
  },
  "37219": {
    DMA: 659,
  },
  "37220": {
    DMA: 659,
  },
  "37221": {
    DMA: 659,
  },
  "37222": {
    DMA: 659,
  },
  "37224": {
    DMA: 659,
  },
  "37227": {
    DMA: 659,
  },
  "37228": {
    DMA: 659,
  },
  "37229": {
    DMA: 659,
  },
  "37230": {
    DMA: 659,
  },
  "37232": {
    DMA: 659,
  },
  "37234": {
    DMA: 659,
  },
  "37235": {
    DMA: 659,
  },
  "37236": {
    DMA: 659,
  },
  "37237": {
    DMA: 659,
  },
  "37238": {
    DMA: 659,
  },
  "37240": {
    DMA: 659,
  },
  "37241": {
    DMA: 659,
  },
  "37242": {
    DMA: 659,
  },
  "37243": {
    DMA: 659,
  },
  "37244": {
    DMA: 659,
  },
  "37245": {
    DMA: 659,
  },
  "37246": {
    DMA: 659,
  },
  "37247": {
    DMA: 659,
  },
  "37248": {
    DMA: 659,
  },
  "37249": {
    DMA: 659,
  },
  "37250": {
    DMA: 659,
  },
  "37301": {
    DMA: 575,
  },
  "37302": {
    DMA: 575,
  },
  "37303": {
    DMA: 575,
  },
  "37304": {
    DMA: 575,
  },
  "37305": {
    DMA: 575,
  },
  "37306": {
    DMA: 659,
  },
  "37307": {
    DMA: 575,
  },
  "37308": {
    DMA: 575,
  },
  "37309": {
    DMA: 575,
  },
  "37310": {
    DMA: 575,
  },
  "37311": {
    DMA: 575,
  },
  "37312": {
    DMA: 575,
  },
  "37313": {
    DMA: 575,
  },
  "37314": {
    DMA: 557,
  },
  "37315": {
    DMA: 575,
  },
  "37316": {
    DMA: 575,
  },
  "37317": {
    DMA: 575,
  },
  "37318": {
    DMA: 659,
  },
  "37320": {
    DMA: 575,
  },
  "37321": {
    DMA: 575,
  },
  "37322": {
    DMA: 575,
  },
  "37323": {
    DMA: 575,
  },
  "37324": {
    DMA: 659,
  },
  "37325": {
    DMA: 575,
  },
  "37326": {
    DMA: 575,
  },
  "37327": {
    DMA: 575,
  },
  "37328": {
    DMA: 691,
  },
  "37329": {
    DMA: 575,
  },
  "37330": {
    DMA: 659,
  },
  "37331": {
    DMA: 575,
  },
  "37332": {
    DMA: 575,
  },
  "37333": {
    DMA: 575,
  },
  "37334": {
    DMA: 691,
  },
  "37335": {
    DMA: 691,
  },
  "37336": {
    DMA: 575,
  },
  "37337": {
    DMA: 575,
  },
  "37338": {
    DMA: 575,
  },
  "37339": {
    DMA: 575,
  },
  "37340": {
    DMA: 575,
  },
  "37341": {
    DMA: 575,
  },
  "37342": {
    DMA: 659,
  },
  "37343": {
    DMA: 575,
  },
  "37345": {
    DMA: 659,
  },
  "37347": {
    DMA: 575,
  },
  "37348": {
    DMA: 691,
  },
  "37349": {
    DMA: 659,
  },
  "37350": {
    DMA: 575,
  },
  "37351": {
    DMA: 575,
  },
  "37352": {
    DMA: 659,
  },
  "37353": {
    DMA: 575,
  },
  "37354": {
    DMA: 557,
  },
  "37355": {
    DMA: 659,
  },
  "37356": {
    DMA: 575,
  },
  "37357": {
    DMA: 659,
  },
  "37359": {
    DMA: 691,
  },
  "37360": {
    DMA: 659,
  },
  "37361": {
    DMA: 575,
  },
  "37362": {
    DMA: 575,
  },
  "37363": {
    DMA: 575,
  },
  "37364": {
    DMA: 575,
  },
  "37365": {
    DMA: 575,
  },
  "37366": {
    DMA: 575,
  },
  "37367": {
    DMA: 575,
  },
  "37369": {
    DMA: 575,
  },
  "37370": {
    DMA: 575,
  },
  "37371": {
    DMA: 575,
  },
  "37373": {
    DMA: 575,
  },
  "37374": {
    DMA: 575,
  },
  "37375": {
    DMA: 659,
  },
  "37376": {
    DMA: 659,
  },
  "37377": {
    DMA: 575,
  },
  "37378": {
    DMA: 659,
  },
  "37379": {
    DMA: 575,
  },
  "37380": {
    DMA: 575,
  },
  "37381": {
    DMA: 575,
  },
  "37382": {
    DMA: 659,
  },
  "37383": {
    DMA: 659,
  },
  "37384": {
    DMA: 575,
  },
  "37385": {
    DMA: 557,
  },
  "37387": {
    DMA: 575,
  },
  "37388": {
    DMA: 659,
  },
  "37389": {
    DMA: 659,
  },
  "37391": {
    DMA: 575,
  },
  "37394": {
    DMA: 659,
  },
  "37396": {
    DMA: 575,
  },
  "37397": {
    DMA: 575,
  },
  "37398": {
    DMA: 659,
  },
  "37401": {
    DMA: 575,
  },
  "37402": {
    DMA: 575,
  },
  "37403": {
    DMA: 575,
  },
  "37404": {
    DMA: 575,
  },
  "37405": {
    DMA: 575,
  },
  "37406": {
    DMA: 575,
  },
  "37407": {
    DMA: 575,
  },
  "37408": {
    DMA: 575,
  },
  "37409": {
    DMA: 575,
  },
  "37410": {
    DMA: 575,
  },
  "37411": {
    DMA: 575,
  },
  "37412": {
    DMA: 575,
  },
  "37414": {
    DMA: 575,
  },
  "37415": {
    DMA: 575,
  },
  "37416": {
    DMA: 575,
  },
  "37419": {
    DMA: 575,
  },
  "37421": {
    DMA: 575,
  },
  "37422": {
    DMA: 575,
  },
  "37424": {
    DMA: 575,
  },
  "37450": {
    DMA: 575,
  },
  "37501": {
    DMA: 640,
  },
  "37544": {
    DMA: 640,
  },
  "37601": {
    DMA: 531,
  },
  "37602": {
    DMA: 531,
  },
  "37604": {
    DMA: 531,
  },
  "37605": {
    DMA: 531,
  },
  "37614": {
    DMA: 531,
  },
  "37615": {
    DMA: 531,
  },
  "37616": {
    DMA: 531,
  },
  "37617": {
    DMA: 531,
  },
  "37618": {
    DMA: 531,
  },
  "37620": {
    DMA: 531,
  },
  "37621": {
    DMA: 531,
  },
  "37625": {
    DMA: 531,
  },
  "37640": {
    DMA: 531,
  },
  "37641": {
    DMA: 531,
  },
  "37642": {
    DMA: 531,
  },
  "37643": {
    DMA: 531,
  },
  "37644": {
    DMA: 531,
  },
  "37645": {
    DMA: 531,
  },
  "37650": {
    DMA: 531,
  },
  "37656": {
    DMA: 531,
  },
  "37657": {
    DMA: 531,
  },
  "37658": {
    DMA: 531,
  },
  "37659": {
    DMA: 531,
  },
  "37660": {
    DMA: 531,
  },
  "37662": {
    DMA: 531,
  },
  "37663": {
    DMA: 531,
  },
  "37664": {
    DMA: 531,
  },
  "37665": {
    DMA: 531,
  },
  "37669": {
    DMA: 531,
  },
  "37680": {
    DMA: 531,
  },
  "37681": {
    DMA: 531,
  },
  "37682": {
    DMA: 531,
  },
  "37683": {
    DMA: 531,
  },
  "37684": {
    DMA: 531,
  },
  "37686": {
    DMA: 531,
  },
  "37687": {
    DMA: 531,
  },
  "37688": {
    DMA: 531,
  },
  "37690": {
    DMA: 531,
  },
  "37691": {
    DMA: 531,
  },
  "37692": {
    DMA: 531,
  },
  "37694": {
    DMA: 531,
  },
  "37699": {
    DMA: 531,
  },
  "37701": {
    DMA: 557,
  },
  "37705": {
    DMA: 557,
  },
  "37707": {
    DMA: 557,
  },
  "37708": {
    DMA: 557,
  },
  "37709": {
    DMA: 557,
  },
  "37710": {
    DMA: 557,
  },
  "37711": {
    DMA: 531,
  },
  "37713": {
    DMA: 557,
  },
  "37714": {
    DMA: 557,
  },
  "37715": {
    DMA: 557,
  },
  "37716": {
    DMA: 557,
  },
  "37717": {
    DMA: 557,
  },
  "37719": {
    DMA: 557,
  },
  "37721": {
    DMA: 557,
  },
  "37722": {
    DMA: 557,
  },
  "37723": {
    DMA: 557,
  },
  "37724": {
    DMA: 557,
  },
  "37725": {
    DMA: 557,
  },
  "37726": {
    DMA: 557,
  },
  "37727": {
    DMA: 557,
  },
  "37729": {
    DMA: 557,
  },
  "37730": {
    DMA: 557,
  },
  "37731": {
    DMA: 531,
  },
  "37732": {
    DMA: 557,
  },
  "37733": {
    DMA: 557,
  },
  "37737": {
    DMA: 557,
  },
  "37738": {
    DMA: 557,
  },
  "37742": {
    DMA: 557,
  },
  "37743": {
    DMA: 531,
  },
  "37744": {
    DMA: 531,
  },
  "37745": {
    DMA: 531,
  },
  "37748": {
    DMA: 557,
  },
  "37752": {
    DMA: 557,
  },
  "37753": {
    DMA: 557,
  },
  "37754": {
    DMA: 557,
  },
  "37755": {
    DMA: 557,
  },
  "37756": {
    DMA: 557,
  },
  "37757": {
    DMA: 557,
  },
  "37760": {
    DMA: 557,
  },
  "37762": {
    DMA: 557,
  },
  "37763": {
    DMA: 557,
  },
  "37764": {
    DMA: 557,
  },
  "37765": {
    DMA: 557,
  },
  "37766": {
    DMA: 557,
  },
  "37769": {
    DMA: 557,
  },
  "37770": {
    DMA: 557,
  },
  "37771": {
    DMA: 557,
  },
  "37772": {
    DMA: 557,
  },
  "37773": {
    DMA: 557,
  },
  "37774": {
    DMA: 557,
  },
  "37777": {
    DMA: 557,
  },
  "37778": {
    DMA: 557,
  },
  "37779": {
    DMA: 557,
  },
  "37801": {
    DMA: 557,
  },
  "37802": {
    DMA: 557,
  },
  "37803": {
    DMA: 557,
  },
  "37804": {
    DMA: 557,
  },
  "37806": {
    DMA: 557,
  },
  "37807": {
    DMA: 557,
  },
  "37809": {
    DMA: 531,
  },
  "37810": {
    DMA: 531,
  },
  "37811": {
    DMA: 531,
  },
  "37813": {
    DMA: 557,
  },
  "37814": {
    DMA: 557,
  },
  "37815": {
    DMA: 557,
  },
  "37816": {
    DMA: 557,
  },
  "37818": {
    DMA: 531,
  },
  "37819": {
    DMA: 557,
  },
  "37820": {
    DMA: 557,
  },
  "37821": {
    DMA: 557,
  },
  "37822": {
    DMA: 557,
  },
  "37824": {
    DMA: 557,
  },
  "37825": {
    DMA: 557,
  },
  "37826": {
    DMA: 575,
  },
  "37828": {
    DMA: 557,
  },
  "37829": {
    DMA: 557,
  },
  "37830": {
    DMA: 557,
  },
  "37831": {
    DMA: 557,
  },
  "37840": {
    DMA: 557,
  },
  "37841": {
    DMA: 557,
  },
  "37843": {
    DMA: 557,
  },
  "37845": {
    DMA: 557,
  },
  "37846": {
    DMA: 557,
  },
  "37847": {
    DMA: 557,
  },
  "37848": {
    DMA: 557,
  },
  "37849": {
    DMA: 557,
  },
  "37851": {
    DMA: 557,
  },
  "37852": {
    DMA: 557,
  },
  "37853": {
    DMA: 557,
  },
  "37854": {
    DMA: 557,
  },
  "37857": {
    DMA: 531,
  },
  "37860": {
    DMA: 557,
  },
  "37861": {
    DMA: 557,
  },
  "37862": {
    DMA: 557,
  },
  "37863": {
    DMA: 557,
  },
  "37864": {
    DMA: 557,
  },
  "37865": {
    DMA: 557,
  },
  "37866": {
    DMA: 557,
  },
  "37867": {
    DMA: 557,
  },
  "37868": {
    DMA: 557,
  },
  "37869": {
    DMA: 557,
  },
  "37870": {
    DMA: 557,
  },
  "37871": {
    DMA: 557,
  },
  "37872": {
    DMA: 557,
  },
  "37873": {
    DMA: 531,
  },
  "37874": {
    DMA: 557,
  },
  "37876": {
    DMA: 557,
  },
  "37877": {
    DMA: 557,
  },
  "37878": {
    DMA: 557,
  },
  "37879": {
    DMA: 557,
  },
  "37880": {
    DMA: 575,
  },
  "37881": {
    DMA: 557,
  },
  "37882": {
    DMA: 557,
  },
  "37885": {
    DMA: 557,
  },
  "37886": {
    DMA: 557,
  },
  "37887": {
    DMA: 557,
  },
  "37888": {
    DMA: 557,
  },
  "37890": {
    DMA: 557,
  },
  "37891": {
    DMA: 557,
  },
  "37892": {
    DMA: 557,
  },
  "37901": {
    DMA: 557,
  },
  "37902": {
    DMA: 557,
  },
  "37909": {
    DMA: 557,
  },
  "37912": {
    DMA: 557,
  },
  "37914": {
    DMA: 557,
  },
  "37915": {
    DMA: 557,
  },
  "37916": {
    DMA: 557,
  },
  "37917": {
    DMA: 557,
  },
  "37918": {
    DMA: 557,
  },
  "37919": {
    DMA: 557,
  },
  "37920": {
    DMA: 557,
  },
  "37921": {
    DMA: 557,
  },
  "37922": {
    DMA: 557,
  },
  "37923": {
    DMA: 557,
  },
  "37924": {
    DMA: 557,
  },
  "37927": {
    DMA: 557,
  },
  "37928": {
    DMA: 557,
  },
  "37929": {
    DMA: 557,
  },
  "37930": {
    DMA: 557,
  },
  "37931": {
    DMA: 557,
  },
  "37932": {
    DMA: 557,
  },
  "37933": {
    DMA: 557,
  },
  "37934": {
    DMA: 557,
  },
  "37938": {
    DMA: 557,
  },
  "37939": {
    DMA: 557,
  },
  "37940": {
    DMA: 557,
  },
  "37950": {
    DMA: 557,
  },
  "37990": {
    DMA: 557,
  },
  "37995": {
    DMA: 557,
  },
  "37996": {
    DMA: 557,
  },
  "37997": {
    DMA: 557,
  },
  "37998": {
    DMA: 557,
  },
  "38001": {
    DMA: 640,
  },
  "38002": {
    DMA: 640,
  },
  "38004": {
    DMA: 640,
  },
  "38006": {
    DMA: 640,
  },
  "38007": {
    DMA: 640,
  },
  "38008": {
    DMA: 640,
  },
  "38010": {
    DMA: 640,
  },
  "38011": {
    DMA: 640,
  },
  "38012": {
    DMA: 640,
  },
  "38014": {
    DMA: 640,
  },
  "38015": {
    DMA: 640,
  },
  "38016": {
    DMA: 640,
  },
  "38017": {
    DMA: 640,
  },
  "38018": {
    DMA: 640,
  },
  "38019": {
    DMA: 640,
  },
  "38021": {
    DMA: 640,
  },
  "38023": {
    DMA: 640,
  },
  "38024": {
    DMA: 640,
  },
  "38025": {
    DMA: 640,
  },
  "38027": {
    DMA: 640,
  },
  "38028": {
    DMA: 640,
  },
  "38029": {
    DMA: 640,
  },
  "38030": {
    DMA: 640,
  },
  "38034": {
    DMA: 640,
  },
  "38036": {
    DMA: 640,
  },
  "38037": {
    DMA: 640,
  },
  "38039": {
    DMA: 640,
  },
  "38040": {
    DMA: 640,
  },
  "38041": {
    DMA: 640,
  },
  "38042": {
    DMA: 640,
  },
  "38044": {
    DMA: 640,
  },
  "38045": {
    DMA: 640,
  },
  "38046": {
    DMA: 640,
  },
  "38047": {
    DMA: 640,
  },
  "38048": {
    DMA: 640,
  },
  "38049": {
    DMA: 640,
  },
  "38050": {
    DMA: 640,
  },
  "38052": {
    DMA: 640,
  },
  "38053": {
    DMA: 640,
  },
  "38054": {
    DMA: 640,
  },
  "38055": {
    DMA: 640,
  },
  "38057": {
    DMA: 640,
  },
  "38058": {
    DMA: 640,
  },
  "38059": {
    DMA: 640,
  },
  "38060": {
    DMA: 640,
  },
  "38061": {
    DMA: 640,
  },
  "38063": {
    DMA: 640,
  },
  "38066": {
    DMA: 640,
  },
  "38067": {
    DMA: 640,
  },
  "38068": {
    DMA: 640,
  },
  "38069": {
    DMA: 640,
  },
  "38070": {
    DMA: 640,
  },
  "38071": {
    DMA: 640,
  },
  "38075": {
    DMA: 640,
  },
  "38076": {
    DMA: 640,
  },
  "38077": {
    DMA: 632,
  },
  "38079": {
    DMA: 632,
  },
  "38080": {
    DMA: 632,
  },
  "38083": {
    DMA: 640,
  },
  "38088": {
    DMA: 640,
  },
  "38101": {
    DMA: 640,
  },
  "38103": {
    DMA: 640,
  },
  "38104": {
    DMA: 640,
  },
  "38105": {
    DMA: 640,
  },
  "38106": {
    DMA: 640,
  },
  "38107": {
    DMA: 640,
  },
  "38108": {
    DMA: 640,
  },
  "38109": {
    DMA: 640,
  },
  "38110": {
    DMA: 640,
  },
  "38111": {
    DMA: 640,
  },
  "38112": {
    DMA: 640,
  },
  "38113": {
    DMA: 640,
  },
  "38114": {
    DMA: 640,
  },
  "38115": {
    DMA: 640,
  },
  "38116": {
    DMA: 640,
  },
  "38117": {
    DMA: 640,
  },
  "38118": {
    DMA: 640,
  },
  "38119": {
    DMA: 640,
  },
  "38120": {
    DMA: 640,
  },
  "38122": {
    DMA: 640,
  },
  "38124": {
    DMA: 640,
  },
  "38125": {
    DMA: 640,
  },
  "38126": {
    DMA: 640,
  },
  "38127": {
    DMA: 640,
  },
  "38128": {
    DMA: 640,
  },
  "38130": {
    DMA: 640,
  },
  "38131": {
    DMA: 640,
  },
  "38132": {
    DMA: 640,
  },
  "38133": {
    DMA: 640,
  },
  "38134": {
    DMA: 640,
  },
  "38135": {
    DMA: 640,
  },
  "38136": {
    DMA: 640,
  },
  "38137": {
    DMA: 640,
  },
  "38138": {
    DMA: 640,
  },
  "38139": {
    DMA: 640,
  },
  "38141": {
    DMA: 640,
  },
  "38142": {
    DMA: 640,
  },
  "38145": {
    DMA: 640,
  },
  "38147": {
    DMA: 640,
  },
  "38148": {
    DMA: 640,
  },
  "38150": {
    DMA: 640,
  },
  "38151": {
    DMA: 640,
  },
  "38152": {
    DMA: 640,
  },
  "38157": {
    DMA: 640,
  },
  "38159": {
    DMA: 640,
  },
  "38161": {
    DMA: 640,
  },
  "38163": {
    DMA: 640,
  },
  "38165": {
    DMA: 640,
  },
  "38166": {
    DMA: 640,
  },
  "38167": {
    DMA: 640,
  },
  "38168": {
    DMA: 640,
  },
  "38173": {
    DMA: 640,
  },
  "38174": {
    DMA: 640,
  },
  "38175": {
    DMA: 640,
  },
  "38177": {
    DMA: 640,
  },
  "38181": {
    DMA: 640,
  },
  "38182": {
    DMA: 640,
  },
  "38183": {
    DMA: 640,
  },
  "38184": {
    DMA: 640,
  },
  "38186": {
    DMA: 640,
  },
  "38187": {
    DMA: 640,
  },
  "38188": {
    DMA: 640,
  },
  "38190": {
    DMA: 640,
  },
  "38193": {
    DMA: 640,
  },
  "38194": {
    DMA: 640,
  },
  "38197": {
    DMA: 640,
  },
  "38201": {
    DMA: 639,
  },
  "38220": {
    DMA: 639,
  },
  "38221": {
    DMA: 659,
  },
  "38222": {
    DMA: 659,
  },
  "38223": {
    DMA: 659,
  },
  "38224": {
    DMA: 659,
  },
  "38225": {
    DMA: 632,
  },
  "38226": {
    DMA: 632,
  },
  "38227": {
    DMA: 659,
  },
  "38229": {
    DMA: 632,
  },
  "38230": {
    DMA: 632,
  },
  "38231": {
    DMA: 659,
  },
  "38232": {
    DMA: 632,
  },
  "38233": {
    DMA: 639,
  },
  "38235": {
    DMA: 639,
  },
  "38236": {
    DMA: 659,
  },
  "38237": {
    DMA: 632,
  },
  "38238": {
    DMA: 632,
  },
  "38240": {
    DMA: 632,
  },
  "38241": {
    DMA: 632,
  },
  "38242": {
    DMA: 659,
  },
  "38251": {
    DMA: 659,
  },
  "38253": {
    DMA: 632,
  },
  "38254": {
    DMA: 632,
  },
  "38255": {
    DMA: 632,
  },
  "38256": {
    DMA: 659,
  },
  "38257": {
    DMA: 632,
  },
  "38258": {
    DMA: 639,
  },
  "38259": {
    DMA: 640,
  },
  "38260": {
    DMA: 632,
  },
  "38261": {
    DMA: 632,
  },
  "38271": {
    DMA: 632,
  },
  "38281": {
    DMA: 632,
  },
  "38301": {
    DMA: 639,
  },
  "38302": {
    DMA: 639,
  },
  "38303": {
    DMA: 639,
  },
  "38305": {
    DMA: 639,
  },
  "38308": {
    DMA: 639,
  },
  "38310": {
    DMA: 640,
  },
  "38311": {
    DMA: 659,
  },
  "38313": {
    DMA: 639,
  },
  "38314": {
    DMA: 639,
  },
  "38315": {
    DMA: 640,
  },
  "38316": {
    DMA: 639,
  },
  "38317": {
    DMA: 639,
  },
  "38318": {
    DMA: 639,
  },
  "38320": {
    DMA: 659,
  },
  "38321": {
    DMA: 639,
  },
  "38324": {
    DMA: 639,
  },
  "38326": {
    DMA: 639,
  },
  "38327": {
    DMA: 639,
  },
  "38328": {
    DMA: 639,
  },
  "38329": {
    DMA: 659,
  },
  "38330": {
    DMA: 639,
  },
  "38331": {
    DMA: 639,
  },
  "38332": {
    DMA: 639,
  },
  "38333": {
    DMA: 659,
  },
  "38334": {
    DMA: 640,
  },
  "38336": {
    DMA: 640,
  },
  "38337": {
    DMA: 640,
  },
  "38338": {
    DMA: 639,
  },
  "38339": {
    DMA: 640,
  },
  "38340": {
    DMA: 639,
  },
  "38341": {
    DMA: 659,
  },
  "38342": {
    DMA: 639,
  },
  "38343": {
    DMA: 639,
  },
  "38344": {
    DMA: 639,
  },
  "38345": {
    DMA: 639,
  },
  "38346": {
    DMA: 639,
  },
  "38347": {
    DMA: 639,
  },
  "38348": {
    DMA: 639,
  },
  "38351": {
    DMA: 639,
  },
  "38352": {
    DMA: 639,
  },
  "38355": {
    DMA: 639,
  },
  "38356": {
    DMA: 639,
  },
  "38357": {
    DMA: 640,
  },
  "38358": {
    DMA: 639,
  },
  "38359": {
    DMA: 640,
  },
  "38361": {
    DMA: 639,
  },
  "38362": {
    DMA: 639,
  },
  "38363": {
    DMA: 659,
  },
  "38365": {
    DMA: 639,
  },
  "38366": {
    DMA: 639,
  },
  "38367": {
    DMA: 640,
  },
  "38368": {
    DMA: 639,
  },
  "38369": {
    DMA: 639,
  },
  "38370": {
    DMA: 639,
  },
  "38371": {
    DMA: 639,
  },
  "38372": {
    DMA: 639,
  },
  "38374": {
    DMA: 659,
  },
  "38375": {
    DMA: 640,
  },
  "38376": {
    DMA: 639,
  },
  "38377": {
    DMA: 640,
  },
  "38378": {
    DMA: 639,
  },
  "38379": {
    DMA: 640,
  },
  "38380": {
    DMA: 659,
  },
  "38381": {
    DMA: 640,
  },
  "38382": {
    DMA: 639,
  },
  "38387": {
    DMA: 639,
  },
  "38388": {
    DMA: 639,
  },
  "38389": {
    DMA: 639,
  },
  "38390": {
    DMA: 639,
  },
  "38391": {
    DMA: 639,
  },
  "38392": {
    DMA: 639,
  },
  "38393": {
    DMA: 640,
  },
  "38401": {
    DMA: 659,
  },
  "38402": {
    DMA: 659,
  },
  "38425": {
    DMA: 659,
  },
  "38449": {
    DMA: 659,
  },
  "38450": {
    DMA: 659,
  },
  "38451": {
    DMA: 659,
  },
  "38452": {
    DMA: 659,
  },
  "38453": {
    DMA: 691,
  },
  "38454": {
    DMA: 659,
  },
  "38455": {
    DMA: 659,
  },
  "38456": {
    DMA: 659,
  },
  "38457": {
    DMA: 659,
  },
  "38459": {
    DMA: 691,
  },
  "38460": {
    DMA: 659,
  },
  "38461": {
    DMA: 659,
  },
  "38462": {
    DMA: 659,
  },
  "38463": {
    DMA: 659,
  },
  "38464": {
    DMA: 659,
  },
  "38468": {
    DMA: 659,
  },
  "38469": {
    DMA: 659,
  },
  "38471": {
    DMA: 659,
  },
  "38472": {
    DMA: 659,
  },
  "38473": {
    DMA: 659,
  },
  "38474": {
    DMA: 659,
  },
  "38475": {
    DMA: 639,
  },
  "38476": {
    DMA: 659,
  },
  "38477": {
    DMA: 659,
  },
  "38478": {
    DMA: 659,
  },
  "38481": {
    DMA: 659,
  },
  "38482": {
    DMA: 659,
  },
  "38483": {
    DMA: 659,
  },
  "38485": {
    DMA: 659,
  },
  "38486": {
    DMA: 659,
  },
  "38487": {
    DMA: 659,
  },
  "38488": {
    DMA: 691,
  },
  "38501": {
    DMA: 659,
  },
  "38502": {
    DMA: 659,
  },
  "38503": {
    DMA: 659,
  },
  "38504": {
    DMA: 557,
  },
  "38505": {
    DMA: 659,
  },
  "38506": {
    DMA: 659,
  },
  "38541": {
    DMA: 659,
  },
  "38542": {
    DMA: 659,
  },
  "38543": {
    DMA: 659,
  },
  "38544": {
    DMA: 659,
  },
  "38545": {
    DMA: 659,
  },
  "38547": {
    DMA: 659,
  },
  "38548": {
    DMA: 659,
  },
  "38549": {
    DMA: 659,
  },
  "38550": {
    DMA: 659,
  },
  "38551": {
    DMA: 659,
  },
  "38552": {
    DMA: 659,
  },
  "38553": {
    DMA: 557,
  },
  "38554": {
    DMA: 659,
  },
  "38555": {
    DMA: 557,
  },
  "38556": {
    DMA: 557,
  },
  "38557": {
    DMA: 557,
  },
  "38558": {
    DMA: 557,
  },
  "38559": {
    DMA: 659,
  },
  "38560": {
    DMA: 659,
  },
  "38562": {
    DMA: 659,
  },
  "38563": {
    DMA: 659,
  },
  "38564": {
    DMA: 659,
  },
  "38565": {
    DMA: 557,
  },
  "38567": {
    DMA: 659,
  },
  "38568": {
    DMA: 659,
  },
  "38569": {
    DMA: 659,
  },
  "38570": {
    DMA: 659,
  },
  "38571": {
    DMA: 557,
  },
  "38572": {
    DMA: 557,
  },
  "38573": {
    DMA: 659,
  },
  "38574": {
    DMA: 659,
  },
  "38575": {
    DMA: 659,
  },
  "38577": {
    DMA: 557,
  },
  "38578": {
    DMA: 557,
  },
  "38579": {
    DMA: 659,
  },
  "38580": {
    DMA: 659,
  },
  "38581": {
    DMA: 659,
  },
  "38582": {
    DMA: 659,
  },
  "38583": {
    DMA: 659,
  },
  "38585": {
    DMA: 659,
  },
  "38587": {
    DMA: 659,
  },
  "38588": {
    DMA: 659,
  },
  "38589": {
    DMA: 659,
  },
  "38601": {
    DMA: 640,
  },
  "38602": {
    DMA: 640,
  },
  "38603": {
    DMA: 640,
  },
  "38606": {
    DMA: 640,
  },
  "38609": {
    DMA: 640,
  },
  "38610": {
    DMA: 640,
  },
  "38611": {
    DMA: 640,
  },
  "38614": {
    DMA: 640,
  },
  "38617": {
    DMA: 640,
  },
  "38618": {
    DMA: 640,
  },
  "38619": {
    DMA: 640,
  },
  "38620": {
    DMA: 640,
  },
  "38621": {
    DMA: 640,
  },
  "38622": {
    DMA: 640,
  },
  "38623": {
    DMA: 640,
  },
  "38625": {
    DMA: 640,
  },
  "38626": {
    DMA: 640,
  },
  "38627": {
    DMA: 673,
  },
  "38628": {
    DMA: 640,
  },
  "38629": {
    DMA: 640,
  },
  "38630": {
    DMA: 640,
  },
  "38631": {
    DMA: 640,
  },
  "38632": {
    DMA: 640,
  },
  "38633": {
    DMA: 640,
  },
  "38634": {
    DMA: 640,
  },
  "38635": {
    DMA: 640,
  },
  "38637": {
    DMA: 640,
  },
  "38638": {
    DMA: 640,
  },
  "38639": {
    DMA: 640,
  },
  "38641": {
    DMA: 640,
  },
  "38642": {
    DMA: 640,
  },
  "38643": {
    DMA: 640,
  },
  "38644": {
    DMA: 640,
  },
  "38645": {
    DMA: 640,
  },
  "38646": {
    DMA: 640,
  },
  "38647": {
    DMA: 640,
  },
  "38649": {
    DMA: 640,
  },
  "38650": {
    DMA: 673,
  },
  "38651": {
    DMA: 640,
  },
  "38652": {
    DMA: 673,
  },
  "38654": {
    DMA: 640,
  },
  "38655": {
    DMA: 640,
  },
  "38658": {
    DMA: 640,
  },
  "38659": {
    DMA: 640,
  },
  "38661": {
    DMA: 640,
  },
  "38663": {
    DMA: 640,
  },
  "38664": {
    DMA: 640,
  },
  "38665": {
    DMA: 640,
  },
  "38666": {
    DMA: 640,
  },
  "38668": {
    DMA: 640,
  },
  "38669": {
    DMA: 640,
  },
  "38670": {
    DMA: 640,
  },
  "38671": {
    DMA: 640,
  },
  "38672": {
    DMA: 640,
  },
  "38673": {
    DMA: 640,
  },
  "38674": {
    DMA: 640,
  },
  "38675": {
    DMA: 640,
  },
  "38676": {
    DMA: 640,
  },
  "38677": {
    DMA: 640,
  },
  "38679": {
    DMA: 640,
  },
  "38680": {
    DMA: 640,
  },
  "38683": {
    DMA: 640,
  },
  "38685": {
    DMA: 640,
  },
  "38686": {
    DMA: 640,
  },
  "38701": {
    DMA: 647,
  },
  "38702": {
    DMA: 647,
  },
  "38703": {
    DMA: 647,
  },
  "38704": {
    DMA: 647,
  },
  "38720": {
    DMA: 647,
  },
  "38721": {
    DMA: 718,
  },
  "38722": {
    DMA: 647,
  },
  "38723": {
    DMA: 647,
  },
  "38725": {
    DMA: 647,
  },
  "38726": {
    DMA: 647,
  },
  "38730": {
    DMA: 647,
  },
  "38731": {
    DMA: 647,
  },
  "38732": {
    DMA: 647,
  },
  "38733": {
    DMA: 647,
  },
  "38736": {
    DMA: 647,
  },
  "38737": {
    DMA: 647,
  },
  "38738": {
    DMA: 647,
  },
  "38739": {
    DMA: 640,
  },
  "38740": {
    DMA: 647,
  },
  "38744": {
    DMA: 647,
  },
  "38745": {
    DMA: 718,
  },
  "38746": {
    DMA: 647,
  },
  "38748": {
    DMA: 647,
  },
  "38749": {
    DMA: 647,
  },
  "38751": {
    DMA: 647,
  },
  "38753": {
    DMA: 647,
  },
  "38754": {
    DMA: 718,
  },
  "38756": {
    DMA: 647,
  },
  "38759": {
    DMA: 647,
  },
  "38760": {
    DMA: 647,
  },
  "38761": {
    DMA: 647,
  },
  "38762": {
    DMA: 647,
  },
  "38764": {
    DMA: 647,
  },
  "38765": {
    DMA: 718,
  },
  "38767": {
    DMA: 640,
  },
  "38768": {
    DMA: 647,
  },
  "38769": {
    DMA: 647,
  },
  "38771": {
    DMA: 647,
  },
  "38772": {
    DMA: 647,
  },
  "38773": {
    DMA: 647,
  },
  "38774": {
    DMA: 647,
  },
  "38776": {
    DMA: 647,
  },
  "38778": {
    DMA: 647,
  },
  "38780": {
    DMA: 647,
  },
  "38781": {
    DMA: 647,
  },
  "38782": {
    DMA: 647,
  },
  "38801": {
    DMA: 673,
  },
  "38802": {
    DMA: 673,
  },
  "38803": {
    DMA: 673,
  },
  "38804": {
    DMA: 673,
  },
  "38820": {
    DMA: 673,
  },
  "38821": {
    DMA: 673,
  },
  "38824": {
    DMA: 673,
  },
  "38825": {
    DMA: 673,
  },
  "38826": {
    DMA: 673,
  },
  "38827": {
    DMA: 673,
  },
  "38828": {
    DMA: 673,
  },
  "38829": {
    DMA: 673,
  },
  "38833": {
    DMA: 673,
  },
  "38834": {
    DMA: 640,
  },
  "38835": {
    DMA: 640,
  },
  "38838": {
    DMA: 673,
  },
  "38839": {
    DMA: 673,
  },
  "38841": {
    DMA: 673,
  },
  "38843": {
    DMA: 673,
  },
  "38844": {
    DMA: 673,
  },
  "38846": {
    DMA: 640,
  },
  "38847": {
    DMA: 673,
  },
  "38848": {
    DMA: 673,
  },
  "38849": {
    DMA: 673,
  },
  "38850": {
    DMA: 673,
  },
  "38851": {
    DMA: 673,
  },
  "38852": {
    DMA: 673,
  },
  "38855": {
    DMA: 673,
  },
  "38856": {
    DMA: 673,
  },
  "38857": {
    DMA: 673,
  },
  "38858": {
    DMA: 673,
  },
  "38859": {
    DMA: 673,
  },
  "38860": {
    DMA: 673,
  },
  "38862": {
    DMA: 673,
  },
  "38863": {
    DMA: 673,
  },
  "38864": {
    DMA: 673,
  },
  "38865": {
    DMA: 640,
  },
  "38866": {
    DMA: 673,
  },
  "38868": {
    DMA: 673,
  },
  "38869": {
    DMA: 673,
  },
  "38870": {
    DMA: 673,
  },
  "38871": {
    DMA: 673,
  },
  "38873": {
    DMA: 673,
  },
  "38874": {
    DMA: 640,
  },
  "38875": {
    DMA: 673,
  },
  "38876": {
    DMA: 673,
  },
  "38877": {
    DMA: 673,
  },
  "38878": {
    DMA: 673,
  },
  "38879": {
    DMA: 673,
  },
  "38880": {
    DMA: 673,
  },
  "38901": {
    DMA: 647,
  },
  "38902": {
    DMA: 647,
  },
  "38913": {
    DMA: 673,
  },
  "38914": {
    DMA: 673,
  },
  "38915": {
    DMA: 673,
  },
  "38916": {
    DMA: 673,
  },
  "38917": {
    DMA: 647,
  },
  "38920": {
    DMA: 647,
  },
  "38921": {
    DMA: 647,
  },
  "38922": {
    DMA: 673,
  },
  "38923": {
    DMA: 647,
  },
  "38924": {
    DMA: 718,
  },
  "38925": {
    DMA: 673,
  },
  "38926": {
    DMA: 686,
  },
  "38927": {
    DMA: 647,
  },
  "38928": {
    DMA: 647,
  },
  "38929": {
    DMA: 647,
  },
  "38930": {
    DMA: 647,
  },
  "38935": {
    DMA: 647,
  },
  "38940": {
    DMA: 647,
  },
  "38941": {
    DMA: 647,
  },
  "38943": {
    DMA: 647,
  },
  "38944": {
    DMA: 647,
  },
  "38945": {
    DMA: 647,
  },
  "38946": {
    DMA: 647,
  },
  "38947": {
    DMA: 647,
  },
  "38948": {
    DMA: 673,
  },
  "38949": {
    DMA: 640,
  },
  "38950": {
    DMA: 647,
  },
  "38951": {
    DMA: 673,
  },
  "38952": {
    DMA: 647,
  },
  "38953": {
    DMA: 673,
  },
  "38954": {
    DMA: 647,
  },
  "38955": {
    DMA: 673,
  },
  "38957": {
    DMA: 647,
  },
  "38958": {
    DMA: 647,
  },
  "38959": {
    DMA: 647,
  },
  "38960": {
    DMA: 647,
  },
  "38961": {
    DMA: 673,
  },
  "38962": {
    DMA: 647,
  },
  "38963": {
    DMA: 647,
  },
  "38964": {
    DMA: 640,
  },
  "38965": {
    DMA: 673,
  },
  "38966": {
    DMA: 647,
  },
  "38967": {
    DMA: 673,
  },
  "39038": {
    DMA: 718,
  },
  "39039": {
    DMA: 718,
  },
  "39040": {
    DMA: 718,
  },
  "39041": {
    DMA: 718,
  },
  "39042": {
    DMA: 718,
  },
  "39043": {
    DMA: 718,
  },
  "39044": {
    DMA: 718,
  },
  "39045": {
    DMA: 718,
  },
  "39046": {
    DMA: 718,
  },
  "39047": {
    DMA: 718,
  },
  "39051": {
    DMA: 718,
  },
  "39054": {
    DMA: 718,
  },
  "39056": {
    DMA: 718,
  },
  "39057": {
    DMA: 711,
  },
  "39058": {
    DMA: 718,
  },
  "39059": {
    DMA: 718,
  },
  "39060": {
    DMA: 718,
  },
  "39061": {
    DMA: 718,
  },
  "39062": {
    DMA: 718,
  },
  "39063": {
    DMA: 718,
  },
  "39066": {
    DMA: 718,
  },
  "39067": {
    DMA: 718,
  },
  "39069": {
    DMA: 718,
  },
  "39071": {
    DMA: 718,
  },
  "39072": {
    DMA: 718,
  },
  "39073": {
    DMA: 718,
  },
  "39074": {
    DMA: 718,
  },
  "39077": {
    DMA: 718,
  },
  "39078": {
    DMA: 718,
  },
  "39079": {
    DMA: 718,
  },
  "39080": {
    DMA: 718,
  },
  "39081": {
    DMA: 718,
  },
  "39082": {
    DMA: 718,
  },
  "39083": {
    DMA: 718,
  },
  "39086": {
    DMA: 718,
  },
  "39087": {
    DMA: 718,
  },
  "39088": {
    DMA: 718,
  },
  "39090": {
    DMA: 718,
  },
  "39092": {
    DMA: 718,
  },
  "39094": {
    DMA: 718,
  },
  "39095": {
    DMA: 718,
  },
  "39096": {
    DMA: 718,
  },
  "39097": {
    DMA: 718,
  },
  "39098": {
    DMA: 718,
  },
  "39107": {
    DMA: 718,
  },
  "39108": {
    DMA: 718,
  },
  "39109": {
    DMA: 718,
  },
  "39110": {
    DMA: 718,
  },
  "39111": {
    DMA: 718,
  },
  "39113": {
    DMA: 718,
  },
  "39114": {
    DMA: 718,
  },
  "39115": {
    DMA: 718,
  },
  "39116": {
    DMA: 718,
  },
  "39117": {
    DMA: 718,
  },
  "39119": {
    DMA: 710,
  },
  "39120": {
    DMA: 718,
  },
  "39121": {
    DMA: 718,
  },
  "39122": {
    DMA: 718,
  },
  "39130": {
    DMA: 718,
  },
  "39140": {
    DMA: 718,
  },
  "39144": {
    DMA: 718,
  },
  "39145": {
    DMA: 718,
  },
  "39146": {
    DMA: 718,
  },
  "39148": {
    DMA: 718,
  },
  "39149": {
    DMA: 718,
  },
  "39150": {
    DMA: 718,
  },
  "39151": {
    DMA: 718,
  },
  "39152": {
    DMA: 718,
  },
  "39153": {
    DMA: 718,
  },
  "39154": {
    DMA: 718,
  },
  "39156": {
    DMA: 718,
  },
  "39157": {
    DMA: 718,
  },
  "39158": {
    DMA: 718,
  },
  "39159": {
    DMA: 718,
  },
  "39160": {
    DMA: 718,
  },
  "39161": {
    DMA: 718,
  },
  "39162": {
    DMA: 718,
  },
  "39163": {
    DMA: 718,
  },
  "39165": {
    DMA: 718,
  },
  "39166": {
    DMA: 718,
  },
  "39167": {
    DMA: 718,
  },
  "39168": {
    DMA: 718,
  },
  "39169": {
    DMA: 718,
  },
  "39170": {
    DMA: 718,
  },
  "39171": {
    DMA: 718,
  },
  "39173": {
    DMA: 718,
  },
  "39174": {
    DMA: 718,
  },
  "39175": {
    DMA: 718,
  },
  "39176": {
    DMA: 647,
  },
  "39177": {
    DMA: 718,
  },
  "39179": {
    DMA: 718,
  },
  "39180": {
    DMA: 718,
  },
  "39181": {
    DMA: 718,
  },
  "39182": {
    DMA: 718,
  },
  "39183": {
    DMA: 718,
  },
  "39189": {
    DMA: 718,
  },
  "39190": {
    DMA: 718,
  },
  "39191": {
    DMA: 718,
  },
  "39192": {
    DMA: 718,
  },
  "39193": {
    DMA: 718,
  },
  "39194": {
    DMA: 718,
  },
  "39201": {
    DMA: 718,
  },
  "39202": {
    DMA: 718,
  },
  "39203": {
    DMA: 718,
  },
  "39204": {
    DMA: 718,
  },
  "39205": {
    DMA: 718,
  },
  "39206": {
    DMA: 718,
  },
  "39207": {
    DMA: 718,
  },
  "39208": {
    DMA: 718,
  },
  "39209": {
    DMA: 718,
  },
  "39210": {
    DMA: 718,
  },
  "39211": {
    DMA: 718,
  },
  "39212": {
    DMA: 718,
  },
  "39213": {
    DMA: 718,
  },
  "39215": {
    DMA: 718,
  },
  "39216": {
    DMA: 718,
  },
  "39217": {
    DMA: 718,
  },
  "39218": {
    DMA: 718,
  },
  "39225": {
    DMA: 718,
  },
  "39232": {
    DMA: 718,
  },
  "39235": {
    DMA: 718,
  },
  "39236": {
    DMA: 718,
  },
  "39250": {
    DMA: 718,
  },
  "39269": {
    DMA: 718,
  },
  "39271": {
    DMA: 718,
  },
  "39272": {
    DMA: 718,
  },
  "39282": {
    DMA: 718,
  },
  "39283": {
    DMA: 718,
  },
  "39284": {
    DMA: 718,
  },
  "39286": {
    DMA: 718,
  },
  "39288": {
    DMA: 718,
  },
  "39289": {
    DMA: 718,
  },
  "39296": {
    DMA: 718,
  },
  "39298": {
    DMA: 718,
  },
  "39301": {
    DMA: 711,
  },
  "39302": {
    DMA: 711,
  },
  "39303": {
    DMA: 711,
  },
  "39304": {
    DMA: 711,
  },
  "39305": {
    DMA: 711,
  },
  "39307": {
    DMA: 711,
  },
  "39309": {
    DMA: 711,
  },
  "39320": {
    DMA: 711,
  },
  "39322": {
    DMA: 710,
  },
  "39323": {
    DMA: 711,
  },
  "39324": {
    DMA: 710,
  },
  "39325": {
    DMA: 711,
  },
  "39326": {
    DMA: 711,
  },
  "39327": {
    DMA: 711,
  },
  "39328": {
    DMA: 711,
  },
  "39330": {
    DMA: 711,
  },
  "39332": {
    DMA: 711,
  },
  "39335": {
    DMA: 711,
  },
  "39336": {
    DMA: 711,
  },
  "39337": {
    DMA: 711,
  },
  "39338": {
    DMA: 710,
  },
  "39339": {
    DMA: 673,
  },
  "39341": {
    DMA: 673,
  },
  "39342": {
    DMA: 711,
  },
  "39345": {
    DMA: 711,
  },
  "39346": {
    DMA: 673,
  },
  "39347": {
    DMA: 711,
  },
  "39348": {
    DMA: 710,
  },
  "39350": {
    DMA: 711,
  },
  "39352": {
    DMA: 711,
  },
  "39354": {
    DMA: 711,
  },
  "39355": {
    DMA: 711,
  },
  "39356": {
    DMA: 710,
  },
  "39358": {
    DMA: 711,
  },
  "39359": {
    DMA: 718,
  },
  "39360": {
    DMA: 711,
  },
  "39361": {
    DMA: 673,
  },
  "39362": {
    DMA: 686,
  },
  "39363": {
    DMA: 711,
  },
  "39364": {
    DMA: 711,
  },
  "39365": {
    DMA: 711,
  },
  "39366": {
    DMA: 710,
  },
  "39367": {
    DMA: 710,
  },
  "39401": {
    DMA: 710,
  },
  "39402": {
    DMA: 710,
  },
  "39403": {
    DMA: 710,
  },
  "39404": {
    DMA: 710,
  },
  "39406": {
    DMA: 710,
  },
  "39407": {
    DMA: 710,
  },
  "39421": {
    DMA: 718,
  },
  "39422": {
    DMA: 710,
  },
  "39423": {
    DMA: 710,
  },
  "39425": {
    DMA: 710,
  },
  "39426": {
    DMA: 622,
  },
  "39427": {
    DMA: 718,
  },
  "39428": {
    DMA: 710,
  },
  "39429": {
    DMA: 710,
  },
  "39436": {
    DMA: 710,
  },
  "39437": {
    DMA: 710,
  },
  "39439": {
    DMA: 710,
  },
  "39440": {
    DMA: 710,
  },
  "39441": {
    DMA: 710,
  },
  "39442": {
    DMA: 710,
  },
  "39443": {
    DMA: 710,
  },
  "39451": {
    DMA: 686,
  },
  "39452": {
    DMA: 746,
  },
  "39455": {
    DMA: 710,
  },
  "39456": {
    DMA: 686,
  },
  "39457": {
    DMA: 622,
  },
  "39459": {
    DMA: 710,
  },
  "39460": {
    DMA: 710,
  },
  "39461": {
    DMA: 686,
  },
  "39462": {
    DMA: 710,
  },
  "39463": {
    DMA: 622,
  },
  "39464": {
    DMA: 710,
  },
  "39465": {
    DMA: 710,
  },
  "39466": {
    DMA: 622,
  },
  "39470": {
    DMA: 622,
  },
  "39474": {
    DMA: 718,
  },
  "39475": {
    DMA: 710,
  },
  "39476": {
    DMA: 710,
  },
  "39477": {
    DMA: 710,
  },
  "39478": {
    DMA: 710,
  },
  "39479": {
    DMA: 710,
  },
  "39480": {
    DMA: 710,
  },
  "39481": {
    DMA: 710,
  },
  "39482": {
    DMA: 710,
  },
  "39483": {
    DMA: 710,
  },
  "39501": {
    DMA: 746,
  },
  "39502": {
    DMA: 746,
  },
  "39503": {
    DMA: 746,
  },
  "39505": {
    DMA: 746,
  },
  "39506": {
    DMA: 746,
  },
  "39507": {
    DMA: 746,
  },
  "39520": {
    DMA: 622,
  },
  "39521": {
    DMA: 622,
  },
  "39522": {
    DMA: 622,
  },
  "39525": {
    DMA: 622,
  },
  "39529": {
    DMA: 622,
  },
  "39530": {
    DMA: 746,
  },
  "39531": {
    DMA: 746,
  },
  "39532": {
    DMA: 746,
  },
  "39533": {
    DMA: 746,
  },
  "39534": {
    DMA: 746,
  },
  "39535": {
    DMA: 746,
  },
  "39540": {
    DMA: 746,
  },
  "39552": {
    DMA: 746,
  },
  "39553": {
    DMA: 746,
  },
  "39555": {
    DMA: 746,
  },
  "39556": {
    DMA: 622,
  },
  "39558": {
    DMA: 622,
  },
  "39560": {
    DMA: 746,
  },
  "39561": {
    DMA: 746,
  },
  "39562": {
    DMA: 746,
  },
  "39563": {
    DMA: 746,
  },
  "39564": {
    DMA: 746,
  },
  "39565": {
    DMA: 746,
  },
  "39566": {
    DMA: 746,
  },
  "39567": {
    DMA: 746,
  },
  "39568": {
    DMA: 746,
  },
  "39569": {
    DMA: 746,
  },
  "39571": {
    DMA: 746,
  },
  "39572": {
    DMA: 622,
  },
  "39573": {
    DMA: 746,
  },
  "39574": {
    DMA: 746,
  },
  "39576": {
    DMA: 622,
  },
  "39577": {
    DMA: 746,
  },
  "39581": {
    DMA: 746,
  },
  "39595": {
    DMA: 746,
  },
  "39601": {
    DMA: 718,
  },
  "39602": {
    DMA: 718,
  },
  "39603": {
    DMA: 718,
  },
  "39629": {
    DMA: 718,
  },
  "39630": {
    DMA: 718,
  },
  "39631": {
    DMA: 716,
  },
  "39632": {
    DMA: 718,
  },
  "39633": {
    DMA: 716,
  },
  "39635": {
    DMA: 718,
  },
  "39638": {
    DMA: 716,
  },
  "39641": {
    DMA: 718,
  },
  "39643": {
    DMA: 710,
  },
  "39645": {
    DMA: 716,
  },
  "39647": {
    DMA: 718,
  },
  "39648": {
    DMA: 718,
  },
  "39649": {
    DMA: 718,
  },
  "39652": {
    DMA: 718,
  },
  "39653": {
    DMA: 718,
  },
  "39654": {
    DMA: 718,
  },
  "39656": {
    DMA: 718,
  },
  "39657": {
    DMA: 718,
  },
  "39661": {
    DMA: 718,
  },
  "39662": {
    DMA: 718,
  },
  "39663": {
    DMA: 718,
  },
  "39664": {
    DMA: 716,
  },
  "39665": {
    DMA: 718,
  },
  "39666": {
    DMA: 718,
  },
  "39667": {
    DMA: 718,
  },
  "39668": {
    DMA: 718,
  },
  "39669": {
    DMA: 716,
  },
  "39701": {
    DMA: 673,
  },
  "39702": {
    DMA: 673,
  },
  "39703": {
    DMA: 673,
  },
  "39704": {
    DMA: 673,
  },
  "39705": {
    DMA: 673,
  },
  "39710": {
    DMA: 673,
  },
  "39730": {
    DMA: 673,
  },
  "39735": {
    DMA: 673,
  },
  "39736": {
    DMA: 673,
  },
  "39737": {
    DMA: 673,
  },
  "39739": {
    DMA: 673,
  },
  "39740": {
    DMA: 673,
  },
  "39741": {
    DMA: 673,
  },
  "39743": {
    DMA: 673,
  },
  "39744": {
    DMA: 673,
  },
  "39745": {
    DMA: 673,
  },
  "39746": {
    DMA: 673,
  },
  "39747": {
    DMA: 673,
  },
  "39750": {
    DMA: 673,
  },
  "39751": {
    DMA: 673,
  },
  "39752": {
    DMA: 673,
  },
  "39753": {
    DMA: 673,
  },
  "39754": {
    DMA: 673,
  },
  "39755": {
    DMA: 673,
  },
  "39756": {
    DMA: 673,
  },
  "39759": {
    DMA: 673,
  },
  "39760": {
    DMA: 673,
  },
  "39762": {
    DMA: 673,
  },
  "39766": {
    DMA: 673,
  },
  "39767": {
    DMA: 673,
  },
  "39769": {
    DMA: 673,
  },
  "39771": {
    DMA: 673,
  },
  "39772": {
    DMA: 673,
  },
  "39773": {
    DMA: 673,
  },
  "39776": {
    DMA: 673,
  },
  "39813": {
    DMA: 525,
  },
  "39815": {
    DMA: 530,
  },
  "39817": {
    DMA: 530,
  },
  "39818": {
    DMA: 530,
  },
  "39819": {
    DMA: 530,
  },
  "39823": {
    DMA: 606,
  },
  "39824": {
    DMA: 522,
  },
  "39825": {
    DMA: 530,
  },
  "39826": {
    DMA: 525,
  },
  "39827": {
    DMA: 530,
  },
  "39828": {
    DMA: 530,
  },
  "39829": {
    DMA: 530,
  },
  "39832": {
    DMA: 606,
  },
  "39834": {
    DMA: 530,
  },
  "39836": {
    DMA: 522,
  },
  "39837": {
    DMA: 530,
  },
  "39840": {
    DMA: 522,
  },
  "39841": {
    DMA: 606,
  },
  "39842": {
    DMA: 525,
  },
  "39845": {
    DMA: 530,
  },
  "39846": {
    DMA: 525,
  },
  "39851": {
    DMA: 522,
  },
  "39852": {
    DMA: 530,
  },
  "39854": {
    DMA: 522,
  },
  "39859": {
    DMA: 530,
  },
  "39861": {
    DMA: 606,
  },
  "39862": {
    DMA: 525,
  },
  "39866": {
    DMA: 525,
  },
  "39867": {
    DMA: 522,
  },
  "39870": {
    DMA: 525,
  },
  "39877": {
    DMA: 525,
  },
  "39885": {
    DMA: 525,
  },
  "39886": {
    DMA: 522,
  },
  "39897": {
    DMA: 530,
  },
  "39901": {
    DMA: 524,
  },
  "40003": {
    DMA: 529,
  },
  "40004": {
    DMA: 529,
  },
  "40006": {
    DMA: 529,
  },
  "40007": {
    DMA: 529,
  },
  "40008": {
    DMA: 529,
  },
  "40009": {
    DMA: 529,
  },
  "40010": {
    DMA: 529,
  },
  "40011": {
    DMA: 529,
  },
  "40012": {
    DMA: 529,
  },
  "40013": {
    DMA: 529,
  },
  "40014": {
    DMA: 529,
  },
  "40018": {
    DMA: 529,
  },
  "40019": {
    DMA: 529,
  },
  "40020": {
    DMA: 529,
  },
  "40022": {
    DMA: 529,
  },
  "40023": {
    DMA: 529,
  },
  "40025": {
    DMA: 529,
  },
  "40026": {
    DMA: 529,
  },
  "40027": {
    DMA: 529,
  },
  "40031": {
    DMA: 529,
  },
  "40032": {
    DMA: 529,
  },
  "40033": {
    DMA: 529,
  },
  "40036": {
    DMA: 529,
  },
  "40037": {
    DMA: 529,
  },
  "40040": {
    DMA: 529,
  },
  "40041": {
    DMA: 529,
  },
  "40045": {
    DMA: 529,
  },
  "40046": {
    DMA: 529,
  },
  "40047": {
    DMA: 529,
  },
  "40048": {
    DMA: 529,
  },
  "40049": {
    DMA: 529,
  },
  "40050": {
    DMA: 529,
  },
  "40051": {
    DMA: 529,
  },
  "40052": {
    DMA: 529,
  },
  "40055": {
    DMA: 529,
  },
  "40056": {
    DMA: 529,
  },
  "40057": {
    DMA: 529,
  },
  "40058": {
    DMA: 529,
  },
  "40059": {
    DMA: 529,
  },
  "40060": {
    DMA: 529,
  },
  "40061": {
    DMA: 529,
  },
  "40062": {
    DMA: 529,
  },
  "40063": {
    DMA: 529,
  },
  "40065": {
    DMA: 529,
  },
  "40066": {
    DMA: 529,
  },
  "40067": {
    DMA: 529,
  },
  "40068": {
    DMA: 529,
  },
  "40069": {
    DMA: 529,
  },
  "40070": {
    DMA: 529,
  },
  "40071": {
    DMA: 529,
  },
  "40075": {
    DMA: 529,
  },
  "40076": {
    DMA: 529,
  },
  "40077": {
    DMA: 529,
  },
  "40078": {
    DMA: 529,
  },
  "40104": {
    DMA: 529,
  },
  "40107": {
    DMA: 529,
  },
  "40108": {
    DMA: 529,
  },
  "40109": {
    DMA: 529,
  },
  "40110": {
    DMA: 529,
  },
  "40111": {
    DMA: 529,
  },
  "40115": {
    DMA: 529,
  },
  "40117": {
    DMA: 529,
  },
  "40118": {
    DMA: 529,
  },
  "40119": {
    DMA: 529,
  },
  "40121": {
    DMA: 529,
  },
  "40122": {
    DMA: 529,
  },
  "40129": {
    DMA: 529,
  },
  "40140": {
    DMA: 529,
  },
  "40142": {
    DMA: 529,
  },
  "40143": {
    DMA: 529,
  },
  "40144": {
    DMA: 529,
  },
  "40145": {
    DMA: 529,
  },
  "40146": {
    DMA: 529,
  },
  "40150": {
    DMA: 529,
  },
  "40152": {
    DMA: 529,
  },
  "40153": {
    DMA: 529,
  },
  "40155": {
    DMA: 529,
  },
  "40157": {
    DMA: 529,
  },
  "40159": {
    DMA: 529,
  },
  "40160": {
    DMA: 529,
  },
  "40161": {
    DMA: 529,
  },
  "40162": {
    DMA: 529,
  },
  "40165": {
    DMA: 529,
  },
  "40166": {
    DMA: 529,
  },
  "40170": {
    DMA: 529,
  },
  "40171": {
    DMA: 529,
  },
  "40175": {
    DMA: 529,
  },
  "40176": {
    DMA: 529,
  },
  "40177": {
    DMA: 529,
  },
  "40178": {
    DMA: 529,
  },
  "40201": {
    DMA: 529,
  },
  "40202": {
    DMA: 529,
  },
  "40203": {
    DMA: 529,
  },
  "40204": {
    DMA: 529,
  },
  "40205": {
    DMA: 529,
  },
  "40206": {
    DMA: 529,
  },
  "40207": {
    DMA: 529,
  },
  "40208": {
    DMA: 529,
  },
  "40209": {
    DMA: 529,
  },
  "40210": {
    DMA: 529,
  },
  "40211": {
    DMA: 529,
  },
  "40212": {
    DMA: 529,
  },
  "40213": {
    DMA: 529,
  },
  "40214": {
    DMA: 529,
  },
  "40215": {
    DMA: 529,
  },
  "40216": {
    DMA: 529,
  },
  "40217": {
    DMA: 529,
  },
  "40218": {
    DMA: 529,
  },
  "40219": {
    DMA: 529,
  },
  "40220": {
    DMA: 529,
  },
  "40221": {
    DMA: 529,
  },
  "40222": {
    DMA: 529,
  },
  "40223": {
    DMA: 529,
  },
  "40224": {
    DMA: 529,
  },
  "40225": {
    DMA: 529,
  },
  "40228": {
    DMA: 529,
  },
  "40229": {
    DMA: 529,
  },
  "40231": {
    DMA: 529,
  },
  "40232": {
    DMA: 529,
  },
  "40233": {
    DMA: 529,
  },
  "40241": {
    DMA: 529,
  },
  "40242": {
    DMA: 529,
  },
  "40243": {
    DMA: 529,
  },
  "40245": {
    DMA: 529,
  },
  "40250": {
    DMA: 529,
  },
  "40251": {
    DMA: 529,
  },
  "40252": {
    DMA: 529,
  },
  "40253": {
    DMA: 529,
  },
  "40255": {
    DMA: 529,
  },
  "40256": {
    DMA: 529,
  },
  "40257": {
    DMA: 529,
  },
  "40258": {
    DMA: 529,
  },
  "40259": {
    DMA: 529,
  },
  "40261": {
    DMA: 529,
  },
  "40266": {
    DMA: 529,
  },
  "40268": {
    DMA: 529,
  },
  "40269": {
    DMA: 529,
  },
  "40270": {
    DMA: 529,
  },
  "40272": {
    DMA: 529,
  },
  "40280": {
    DMA: 529,
  },
  "40281": {
    DMA: 529,
  },
  "40282": {
    DMA: 529,
  },
  "40283": {
    DMA: 529,
  },
  "40285": {
    DMA: 529,
  },
  "40287": {
    DMA: 529,
  },
  "40289": {
    DMA: 529,
  },
  "40290": {
    DMA: 529,
  },
  "40291": {
    DMA: 529,
  },
  "40292": {
    DMA: 529,
  },
  "40293": {
    DMA: 529,
  },
  "40294": {
    DMA: 529,
  },
  "40295": {
    DMA: 529,
  },
  "40296": {
    DMA: 529,
  },
  "40297": {
    DMA: 529,
  },
  "40298": {
    DMA: 529,
  },
  "40299": {
    DMA: 529,
  },
  "40310": {
    DMA: 541,
  },
  "40311": {
    DMA: 541,
  },
  "40312": {
    DMA: 541,
  },
  "40313": {
    DMA: 541,
  },
  "40316": {
    DMA: 541,
  },
  "40317": {
    DMA: 541,
  },
  "40319": {
    DMA: 541,
  },
  "40322": {
    DMA: 541,
  },
  "40324": {
    DMA: 541,
  },
  "40328": {
    DMA: 529,
  },
  "40330": {
    DMA: 541,
  },
  "40334": {
    DMA: 541,
  },
  "40336": {
    DMA: 541,
  },
  "40337": {
    DMA: 541,
  },
  "40339": {
    DMA: 541,
  },
  "40340": {
    DMA: 541,
  },
  "40342": {
    DMA: 541,
  },
  "40346": {
    DMA: 541,
  },
  "40347": {
    DMA: 541,
  },
  "40348": {
    DMA: 541,
  },
  "40350": {
    DMA: 541,
  },
  "40351": {
    DMA: 541,
  },
  "40353": {
    DMA: 541,
  },
  "40355": {
    DMA: 515,
  },
  "40356": {
    DMA: 541,
  },
  "40357": {
    DMA: 541,
  },
  "40358": {
    DMA: 541,
  },
  "40359": {
    DMA: 515,
  },
  "40360": {
    DMA: 541,
  },
  "40361": {
    DMA: 541,
  },
  "40362": {
    DMA: 541,
  },
  "40363": {
    DMA: 515,
  },
  "40366": {
    DMA: 541,
  },
  "40370": {
    DMA: 541,
  },
  "40371": {
    DMA: 541,
  },
  "40372": {
    DMA: 541,
  },
  "40374": {
    DMA: 541,
  },
  "40376": {
    DMA: 541,
  },
  "40379": {
    DMA: 541,
  },
  "40380": {
    DMA: 541,
  },
  "40383": {
    DMA: 541,
  },
  "40384": {
    DMA: 541,
  },
  "40385": {
    DMA: 541,
  },
  "40386": {
    DMA: 541,
  },
  "40387": {
    DMA: 541,
  },
  "40390": {
    DMA: 541,
  },
  "40391": {
    DMA: 541,
  },
  "40392": {
    DMA: 541,
  },
  "40402": {
    DMA: 541,
  },
  "40403": {
    DMA: 541,
  },
  "40404": {
    DMA: 541,
  },
  "40405": {
    DMA: 541,
  },
  "40409": {
    DMA: 541,
  },
  "40410": {
    DMA: 541,
  },
  "40419": {
    DMA: 541,
  },
  "40422": {
    DMA: 541,
  },
  "40423": {
    DMA: 541,
  },
  "40434": {
    DMA: 541,
  },
  "40437": {
    DMA: 541,
  },
  "40440": {
    DMA: 541,
  },
  "40442": {
    DMA: 541,
  },
  "40444": {
    DMA: 541,
  },
  "40445": {
    DMA: 541,
  },
  "40446": {
    DMA: 541,
  },
  "40447": {
    DMA: 541,
  },
  "40448": {
    DMA: 541,
  },
  "40452": {
    DMA: 541,
  },
  "40456": {
    DMA: 541,
  },
  "40460": {
    DMA: 541,
  },
  "40461": {
    DMA: 541,
  },
  "40464": {
    DMA: 541,
  },
  "40468": {
    DMA: 541,
  },
  "40472": {
    DMA: 541,
  },
  "40473": {
    DMA: 541,
  },
  "40475": {
    DMA: 541,
  },
  "40476": {
    DMA: 541,
  },
  "40481": {
    DMA: 541,
  },
  "40484": {
    DMA: 541,
  },
  "40486": {
    DMA: 541,
  },
  "40488": {
    DMA: 541,
  },
  "40489": {
    DMA: 541,
  },
  "40492": {
    DMA: 541,
  },
  "40495": {
    DMA: 541,
  },
  "40502": {
    DMA: 541,
  },
  "40503": {
    DMA: 541,
  },
  "40504": {
    DMA: 541,
  },
  "40505": {
    DMA: 541,
  },
  "40506": {
    DMA: 541,
  },
  "40507": {
    DMA: 541,
  },
  "40508": {
    DMA: 541,
  },
  "40509": {
    DMA: 541,
  },
  "40510": {
    DMA: 541,
  },
  "40511": {
    DMA: 541,
  },
  "40512": {
    DMA: 541,
  },
  "40513": {
    DMA: 541,
  },
  "40514": {
    DMA: 541,
  },
  "40515": {
    DMA: 541,
  },
  "40516": {
    DMA: 541,
  },
  "40517": {
    DMA: 541,
  },
  "40522": {
    DMA: 541,
  },
  "40523": {
    DMA: 541,
  },
  "40524": {
    DMA: 541,
  },
  "40526": {
    DMA: 541,
  },
  "40533": {
    DMA: 541,
  },
  "40536": {
    DMA: 541,
  },
  "40544": {
    DMA: 541,
  },
  "40546": {
    DMA: 541,
  },
  "40550": {
    DMA: 541,
  },
  "40555": {
    DMA: 541,
  },
  "40574": {
    DMA: 541,
  },
  "40575": {
    DMA: 541,
  },
  "40576": {
    DMA: 541,
  },
  "40577": {
    DMA: 541,
  },
  "40578": {
    DMA: 541,
  },
  "40579": {
    DMA: 541,
  },
  "40580": {
    DMA: 541,
  },
  "40581": {
    DMA: 541,
  },
  "40582": {
    DMA: 541,
  },
  "40583": {
    DMA: 541,
  },
  "40588": {
    DMA: 541,
  },
  "40591": {
    DMA: 541,
  },
  "40598": {
    DMA: 541,
  },
  "40601": {
    DMA: 541,
  },
  "40602": {
    DMA: 541,
  },
  "40603": {
    DMA: 541,
  },
  "40604": {
    DMA: 541,
  },
  "40618": {
    DMA: 541,
  },
  "40619": {
    DMA: 541,
  },
  "40620": {
    DMA: 541,
  },
  "40621": {
    DMA: 541,
  },
  "40622": {
    DMA: 541,
  },
  "40701": {
    DMA: 541,
  },
  "40702": {
    DMA: 541,
  },
  "40724": {
    DMA: 541,
  },
  "40729": {
    DMA: 541,
  },
  "40730": {
    DMA: 541,
  },
  "40734": {
    DMA: 541,
  },
  "40737": {
    DMA: 541,
  },
  "40740": {
    DMA: 541,
  },
  "40741": {
    DMA: 541,
  },
  "40742": {
    DMA: 541,
  },
  "40743": {
    DMA: 541,
  },
  "40744": {
    DMA: 541,
  },
  "40745": {
    DMA: 541,
  },
  "40750": {
    DMA: 541,
  },
  "40754": {
    DMA: 557,
  },
  "40755": {
    DMA: 541,
  },
  "40759": {
    DMA: 541,
  },
  "40763": {
    DMA: 541,
  },
  "40769": {
    DMA: 541,
  },
  "40771": {
    DMA: 541,
  },
  "40801": {
    DMA: 557,
  },
  "40803": {
    DMA: 531,
  },
  "40806": {
    DMA: 557,
  },
  "40807": {
    DMA: 557,
  },
  "40808": {
    DMA: 557,
  },
  "40810": {
    DMA: 557,
  },
  "40813": {
    DMA: 557,
  },
  "40815": {
    DMA: 557,
  },
  "40816": {
    DMA: 531,
  },
  "40818": {
    DMA: 557,
  },
  "40819": {
    DMA: 557,
  },
  "40820": {
    DMA: 557,
  },
  "40823": {
    DMA: 557,
  },
  "40824": {
    DMA: 557,
  },
  "40826": {
    DMA: 531,
  },
  "40827": {
    DMA: 531,
  },
  "40828": {
    DMA: 557,
  },
  "40829": {
    DMA: 557,
  },
  "40830": {
    DMA: 557,
  },
  "40831": {
    DMA: 557,
  },
  "40840": {
    DMA: 531,
  },
  "40843": {
    DMA: 557,
  },
  "40844": {
    DMA: 531,
  },
  "40845": {
    DMA: 557,
  },
  "40847": {
    DMA: 557,
  },
  "40849": {
    DMA: 557,
  },
  "40854": {
    DMA: 557,
  },
  "40855": {
    DMA: 557,
  },
  "40856": {
    DMA: 557,
  },
  "40858": {
    DMA: 531,
  },
  "40862": {
    DMA: 531,
  },
  "40863": {
    DMA: 557,
  },
  "40865": {
    DMA: 557,
  },
  "40868": {
    DMA: 531,
  },
  "40870": {
    DMA: 557,
  },
  "40873": {
    DMA: 557,
  },
  "40874": {
    DMA: 531,
  },
  "40902": {
    DMA: 557,
  },
  "40903": {
    DMA: 541,
  },
  "40906": {
    DMA: 541,
  },
  "40913": {
    DMA: 557,
  },
  "40914": {
    DMA: 541,
  },
  "40915": {
    DMA: 541,
  },
  "40921": {
    DMA: 541,
  },
  "40923": {
    DMA: 541,
  },
  "40927": {
    DMA: 557,
  },
  "40930": {
    DMA: 541,
  },
  "40931": {
    DMA: 541,
  },
  "40932": {
    DMA: 541,
  },
  "40935": {
    DMA: 541,
  },
  "40939": {
    DMA: 557,
  },
  "40940": {
    DMA: 557,
  },
  "40941": {
    DMA: 541,
  },
  "40943": {
    DMA: 541,
  },
  "40944": {
    DMA: 541,
  },
  "40946": {
    DMA: 541,
  },
  "40949": {
    DMA: 541,
  },
  "40951": {
    DMA: 541,
  },
  "40953": {
    DMA: 541,
  },
  "40955": {
    DMA: 557,
  },
  "40958": {
    DMA: 557,
  },
  "40962": {
    DMA: 541,
  },
  "40964": {
    DMA: 557,
  },
  "40965": {
    DMA: 557,
  },
  "40972": {
    DMA: 541,
  },
  "40977": {
    DMA: 557,
  },
  "40979": {
    DMA: 531,
  },
  "40981": {
    DMA: 541,
  },
  "40982": {
    DMA: 541,
  },
  "40983": {
    DMA: 541,
  },
  "40988": {
    DMA: 557,
  },
  "40995": {
    DMA: 541,
  },
  "40997": {
    DMA: 541,
  },
  "40999": {
    DMA: 541,
  },
  "41001": {
    DMA: 515,
  },
  "41002": {
    DMA: 515,
  },
  "41003": {
    DMA: 541,
  },
  "41004": {
    DMA: 515,
  },
  "41005": {
    DMA: 515,
  },
  "41006": {
    DMA: 515,
  },
  "41007": {
    DMA: 515,
  },
  "41008": {
    DMA: 529,
  },
  "41010": {
    DMA: 515,
  },
  "41011": {
    DMA: 515,
  },
  "41012": {
    DMA: 515,
  },
  "41014": {
    DMA: 515,
  },
  "41015": {
    DMA: 515,
  },
  "41016": {
    DMA: 515,
  },
  "41017": {
    DMA: 515,
  },
  "41018": {
    DMA: 515,
  },
  "41019": {
    DMA: 515,
  },
  "41021": {
    DMA: 515,
  },
  "41022": {
    DMA: 515,
  },
  "41025": {
    DMA: 515,
  },
  "41030": {
    DMA: 515,
  },
  "41031": {
    DMA: 541,
  },
  "41033": {
    DMA: 515,
  },
  "41034": {
    DMA: 515,
  },
  "41035": {
    DMA: 515,
  },
  "41037": {
    DMA: 541,
  },
  "41039": {
    DMA: 541,
  },
  "41040": {
    DMA: 515,
  },
  "41041": {
    DMA: 541,
  },
  "41042": {
    DMA: 515,
  },
  "41043": {
    DMA: 515,
  },
  "41044": {
    DMA: 515,
  },
  "41045": {
    DMA: 529,
  },
  "41046": {
    DMA: 515,
  },
  "41048": {
    DMA: 515,
  },
  "41049": {
    DMA: 541,
  },
  "41051": {
    DMA: 515,
  },
  "41052": {
    DMA: 515,
  },
  "41053": {
    DMA: 515,
  },
  "41054": {
    DMA: 515,
  },
  "41055": {
    DMA: 515,
  },
  "41056": {
    DMA: 515,
  },
  "41059": {
    DMA: 515,
  },
  "41061": {
    DMA: 515,
  },
  "41062": {
    DMA: 515,
  },
  "41063": {
    DMA: 515,
  },
  "41064": {
    DMA: 515,
  },
  "41065": {
    DMA: 541,
  },
  "41071": {
    DMA: 515,
  },
  "41072": {
    DMA: 515,
  },
  "41073": {
    DMA: 515,
  },
  "41074": {
    DMA: 515,
  },
  "41075": {
    DMA: 515,
  },
  "41076": {
    DMA: 515,
  },
  "41080": {
    DMA: 515,
  },
  "41081": {
    DMA: 541,
  },
  "41083": {
    DMA: 529,
  },
  "41085": {
    DMA: 515,
  },
  "41086": {
    DMA: 515,
  },
  "41091": {
    DMA: 515,
  },
  "41092": {
    DMA: 515,
  },
  "41093": {
    DMA: 541,
  },
  "41094": {
    DMA: 515,
  },
  "41095": {
    DMA: 515,
  },
  "41096": {
    DMA: 515,
  },
  "41097": {
    DMA: 515,
  },
  "41098": {
    DMA: 529,
  },
  "41099": {
    DMA: 515,
  },
  "41101": {
    DMA: 564,
  },
  "41102": {
    DMA: 564,
  },
  "41105": {
    DMA: 564,
  },
  "41114": {
    DMA: 564,
  },
  "41121": {
    DMA: 564,
  },
  "41124": {
    DMA: 564,
  },
  "41128": {
    DMA: 564,
  },
  "41129": {
    DMA: 564,
  },
  "41132": {
    DMA: 564,
  },
  "41135": {
    DMA: 564,
  },
  "41139": {
    DMA: 564,
  },
  "41141": {
    DMA: 564,
  },
  "41142": {
    DMA: 564,
  },
  "41143": {
    DMA: 564,
  },
  "41144": {
    DMA: 564,
  },
  "41146": {
    DMA: 564,
  },
  "41149": {
    DMA: 564,
  },
  "41159": {
    DMA: 564,
  },
  "41160": {
    DMA: 564,
  },
  "41164": {
    DMA: 564,
  },
  "41166": {
    DMA: 564,
  },
  "41168": {
    DMA: 564,
  },
  "41169": {
    DMA: 564,
  },
  "41171": {
    DMA: 564,
  },
  "41173": {
    DMA: 564,
  },
  "41174": {
    DMA: 564,
  },
  "41175": {
    DMA: 564,
  },
  "41179": {
    DMA: 564,
  },
  "41180": {
    DMA: 564,
  },
  "41181": {
    DMA: 564,
  },
  "41183": {
    DMA: 564,
  },
  "41189": {
    DMA: 564,
  },
  "41201": {
    DMA: 564,
  },
  "41203": {
    DMA: 564,
  },
  "41204": {
    DMA: 564,
  },
  "41214": {
    DMA: 564,
  },
  "41216": {
    DMA: 564,
  },
  "41219": {
    DMA: 564,
  },
  "41222": {
    DMA: 564,
  },
  "41224": {
    DMA: 564,
  },
  "41226": {
    DMA: 564,
  },
  "41230": {
    DMA: 564,
  },
  "41231": {
    DMA: 564,
  },
  "41232": {
    DMA: 564,
  },
  "41234": {
    DMA: 564,
  },
  "41238": {
    DMA: 564,
  },
  "41240": {
    DMA: 564,
  },
  "41250": {
    DMA: 564,
  },
  "41254": {
    DMA: 564,
  },
  "41255": {
    DMA: 564,
  },
  "41256": {
    DMA: 564,
  },
  "41257": {
    DMA: 564,
  },
  "41260": {
    DMA: 564,
  },
  "41262": {
    DMA: 564,
  },
  "41263": {
    DMA: 564,
  },
  "41264": {
    DMA: 564,
  },
  "41265": {
    DMA: 564,
  },
  "41267": {
    DMA: 564,
  },
  "41268": {
    DMA: 564,
  },
  "41271": {
    DMA: 564,
  },
  "41274": {
    DMA: 564,
  },
  "41301": {
    DMA: 541,
  },
  "41307": {
    DMA: 541,
  },
  "41310": {
    DMA: 541,
  },
  "41311": {
    DMA: 541,
  },
  "41313": {
    DMA: 541,
  },
  "41314": {
    DMA: 541,
  },
  "41317": {
    DMA: 541,
  },
  "41332": {
    DMA: 541,
  },
  "41333": {
    DMA: 541,
  },
  "41338": {
    DMA: 541,
  },
  "41339": {
    DMA: 541,
  },
  "41347": {
    DMA: 541,
  },
  "41348": {
    DMA: 541,
  },
  "41351": {
    DMA: 541,
  },
  "41352": {
    DMA: 541,
  },
  "41360": {
    DMA: 541,
  },
  "41362": {
    DMA: 541,
  },
  "41364": {
    DMA: 541,
  },
  "41365": {
    DMA: 541,
  },
  "41366": {
    DMA: 541,
  },
  "41367": {
    DMA: 541,
  },
  "41368": {
    DMA: 541,
  },
  "41385": {
    DMA: 541,
  },
  "41386": {
    DMA: 541,
  },
  "41390": {
    DMA: 541,
  },
  "41397": {
    DMA: 541,
  },
  "41408": {
    DMA: 541,
  },
  "41413": {
    DMA: 541,
  },
  "41421": {
    DMA: 541,
  },
  "41425": {
    DMA: 541,
  },
  "41426": {
    DMA: 541,
  },
  "41433": {
    DMA: 541,
  },
  "41451": {
    DMA: 541,
  },
  "41459": {
    DMA: 541,
  },
  "41464": {
    DMA: 541,
  },
  "41465": {
    DMA: 541,
  },
  "41472": {
    DMA: 541,
  },
  "41477": {
    DMA: 541,
  },
  "41501": {
    DMA: 564,
  },
  "41502": {
    DMA: 564,
  },
  "41503": {
    DMA: 564,
  },
  "41512": {
    DMA: 564,
  },
  "41513": {
    DMA: 564,
  },
  "41514": {
    DMA: 564,
  },
  "41517": {
    DMA: 531,
  },
  "41519": {
    DMA: 564,
  },
  "41520": {
    DMA: 564,
  },
  "41522": {
    DMA: 564,
  },
  "41524": {
    DMA: 564,
  },
  "41526": {
    DMA: 564,
  },
  "41527": {
    DMA: 564,
  },
  "41528": {
    DMA: 564,
  },
  "41531": {
    DMA: 564,
  },
  "41534": {
    DMA: 564,
  },
  "41535": {
    DMA: 564,
  },
  "41537": {
    DMA: 531,
  },
  "41538": {
    DMA: 564,
  },
  "41539": {
    DMA: 564,
  },
  "41540": {
    DMA: 564,
  },
  "41542": {
    DMA: 564,
  },
  "41543": {
    DMA: 564,
  },
  "41544": {
    DMA: 564,
  },
  "41547": {
    DMA: 564,
  },
  "41548": {
    DMA: 564,
  },
  "41549": {
    DMA: 564,
  },
  "41553": {
    DMA: 564,
  },
  "41554": {
    DMA: 564,
  },
  "41555": {
    DMA: 564,
  },
  "41557": {
    DMA: 564,
  },
  "41558": {
    DMA: 564,
  },
  "41559": {
    DMA: 564,
  },
  "41560": {
    DMA: 564,
  },
  "41561": {
    DMA: 564,
  },
  "41562": {
    DMA: 564,
  },
  "41563": {
    DMA: 564,
  },
  "41564": {
    DMA: 564,
  },
  "41566": {
    DMA: 564,
  },
  "41567": {
    DMA: 564,
  },
  "41568": {
    DMA: 564,
  },
  "41571": {
    DMA: 564,
  },
  "41572": {
    DMA: 564,
  },
  "41601": {
    DMA: 564,
  },
  "41602": {
    DMA: 564,
  },
  "41603": {
    DMA: 564,
  },
  "41604": {
    DMA: 564,
  },
  "41605": {
    DMA: 564,
  },
  "41606": {
    DMA: 564,
  },
  "41607": {
    DMA: 564,
  },
  "41612": {
    DMA: 564,
  },
  "41615": {
    DMA: 564,
  },
  "41616": {
    DMA: 564,
  },
  "41619": {
    DMA: 564,
  },
  "41621": {
    DMA: 564,
  },
  "41622": {
    DMA: 564,
  },
  "41630": {
    DMA: 564,
  },
  "41631": {
    DMA: 564,
  },
  "41632": {
    DMA: 541,
  },
  "41635": {
    DMA: 564,
  },
  "41636": {
    DMA: 564,
  },
  "41640": {
    DMA: 564,
  },
  "41642": {
    DMA: 564,
  },
  "41643": {
    DMA: 564,
  },
  "41645": {
    DMA: 564,
  },
  "41647": {
    DMA: 564,
  },
  "41649": {
    DMA: 564,
  },
  "41650": {
    DMA: 564,
  },
  "41651": {
    DMA: 564,
  },
  "41653": {
    DMA: 564,
  },
  "41655": {
    DMA: 564,
  },
  "41659": {
    DMA: 564,
  },
  "41660": {
    DMA: 564,
  },
  "41663": {
    DMA: 564,
  },
  "41666": {
    DMA: 564,
  },
  "41667": {
    DMA: 564,
  },
  "41669": {
    DMA: 564,
  },
  "41701": {
    DMA: 541,
  },
  "41702": {
    DMA: 541,
  },
  "41712": {
    DMA: 541,
  },
  "41713": {
    DMA: 541,
  },
  "41714": {
    DMA: 531,
  },
  "41719": {
    DMA: 541,
  },
  "41721": {
    DMA: 541,
  },
  "41722": {
    DMA: 541,
  },
  "41723": {
    DMA: 541,
  },
  "41725": {
    DMA: 541,
  },
  "41727": {
    DMA: 541,
  },
  "41729": {
    DMA: 541,
  },
  "41731": {
    DMA: 541,
  },
  "41735": {
    DMA: 541,
  },
  "41736": {
    DMA: 541,
  },
  "41739": {
    DMA: 541,
  },
  "41740": {
    DMA: 541,
  },
  "41743": {
    DMA: 541,
  },
  "41745": {
    DMA: 541,
  },
  "41746": {
    DMA: 541,
  },
  "41747": {
    DMA: 541,
  },
  "41749": {
    DMA: 531,
  },
  "41751": {
    DMA: 541,
  },
  "41754": {
    DMA: 541,
  },
  "41759": {
    DMA: 541,
  },
  "41760": {
    DMA: 541,
  },
  "41762": {
    DMA: 531,
  },
  "41763": {
    DMA: 541,
  },
  "41764": {
    DMA: 531,
  },
  "41766": {
    DMA: 531,
  },
  "41772": {
    DMA: 541,
  },
  "41773": {
    DMA: 541,
  },
  "41774": {
    DMA: 541,
  },
  "41775": {
    DMA: 531,
  },
  "41776": {
    DMA: 531,
  },
  "41777": {
    DMA: 531,
  },
  "41778": {
    DMA: 541,
  },
  "41804": {
    DMA: 531,
  },
  "41810": {
    DMA: 531,
  },
  "41812": {
    DMA: 531,
  },
  "41815": {
    DMA: 531,
  },
  "41817": {
    DMA: 541,
  },
  "41819": {
    DMA: 531,
  },
  "41821": {
    DMA: 531,
  },
  "41822": {
    DMA: 541,
  },
  "41824": {
    DMA: 531,
  },
  "41825": {
    DMA: 531,
  },
  "41826": {
    DMA: 531,
  },
  "41828": {
    DMA: 541,
  },
  "41831": {
    DMA: 541,
  },
  "41832": {
    DMA: 531,
  },
  "41833": {
    DMA: 531,
  },
  "41834": {
    DMA: 541,
  },
  "41835": {
    DMA: 531,
  },
  "41836": {
    DMA: 541,
  },
  "41837": {
    DMA: 531,
  },
  "41838": {
    DMA: 531,
  },
  "41839": {
    DMA: 541,
  },
  "41840": {
    DMA: 531,
  },
  "41843": {
    DMA: 541,
  },
  "41844": {
    DMA: 541,
  },
  "41845": {
    DMA: 531,
  },
  "41847": {
    DMA: 541,
  },
  "41848": {
    DMA: 531,
  },
  "41849": {
    DMA: 531,
  },
  "41855": {
    DMA: 531,
  },
  "41858": {
    DMA: 531,
  },
  "41859": {
    DMA: 541,
  },
  "41861": {
    DMA: 541,
  },
  "41862": {
    DMA: 541,
  },
  "42001": {
    DMA: 632,
  },
  "42002": {
    DMA: 632,
  },
  "42003": {
    DMA: 632,
  },
  "42020": {
    DMA: 632,
  },
  "42021": {
    DMA: 632,
  },
  "42022": {
    DMA: 632,
  },
  "42023": {
    DMA: 632,
  },
  "42024": {
    DMA: 632,
  },
  "42025": {
    DMA: 632,
  },
  "42027": {
    DMA: 632,
  },
  "42028": {
    DMA: 632,
  },
  "42029": {
    DMA: 632,
  },
  "42031": {
    DMA: 632,
  },
  "42032": {
    DMA: 632,
  },
  "42033": {
    DMA: 632,
  },
  "42035": {
    DMA: 632,
  },
  "42036": {
    DMA: 632,
  },
  "42037": {
    DMA: 632,
  },
  "42038": {
    DMA: 632,
  },
  "42039": {
    DMA: 632,
  },
  "42040": {
    DMA: 632,
  },
  "42041": {
    DMA: 632,
  },
  "42044": {
    DMA: 632,
  },
  "42045": {
    DMA: 632,
  },
  "42047": {
    DMA: 632,
  },
  "42048": {
    DMA: 632,
  },
  "42049": {
    DMA: 632,
  },
  "42050": {
    DMA: 632,
  },
  "42051": {
    DMA: 632,
  },
  "42053": {
    DMA: 632,
  },
  "42054": {
    DMA: 632,
  },
  "42055": {
    DMA: 632,
  },
  "42056": {
    DMA: 632,
  },
  "42058": {
    DMA: 632,
  },
  "42060": {
    DMA: 632,
  },
  "42061": {
    DMA: 632,
  },
  "42063": {
    DMA: 632,
  },
  "42064": {
    DMA: 632,
  },
  "42066": {
    DMA: 632,
  },
  "42069": {
    DMA: 632,
  },
  "42070": {
    DMA: 632,
  },
  "42071": {
    DMA: 632,
  },
  "42076": {
    DMA: 632,
  },
  "42078": {
    DMA: 632,
  },
  "42079": {
    DMA: 632,
  },
  "42081": {
    DMA: 632,
  },
  "42082": {
    DMA: 632,
  },
  "42083": {
    DMA: 632,
  },
  "42084": {
    DMA: 632,
  },
  "42085": {
    DMA: 632,
  },
  "42086": {
    DMA: 632,
  },
  "42087": {
    DMA: 632,
  },
  "42088": {
    DMA: 632,
  },
  "42101": {
    DMA: 736,
  },
  "42102": {
    DMA: 736,
  },
  "42103": {
    DMA: 736,
  },
  "42104": {
    DMA: 736,
  },
  "42120": {
    DMA: 659,
  },
  "42122": {
    DMA: 736,
  },
  "42123": {
    DMA: 736,
  },
  "42124": {
    DMA: 736,
  },
  "42127": {
    DMA: 736,
  },
  "42128": {
    DMA: 736,
  },
  "42129": {
    DMA: 736,
  },
  "42130": {
    DMA: 736,
  },
  "42131": {
    DMA: 736,
  },
  "42133": {
    DMA: 659,
  },
  "42134": {
    DMA: 659,
  },
  "42135": {
    DMA: 659,
  },
  "42140": {
    DMA: 659,
  },
  "42141": {
    DMA: 736,
  },
  "42142": {
    DMA: 736,
  },
  "42151": {
    DMA: 659,
  },
  "42152": {
    DMA: 736,
  },
  "42153": {
    DMA: 659,
  },
  "42154": {
    DMA: 736,
  },
  "42156": {
    DMA: 736,
  },
  "42157": {
    DMA: 659,
  },
  "42159": {
    DMA: 736,
  },
  "42160": {
    DMA: 736,
  },
  "42163": {
    DMA: 736,
  },
  "42164": {
    DMA: 659,
  },
  "42166": {
    DMA: 736,
  },
  "42167": {
    DMA: 659,
  },
  "42170": {
    DMA: 736,
  },
  "42171": {
    DMA: 736,
  },
  "42201": {
    DMA: 736,
  },
  "42202": {
    DMA: 659,
  },
  "42204": {
    DMA: 659,
  },
  "42206": {
    DMA: 659,
  },
  "42207": {
    DMA: 736,
  },
  "42210": {
    DMA: 736,
  },
  "42211": {
    DMA: 659,
  },
  "42214": {
    DMA: 736,
  },
  "42215": {
    DMA: 659,
  },
  "42216": {
    DMA: 659,
  },
  "42217": {
    DMA: 659,
  },
  "42219": {
    DMA: 736,
  },
  "42220": {
    DMA: 659,
  },
  "42221": {
    DMA: 659,
  },
  "42223": {
    DMA: 659,
  },
  "42232": {
    DMA: 659,
  },
  "42234": {
    DMA: 659,
  },
  "42236": {
    DMA: 659,
  },
  "42240": {
    DMA: 659,
  },
  "42241": {
    DMA: 659,
  },
  "42252": {
    DMA: 736,
  },
  "42254": {
    DMA: 659,
  },
  "42256": {
    DMA: 659,
  },
  "42259": {
    DMA: 736,
  },
  "42261": {
    DMA: 736,
  },
  "42262": {
    DMA: 659,
  },
  "42265": {
    DMA: 659,
  },
  "42266": {
    DMA: 659,
  },
  "42273": {
    DMA: 736,
  },
  "42274": {
    DMA: 736,
  },
  "42275": {
    DMA: 736,
  },
  "42276": {
    DMA: 659,
  },
  "42280": {
    DMA: 659,
  },
  "42283": {
    DMA: 659,
  },
  "42285": {
    DMA: 736,
  },
  "42286": {
    DMA: 659,
  },
  "42287": {
    DMA: 736,
  },
  "42288": {
    DMA: 736,
  },
  "42301": {
    DMA: 649,
  },
  "42302": {
    DMA: 649,
  },
  "42303": {
    DMA: 649,
  },
  "42304": {
    DMA: 649,
  },
  "42320": {
    DMA: 649,
  },
  "42321": {
    DMA: 649,
  },
  "42322": {
    DMA: 649,
  },
  "42323": {
    DMA: 649,
  },
  "42324": {
    DMA: 649,
  },
  "42325": {
    DMA: 649,
  },
  "42326": {
    DMA: 649,
  },
  "42327": {
    DMA: 649,
  },
  "42328": {
    DMA: 649,
  },
  "42330": {
    DMA: 649,
  },
  "42332": {
    DMA: 649,
  },
  "42333": {
    DMA: 649,
  },
  "42334": {
    DMA: 649,
  },
  "42337": {
    DMA: 649,
  },
  "42338": {
    DMA: 649,
  },
  "42339": {
    DMA: 649,
  },
  "42343": {
    DMA: 649,
  },
  "42344": {
    DMA: 649,
  },
  "42345": {
    DMA: 649,
  },
  "42347": {
    DMA: 649,
  },
  "42348": {
    DMA: 649,
  },
  "42349": {
    DMA: 649,
  },
  "42350": {
    DMA: 649,
  },
  "42351": {
    DMA: 649,
  },
  "42352": {
    DMA: 649,
  },
  "42354": {
    DMA: 649,
  },
  "42355": {
    DMA: 649,
  },
  "42356": {
    DMA: 649,
  },
  "42361": {
    DMA: 649,
  },
  "42364": {
    DMA: 649,
  },
  "42366": {
    DMA: 649,
  },
  "42367": {
    DMA: 649,
  },
  "42368": {
    DMA: 649,
  },
  "42369": {
    DMA: 649,
  },
  "42370": {
    DMA: 649,
  },
  "42371": {
    DMA: 649,
  },
  "42372": {
    DMA: 649,
  },
  "42374": {
    DMA: 649,
  },
  "42375": {
    DMA: 649,
  },
  "42376": {
    DMA: 649,
  },
  "42377": {
    DMA: 649,
  },
  "42378": {
    DMA: 649,
  },
  "42402": {
    DMA: 649,
  },
  "42403": {
    DMA: 649,
  },
  "42404": {
    DMA: 649,
  },
  "42406": {
    DMA: 649,
  },
  "42408": {
    DMA: 649,
  },
  "42409": {
    DMA: 649,
  },
  "42410": {
    DMA: 649,
  },
  "42411": {
    DMA: 632,
  },
  "42413": {
    DMA: 649,
  },
  "42419": {
    DMA: 649,
  },
  "42420": {
    DMA: 649,
  },
  "42431": {
    DMA: 649,
  },
  "42436": {
    DMA: 649,
  },
  "42437": {
    DMA: 649,
  },
  "42440": {
    DMA: 649,
  },
  "42441": {
    DMA: 649,
  },
  "42442": {
    DMA: 649,
  },
  "42444": {
    DMA: 649,
  },
  "42445": {
    DMA: 632,
  },
  "42450": {
    DMA: 649,
  },
  "42451": {
    DMA: 649,
  },
  "42452": {
    DMA: 649,
  },
  "42453": {
    DMA: 649,
  },
  "42455": {
    DMA: 649,
  },
  "42456": {
    DMA: 649,
  },
  "42457": {
    DMA: 649,
  },
  "42458": {
    DMA: 649,
  },
  "42459": {
    DMA: 649,
  },
  "42460": {
    DMA: 649,
  },
  "42461": {
    DMA: 649,
  },
  "42462": {
    DMA: 649,
  },
  "42463": {
    DMA: 649,
  },
  "42464": {
    DMA: 649,
  },
  "42501": {
    DMA: 541,
  },
  "42502": {
    DMA: 541,
  },
  "42503": {
    DMA: 541,
  },
  "42516": {
    DMA: 541,
  },
  "42518": {
    DMA: 541,
  },
  "42519": {
    DMA: 541,
  },
  "42528": {
    DMA: 541,
  },
  "42533": {
    DMA: 541,
  },
  "42539": {
    DMA: 541,
  },
  "42541": {
    DMA: 541,
  },
  "42544": {
    DMA: 541,
  },
  "42553": {
    DMA: 541,
  },
  "42558": {
    DMA: 541,
  },
  "42564": {
    DMA: 541,
  },
  "42565": {
    DMA: 541,
  },
  "42566": {
    DMA: 541,
  },
  "42567": {
    DMA: 541,
  },
  "42602": {
    DMA: 659,
  },
  "42603": {
    DMA: 659,
  },
  "42629": {
    DMA: 541,
  },
  "42631": {
    DMA: 557,
  },
  "42633": {
    DMA: 541,
  },
  "42634": {
    DMA: 557,
  },
  "42635": {
    DMA: 557,
  },
  "42638": {
    DMA: 557,
  },
  "42642": {
    DMA: 541,
  },
  "42647": {
    DMA: 557,
  },
  "42649": {
    DMA: 557,
  },
  "42653": {
    DMA: 557,
  },
  "42701": {
    DMA: 529,
  },
  "42702": {
    DMA: 529,
  },
  "42712": {
    DMA: 529,
  },
  "42713": {
    DMA: 736,
  },
  "42715": {
    DMA: 529,
  },
  "42716": {
    DMA: 529,
  },
  "42717": {
    DMA: 659,
  },
  "42718": {
    DMA: 529,
  },
  "42719": {
    DMA: 529,
  },
  "42720": {
    DMA: 529,
  },
  "42721": {
    DMA: 529,
  },
  "42722": {
    DMA: 736,
  },
  "42724": {
    DMA: 529,
  },
  "42726": {
    DMA: 529,
  },
  "42728": {
    DMA: 529,
  },
  "42729": {
    DMA: 736,
  },
  "42731": {
    DMA: 659,
  },
  "42732": {
    DMA: 529,
  },
  "42733": {
    DMA: 529,
  },
  "42740": {
    DMA: 529,
  },
  "42741": {
    DMA: 529,
  },
  "42742": {
    DMA: 529,
  },
  "42743": {
    DMA: 529,
  },
  "42746": {
    DMA: 736,
  },
  "42748": {
    DMA: 529,
  },
  "42749": {
    DMA: 736,
  },
  "42753": {
    DMA: 529,
  },
  "42754": {
    DMA: 529,
  },
  "42755": {
    DMA: 529,
  },
  "42757": {
    DMA: 529,
  },
  "42758": {
    DMA: 529,
  },
  "42759": {
    DMA: 659,
  },
  "42762": {
    DMA: 529,
  },
  "42764": {
    DMA: 529,
  },
  "42765": {
    DMA: 736,
  },
  "42776": {
    DMA: 529,
  },
  "42782": {
    DMA: 529,
  },
  "42784": {
    DMA: 529,
  },
  "42788": {
    DMA: 529,
  },
  "43001": {
    DMA: 535,
  },
  "43002": {
    DMA: 535,
  },
  "43003": {
    DMA: 535,
  },
  "43004": {
    DMA: 535,
  },
  "43005": {
    DMA: 535,
  },
  "43006": {
    DMA: 535,
  },
  "43007": {
    DMA: 535,
  },
  "43008": {
    DMA: 535,
  },
  "43009": {
    DMA: 542,
  },
  "43010": {
    DMA: 542,
  },
  "43011": {
    DMA: 535,
  },
  "43013": {
    DMA: 535,
  },
  "43014": {
    DMA: 535,
  },
  "43015": {
    DMA: 535,
  },
  "43016": {
    DMA: 535,
  },
  "43017": {
    DMA: 535,
  },
  "43018": {
    DMA: 535,
  },
  "43019": {
    DMA: 535,
  },
  "43021": {
    DMA: 535,
  },
  "43022": {
    DMA: 535,
  },
  "43023": {
    DMA: 535,
  },
  "43025": {
    DMA: 535,
  },
  "43026": {
    DMA: 535,
  },
  "43027": {
    DMA: 535,
  },
  "43028": {
    DMA: 535,
  },
  "43029": {
    DMA: 535,
  },
  "43030": {
    DMA: 535,
  },
  "43031": {
    DMA: 535,
  },
  "43032": {
    DMA: 535,
  },
  "43033": {
    DMA: 535,
  },
  "43035": {
    DMA: 535,
  },
  "43036": {
    DMA: 535,
  },
  "43037": {
    DMA: 535,
  },
  "43040": {
    DMA: 535,
  },
  "43041": {
    DMA: 535,
  },
  "43044": {
    DMA: 542,
  },
  "43045": {
    DMA: 535,
  },
  "43046": {
    DMA: 535,
  },
  "43047": {
    DMA: 542,
  },
  "43048": {
    DMA: 535,
  },
  "43050": {
    DMA: 535,
  },
  "43054": {
    DMA: 535,
  },
  "43055": {
    DMA: 535,
  },
  "43056": {
    DMA: 535,
  },
  "43058": {
    DMA: 535,
  },
  "43060": {
    DMA: 542,
  },
  "43061": {
    DMA: 535,
  },
  "43062": {
    DMA: 535,
  },
  "43064": {
    DMA: 535,
  },
  "43065": {
    DMA: 535,
  },
  "43066": {
    DMA: 535,
  },
  "43067": {
    DMA: 535,
  },
  "43068": {
    DMA: 535,
  },
  "43069": {
    DMA: 535,
  },
  "43070": {
    DMA: 542,
  },
  "43071": {
    DMA: 535,
  },
  "43072": {
    DMA: 542,
  },
  "43073": {
    DMA: 535,
  },
  "43074": {
    DMA: 535,
  },
  "43076": {
    DMA: 535,
  },
  "43077": {
    DMA: 535,
  },
  "43078": {
    DMA: 542,
  },
  "43080": {
    DMA: 535,
  },
  "43081": {
    DMA: 535,
  },
  "43082": {
    DMA: 535,
  },
  "43083": {
    DMA: 542,
  },
  "43084": {
    DMA: 542,
  },
  "43085": {
    DMA: 535,
  },
  "43086": {
    DMA: 535,
  },
  "43093": {
    DMA: 535,
  },
  "43098": {
    DMA: 535,
  },
  "43101": {
    DMA: 535,
  },
  "43102": {
    DMA: 535,
  },
  "43103": {
    DMA: 535,
  },
  "43105": {
    DMA: 535,
  },
  "43106": {
    DMA: 535,
  },
  "43107": {
    DMA: 535,
  },
  "43109": {
    DMA: 535,
  },
  "43110": {
    DMA: 535,
  },
  "43111": {
    DMA: 535,
  },
  "43112": {
    DMA: 535,
  },
  "43113": {
    DMA: 535,
  },
  "43115": {
    DMA: 535,
  },
  "43116": {
    DMA: 535,
  },
  "43117": {
    DMA: 535,
  },
  "43119": {
    DMA: 535,
  },
  "43123": {
    DMA: 535,
  },
  "43125": {
    DMA: 535,
  },
  "43126": {
    DMA: 535,
  },
  "43127": {
    DMA: 535,
  },
  "43128": {
    DMA: 535,
  },
  "43130": {
    DMA: 535,
  },
  "43135": {
    DMA: 535,
  },
  "43136": {
    DMA: 535,
  },
  "43137": {
    DMA: 535,
  },
  "43138": {
    DMA: 535,
  },
  "43140": {
    DMA: 535,
  },
  "43142": {
    DMA: 535,
  },
  "43143": {
    DMA: 535,
  },
  "43144": {
    DMA: 535,
  },
  "43145": {
    DMA: 535,
  },
  "43146": {
    DMA: 535,
  },
  "43147": {
    DMA: 535,
  },
  "43148": {
    DMA: 535,
  },
  "43149": {
    DMA: 535,
  },
  "43150": {
    DMA: 535,
  },
  "43151": {
    DMA: 535,
  },
  "43152": {
    DMA: 535,
  },
  "43153": {
    DMA: 535,
  },
  "43154": {
    DMA: 535,
  },
  "43155": {
    DMA: 535,
  },
  "43156": {
    DMA: 535,
  },
  "43157": {
    DMA: 535,
  },
  "43158": {
    DMA: 535,
  },
  "43160": {
    DMA: 535,
  },
  "43162": {
    DMA: 535,
  },
  "43163": {
    DMA: 535,
  },
  "43164": {
    DMA: 535,
  },
  "43194": {
    DMA: 535,
  },
  "43195": {
    DMA: 535,
  },
  "43196": {
    DMA: 535,
  },
  "43198": {
    DMA: 535,
  },
  "43199": {
    DMA: 535,
  },
  "43201": {
    DMA: 535,
  },
  "43202": {
    DMA: 535,
  },
  "43203": {
    DMA: 535,
  },
  "43204": {
    DMA: 535,
  },
  "43205": {
    DMA: 535,
  },
  "43206": {
    DMA: 535,
  },
  "43207": {
    DMA: 535,
  },
  "43209": {
    DMA: 535,
  },
  "43210": {
    DMA: 535,
  },
  "43211": {
    DMA: 535,
  },
  "43212": {
    DMA: 535,
  },
  "43213": {
    DMA: 535,
  },
  "43214": {
    DMA: 535,
  },
  "43215": {
    DMA: 535,
  },
  "43216": {
    DMA: 535,
  },
  "43217": {
    DMA: 535,
  },
  "43218": {
    DMA: 535,
  },
  "43219": {
    DMA: 535,
  },
  "43220": {
    DMA: 535,
  },
  "43221": {
    DMA: 535,
  },
  "43222": {
    DMA: 535,
  },
  "43223": {
    DMA: 535,
  },
  "43224": {
    DMA: 535,
  },
  "43226": {
    DMA: 535,
  },
  "43227": {
    DMA: 535,
  },
  "43228": {
    DMA: 535,
  },
  "43229": {
    DMA: 535,
  },
  "43230": {
    DMA: 535,
  },
  "43231": {
    DMA: 535,
  },
  "43232": {
    DMA: 535,
  },
  "43234": {
    DMA: 535,
  },
  "43235": {
    DMA: 535,
  },
  "43236": {
    DMA: 535,
  },
  "43240": {
    DMA: 535,
  },
  "43251": {
    DMA: 535,
  },
  "43260": {
    DMA: 535,
  },
  "43265": {
    DMA: 535,
  },
  "43266": {
    DMA: 535,
  },
  "43268": {
    DMA: 535,
  },
  "43270": {
    DMA: 535,
  },
  "43271": {
    DMA: 535,
  },
  "43272": {
    DMA: 535,
  },
  "43279": {
    DMA: 535,
  },
  "43287": {
    DMA: 535,
  },
  "43291": {
    DMA: 535,
  },
  "43299": {
    DMA: 535,
  },
  "43301": {
    DMA: 535,
  },
  "43302": {
    DMA: 535,
  },
  "43306": {
    DMA: 535,
  },
  "43307": {
    DMA: 535,
  },
  "43310": {
    DMA: 542,
  },
  "43311": {
    DMA: 542,
  },
  "43314": {
    DMA: 535,
  },
  "43315": {
    DMA: 535,
  },
  "43316": {
    DMA: 547,
  },
  "43317": {
    DMA: 535,
  },
  "43318": {
    DMA: 542,
  },
  "43319": {
    DMA: 542,
  },
  "43320": {
    DMA: 535,
  },
  "43321": {
    DMA: 535,
  },
  "43322": {
    DMA: 535,
  },
  "43323": {
    DMA: 547,
  },
  "43324": {
    DMA: 542,
  },
  "43325": {
    DMA: 535,
  },
  "43326": {
    DMA: 535,
  },
  "43330": {
    DMA: 547,
  },
  "43331": {
    DMA: 542,
  },
  "43332": {
    DMA: 535,
  },
  "43333": {
    DMA: 542,
  },
  "43334": {
    DMA: 535,
  },
  "43335": {
    DMA: 535,
  },
  "43336": {
    DMA: 542,
  },
  "43337": {
    DMA: 535,
  },
  "43338": {
    DMA: 535,
  },
  "43340": {
    DMA: 535,
  },
  "43341": {
    DMA: 535,
  },
  "43342": {
    DMA: 535,
  },
  "43343": {
    DMA: 542,
  },
  "43344": {
    DMA: 535,
  },
  "43345": {
    DMA: 535,
  },
  "43346": {
    DMA: 535,
  },
  "43347": {
    DMA: 542,
  },
  "43348": {
    DMA: 542,
  },
  "43349": {
    DMA: 535,
  },
  "43350": {
    DMA: 535,
  },
  "43351": {
    DMA: 547,
  },
  "43356": {
    DMA: 535,
  },
  "43357": {
    DMA: 542,
  },
  "43358": {
    DMA: 542,
  },
  "43359": {
    DMA: 547,
  },
  "43360": {
    DMA: 542,
  },
  "43402": {
    DMA: 547,
  },
  "43403": {
    DMA: 547,
  },
  "43406": {
    DMA: 547,
  },
  "43407": {
    DMA: 547,
  },
  "43408": {
    DMA: 547,
  },
  "43410": {
    DMA: 547,
  },
  "43412": {
    DMA: 547,
  },
  "43413": {
    DMA: 547,
  },
  "43414": {
    DMA: 547,
  },
  "43416": {
    DMA: 547,
  },
  "43420": {
    DMA: 547,
  },
  "43430": {
    DMA: 547,
  },
  "43431": {
    DMA: 547,
  },
  "43432": {
    DMA: 547,
  },
  "43433": {
    DMA: 547,
  },
  "43434": {
    DMA: 547,
  },
  "43435": {
    DMA: 547,
  },
  "43436": {
    DMA: 547,
  },
  "43437": {
    DMA: 547,
  },
  "43438": {
    DMA: 510,
  },
  "43439": {
    DMA: 547,
  },
  "43440": {
    DMA: 547,
  },
  "43441": {
    DMA: 547,
  },
  "43442": {
    DMA: 547,
  },
  "43443": {
    DMA: 547,
  },
  "43445": {
    DMA: 547,
  },
  "43446": {
    DMA: 547,
  },
  "43447": {
    DMA: 547,
  },
  "43449": {
    DMA: 547,
  },
  "43450": {
    DMA: 547,
  },
  "43451": {
    DMA: 547,
  },
  "43452": {
    DMA: 547,
  },
  "43456": {
    DMA: 547,
  },
  "43457": {
    DMA: 547,
  },
  "43458": {
    DMA: 547,
  },
  "43460": {
    DMA: 547,
  },
  "43462": {
    DMA: 547,
  },
  "43463": {
    DMA: 547,
  },
  "43464": {
    DMA: 547,
  },
  "43465": {
    DMA: 547,
  },
  "43466": {
    DMA: 547,
  },
  "43467": {
    DMA: 547,
  },
  "43468": {
    DMA: 547,
  },
  "43469": {
    DMA: 547,
  },
  "43501": {
    DMA: 547,
  },
  "43502": {
    DMA: 547,
  },
  "43504": {
    DMA: 547,
  },
  "43505": {
    DMA: 547,
  },
  "43506": {
    DMA: 547,
  },
  "43510": {
    DMA: 547,
  },
  "43511": {
    DMA: 547,
  },
  "43512": {
    DMA: 547,
  },
  "43515": {
    DMA: 547,
  },
  "43516": {
    DMA: 547,
  },
  "43517": {
    DMA: 547,
  },
  "43518": {
    DMA: 547,
  },
  "43519": {
    DMA: 547,
  },
  "43520": {
    DMA: 547,
  },
  "43521": {
    DMA: 547,
  },
  "43522": {
    DMA: 547,
  },
  "43523": {
    DMA: 547,
  },
  "43524": {
    DMA: 547,
  },
  "43525": {
    DMA: 547,
  },
  "43526": {
    DMA: 547,
  },
  "43527": {
    DMA: 547,
  },
  "43528": {
    DMA: 547,
  },
  "43529": {
    DMA: 547,
  },
  "43530": {
    DMA: 547,
  },
  "43531": {
    DMA: 547,
  },
  "43532": {
    DMA: 547,
  },
  "43533": {
    DMA: 547,
  },
  "43534": {
    DMA: 547,
  },
  "43535": {
    DMA: 547,
  },
  "43536": {
    DMA: 547,
  },
  "43537": {
    DMA: 547,
  },
  "43540": {
    DMA: 547,
  },
  "43541": {
    DMA: 547,
  },
  "43542": {
    DMA: 547,
  },
  "43543": {
    DMA: 547,
  },
  "43545": {
    DMA: 547,
  },
  "43547": {
    DMA: 547,
  },
  "43548": {
    DMA: 547,
  },
  "43549": {
    DMA: 547,
  },
  "43550": {
    DMA: 547,
  },
  "43551": {
    DMA: 547,
  },
  "43552": {
    DMA: 547,
  },
  "43553": {
    DMA: 547,
  },
  "43554": {
    DMA: 547,
  },
  "43555": {
    DMA: 547,
  },
  "43556": {
    DMA: 547,
  },
  "43557": {
    DMA: 547,
  },
  "43558": {
    DMA: 547,
  },
  "43560": {
    DMA: 547,
  },
  "43565": {
    DMA: 547,
  },
  "43566": {
    DMA: 547,
  },
  "43567": {
    DMA: 547,
  },
  "43569": {
    DMA: 547,
  },
  "43570": {
    DMA: 547,
  },
  "43571": {
    DMA: 547,
  },
  "43601": {
    DMA: 547,
  },
  "43603": {
    DMA: 547,
  },
  "43604": {
    DMA: 547,
  },
  "43605": {
    DMA: 547,
  },
  "43606": {
    DMA: 547,
  },
  "43607": {
    DMA: 547,
  },
  "43608": {
    DMA: 547,
  },
  "43609": {
    DMA: 547,
  },
  "43610": {
    DMA: 547,
  },
  "43611": {
    DMA: 547,
  },
  "43612": {
    DMA: 547,
  },
  "43613": {
    DMA: 547,
  },
  "43614": {
    DMA: 547,
  },
  "43615": {
    DMA: 547,
  },
  "43616": {
    DMA: 547,
  },
  "43617": {
    DMA: 547,
  },
  "43618": {
    DMA: 547,
  },
  "43619": {
    DMA: 547,
  },
  "43620": {
    DMA: 547,
  },
  "43623": {
    DMA: 547,
  },
  "43635": {
    DMA: 547,
  },
  "43652": {
    DMA: 547,
  },
  "43654": {
    DMA: 547,
  },
  "43656": {
    DMA: 547,
  },
  "43657": {
    DMA: 547,
  },
  "43659": {
    DMA: 547,
  },
  "43660": {
    DMA: 547,
  },
  "43661": {
    DMA: 547,
  },
  "43666": {
    DMA: 547,
  },
  "43667": {
    DMA: 547,
  },
  "43681": {
    DMA: 547,
  },
  "43682": {
    DMA: 547,
  },
  "43697": {
    DMA: 547,
  },
  "43699": {
    DMA: 547,
  },
  "43701": {
    DMA: 596,
  },
  "43702": {
    DMA: 596,
  },
  "43711": {
    DMA: 535,
  },
  "43713": {
    DMA: 554,
  },
  "43716": {
    DMA: 554,
  },
  "43717": {
    DMA: 535,
  },
  "43718": {
    DMA: 554,
  },
  "43719": {
    DMA: 554,
  },
  "43720": {
    DMA: 596,
  },
  "43721": {
    DMA: 535,
  },
  "43722": {
    DMA: 535,
  },
  "43723": {
    DMA: 535,
  },
  "43724": {
    DMA: 535,
  },
  "43725": {
    DMA: 535,
  },
  "43727": {
    DMA: 596,
  },
  "43728": {
    DMA: 535,
  },
  "43730": {
    DMA: 535,
  },
  "43731": {
    DMA: 535,
  },
  "43732": {
    DMA: 535,
  },
  "43733": {
    DMA: 535,
  },
  "43734": {
    DMA: 596,
  },
  "43735": {
    DMA: 596,
  },
  "43736": {
    DMA: 535,
  },
  "43738": {
    DMA: 596,
  },
  "43739": {
    DMA: 535,
  },
  "43740": {
    DMA: 535,
  },
  "43746": {
    DMA: 596,
  },
  "43747": {
    DMA: 554,
  },
  "43748": {
    DMA: 535,
  },
  "43749": {
    DMA: 535,
  },
  "43750": {
    DMA: 535,
  },
  "43752": {
    DMA: 554,
  },
  "43754": {
    DMA: 554,
  },
  "43755": {
    DMA: 535,
  },
  "43756": {
    DMA: 535,
  },
  "43757": {
    DMA: 554,
  },
  "43758": {
    DMA: 535,
  },
  "43759": {
    DMA: 554,
  },
  "43760": {
    DMA: 535,
  },
  "43761": {
    DMA: 535,
  },
  "43762": {
    DMA: 596,
  },
  "43764": {
    DMA: 535,
  },
  "43766": {
    DMA: 535,
  },
  "43767": {
    DMA: 596,
  },
  "43768": {
    DMA: 535,
  },
  "43771": {
    DMA: 596,
  },
  "43772": {
    DMA: 535,
  },
  "43773": {
    DMA: 535,
  },
  "43777": {
    DMA: 596,
  },
  "43778": {
    DMA: 535,
  },
  "43779": {
    DMA: 535,
  },
  "43780": {
    DMA: 535,
  },
  "43782": {
    DMA: 535,
  },
  "43783": {
    DMA: 535,
  },
  "43786": {
    DMA: 554,
  },
  "43787": {
    DMA: 535,
  },
  "43788": {
    DMA: 535,
  },
  "43789": {
    DMA: 554,
  },
  "43791": {
    DMA: 596,
  },
  "43793": {
    DMA: 554,
  },
  "43802": {
    DMA: 596,
  },
  "43803": {
    DMA: 535,
  },
  "43804": {
    DMA: 510,
  },
  "43805": {
    DMA: 535,
  },
  "43811": {
    DMA: 535,
  },
  "43812": {
    DMA: 535,
  },
  "43821": {
    DMA: 596,
  },
  "43822": {
    DMA: 596,
  },
  "43824": {
    DMA: 535,
  },
  "43828": {
    DMA: 535,
  },
  "43830": {
    DMA: 596,
  },
  "43832": {
    DMA: 510,
  },
  "43836": {
    DMA: 535,
  },
  "43837": {
    DMA: 510,
  },
  "43840": {
    DMA: 510,
  },
  "43842": {
    DMA: 596,
  },
  "43843": {
    DMA: 535,
  },
  "43844": {
    DMA: 535,
  },
  "43845": {
    DMA: 535,
  },
  "43901": {
    DMA: 554,
  },
  "43902": {
    DMA: 554,
  },
  "43903": {
    DMA: 554,
  },
  "43905": {
    DMA: 554,
  },
  "43906": {
    DMA: 554,
  },
  "43907": {
    DMA: 554,
  },
  "43908": {
    DMA: 554,
  },
  "43909": {
    DMA: 554,
  },
  "43910": {
    DMA: 554,
  },
  "43912": {
    DMA: 554,
  },
  "43913": {
    DMA: 554,
  },
  "43914": {
    DMA: 554,
  },
  "43915": {
    DMA: 554,
  },
  "43916": {
    DMA: 554,
  },
  "43917": {
    DMA: 554,
  },
  "43920": {
    DMA: 536,
  },
  "43925": {
    DMA: 554,
  },
  "43926": {
    DMA: 554,
  },
  "43927": {
    DMA: 554,
  },
  "43928": {
    DMA: 554,
  },
  "43930": {
    DMA: 554,
  },
  "43931": {
    DMA: 554,
  },
  "43932": {
    DMA: 554,
  },
  "43933": {
    DMA: 554,
  },
  "43934": {
    DMA: 554,
  },
  "43935": {
    DMA: 554,
  },
  "43937": {
    DMA: 554,
  },
  "43938": {
    DMA: 554,
  },
  "43939": {
    DMA: 554,
  },
  "43940": {
    DMA: 554,
  },
  "43941": {
    DMA: 554,
  },
  "43942": {
    DMA: 554,
  },
  "43943": {
    DMA: 554,
  },
  "43944": {
    DMA: 554,
  },
  "43945": {
    DMA: 536,
  },
  "43946": {
    DMA: 554,
  },
  "43947": {
    DMA: 554,
  },
  "43948": {
    DMA: 554,
  },
  "43950": {
    DMA: 554,
  },
  "43951": {
    DMA: 554,
  },
  "43952": {
    DMA: 554,
  },
  "43953": {
    DMA: 554,
  },
  "43961": {
    DMA: 554,
  },
  "43962": {
    DMA: 536,
  },
  "43963": {
    DMA: 554,
  },
  "43964": {
    DMA: 554,
  },
  "43967": {
    DMA: 554,
  },
  "43968": {
    DMA: 536,
  },
  "43970": {
    DMA: 554,
  },
  "43971": {
    DMA: 554,
  },
  "43972": {
    DMA: 554,
  },
  "43973": {
    DMA: 554,
  },
  "43974": {
    DMA: 554,
  },
  "43976": {
    DMA: 554,
  },
  "43977": {
    DMA: 554,
  },
  "43981": {
    DMA: 554,
  },
  "43983": {
    DMA: 554,
  },
  "43984": {
    DMA: 554,
  },
  "43985": {
    DMA: 554,
  },
  "43986": {
    DMA: 554,
  },
  "43988": {
    DMA: 554,
  },
  "44001": {
    DMA: 510,
  },
  "44003": {
    DMA: 510,
  },
  "44004": {
    DMA: 510,
  },
  "44005": {
    DMA: 510,
  },
  "44010": {
    DMA: 510,
  },
  "44011": {
    DMA: 510,
  },
  "44012": {
    DMA: 510,
  },
  "44017": {
    DMA: 510,
  },
  "44021": {
    DMA: 510,
  },
  "44022": {
    DMA: 510,
  },
  "44023": {
    DMA: 510,
  },
  "44024": {
    DMA: 510,
  },
  "44026": {
    DMA: 510,
  },
  "44028": {
    DMA: 510,
  },
  "44030": {
    DMA: 510,
  },
  "44032": {
    DMA: 510,
  },
  "44033": {
    DMA: 510,
  },
  "44035": {
    DMA: 510,
  },
  "44036": {
    DMA: 510,
  },
  "44039": {
    DMA: 510,
  },
  "44040": {
    DMA: 510,
  },
  "44041": {
    DMA: 510,
  },
  "44044": {
    DMA: 510,
  },
  "44045": {
    DMA: 510,
  },
  "44046": {
    DMA: 510,
  },
  "44047": {
    DMA: 510,
  },
  "44048": {
    DMA: 510,
  },
  "44049": {
    DMA: 510,
  },
  "44050": {
    DMA: 510,
  },
  "44052": {
    DMA: 510,
  },
  "44053": {
    DMA: 510,
  },
  "44054": {
    DMA: 510,
  },
  "44055": {
    DMA: 510,
  },
  "44056": {
    DMA: 510,
  },
  "44057": {
    DMA: 510,
  },
  "44060": {
    DMA: 510,
  },
  "44061": {
    DMA: 510,
  },
  "44062": {
    DMA: 510,
  },
  "44064": {
    DMA: 510,
  },
  "44065": {
    DMA: 510,
  },
  "44067": {
    DMA: 510,
  },
  "44068": {
    DMA: 510,
  },
  "44070": {
    DMA: 510,
  },
  "44072": {
    DMA: 510,
  },
  "44073": {
    DMA: 510,
  },
  "44074": {
    DMA: 510,
  },
  "44076": {
    DMA: 510,
  },
  "44077": {
    DMA: 510,
  },
  "44080": {
    DMA: 510,
  },
  "44081": {
    DMA: 510,
  },
  "44082": {
    DMA: 510,
  },
  "44084": {
    DMA: 510,
  },
  "44085": {
    DMA: 510,
  },
  "44086": {
    DMA: 510,
  },
  "44087": {
    DMA: 510,
  },
  "44088": {
    DMA: 510,
  },
  "44089": {
    DMA: 510,
  },
  "44090": {
    DMA: 510,
  },
  "44092": {
    DMA: 510,
  },
  "44093": {
    DMA: 510,
  },
  "44094": {
    DMA: 510,
  },
  "44095": {
    DMA: 510,
  },
  "44096": {
    DMA: 510,
  },
  "44097": {
    DMA: 510,
  },
  "44099": {
    DMA: 510,
  },
  "44101": {
    DMA: 510,
  },
  "44102": {
    DMA: 510,
  },
  "44103": {
    DMA: 510,
  },
  "44104": {
    DMA: 510,
  },
  "44105": {
    DMA: 510,
  },
  "44106": {
    DMA: 510,
  },
  "44107": {
    DMA: 510,
  },
  "44108": {
    DMA: 510,
  },
  "44109": {
    DMA: 510,
  },
  "44110": {
    DMA: 510,
  },
  "44111": {
    DMA: 510,
  },
  "44112": {
    DMA: 510,
  },
  "44113": {
    DMA: 510,
  },
  "44114": {
    DMA: 510,
  },
  "44115": {
    DMA: 510,
  },
  "44116": {
    DMA: 510,
  },
  "44117": {
    DMA: 510,
  },
  "44118": {
    DMA: 510,
  },
  "44119": {
    DMA: 510,
  },
  "44120": {
    DMA: 510,
  },
  "44121": {
    DMA: 510,
  },
  "44122": {
    DMA: 510,
  },
  "44123": {
    DMA: 510,
  },
  "44124": {
    DMA: 510,
  },
  "44125": {
    DMA: 510,
  },
  "44126": {
    DMA: 510,
  },
  "44127": {
    DMA: 510,
  },
  "44128": {
    DMA: 510,
  },
  "44129": {
    DMA: 510,
  },
  "44130": {
    DMA: 510,
  },
  "44131": {
    DMA: 510,
  },
  "44132": {
    DMA: 510,
  },
  "44133": {
    DMA: 510,
  },
  "44134": {
    DMA: 510,
  },
  "44135": {
    DMA: 510,
  },
  "44136": {
    DMA: 510,
  },
  "44137": {
    DMA: 510,
  },
  "44138": {
    DMA: 510,
  },
  "44139": {
    DMA: 510,
  },
  "44140": {
    DMA: 510,
  },
  "44141": {
    DMA: 510,
  },
  "44142": {
    DMA: 510,
  },
  "44143": {
    DMA: 510,
  },
  "44144": {
    DMA: 510,
  },
  "44145": {
    DMA: 510,
  },
  "44146": {
    DMA: 510,
  },
  "44147": {
    DMA: 510,
  },
  "44149": {
    DMA: 510,
  },
  "44178": {
    DMA: 510,
  },
  "44181": {
    DMA: 510,
  },
  "44185": {
    DMA: 510,
  },
  "44188": {
    DMA: 510,
  },
  "44189": {
    DMA: 510,
  },
  "44190": {
    DMA: 510,
  },
  "44191": {
    DMA: 510,
  },
  "44192": {
    DMA: 510,
  },
  "44193": {
    DMA: 510,
  },
  "44194": {
    DMA: 510,
  },
  "44195": {
    DMA: 510,
  },
  "44197": {
    DMA: 510,
  },
  "44198": {
    DMA: 510,
  },
  "44199": {
    DMA: 510,
  },
  "44201": {
    DMA: 510,
  },
  "44202": {
    DMA: 510,
  },
  "44203": {
    DMA: 510,
  },
  "44210": {
    DMA: 510,
  },
  "44211": {
    DMA: 510,
  },
  "44212": {
    DMA: 510,
  },
  "44214": {
    DMA: 510,
  },
  "44215": {
    DMA: 510,
  },
  "44216": {
    DMA: 510,
  },
  "44217": {
    DMA: 510,
  },
  "44221": {
    DMA: 510,
  },
  "44222": {
    DMA: 510,
  },
  "44223": {
    DMA: 510,
  },
  "44224": {
    DMA: 510,
  },
  "44230": {
    DMA: 510,
  },
  "44231": {
    DMA: 510,
  },
  "44232": {
    DMA: 510,
  },
  "44233": {
    DMA: 510,
  },
  "44234": {
    DMA: 510,
  },
  "44235": {
    DMA: 510,
  },
  "44236": {
    DMA: 510,
  },
  "44237": {
    DMA: 510,
  },
  "44240": {
    DMA: 510,
  },
  "44241": {
    DMA: 510,
  },
  "44242": {
    DMA: 510,
  },
  "44243": {
    DMA: 510,
  },
  "44250": {
    DMA: 510,
  },
  "44251": {
    DMA: 510,
  },
  "44253": {
    DMA: 510,
  },
  "44254": {
    DMA: 510,
  },
  "44255": {
    DMA: 510,
  },
  "44256": {
    DMA: 510,
  },
  "44258": {
    DMA: 510,
  },
  "44260": {
    DMA: 510,
  },
  "44262": {
    DMA: 510,
  },
  "44264": {
    DMA: 510,
  },
  "44265": {
    DMA: 510,
  },
  "44266": {
    DMA: 510,
  },
  "44270": {
    DMA: 510,
  },
  "44272": {
    DMA: 510,
  },
  "44273": {
    DMA: 510,
  },
  "44274": {
    DMA: 510,
  },
  "44275": {
    DMA: 510,
  },
  "44276": {
    DMA: 510,
  },
  "44278": {
    DMA: 510,
  },
  "44280": {
    DMA: 510,
  },
  "44281": {
    DMA: 510,
  },
  "44282": {
    DMA: 510,
  },
  "44285": {
    DMA: 510,
  },
  "44286": {
    DMA: 510,
  },
  "44287": {
    DMA: 510,
  },
  "44288": {
    DMA: 510,
  },
  "44301": {
    DMA: 510,
  },
  "44302": {
    DMA: 510,
  },
  "44303": {
    DMA: 510,
  },
  "44304": {
    DMA: 510,
  },
  "44305": {
    DMA: 510,
  },
  "44306": {
    DMA: 510,
  },
  "44307": {
    DMA: 510,
  },
  "44308": {
    DMA: 510,
  },
  "44309": {
    DMA: 510,
  },
  "44310": {
    DMA: 510,
  },
  "44311": {
    DMA: 510,
  },
  "44312": {
    DMA: 510,
  },
  "44313": {
    DMA: 510,
  },
  "44314": {
    DMA: 510,
  },
  "44315": {
    DMA: 510,
  },
  "44316": {
    DMA: 510,
  },
  "44317": {
    DMA: 510,
  },
  "44319": {
    DMA: 510,
  },
  "44320": {
    DMA: 510,
  },
  "44321": {
    DMA: 510,
  },
  "44322": {
    DMA: 510,
  },
  "44325": {
    DMA: 510,
  },
  "44326": {
    DMA: 510,
  },
  "44328": {
    DMA: 510,
  },
  "44333": {
    DMA: 510,
  },
  "44334": {
    DMA: 510,
  },
  "44372": {
    DMA: 510,
  },
  "44393": {
    DMA: 510,
  },
  "44396": {
    DMA: 510,
  },
  "44398": {
    DMA: 510,
  },
  "44399": {
    DMA: 510,
  },
  "44401": {
    DMA: 536,
  },
  "44402": {
    DMA: 536,
  },
  "44403": {
    DMA: 536,
  },
  "44404": {
    DMA: 536,
  },
  "44405": {
    DMA: 536,
  },
  "44406": {
    DMA: 536,
  },
  "44408": {
    DMA: 536,
  },
  "44410": {
    DMA: 536,
  },
  "44411": {
    DMA: 510,
  },
  "44412": {
    DMA: 510,
  },
  "44413": {
    DMA: 536,
  },
  "44415": {
    DMA: 536,
  },
  "44416": {
    DMA: 536,
  },
  "44417": {
    DMA: 536,
  },
  "44418": {
    DMA: 536,
  },
  "44420": {
    DMA: 536,
  },
  "44422": {
    DMA: 536,
  },
  "44423": {
    DMA: 536,
  },
  "44424": {
    DMA: 536,
  },
  "44425": {
    DMA: 536,
  },
  "44427": {
    DMA: 536,
  },
  "44428": {
    DMA: 536,
  },
  "44429": {
    DMA: 536,
  },
  "44430": {
    DMA: 536,
  },
  "44431": {
    DMA: 536,
  },
  "44432": {
    DMA: 536,
  },
  "44436": {
    DMA: 536,
  },
  "44437": {
    DMA: 536,
  },
  "44438": {
    DMA: 536,
  },
  "44439": {
    DMA: 536,
  },
  "44440": {
    DMA: 536,
  },
  "44441": {
    DMA: 536,
  },
  "44442": {
    DMA: 536,
  },
  "44443": {
    DMA: 536,
  },
  "44444": {
    DMA: 536,
  },
  "44445": {
    DMA: 536,
  },
  "44446": {
    DMA: 536,
  },
  "44449": {
    DMA: 510,
  },
  "44450": {
    DMA: 536,
  },
  "44451": {
    DMA: 536,
  },
  "44452": {
    DMA: 536,
  },
  "44453": {
    DMA: 536,
  },
  "44454": {
    DMA: 536,
  },
  "44455": {
    DMA: 536,
  },
  "44460": {
    DMA: 536,
  },
  "44470": {
    DMA: 536,
  },
  "44471": {
    DMA: 536,
  },
  "44473": {
    DMA: 536,
  },
  "44481": {
    DMA: 536,
  },
  "44482": {
    DMA: 536,
  },
  "44483": {
    DMA: 536,
  },
  "44484": {
    DMA: 536,
  },
  "44485": {
    DMA: 536,
  },
  "44486": {
    DMA: 536,
  },
  "44488": {
    DMA: 536,
  },
  "44490": {
    DMA: 536,
  },
  "44491": {
    DMA: 536,
  },
  "44492": {
    DMA: 536,
  },
  "44493": {
    DMA: 536,
  },
  "44501": {
    DMA: 536,
  },
  "44502": {
    DMA: 536,
  },
  "44503": {
    DMA: 536,
  },
  "44504": {
    DMA: 536,
  },
  "44505": {
    DMA: 536,
  },
  "44506": {
    DMA: 536,
  },
  "44507": {
    DMA: 536,
  },
  "44509": {
    DMA: 536,
  },
  "44510": {
    DMA: 536,
  },
  "44511": {
    DMA: 536,
  },
  "44512": {
    DMA: 536,
  },
  "44513": {
    DMA: 536,
  },
  "44514": {
    DMA: 536,
  },
  "44515": {
    DMA: 536,
  },
  "44555": {
    DMA: 536,
  },
  "44601": {
    DMA: 510,
  },
  "44606": {
    DMA: 510,
  },
  "44607": {
    DMA: 510,
  },
  "44608": {
    DMA: 510,
  },
  "44609": {
    DMA: 536,
  },
  "44610": {
    DMA: 510,
  },
  "44611": {
    DMA: 510,
  },
  "44612": {
    DMA: 510,
  },
  "44613": {
    DMA: 510,
  },
  "44614": {
    DMA: 510,
  },
  "44615": {
    DMA: 510,
  },
  "44617": {
    DMA: 510,
  },
  "44618": {
    DMA: 510,
  },
  "44619": {
    DMA: 536,
  },
  "44620": {
    DMA: 510,
  },
  "44621": {
    DMA: 510,
  },
  "44622": {
    DMA: 510,
  },
  "44624": {
    DMA: 510,
  },
  "44625": {
    DMA: 536,
  },
  "44626": {
    DMA: 510,
  },
  "44627": {
    DMA: 510,
  },
  "44628": {
    DMA: 510,
  },
  "44629": {
    DMA: 510,
  },
  "44630": {
    DMA: 510,
  },
  "44631": {
    DMA: 510,
  },
  "44632": {
    DMA: 510,
  },
  "44633": {
    DMA: 510,
  },
  "44634": {
    DMA: 536,
  },
  "44636": {
    DMA: 510,
  },
  "44637": {
    DMA: 510,
  },
  "44638": {
    DMA: 510,
  },
  "44639": {
    DMA: 510,
  },
  "44640": {
    DMA: 510,
  },
  "44641": {
    DMA: 510,
  },
  "44643": {
    DMA: 510,
  },
  "44644": {
    DMA: 510,
  },
  "44645": {
    DMA: 510,
  },
  "44646": {
    DMA: 510,
  },
  "44647": {
    DMA: 510,
  },
  "44648": {
    DMA: 510,
  },
  "44650": {
    DMA: 510,
  },
  "44651": {
    DMA: 510,
  },
  "44652": {
    DMA: 510,
  },
  "44653": {
    DMA: 510,
  },
  "44654": {
    DMA: 510,
  },
  "44656": {
    DMA: 510,
  },
  "44657": {
    DMA: 510,
  },
  "44659": {
    DMA: 510,
  },
  "44660": {
    DMA: 510,
  },
  "44661": {
    DMA: 510,
  },
  "44662": {
    DMA: 510,
  },
  "44663": {
    DMA: 510,
  },
  "44665": {
    DMA: 536,
  },
  "44666": {
    DMA: 510,
  },
  "44667": {
    DMA: 510,
  },
  "44669": {
    DMA: 510,
  },
  "44670": {
    DMA: 510,
  },
  "44671": {
    DMA: 510,
  },
  "44672": {
    DMA: 536,
  },
  "44675": {
    DMA: 510,
  },
  "44676": {
    DMA: 510,
  },
  "44677": {
    DMA: 510,
  },
  "44678": {
    DMA: 510,
  },
  "44679": {
    DMA: 510,
  },
  "44680": {
    DMA: 510,
  },
  "44681": {
    DMA: 510,
  },
  "44682": {
    DMA: 510,
  },
  "44683": {
    DMA: 510,
  },
  "44685": {
    DMA: 510,
  },
  "44687": {
    DMA: 510,
  },
  "44688": {
    DMA: 510,
  },
  "44689": {
    DMA: 510,
  },
  "44690": {
    DMA: 510,
  },
  "44691": {
    DMA: 510,
  },
  "44693": {
    DMA: 554,
  },
  "44695": {
    DMA: 554,
  },
  "44697": {
    DMA: 510,
  },
  "44699": {
    DMA: 554,
  },
  "44701": {
    DMA: 510,
  },
  "44702": {
    DMA: 510,
  },
  "44703": {
    DMA: 510,
  },
  "44704": {
    DMA: 510,
  },
  "44705": {
    DMA: 510,
  },
  "44706": {
    DMA: 510,
  },
  "44707": {
    DMA: 510,
  },
  "44708": {
    DMA: 510,
  },
  "44709": {
    DMA: 510,
  },
  "44710": {
    DMA: 510,
  },
  "44711": {
    DMA: 510,
  },
  "44714": {
    DMA: 510,
  },
  "44718": {
    DMA: 510,
  },
  "44720": {
    DMA: 510,
  },
  "44721": {
    DMA: 510,
  },
  "44730": {
    DMA: 510,
  },
  "44735": {
    DMA: 510,
  },
  "44750": {
    DMA: 510,
  },
  "44767": {
    DMA: 510,
  },
  "44799": {
    DMA: 510,
  },
  "44802": {
    DMA: 547,
  },
  "44804": {
    DMA: 547,
  },
  "44805": {
    DMA: 510,
  },
  "44807": {
    DMA: 547,
  },
  "44809": {
    DMA: 547,
  },
  "44811": {
    DMA: 510,
  },
  "44813": {
    DMA: 510,
  },
  "44814": {
    DMA: 510,
  },
  "44815": {
    DMA: 547,
  },
  "44816": {
    DMA: 510,
  },
  "44817": {
    DMA: 547,
  },
  "44818": {
    DMA: 547,
  },
  "44820": {
    DMA: 535,
  },
  "44822": {
    DMA: 510,
  },
  "44824": {
    DMA: 510,
  },
  "44825": {
    DMA: 535,
  },
  "44826": {
    DMA: 510,
  },
  "44827": {
    DMA: 535,
  },
  "44828": {
    DMA: 547,
  },
  "44830": {
    DMA: 547,
  },
  "44833": {
    DMA: 535,
  },
  "44836": {
    DMA: 547,
  },
  "44837": {
    DMA: 510,
  },
  "44838": {
    DMA: 510,
  },
  "44839": {
    DMA: 510,
  },
  "44840": {
    DMA: 510,
  },
  "44841": {
    DMA: 547,
  },
  "44842": {
    DMA: 510,
  },
  "44843": {
    DMA: 510,
  },
  "44844": {
    DMA: 547,
  },
  "44845": {
    DMA: 547,
  },
  "44846": {
    DMA: 510,
  },
  "44847": {
    DMA: 510,
  },
  "44848": {
    DMA: 510,
  },
  "44849": {
    DMA: 547,
  },
  "44850": {
    DMA: 510,
  },
  "44851": {
    DMA: 510,
  },
  "44853": {
    DMA: 547,
  },
  "44854": {
    DMA: 535,
  },
  "44855": {
    DMA: 510,
  },
  "44856": {
    DMA: 535,
  },
  "44857": {
    DMA: 510,
  },
  "44859": {
    DMA: 510,
  },
  "44860": {
    DMA: 535,
  },
  "44861": {
    DMA: 547,
  },
  "44862": {
    DMA: 510,
  },
  "44864": {
    DMA: 510,
  },
  "44865": {
    DMA: 510,
  },
  "44866": {
    DMA: 510,
  },
  "44867": {
    DMA: 547,
  },
  "44870": {
    DMA: 510,
  },
  "44871": {
    DMA: 510,
  },
  "44874": {
    DMA: 510,
  },
  "44875": {
    DMA: 510,
  },
  "44878": {
    DMA: 510,
  },
  "44880": {
    DMA: 510,
  },
  "44881": {
    DMA: 535,
  },
  "44882": {
    DMA: 547,
  },
  "44883": {
    DMA: 547,
  },
  "44887": {
    DMA: 535,
  },
  "44888": {
    DMA: 510,
  },
  "44889": {
    DMA: 510,
  },
  "44890": {
    DMA: 510,
  },
  "44901": {
    DMA: 510,
  },
  "44902": {
    DMA: 510,
  },
  "44903": {
    DMA: 510,
  },
  "44904": {
    DMA: 510,
  },
  "44905": {
    DMA: 510,
  },
  "44906": {
    DMA: 510,
  },
  "44907": {
    DMA: 510,
  },
  "44999": {
    DMA: 510,
  },
  "45001": {
    DMA: 515,
  },
  "45002": {
    DMA: 515,
  },
  "45003": {
    DMA: 515,
  },
  "45004": {
    DMA: 515,
  },
  "45005": {
    DMA: 515,
  },
  "45011": {
    DMA: 515,
  },
  "45012": {
    DMA: 515,
  },
  "45013": {
    DMA: 515,
  },
  "45014": {
    DMA: 515,
  },
  "45015": {
    DMA: 515,
  },
  "45018": {
    DMA: 515,
  },
  "45025": {
    DMA: 515,
  },
  "45026": {
    DMA: 515,
  },
  "45030": {
    DMA: 515,
  },
  "45032": {
    DMA: 515,
  },
  "45033": {
    DMA: 515,
  },
  "45034": {
    DMA: 515,
  },
  "45036": {
    DMA: 515,
  },
  "45039": {
    DMA: 515,
  },
  "45040": {
    DMA: 515,
  },
  "45041": {
    DMA: 515,
  },
  "45042": {
    DMA: 515,
  },
  "45043": {
    DMA: 515,
  },
  "45044": {
    DMA: 515,
  },
  "45050": {
    DMA: 515,
  },
  "45051": {
    DMA: 515,
  },
  "45052": {
    DMA: 515,
  },
  "45053": {
    DMA: 515,
  },
  "45054": {
    DMA: 515,
  },
  "45055": {
    DMA: 515,
  },
  "45056": {
    DMA: 515,
  },
  "45061": {
    DMA: 515,
  },
  "45062": {
    DMA: 515,
  },
  "45063": {
    DMA: 515,
  },
  "45064": {
    DMA: 515,
  },
  "45065": {
    DMA: 515,
  },
  "45066": {
    DMA: 515,
  },
  "45067": {
    DMA: 515,
  },
  "45068": {
    DMA: 515,
  },
  "45069": {
    DMA: 515,
  },
  "45070": {
    DMA: 542,
  },
  "45071": {
    DMA: 515,
  },
  "45101": {
    DMA: 515,
  },
  "45102": {
    DMA: 515,
  },
  "45103": {
    DMA: 515,
  },
  "45105": {
    DMA: 515,
  },
  "45106": {
    DMA: 515,
  },
  "45107": {
    DMA: 515,
  },
  "45110": {
    DMA: 515,
  },
  "45111": {
    DMA: 515,
  },
  "45112": {
    DMA: 515,
  },
  "45113": {
    DMA: 515,
  },
  "45114": {
    DMA: 515,
  },
  "45115": {
    DMA: 515,
  },
  "45118": {
    DMA: 515,
  },
  "45119": {
    DMA: 515,
  },
  "45120": {
    DMA: 515,
  },
  "45121": {
    DMA: 515,
  },
  "45122": {
    DMA: 515,
  },
  "45123": {
    DMA: 515,
  },
  "45130": {
    DMA: 515,
  },
  "45131": {
    DMA: 515,
  },
  "45132": {
    DMA: 515,
  },
  "45133": {
    DMA: 515,
  },
  "45135": {
    DMA: 515,
  },
  "45138": {
    DMA: 515,
  },
  "45140": {
    DMA: 515,
  },
  "45142": {
    DMA: 515,
  },
  "45144": {
    DMA: 515,
  },
  "45145": {
    DMA: 515,
  },
  "45146": {
    DMA: 515,
  },
  "45147": {
    DMA: 515,
  },
  "45148": {
    DMA: 515,
  },
  "45150": {
    DMA: 515,
  },
  "45152": {
    DMA: 515,
  },
  "45153": {
    DMA: 515,
  },
  "45154": {
    DMA: 515,
  },
  "45155": {
    DMA: 515,
  },
  "45156": {
    DMA: 515,
  },
  "45157": {
    DMA: 515,
  },
  "45158": {
    DMA: 515,
  },
  "45159": {
    DMA: 515,
  },
  "45160": {
    DMA: 515,
  },
  "45162": {
    DMA: 515,
  },
  "45164": {
    DMA: 515,
  },
  "45166": {
    DMA: 515,
  },
  "45167": {
    DMA: 515,
  },
  "45168": {
    DMA: 515,
  },
  "45169": {
    DMA: 515,
  },
  "45171": {
    DMA: 515,
  },
  "45172": {
    DMA: 515,
  },
  "45174": {
    DMA: 515,
  },
  "45176": {
    DMA: 515,
  },
  "45177": {
    DMA: 515,
  },
  "45201": {
    DMA: 515,
  },
  "45202": {
    DMA: 515,
  },
  "45203": {
    DMA: 515,
  },
  "45204": {
    DMA: 515,
  },
  "45205": {
    DMA: 515,
  },
  "45206": {
    DMA: 515,
  },
  "45207": {
    DMA: 515,
  },
  "45208": {
    DMA: 515,
  },
  "45209": {
    DMA: 515,
  },
  "45211": {
    DMA: 515,
  },
  "45212": {
    DMA: 515,
  },
  "45213": {
    DMA: 515,
  },
  "45214": {
    DMA: 515,
  },
  "45215": {
    DMA: 515,
  },
  "45216": {
    DMA: 515,
  },
  "45217": {
    DMA: 515,
  },
  "45218": {
    DMA: 515,
  },
  "45219": {
    DMA: 515,
  },
  "45220": {
    DMA: 515,
  },
  "45221": {
    DMA: 515,
  },
  "45222": {
    DMA: 515,
  },
  "45223": {
    DMA: 515,
  },
  "45224": {
    DMA: 515,
  },
  "45225": {
    DMA: 515,
  },
  "45226": {
    DMA: 515,
  },
  "45227": {
    DMA: 515,
  },
  "45228": {
    DMA: 515,
  },
  "45229": {
    DMA: 515,
  },
  "45230": {
    DMA: 515,
  },
  "45231": {
    DMA: 515,
  },
  "45232": {
    DMA: 515,
  },
  "45233": {
    DMA: 515,
  },
  "45234": {
    DMA: 515,
  },
  "45235": {
    DMA: 515,
  },
  "45236": {
    DMA: 515,
  },
  "45237": {
    DMA: 515,
  },
  "45238": {
    DMA: 515,
  },
  "45239": {
    DMA: 515,
  },
  "45240": {
    DMA: 515,
  },
  "45241": {
    DMA: 515,
  },
  "45242": {
    DMA: 515,
  },
  "45243": {
    DMA: 515,
  },
  "45244": {
    DMA: 515,
  },
  "45245": {
    DMA: 515,
  },
  "45246": {
    DMA: 515,
  },
  "45247": {
    DMA: 515,
  },
  "45248": {
    DMA: 515,
  },
  "45249": {
    DMA: 515,
  },
  "45250": {
    DMA: 515,
  },
  "45251": {
    DMA: 515,
  },
  "45252": {
    DMA: 515,
  },
  "45253": {
    DMA: 515,
  },
  "45254": {
    DMA: 515,
  },
  "45255": {
    DMA: 515,
  },
  "45258": {
    DMA: 515,
  },
  "45262": {
    DMA: 515,
  },
  "45263": {
    DMA: 515,
  },
  "45264": {
    DMA: 515,
  },
  "45267": {
    DMA: 515,
  },
  "45268": {
    DMA: 515,
  },
  "45269": {
    DMA: 515,
  },
  "45270": {
    DMA: 515,
  },
  "45271": {
    DMA: 515,
  },
  "45273": {
    DMA: 515,
  },
  "45274": {
    DMA: 515,
  },
  "45275": {
    DMA: 515,
  },
  "45277": {
    DMA: 515,
  },
  "45280": {
    DMA: 515,
  },
  "45296": {
    DMA: 515,
  },
  "45298": {
    DMA: 515,
  },
  "45299": {
    DMA: 515,
  },
  "45301": {
    DMA: 542,
  },
  "45302": {
    DMA: 542,
  },
  "45303": {
    DMA: 542,
  },
  "45304": {
    DMA: 542,
  },
  "45305": {
    DMA: 542,
  },
  "45306": {
    DMA: 542,
  },
  "45307": {
    DMA: 542,
  },
  "45308": {
    DMA: 542,
  },
  "45309": {
    DMA: 542,
  },
  "45310": {
    DMA: 542,
  },
  "45311": {
    DMA: 542,
  },
  "45312": {
    DMA: 542,
  },
  "45314": {
    DMA: 542,
  },
  "45315": {
    DMA: 542,
  },
  "45316": {
    DMA: 542,
  },
  "45317": {
    DMA: 542,
  },
  "45318": {
    DMA: 542,
  },
  "45319": {
    DMA: 542,
  },
  "45320": {
    DMA: 542,
  },
  "45321": {
    DMA: 542,
  },
  "45322": {
    DMA: 542,
  },
  "45323": {
    DMA: 542,
  },
  "45324": {
    DMA: 542,
  },
  "45325": {
    DMA: 542,
  },
  "45326": {
    DMA: 542,
  },
  "45327": {
    DMA: 542,
  },
  "45328": {
    DMA: 542,
  },
  "45330": {
    DMA: 542,
  },
  "45331": {
    DMA: 542,
  },
  "45332": {
    DMA: 542,
  },
  "45333": {
    DMA: 542,
  },
  "45334": {
    DMA: 542,
  },
  "45335": {
    DMA: 542,
  },
  "45336": {
    DMA: 542,
  },
  "45337": {
    DMA: 542,
  },
  "45338": {
    DMA: 542,
  },
  "45339": {
    DMA: 542,
  },
  "45340": {
    DMA: 542,
  },
  "45341": {
    DMA: 542,
  },
  "45342": {
    DMA: 542,
  },
  "45343": {
    DMA: 542,
  },
  "45344": {
    DMA: 542,
  },
  "45345": {
    DMA: 542,
  },
  "45346": {
    DMA: 542,
  },
  "45347": {
    DMA: 542,
  },
  "45348": {
    DMA: 542,
  },
  "45349": {
    DMA: 542,
  },
  "45350": {
    DMA: 542,
  },
  "45351": {
    DMA: 542,
  },
  "45352": {
    DMA: 542,
  },
  "45353": {
    DMA: 542,
  },
  "45354": {
    DMA: 542,
  },
  "45356": {
    DMA: 542,
  },
  "45358": {
    DMA: 542,
  },
  "45359": {
    DMA: 542,
  },
  "45360": {
    DMA: 542,
  },
  "45361": {
    DMA: 542,
  },
  "45362": {
    DMA: 542,
  },
  "45363": {
    DMA: 542,
  },
  "45365": {
    DMA: 542,
  },
  "45367": {
    DMA: 542,
  },
  "45368": {
    DMA: 542,
  },
  "45369": {
    DMA: 542,
  },
  "45370": {
    DMA: 542,
  },
  "45371": {
    DMA: 542,
  },
  "45372": {
    DMA: 542,
  },
  "45373": {
    DMA: 542,
  },
  "45374": {
    DMA: 542,
  },
  "45377": {
    DMA: 542,
  },
  "45378": {
    DMA: 542,
  },
  "45380": {
    DMA: 542,
  },
  "45381": {
    DMA: 542,
  },
  "45382": {
    DMA: 542,
  },
  "45383": {
    DMA: 542,
  },
  "45384": {
    DMA: 542,
  },
  "45385": {
    DMA: 542,
  },
  "45387": {
    DMA: 542,
  },
  "45388": {
    DMA: 542,
  },
  "45389": {
    DMA: 542,
  },
  "45390": {
    DMA: 542,
  },
  "45400": {
    DMA: 542,
  },
  "45401": {
    DMA: 542,
  },
  "45402": {
    DMA: 542,
  },
  "45403": {
    DMA: 542,
  },
  "45404": {
    DMA: 542,
  },
  "45405": {
    DMA: 542,
  },
  "45406": {
    DMA: 542,
  },
  "45408": {
    DMA: 542,
  },
  "45409": {
    DMA: 542,
  },
  "45410": {
    DMA: 542,
  },
  "45412": {
    DMA: 542,
  },
  "45413": {
    DMA: 542,
  },
  "45414": {
    DMA: 542,
  },
  "45415": {
    DMA: 542,
  },
  "45416": {
    DMA: 542,
  },
  "45417": {
    DMA: 542,
  },
  "45418": {
    DMA: 542,
  },
  "45419": {
    DMA: 542,
  },
  "45420": {
    DMA: 542,
  },
  "45422": {
    DMA: 542,
  },
  "45423": {
    DMA: 542,
  },
  "45424": {
    DMA: 542,
  },
  "45426": {
    DMA: 542,
  },
  "45427": {
    DMA: 542,
  },
  "45428": {
    DMA: 542,
  },
  "45429": {
    DMA: 542,
  },
  "45430": {
    DMA: 542,
  },
  "45431": {
    DMA: 542,
  },
  "45432": {
    DMA: 542,
  },
  "45433": {
    DMA: 542,
  },
  "45434": {
    DMA: 542,
  },
  "45435": {
    DMA: 542,
  },
  "45437": {
    DMA: 542,
  },
  "45439": {
    DMA: 542,
  },
  "45440": {
    DMA: 542,
  },
  "45441": {
    DMA: 542,
  },
  "45448": {
    DMA: 542,
  },
  "45449": {
    DMA: 542,
  },
  "45454": {
    DMA: 542,
  },
  "45458": {
    DMA: 542,
  },
  "45459": {
    DMA: 542,
  },
  "45463": {
    DMA: 542,
  },
  "45469": {
    DMA: 542,
  },
  "45470": {
    DMA: 542,
  },
  "45475": {
    DMA: 542,
  },
  "45479": {
    DMA: 542,
  },
  "45481": {
    DMA: 542,
  },
  "45482": {
    DMA: 542,
  },
  "45490": {
    DMA: 542,
  },
  "45501": {
    DMA: 542,
  },
  "45502": {
    DMA: 542,
  },
  "45503": {
    DMA: 542,
  },
  "45504": {
    DMA: 542,
  },
  "45505": {
    DMA: 542,
  },
  "45506": {
    DMA: 542,
  },
  "45601": {
    DMA: 535,
  },
  "45612": {
    DMA: 535,
  },
  "45613": {
    DMA: 535,
  },
  "45614": {
    DMA: 564,
  },
  "45616": {
    DMA: 515,
  },
  "45617": {
    DMA: 535,
  },
  "45618": {
    DMA: 515,
  },
  "45619": {
    DMA: 564,
  },
  "45620": {
    DMA: 564,
  },
  "45621": {
    DMA: 564,
  },
  "45622": {
    DMA: 564,
  },
  "45623": {
    DMA: 564,
  },
  "45624": {
    DMA: 535,
  },
  "45628": {
    DMA: 535,
  },
  "45629": {
    DMA: 564,
  },
  "45630": {
    DMA: 564,
  },
  "45631": {
    DMA: 564,
  },
  "45633": {
    DMA: 535,
  },
  "45634": {
    DMA: 564,
  },
  "45636": {
    DMA: 564,
  },
  "45638": {
    DMA: 564,
  },
  "45640": {
    DMA: 564,
  },
  "45642": {
    DMA: 535,
  },
  "45643": {
    DMA: 564,
  },
  "45644": {
    DMA: 535,
  },
  "45645": {
    DMA: 564,
  },
  "45646": {
    DMA: 535,
  },
  "45647": {
    DMA: 535,
  },
  "45648": {
    DMA: 564,
  },
  "45650": {
    DMA: 515,
  },
  "45651": {
    DMA: 564,
  },
  "45652": {
    DMA: 564,
  },
  "45653": {
    DMA: 564,
  },
  "45654": {
    DMA: 564,
  },
  "45656": {
    DMA: 564,
  },
  "45657": {
    DMA: 564,
  },
  "45658": {
    DMA: 564,
  },
  "45659": {
    DMA: 564,
  },
  "45660": {
    DMA: 515,
  },
  "45661": {
    DMA: 535,
  },
  "45662": {
    DMA: 564,
  },
  "45663": {
    DMA: 564,
  },
  "45669": {
    DMA: 564,
  },
  "45671": {
    DMA: 564,
  },
  "45672": {
    DMA: 564,
  },
  "45673": {
    DMA: 535,
  },
  "45674": {
    DMA: 564,
  },
  "45675": {
    DMA: 564,
  },
  "45677": {
    DMA: 564,
  },
  "45678": {
    DMA: 564,
  },
  "45679": {
    DMA: 515,
  },
  "45680": {
    DMA: 564,
  },
  "45681": {
    DMA: 535,
  },
  "45682": {
    DMA: 564,
  },
  "45683": {
    DMA: 535,
  },
  "45684": {
    DMA: 515,
  },
  "45685": {
    DMA: 564,
  },
  "45686": {
    DMA: 564,
  },
  "45687": {
    DMA: 535,
  },
  "45688": {
    DMA: 564,
  },
  "45690": {
    DMA: 535,
  },
  "45692": {
    DMA: 564,
  },
  "45693": {
    DMA: 515,
  },
  "45694": {
    DMA: 564,
  },
  "45695": {
    DMA: 564,
  },
  "45696": {
    DMA: 564,
  },
  "45697": {
    DMA: 515,
  },
  "45698": {
    DMA: 564,
  },
  "45699": {
    DMA: 564,
  },
  "45701": {
    DMA: 535,
  },
  "45710": {
    DMA: 535,
  },
  "45711": {
    DMA: 535,
  },
  "45712": {
    DMA: 597,
  },
  "45713": {
    DMA: 597,
  },
  "45714": {
    DMA: 597,
  },
  "45715": {
    DMA: 597,
  },
  "45716": {
    DMA: 535,
  },
  "45717": {
    DMA: 535,
  },
  "45719": {
    DMA: 535,
  },
  "45720": {
    DMA: 564,
  },
  "45721": {
    DMA: 597,
  },
  "45723": {
    DMA: 535,
  },
  "45724": {
    DMA: 597,
  },
  "45727": {
    DMA: 535,
  },
  "45729": {
    DMA: 597,
  },
  "45732": {
    DMA: 535,
  },
  "45734": {
    DMA: 597,
  },
  "45735": {
    DMA: 535,
  },
  "45739": {
    DMA: 535,
  },
  "45740": {
    DMA: 535,
  },
  "45741": {
    DMA: 564,
  },
  "45742": {
    DMA: 597,
  },
  "45743": {
    DMA: 564,
  },
  "45744": {
    DMA: 597,
  },
  "45745": {
    DMA: 597,
  },
  "45746": {
    DMA: 597,
  },
  "45750": {
    DMA: 597,
  },
  "45760": {
    DMA: 564,
  },
  "45761": {
    DMA: 535,
  },
  "45764": {
    DMA: 535,
  },
  "45766": {
    DMA: 535,
  },
  "45767": {
    DMA: 597,
  },
  "45768": {
    DMA: 597,
  },
  "45769": {
    DMA: 564,
  },
  "45770": {
    DMA: 564,
  },
  "45771": {
    DMA: 564,
  },
  "45772": {
    DMA: 564,
  },
  "45773": {
    DMA: 597,
  },
  "45775": {
    DMA: 564,
  },
  "45776": {
    DMA: 535,
  },
  "45777": {
    DMA: 535,
  },
  "45778": {
    DMA: 535,
  },
  "45779": {
    DMA: 564,
  },
  "45780": {
    DMA: 535,
  },
  "45782": {
    DMA: 535,
  },
  "45783": {
    DMA: 564,
  },
  "45784": {
    DMA: 597,
  },
  "45786": {
    DMA: 597,
  },
  "45787": {
    DMA: 597,
  },
  "45788": {
    DMA: 597,
  },
  "45789": {
    DMA: 597,
  },
  "45801": {
    DMA: 558,
  },
  "45802": {
    DMA: 558,
  },
  "45804": {
    DMA: 558,
  },
  "45805": {
    DMA: 558,
  },
  "45806": {
    DMA: 558,
  },
  "45807": {
    DMA: 558,
  },
  "45808": {
    DMA: 558,
  },
  "45809": {
    DMA: 558,
  },
  "45810": {
    DMA: 535,
  },
  "45812": {
    DMA: 535,
  },
  "45813": {
    DMA: 509,
  },
  "45814": {
    DMA: 547,
  },
  "45815": {
    DMA: 558,
  },
  "45816": {
    DMA: 547,
  },
  "45817": {
    DMA: 558,
  },
  "45819": {
    DMA: 558,
  },
  "45820": {
    DMA: 558,
  },
  "45821": {
    DMA: 509,
  },
  "45822": {
    DMA: 542,
  },
  "45826": {
    DMA: 542,
  },
  "45827": {
    DMA: 558,
  },
  "45828": {
    DMA: 542,
  },
  "45830": {
    DMA: 558,
  },
  "45831": {
    DMA: 558,
  },
  "45832": {
    DMA: 509,
  },
  "45833": {
    DMA: 558,
  },
  "45835": {
    DMA: 535,
  },
  "45836": {
    DMA: 535,
  },
  "45837": {
    DMA: 558,
  },
  "45838": {
    DMA: 509,
  },
  "45839": {
    DMA: 547,
  },
  "45840": {
    DMA: 547,
  },
  "45841": {
    DMA: 547,
  },
  "45843": {
    DMA: 535,
  },
  "45844": {
    DMA: 558,
  },
  "45845": {
    DMA: 542,
  },
  "45846": {
    DMA: 542,
  },
  "45848": {
    DMA: 558,
  },
  "45849": {
    DMA: 509,
  },
  "45850": {
    DMA: 558,
  },
  "45851": {
    DMA: 509,
  },
  "45853": {
    DMA: 558,
  },
  "45854": {
    DMA: 558,
  },
  "45855": {
    DMA: 509,
  },
  "45856": {
    DMA: 558,
  },
  "45858": {
    DMA: 547,
  },
  "45859": {
    DMA: 535,
  },
  "45860": {
    DMA: 542,
  },
  "45861": {
    DMA: 509,
  },
  "45862": {
    DMA: 542,
  },
  "45863": {
    DMA: 509,
  },
  "45864": {
    DMA: 558,
  },
  "45865": {
    DMA: 558,
  },
  "45866": {
    DMA: 542,
  },
  "45867": {
    DMA: 547,
  },
  "45868": {
    DMA: 547,
  },
  "45869": {
    DMA: 558,
  },
  "45870": {
    DMA: 558,
  },
  "45871": {
    DMA: 558,
  },
  "45872": {
    DMA: 547,
  },
  "45873": {
    DMA: 509,
  },
  "45874": {
    DMA: 509,
  },
  "45875": {
    DMA: 558,
  },
  "45876": {
    DMA: 558,
  },
  "45877": {
    DMA: 558,
  },
  "45879": {
    DMA: 509,
  },
  "45880": {
    DMA: 509,
  },
  "45881": {
    DMA: 547,
  },
  "45882": {
    DMA: 542,
  },
  "45883": {
    DMA: 542,
  },
  "45884": {
    DMA: 558,
  },
  "45885": {
    DMA: 558,
  },
  "45886": {
    DMA: 509,
  },
  "45887": {
    DMA: 558,
  },
  "45888": {
    DMA: 558,
  },
  "45889": {
    DMA: 547,
  },
  "45890": {
    DMA: 547,
  },
  "45891": {
    DMA: 509,
  },
  "45893": {
    DMA: 558,
  },
  "45894": {
    DMA: 509,
  },
  "45895": {
    DMA: 558,
  },
  "45896": {
    DMA: 558,
  },
  "45897": {
    DMA: 547,
  },
  "45898": {
    DMA: 509,
  },
  "45899": {
    DMA: 509,
  },
  "45999": {
    DMA: 515,
  },
  "46001": {
    DMA: 527,
  },
  "46011": {
    DMA: 527,
  },
  "46012": {
    DMA: 527,
  },
  "46013": {
    DMA: 527,
  },
  "46014": {
    DMA: 527,
  },
  "46015": {
    DMA: 527,
  },
  "46016": {
    DMA: 527,
  },
  "46017": {
    DMA: 527,
  },
  "46018": {
    DMA: 527,
  },
  "46030": {
    DMA: 527,
  },
  "46031": {
    DMA: 527,
  },
  "46032": {
    DMA: 527,
  },
  "46033": {
    DMA: 527,
  },
  "46034": {
    DMA: 527,
  },
  "46035": {
    DMA: 527,
  },
  "46036": {
    DMA: 527,
  },
  "46037": {
    DMA: 527,
  },
  "46038": {
    DMA: 527,
  },
  "46039": {
    DMA: 527,
  },
  "46040": {
    DMA: 527,
  },
  "46041": {
    DMA: 527,
  },
  "46044": {
    DMA: 527,
  },
  "46045": {
    DMA: 527,
  },
  "46047": {
    DMA: 527,
  },
  "46048": {
    DMA: 527,
  },
  "46049": {
    DMA: 527,
  },
  "46050": {
    DMA: 527,
  },
  "46051": {
    DMA: 527,
  },
  "46052": {
    DMA: 527,
  },
  "46055": {
    DMA: 527,
  },
  "46056": {
    DMA: 527,
  },
  "46057": {
    DMA: 527,
  },
  "46058": {
    DMA: 527,
  },
  "46060": {
    DMA: 527,
  },
  "46061": {
    DMA: 527,
  },
  "46062": {
    DMA: 527,
  },
  "46063": {
    DMA: 527,
  },
  "46064": {
    DMA: 527,
  },
  "46065": {
    DMA: 527,
  },
  "46067": {
    DMA: 527,
  },
  "46068": {
    DMA: 527,
  },
  "46069": {
    DMA: 527,
  },
  "46070": {
    DMA: 527,
  },
  "46071": {
    DMA: 527,
  },
  "46072": {
    DMA: 527,
  },
  "46074": {
    DMA: 527,
  },
  "46075": {
    DMA: 527,
  },
  "46076": {
    DMA: 527,
  },
  "46077": {
    DMA: 527,
  },
  "46082": {
    DMA: 527,
  },
  "46085": {
    DMA: 527,
  },
  "46102": {
    DMA: 527,
  },
  "46103": {
    DMA: 527,
  },
  "46104": {
    DMA: 527,
  },
  "46105": {
    DMA: 527,
  },
  "46106": {
    DMA: 527,
  },
  "46107": {
    DMA: 527,
  },
  "46110": {
    DMA: 527,
  },
  "46111": {
    DMA: 527,
  },
  "46112": {
    DMA: 527,
  },
  "46113": {
    DMA: 527,
  },
  "46115": {
    DMA: 527,
  },
  "46117": {
    DMA: 527,
  },
  "46118": {
    DMA: 527,
  },
  "46120": {
    DMA: 527,
  },
  "46121": {
    DMA: 527,
  },
  "46122": {
    DMA: 527,
  },
  "46123": {
    DMA: 527,
  },
  "46124": {
    DMA: 527,
  },
  "46125": {
    DMA: 527,
  },
  "46126": {
    DMA: 527,
  },
  "46127": {
    DMA: 527,
  },
  "46128": {
    DMA: 527,
  },
  "46129": {
    DMA: 527,
  },
  "46130": {
    DMA: 527,
  },
  "46131": {
    DMA: 527,
  },
  "46133": {
    DMA: 527,
  },
  "46135": {
    DMA: 527,
  },
  "46140": {
    DMA: 527,
  },
  "46142": {
    DMA: 527,
  },
  "46143": {
    DMA: 527,
  },
  "46144": {
    DMA: 527,
  },
  "46146": {
    DMA: 527,
  },
  "46147": {
    DMA: 527,
  },
  "46148": {
    DMA: 527,
  },
  "46149": {
    DMA: 527,
  },
  "46150": {
    DMA: 527,
  },
  "46151": {
    DMA: 527,
  },
  "46154": {
    DMA: 527,
  },
  "46155": {
    DMA: 527,
  },
  "46156": {
    DMA: 527,
  },
  "46157": {
    DMA: 527,
  },
  "46158": {
    DMA: 527,
  },
  "46160": {
    DMA: 527,
  },
  "46161": {
    DMA: 527,
  },
  "46162": {
    DMA: 527,
  },
  "46163": {
    DMA: 527,
  },
  "46164": {
    DMA: 527,
  },
  "46165": {
    DMA: 527,
  },
  "46166": {
    DMA: 527,
  },
  "46167": {
    DMA: 527,
  },
  "46168": {
    DMA: 527,
  },
  "46170": {
    DMA: 527,
  },
  "46171": {
    DMA: 527,
  },
  "46172": {
    DMA: 527,
  },
  "46173": {
    DMA: 527,
  },
  "46175": {
    DMA: 527,
  },
  "46176": {
    DMA: 527,
  },
  "46180": {
    DMA: 527,
  },
  "46181": {
    DMA: 527,
  },
  "46182": {
    DMA: 527,
  },
  "46183": {
    DMA: 527,
  },
  "46184": {
    DMA: 527,
  },
  "46186": {
    DMA: 527,
  },
  "46197": {
    DMA: 527,
  },
  "46201": {
    DMA: 527,
  },
  "46202": {
    DMA: 527,
  },
  "46203": {
    DMA: 527,
  },
  "46204": {
    DMA: 527,
  },
  "46205": {
    DMA: 527,
  },
  "46206": {
    DMA: 527,
  },
  "46207": {
    DMA: 527,
  },
  "46208": {
    DMA: 527,
  },
  "46209": {
    DMA: 527,
  },
  "46210": {
    DMA: 527,
  },
  "46211": {
    DMA: 527,
  },
  "46213": {
    DMA: 527,
  },
  "46214": {
    DMA: 527,
  },
  "46216": {
    DMA: 527,
  },
  "46217": {
    DMA: 527,
  },
  "46218": {
    DMA: 527,
  },
  "46219": {
    DMA: 527,
  },
  "46220": {
    DMA: 527,
  },
  "46221": {
    DMA: 527,
  },
  "46222": {
    DMA: 527,
  },
  "46223": {
    DMA: 527,
  },
  "46224": {
    DMA: 527,
  },
  "46225": {
    DMA: 527,
  },
  "46226": {
    DMA: 527,
  },
  "46227": {
    DMA: 527,
  },
  "46228": {
    DMA: 527,
  },
  "46229": {
    DMA: 527,
  },
  "46230": {
    DMA: 527,
  },
  "46231": {
    DMA: 527,
  },
  "46234": {
    DMA: 527,
  },
  "46235": {
    DMA: 527,
  },
  "46236": {
    DMA: 527,
  },
  "46237": {
    DMA: 527,
  },
  "46239": {
    DMA: 527,
  },
  "46240": {
    DMA: 527,
  },
  "46241": {
    DMA: 527,
  },
  "46242": {
    DMA: 527,
  },
  "46244": {
    DMA: 527,
  },
  "46247": {
    DMA: 527,
  },
  "46249": {
    DMA: 527,
  },
  "46250": {
    DMA: 527,
  },
  "46251": {
    DMA: 527,
  },
  "46253": {
    DMA: 527,
  },
  "46254": {
    DMA: 527,
  },
  "46255": {
    DMA: 527,
  },
  "46256": {
    DMA: 527,
  },
  "46259": {
    DMA: 527,
  },
  "46260": {
    DMA: 527,
  },
  "46262": {
    DMA: 527,
  },
  "46266": {
    DMA: 527,
  },
  "46268": {
    DMA: 527,
  },
  "46274": {
    DMA: 527,
  },
  "46275": {
    DMA: 527,
  },
  "46277": {
    DMA: 527,
  },
  "46278": {
    DMA: 527,
  },
  "46280": {
    DMA: 527,
  },
  "46282": {
    DMA: 527,
  },
  "46283": {
    DMA: 527,
  },
  "46285": {
    DMA: 527,
  },
  "46288": {
    DMA: 527,
  },
  "46290": {
    DMA: 527,
  },
  "46291": {
    DMA: 527,
  },
  "46295": {
    DMA: 527,
  },
  "46296": {
    DMA: 527,
  },
  "46298": {
    DMA: 527,
  },
  "46301": {
    DMA: 602,
  },
  "46302": {
    DMA: 602,
  },
  "46303": {
    DMA: 602,
  },
  "46304": {
    DMA: 602,
  },
  "46307": {
    DMA: 602,
  },
  "46308": {
    DMA: 602,
  },
  "46310": {
    DMA: 602,
  },
  "46311": {
    DMA: 602,
  },
  "46312": {
    DMA: 602,
  },
  "46319": {
    DMA: 602,
  },
  "46320": {
    DMA: 602,
  },
  "46321": {
    DMA: 602,
  },
  "46322": {
    DMA: 602,
  },
  "46323": {
    DMA: 602,
  },
  "46324": {
    DMA: 602,
  },
  "46325": {
    DMA: 602,
  },
  "46327": {
    DMA: 602,
  },
  "46340": {
    DMA: 602,
  },
  "46341": {
    DMA: 602,
  },
  "46342": {
    DMA: 602,
  },
  "46345": {
    DMA: 602,
  },
  "46346": {
    DMA: 602,
  },
  "46347": {
    DMA: 602,
  },
  "46348": {
    DMA: 602,
  },
  "46349": {
    DMA: 602,
  },
  "46350": {
    DMA: 602,
  },
  "46352": {
    DMA: 602,
  },
  "46355": {
    DMA: 602,
  },
  "46356": {
    DMA: 602,
  },
  "46360": {
    DMA: 602,
  },
  "46361": {
    DMA: 602,
  },
  "46365": {
    DMA: 602,
  },
  "46366": {
    DMA: 588,
  },
  "46368": {
    DMA: 602,
  },
  "46371": {
    DMA: 602,
  },
  "46372": {
    DMA: 602,
  },
  "46373": {
    DMA: 602,
  },
  "46374": {
    DMA: 588,
  },
  "46375": {
    DMA: 602,
  },
  "46376": {
    DMA: 602,
  },
  "46377": {
    DMA: 602,
  },
  "46379": {
    DMA: 602,
  },
  "46380": {
    DMA: 602,
  },
  "46381": {
    DMA: 602,
  },
  "46382": {
    DMA: 602,
  },
  "46383": {
    DMA: 602,
  },
  "46384": {
    DMA: 602,
  },
  "46385": {
    DMA: 602,
  },
  "46390": {
    DMA: 602,
  },
  "46391": {
    DMA: 602,
  },
  "46392": {
    DMA: 602,
  },
  "46393": {
    DMA: 602,
  },
  "46394": {
    DMA: 602,
  },
  "46401": {
    DMA: 602,
  },
  "46402": {
    DMA: 602,
  },
  "46403": {
    DMA: 602,
  },
  "46404": {
    DMA: 602,
  },
  "46405": {
    DMA: 602,
  },
  "46406": {
    DMA: 602,
  },
  "46407": {
    DMA: 602,
  },
  "46408": {
    DMA: 602,
  },
  "46409": {
    DMA: 602,
  },
  "46410": {
    DMA: 602,
  },
  "46411": {
    DMA: 602,
  },
  "46501": {
    DMA: 588,
  },
  "46502": {
    DMA: 588,
  },
  "46504": {
    DMA: 588,
  },
  "46506": {
    DMA: 588,
  },
  "46507": {
    DMA: 588,
  },
  "46508": {
    DMA: 588,
  },
  "46510": {
    DMA: 588,
  },
  "46511": {
    DMA: 588,
  },
  "46513": {
    DMA: 588,
  },
  "46514": {
    DMA: 588,
  },
  "46515": {
    DMA: 588,
  },
  "46516": {
    DMA: 588,
  },
  "46517": {
    DMA: 588,
  },
  "46524": {
    DMA: 588,
  },
  "46526": {
    DMA: 588,
  },
  "46527": {
    DMA: 588,
  },
  "46528": {
    DMA: 588,
  },
  "46530": {
    DMA: 588,
  },
  "46531": {
    DMA: 588,
  },
  "46532": {
    DMA: 588,
  },
  "46534": {
    DMA: 588,
  },
  "46536": {
    DMA: 588,
  },
  "46537": {
    DMA: 588,
  },
  "46538": {
    DMA: 588,
  },
  "46539": {
    DMA: 588,
  },
  "46540": {
    DMA: 588,
  },
  "46542": {
    DMA: 588,
  },
  "46543": {
    DMA: 588,
  },
  "46544": {
    DMA: 588,
  },
  "46545": {
    DMA: 588,
  },
  "46546": {
    DMA: 588,
  },
  "46550": {
    DMA: 588,
  },
  "46552": {
    DMA: 588,
  },
  "46553": {
    DMA: 588,
  },
  "46554": {
    DMA: 588,
  },
  "46555": {
    DMA: 588,
  },
  "46556": {
    DMA: 588,
  },
  "46561": {
    DMA: 588,
  },
  "46562": {
    DMA: 588,
  },
  "46563": {
    DMA: 588,
  },
  "46565": {
    DMA: 588,
  },
  "46567": {
    DMA: 588,
  },
  "46570": {
    DMA: 588,
  },
  "46571": {
    DMA: 588,
  },
  "46572": {
    DMA: 588,
  },
  "46573": {
    DMA: 588,
  },
  "46574": {
    DMA: 588,
  },
  "46580": {
    DMA: 588,
  },
  "46581": {
    DMA: 588,
  },
  "46582": {
    DMA: 588,
  },
  "46590": {
    DMA: 588,
  },
  "46595": {
    DMA: 588,
  },
  "46601": {
    DMA: 588,
  },
  "46604": {
    DMA: 588,
  },
  "46613": {
    DMA: 588,
  },
  "46614": {
    DMA: 588,
  },
  "46615": {
    DMA: 588,
  },
  "46616": {
    DMA: 588,
  },
  "46617": {
    DMA: 588,
  },
  "46619": {
    DMA: 588,
  },
  "46620": {
    DMA: 588,
  },
  "46624": {
    DMA: 588,
  },
  "46626": {
    DMA: 588,
  },
  "46628": {
    DMA: 588,
  },
  "46634": {
    DMA: 588,
  },
  "46635": {
    DMA: 588,
  },
  "46637": {
    DMA: 588,
  },
  "46660": {
    DMA: 588,
  },
  "46680": {
    DMA: 588,
  },
  "46699": {
    DMA: 588,
  },
  "46701": {
    DMA: 509,
  },
  "46702": {
    DMA: 509,
  },
  "46703": {
    DMA: 509,
  },
  "46704": {
    DMA: 509,
  },
  "46705": {
    DMA: 509,
  },
  "46706": {
    DMA: 509,
  },
  "46710": {
    DMA: 509,
  },
  "46711": {
    DMA: 509,
  },
  "46713": {
    DMA: 509,
  },
  "46714": {
    DMA: 509,
  },
  "46721": {
    DMA: 509,
  },
  "46723": {
    DMA: 509,
  },
  "46725": {
    DMA: 509,
  },
  "46730": {
    DMA: 509,
  },
  "46731": {
    DMA: 509,
  },
  "46732": {
    DMA: 509,
  },
  "46733": {
    DMA: 509,
  },
  "46737": {
    DMA: 509,
  },
  "46738": {
    DMA: 509,
  },
  "46740": {
    DMA: 509,
  },
  "46741": {
    DMA: 509,
  },
  "46742": {
    DMA: 509,
  },
  "46743": {
    DMA: 509,
  },
  "46745": {
    DMA: 509,
  },
  "46746": {
    DMA: 588,
  },
  "46747": {
    DMA: 509,
  },
  "46748": {
    DMA: 509,
  },
  "46750": {
    DMA: 509,
  },
  "46755": {
    DMA: 509,
  },
  "46759": {
    DMA: 509,
  },
  "46760": {
    DMA: 509,
  },
  "46761": {
    DMA: 588,
  },
  "46763": {
    DMA: 509,
  },
  "46764": {
    DMA: 509,
  },
  "46765": {
    DMA: 509,
  },
  "46766": {
    DMA: 509,
  },
  "46767": {
    DMA: 509,
  },
  "46769": {
    DMA: 509,
  },
  "46770": {
    DMA: 509,
  },
  "46771": {
    DMA: 588,
  },
  "46772": {
    DMA: 509,
  },
  "46773": {
    DMA: 509,
  },
  "46774": {
    DMA: 509,
  },
  "46776": {
    DMA: 509,
  },
  "46777": {
    DMA: 509,
  },
  "46778": {
    DMA: 509,
  },
  "46779": {
    DMA: 509,
  },
  "46780": {
    DMA: 509,
  },
  "46781": {
    DMA: 509,
  },
  "46782": {
    DMA: 509,
  },
  "46783": {
    DMA: 509,
  },
  "46784": {
    DMA: 509,
  },
  "46785": {
    DMA: 509,
  },
  "46786": {
    DMA: 588,
  },
  "46787": {
    DMA: 509,
  },
  "46788": {
    DMA: 509,
  },
  "46789": {
    DMA: 588,
  },
  "46791": {
    DMA: 509,
  },
  "46792": {
    DMA: 509,
  },
  "46793": {
    DMA: 509,
  },
  "46794": {
    DMA: 509,
  },
  "46795": {
    DMA: 588,
  },
  "46796": {
    DMA: 509,
  },
  "46797": {
    DMA: 509,
  },
  "46798": {
    DMA: 509,
  },
  "46799": {
    DMA: 509,
  },
  "46801": {
    DMA: 509,
  },
  "46802": {
    DMA: 509,
  },
  "46803": {
    DMA: 509,
  },
  "46804": {
    DMA: 509,
  },
  "46805": {
    DMA: 509,
  },
  "46806": {
    DMA: 509,
  },
  "46807": {
    DMA: 509,
  },
  "46808": {
    DMA: 509,
  },
  "46809": {
    DMA: 509,
  },
  "46814": {
    DMA: 509,
  },
  "46815": {
    DMA: 509,
  },
  "46816": {
    DMA: 509,
  },
  "46818": {
    DMA: 509,
  },
  "46819": {
    DMA: 509,
  },
  "46825": {
    DMA: 509,
  },
  "46835": {
    DMA: 509,
  },
  "46845": {
    DMA: 509,
  },
  "46850": {
    DMA: 509,
  },
  "46851": {
    DMA: 509,
  },
  "46852": {
    DMA: 509,
  },
  "46853": {
    DMA: 509,
  },
  "46854": {
    DMA: 509,
  },
  "46855": {
    DMA: 509,
  },
  "46856": {
    DMA: 509,
  },
  "46857": {
    DMA: 509,
  },
  "46858": {
    DMA: 509,
  },
  "46859": {
    DMA: 509,
  },
  "46860": {
    DMA: 509,
  },
  "46861": {
    DMA: 509,
  },
  "46862": {
    DMA: 509,
  },
  "46863": {
    DMA: 509,
  },
  "46864": {
    DMA: 509,
  },
  "46865": {
    DMA: 509,
  },
  "46866": {
    DMA: 509,
  },
  "46867": {
    DMA: 509,
  },
  "46868": {
    DMA: 509,
  },
  "46869": {
    DMA: 509,
  },
  "46885": {
    DMA: 509,
  },
  "46895": {
    DMA: 509,
  },
  "46896": {
    DMA: 509,
  },
  "46897": {
    DMA: 509,
  },
  "46898": {
    DMA: 509,
  },
  "46899": {
    DMA: 509,
  },
  "46901": {
    DMA: 527,
  },
  "46902": {
    DMA: 527,
  },
  "46903": {
    DMA: 527,
  },
  "46904": {
    DMA: 527,
  },
  "46910": {
    DMA: 588,
  },
  "46911": {
    DMA: 527,
  },
  "46912": {
    DMA: 588,
  },
  "46913": {
    DMA: 527,
  },
  "46914": {
    DMA: 527,
  },
  "46915": {
    DMA: 527,
  },
  "46916": {
    DMA: 527,
  },
  "46917": {
    DMA: 527,
  },
  "46919": {
    DMA: 527,
  },
  "46920": {
    DMA: 527,
  },
  "46921": {
    DMA: 527,
  },
  "46922": {
    DMA: 588,
  },
  "46923": {
    DMA: 527,
  },
  "46926": {
    DMA: 527,
  },
  "46928": {
    DMA: 527,
  },
  "46929": {
    DMA: 527,
  },
  "46930": {
    DMA: 527,
  },
  "46931": {
    DMA: 588,
  },
  "46932": {
    DMA: 527,
  },
  "46933": {
    DMA: 527,
  },
  "46935": {
    DMA: 588,
  },
  "46936": {
    DMA: 527,
  },
  "46937": {
    DMA: 527,
  },
  "46938": {
    DMA: 527,
  },
  "46939": {
    DMA: 588,
  },
  "46940": {
    DMA: 509,
  },
  "46941": {
    DMA: 509,
  },
  "46942": {
    DMA: 527,
  },
  "46943": {
    DMA: 509,
  },
  "46945": {
    DMA: 588,
  },
  "46946": {
    DMA: 509,
  },
  "46947": {
    DMA: 527,
  },
  "46950": {
    DMA: 527,
  },
  "46951": {
    DMA: 527,
  },
  "46952": {
    DMA: 527,
  },
  "46953": {
    DMA: 527,
  },
  "46957": {
    DMA: 527,
  },
  "46958": {
    DMA: 527,
  },
  "46959": {
    DMA: 527,
  },
  "46960": {
    DMA: 588,
  },
  "46961": {
    DMA: 527,
  },
  "46962": {
    DMA: 509,
  },
  "46965": {
    DMA: 527,
  },
  "46967": {
    DMA: 527,
  },
  "46968": {
    DMA: 588,
  },
  "46970": {
    DMA: 527,
  },
  "46971": {
    DMA: 527,
  },
  "46974": {
    DMA: 509,
  },
  "46975": {
    DMA: 588,
  },
  "46977": {
    DMA: 527,
  },
  "46978": {
    DMA: 527,
  },
  "46979": {
    DMA: 527,
  },
  "46980": {
    DMA: 509,
  },
  "46982": {
    DMA: 588,
  },
  "46984": {
    DMA: 509,
  },
  "46985": {
    DMA: 588,
  },
  "46986": {
    DMA: 527,
  },
  "46987": {
    DMA: 527,
  },
  "46988": {
    DMA: 527,
  },
  "46989": {
    DMA: 527,
  },
  "46990": {
    DMA: 509,
  },
  "46991": {
    DMA: 527,
  },
  "46992": {
    DMA: 509,
  },
  "46994": {
    DMA: 527,
  },
  "46995": {
    DMA: 527,
  },
  "46996": {
    DMA: 588,
  },
  "46998": {
    DMA: 527,
  },
  "47001": {
    DMA: 515,
  },
  "47003": {
    DMA: 515,
  },
  "47006": {
    DMA: 515,
  },
  "47010": {
    DMA: 515,
  },
  "47011": {
    DMA: 515,
  },
  "47012": {
    DMA: 515,
  },
  "47016": {
    DMA: 515,
  },
  "47017": {
    DMA: 515,
  },
  "47018": {
    DMA: 515,
  },
  "47019": {
    DMA: 515,
  },
  "47020": {
    DMA: 515,
  },
  "47021": {
    DMA: 515,
  },
  "47022": {
    DMA: 515,
  },
  "47023": {
    DMA: 515,
  },
  "47024": {
    DMA: 515,
  },
  "47025": {
    DMA: 515,
  },
  "47030": {
    DMA: 515,
  },
  "47031": {
    DMA: 515,
  },
  "47032": {
    DMA: 515,
  },
  "47033": {
    DMA: 515,
  },
  "47034": {
    DMA: 515,
  },
  "47035": {
    DMA: 515,
  },
  "47036": {
    DMA: 515,
  },
  "47037": {
    DMA: 515,
  },
  "47038": {
    DMA: 515,
  },
  "47039": {
    DMA: 515,
  },
  "47040": {
    DMA: 515,
  },
  "47041": {
    DMA: 515,
  },
  "47042": {
    DMA: 515,
  },
  "47043": {
    DMA: 515,
  },
  "47060": {
    DMA: 515,
  },
  "47102": {
    DMA: 529,
  },
  "47104": {
    DMA: 529,
  },
  "47106": {
    DMA: 529,
  },
  "47107": {
    DMA: 529,
  },
  "47108": {
    DMA: 529,
  },
  "47110": {
    DMA: 529,
  },
  "47111": {
    DMA: 529,
  },
  "47112": {
    DMA: 529,
  },
  "47114": {
    DMA: 529,
  },
  "47115": {
    DMA: 529,
  },
  "47116": {
    DMA: 529,
  },
  "47117": {
    DMA: 529,
  },
  "47118": {
    DMA: 529,
  },
  "47119": {
    DMA: 529,
  },
  "47120": {
    DMA: 529,
  },
  "47122": {
    DMA: 529,
  },
  "47123": {
    DMA: 529,
  },
  "47124": {
    DMA: 529,
  },
  "47125": {
    DMA: 529,
  },
  "47126": {
    DMA: 529,
  },
  "47129": {
    DMA: 529,
  },
  "47130": {
    DMA: 529,
  },
  "47131": {
    DMA: 529,
  },
  "47132": {
    DMA: 529,
  },
  "47133": {
    DMA: 529,
  },
  "47134": {
    DMA: 529,
  },
  "47135": {
    DMA: 529,
  },
  "47136": {
    DMA: 529,
  },
  "47137": {
    DMA: 529,
  },
  "47138": {
    DMA: 529,
  },
  "47139": {
    DMA: 529,
  },
  "47140": {
    DMA: 529,
  },
  "47141": {
    DMA: 529,
  },
  "47142": {
    DMA: 529,
  },
  "47143": {
    DMA: 529,
  },
  "47144": {
    DMA: 529,
  },
  "47145": {
    DMA: 529,
  },
  "47146": {
    DMA: 529,
  },
  "47147": {
    DMA: 529,
  },
  "47150": {
    DMA: 529,
  },
  "47151": {
    DMA: 529,
  },
  "47160": {
    DMA: 529,
  },
  "47161": {
    DMA: 529,
  },
  "47162": {
    DMA: 529,
  },
  "47163": {
    DMA: 529,
  },
  "47164": {
    DMA: 529,
  },
  "47165": {
    DMA: 529,
  },
  "47166": {
    DMA: 529,
  },
  "47167": {
    DMA: 529,
  },
  "47170": {
    DMA: 529,
  },
  "47172": {
    DMA: 529,
  },
  "47174": {
    DMA: 529,
  },
  "47175": {
    DMA: 529,
  },
  "47177": {
    DMA: 529,
  },
  "47190": {
    DMA: 529,
  },
  "47199": {
    DMA: 529,
  },
  "47201": {
    DMA: 527,
  },
  "47202": {
    DMA: 527,
  },
  "47203": {
    DMA: 527,
  },
  "47220": {
    DMA: 529,
  },
  "47223": {
    DMA: 529,
  },
  "47224": {
    DMA: 529,
  },
  "47225": {
    DMA: 527,
  },
  "47226": {
    DMA: 527,
  },
  "47227": {
    DMA: 529,
  },
  "47228": {
    DMA: 529,
  },
  "47229": {
    DMA: 529,
  },
  "47230": {
    DMA: 529,
  },
  "47231": {
    DMA: 529,
  },
  "47232": {
    DMA: 527,
  },
  "47234": {
    DMA: 527,
  },
  "47235": {
    DMA: 529,
  },
  "47236": {
    DMA: 527,
  },
  "47240": {
    DMA: 527,
  },
  "47243": {
    DMA: 529,
  },
  "47244": {
    DMA: 527,
  },
  "47245": {
    DMA: 529,
  },
  "47246": {
    DMA: 527,
  },
  "47247": {
    DMA: 527,
  },
  "47249": {
    DMA: 529,
  },
  "47250": {
    DMA: 529,
  },
  "47260": {
    DMA: 529,
  },
  "47261": {
    DMA: 515,
  },
  "47263": {
    DMA: 527,
  },
  "47264": {
    DMA: 529,
  },
  "47265": {
    DMA: 529,
  },
  "47270": {
    DMA: 529,
  },
  "47272": {
    DMA: 527,
  },
  "47273": {
    DMA: 529,
  },
  "47274": {
    DMA: 529,
  },
  "47280": {
    DMA: 527,
  },
  "47281": {
    DMA: 529,
  },
  "47282": {
    DMA: 529,
  },
  "47283": {
    DMA: 527,
  },
  "47302": {
    DMA: 527,
  },
  "47303": {
    DMA: 527,
  },
  "47304": {
    DMA: 527,
  },
  "47305": {
    DMA: 527,
  },
  "47306": {
    DMA: 527,
  },
  "47307": {
    DMA: 527,
  },
  "47308": {
    DMA: 527,
  },
  "47320": {
    DMA: 527,
  },
  "47322": {
    DMA: 527,
  },
  "47324": {
    DMA: 542,
  },
  "47325": {
    DMA: 515,
  },
  "47326": {
    DMA: 509,
  },
  "47327": {
    DMA: 542,
  },
  "47330": {
    DMA: 542,
  },
  "47331": {
    DMA: 527,
  },
  "47334": {
    DMA: 527,
  },
  "47335": {
    DMA: 542,
  },
  "47336": {
    DMA: 509,
  },
  "47337": {
    DMA: 527,
  },
  "47338": {
    DMA: 527,
  },
  "47339": {
    DMA: 542,
  },
  "47340": {
    DMA: 527,
  },
  "47341": {
    DMA: 542,
  },
  "47342": {
    DMA: 527,
  },
  "47344": {
    DMA: 527,
  },
  "47345": {
    DMA: 542,
  },
  "47346": {
    DMA: 542,
  },
  "47348": {
    DMA: 527,
  },
  "47351": {
    DMA: 527,
  },
  "47352": {
    DMA: 527,
  },
  "47353": {
    DMA: 515,
  },
  "47354": {
    DMA: 527,
  },
  "47355": {
    DMA: 527,
  },
  "47356": {
    DMA: 527,
  },
  "47357": {
    DMA: 542,
  },
  "47358": {
    DMA: 527,
  },
  "47359": {
    DMA: 527,
  },
  "47360": {
    DMA: 527,
  },
  "47361": {
    DMA: 527,
  },
  "47362": {
    DMA: 527,
  },
  "47366": {
    DMA: 527,
  },
  "47367": {
    DMA: 527,
  },
  "47368": {
    DMA: 527,
  },
  "47369": {
    DMA: 509,
  },
  "47370": {
    DMA: 542,
  },
  "47371": {
    DMA: 509,
  },
  "47373": {
    DMA: 509,
  },
  "47374": {
    DMA: 542,
  },
  "47375": {
    DMA: 542,
  },
  "47380": {
    DMA: 527,
  },
  "47381": {
    DMA: 509,
  },
  "47382": {
    DMA: 527,
  },
  "47383": {
    DMA: 527,
  },
  "47384": {
    DMA: 527,
  },
  "47385": {
    DMA: 527,
  },
  "47386": {
    DMA: 527,
  },
  "47387": {
    DMA: 527,
  },
  "47388": {
    DMA: 527,
  },
  "47390": {
    DMA: 527,
  },
  "47392": {
    DMA: 542,
  },
  "47393": {
    DMA: 542,
  },
  "47394": {
    DMA: 527,
  },
  "47396": {
    DMA: 527,
  },
  "47401": {
    DMA: 527,
  },
  "47402": {
    DMA: 527,
  },
  "47403": {
    DMA: 527,
  },
  "47404": {
    DMA: 527,
  },
  "47405": {
    DMA: 527,
  },
  "47406": {
    DMA: 527,
  },
  "47407": {
    DMA: 527,
  },
  "47408": {
    DMA: 527,
  },
  "47420": {
    DMA: 527,
  },
  "47421": {
    DMA: 527,
  },
  "47424": {
    DMA: 581,
  },
  "47426": {
    DMA: 527,
  },
  "47427": {
    DMA: 527,
  },
  "47429": {
    DMA: 527,
  },
  "47430": {
    DMA: 527,
  },
  "47431": {
    DMA: 527,
  },
  "47432": {
    DMA: 529,
  },
  "47433": {
    DMA: 527,
  },
  "47434": {
    DMA: 527,
  },
  "47435": {
    DMA: 527,
  },
  "47436": {
    DMA: 527,
  },
  "47437": {
    DMA: 527,
  },
  "47438": {
    DMA: 581,
  },
  "47439": {
    DMA: 581,
  },
  "47441": {
    DMA: 581,
  },
  "47443": {
    DMA: 581,
  },
  "47445": {
    DMA: 581,
  },
  "47446": {
    DMA: 527,
  },
  "47448": {
    DMA: 527,
  },
  "47449": {
    DMA: 581,
  },
  "47451": {
    DMA: 527,
  },
  "47452": {
    DMA: 529,
  },
  "47453": {
    DMA: 581,
  },
  "47454": {
    DMA: 529,
  },
  "47455": {
    DMA: 527,
  },
  "47456": {
    DMA: 527,
  },
  "47457": {
    DMA: 581,
  },
  "47458": {
    DMA: 527,
  },
  "47459": {
    DMA: 581,
  },
  "47460": {
    DMA: 527,
  },
  "47462": {
    DMA: 527,
  },
  "47463": {
    DMA: 527,
  },
  "47464": {
    DMA: 527,
  },
  "47465": {
    DMA: 581,
  },
  "47467": {
    DMA: 527,
  },
  "47468": {
    DMA: 527,
  },
  "47469": {
    DMA: 529,
  },
  "47470": {
    DMA: 527,
  },
  "47471": {
    DMA: 581,
  },
  "47490": {
    DMA: 527,
  },
  "47501": {
    DMA: 581,
  },
  "47512": {
    DMA: 581,
  },
  "47513": {
    DMA: 649,
  },
  "47514": {
    DMA: 649,
  },
  "47515": {
    DMA: 649,
  },
  "47516": {
    DMA: 581,
  },
  "47519": {
    DMA: 581,
  },
  "47520": {
    DMA: 649,
  },
  "47521": {
    DMA: 649,
  },
  "47522": {
    DMA: 581,
  },
  "47523": {
    DMA: 649,
  },
  "47524": {
    DMA: 581,
  },
  "47525": {
    DMA: 649,
  },
  "47527": {
    DMA: 649,
  },
  "47528": {
    DMA: 581,
  },
  "47529": {
    DMA: 581,
  },
  "47531": {
    DMA: 649,
  },
  "47532": {
    DMA: 649,
  },
  "47535": {
    DMA: 581,
  },
  "47536": {
    DMA: 649,
  },
  "47537": {
    DMA: 649,
  },
  "47541": {
    DMA: 649,
  },
  "47542": {
    DMA: 649,
  },
  "47545": {
    DMA: 649,
  },
  "47546": {
    DMA: 649,
  },
  "47547": {
    DMA: 649,
  },
  "47549": {
    DMA: 649,
  },
  "47550": {
    DMA: 649,
  },
  "47551": {
    DMA: 649,
  },
  "47552": {
    DMA: 649,
  },
  "47553": {
    DMA: 581,
  },
  "47556": {
    DMA: 649,
  },
  "47557": {
    DMA: 581,
  },
  "47558": {
    DMA: 581,
  },
  "47561": {
    DMA: 581,
  },
  "47562": {
    DMA: 581,
  },
  "47564": {
    DMA: 649,
  },
  "47567": {
    DMA: 649,
  },
  "47568": {
    DMA: 581,
  },
  "47573": {
    DMA: 581,
  },
  "47574": {
    DMA: 649,
  },
  "47575": {
    DMA: 649,
  },
  "47576": {
    DMA: 649,
  },
  "47577": {
    DMA: 649,
  },
  "47578": {
    DMA: 581,
  },
  "47579": {
    DMA: 649,
  },
  "47580": {
    DMA: 649,
  },
  "47581": {
    DMA: 581,
  },
  "47584": {
    DMA: 649,
  },
  "47585": {
    DMA: 649,
  },
  "47586": {
    DMA: 649,
  },
  "47588": {
    DMA: 649,
  },
  "47590": {
    DMA: 649,
  },
  "47591": {
    DMA: 581,
  },
  "47596": {
    DMA: 581,
  },
  "47597": {
    DMA: 581,
  },
  "47598": {
    DMA: 649,
  },
  "47601": {
    DMA: 649,
  },
  "47610": {
    DMA: 649,
  },
  "47611": {
    DMA: 649,
  },
  "47612": {
    DMA: 649,
  },
  "47613": {
    DMA: 649,
  },
  "47614": {
    DMA: 649,
  },
  "47615": {
    DMA: 649,
  },
  "47616": {
    DMA: 649,
  },
  "47617": {
    DMA: 649,
  },
  "47618": {
    DMA: 649,
  },
  "47619": {
    DMA: 649,
  },
  "47620": {
    DMA: 649,
  },
  "47629": {
    DMA: 649,
  },
  "47630": {
    DMA: 649,
  },
  "47631": {
    DMA: 649,
  },
  "47633": {
    DMA: 649,
  },
  "47634": {
    DMA: 649,
  },
  "47635": {
    DMA: 649,
  },
  "47637": {
    DMA: 649,
  },
  "47638": {
    DMA: 649,
  },
  "47639": {
    DMA: 649,
  },
  "47640": {
    DMA: 649,
  },
  "47647": {
    DMA: 649,
  },
  "47648": {
    DMA: 649,
  },
  "47649": {
    DMA: 649,
  },
  "47654": {
    DMA: 649,
  },
  "47660": {
    DMA: 649,
  },
  "47665": {
    DMA: 649,
  },
  "47666": {
    DMA: 649,
  },
  "47670": {
    DMA: 649,
  },
  "47683": {
    DMA: 649,
  },
  "47701": {
    DMA: 649,
  },
  "47702": {
    DMA: 649,
  },
  "47703": {
    DMA: 649,
  },
  "47704": {
    DMA: 649,
  },
  "47705": {
    DMA: 649,
  },
  "47706": {
    DMA: 649,
  },
  "47708": {
    DMA: 649,
  },
  "47710": {
    DMA: 649,
  },
  "47711": {
    DMA: 649,
  },
  "47712": {
    DMA: 649,
  },
  "47713": {
    DMA: 649,
  },
  "47714": {
    DMA: 649,
  },
  "47715": {
    DMA: 649,
  },
  "47716": {
    DMA: 649,
  },
  "47719": {
    DMA: 649,
  },
  "47720": {
    DMA: 649,
  },
  "47721": {
    DMA: 649,
  },
  "47722": {
    DMA: 649,
  },
  "47724": {
    DMA: 649,
  },
  "47725": {
    DMA: 649,
  },
  "47727": {
    DMA: 649,
  },
  "47728": {
    DMA: 649,
  },
  "47730": {
    DMA: 649,
  },
  "47731": {
    DMA: 649,
  },
  "47732": {
    DMA: 649,
  },
  "47733": {
    DMA: 649,
  },
  "47734": {
    DMA: 649,
  },
  "47735": {
    DMA: 649,
  },
  "47736": {
    DMA: 649,
  },
  "47737": {
    DMA: 649,
  },
  "47739": {
    DMA: 649,
  },
  "47740": {
    DMA: 649,
  },
  "47741": {
    DMA: 649,
  },
  "47744": {
    DMA: 649,
  },
  "47747": {
    DMA: 649,
  },
  "47750": {
    DMA: 649,
  },
  "47801": {
    DMA: 581,
  },
  "47802": {
    DMA: 581,
  },
  "47803": {
    DMA: 581,
  },
  "47804": {
    DMA: 581,
  },
  "47805": {
    DMA: 581,
  },
  "47807": {
    DMA: 581,
  },
  "47808": {
    DMA: 581,
  },
  "47809": {
    DMA: 581,
  },
  "47811": {
    DMA: 581,
  },
  "47812": {
    DMA: 581,
  },
  "47830": {
    DMA: 581,
  },
  "47831": {
    DMA: 581,
  },
  "47832": {
    DMA: 581,
  },
  "47833": {
    DMA: 581,
  },
  "47834": {
    DMA: 581,
  },
  "47836": {
    DMA: 581,
  },
  "47837": {
    DMA: 581,
  },
  "47838": {
    DMA: 581,
  },
  "47840": {
    DMA: 581,
  },
  "47841": {
    DMA: 581,
  },
  "47842": {
    DMA: 581,
  },
  "47845": {
    DMA: 581,
  },
  "47846": {
    DMA: 581,
  },
  "47847": {
    DMA: 581,
  },
  "47848": {
    DMA: 581,
  },
  "47849": {
    DMA: 581,
  },
  "47850": {
    DMA: 581,
  },
  "47851": {
    DMA: 581,
  },
  "47852": {
    DMA: 581,
  },
  "47853": {
    DMA: 581,
  },
  "47854": {
    DMA: 581,
  },
  "47855": {
    DMA: 581,
  },
  "47856": {
    DMA: 581,
  },
  "47857": {
    DMA: 581,
  },
  "47858": {
    DMA: 581,
  },
  "47859": {
    DMA: 581,
  },
  "47860": {
    DMA: 581,
  },
  "47861": {
    DMA: 581,
  },
  "47862": {
    DMA: 581,
  },
  "47863": {
    DMA: 581,
  },
  "47864": {
    DMA: 581,
  },
  "47865": {
    DMA: 581,
  },
  "47866": {
    DMA: 581,
  },
  "47868": {
    DMA: 527,
  },
  "47869": {
    DMA: 581,
  },
  "47870": {
    DMA: 581,
  },
  "47871": {
    DMA: 581,
  },
  "47872": {
    DMA: 581,
  },
  "47874": {
    DMA: 581,
  },
  "47875": {
    DMA: 581,
  },
  "47876": {
    DMA: 581,
  },
  "47878": {
    DMA: 581,
  },
  "47879": {
    DMA: 581,
  },
  "47880": {
    DMA: 581,
  },
  "47881": {
    DMA: 581,
  },
  "47882": {
    DMA: 581,
  },
  "47884": {
    DMA: 581,
  },
  "47885": {
    DMA: 581,
  },
  "47901": {
    DMA: 582,
  },
  "47902": {
    DMA: 582,
  },
  "47903": {
    DMA: 582,
  },
  "47904": {
    DMA: 582,
  },
  "47905": {
    DMA: 582,
  },
  "47906": {
    DMA: 582,
  },
  "47907": {
    DMA: 582,
  },
  "47909": {
    DMA: 582,
  },
  "47916": {
    DMA: 527,
  },
  "47917": {
    DMA: 582,
  },
  "47918": {
    DMA: 527,
  },
  "47920": {
    DMA: 582,
  },
  "47921": {
    DMA: 582,
  },
  "47922": {
    DMA: 602,
  },
  "47923": {
    DMA: 527,
  },
  "47924": {
    DMA: 582,
  },
  "47925": {
    DMA: 527,
  },
  "47926": {
    DMA: 527,
  },
  "47928": {
    DMA: 581,
  },
  "47929": {
    DMA: 527,
  },
  "47930": {
    DMA: 582,
  },
  "47932": {
    DMA: 527,
  },
  "47933": {
    DMA: 527,
  },
  "47934": {
    DMA: 527,
  },
  "47935": {
    DMA: 527,
  },
  "47936": {
    DMA: 527,
  },
  "47937": {
    DMA: 527,
  },
  "47938": {
    DMA: 527,
  },
  "47939": {
    DMA: 527,
  },
  "47940": {
    DMA: 527,
  },
  "47941": {
    DMA: 582,
  },
  "47942": {
    DMA: 582,
  },
  "47943": {
    DMA: 602,
  },
  "47944": {
    DMA: 582,
  },
  "47946": {
    DMA: 588,
  },
  "47948": {
    DMA: 602,
  },
  "47949": {
    DMA: 527,
  },
  "47950": {
    DMA: 527,
  },
  "47951": {
    DMA: 602,
  },
  "47952": {
    DMA: 527,
  },
  "47954": {
    DMA: 527,
  },
  "47955": {
    DMA: 527,
  },
  "47957": {
    DMA: 588,
  },
  "47958": {
    DMA: 527,
  },
  "47959": {
    DMA: 527,
  },
  "47960": {
    DMA: 527,
  },
  "47962": {
    DMA: 582,
  },
  "47963": {
    DMA: 602,
  },
  "47964": {
    DMA: 602,
  },
  "47965": {
    DMA: 527,
  },
  "47966": {
    DMA: 581,
  },
  "47967": {
    DMA: 527,
  },
  "47968": {
    DMA: 527,
  },
  "47969": {
    DMA: 527,
  },
  "47970": {
    DMA: 582,
  },
  "47971": {
    DMA: 582,
  },
  "47974": {
    DMA: 581,
  },
  "47975": {
    DMA: 582,
  },
  "47977": {
    DMA: 602,
  },
  "47978": {
    DMA: 602,
  },
  "47980": {
    DMA: 527,
  },
  "47981": {
    DMA: 582,
  },
  "47982": {
    DMA: 582,
  },
  "47983": {
    DMA: 582,
  },
  "47984": {
    DMA: 582,
  },
  "47986": {
    DMA: 582,
  },
  "47987": {
    DMA: 527,
  },
  "47988": {
    DMA: 527,
  },
  "47989": {
    DMA: 527,
  },
  "47990": {
    DMA: 527,
  },
  "47991": {
    DMA: 582,
  },
  "47992": {
    DMA: 582,
  },
  "47993": {
    DMA: 582,
  },
  "47994": {
    DMA: 527,
  },
  "47995": {
    DMA: 527,
  },
  "47996": {
    DMA: 582,
  },
  "47997": {
    DMA: 527,
  },
  "48001": {
    DMA: 505,
  },
  "48002": {
    DMA: 505,
  },
  "48003": {
    DMA: 505,
  },
  "48004": {
    DMA: 505,
  },
  "48005": {
    DMA: 505,
  },
  "48006": {
    DMA: 505,
  },
  "48007": {
    DMA: 505,
  },
  "48009": {
    DMA: 505,
  },
  "48012": {
    DMA: 505,
  },
  "48014": {
    DMA: 505,
  },
  "48015": {
    DMA: 505,
  },
  "48017": {
    DMA: 505,
  },
  "48021": {
    DMA: 505,
  },
  "48022": {
    DMA: 505,
  },
  "48023": {
    DMA: 505,
  },
  "48025": {
    DMA: 505,
  },
  "48026": {
    DMA: 505,
  },
  "48027": {
    DMA: 505,
  },
  "48028": {
    DMA: 505,
  },
  "48030": {
    DMA: 505,
  },
  "48032": {
    DMA: 505,
  },
  "48033": {
    DMA: 505,
  },
  "48034": {
    DMA: 505,
  },
  "48035": {
    DMA: 505,
  },
  "48036": {
    DMA: 505,
  },
  "48037": {
    DMA: 505,
  },
  "48038": {
    DMA: 505,
  },
  "48039": {
    DMA: 505,
  },
  "48040": {
    DMA: 505,
  },
  "48041": {
    DMA: 505,
  },
  "48042": {
    DMA: 505,
  },
  "48043": {
    DMA: 505,
  },
  "48044": {
    DMA: 505,
  },
  "48045": {
    DMA: 505,
  },
  "48046": {
    DMA: 505,
  },
  "48047": {
    DMA: 505,
  },
  "48048": {
    DMA: 505,
  },
  "48049": {
    DMA: 505,
  },
  "48050": {
    DMA: 505,
  },
  "48051": {
    DMA: 505,
  },
  "48054": {
    DMA: 505,
  },
  "48059": {
    DMA: 505,
  },
  "48060": {
    DMA: 505,
  },
  "48061": {
    DMA: 505,
  },
  "48062": {
    DMA: 505,
  },
  "48063": {
    DMA: 505,
  },
  "48064": {
    DMA: 505,
  },
  "48065": {
    DMA: 505,
  },
  "48066": {
    DMA: 505,
  },
  "48067": {
    DMA: 505,
  },
  "48068": {
    DMA: 505,
  },
  "48069": {
    DMA: 505,
  },
  "48070": {
    DMA: 505,
  },
  "48071": {
    DMA: 505,
  },
  "48072": {
    DMA: 505,
  },
  "48073": {
    DMA: 505,
  },
  "48074": {
    DMA: 505,
  },
  "48075": {
    DMA: 505,
  },
  "48076": {
    DMA: 505,
  },
  "48079": {
    DMA: 505,
  },
  "48080": {
    DMA: 505,
  },
  "48081": {
    DMA: 505,
  },
  "48082": {
    DMA: 505,
  },
  "48083": {
    DMA: 505,
  },
  "48084": {
    DMA: 505,
  },
  "48085": {
    DMA: 505,
  },
  "48086": {
    DMA: 505,
  },
  "48088": {
    DMA: 505,
  },
  "48089": {
    DMA: 505,
  },
  "48090": {
    DMA: 505,
  },
  "48091": {
    DMA: 505,
  },
  "48092": {
    DMA: 505,
  },
  "48093": {
    DMA: 505,
  },
  "48094": {
    DMA: 505,
  },
  "48095": {
    DMA: 505,
  },
  "48096": {
    DMA: 505,
  },
  "48097": {
    DMA: 505,
  },
  "48098": {
    DMA: 505,
  },
  "48099": {
    DMA: 505,
  },
  "48101": {
    DMA: 505,
  },
  "48103": {
    DMA: 505,
  },
  "48104": {
    DMA: 505,
  },
  "48105": {
    DMA: 505,
  },
  "48106": {
    DMA: 505,
  },
  "48107": {
    DMA: 505,
  },
  "48108": {
    DMA: 505,
  },
  "48109": {
    DMA: 505,
  },
  "48110": {
    DMA: 505,
  },
  "48111": {
    DMA: 505,
  },
  "48112": {
    DMA: 505,
  },
  "48113": {
    DMA: 505,
  },
  "48114": {
    DMA: 505,
  },
  "48115": {
    DMA: 505,
  },
  "48116": {
    DMA: 505,
  },
  "48117": {
    DMA: 505,
  },
  "48118": {
    DMA: 505,
  },
  "48120": {
    DMA: 505,
  },
  "48121": {
    DMA: 505,
  },
  "48122": {
    DMA: 505,
  },
  "48123": {
    DMA: 505,
  },
  "48124": {
    DMA: 505,
  },
  "48125": {
    DMA: 505,
  },
  "48126": {
    DMA: 505,
  },
  "48127": {
    DMA: 505,
  },
  "48128": {
    DMA: 505,
  },
  "48130": {
    DMA: 505,
  },
  "48131": {
    DMA: 505,
  },
  "48133": {
    DMA: 505,
  },
  "48134": {
    DMA: 505,
  },
  "48135": {
    DMA: 505,
  },
  "48136": {
    DMA: 505,
  },
  "48137": {
    DMA: 505,
  },
  "48138": {
    DMA: 505,
  },
  "48139": {
    DMA: 505,
  },
  "48140": {
    DMA: 505,
  },
  "48141": {
    DMA: 505,
  },
  "48143": {
    DMA: 505,
  },
  "48144": {
    DMA: 505,
  },
  "48145": {
    DMA: 505,
  },
  "48146": {
    DMA: 505,
  },
  "48150": {
    DMA: 505,
  },
  "48151": {
    DMA: 505,
  },
  "48152": {
    DMA: 505,
  },
  "48153": {
    DMA: 505,
  },
  "48154": {
    DMA: 505,
  },
  "48157": {
    DMA: 505,
  },
  "48158": {
    DMA: 505,
  },
  "48159": {
    DMA: 505,
  },
  "48160": {
    DMA: 505,
  },
  "48161": {
    DMA: 505,
  },
  "48162": {
    DMA: 505,
  },
  "48164": {
    DMA: 505,
  },
  "48165": {
    DMA: 505,
  },
  "48166": {
    DMA: 505,
  },
  "48167": {
    DMA: 505,
  },
  "48168": {
    DMA: 505,
  },
  "48169": {
    DMA: 505,
  },
  "48170": {
    DMA: 505,
  },
  "48173": {
    DMA: 505,
  },
  "48174": {
    DMA: 505,
  },
  "48175": {
    DMA: 505,
  },
  "48176": {
    DMA: 505,
  },
  "48177": {
    DMA: 505,
  },
  "48178": {
    DMA: 505,
  },
  "48179": {
    DMA: 505,
  },
  "48180": {
    DMA: 505,
  },
  "48182": {
    DMA: 505,
  },
  "48183": {
    DMA: 505,
  },
  "48184": {
    DMA: 505,
  },
  "48185": {
    DMA: 505,
  },
  "48186": {
    DMA: 505,
  },
  "48187": {
    DMA: 505,
  },
  "48188": {
    DMA: 505,
  },
  "48189": {
    DMA: 505,
  },
  "48190": {
    DMA: 505,
  },
  "48191": {
    DMA: 505,
  },
  "48192": {
    DMA: 505,
  },
  "48193": {
    DMA: 505,
  },
  "48195": {
    DMA: 505,
  },
  "48197": {
    DMA: 505,
  },
  "48198": {
    DMA: 505,
  },
  "48201": {
    DMA: 505,
  },
  "48202": {
    DMA: 505,
  },
  "48203": {
    DMA: 505,
  },
  "48204": {
    DMA: 505,
  },
  "48205": {
    DMA: 505,
  },
  "48206": {
    DMA: 505,
  },
  "48207": {
    DMA: 505,
  },
  "48208": {
    DMA: 505,
  },
  "48209": {
    DMA: 505,
  },
  "48210": {
    DMA: 505,
  },
  "48211": {
    DMA: 505,
  },
  "48212": {
    DMA: 505,
  },
  "48213": {
    DMA: 505,
  },
  "48214": {
    DMA: 505,
  },
  "48215": {
    DMA: 505,
  },
  "48216": {
    DMA: 505,
  },
  "48217": {
    DMA: 505,
  },
  "48218": {
    DMA: 505,
  },
  "48219": {
    DMA: 505,
  },
  "48220": {
    DMA: 505,
  },
  "48221": {
    DMA: 505,
  },
  "48222": {
    DMA: 505,
  },
  "48223": {
    DMA: 505,
  },
  "48224": {
    DMA: 505,
  },
  "48225": {
    DMA: 505,
  },
  "48226": {
    DMA: 505,
  },
  "48227": {
    DMA: 505,
  },
  "48228": {
    DMA: 505,
  },
  "48229": {
    DMA: 505,
  },
  "48230": {
    DMA: 505,
  },
  "48231": {
    DMA: 505,
  },
  "48232": {
    DMA: 505,
  },
  "48233": {
    DMA: 505,
  },
  "48234": {
    DMA: 505,
  },
  "48235": {
    DMA: 505,
  },
  "48236": {
    DMA: 505,
  },
  "48237": {
    DMA: 505,
  },
  "48238": {
    DMA: 505,
  },
  "48239": {
    DMA: 505,
  },
  "48240": {
    DMA: 505,
  },
  "48242": {
    DMA: 505,
  },
  "48243": {
    DMA: 505,
  },
  "48244": {
    DMA: 505,
  },
  "48255": {
    DMA: 505,
  },
  "48260": {
    DMA: 505,
  },
  "48264": {
    DMA: 505,
  },
  "48265": {
    DMA: 505,
  },
  "48266": {
    DMA: 505,
  },
  "48267": {
    DMA: 505,
  },
  "48268": {
    DMA: 505,
  },
  "48269": {
    DMA: 505,
  },
  "48272": {
    DMA: 505,
  },
  "48275": {
    DMA: 505,
  },
  "48277": {
    DMA: 505,
  },
  "48278": {
    DMA: 505,
  },
  "48279": {
    DMA: 505,
  },
  "48288": {
    DMA: 505,
  },
  "48301": {
    DMA: 505,
  },
  "48302": {
    DMA: 505,
  },
  "48303": {
    DMA: 505,
  },
  "48304": {
    DMA: 505,
  },
  "48306": {
    DMA: 505,
  },
  "48307": {
    DMA: 505,
  },
  "48308": {
    DMA: 505,
  },
  "48309": {
    DMA: 505,
  },
  "48310": {
    DMA: 505,
  },
  "48311": {
    DMA: 505,
  },
  "48312": {
    DMA: 505,
  },
  "48313": {
    DMA: 505,
  },
  "48314": {
    DMA: 505,
  },
  "48315": {
    DMA: 505,
  },
  "48316": {
    DMA: 505,
  },
  "48317": {
    DMA: 505,
  },
  "48318": {
    DMA: 505,
  },
  "48320": {
    DMA: 505,
  },
  "48321": {
    DMA: 505,
  },
  "48322": {
    DMA: 505,
  },
  "48323": {
    DMA: 505,
  },
  "48324": {
    DMA: 505,
  },
  "48325": {
    DMA: 505,
  },
  "48326": {
    DMA: 505,
  },
  "48327": {
    DMA: 505,
  },
  "48328": {
    DMA: 505,
  },
  "48329": {
    DMA: 505,
  },
  "48330": {
    DMA: 505,
  },
  "48331": {
    DMA: 505,
  },
  "48332": {
    DMA: 505,
  },
  "48333": {
    DMA: 505,
  },
  "48334": {
    DMA: 505,
  },
  "48335": {
    DMA: 505,
  },
  "48336": {
    DMA: 505,
  },
  "48340": {
    DMA: 505,
  },
  "48341": {
    DMA: 505,
  },
  "48342": {
    DMA: 505,
  },
  "48343": {
    DMA: 505,
  },
  "48346": {
    DMA: 505,
  },
  "48347": {
    DMA: 505,
  },
  "48348": {
    DMA: 505,
  },
  "48350": {
    DMA: 505,
  },
  "48353": {
    DMA: 505,
  },
  "48356": {
    DMA: 505,
  },
  "48357": {
    DMA: 505,
  },
  "48359": {
    DMA: 505,
  },
  "48360": {
    DMA: 505,
  },
  "48361": {
    DMA: 505,
  },
  "48362": {
    DMA: 505,
  },
  "48363": {
    DMA: 505,
  },
  "48366": {
    DMA: 505,
  },
  "48367": {
    DMA: 505,
  },
  "48370": {
    DMA: 505,
  },
  "48371": {
    DMA: 505,
  },
  "48374": {
    DMA: 505,
  },
  "48375": {
    DMA: 505,
  },
  "48376": {
    DMA: 505,
  },
  "48377": {
    DMA: 505,
  },
  "48380": {
    DMA: 505,
  },
  "48381": {
    DMA: 505,
  },
  "48382": {
    DMA: 505,
  },
  "48383": {
    DMA: 505,
  },
  "48386": {
    DMA: 505,
  },
  "48387": {
    DMA: 505,
  },
  "48390": {
    DMA: 505,
  },
  "48391": {
    DMA: 505,
  },
  "48393": {
    DMA: 505,
  },
  "48397": {
    DMA: 505,
  },
  "48401": {
    DMA: 505,
  },
  "48410": {
    DMA: 505,
  },
  "48411": {
    DMA: 513,
  },
  "48412": {
    DMA: 505,
  },
  "48413": {
    DMA: 513,
  },
  "48414": {
    DMA: 513,
  },
  "48415": {
    DMA: 513,
  },
  "48416": {
    DMA: 505,
  },
  "48417": {
    DMA: 513,
  },
  "48418": {
    DMA: 513,
  },
  "48419": {
    DMA: 505,
  },
  "48420": {
    DMA: 513,
  },
  "48421": {
    DMA: 505,
  },
  "48422": {
    DMA: 505,
  },
  "48423": {
    DMA: 513,
  },
  "48426": {
    DMA: 505,
  },
  "48427": {
    DMA: 505,
  },
  "48428": {
    DMA: 505,
  },
  "48429": {
    DMA: 513,
  },
  "48430": {
    DMA: 513,
  },
  "48432": {
    DMA: 513,
  },
  "48433": {
    DMA: 513,
  },
  "48434": {
    DMA: 505,
  },
  "48435": {
    DMA: 513,
  },
  "48436": {
    DMA: 513,
  },
  "48437": {
    DMA: 513,
  },
  "48438": {
    DMA: 513,
  },
  "48439": {
    DMA: 513,
  },
  "48440": {
    DMA: 505,
  },
  "48441": {
    DMA: 513,
  },
  "48442": {
    DMA: 505,
  },
  "48444": {
    DMA: 505,
  },
  "48445": {
    DMA: 513,
  },
  "48446": {
    DMA: 505,
  },
  "48449": {
    DMA: 513,
  },
  "48450": {
    DMA: 505,
  },
  "48451": {
    DMA: 513,
  },
  "48453": {
    DMA: 505,
  },
  "48454": {
    DMA: 505,
  },
  "48455": {
    DMA: 505,
  },
  "48456": {
    DMA: 505,
  },
  "48457": {
    DMA: 513,
  },
  "48458": {
    DMA: 513,
  },
  "48460": {
    DMA: 513,
  },
  "48461": {
    DMA: 505,
  },
  "48462": {
    DMA: 505,
  },
  "48463": {
    DMA: 513,
  },
  "48464": {
    DMA: 505,
  },
  "48465": {
    DMA: 505,
  },
  "48466": {
    DMA: 505,
  },
  "48467": {
    DMA: 513,
  },
  "48468": {
    DMA: 513,
  },
  "48469": {
    DMA: 505,
  },
  "48470": {
    DMA: 513,
  },
  "48471": {
    DMA: 505,
  },
  "48472": {
    DMA: 505,
  },
  "48473": {
    DMA: 513,
  },
  "48475": {
    DMA: 513,
  },
  "48476": {
    DMA: 513,
  },
  "48480": {
    DMA: 513,
  },
  "48501": {
    DMA: 513,
  },
  "48502": {
    DMA: 513,
  },
  "48503": {
    DMA: 513,
  },
  "48504": {
    DMA: 513,
  },
  "48505": {
    DMA: 513,
  },
  "48506": {
    DMA: 513,
  },
  "48507": {
    DMA: 513,
  },
  "48509": {
    DMA: 513,
  },
  "48519": {
    DMA: 513,
  },
  "48529": {
    DMA: 513,
  },
  "48531": {
    DMA: 513,
  },
  "48532": {
    DMA: 513,
  },
  "48550": {
    DMA: 513,
  },
  "48551": {
    DMA: 513,
  },
  "48552": {
    DMA: 513,
  },
  "48553": {
    DMA: 513,
  },
  "48554": {
    DMA: 513,
  },
  "48555": {
    DMA: 513,
  },
  "48556": {
    DMA: 513,
  },
  "48557": {
    DMA: 513,
  },
  "48559": {
    DMA: 513,
  },
  "48601": {
    DMA: 513,
  },
  "48602": {
    DMA: 513,
  },
  "48603": {
    DMA: 513,
  },
  "48604": {
    DMA: 513,
  },
  "48605": {
    DMA: 513,
  },
  "48606": {
    DMA: 513,
  },
  "48607": {
    DMA: 513,
  },
  "48608": {
    DMA: 513,
  },
  "48609": {
    DMA: 513,
  },
  "48610": {
    DMA: 513,
  },
  "48611": {
    DMA: 513,
  },
  "48612": {
    DMA: 513,
  },
  "48613": {
    DMA: 513,
  },
  "48614": {
    DMA: 513,
  },
  "48615": {
    DMA: 513,
  },
  "48616": {
    DMA: 513,
  },
  "48617": {
    DMA: 540,
  },
  "48618": {
    DMA: 513,
  },
  "48619": {
    DMA: 540,
  },
  "48620": {
    DMA: 513,
  },
  "48621": {
    DMA: 540,
  },
  "48622": {
    DMA: 540,
  },
  "48623": {
    DMA: 513,
  },
  "48624": {
    DMA: 513,
  },
  "48625": {
    DMA: 540,
  },
  "48626": {
    DMA: 513,
  },
  "48627": {
    DMA: 540,
  },
  "48628": {
    DMA: 513,
  },
  "48629": {
    DMA: 540,
  },
  "48630": {
    DMA: 540,
  },
  "48631": {
    DMA: 513,
  },
  "48632": {
    DMA: 540,
  },
  "48633": {
    DMA: 540,
  },
  "48634": {
    DMA: 513,
  },
  "48635": {
    DMA: 513,
  },
  "48636": {
    DMA: 540,
  },
  "48637": {
    DMA: 513,
  },
  "48638": {
    DMA: 513,
  },
  "48640": {
    DMA: 513,
  },
  "48641": {
    DMA: 513,
  },
  "48642": {
    DMA: 513,
  },
  "48647": {
    DMA: 540,
  },
  "48649": {
    DMA: 513,
  },
  "48650": {
    DMA: 513,
  },
  "48651": {
    DMA: 540,
  },
  "48652": {
    DMA: 513,
  },
  "48653": {
    DMA: 540,
  },
  "48654": {
    DMA: 513,
  },
  "48655": {
    DMA: 513,
  },
  "48656": {
    DMA: 540,
  },
  "48657": {
    DMA: 513,
  },
  "48658": {
    DMA: 513,
  },
  "48659": {
    DMA: 513,
  },
  "48661": {
    DMA: 513,
  },
  "48662": {
    DMA: 513,
  },
  "48663": {
    DMA: 513,
  },
  "48667": {
    DMA: 513,
  },
  "48670": {
    DMA: 513,
  },
  "48674": {
    DMA: 513,
  },
  "48686": {
    DMA: 513,
  },
  "48701": {
    DMA: 513,
  },
  "48703": {
    DMA: 513,
  },
  "48705": {
    DMA: 583,
  },
  "48706": {
    DMA: 513,
  },
  "48707": {
    DMA: 513,
  },
  "48708": {
    DMA: 513,
  },
  "48710": {
    DMA: 513,
  },
  "48720": {
    DMA: 513,
  },
  "48721": {
    DMA: 583,
  },
  "48722": {
    DMA: 513,
  },
  "48723": {
    DMA: 513,
  },
  "48724": {
    DMA: 513,
  },
  "48725": {
    DMA: 513,
  },
  "48726": {
    DMA: 513,
  },
  "48727": {
    DMA: 505,
  },
  "48728": {
    DMA: 583,
  },
  "48729": {
    DMA: 513,
  },
  "48730": {
    DMA: 513,
  },
  "48731": {
    DMA: 513,
  },
  "48732": {
    DMA: 513,
  },
  "48733": {
    DMA: 513,
  },
  "48734": {
    DMA: 513,
  },
  "48735": {
    DMA: 513,
  },
  "48736": {
    DMA: 513,
  },
  "48737": {
    DMA: 583,
  },
  "48738": {
    DMA: 583,
  },
  "48739": {
    DMA: 513,
  },
  "48740": {
    DMA: 583,
  },
  "48741": {
    DMA: 513,
  },
  "48742": {
    DMA: 583,
  },
  "48743": {
    DMA: 513,
  },
  "48744": {
    DMA: 513,
  },
  "48745": {
    DMA: 583,
  },
  "48746": {
    DMA: 513,
  },
  "48747": {
    DMA: 513,
  },
  "48748": {
    DMA: 513,
  },
  "48749": {
    DMA: 513,
  },
  "48750": {
    DMA: 513,
  },
  "48754": {
    DMA: 513,
  },
  "48755": {
    DMA: 513,
  },
  "48756": {
    DMA: 513,
  },
  "48757": {
    DMA: 513,
  },
  "48758": {
    DMA: 513,
  },
  "48759": {
    DMA: 513,
  },
  "48760": {
    DMA: 505,
  },
  "48761": {
    DMA: 513,
  },
  "48762": {
    DMA: 583,
  },
  "48763": {
    DMA: 513,
  },
  "48764": {
    DMA: 513,
  },
  "48765": {
    DMA: 513,
  },
  "48766": {
    DMA: 513,
  },
  "48767": {
    DMA: 513,
  },
  "48768": {
    DMA: 513,
  },
  "48769": {
    DMA: 513,
  },
  "48770": {
    DMA: 513,
  },
  "48787": {
    DMA: 513,
  },
  "48801": {
    DMA: 513,
  },
  "48802": {
    DMA: 513,
  },
  "48804": {
    DMA: 513,
  },
  "48805": {
    DMA: 551,
  },
  "48806": {
    DMA: 513,
  },
  "48807": {
    DMA: 513,
  },
  "48808": {
    DMA: 551,
  },
  "48809": {
    DMA: 563,
  },
  "48811": {
    DMA: 563,
  },
  "48812": {
    DMA: 563,
  },
  "48813": {
    DMA: 551,
  },
  "48815": {
    DMA: 563,
  },
  "48816": {
    DMA: 505,
  },
  "48817": {
    DMA: 513,
  },
  "48818": {
    DMA: 563,
  },
  "48819": {
    DMA: 551,
  },
  "48820": {
    DMA: 551,
  },
  "48821": {
    DMA: 551,
  },
  "48822": {
    DMA: 551,
  },
  "48823": {
    DMA: 551,
  },
  "48824": {
    DMA: 551,
  },
  "48825": {
    DMA: 551,
  },
  "48826": {
    DMA: 551,
  },
  "48827": {
    DMA: 551,
  },
  "48829": {
    DMA: 563,
  },
  "48830": {
    DMA: 513,
  },
  "48831": {
    DMA: 551,
  },
  "48832": {
    DMA: 513,
  },
  "48833": {
    DMA: 551,
  },
  "48834": {
    DMA: 563,
  },
  "48835": {
    DMA: 551,
  },
  "48836": {
    DMA: 505,
  },
  "48837": {
    DMA: 551,
  },
  "48838": {
    DMA: 563,
  },
  "48840": {
    DMA: 551,
  },
  "48841": {
    DMA: 513,
  },
  "48842": {
    DMA: 551,
  },
  "48843": {
    DMA: 505,
  },
  "48844": {
    DMA: 505,
  },
  "48845": {
    DMA: 563,
  },
  "48846": {
    DMA: 563,
  },
  "48847": {
    DMA: 513,
  },
  "48848": {
    DMA: 513,
  },
  "48849": {
    DMA: 563,
  },
  "48850": {
    DMA: 563,
  },
  "48851": {
    DMA: 563,
  },
  "48852": {
    DMA: 563,
  },
  "48853": {
    DMA: 551,
  },
  "48854": {
    DMA: 551,
  },
  "48855": {
    DMA: 505,
  },
  "48856": {
    DMA: 513,
  },
  "48857": {
    DMA: 513,
  },
  "48858": {
    DMA: 513,
  },
  "48859": {
    DMA: 513,
  },
  "48860": {
    DMA: 563,
  },
  "48861": {
    DMA: 551,
  },
  "48862": {
    DMA: 513,
  },
  "48863": {
    DMA: 505,
  },
  "48864": {
    DMA: 551,
  },
  "48865": {
    DMA: 563,
  },
  "48866": {
    DMA: 551,
  },
  "48867": {
    DMA: 513,
  },
  "48870": {
    DMA: 563,
  },
  "48871": {
    DMA: 513,
  },
  "48872": {
    DMA: 513,
  },
  "48873": {
    DMA: 563,
  },
  "48874": {
    DMA: 513,
  },
  "48875": {
    DMA: 563,
  },
  "48876": {
    DMA: 551,
  },
  "48877": {
    DMA: 513,
  },
  "48878": {
    DMA: 513,
  },
  "48879": {
    DMA: 551,
  },
  "48880": {
    DMA: 513,
  },
  "48881": {
    DMA: 563,
  },
  "48882": {
    DMA: 513,
  },
  "48883": {
    DMA: 513,
  },
  "48884": {
    DMA: 563,
  },
  "48885": {
    DMA: 563,
  },
  "48886": {
    DMA: 563,
  },
  "48887": {
    DMA: 563,
  },
  "48888": {
    DMA: 563,
  },
  "48889": {
    DMA: 513,
  },
  "48890": {
    DMA: 551,
  },
  "48891": {
    DMA: 563,
  },
  "48892": {
    DMA: 551,
  },
  "48893": {
    DMA: 513,
  },
  "48894": {
    DMA: 551,
  },
  "48895": {
    DMA: 551,
  },
  "48896": {
    DMA: 513,
  },
  "48897": {
    DMA: 563,
  },
  "48901": {
    DMA: 551,
  },
  "48906": {
    DMA: 551,
  },
  "48908": {
    DMA: 551,
  },
  "48909": {
    DMA: 551,
  },
  "48910": {
    DMA: 551,
  },
  "48911": {
    DMA: 551,
  },
  "48912": {
    DMA: 551,
  },
  "48913": {
    DMA: 551,
  },
  "48915": {
    DMA: 551,
  },
  "48916": {
    DMA: 551,
  },
  "48917": {
    DMA: 551,
  },
  "48918": {
    DMA: 551,
  },
  "48919": {
    DMA: 551,
  },
  "48921": {
    DMA: 551,
  },
  "48922": {
    DMA: 551,
  },
  "48924": {
    DMA: 551,
  },
  "48929": {
    DMA: 551,
  },
  "48930": {
    DMA: 551,
  },
  "48933": {
    DMA: 551,
  },
  "48937": {
    DMA: 551,
  },
  "48950": {
    DMA: 551,
  },
  "48951": {
    DMA: 551,
  },
  "48956": {
    DMA: 551,
  },
  "48980": {
    DMA: 551,
  },
  "49001": {
    DMA: 563,
  },
  "49002": {
    DMA: 563,
  },
  "49003": {
    DMA: 563,
  },
  "49004": {
    DMA: 563,
  },
  "49005": {
    DMA: 563,
  },
  "49006": {
    DMA: 563,
  },
  "49007": {
    DMA: 563,
  },
  "49008": {
    DMA: 563,
  },
  "49009": {
    DMA: 563,
  },
  "49010": {
    DMA: 563,
  },
  "49011": {
    DMA: 563,
  },
  "49012": {
    DMA: 563,
  },
  "49013": {
    DMA: 563,
  },
  "49014": {
    DMA: 563,
  },
  "49015": {
    DMA: 563,
  },
  "49016": {
    DMA: 563,
  },
  "49017": {
    DMA: 563,
  },
  "49018": {
    DMA: 563,
  },
  "49019": {
    DMA: 563,
  },
  "49020": {
    DMA: 563,
  },
  "49021": {
    DMA: 551,
  },
  "49022": {
    DMA: 588,
  },
  "49023": {
    DMA: 588,
  },
  "49024": {
    DMA: 563,
  },
  "49026": {
    DMA: 563,
  },
  "49027": {
    DMA: 563,
  },
  "49028": {
    DMA: 563,
  },
  "49029": {
    DMA: 563,
  },
  "49030": {
    DMA: 563,
  },
  "49031": {
    DMA: 588,
  },
  "49032": {
    DMA: 563,
  },
  "49033": {
    DMA: 563,
  },
  "49034": {
    DMA: 563,
  },
  "49035": {
    DMA: 563,
  },
  "49036": {
    DMA: 563,
  },
  "49037": {
    DMA: 563,
  },
  "49038": {
    DMA: 588,
  },
  "49039": {
    DMA: 588,
  },
  "49040": {
    DMA: 563,
  },
  "49041": {
    DMA: 563,
  },
  "49042": {
    DMA: 563,
  },
  "49043": {
    DMA: 563,
  },
  "49045": {
    DMA: 563,
  },
  "49046": {
    DMA: 563,
  },
  "49047": {
    DMA: 588,
  },
  "49048": {
    DMA: 563,
  },
  "49050": {
    DMA: 563,
  },
  "49051": {
    DMA: 563,
  },
  "49052": {
    DMA: 563,
  },
  "49053": {
    DMA: 563,
  },
  "49055": {
    DMA: 563,
  },
  "49056": {
    DMA: 563,
  },
  "49057": {
    DMA: 563,
  },
  "49058": {
    DMA: 563,
  },
  "49060": {
    DMA: 563,
  },
  "49061": {
    DMA: 588,
  },
  "49062": {
    DMA: 563,
  },
  "49063": {
    DMA: 563,
  },
  "49064": {
    DMA: 563,
  },
  "49065": {
    DMA: 563,
  },
  "49066": {
    DMA: 563,
  },
  "49067": {
    DMA: 588,
  },
  "49068": {
    DMA: 563,
  },
  "49069": {
    DMA: 563,
  },
  "49070": {
    DMA: 563,
  },
  "49071": {
    DMA: 563,
  },
  "49072": {
    DMA: 563,
  },
  "49073": {
    DMA: 563,
  },
  "49074": {
    DMA: 563,
  },
  "49075": {
    DMA: 563,
  },
  "49076": {
    DMA: 551,
  },
  "49077": {
    DMA: 563,
  },
  "49078": {
    DMA: 563,
  },
  "49079": {
    DMA: 563,
  },
  "49080": {
    DMA: 563,
  },
  "49081": {
    DMA: 563,
  },
  "49082": {
    DMA: 563,
  },
  "49083": {
    DMA: 563,
  },
  "49084": {
    DMA: 588,
  },
  "49085": {
    DMA: 588,
  },
  "49087": {
    DMA: 563,
  },
  "49088": {
    DMA: 563,
  },
  "49089": {
    DMA: 563,
  },
  "49090": {
    DMA: 563,
  },
  "49091": {
    DMA: 563,
  },
  "49092": {
    DMA: 563,
  },
  "49093": {
    DMA: 563,
  },
  "49094": {
    DMA: 563,
  },
  "49095": {
    DMA: 588,
  },
  "49096": {
    DMA: 551,
  },
  "49097": {
    DMA: 563,
  },
  "49098": {
    DMA: 588,
  },
  "49099": {
    DMA: 563,
  },
  "49101": {
    DMA: 588,
  },
  "49102": {
    DMA: 588,
  },
  "49103": {
    DMA: 588,
  },
  "49104": {
    DMA: 588,
  },
  "49106": {
    DMA: 588,
  },
  "49107": {
    DMA: 588,
  },
  "49111": {
    DMA: 588,
  },
  "49112": {
    DMA: 588,
  },
  "49113": {
    DMA: 588,
  },
  "49115": {
    DMA: 588,
  },
  "49116": {
    DMA: 588,
  },
  "49117": {
    DMA: 588,
  },
  "49119": {
    DMA: 588,
  },
  "49120": {
    DMA: 588,
  },
  "49121": {
    DMA: 588,
  },
  "49125": {
    DMA: 588,
  },
  "49126": {
    DMA: 588,
  },
  "49127": {
    DMA: 588,
  },
  "49128": {
    DMA: 588,
  },
  "49129": {
    DMA: 588,
  },
  "49130": {
    DMA: 588,
  },
  "49201": {
    DMA: 551,
  },
  "49202": {
    DMA: 551,
  },
  "49203": {
    DMA: 551,
  },
  "49204": {
    DMA: 551,
  },
  "49220": {
    DMA: 547,
  },
  "49221": {
    DMA: 547,
  },
  "49224": {
    DMA: 563,
  },
  "49227": {
    DMA: 551,
  },
  "49228": {
    DMA: 547,
  },
  "49229": {
    DMA: 547,
  },
  "49230": {
    DMA: 551,
  },
  "49232": {
    DMA: 551,
  },
  "49233": {
    DMA: 547,
  },
  "49234": {
    DMA: 551,
  },
  "49235": {
    DMA: 547,
  },
  "49236": {
    DMA: 547,
  },
  "49237": {
    DMA: 551,
  },
  "49238": {
    DMA: 547,
  },
  "49239": {
    DMA: 551,
  },
  "49240": {
    DMA: 551,
  },
  "49241": {
    DMA: 551,
  },
  "49242": {
    DMA: 551,
  },
  "49245": {
    DMA: 563,
  },
  "49246": {
    DMA: 551,
  },
  "49247": {
    DMA: 547,
  },
  "49248": {
    DMA: 547,
  },
  "49249": {
    DMA: 551,
  },
  "49250": {
    DMA: 551,
  },
  "49251": {
    DMA: 551,
  },
  "49252": {
    DMA: 551,
  },
  "49253": {
    DMA: 547,
  },
  "49254": {
    DMA: 551,
  },
  "49255": {
    DMA: 563,
  },
  "49256": {
    DMA: 547,
  },
  "49257": {
    DMA: 551,
  },
  "49258": {
    DMA: 551,
  },
  "49259": {
    DMA: 551,
  },
  "49261": {
    DMA: 551,
  },
  "49262": {
    DMA: 551,
  },
  "49263": {
    DMA: 551,
  },
  "49264": {
    DMA: 551,
  },
  "49265": {
    DMA: 547,
  },
  "49266": {
    DMA: 551,
  },
  "49267": {
    DMA: 505,
  },
  "49268": {
    DMA: 547,
  },
  "49269": {
    DMA: 551,
  },
  "49270": {
    DMA: 505,
  },
  "49271": {
    DMA: 551,
  },
  "49272": {
    DMA: 551,
  },
  "49274": {
    DMA: 551,
  },
  "49276": {
    DMA: 547,
  },
  "49277": {
    DMA: 551,
  },
  "49279": {
    DMA: 547,
  },
  "49281": {
    DMA: 551,
  },
  "49282": {
    DMA: 551,
  },
  "49283": {
    DMA: 551,
  },
  "49284": {
    DMA: 551,
  },
  "49285": {
    DMA: 551,
  },
  "49286": {
    DMA: 547,
  },
  "49287": {
    DMA: 547,
  },
  "49288": {
    DMA: 551,
  },
  "49289": {
    DMA: 547,
  },
  "49301": {
    DMA: 563,
  },
  "49302": {
    DMA: 563,
  },
  "49303": {
    DMA: 563,
  },
  "49304": {
    DMA: 540,
  },
  "49305": {
    DMA: 540,
  },
  "49306": {
    DMA: 563,
  },
  "49307": {
    DMA: 540,
  },
  "49309": {
    DMA: 563,
  },
  "49310": {
    DMA: 513,
  },
  "49311": {
    DMA: 563,
  },
  "49312": {
    DMA: 563,
  },
  "49314": {
    DMA: 563,
  },
  "49315": {
    DMA: 563,
  },
  "49316": {
    DMA: 563,
  },
  "49317": {
    DMA: 563,
  },
  "49318": {
    DMA: 563,
  },
  "49319": {
    DMA: 563,
  },
  "49320": {
    DMA: 540,
  },
  "49321": {
    DMA: 563,
  },
  "49322": {
    DMA: 563,
  },
  "49323": {
    DMA: 563,
  },
  "49325": {
    DMA: 563,
  },
  "49326": {
    DMA: 563,
  },
  "49327": {
    DMA: 563,
  },
  "49328": {
    DMA: 563,
  },
  "49329": {
    DMA: 563,
  },
  "49330": {
    DMA: 563,
  },
  "49331": {
    DMA: 563,
  },
  "49332": {
    DMA: 540,
  },
  "49333": {
    DMA: 563,
  },
  "49335": {
    DMA: 563,
  },
  "49336": {
    DMA: 540,
  },
  "49337": {
    DMA: 563,
  },
  "49338": {
    DMA: 540,
  },
  "49339": {
    DMA: 563,
  },
  "49340": {
    DMA: 540,
  },
  "49341": {
    DMA: 563,
  },
  "49342": {
    DMA: 540,
  },
  "49343": {
    DMA: 563,
  },
  "49344": {
    DMA: 563,
  },
  "49345": {
    DMA: 563,
  },
  "49346": {
    DMA: 540,
  },
  "49347": {
    DMA: 563,
  },
  "49348": {
    DMA: 563,
  },
  "49349": {
    DMA: 563,
  },
  "49351": {
    DMA: 563,
  },
  "49355": {
    DMA: 563,
  },
  "49356": {
    DMA: 563,
  },
  "49357": {
    DMA: 563,
  },
  "49401": {
    DMA: 563,
  },
  "49402": {
    DMA: 540,
  },
  "49403": {
    DMA: 563,
  },
  "49404": {
    DMA: 563,
  },
  "49405": {
    DMA: 540,
  },
  "49406": {
    DMA: 563,
  },
  "49408": {
    DMA: 563,
  },
  "49409": {
    DMA: 563,
  },
  "49410": {
    DMA: 540,
  },
  "49411": {
    DMA: 540,
  },
  "49412": {
    DMA: 563,
  },
  "49413": {
    DMA: 563,
  },
  "49415": {
    DMA: 563,
  },
  "49416": {
    DMA: 563,
  },
  "49417": {
    DMA: 563,
  },
  "49418": {
    DMA: 563,
  },
  "49419": {
    DMA: 563,
  },
  "49420": {
    DMA: 563,
  },
  "49421": {
    DMA: 563,
  },
  "49422": {
    DMA: 563,
  },
  "49423": {
    DMA: 563,
  },
  "49424": {
    DMA: 563,
  },
  "49425": {
    DMA: 563,
  },
  "49426": {
    DMA: 563,
  },
  "49427": {
    DMA: 563,
  },
  "49428": {
    DMA: 563,
  },
  "49429": {
    DMA: 563,
  },
  "49430": {
    DMA: 563,
  },
  "49431": {
    DMA: 540,
  },
  "49434": {
    DMA: 563,
  },
  "49435": {
    DMA: 563,
  },
  "49436": {
    DMA: 563,
  },
  "49437": {
    DMA: 563,
  },
  "49440": {
    DMA: 563,
  },
  "49441": {
    DMA: 563,
  },
  "49442": {
    DMA: 563,
  },
  "49443": {
    DMA: 563,
  },
  "49444": {
    DMA: 563,
  },
  "49445": {
    DMA: 563,
  },
  "49446": {
    DMA: 563,
  },
  "49448": {
    DMA: 563,
  },
  "49449": {
    DMA: 563,
  },
  "49450": {
    DMA: 563,
  },
  "49451": {
    DMA: 563,
  },
  "49452": {
    DMA: 563,
  },
  "49453": {
    DMA: 563,
  },
  "49454": {
    DMA: 540,
  },
  "49455": {
    DMA: 563,
  },
  "49456": {
    DMA: 563,
  },
  "49457": {
    DMA: 563,
  },
  "49458": {
    DMA: 540,
  },
  "49459": {
    DMA: 563,
  },
  "49460": {
    DMA: 563,
  },
  "49461": {
    DMA: 563,
  },
  "49463": {
    DMA: 563,
  },
  "49464": {
    DMA: 563,
  },
  "49468": {
    DMA: 563,
  },
  "49501": {
    DMA: 563,
  },
  "49502": {
    DMA: 563,
  },
  "49503": {
    DMA: 563,
  },
  "49504": {
    DMA: 563,
  },
  "49505": {
    DMA: 563,
  },
  "49506": {
    DMA: 563,
  },
  "49507": {
    DMA: 563,
  },
  "49508": {
    DMA: 563,
  },
  "49509": {
    DMA: 563,
  },
  "49510": {
    DMA: 563,
  },
  "49512": {
    DMA: 563,
  },
  "49514": {
    DMA: 563,
  },
  "49515": {
    DMA: 563,
  },
  "49516": {
    DMA: 563,
  },
  "49518": {
    DMA: 563,
  },
  "49519": {
    DMA: 563,
  },
  "49523": {
    DMA: 563,
  },
  "49525": {
    DMA: 563,
  },
  "49528": {
    DMA: 563,
  },
  "49530": {
    DMA: 563,
  },
  "49534": {
    DMA: 563,
  },
  "49544": {
    DMA: 563,
  },
  "49546": {
    DMA: 563,
  },
  "49548": {
    DMA: 563,
  },
  "49550": {
    DMA: 563,
  },
  "49555": {
    DMA: 563,
  },
  "49560": {
    DMA: 563,
  },
  "49588": {
    DMA: 563,
  },
  "49599": {
    DMA: 563,
  },
  "49601": {
    DMA: 540,
  },
  "49610": {
    DMA: 540,
  },
  "49611": {
    DMA: 540,
  },
  "49612": {
    DMA: 540,
  },
  "49613": {
    DMA: 540,
  },
  "49614": {
    DMA: 540,
  },
  "49615": {
    DMA: 540,
  },
  "49616": {
    DMA: 540,
  },
  "49617": {
    DMA: 540,
  },
  "49618": {
    DMA: 540,
  },
  "49619": {
    DMA: 540,
  },
  "49620": {
    DMA: 540,
  },
  "49621": {
    DMA: 540,
  },
  "49622": {
    DMA: 540,
  },
  "49623": {
    DMA: 540,
  },
  "49625": {
    DMA: 540,
  },
  "49626": {
    DMA: 540,
  },
  "49627": {
    DMA: 540,
  },
  "49628": {
    DMA: 540,
  },
  "49629": {
    DMA: 540,
  },
  "49630": {
    DMA: 540,
  },
  "49631": {
    DMA: 540,
  },
  "49632": {
    DMA: 540,
  },
  "49633": {
    DMA: 540,
  },
  "49634": {
    DMA: 540,
  },
  "49635": {
    DMA: 540,
  },
  "49636": {
    DMA: 540,
  },
  "49637": {
    DMA: 540,
  },
  "49638": {
    DMA: 540,
  },
  "49639": {
    DMA: 540,
  },
  "49640": {
    DMA: 540,
  },
  "49642": {
    DMA: 540,
  },
  "49643": {
    DMA: 540,
  },
  "49644": {
    DMA: 540,
  },
  "49645": {
    DMA: 540,
  },
  "49646": {
    DMA: 540,
  },
  "49648": {
    DMA: 540,
  },
  "49649": {
    DMA: 540,
  },
  "49650": {
    DMA: 540,
  },
  "49651": {
    DMA: 540,
  },
  "49653": {
    DMA: 540,
  },
  "49654": {
    DMA: 540,
  },
  "49655": {
    DMA: 540,
  },
  "49656": {
    DMA: 540,
  },
  "49657": {
    DMA: 540,
  },
  "49659": {
    DMA: 540,
  },
  "49660": {
    DMA: 540,
  },
  "49663": {
    DMA: 540,
  },
  "49664": {
    DMA: 540,
  },
  "49665": {
    DMA: 540,
  },
  "49666": {
    DMA: 540,
  },
  "49667": {
    DMA: 540,
  },
  "49668": {
    DMA: 540,
  },
  "49670": {
    DMA: 540,
  },
  "49673": {
    DMA: 540,
  },
  "49674": {
    DMA: 540,
  },
  "49675": {
    DMA: 540,
  },
  "49676": {
    DMA: 540,
  },
  "49677": {
    DMA: 540,
  },
  "49679": {
    DMA: 540,
  },
  "49680": {
    DMA: 540,
  },
  "49682": {
    DMA: 540,
  },
  "49683": {
    DMA: 540,
  },
  "49684": {
    DMA: 540,
  },
  "49685": {
    DMA: 540,
  },
  "49686": {
    DMA: 540,
  },
  "49688": {
    DMA: 540,
  },
  "49689": {
    DMA: 540,
  },
  "49690": {
    DMA: 540,
  },
  "49696": {
    DMA: 540,
  },
  "49701": {
    DMA: 540,
  },
  "49705": {
    DMA: 540,
  },
  "49706": {
    DMA: 540,
  },
  "49707": {
    DMA: 583,
  },
  "49709": {
    DMA: 540,
  },
  "49710": {
    DMA: 540,
  },
  "49711": {
    DMA: 540,
  },
  "49712": {
    DMA: 540,
  },
  "49713": {
    DMA: 540,
  },
  "49715": {
    DMA: 540,
  },
  "49716": {
    DMA: 540,
  },
  "49717": {
    DMA: 540,
  },
  "49718": {
    DMA: 540,
  },
  "49719": {
    DMA: 540,
  },
  "49720": {
    DMA: 540,
  },
  "49721": {
    DMA: 540,
  },
  "49722": {
    DMA: 540,
  },
  "49723": {
    DMA: 540,
  },
  "49724": {
    DMA: 540,
  },
  "49725": {
    DMA: 540,
  },
  "49726": {
    DMA: 540,
  },
  "49727": {
    DMA: 540,
  },
  "49728": {
    DMA: 540,
  },
  "49729": {
    DMA: 540,
  },
  "49730": {
    DMA: 540,
  },
  "49733": {
    DMA: 540,
  },
  "49734": {
    DMA: 540,
  },
  "49735": {
    DMA: 540,
  },
  "49736": {
    DMA: 540,
  },
  "49737": {
    DMA: 540,
  },
  "49738": {
    DMA: 540,
  },
  "49739": {
    DMA: 540,
  },
  "49740": {
    DMA: 540,
  },
  "49743": {
    DMA: 540,
  },
  "49744": {
    DMA: 583,
  },
  "49745": {
    DMA: 540,
  },
  "49746": {
    DMA: 540,
  },
  "49747": {
    DMA: 583,
  },
  "49748": {
    DMA: 540,
  },
  "49749": {
    DMA: 540,
  },
  "49751": {
    DMA: 540,
  },
  "49752": {
    DMA: 540,
  },
  "49753": {
    DMA: 583,
  },
  "49755": {
    DMA: 540,
  },
  "49756": {
    DMA: 540,
  },
  "49757": {
    DMA: 540,
  },
  "49759": {
    DMA: 540,
  },
  "49760": {
    DMA: 540,
  },
  "49761": {
    DMA: 540,
  },
  "49762": {
    DMA: 540,
  },
  "49764": {
    DMA: 540,
  },
  "49765": {
    DMA: 540,
  },
  "49766": {
    DMA: 583,
  },
  "49768": {
    DMA: 540,
  },
  "49769": {
    DMA: 540,
  },
  "49770": {
    DMA: 540,
  },
  "49774": {
    DMA: 540,
  },
  "49775": {
    DMA: 540,
  },
  "49776": {
    DMA: 540,
  },
  "49777": {
    DMA: 540,
  },
  "49779": {
    DMA: 540,
  },
  "49780": {
    DMA: 540,
  },
  "49781": {
    DMA: 540,
  },
  "49782": {
    DMA: 540,
  },
  "49783": {
    DMA: 540,
  },
  "49784": {
    DMA: 540,
  },
  "49785": {
    DMA: 540,
  },
  "49786": {
    DMA: 540,
  },
  "49788": {
    DMA: 540,
  },
  "49790": {
    DMA: 540,
  },
  "49791": {
    DMA: 540,
  },
  "49792": {
    DMA: 540,
  },
  "49793": {
    DMA: 540,
  },
  "49795": {
    DMA: 540,
  },
  "49796": {
    DMA: 540,
  },
  "49797": {
    DMA: 540,
  },
  "49799": {
    DMA: 540,
  },
  "49801": {
    DMA: 553,
  },
  "49802": {
    DMA: 553,
  },
  "49805": {
    DMA: 553,
  },
  "49806": {
    DMA: 553,
  },
  "49807": {
    DMA: 553,
  },
  "49808": {
    DMA: 553,
  },
  "49812": {
    DMA: 658,
  },
  "49814": {
    DMA: 553,
  },
  "49815": {
    DMA: 553,
  },
  "49816": {
    DMA: 553,
  },
  "49817": {
    DMA: 553,
  },
  "49818": {
    DMA: 553,
  },
  "49819": {
    DMA: 553,
  },
  "49820": {
    DMA: 540,
  },
  "49821": {
    DMA: 658,
  },
  "49822": {
    DMA: 553,
  },
  "49825": {
    DMA: 553,
  },
  "49826": {
    DMA: 553,
  },
  "49827": {
    DMA: 540,
  },
  "49829": {
    DMA: 553,
  },
  "49831": {
    DMA: 553,
  },
  "49833": {
    DMA: 553,
  },
  "49834": {
    DMA: 553,
  },
  "49835": {
    DMA: 553,
  },
  "49836": {
    DMA: 553,
  },
  "49837": {
    DMA: 553,
  },
  "49838": {
    DMA: 540,
  },
  "49839": {
    DMA: 553,
  },
  "49840": {
    DMA: 553,
  },
  "49841": {
    DMA: 553,
  },
  "49845": {
    DMA: 658,
  },
  "49847": {
    DMA: 658,
  },
  "49848": {
    DMA: 658,
  },
  "49849": {
    DMA: 553,
  },
  "49852": {
    DMA: 553,
  },
  "49853": {
    DMA: 540,
  },
  "49854": {
    DMA: 553,
  },
  "49855": {
    DMA: 553,
  },
  "49858": {
    DMA: 658,
  },
  "49861": {
    DMA: 553,
  },
  "49862": {
    DMA: 553,
  },
  "49863": {
    DMA: 658,
  },
  "49864": {
    DMA: 553,
  },
  "49865": {
    DMA: 553,
  },
  "49866": {
    DMA: 553,
  },
  "49868": {
    DMA: 540,
  },
  "49870": {
    DMA: 553,
  },
  "49871": {
    DMA: 553,
  },
  "49872": {
    DMA: 553,
  },
  "49873": {
    DMA: 658,
  },
  "49874": {
    DMA: 658,
  },
  "49876": {
    DMA: 553,
  },
  "49877": {
    DMA: 553,
  },
  "49878": {
    DMA: 553,
  },
  "49879": {
    DMA: 553,
  },
  "49880": {
    DMA: 553,
  },
  "49881": {
    DMA: 553,
  },
  "49883": {
    DMA: 553,
  },
  "49884": {
    DMA: 553,
  },
  "49885": {
    DMA: 553,
  },
  "49886": {
    DMA: 658,
  },
  "49887": {
    DMA: 658,
  },
  "49891": {
    DMA: 553,
  },
  "49892": {
    DMA: 553,
  },
  "49893": {
    DMA: 658,
  },
  "49894": {
    DMA: 553,
  },
  "49895": {
    DMA: 553,
  },
  "49896": {
    DMA: 658,
  },
  "49901": {
    DMA: 553,
  },
  "49902": {
    DMA: 553,
  },
  "49903": {
    DMA: 553,
  },
  "49905": {
    DMA: 553,
  },
  "49908": {
    DMA: 553,
  },
  "49910": {
    DMA: 553,
  },
  "49911": {
    DMA: 676,
  },
  "49912": {
    DMA: 553,
  },
  "49913": {
    DMA: 553,
  },
  "49915": {
    DMA: 553,
  },
  "49916": {
    DMA: 553,
  },
  "49917": {
    DMA: 553,
  },
  "49918": {
    DMA: 553,
  },
  "49919": {
    DMA: 553,
  },
  "49920": {
    DMA: 553,
  },
  "49921": {
    DMA: 553,
  },
  "49922": {
    DMA: 553,
  },
  "49925": {
    DMA: 553,
  },
  "49927": {
    DMA: 553,
  },
  "49929": {
    DMA: 553,
  },
  "49930": {
    DMA: 553,
  },
  "49931": {
    DMA: 553,
  },
  "49934": {
    DMA: 553,
  },
  "49935": {
    DMA: 553,
  },
  "49938": {
    DMA: 676,
  },
  "49942": {
    DMA: 553,
  },
  "49945": {
    DMA: 553,
  },
  "49946": {
    DMA: 553,
  },
  "49947": {
    DMA: 676,
  },
  "49948": {
    DMA: 553,
  },
  "49950": {
    DMA: 553,
  },
  "49952": {
    DMA: 553,
  },
  "49953": {
    DMA: 553,
  },
  "49955": {
    DMA: 553,
  },
  "49958": {
    DMA: 553,
  },
  "49959": {
    DMA: 676,
  },
  "49960": {
    DMA: 553,
  },
  "49961": {
    DMA: 553,
  },
  "49962": {
    DMA: 553,
  },
  "49963": {
    DMA: 553,
  },
  "49964": {
    DMA: 553,
  },
  "49965": {
    DMA: 553,
  },
  "49967": {
    DMA: 553,
  },
  "49968": {
    DMA: 676,
  },
  "49969": {
    DMA: 676,
  },
  "49970": {
    DMA: 553,
  },
  "49971": {
    DMA: 553,
  },
  "50001": {
    DMA: 679,
  },
  "50002": {
    DMA: 679,
  },
  "50003": {
    DMA: 679,
  },
  "50005": {
    DMA: 679,
  },
  "50006": {
    DMA: 679,
  },
  "50007": {
    DMA: 679,
  },
  "50008": {
    DMA: 679,
  },
  "50009": {
    DMA: 679,
  },
  "50010": {
    DMA: 679,
  },
  "50011": {
    DMA: 679,
  },
  "50012": {
    DMA: 679,
  },
  "50013": {
    DMA: 679,
  },
  "50014": {
    DMA: 679,
  },
  "50020": {
    DMA: 652,
  },
  "50021": {
    DMA: 679,
  },
  "50022": {
    DMA: 652,
  },
  "50023": {
    DMA: 679,
  },
  "50025": {
    DMA: 679,
  },
  "50026": {
    DMA: 679,
  },
  "50027": {
    DMA: 679,
  },
  "50028": {
    DMA: 679,
  },
  "50029": {
    DMA: 679,
  },
  "50031": {
    DMA: 679,
  },
  "50032": {
    DMA: 679,
  },
  "50033": {
    DMA: 679,
  },
  "50034": {
    DMA: 679,
  },
  "50035": {
    DMA: 679,
  },
  "50036": {
    DMA: 679,
  },
  "50037": {
    DMA: 679,
  },
  "50038": {
    DMA: 679,
  },
  "50039": {
    DMA: 679,
  },
  "50040": {
    DMA: 679,
  },
  "50041": {
    DMA: 679,
  },
  "50042": {
    DMA: 679,
  },
  "50043": {
    DMA: 679,
  },
  "50044": {
    DMA: 679,
  },
  "50046": {
    DMA: 679,
  },
  "50047": {
    DMA: 679,
  },
  "50048": {
    DMA: 679,
  },
  "50049": {
    DMA: 679,
  },
  "50050": {
    DMA: 679,
  },
  "50051": {
    DMA: 679,
  },
  "50052": {
    DMA: 679,
  },
  "50054": {
    DMA: 679,
  },
  "50055": {
    DMA: 679,
  },
  "50056": {
    DMA: 679,
  },
  "50057": {
    DMA: 679,
  },
  "50058": {
    DMA: 679,
  },
  "50059": {
    DMA: 679,
  },
  "50060": {
    DMA: 679,
  },
  "50061": {
    DMA: 679,
  },
  "50062": {
    DMA: 679,
  },
  "50063": {
    DMA: 679,
  },
  "50064": {
    DMA: 679,
  },
  "50065": {
    DMA: 679,
  },
  "50066": {
    DMA: 679,
  },
  "50067": {
    DMA: 679,
  },
  "50068": {
    DMA: 679,
  },
  "50069": {
    DMA: 679,
  },
  "50070": {
    DMA: 679,
  },
  "50071": {
    DMA: 679,
  },
  "50072": {
    DMA: 679,
  },
  "50073": {
    DMA: 679,
  },
  "50074": {
    DMA: 679,
  },
  "50075": {
    DMA: 679,
  },
  "50076": {
    DMA: 679,
  },
  "50078": {
    DMA: 679,
  },
  "50099": {
    DMA: 679,
  },
  "50101": {
    DMA: 679,
  },
  "50102": {
    DMA: 679,
  },
  "50103": {
    DMA: 679,
  },
  "50104": {
    DMA: 637,
  },
  "50105": {
    DMA: 679,
  },
  "50106": {
    DMA: 679,
  },
  "50107": {
    DMA: 679,
  },
  "50108": {
    DMA: 679,
  },
  "50109": {
    DMA: 679,
  },
  "50110": {
    DMA: 679,
  },
  "50111": {
    DMA: 679,
  },
  "50112": {
    DMA: 679,
  },
  "50115": {
    DMA: 679,
  },
  "50116": {
    DMA: 679,
  },
  "50117": {
    DMA: 679,
  },
  "50118": {
    DMA: 679,
  },
  "50119": {
    DMA: 679,
  },
  "50120": {
    DMA: 679,
  },
  "50122": {
    DMA: 679,
  },
  "50123": {
    DMA: 679,
  },
  "50124": {
    DMA: 679,
  },
  "50125": {
    DMA: 679,
  },
  "50126": {
    DMA: 679,
  },
  "50127": {
    DMA: 679,
  },
  "50128": {
    DMA: 679,
  },
  "50129": {
    DMA: 679,
  },
  "50130": {
    DMA: 679,
  },
  "50131": {
    DMA: 679,
  },
  "50132": {
    DMA: 679,
  },
  "50133": {
    DMA: 679,
  },
  "50134": {
    DMA: 679,
  },
  "50135": {
    DMA: 679,
  },
  "50136": {
    DMA: 637,
  },
  "50137": {
    DMA: 679,
  },
  "50138": {
    DMA: 679,
  },
  "50139": {
    DMA: 679,
  },
  "50140": {
    DMA: 679,
  },
  "50141": {
    DMA: 679,
  },
  "50142": {
    DMA: 679,
  },
  "50143": {
    DMA: 679,
  },
  "50144": {
    DMA: 679,
  },
  "50145": {
    DMA: 679,
  },
  "50146": {
    DMA: 679,
  },
  "50147": {
    DMA: 679,
  },
  "50148": {
    DMA: 679,
  },
  "50149": {
    DMA: 679,
  },
  "50150": {
    DMA: 679,
  },
  "50151": {
    DMA: 679,
  },
  "50152": {
    DMA: 679,
  },
  "50153": {
    DMA: 679,
  },
  "50154": {
    DMA: 679,
  },
  "50155": {
    DMA: 679,
  },
  "50156": {
    DMA: 679,
  },
  "50157": {
    DMA: 679,
  },
  "50158": {
    DMA: 679,
  },
  "50160": {
    DMA: 679,
  },
  "50161": {
    DMA: 679,
  },
  "50162": {
    DMA: 679,
  },
  "50163": {
    DMA: 679,
  },
  "50164": {
    DMA: 679,
  },
  "50165": {
    DMA: 679,
  },
  "50166": {
    DMA: 679,
  },
  "50167": {
    DMA: 679,
  },
  "50168": {
    DMA: 679,
  },
  "50169": {
    DMA: 679,
  },
  "50170": {
    DMA: 679,
  },
  "50171": {
    DMA: 679,
  },
  "50173": {
    DMA: 637,
  },
  "50174": {
    DMA: 679,
  },
  "50201": {
    DMA: 679,
  },
  "50206": {
    DMA: 679,
  },
  "50207": {
    DMA: 679,
  },
  "50208": {
    DMA: 679,
  },
  "50210": {
    DMA: 679,
  },
  "50211": {
    DMA: 679,
  },
  "50212": {
    DMA: 679,
  },
  "50213": {
    DMA: 679,
  },
  "50214": {
    DMA: 679,
  },
  "50216": {
    DMA: 679,
  },
  "50217": {
    DMA: 679,
  },
  "50218": {
    DMA: 679,
  },
  "50219": {
    DMA: 679,
  },
  "50220": {
    DMA: 679,
  },
  "50222": {
    DMA: 679,
  },
  "50223": {
    DMA: 679,
  },
  "50225": {
    DMA: 679,
  },
  "50226": {
    DMA: 679,
  },
  "50227": {
    DMA: 679,
  },
  "50228": {
    DMA: 679,
  },
  "50229": {
    DMA: 679,
  },
  "50230": {
    DMA: 679,
  },
  "50231": {
    DMA: 679,
  },
  "50232": {
    DMA: 679,
  },
  "50233": {
    DMA: 679,
  },
  "50234": {
    DMA: 679,
  },
  "50235": {
    DMA: 679,
  },
  "50236": {
    DMA: 679,
  },
  "50237": {
    DMA: 679,
  },
  "50238": {
    DMA: 679,
  },
  "50239": {
    DMA: 679,
  },
  "50240": {
    DMA: 679,
  },
  "50241": {
    DMA: 679,
  },
  "50242": {
    DMA: 679,
  },
  "50243": {
    DMA: 679,
  },
  "50244": {
    DMA: 679,
  },
  "50246": {
    DMA: 679,
  },
  "50247": {
    DMA: 679,
  },
  "50248": {
    DMA: 679,
  },
  "50249": {
    DMA: 679,
  },
  "50250": {
    DMA: 679,
  },
  "50251": {
    DMA: 679,
  },
  "50252": {
    DMA: 679,
  },
  "50254": {
    DMA: 679,
  },
  "50255": {
    DMA: 637,
  },
  "50256": {
    DMA: 679,
  },
  "50257": {
    DMA: 679,
  },
  "50258": {
    DMA: 679,
  },
  "50259": {
    DMA: 679,
  },
  "50261": {
    DMA: 679,
  },
  "50262": {
    DMA: 679,
  },
  "50263": {
    DMA: 679,
  },
  "50264": {
    DMA: 679,
  },
  "50265": {
    DMA: 679,
  },
  "50266": {
    DMA: 679,
  },
  "50268": {
    DMA: 637,
  },
  "50269": {
    DMA: 679,
  },
  "50271": {
    DMA: 679,
  },
  "50272": {
    DMA: 679,
  },
  "50273": {
    DMA: 679,
  },
  "50274": {
    DMA: 652,
  },
  "50275": {
    DMA: 679,
  },
  "50276": {
    DMA: 679,
  },
  "50277": {
    DMA: 679,
  },
  "50278": {
    DMA: 679,
  },
  "50301": {
    DMA: 679,
  },
  "50302": {
    DMA: 679,
  },
  "50303": {
    DMA: 679,
  },
  "50304": {
    DMA: 679,
  },
  "50305": {
    DMA: 679,
  },
  "50306": {
    DMA: 679,
  },
  "50307": {
    DMA: 679,
  },
  "50308": {
    DMA: 679,
  },
  "50309": {
    DMA: 679,
  },
  "50310": {
    DMA: 679,
  },
  "50311": {
    DMA: 679,
  },
  "50312": {
    DMA: 679,
  },
  "50313": {
    DMA: 679,
  },
  "50314": {
    DMA: 679,
  },
  "50315": {
    DMA: 679,
  },
  "50316": {
    DMA: 679,
  },
  "50317": {
    DMA: 679,
  },
  "50318": {
    DMA: 679,
  },
  "50319": {
    DMA: 679,
  },
  "50320": {
    DMA: 679,
  },
  "50321": {
    DMA: 679,
  },
  "50322": {
    DMA: 679,
  },
  "50323": {
    DMA: 679,
  },
  "50324": {
    DMA: 679,
  },
  "50325": {
    DMA: 679,
  },
  "50327": {
    DMA: 679,
  },
  "50328": {
    DMA: 679,
  },
  "50329": {
    DMA: 679,
  },
  "50330": {
    DMA: 679,
  },
  "50331": {
    DMA: 679,
  },
  "50332": {
    DMA: 679,
  },
  "50333": {
    DMA: 679,
  },
  "50334": {
    DMA: 679,
  },
  "50335": {
    DMA: 679,
  },
  "50336": {
    DMA: 679,
  },
  "50339": {
    DMA: 679,
  },
  "50340": {
    DMA: 679,
  },
  "50347": {
    DMA: 679,
  },
  "50359": {
    DMA: 679,
  },
  "50360": {
    DMA: 679,
  },
  "50361": {
    DMA: 679,
  },
  "50362": {
    DMA: 679,
  },
  "50363": {
    DMA: 679,
  },
  "50364": {
    DMA: 679,
  },
  "50367": {
    DMA: 679,
  },
  "50368": {
    DMA: 679,
  },
  "50369": {
    DMA: 679,
  },
  "50380": {
    DMA: 679,
  },
  "50381": {
    DMA: 679,
  },
  "50391": {
    DMA: 679,
  },
  "50392": {
    DMA: 679,
  },
  "50393": {
    DMA: 679,
  },
  "50394": {
    DMA: 679,
  },
  "50395": {
    DMA: 679,
  },
  "50396": {
    DMA: 679,
  },
  "50397": {
    DMA: 679,
  },
  "50398": {
    DMA: 679,
  },
  "50401": {
    DMA: 611,
  },
  "50402": {
    DMA: 611,
  },
  "50420": {
    DMA: 679,
  },
  "50421": {
    DMA: 679,
  },
  "50423": {
    DMA: 611,
  },
  "50424": {
    DMA: 611,
  },
  "50426": {
    DMA: 611,
  },
  "50427": {
    DMA: 679,
  },
  "50428": {
    DMA: 611,
  },
  "50430": {
    DMA: 611,
  },
  "50431": {
    DMA: 679,
  },
  "50432": {
    DMA: 611,
  },
  "50433": {
    DMA: 611,
  },
  "50434": {
    DMA: 611,
  },
  "50435": {
    DMA: 611,
  },
  "50436": {
    DMA: 611,
  },
  "50438": {
    DMA: 611,
  },
  "50439": {
    DMA: 611,
  },
  "50440": {
    DMA: 611,
  },
  "50441": {
    DMA: 679,
  },
  "50444": {
    DMA: 611,
  },
  "50446": {
    DMA: 611,
  },
  "50447": {
    DMA: 611,
  },
  "50448": {
    DMA: 611,
  },
  "50449": {
    DMA: 611,
  },
  "50450": {
    DMA: 611,
  },
  "50451": {
    DMA: 679,
  },
  "50452": {
    DMA: 679,
  },
  "50453": {
    DMA: 611,
  },
  "50454": {
    DMA: 611,
  },
  "50455": {
    DMA: 611,
  },
  "50456": {
    DMA: 611,
  },
  "50457": {
    DMA: 611,
  },
  "50458": {
    DMA: 611,
  },
  "50459": {
    DMA: 611,
  },
  "50460": {
    DMA: 611,
  },
  "50461": {
    DMA: 611,
  },
  "50464": {
    DMA: 611,
  },
  "50465": {
    DMA: 611,
  },
  "50466": {
    DMA: 611,
  },
  "50467": {
    DMA: 611,
  },
  "50468": {
    DMA: 611,
  },
  "50469": {
    DMA: 611,
  },
  "50470": {
    DMA: 679,
  },
  "50471": {
    DMA: 611,
  },
  "50472": {
    DMA: 611,
  },
  "50473": {
    DMA: 611,
  },
  "50475": {
    DMA: 679,
  },
  "50476": {
    DMA: 611,
  },
  "50477": {
    DMA: 611,
  },
  "50478": {
    DMA: 611,
  },
  "50479": {
    DMA: 611,
  },
  "50480": {
    DMA: 679,
  },
  "50481": {
    DMA: 611,
  },
  "50482": {
    DMA: 611,
  },
  "50483": {
    DMA: 679,
  },
  "50484": {
    DMA: 611,
  },
  "50501": {
    DMA: 679,
  },
  "50510": {
    DMA: 624,
  },
  "50511": {
    DMA: 679,
  },
  "50514": {
    DMA: 624,
  },
  "50515": {
    DMA: 624,
  },
  "50516": {
    DMA: 679,
  },
  "50517": {
    DMA: 679,
  },
  "50518": {
    DMA: 679,
  },
  "50519": {
    DMA: 679,
  },
  "50520": {
    DMA: 679,
  },
  "50521": {
    DMA: 679,
  },
  "50522": {
    DMA: 679,
  },
  "50523": {
    DMA: 679,
  },
  "50524": {
    DMA: 679,
  },
  "50525": {
    DMA: 679,
  },
  "50526": {
    DMA: 679,
  },
  "50527": {
    DMA: 624,
  },
  "50528": {
    DMA: 624,
  },
  "50529": {
    DMA: 679,
  },
  "50530": {
    DMA: 679,
  },
  "50531": {
    DMA: 624,
  },
  "50532": {
    DMA: 679,
  },
  "50533": {
    DMA: 679,
  },
  "50535": {
    DMA: 624,
  },
  "50536": {
    DMA: 624,
  },
  "50538": {
    DMA: 679,
  },
  "50539": {
    DMA: 679,
  },
  "50540": {
    DMA: 679,
  },
  "50541": {
    DMA: 679,
  },
  "50542": {
    DMA: 679,
  },
  "50543": {
    DMA: 679,
  },
  "50544": {
    DMA: 679,
  },
  "50545": {
    DMA: 679,
  },
  "50546": {
    DMA: 679,
  },
  "50548": {
    DMA: 679,
  },
  "50551": {
    DMA: 679,
  },
  "50552": {
    DMA: 679,
  },
  "50554": {
    DMA: 679,
  },
  "50556": {
    DMA: 679,
  },
  "50557": {
    DMA: 679,
  },
  "50558": {
    DMA: 679,
  },
  "50559": {
    DMA: 679,
  },
  "50560": {
    DMA: 679,
  },
  "50561": {
    DMA: 679,
  },
  "50562": {
    DMA: 624,
  },
  "50563": {
    DMA: 679,
  },
  "50565": {
    DMA: 624,
  },
  "50566": {
    DMA: 679,
  },
  "50567": {
    DMA: 624,
  },
  "50568": {
    DMA: 624,
  },
  "50569": {
    DMA: 679,
  },
  "50570": {
    DMA: 679,
  },
  "50571": {
    DMA: 679,
  },
  "50573": {
    DMA: 679,
  },
  "50574": {
    DMA: 679,
  },
  "50575": {
    DMA: 679,
  },
  "50576": {
    DMA: 624,
  },
  "50577": {
    DMA: 679,
  },
  "50578": {
    DMA: 624,
  },
  "50579": {
    DMA: 679,
  },
  "50581": {
    DMA: 679,
  },
  "50582": {
    DMA: 679,
  },
  "50583": {
    DMA: 624,
  },
  "50585": {
    DMA: 624,
  },
  "50586": {
    DMA: 679,
  },
  "50588": {
    DMA: 624,
  },
  "50590": {
    DMA: 679,
  },
  "50591": {
    DMA: 679,
  },
  "50592": {
    DMA: 624,
  },
  "50593": {
    DMA: 679,
  },
  "50594": {
    DMA: 679,
  },
  "50595": {
    DMA: 679,
  },
  "50597": {
    DMA: 624,
  },
  "50598": {
    DMA: 679,
  },
  "50599": {
    DMA: 679,
  },
  "50601": {
    DMA: 679,
  },
  "50602": {
    DMA: 637,
  },
  "50603": {
    DMA: 637,
  },
  "50604": {
    DMA: 637,
  },
  "50605": {
    DMA: 637,
  },
  "50606": {
    DMA: 637,
  },
  "50607": {
    DMA: 637,
  },
  "50608": {
    DMA: 637,
  },
  "50609": {
    DMA: 637,
  },
  "50611": {
    DMA: 637,
  },
  "50612": {
    DMA: 637,
  },
  "50613": {
    DMA: 637,
  },
  "50614": {
    DMA: 637,
  },
  "50616": {
    DMA: 611,
  },
  "50619": {
    DMA: 637,
  },
  "50620": {
    DMA: 611,
  },
  "50621": {
    DMA: 637,
  },
  "50622": {
    DMA: 637,
  },
  "50623": {
    DMA: 637,
  },
  "50624": {
    DMA: 637,
  },
  "50625": {
    DMA: 637,
  },
  "50626": {
    DMA: 637,
  },
  "50627": {
    DMA: 679,
  },
  "50628": {
    DMA: 611,
  },
  "50629": {
    DMA: 637,
  },
  "50630": {
    DMA: 637,
  },
  "50631": {
    DMA: 637,
  },
  "50632": {
    DMA: 637,
  },
  "50633": {
    DMA: 679,
  },
  "50634": {
    DMA: 637,
  },
  "50635": {
    DMA: 637,
  },
  "50636": {
    DMA: 637,
  },
  "50638": {
    DMA: 637,
  },
  "50641": {
    DMA: 637,
  },
  "50642": {
    DMA: 637,
  },
  "50643": {
    DMA: 637,
  },
  "50644": {
    DMA: 637,
  },
  "50645": {
    DMA: 637,
  },
  "50647": {
    DMA: 637,
  },
  "50648": {
    DMA: 637,
  },
  "50649": {
    DMA: 637,
  },
  "50650": {
    DMA: 637,
  },
  "50651": {
    DMA: 637,
  },
  "50652": {
    DMA: 637,
  },
  "50653": {
    DMA: 611,
  },
  "50654": {
    DMA: 637,
  },
  "50655": {
    DMA: 637,
  },
  "50657": {
    DMA: 637,
  },
  "50658": {
    DMA: 637,
  },
  "50659": {
    DMA: 637,
  },
  "50660": {
    DMA: 637,
  },
  "50661": {
    DMA: 637,
  },
  "50662": {
    DMA: 637,
  },
  "50664": {
    DMA: 637,
  },
  "50665": {
    DMA: 637,
  },
  "50666": {
    DMA: 637,
  },
  "50667": {
    DMA: 637,
  },
  "50668": {
    DMA: 637,
  },
  "50669": {
    DMA: 637,
  },
  "50670": {
    DMA: 637,
  },
  "50671": {
    DMA: 637,
  },
  "50672": {
    DMA: 679,
  },
  "50673": {
    DMA: 637,
  },
  "50674": {
    DMA: 637,
  },
  "50675": {
    DMA: 637,
  },
  "50676": {
    DMA: 637,
  },
  "50677": {
    DMA: 637,
  },
  "50680": {
    DMA: 637,
  },
  "50681": {
    DMA: 637,
  },
  "50682": {
    DMA: 637,
  },
  "50701": {
    DMA: 637,
  },
  "50702": {
    DMA: 637,
  },
  "50703": {
    DMA: 637,
  },
  "50704": {
    DMA: 637,
  },
  "50706": {
    DMA: 637,
  },
  "50707": {
    DMA: 637,
  },
  "50801": {
    DMA: 679,
  },
  "50830": {
    DMA: 679,
  },
  "50831": {
    DMA: 679,
  },
  "50833": {
    DMA: 679,
  },
  "50835": {
    DMA: 679,
  },
  "50836": {
    DMA: 679,
  },
  "50837": {
    DMA: 679,
  },
  "50839": {
    DMA: 679,
  },
  "50840": {
    DMA: 679,
  },
  "50841": {
    DMA: 679,
  },
  "50842": {
    DMA: 679,
  },
  "50843": {
    DMA: 652,
  },
  "50845": {
    DMA: 679,
  },
  "50846": {
    DMA: 679,
  },
  "50847": {
    DMA: 652,
  },
  "50848": {
    DMA: 679,
  },
  "50849": {
    DMA: 679,
  },
  "50851": {
    DMA: 679,
  },
  "50853": {
    DMA: 652,
  },
  "50854": {
    DMA: 679,
  },
  "50857": {
    DMA: 679,
  },
  "50858": {
    DMA: 679,
  },
  "50859": {
    DMA: 679,
  },
  "50860": {
    DMA: 679,
  },
  "50861": {
    DMA: 679,
  },
  "50862": {
    DMA: 679,
  },
  "50863": {
    DMA: 679,
  },
  "50864": {
    DMA: 652,
  },
  "50936": {
    DMA: 679,
  },
  "50940": {
    DMA: 679,
  },
  "50947": {
    DMA: 679,
  },
  "50950": {
    DMA: 679,
  },
  "50980": {
    DMA: 679,
  },
  "50981": {
    DMA: 679,
  },
  "50982": {
    DMA: 679,
  },
  "50983": {
    DMA: 679,
  },
  "51001": {
    DMA: 624,
  },
  "51002": {
    DMA: 624,
  },
  "51003": {
    DMA: 624,
  },
  "51004": {
    DMA: 624,
  },
  "51005": {
    DMA: 624,
  },
  "51006": {
    DMA: 624,
  },
  "51007": {
    DMA: 624,
  },
  "51008": {
    DMA: 624,
  },
  "51009": {
    DMA: 624,
  },
  "51010": {
    DMA: 624,
  },
  "51011": {
    DMA: 624,
  },
  "51012": {
    DMA: 624,
  },
  "51014": {
    DMA: 624,
  },
  "51015": {
    DMA: 624,
  },
  "51016": {
    DMA: 624,
  },
  "51018": {
    DMA: 624,
  },
  "51019": {
    DMA: 624,
  },
  "51020": {
    DMA: 624,
  },
  "51022": {
    DMA: 624,
  },
  "51023": {
    DMA: 624,
  },
  "51024": {
    DMA: 624,
  },
  "51025": {
    DMA: 624,
  },
  "51026": {
    DMA: 624,
  },
  "51027": {
    DMA: 624,
  },
  "51028": {
    DMA: 624,
  },
  "51029": {
    DMA: 624,
  },
  "51030": {
    DMA: 624,
  },
  "51031": {
    DMA: 624,
  },
  "51033": {
    DMA: 624,
  },
  "51034": {
    DMA: 624,
  },
  "51035": {
    DMA: 624,
  },
  "51036": {
    DMA: 624,
  },
  "51037": {
    DMA: 624,
  },
  "51038": {
    DMA: 624,
  },
  "51039": {
    DMA: 624,
  },
  "51040": {
    DMA: 624,
  },
  "51041": {
    DMA: 624,
  },
  "51044": {
    DMA: 624,
  },
  "51045": {
    DMA: 624,
  },
  "51046": {
    DMA: 624,
  },
  "51047": {
    DMA: 624,
  },
  "51048": {
    DMA: 624,
  },
  "51049": {
    DMA: 624,
  },
  "51050": {
    DMA: 624,
  },
  "51051": {
    DMA: 624,
  },
  "51052": {
    DMA: 624,
  },
  "51053": {
    DMA: 624,
  },
  "51054": {
    DMA: 624,
  },
  "51055": {
    DMA: 624,
  },
  "51056": {
    DMA: 624,
  },
  "51058": {
    DMA: 624,
  },
  "51060": {
    DMA: 624,
  },
  "51061": {
    DMA: 624,
  },
  "51062": {
    DMA: 624,
  },
  "51063": {
    DMA: 624,
  },
  "51101": {
    DMA: 624,
  },
  "51102": {
    DMA: 624,
  },
  "51103": {
    DMA: 624,
  },
  "51104": {
    DMA: 624,
  },
  "51105": {
    DMA: 624,
  },
  "51106": {
    DMA: 624,
  },
  "51108": {
    DMA: 624,
  },
  "51109": {
    DMA: 624,
  },
  "51111": {
    DMA: 624,
  },
  "51201": {
    DMA: 624,
  },
  "51230": {
    DMA: 725,
  },
  "51231": {
    DMA: 624,
  },
  "51232": {
    DMA: 725,
  },
  "51234": {
    DMA: 624,
  },
  "51235": {
    DMA: 725,
  },
  "51237": {
    DMA: 725,
  },
  "51238": {
    DMA: 624,
  },
  "51239": {
    DMA: 624,
  },
  "51240": {
    DMA: 725,
  },
  "51241": {
    DMA: 725,
  },
  "51242": {
    DMA: 725,
  },
  "51243": {
    DMA: 725,
  },
  "51244": {
    DMA: 624,
  },
  "51245": {
    DMA: 624,
  },
  "51246": {
    DMA: 725,
  },
  "51247": {
    DMA: 624,
  },
  "51248": {
    DMA: 624,
  },
  "51249": {
    DMA: 725,
  },
  "51250": {
    DMA: 624,
  },
  "51301": {
    DMA: 624,
  },
  "51331": {
    DMA: 624,
  },
  "51333": {
    DMA: 624,
  },
  "51334": {
    DMA: 624,
  },
  "51338": {
    DMA: 624,
  },
  "51340": {
    DMA: 624,
  },
  "51341": {
    DMA: 624,
  },
  "51342": {
    DMA: 624,
  },
  "51343": {
    DMA: 624,
  },
  "51344": {
    DMA: 624,
  },
  "51345": {
    DMA: 725,
  },
  "51346": {
    DMA: 624,
  },
  "51347": {
    DMA: 624,
  },
  "51350": {
    DMA: 725,
  },
  "51351": {
    DMA: 624,
  },
  "51354": {
    DMA: 725,
  },
  "51355": {
    DMA: 624,
  },
  "51357": {
    DMA: 624,
  },
  "51358": {
    DMA: 624,
  },
  "51360": {
    DMA: 624,
  },
  "51363": {
    DMA: 624,
  },
  "51364": {
    DMA: 624,
  },
  "51365": {
    DMA: 624,
  },
  "51366": {
    DMA: 624,
  },
  "51401": {
    DMA: 679,
  },
  "51430": {
    DMA: 679,
  },
  "51431": {
    DMA: 624,
  },
  "51432": {
    DMA: 652,
  },
  "51433": {
    DMA: 624,
  },
  "51436": {
    DMA: 679,
  },
  "51439": {
    DMA: 652,
  },
  "51440": {
    DMA: 679,
  },
  "51441": {
    DMA: 652,
  },
  "51442": {
    DMA: 652,
  },
  "51443": {
    DMA: 679,
  },
  "51444": {
    DMA: 679,
  },
  "51445": {
    DMA: 624,
  },
  "51446": {
    DMA: 652,
  },
  "51447": {
    DMA: 652,
  },
  "51448": {
    DMA: 652,
  },
  "51449": {
    DMA: 679,
  },
  "51450": {
    DMA: 624,
  },
  "51451": {
    DMA: 679,
  },
  "51452": {
    DMA: 679,
  },
  "51453": {
    DMA: 679,
  },
  "51454": {
    DMA: 652,
  },
  "51455": {
    DMA: 679,
  },
  "51458": {
    DMA: 624,
  },
  "51459": {
    DMA: 679,
  },
  "51460": {
    DMA: 652,
  },
  "51461": {
    DMA: 652,
  },
  "51462": {
    DMA: 679,
  },
  "51463": {
    DMA: 679,
  },
  "51465": {
    DMA: 652,
  },
  "51466": {
    DMA: 624,
  },
  "51467": {
    DMA: 652,
  },
  "51501": {
    DMA: 652,
  },
  "51502": {
    DMA: 652,
  },
  "51503": {
    DMA: 652,
  },
  "51510": {
    DMA: 652,
  },
  "51520": {
    DMA: 652,
  },
  "51521": {
    DMA: 652,
  },
  "51523": {
    DMA: 624,
  },
  "51525": {
    DMA: 652,
  },
  "51526": {
    DMA: 652,
  },
  "51527": {
    DMA: 652,
  },
  "51528": {
    DMA: 652,
  },
  "51529": {
    DMA: 652,
  },
  "51530": {
    DMA: 652,
  },
  "51531": {
    DMA: 652,
  },
  "51532": {
    DMA: 652,
  },
  "51533": {
    DMA: 652,
  },
  "51534": {
    DMA: 652,
  },
  "51535": {
    DMA: 652,
  },
  "51536": {
    DMA: 652,
  },
  "51537": {
    DMA: 652,
  },
  "51540": {
    DMA: 652,
  },
  "51541": {
    DMA: 652,
  },
  "51542": {
    DMA: 652,
  },
  "51543": {
    DMA: 679,
  },
  "51544": {
    DMA: 652,
  },
  "51545": {
    DMA: 652,
  },
  "51546": {
    DMA: 652,
  },
  "51548": {
    DMA: 652,
  },
  "51549": {
    DMA: 652,
  },
  "51550": {
    DMA: 652,
  },
  "51551": {
    DMA: 652,
  },
  "51552": {
    DMA: 652,
  },
  "51553": {
    DMA: 652,
  },
  "51554": {
    DMA: 652,
  },
  "51555": {
    DMA: 652,
  },
  "51556": {
    DMA: 652,
  },
  "51557": {
    DMA: 652,
  },
  "51558": {
    DMA: 624,
  },
  "51559": {
    DMA: 652,
  },
  "51560": {
    DMA: 652,
  },
  "51561": {
    DMA: 652,
  },
  "51562": {
    DMA: 652,
  },
  "51563": {
    DMA: 652,
  },
  "51564": {
    DMA: 652,
  },
  "51565": {
    DMA: 652,
  },
  "51566": {
    DMA: 652,
  },
  "51570": {
    DMA: 652,
  },
  "51571": {
    DMA: 652,
  },
  "51572": {
    DMA: 624,
  },
  "51573": {
    DMA: 652,
  },
  "51575": {
    DMA: 652,
  },
  "51576": {
    DMA: 652,
  },
  "51577": {
    DMA: 652,
  },
  "51578": {
    DMA: 652,
  },
  "51579": {
    DMA: 652,
  },
  "51591": {
    DMA: 652,
  },
  "51593": {
    DMA: 652,
  },
  "51601": {
    DMA: 652,
  },
  "51602": {
    DMA: 652,
  },
  "51603": {
    DMA: 652,
  },
  "51630": {
    DMA: 652,
  },
  "51631": {
    DMA: 652,
  },
  "51632": {
    DMA: 652,
  },
  "51636": {
    DMA: 652,
  },
  "51637": {
    DMA: 652,
  },
  "51638": {
    DMA: 652,
  },
  "51639": {
    DMA: 652,
  },
  "51640": {
    DMA: 652,
  },
  "51645": {
    DMA: 652,
  },
  "51646": {
    DMA: 679,
  },
  "51647": {
    DMA: 652,
  },
  "51648": {
    DMA: 652,
  },
  "51649": {
    DMA: 652,
  },
  "51650": {
    DMA: 652,
  },
  "51651": {
    DMA: 652,
  },
  "51652": {
    DMA: 652,
  },
  "51653": {
    DMA: 652,
  },
  "51654": {
    DMA: 652,
  },
  "51656": {
    DMA: 652,
  },
  "52001": {
    DMA: 637,
  },
  "52002": {
    DMA: 637,
  },
  "52003": {
    DMA: 637,
  },
  "52004": {
    DMA: 637,
  },
  "52030": {
    DMA: 682,
  },
  "52031": {
    DMA: 682,
  },
  "52032": {
    DMA: 637,
  },
  "52033": {
    DMA: 637,
  },
  "52035": {
    DMA: 637,
  },
  "52036": {
    DMA: 637,
  },
  "52037": {
    DMA: 682,
  },
  "52038": {
    DMA: 637,
  },
  "52039": {
    DMA: 637,
  },
  "52040": {
    DMA: 637,
  },
  "52041": {
    DMA: 637,
  },
  "52042": {
    DMA: 637,
  },
  "52043": {
    DMA: 637,
  },
  "52044": {
    DMA: 637,
  },
  "52045": {
    DMA: 637,
  },
  "52046": {
    DMA: 637,
  },
  "52047": {
    DMA: 637,
  },
  "52048": {
    DMA: 637,
  },
  "52049": {
    DMA: 637,
  },
  "52050": {
    DMA: 637,
  },
  "52052": {
    DMA: 637,
  },
  "52053": {
    DMA: 637,
  },
  "52054": {
    DMA: 682,
  },
  "52056": {
    DMA: 637,
  },
  "52057": {
    DMA: 637,
  },
  "52060": {
    DMA: 682,
  },
  "52064": {
    DMA: 682,
  },
  "52065": {
    DMA: 637,
  },
  "52066": {
    DMA: 637,
  },
  "52068": {
    DMA: 637,
  },
  "52069": {
    DMA: 682,
  },
  "52070": {
    DMA: 682,
  },
  "52071": {
    DMA: 682,
  },
  "52072": {
    DMA: 637,
  },
  "52073": {
    DMA: 637,
  },
  "52074": {
    DMA: 682,
  },
  "52075": {
    DMA: 682,
  },
  "52076": {
    DMA: 637,
  },
  "52077": {
    DMA: 637,
  },
  "52078": {
    DMA: 637,
  },
  "52079": {
    DMA: 637,
  },
  "52099": {
    DMA: 637,
  },
  "52101": {
    DMA: 637,
  },
  "52132": {
    DMA: 637,
  },
  "52133": {
    DMA: 637,
  },
  "52134": {
    DMA: 611,
  },
  "52135": {
    DMA: 637,
  },
  "52136": {
    DMA: 611,
  },
  "52140": {
    DMA: 637,
  },
  "52141": {
    DMA: 637,
  },
  "52142": {
    DMA: 637,
  },
  "52144": {
    DMA: 637,
  },
  "52146": {
    DMA: 637,
  },
  "52147": {
    DMA: 637,
  },
  "52149": {
    DMA: 637,
  },
  "52151": {
    DMA: 637,
  },
  "52154": {
    DMA: 637,
  },
  "52155": {
    DMA: 611,
  },
  "52156": {
    DMA: 637,
  },
  "52157": {
    DMA: 637,
  },
  "52158": {
    DMA: 637,
  },
  "52159": {
    DMA: 637,
  },
  "52160": {
    DMA: 637,
  },
  "52161": {
    DMA: 637,
  },
  "52162": {
    DMA: 637,
  },
  "52163": {
    DMA: 611,
  },
  "52164": {
    DMA: 637,
  },
  "52165": {
    DMA: 637,
  },
  "52166": {
    DMA: 637,
  },
  "52168": {
    DMA: 637,
  },
  "52169": {
    DMA: 637,
  },
  "52170": {
    DMA: 637,
  },
  "52171": {
    DMA: 637,
  },
  "52172": {
    DMA: 637,
  },
  "52175": {
    DMA: 637,
  },
  "52201": {
    DMA: 637,
  },
  "52202": {
    DMA: 637,
  },
  "52203": {
    DMA: 637,
  },
  "52204": {
    DMA: 637,
  },
  "52205": {
    DMA: 637,
  },
  "52206": {
    DMA: 637,
  },
  "52207": {
    DMA: 682,
  },
  "52208": {
    DMA: 637,
  },
  "52209": {
    DMA: 637,
  },
  "52210": {
    DMA: 637,
  },
  "52211": {
    DMA: 679,
  },
  "52212": {
    DMA: 637,
  },
  "52213": {
    DMA: 637,
  },
  "52214": {
    DMA: 637,
  },
  "52215": {
    DMA: 637,
  },
  "52216": {
    DMA: 637,
  },
  "52217": {
    DMA: 637,
  },
  "52218": {
    DMA: 637,
  },
  "52219": {
    DMA: 637,
  },
  "52220": {
    DMA: 637,
  },
  "52221": {
    DMA: 679,
  },
  "52222": {
    DMA: 679,
  },
  "52223": {
    DMA: 637,
  },
  "52224": {
    DMA: 637,
  },
  "52225": {
    DMA: 637,
  },
  "52227": {
    DMA: 637,
  },
  "52228": {
    DMA: 637,
  },
  "52229": {
    DMA: 637,
  },
  "52231": {
    DMA: 637,
  },
  "52232": {
    DMA: 679,
  },
  "52233": {
    DMA: 637,
  },
  "52235": {
    DMA: 637,
  },
  "52236": {
    DMA: 637,
  },
  "52237": {
    DMA: 637,
  },
  "52240": {
    DMA: 637,
  },
  "52241": {
    DMA: 637,
  },
  "52242": {
    DMA: 637,
  },
  "52243": {
    DMA: 637,
  },
  "52244": {
    DMA: 637,
  },
  "52245": {
    DMA: 637,
  },
  "52246": {
    DMA: 637,
  },
  "52247": {
    DMA: 637,
  },
  "52248": {
    DMA: 637,
  },
  "52249": {
    DMA: 637,
  },
  "52251": {
    DMA: 637,
  },
  "52252": {
    DMA: 637,
  },
  "52253": {
    DMA: 637,
  },
  "52254": {
    DMA: 682,
  },
  "52255": {
    DMA: 637,
  },
  "52257": {
    DMA: 637,
  },
  "52301": {
    DMA: 637,
  },
  "52302": {
    DMA: 637,
  },
  "52305": {
    DMA: 637,
  },
  "52306": {
    DMA: 637,
  },
  "52307": {
    DMA: 637,
  },
  "52308": {
    DMA: 637,
  },
  "52309": {
    DMA: 682,
  },
  "52310": {
    DMA: 637,
  },
  "52312": {
    DMA: 637,
  },
  "52313": {
    DMA: 637,
  },
  "52314": {
    DMA: 637,
  },
  "52315": {
    DMA: 637,
  },
  "52316": {
    DMA: 637,
  },
  "52317": {
    DMA: 637,
  },
  "52318": {
    DMA: 637,
  },
  "52319": {
    DMA: 637,
  },
  "52320": {
    DMA: 637,
  },
  "52321": {
    DMA: 637,
  },
  "52322": {
    DMA: 637,
  },
  "52323": {
    DMA: 637,
  },
  "52324": {
    DMA: 637,
  },
  "52325": {
    DMA: 637,
  },
  "52326": {
    DMA: 637,
  },
  "52327": {
    DMA: 637,
  },
  "52328": {
    DMA: 637,
  },
  "52329": {
    DMA: 637,
  },
  "52330": {
    DMA: 637,
  },
  "52332": {
    DMA: 637,
  },
  "52333": {
    DMA: 637,
  },
  "52334": {
    DMA: 637,
  },
  "52335": {
    DMA: 637,
  },
  "52336": {
    DMA: 637,
  },
  "52337": {
    DMA: 637,
  },
  "52338": {
    DMA: 637,
  },
  "52339": {
    DMA: 637,
  },
  "52340": {
    DMA: 637,
  },
  "52341": {
    DMA: 637,
  },
  "52342": {
    DMA: 637,
  },
  "52344": {
    DMA: 637,
  },
  "52345": {
    DMA: 637,
  },
  "52346": {
    DMA: 637,
  },
  "52347": {
    DMA: 637,
  },
  "52348": {
    DMA: 637,
  },
  "52349": {
    DMA: 637,
  },
  "52350": {
    DMA: 637,
  },
  "52351": {
    DMA: 637,
  },
  "52352": {
    DMA: 637,
  },
  "52353": {
    DMA: 637,
  },
  "52354": {
    DMA: 637,
  },
  "52355": {
    DMA: 637,
  },
  "52356": {
    DMA: 637,
  },
  "52358": {
    DMA: 637,
  },
  "52359": {
    DMA: 637,
  },
  "52361": {
    DMA: 637,
  },
  "52362": {
    DMA: 637,
  },
  "52401": {
    DMA: 637,
  },
  "52402": {
    DMA: 637,
  },
  "52403": {
    DMA: 637,
  },
  "52404": {
    DMA: 637,
  },
  "52405": {
    DMA: 637,
  },
  "52406": {
    DMA: 637,
  },
  "52407": {
    DMA: 637,
  },
  "52408": {
    DMA: 637,
  },
  "52409": {
    DMA: 637,
  },
  "52410": {
    DMA: 637,
  },
  "52411": {
    DMA: 637,
  },
  "52497": {
    DMA: 637,
  },
  "52498": {
    DMA: 637,
  },
  "52499": {
    DMA: 637,
  },
  "52501": {
    DMA: 631,
  },
  "52530": {
    DMA: 631,
  },
  "52531": {
    DMA: 679,
  },
  "52533": {
    DMA: 631,
  },
  "52534": {
    DMA: 679,
  },
  "52535": {
    DMA: 631,
  },
  "52536": {
    DMA: 631,
  },
  "52537": {
    DMA: 631,
  },
  "52538": {
    DMA: 679,
  },
  "52540": {
    DMA: 637,
  },
  "52542": {
    DMA: 631,
  },
  "52543": {
    DMA: 679,
  },
  "52544": {
    DMA: 679,
  },
  "52548": {
    DMA: 631,
  },
  "52549": {
    DMA: 679,
  },
  "52550": {
    DMA: 637,
  },
  "52551": {
    DMA: 631,
  },
  "52552": {
    DMA: 631,
  },
  "52553": {
    DMA: 631,
  },
  "52554": {
    DMA: 631,
  },
  "52555": {
    DMA: 679,
  },
  "52556": {
    DMA: 631,
  },
  "52557": {
    DMA: 631,
  },
  "52560": {
    DMA: 631,
  },
  "52561": {
    DMA: 679,
  },
  "52562": {
    DMA: 637,
  },
  "52563": {
    DMA: 637,
  },
  "52565": {
    DMA: 631,
  },
  "52566": {
    DMA: 631,
  },
  "52567": {
    DMA: 631,
  },
  "52568": {
    DMA: 637,
  },
  "52569": {
    DMA: 679,
  },
  "52570": {
    DMA: 631,
  },
  "52571": {
    DMA: 679,
  },
  "52572": {
    DMA: 679,
  },
  "52573": {
    DMA: 631,
  },
  "52574": {
    DMA: 679,
  },
  "52576": {
    DMA: 637,
  },
  "52577": {
    DMA: 679,
  },
  "52580": {
    DMA: 631,
  },
  "52581": {
    DMA: 679,
  },
  "52583": {
    DMA: 679,
  },
  "52584": {
    DMA: 631,
  },
  "52585": {
    DMA: 637,
  },
  "52586": {
    DMA: 679,
  },
  "52588": {
    DMA: 631,
  },
  "52590": {
    DMA: 679,
  },
  "52591": {
    DMA: 637,
  },
  "52593": {
    DMA: 679,
  },
  "52594": {
    DMA: 679,
  },
  "52595": {
    DMA: 679,
  },
  "52601": {
    DMA: 682,
  },
  "52619": {
    DMA: 717,
  },
  "52620": {
    DMA: 631,
  },
  "52621": {
    DMA: 637,
  },
  "52623": {
    DMA: 682,
  },
  "52624": {
    DMA: 717,
  },
  "52625": {
    DMA: 717,
  },
  "52626": {
    DMA: 631,
  },
  "52627": {
    DMA: 717,
  },
  "52630": {
    DMA: 682,
  },
  "52631": {
    DMA: 717,
  },
  "52632": {
    DMA: 717,
  },
  "52635": {
    DMA: 631,
  },
  "52637": {
    DMA: 682,
  },
  "52638": {
    DMA: 682,
  },
  "52639": {
    DMA: 717,
  },
  "52640": {
    DMA: 682,
  },
  "52641": {
    DMA: 682,
  },
  "52642": {
    DMA: 682,
  },
  "52644": {
    DMA: 682,
  },
  "52645": {
    DMA: 682,
  },
  "52646": {
    DMA: 682,
  },
  "52647": {
    DMA: 682,
  },
  "52648": {
    DMA: 717,
  },
  "52649": {
    DMA: 682,
  },
  "52650": {
    DMA: 682,
  },
  "52651": {
    DMA: 631,
  },
  "52652": {
    DMA: 682,
  },
  "52653": {
    DMA: 682,
  },
  "52654": {
    DMA: 682,
  },
  "52655": {
    DMA: 682,
  },
  "52656": {
    DMA: 717,
  },
  "52657": {
    DMA: 717,
  },
  "52658": {
    DMA: 717,
  },
  "52659": {
    DMA: 682,
  },
  "52660": {
    DMA: 682,
  },
  "52701": {
    DMA: 682,
  },
  "52720": {
    DMA: 682,
  },
  "52721": {
    DMA: 637,
  },
  "52722": {
    DMA: 682,
  },
  "52726": {
    DMA: 682,
  },
  "52727": {
    DMA: 682,
  },
  "52728": {
    DMA: 682,
  },
  "52729": {
    DMA: 682,
  },
  "52730": {
    DMA: 682,
  },
  "52731": {
    DMA: 682,
  },
  "52732": {
    DMA: 682,
  },
  "52733": {
    DMA: 682,
  },
  "52734": {
    DMA: 682,
  },
  "52736": {
    DMA: 682,
  },
  "52737": {
    DMA: 682,
  },
  "52738": {
    DMA: 682,
  },
  "52739": {
    DMA: 682,
  },
  "52742": {
    DMA: 682,
  },
  "52745": {
    DMA: 682,
  },
  "52746": {
    DMA: 682,
  },
  "52747": {
    DMA: 637,
  },
  "52748": {
    DMA: 682,
  },
  "52749": {
    DMA: 682,
  },
  "52750": {
    DMA: 682,
  },
  "52751": {
    DMA: 682,
  },
  "52752": {
    DMA: 682,
  },
  "52753": {
    DMA: 682,
  },
  "52754": {
    DMA: 682,
  },
  "52755": {
    DMA: 637,
  },
  "52756": {
    DMA: 682,
  },
  "52757": {
    DMA: 682,
  },
  "52758": {
    DMA: 682,
  },
  "52759": {
    DMA: 682,
  },
  "52760": {
    DMA: 682,
  },
  "52761": {
    DMA: 682,
  },
  "52765": {
    DMA: 682,
  },
  "52766": {
    DMA: 682,
  },
  "52767": {
    DMA: 682,
  },
  "52768": {
    DMA: 682,
  },
  "52769": {
    DMA: 682,
  },
  "52771": {
    DMA: 682,
  },
  "52772": {
    DMA: 637,
  },
  "52773": {
    DMA: 682,
  },
  "52774": {
    DMA: 682,
  },
  "52776": {
    DMA: 682,
  },
  "52777": {
    DMA: 682,
  },
  "52778": {
    DMA: 682,
  },
  "52801": {
    DMA: 682,
  },
  "52802": {
    DMA: 682,
  },
  "52803": {
    DMA: 682,
  },
  "52804": {
    DMA: 682,
  },
  "52805": {
    DMA: 682,
  },
  "52806": {
    DMA: 682,
  },
  "52807": {
    DMA: 682,
  },
  "52808": {
    DMA: 682,
  },
  "52809": {
    DMA: 682,
  },
  "53001": {
    DMA: 617,
  },
  "53002": {
    DMA: 617,
  },
  "53003": {
    DMA: 617,
  },
  "53004": {
    DMA: 617,
  },
  "53005": {
    DMA: 617,
  },
  "53006": {
    DMA: 617,
  },
  "53007": {
    DMA: 617,
  },
  "53008": {
    DMA: 617,
  },
  "53010": {
    DMA: 658,
  },
  "53011": {
    DMA: 617,
  },
  "53012": {
    DMA: 617,
  },
  "53013": {
    DMA: 617,
  },
  "53014": {
    DMA: 658,
  },
  "53015": {
    DMA: 658,
  },
  "53016": {
    DMA: 617,
  },
  "53017": {
    DMA: 617,
  },
  "53018": {
    DMA: 617,
  },
  "53019": {
    DMA: 658,
  },
  "53020": {
    DMA: 617,
  },
  "53021": {
    DMA: 617,
  },
  "53022": {
    DMA: 617,
  },
  "53023": {
    DMA: 617,
  },
  "53024": {
    DMA: 617,
  },
  "53026": {
    DMA: 617,
  },
  "53027": {
    DMA: 617,
  },
  "53029": {
    DMA: 617,
  },
  "53031": {
    DMA: 617,
  },
  "53032": {
    DMA: 617,
  },
  "53033": {
    DMA: 617,
  },
  "53034": {
    DMA: 617,
  },
  "53035": {
    DMA: 617,
  },
  "53036": {
    DMA: 617,
  },
  "53037": {
    DMA: 617,
  },
  "53038": {
    DMA: 617,
  },
  "53039": {
    DMA: 617,
  },
  "53040": {
    DMA: 617,
  },
  "53042": {
    DMA: 658,
  },
  "53044": {
    DMA: 617,
  },
  "53045": {
    DMA: 617,
  },
  "53046": {
    DMA: 617,
  },
  "53047": {
    DMA: 617,
  },
  "53048": {
    DMA: 617,
  },
  "53049": {
    DMA: 658,
  },
  "53050": {
    DMA: 617,
  },
  "53051": {
    DMA: 617,
  },
  "53052": {
    DMA: 617,
  },
  "53056": {
    DMA: 617,
  },
  "53057": {
    DMA: 658,
  },
  "53058": {
    DMA: 617,
  },
  "53059": {
    DMA: 617,
  },
  "53060": {
    DMA: 617,
  },
  "53061": {
    DMA: 658,
  },
  "53062": {
    DMA: 658,
  },
  "53063": {
    DMA: 658,
  },
  "53064": {
    DMA: 617,
  },
  "53065": {
    DMA: 658,
  },
  "53066": {
    DMA: 617,
  },
  "53069": {
    DMA: 617,
  },
  "53070": {
    DMA: 617,
  },
  "53072": {
    DMA: 617,
  },
  "53073": {
    DMA: 617,
  },
  "53074": {
    DMA: 617,
  },
  "53075": {
    DMA: 617,
  },
  "53076": {
    DMA: 617,
  },
  "53078": {
    DMA: 617,
  },
  "53079": {
    DMA: 658,
  },
  "53080": {
    DMA: 617,
  },
  "53081": {
    DMA: 617,
  },
  "53082": {
    DMA: 617,
  },
  "53083": {
    DMA: 617,
  },
  "53085": {
    DMA: 617,
  },
  "53086": {
    DMA: 617,
  },
  "53088": {
    DMA: 658,
  },
  "53089": {
    DMA: 617,
  },
  "53090": {
    DMA: 617,
  },
  "53091": {
    DMA: 617,
  },
  "53092": {
    DMA: 617,
  },
  "53093": {
    DMA: 617,
  },
  "53094": {
    DMA: 617,
  },
  "53095": {
    DMA: 617,
  },
  "53097": {
    DMA: 617,
  },
  "53098": {
    DMA: 617,
  },
  "53099": {
    DMA: 617,
  },
  "53101": {
    DMA: 617,
  },
  "53102": {
    DMA: 617,
  },
  "53103": {
    DMA: 617,
  },
  "53104": {
    DMA: 617,
  },
  "53105": {
    DMA: 617,
  },
  "53108": {
    DMA: 617,
  },
  "53109": {
    DMA: 617,
  },
  "53110": {
    DMA: 617,
  },
  "53114": {
    DMA: 617,
  },
  "53115": {
    DMA: 617,
  },
  "53118": {
    DMA: 617,
  },
  "53119": {
    DMA: 617,
  },
  "53120": {
    DMA: 617,
  },
  "53121": {
    DMA: 617,
  },
  "53122": {
    DMA: 617,
  },
  "53125": {
    DMA: 617,
  },
  "53126": {
    DMA: 617,
  },
  "53127": {
    DMA: 617,
  },
  "53128": {
    DMA: 617,
  },
  "53129": {
    DMA: 617,
  },
  "53130": {
    DMA: 617,
  },
  "53132": {
    DMA: 617,
  },
  "53137": {
    DMA: 617,
  },
  "53138": {
    DMA: 617,
  },
  "53139": {
    DMA: 617,
  },
  "53140": {
    DMA: 617,
  },
  "53141": {
    DMA: 617,
  },
  "53142": {
    DMA: 617,
  },
  "53143": {
    DMA: 617,
  },
  "53144": {
    DMA: 617,
  },
  "53146": {
    DMA: 617,
  },
  "53147": {
    DMA: 617,
  },
  "53148": {
    DMA: 617,
  },
  "53149": {
    DMA: 617,
  },
  "53150": {
    DMA: 617,
  },
  "53151": {
    DMA: 617,
  },
  "53152": {
    DMA: 617,
  },
  "53153": {
    DMA: 617,
  },
  "53154": {
    DMA: 617,
  },
  "53156": {
    DMA: 617,
  },
  "53157": {
    DMA: 617,
  },
  "53158": {
    DMA: 617,
  },
  "53159": {
    DMA: 617,
  },
  "53167": {
    DMA: 617,
  },
  "53168": {
    DMA: 617,
  },
  "53170": {
    DMA: 617,
  },
  "53171": {
    DMA: 617,
  },
  "53172": {
    DMA: 617,
  },
  "53176": {
    DMA: 617,
  },
  "53177": {
    DMA: 617,
  },
  "53178": {
    DMA: 617,
  },
  "53179": {
    DMA: 617,
  },
  "53181": {
    DMA: 617,
  },
  "53182": {
    DMA: 617,
  },
  "53183": {
    DMA: 617,
  },
  "53184": {
    DMA: 617,
  },
  "53185": {
    DMA: 617,
  },
  "53186": {
    DMA: 617,
  },
  "53187": {
    DMA: 617,
  },
  "53188": {
    DMA: 617,
  },
  "53189": {
    DMA: 617,
  },
  "53190": {
    DMA: 617,
  },
  "53191": {
    DMA: 617,
  },
  "53192": {
    DMA: 617,
  },
  "53194": {
    DMA: 617,
  },
  "53195": {
    DMA: 617,
  },
  "53199": {
    DMA: 617,
  },
  "53201": {
    DMA: 617,
  },
  "53202": {
    DMA: 617,
  },
  "53203": {
    DMA: 617,
  },
  "53204": {
    DMA: 617,
  },
  "53205": {
    DMA: 617,
  },
  "53206": {
    DMA: 617,
  },
  "53207": {
    DMA: 617,
  },
  "53208": {
    DMA: 617,
  },
  "53209": {
    DMA: 617,
  },
  "53210": {
    DMA: 617,
  },
  "53211": {
    DMA: 617,
  },
  "53212": {
    DMA: 617,
  },
  "53213": {
    DMA: 617,
  },
  "53214": {
    DMA: 617,
  },
  "53215": {
    DMA: 617,
  },
  "53216": {
    DMA: 617,
  },
  "53217": {
    DMA: 617,
  },
  "53218": {
    DMA: 617,
  },
  "53219": {
    DMA: 617,
  },
  "53220": {
    DMA: 617,
  },
  "53221": {
    DMA: 617,
  },
  "53222": {
    DMA: 617,
  },
  "53223": {
    DMA: 617,
  },
  "53224": {
    DMA: 617,
  },
  "53225": {
    DMA: 617,
  },
  "53226": {
    DMA: 617,
  },
  "53227": {
    DMA: 617,
  },
  "53228": {
    DMA: 617,
  },
  "53233": {
    DMA: 617,
  },
  "53234": {
    DMA: 617,
  },
  "53235": {
    DMA: 617,
  },
  "53237": {
    DMA: 617,
  },
  "53244": {
    DMA: 617,
  },
  "53259": {
    DMA: 617,
  },
  "53263": {
    DMA: 617,
  },
  "53267": {
    DMA: 617,
  },
  "53268": {
    DMA: 617,
  },
  "53274": {
    DMA: 617,
  },
  "53278": {
    DMA: 617,
  },
  "53288": {
    DMA: 617,
  },
  "53290": {
    DMA: 617,
  },
  "53293": {
    DMA: 617,
  },
  "53295": {
    DMA: 617,
  },
  "53401": {
    DMA: 617,
  },
  "53402": {
    DMA: 617,
  },
  "53403": {
    DMA: 617,
  },
  "53404": {
    DMA: 617,
  },
  "53405": {
    DMA: 617,
  },
  "53406": {
    DMA: 617,
  },
  "53407": {
    DMA: 617,
  },
  "53408": {
    DMA: 617,
  },
  "53501": {
    DMA: 669,
  },
  "53502": {
    DMA: 669,
  },
  "53503": {
    DMA: 669,
  },
  "53504": {
    DMA: 669,
  },
  "53505": {
    DMA: 669,
  },
  "53506": {
    DMA: 669,
  },
  "53507": {
    DMA: 669,
  },
  "53508": {
    DMA: 669,
  },
  "53510": {
    DMA: 669,
  },
  "53511": {
    DMA: 669,
  },
  "53512": {
    DMA: 669,
  },
  "53515": {
    DMA: 669,
  },
  "53516": {
    DMA: 669,
  },
  "53517": {
    DMA: 669,
  },
  "53518": {
    DMA: 669,
  },
  "53520": {
    DMA: 669,
  },
  "53521": {
    DMA: 669,
  },
  "53522": {
    DMA: 669,
  },
  "53523": {
    DMA: 669,
  },
  "53525": {
    DMA: 669,
  },
  "53526": {
    DMA: 669,
  },
  "53527": {
    DMA: 669,
  },
  "53528": {
    DMA: 669,
  },
  "53529": {
    DMA: 669,
  },
  "53530": {
    DMA: 669,
  },
  "53531": {
    DMA: 669,
  },
  "53532": {
    DMA: 669,
  },
  "53533": {
    DMA: 669,
  },
  "53534": {
    DMA: 669,
  },
  "53535": {
    DMA: 669,
  },
  "53536": {
    DMA: 669,
  },
  "53537": {
    DMA: 669,
  },
  "53538": {
    DMA: 617,
  },
  "53540": {
    DMA: 669,
  },
  "53541": {
    DMA: 669,
  },
  "53542": {
    DMA: 669,
  },
  "53543": {
    DMA: 669,
  },
  "53544": {
    DMA: 669,
  },
  "53545": {
    DMA: 669,
  },
  "53546": {
    DMA: 669,
  },
  "53547": {
    DMA: 669,
  },
  "53548": {
    DMA: 669,
  },
  "53549": {
    DMA: 617,
  },
  "53550": {
    DMA: 669,
  },
  "53551": {
    DMA: 617,
  },
  "53553": {
    DMA: 669,
  },
  "53554": {
    DMA: 669,
  },
  "53555": {
    DMA: 669,
  },
  "53556": {
    DMA: 669,
  },
  "53557": {
    DMA: 617,
  },
  "53558": {
    DMA: 669,
  },
  "53559": {
    DMA: 669,
  },
  "53560": {
    DMA: 669,
  },
  "53561": {
    DMA: 669,
  },
  "53562": {
    DMA: 669,
  },
  "53563": {
    DMA: 669,
  },
  "53565": {
    DMA: 669,
  },
  "53566": {
    DMA: 669,
  },
  "53569": {
    DMA: 669,
  },
  "53570": {
    DMA: 669,
  },
  "53571": {
    DMA: 669,
  },
  "53572": {
    DMA: 669,
  },
  "53573": {
    DMA: 669,
  },
  "53574": {
    DMA: 669,
  },
  "53575": {
    DMA: 669,
  },
  "53576": {
    DMA: 669,
  },
  "53577": {
    DMA: 669,
  },
  "53578": {
    DMA: 669,
  },
  "53579": {
    DMA: 617,
  },
  "53580": {
    DMA: 669,
  },
  "53581": {
    DMA: 669,
  },
  "53582": {
    DMA: 669,
  },
  "53583": {
    DMA: 669,
  },
  "53584": {
    DMA: 669,
  },
  "53585": {
    DMA: 617,
  },
  "53586": {
    DMA: 669,
  },
  "53587": {
    DMA: 669,
  },
  "53588": {
    DMA: 669,
  },
  "53589": {
    DMA: 669,
  },
  "53590": {
    DMA: 669,
  },
  "53593": {
    DMA: 669,
  },
  "53594": {
    DMA: 617,
  },
  "53595": {
    DMA: 669,
  },
  "53596": {
    DMA: 669,
  },
  "53597": {
    DMA: 669,
  },
  "53598": {
    DMA: 669,
  },
  "53599": {
    DMA: 669,
  },
  "53701": {
    DMA: 669,
  },
  "53702": {
    DMA: 669,
  },
  "53703": {
    DMA: 669,
  },
  "53704": {
    DMA: 669,
  },
  "53705": {
    DMA: 669,
  },
  "53706": {
    DMA: 669,
  },
  "53707": {
    DMA: 669,
  },
  "53708": {
    DMA: 669,
  },
  "53711": {
    DMA: 669,
  },
  "53713": {
    DMA: 669,
  },
  "53714": {
    DMA: 669,
  },
  "53715": {
    DMA: 669,
  },
  "53716": {
    DMA: 669,
  },
  "53717": {
    DMA: 669,
  },
  "53718": {
    DMA: 669,
  },
  "53719": {
    DMA: 669,
  },
  "53725": {
    DMA: 669,
  },
  "53726": {
    DMA: 669,
  },
  "53744": {
    DMA: 669,
  },
  "53774": {
    DMA: 669,
  },
  "53777": {
    DMA: 669,
  },
  "53778": {
    DMA: 699,
  },
  "53779": {
    DMA: 699,
  },
  "53782": {
    DMA: 669,
  },
  "53783": {
    DMA: 669,
  },
  "53784": {
    DMA: 669,
  },
  "53785": {
    DMA: 669,
  },
  "53786": {
    DMA: 669,
  },
  "53788": {
    DMA: 669,
  },
  "53789": {
    DMA: 699,
  },
  "53790": {
    DMA: 669,
  },
  "53791": {
    DMA: 669,
  },
  "53792": {
    DMA: 669,
  },
  "53793": {
    DMA: 669,
  },
  "53794": {
    DMA: 669,
  },
  "53801": {
    DMA: 669,
  },
  "53802": {
    DMA: 669,
  },
  "53803": {
    DMA: 669,
  },
  "53804": {
    DMA: 669,
  },
  "53805": {
    DMA: 669,
  },
  "53806": {
    DMA: 669,
  },
  "53807": {
    DMA: 669,
  },
  "53808": {
    DMA: 669,
  },
  "53809": {
    DMA: 669,
  },
  "53810": {
    DMA: 669,
  },
  "53811": {
    DMA: 669,
  },
  "53812": {
    DMA: 669,
  },
  "53813": {
    DMA: 669,
  },
  "53816": {
    DMA: 669,
  },
  "53817": {
    DMA: 669,
  },
  "53818": {
    DMA: 669,
  },
  "53820": {
    DMA: 669,
  },
  "53821": {
    DMA: 702,
  },
  "53824": {
    DMA: 669,
  },
  "53825": {
    DMA: 669,
  },
  "53826": {
    DMA: 702,
  },
  "53827": {
    DMA: 669,
  },
  "53901": {
    DMA: 669,
  },
  "53910": {
    DMA: 705,
  },
  "53911": {
    DMA: 669,
  },
  "53913": {
    DMA: 669,
  },
  "53916": {
    DMA: 617,
  },
  "53919": {
    DMA: 658,
  },
  "53920": {
    DMA: 669,
  },
  "53922": {
    DMA: 617,
  },
  "53923": {
    DMA: 669,
  },
  "53924": {
    DMA: 669,
  },
  "53925": {
    DMA: 669,
  },
  "53926": {
    DMA: 658,
  },
  "53927": {
    DMA: 705,
  },
  "53928": {
    DMA: 669,
  },
  "53929": {
    DMA: 669,
  },
  "53930": {
    DMA: 669,
  },
  "53931": {
    DMA: 658,
  },
  "53932": {
    DMA: 669,
  },
  "53933": {
    DMA: 617,
  },
  "53934": {
    DMA: 705,
  },
  "53935": {
    DMA: 669,
  },
  "53936": {
    DMA: 705,
  },
  "53937": {
    DMA: 669,
  },
  "53939": {
    DMA: 658,
  },
  "53940": {
    DMA: 669,
  },
  "53941": {
    DMA: 669,
  },
  "53942": {
    DMA: 669,
  },
  "53943": {
    DMA: 669,
  },
  "53944": {
    DMA: 669,
  },
  "53946": {
    DMA: 658,
  },
  "53947": {
    DMA: 658,
  },
  "53948": {
    DMA: 669,
  },
  "53949": {
    DMA: 669,
  },
  "53950": {
    DMA: 669,
  },
  "53951": {
    DMA: 669,
  },
  "53952": {
    DMA: 669,
  },
  "53953": {
    DMA: 669,
  },
  "53954": {
    DMA: 669,
  },
  "53955": {
    DMA: 669,
  },
  "53956": {
    DMA: 617,
  },
  "53957": {
    DMA: 669,
  },
  "53958": {
    DMA: 669,
  },
  "53959": {
    DMA: 669,
  },
  "53960": {
    DMA: 669,
  },
  "53961": {
    DMA: 669,
  },
  "53962": {
    DMA: 669,
  },
  "53963": {
    DMA: 617,
  },
  "53964": {
    DMA: 669,
  },
  "53965": {
    DMA: 669,
  },
  "53968": {
    DMA: 669,
  },
  "53969": {
    DMA: 669,
  },
  "54001": {
    DMA: 613,
  },
  "54002": {
    DMA: 613,
  },
  "54003": {
    DMA: 613,
  },
  "54004": {
    DMA: 613,
  },
  "54005": {
    DMA: 613,
  },
  "54006": {
    DMA: 613,
  },
  "54007": {
    DMA: 613,
  },
  "54009": {
    DMA: 613,
  },
  "54010": {
    DMA: 613,
  },
  "54011": {
    DMA: 613,
  },
  "54013": {
    DMA: 613,
  },
  "54014": {
    DMA: 613,
  },
  "54015": {
    DMA: 613,
  },
  "54016": {
    DMA: 613,
  },
  "54017": {
    DMA: 613,
  },
  "54020": {
    DMA: 613,
  },
  "54021": {
    DMA: 613,
  },
  "54022": {
    DMA: 613,
  },
  "54023": {
    DMA: 613,
  },
  "54024": {
    DMA: 613,
  },
  "54025": {
    DMA: 613,
  },
  "54026": {
    DMA: 613,
  },
  "54027": {
    DMA: 613,
  },
  "54028": {
    DMA: 613,
  },
  "54082": {
    DMA: 613,
  },
  "54101": {
    DMA: 658,
  },
  "54102": {
    DMA: 658,
  },
  "54103": {
    DMA: 705,
  },
  "54104": {
    DMA: 658,
  },
  "54106": {
    DMA: 658,
  },
  "54107": {
    DMA: 658,
  },
  "54110": {
    DMA: 658,
  },
  "54111": {
    DMA: 658,
  },
  "54112": {
    DMA: 658,
  },
  "54113": {
    DMA: 658,
  },
  "54114": {
    DMA: 658,
  },
  "54115": {
    DMA: 658,
  },
  "54119": {
    DMA: 658,
  },
  "54120": {
    DMA: 553,
  },
  "54121": {
    DMA: 553,
  },
  "54123": {
    DMA: 658,
  },
  "54124": {
    DMA: 658,
  },
  "54125": {
    DMA: 658,
  },
  "54126": {
    DMA: 658,
  },
  "54127": {
    DMA: 658,
  },
  "54128": {
    DMA: 658,
  },
  "54129": {
    DMA: 658,
  },
  "54130": {
    DMA: 658,
  },
  "54131": {
    DMA: 658,
  },
  "54135": {
    DMA: 658,
  },
  "54136": {
    DMA: 658,
  },
  "54137": {
    DMA: 658,
  },
  "54138": {
    DMA: 658,
  },
  "54139": {
    DMA: 658,
  },
  "54140": {
    DMA: 658,
  },
  "54141": {
    DMA: 658,
  },
  "54143": {
    DMA: 658,
  },
  "54149": {
    DMA: 658,
  },
  "54150": {
    DMA: 658,
  },
  "54151": {
    DMA: 658,
  },
  "54152": {
    DMA: 658,
  },
  "54153": {
    DMA: 658,
  },
  "54154": {
    DMA: 658,
  },
  "54155": {
    DMA: 658,
  },
  "54156": {
    DMA: 658,
  },
  "54157": {
    DMA: 658,
  },
  "54159": {
    DMA: 658,
  },
  "54160": {
    DMA: 658,
  },
  "54161": {
    DMA: 658,
  },
  "54162": {
    DMA: 658,
  },
  "54165": {
    DMA: 658,
  },
  "54166": {
    DMA: 658,
  },
  "54169": {
    DMA: 658,
  },
  "54170": {
    DMA: 658,
  },
  "54171": {
    DMA: 658,
  },
  "54173": {
    DMA: 658,
  },
  "54174": {
    DMA: 658,
  },
  "54175": {
    DMA: 658,
  },
  "54177": {
    DMA: 658,
  },
  "54180": {
    DMA: 658,
  },
  "54182": {
    DMA: 658,
  },
  "54201": {
    DMA: 658,
  },
  "54202": {
    DMA: 658,
  },
  "54204": {
    DMA: 658,
  },
  "54205": {
    DMA: 658,
  },
  "54207": {
    DMA: 658,
  },
  "54208": {
    DMA: 658,
  },
  "54209": {
    DMA: 658,
  },
  "54210": {
    DMA: 658,
  },
  "54211": {
    DMA: 658,
  },
  "54212": {
    DMA: 658,
  },
  "54213": {
    DMA: 658,
  },
  "54214": {
    DMA: 658,
  },
  "54215": {
    DMA: 658,
  },
  "54216": {
    DMA: 658,
  },
  "54217": {
    DMA: 658,
  },
  "54220": {
    DMA: 658,
  },
  "54221": {
    DMA: 658,
  },
  "54226": {
    DMA: 658,
  },
  "54227": {
    DMA: 658,
  },
  "54228": {
    DMA: 658,
  },
  "54229": {
    DMA: 658,
  },
  "54230": {
    DMA: 658,
  },
  "54232": {
    DMA: 658,
  },
  "54234": {
    DMA: 658,
  },
  "54235": {
    DMA: 658,
  },
  "54240": {
    DMA: 658,
  },
  "54241": {
    DMA: 658,
  },
  "54245": {
    DMA: 658,
  },
  "54246": {
    DMA: 658,
  },
  "54247": {
    DMA: 658,
  },
  "54301": {
    DMA: 658,
  },
  "54302": {
    DMA: 658,
  },
  "54303": {
    DMA: 658,
  },
  "54304": {
    DMA: 658,
  },
  "54305": {
    DMA: 658,
  },
  "54306": {
    DMA: 658,
  },
  "54307": {
    DMA: 658,
  },
  "54308": {
    DMA: 658,
  },
  "54311": {
    DMA: 658,
  },
  "54313": {
    DMA: 658,
  },
  "54324": {
    DMA: 658,
  },
  "54344": {
    DMA: 658,
  },
  "54401": {
    DMA: 705,
  },
  "54402": {
    DMA: 705,
  },
  "54403": {
    DMA: 705,
  },
  "54404": {
    DMA: 705,
  },
  "54405": {
    DMA: 702,
  },
  "54406": {
    DMA: 705,
  },
  "54407": {
    DMA: 705,
  },
  "54408": {
    DMA: 705,
  },
  "54409": {
    DMA: 705,
  },
  "54410": {
    DMA: 705,
  },
  "54411": {
    DMA: 705,
  },
  "54412": {
    DMA: 705,
  },
  "54413": {
    DMA: 705,
  },
  "54414": {
    DMA: 658,
  },
  "54415": {
    DMA: 705,
  },
  "54416": {
    DMA: 658,
  },
  "54417": {
    DMA: 705,
  },
  "54418": {
    DMA: 705,
  },
  "54420": {
    DMA: 702,
  },
  "54421": {
    DMA: 702,
  },
  "54422": {
    DMA: 702,
  },
  "54423": {
    DMA: 705,
  },
  "54424": {
    DMA: 705,
  },
  "54425": {
    DMA: 702,
  },
  "54426": {
    DMA: 705,
  },
  "54427": {
    DMA: 705,
  },
  "54428": {
    DMA: 705,
  },
  "54429": {
    DMA: 705,
  },
  "54430": {
    DMA: 705,
  },
  "54432": {
    DMA: 705,
  },
  "54433": {
    DMA: 705,
  },
  "54434": {
    DMA: 705,
  },
  "54435": {
    DMA: 705,
  },
  "54436": {
    DMA: 702,
  },
  "54437": {
    DMA: 702,
  },
  "54439": {
    DMA: 705,
  },
  "54440": {
    DMA: 705,
  },
  "54441": {
    DMA: 705,
  },
  "54442": {
    DMA: 705,
  },
  "54443": {
    DMA: 705,
  },
  "54446": {
    DMA: 702,
  },
  "54447": {
    DMA: 705,
  },
  "54448": {
    DMA: 705,
  },
  "54449": {
    DMA: 705,
  },
  "54450": {
    DMA: 658,
  },
  "54451": {
    DMA: 705,
  },
  "54452": {
    DMA: 705,
  },
  "54454": {
    DMA: 705,
  },
  "54455": {
    DMA: 705,
  },
  "54456": {
    DMA: 702,
  },
  "54457": {
    DMA: 705,
  },
  "54458": {
    DMA: 705,
  },
  "54459": {
    DMA: 705,
  },
  "54460": {
    DMA: 702,
  },
  "54462": {
    DMA: 705,
  },
  "54463": {
    DMA: 705,
  },
  "54464": {
    DMA: 705,
  },
  "54465": {
    DMA: 705,
  },
  "54466": {
    DMA: 705,
  },
  "54467": {
    DMA: 705,
  },
  "54469": {
    DMA: 705,
  },
  "54470": {
    DMA: 705,
  },
  "54471": {
    DMA: 705,
  },
  "54472": {
    DMA: 705,
  },
  "54473": {
    DMA: 705,
  },
  "54474": {
    DMA: 705,
  },
  "54475": {
    DMA: 705,
  },
  "54476": {
    DMA: 705,
  },
  "54479": {
    DMA: 705,
  },
  "54480": {
    DMA: 705,
  },
  "54481": {
    DMA: 705,
  },
  "54482": {
    DMA: 705,
  },
  "54484": {
    DMA: 705,
  },
  "54485": {
    DMA: 705,
  },
  "54486": {
    DMA: 658,
  },
  "54487": {
    DMA: 705,
  },
  "54488": {
    DMA: 705,
  },
  "54489": {
    DMA: 705,
  },
  "54490": {
    DMA: 705,
  },
  "54491": {
    DMA: 705,
  },
  "54492": {
    DMA: 705,
  },
  "54493": {
    DMA: 702,
  },
  "54494": {
    DMA: 705,
  },
  "54495": {
    DMA: 705,
  },
  "54498": {
    DMA: 702,
  },
  "54499": {
    DMA: 658,
  },
  "54501": {
    DMA: 705,
  },
  "54511": {
    DMA: 705,
  },
  "54512": {
    DMA: 705,
  },
  "54513": {
    DMA: 705,
  },
  "54514": {
    DMA: 676,
  },
  "54515": {
    DMA: 705,
  },
  "54517": {
    DMA: 676,
  },
  "54519": {
    DMA: 705,
  },
  "54520": {
    DMA: 705,
  },
  "54521": {
    DMA: 705,
  },
  "54524": {
    DMA: 705,
  },
  "54525": {
    DMA: 676,
  },
  "54526": {
    DMA: 702,
  },
  "54527": {
    DMA: 676,
  },
  "54529": {
    DMA: 705,
  },
  "54530": {
    DMA: 702,
  },
  "54531": {
    DMA: 705,
  },
  "54532": {
    DMA: 705,
  },
  "54534": {
    DMA: 676,
  },
  "54536": {
    DMA: 676,
  },
  "54537": {
    DMA: 705,
  },
  "54538": {
    DMA: 705,
  },
  "54539": {
    DMA: 705,
  },
  "54540": {
    DMA: 705,
  },
  "54541": {
    DMA: 705,
  },
  "54542": {
    DMA: 553,
  },
  "54543": {
    DMA: 705,
  },
  "54545": {
    DMA: 705,
  },
  "54546": {
    DMA: 676,
  },
  "54547": {
    DMA: 676,
  },
  "54548": {
    DMA: 705,
  },
  "54550": {
    DMA: 676,
  },
  "54552": {
    DMA: 705,
  },
  "54554": {
    DMA: 705,
  },
  "54555": {
    DMA: 705,
  },
  "54556": {
    DMA: 705,
  },
  "54557": {
    DMA: 705,
  },
  "54558": {
    DMA: 705,
  },
  "54559": {
    DMA: 676,
  },
  "54560": {
    DMA: 705,
  },
  "54561": {
    DMA: 705,
  },
  "54562": {
    DMA: 705,
  },
  "54563": {
    DMA: 702,
  },
  "54564": {
    DMA: 705,
  },
  "54565": {
    DMA: 676,
  },
  "54566": {
    DMA: 705,
  },
  "54568": {
    DMA: 705,
  },
  "54601": {
    DMA: 702,
  },
  "54602": {
    DMA: 702,
  },
  "54603": {
    DMA: 702,
  },
  "54610": {
    DMA: 702,
  },
  "54611": {
    DMA: 702,
  },
  "54612": {
    DMA: 702,
  },
  "54613": {
    DMA: 705,
  },
  "54614": {
    DMA: 702,
  },
  "54615": {
    DMA: 702,
  },
  "54616": {
    DMA: 702,
  },
  "54618": {
    DMA: 669,
  },
  "54619": {
    DMA: 702,
  },
  "54620": {
    DMA: 702,
  },
  "54621": {
    DMA: 702,
  },
  "54622": {
    DMA: 702,
  },
  "54623": {
    DMA: 702,
  },
  "54624": {
    DMA: 702,
  },
  "54625": {
    DMA: 702,
  },
  "54626": {
    DMA: 702,
  },
  "54627": {
    DMA: 702,
  },
  "54628": {
    DMA: 702,
  },
  "54629": {
    DMA: 702,
  },
  "54630": {
    DMA: 702,
  },
  "54631": {
    DMA: 702,
  },
  "54632": {
    DMA: 702,
  },
  "54634": {
    DMA: 702,
  },
  "54635": {
    DMA: 702,
  },
  "54636": {
    DMA: 702,
  },
  "54637": {
    DMA: 669,
  },
  "54638": {
    DMA: 702,
  },
  "54639": {
    DMA: 702,
  },
  "54640": {
    DMA: 702,
  },
  "54641": {
    DMA: 669,
  },
  "54642": {
    DMA: 702,
  },
  "54643": {
    DMA: 702,
  },
  "54644": {
    DMA: 702,
  },
  "54645": {
    DMA: 702,
  },
  "54646": {
    DMA: 669,
  },
  "54648": {
    DMA: 702,
  },
  "54649": {
    DMA: 702,
  },
  "54650": {
    DMA: 702,
  },
  "54651": {
    DMA: 702,
  },
  "54652": {
    DMA: 702,
  },
  "54653": {
    DMA: 702,
  },
  "54654": {
    DMA: 702,
  },
  "54655": {
    DMA: 702,
  },
  "54656": {
    DMA: 702,
  },
  "54657": {
    DMA: 702,
  },
  "54658": {
    DMA: 702,
  },
  "54659": {
    DMA: 702,
  },
  "54660": {
    DMA: 702,
  },
  "54661": {
    DMA: 702,
  },
  "54662": {
    DMA: 702,
  },
  "54664": {
    DMA: 669,
  },
  "54665": {
    DMA: 702,
  },
  "54666": {
    DMA: 702,
  },
  "54667": {
    DMA: 702,
  },
  "54669": {
    DMA: 702,
  },
  "54670": {
    DMA: 702,
  },
  "54701": {
    DMA: 702,
  },
  "54702": {
    DMA: 702,
  },
  "54703": {
    DMA: 702,
  },
  "54720": {
    DMA: 702,
  },
  "54721": {
    DMA: 702,
  },
  "54722": {
    DMA: 702,
  },
  "54723": {
    DMA: 613,
  },
  "54724": {
    DMA: 702,
  },
  "54725": {
    DMA: 613,
  },
  "54726": {
    DMA: 702,
  },
  "54727": {
    DMA: 702,
  },
  "54728": {
    DMA: 613,
  },
  "54729": {
    DMA: 702,
  },
  "54730": {
    DMA: 613,
  },
  "54731": {
    DMA: 702,
  },
  "54732": {
    DMA: 702,
  },
  "54733": {
    DMA: 613,
  },
  "54734": {
    DMA: 613,
  },
  "54735": {
    DMA: 613,
  },
  "54736": {
    DMA: 702,
  },
  "54737": {
    DMA: 613,
  },
  "54738": {
    DMA: 702,
  },
  "54739": {
    DMA: 613,
  },
  "54740": {
    DMA: 613,
  },
  "54741": {
    DMA: 702,
  },
  "54742": {
    DMA: 702,
  },
  "54743": {
    DMA: 702,
  },
  "54745": {
    DMA: 702,
  },
  "54746": {
    DMA: 702,
  },
  "54747": {
    DMA: 702,
  },
  "54748": {
    DMA: 702,
  },
  "54749": {
    DMA: 613,
  },
  "54750": {
    DMA: 613,
  },
  "54751": {
    DMA: 613,
  },
  "54754": {
    DMA: 702,
  },
  "54755": {
    DMA: 702,
  },
  "54756": {
    DMA: 702,
  },
  "54757": {
    DMA: 702,
  },
  "54758": {
    DMA: 702,
  },
  "54759": {
    DMA: 702,
  },
  "54760": {
    DMA: 702,
  },
  "54761": {
    DMA: 613,
  },
  "54762": {
    DMA: 613,
  },
  "54763": {
    DMA: 613,
  },
  "54764": {
    DMA: 613,
  },
  "54765": {
    DMA: 613,
  },
  "54766": {
    DMA: 702,
  },
  "54767": {
    DMA: 613,
  },
  "54768": {
    DMA: 702,
  },
  "54769": {
    DMA: 702,
  },
  "54770": {
    DMA: 702,
  },
  "54771": {
    DMA: 702,
  },
  "54772": {
    DMA: 613,
  },
  "54773": {
    DMA: 702,
  },
  "54774": {
    DMA: 702,
  },
  "54801": {
    DMA: 613,
  },
  "54805": {
    DMA: 613,
  },
  "54806": {
    DMA: 676,
  },
  "54810": {
    DMA: 613,
  },
  "54812": {
    DMA: 613,
  },
  "54813": {
    DMA: 613,
  },
  "54814": {
    DMA: 676,
  },
  "54816": {
    DMA: 676,
  },
  "54817": {
    DMA: 613,
  },
  "54818": {
    DMA: 613,
  },
  "54819": {
    DMA: 702,
  },
  "54820": {
    DMA: 676,
  },
  "54821": {
    DMA: 676,
  },
  "54822": {
    DMA: 613,
  },
  "54824": {
    DMA: 613,
  },
  "54826": {
    DMA: 613,
  },
  "54827": {
    DMA: 676,
  },
  "54828": {
    DMA: 676,
  },
  "54829": {
    DMA: 613,
  },
  "54830": {
    DMA: 613,
  },
  "54832": {
    DMA: 676,
  },
  "54834": {
    DMA: 676,
  },
  "54835": {
    DMA: 676,
  },
  "54836": {
    DMA: 676,
  },
  "54837": {
    DMA: 613,
  },
  "54838": {
    DMA: 676,
  },
  "54839": {
    DMA: 676,
  },
  "54840": {
    DMA: 613,
  },
  "54841": {
    DMA: 613,
  },
  "54842": {
    DMA: 676,
  },
  "54843": {
    DMA: 676,
  },
  "54844": {
    DMA: 676,
  },
  "54845": {
    DMA: 613,
  },
  "54846": {
    DMA: 676,
  },
  "54847": {
    DMA: 676,
  },
  "54848": {
    DMA: 702,
  },
  "54849": {
    DMA: 676,
  },
  "54850": {
    DMA: 676,
  },
  "54853": {
    DMA: 613,
  },
  "54854": {
    DMA: 676,
  },
  "54855": {
    DMA: 676,
  },
  "54856": {
    DMA: 676,
  },
  "54857": {
    DMA: 613,
  },
  "54858": {
    DMA: 613,
  },
  "54859": {
    DMA: 613,
  },
  "54861": {
    DMA: 676,
  },
  "54862": {
    DMA: 676,
  },
  "54864": {
    DMA: 676,
  },
  "54865": {
    DMA: 676,
  },
  "54867": {
    DMA: 676,
  },
  "54868": {
    DMA: 613,
  },
  "54870": {
    DMA: 613,
  },
  "54871": {
    DMA: 613,
  },
  "54872": {
    DMA: 613,
  },
  "54873": {
    DMA: 676,
  },
  "54874": {
    DMA: 676,
  },
  "54875": {
    DMA: 613,
  },
  "54876": {
    DMA: 676,
  },
  "54880": {
    DMA: 676,
  },
  "54888": {
    DMA: 613,
  },
  "54889": {
    DMA: 613,
  },
  "54890": {
    DMA: 676,
  },
  "54891": {
    DMA: 676,
  },
  "54893": {
    DMA: 613,
  },
  "54895": {
    DMA: 702,
  },
  "54896": {
    DMA: 676,
  },
  "54901": {
    DMA: 658,
  },
  "54902": {
    DMA: 658,
  },
  "54903": {
    DMA: 658,
  },
  "54904": {
    DMA: 658,
  },
  "54906": {
    DMA: 658,
  },
  "54909": {
    DMA: 705,
  },
  "54911": {
    DMA: 658,
  },
  "54912": {
    DMA: 658,
  },
  "54913": {
    DMA: 658,
  },
  "54914": {
    DMA: 658,
  },
  "54915": {
    DMA: 658,
  },
  "54919": {
    DMA: 658,
  },
  "54921": {
    DMA: 705,
  },
  "54922": {
    DMA: 658,
  },
  "54923": {
    DMA: 658,
  },
  "54926": {
    DMA: 658,
  },
  "54927": {
    DMA: 658,
  },
  "54928": {
    DMA: 658,
  },
  "54929": {
    DMA: 658,
  },
  "54930": {
    DMA: 658,
  },
  "54931": {
    DMA: 658,
  },
  "54932": {
    DMA: 658,
  },
  "54933": {
    DMA: 658,
  },
  "54934": {
    DMA: 658,
  },
  "54935": {
    DMA: 658,
  },
  "54936": {
    DMA: 658,
  },
  "54937": {
    DMA: 658,
  },
  "54940": {
    DMA: 658,
  },
  "54941": {
    DMA: 658,
  },
  "54942": {
    DMA: 658,
  },
  "54943": {
    DMA: 658,
  },
  "54944": {
    DMA: 658,
  },
  "54945": {
    DMA: 658,
  },
  "54946": {
    DMA: 658,
  },
  "54947": {
    DMA: 658,
  },
  "54948": {
    DMA: 658,
  },
  "54949": {
    DMA: 658,
  },
  "54950": {
    DMA: 658,
  },
  "54952": {
    DMA: 658,
  },
  "54956": {
    DMA: 658,
  },
  "54957": {
    DMA: 658,
  },
  "54960": {
    DMA: 669,
  },
  "54961": {
    DMA: 658,
  },
  "54962": {
    DMA: 658,
  },
  "54963": {
    DMA: 658,
  },
  "54964": {
    DMA: 658,
  },
  "54965": {
    DMA: 658,
  },
  "54966": {
    DMA: 658,
  },
  "54967": {
    DMA: 658,
  },
  "54968": {
    DMA: 658,
  },
  "54969": {
    DMA: 658,
  },
  "54970": {
    DMA: 658,
  },
  "54971": {
    DMA: 658,
  },
  "54974": {
    DMA: 658,
  },
  "54976": {
    DMA: 658,
  },
  "54977": {
    DMA: 658,
  },
  "54978": {
    DMA: 658,
  },
  "54979": {
    DMA: 658,
  },
  "54980": {
    DMA: 658,
  },
  "54981": {
    DMA: 658,
  },
  "54982": {
    DMA: 658,
  },
  "54983": {
    DMA: 658,
  },
  "54984": {
    DMA: 658,
  },
  "54985": {
    DMA: 658,
  },
  "54986": {
    DMA: 658,
  },
  "54990": {
    DMA: 658,
  },
  "55001": {
    DMA: 613,
  },
  "55002": {
    DMA: 613,
  },
  "55003": {
    DMA: 613,
  },
  "55005": {
    DMA: 613,
  },
  "55006": {
    DMA: 613,
  },
  "55007": {
    DMA: 613,
  },
  "55008": {
    DMA: 613,
  },
  "55009": {
    DMA: 613,
  },
  "55010": {
    DMA: 613,
  },
  "55011": {
    DMA: 613,
  },
  "55012": {
    DMA: 613,
  },
  "55013": {
    DMA: 613,
  },
  "55014": {
    DMA: 613,
  },
  "55016": {
    DMA: 613,
  },
  "55017": {
    DMA: 613,
  },
  "55018": {
    DMA: 613,
  },
  "55019": {
    DMA: 613,
  },
  "55020": {
    DMA: 613,
  },
  "55021": {
    DMA: 613,
  },
  "55024": {
    DMA: 613,
  },
  "55025": {
    DMA: 613,
  },
  "55026": {
    DMA: 613,
  },
  "55027": {
    DMA: 613,
  },
  "55029": {
    DMA: 613,
  },
  "55030": {
    DMA: 613,
  },
  "55031": {
    DMA: 613,
  },
  "55032": {
    DMA: 613,
  },
  "55033": {
    DMA: 613,
  },
  "55036": {
    DMA: 613,
  },
  "55037": {
    DMA: 613,
  },
  "55038": {
    DMA: 613,
  },
  "55040": {
    DMA: 613,
  },
  "55041": {
    DMA: 613,
  },
  "55042": {
    DMA: 613,
  },
  "55043": {
    DMA: 613,
  },
  "55044": {
    DMA: 613,
  },
  "55045": {
    DMA: 613,
  },
  "55046": {
    DMA: 613,
  },
  "55047": {
    DMA: 613,
  },
  "55049": {
    DMA: 613,
  },
  "55051": {
    DMA: 613,
  },
  "55052": {
    DMA: 613,
  },
  "55053": {
    DMA: 613,
  },
  "55054": {
    DMA: 613,
  },
  "55055": {
    DMA: 613,
  },
  "55056": {
    DMA: 613,
  },
  "55057": {
    DMA: 613,
  },
  "55060": {
    DMA: 613,
  },
  "55063": {
    DMA: 613,
  },
  "55065": {
    DMA: 613,
  },
  "55066": {
    DMA: 613,
  },
  "55067": {
    DMA: 613,
  },
  "55068": {
    DMA: 613,
  },
  "55069": {
    DMA: 613,
  },
  "55070": {
    DMA: 613,
  },
  "55071": {
    DMA: 613,
  },
  "55072": {
    DMA: 613,
  },
  "55073": {
    DMA: 613,
  },
  "55074": {
    DMA: 613,
  },
  "55075": {
    DMA: 613,
  },
  "55076": {
    DMA: 613,
  },
  "55077": {
    DMA: 613,
  },
  "55078": {
    DMA: 613,
  },
  "55079": {
    DMA: 613,
  },
  "55080": {
    DMA: 613,
  },
  "55082": {
    DMA: 613,
  },
  "55083": {
    DMA: 613,
  },
  "55084": {
    DMA: 613,
  },
  "55085": {
    DMA: 613,
  },
  "55087": {
    DMA: 613,
  },
  "55088": {
    DMA: 613,
  },
  "55089": {
    DMA: 613,
  },
  "55090": {
    DMA: 613,
  },
  "55092": {
    DMA: 613,
  },
  "55101": {
    DMA: 613,
  },
  "55102": {
    DMA: 613,
  },
  "55103": {
    DMA: 613,
  },
  "55104": {
    DMA: 613,
  },
  "55105": {
    DMA: 613,
  },
  "55106": {
    DMA: 613,
  },
  "55107": {
    DMA: 613,
  },
  "55108": {
    DMA: 613,
  },
  "55109": {
    DMA: 613,
  },
  "55110": {
    DMA: 613,
  },
  "55111": {
    DMA: 613,
  },
  "55112": {
    DMA: 613,
  },
  "55113": {
    DMA: 613,
  },
  "55114": {
    DMA: 613,
  },
  "55115": {
    DMA: 613,
  },
  "55116": {
    DMA: 613,
  },
  "55117": {
    DMA: 613,
  },
  "55118": {
    DMA: 613,
  },
  "55119": {
    DMA: 613,
  },
  "55120": {
    DMA: 613,
  },
  "55121": {
    DMA: 613,
  },
  "55122": {
    DMA: 613,
  },
  "55123": {
    DMA: 613,
  },
  "55124": {
    DMA: 613,
  },
  "55125": {
    DMA: 613,
  },
  "55126": {
    DMA: 613,
  },
  "55127": {
    DMA: 613,
  },
  "55128": {
    DMA: 613,
  },
  "55129": {
    DMA: 613,
  },
  "55130": {
    DMA: 613,
  },
  "55131": {
    DMA: 613,
  },
  "55133": {
    DMA: 613,
  },
  "55144": {
    DMA: 613,
  },
  "55145": {
    DMA: 613,
  },
  "55146": {
    DMA: 613,
  },
  "55150": {
    DMA: 613,
  },
  "55155": {
    DMA: 613,
  },
  "55161": {
    DMA: 613,
  },
  "55164": {
    DMA: 613,
  },
  "55165": {
    DMA: 613,
  },
  "55166": {
    DMA: 613,
  },
  "55168": {
    DMA: 613,
  },
  "55169": {
    DMA: 613,
  },
  "55170": {
    DMA: 613,
  },
  "55171": {
    DMA: 613,
  },
  "55172": {
    DMA: 613,
  },
  "55175": {
    DMA: 613,
  },
  "55177": {
    DMA: 613,
  },
  "55187": {
    DMA: 613,
  },
  "55188": {
    DMA: 613,
  },
  "55191": {
    DMA: 613,
  },
  "55301": {
    DMA: 613,
  },
  "55302": {
    DMA: 613,
  },
  "55303": {
    DMA: 613,
  },
  "55304": {
    DMA: 613,
  },
  "55305": {
    DMA: 613,
  },
  "55306": {
    DMA: 613,
  },
  "55307": {
    DMA: 613,
  },
  "55308": {
    DMA: 613,
  },
  "55309": {
    DMA: 613,
  },
  "55310": {
    DMA: 613,
  },
  "55311": {
    DMA: 613,
  },
  "55312": {
    DMA: 613,
  },
  "55313": {
    DMA: 613,
  },
  "55314": {
    DMA: 613,
  },
  "55315": {
    DMA: 613,
  },
  "55316": {
    DMA: 613,
  },
  "55317": {
    DMA: 613,
  },
  "55318": {
    DMA: 613,
  },
  "55319": {
    DMA: 613,
  },
  "55320": {
    DMA: 613,
  },
  "55321": {
    DMA: 613,
  },
  "55322": {
    DMA: 613,
  },
  "55323": {
    DMA: 613,
  },
  "55324": {
    DMA: 613,
  },
  "55325": {
    DMA: 613,
  },
  "55327": {
    DMA: 613,
  },
  "55328": {
    DMA: 613,
  },
  "55329": {
    DMA: 613,
  },
  "55330": {
    DMA: 613,
  },
  "55331": {
    DMA: 613,
  },
  "55332": {
    DMA: 613,
  },
  "55333": {
    DMA: 613,
  },
  "55334": {
    DMA: 613,
  },
  "55335": {
    DMA: 613,
  },
  "55336": {
    DMA: 613,
  },
  "55337": {
    DMA: 613,
  },
  "55338": {
    DMA: 613,
  },
  "55339": {
    DMA: 613,
  },
  "55340": {
    DMA: 613,
  },
  "55341": {
    DMA: 613,
  },
  "55342": {
    DMA: 613,
  },
  "55343": {
    DMA: 613,
  },
  "55344": {
    DMA: 613,
  },
  "55345": {
    DMA: 613,
  },
  "55346": {
    DMA: 613,
  },
  "55347": {
    DMA: 613,
  },
  "55348": {
    DMA: 613,
  },
  "55349": {
    DMA: 613,
  },
  "55350": {
    DMA: 613,
  },
  "55352": {
    DMA: 613,
  },
  "55353": {
    DMA: 613,
  },
  "55354": {
    DMA: 613,
  },
  "55355": {
    DMA: 613,
  },
  "55356": {
    DMA: 613,
  },
  "55357": {
    DMA: 613,
  },
  "55358": {
    DMA: 613,
  },
  "55359": {
    DMA: 613,
  },
  "55360": {
    DMA: 613,
  },
  "55361": {
    DMA: 613,
  },
  "55362": {
    DMA: 613,
  },
  "55363": {
    DMA: 613,
  },
  "55364": {
    DMA: 613,
  },
  "55365": {
    DMA: 613,
  },
  "55366": {
    DMA: 613,
  },
  "55367": {
    DMA: 613,
  },
  "55368": {
    DMA: 613,
  },
  "55369": {
    DMA: 613,
  },
  "55370": {
    DMA: 613,
  },
  "55371": {
    DMA: 613,
  },
  "55372": {
    DMA: 613,
  },
  "55373": {
    DMA: 613,
  },
  "55374": {
    DMA: 613,
  },
  "55375": {
    DMA: 613,
  },
  "55376": {
    DMA: 613,
  },
  "55377": {
    DMA: 613,
  },
  "55378": {
    DMA: 613,
  },
  "55379": {
    DMA: 613,
  },
  "55380": {
    DMA: 613,
  },
  "55381": {
    DMA: 613,
  },
  "55382": {
    DMA: 613,
  },
  "55383": {
    DMA: 613,
  },
  "55384": {
    DMA: 613,
  },
  "55385": {
    DMA: 613,
  },
  "55386": {
    DMA: 613,
  },
  "55387": {
    DMA: 613,
  },
  "55388": {
    DMA: 613,
  },
  "55389": {
    DMA: 613,
  },
  "55390": {
    DMA: 613,
  },
  "55391": {
    DMA: 613,
  },
  "55392": {
    DMA: 613,
  },
  "55393": {
    DMA: 613,
  },
  "55394": {
    DMA: 613,
  },
  "55395": {
    DMA: 613,
  },
  "55396": {
    DMA: 613,
  },
  "55397": {
    DMA: 613,
  },
  "55398": {
    DMA: 613,
  },
  "55399": {
    DMA: 613,
  },
  "55401": {
    DMA: 613,
  },
  "55402": {
    DMA: 613,
  },
  "55403": {
    DMA: 613,
  },
  "55404": {
    DMA: 613,
  },
  "55405": {
    DMA: 613,
  },
  "55406": {
    DMA: 613,
  },
  "55407": {
    DMA: 613,
  },
  "55408": {
    DMA: 613,
  },
  "55409": {
    DMA: 613,
  },
  "55410": {
    DMA: 613,
  },
  "55411": {
    DMA: 613,
  },
  "55412": {
    DMA: 613,
  },
  "55413": {
    DMA: 613,
  },
  "55414": {
    DMA: 613,
  },
  "55415": {
    DMA: 613,
  },
  "55416": {
    DMA: 613,
  },
  "55417": {
    DMA: 613,
  },
  "55418": {
    DMA: 613,
  },
  "55419": {
    DMA: 613,
  },
  "55420": {
    DMA: 613,
  },
  "55421": {
    DMA: 613,
  },
  "55422": {
    DMA: 613,
  },
  "55423": {
    DMA: 613,
  },
  "55424": {
    DMA: 613,
  },
  "55425": {
    DMA: 613,
  },
  "55426": {
    DMA: 613,
  },
  "55427": {
    DMA: 613,
  },
  "55428": {
    DMA: 613,
  },
  "55429": {
    DMA: 613,
  },
  "55430": {
    DMA: 613,
  },
  "55431": {
    DMA: 613,
  },
  "55432": {
    DMA: 613,
  },
  "55433": {
    DMA: 613,
  },
  "55434": {
    DMA: 613,
  },
  "55435": {
    DMA: 613,
  },
  "55436": {
    DMA: 613,
  },
  "55437": {
    DMA: 613,
  },
  "55438": {
    DMA: 613,
  },
  "55439": {
    DMA: 613,
  },
  "55440": {
    DMA: 613,
  },
  "55441": {
    DMA: 613,
  },
  "55442": {
    DMA: 613,
  },
  "55443": {
    DMA: 613,
  },
  "55444": {
    DMA: 613,
  },
  "55445": {
    DMA: 613,
  },
  "55446": {
    DMA: 613,
  },
  "55447": {
    DMA: 613,
  },
  "55448": {
    DMA: 613,
  },
  "55449": {
    DMA: 613,
  },
  "55450": {
    DMA: 613,
  },
  "55454": {
    DMA: 613,
  },
  "55455": {
    DMA: 613,
  },
  "55458": {
    DMA: 613,
  },
  "55459": {
    DMA: 613,
  },
  "55460": {
    DMA: 613,
  },
  "55467": {
    DMA: 613,
  },
  "55468": {
    DMA: 613,
  },
  "55470": {
    DMA: 613,
  },
  "55472": {
    DMA: 613,
  },
  "55473": {
    DMA: 613,
  },
  "55474": {
    DMA: 613,
  },
  "55478": {
    DMA: 613,
  },
  "55479": {
    DMA: 613,
  },
  "55480": {
    DMA: 613,
  },
  "55483": {
    DMA: 613,
  },
  "55484": {
    DMA: 613,
  },
  "55485": {
    DMA: 613,
  },
  "55486": {
    DMA: 613,
  },
  "55487": {
    DMA: 613,
  },
  "55488": {
    DMA: 613,
  },
  "55550": {
    DMA: 613,
  },
  "55551": {
    DMA: 613,
  },
  "55552": {
    DMA: 613,
  },
  "55553": {
    DMA: 613,
  },
  "55554": {
    DMA: 613,
  },
  "55555": {
    DMA: 613,
  },
  "55556": {
    DMA: 613,
  },
  "55557": {
    DMA: 613,
  },
  "55558": {
    DMA: 613,
  },
  "55559": {
    DMA: 613,
  },
  "55560": {
    DMA: 613,
  },
  "55561": {
    DMA: 613,
  },
  "55562": {
    DMA: 613,
  },
  "55563": {
    DMA: 613,
  },
  "55564": {
    DMA: 613,
  },
  "55565": {
    DMA: 613,
  },
  "55566": {
    DMA: 613,
  },
  "55567": {
    DMA: 613,
  },
  "55568": {
    DMA: 613,
  },
  "55569": {
    DMA: 613,
  },
  "55570": {
    DMA: 613,
  },
  "55571": {
    DMA: 613,
  },
  "55572": {
    DMA: 613,
  },
  "55573": {
    DMA: 613,
  },
  "55574": {
    DMA: 613,
  },
  "55575": {
    DMA: 613,
  },
  "55576": {
    DMA: 613,
  },
  "55577": {
    DMA: 613,
  },
  "55578": {
    DMA: 613,
  },
  "55579": {
    DMA: 613,
  },
  "55580": {
    DMA: 613,
  },
  "55581": {
    DMA: 613,
  },
  "55582": {
    DMA: 613,
  },
  "55583": {
    DMA: 613,
  },
  "55584": {
    DMA: 613,
  },
  "55585": {
    DMA: 613,
  },
  "55586": {
    DMA: 613,
  },
  "55587": {
    DMA: 613,
  },
  "55588": {
    DMA: 613,
  },
  "55589": {
    DMA: 613,
  },
  "55590": {
    DMA: 613,
  },
  "55591": {
    DMA: 613,
  },
  "55592": {
    DMA: 613,
  },
  "55593": {
    DMA: 613,
  },
  "55594": {
    DMA: 613,
  },
  "55595": {
    DMA: 613,
  },
  "55596": {
    DMA: 613,
  },
  "55597": {
    DMA: 613,
  },
  "55598": {
    DMA: 613,
  },
  "55599": {
    DMA: 613,
  },
  "55601": {
    DMA: 676,
  },
  "55602": {
    DMA: 676,
  },
  "55603": {
    DMA: 676,
  },
  "55604": {
    DMA: 676,
  },
  "55605": {
    DMA: 676,
  },
  "55606": {
    DMA: 676,
  },
  "55607": {
    DMA: 676,
  },
  "55609": {
    DMA: 676,
  },
  "55612": {
    DMA: 676,
  },
  "55613": {
    DMA: 676,
  },
  "55614": {
    DMA: 676,
  },
  "55615": {
    DMA: 676,
  },
  "55616": {
    DMA: 676,
  },
  "55701": {
    DMA: 676,
  },
  "55702": {
    DMA: 676,
  },
  "55703": {
    DMA: 676,
  },
  "55704": {
    DMA: 613,
  },
  "55705": {
    DMA: 676,
  },
  "55706": {
    DMA: 676,
  },
  "55707": {
    DMA: 676,
  },
  "55708": {
    DMA: 676,
  },
  "55709": {
    DMA: 676,
  },
  "55710": {
    DMA: 676,
  },
  "55711": {
    DMA: 676,
  },
  "55712": {
    DMA: 613,
  },
  "55713": {
    DMA: 676,
  },
  "55716": {
    DMA: 676,
  },
  "55717": {
    DMA: 676,
  },
  "55718": {
    DMA: 676,
  },
  "55719": {
    DMA: 676,
  },
  "55720": {
    DMA: 676,
  },
  "55721": {
    DMA: 676,
  },
  "55722": {
    DMA: 676,
  },
  "55723": {
    DMA: 676,
  },
  "55724": {
    DMA: 676,
  },
  "55725": {
    DMA: 676,
  },
  "55726": {
    DMA: 676,
  },
  "55730": {
    DMA: 676,
  },
  "55731": {
    DMA: 676,
  },
  "55732": {
    DMA: 676,
  },
  "55733": {
    DMA: 676,
  },
  "55734": {
    DMA: 676,
  },
  "55735": {
    DMA: 613,
  },
  "55736": {
    DMA: 676,
  },
  "55738": {
    DMA: 676,
  },
  "55741": {
    DMA: 676,
  },
  "55742": {
    DMA: 676,
  },
  "55744": {
    DMA: 676,
  },
  "55745": {
    DMA: 676,
  },
  "55746": {
    DMA: 676,
  },
  "55747": {
    DMA: 676,
  },
  "55748": {
    DMA: 613,
  },
  "55749": {
    DMA: 676,
  },
  "55750": {
    DMA: 676,
  },
  "55751": {
    DMA: 676,
  },
  "55752": {
    DMA: 676,
  },
  "55753": {
    DMA: 676,
  },
  "55756": {
    DMA: 613,
  },
  "55757": {
    DMA: 676,
  },
  "55758": {
    DMA: 676,
  },
  "55760": {
    DMA: 613,
  },
  "55763": {
    DMA: 676,
  },
  "55764": {
    DMA: 676,
  },
  "55765": {
    DMA: 676,
  },
  "55766": {
    DMA: 676,
  },
  "55767": {
    DMA: 676,
  },
  "55768": {
    DMA: 676,
  },
  "55769": {
    DMA: 676,
  },
  "55771": {
    DMA: 676,
  },
  "55772": {
    DMA: 676,
  },
  "55775": {
    DMA: 676,
  },
  "55777": {
    DMA: 676,
  },
  "55779": {
    DMA: 676,
  },
  "55780": {
    DMA: 676,
  },
  "55781": {
    DMA: 676,
  },
  "55782": {
    DMA: 676,
  },
  "55783": {
    DMA: 613,
  },
  "55784": {
    DMA: 676,
  },
  "55785": {
    DMA: 613,
  },
  "55786": {
    DMA: 676,
  },
  "55787": {
    DMA: 613,
  },
  "55790": {
    DMA: 676,
  },
  "55791": {
    DMA: 676,
  },
  "55792": {
    DMA: 676,
  },
  "55793": {
    DMA: 676,
  },
  "55795": {
    DMA: 613,
  },
  "55796": {
    DMA: 676,
  },
  "55797": {
    DMA: 676,
  },
  "55798": {
    DMA: 676,
  },
  "55801": {
    DMA: 676,
  },
  "55802": {
    DMA: 676,
  },
  "55803": {
    DMA: 676,
  },
  "55804": {
    DMA: 676,
  },
  "55805": {
    DMA: 676,
  },
  "55806": {
    DMA: 676,
  },
  "55807": {
    DMA: 676,
  },
  "55808": {
    DMA: 676,
  },
  "55810": {
    DMA: 676,
  },
  "55811": {
    DMA: 676,
  },
  "55812": {
    DMA: 676,
  },
  "55814": {
    DMA: 676,
  },
  "55815": {
    DMA: 676,
  },
  "55816": {
    DMA: 676,
  },
  "55901": {
    DMA: 611,
  },
  "55902": {
    DMA: 611,
  },
  "55903": {
    DMA: 611,
  },
  "55904": {
    DMA: 611,
  },
  "55905": {
    DMA: 611,
  },
  "55906": {
    DMA: 611,
  },
  "55909": {
    DMA: 611,
  },
  "55910": {
    DMA: 702,
  },
  "55912": {
    DMA: 611,
  },
  "55917": {
    DMA: 613,
  },
  "55918": {
    DMA: 611,
  },
  "55919": {
    DMA: 702,
  },
  "55920": {
    DMA: 611,
  },
  "55921": {
    DMA: 702,
  },
  "55922": {
    DMA: 611,
  },
  "55923": {
    DMA: 611,
  },
  "55924": {
    DMA: 611,
  },
  "55925": {
    DMA: 702,
  },
  "55926": {
    DMA: 611,
  },
  "55927": {
    DMA: 611,
  },
  "55929": {
    DMA: 611,
  },
  "55931": {
    DMA: 702,
  },
  "55932": {
    DMA: 613,
  },
  "55933": {
    DMA: 611,
  },
  "55934": {
    DMA: 611,
  },
  "55935": {
    DMA: 611,
  },
  "55936": {
    DMA: 611,
  },
  "55939": {
    DMA: 611,
  },
  "55940": {
    DMA: 611,
  },
  "55941": {
    DMA: 702,
  },
  "55942": {
    DMA: 702,
  },
  "55943": {
    DMA: 702,
  },
  "55944": {
    DMA: 611,
  },
  "55945": {
    DMA: 613,
  },
  "55946": {
    DMA: 613,
  },
  "55947": {
    DMA: 702,
  },
  "55949": {
    DMA: 611,
  },
  "55950": {
    DMA: 611,
  },
  "55951": {
    DMA: 611,
  },
  "55952": {
    DMA: 702,
  },
  "55953": {
    DMA: 611,
  },
  "55954": {
    DMA: 611,
  },
  "55955": {
    DMA: 611,
  },
  "55956": {
    DMA: 613,
  },
  "55957": {
    DMA: 613,
  },
  "55959": {
    DMA: 702,
  },
  "55960": {
    DMA: 611,
  },
  "55961": {
    DMA: 611,
  },
  "55962": {
    DMA: 611,
  },
  "55963": {
    DMA: 613,
  },
  "55964": {
    DMA: 613,
  },
  "55965": {
    DMA: 611,
  },
  "55967": {
    DMA: 611,
  },
  "55968": {
    DMA: 613,
  },
  "55969": {
    DMA: 702,
  },
  "55970": {
    DMA: 611,
  },
  "55971": {
    DMA: 611,
  },
  "55972": {
    DMA: 702,
  },
  "55973": {
    DMA: 611,
  },
  "55974": {
    DMA: 702,
  },
  "55975": {
    DMA: 611,
  },
  "55976": {
    DMA: 611,
  },
  "55977": {
    DMA: 611,
  },
  "55979": {
    DMA: 702,
  },
  "55981": {
    DMA: 613,
  },
  "55982": {
    DMA: 611,
  },
  "55983": {
    DMA: 613,
  },
  "55985": {
    DMA: 611,
  },
  "55987": {
    DMA: 702,
  },
  "55988": {
    DMA: 702,
  },
  "55990": {
    DMA: 611,
  },
  "55991": {
    DMA: 613,
  },
  "55992": {
    DMA: 613,
  },
  "56001": {
    DMA: 737,
  },
  "56002": {
    DMA: 737,
  },
  "56003": {
    DMA: 613,
  },
  "56006": {
    DMA: 737,
  },
  "56007": {
    DMA: 611,
  },
  "56009": {
    DMA: 611,
  },
  "56010": {
    DMA: 737,
  },
  "56011": {
    DMA: 613,
  },
  "56013": {
    DMA: 613,
  },
  "56014": {
    DMA: 613,
  },
  "56016": {
    DMA: 611,
  },
  "56017": {
    DMA: 613,
  },
  "56019": {
    DMA: 737,
  },
  "56020": {
    DMA: 611,
  },
  "56021": {
    DMA: 613,
  },
  "56022": {
    DMA: 737,
  },
  "56023": {
    DMA: 613,
  },
  "56024": {
    DMA: 737,
  },
  "56025": {
    DMA: 613,
  },
  "56026": {
    DMA: 613,
  },
  "56027": {
    DMA: 613,
  },
  "56028": {
    DMA: 613,
  },
  "56029": {
    DMA: 611,
  },
  "56030": {
    DMA: 737,
  },
  "56031": {
    DMA: 737,
  },
  "56032": {
    DMA: 611,
  },
  "56033": {
    DMA: 613,
  },
  "56034": {
    DMA: 737,
  },
  "56035": {
    DMA: 611,
  },
  "56036": {
    DMA: 611,
  },
  "56037": {
    DMA: 737,
  },
  "56039": {
    DMA: 737,
  },
  "56041": {
    DMA: 737,
  },
  "56042": {
    DMA: 611,
  },
  "56043": {
    DMA: 611,
  },
  "56044": {
    DMA: 613,
  },
  "56045": {
    DMA: 611,
  },
  "56046": {
    DMA: 613,
  },
  "56047": {
    DMA: 613,
  },
  "56048": {
    DMA: 613,
  },
  "56050": {
    DMA: 613,
  },
  "56051": {
    DMA: 613,
  },
  "56052": {
    DMA: 613,
  },
  "56054": {
    DMA: 613,
  },
  "56055": {
    DMA: 737,
  },
  "56056": {
    DMA: 737,
  },
  "56057": {
    DMA: 613,
  },
  "56058": {
    DMA: 613,
  },
  "56060": {
    DMA: 737,
  },
  "56062": {
    DMA: 737,
  },
  "56063": {
    DMA: 737,
  },
  "56065": {
    DMA: 737,
  },
  "56068": {
    DMA: 613,
  },
  "56069": {
    DMA: 613,
  },
  "56071": {
    DMA: 613,
  },
  "56072": {
    DMA: 613,
  },
  "56073": {
    DMA: 737,
  },
  "56074": {
    DMA: 613,
  },
  "56075": {
    DMA: 737,
  },
  "56078": {
    DMA: 737,
  },
  "56080": {
    DMA: 737,
  },
  "56081": {
    DMA: 737,
  },
  "56082": {
    DMA: 613,
  },
  "56083": {
    DMA: 613,
  },
  "56084": {
    DMA: 737,
  },
  "56085": {
    DMA: 737,
  },
  "56087": {
    DMA: 737,
  },
  "56088": {
    DMA: 737,
  },
  "56089": {
    DMA: 611,
  },
  "56090": {
    DMA: 737,
  },
  "56091": {
    DMA: 613,
  },
  "56093": {
    DMA: 613,
  },
  "56096": {
    DMA: 613,
  },
  "56097": {
    DMA: 613,
  },
  "56098": {
    DMA: 613,
  },
  "56101": {
    DMA: 613,
  },
  "56110": {
    DMA: 725,
  },
  "56111": {
    DMA: 613,
  },
  "56113": {
    DMA: 725,
  },
  "56114": {
    DMA: 725,
  },
  "56115": {
    DMA: 613,
  },
  "56116": {
    DMA: 725,
  },
  "56117": {
    DMA: 725,
  },
  "56118": {
    DMA: 613,
  },
  "56119": {
    DMA: 725,
  },
  "56120": {
    DMA: 737,
  },
  "56121": {
    DMA: 737,
  },
  "56122": {
    DMA: 725,
  },
  "56123": {
    DMA: 725,
  },
  "56125": {
    DMA: 725,
  },
  "56127": {
    DMA: 737,
  },
  "56128": {
    DMA: 725,
  },
  "56129": {
    DMA: 725,
  },
  "56131": {
    DMA: 725,
  },
  "56132": {
    DMA: 613,
  },
  "56134": {
    DMA: 725,
  },
  "56136": {
    DMA: 725,
  },
  "56137": {
    DMA: 613,
  },
  "56138": {
    DMA: 725,
  },
  "56139": {
    DMA: 725,
  },
  "56140": {
    DMA: 725,
  },
  "56141": {
    DMA: 725,
  },
  "56142": {
    DMA: 725,
  },
  "56143": {
    DMA: 613,
  },
  "56144": {
    DMA: 725,
  },
  "56145": {
    DMA: 613,
  },
  "56146": {
    DMA: 725,
  },
  "56147": {
    DMA: 725,
  },
  "56149": {
    DMA: 725,
  },
  "56150": {
    DMA: 613,
  },
  "56151": {
    DMA: 725,
  },
  "56152": {
    DMA: 613,
  },
  "56153": {
    DMA: 725,
  },
  "56155": {
    DMA: 725,
  },
  "56156": {
    DMA: 725,
  },
  "56157": {
    DMA: 613,
  },
  "56158": {
    DMA: 725,
  },
  "56159": {
    DMA: 613,
  },
  "56160": {
    DMA: 737,
  },
  "56161": {
    DMA: 613,
  },
  "56162": {
    DMA: 737,
  },
  "56164": {
    DMA: 725,
  },
  "56165": {
    DMA: 725,
  },
  "56166": {
    DMA: 613,
  },
  "56167": {
    DMA: 725,
  },
  "56168": {
    DMA: 725,
  },
  "56169": {
    DMA: 613,
  },
  "56170": {
    DMA: 725,
  },
  "56171": {
    DMA: 737,
  },
  "56172": {
    DMA: 725,
  },
  "56173": {
    DMA: 725,
  },
  "56174": {
    DMA: 613,
  },
  "56175": {
    DMA: 613,
  },
  "56176": {
    DMA: 737,
  },
  "56177": {
    DMA: 725,
  },
  "56178": {
    DMA: 725,
  },
  "56180": {
    DMA: 613,
  },
  "56181": {
    DMA: 737,
  },
  "56183": {
    DMA: 613,
  },
  "56185": {
    DMA: 725,
  },
  "56186": {
    DMA: 725,
  },
  "56187": {
    DMA: 725,
  },
  "56201": {
    DMA: 613,
  },
  "56207": {
    DMA: 613,
  },
  "56208": {
    DMA: 613,
  },
  "56209": {
    DMA: 613,
  },
  "56210": {
    DMA: 613,
  },
  "56211": {
    DMA: 613,
  },
  "56212": {
    DMA: 613,
  },
  "56214": {
    DMA: 613,
  },
  "56215": {
    DMA: 613,
  },
  "56216": {
    DMA: 613,
  },
  "56218": {
    DMA: 613,
  },
  "56219": {
    DMA: 613,
  },
  "56220": {
    DMA: 613,
  },
  "56221": {
    DMA: 613,
  },
  "56222": {
    DMA: 613,
  },
  "56223": {
    DMA: 613,
  },
  "56224": {
    DMA: 613,
  },
  "56225": {
    DMA: 613,
  },
  "56226": {
    DMA: 613,
  },
  "56227": {
    DMA: 613,
  },
  "56228": {
    DMA: 613,
  },
  "56229": {
    DMA: 613,
  },
  "56230": {
    DMA: 613,
  },
  "56231": {
    DMA: 613,
  },
  "56232": {
    DMA: 613,
  },
  "56235": {
    DMA: 613,
  },
  "56236": {
    DMA: 613,
  },
  "56237": {
    DMA: 613,
  },
  "56239": {
    DMA: 613,
  },
  "56240": {
    DMA: 613,
  },
  "56241": {
    DMA: 613,
  },
  "56243": {
    DMA: 613,
  },
  "56244": {
    DMA: 613,
  },
  "56245": {
    DMA: 613,
  },
  "56248": {
    DMA: 613,
  },
  "56249": {
    DMA: 613,
  },
  "56251": {
    DMA: 613,
  },
  "56252": {
    DMA: 613,
  },
  "56253": {
    DMA: 613,
  },
  "56255": {
    DMA: 613,
  },
  "56256": {
    DMA: 613,
  },
  "56257": {
    DMA: 613,
  },
  "56258": {
    DMA: 613,
  },
  "56260": {
    DMA: 613,
  },
  "56262": {
    DMA: 613,
  },
  "56263": {
    DMA: 613,
  },
  "56264": {
    DMA: 613,
  },
  "56265": {
    DMA: 613,
  },
  "56266": {
    DMA: 613,
  },
  "56267": {
    DMA: 613,
  },
  "56270": {
    DMA: 613,
  },
  "56271": {
    DMA: 613,
  },
  "56273": {
    DMA: 613,
  },
  "56274": {
    DMA: 613,
  },
  "56276": {
    DMA: 613,
  },
  "56277": {
    DMA: 613,
  },
  "56278": {
    DMA: 613,
  },
  "56279": {
    DMA: 613,
  },
  "56280": {
    DMA: 613,
  },
  "56281": {
    DMA: 613,
  },
  "56282": {
    DMA: 613,
  },
  "56283": {
    DMA: 613,
  },
  "56284": {
    DMA: 613,
  },
  "56285": {
    DMA: 613,
  },
  "56287": {
    DMA: 613,
  },
  "56288": {
    DMA: 613,
  },
  "56289": {
    DMA: 613,
  },
  "56291": {
    DMA: 613,
  },
  "56292": {
    DMA: 613,
  },
  "56293": {
    DMA: 613,
  },
  "56294": {
    DMA: 613,
  },
  "56295": {
    DMA: 613,
  },
  "56296": {
    DMA: 613,
  },
  "56297": {
    DMA: 613,
  },
  "56301": {
    DMA: 613,
  },
  "56302": {
    DMA: 613,
  },
  "56303": {
    DMA: 613,
  },
  "56304": {
    DMA: 613,
  },
  "56307": {
    DMA: 613,
  },
  "56308": {
    DMA: 613,
  },
  "56309": {
    DMA: 613,
  },
  "56310": {
    DMA: 613,
  },
  "56311": {
    DMA: 613,
  },
  "56312": {
    DMA: 613,
  },
  "56313": {
    DMA: 613,
  },
  "56314": {
    DMA: 613,
  },
  "56315": {
    DMA: 613,
  },
  "56316": {
    DMA: 613,
  },
  "56317": {
    DMA: 613,
  },
  "56318": {
    DMA: 613,
  },
  "56319": {
    DMA: 613,
  },
  "56320": {
    DMA: 613,
  },
  "56321": {
    DMA: 613,
  },
  "56323": {
    DMA: 613,
  },
  "56324": {
    DMA: 724,
  },
  "56325": {
    DMA: 613,
  },
  "56326": {
    DMA: 613,
  },
  "56327": {
    DMA: 613,
  },
  "56328": {
    DMA: 613,
  },
  "56329": {
    DMA: 613,
  },
  "56330": {
    DMA: 613,
  },
  "56331": {
    DMA: 613,
  },
  "56332": {
    DMA: 613,
  },
  "56333": {
    DMA: 613,
  },
  "56334": {
    DMA: 613,
  },
  "56335": {
    DMA: 613,
  },
  "56336": {
    DMA: 613,
  },
  "56338": {
    DMA: 613,
  },
  "56339": {
    DMA: 613,
  },
  "56340": {
    DMA: 613,
  },
  "56341": {
    DMA: 613,
  },
  "56342": {
    DMA: 613,
  },
  "56343": {
    DMA: 613,
  },
  "56344": {
    DMA: 613,
  },
  "56345": {
    DMA: 613,
  },
  "56347": {
    DMA: 613,
  },
  "56349": {
    DMA: 613,
  },
  "56350": {
    DMA: 613,
  },
  "56352": {
    DMA: 613,
  },
  "56353": {
    DMA: 613,
  },
  "56354": {
    DMA: 613,
  },
  "56355": {
    DMA: 613,
  },
  "56356": {
    DMA: 613,
  },
  "56357": {
    DMA: 613,
  },
  "56358": {
    DMA: 613,
  },
  "56359": {
    DMA: 613,
  },
  "56360": {
    DMA: 613,
  },
  "56361": {
    DMA: 724,
  },
  "56362": {
    DMA: 613,
  },
  "56363": {
    DMA: 613,
  },
  "56364": {
    DMA: 613,
  },
  "56367": {
    DMA: 613,
  },
  "56368": {
    DMA: 613,
  },
  "56369": {
    DMA: 613,
  },
  "56371": {
    DMA: 613,
  },
  "56372": {
    DMA: 613,
  },
  "56373": {
    DMA: 613,
  },
  "56374": {
    DMA: 613,
  },
  "56375": {
    DMA: 613,
  },
  "56376": {
    DMA: 613,
  },
  "56377": {
    DMA: 613,
  },
  "56378": {
    DMA: 613,
  },
  "56379": {
    DMA: 613,
  },
  "56381": {
    DMA: 613,
  },
  "56382": {
    DMA: 613,
  },
  "56384": {
    DMA: 613,
  },
  "56385": {
    DMA: 613,
  },
  "56386": {
    DMA: 613,
  },
  "56387": {
    DMA: 613,
  },
  "56388": {
    DMA: 613,
  },
  "56389": {
    DMA: 613,
  },
  "56393": {
    DMA: 613,
  },
  "56395": {
    DMA: 613,
  },
  "56396": {
    DMA: 613,
  },
  "56397": {
    DMA: 613,
  },
  "56398": {
    DMA: 613,
  },
  "56399": {
    DMA: 613,
  },
  "56401": {
    DMA: 613,
  },
  "56425": {
    DMA: 613,
  },
  "56430": {
    DMA: 613,
  },
  "56431": {
    DMA: 613,
  },
  "56433": {
    DMA: 613,
  },
  "56434": {
    DMA: 613,
  },
  "56435": {
    DMA: 613,
  },
  "56436": {
    DMA: 613,
  },
  "56437": {
    DMA: 613,
  },
  "56438": {
    DMA: 613,
  },
  "56440": {
    DMA: 613,
  },
  "56441": {
    DMA: 613,
  },
  "56442": {
    DMA: 613,
  },
  "56443": {
    DMA: 613,
  },
  "56444": {
    DMA: 613,
  },
  "56446": {
    DMA: 613,
  },
  "56447": {
    DMA: 613,
  },
  "56448": {
    DMA: 613,
  },
  "56449": {
    DMA: 613,
  },
  "56450": {
    DMA: 613,
  },
  "56452": {
    DMA: 613,
  },
  "56453": {
    DMA: 613,
  },
  "56455": {
    DMA: 613,
  },
  "56456": {
    DMA: 613,
  },
  "56458": {
    DMA: 613,
  },
  "56459": {
    DMA: 613,
  },
  "56461": {
    DMA: 613,
  },
  "56464": {
    DMA: 613,
  },
  "56465": {
    DMA: 613,
  },
  "56466": {
    DMA: 613,
  },
  "56467": {
    DMA: 613,
  },
  "56468": {
    DMA: 613,
  },
  "56469": {
    DMA: 613,
  },
  "56470": {
    DMA: 613,
  },
  "56472": {
    DMA: 613,
  },
  "56473": {
    DMA: 613,
  },
  "56474": {
    DMA: 613,
  },
  "56475": {
    DMA: 613,
  },
  "56477": {
    DMA: 613,
  },
  "56478": {
    DMA: 613,
  },
  "56479": {
    DMA: 613,
  },
  "56481": {
    DMA: 613,
  },
  "56482": {
    DMA: 613,
  },
  "56484": {
    DMA: 613,
  },
  "56501": {
    DMA: 724,
  },
  "56502": {
    DMA: 724,
  },
  "56510": {
    DMA: 724,
  },
  "56511": {
    DMA: 724,
  },
  "56514": {
    DMA: 724,
  },
  "56515": {
    DMA: 724,
  },
  "56516": {
    DMA: 724,
  },
  "56517": {
    DMA: 724,
  },
  "56518": {
    DMA: 724,
  },
  "56519": {
    DMA: 724,
  },
  "56520": {
    DMA: 724,
  },
  "56521": {
    DMA: 724,
  },
  "56522": {
    DMA: 724,
  },
  "56523": {
    DMA: 724,
  },
  "56524": {
    DMA: 724,
  },
  "56525": {
    DMA: 724,
  },
  "56527": {
    DMA: 724,
  },
  "56528": {
    DMA: 724,
  },
  "56529": {
    DMA: 724,
  },
  "56531": {
    DMA: 613,
  },
  "56533": {
    DMA: 724,
  },
  "56534": {
    DMA: 724,
  },
  "56535": {
    DMA: 724,
  },
  "56536": {
    DMA: 724,
  },
  "56537": {
    DMA: 724,
  },
  "56538": {
    DMA: 724,
  },
  "56540": {
    DMA: 724,
  },
  "56541": {
    DMA: 724,
  },
  "56542": {
    DMA: 724,
  },
  "56543": {
    DMA: 724,
  },
  "56544": {
    DMA: 724,
  },
  "56545": {
    DMA: 724,
  },
  "56546": {
    DMA: 724,
  },
  "56547": {
    DMA: 724,
  },
  "56548": {
    DMA: 724,
  },
  "56549": {
    DMA: 724,
  },
  "56550": {
    DMA: 724,
  },
  "56551": {
    DMA: 724,
  },
  "56552": {
    DMA: 724,
  },
  "56553": {
    DMA: 724,
  },
  "56554": {
    DMA: 724,
  },
  "56556": {
    DMA: 724,
  },
  "56557": {
    DMA: 724,
  },
  "56560": {
    DMA: 724,
  },
  "56561": {
    DMA: 724,
  },
  "56562": {
    DMA: 724,
  },
  "56563": {
    DMA: 724,
  },
  "56565": {
    DMA: 724,
  },
  "56566": {
    DMA: 724,
  },
  "56567": {
    DMA: 724,
  },
  "56568": {
    DMA: 724,
  },
  "56569": {
    DMA: 724,
  },
  "56570": {
    DMA: 724,
  },
  "56571": {
    DMA: 724,
  },
  "56572": {
    DMA: 724,
  },
  "56573": {
    DMA: 724,
  },
  "56574": {
    DMA: 724,
  },
  "56575": {
    DMA: 724,
  },
  "56576": {
    DMA: 724,
  },
  "56577": {
    DMA: 724,
  },
  "56578": {
    DMA: 724,
  },
  "56579": {
    DMA: 724,
  },
  "56580": {
    DMA: 724,
  },
  "56581": {
    DMA: 724,
  },
  "56583": {
    DMA: 613,
  },
  "56584": {
    DMA: 724,
  },
  "56585": {
    DMA: 724,
  },
  "56586": {
    DMA: 724,
  },
  "56587": {
    DMA: 724,
  },
  "56588": {
    DMA: 724,
  },
  "56589": {
    DMA: 724,
  },
  "56590": {
    DMA: 613,
  },
  "56591": {
    DMA: 724,
  },
  "56592": {
    DMA: 724,
  },
  "56593": {
    DMA: 724,
  },
  "56594": {
    DMA: 724,
  },
  "56601": {
    DMA: 613,
  },
  "56619": {
    DMA: 613,
  },
  "56621": {
    DMA: 724,
  },
  "56623": {
    DMA: 724,
  },
  "56626": {
    DMA: 613,
  },
  "56627": {
    DMA: 676,
  },
  "56628": {
    DMA: 676,
  },
  "56629": {
    DMA: 676,
  },
  "56630": {
    DMA: 613,
  },
  "56631": {
    DMA: 676,
  },
  "56633": {
    DMA: 613,
  },
  "56634": {
    DMA: 724,
  },
  "56636": {
    DMA: 676,
  },
  "56637": {
    DMA: 676,
  },
  "56639": {
    DMA: 676,
  },
  "56641": {
    DMA: 613,
  },
  "56644": {
    DMA: 724,
  },
  "56646": {
    DMA: 724,
  },
  "56647": {
    DMA: 613,
  },
  "56649": {
    DMA: 676,
  },
  "56650": {
    DMA: 613,
  },
  "56651": {
    DMA: 724,
  },
  "56652": {
    DMA: 724,
  },
  "56653": {
    DMA: 676,
  },
  "56654": {
    DMA: 676,
  },
  "56655": {
    DMA: 613,
  },
  "56657": {
    DMA: 676,
  },
  "56658": {
    DMA: 676,
  },
  "56659": {
    DMA: 676,
  },
  "56660": {
    DMA: 676,
  },
  "56661": {
    DMA: 676,
  },
  "56662": {
    DMA: 613,
  },
  "56663": {
    DMA: 613,
  },
  "56666": {
    DMA: 613,
  },
  "56667": {
    DMA: 613,
  },
  "56668": {
    DMA: 676,
  },
  "56669": {
    DMA: 676,
  },
  "56670": {
    DMA: 613,
  },
  "56671": {
    DMA: 613,
  },
  "56672": {
    DMA: 613,
  },
  "56673": {
    DMA: 724,
  },
  "56676": {
    DMA: 724,
  },
  "56678": {
    DMA: 613,
  },
  "56679": {
    DMA: 676,
  },
  "56680": {
    DMA: 676,
  },
  "56681": {
    DMA: 676,
  },
  "56682": {
    DMA: 724,
  },
  "56683": {
    DMA: 613,
  },
  "56684": {
    DMA: 724,
  },
  "56685": {
    DMA: 613,
  },
  "56686": {
    DMA: 724,
  },
  "56687": {
    DMA: 613,
  },
  "56688": {
    DMA: 676,
  },
  "56701": {
    DMA: 724,
  },
  "56710": {
    DMA: 724,
  },
  "56711": {
    DMA: 724,
  },
  "56713": {
    DMA: 724,
  },
  "56714": {
    DMA: 724,
  },
  "56715": {
    DMA: 724,
  },
  "56716": {
    DMA: 724,
  },
  "56720": {
    DMA: 724,
  },
  "56721": {
    DMA: 724,
  },
  "56722": {
    DMA: 724,
  },
  "56723": {
    DMA: 724,
  },
  "56724": {
    DMA: 724,
  },
  "56725": {
    DMA: 724,
  },
  "56726": {
    DMA: 724,
  },
  "56727": {
    DMA: 724,
  },
  "56728": {
    DMA: 724,
  },
  "56729": {
    DMA: 724,
  },
  "56731": {
    DMA: 724,
  },
  "56732": {
    DMA: 724,
  },
  "56733": {
    DMA: 724,
  },
  "56734": {
    DMA: 724,
  },
  "56735": {
    DMA: 724,
  },
  "56736": {
    DMA: 724,
  },
  "56737": {
    DMA: 724,
  },
  "56738": {
    DMA: 724,
  },
  "56740": {
    DMA: 724,
  },
  "56741": {
    DMA: 724,
  },
  "56742": {
    DMA: 724,
  },
  "56744": {
    DMA: 724,
  },
  "56748": {
    DMA: 724,
  },
  "56750": {
    DMA: 724,
  },
  "56751": {
    DMA: 724,
  },
  "56754": {
    DMA: 724,
  },
  "56755": {
    DMA: 724,
  },
  "56756": {
    DMA: 724,
  },
  "56757": {
    DMA: 724,
  },
  "56758": {
    DMA: 724,
  },
  "56759": {
    DMA: 724,
  },
  "56760": {
    DMA: 724,
  },
  "56761": {
    DMA: 724,
  },
  "56762": {
    DMA: 724,
  },
  "56763": {
    DMA: 724,
  },
  "56901": {
    DMA: 511,
  },
  "56902": {
    DMA: 511,
  },
  "56904": {
    DMA: 511,
  },
  "56908": {
    DMA: 511,
  },
  "56915": {
    DMA: 511,
  },
  "56920": {
    DMA: 511,
  },
  "56933": {
    DMA: 511,
  },
  "56935": {
    DMA: 511,
  },
  "56944": {
    DMA: 511,
  },
  "56945": {
    DMA: 511,
  },
  "56950": {
    DMA: 511,
  },
  "56964": {
    DMA: 511,
  },
  "56965": {
    DMA: 511,
  },
  "56966": {
    DMA: 511,
  },
  "56967": {
    DMA: 511,
  },
  "56968": {
    DMA: 511,
  },
  "56969": {
    DMA: 511,
  },
  "56970": {
    DMA: 511,
  },
  "56971": {
    DMA: 511,
  },
  "56972": {
    DMA: 511,
  },
  "56973": {
    DMA: 511,
  },
  "56980": {
    DMA: 511,
  },
  "56981": {
    DMA: 511,
  },
  "56982": {
    DMA: 511,
  },
  "56983": {
    DMA: 511,
  },
  "56984": {
    DMA: 511,
  },
  "56985": {
    DMA: 511,
  },
  "56998": {
    DMA: 511,
  },
  "56999": {
    DMA: 511,
  },
  "57001": {
    DMA: 624,
  },
  "57002": {
    DMA: 725,
  },
  "57003": {
    DMA: 725,
  },
  "57004": {
    DMA: 624,
  },
  "57005": {
    DMA: 725,
  },
  "57006": {
    DMA: 725,
  },
  "57007": {
    DMA: 725,
  },
  "57010": {
    DMA: 725,
  },
  "57012": {
    DMA: 725,
  },
  "57013": {
    DMA: 725,
  },
  "57014": {
    DMA: 725,
  },
  "57015": {
    DMA: 725,
  },
  "57016": {
    DMA: 725,
  },
  "57017": {
    DMA: 725,
  },
  "57018": {
    DMA: 725,
  },
  "57020": {
    DMA: 725,
  },
  "57021": {
    DMA: 725,
  },
  "57022": {
    DMA: 725,
  },
  "57024": {
    DMA: 725,
  },
  "57025": {
    DMA: 624,
  },
  "57026": {
    DMA: 725,
  },
  "57027": {
    DMA: 725,
  },
  "57028": {
    DMA: 725,
  },
  "57029": {
    DMA: 725,
  },
  "57030": {
    DMA: 725,
  },
  "57031": {
    DMA: 725,
  },
  "57032": {
    DMA: 725,
  },
  "57033": {
    DMA: 725,
  },
  "57034": {
    DMA: 725,
  },
  "57035": {
    DMA: 725,
  },
  "57036": {
    DMA: 725,
  },
  "57037": {
    DMA: 725,
  },
  "57038": {
    DMA: 624,
  },
  "57039": {
    DMA: 725,
  },
  "57040": {
    DMA: 725,
  },
  "57041": {
    DMA: 725,
  },
  "57042": {
    DMA: 725,
  },
  "57043": {
    DMA: 725,
  },
  "57045": {
    DMA: 725,
  },
  "57046": {
    DMA: 725,
  },
  "57047": {
    DMA: 725,
  },
  "57048": {
    DMA: 725,
  },
  "57049": {
    DMA: 624,
  },
  "57050": {
    DMA: 725,
  },
  "57051": {
    DMA: 725,
  },
  "57052": {
    DMA: 725,
  },
  "57053": {
    DMA: 725,
  },
  "57054": {
    DMA: 725,
  },
  "57055": {
    DMA: 725,
  },
  "57056": {
    DMA: 725,
  },
  "57057": {
    DMA: 725,
  },
  "57058": {
    DMA: 725,
  },
  "57059": {
    DMA: 725,
  },
  "57061": {
    DMA: 725,
  },
  "57062": {
    DMA: 725,
  },
  "57063": {
    DMA: 725,
  },
  "57064": {
    DMA: 725,
  },
  "57065": {
    DMA: 725,
  },
  "57066": {
    DMA: 725,
  },
  "57067": {
    DMA: 725,
  },
  "57068": {
    DMA: 725,
  },
  "57069": {
    DMA: 725,
  },
  "57070": {
    DMA: 725,
  },
  "57071": {
    DMA: 725,
  },
  "57072": {
    DMA: 725,
  },
  "57073": {
    DMA: 725,
  },
  "57075": {
    DMA: 725,
  },
  "57076": {
    DMA: 725,
  },
  "57077": {
    DMA: 725,
  },
  "57078": {
    DMA: 725,
  },
  "57079": {
    DMA: 725,
  },
  "57101": {
    DMA: 725,
  },
  "57103": {
    DMA: 725,
  },
  "57104": {
    DMA: 725,
  },
  "57105": {
    DMA: 725,
  },
  "57106": {
    DMA: 725,
  },
  "57107": {
    DMA: 725,
  },
  "57108": {
    DMA: 725,
  },
  "57109": {
    DMA: 725,
  },
  "57110": {
    DMA: 725,
  },
  "57117": {
    DMA: 725,
  },
  "57118": {
    DMA: 725,
  },
  "57186": {
    DMA: 725,
  },
  "57188": {
    DMA: 725,
  },
  "57189": {
    DMA: 725,
  },
  "57192": {
    DMA: 725,
  },
  "57193": {
    DMA: 725,
  },
  "57194": {
    DMA: 725,
  },
  "57195": {
    DMA: 725,
  },
  "57196": {
    DMA: 725,
  },
  "57197": {
    DMA: 725,
  },
  "57198": {
    DMA: 725,
  },
  "57201": {
    DMA: 725,
  },
  "57212": {
    DMA: 725,
  },
  "57213": {
    DMA: 725,
  },
  "57214": {
    DMA: 725,
  },
  "57216": {
    DMA: 725,
  },
  "57217": {
    DMA: 725,
  },
  "57218": {
    DMA: 725,
  },
  "57219": {
    DMA: 725,
  },
  "57220": {
    DMA: 725,
  },
  "57221": {
    DMA: 725,
  },
  "57223": {
    DMA: 725,
  },
  "57224": {
    DMA: 725,
  },
  "57225": {
    DMA: 725,
  },
  "57226": {
    DMA: 725,
  },
  "57227": {
    DMA: 725,
  },
  "57231": {
    DMA: 725,
  },
  "57232": {
    DMA: 725,
  },
  "57233": {
    DMA: 725,
  },
  "57234": {
    DMA: 725,
  },
  "57235": {
    DMA: 725,
  },
  "57236": {
    DMA: 725,
  },
  "57237": {
    DMA: 725,
  },
  "57238": {
    DMA: 725,
  },
  "57239": {
    DMA: 725,
  },
  "57241": {
    DMA: 725,
  },
  "57242": {
    DMA: 725,
  },
  "57243": {
    DMA: 725,
  },
  "57245": {
    DMA: 725,
  },
  "57246": {
    DMA: 725,
  },
  "57247": {
    DMA: 725,
  },
  "57248": {
    DMA: 725,
  },
  "57249": {
    DMA: 725,
  },
  "57251": {
    DMA: 725,
  },
  "57252": {
    DMA: 725,
  },
  "57253": {
    DMA: 725,
  },
  "57255": {
    DMA: 725,
  },
  "57256": {
    DMA: 725,
  },
  "57257": {
    DMA: 725,
  },
  "57258": {
    DMA: 725,
  },
  "57259": {
    DMA: 725,
  },
  "57260": {
    DMA: 725,
  },
  "57261": {
    DMA: 725,
  },
  "57262": {
    DMA: 725,
  },
  "57263": {
    DMA: 725,
  },
  "57264": {
    DMA: 725,
  },
  "57265": {
    DMA: 725,
  },
  "57266": {
    DMA: 725,
  },
  "57268": {
    DMA: 725,
  },
  "57269": {
    DMA: 725,
  },
  "57270": {
    DMA: 725,
  },
  "57271": {
    DMA: 725,
  },
  "57272": {
    DMA: 725,
  },
  "57273": {
    DMA: 725,
  },
  "57274": {
    DMA: 725,
  },
  "57276": {
    DMA: 725,
  },
  "57278": {
    DMA: 725,
  },
  "57279": {
    DMA: 725,
  },
  "57301": {
    DMA: 725,
  },
  "57311": {
    DMA: 725,
  },
  "57312": {
    DMA: 725,
  },
  "57313": {
    DMA: 725,
  },
  "57314": {
    DMA: 725,
  },
  "57315": {
    DMA: 725,
  },
  "57317": {
    DMA: 725,
  },
  "57319": {
    DMA: 725,
  },
  "57321": {
    DMA: 725,
  },
  "57322": {
    DMA: 725,
  },
  "57323": {
    DMA: 725,
  },
  "57324": {
    DMA: 725,
  },
  "57325": {
    DMA: 725,
  },
  "57326": {
    DMA: 725,
  },
  "57328": {
    DMA: 725,
  },
  "57329": {
    DMA: 725,
  },
  "57330": {
    DMA: 725,
  },
  "57331": {
    DMA: 725,
  },
  "57332": {
    DMA: 725,
  },
  "57334": {
    DMA: 725,
  },
  "57335": {
    DMA: 725,
  },
  "57337": {
    DMA: 725,
  },
  "57339": {
    DMA: 725,
  },
  "57340": {
    DMA: 725,
  },
  "57341": {
    DMA: 725,
  },
  "57342": {
    DMA: 725,
  },
  "57344": {
    DMA: 725,
  },
  "57345": {
    DMA: 725,
  },
  "57346": {
    DMA: 725,
  },
  "57348": {
    DMA: 725,
  },
  "57349": {
    DMA: 725,
  },
  "57350": {
    DMA: 725,
  },
  "57353": {
    DMA: 725,
  },
  "57354": {
    DMA: 725,
  },
  "57355": {
    DMA: 725,
  },
  "57356": {
    DMA: 725,
  },
  "57358": {
    DMA: 725,
  },
  "57359": {
    DMA: 725,
  },
  "57361": {
    DMA: 725,
  },
  "57362": {
    DMA: 725,
  },
  "57363": {
    DMA: 725,
  },
  "57364": {
    DMA: 725,
  },
  "57365": {
    DMA: 725,
  },
  "57366": {
    DMA: 725,
  },
  "57367": {
    DMA: 725,
  },
  "57368": {
    DMA: 725,
  },
  "57369": {
    DMA: 725,
  },
  "57370": {
    DMA: 725,
  },
  "57371": {
    DMA: 725,
  },
  "57373": {
    DMA: 725,
  },
  "57374": {
    DMA: 725,
  },
  "57375": {
    DMA: 725,
  },
  "57376": {
    DMA: 725,
  },
  "57379": {
    DMA: 725,
  },
  "57380": {
    DMA: 725,
  },
  "57381": {
    DMA: 725,
  },
  "57382": {
    DMA: 725,
  },
  "57383": {
    DMA: 725,
  },
  "57384": {
    DMA: 725,
  },
  "57385": {
    DMA: 725,
  },
  "57386": {
    DMA: 725,
  },
  "57399": {
    DMA: 725,
  },
  "57401": {
    DMA: 725,
  },
  "57402": {
    DMA: 725,
  },
  "57420": {
    DMA: 725,
  },
  "57421": {
    DMA: 725,
  },
  "57422": {
    DMA: 725,
  },
  "57424": {
    DMA: 725,
  },
  "57426": {
    DMA: 725,
  },
  "57427": {
    DMA: 725,
  },
  "57428": {
    DMA: 725,
  },
  "57429": {
    DMA: 725,
  },
  "57430": {
    DMA: 725,
  },
  "57432": {
    DMA: 725,
  },
  "57433": {
    DMA: 725,
  },
  "57434": {
    DMA: 725,
  },
  "57435": {
    DMA: 725,
  },
  "57436": {
    DMA: 725,
  },
  "57437": {
    DMA: 725,
  },
  "57438": {
    DMA: 725,
  },
  "57439": {
    DMA: 725,
  },
  "57440": {
    DMA: 725,
  },
  "57441": {
    DMA: 725,
  },
  "57442": {
    DMA: 725,
  },
  "57445": {
    DMA: 725,
  },
  "57446": {
    DMA: 725,
  },
  "57448": {
    DMA: 725,
  },
  "57449": {
    DMA: 725,
  },
  "57450": {
    DMA: 725,
  },
  "57451": {
    DMA: 725,
  },
  "57452": {
    DMA: 725,
  },
  "57454": {
    DMA: 725,
  },
  "57455": {
    DMA: 725,
  },
  "57456": {
    DMA: 725,
  },
  "57457": {
    DMA: 725,
  },
  "57460": {
    DMA: 725,
  },
  "57461": {
    DMA: 725,
  },
  "57465": {
    DMA: 725,
  },
  "57466": {
    DMA: 725,
  },
  "57467": {
    DMA: 725,
  },
  "57468": {
    DMA: 725,
  },
  "57469": {
    DMA: 725,
  },
  "57470": {
    DMA: 725,
  },
  "57471": {
    DMA: 725,
  },
  "57472": {
    DMA: 725,
  },
  "57473": {
    DMA: 725,
  },
  "57474": {
    DMA: 725,
  },
  "57475": {
    DMA: 725,
  },
  "57476": {
    DMA: 725,
  },
  "57477": {
    DMA: 725,
  },
  "57479": {
    DMA: 725,
  },
  "57481": {
    DMA: 725,
  },
  "57501": {
    DMA: 725,
  },
  "57520": {
    DMA: 725,
  },
  "57521": {
    DMA: 764,
  },
  "57522": {
    DMA: 725,
  },
  "57523": {
    DMA: 725,
  },
  "57528": {
    DMA: 725,
  },
  "57529": {
    DMA: 725,
  },
  "57531": {
    DMA: 764,
  },
  "57532": {
    DMA: 725,
  },
  "57533": {
    DMA: 725,
  },
  "57534": {
    DMA: 725,
  },
  "57536": {
    DMA: 725,
  },
  "57537": {
    DMA: 725,
  },
  "57538": {
    DMA: 725,
  },
  "57540": {
    DMA: 725,
  },
  "57541": {
    DMA: 725,
  },
  "57543": {
    DMA: 764,
  },
  "57544": {
    DMA: 725,
  },
  "57547": {
    DMA: 764,
  },
  "57548": {
    DMA: 725,
  },
  "57551": {
    DMA: 764,
  },
  "57552": {
    DMA: 764,
  },
  "57553": {
    DMA: 764,
  },
  "57555": {
    DMA: 725,
  },
  "57559": {
    DMA: 764,
  },
  "57560": {
    DMA: 725,
  },
  "57562": {
    DMA: 764,
  },
  "57563": {
    DMA: 725,
  },
  "57564": {
    DMA: 725,
  },
  "57566": {
    DMA: 725,
  },
  "57567": {
    DMA: 764,
  },
  "57568": {
    DMA: 725,
  },
  "57569": {
    DMA: 725,
  },
  "57570": {
    DMA: 725,
  },
  "57571": {
    DMA: 725,
  },
  "57572": {
    DMA: 725,
  },
  "57574": {
    DMA: 764,
  },
  "57576": {
    DMA: 725,
  },
  "57577": {
    DMA: 764,
  },
  "57579": {
    DMA: 725,
  },
  "57580": {
    DMA: 725,
  },
  "57584": {
    DMA: 725,
  },
  "57585": {
    DMA: 725,
  },
  "57601": {
    DMA: 725,
  },
  "57620": {
    DMA: 764,
  },
  "57621": {
    DMA: 687,
  },
  "57622": {
    DMA: 764,
  },
  "57623": {
    DMA: 764,
  },
  "57625": {
    DMA: 725,
  },
  "57626": {
    DMA: 764,
  },
  "57630": {
    DMA: 725,
  },
  "57631": {
    DMA: 725,
  },
  "57632": {
    DMA: 725,
  },
  "57633": {
    DMA: 725,
  },
  "57634": {
    DMA: 687,
  },
  "57636": {
    DMA: 725,
  },
  "57638": {
    DMA: 764,
  },
  "57639": {
    DMA: 687,
  },
  "57640": {
    DMA: 764,
  },
  "57641": {
    DMA: 687,
  },
  "57642": {
    DMA: 687,
  },
  "57644": {
    DMA: 764,
  },
  "57645": {
    DMA: 687,
  },
  "57646": {
    DMA: 725,
  },
  "57648": {
    DMA: 725,
  },
  "57649": {
    DMA: 764,
  },
  "57650": {
    DMA: 764,
  },
  "57651": {
    DMA: 764,
  },
  "57652": {
    DMA: 725,
  },
  "57656": {
    DMA: 725,
  },
  "57657": {
    DMA: 687,
  },
  "57658": {
    DMA: 687,
  },
  "57659": {
    DMA: 687,
  },
  "57660": {
    DMA: 687,
  },
  "57661": {
    DMA: 725,
  },
  "57701": {
    DMA: 764,
  },
  "57702": {
    DMA: 764,
  },
  "57703": {
    DMA: 764,
  },
  "57706": {
    DMA: 764,
  },
  "57709": {
    DMA: 764,
  },
  "57714": {
    DMA: 764,
  },
  "57716": {
    DMA: 764,
  },
  "57717": {
    DMA: 764,
  },
  "57718": {
    DMA: 764,
  },
  "57719": {
    DMA: 764,
  },
  "57720": {
    DMA: 764,
  },
  "57722": {
    DMA: 764,
  },
  "57724": {
    DMA: 764,
  },
  "57725": {
    DMA: 764,
  },
  "57730": {
    DMA: 764,
  },
  "57732": {
    DMA: 764,
  },
  "57735": {
    DMA: 764,
  },
  "57737": {
    DMA: 764,
  },
  "57738": {
    DMA: 764,
  },
  "57741": {
    DMA: 764,
  },
  "57744": {
    DMA: 764,
  },
  "57745": {
    DMA: 764,
  },
  "57747": {
    DMA: 764,
  },
  "57748": {
    DMA: 764,
  },
  "57750": {
    DMA: 764,
  },
  "57751": {
    DMA: 764,
  },
  "57752": {
    DMA: 764,
  },
  "57754": {
    DMA: 764,
  },
  "57755": {
    DMA: 764,
  },
  "57756": {
    DMA: 764,
  },
  "57758": {
    DMA: 764,
  },
  "57759": {
    DMA: 764,
  },
  "57760": {
    DMA: 764,
  },
  "57761": {
    DMA: 764,
  },
  "57762": {
    DMA: 764,
  },
  "57763": {
    DMA: 764,
  },
  "57764": {
    DMA: 764,
  },
  "57766": {
    DMA: 764,
  },
  "57767": {
    DMA: 764,
  },
  "57769": {
    DMA: 764,
  },
  "57770": {
    DMA: 764,
  },
  "57772": {
    DMA: 764,
  },
  "57773": {
    DMA: 764,
  },
  "57775": {
    DMA: 764,
  },
  "57776": {
    DMA: 764,
  },
  "57779": {
    DMA: 764,
  },
  "57780": {
    DMA: 764,
  },
  "57782": {
    DMA: 764,
  },
  "57783": {
    DMA: 764,
  },
  "57785": {
    DMA: 764,
  },
  "57787": {
    DMA: 764,
  },
  "57788": {
    DMA: 764,
  },
  "57790": {
    DMA: 764,
  },
  "57791": {
    DMA: 764,
  },
  "57792": {
    DMA: 764,
  },
  "57793": {
    DMA: 764,
  },
  "57794": {
    DMA: 764,
  },
  "57799": {
    DMA: 764,
  },
  "58001": {
    DMA: 724,
  },
  "58002": {
    DMA: 724,
  },
  "58004": {
    DMA: 724,
  },
  "58005": {
    DMA: 724,
  },
  "58006": {
    DMA: 724,
  },
  "58007": {
    DMA: 724,
  },
  "58008": {
    DMA: 724,
  },
  "58009": {
    DMA: 724,
  },
  "58011": {
    DMA: 724,
  },
  "58012": {
    DMA: 724,
  },
  "58013": {
    DMA: 724,
  },
  "58015": {
    DMA: 724,
  },
  "58016": {
    DMA: 724,
  },
  "58017": {
    DMA: 724,
  },
  "58018": {
    DMA: 724,
  },
  "58021": {
    DMA: 724,
  },
  "58027": {
    DMA: 724,
  },
  "58029": {
    DMA: 724,
  },
  "58030": {
    DMA: 724,
  },
  "58031": {
    DMA: 724,
  },
  "58032": {
    DMA: 724,
  },
  "58033": {
    DMA: 724,
  },
  "58035": {
    DMA: 724,
  },
  "58036": {
    DMA: 724,
  },
  "58038": {
    DMA: 724,
  },
  "58040": {
    DMA: 724,
  },
  "58041": {
    DMA: 724,
  },
  "58042": {
    DMA: 724,
  },
  "58043": {
    DMA: 724,
  },
  "58045": {
    DMA: 724,
  },
  "58046": {
    DMA: 724,
  },
  "58047": {
    DMA: 724,
  },
  "58048": {
    DMA: 724,
  },
  "58049": {
    DMA: 724,
  },
  "58051": {
    DMA: 724,
  },
  "58052": {
    DMA: 724,
  },
  "58053": {
    DMA: 724,
  },
  "58054": {
    DMA: 724,
  },
  "58056": {
    DMA: 724,
  },
  "58057": {
    DMA: 724,
  },
  "58058": {
    DMA: 724,
  },
  "58059": {
    DMA: 724,
  },
  "58060": {
    DMA: 724,
  },
  "58061": {
    DMA: 724,
  },
  "58062": {
    DMA: 724,
  },
  "58063": {
    DMA: 724,
  },
  "58064": {
    DMA: 724,
  },
  "58065": {
    DMA: 724,
  },
  "58067": {
    DMA: 724,
  },
  "58068": {
    DMA: 724,
  },
  "58069": {
    DMA: 724,
  },
  "58071": {
    DMA: 724,
  },
  "58072": {
    DMA: 724,
  },
  "58074": {
    DMA: 724,
  },
  "58075": {
    DMA: 724,
  },
  "58076": {
    DMA: 724,
  },
  "58077": {
    DMA: 724,
  },
  "58078": {
    DMA: 724,
  },
  "58079": {
    DMA: 724,
  },
  "58081": {
    DMA: 724,
  },
  "58102": {
    DMA: 724,
  },
  "58103": {
    DMA: 724,
  },
  "58104": {
    DMA: 724,
  },
  "58105": {
    DMA: 724,
  },
  "58106": {
    DMA: 724,
  },
  "58107": {
    DMA: 724,
  },
  "58108": {
    DMA: 724,
  },
  "58109": {
    DMA: 724,
  },
  "58121": {
    DMA: 724,
  },
  "58122": {
    DMA: 724,
  },
  "58124": {
    DMA: 724,
  },
  "58125": {
    DMA: 724,
  },
  "58126": {
    DMA: 724,
  },
  "58201": {
    DMA: 724,
  },
  "58202": {
    DMA: 724,
  },
  "58203": {
    DMA: 724,
  },
  "58204": {
    DMA: 724,
  },
  "58205": {
    DMA: 724,
  },
  "58206": {
    DMA: 724,
  },
  "58207": {
    DMA: 724,
  },
  "58208": {
    DMA: 724,
  },
  "58210": {
    DMA: 724,
  },
  "58212": {
    DMA: 724,
  },
  "58214": {
    DMA: 724,
  },
  "58216": {
    DMA: 724,
  },
  "58218": {
    DMA: 724,
  },
  "58219": {
    DMA: 724,
  },
  "58220": {
    DMA: 724,
  },
  "58222": {
    DMA: 724,
  },
  "58223": {
    DMA: 724,
  },
  "58224": {
    DMA: 724,
  },
  "58225": {
    DMA: 724,
  },
  "58227": {
    DMA: 724,
  },
  "58228": {
    DMA: 724,
  },
  "58229": {
    DMA: 724,
  },
  "58230": {
    DMA: 724,
  },
  "58231": {
    DMA: 724,
  },
  "58233": {
    DMA: 724,
  },
  "58235": {
    DMA: 724,
  },
  "58236": {
    DMA: 724,
  },
  "58237": {
    DMA: 724,
  },
  "58238": {
    DMA: 724,
  },
  "58239": {
    DMA: 724,
  },
  "58240": {
    DMA: 724,
  },
  "58241": {
    DMA: 724,
  },
  "58243": {
    DMA: 724,
  },
  "58244": {
    DMA: 724,
  },
  "58249": {
    DMA: 724,
  },
  "58250": {
    DMA: 724,
  },
  "58251": {
    DMA: 724,
  },
  "58254": {
    DMA: 724,
  },
  "58255": {
    DMA: 724,
  },
  "58256": {
    DMA: 724,
  },
  "58257": {
    DMA: 724,
  },
  "58258": {
    DMA: 724,
  },
  "58259": {
    DMA: 724,
  },
  "58260": {
    DMA: 724,
  },
  "58261": {
    DMA: 724,
  },
  "58262": {
    DMA: 724,
  },
  "58265": {
    DMA: 724,
  },
  "58266": {
    DMA: 724,
  },
  "58267": {
    DMA: 724,
  },
  "58269": {
    DMA: 724,
  },
  "58270": {
    DMA: 724,
  },
  "58271": {
    DMA: 724,
  },
  "58272": {
    DMA: 724,
  },
  "58273": {
    DMA: 724,
  },
  "58274": {
    DMA: 724,
  },
  "58275": {
    DMA: 724,
  },
  "58276": {
    DMA: 724,
  },
  "58277": {
    DMA: 724,
  },
  "58278": {
    DMA: 724,
  },
  "58281": {
    DMA: 724,
  },
  "58282": {
    DMA: 724,
  },
  "58301": {
    DMA: 724,
  },
  "58310": {
    DMA: 687,
  },
  "58311": {
    DMA: 724,
  },
  "58313": {
    DMA: 687,
  },
  "58316": {
    DMA: 687,
  },
  "58317": {
    DMA: 724,
  },
  "58318": {
    DMA: 687,
  },
  "58319": {
    DMA: 687,
  },
  "58321": {
    DMA: 724,
  },
  "58323": {
    DMA: 724,
  },
  "58324": {
    DMA: 724,
  },
  "58325": {
    DMA: 724,
  },
  "58327": {
    DMA: 724,
  },
  "58329": {
    DMA: 687,
  },
  "58330": {
    DMA: 724,
  },
  "58331": {
    DMA: 724,
  },
  "58332": {
    DMA: 724,
  },
  "58335": {
    DMA: 724,
  },
  "58338": {
    DMA: 724,
  },
  "58339": {
    DMA: 724,
  },
  "58341": {
    DMA: 687,
  },
  "58343": {
    DMA: 724,
  },
  "58344": {
    DMA: 724,
  },
  "58345": {
    DMA: 724,
  },
  "58346": {
    DMA: 724,
  },
  "58348": {
    DMA: 724,
  },
  "58351": {
    DMA: 724,
  },
  "58352": {
    DMA: 724,
  },
  "58353": {
    DMA: 687,
  },
  "58355": {
    DMA: 724,
  },
  "58356": {
    DMA: 724,
  },
  "58357": {
    DMA: 724,
  },
  "58361": {
    DMA: 724,
  },
  "58362": {
    DMA: 724,
  },
  "58363": {
    DMA: 724,
  },
  "58365": {
    DMA: 724,
  },
  "58366": {
    DMA: 687,
  },
  "58367": {
    DMA: 687,
  },
  "58368": {
    DMA: 687,
  },
  "58369": {
    DMA: 687,
  },
  "58370": {
    DMA: 724,
  },
  "58372": {
    DMA: 724,
  },
  "58374": {
    DMA: 724,
  },
  "58377": {
    DMA: 724,
  },
  "58379": {
    DMA: 724,
  },
  "58380": {
    DMA: 724,
  },
  "58381": {
    DMA: 724,
  },
  "58382": {
    DMA: 724,
  },
  "58384": {
    DMA: 687,
  },
  "58385": {
    DMA: 687,
  },
  "58386": {
    DMA: 724,
  },
  "58401": {
    DMA: 724,
  },
  "58402": {
    DMA: 724,
  },
  "58405": {
    DMA: 724,
  },
  "58413": {
    DMA: 687,
  },
  "58415": {
    DMA: 724,
  },
  "58416": {
    DMA: 724,
  },
  "58418": {
    DMA: 687,
  },
  "58420": {
    DMA: 724,
  },
  "58421": {
    DMA: 724,
  },
  "58422": {
    DMA: 687,
  },
  "58423": {
    DMA: 687,
  },
  "58424": {
    DMA: 724,
  },
  "58425": {
    DMA: 724,
  },
  "58426": {
    DMA: 724,
  },
  "58428": {
    DMA: 687,
  },
  "58429": {
    DMA: 724,
  },
  "58430": {
    DMA: 687,
  },
  "58431": {
    DMA: 724,
  },
  "58433": {
    DMA: 724,
  },
  "58436": {
    DMA: 724,
  },
  "58438": {
    DMA: 687,
  },
  "58439": {
    DMA: 724,
  },
  "58440": {
    DMA: 687,
  },
  "58441": {
    DMA: 724,
  },
  "58442": {
    DMA: 687,
  },
  "58443": {
    DMA: 724,
  },
  "58444": {
    DMA: 687,
  },
  "58445": {
    DMA: 724,
  },
  "58448": {
    DMA: 724,
  },
  "58451": {
    DMA: 687,
  },
  "58452": {
    DMA: 724,
  },
  "58454": {
    DMA: 724,
  },
  "58455": {
    DMA: 724,
  },
  "58456": {
    DMA: 724,
  },
  "58458": {
    DMA: 724,
  },
  "58460": {
    DMA: 687,
  },
  "58461": {
    DMA: 724,
  },
  "58463": {
    DMA: 687,
  },
  "58464": {
    DMA: 724,
  },
  "58466": {
    DMA: 724,
  },
  "58467": {
    DMA: 724,
  },
  "58472": {
    DMA: 724,
  },
  "58474": {
    DMA: 724,
  },
  "58475": {
    DMA: 687,
  },
  "58476": {
    DMA: 724,
  },
  "58477": {
    DMA: 687,
  },
  "58478": {
    DMA: 687,
  },
  "58479": {
    DMA: 724,
  },
  "58480": {
    DMA: 724,
  },
  "58481": {
    DMA: 724,
  },
  "58482": {
    DMA: 687,
  },
  "58483": {
    DMA: 724,
  },
  "58484": {
    DMA: 724,
  },
  "58486": {
    DMA: 687,
  },
  "58487": {
    DMA: 687,
  },
  "58488": {
    DMA: 687,
  },
  "58490": {
    DMA: 724,
  },
  "58492": {
    DMA: 724,
  },
  "58494": {
    DMA: 687,
  },
  "58495": {
    DMA: 687,
  },
  "58496": {
    DMA: 724,
  },
  "58497": {
    DMA: 724,
  },
  "58501": {
    DMA: 687,
  },
  "58502": {
    DMA: 687,
  },
  "58503": {
    DMA: 687,
  },
  "58504": {
    DMA: 687,
  },
  "58505": {
    DMA: 687,
  },
  "58506": {
    DMA: 687,
  },
  "58507": {
    DMA: 687,
  },
  "58520": {
    DMA: 687,
  },
  "58521": {
    DMA: 687,
  },
  "58523": {
    DMA: 687,
  },
  "58524": {
    DMA: 687,
  },
  "58528": {
    DMA: 687,
  },
  "58529": {
    DMA: 687,
  },
  "58530": {
    DMA: 687,
  },
  "58531": {
    DMA: 687,
  },
  "58532": {
    DMA: 687,
  },
  "58533": {
    DMA: 687,
  },
  "58535": {
    DMA: 687,
  },
  "58538": {
    DMA: 687,
  },
  "58540": {
    DMA: 687,
  },
  "58541": {
    DMA: 687,
  },
  "58542": {
    DMA: 687,
  },
  "58544": {
    DMA: 687,
  },
  "58545": {
    DMA: 687,
  },
  "58549": {
    DMA: 687,
  },
  "58552": {
    DMA: 687,
  },
  "58554": {
    DMA: 687,
  },
  "58558": {
    DMA: 687,
  },
  "58559": {
    DMA: 687,
  },
  "58560": {
    DMA: 687,
  },
  "58561": {
    DMA: 687,
  },
  "58562": {
    DMA: 687,
  },
  "58563": {
    DMA: 687,
  },
  "58564": {
    DMA: 687,
  },
  "58565": {
    DMA: 687,
  },
  "58566": {
    DMA: 687,
  },
  "58568": {
    DMA: 687,
  },
  "58569": {
    DMA: 687,
  },
  "58570": {
    DMA: 687,
  },
  "58571": {
    DMA: 687,
  },
  "58572": {
    DMA: 687,
  },
  "58573": {
    DMA: 687,
  },
  "58575": {
    DMA: 687,
  },
  "58576": {
    DMA: 687,
  },
  "58577": {
    DMA: 687,
  },
  "58579": {
    DMA: 687,
  },
  "58580": {
    DMA: 687,
  },
  "58581": {
    DMA: 687,
  },
  "58601": {
    DMA: 687,
  },
  "58602": {
    DMA: 687,
  },
  "58620": {
    DMA: 687,
  },
  "58621": {
    DMA: 687,
  },
  "58622": {
    DMA: 687,
  },
  "58623": {
    DMA: 687,
  },
  "58625": {
    DMA: 687,
  },
  "58626": {
    DMA: 687,
  },
  "58627": {
    DMA: 687,
  },
  "58630": {
    DMA: 687,
  },
  "58631": {
    DMA: 687,
  },
  "58632": {
    DMA: 687,
  },
  "58634": {
    DMA: 687,
  },
  "58636": {
    DMA: 687,
  },
  "58638": {
    DMA: 687,
  },
  "58639": {
    DMA: 687,
  },
  "58640": {
    DMA: 687,
  },
  "58641": {
    DMA: 687,
  },
  "58642": {
    DMA: 687,
  },
  "58643": {
    DMA: 687,
  },
  "58644": {
    DMA: 687,
  },
  "58645": {
    DMA: 687,
  },
  "58646": {
    DMA: 687,
  },
  "58647": {
    DMA: 687,
  },
  "58649": {
    DMA: 687,
  },
  "58650": {
    DMA: 687,
  },
  "58651": {
    DMA: 687,
  },
  "58652": {
    DMA: 687,
  },
  "58653": {
    DMA: 687,
  },
  "58654": {
    DMA: 687,
  },
  "58655": {
    DMA: 687,
  },
  "58656": {
    DMA: 687,
  },
  "58701": {
    DMA: 687,
  },
  "58702": {
    DMA: 687,
  },
  "58703": {
    DMA: 687,
  },
  "58704": {
    DMA: 687,
  },
  "58705": {
    DMA: 687,
  },
  "58707": {
    DMA: 687,
  },
  "58710": {
    DMA: 687,
  },
  "58711": {
    DMA: 687,
  },
  "58712": {
    DMA: 687,
  },
  "58713": {
    DMA: 687,
  },
  "58716": {
    DMA: 687,
  },
  "58718": {
    DMA: 687,
  },
  "58721": {
    DMA: 687,
  },
  "58722": {
    DMA: 687,
  },
  "58723": {
    DMA: 687,
  },
  "58725": {
    DMA: 687,
  },
  "58727": {
    DMA: 687,
  },
  "58730": {
    DMA: 687,
  },
  "58731": {
    DMA: 687,
  },
  "58733": {
    DMA: 687,
  },
  "58734": {
    DMA: 687,
  },
  "58735": {
    DMA: 687,
  },
  "58736": {
    DMA: 687,
  },
  "58737": {
    DMA: 687,
  },
  "58740": {
    DMA: 687,
  },
  "58741": {
    DMA: 687,
  },
  "58744": {
    DMA: 687,
  },
  "58746": {
    DMA: 687,
  },
  "58748": {
    DMA: 687,
  },
  "58750": {
    DMA: 687,
  },
  "58752": {
    DMA: 687,
  },
  "58755": {
    DMA: 687,
  },
  "58756": {
    DMA: 687,
  },
  "58757": {
    DMA: 687,
  },
  "58758": {
    DMA: 687,
  },
  "58759": {
    DMA: 687,
  },
  "58760": {
    DMA: 687,
  },
  "58761": {
    DMA: 687,
  },
  "58762": {
    DMA: 687,
  },
  "58763": {
    DMA: 687,
  },
  "58765": {
    DMA: 687,
  },
  "58768": {
    DMA: 687,
  },
  "58769": {
    DMA: 687,
  },
  "58770": {
    DMA: 687,
  },
  "58771": {
    DMA: 687,
  },
  "58772": {
    DMA: 687,
  },
  "58773": {
    DMA: 687,
  },
  "58775": {
    DMA: 687,
  },
  "58776": {
    DMA: 687,
  },
  "58778": {
    DMA: 687,
  },
  "58779": {
    DMA: 687,
  },
  "58781": {
    DMA: 687,
  },
  "58782": {
    DMA: 687,
  },
  "58783": {
    DMA: 687,
  },
  "58784": {
    DMA: 687,
  },
  "58785": {
    DMA: 687,
  },
  "58787": {
    DMA: 687,
  },
  "58788": {
    DMA: 687,
  },
  "58789": {
    DMA: 687,
  },
  "58790": {
    DMA: 687,
  },
  "58792": {
    DMA: 687,
  },
  "58793": {
    DMA: 687,
  },
  "58794": {
    DMA: 687,
  },
  "58795": {
    DMA: 687,
  },
  "58801": {
    DMA: 687,
  },
  "58802": {
    DMA: 687,
  },
  "58803": {
    DMA: 687,
  },
  "58830": {
    DMA: 687,
  },
  "58831": {
    DMA: 687,
  },
  "58833": {
    DMA: 687,
  },
  "58835": {
    DMA: 687,
  },
  "58838": {
    DMA: 687,
  },
  "58843": {
    DMA: 687,
  },
  "58844": {
    DMA: 687,
  },
  "58845": {
    DMA: 687,
  },
  "58847": {
    DMA: 687,
  },
  "58849": {
    DMA: 687,
  },
  "58852": {
    DMA: 687,
  },
  "58853": {
    DMA: 687,
  },
  "58854": {
    DMA: 687,
  },
  "58856": {
    DMA: 687,
  },
  "59001": {
    DMA: 756,
  },
  "59002": {
    DMA: 756,
  },
  "59003": {
    DMA: 756,
  },
  "59004": {
    DMA: 756,
  },
  "59006": {
    DMA: 756,
  },
  "59007": {
    DMA: 756,
  },
  "59008": {
    DMA: 756,
  },
  "59010": {
    DMA: 756,
  },
  "59011": {
    DMA: 756,
  },
  "59012": {
    DMA: 756,
  },
  "59013": {
    DMA: 756,
  },
  "59014": {
    DMA: 756,
  },
  "59015": {
    DMA: 756,
  },
  "59016": {
    DMA: 756,
  },
  "59018": {
    DMA: 756,
  },
  "59019": {
    DMA: 756,
  },
  "59020": {
    DMA: 756,
  },
  "59022": {
    DMA: 756,
  },
  "59024": {
    DMA: 756,
  },
  "59025": {
    DMA: 756,
  },
  "59026": {
    DMA: 756,
  },
  "59027": {
    DMA: 756,
  },
  "59028": {
    DMA: 756,
  },
  "59029": {
    DMA: 756,
  },
  "59030": {
    DMA: 756,
  },
  "59031": {
    DMA: 756,
  },
  "59032": {
    DMA: 755,
  },
  "59033": {
    DMA: 756,
  },
  "59034": {
    DMA: 756,
  },
  "59035": {
    DMA: 756,
  },
  "59036": {
    DMA: 756,
  },
  "59037": {
    DMA: 756,
  },
  "59038": {
    DMA: 756,
  },
  "59039": {
    DMA: 756,
  },
  "59041": {
    DMA: 756,
  },
  "59043": {
    DMA: 756,
  },
  "59044": {
    DMA: 756,
  },
  "59046": {
    DMA: 756,
  },
  "59047": {
    DMA: 756,
  },
  "59050": {
    DMA: 756,
  },
  "59052": {
    DMA: 756,
  },
  "59053": {
    DMA: 756,
  },
  "59054": {
    DMA: 756,
  },
  "59055": {
    DMA: 756,
  },
  "59057": {
    DMA: 756,
  },
  "59058": {
    DMA: 756,
  },
  "59059": {
    DMA: 756,
  },
  "59061": {
    DMA: 756,
  },
  "59062": {
    DMA: 756,
  },
  "59063": {
    DMA: 756,
  },
  "59064": {
    DMA: 756,
  },
  "59065": {
    DMA: 756,
  },
  "59066": {
    DMA: 756,
  },
  "59067": {
    DMA: 756,
  },
  "59068": {
    DMA: 756,
  },
  "59069": {
    DMA: 756,
  },
  "59070": {
    DMA: 756,
  },
  "59071": {
    DMA: 756,
  },
  "59072": {
    DMA: 756,
  },
  "59073": {
    DMA: 756,
  },
  "59074": {
    DMA: 756,
  },
  "59075": {
    DMA: 756,
  },
  "59076": {
    DMA: 756,
  },
  "59077": {
    DMA: 756,
  },
  "59078": {
    DMA: 756,
  },
  "59079": {
    DMA: 756,
  },
  "59081": {
    DMA: 756,
  },
  "59082": {
    DMA: 756,
  },
  "59083": {
    DMA: 756,
  },
  "59084": {
    DMA: 756,
  },
  "59085": {
    DMA: 756,
  },
  "59086": {
    DMA: 756,
  },
  "59087": {
    DMA: 756,
  },
  "59088": {
    DMA: 756,
  },
  "59089": {
    DMA: 756,
  },
  "59101": {
    DMA: 756,
  },
  "59102": {
    DMA: 756,
  },
  "59103": {
    DMA: 756,
  },
  "59104": {
    DMA: 756,
  },
  "59105": {
    DMA: 756,
  },
  "59106": {
    DMA: 756,
  },
  "59107": {
    DMA: 756,
  },
  "59108": {
    DMA: 756,
  },
  "59111": {
    DMA: 756,
  },
  "59112": {
    DMA: 756,
  },
  "59114": {
    DMA: 756,
  },
  "59115": {
    DMA: 756,
  },
  "59116": {
    DMA: 756,
  },
  "59117": {
    DMA: 756,
  },
  "59201": {
    DMA: 687,
  },
  "59211": {
    DMA: 687,
  },
  "59212": {
    DMA: 687,
  },
  "59213": {
    DMA: 687,
  },
  "59214": {
    DMA: 687,
  },
  "59215": {
    DMA: 687,
  },
  "59217": {
    DMA: 687,
  },
  "59218": {
    DMA: 687,
  },
  "59219": {
    DMA: 687,
  },
  "59221": {
    DMA: 687,
  },
  "59222": {
    DMA: 687,
  },
  "59223": {
    DMA: 755,
  },
  "59225": {
    DMA: 755,
  },
  "59226": {
    DMA: 687,
  },
  "59230": {
    DMA: 755,
  },
  "59231": {
    DMA: 755,
  },
  "59240": {
    DMA: 755,
  },
  "59241": {
    DMA: 755,
  },
  "59242": {
    DMA: 687,
  },
  "59243": {
    DMA: 687,
  },
  "59244": {
    DMA: 755,
  },
  "59247": {
    DMA: 687,
  },
  "59248": {
    DMA: 755,
  },
  "59250": {
    DMA: 755,
  },
  "59252": {
    DMA: 687,
  },
  "59253": {
    DMA: 687,
  },
  "59254": {
    DMA: 687,
  },
  "59255": {
    DMA: 687,
  },
  "59256": {
    DMA: 687,
  },
  "59257": {
    DMA: 687,
  },
  "59258": {
    DMA: 687,
  },
  "59259": {
    DMA: 798,
  },
  "59260": {
    DMA: 755,
  },
  "59261": {
    DMA: 755,
  },
  "59262": {
    DMA: 687,
  },
  "59263": {
    DMA: 687,
  },
  "59270": {
    DMA: 687,
  },
  "59273": {
    DMA: 755,
  },
  "59274": {
    DMA: 687,
  },
  "59275": {
    DMA: 687,
  },
  "59276": {
    DMA: 687,
  },
  "59301": {
    DMA: 756,
  },
  "59311": {
    DMA: 764,
  },
  "59312": {
    DMA: 756,
  },
  "59313": {
    DMA: 687,
  },
  "59314": {
    DMA: 756,
  },
  "59315": {
    DMA: 798,
  },
  "59316": {
    DMA: 764,
  },
  "59317": {
    DMA: 756,
  },
  "59318": {
    DMA: 756,
  },
  "59319": {
    DMA: 764,
  },
  "59322": {
    DMA: 756,
  },
  "59323": {
    DMA: 756,
  },
  "59324": {
    DMA: 764,
  },
  "59326": {
    DMA: 798,
  },
  "59327": {
    DMA: 756,
  },
  "59330": {
    DMA: 798,
  },
  "59332": {
    DMA: 764,
  },
  "59333": {
    DMA: 756,
  },
  "59336": {
    DMA: 756,
  },
  "59337": {
    DMA: 756,
  },
  "59338": {
    DMA: 756,
  },
  "59339": {
    DMA: 798,
  },
  "59341": {
    DMA: 798,
  },
  "59343": {
    DMA: 756,
  },
  "59344": {
    DMA: 687,
  },
  "59345": {
    DMA: 756,
  },
  "59347": {
    DMA: 756,
  },
  "59349": {
    DMA: 798,
  },
  "59351": {
    DMA: 756,
  },
  "59353": {
    DMA: 687,
  },
  "59354": {
    DMA: 687,
  },
  "59401": {
    DMA: 755,
  },
  "59402": {
    DMA: 755,
  },
  "59403": {
    DMA: 755,
  },
  "59404": {
    DMA: 755,
  },
  "59405": {
    DMA: 755,
  },
  "59406": {
    DMA: 755,
  },
  "59410": {
    DMA: 766,
  },
  "59411": {
    DMA: 755,
  },
  "59412": {
    DMA: 755,
  },
  "59414": {
    DMA: 755,
  },
  "59416": {
    DMA: 755,
  },
  "59417": {
    DMA: 755,
  },
  "59418": {
    DMA: 755,
  },
  "59419": {
    DMA: 755,
  },
  "59420": {
    DMA: 755,
  },
  "59421": {
    DMA: 755,
  },
  "59422": {
    DMA: 755,
  },
  "59424": {
    DMA: 755,
  },
  "59425": {
    DMA: 755,
  },
  "59427": {
    DMA: 755,
  },
  "59430": {
    DMA: 755,
  },
  "59432": {
    DMA: 755,
  },
  "59433": {
    DMA: 755,
  },
  "59434": {
    DMA: 755,
  },
  "59435": {
    DMA: 755,
  },
  "59436": {
    DMA: 755,
  },
  "59440": {
    DMA: 755,
  },
  "59441": {
    DMA: 755,
  },
  "59442": {
    DMA: 755,
  },
  "59443": {
    DMA: 755,
  },
  "59444": {
    DMA: 755,
  },
  "59446": {
    DMA: 755,
  },
  "59447": {
    DMA: 755,
  },
  "59448": {
    DMA: 755,
  },
  "59450": {
    DMA: 755,
  },
  "59451": {
    DMA: 755,
  },
  "59452": {
    DMA: 755,
  },
  "59453": {
    DMA: 756,
  },
  "59454": {
    DMA: 755,
  },
  "59456": {
    DMA: 755,
  },
  "59457": {
    DMA: 755,
  },
  "59460": {
    DMA: 755,
  },
  "59461": {
    DMA: 755,
  },
  "59462": {
    DMA: 755,
  },
  "59463": {
    DMA: 755,
  },
  "59464": {
    DMA: 755,
  },
  "59465": {
    DMA: 755,
  },
  "59466": {
    DMA: 755,
  },
  "59467": {
    DMA: 755,
  },
  "59468": {
    DMA: 755,
  },
  "59469": {
    DMA: 755,
  },
  "59471": {
    DMA: 755,
  },
  "59472": {
    DMA: 755,
  },
  "59474": {
    DMA: 755,
  },
  "59477": {
    DMA: 755,
  },
  "59479": {
    DMA: 755,
  },
  "59480": {
    DMA: 755,
  },
  "59482": {
    DMA: 755,
  },
  "59483": {
    DMA: 755,
  },
  "59484": {
    DMA: 755,
  },
  "59485": {
    DMA: 755,
  },
  "59486": {
    DMA: 755,
  },
  "59487": {
    DMA: 755,
  },
  "59489": {
    DMA: 755,
  },
  "59501": {
    DMA: 755,
  },
  "59520": {
    DMA: 755,
  },
  "59521": {
    DMA: 755,
  },
  "59522": {
    DMA: 755,
  },
  "59523": {
    DMA: 755,
  },
  "59524": {
    DMA: 755,
  },
  "59525": {
    DMA: 755,
  },
  "59526": {
    DMA: 755,
  },
  "59527": {
    DMA: 755,
  },
  "59528": {
    DMA: 755,
  },
  "59529": {
    DMA: 755,
  },
  "59530": {
    DMA: 755,
  },
  "59531": {
    DMA: 755,
  },
  "59532": {
    DMA: 755,
  },
  "59535": {
    DMA: 755,
  },
  "59537": {
    DMA: 755,
  },
  "59538": {
    DMA: 755,
  },
  "59540": {
    DMA: 755,
  },
  "59542": {
    DMA: 755,
  },
  "59544": {
    DMA: 755,
  },
  "59545": {
    DMA: 755,
  },
  "59546": {
    DMA: 755,
  },
  "59547": {
    DMA: 755,
  },
  "59601": {
    DMA: 766,
  },
  "59602": {
    DMA: 766,
  },
  "59604": {
    DMA: 766,
  },
  "59620": {
    DMA: 766,
  },
  "59623": {
    DMA: 766,
  },
  "59624": {
    DMA: 766,
  },
  "59625": {
    DMA: 766,
  },
  "59626": {
    DMA: 766,
  },
  "59631": {
    DMA: 754,
  },
  "59632": {
    DMA: 754,
  },
  "59633": {
    DMA: 766,
  },
  "59634": {
    DMA: 754,
  },
  "59635": {
    DMA: 766,
  },
  "59636": {
    DMA: 766,
  },
  "59638": {
    DMA: 754,
  },
  "59639": {
    DMA: 766,
  },
  "59640": {
    DMA: 766,
  },
  "59641": {
    DMA: 766,
  },
  "59642": {
    DMA: 756,
  },
  "59643": {
    DMA: 766,
  },
  "59644": {
    DMA: 766,
  },
  "59645": {
    DMA: 756,
  },
  "59647": {
    DMA: 766,
  },
  "59648": {
    DMA: 766,
  },
  "59701": {
    DMA: 754,
  },
  "59702": {
    DMA: 754,
  },
  "59703": {
    DMA: 754,
  },
  "59707": {
    DMA: 754,
  },
  "59710": {
    DMA: 754,
  },
  "59711": {
    DMA: 754,
  },
  "59713": {
    DMA: 754,
  },
  "59714": {
    DMA: 754,
  },
  "59715": {
    DMA: 754,
  },
  "59716": {
    DMA: 754,
  },
  "59717": {
    DMA: 754,
  },
  "59718": {
    DMA: 754,
  },
  "59719": {
    DMA: 754,
  },
  "59720": {
    DMA: 754,
  },
  "59721": {
    DMA: 754,
  },
  "59722": {
    DMA: 754,
  },
  "59724": {
    DMA: 754,
  },
  "59725": {
    DMA: 754,
  },
  "59727": {
    DMA: 754,
  },
  "59728": {
    DMA: 754,
  },
  "59729": {
    DMA: 754,
  },
  "59730": {
    DMA: 754,
  },
  "59731": {
    DMA: 754,
  },
  "59732": {
    DMA: 754,
  },
  "59733": {
    DMA: 754,
  },
  "59735": {
    DMA: 754,
  },
  "59736": {
    DMA: 754,
  },
  "59739": {
    DMA: 754,
  },
  "59740": {
    DMA: 754,
  },
  "59741": {
    DMA: 754,
  },
  "59743": {
    DMA: 754,
  },
  "59745": {
    DMA: 754,
  },
  "59746": {
    DMA: 754,
  },
  "59747": {
    DMA: 754,
  },
  "59748": {
    DMA: 754,
  },
  "59749": {
    DMA: 754,
  },
  "59750": {
    DMA: 754,
  },
  "59751": {
    DMA: 754,
  },
  "59752": {
    DMA: 754,
  },
  "59754": {
    DMA: 754,
  },
  "59755": {
    DMA: 754,
  },
  "59756": {
    DMA: 754,
  },
  "59758": {
    DMA: 754,
  },
  "59759": {
    DMA: 754,
  },
  "59760": {
    DMA: 754,
  },
  "59761": {
    DMA: 754,
  },
  "59762": {
    DMA: 754,
  },
  "59771": {
    DMA: 754,
  },
  "59772": {
    DMA: 754,
  },
  "59773": {
    DMA: "#N/A",
  },
  "59801": {
    DMA: 762,
  },
  "59802": {
    DMA: 762,
  },
  "59803": {
    DMA: 762,
  },
  "59804": {
    DMA: 762,
  },
  "59806": {
    DMA: 762,
  },
  "59807": {
    DMA: 762,
  },
  "59808": {
    DMA: 762,
  },
  "59812": {
    DMA: 762,
  },
  "59820": {
    DMA: 762,
  },
  "59821": {
    DMA: 762,
  },
  "59823": {
    DMA: 762,
  },
  "59824": {
    DMA: 762,
  },
  "59825": {
    DMA: 762,
  },
  "59826": {
    DMA: 762,
  },
  "59827": {
    DMA: 762,
  },
  "59828": {
    DMA: 762,
  },
  "59829": {
    DMA: 762,
  },
  "59830": {
    DMA: 762,
  },
  "59831": {
    DMA: 762,
  },
  "59832": {
    DMA: 762,
  },
  "59833": {
    DMA: 762,
  },
  "59834": {
    DMA: 762,
  },
  "59835": {
    DMA: 762,
  },
  "59837": {
    DMA: 762,
  },
  "59840": {
    DMA: 762,
  },
  "59841": {
    DMA: 762,
  },
  "59842": {
    DMA: 762,
  },
  "59843": {
    DMA: 754,
  },
  "59844": {
    DMA: 762,
  },
  "59845": {
    DMA: 762,
  },
  "59846": {
    DMA: 762,
  },
  "59847": {
    DMA: 762,
  },
  "59848": {
    DMA: 762,
  },
  "59851": {
    DMA: 762,
  },
  "59853": {
    DMA: 762,
  },
  "59854": {
    DMA: 754,
  },
  "59855": {
    DMA: 762,
  },
  "59856": {
    DMA: 762,
  },
  "59858": {
    DMA: 762,
  },
  "59859": {
    DMA: 762,
  },
  "59860": {
    DMA: 762,
  },
  "59863": {
    DMA: 762,
  },
  "59864": {
    DMA: 762,
  },
  "59865": {
    DMA: 762,
  },
  "59866": {
    DMA: 762,
  },
  "59867": {
    DMA: 762,
  },
  "59868": {
    DMA: 762,
  },
  "59870": {
    DMA: 762,
  },
  "59871": {
    DMA: 762,
  },
  "59872": {
    DMA: 762,
  },
  "59873": {
    DMA: 762,
  },
  "59874": {
    DMA: 762,
  },
  "59875": {
    DMA: 762,
  },
  "59901": {
    DMA: 762,
  },
  "59903": {
    DMA: 762,
  },
  "59904": {
    DMA: 762,
  },
  "59910": {
    DMA: 762,
  },
  "59911": {
    DMA: 762,
  },
  "59912": {
    DMA: 762,
  },
  "59913": {
    DMA: 762,
  },
  "59914": {
    DMA: 762,
  },
  "59915": {
    DMA: 762,
  },
  "59916": {
    DMA: 762,
  },
  "59917": {
    DMA: 881,
  },
  "59918": {
    DMA: 881,
  },
  "59919": {
    DMA: 762,
  },
  "59920": {
    DMA: 762,
  },
  "59921": {
    DMA: 762,
  },
  "59922": {
    DMA: 762,
  },
  "59923": {
    DMA: 881,
  },
  "59925": {
    DMA: 762,
  },
  "59926": {
    DMA: 762,
  },
  "59927": {
    DMA: 762,
  },
  "59928": {
    DMA: 762,
  },
  "59929": {
    DMA: 762,
  },
  "59930": {
    DMA: 881,
  },
  "59931": {
    DMA: 762,
  },
  "59932": {
    DMA: 762,
  },
  "59933": {
    DMA: 881,
  },
  "59934": {
    DMA: 881,
  },
  "59935": {
    DMA: 881,
  },
  "59936": {
    DMA: 762,
  },
  "59937": {
    DMA: 762,
  },
  "60001": {
    DMA: 602,
  },
  "60002": {
    DMA: 602,
  },
  "60004": {
    DMA: 602,
  },
  "60005": {
    DMA: 602,
  },
  "60006": {
    DMA: 602,
  },
  "60007": {
    DMA: 602,
  },
  "60008": {
    DMA: 602,
  },
  "60009": {
    DMA: 602,
  },
  "60010": {
    DMA: 602,
  },
  "60011": {
    DMA: 602,
  },
  "60012": {
    DMA: 602,
  },
  "60013": {
    DMA: 602,
  },
  "60014": {
    DMA: 602,
  },
  "60015": {
    DMA: 602,
  },
  "60016": {
    DMA: 602,
  },
  "60017": {
    DMA: 602,
  },
  "60018": {
    DMA: 602,
  },
  "60019": {
    DMA: 602,
  },
  "60020": {
    DMA: 602,
  },
  "60021": {
    DMA: 602,
  },
  "60022": {
    DMA: 602,
  },
  "60025": {
    DMA: 602,
  },
  "60026": {
    DMA: 602,
  },
  "60029": {
    DMA: 602,
  },
  "60030": {
    DMA: 602,
  },
  "60031": {
    DMA: 602,
  },
  "60033": {
    DMA: 602,
  },
  "60034": {
    DMA: 602,
  },
  "60035": {
    DMA: 602,
  },
  "60037": {
    DMA: 602,
  },
  "60038": {
    DMA: 602,
  },
  "60039": {
    DMA: 602,
  },
  "60040": {
    DMA: 602,
  },
  "60041": {
    DMA: 602,
  },
  "60042": {
    DMA: 602,
  },
  "60043": {
    DMA: 602,
  },
  "60044": {
    DMA: 602,
  },
  "60045": {
    DMA: 602,
  },
  "60046": {
    DMA: 602,
  },
  "60047": {
    DMA: 602,
  },
  "60048": {
    DMA: 602,
  },
  "60049": {
    DMA: 602,
  },
  "60050": {
    DMA: 602,
  },
  "60051": {
    DMA: 602,
  },
  "60053": {
    DMA: 602,
  },
  "60055": {
    DMA: 602,
  },
  "60056": {
    DMA: 602,
  },
  "60060": {
    DMA: 602,
  },
  "60061": {
    DMA: 602,
  },
  "60062": {
    DMA: 602,
  },
  "60064": {
    DMA: 602,
  },
  "60065": {
    DMA: 602,
  },
  "60067": {
    DMA: 602,
  },
  "60068": {
    DMA: 602,
  },
  "60069": {
    DMA: 602,
  },
  "60070": {
    DMA: 602,
  },
  "60071": {
    DMA: 602,
  },
  "60072": {
    DMA: 602,
  },
  "60073": {
    DMA: 602,
  },
  "60074": {
    DMA: 602,
  },
  "60075": {
    DMA: 602,
  },
  "60076": {
    DMA: 602,
  },
  "60077": {
    DMA: 602,
  },
  "60078": {
    DMA: 602,
  },
  "60079": {
    DMA: 602,
  },
  "60081": {
    DMA: 602,
  },
  "60082": {
    DMA: 602,
  },
  "60083": {
    DMA: 602,
  },
  "60084": {
    DMA: 602,
  },
  "60085": {
    DMA: 602,
  },
  "60086": {
    DMA: 602,
  },
  "60087": {
    DMA: 602,
  },
  "60088": {
    DMA: 602,
  },
  "60089": {
    DMA: 602,
  },
  "60090": {
    DMA: 602,
  },
  "60091": {
    DMA: 602,
  },
  "60092": {
    DMA: 602,
  },
  "60093": {
    DMA: 602,
  },
  "60094": {
    DMA: 602,
  },
  "60095": {
    DMA: 602,
  },
  "60096": {
    DMA: 602,
  },
  "60097": {
    DMA: 602,
  },
  "60098": {
    DMA: 602,
  },
  "60099": {
    DMA: 602,
  },
  "60101": {
    DMA: 602,
  },
  "60102": {
    DMA: 602,
  },
  "60103": {
    DMA: 602,
  },
  "60104": {
    DMA: 602,
  },
  "60105": {
    DMA: 602,
  },
  "60106": {
    DMA: 602,
  },
  "60107": {
    DMA: 602,
  },
  "60108": {
    DMA: 602,
  },
  "60109": {
    DMA: 602,
  },
  "60110": {
    DMA: 602,
  },
  "60111": {
    DMA: 602,
  },
  "60112": {
    DMA: 602,
  },
  "60113": {
    DMA: 610,
  },
  "60115": {
    DMA: 602,
  },
  "60116": {
    DMA: 602,
  },
  "60117": {
    DMA: 602,
  },
  "60118": {
    DMA: 602,
  },
  "60119": {
    DMA: 602,
  },
  "60120": {
    DMA: 602,
  },
  "60121": {
    DMA: 602,
  },
  "60122": {
    DMA: 602,
  },
  "60123": {
    DMA: 602,
  },
  "60124": {
    DMA: 602,
  },
  "60125": {
    DMA: 602,
  },
  "60126": {
    DMA: 602,
  },
  "60128": {
    DMA: 602,
  },
  "60129": {
    DMA: 602,
  },
  "60130": {
    DMA: 602,
  },
  "60131": {
    DMA: 602,
  },
  "60132": {
    DMA: 602,
  },
  "60133": {
    DMA: 602,
  },
  "60134": {
    DMA: 602,
  },
  "60135": {
    DMA: 602,
  },
  "60136": {
    DMA: 602,
  },
  "60137": {
    DMA: 602,
  },
  "60138": {
    DMA: 602,
  },
  "60139": {
    DMA: 602,
  },
  "60140": {
    DMA: 602,
  },
  "60141": {
    DMA: 602,
  },
  "60142": {
    DMA: 602,
  },
  "60143": {
    DMA: 602,
  },
  "60144": {
    DMA: 602,
  },
  "60145": {
    DMA: 602,
  },
  "60146": {
    DMA: 602,
  },
  "60147": {
    DMA: 602,
  },
  "60148": {
    DMA: 602,
  },
  "60150": {
    DMA: 602,
  },
  "60151": {
    DMA: 602,
  },
  "60152": {
    DMA: 602,
  },
  "60153": {
    DMA: 602,
  },
  "60154": {
    DMA: 602,
  },
  "60155": {
    DMA: 602,
  },
  "60156": {
    DMA: 602,
  },
  "60157": {
    DMA: 602,
  },
  "60159": {
    DMA: 602,
  },
  "60160": {
    DMA: 602,
  },
  "60161": {
    DMA: 602,
  },
  "60162": {
    DMA: 602,
  },
  "60163": {
    DMA: 602,
  },
  "60164": {
    DMA: 602,
  },
  "60165": {
    DMA: 602,
  },
  "60168": {
    DMA: 602,
  },
  "60169": {
    DMA: 602,
  },
  "60170": {
    DMA: 602,
  },
  "60171": {
    DMA: 602,
  },
  "60172": {
    DMA: 602,
  },
  "60173": {
    DMA: 602,
  },
  "60174": {
    DMA: 602,
  },
  "60175": {
    DMA: 602,
  },
  "60176": {
    DMA: 602,
  },
  "60177": {
    DMA: 602,
  },
  "60178": {
    DMA: 602,
  },
  "60179": {
    DMA: 602,
  },
  "60180": {
    DMA: 602,
  },
  "60181": {
    DMA: 602,
  },
  "60183": {
    DMA: 602,
  },
  "60184": {
    DMA: 602,
  },
  "60185": {
    DMA: 602,
  },
  "60186": {
    DMA: 602,
  },
  "60187": {
    DMA: 602,
  },
  "60188": {
    DMA: 602,
  },
  "60189": {
    DMA: 602,
  },
  "60190": {
    DMA: 602,
  },
  "60191": {
    DMA: 602,
  },
  "60192": {
    DMA: 602,
  },
  "60193": {
    DMA: 602,
  },
  "60194": {
    DMA: 602,
  },
  "60195": {
    DMA: 602,
  },
  "60196": {
    DMA: 602,
  },
  "60197": {
    DMA: 602,
  },
  "60199": {
    DMA: 602,
  },
  "60201": {
    DMA: 602,
  },
  "60202": {
    DMA: 602,
  },
  "60203": {
    DMA: 602,
  },
  "60204": {
    DMA: 602,
  },
  "60208": {
    DMA: 602,
  },
  "60209": {
    DMA: 602,
  },
  "60290": {
    DMA: 602,
  },
  "60301": {
    DMA: 602,
  },
  "60302": {
    DMA: 602,
  },
  "60303": {
    DMA: 602,
  },
  "60304": {
    DMA: 602,
  },
  "60305": {
    DMA: 602,
  },
  "60399": {
    DMA: 602,
  },
  "60401": {
    DMA: 602,
  },
  "60402": {
    DMA: 602,
  },
  "60403": {
    DMA: 602,
  },
  "60404": {
    DMA: 602,
  },
  "60406": {
    DMA: 602,
  },
  "60407": {
    DMA: 602,
  },
  "60408": {
    DMA: 602,
  },
  "60409": {
    DMA: 602,
  },
  "60410": {
    DMA: 602,
  },
  "60411": {
    DMA: 602,
  },
  "60412": {
    DMA: 602,
  },
  "60415": {
    DMA: 602,
  },
  "60416": {
    DMA: 602,
  },
  "60417": {
    DMA: 602,
  },
  "60418": {
    DMA: 602,
  },
  "60419": {
    DMA: 602,
  },
  "60420": {
    DMA: 675,
  },
  "60421": {
    DMA: 602,
  },
  "60422": {
    DMA: 602,
  },
  "60423": {
    DMA: 602,
  },
  "60424": {
    DMA: 602,
  },
  "60425": {
    DMA: 602,
  },
  "60426": {
    DMA: 602,
  },
  "60428": {
    DMA: 602,
  },
  "60429": {
    DMA: 602,
  },
  "60430": {
    DMA: 602,
  },
  "60431": {
    DMA: 602,
  },
  "60432": {
    DMA: 602,
  },
  "60433": {
    DMA: 602,
  },
  "60434": {
    DMA: 602,
  },
  "60435": {
    DMA: 602,
  },
  "60436": {
    DMA: 602,
  },
  "60437": {
    DMA: 602,
  },
  "60438": {
    DMA: 602,
  },
  "60439": {
    DMA: 602,
  },
  "60440": {
    DMA: 602,
  },
  "60441": {
    DMA: 602,
  },
  "60442": {
    DMA: 602,
  },
  "60443": {
    DMA: 602,
  },
  "60444": {
    DMA: 602,
  },
  "60445": {
    DMA: 602,
  },
  "60446": {
    DMA: 602,
  },
  "60447": {
    DMA: 602,
  },
  "60448": {
    DMA: 602,
  },
  "60449": {
    DMA: 602,
  },
  "60450": {
    DMA: 602,
  },
  "60451": {
    DMA: 602,
  },
  "60452": {
    DMA: 602,
  },
  "60453": {
    DMA: 602,
  },
  "60454": {
    DMA: 602,
  },
  "60455": {
    DMA: 602,
  },
  "60456": {
    DMA: 602,
  },
  "60457": {
    DMA: 602,
  },
  "60458": {
    DMA: 602,
  },
  "60459": {
    DMA: 602,
  },
  "60460": {
    DMA: 675,
  },
  "60461": {
    DMA: 602,
  },
  "60462": {
    DMA: 602,
  },
  "60463": {
    DMA: 602,
  },
  "60464": {
    DMA: 602,
  },
  "60465": {
    DMA: 602,
  },
  "60466": {
    DMA: 602,
  },
  "60467": {
    DMA: 602,
  },
  "60468": {
    DMA: 602,
  },
  "60469": {
    DMA: 602,
  },
  "60470": {
    DMA: 602,
  },
  "60471": {
    DMA: 602,
  },
  "60472": {
    DMA: 602,
  },
  "60473": {
    DMA: 602,
  },
  "60474": {
    DMA: 602,
  },
  "60475": {
    DMA: 602,
  },
  "60476": {
    DMA: 602,
  },
  "60477": {
    DMA: 602,
  },
  "60478": {
    DMA: 602,
  },
  "60479": {
    DMA: 602,
  },
  "60480": {
    DMA: 602,
  },
  "60481": {
    DMA: 602,
  },
  "60482": {
    DMA: 602,
  },
  "60484": {
    DMA: 602,
  },
  "60487": {
    DMA: 602,
  },
  "60490": {
    DMA: 602,
  },
  "60491": {
    DMA: 602,
  },
  "60499": {
    DMA: 602,
  },
  "60501": {
    DMA: 602,
  },
  "60502": {
    DMA: 602,
  },
  "60503": {
    DMA: 602,
  },
  "60504": {
    DMA: 602,
  },
  "60505": {
    DMA: 602,
  },
  "60506": {
    DMA: 602,
  },
  "60507": {
    DMA: 602,
  },
  "60510": {
    DMA: 602,
  },
  "60511": {
    DMA: 602,
  },
  "60512": {
    DMA: 602,
  },
  "60513": {
    DMA: 602,
  },
  "60514": {
    DMA: 602,
  },
  "60515": {
    DMA: 602,
  },
  "60516": {
    DMA: 602,
  },
  "60517": {
    DMA: 602,
  },
  "60518": {
    DMA: 602,
  },
  "60519": {
    DMA: 602,
  },
  "60520": {
    DMA: 602,
  },
  "60521": {
    DMA: 602,
  },
  "60522": {
    DMA: 602,
  },
  "60523": {
    DMA: 602,
  },
  "60525": {
    DMA: 602,
  },
  "60526": {
    DMA: 602,
  },
  "60527": {
    DMA: 602,
  },
  "60530": {
    DMA: 610,
  },
  "60531": {
    DMA: 602,
  },
  "60532": {
    DMA: 602,
  },
  "60534": {
    DMA: 602,
  },
  "60536": {
    DMA: 602,
  },
  "60537": {
    DMA: 602,
  },
  "60538": {
    DMA: 602,
  },
  "60539": {
    DMA: 602,
  },
  "60540": {
    DMA: 602,
  },
  "60541": {
    DMA: 602,
  },
  "60542": {
    DMA: 602,
  },
  "60543": {
    DMA: 602,
  },
  "60544": {
    DMA: 602,
  },
  "60545": {
    DMA: 602,
  },
  "60546": {
    DMA: 602,
  },
  "60548": {
    DMA: 602,
  },
  "60549": {
    DMA: 602,
  },
  "60550": {
    DMA: 602,
  },
  "60551": {
    DMA: 602,
  },
  "60552": {
    DMA: 602,
  },
  "60553": {
    DMA: 610,
  },
  "60554": {
    DMA: 602,
  },
  "60555": {
    DMA: 602,
  },
  "60556": {
    DMA: 602,
  },
  "60557": {
    DMA: 602,
  },
  "60558": {
    DMA: 602,
  },
  "60559": {
    DMA: 602,
  },
  "60560": {
    DMA: 602,
  },
  "60561": {
    DMA: 602,
  },
  "60563": {
    DMA: 602,
  },
  "60564": {
    DMA: 602,
  },
  "60565": {
    DMA: 602,
  },
  "60566": {
    DMA: 602,
  },
  "60567": {
    DMA: 602,
  },
  "60568": {
    DMA: 602,
  },
  "60569": {
    DMA: 602,
  },
  "60570": {
    DMA: 602,
  },
  "60572": {
    DMA: 602,
  },
  "60585": {
    DMA: 602,
  },
  "60586": {
    DMA: 602,
  },
  "60597": {
    DMA: 602,
  },
  "60598": {
    DMA: 602,
  },
  "60599": {
    DMA: 602,
  },
  "60601": {
    DMA: 602,
  },
  "60602": {
    DMA: 602,
  },
  "60603": {
    DMA: 602,
  },
  "60604": {
    DMA: 602,
  },
  "60605": {
    DMA: 602,
  },
  "60606": {
    DMA: 602,
  },
  "60607": {
    DMA: 602,
  },
  "60608": {
    DMA: 602,
  },
  "60609": {
    DMA: 602,
  },
  "60610": {
    DMA: 602,
  },
  "60611": {
    DMA: 602,
  },
  "60612": {
    DMA: 602,
  },
  "60613": {
    DMA: 602,
  },
  "60614": {
    DMA: 602,
  },
  "60615": {
    DMA: 602,
  },
  "60616": {
    DMA: 602,
  },
  "60617": {
    DMA: 602,
  },
  "60618": {
    DMA: 602,
  },
  "60619": {
    DMA: 602,
  },
  "60620": {
    DMA: 602,
  },
  "60621": {
    DMA: 602,
  },
  "60622": {
    DMA: 602,
  },
  "60623": {
    DMA: 602,
  },
  "60624": {
    DMA: 602,
  },
  "60625": {
    DMA: 602,
  },
  "60626": {
    DMA: 602,
  },
  "60628": {
    DMA: 602,
  },
  "60629": {
    DMA: 602,
  },
  "60630": {
    DMA: 602,
  },
  "60631": {
    DMA: 602,
  },
  "60632": {
    DMA: 602,
  },
  "60633": {
    DMA: 602,
  },
  "60634": {
    DMA: 602,
  },
  "60636": {
    DMA: 602,
  },
  "60637": {
    DMA: 602,
  },
  "60638": {
    DMA: 602,
  },
  "60639": {
    DMA: 602,
  },
  "60640": {
    DMA: 602,
  },
  "60641": {
    DMA: 602,
  },
  "60642": {
    DMA: 602,
  },
  "60643": {
    DMA: 602,
  },
  "60644": {
    DMA: 602,
  },
  "60645": {
    DMA: 602,
  },
  "60646": {
    DMA: 602,
  },
  "60647": {
    DMA: 602,
  },
  "60649": {
    DMA: 602,
  },
  "60651": {
    DMA: 602,
  },
  "60652": {
    DMA: 602,
  },
  "60653": {
    DMA: 602,
  },
  "60654": {
    DMA: 602,
  },
  "60655": {
    DMA: 602,
  },
  "60656": {
    DMA: 602,
  },
  "60657": {
    DMA: 602,
  },
  "60659": {
    DMA: 602,
  },
  "60660": {
    DMA: 602,
  },
  "60661": {
    DMA: 602,
  },
  "60663": {
    DMA: 602,
  },
  "60664": {
    DMA: 602,
  },
  "60666": {
    DMA: 602,
  },
  "60668": {
    DMA: 602,
  },
  "60669": {
    DMA: 602,
  },
  "60670": {
    DMA: 602,
  },
  "60673": {
    DMA: 602,
  },
  "60674": {
    DMA: 602,
  },
  "60675": {
    DMA: 602,
  },
  "60677": {
    DMA: 602,
  },
  "60678": {
    DMA: 602,
  },
  "60679": {
    DMA: 602,
  },
  "60680": {
    DMA: 602,
  },
  "60681": {
    DMA: 602,
  },
  "60682": {
    DMA: 602,
  },
  "60684": {
    DMA: 602,
  },
  "60685": {
    DMA: 602,
  },
  "60686": {
    DMA: 602,
  },
  "60687": {
    DMA: 602,
  },
  "60688": {
    DMA: 602,
  },
  "60689": {
    DMA: 602,
  },
  "60690": {
    DMA: 602,
  },
  "60691": {
    DMA: 602,
  },
  "60693": {
    DMA: 602,
  },
  "60694": {
    DMA: 602,
  },
  "60695": {
    DMA: 602,
  },
  "60696": {
    DMA: 602,
  },
  "60697": {
    DMA: 602,
  },
  "60699": {
    DMA: 602,
  },
  "60701": {
    DMA: 602,
  },
  "60706": {
    DMA: 602,
  },
  "60707": {
    DMA: 602,
  },
  "60712": {
    DMA: 602,
  },
  "60714": {
    DMA: 602,
  },
  "60803": {
    DMA: 602,
  },
  "60804": {
    DMA: 602,
  },
  "60805": {
    DMA: 602,
  },
  "60827": {
    DMA: 602,
  },
  "60901": {
    DMA: 602,
  },
  "60910": {
    DMA: 602,
  },
  "60911": {
    DMA: 648,
  },
  "60912": {
    DMA: 648,
  },
  "60913": {
    DMA: 602,
  },
  "60914": {
    DMA: 602,
  },
  "60915": {
    DMA: 602,
  },
  "60917": {
    DMA: 602,
  },
  "60918": {
    DMA: 648,
  },
  "60919": {
    DMA: 648,
  },
  "60920": {
    DMA: 675,
  },
  "60921": {
    DMA: 675,
  },
  "60922": {
    DMA: 648,
  },
  "60924": {
    DMA: 648,
  },
  "60926": {
    DMA: 648,
  },
  "60927": {
    DMA: 648,
  },
  "60928": {
    DMA: 648,
  },
  "60929": {
    DMA: 675,
  },
  "60930": {
    DMA: 648,
  },
  "60931": {
    DMA: 648,
  },
  "60932": {
    DMA: 648,
  },
  "60933": {
    DMA: 648,
  },
  "60934": {
    DMA: 675,
  },
  "60935": {
    DMA: 602,
  },
  "60936": {
    DMA: 648,
  },
  "60938": {
    DMA: 648,
  },
  "60939": {
    DMA: 648,
  },
  "60940": {
    DMA: 602,
  },
  "60941": {
    DMA: 602,
  },
  "60942": {
    DMA: 648,
  },
  "60944": {
    DMA: 602,
  },
  "60945": {
    DMA: 648,
  },
  "60946": {
    DMA: 648,
  },
  "60948": {
    DMA: 648,
  },
  "60949": {
    DMA: 648,
  },
  "60950": {
    DMA: 602,
  },
  "60951": {
    DMA: 648,
  },
  "60952": {
    DMA: 648,
  },
  "60953": {
    DMA: 648,
  },
  "60954": {
    DMA: 602,
  },
  "60955": {
    DMA: 648,
  },
  "60956": {
    DMA: 648,
  },
  "60957": {
    DMA: 648,
  },
  "60958": {
    DMA: 602,
  },
  "60959": {
    DMA: 648,
  },
  "60960": {
    DMA: 648,
  },
  "60961": {
    DMA: 602,
  },
  "60962": {
    DMA: 648,
  },
  "60963": {
    DMA: 648,
  },
  "60964": {
    DMA: 602,
  },
  "60966": {
    DMA: 648,
  },
  "60967": {
    DMA: 648,
  },
  "60968": {
    DMA: 648,
  },
  "60969": {
    DMA: 602,
  },
  "60970": {
    DMA: 648,
  },
  "60973": {
    DMA: 648,
  },
  "60974": {
    DMA: 648,
  },
  "61001": {
    DMA: 682,
  },
  "61006": {
    DMA: 610,
  },
  "61007": {
    DMA: 610,
  },
  "61008": {
    DMA: 610,
  },
  "61010": {
    DMA: 610,
  },
  "61011": {
    DMA: 610,
  },
  "61012": {
    DMA: 610,
  },
  "61013": {
    DMA: 610,
  },
  "61014": {
    DMA: 682,
  },
  "61015": {
    DMA: 610,
  },
  "61016": {
    DMA: 610,
  },
  "61018": {
    DMA: 610,
  },
  "61019": {
    DMA: 610,
  },
  "61020": {
    DMA: 610,
  },
  "61021": {
    DMA: 610,
  },
  "61024": {
    DMA: 610,
  },
  "61025": {
    DMA: 682,
  },
  "61027": {
    DMA: 610,
  },
  "61028": {
    DMA: 682,
  },
  "61030": {
    DMA: 610,
  },
  "61031": {
    DMA: 610,
  },
  "61032": {
    DMA: 610,
  },
  "61036": {
    DMA: 682,
  },
  "61037": {
    DMA: 682,
  },
  "61038": {
    DMA: 610,
  },
  "61039": {
    DMA: 610,
  },
  "61041": {
    DMA: 682,
  },
  "61042": {
    DMA: 610,
  },
  "61043": {
    DMA: 610,
  },
  "61044": {
    DMA: 610,
  },
  "61046": {
    DMA: 682,
  },
  "61047": {
    DMA: 610,
  },
  "61048": {
    DMA: 610,
  },
  "61049": {
    DMA: 610,
  },
  "61050": {
    DMA: 610,
  },
  "61051": {
    DMA: 682,
  },
  "61052": {
    DMA: 610,
  },
  "61053": {
    DMA: 682,
  },
  "61054": {
    DMA: 610,
  },
  "61057": {
    DMA: 610,
  },
  "61059": {
    DMA: 682,
  },
  "61060": {
    DMA: 610,
  },
  "61061": {
    DMA: 610,
  },
  "61062": {
    DMA: 610,
  },
  "61063": {
    DMA: 610,
  },
  "61064": {
    DMA: 610,
  },
  "61065": {
    DMA: 610,
  },
  "61067": {
    DMA: 610,
  },
  "61068": {
    DMA: 610,
  },
  "61070": {
    DMA: 610,
  },
  "61071": {
    DMA: 682,
  },
  "61072": {
    DMA: 610,
  },
  "61073": {
    DMA: 610,
  },
  "61074": {
    DMA: 682,
  },
  "61075": {
    DMA: 682,
  },
  "61077": {
    DMA: 610,
  },
  "61078": {
    DMA: 682,
  },
  "61079": {
    DMA: 610,
  },
  "61080": {
    DMA: 610,
  },
  "61081": {
    DMA: 682,
  },
  "61084": {
    DMA: 610,
  },
  "61085": {
    DMA: 682,
  },
  "61087": {
    DMA: 682,
  },
  "61088": {
    DMA: 610,
  },
  "61089": {
    DMA: 610,
  },
  "61091": {
    DMA: 610,
  },
  "61101": {
    DMA: 610,
  },
  "61102": {
    DMA: 610,
  },
  "61103": {
    DMA: 610,
  },
  "61104": {
    DMA: 610,
  },
  "61105": {
    DMA: 610,
  },
  "61106": {
    DMA: 610,
  },
  "61107": {
    DMA: 610,
  },
  "61108": {
    DMA: 610,
  },
  "61109": {
    DMA: 610,
  },
  "61110": {
    DMA: 610,
  },
  "61111": {
    DMA: 610,
  },
  "61112": {
    DMA: 610,
  },
  "61114": {
    DMA: 610,
  },
  "61115": {
    DMA: 610,
  },
  "61125": {
    DMA: 610,
  },
  "61126": {
    DMA: 610,
  },
  "61130": {
    DMA: 610,
  },
  "61131": {
    DMA: 610,
  },
  "61132": {
    DMA: 610,
  },
  "61201": {
    DMA: 682,
  },
  "61204": {
    DMA: 682,
  },
  "61230": {
    DMA: 682,
  },
  "61231": {
    DMA: 682,
  },
  "61232": {
    DMA: 682,
  },
  "61233": {
    DMA: 682,
  },
  "61234": {
    DMA: 682,
  },
  "61235": {
    DMA: 682,
  },
  "61236": {
    DMA: 682,
  },
  "61237": {
    DMA: 682,
  },
  "61238": {
    DMA: 682,
  },
  "61239": {
    DMA: 682,
  },
  "61240": {
    DMA: 682,
  },
  "61241": {
    DMA: 682,
  },
  "61242": {
    DMA: 682,
  },
  "61243": {
    DMA: 682,
  },
  "61244": {
    DMA: 682,
  },
  "61250": {
    DMA: 682,
  },
  "61251": {
    DMA: 682,
  },
  "61252": {
    DMA: 682,
  },
  "61254": {
    DMA: 682,
  },
  "61256": {
    DMA: 682,
  },
  "61257": {
    DMA: 682,
  },
  "61258": {
    DMA: 682,
  },
  "61259": {
    DMA: 682,
  },
  "61260": {
    DMA: 682,
  },
  "61261": {
    DMA: 682,
  },
  "61262": {
    DMA: 682,
  },
  "61263": {
    DMA: 682,
  },
  "61264": {
    DMA: 682,
  },
  "61265": {
    DMA: 682,
  },
  "61266": {
    DMA: 682,
  },
  "61270": {
    DMA: 682,
  },
  "61272": {
    DMA: 682,
  },
  "61273": {
    DMA: 682,
  },
  "61274": {
    DMA: 682,
  },
  "61275": {
    DMA: 682,
  },
  "61276": {
    DMA: 682,
  },
  "61277": {
    DMA: 682,
  },
  "61278": {
    DMA: 682,
  },
  "61279": {
    DMA: 682,
  },
  "61281": {
    DMA: 682,
  },
  "61282": {
    DMA: 682,
  },
  "61283": {
    DMA: 682,
  },
  "61284": {
    DMA: 682,
  },
  "61285": {
    DMA: 682,
  },
  "61299": {
    DMA: 682,
  },
  "61301": {
    DMA: 602,
  },
  "61310": {
    DMA: 610,
  },
  "61311": {
    DMA: 675,
  },
  "61312": {
    DMA: 682,
  },
  "61313": {
    DMA: 675,
  },
  "61314": {
    DMA: 682,
  },
  "61315": {
    DMA: 682,
  },
  "61316": {
    DMA: 602,
  },
  "61317": {
    DMA: 682,
  },
  "61318": {
    DMA: 610,
  },
  "61319": {
    DMA: 675,
  },
  "61320": {
    DMA: 682,
  },
  "61321": {
    DMA: 602,
  },
  "61322": {
    DMA: 682,
  },
  "61323": {
    DMA: 682,
  },
  "61324": {
    DMA: 610,
  },
  "61325": {
    DMA: 602,
  },
  "61326": {
    DMA: 675,
  },
  "61327": {
    DMA: 675,
  },
  "61328": {
    DMA: 682,
  },
  "61329": {
    DMA: 682,
  },
  "61330": {
    DMA: 682,
  },
  "61331": {
    DMA: 610,
  },
  "61332": {
    DMA: 602,
  },
  "61333": {
    DMA: 675,
  },
  "61334": {
    DMA: 602,
  },
  "61335": {
    DMA: 675,
  },
  "61336": {
    DMA: 675,
  },
  "61337": {
    DMA: 682,
  },
  "61338": {
    DMA: 682,
  },
  "61340": {
    DMA: 675,
  },
  "61341": {
    DMA: 602,
  },
  "61342": {
    DMA: 602,
  },
  "61344": {
    DMA: 682,
  },
  "61345": {
    DMA: 682,
  },
  "61346": {
    DMA: 682,
  },
  "61348": {
    DMA: 602,
  },
  "61349": {
    DMA: 682,
  },
  "61350": {
    DMA: 602,
  },
  "61353": {
    DMA: 610,
  },
  "61354": {
    DMA: 602,
  },
  "61356": {
    DMA: 682,
  },
  "61358": {
    DMA: 602,
  },
  "61359": {
    DMA: 682,
  },
  "61360": {
    DMA: 602,
  },
  "61361": {
    DMA: 682,
  },
  "61362": {
    DMA: 682,
  },
  "61363": {
    DMA: 675,
  },
  "61364": {
    DMA: 602,
  },
  "61367": {
    DMA: 610,
  },
  "61368": {
    DMA: 682,
  },
  "61369": {
    DMA: 675,
  },
  "61370": {
    DMA: 602,
  },
  "61371": {
    DMA: 602,
  },
  "61372": {
    DMA: 602,
  },
  "61373": {
    DMA: 602,
  },
  "61374": {
    DMA: 682,
  },
  "61375": {
    DMA: 675,
  },
  "61376": {
    DMA: 682,
  },
  "61377": {
    DMA: 675,
  },
  "61378": {
    DMA: 610,
  },
  "61379": {
    DMA: 682,
  },
  "61401": {
    DMA: 682,
  },
  "61402": {
    DMA: 682,
  },
  "61410": {
    DMA: 682,
  },
  "61411": {
    DMA: 717,
  },
  "61412": {
    DMA: 682,
  },
  "61413": {
    DMA: 682,
  },
  "61414": {
    DMA: 682,
  },
  "61415": {
    DMA: 675,
  },
  "61416": {
    DMA: 717,
  },
  "61417": {
    DMA: 682,
  },
  "61418": {
    DMA: 682,
  },
  "61419": {
    DMA: 682,
  },
  "61420": {
    DMA: 717,
  },
  "61421": {
    DMA: 675,
  },
  "61422": {
    DMA: 717,
  },
  "61423": {
    DMA: 682,
  },
  "61424": {
    DMA: 675,
  },
  "61425": {
    DMA: 682,
  },
  "61426": {
    DMA: 675,
  },
  "61427": {
    DMA: 675,
  },
  "61428": {
    DMA: 682,
  },
  "61430": {
    DMA: 682,
  },
  "61431": {
    DMA: 675,
  },
  "61432": {
    DMA: 675,
  },
  "61433": {
    DMA: 675,
  },
  "61434": {
    DMA: 682,
  },
  "61435": {
    DMA: 682,
  },
  "61436": {
    DMA: 682,
  },
  "61437": {
    DMA: 682,
  },
  "61438": {
    DMA: 717,
  },
  "61439": {
    DMA: 682,
  },
  "61440": {
    DMA: 717,
  },
  "61441": {
    DMA: 675,
  },
  "61442": {
    DMA: 682,
  },
  "61443": {
    DMA: 682,
  },
  "61447": {
    DMA: 682,
  },
  "61448": {
    DMA: 682,
  },
  "61449": {
    DMA: 675,
  },
  "61450": {
    DMA: 717,
  },
  "61451": {
    DMA: 675,
  },
  "61452": {
    DMA: 717,
  },
  "61453": {
    DMA: 682,
  },
  "61454": {
    DMA: 682,
  },
  "61455": {
    DMA: 717,
  },
  "61458": {
    DMA: 682,
  },
  "61459": {
    DMA: 675,
  },
  "61460": {
    DMA: 682,
  },
  "61462": {
    DMA: 682,
  },
  "61465": {
    DMA: 682,
  },
  "61466": {
    DMA: 682,
  },
  "61467": {
    DMA: 682,
  },
  "61468": {
    DMA: 682,
  },
  "61469": {
    DMA: 682,
  },
  "61470": {
    DMA: 717,
  },
  "61471": {
    DMA: 682,
  },
  "61472": {
    DMA: 682,
  },
  "61473": {
    DMA: 682,
  },
  "61474": {
    DMA: 682,
  },
  "61475": {
    DMA: 717,
  },
  "61476": {
    DMA: 682,
  },
  "61477": {
    DMA: 675,
  },
  "61478": {
    DMA: 682,
  },
  "61479": {
    DMA: 675,
  },
  "61480": {
    DMA: 682,
  },
  "61482": {
    DMA: 675,
  },
  "61483": {
    DMA: 675,
  },
  "61484": {
    DMA: 675,
  },
  "61485": {
    DMA: 682,
  },
  "61486": {
    DMA: 682,
  },
  "61488": {
    DMA: 682,
  },
  "61489": {
    DMA: 682,
  },
  "61490": {
    DMA: 682,
  },
  "61491": {
    DMA: 675,
  },
  "61501": {
    DMA: 675,
  },
  "61516": {
    DMA: 675,
  },
  "61517": {
    DMA: 675,
  },
  "61519": {
    DMA: 675,
  },
  "61520": {
    DMA: 675,
  },
  "61523": {
    DMA: 675,
  },
  "61524": {
    DMA: 675,
  },
  "61525": {
    DMA: 675,
  },
  "61526": {
    DMA: 675,
  },
  "61528": {
    DMA: 675,
  },
  "61529": {
    DMA: 675,
  },
  "61530": {
    DMA: 675,
  },
  "61531": {
    DMA: 675,
  },
  "61532": {
    DMA: 675,
  },
  "61533": {
    DMA: 675,
  },
  "61534": {
    DMA: 675,
  },
  "61535": {
    DMA: 675,
  },
  "61536": {
    DMA: 675,
  },
  "61537": {
    DMA: 675,
  },
  "61539": {
    DMA: 675,
  },
  "61540": {
    DMA: 675,
  },
  "61541": {
    DMA: 675,
  },
  "61542": {
    DMA: 675,
  },
  "61543": {
    DMA: 675,
  },
  "61544": {
    DMA: 675,
  },
  "61545": {
    DMA: 675,
  },
  "61546": {
    DMA: 675,
  },
  "61547": {
    DMA: 675,
  },
  "61548": {
    DMA: 675,
  },
  "61550": {
    DMA: 675,
  },
  "61552": {
    DMA: 675,
  },
  "61553": {
    DMA: 675,
  },
  "61554": {
    DMA: 675,
  },
  "61555": {
    DMA: 675,
  },
  "61558": {
    DMA: 675,
  },
  "61559": {
    DMA: 675,
  },
  "61560": {
    DMA: 675,
  },
  "61561": {
    DMA: 675,
  },
  "61562": {
    DMA: 675,
  },
  "61563": {
    DMA: 675,
  },
  "61564": {
    DMA: 675,
  },
  "61565": {
    DMA: 675,
  },
  "61567": {
    DMA: 675,
  },
  "61568": {
    DMA: 675,
  },
  "61569": {
    DMA: 675,
  },
  "61570": {
    DMA: 675,
  },
  "61571": {
    DMA: 675,
  },
  "61572": {
    DMA: 682,
  },
  "61601": {
    DMA: 675,
  },
  "61602": {
    DMA: 675,
  },
  "61603": {
    DMA: 675,
  },
  "61604": {
    DMA: 675,
  },
  "61605": {
    DMA: 675,
  },
  "61606": {
    DMA: 675,
  },
  "61607": {
    DMA: 675,
  },
  "61610": {
    DMA: 675,
  },
  "61611": {
    DMA: 675,
  },
  "61612": {
    DMA: 675,
  },
  "61613": {
    DMA: 675,
  },
  "61614": {
    DMA: 675,
  },
  "61615": {
    DMA: 675,
  },
  "61616": {
    DMA: 675,
  },
  "61625": {
    DMA: 675,
  },
  "61629": {
    DMA: 675,
  },
  "61630": {
    DMA: 675,
  },
  "61633": {
    DMA: 675,
  },
  "61634": {
    DMA: 675,
  },
  "61635": {
    DMA: 675,
  },
  "61636": {
    DMA: 675,
  },
  "61637": {
    DMA: 675,
  },
  "61638": {
    DMA: 675,
  },
  "61639": {
    DMA: 675,
  },
  "61641": {
    DMA: 675,
  },
  "61643": {
    DMA: 675,
  },
  "61650": {
    DMA: 675,
  },
  "61651": {
    DMA: 675,
  },
  "61652": {
    DMA: 675,
  },
  "61653": {
    DMA: 675,
  },
  "61654": {
    DMA: 675,
  },
  "61655": {
    DMA: 675,
  },
  "61656": {
    DMA: 675,
  },
  "61701": {
    DMA: 675,
  },
  "61702": {
    DMA: 675,
  },
  "61704": {
    DMA: 675,
  },
  "61705": {
    DMA: 675,
  },
  "61709": {
    DMA: 675,
  },
  "61710": {
    DMA: 675,
  },
  "61720": {
    DMA: 675,
  },
  "61721": {
    DMA: 675,
  },
  "61722": {
    DMA: 675,
  },
  "61723": {
    DMA: 648,
  },
  "61724": {
    DMA: 675,
  },
  "61725": {
    DMA: 675,
  },
  "61726": {
    DMA: 675,
  },
  "61727": {
    DMA: 648,
  },
  "61728": {
    DMA: 675,
  },
  "61729": {
    DMA: 675,
  },
  "61730": {
    DMA: 675,
  },
  "61731": {
    DMA: 675,
  },
  "61732": {
    DMA: 675,
  },
  "61733": {
    DMA: 675,
  },
  "61734": {
    DMA: 675,
  },
  "61735": {
    DMA: 648,
  },
  "61736": {
    DMA: 675,
  },
  "61737": {
    DMA: 675,
  },
  "61738": {
    DMA: 675,
  },
  "61739": {
    DMA: 675,
  },
  "61740": {
    DMA: 675,
  },
  "61741": {
    DMA: 675,
  },
  "61742": {
    DMA: 675,
  },
  "61743": {
    DMA: 675,
  },
  "61744": {
    DMA: 675,
  },
  "61745": {
    DMA: 675,
  },
  "61747": {
    DMA: 675,
  },
  "61748": {
    DMA: 675,
  },
  "61749": {
    DMA: 648,
  },
  "61750": {
    DMA: 648,
  },
  "61751": {
    DMA: 648,
  },
  "61752": {
    DMA: 675,
  },
  "61753": {
    DMA: 675,
  },
  "61754": {
    DMA: 675,
  },
  "61755": {
    DMA: 675,
  },
  "61756": {
    DMA: 648,
  },
  "61758": {
    DMA: 675,
  },
  "61759": {
    DMA: 675,
  },
  "61760": {
    DMA: 675,
  },
  "61761": {
    DMA: 675,
  },
  "61764": {
    DMA: 675,
  },
  "61769": {
    DMA: 675,
  },
  "61770": {
    DMA: 675,
  },
  "61771": {
    DMA: 675,
  },
  "61772": {
    DMA: 675,
  },
  "61773": {
    DMA: 648,
  },
  "61774": {
    DMA: 675,
  },
  "61775": {
    DMA: 675,
  },
  "61776": {
    DMA: 675,
  },
  "61777": {
    DMA: 648,
  },
  "61778": {
    DMA: 648,
  },
  "61790": {
    DMA: 675,
  },
  "61791": {
    DMA: 675,
  },
  "61799": {
    DMA: 675,
  },
  "61801": {
    DMA: 648,
  },
  "61802": {
    DMA: 648,
  },
  "61803": {
    DMA: 648,
  },
  "61810": {
    DMA: 648,
  },
  "61811": {
    DMA: 648,
  },
  "61812": {
    DMA: 648,
  },
  "61813": {
    DMA: 648,
  },
  "61814": {
    DMA: 648,
  },
  "61815": {
    DMA: 648,
  },
  "61816": {
    DMA: 648,
  },
  "61817": {
    DMA: 648,
  },
  "61818": {
    DMA: 648,
  },
  "61820": {
    DMA: 648,
  },
  "61821": {
    DMA: 648,
  },
  "61822": {
    DMA: 648,
  },
  "61824": {
    DMA: 648,
  },
  "61825": {
    DMA: 648,
  },
  "61826": {
    DMA: 648,
  },
  "61830": {
    DMA: 648,
  },
  "61831": {
    DMA: 648,
  },
  "61832": {
    DMA: 648,
  },
  "61833": {
    DMA: 648,
  },
  "61834": {
    DMA: 648,
  },
  "61839": {
    DMA: 648,
  },
  "61840": {
    DMA: 648,
  },
  "61841": {
    DMA: 648,
  },
  "61842": {
    DMA: 648,
  },
  "61843": {
    DMA: 648,
  },
  "61844": {
    DMA: 648,
  },
  "61845": {
    DMA: 648,
  },
  "61846": {
    DMA: 648,
  },
  "61847": {
    DMA: 648,
  },
  "61848": {
    DMA: 648,
  },
  "61849": {
    DMA: 648,
  },
  "61850": {
    DMA: 648,
  },
  "61851": {
    DMA: 648,
  },
  "61852": {
    DMA: 648,
  },
  "61853": {
    DMA: 648,
  },
  "61854": {
    DMA: 648,
  },
  "61855": {
    DMA: 648,
  },
  "61856": {
    DMA: 648,
  },
  "61857": {
    DMA: 648,
  },
  "61858": {
    DMA: 648,
  },
  "61859": {
    DMA: 648,
  },
  "61862": {
    DMA: 648,
  },
  "61863": {
    DMA: 648,
  },
  "61864": {
    DMA: 648,
  },
  "61865": {
    DMA: 648,
  },
  "61866": {
    DMA: 648,
  },
  "61870": {
    DMA: 648,
  },
  "61871": {
    DMA: 648,
  },
  "61872": {
    DMA: 648,
  },
  "61873": {
    DMA: 648,
  },
  "61874": {
    DMA: 648,
  },
  "61875": {
    DMA: 648,
  },
  "61876": {
    DMA: 648,
  },
  "61877": {
    DMA: 648,
  },
  "61878": {
    DMA: 648,
  },
  "61880": {
    DMA: 648,
  },
  "61882": {
    DMA: 648,
  },
  "61883": {
    DMA: 648,
  },
  "61884": {
    DMA: 648,
  },
  "61910": {
    DMA: 648,
  },
  "61911": {
    DMA: 648,
  },
  "61912": {
    DMA: 648,
  },
  "61913": {
    DMA: 648,
  },
  "61914": {
    DMA: 648,
  },
  "61917": {
    DMA: 648,
  },
  "61919": {
    DMA: 648,
  },
  "61920": {
    DMA: 648,
  },
  "61924": {
    DMA: 648,
  },
  "61925": {
    DMA: 648,
  },
  "61928": {
    DMA: 648,
  },
  "61929": {
    DMA: 648,
  },
  "61930": {
    DMA: 648,
  },
  "61931": {
    DMA: 648,
  },
  "61932": {
    DMA: 648,
  },
  "61933": {
    DMA: 648,
  },
  "61936": {
    DMA: 648,
  },
  "61937": {
    DMA: 648,
  },
  "61938": {
    DMA: 648,
  },
  "61940": {
    DMA: 648,
  },
  "61941": {
    DMA: 648,
  },
  "61942": {
    DMA: 648,
  },
  "61943": {
    DMA: 648,
  },
  "61944": {
    DMA: 648,
  },
  "61949": {
    DMA: 648,
  },
  "61951": {
    DMA: 648,
  },
  "61953": {
    DMA: 648,
  },
  "61955": {
    DMA: 648,
  },
  "61956": {
    DMA: 648,
  },
  "61957": {
    DMA: 648,
  },
  "62001": {
    DMA: 609,
  },
  "62002": {
    DMA: 609,
  },
  "62006": {
    DMA: 609,
  },
  "62009": {
    DMA: 609,
  },
  "62010": {
    DMA: 609,
  },
  "62011": {
    DMA: 609,
  },
  "62012": {
    DMA: 609,
  },
  "62013": {
    DMA: 609,
  },
  "62014": {
    DMA: 609,
  },
  "62015": {
    DMA: 609,
  },
  "62016": {
    DMA: 609,
  },
  "62017": {
    DMA: 609,
  },
  "62018": {
    DMA: 609,
  },
  "62019": {
    DMA: 609,
  },
  "62021": {
    DMA: 609,
  },
  "62022": {
    DMA: 609,
  },
  "62023": {
    DMA: 609,
  },
  "62024": {
    DMA: 609,
  },
  "62025": {
    DMA: 609,
  },
  "62026": {
    DMA: 609,
  },
  "62027": {
    DMA: 609,
  },
  "62028": {
    DMA: 609,
  },
  "62030": {
    DMA: 609,
  },
  "62031": {
    DMA: 609,
  },
  "62032": {
    DMA: 609,
  },
  "62033": {
    DMA: 609,
  },
  "62034": {
    DMA: 609,
  },
  "62035": {
    DMA: 609,
  },
  "62036": {
    DMA: 609,
  },
  "62037": {
    DMA: 609,
  },
  "62040": {
    DMA: 609,
  },
  "62044": {
    DMA: 609,
  },
  "62045": {
    DMA: 609,
  },
  "62046": {
    DMA: 609,
  },
  "62047": {
    DMA: 609,
  },
  "62048": {
    DMA: 609,
  },
  "62049": {
    DMA: 609,
  },
  "62050": {
    DMA: 609,
  },
  "62051": {
    DMA: 609,
  },
  "62052": {
    DMA: 609,
  },
  "62053": {
    DMA: 609,
  },
  "62054": {
    DMA: 609,
  },
  "62056": {
    DMA: 609,
  },
  "62058": {
    DMA: 609,
  },
  "62059": {
    DMA: 609,
  },
  "62060": {
    DMA: 609,
  },
  "62061": {
    DMA: 609,
  },
  "62062": {
    DMA: 609,
  },
  "62063": {
    DMA: 609,
  },
  "62065": {
    DMA: 609,
  },
  "62067": {
    DMA: 609,
  },
  "62069": {
    DMA: 609,
  },
  "62070": {
    DMA: 609,
  },
  "62071": {
    DMA: 609,
  },
  "62074": {
    DMA: 609,
  },
  "62075": {
    DMA: 609,
  },
  "62076": {
    DMA: 609,
  },
  "62077": {
    DMA: 609,
  },
  "62078": {
    DMA: 609,
  },
  "62079": {
    DMA: 609,
  },
  "62080": {
    DMA: 609,
  },
  "62081": {
    DMA: 609,
  },
  "62082": {
    DMA: 609,
  },
  "62083": {
    DMA: 648,
  },
  "62084": {
    DMA: 609,
  },
  "62085": {
    DMA: 609,
  },
  "62086": {
    DMA: 609,
  },
  "62087": {
    DMA: 609,
  },
  "62088": {
    DMA: 609,
  },
  "62089": {
    DMA: 609,
  },
  "62090": {
    DMA: 609,
  },
  "62091": {
    DMA: 609,
  },
  "62092": {
    DMA: 609,
  },
  "62093": {
    DMA: 609,
  },
  "62094": {
    DMA: 609,
  },
  "62095": {
    DMA: 609,
  },
  "62097": {
    DMA: 609,
  },
  "62098": {
    DMA: 609,
  },
  "62201": {
    DMA: 609,
  },
  "62202": {
    DMA: 609,
  },
  "62203": {
    DMA: 609,
  },
  "62204": {
    DMA: 609,
  },
  "62205": {
    DMA: 609,
  },
  "62206": {
    DMA: 609,
  },
  "62207": {
    DMA: 609,
  },
  "62208": {
    DMA: 609,
  },
  "62214": {
    DMA: 609,
  },
  "62215": {
    DMA: 609,
  },
  "62216": {
    DMA: 609,
  },
  "62217": {
    DMA: 609,
  },
  "62218": {
    DMA: 609,
  },
  "62219": {
    DMA: 609,
  },
  "62220": {
    DMA: 609,
  },
  "62221": {
    DMA: 609,
  },
  "62222": {
    DMA: 609,
  },
  "62223": {
    DMA: 609,
  },
  "62224": {
    DMA: 609,
  },
  "62225": {
    DMA: 609,
  },
  "62226": {
    DMA: 609,
  },
  "62230": {
    DMA: 609,
  },
  "62231": {
    DMA: 609,
  },
  "62232": {
    DMA: 609,
  },
  "62233": {
    DMA: 609,
  },
  "62234": {
    DMA: 609,
  },
  "62236": {
    DMA: 609,
  },
  "62237": {
    DMA: 609,
  },
  "62238": {
    DMA: 632,
  },
  "62239": {
    DMA: 609,
  },
  "62240": {
    DMA: 609,
  },
  "62241": {
    DMA: 609,
  },
  "62242": {
    DMA: 609,
  },
  "62243": {
    DMA: 609,
  },
  "62244": {
    DMA: 609,
  },
  "62245": {
    DMA: 609,
  },
  "62246": {
    DMA: 609,
  },
  "62247": {
    DMA: 609,
  },
  "62248": {
    DMA: 609,
  },
  "62249": {
    DMA: 609,
  },
  "62250": {
    DMA: 609,
  },
  "62252": {
    DMA: 609,
  },
  "62253": {
    DMA: 609,
  },
  "62254": {
    DMA: 609,
  },
  "62255": {
    DMA: 609,
  },
  "62256": {
    DMA: 609,
  },
  "62257": {
    DMA: 609,
  },
  "62258": {
    DMA: 609,
  },
  "62259": {
    DMA: 609,
  },
  "62260": {
    DMA: 609,
  },
  "62261": {
    DMA: 609,
  },
  "62262": {
    DMA: 609,
  },
  "62263": {
    DMA: 609,
  },
  "62264": {
    DMA: 609,
  },
  "62265": {
    DMA: 609,
  },
  "62266": {
    DMA: 609,
  },
  "62268": {
    DMA: 609,
  },
  "62269": {
    DMA: 609,
  },
  "62271": {
    DMA: 609,
  },
  "62272": {
    DMA: 609,
  },
  "62273": {
    DMA: 609,
  },
  "62274": {
    DMA: 632,
  },
  "62275": {
    DMA: 609,
  },
  "62277": {
    DMA: 609,
  },
  "62278": {
    DMA: 609,
  },
  "62279": {
    DMA: 609,
  },
  "62280": {
    DMA: 609,
  },
  "62281": {
    DMA: 609,
  },
  "62282": {
    DMA: 609,
  },
  "62284": {
    DMA: 609,
  },
  "62285": {
    DMA: 609,
  },
  "62286": {
    DMA: 609,
  },
  "62288": {
    DMA: 609,
  },
  "62289": {
    DMA: 609,
  },
  "62292": {
    DMA: 609,
  },
  "62293": {
    DMA: 609,
  },
  "62294": {
    DMA: 609,
  },
  "62295": {
    DMA: 609,
  },
  "62297": {
    DMA: 609,
  },
  "62298": {
    DMA: 609,
  },
  "62301": {
    DMA: 717,
  },
  "62305": {
    DMA: 717,
  },
  "62306": {
    DMA: 717,
  },
  "62311": {
    DMA: 717,
  },
  "62312": {
    DMA: 717,
  },
  "62313": {
    DMA: 717,
  },
  "62314": {
    DMA: 717,
  },
  "62316": {
    DMA: 717,
  },
  "62319": {
    DMA: 717,
  },
  "62320": {
    DMA: 717,
  },
  "62321": {
    DMA: 717,
  },
  "62323": {
    DMA: 717,
  },
  "62324": {
    DMA: 717,
  },
  "62325": {
    DMA: 717,
  },
  "62326": {
    DMA: 717,
  },
  "62329": {
    DMA: 717,
  },
  "62330": {
    DMA: 717,
  },
  "62334": {
    DMA: 717,
  },
  "62336": {
    DMA: 717,
  },
  "62338": {
    DMA: 717,
  },
  "62339": {
    DMA: 717,
  },
  "62340": {
    DMA: 717,
  },
  "62341": {
    DMA: 717,
  },
  "62343": {
    DMA: 717,
  },
  "62344": {
    DMA: 717,
  },
  "62345": {
    DMA: 717,
  },
  "62346": {
    DMA: 717,
  },
  "62347": {
    DMA: 717,
  },
  "62348": {
    DMA: 717,
  },
  "62349": {
    DMA: 717,
  },
  "62351": {
    DMA: 717,
  },
  "62352": {
    DMA: 717,
  },
  "62353": {
    DMA: 717,
  },
  "62354": {
    DMA: 717,
  },
  "62355": {
    DMA: 717,
  },
  "62356": {
    DMA: 717,
  },
  "62357": {
    DMA: 717,
  },
  "62358": {
    DMA: 717,
  },
  "62359": {
    DMA: 717,
  },
  "62360": {
    DMA: 717,
  },
  "62361": {
    DMA: 717,
  },
  "62362": {
    DMA: 717,
  },
  "62363": {
    DMA: 717,
  },
  "62365": {
    DMA: 717,
  },
  "62366": {
    DMA: 717,
  },
  "62367": {
    DMA: 717,
  },
  "62370": {
    DMA: 717,
  },
  "62373": {
    DMA: 717,
  },
  "62374": {
    DMA: 717,
  },
  "62375": {
    DMA: 717,
  },
  "62376": {
    DMA: 717,
  },
  "62378": {
    DMA: 717,
  },
  "62379": {
    DMA: 717,
  },
  "62380": {
    DMA: 717,
  },
  "62401": {
    DMA: 648,
  },
  "62410": {
    DMA: 649,
  },
  "62411": {
    DMA: 648,
  },
  "62413": {
    DMA: 581,
  },
  "62414": {
    DMA: 648,
  },
  "62417": {
    DMA: 581,
  },
  "62418": {
    DMA: 609,
  },
  "62419": {
    DMA: 581,
  },
  "62420": {
    DMA: 581,
  },
  "62421": {
    DMA: 581,
  },
  "62422": {
    DMA: 648,
  },
  "62423": {
    DMA: 581,
  },
  "62424": {
    DMA: 648,
  },
  "62425": {
    DMA: 581,
  },
  "62426": {
    DMA: 648,
  },
  "62427": {
    DMA: 581,
  },
  "62428": {
    DMA: 648,
  },
  "62431": {
    DMA: 648,
  },
  "62432": {
    DMA: 581,
  },
  "62433": {
    DMA: 581,
  },
  "62434": {
    DMA: 609,
  },
  "62435": {
    DMA: 648,
  },
  "62436": {
    DMA: 648,
  },
  "62438": {
    DMA: 648,
  },
  "62439": {
    DMA: 581,
  },
  "62440": {
    DMA: 648,
  },
  "62441": {
    DMA: 581,
  },
  "62442": {
    DMA: 581,
  },
  "62443": {
    DMA: 648,
  },
  "62444": {
    DMA: 648,
  },
  "62445": {
    DMA: 648,
  },
  "62446": {
    DMA: 649,
  },
  "62447": {
    DMA: 648,
  },
  "62448": {
    DMA: 581,
  },
  "62449": {
    DMA: 581,
  },
  "62450": {
    DMA: 581,
  },
  "62451": {
    DMA: 581,
  },
  "62452": {
    DMA: 581,
  },
  "62454": {
    DMA: 581,
  },
  "62458": {
    DMA: 609,
  },
  "62459": {
    DMA: 581,
  },
  "62460": {
    DMA: 581,
  },
  "62461": {
    DMA: 648,
  },
  "62462": {
    DMA: 648,
  },
  "62463": {
    DMA: 648,
  },
  "62464": {
    DMA: 581,
  },
  "62465": {
    DMA: 648,
  },
  "62466": {
    DMA: 581,
  },
  "62467": {
    DMA: 648,
  },
  "62468": {
    DMA: 648,
  },
  "62469": {
    DMA: 648,
  },
  "62471": {
    DMA: 609,
  },
  "62473": {
    DMA: 648,
  },
  "62474": {
    DMA: 581,
  },
  "62475": {
    DMA: 581,
  },
  "62476": {
    DMA: 649,
  },
  "62477": {
    DMA: 581,
  },
  "62478": {
    DMA: 581,
  },
  "62479": {
    DMA: 581,
  },
  "62480": {
    DMA: 581,
  },
  "62481": {
    DMA: 581,
  },
  "62501": {
    DMA: 648,
  },
  "62510": {
    DMA: 648,
  },
  "62512": {
    DMA: 648,
  },
  "62513": {
    DMA: 648,
  },
  "62514": {
    DMA: 648,
  },
  "62515": {
    DMA: 648,
  },
  "62517": {
    DMA: 648,
  },
  "62518": {
    DMA: 648,
  },
  "62519": {
    DMA: 648,
  },
  "62520": {
    DMA: 648,
  },
  "62521": {
    DMA: 648,
  },
  "62522": {
    DMA: 648,
  },
  "62523": {
    DMA: 648,
  },
  "62524": {
    DMA: 648,
  },
  "62525": {
    DMA: 648,
  },
  "62526": {
    DMA: 648,
  },
  "62530": {
    DMA: 648,
  },
  "62531": {
    DMA: 648,
  },
  "62532": {
    DMA: 648,
  },
  "62533": {
    DMA: 609,
  },
  "62534": {
    DMA: 648,
  },
  "62535": {
    DMA: 648,
  },
  "62536": {
    DMA: 648,
  },
  "62537": {
    DMA: 648,
  },
  "62538": {
    DMA: 609,
  },
  "62539": {
    DMA: 648,
  },
  "62540": {
    DMA: 648,
  },
  "62541": {
    DMA: 648,
  },
  "62543": {
    DMA: 648,
  },
  "62544": {
    DMA: 648,
  },
  "62545": {
    DMA: 648,
  },
  "62546": {
    DMA: 648,
  },
  "62547": {
    DMA: 648,
  },
  "62548": {
    DMA: 648,
  },
  "62549": {
    DMA: 648,
  },
  "62550": {
    DMA: 648,
  },
  "62551": {
    DMA: 648,
  },
  "62553": {
    DMA: 648,
  },
  "62554": {
    DMA: 648,
  },
  "62555": {
    DMA: 648,
  },
  "62556": {
    DMA: 648,
  },
  "62557": {
    DMA: 648,
  },
  "62558": {
    DMA: 648,
  },
  "62560": {
    DMA: 609,
  },
  "62561": {
    DMA: 648,
  },
  "62563": {
    DMA: 648,
  },
  "62565": {
    DMA: 648,
  },
  "62567": {
    DMA: 648,
  },
  "62568": {
    DMA: 648,
  },
  "62570": {
    DMA: 648,
  },
  "62571": {
    DMA: 648,
  },
  "62572": {
    DMA: 609,
  },
  "62573": {
    DMA: 648,
  },
  "62601": {
    DMA: 648,
  },
  "62610": {
    DMA: 717,
  },
  "62611": {
    DMA: 648,
  },
  "62612": {
    DMA: 648,
  },
  "62613": {
    DMA: 648,
  },
  "62615": {
    DMA: 648,
  },
  "62617": {
    DMA: 675,
  },
  "62618": {
    DMA: 648,
  },
  "62621": {
    DMA: 717,
  },
  "62622": {
    DMA: 648,
  },
  "62624": {
    DMA: 717,
  },
  "62625": {
    DMA: 648,
  },
  "62626": {
    DMA: 609,
  },
  "62627": {
    DMA: 648,
  },
  "62628": {
    DMA: 648,
  },
  "62629": {
    DMA: 648,
  },
  "62630": {
    DMA: 609,
  },
  "62631": {
    DMA: 648,
  },
  "62633": {
    DMA: 675,
  },
  "62634": {
    DMA: 648,
  },
  "62635": {
    DMA: 648,
  },
  "62638": {
    DMA: 648,
  },
  "62639": {
    DMA: 717,
  },
  "62640": {
    DMA: 609,
  },
  "62642": {
    DMA: 648,
  },
  "62643": {
    DMA: 648,
  },
  "62644": {
    DMA: 675,
  },
  "62649": {
    DMA: 609,
  },
  "62650": {
    DMA: 648,
  },
  "62651": {
    DMA: 648,
  },
  "62655": {
    DMA: 675,
  },
  "62656": {
    DMA: 648,
  },
  "62659": {
    DMA: 648,
  },
  "62660": {
    DMA: 648,
  },
  "62661": {
    DMA: 648,
  },
  "62662": {
    DMA: 648,
  },
  "62663": {
    DMA: 717,
  },
  "62664": {
    DMA: 675,
  },
  "62665": {
    DMA: 648,
  },
  "62666": {
    DMA: 648,
  },
  "62667": {
    DMA: 609,
  },
  "62668": {
    DMA: 648,
  },
  "62670": {
    DMA: 648,
  },
  "62671": {
    DMA: 648,
  },
  "62672": {
    DMA: 609,
  },
  "62673": {
    DMA: 648,
  },
  "62674": {
    DMA: 609,
  },
  "62675": {
    DMA: 648,
  },
  "62677": {
    DMA: 648,
  },
  "62681": {
    DMA: 717,
  },
  "62682": {
    DMA: 675,
  },
  "62683": {
    DMA: 609,
  },
  "62684": {
    DMA: 648,
  },
  "62685": {
    DMA: 609,
  },
  "62688": {
    DMA: 648,
  },
  "62689": {
    DMA: 648,
  },
  "62690": {
    DMA: 609,
  },
  "62691": {
    DMA: 648,
  },
  "62692": {
    DMA: 648,
  },
  "62693": {
    DMA: 648,
  },
  "62694": {
    DMA: 717,
  },
  "62695": {
    DMA: 648,
  },
  "62701": {
    DMA: 648,
  },
  "62702": {
    DMA: 648,
  },
  "62703": {
    DMA: 648,
  },
  "62704": {
    DMA: 648,
  },
  "62705": {
    DMA: 648,
  },
  "62706": {
    DMA: 648,
  },
  "62707": {
    DMA: 648,
  },
  "62708": {
    DMA: 648,
  },
  "62711": {
    DMA: 648,
  },
  "62712": {
    DMA: 648,
  },
  "62713": {
    DMA: 648,
  },
  "62715": {
    DMA: 648,
  },
  "62716": {
    DMA: 648,
  },
  "62719": {
    DMA: 648,
  },
  "62721": {
    DMA: 648,
  },
  "62722": {
    DMA: 648,
  },
  "62723": {
    DMA: 648,
  },
  "62726": {
    DMA: 648,
  },
  "62736": {
    DMA: 648,
  },
  "62739": {
    DMA: 648,
  },
  "62746": {
    DMA: 648,
  },
  "62756": {
    DMA: 648,
  },
  "62757": {
    DMA: 648,
  },
  "62761": {
    DMA: 648,
  },
  "62762": {
    DMA: 648,
  },
  "62763": {
    DMA: 648,
  },
  "62764": {
    DMA: 648,
  },
  "62765": {
    DMA: 648,
  },
  "62766": {
    DMA: 648,
  },
  "62767": {
    DMA: 648,
  },
  "62769": {
    DMA: 648,
  },
  "62776": {
    DMA: 648,
  },
  "62777": {
    DMA: 648,
  },
  "62781": {
    DMA: 648,
  },
  "62786": {
    DMA: 648,
  },
  "62791": {
    DMA: 648,
  },
  "62794": {
    DMA: 648,
  },
  "62796": {
    DMA: 648,
  },
  "62801": {
    DMA: 609,
  },
  "62803": {
    DMA: 609,
  },
  "62805": {
    DMA: 632,
  },
  "62806": {
    DMA: 649,
  },
  "62807": {
    DMA: 609,
  },
  "62808": {
    DMA: 609,
  },
  "62809": {
    DMA: 649,
  },
  "62810": {
    DMA: 632,
  },
  "62811": {
    DMA: 649,
  },
  "62812": {
    DMA: 632,
  },
  "62814": {
    DMA: 632,
  },
  "62815": {
    DMA: 649,
  },
  "62816": {
    DMA: 632,
  },
  "62817": {
    DMA: 632,
  },
  "62818": {
    DMA: 649,
  },
  "62819": {
    DMA: 632,
  },
  "62820": {
    DMA: 649,
  },
  "62821": {
    DMA: 649,
  },
  "62822": {
    DMA: 632,
  },
  "62823": {
    DMA: 649,
  },
  "62824": {
    DMA: 609,
  },
  "62825": {
    DMA: 632,
  },
  "62827": {
    DMA: 649,
  },
  "62828": {
    DMA: 632,
  },
  "62829": {
    DMA: 632,
  },
  "62830": {
    DMA: 632,
  },
  "62831": {
    DMA: 609,
  },
  "62832": {
    DMA: 632,
  },
  "62833": {
    DMA: 649,
  },
  "62834": {
    DMA: 649,
  },
  "62835": {
    DMA: 649,
  },
  "62836": {
    DMA: 632,
  },
  "62837": {
    DMA: 649,
  },
  "62838": {
    DMA: 609,
  },
  "62839": {
    DMA: 609,
  },
  "62840": {
    DMA: 632,
  },
  "62841": {
    DMA: 632,
  },
  "62842": {
    DMA: 649,
  },
  "62843": {
    DMA: 649,
  },
  "62844": {
    DMA: 649,
  },
  "62846": {
    DMA: 632,
  },
  "62848": {
    DMA: 609,
  },
  "62849": {
    DMA: 609,
  },
  "62850": {
    DMA: 649,
  },
  "62851": {
    DMA: 649,
  },
  "62852": {
    DMA: 649,
  },
  "62853": {
    DMA: 609,
  },
  "62854": {
    DMA: 609,
  },
  "62855": {
    DMA: 649,
  },
  "62856": {
    DMA: 632,
  },
  "62857": {
    DMA: 609,
  },
  "62858": {
    DMA: 609,
  },
  "62859": {
    DMA: 632,
  },
  "62860": {
    DMA: 632,
  },
  "62861": {
    DMA: 649,
  },
  "62862": {
    DMA: 649,
  },
  "62863": {
    DMA: 649,
  },
  "62864": {
    DMA: 632,
  },
  "62865": {
    DMA: 632,
  },
  "62866": {
    DMA: 632,
  },
  "62867": {
    DMA: 632,
  },
  "62868": {
    DMA: 581,
  },
  "62869": {
    DMA: 649,
  },
  "62870": {
    DMA: 609,
  },
  "62871": {
    DMA: 632,
  },
  "62872": {
    DMA: 632,
  },
  "62874": {
    DMA: 632,
  },
  "62875": {
    DMA: 609,
  },
  "62876": {
    DMA: 609,
  },
  "62877": {
    DMA: 609,
  },
  "62878": {
    DMA: 649,
  },
  "62879": {
    DMA: 609,
  },
  "62880": {
    DMA: 609,
  },
  "62881": {
    DMA: 609,
  },
  "62882": {
    DMA: 609,
  },
  "62883": {
    DMA: 632,
  },
  "62884": {
    DMA: 632,
  },
  "62885": {
    DMA: 609,
  },
  "62886": {
    DMA: 649,
  },
  "62887": {
    DMA: 649,
  },
  "62888": {
    DMA: 632,
  },
  "62889": {
    DMA: 632,
  },
  "62890": {
    DMA: 632,
  },
  "62891": {
    DMA: 632,
  },
  "62892": {
    DMA: 609,
  },
  "62893": {
    DMA: 609,
  },
  "62894": {
    DMA: 632,
  },
  "62895": {
    DMA: 649,
  },
  "62896": {
    DMA: 632,
  },
  "62897": {
    DMA: 632,
  },
  "62898": {
    DMA: 632,
  },
  "62899": {
    DMA: 609,
  },
  "62901": {
    DMA: 632,
  },
  "62902": {
    DMA: 632,
  },
  "62903": {
    DMA: 632,
  },
  "62905": {
    DMA: 632,
  },
  "62906": {
    DMA: 632,
  },
  "62907": {
    DMA: 632,
  },
  "62908": {
    DMA: 632,
  },
  "62909": {
    DMA: 632,
  },
  "62910": {
    DMA: 632,
  },
  "62912": {
    DMA: 632,
  },
  "62914": {
    DMA: 632,
  },
  "62915": {
    DMA: 632,
  },
  "62916": {
    DMA: 632,
  },
  "62917": {
    DMA: 632,
  },
  "62918": {
    DMA: 632,
  },
  "62919": {
    DMA: 632,
  },
  "62920": {
    DMA: 632,
  },
  "62921": {
    DMA: 632,
  },
  "62922": {
    DMA: 632,
  },
  "62923": {
    DMA: 632,
  },
  "62924": {
    DMA: 632,
  },
  "62926": {
    DMA: 632,
  },
  "62927": {
    DMA: 632,
  },
  "62928": {
    DMA: 632,
  },
  "62930": {
    DMA: 632,
  },
  "62931": {
    DMA: 632,
  },
  "62932": {
    DMA: 632,
  },
  "62933": {
    DMA: 632,
  },
  "62934": {
    DMA: 632,
  },
  "62935": {
    DMA: 632,
  },
  "62938": {
    DMA: 632,
  },
  "62939": {
    DMA: 632,
  },
  "62940": {
    DMA: 632,
  },
  "62941": {
    DMA: 632,
  },
  "62942": {
    DMA: 632,
  },
  "62943": {
    DMA: 632,
  },
  "62946": {
    DMA: 632,
  },
  "62947": {
    DMA: 632,
  },
  "62948": {
    DMA: 632,
  },
  "62949": {
    DMA: 632,
  },
  "62950": {
    DMA: 632,
  },
  "62951": {
    DMA: 632,
  },
  "62952": {
    DMA: 632,
  },
  "62953": {
    DMA: 632,
  },
  "62954": {
    DMA: 632,
  },
  "62955": {
    DMA: 632,
  },
  "62956": {
    DMA: 632,
  },
  "62957": {
    DMA: 632,
  },
  "62958": {
    DMA: 632,
  },
  "62959": {
    DMA: 632,
  },
  "62960": {
    DMA: 632,
  },
  "62961": {
    DMA: 632,
  },
  "62962": {
    DMA: 632,
  },
  "62963": {
    DMA: 632,
  },
  "62964": {
    DMA: 632,
  },
  "62965": {
    DMA: 632,
  },
  "62966": {
    DMA: 632,
  },
  "62967": {
    DMA: 632,
  },
  "62969": {
    DMA: 632,
  },
  "62970": {
    DMA: 632,
  },
  "62971": {
    DMA: 632,
  },
  "62972": {
    DMA: 632,
  },
  "62973": {
    DMA: 632,
  },
  "62974": {
    DMA: 632,
  },
  "62975": {
    DMA: 632,
  },
  "62976": {
    DMA: 632,
  },
  "62977": {
    DMA: 632,
  },
  "62979": {
    DMA: 632,
  },
  "62982": {
    DMA: 632,
  },
  "62983": {
    DMA: 632,
  },
  "62984": {
    DMA: 632,
  },
  "62985": {
    DMA: 632,
  },
  "62987": {
    DMA: 632,
  },
  "62988": {
    DMA: 632,
  },
  "62990": {
    DMA: 632,
  },
  "62992": {
    DMA: 632,
  },
  "62993": {
    DMA: 632,
  },
  "62994": {
    DMA: 632,
  },
  "62995": {
    DMA: 632,
  },
  "62996": {
    DMA: 632,
  },
  "62997": {
    DMA: 632,
  },
  "62998": {
    DMA: 632,
  },
  "62999": {
    DMA: 632,
  },
  "63001": {
    DMA: 609,
  },
  "63005": {
    DMA: 609,
  },
  "63006": {
    DMA: 609,
  },
  "63010": {
    DMA: 609,
  },
  "63011": {
    DMA: 609,
  },
  "63012": {
    DMA: 609,
  },
  "63013": {
    DMA: 609,
  },
  "63014": {
    DMA: 609,
  },
  "63015": {
    DMA: 609,
  },
  "63016": {
    DMA: 609,
  },
  "63017": {
    DMA: 609,
  },
  "63019": {
    DMA: 609,
  },
  "63020": {
    DMA: 609,
  },
  "63021": {
    DMA: 609,
  },
  "63022": {
    DMA: 609,
  },
  "63023": {
    DMA: 609,
  },
  "63024": {
    DMA: 609,
  },
  "63025": {
    DMA: 609,
  },
  "63026": {
    DMA: 609,
  },
  "63028": {
    DMA: 609,
  },
  "63030": {
    DMA: 609,
  },
  "63031": {
    DMA: 609,
  },
  "63032": {
    DMA: 609,
  },
  "63033": {
    DMA: 609,
  },
  "63034": {
    DMA: 609,
  },
  "63036": {
    DMA: 609,
  },
  "63037": {
    DMA: 609,
  },
  "63038": {
    DMA: 609,
  },
  "63039": {
    DMA: 609,
  },
  "63040": {
    DMA: 609,
  },
  "63041": {
    DMA: 609,
  },
  "63042": {
    DMA: 609,
  },
  "63043": {
    DMA: 609,
  },
  "63044": {
    DMA: 609,
  },
  "63045": {
    DMA: 609,
  },
  "63047": {
    DMA: 609,
  },
  "63048": {
    DMA: 609,
  },
  "63049": {
    DMA: 609,
  },
  "63050": {
    DMA: 609,
  },
  "63051": {
    DMA: 609,
  },
  "63052": {
    DMA: 609,
  },
  "63053": {
    DMA: 609,
  },
  "63055": {
    DMA: 609,
  },
  "63056": {
    DMA: 609,
  },
  "63057": {
    DMA: 609,
  },
  "63060": {
    DMA: 609,
  },
  "63061": {
    DMA: 609,
  },
  "63065": {
    DMA: 609,
  },
  "63066": {
    DMA: 609,
  },
  "63068": {
    DMA: 609,
  },
  "63069": {
    DMA: 609,
  },
  "63070": {
    DMA: 609,
  },
  "63071": {
    DMA: 609,
  },
  "63072": {
    DMA: 609,
  },
  "63073": {
    DMA: 609,
  },
  "63074": {
    DMA: 609,
  },
  "63077": {
    DMA: 609,
  },
  "63079": {
    DMA: 609,
  },
  "63080": {
    DMA: 609,
  },
  "63084": {
    DMA: 609,
  },
  "63087": {
    DMA: 609,
  },
  "63088": {
    DMA: 609,
  },
  "63089": {
    DMA: 609,
  },
  "63090": {
    DMA: 609,
  },
  "63091": {
    DMA: 609,
  },
  "63099": {
    DMA: 609,
  },
  "63101": {
    DMA: 609,
  },
  "63102": {
    DMA: 609,
  },
  "63103": {
    DMA: 609,
  },
  "63104": {
    DMA: 609,
  },
  "63105": {
    DMA: 609,
  },
  "63106": {
    DMA: 609,
  },
  "63107": {
    DMA: 609,
  },
  "63108": {
    DMA: 609,
  },
  "63109": {
    DMA: 609,
  },
  "63110": {
    DMA: 609,
  },
  "63111": {
    DMA: 609,
  },
  "63112": {
    DMA: 609,
  },
  "63113": {
    DMA: 609,
  },
  "63114": {
    DMA: 609,
  },
  "63115": {
    DMA: 609,
  },
  "63116": {
    DMA: 609,
  },
  "63117": {
    DMA: 609,
  },
  "63118": {
    DMA: 609,
  },
  "63119": {
    DMA: 609,
  },
  "63120": {
    DMA: 609,
  },
  "63121": {
    DMA: 609,
  },
  "63122": {
    DMA: 609,
  },
  "63123": {
    DMA: 609,
  },
  "63124": {
    DMA: 609,
  },
  "63125": {
    DMA: 609,
  },
  "63126": {
    DMA: 609,
  },
  "63127": {
    DMA: 609,
  },
  "63128": {
    DMA: 609,
  },
  "63129": {
    DMA: 609,
  },
  "63130": {
    DMA: 609,
  },
  "63131": {
    DMA: 609,
  },
  "63132": {
    DMA: 609,
  },
  "63133": {
    DMA: 609,
  },
  "63134": {
    DMA: 609,
  },
  "63135": {
    DMA: 609,
  },
  "63136": {
    DMA: 609,
  },
  "63137": {
    DMA: 609,
  },
  "63138": {
    DMA: 609,
  },
  "63139": {
    DMA: 609,
  },
  "63140": {
    DMA: 609,
  },
  "63141": {
    DMA: 609,
  },
  "63143": {
    DMA: 609,
  },
  "63144": {
    DMA: 609,
  },
  "63145": {
    DMA: 609,
  },
  "63146": {
    DMA: 609,
  },
  "63147": {
    DMA: 609,
  },
  "63150": {
    DMA: 609,
  },
  "63151": {
    DMA: 609,
  },
  "63155": {
    DMA: 609,
  },
  "63156": {
    DMA: 609,
  },
  "63157": {
    DMA: 609,
  },
  "63158": {
    DMA: 609,
  },
  "63160": {
    DMA: 609,
  },
  "63163": {
    DMA: 609,
  },
  "63164": {
    DMA: 609,
  },
  "63166": {
    DMA: 609,
  },
  "63167": {
    DMA: 609,
  },
  "63169": {
    DMA: 609,
  },
  "63171": {
    DMA: 609,
  },
  "63177": {
    DMA: 609,
  },
  "63178": {
    DMA: 609,
  },
  "63179": {
    DMA: 609,
  },
  "63180": {
    DMA: 609,
  },
  "63182": {
    DMA: 609,
  },
  "63188": {
    DMA: 609,
  },
  "63190": {
    DMA: 609,
  },
  "63195": {
    DMA: 609,
  },
  "63196": {
    DMA: 609,
  },
  "63197": {
    DMA: 609,
  },
  "63198": {
    DMA: 609,
  },
  "63199": {
    DMA: 609,
  },
  "63301": {
    DMA: 609,
  },
  "63302": {
    DMA: 609,
  },
  "63303": {
    DMA: 609,
  },
  "63304": {
    DMA: 609,
  },
  "63330": {
    DMA: 609,
  },
  "63332": {
    DMA: 609,
  },
  "63333": {
    DMA: 604,
  },
  "63334": {
    DMA: 609,
  },
  "63336": {
    DMA: 609,
  },
  "63338": {
    DMA: 609,
  },
  "63339": {
    DMA: 609,
  },
  "63341": {
    DMA: 609,
  },
  "63342": {
    DMA: 609,
  },
  "63343": {
    DMA: 609,
  },
  "63344": {
    DMA: 609,
  },
  "63345": {
    DMA: 604,
  },
  "63346": {
    DMA: 609,
  },
  "63347": {
    DMA: 609,
  },
  "63348": {
    DMA: 609,
  },
  "63349": {
    DMA: 609,
  },
  "63350": {
    DMA: 604,
  },
  "63351": {
    DMA: 604,
  },
  "63352": {
    DMA: 604,
  },
  "63353": {
    DMA: 609,
  },
  "63357": {
    DMA: 609,
  },
  "63359": {
    DMA: 604,
  },
  "63361": {
    DMA: 604,
  },
  "63362": {
    DMA: 609,
  },
  "63363": {
    DMA: 604,
  },
  "63365": {
    DMA: 609,
  },
  "63366": {
    DMA: 609,
  },
  "63367": {
    DMA: 609,
  },
  "63368": {
    DMA: 609,
  },
  "63369": {
    DMA: 609,
  },
  "63370": {
    DMA: 609,
  },
  "63373": {
    DMA: 609,
  },
  "63376": {
    DMA: 609,
  },
  "63377": {
    DMA: 609,
  },
  "63378": {
    DMA: 609,
  },
  "63379": {
    DMA: 609,
  },
  "63380": {
    DMA: 609,
  },
  "63381": {
    DMA: 609,
  },
  "63382": {
    DMA: 604,
  },
  "63383": {
    DMA: 609,
  },
  "63384": {
    DMA: 604,
  },
  "63385": {
    DMA: 609,
  },
  "63386": {
    DMA: 609,
  },
  "63387": {
    DMA: 609,
  },
  "63388": {
    DMA: 604,
  },
  "63389": {
    DMA: 609,
  },
  "63390": {
    DMA: 609,
  },
  "63401": {
    DMA: 717,
  },
  "63430": {
    DMA: 717,
  },
  "63431": {
    DMA: 631,
  },
  "63432": {
    DMA: 631,
  },
  "63433": {
    DMA: 609,
  },
  "63434": {
    DMA: 717,
  },
  "63435": {
    DMA: 717,
  },
  "63436": {
    DMA: 717,
  },
  "63437": {
    DMA: 717,
  },
  "63438": {
    DMA: 717,
  },
  "63439": {
    DMA: 717,
  },
  "63440": {
    DMA: 717,
  },
  "63441": {
    DMA: 609,
  },
  "63442": {
    DMA: 631,
  },
  "63443": {
    DMA: 717,
  },
  "63445": {
    DMA: 717,
  },
  "63446": {
    DMA: 717,
  },
  "63447": {
    DMA: 717,
  },
  "63448": {
    DMA: 717,
  },
  "63450": {
    DMA: 717,
  },
  "63451": {
    DMA: 717,
  },
  "63452": {
    DMA: 717,
  },
  "63453": {
    DMA: 717,
  },
  "63454": {
    DMA: 717,
  },
  "63456": {
    DMA: 717,
  },
  "63457": {
    DMA: 717,
  },
  "63458": {
    DMA: 717,
  },
  "63459": {
    DMA: 717,
  },
  "63460": {
    DMA: 717,
  },
  "63461": {
    DMA: 717,
  },
  "63462": {
    DMA: 717,
  },
  "63463": {
    DMA: 717,
  },
  "63464": {
    DMA: 717,
  },
  "63465": {
    DMA: 717,
  },
  "63466": {
    DMA: 717,
  },
  "63467": {
    DMA: 717,
  },
  "63468": {
    DMA: 717,
  },
  "63469": {
    DMA: 717,
  },
  "63471": {
    DMA: 717,
  },
  "63472": {
    DMA: 717,
  },
  "63473": {
    DMA: 717,
  },
  "63474": {
    DMA: 717,
  },
  "63501": {
    DMA: 631,
  },
  "63530": {
    DMA: 631,
  },
  "63531": {
    DMA: 717,
  },
  "63532": {
    DMA: 631,
  },
  "63533": {
    DMA: 631,
  },
  "63534": {
    DMA: 631,
  },
  "63535": {
    DMA: 631,
  },
  "63536": {
    DMA: 631,
  },
  "63537": {
    DMA: 717,
  },
  "63538": {
    DMA: 631,
  },
  "63539": {
    DMA: 631,
  },
  "63540": {
    DMA: 631,
  },
  "63541": {
    DMA: 631,
  },
  "63543": {
    DMA: 631,
  },
  "63544": {
    DMA: 631,
  },
  "63545": {
    DMA: 631,
  },
  "63546": {
    DMA: 631,
  },
  "63547": {
    DMA: 717,
  },
  "63548": {
    DMA: 631,
  },
  "63549": {
    DMA: 631,
  },
  "63551": {
    DMA: 631,
  },
  "63552": {
    DMA: 631,
  },
  "63555": {
    DMA: 631,
  },
  "63556": {
    DMA: 631,
  },
  "63557": {
    DMA: 616,
  },
  "63558": {
    DMA: 631,
  },
  "63559": {
    DMA: 631,
  },
  "63560": {
    DMA: 631,
  },
  "63561": {
    DMA: 631,
  },
  "63563": {
    DMA: 631,
  },
  "63565": {
    DMA: 631,
  },
  "63566": {
    DMA: 631,
  },
  "63567": {
    DMA: 631,
  },
  "63601": {
    DMA: 609,
  },
  "63620": {
    DMA: 609,
  },
  "63621": {
    DMA: 609,
  },
  "63622": {
    DMA: 609,
  },
  "63623": {
    DMA: 609,
  },
  "63624": {
    DMA: 609,
  },
  "63625": {
    DMA: 609,
  },
  "63626": {
    DMA: 609,
  },
  "63627": {
    DMA: 609,
  },
  "63628": {
    DMA: 609,
  },
  "63629": {
    DMA: 609,
  },
  "63630": {
    DMA: 609,
  },
  "63631": {
    DMA: 609,
  },
  "63632": {
    DMA: 632,
  },
  "63633": {
    DMA: 609,
  },
  "63636": {
    DMA: 609,
  },
  "63637": {
    DMA: 609,
  },
  "63638": {
    DMA: 609,
  },
  "63640": {
    DMA: 609,
  },
  "63645": {
    DMA: 632,
  },
  "63648": {
    DMA: 609,
  },
  "63650": {
    DMA: 609,
  },
  "63651": {
    DMA: 609,
  },
  "63653": {
    DMA: 609,
  },
  "63654": {
    DMA: 609,
  },
  "63655": {
    DMA: 632,
  },
  "63656": {
    DMA: 609,
  },
  "63660": {
    DMA: 609,
  },
  "63662": {
    DMA: 632,
  },
  "63663": {
    DMA: 609,
  },
  "63664": {
    DMA: 609,
  },
  "63665": {
    DMA: 609,
  },
  "63666": {
    DMA: 609,
  },
  "63670": {
    DMA: 609,
  },
  "63673": {
    DMA: 609,
  },
  "63674": {
    DMA: 609,
  },
  "63675": {
    DMA: 609,
  },
  "63701": {
    DMA: 632,
  },
  "63702": {
    DMA: 632,
  },
  "63703": {
    DMA: 632,
  },
  "63730": {
    DMA: 632,
  },
  "63732": {
    DMA: 632,
  },
  "63735": {
    DMA: 632,
  },
  "63736": {
    DMA: 632,
  },
  "63737": {
    DMA: 632,
  },
  "63738": {
    DMA: 632,
  },
  "63739": {
    DMA: 632,
  },
  "63740": {
    DMA: 632,
  },
  "63742": {
    DMA: 632,
  },
  "63743": {
    DMA: 632,
  },
  "63744": {
    DMA: 632,
  },
  "63745": {
    DMA: 632,
  },
  "63746": {
    DMA: 632,
  },
  "63747": {
    DMA: 632,
  },
  "63748": {
    DMA: 632,
  },
  "63750": {
    DMA: 632,
  },
  "63751": {
    DMA: 632,
  },
  "63752": {
    DMA: 632,
  },
  "63755": {
    DMA: 632,
  },
  "63758": {
    DMA: 632,
  },
  "63760": {
    DMA: 632,
  },
  "63763": {
    DMA: 632,
  },
  "63764": {
    DMA: 632,
  },
  "63766": {
    DMA: 632,
  },
  "63767": {
    DMA: 632,
  },
  "63769": {
    DMA: 632,
  },
  "63770": {
    DMA: 632,
  },
  "63771": {
    DMA: 632,
  },
  "63774": {
    DMA: 632,
  },
  "63775": {
    DMA: 632,
  },
  "63776": {
    DMA: 632,
  },
  "63779": {
    DMA: 632,
  },
  "63780": {
    DMA: 632,
  },
  "63781": {
    DMA: 632,
  },
  "63782": {
    DMA: 632,
  },
  "63783": {
    DMA: 632,
  },
  "63784": {
    DMA: 632,
  },
  "63785": {
    DMA: 632,
  },
  "63787": {
    DMA: 632,
  },
  "63801": {
    DMA: 632,
  },
  "63820": {
    DMA: 632,
  },
  "63821": {
    DMA: 632,
  },
  "63822": {
    DMA: 632,
  },
  "63823": {
    DMA: 632,
  },
  "63824": {
    DMA: 632,
  },
  "63825": {
    DMA: 632,
  },
  "63826": {
    DMA: 640,
  },
  "63827": {
    DMA: 640,
  },
  "63828": {
    DMA: 632,
  },
  "63829": {
    DMA: 632,
  },
  "63830": {
    DMA: 640,
  },
  "63833": {
    DMA: 632,
  },
  "63834": {
    DMA: 632,
  },
  "63837": {
    DMA: 632,
  },
  "63839": {
    DMA: 640,
  },
  "63840": {
    DMA: 640,
  },
  "63841": {
    DMA: 632,
  },
  "63845": {
    DMA: 632,
  },
  "63846": {
    DMA: 632,
  },
  "63847": {
    DMA: 632,
  },
  "63848": {
    DMA: 632,
  },
  "63849": {
    DMA: 640,
  },
  "63850": {
    DMA: 632,
  },
  "63851": {
    DMA: 640,
  },
  "63852": {
    DMA: 632,
  },
  "63853": {
    DMA: 640,
  },
  "63855": {
    DMA: 632,
  },
  "63857": {
    DMA: 632,
  },
  "63860": {
    DMA: 632,
  },
  "63862": {
    DMA: 632,
  },
  "63863": {
    DMA: 632,
  },
  "63866": {
    DMA: 632,
  },
  "63867": {
    DMA: 632,
  },
  "63868": {
    DMA: 632,
  },
  "63869": {
    DMA: 632,
  },
  "63870": {
    DMA: 632,
  },
  "63873": {
    DMA: 632,
  },
  "63874": {
    DMA: 632,
  },
  "63875": {
    DMA: 632,
  },
  "63876": {
    DMA: 632,
  },
  "63877": {
    DMA: 640,
  },
  "63878": {
    DMA: 632,
  },
  "63879": {
    DMA: 640,
  },
  "63880": {
    DMA: 632,
  },
  "63881": {
    DMA: 632,
  },
  "63882": {
    DMA: 632,
  },
  "63901": {
    DMA: 632,
  },
  "63902": {
    DMA: 632,
  },
  "63931": {
    DMA: 632,
  },
  "63932": {
    DMA: 632,
  },
  "63933": {
    DMA: 632,
  },
  "63934": {
    DMA: 632,
  },
  "63935": {
    DMA: 632,
  },
  "63936": {
    DMA: 632,
  },
  "63937": {
    DMA: 632,
  },
  "63938": {
    DMA: 632,
  },
  "63939": {
    DMA: 632,
  },
  "63940": {
    DMA: 632,
  },
  "63941": {
    DMA: 632,
  },
  "63942": {
    DMA: 632,
  },
  "63943": {
    DMA: 632,
  },
  "63944": {
    DMA: 632,
  },
  "63945": {
    DMA: 632,
  },
  "63950": {
    DMA: 632,
  },
  "63951": {
    DMA: 632,
  },
  "63952": {
    DMA: 632,
  },
  "63953": {
    DMA: 632,
  },
  "63954": {
    DMA: 632,
  },
  "63955": {
    DMA: 632,
  },
  "63956": {
    DMA: 632,
  },
  "63957": {
    DMA: 632,
  },
  "63960": {
    DMA: 632,
  },
  "63961": {
    DMA: 632,
  },
  "63962": {
    DMA: 632,
  },
  "63963": {
    DMA: 632,
  },
  "63964": {
    DMA: 632,
  },
  "63965": {
    DMA: 632,
  },
  "63966": {
    DMA: 632,
  },
  "63967": {
    DMA: 632,
  },
  "64001": {
    DMA: 616,
  },
  "64002": {
    DMA: 616,
  },
  "64011": {
    DMA: 616,
  },
  "64012": {
    DMA: 616,
  },
  "64013": {
    DMA: 616,
  },
  "64014": {
    DMA: 616,
  },
  "64015": {
    DMA: 616,
  },
  "64016": {
    DMA: 616,
  },
  "64017": {
    DMA: 616,
  },
  "64018": {
    DMA: 616,
  },
  "64019": {
    DMA: 616,
  },
  "64020": {
    DMA: 616,
  },
  "64021": {
    DMA: 616,
  },
  "64022": {
    DMA: 616,
  },
  "64024": {
    DMA: 616,
  },
  "64028": {
    DMA: 616,
  },
  "64029": {
    DMA: 616,
  },
  "64030": {
    DMA: 616,
  },
  "64034": {
    DMA: 616,
  },
  "64035": {
    DMA: 616,
  },
  "64036": {
    DMA: 616,
  },
  "64037": {
    DMA: 616,
  },
  "64040": {
    DMA: 616,
  },
  "64048": {
    DMA: 616,
  },
  "64050": {
    DMA: 616,
  },
  "64051": {
    DMA: 616,
  },
  "64052": {
    DMA: 616,
  },
  "64053": {
    DMA: 616,
  },
  "64054": {
    DMA: 616,
  },
  "64055": {
    DMA: 616,
  },
  "64056": {
    DMA: 616,
  },
  "64057": {
    DMA: 616,
  },
  "64058": {
    DMA: 616,
  },
  "64060": {
    DMA: 616,
  },
  "64061": {
    DMA: 616,
  },
  "64062": {
    DMA: 616,
  },
  "64063": {
    DMA: 616,
  },
  "64064": {
    DMA: 616,
  },
  "64065": {
    DMA: 616,
  },
  "64066": {
    DMA: 616,
  },
  "64067": {
    DMA: 616,
  },
  "64068": {
    DMA: 616,
  },
  "64069": {
    DMA: 616,
  },
  "64070": {
    DMA: 616,
  },
  "64071": {
    DMA: 616,
  },
  "64072": {
    DMA: 616,
  },
  "64073": {
    DMA: 616,
  },
  "64074": {
    DMA: 616,
  },
  "64075": {
    DMA: 616,
  },
  "64076": {
    DMA: 616,
  },
  "64077": {
    DMA: 616,
  },
  "64078": {
    DMA: 616,
  },
  "64079": {
    DMA: 616,
  },
  "64080": {
    DMA: 616,
  },
  "64081": {
    DMA: 616,
  },
  "64082": {
    DMA: 616,
  },
  "64083": {
    DMA: 616,
  },
  "64084": {
    DMA: 616,
  },
  "64085": {
    DMA: 616,
  },
  "64086": {
    DMA: 616,
  },
  "64088": {
    DMA: 616,
  },
  "64089": {
    DMA: 616,
  },
  "64090": {
    DMA: 616,
  },
  "64092": {
    DMA: 616,
  },
  "64093": {
    DMA: 616,
  },
  "64096": {
    DMA: 616,
  },
  "64097": {
    DMA: 616,
  },
  "64098": {
    DMA: 616,
  },
  "64101": {
    DMA: 616,
  },
  "64102": {
    DMA: 616,
  },
  "64105": {
    DMA: 616,
  },
  "64106": {
    DMA: 616,
  },
  "64108": {
    DMA: 616,
  },
  "64109": {
    DMA: 616,
  },
  "64110": {
    DMA: 616,
  },
  "64111": {
    DMA: 616,
  },
  "64112": {
    DMA: 616,
  },
  "64113": {
    DMA: 616,
  },
  "64114": {
    DMA: 616,
  },
  "64116": {
    DMA: 616,
  },
  "64117": {
    DMA: 616,
  },
  "64118": {
    DMA: 616,
  },
  "64119": {
    DMA: 616,
  },
  "64120": {
    DMA: 616,
  },
  "64121": {
    DMA: 616,
  },
  "64123": {
    DMA: 616,
  },
  "64124": {
    DMA: 616,
  },
  "64125": {
    DMA: 616,
  },
  "64126": {
    DMA: 616,
  },
  "64127": {
    DMA: 616,
  },
  "64128": {
    DMA: 616,
  },
  "64129": {
    DMA: 616,
  },
  "64130": {
    DMA: 616,
  },
  "64131": {
    DMA: 616,
  },
  "64132": {
    DMA: 616,
  },
  "64133": {
    DMA: 616,
  },
  "64134": {
    DMA: 616,
  },
  "64136": {
    DMA: 616,
  },
  "64137": {
    DMA: 616,
  },
  "64138": {
    DMA: 616,
  },
  "64139": {
    DMA: 616,
  },
  "64141": {
    DMA: 616,
  },
  "64144": {
    DMA: 616,
  },
  "64145": {
    DMA: 616,
  },
  "64146": {
    DMA: 616,
  },
  "64147": {
    DMA: 616,
  },
  "64148": {
    DMA: 616,
  },
  "64149": {
    DMA: 616,
  },
  "64150": {
    DMA: 616,
  },
  "64151": {
    DMA: 616,
  },
  "64152": {
    DMA: 616,
  },
  "64153": {
    DMA: 616,
  },
  "64154": {
    DMA: 616,
  },
  "64155": {
    DMA: 616,
  },
  "64156": {
    DMA: 616,
  },
  "64157": {
    DMA: 616,
  },
  "64158": {
    DMA: 616,
  },
  "64161": {
    DMA: 616,
  },
  "64162": {
    DMA: 616,
  },
  "64163": {
    DMA: 616,
  },
  "64164": {
    DMA: 616,
  },
  "64165": {
    DMA: 616,
  },
  "64166": {
    DMA: 616,
  },
  "64167": {
    DMA: 616,
  },
  "64168": {
    DMA: 616,
  },
  "64170": {
    DMA: 616,
  },
  "64171": {
    DMA: 616,
  },
  "64172": {
    DMA: 616,
  },
  "64179": {
    DMA: 616,
  },
  "64180": {
    DMA: 616,
  },
  "64183": {
    DMA: 616,
  },
  "64184": {
    DMA: 616,
  },
  "64185": {
    DMA: 616,
  },
  "64187": {
    DMA: 616,
  },
  "64188": {
    DMA: 616,
  },
  "64190": {
    DMA: 616,
  },
  "64191": {
    DMA: 616,
  },
  "64192": {
    DMA: 616,
  },
  "64193": {
    DMA: 616,
  },
  "64194": {
    DMA: 616,
  },
  "64195": {
    DMA: 616,
  },
  "64196": {
    DMA: 616,
  },
  "64197": {
    DMA: 616,
  },
  "64198": {
    DMA: 616,
  },
  "64199": {
    DMA: 616,
  },
  "64401": {
    DMA: 638,
  },
  "64402": {
    DMA: 616,
  },
  "64420": {
    DMA: 616,
  },
  "64421": {
    DMA: 638,
  },
  "64422": {
    DMA: 638,
  },
  "64423": {
    DMA: 616,
  },
  "64424": {
    DMA: 616,
  },
  "64426": {
    DMA: 616,
  },
  "64427": {
    DMA: 638,
  },
  "64428": {
    DMA: 616,
  },
  "64429": {
    DMA: 616,
  },
  "64430": {
    DMA: 638,
  },
  "64431": {
    DMA: 616,
  },
  "64432": {
    DMA: 616,
  },
  "64433": {
    DMA: 616,
  },
  "64434": {
    DMA: 616,
  },
  "64436": {
    DMA: 638,
  },
  "64437": {
    DMA: 616,
  },
  "64438": {
    DMA: 616,
  },
  "64439": {
    DMA: 616,
  },
  "64440": {
    DMA: 638,
  },
  "64441": {
    DMA: 616,
  },
  "64442": {
    DMA: 616,
  },
  "64443": {
    DMA: 638,
  },
  "64444": {
    DMA: 616,
  },
  "64445": {
    DMA: 616,
  },
  "64446": {
    DMA: 652,
  },
  "64447": {
    DMA: 638,
  },
  "64448": {
    DMA: 638,
  },
  "64449": {
    DMA: 638,
  },
  "64451": {
    DMA: 616,
  },
  "64453": {
    DMA: 616,
  },
  "64454": {
    DMA: 616,
  },
  "64455": {
    DMA: 616,
  },
  "64456": {
    DMA: 616,
  },
  "64457": {
    DMA: 616,
  },
  "64458": {
    DMA: 616,
  },
  "64459": {
    DMA: 638,
  },
  "64461": {
    DMA: 616,
  },
  "64463": {
    DMA: 616,
  },
  "64465": {
    DMA: 616,
  },
  "64466": {
    DMA: 616,
  },
  "64467": {
    DMA: 616,
  },
  "64468": {
    DMA: 616,
  },
  "64469": {
    DMA: 638,
  },
  "64470": {
    DMA: 616,
  },
  "64471": {
    DMA: 616,
  },
  "64473": {
    DMA: 616,
  },
  "64474": {
    DMA: 638,
  },
  "64475": {
    DMA: 616,
  },
  "64476": {
    DMA: 616,
  },
  "64477": {
    DMA: 616,
  },
  "64479": {
    DMA: 616,
  },
  "64480": {
    DMA: 638,
  },
  "64481": {
    DMA: 616,
  },
  "64482": {
    DMA: 652,
  },
  "64483": {
    DMA: 638,
  },
  "64484": {
    DMA: 638,
  },
  "64485": {
    DMA: 638,
  },
  "64486": {
    DMA: 616,
  },
  "64487": {
    DMA: 616,
  },
  "64489": {
    DMA: 616,
  },
  "64490": {
    DMA: 638,
  },
  "64491": {
    DMA: 652,
  },
  "64492": {
    DMA: 616,
  },
  "64493": {
    DMA: 616,
  },
  "64494": {
    DMA: 638,
  },
  "64496": {
    DMA: 652,
  },
  "64497": {
    DMA: 638,
  },
  "64498": {
    DMA: 652,
  },
  "64499": {
    DMA: 616,
  },
  "64501": {
    DMA: 638,
  },
  "64502": {
    DMA: 638,
  },
  "64503": {
    DMA: 638,
  },
  "64504": {
    DMA: 638,
  },
  "64505": {
    DMA: 638,
  },
  "64506": {
    DMA: 638,
  },
  "64507": {
    DMA: 638,
  },
  "64508": {
    DMA: 638,
  },
  "64601": {
    DMA: 616,
  },
  "64620": {
    DMA: 616,
  },
  "64622": {
    DMA: 616,
  },
  "64623": {
    DMA: 616,
  },
  "64624": {
    DMA: 616,
  },
  "64625": {
    DMA: 616,
  },
  "64628": {
    DMA: 616,
  },
  "64630": {
    DMA: 616,
  },
  "64631": {
    DMA: 616,
  },
  "64632": {
    DMA: 616,
  },
  "64633": {
    DMA: 616,
  },
  "64635": {
    DMA: 616,
  },
  "64636": {
    DMA: 616,
  },
  "64637": {
    DMA: 616,
  },
  "64638": {
    DMA: 616,
  },
  "64639": {
    DMA: 616,
  },
  "64640": {
    DMA: 616,
  },
  "64641": {
    DMA: 616,
  },
  "64642": {
    DMA: 616,
  },
  "64643": {
    DMA: 616,
  },
  "64644": {
    DMA: 616,
  },
  "64645": {
    DMA: 631,
  },
  "64646": {
    DMA: 631,
  },
  "64647": {
    DMA: 616,
  },
  "64648": {
    DMA: 616,
  },
  "64649": {
    DMA: 616,
  },
  "64650": {
    DMA: 616,
  },
  "64651": {
    DMA: 616,
  },
  "64652": {
    DMA: 616,
  },
  "64653": {
    DMA: 616,
  },
  "64654": {
    DMA: 616,
  },
  "64655": {
    DMA: 631,
  },
  "64656": {
    DMA: 616,
  },
  "64657": {
    DMA: 616,
  },
  "64658": {
    DMA: 616,
  },
  "64659": {
    DMA: 616,
  },
  "64660": {
    DMA: 604,
  },
  "64661": {
    DMA: 616,
  },
  "64664": {
    DMA: 616,
  },
  "64667": {
    DMA: 631,
  },
  "64668": {
    DMA: 616,
  },
  "64670": {
    DMA: 616,
  },
  "64671": {
    DMA: 616,
  },
  "64672": {
    DMA: 631,
  },
  "64673": {
    DMA: 616,
  },
  "64674": {
    DMA: 616,
  },
  "64676": {
    DMA: 604,
  },
  "64679": {
    DMA: 616,
  },
  "64680": {
    DMA: 616,
  },
  "64681": {
    DMA: 604,
  },
  "64682": {
    DMA: 616,
  },
  "64683": {
    DMA: 616,
  },
  "64686": {
    DMA: 616,
  },
  "64688": {
    DMA: 616,
  },
  "64689": {
    DMA: 616,
  },
  "64701": {
    DMA: 616,
  },
  "64720": {
    DMA: 616,
  },
  "64722": {
    DMA: 616,
  },
  "64723": {
    DMA: 616,
  },
  "64724": {
    DMA: 619,
  },
  "64725": {
    DMA: 616,
  },
  "64726": {
    DMA: 616,
  },
  "64728": {
    DMA: 603,
  },
  "64730": {
    DMA: 616,
  },
  "64733": {
    DMA: 616,
  },
  "64734": {
    DMA: 616,
  },
  "64735": {
    DMA: 616,
  },
  "64738": {
    DMA: 619,
  },
  "64739": {
    DMA: 616,
  },
  "64740": {
    DMA: 616,
  },
  "64741": {
    DMA: 603,
  },
  "64742": {
    DMA: 616,
  },
  "64743": {
    DMA: 616,
  },
  "64744": {
    DMA: 619,
  },
  "64745": {
    DMA: 616,
  },
  "64746": {
    DMA: 616,
  },
  "64747": {
    DMA: 616,
  },
  "64748": {
    DMA: 603,
  },
  "64750": {
    DMA: 603,
  },
  "64752": {
    DMA: 616,
  },
  "64755": {
    DMA: 603,
  },
  "64756": {
    DMA: 619,
  },
  "64759": {
    DMA: 603,
  },
  "64761": {
    DMA: 616,
  },
  "64762": {
    DMA: 603,
  },
  "64763": {
    DMA: 619,
  },
  "64765": {
    DMA: 603,
  },
  "64766": {
    DMA: 603,
  },
  "64767": {
    DMA: 603,
  },
  "64769": {
    DMA: 603,
  },
  "64770": {
    DMA: 616,
  },
  "64771": {
    DMA: 603,
  },
  "64772": {
    DMA: 603,
  },
  "64776": {
    DMA: 619,
  },
  "64778": {
    DMA: 603,
  },
  "64779": {
    DMA: 616,
  },
  "64780": {
    DMA: 616,
  },
  "64781": {
    DMA: 619,
  },
  "64783": {
    DMA: 603,
  },
  "64784": {
    DMA: 603,
  },
  "64788": {
    DMA: 616,
  },
  "64789": {
    DMA: "#N/A",
  },
  "64790": {
    DMA: 603,
  },
  "64801": {
    DMA: 603,
  },
  "64802": {
    DMA: 603,
  },
  "64803": {
    DMA: 603,
  },
  "64804": {
    DMA: 603,
  },
  "64830": {
    DMA: 603,
  },
  "64831": {
    DMA: 603,
  },
  "64832": {
    DMA: 603,
  },
  "64833": {
    DMA: 603,
  },
  "64834": {
    DMA: 603,
  },
  "64835": {
    DMA: 603,
  },
  "64836": {
    DMA: 603,
  },
  "64840": {
    DMA: 603,
  },
  "64841": {
    DMA: 603,
  },
  "64842": {
    DMA: 603,
  },
  "64843": {
    DMA: 603,
  },
  "64844": {
    DMA: 603,
  },
  "64847": {
    DMA: 603,
  },
  "64848": {
    DMA: 619,
  },
  "64849": {
    DMA: 603,
  },
  "64850": {
    DMA: 603,
  },
  "64853": {
    DMA: 603,
  },
  "64854": {
    DMA: 603,
  },
  "64855": {
    DMA: 603,
  },
  "64856": {
    DMA: 603,
  },
  "64857": {
    DMA: 603,
  },
  "64858": {
    DMA: 603,
  },
  "64859": {
    DMA: 603,
  },
  "64861": {
    DMA: 603,
  },
  "64862": {
    DMA: 603,
  },
  "64863": {
    DMA: 603,
  },
  "64864": {
    DMA: 603,
  },
  "64865": {
    DMA: 603,
  },
  "64866": {
    DMA: 603,
  },
  "64867": {
    DMA: 603,
  },
  "64868": {
    DMA: 603,
  },
  "64869": {
    DMA: 603,
  },
  "64870": {
    DMA: 603,
  },
  "64873": {
    DMA: 619,
  },
  "64874": {
    DMA: 619,
  },
  "64944": {
    DMA: 616,
  },
  "64999": {
    DMA: 616,
  },
  "65001": {
    DMA: 604,
  },
  "65010": {
    DMA: 604,
  },
  "65011": {
    DMA: 604,
  },
  "65013": {
    DMA: 604,
  },
  "65014": {
    DMA: 609,
  },
  "65016": {
    DMA: 604,
  },
  "65017": {
    DMA: 604,
  },
  "65018": {
    DMA: 604,
  },
  "65020": {
    DMA: 619,
  },
  "65023": {
    DMA: 604,
  },
  "65024": {
    DMA: 604,
  },
  "65025": {
    DMA: 604,
  },
  "65026": {
    DMA: 604,
  },
  "65032": {
    DMA: 604,
  },
  "65034": {
    DMA: 604,
  },
  "65035": {
    DMA: 604,
  },
  "65036": {
    DMA: 609,
  },
  "65037": {
    DMA: 604,
  },
  "65038": {
    DMA: 604,
  },
  "65039": {
    DMA: 604,
  },
  "65040": {
    DMA: 604,
  },
  "65041": {
    DMA: 609,
  },
  "65042": {
    DMA: 604,
  },
  "65043": {
    DMA: 604,
  },
  "65046": {
    DMA: 604,
  },
  "65047": {
    DMA: 604,
  },
  "65048": {
    DMA: 604,
  },
  "65049": {
    DMA: 619,
  },
  "65050": {
    DMA: 604,
  },
  "65051": {
    DMA: 604,
  },
  "65052": {
    DMA: 619,
  },
  "65053": {
    DMA: 604,
  },
  "65054": {
    DMA: 604,
  },
  "65055": {
    DMA: 604,
  },
  "65058": {
    DMA: 604,
  },
  "65059": {
    DMA: 604,
  },
  "65061": {
    DMA: 609,
  },
  "65062": {
    DMA: 609,
  },
  "65063": {
    DMA: 604,
  },
  "65064": {
    DMA: 604,
  },
  "65065": {
    DMA: 619,
  },
  "65066": {
    DMA: 609,
  },
  "65067": {
    DMA: 604,
  },
  "65068": {
    DMA: 604,
  },
  "65069": {
    DMA: 604,
  },
  "65072": {
    DMA: 604,
  },
  "65074": {
    DMA: 604,
  },
  "65075": {
    DMA: 604,
  },
  "65076": {
    DMA: 604,
  },
  "65077": {
    DMA: 604,
  },
  "65078": {
    DMA: 604,
  },
  "65079": {
    DMA: 619,
  },
  "65080": {
    DMA: 604,
  },
  "65081": {
    DMA: 604,
  },
  "65082": {
    DMA: 604,
  },
  "65083": {
    DMA: 604,
  },
  "65084": {
    DMA: 604,
  },
  "65085": {
    DMA: 604,
  },
  "65101": {
    DMA: 604,
  },
  "65102": {
    DMA: 604,
  },
  "65103": {
    DMA: 604,
  },
  "65104": {
    DMA: 604,
  },
  "65105": {
    DMA: 604,
  },
  "65106": {
    DMA: 604,
  },
  "65107": {
    DMA: 604,
  },
  "65108": {
    DMA: 604,
  },
  "65109": {
    DMA: 604,
  },
  "65110": {
    DMA: 604,
  },
  "65111": {
    DMA: 604,
  },
  "65201": {
    DMA: 604,
  },
  "65202": {
    DMA: 604,
  },
  "65203": {
    DMA: 604,
  },
  "65205": {
    DMA: 604,
  },
  "65211": {
    DMA: 604,
  },
  "65212": {
    DMA: 604,
  },
  "65215": {
    DMA: 604,
  },
  "65216": {
    DMA: 604,
  },
  "65217": {
    DMA: 604,
  },
  "65218": {
    DMA: 604,
  },
  "65230": {
    DMA: 604,
  },
  "65231": {
    DMA: 604,
  },
  "65232": {
    DMA: 604,
  },
  "65233": {
    DMA: 604,
  },
  "65236": {
    DMA: 604,
  },
  "65237": {
    DMA: 604,
  },
  "65239": {
    DMA: 604,
  },
  "65240": {
    DMA: 604,
  },
  "65243": {
    DMA: 604,
  },
  "65244": {
    DMA: 604,
  },
  "65246": {
    DMA: 604,
  },
  "65247": {
    DMA: 631,
  },
  "65248": {
    DMA: 604,
  },
  "65250": {
    DMA: 604,
  },
  "65251": {
    DMA: 604,
  },
  "65254": {
    DMA: 604,
  },
  "65255": {
    DMA: 604,
  },
  "65256": {
    DMA: 604,
  },
  "65257": {
    DMA: 604,
  },
  "65258": {
    DMA: 717,
  },
  "65259": {
    DMA: 604,
  },
  "65260": {
    DMA: 604,
  },
  "65261": {
    DMA: 604,
  },
  "65262": {
    DMA: 604,
  },
  "65263": {
    DMA: 717,
  },
  "65264": {
    DMA: 604,
  },
  "65265": {
    DMA: 604,
  },
  "65270": {
    DMA: 604,
  },
  "65274": {
    DMA: 604,
  },
  "65275": {
    DMA: 717,
  },
  "65276": {
    DMA: 604,
  },
  "65278": {
    DMA: 604,
  },
  "65279": {
    DMA: 604,
  },
  "65280": {
    DMA: 604,
  },
  "65281": {
    DMA: 604,
  },
  "65282": {
    DMA: 717,
  },
  "65283": {
    DMA: 717,
  },
  "65284": {
    DMA: 604,
  },
  "65285": {
    DMA: 604,
  },
  "65286": {
    DMA: 604,
  },
  "65287": {
    DMA: 604,
  },
  "65299": {
    DMA: 604,
  },
  "65301": {
    DMA: 616,
  },
  "65302": {
    DMA: 616,
  },
  "65305": {
    DMA: 616,
  },
  "65320": {
    DMA: 616,
  },
  "65321": {
    DMA: 616,
  },
  "65322": {
    DMA: 604,
  },
  "65323": {
    DMA: 616,
  },
  "65324": {
    DMA: 619,
  },
  "65325": {
    DMA: 619,
  },
  "65326": {
    DMA: 619,
  },
  "65327": {
    DMA: 616,
  },
  "65329": {
    DMA: 604,
  },
  "65330": {
    DMA: 616,
  },
  "65332": {
    DMA: 616,
  },
  "65333": {
    DMA: 616,
  },
  "65334": {
    DMA: 616,
  },
  "65335": {
    DMA: 619,
  },
  "65336": {
    DMA: 616,
  },
  "65337": {
    DMA: 616,
  },
  "65338": {
    DMA: 619,
  },
  "65339": {
    DMA: 616,
  },
  "65340": {
    DMA: 616,
  },
  "65344": {
    DMA: 616,
  },
  "65345": {
    DMA: 616,
  },
  "65347": {
    DMA: 616,
  },
  "65348": {
    DMA: 604,
  },
  "65349": {
    DMA: 616,
  },
  "65350": {
    DMA: 616,
  },
  "65351": {
    DMA: 616,
  },
  "65354": {
    DMA: 604,
  },
  "65355": {
    DMA: 619,
  },
  "65360": {
    DMA: 616,
  },
  "65401": {
    DMA: 609,
  },
  "65402": {
    DMA: 609,
  },
  "65409": {
    DMA: 609,
  },
  "65436": {
    DMA: 609,
  },
  "65438": {
    DMA: 619,
  },
  "65439": {
    DMA: 609,
  },
  "65440": {
    DMA: 619,
  },
  "65441": {
    DMA: 609,
  },
  "65443": {
    DMA: 604,
  },
  "65444": {
    DMA: 619,
  },
  "65446": {
    DMA: 609,
  },
  "65449": {
    DMA: 609,
  },
  "65452": {
    DMA: 619,
  },
  "65453": {
    DMA: 609,
  },
  "65456": {
    DMA: 609,
  },
  "65457": {
    DMA: 619,
  },
  "65459": {
    DMA: 619,
  },
  "65461": {
    DMA: 609,
  },
  "65462": {
    DMA: 609,
  },
  "65463": {
    DMA: 619,
  },
  "65464": {
    DMA: 619,
  },
  "65466": {
    DMA: 619,
  },
  "65468": {
    DMA: 619,
  },
  "65470": {
    DMA: 619,
  },
  "65473": {
    DMA: 619,
  },
  "65479": {
    DMA: 619,
  },
  "65483": {
    DMA: 619,
  },
  "65484": {
    DMA: 619,
  },
  "65486": {
    DMA: 604,
  },
  "65501": {
    DMA: 619,
  },
  "65529": {
    DMA: 609,
  },
  "65532": {
    DMA: 619,
  },
  "65534": {
    DMA: 619,
  },
  "65535": {
    DMA: 609,
  },
  "65536": {
    DMA: 619,
  },
  "65541": {
    DMA: 619,
  },
  "65542": {
    DMA: 619,
  },
  "65543": {
    DMA: 619,
  },
  "65546": {
    DMA: 619,
  },
  "65548": {
    DMA: 619,
  },
  "65550": {
    DMA: 609,
  },
  "65552": {
    DMA: 619,
  },
  "65555": {
    DMA: 619,
  },
  "65556": {
    DMA: 619,
  },
  "65557": {
    DMA: 619,
  },
  "65559": {
    DMA: 609,
  },
  "65560": {
    DMA: 619,
  },
  "65564": {
    DMA: 619,
  },
  "65565": {
    DMA: 609,
  },
  "65566": {
    DMA: 609,
  },
  "65567": {
    DMA: 619,
  },
  "65570": {
    DMA: 619,
  },
  "65571": {
    DMA: 619,
  },
  "65580": {
    DMA: 604,
  },
  "65582": {
    DMA: 604,
  },
  "65583": {
    DMA: 619,
  },
  "65584": {
    DMA: 619,
  },
  "65586": {
    DMA: 609,
  },
  "65588": {
    DMA: 619,
  },
  "65589": {
    DMA: 619,
  },
  "65590": {
    DMA: 619,
  },
  "65591": {
    DMA: 619,
  },
  "65601": {
    DMA: 619,
  },
  "65603": {
    DMA: 619,
  },
  "65604": {
    DMA: 619,
  },
  "65605": {
    DMA: 619,
  },
  "65606": {
    DMA: 619,
  },
  "65607": {
    DMA: 619,
  },
  "65608": {
    DMA: 619,
  },
  "65609": {
    DMA: 619,
  },
  "65610": {
    DMA: 619,
  },
  "65611": {
    DMA: 619,
  },
  "65612": {
    DMA: 619,
  },
  "65613": {
    DMA: 619,
  },
  "65614": {
    DMA: 619,
  },
  "65615": {
    DMA: 619,
  },
  "65616": {
    DMA: 619,
  },
  "65617": {
    DMA: 619,
  },
  "65618": {
    DMA: 619,
  },
  "65619": {
    DMA: 619,
  },
  "65620": {
    DMA: 619,
  },
  "65622": {
    DMA: 619,
  },
  "65623": {
    DMA: 619,
  },
  "65624": {
    DMA: 619,
  },
  "65625": {
    DMA: 619,
  },
  "65626": {
    DMA: 619,
  },
  "65627": {
    DMA: 619,
  },
  "65629": {
    DMA: 619,
  },
  "65630": {
    DMA: 619,
  },
  "65631": {
    DMA: 619,
  },
  "65632": {
    DMA: 619,
  },
  "65633": {
    DMA: 619,
  },
  "65634": {
    DMA: 619,
  },
  "65635": {
    DMA: 619,
  },
  "65636": {
    DMA: 619,
  },
  "65637": {
    DMA: 619,
  },
  "65638": {
    DMA: 619,
  },
  "65640": {
    DMA: 619,
  },
  "65641": {
    DMA: 619,
  },
  "65644": {
    DMA: 619,
  },
  "65645": {
    DMA: 619,
  },
  "65646": {
    DMA: 619,
  },
  "65647": {
    DMA: 619,
  },
  "65648": {
    DMA: 619,
  },
  "65649": {
    DMA: 619,
  },
  "65650": {
    DMA: 619,
  },
  "65652": {
    DMA: 619,
  },
  "65653": {
    DMA: 619,
  },
  "65654": {
    DMA: 619,
  },
  "65655": {
    DMA: 619,
  },
  "65656": {
    DMA: 619,
  },
  "65657": {
    DMA: 619,
  },
  "65658": {
    DMA: 619,
  },
  "65660": {
    DMA: 619,
  },
  "65661": {
    DMA: 619,
  },
  "65662": {
    DMA: 619,
  },
  "65663": {
    DMA: 619,
  },
  "65664": {
    DMA: 619,
  },
  "65666": {
    DMA: 619,
  },
  "65667": {
    DMA: 619,
  },
  "65668": {
    DMA: 619,
  },
  "65669": {
    DMA: 619,
  },
  "65672": {
    DMA: 619,
  },
  "65673": {
    DMA: 619,
  },
  "65674": {
    DMA: 619,
  },
  "65675": {
    DMA: 619,
  },
  "65676": {
    DMA: 619,
  },
  "65679": {
    DMA: 619,
  },
  "65680": {
    DMA: 619,
  },
  "65681": {
    DMA: 619,
  },
  "65682": {
    DMA: 619,
  },
  "65685": {
    DMA: 619,
  },
  "65686": {
    DMA: 619,
  },
  "65688": {
    DMA: 619,
  },
  "65689": {
    DMA: 619,
  },
  "65690": {
    DMA: 619,
  },
  "65692": {
    DMA: 619,
  },
  "65701": {
    DMA: 619,
  },
  "65702": {
    DMA: 619,
  },
  "65704": {
    DMA: 619,
  },
  "65705": {
    DMA: 619,
  },
  "65706": {
    DMA: 619,
  },
  "65707": {
    DMA: 619,
  },
  "65708": {
    DMA: 619,
  },
  "65710": {
    DMA: 619,
  },
  "65711": {
    DMA: 619,
  },
  "65712": {
    DMA: 619,
  },
  "65713": {
    DMA: 619,
  },
  "65714": {
    DMA: 619,
  },
  "65715": {
    DMA: 619,
  },
  "65717": {
    DMA: 619,
  },
  "65720": {
    DMA: 619,
  },
  "65721": {
    DMA: 619,
  },
  "65722": {
    DMA: 619,
  },
  "65723": {
    DMA: 619,
  },
  "65724": {
    DMA: 619,
  },
  "65725": {
    DMA: 619,
  },
  "65726": {
    DMA: 619,
  },
  "65727": {
    DMA: 619,
  },
  "65728": {
    DMA: 619,
  },
  "65729": {
    DMA: 619,
  },
  "65730": {
    DMA: 603,
  },
  "65731": {
    DMA: 619,
  },
  "65732": {
    DMA: 619,
  },
  "65733": {
    DMA: 619,
  },
  "65734": {
    DMA: 619,
  },
  "65735": {
    DMA: 619,
  },
  "65737": {
    DMA: 619,
  },
  "65738": {
    DMA: 619,
  },
  "65739": {
    DMA: 619,
  },
  "65740": {
    DMA: 619,
  },
  "65741": {
    DMA: 619,
  },
  "65742": {
    DMA: 619,
  },
  "65744": {
    DMA: 619,
  },
  "65745": {
    DMA: 619,
  },
  "65746": {
    DMA: 619,
  },
  "65747": {
    DMA: 619,
  },
  "65752": {
    DMA: 619,
  },
  "65753": {
    DMA: 619,
  },
  "65754": {
    DMA: 619,
  },
  "65755": {
    DMA: 619,
  },
  "65756": {
    DMA: 619,
  },
  "65757": {
    DMA: 619,
  },
  "65759": {
    DMA: 619,
  },
  "65760": {
    DMA: 619,
  },
  "65761": {
    DMA: 619,
  },
  "65762": {
    DMA: 619,
  },
  "65764": {
    DMA: 619,
  },
  "65765": {
    DMA: 619,
  },
  "65766": {
    DMA: 619,
  },
  "65767": {
    DMA: 619,
  },
  "65768": {
    DMA: 619,
  },
  "65769": {
    DMA: 619,
  },
  "65770": {
    DMA: 619,
  },
  "65771": {
    DMA: 619,
  },
  "65772": {
    DMA: 619,
  },
  "65773": {
    DMA: 619,
  },
  "65774": {
    DMA: 619,
  },
  "65775": {
    DMA: 619,
  },
  "65776": {
    DMA: 619,
  },
  "65777": {
    DMA: 619,
  },
  "65778": {
    DMA: 619,
  },
  "65779": {
    DMA: 619,
  },
  "65781": {
    DMA: 619,
  },
  "65783": {
    DMA: 619,
  },
  "65784": {
    DMA: 619,
  },
  "65785": {
    DMA: 619,
  },
  "65786": {
    DMA: 619,
  },
  "65787": {
    DMA: 619,
  },
  "65788": {
    DMA: 619,
  },
  "65789": {
    DMA: 619,
  },
  "65790": {
    DMA: 619,
  },
  "65791": {
    DMA: 619,
  },
  "65793": {
    DMA: 619,
  },
  "65801": {
    DMA: 619,
  },
  "65802": {
    DMA: 619,
  },
  "65803": {
    DMA: 619,
  },
  "65804": {
    DMA: 619,
  },
  "65805": {
    DMA: 619,
  },
  "65806": {
    DMA: 619,
  },
  "65807": {
    DMA: 619,
  },
  "65808": {
    DMA: 619,
  },
  "65809": {
    DMA: 619,
  },
  "65810": {
    DMA: 619,
  },
  "65814": {
    DMA: 619,
  },
  "65817": {
    DMA: 619,
  },
  "65890": {
    DMA: 619,
  },
  "65897": {
    DMA: 619,
  },
  "65898": {
    DMA: 619,
  },
  "65899": {
    DMA: 619,
  },
  "66002": {
    DMA: 616,
  },
  "66006": {
    DMA: 616,
  },
  "66007": {
    DMA: 616,
  },
  "66008": {
    DMA: 638,
  },
  "66010": {
    DMA: 616,
  },
  "66012": {
    DMA: 616,
  },
  "66013": {
    DMA: 616,
  },
  "66014": {
    DMA: 616,
  },
  "66015": {
    DMA: 616,
  },
  "66016": {
    DMA: 616,
  },
  "66017": {
    DMA: 638,
  },
  "66018": {
    DMA: 616,
  },
  "66019": {
    DMA: 616,
  },
  "66020": {
    DMA: 616,
  },
  "66021": {
    DMA: 616,
  },
  "66023": {
    DMA: 616,
  },
  "66024": {
    DMA: 638,
  },
  "66025": {
    DMA: 616,
  },
  "66026": {
    DMA: 616,
  },
  "66027": {
    DMA: 616,
  },
  "66030": {
    DMA: 616,
  },
  "66031": {
    DMA: 616,
  },
  "66032": {
    DMA: 616,
  },
  "66033": {
    DMA: 616,
  },
  "66035": {
    DMA: 638,
  },
  "66036": {
    DMA: 616,
  },
  "66039": {
    DMA: 616,
  },
  "66040": {
    DMA: 616,
  },
  "66041": {
    DMA: 616,
  },
  "66042": {
    DMA: 616,
  },
  "66043": {
    DMA: 616,
  },
  "66044": {
    DMA: 616,
  },
  "66045": {
    DMA: 616,
  },
  "66046": {
    DMA: 616,
  },
  "66047": {
    DMA: 616,
  },
  "66048": {
    DMA: 616,
  },
  "66049": {
    DMA: 616,
  },
  "66050": {
    DMA: 605,
  },
  "66051": {
    DMA: 616,
  },
  "66052": {
    DMA: 616,
  },
  "66053": {
    DMA: 616,
  },
  "66054": {
    DMA: 605,
  },
  "66056": {
    DMA: 616,
  },
  "66058": {
    DMA: 616,
  },
  "66060": {
    DMA: 605,
  },
  "66061": {
    DMA: 616,
  },
  "66062": {
    DMA: 616,
  },
  "66063": {
    DMA: 616,
  },
  "66064": {
    DMA: 616,
  },
  "66066": {
    DMA: 605,
  },
  "66067": {
    DMA: 616,
  },
  "66070": {
    DMA: 605,
  },
  "66071": {
    DMA: 616,
  },
  "66072": {
    DMA: 616,
  },
  "66073": {
    DMA: 605,
  },
  "66075": {
    DMA: 616,
  },
  "66076": {
    DMA: 616,
  },
  "66077": {
    DMA: 616,
  },
  "66078": {
    DMA: 616,
  },
  "66079": {
    DMA: 616,
  },
  "66080": {
    DMA: 616,
  },
  "66083": {
    DMA: 616,
  },
  "66085": {
    DMA: 616,
  },
  "66086": {
    DMA: 616,
  },
  "66087": {
    DMA: 638,
  },
  "66088": {
    DMA: 605,
  },
  "66090": {
    DMA: 638,
  },
  "66091": {
    DMA: 616,
  },
  "66092": {
    DMA: 616,
  },
  "66093": {
    DMA: 616,
  },
  "66094": {
    DMA: 638,
  },
  "66095": {
    DMA: 616,
  },
  "66097": {
    DMA: 605,
  },
  "66101": {
    DMA: 616,
  },
  "66102": {
    DMA: 616,
  },
  "66103": {
    DMA: 616,
  },
  "66104": {
    DMA: 616,
  },
  "66105": {
    DMA: 616,
  },
  "66106": {
    DMA: 616,
  },
  "66109": {
    DMA: 616,
  },
  "66110": {
    DMA: 616,
  },
  "66111": {
    DMA: 616,
  },
  "66112": {
    DMA: 616,
  },
  "66113": {
    DMA: 616,
  },
  "66115": {
    DMA: 616,
  },
  "66117": {
    DMA: 616,
  },
  "66118": {
    DMA: 616,
  },
  "66119": {
    DMA: 616,
  },
  "66160": {
    DMA: 616,
  },
  "66201": {
    DMA: 616,
  },
  "66202": {
    DMA: 616,
  },
  "66203": {
    DMA: 616,
  },
  "66204": {
    DMA: 616,
  },
  "66205": {
    DMA: 616,
  },
  "66206": {
    DMA: 616,
  },
  "66207": {
    DMA: 616,
  },
  "66208": {
    DMA: 616,
  },
  "66209": {
    DMA: 616,
  },
  "66210": {
    DMA: 616,
  },
  "66211": {
    DMA: 616,
  },
  "66212": {
    DMA: 616,
  },
  "66213": {
    DMA: 616,
  },
  "66214": {
    DMA: 616,
  },
  "66215": {
    DMA: 616,
  },
  "66216": {
    DMA: 616,
  },
  "66217": {
    DMA: 616,
  },
  "66218": {
    DMA: 616,
  },
  "66219": {
    DMA: 616,
  },
  "66220": {
    DMA: 616,
  },
  "66221": {
    DMA: 616,
  },
  "66222": {
    DMA: 616,
  },
  "66223": {
    DMA: 616,
  },
  "66224": {
    DMA: 616,
  },
  "66225": {
    DMA: 616,
  },
  "66226": {
    DMA: 616,
  },
  "66227": {
    DMA: 616,
  },
  "66250": {
    DMA: 616,
  },
  "66251": {
    DMA: 616,
  },
  "66276": {
    DMA: 616,
  },
  "66279": {
    DMA: 616,
  },
  "66282": {
    DMA: 616,
  },
  "66283": {
    DMA: 616,
  },
  "66285": {
    DMA: 616,
  },
  "66286": {
    DMA: 616,
  },
  "66401": {
    DMA: 605,
  },
  "66402": {
    DMA: 605,
  },
  "66403": {
    DMA: 605,
  },
  "66404": {
    DMA: 605,
  },
  "66406": {
    DMA: 605,
  },
  "66407": {
    DMA: 605,
  },
  "66408": {
    DMA: 605,
  },
  "66409": {
    DMA: 605,
  },
  "66411": {
    DMA: 605,
  },
  "66412": {
    DMA: 605,
  },
  "66413": {
    DMA: 605,
  },
  "66414": {
    DMA: 605,
  },
  "66415": {
    DMA: 605,
  },
  "66416": {
    DMA: 605,
  },
  "66417": {
    DMA: 605,
  },
  "66418": {
    DMA: 605,
  },
  "66419": {
    DMA: 605,
  },
  "66420": {
    DMA: 605,
  },
  "66422": {
    DMA: 605,
  },
  "66423": {
    DMA: 605,
  },
  "66424": {
    DMA: 605,
  },
  "66425": {
    DMA: 605,
  },
  "66426": {
    DMA: 605,
  },
  "66427": {
    DMA: 605,
  },
  "66428": {
    DMA: 605,
  },
  "66429": {
    DMA: 605,
  },
  "66431": {
    DMA: 605,
  },
  "66432": {
    DMA: 605,
  },
  "66434": {
    DMA: 605,
  },
  "66436": {
    DMA: 605,
  },
  "66438": {
    DMA: 605,
  },
  "66439": {
    DMA: 605,
  },
  "66440": {
    DMA: 605,
  },
  "66441": {
    DMA: 605,
  },
  "66442": {
    DMA: 605,
  },
  "66449": {
    DMA: 605,
  },
  "66451": {
    DMA: 605,
  },
  "66501": {
    DMA: 605,
  },
  "66502": {
    DMA: 605,
  },
  "66503": {
    DMA: 605,
  },
  "66505": {
    DMA: 605,
  },
  "66506": {
    DMA: 605,
  },
  "66507": {
    DMA: 605,
  },
  "66508": {
    DMA: 605,
  },
  "66509": {
    DMA: 605,
  },
  "66510": {
    DMA: 605,
  },
  "66512": {
    DMA: 605,
  },
  "66514": {
    DMA: 605,
  },
  "66515": {
    DMA: 605,
  },
  "66516": {
    DMA: 605,
  },
  "66517": {
    DMA: 605,
  },
  "66518": {
    DMA: 605,
  },
  "66520": {
    DMA: 605,
  },
  "66521": {
    DMA: 605,
  },
  "66522": {
    DMA: 605,
  },
  "66523": {
    DMA: 605,
  },
  "66524": {
    DMA: 605,
  },
  "66526": {
    DMA: 605,
  },
  "66527": {
    DMA: 605,
  },
  "66528": {
    DMA: 605,
  },
  "66531": {
    DMA: 605,
  },
  "66532": {
    DMA: 605,
  },
  "66533": {
    DMA: 605,
  },
  "66534": {
    DMA: 605,
  },
  "66535": {
    DMA: 605,
  },
  "66536": {
    DMA: 605,
  },
  "66537": {
    DMA: 605,
  },
  "66538": {
    DMA: 605,
  },
  "66539": {
    DMA: 605,
  },
  "66540": {
    DMA: 605,
  },
  "66541": {
    DMA: 605,
  },
  "66542": {
    DMA: 605,
  },
  "66543": {
    DMA: 605,
  },
  "66544": {
    DMA: 605,
  },
  "66546": {
    DMA: 605,
  },
  "66547": {
    DMA: 605,
  },
  "66548": {
    DMA: 605,
  },
  "66549": {
    DMA: 605,
  },
  "66550": {
    DMA: 605,
  },
  "66552": {
    DMA: 605,
  },
  "66554": {
    DMA: 605,
  },
  "66601": {
    DMA: 605,
  },
  "66603": {
    DMA: 605,
  },
  "66604": {
    DMA: 605,
  },
  "66605": {
    DMA: 605,
  },
  "66606": {
    DMA: 605,
  },
  "66607": {
    DMA: 605,
  },
  "66608": {
    DMA: 605,
  },
  "66609": {
    DMA: 605,
  },
  "66610": {
    DMA: 605,
  },
  "66611": {
    DMA: 605,
  },
  "66612": {
    DMA: 605,
  },
  "66614": {
    DMA: 605,
  },
  "66615": {
    DMA: 605,
  },
  "66616": {
    DMA: 605,
  },
  "66617": {
    DMA: 605,
  },
  "66618": {
    DMA: 605,
  },
  "66619": {
    DMA: 605,
  },
  "66620": {
    DMA: 605,
  },
  "66621": {
    DMA: 605,
  },
  "66622": {
    DMA: 605,
  },
  "66624": {
    DMA: 605,
  },
  "66625": {
    DMA: 605,
  },
  "66626": {
    DMA: 605,
  },
  "66628": {
    DMA: 605,
  },
  "66629": {
    DMA: 605,
  },
  "66630": {
    DMA: 605,
  },
  "66636": {
    DMA: 605,
  },
  "66637": {
    DMA: 605,
  },
  "66642": {
    DMA: 605,
  },
  "66647": {
    DMA: 605,
  },
  "66652": {
    DMA: 605,
  },
  "66653": {
    DMA: 605,
  },
  "66667": {
    DMA: 605,
  },
  "66675": {
    DMA: 605,
  },
  "66683": {
    DMA: 605,
  },
  "66692": {
    DMA: 605,
  },
  "66699": {
    DMA: 605,
  },
  "66701": {
    DMA: 603,
  },
  "66710": {
    DMA: 603,
  },
  "66711": {
    DMA: 603,
  },
  "66712": {
    DMA: 603,
  },
  "66713": {
    DMA: 603,
  },
  "66714": {
    DMA: 603,
  },
  "66716": {
    DMA: 603,
  },
  "66717": {
    DMA: 603,
  },
  "66720": {
    DMA: 603,
  },
  "66724": {
    DMA: 603,
  },
  "66725": {
    DMA: 603,
  },
  "66728": {
    DMA: 603,
  },
  "66732": {
    DMA: 603,
  },
  "66733": {
    DMA: 603,
  },
  "66734": {
    DMA: 603,
  },
  "66735": {
    DMA: 603,
  },
  "66736": {
    DMA: 603,
  },
  "66738": {
    DMA: 603,
  },
  "66739": {
    DMA: 603,
  },
  "66740": {
    DMA: 603,
  },
  "66741": {
    DMA: 603,
  },
  "66742": {
    DMA: 603,
  },
  "66743": {
    DMA: 603,
  },
  "66746": {
    DMA: 603,
  },
  "66748": {
    DMA: 603,
  },
  "66749": {
    DMA: 603,
  },
  "66751": {
    DMA: 603,
  },
  "66753": {
    DMA: 603,
  },
  "66754": {
    DMA: 603,
  },
  "66755": {
    DMA: 603,
  },
  "66756": {
    DMA: 603,
  },
  "66757": {
    DMA: 603,
  },
  "66758": {
    DMA: 605,
  },
  "66759": {
    DMA: 678,
  },
  "66760": {
    DMA: 603,
  },
  "66761": {
    DMA: 603,
  },
  "66762": {
    DMA: 603,
  },
  "66763": {
    DMA: 603,
  },
  "66767": {
    DMA: 616,
  },
  "66769": {
    DMA: 603,
  },
  "66770": {
    DMA: 603,
  },
  "66771": {
    DMA: 603,
  },
  "66772": {
    DMA: 603,
  },
  "66773": {
    DMA: 603,
  },
  "66775": {
    DMA: 603,
  },
  "66776": {
    DMA: 603,
  },
  "66777": {
    DMA: 603,
  },
  "66778": {
    DMA: 603,
  },
  "66779": {
    DMA: 603,
  },
  "66780": {
    DMA: 603,
  },
  "66781": {
    DMA: 603,
  },
  "66782": {
    DMA: 603,
  },
  "66783": {
    DMA: 603,
  },
  "66801": {
    DMA: 605,
  },
  "66830": {
    DMA: 605,
  },
  "66833": {
    DMA: 605,
  },
  "66834": {
    DMA: 605,
  },
  "66835": {
    DMA: 605,
  },
  "66838": {
    DMA: 605,
  },
  "66839": {
    DMA: 605,
  },
  "66840": {
    DMA: 678,
  },
  "66842": {
    DMA: 678,
  },
  "66843": {
    DMA: 678,
  },
  "66845": {
    DMA: 678,
  },
  "66846": {
    DMA: 605,
  },
  "66849": {
    DMA: 605,
  },
  "66850": {
    DMA: 678,
  },
  "66851": {
    DMA: 678,
  },
  "66852": {
    DMA: 605,
  },
  "66853": {
    DMA: 678,
  },
  "66854": {
    DMA: 605,
  },
  "66855": {
    DMA: 678,
  },
  "66856": {
    DMA: 605,
  },
  "66857": {
    DMA: 605,
  },
  "66858": {
    DMA: 678,
  },
  "66859": {
    DMA: 678,
  },
  "66860": {
    DMA: 678,
  },
  "66861": {
    DMA: 678,
  },
  "66862": {
    DMA: 678,
  },
  "66863": {
    DMA: 678,
  },
  "66864": {
    DMA: 605,
  },
  "66865": {
    DMA: 605,
  },
  "66866": {
    DMA: 678,
  },
  "66868": {
    DMA: 605,
  },
  "66869": {
    DMA: 678,
  },
  "66870": {
    DMA: 678,
  },
  "66871": {
    DMA: 605,
  },
  "66872": {
    DMA: 605,
  },
  "66873": {
    DMA: 605,
  },
  "66901": {
    DMA: 605,
  },
  "66930": {
    DMA: 722,
  },
  "66932": {
    DMA: 722,
  },
  "66933": {
    DMA: 605,
  },
  "66935": {
    DMA: 722,
  },
  "66936": {
    DMA: 722,
  },
  "66937": {
    DMA: 605,
  },
  "66938": {
    DMA: 605,
  },
  "66939": {
    DMA: 722,
  },
  "66940": {
    DMA: 722,
  },
  "66941": {
    DMA: 722,
  },
  "66942": {
    DMA: 722,
  },
  "66943": {
    DMA: 605,
  },
  "66944": {
    DMA: 605,
  },
  "66945": {
    DMA: 605,
  },
  "66946": {
    DMA: 605,
  },
  "66948": {
    DMA: 605,
  },
  "66949": {
    DMA: 722,
  },
  "66951": {
    DMA: 722,
  },
  "66952": {
    DMA: 722,
  },
  "66953": {
    DMA: 605,
  },
  "66955": {
    DMA: 605,
  },
  "66956": {
    DMA: 722,
  },
  "66958": {
    DMA: 605,
  },
  "66959": {
    DMA: 722,
  },
  "66960": {
    DMA: 722,
  },
  "66961": {
    DMA: 722,
  },
  "66962": {
    DMA: 605,
  },
  "66963": {
    DMA: 722,
  },
  "66964": {
    DMA: 722,
  },
  "66966": {
    DMA: 722,
  },
  "66967": {
    DMA: 722,
  },
  "66968": {
    DMA: 605,
  },
  "66970": {
    DMA: 722,
  },
  "67001": {
    DMA: 678,
  },
  "67002": {
    DMA: 678,
  },
  "67003": {
    DMA: 678,
  },
  "67004": {
    DMA: 678,
  },
  "67005": {
    DMA: 678,
  },
  "67008": {
    DMA: 678,
  },
  "67009": {
    DMA: 678,
  },
  "67010": {
    DMA: 678,
  },
  "67012": {
    DMA: 678,
  },
  "67013": {
    DMA: 678,
  },
  "67016": {
    DMA: 678,
  },
  "67017": {
    DMA: 678,
  },
  "67018": {
    DMA: 678,
  },
  "67019": {
    DMA: 678,
  },
  "67020": {
    DMA: 678,
  },
  "67021": {
    DMA: 678,
  },
  "67022": {
    DMA: 678,
  },
  "67023": {
    DMA: 678,
  },
  "67024": {
    DMA: 671,
  },
  "67025": {
    DMA: 678,
  },
  "67026": {
    DMA: 678,
  },
  "67028": {
    DMA: 678,
  },
  "67029": {
    DMA: 678,
  },
  "67030": {
    DMA: 678,
  },
  "67031": {
    DMA: 678,
  },
  "67035": {
    DMA: 678,
  },
  "67036": {
    DMA: 678,
  },
  "67037": {
    DMA: 678,
  },
  "67038": {
    DMA: 678,
  },
  "67039": {
    DMA: 678,
  },
  "67041": {
    DMA: 678,
  },
  "67042": {
    DMA: 678,
  },
  "67045": {
    DMA: 678,
  },
  "67047": {
    DMA: 678,
  },
  "67049": {
    DMA: 678,
  },
  "67050": {
    DMA: 678,
  },
  "67051": {
    DMA: 678,
  },
  "67052": {
    DMA: 678,
  },
  "67053": {
    DMA: 678,
  },
  "67054": {
    DMA: 678,
  },
  "67055": {
    DMA: 678,
  },
  "67056": {
    DMA: 678,
  },
  "67057": {
    DMA: 678,
  },
  "67058": {
    DMA: 678,
  },
  "67059": {
    DMA: 678,
  },
  "67060": {
    DMA: 678,
  },
  "67061": {
    DMA: 678,
  },
  "67062": {
    DMA: 678,
  },
  "67063": {
    DMA: 678,
  },
  "67065": {
    DMA: 678,
  },
  "67066": {
    DMA: 678,
  },
  "67067": {
    DMA: 678,
  },
  "67068": {
    DMA: 678,
  },
  "67070": {
    DMA: 678,
  },
  "67071": {
    DMA: 678,
  },
  "67072": {
    DMA: 678,
  },
  "67073": {
    DMA: 678,
  },
  "67074": {
    DMA: 678,
  },
  "67101": {
    DMA: 678,
  },
  "67102": {
    DMA: 678,
  },
  "67103": {
    DMA: 678,
  },
  "67104": {
    DMA: 678,
  },
  "67105": {
    DMA: 678,
  },
  "67106": {
    DMA: 678,
  },
  "67107": {
    DMA: 678,
  },
  "67108": {
    DMA: 678,
  },
  "67109": {
    DMA: 678,
  },
  "67110": {
    DMA: 678,
  },
  "67111": {
    DMA: 678,
  },
  "67112": {
    DMA: 678,
  },
  "67114": {
    DMA: 678,
  },
  "67117": {
    DMA: 678,
  },
  "67118": {
    DMA: 678,
  },
  "67119": {
    DMA: 678,
  },
  "67120": {
    DMA: 678,
  },
  "67122": {
    DMA: 678,
  },
  "67123": {
    DMA: 678,
  },
  "67124": {
    DMA: 678,
  },
  "67127": {
    DMA: 678,
  },
  "67131": {
    DMA: 678,
  },
  "67132": {
    DMA: 678,
  },
  "67133": {
    DMA: 678,
  },
  "67134": {
    DMA: 678,
  },
  "67135": {
    DMA: 678,
  },
  "67137": {
    DMA: 678,
  },
  "67138": {
    DMA: 678,
  },
  "67140": {
    DMA: 678,
  },
  "67142": {
    DMA: 678,
  },
  "67143": {
    DMA: 678,
  },
  "67144": {
    DMA: 678,
  },
  "67146": {
    DMA: 678,
  },
  "67147": {
    DMA: 678,
  },
  "67149": {
    DMA: 678,
  },
  "67150": {
    DMA: 678,
  },
  "67151": {
    DMA: 678,
  },
  "67152": {
    DMA: 678,
  },
  "67154": {
    DMA: 678,
  },
  "67155": {
    DMA: 678,
  },
  "67156": {
    DMA: 678,
  },
  "67159": {
    DMA: 678,
  },
  "67201": {
    DMA: 678,
  },
  "67202": {
    DMA: 678,
  },
  "67203": {
    DMA: 678,
  },
  "67204": {
    DMA: 678,
  },
  "67205": {
    DMA: 678,
  },
  "67206": {
    DMA: 678,
  },
  "67207": {
    DMA: 678,
  },
  "67208": {
    DMA: 678,
  },
  "67209": {
    DMA: 678,
  },
  "67210": {
    DMA: 678,
  },
  "67211": {
    DMA: 678,
  },
  "67212": {
    DMA: 678,
  },
  "67213": {
    DMA: 678,
  },
  "67214": {
    DMA: 678,
  },
  "67215": {
    DMA: 678,
  },
  "67216": {
    DMA: 678,
  },
  "67217": {
    DMA: 678,
  },
  "67218": {
    DMA: 678,
  },
  "67219": {
    DMA: 678,
  },
  "67220": {
    DMA: 678,
  },
  "67221": {
    DMA: 678,
  },
  "67223": {
    DMA: 678,
  },
  "67226": {
    DMA: 678,
  },
  "67227": {
    DMA: 678,
  },
  "67228": {
    DMA: 678,
  },
  "67230": {
    DMA: 678,
  },
  "67232": {
    DMA: 678,
  },
  "67235": {
    DMA: 678,
  },
  "67260": {
    DMA: 678,
  },
  "67275": {
    DMA: 678,
  },
  "67276": {
    DMA: 678,
  },
  "67277": {
    DMA: 678,
  },
  "67278": {
    DMA: 678,
  },
  "67301": {
    DMA: 671,
  },
  "67330": {
    DMA: 603,
  },
  "67332": {
    DMA: 603,
  },
  "67333": {
    DMA: 671,
  },
  "67334": {
    DMA: 671,
  },
  "67335": {
    DMA: 671,
  },
  "67336": {
    DMA: 603,
  },
  "67337": {
    DMA: 671,
  },
  "67340": {
    DMA: 671,
  },
  "67341": {
    DMA: 603,
  },
  "67342": {
    DMA: 603,
  },
  "67344": {
    DMA: 671,
  },
  "67345": {
    DMA: 678,
  },
  "67346": {
    DMA: 678,
  },
  "67347": {
    DMA: 671,
  },
  "67349": {
    DMA: 678,
  },
  "67351": {
    DMA: 671,
  },
  "67352": {
    DMA: 678,
  },
  "67353": {
    DMA: 678,
  },
  "67354": {
    DMA: 603,
  },
  "67355": {
    DMA: 671,
  },
  "67356": {
    DMA: 603,
  },
  "67357": {
    DMA: 603,
  },
  "67360": {
    DMA: 671,
  },
  "67361": {
    DMA: 671,
  },
  "67363": {
    DMA: 671,
  },
  "67364": {
    DMA: 671,
  },
  "67401": {
    DMA: 678,
  },
  "67402": {
    DMA: 678,
  },
  "67410": {
    DMA: 678,
  },
  "67416": {
    DMA: 678,
  },
  "67417": {
    DMA: 605,
  },
  "67418": {
    DMA: 678,
  },
  "67420": {
    DMA: 678,
  },
  "67422": {
    DMA: 678,
  },
  "67423": {
    DMA: 678,
  },
  "67425": {
    DMA: 678,
  },
  "67427": {
    DMA: 678,
  },
  "67428": {
    DMA: 678,
  },
  "67430": {
    DMA: 678,
  },
  "67431": {
    DMA: 678,
  },
  "67432": {
    DMA: 605,
  },
  "67436": {
    DMA: 678,
  },
  "67437": {
    DMA: 678,
  },
  "67438": {
    DMA: 678,
  },
  "67439": {
    DMA: 678,
  },
  "67441": {
    DMA: 678,
  },
  "67442": {
    DMA: 678,
  },
  "67443": {
    DMA: 678,
  },
  "67444": {
    DMA: 678,
  },
  "67445": {
    DMA: 605,
  },
  "67446": {
    DMA: 678,
  },
  "67447": {
    DMA: 605,
  },
  "67448": {
    DMA: 678,
  },
  "67449": {
    DMA: 678,
  },
  "67450": {
    DMA: 678,
  },
  "67451": {
    DMA: 678,
  },
  "67452": {
    DMA: 678,
  },
  "67454": {
    DMA: 678,
  },
  "67455": {
    DMA: 678,
  },
  "67456": {
    DMA: 678,
  },
  "67457": {
    DMA: 678,
  },
  "67458": {
    DMA: 605,
  },
  "67459": {
    DMA: 678,
  },
  "67460": {
    DMA: 678,
  },
  "67464": {
    DMA: 678,
  },
  "67466": {
    DMA: 605,
  },
  "67467": {
    DMA: 678,
  },
  "67468": {
    DMA: 605,
  },
  "67470": {
    DMA: 678,
  },
  "67473": {
    DMA: 678,
  },
  "67474": {
    DMA: 678,
  },
  "67475": {
    DMA: 678,
  },
  "67476": {
    DMA: 678,
  },
  "67478": {
    DMA: 678,
  },
  "67480": {
    DMA: 678,
  },
  "67481": {
    DMA: 678,
  },
  "67482": {
    DMA: 678,
  },
  "67483": {
    DMA: 678,
  },
  "67484": {
    DMA: 678,
  },
  "67485": {
    DMA: 678,
  },
  "67487": {
    DMA: 605,
  },
  "67490": {
    DMA: 678,
  },
  "67491": {
    DMA: 678,
  },
  "67492": {
    DMA: 678,
  },
  "67501": {
    DMA: 678,
  },
  "67502": {
    DMA: 678,
  },
  "67504": {
    DMA: 678,
  },
  "67505": {
    DMA: 678,
  },
  "67510": {
    DMA: 678,
  },
  "67511": {
    DMA: 678,
  },
  "67512": {
    DMA: 678,
  },
  "67513": {
    DMA: 678,
  },
  "67514": {
    DMA: 678,
  },
  "67515": {
    DMA: 678,
  },
  "67516": {
    DMA: 678,
  },
  "67518": {
    DMA: 678,
  },
  "67519": {
    DMA: 678,
  },
  "67520": {
    DMA: 678,
  },
  "67521": {
    DMA: 678,
  },
  "67522": {
    DMA: 678,
  },
  "67523": {
    DMA: 678,
  },
  "67524": {
    DMA: 678,
  },
  "67525": {
    DMA: 678,
  },
  "67526": {
    DMA: 678,
  },
  "67529": {
    DMA: 678,
  },
  "67530": {
    DMA: 678,
  },
  "67543": {
    DMA: 678,
  },
  "67544": {
    DMA: 678,
  },
  "67545": {
    DMA: 678,
  },
  "67546": {
    DMA: 678,
  },
  "67547": {
    DMA: 678,
  },
  "67548": {
    DMA: 678,
  },
  "67550": {
    DMA: 678,
  },
  "67552": {
    DMA: 678,
  },
  "67553": {
    DMA: 678,
  },
  "67554": {
    DMA: 678,
  },
  "67556": {
    DMA: 678,
  },
  "67557": {
    DMA: 678,
  },
  "67559": {
    DMA: 678,
  },
  "67560": {
    DMA: 678,
  },
  "67561": {
    DMA: 678,
  },
  "67563": {
    DMA: 678,
  },
  "67564": {
    DMA: 678,
  },
  "67565": {
    DMA: 678,
  },
  "67566": {
    DMA: 678,
  },
  "67567": {
    DMA: 678,
  },
  "67568": {
    DMA: 678,
  },
  "67570": {
    DMA: 678,
  },
  "67572": {
    DMA: 678,
  },
  "67573": {
    DMA: 678,
  },
  "67574": {
    DMA: 678,
  },
  "67575": {
    DMA: 678,
  },
  "67576": {
    DMA: 678,
  },
  "67578": {
    DMA: 678,
  },
  "67579": {
    DMA: 678,
  },
  "67581": {
    DMA: 678,
  },
  "67583": {
    DMA: 678,
  },
  "67584": {
    DMA: 678,
  },
  "67585": {
    DMA: 678,
  },
  "67601": {
    DMA: 678,
  },
  "67621": {
    DMA: 722,
  },
  "67622": {
    DMA: 678,
  },
  "67623": {
    DMA: 678,
  },
  "67625": {
    DMA: 678,
  },
  "67626": {
    DMA: 678,
  },
  "67627": {
    DMA: 678,
  },
  "67628": {
    DMA: 722,
  },
  "67629": {
    DMA: 678,
  },
  "67631": {
    DMA: 678,
  },
  "67632": {
    DMA: 678,
  },
  "67634": {
    DMA: 678,
  },
  "67635": {
    DMA: 678,
  },
  "67637": {
    DMA: 678,
  },
  "67638": {
    DMA: 722,
  },
  "67639": {
    DMA: 722,
  },
  "67640": {
    DMA: 678,
  },
  "67642": {
    DMA: 678,
  },
  "67643": {
    DMA: 678,
  },
  "67644": {
    DMA: 722,
  },
  "67645": {
    DMA: 678,
  },
  "67646": {
    DMA: 722,
  },
  "67647": {
    DMA: 722,
  },
  "67648": {
    DMA: 678,
  },
  "67649": {
    DMA: 678,
  },
  "67650": {
    DMA: 678,
  },
  "67651": {
    DMA: 678,
  },
  "67653": {
    DMA: 678,
  },
  "67654": {
    DMA: 678,
  },
  "67656": {
    DMA: 678,
  },
  "67657": {
    DMA: 678,
  },
  "67658": {
    DMA: 678,
  },
  "67659": {
    DMA: 678,
  },
  "67660": {
    DMA: 678,
  },
  "67661": {
    DMA: 722,
  },
  "67663": {
    DMA: 678,
  },
  "67664": {
    DMA: 722,
  },
  "67665": {
    DMA: 678,
  },
  "67667": {
    DMA: 678,
  },
  "67669": {
    DMA: 678,
  },
  "67671": {
    DMA: 678,
  },
  "67672": {
    DMA: 678,
  },
  "67673": {
    DMA: 678,
  },
  "67674": {
    DMA: 678,
  },
  "67675": {
    DMA: 678,
  },
  "67701": {
    DMA: 678,
  },
  "67730": {
    DMA: 678,
  },
  "67731": {
    DMA: 678,
  },
  "67732": {
    DMA: 678,
  },
  "67733": {
    DMA: 678,
  },
  "67734": {
    DMA: 678,
  },
  "67735": {
    DMA: 678,
  },
  "67736": {
    DMA: 678,
  },
  "67737": {
    DMA: 678,
  },
  "67738": {
    DMA: 678,
  },
  "67739": {
    DMA: 678,
  },
  "67740": {
    DMA: 678,
  },
  "67741": {
    DMA: 678,
  },
  "67743": {
    DMA: 678,
  },
  "67744": {
    DMA: 678,
  },
  "67745": {
    DMA: 678,
  },
  "67747": {
    DMA: 678,
  },
  "67748": {
    DMA: 678,
  },
  "67749": {
    DMA: 678,
  },
  "67751": {
    DMA: 678,
  },
  "67752": {
    DMA: 678,
  },
  "67753": {
    DMA: 678,
  },
  "67756": {
    DMA: 678,
  },
  "67757": {
    DMA: 678,
  },
  "67758": {
    DMA: 678,
  },
  "67761": {
    DMA: 678,
  },
  "67762": {
    DMA: 678,
  },
  "67764": {
    DMA: 678,
  },
  "67801": {
    DMA: 678,
  },
  "67831": {
    DMA: 678,
  },
  "67834": {
    DMA: 678,
  },
  "67835": {
    DMA: 678,
  },
  "67836": {
    DMA: 678,
  },
  "67837": {
    DMA: 678,
  },
  "67838": {
    DMA: 678,
  },
  "67839": {
    DMA: 678,
  },
  "67840": {
    DMA: 678,
  },
  "67841": {
    DMA: 678,
  },
  "67842": {
    DMA: 678,
  },
  "67843": {
    DMA: 678,
  },
  "67844": {
    DMA: 678,
  },
  "67846": {
    DMA: 678,
  },
  "67849": {
    DMA: 678,
  },
  "67850": {
    DMA: 678,
  },
  "67851": {
    DMA: 678,
  },
  "67853": {
    DMA: 678,
  },
  "67854": {
    DMA: 678,
  },
  "67855": {
    DMA: 678,
  },
  "67857": {
    DMA: 678,
  },
  "67859": {
    DMA: 678,
  },
  "67860": {
    DMA: 678,
  },
  "67861": {
    DMA: 678,
  },
  "67862": {
    DMA: 678,
  },
  "67863": {
    DMA: 678,
  },
  "67864": {
    DMA: 678,
  },
  "67865": {
    DMA: 678,
  },
  "67867": {
    DMA: 678,
  },
  "67868": {
    DMA: 678,
  },
  "67869": {
    DMA: 678,
  },
  "67870": {
    DMA: 678,
  },
  "67871": {
    DMA: 678,
  },
  "67876": {
    DMA: 678,
  },
  "67877": {
    DMA: 678,
  },
  "67878": {
    DMA: 678,
  },
  "67879": {
    DMA: 678,
  },
  "67880": {
    DMA: 678,
  },
  "67882": {
    DMA: 678,
  },
  "67901": {
    DMA: 678,
  },
  "67905": {
    DMA: 678,
  },
  "67950": {
    DMA: 678,
  },
  "67951": {
    DMA: 678,
  },
  "67952": {
    DMA: 678,
  },
  "67953": {
    DMA: 678,
  },
  "67954": {
    DMA: 678,
  },
  "68001": {
    DMA: 722,
  },
  "68002": {
    DMA: 652,
  },
  "68003": {
    DMA: 652,
  },
  "68004": {
    DMA: 652,
  },
  "68005": {
    DMA: 652,
  },
  "68007": {
    DMA: 652,
  },
  "68008": {
    DMA: 652,
  },
  "68009": {
    DMA: 652,
  },
  "68010": {
    DMA: 652,
  },
  "68014": {
    DMA: 722,
  },
  "68015": {
    DMA: 652,
  },
  "68016": {
    DMA: 652,
  },
  "68017": {
    DMA: 652,
  },
  "68018": {
    DMA: 652,
  },
  "68019": {
    DMA: 652,
  },
  "68020": {
    DMA: 652,
  },
  "68022": {
    DMA: 652,
  },
  "68023": {
    DMA: 652,
  },
  "68025": {
    DMA: 652,
  },
  "68026": {
    DMA: 652,
  },
  "68028": {
    DMA: 652,
  },
  "68029": {
    DMA: 652,
  },
  "68030": {
    DMA: 624,
  },
  "68031": {
    DMA: 652,
  },
  "68033": {
    DMA: 652,
  },
  "68034": {
    DMA: 652,
  },
  "68036": {
    DMA: 722,
  },
  "68037": {
    DMA: 652,
  },
  "68038": {
    DMA: 652,
  },
  "68039": {
    DMA: 624,
  },
  "68040": {
    DMA: 652,
  },
  "68041": {
    DMA: 652,
  },
  "68042": {
    DMA: 652,
  },
  "68044": {
    DMA: 652,
  },
  "68045": {
    DMA: 652,
  },
  "68046": {
    DMA: 652,
  },
  "68047": {
    DMA: 624,
  },
  "68048": {
    DMA: 652,
  },
  "68050": {
    DMA: 652,
  },
  "68055": {
    DMA: 624,
  },
  "68056": {
    DMA: 652,
  },
  "68057": {
    DMA: 652,
  },
  "68058": {
    DMA: 652,
  },
  "68059": {
    DMA: 652,
  },
  "68061": {
    DMA: 652,
  },
  "68062": {
    DMA: 624,
  },
  "68063": {
    DMA: 652,
  },
  "68064": {
    DMA: 652,
  },
  "68065": {
    DMA: 652,
  },
  "68066": {
    DMA: 652,
  },
  "68067": {
    DMA: 624,
  },
  "68068": {
    DMA: 652,
  },
  "68069": {
    DMA: 652,
  },
  "68070": {
    DMA: 652,
  },
  "68071": {
    DMA: 624,
  },
  "68072": {
    DMA: 652,
  },
  "68073": {
    DMA: 652,
  },
  "68101": {
    DMA: 652,
  },
  "68102": {
    DMA: 652,
  },
  "68103": {
    DMA: 652,
  },
  "68104": {
    DMA: 652,
  },
  "68105": {
    DMA: 652,
  },
  "68106": {
    DMA: 652,
  },
  "68107": {
    DMA: 652,
  },
  "68108": {
    DMA: 652,
  },
  "68109": {
    DMA: 652,
  },
  "68110": {
    DMA: 652,
  },
  "68111": {
    DMA: 652,
  },
  "68112": {
    DMA: 652,
  },
  "68113": {
    DMA: 652,
  },
  "68114": {
    DMA: 652,
  },
  "68116": {
    DMA: 652,
  },
  "68117": {
    DMA: 652,
  },
  "68118": {
    DMA: 652,
  },
  "68119": {
    DMA: 652,
  },
  "68120": {
    DMA: 652,
  },
  "68122": {
    DMA: 652,
  },
  "68123": {
    DMA: 652,
  },
  "68124": {
    DMA: 652,
  },
  "68127": {
    DMA: 652,
  },
  "68128": {
    DMA: 652,
  },
  "68130": {
    DMA: 652,
  },
  "68131": {
    DMA: 652,
  },
  "68132": {
    DMA: 652,
  },
  "68133": {
    DMA: 652,
  },
  "68134": {
    DMA: 652,
  },
  "68135": {
    DMA: 652,
  },
  "68136": {
    DMA: 652,
  },
  "68137": {
    DMA: 652,
  },
  "68138": {
    DMA: 652,
  },
  "68139": {
    DMA: 652,
  },
  "68142": {
    DMA: 652,
  },
  "68144": {
    DMA: 652,
  },
  "68145": {
    DMA: 652,
  },
  "68147": {
    DMA: 652,
  },
  "68152": {
    DMA: 652,
  },
  "68154": {
    DMA: 652,
  },
  "68155": {
    DMA: 652,
  },
  "68157": {
    DMA: 652,
  },
  "68164": {
    DMA: 652,
  },
  "68172": {
    DMA: 652,
  },
  "68175": {
    DMA: 652,
  },
  "68176": {
    DMA: 652,
  },
  "68178": {
    DMA: 652,
  },
  "68179": {
    DMA: 652,
  },
  "68180": {
    DMA: 652,
  },
  "68181": {
    DMA: 652,
  },
  "68182": {
    DMA: 652,
  },
  "68183": {
    DMA: 652,
  },
  "68197": {
    DMA: 652,
  },
  "68198": {
    DMA: 652,
  },
  "68301": {
    DMA: 722,
  },
  "68303": {
    DMA: 722,
  },
  "68304": {
    DMA: 652,
  },
  "68305": {
    DMA: 652,
  },
  "68307": {
    DMA: 652,
  },
  "68309": {
    DMA: 722,
  },
  "68310": {
    DMA: 722,
  },
  "68313": {
    DMA: 722,
  },
  "68314": {
    DMA: 722,
  },
  "68315": {
    DMA: 722,
  },
  "68316": {
    DMA: 722,
  },
  "68317": {
    DMA: 722,
  },
  "68318": {
    DMA: 722,
  },
  "68319": {
    DMA: 722,
  },
  "68320": {
    DMA: 652,
  },
  "68321": {
    DMA: 652,
  },
  "68322": {
    DMA: 722,
  },
  "68323": {
    DMA: 722,
  },
  "68324": {
    DMA: 652,
  },
  "68325": {
    DMA: 722,
  },
  "68326": {
    DMA: 722,
  },
  "68327": {
    DMA: 722,
  },
  "68328": {
    DMA: 722,
  },
  "68329": {
    DMA: 652,
  },
  "68330": {
    DMA: 722,
  },
  "68331": {
    DMA: 722,
  },
  "68332": {
    DMA: 652,
  },
  "68333": {
    DMA: 722,
  },
  "68335": {
    DMA: 722,
  },
  "68336": {
    DMA: 722,
  },
  "68337": {
    DMA: 652,
  },
  "68338": {
    DMA: 722,
  },
  "68339": {
    DMA: 722,
  },
  "68340": {
    DMA: 722,
  },
  "68341": {
    DMA: 722,
  },
  "68342": {
    DMA: 722,
  },
  "68343": {
    DMA: 722,
  },
  "68344": {
    DMA: 652,
  },
  "68345": {
    DMA: 722,
  },
  "68346": {
    DMA: 652,
  },
  "68347": {
    DMA: 652,
  },
  "68348": {
    DMA: 652,
  },
  "68349": {
    DMA: 652,
  },
  "68350": {
    DMA: 722,
  },
  "68351": {
    DMA: 722,
  },
  "68352": {
    DMA: 722,
  },
  "68354": {
    DMA: 722,
  },
  "68355": {
    DMA: 652,
  },
  "68357": {
    DMA: 722,
  },
  "68358": {
    DMA: 722,
  },
  "68359": {
    DMA: 722,
  },
  "68360": {
    DMA: 722,
  },
  "68361": {
    DMA: 722,
  },
  "68362": {
    DMA: 722,
  },
  "68364": {
    DMA: 722,
  },
  "68365": {
    DMA: 722,
  },
  "68366": {
    DMA: 652,
  },
  "68367": {
    DMA: 722,
  },
  "68368": {
    DMA: 722,
  },
  "68370": {
    DMA: 722,
  },
  "68371": {
    DMA: 722,
  },
  "68372": {
    DMA: 722,
  },
  "68375": {
    DMA: 722,
  },
  "68376": {
    DMA: 652,
  },
  "68377": {
    DMA: 722,
  },
  "68378": {
    DMA: 652,
  },
  "68379": {
    DMA: 652,
  },
  "68380": {
    DMA: 722,
  },
  "68381": {
    DMA: 722,
  },
  "68382": {
    DMA: 652,
  },
  "68401": {
    DMA: 722,
  },
  "68402": {
    DMA: 722,
  },
  "68403": {
    DMA: 652,
  },
  "68404": {
    DMA: 722,
  },
  "68405": {
    DMA: 722,
  },
  "68406": {
    DMA: 722,
  },
  "68407": {
    DMA: 652,
  },
  "68409": {
    DMA: 652,
  },
  "68410": {
    DMA: 652,
  },
  "68413": {
    DMA: 652,
  },
  "68414": {
    DMA: 652,
  },
  "68415": {
    DMA: 722,
  },
  "68416": {
    DMA: 722,
  },
  "68417": {
    DMA: 652,
  },
  "68418": {
    DMA: 652,
  },
  "68419": {
    DMA: 722,
  },
  "68420": {
    DMA: 722,
  },
  "68421": {
    DMA: 652,
  },
  "68422": {
    DMA: 722,
  },
  "68423": {
    DMA: 722,
  },
  "68424": {
    DMA: 722,
  },
  "68428": {
    DMA: 722,
  },
  "68429": {
    DMA: 722,
  },
  "68430": {
    DMA: 722,
  },
  "68431": {
    DMA: 652,
  },
  "68433": {
    DMA: 652,
  },
  "68434": {
    DMA: 722,
  },
  "68436": {
    DMA: 722,
  },
  "68437": {
    DMA: 652,
  },
  "68438": {
    DMA: 722,
  },
  "68439": {
    DMA: 722,
  },
  "68440": {
    DMA: 722,
  },
  "68441": {
    DMA: 722,
  },
  "68442": {
    DMA: 652,
  },
  "68443": {
    DMA: 652,
  },
  "68444": {
    DMA: 722,
  },
  "68445": {
    DMA: 722,
  },
  "68446": {
    DMA: 652,
  },
  "68447": {
    DMA: 722,
  },
  "68448": {
    DMA: 652,
  },
  "68450": {
    DMA: 652,
  },
  "68452": {
    DMA: 722,
  },
  "68453": {
    DMA: 722,
  },
  "68454": {
    DMA: 652,
  },
  "68455": {
    DMA: 652,
  },
  "68456": {
    DMA: 722,
  },
  "68457": {
    DMA: 652,
  },
  "68458": {
    DMA: 722,
  },
  "68460": {
    DMA: 722,
  },
  "68461": {
    DMA: 722,
  },
  "68462": {
    DMA: 722,
  },
  "68463": {
    DMA: 652,
  },
  "68464": {
    DMA: 722,
  },
  "68465": {
    DMA: 722,
  },
  "68466": {
    DMA: 722,
  },
  "68467": {
    DMA: 722,
  },
  "68501": {
    DMA: 722,
  },
  "68502": {
    DMA: 722,
  },
  "68503": {
    DMA: 722,
  },
  "68504": {
    DMA: 722,
  },
  "68505": {
    DMA: 722,
  },
  "68506": {
    DMA: 722,
  },
  "68507": {
    DMA: 722,
  },
  "68508": {
    DMA: 722,
  },
  "68509": {
    DMA: 722,
  },
  "68510": {
    DMA: 722,
  },
  "68512": {
    DMA: 722,
  },
  "68514": {
    DMA: 722,
  },
  "68516": {
    DMA: 722,
  },
  "68517": {
    DMA: 722,
  },
  "68520": {
    DMA: 722,
  },
  "68521": {
    DMA: 722,
  },
  "68522": {
    DMA: 722,
  },
  "68523": {
    DMA: 722,
  },
  "68524": {
    DMA: 722,
  },
  "68526": {
    DMA: 722,
  },
  "68527": {
    DMA: 722,
  },
  "68528": {
    DMA: 722,
  },
  "68529": {
    DMA: 722,
  },
  "68531": {
    DMA: 722,
  },
  "68532": {
    DMA: 722,
  },
  "68542": {
    DMA: 722,
  },
  "68544": {
    DMA: 722,
  },
  "68583": {
    DMA: 722,
  },
  "68588": {
    DMA: 722,
  },
  "68601": {
    DMA: 652,
  },
  "68602": {
    DMA: 652,
  },
  "68620": {
    DMA: 722,
  },
  "68621": {
    DMA: 652,
  },
  "68622": {
    DMA: 722,
  },
  "68623": {
    DMA: 722,
  },
  "68624": {
    DMA: 722,
  },
  "68626": {
    DMA: 722,
  },
  "68627": {
    DMA: 722,
  },
  "68628": {
    DMA: 722,
  },
  "68629": {
    DMA: 652,
  },
  "68631": {
    DMA: 652,
  },
  "68632": {
    DMA: 722,
  },
  "68633": {
    DMA: 652,
  },
  "68634": {
    DMA: 652,
  },
  "68635": {
    DMA: 722,
  },
  "68636": {
    DMA: 722,
  },
  "68637": {
    DMA: 722,
  },
  "68638": {
    DMA: 722,
  },
  "68640": {
    DMA: 722,
  },
  "68641": {
    DMA: 652,
  },
  "68642": {
    DMA: 652,
  },
  "68643": {
    DMA: 652,
  },
  "68644": {
    DMA: 652,
  },
  "68647": {
    DMA: 652,
  },
  "68648": {
    DMA: 652,
  },
  "68649": {
    DMA: 652,
  },
  "68651": {
    DMA: 722,
  },
  "68652": {
    DMA: 722,
  },
  "68653": {
    DMA: 652,
  },
  "68654": {
    DMA: 722,
  },
  "68655": {
    DMA: 722,
  },
  "68658": {
    DMA: 722,
  },
  "68659": {
    DMA: 652,
  },
  "68660": {
    DMA: 722,
  },
  "68661": {
    DMA: 652,
  },
  "68662": {
    DMA: 722,
  },
  "68663": {
    DMA: 722,
  },
  "68664": {
    DMA: 652,
  },
  "68665": {
    DMA: 722,
  },
  "68666": {
    DMA: 722,
  },
  "68667": {
    DMA: 722,
  },
  "68669": {
    DMA: 722,
  },
  "68701": {
    DMA: 624,
  },
  "68702": {
    DMA: 624,
  },
  "68710": {
    DMA: 624,
  },
  "68711": {
    DMA: 722,
  },
  "68713": {
    DMA: 722,
  },
  "68714": {
    DMA: 722,
  },
  "68715": {
    DMA: 624,
  },
  "68716": {
    DMA: 652,
  },
  "68717": {
    DMA: 624,
  },
  "68718": {
    DMA: 624,
  },
  "68719": {
    DMA: 722,
  },
  "68720": {
    DMA: 722,
  },
  "68722": {
    DMA: 722,
  },
  "68723": {
    DMA: 624,
  },
  "68724": {
    DMA: 624,
  },
  "68725": {
    DMA: 722,
  },
  "68726": {
    DMA: 722,
  },
  "68727": {
    DMA: 624,
  },
  "68728": {
    DMA: 624,
  },
  "68729": {
    DMA: 624,
  },
  "68730": {
    DMA: 624,
  },
  "68731": {
    DMA: 624,
  },
  "68732": {
    DMA: 624,
  },
  "68733": {
    DMA: 624,
  },
  "68734": {
    DMA: 722,
  },
  "68735": {
    DMA: 722,
  },
  "68736": {
    DMA: 624,
  },
  "68738": {
    DMA: 624,
  },
  "68739": {
    DMA: 624,
  },
  "68740": {
    DMA: 624,
  },
  "68741": {
    DMA: 624,
  },
  "68742": {
    DMA: 722,
  },
  "68743": {
    DMA: 624,
  },
  "68745": {
    DMA: 624,
  },
  "68746": {
    DMA: 722,
  },
  "68747": {
    DMA: 624,
  },
  "68748": {
    DMA: 624,
  },
  "68749": {
    DMA: 624,
  },
  "68751": {
    DMA: 624,
  },
  "68752": {
    DMA: 624,
  },
  "68753": {
    DMA: 722,
  },
  "68755": {
    DMA: 722,
  },
  "68756": {
    DMA: 722,
  },
  "68757": {
    DMA: 624,
  },
  "68758": {
    DMA: 624,
  },
  "68759": {
    DMA: 722,
  },
  "68760": {
    DMA: 624,
  },
  "68761": {
    DMA: 722,
  },
  "68763": {
    DMA: 722,
  },
  "68764": {
    DMA: 722,
  },
  "68765": {
    DMA: 624,
  },
  "68766": {
    DMA: 722,
  },
  "68767": {
    DMA: 624,
  },
  "68768": {
    DMA: 624,
  },
  "68769": {
    DMA: 624,
  },
  "68770": {
    DMA: 624,
  },
  "68771": {
    DMA: 624,
  },
  "68773": {
    DMA: 722,
  },
  "68774": {
    DMA: 624,
  },
  "68776": {
    DMA: 624,
  },
  "68777": {
    DMA: 722,
  },
  "68778": {
    DMA: 722,
  },
  "68779": {
    DMA: 624,
  },
  "68780": {
    DMA: 722,
  },
  "68781": {
    DMA: 624,
  },
  "68783": {
    DMA: 624,
  },
  "68784": {
    DMA: 624,
  },
  "68785": {
    DMA: 624,
  },
  "68786": {
    DMA: 624,
  },
  "68787": {
    DMA: 624,
  },
  "68788": {
    DMA: 652,
  },
  "68789": {
    DMA: 624,
  },
  "68790": {
    DMA: 624,
  },
  "68791": {
    DMA: 652,
  },
  "68792": {
    DMA: 624,
  },
  "68801": {
    DMA: 722,
  },
  "68802": {
    DMA: 722,
  },
  "68803": {
    DMA: 722,
  },
  "68810": {
    DMA: 722,
  },
  "68812": {
    DMA: 722,
  },
  "68813": {
    DMA: 722,
  },
  "68814": {
    DMA: 722,
  },
  "68815": {
    DMA: 722,
  },
  "68816": {
    DMA: 722,
  },
  "68817": {
    DMA: 722,
  },
  "68818": {
    DMA: 722,
  },
  "68820": {
    DMA: 722,
  },
  "68821": {
    DMA: 722,
  },
  "68822": {
    DMA: 722,
  },
  "68823": {
    DMA: 722,
  },
  "68824": {
    DMA: 722,
  },
  "68825": {
    DMA: 722,
  },
  "68826": {
    DMA: 722,
  },
  "68827": {
    DMA: 722,
  },
  "68828": {
    DMA: 722,
  },
  "68831": {
    DMA: 722,
  },
  "68832": {
    DMA: 722,
  },
  "68833": {
    DMA: 722,
  },
  "68834": {
    DMA: 722,
  },
  "68835": {
    DMA: 722,
  },
  "68836": {
    DMA: 722,
  },
  "68837": {
    DMA: 722,
  },
  "68838": {
    DMA: 722,
  },
  "68840": {
    DMA: 722,
  },
  "68841": {
    DMA: 722,
  },
  "68842": {
    DMA: 722,
  },
  "68843": {
    DMA: 722,
  },
  "68844": {
    DMA: 722,
  },
  "68845": {
    DMA: 722,
  },
  "68846": {
    DMA: 722,
  },
  "68847": {
    DMA: 722,
  },
  "68848": {
    DMA: 722,
  },
  "68849": {
    DMA: 722,
  },
  "68850": {
    DMA: 722,
  },
  "68852": {
    DMA: 722,
  },
  "68853": {
    DMA: 722,
  },
  "68854": {
    DMA: 722,
  },
  "68855": {
    DMA: 722,
  },
  "68856": {
    DMA: 722,
  },
  "68858": {
    DMA: 722,
  },
  "68859": {
    DMA: 722,
  },
  "68860": {
    DMA: 722,
  },
  "68861": {
    DMA: 722,
  },
  "68862": {
    DMA: 722,
  },
  "68863": {
    DMA: 722,
  },
  "68864": {
    DMA: 722,
  },
  "68865": {
    DMA: 722,
  },
  "68866": {
    DMA: 722,
  },
  "68869": {
    DMA: 722,
  },
  "68870": {
    DMA: 722,
  },
  "68871": {
    DMA: 722,
  },
  "68872": {
    DMA: 722,
  },
  "68873": {
    DMA: 722,
  },
  "68874": {
    DMA: 722,
  },
  "68875": {
    DMA: 722,
  },
  "68876": {
    DMA: 722,
  },
  "68878": {
    DMA: 722,
  },
  "68879": {
    DMA: 722,
  },
  "68881": {
    DMA: 722,
  },
  "68882": {
    DMA: 722,
  },
  "68883": {
    DMA: 722,
  },
  "68901": {
    DMA: 722,
  },
  "68902": {
    DMA: 722,
  },
  "68920": {
    DMA: 722,
  },
  "68922": {
    DMA: 722,
  },
  "68923": {
    DMA: 722,
  },
  "68924": {
    DMA: 722,
  },
  "68925": {
    DMA: 722,
  },
  "68926": {
    DMA: 722,
  },
  "68927": {
    DMA: 722,
  },
  "68928": {
    DMA: 722,
  },
  "68929": {
    DMA: 722,
  },
  "68930": {
    DMA: 722,
  },
  "68932": {
    DMA: 722,
  },
  "68933": {
    DMA: 722,
  },
  "68934": {
    DMA: 722,
  },
  "68935": {
    DMA: 722,
  },
  "68936": {
    DMA: 722,
  },
  "68937": {
    DMA: 722,
  },
  "68938": {
    DMA: 722,
  },
  "68939": {
    DMA: 722,
  },
  "68940": {
    DMA: 722,
  },
  "68941": {
    DMA: 722,
  },
  "68942": {
    DMA: 722,
  },
  "68943": {
    DMA: 722,
  },
  "68944": {
    DMA: 722,
  },
  "68945": {
    DMA: 722,
  },
  "68946": {
    DMA: 722,
  },
  "68947": {
    DMA: 722,
  },
  "68948": {
    DMA: 722,
  },
  "68949": {
    DMA: 722,
  },
  "68950": {
    DMA: 722,
  },
  "68952": {
    DMA: 722,
  },
  "68954": {
    DMA: 722,
  },
  "68955": {
    DMA: 722,
  },
  "68956": {
    DMA: 722,
  },
  "68957": {
    DMA: 722,
  },
  "68958": {
    DMA: 722,
  },
  "68959": {
    DMA: 722,
  },
  "68960": {
    DMA: 722,
  },
  "68961": {
    DMA: 722,
  },
  "68964": {
    DMA: 722,
  },
  "68966": {
    DMA: 722,
  },
  "68967": {
    DMA: 722,
  },
  "68969": {
    DMA: 722,
  },
  "68970": {
    DMA: 722,
  },
  "68971": {
    DMA: 722,
  },
  "68972": {
    DMA: 722,
  },
  "68973": {
    DMA: 722,
  },
  "68974": {
    DMA: 722,
  },
  "68975": {
    DMA: 722,
  },
  "68976": {
    DMA: 722,
  },
  "68977": {
    DMA: 722,
  },
  "68978": {
    DMA: 722,
  },
  "68979": {
    DMA: 722,
  },
  "68980": {
    DMA: 722,
  },
  "68981": {
    DMA: 722,
  },
  "68982": {
    DMA: 722,
  },
  "69001": {
    DMA: 722,
  },
  "69020": {
    DMA: 722,
  },
  "69021": {
    DMA: 678,
  },
  "69022": {
    DMA: 722,
  },
  "69023": {
    DMA: 722,
  },
  "69024": {
    DMA: 722,
  },
  "69025": {
    DMA: 722,
  },
  "69026": {
    DMA: 722,
  },
  "69027": {
    DMA: 722,
  },
  "69028": {
    DMA: 722,
  },
  "69029": {
    DMA: 722,
  },
  "69030": {
    DMA: 678,
  },
  "69032": {
    DMA: 722,
  },
  "69033": {
    DMA: 722,
  },
  "69034": {
    DMA: 722,
  },
  "69036": {
    DMA: 722,
  },
  "69037": {
    DMA: 678,
  },
  "69038": {
    DMA: 722,
  },
  "69039": {
    DMA: 722,
  },
  "69040": {
    DMA: 722,
  },
  "69041": {
    DMA: 678,
  },
  "69042": {
    DMA: 722,
  },
  "69043": {
    DMA: 722,
  },
  "69044": {
    DMA: 722,
  },
  "69045": {
    DMA: 722,
  },
  "69046": {
    DMA: 722,
  },
  "69101": {
    DMA: 740,
  },
  "69103": {
    DMA: 740,
  },
  "69120": {
    DMA: 722,
  },
  "69121": {
    DMA: 751,
  },
  "69122": {
    DMA: 751,
  },
  "69123": {
    DMA: 740,
  },
  "69125": {
    DMA: 764,
  },
  "69127": {
    DMA: 751,
  },
  "69128": {
    DMA: 751,
  },
  "69129": {
    DMA: 751,
  },
  "69130": {
    DMA: 722,
  },
  "69131": {
    DMA: 751,
  },
  "69132": {
    DMA: 740,
  },
  "69133": {
    DMA: 751,
  },
  "69134": {
    DMA: 722,
  },
  "69135": {
    DMA: 751,
  },
  "69138": {
    DMA: 722,
  },
  "69140": {
    DMA: 722,
  },
  "69141": {
    DMA: 751,
  },
  "69142": {
    DMA: 740,
  },
  "69143": {
    DMA: 740,
  },
  "69144": {
    DMA: 751,
  },
  "69145": {
    DMA: 751,
  },
  "69146": {
    DMA: 751,
  },
  "69147": {
    DMA: 751,
  },
  "69148": {
    DMA: 751,
  },
  "69149": {
    DMA: 751,
  },
  "69150": {
    DMA: 722,
  },
  "69151": {
    DMA: 740,
  },
  "69152": {
    DMA: 751,
  },
  "69153": {
    DMA: 751,
  },
  "69154": {
    DMA: 751,
  },
  "69155": {
    DMA: 751,
  },
  "69156": {
    DMA: 751,
  },
  "69157": {
    DMA: 722,
  },
  "69160": {
    DMA: 751,
  },
  "69161": {
    DMA: 740,
  },
  "69162": {
    DMA: 751,
  },
  "69163": {
    DMA: 740,
  },
  "69165": {
    DMA: 740,
  },
  "69166": {
    DMA: 740,
  },
  "69167": {
    DMA: 740,
  },
  "69168": {
    DMA: 722,
  },
  "69169": {
    DMA: 740,
  },
  "69170": {
    DMA: 740,
  },
  "69171": {
    DMA: 722,
  },
  "69190": {
    DMA: 751,
  },
  "69201": {
    DMA: 751,
  },
  "69210": {
    DMA: 722,
  },
  "69211": {
    DMA: 751,
  },
  "69212": {
    DMA: 751,
  },
  "69214": {
    DMA: 722,
  },
  "69216": {
    DMA: 751,
  },
  "69217": {
    DMA: 722,
  },
  "69218": {
    DMA: 751,
  },
  "69219": {
    DMA: 751,
  },
  "69220": {
    DMA: 751,
  },
  "69221": {
    DMA: 751,
  },
  "69301": {
    DMA: 751,
  },
  "69331": {
    DMA: 764,
  },
  "69333": {
    DMA: 751,
  },
  "69334": {
    DMA: 764,
  },
  "69335": {
    DMA: 751,
  },
  "69336": {
    DMA: 764,
  },
  "69337": {
    DMA: 751,
  },
  "69339": {
    DMA: 751,
  },
  "69340": {
    DMA: 751,
  },
  "69341": {
    DMA: 759,
  },
  "69343": {
    DMA: 751,
  },
  "69345": {
    DMA: 751,
  },
  "69346": {
    DMA: 759,
  },
  "69347": {
    DMA: 751,
  },
  "69348": {
    DMA: 751,
  },
  "69350": {
    DMA: 751,
  },
  "69351": {
    DMA: 751,
  },
  "69352": {
    DMA: 759,
  },
  "69353": {
    DMA: 759,
  },
  "69354": {
    DMA: 751,
  },
  "69355": {
    DMA: 759,
  },
  "69356": {
    DMA: 759,
  },
  "69357": {
    DMA: 759,
  },
  "69358": {
    DMA: 759,
  },
  "69360": {
    DMA: 751,
  },
  "69361": {
    DMA: 759,
  },
  "69363": {
    DMA: 759,
  },
  "69365": {
    DMA: 751,
  },
  "69366": {
    DMA: 751,
  },
  "69367": {
    DMA: 751,
  },
  "70001": {
    DMA: 622,
  },
  "70002": {
    DMA: 622,
  },
  "70003": {
    DMA: 622,
  },
  "70004": {
    DMA: 622,
  },
  "70005": {
    DMA: 622,
  },
  "70006": {
    DMA: 622,
  },
  "70009": {
    DMA: 622,
  },
  "70010": {
    DMA: 622,
  },
  "70011": {
    DMA: 622,
  },
  "70030": {
    DMA: 622,
  },
  "70031": {
    DMA: 622,
  },
  "70032": {
    DMA: 622,
  },
  "70033": {
    DMA: 622,
  },
  "70036": {
    DMA: 622,
  },
  "70037": {
    DMA: 622,
  },
  "70038": {
    DMA: 622,
  },
  "70039": {
    DMA: 622,
  },
  "70040": {
    DMA: 622,
  },
  "70041": {
    DMA: 622,
  },
  "70043": {
    DMA: 622,
  },
  "70044": {
    DMA: 622,
  },
  "70047": {
    DMA: 622,
  },
  "70049": {
    DMA: 622,
  },
  "70050": {
    DMA: 622,
  },
  "70051": {
    DMA: 622,
  },
  "70052": {
    DMA: 622,
  },
  "70053": {
    DMA: 622,
  },
  "70054": {
    DMA: 622,
  },
  "70055": {
    DMA: 622,
  },
  "70056": {
    DMA: 622,
  },
  "70057": {
    DMA: 622,
  },
  "70058": {
    DMA: 622,
  },
  "70059": {
    DMA: 622,
  },
  "70060": {
    DMA: 622,
  },
  "70062": {
    DMA: 622,
  },
  "70063": {
    DMA: 622,
  },
  "70064": {
    DMA: 622,
  },
  "70065": {
    DMA: 622,
  },
  "70067": {
    DMA: 622,
  },
  "70068": {
    DMA: 622,
  },
  "70069": {
    DMA: 622,
  },
  "70070": {
    DMA: 622,
  },
  "70071": {
    DMA: 622,
  },
  "70072": {
    DMA: 622,
  },
  "70073": {
    DMA: 622,
  },
  "70075": {
    DMA: 622,
  },
  "70076": {
    DMA: 622,
  },
  "70078": {
    DMA: 622,
  },
  "70079": {
    DMA: 622,
  },
  "70080": {
    DMA: 622,
  },
  "70081": {
    DMA: 622,
  },
  "70082": {
    DMA: 622,
  },
  "70083": {
    DMA: 622,
  },
  "70084": {
    DMA: 622,
  },
  "70085": {
    DMA: 622,
  },
  "70086": {
    DMA: 622,
  },
  "70087": {
    DMA: 622,
  },
  "70090": {
    DMA: 622,
  },
  "70091": {
    DMA: 622,
  },
  "70092": {
    DMA: 622,
  },
  "70093": {
    DMA: 622,
  },
  "70094": {
    DMA: 622,
  },
  "70096": {
    DMA: 622,
  },
  "70097": {
    DMA: 622,
  },
  "70112": {
    DMA: 622,
  },
  "70113": {
    DMA: 622,
  },
  "70114": {
    DMA: 622,
  },
  "70115": {
    DMA: 622,
  },
  "70116": {
    DMA: 622,
  },
  "70117": {
    DMA: 622,
  },
  "70118": {
    DMA: 622,
  },
  "70119": {
    DMA: 622,
  },
  "70121": {
    DMA: 622,
  },
  "70122": {
    DMA: 622,
  },
  "70123": {
    DMA: 622,
  },
  "70124": {
    DMA: 622,
  },
  "70125": {
    DMA: 622,
  },
  "70126": {
    DMA: 622,
  },
  "70127": {
    DMA: 622,
  },
  "70128": {
    DMA: 622,
  },
  "70129": {
    DMA: 622,
  },
  "70130": {
    DMA: 622,
  },
  "70131": {
    DMA: 622,
  },
  "70139": {
    DMA: 622,
  },
  "70140": {
    DMA: 622,
  },
  "70141": {
    DMA: 622,
  },
  "70142": {
    DMA: 622,
  },
  "70143": {
    DMA: 622,
  },
  "70145": {
    DMA: 622,
  },
  "70146": {
    DMA: 622,
  },
  "70148": {
    DMA: 622,
  },
  "70149": {
    DMA: 622,
  },
  "70150": {
    DMA: 622,
  },
  "70151": {
    DMA: 622,
  },
  "70152": {
    DMA: 622,
  },
  "70153": {
    DMA: 622,
  },
  "70154": {
    DMA: 622,
  },
  "70156": {
    DMA: 622,
  },
  "70157": {
    DMA: 622,
  },
  "70158": {
    DMA: 622,
  },
  "70159": {
    DMA: 622,
  },
  "70160": {
    DMA: 622,
  },
  "70161": {
    DMA: 622,
  },
  "70162": {
    DMA: 622,
  },
  "70163": {
    DMA: 622,
  },
  "70164": {
    DMA: 622,
  },
  "70165": {
    DMA: 622,
  },
  "70166": {
    DMA: 622,
  },
  "70167": {
    DMA: 622,
  },
  "70170": {
    DMA: 622,
  },
  "70172": {
    DMA: 622,
  },
  "70174": {
    DMA: 622,
  },
  "70175": {
    DMA: 622,
  },
  "70176": {
    DMA: 622,
  },
  "70177": {
    DMA: 622,
  },
  "70178": {
    DMA: 622,
  },
  "70179": {
    DMA: 622,
  },
  "70181": {
    DMA: 622,
  },
  "70182": {
    DMA: 622,
  },
  "70183": {
    DMA: 622,
  },
  "70184": {
    DMA: 622,
  },
  "70185": {
    DMA: 622,
  },
  "70186": {
    DMA: 622,
  },
  "70187": {
    DMA: 622,
  },
  "70189": {
    DMA: 622,
  },
  "70190": {
    DMA: 622,
  },
  "70195": {
    DMA: 622,
  },
  "70301": {
    DMA: 622,
  },
  "70302": {
    DMA: 622,
  },
  "70310": {
    DMA: 622,
  },
  "70339": {
    DMA: 716,
  },
  "70340": {
    DMA: 716,
  },
  "70341": {
    DMA: 716,
  },
  "70342": {
    DMA: 716,
  },
  "70343": {
    DMA: 622,
  },
  "70344": {
    DMA: 622,
  },
  "70345": {
    DMA: 622,
  },
  "70346": {
    DMA: 716,
  },
  "70352": {
    DMA: 622,
  },
  "70353": {
    DMA: 622,
  },
  "70354": {
    DMA: 622,
  },
  "70355": {
    DMA: 622,
  },
  "70356": {
    DMA: 622,
  },
  "70357": {
    DMA: 622,
  },
  "70358": {
    DMA: 622,
  },
  "70359": {
    DMA: 622,
  },
  "70360": {
    DMA: 622,
  },
  "70361": {
    DMA: 622,
  },
  "70363": {
    DMA: 622,
  },
  "70364": {
    DMA: 622,
  },
  "70371": {
    DMA: 622,
  },
  "70372": {
    DMA: 716,
  },
  "70373": {
    DMA: 622,
  },
  "70374": {
    DMA: 622,
  },
  "70375": {
    DMA: 622,
  },
  "70377": {
    DMA: 622,
  },
  "70380": {
    DMA: 716,
  },
  "70381": {
    DMA: 716,
  },
  "70390": {
    DMA: 716,
  },
  "70391": {
    DMA: 716,
  },
  "70392": {
    DMA: 716,
  },
  "70393": {
    DMA: 716,
  },
  "70394": {
    DMA: 622,
  },
  "70395": {
    DMA: 622,
  },
  "70397": {
    DMA: 622,
  },
  "70401": {
    DMA: 622,
  },
  "70402": {
    DMA: 622,
  },
  "70403": {
    DMA: 622,
  },
  "70404": {
    DMA: 622,
  },
  "70420": {
    DMA: 622,
  },
  "70421": {
    DMA: 622,
  },
  "70422": {
    DMA: 622,
  },
  "70426": {
    DMA: 622,
  },
  "70427": {
    DMA: 622,
  },
  "70429": {
    DMA: 622,
  },
  "70431": {
    DMA: 622,
  },
  "70433": {
    DMA: 622,
  },
  "70434": {
    DMA: 622,
  },
  "70435": {
    DMA: 622,
  },
  "70436": {
    DMA: 622,
  },
  "70437": {
    DMA: 622,
  },
  "70438": {
    DMA: 622,
  },
  "70441": {
    DMA: 716,
  },
  "70442": {
    DMA: 622,
  },
  "70443": {
    DMA: 622,
  },
  "70444": {
    DMA: 622,
  },
  "70445": {
    DMA: 622,
  },
  "70446": {
    DMA: 622,
  },
  "70447": {
    DMA: 622,
  },
  "70448": {
    DMA: 622,
  },
  "70449": {
    DMA: 716,
  },
  "70450": {
    DMA: 622,
  },
  "70451": {
    DMA: 622,
  },
  "70452": {
    DMA: 622,
  },
  "70453": {
    DMA: 716,
  },
  "70454": {
    DMA: 622,
  },
  "70455": {
    DMA: 622,
  },
  "70456": {
    DMA: 622,
  },
  "70457": {
    DMA: 622,
  },
  "70458": {
    DMA: 622,
  },
  "70459": {
    DMA: 622,
  },
  "70460": {
    DMA: 622,
  },
  "70461": {
    DMA: 622,
  },
  "70462": {
    DMA: 716,
  },
  "70463": {
    DMA: 622,
  },
  "70464": {
    DMA: 622,
  },
  "70465": {
    DMA: 622,
  },
  "70466": {
    DMA: 622,
  },
  "70467": {
    DMA: 622,
  },
  "70469": {
    DMA: 622,
  },
  "70470": {
    DMA: 622,
  },
  "70471": {
    DMA: 622,
  },
  "70500": {
    DMA: 642,
  },
  "70501": {
    DMA: 642,
  },
  "70502": {
    DMA: 642,
  },
  "70503": {
    DMA: 642,
  },
  "70504": {
    DMA: 642,
  },
  "70505": {
    DMA: 642,
  },
  "70506": {
    DMA: 642,
  },
  "70507": {
    DMA: 642,
  },
  "70508": {
    DMA: 642,
  },
  "70509": {
    DMA: 642,
  },
  "70510": {
    DMA: 642,
  },
  "70511": {
    DMA: 642,
  },
  "70512": {
    DMA: 642,
  },
  "70513": {
    DMA: 642,
  },
  "70514": {
    DMA: 716,
  },
  "70515": {
    DMA: 642,
  },
  "70516": {
    DMA: 642,
  },
  "70517": {
    DMA: 642,
  },
  "70518": {
    DMA: 642,
  },
  "70519": {
    DMA: 642,
  },
  "70520": {
    DMA: 642,
  },
  "70521": {
    DMA: 642,
  },
  "70522": {
    DMA: 716,
  },
  "70523": {
    DMA: 716,
  },
  "70524": {
    DMA: 642,
  },
  "70525": {
    DMA: 642,
  },
  "70526": {
    DMA: 642,
  },
  "70527": {
    DMA: 642,
  },
  "70528": {
    DMA: 642,
  },
  "70529": {
    DMA: 642,
  },
  "70531": {
    DMA: 642,
  },
  "70532": {
    DMA: 642,
  },
  "70533": {
    DMA: 642,
  },
  "70534": {
    DMA: 642,
  },
  "70535": {
    DMA: 642,
  },
  "70537": {
    DMA: 642,
  },
  "70538": {
    DMA: 716,
  },
  "70540": {
    DMA: 716,
  },
  "70541": {
    DMA: 642,
  },
  "70542": {
    DMA: 642,
  },
  "70543": {
    DMA: 642,
  },
  "70544": {
    DMA: 642,
  },
  "70546": {
    DMA: 642,
  },
  "70548": {
    DMA: 642,
  },
  "70549": {
    DMA: 642,
  },
  "70550": {
    DMA: 642,
  },
  "70551": {
    DMA: 642,
  },
  "70552": {
    DMA: 642,
  },
  "70554": {
    DMA: 642,
  },
  "70555": {
    DMA: 642,
  },
  "70556": {
    DMA: 642,
  },
  "70558": {
    DMA: 642,
  },
  "70559": {
    DMA: 642,
  },
  "70560": {
    DMA: 642,
  },
  "70562": {
    DMA: 642,
  },
  "70563": {
    DMA: 642,
  },
  "70569": {
    DMA: 642,
  },
  "70570": {
    DMA: 642,
  },
  "70571": {
    DMA: 642,
  },
  "70575": {
    DMA: 642,
  },
  "70576": {
    DMA: 642,
  },
  "70577": {
    DMA: 642,
  },
  "70578": {
    DMA: 642,
  },
  "70580": {
    DMA: 642,
  },
  "70581": {
    DMA: 642,
  },
  "70582": {
    DMA: 642,
  },
  "70583": {
    DMA: 642,
  },
  "70584": {
    DMA: 642,
  },
  "70585": {
    DMA: 642,
  },
  "70586": {
    DMA: 642,
  },
  "70589": {
    DMA: 642,
  },
  "70591": {
    DMA: 642,
  },
  "70592": {
    DMA: 642,
  },
  "70593": {
    DMA: 642,
  },
  "70595": {
    DMA: 642,
  },
  "70596": {
    DMA: 642,
  },
  "70598": {
    DMA: 642,
  },
  "70601": {
    DMA: 643,
  },
  "70602": {
    DMA: 643,
  },
  "70605": {
    DMA: 643,
  },
  "70606": {
    DMA: 643,
  },
  "70607": {
    DMA: 643,
  },
  "70609": {
    DMA: 643,
  },
  "70611": {
    DMA: 643,
  },
  "70612": {
    DMA: 643,
  },
  "70615": {
    DMA: 643,
  },
  "70616": {
    DMA: 643,
  },
  "70629": {
    DMA: 643,
  },
  "70630": {
    DMA: 643,
  },
  "70631": {
    DMA: 643,
  },
  "70632": {
    DMA: 643,
  },
  "70633": {
    DMA: 643,
  },
  "70634": {
    DMA: 643,
  },
  "70637": {
    DMA: 643,
  },
  "70638": {
    DMA: 643,
  },
  "70639": {
    DMA: 644,
  },
  "70640": {
    DMA: 642,
  },
  "70643": {
    DMA: 643,
  },
  "70644": {
    DMA: 643,
  },
  "70645": {
    DMA: 643,
  },
  "70646": {
    DMA: 643,
  },
  "70647": {
    DMA: 643,
  },
  "70648": {
    DMA: 643,
  },
  "70650": {
    DMA: 642,
  },
  "70651": {
    DMA: 643,
  },
  "70652": {
    DMA: 643,
  },
  "70653": {
    DMA: 643,
  },
  "70654": {
    DMA: 643,
  },
  "70655": {
    DMA: 643,
  },
  "70656": {
    DMA: 644,
  },
  "70657": {
    DMA: 643,
  },
  "70658": {
    DMA: 643,
  },
  "70659": {
    DMA: 644,
  },
  "70660": {
    DMA: 643,
  },
  "70661": {
    DMA: 643,
  },
  "70662": {
    DMA: 643,
  },
  "70663": {
    DMA: 643,
  },
  "70664": {
    DMA: 643,
  },
  "70665": {
    DMA: 643,
  },
  "70668": {
    DMA: 643,
  },
  "70669": {
    DMA: 643,
  },
  "70704": {
    DMA: 716,
  },
  "70706": {
    DMA: 716,
  },
  "70707": {
    DMA: 716,
  },
  "70710": {
    DMA: 716,
  },
  "70711": {
    DMA: 716,
  },
  "70712": {
    DMA: 716,
  },
  "70714": {
    DMA: 716,
  },
  "70715": {
    DMA: 716,
  },
  "70718": {
    DMA: 716,
  },
  "70719": {
    DMA: 716,
  },
  "70721": {
    DMA: 716,
  },
  "70722": {
    DMA: 716,
  },
  "70723": {
    DMA: 622,
  },
  "70725": {
    DMA: 716,
  },
  "70726": {
    DMA: 716,
  },
  "70727": {
    DMA: 716,
  },
  "70728": {
    DMA: 716,
  },
  "70729": {
    DMA: 716,
  },
  "70730": {
    DMA: 716,
  },
  "70732": {
    DMA: 716,
  },
  "70733": {
    DMA: 716,
  },
  "70734": {
    DMA: 716,
  },
  "70736": {
    DMA: 716,
  },
  "70737": {
    DMA: 716,
  },
  "70738": {
    DMA: 716,
  },
  "70739": {
    DMA: 716,
  },
  "70740": {
    DMA: 716,
  },
  "70743": {
    DMA: 622,
  },
  "70744": {
    DMA: 716,
  },
  "70747": {
    DMA: 716,
  },
  "70748": {
    DMA: 716,
  },
  "70749": {
    DMA: 716,
  },
  "70750": {
    DMA: 642,
  },
  "70752": {
    DMA: 716,
  },
  "70753": {
    DMA: 716,
  },
  "70754": {
    DMA: 716,
  },
  "70755": {
    DMA: 716,
  },
  "70756": {
    DMA: 716,
  },
  "70757": {
    DMA: 716,
  },
  "70759": {
    DMA: 716,
  },
  "70760": {
    DMA: 716,
  },
  "70761": {
    DMA: 716,
  },
  "70762": {
    DMA: 716,
  },
  "70763": {
    DMA: 622,
  },
  "70764": {
    DMA: 716,
  },
  "70765": {
    DMA: 716,
  },
  "70767": {
    DMA: 716,
  },
  "70769": {
    DMA: 716,
  },
  "70770": {
    DMA: 716,
  },
  "70772": {
    DMA: 716,
  },
  "70773": {
    DMA: 716,
  },
  "70774": {
    DMA: 716,
  },
  "70775": {
    DMA: 716,
  },
  "70776": {
    DMA: 716,
  },
  "70777": {
    DMA: 716,
  },
  "70778": {
    DMA: 716,
  },
  "70780": {
    DMA: 716,
  },
  "70782": {
    DMA: 716,
  },
  "70783": {
    DMA: 716,
  },
  "70784": {
    DMA: 716,
  },
  "70785": {
    DMA: 716,
  },
  "70786": {
    DMA: 716,
  },
  "70787": {
    DMA: 716,
  },
  "70788": {
    DMA: 716,
  },
  "70789": {
    DMA: 716,
  },
  "70791": {
    DMA: 716,
  },
  "70792": {
    DMA: 622,
  },
  "70801": {
    DMA: 716,
  },
  "70802": {
    DMA: 716,
  },
  "70803": {
    DMA: 716,
  },
  "70804": {
    DMA: 716,
  },
  "70805": {
    DMA: 716,
  },
  "70806": {
    DMA: 716,
  },
  "70807": {
    DMA: 716,
  },
  "70808": {
    DMA: 716,
  },
  "70809": {
    DMA: 716,
  },
  "70810": {
    DMA: 716,
  },
  "70811": {
    DMA: 716,
  },
  "70812": {
    DMA: 716,
  },
  "70813": {
    DMA: 716,
  },
  "70814": {
    DMA: 716,
  },
  "70815": {
    DMA: 716,
  },
  "70816": {
    DMA: 716,
  },
  "70817": {
    DMA: 716,
  },
  "70818": {
    DMA: 716,
  },
  "70819": {
    DMA: 716,
  },
  "70820": {
    DMA: 716,
  },
  "70821": {
    DMA: 716,
  },
  "70822": {
    DMA: 716,
  },
  "70823": {
    DMA: 716,
  },
  "70825": {
    DMA: 716,
  },
  "70826": {
    DMA: 716,
  },
  "70827": {
    DMA: 716,
  },
  "70831": {
    DMA: 716,
  },
  "70833": {
    DMA: 716,
  },
  "70835": {
    DMA: 716,
  },
  "70836": {
    DMA: 716,
  },
  "70837": {
    DMA: 716,
  },
  "70873": {
    DMA: 716,
  },
  "70874": {
    DMA: 716,
  },
  "70879": {
    DMA: 716,
  },
  "70883": {
    DMA: 716,
  },
  "70884": {
    DMA: 716,
  },
  "70891": {
    DMA: 716,
  },
  "70892": {
    DMA: 716,
  },
  "70893": {
    DMA: 716,
  },
  "70894": {
    DMA: 716,
  },
  "70895": {
    DMA: 716,
  },
  "70896": {
    DMA: 716,
  },
  "70898": {
    DMA: 716,
  },
  "71001": {
    DMA: 612,
  },
  "71002": {
    DMA: 612,
  },
  "71003": {
    DMA: 612,
  },
  "71004": {
    DMA: 612,
  },
  "71006": {
    DMA: 612,
  },
  "71007": {
    DMA: 612,
  },
  "71008": {
    DMA: 612,
  },
  "71009": {
    DMA: 612,
  },
  "71016": {
    DMA: 612,
  },
  "71018": {
    DMA: 612,
  },
  "71019": {
    DMA: 612,
  },
  "71021": {
    DMA: 612,
  },
  "71023": {
    DMA: 612,
  },
  "71024": {
    DMA: 612,
  },
  "71027": {
    DMA: 612,
  },
  "71028": {
    DMA: 612,
  },
  "71029": {
    DMA: 612,
  },
  "71030": {
    DMA: 612,
  },
  "71031": {
    DMA: 612,
  },
  "71032": {
    DMA: 612,
  },
  "71033": {
    DMA: 612,
  },
  "71034": {
    DMA: 612,
  },
  "71037": {
    DMA: 612,
  },
  "71038": {
    DMA: 612,
  },
  "71039": {
    DMA: 612,
  },
  "71040": {
    DMA: 612,
  },
  "71043": {
    DMA: 612,
  },
  "71044": {
    DMA: 612,
  },
  "71045": {
    DMA: 612,
  },
  "71046": {
    DMA: 612,
  },
  "71047": {
    DMA: 612,
  },
  "71048": {
    DMA: 612,
  },
  "71049": {
    DMA: 612,
  },
  "71050": {
    DMA: 612,
  },
  "71051": {
    DMA: 612,
  },
  "71052": {
    DMA: 612,
  },
  "71055": {
    DMA: 612,
  },
  "71058": {
    DMA: 612,
  },
  "71060": {
    DMA: 612,
  },
  "71061": {
    DMA: 612,
  },
  "71063": {
    DMA: 612,
  },
  "71064": {
    DMA: 612,
  },
  "71065": {
    DMA: 612,
  },
  "71066": {
    DMA: 612,
  },
  "71067": {
    DMA: 612,
  },
  "71068": {
    DMA: 612,
  },
  "71069": {
    DMA: 612,
  },
  "71070": {
    DMA: 612,
  },
  "71071": {
    DMA: 612,
  },
  "71072": {
    DMA: 612,
  },
  "71073": {
    DMA: 612,
  },
  "71075": {
    DMA: 612,
  },
  "71078": {
    DMA: 612,
  },
  "71079": {
    DMA: 612,
  },
  "71080": {
    DMA: 612,
  },
  "71082": {
    DMA: 612,
  },
  "71101": {
    DMA: 612,
  },
  "71102": {
    DMA: 612,
  },
  "71103": {
    DMA: 612,
  },
  "71104": {
    DMA: 612,
  },
  "71105": {
    DMA: 612,
  },
  "71106": {
    DMA: 612,
  },
  "71107": {
    DMA: 612,
  },
  "71108": {
    DMA: 612,
  },
  "71109": {
    DMA: 612,
  },
  "71110": {
    DMA: 612,
  },
  "71111": {
    DMA: 612,
  },
  "71112": {
    DMA: 612,
  },
  "71113": {
    DMA: 612,
  },
  "71115": {
    DMA: 612,
  },
  "71118": {
    DMA: 612,
  },
  "71119": {
    DMA: 612,
  },
  "71120": {
    DMA: 612,
  },
  "71129": {
    DMA: 612,
  },
  "71130": {
    DMA: 612,
  },
  "71133": {
    DMA: 612,
  },
  "71134": {
    DMA: 612,
  },
  "71135": {
    DMA: 612,
  },
  "71136": {
    DMA: 612,
  },
  "71137": {
    DMA: 612,
  },
  "71138": {
    DMA: 612,
  },
  "71148": {
    DMA: 612,
  },
  "71149": {
    DMA: 612,
  },
  "71150": {
    DMA: 612,
  },
  "71151": {
    DMA: 612,
  },
  "71152": {
    DMA: 612,
  },
  "71153": {
    DMA: 612,
  },
  "71154": {
    DMA: 612,
  },
  "71156": {
    DMA: 612,
  },
  "71161": {
    DMA: 612,
  },
  "71162": {
    DMA: 612,
  },
  "71163": {
    DMA: 612,
  },
  "71164": {
    DMA: 612,
  },
  "71165": {
    DMA: 612,
  },
  "71166": {
    DMA: 612,
  },
  "71171": {
    DMA: 612,
  },
  "71172": {
    DMA: 612,
  },
  "71201": {
    DMA: 628,
  },
  "71202": {
    DMA: 628,
  },
  "71203": {
    DMA: 628,
  },
  "71207": {
    DMA: 628,
  },
  "71208": {
    DMA: 628,
  },
  "71209": {
    DMA: 628,
  },
  "71210": {
    DMA: 628,
  },
  "71211": {
    DMA: 628,
  },
  "71212": {
    DMA: 628,
  },
  "71213": {
    DMA: 628,
  },
  "71217": {
    DMA: 628,
  },
  "71218": {
    DMA: 628,
  },
  "71219": {
    DMA: 628,
  },
  "71220": {
    DMA: 628,
  },
  "71221": {
    DMA: 628,
  },
  "71222": {
    DMA: 628,
  },
  "71223": {
    DMA: 628,
  },
  "71225": {
    DMA: 628,
  },
  "71226": {
    DMA: 628,
  },
  "71227": {
    DMA: 628,
  },
  "71229": {
    DMA: 628,
  },
  "71230": {
    DMA: 628,
  },
  "71232": {
    DMA: 628,
  },
  "71233": {
    DMA: 628,
  },
  "71234": {
    DMA: 628,
  },
  "71235": {
    DMA: 628,
  },
  "71237": {
    DMA: 628,
  },
  "71238": {
    DMA: 628,
  },
  "71240": {
    DMA: 628,
  },
  "71241": {
    DMA: 628,
  },
  "71242": {
    DMA: 628,
  },
  "71243": {
    DMA: 628,
  },
  "71245": {
    DMA: 628,
  },
  "71247": {
    DMA: 628,
  },
  "71249": {
    DMA: 628,
  },
  "71250": {
    DMA: 628,
  },
  "71251": {
    DMA: 628,
  },
  "71253": {
    DMA: 628,
  },
  "71254": {
    DMA: 628,
  },
  "71256": {
    DMA: 628,
  },
  "71259": {
    DMA: 628,
  },
  "71260": {
    DMA: 628,
  },
  "71261": {
    DMA: 628,
  },
  "71263": {
    DMA: 628,
  },
  "71264": {
    DMA: 628,
  },
  "71266": {
    DMA: 628,
  },
  "71268": {
    DMA: 628,
  },
  "71269": {
    DMA: 628,
  },
  "71270": {
    DMA: 628,
  },
  "71272": {
    DMA: 628,
  },
  "71273": {
    DMA: 628,
  },
  "71275": {
    DMA: 628,
  },
  "71276": {
    DMA: 628,
  },
  "71277": {
    DMA: 628,
  },
  "71279": {
    DMA: 628,
  },
  "71280": {
    DMA: 628,
  },
  "71281": {
    DMA: 628,
  },
  "71282": {
    DMA: 628,
  },
  "71284": {
    DMA: 628,
  },
  "71286": {
    DMA: 628,
  },
  "71291": {
    DMA: 628,
  },
  "71292": {
    DMA: 628,
  },
  "71294": {
    DMA: 628,
  },
  "71295": {
    DMA: 628,
  },
  "71301": {
    DMA: 644,
  },
  "71302": {
    DMA: 644,
  },
  "71303": {
    DMA: 644,
  },
  "71306": {
    DMA: 644,
  },
  "71307": {
    DMA: 644,
  },
  "71309": {
    DMA: 644,
  },
  "71315": {
    DMA: 644,
  },
  "71316": {
    DMA: 628,
  },
  "71320": {
    DMA: 644,
  },
  "71322": {
    DMA: 644,
  },
  "71323": {
    DMA: 644,
  },
  "71324": {
    DMA: 628,
  },
  "71325": {
    DMA: 644,
  },
  "71326": {
    DMA: 628,
  },
  "71327": {
    DMA: 644,
  },
  "71328": {
    DMA: 644,
  },
  "71329": {
    DMA: 644,
  },
  "71330": {
    DMA: 644,
  },
  "71331": {
    DMA: 644,
  },
  "71333": {
    DMA: 644,
  },
  "71334": {
    DMA: 628,
  },
  "71336": {
    DMA: 628,
  },
  "71339": {
    DMA: 644,
  },
  "71340": {
    DMA: 628,
  },
  "71341": {
    DMA: 644,
  },
  "71342": {
    DMA: 628,
  },
  "71343": {
    DMA: 628,
  },
  "71345": {
    DMA: 642,
  },
  "71346": {
    DMA: 644,
  },
  "71348": {
    DMA: 644,
  },
  "71350": {
    DMA: 644,
  },
  "71351": {
    DMA: 644,
  },
  "71353": {
    DMA: 642,
  },
  "71354": {
    DMA: 628,
  },
  "71355": {
    DMA: 644,
  },
  "71356": {
    DMA: 642,
  },
  "71357": {
    DMA: 628,
  },
  "71358": {
    DMA: 642,
  },
  "71359": {
    DMA: 644,
  },
  "71360": {
    DMA: 644,
  },
  "71361": {
    DMA: 644,
  },
  "71362": {
    DMA: 644,
  },
  "71363": {
    DMA: 628,
  },
  "71365": {
    DMA: 644,
  },
  "71366": {
    DMA: 628,
  },
  "71367": {
    DMA: 642,
  },
  "71368": {
    DMA: 628,
  },
  "71369": {
    DMA: 644,
  },
  "71371": {
    DMA: 628,
  },
  "71373": {
    DMA: 628,
  },
  "71375": {
    DMA: 628,
  },
  "71377": {
    DMA: 628,
  },
  "71378": {
    DMA: 628,
  },
  "71401": {
    DMA: 628,
  },
  "71403": {
    DMA: 644,
  },
  "71404": {
    DMA: 628,
  },
  "71405": {
    DMA: 644,
  },
  "71406": {
    DMA: 612,
  },
  "71407": {
    DMA: 644,
  },
  "71409": {
    DMA: 644,
  },
  "71410": {
    DMA: 628,
  },
  "71411": {
    DMA: 612,
  },
  "71414": {
    DMA: 612,
  },
  "71415": {
    DMA: 628,
  },
  "71416": {
    DMA: 612,
  },
  "71417": {
    DMA: 644,
  },
  "71418": {
    DMA: 628,
  },
  "71419": {
    DMA: 612,
  },
  "71422": {
    DMA: 628,
  },
  "71423": {
    DMA: 644,
  },
  "71424": {
    DMA: 644,
  },
  "71425": {
    DMA: 628,
  },
  "71426": {
    DMA: 612,
  },
  "71427": {
    DMA: 644,
  },
  "71428": {
    DMA: 612,
  },
  "71429": {
    DMA: 612,
  },
  "71430": {
    DMA: 644,
  },
  "71431": {
    DMA: 644,
  },
  "71432": {
    DMA: 644,
  },
  "71433": {
    DMA: 644,
  },
  "71434": {
    DMA: 612,
  },
  "71435": {
    DMA: 628,
  },
  "71438": {
    DMA: 644,
  },
  "71439": {
    DMA: 644,
  },
  "71440": {
    DMA: 628,
  },
  "71441": {
    DMA: 628,
  },
  "71443": {
    DMA: 644,
  },
  "71446": {
    DMA: 644,
  },
  "71447": {
    DMA: 644,
  },
  "71448": {
    DMA: 644,
  },
  "71449": {
    DMA: 612,
  },
  "71450": {
    DMA: 612,
  },
  "71452": {
    DMA: 612,
  },
  "71454": {
    DMA: 644,
  },
  "71455": {
    DMA: 644,
  },
  "71456": {
    DMA: 612,
  },
  "71457": {
    DMA: 612,
  },
  "71458": {
    DMA: 612,
  },
  "71459": {
    DMA: 644,
  },
  "71460": {
    DMA: 612,
  },
  "71461": {
    DMA: 644,
  },
  "71462": {
    DMA: 612,
  },
  "71463": {
    DMA: 643,
  },
  "71465": {
    DMA: 628,
  },
  "71466": {
    DMA: 644,
  },
  "71467": {
    DMA: 644,
  },
  "71468": {
    DMA: 612,
  },
  "71469": {
    DMA: 612,
  },
  "71471": {
    DMA: 628,
  },
  "71472": {
    DMA: 644,
  },
  "71473": {
    DMA: 628,
  },
  "71474": {
    DMA: 644,
  },
  "71475": {
    DMA: 644,
  },
  "71477": {
    DMA: 644,
  },
  "71479": {
    DMA: 628,
  },
  "71480": {
    DMA: 628,
  },
  "71483": {
    DMA: 628,
  },
  "71485": {
    DMA: 644,
  },
  "71486": {
    DMA: 612,
  },
  "71496": {
    DMA: 644,
  },
  "71497": {
    DMA: 612,
  },
  "71601": {
    DMA: 693,
  },
  "71602": {
    DMA: 693,
  },
  "71603": {
    DMA: 693,
  },
  "71611": {
    DMA: 693,
  },
  "71612": {
    DMA: 693,
  },
  "71613": {
    DMA: 693,
  },
  "71630": {
    DMA: 693,
  },
  "71631": {
    DMA: 693,
  },
  "71635": {
    DMA: 628,
  },
  "71638": {
    DMA: 647,
  },
  "71639": {
    DMA: 693,
  },
  "71640": {
    DMA: 647,
  },
  "71642": {
    DMA: 628,
  },
  "71643": {
    DMA: 693,
  },
  "71644": {
    DMA: 693,
  },
  "71646": {
    DMA: 628,
  },
  "71647": {
    DMA: 693,
  },
  "71651": {
    DMA: 693,
  },
  "71652": {
    DMA: 693,
  },
  "71653": {
    DMA: 647,
  },
  "71654": {
    DMA: 693,
  },
  "71655": {
    DMA: 693,
  },
  "71656": {
    DMA: 693,
  },
  "71657": {
    DMA: 693,
  },
  "71658": {
    DMA: 628,
  },
  "71659": {
    DMA: 693,
  },
  "71660": {
    DMA: 693,
  },
  "71661": {
    DMA: 628,
  },
  "71662": {
    DMA: 693,
  },
  "71663": {
    DMA: 628,
  },
  "71665": {
    DMA: 693,
  },
  "71666": {
    DMA: 693,
  },
  "71667": {
    DMA: 693,
  },
  "71670": {
    DMA: 693,
  },
  "71671": {
    DMA: 693,
  },
  "71674": {
    DMA: 693,
  },
  "71675": {
    DMA: 693,
  },
  "71676": {
    DMA: 628,
  },
  "71677": {
    DMA: 693,
  },
  "71678": {
    DMA: 693,
  },
  "71701": {
    DMA: 693,
  },
  "71711": {
    DMA: 693,
  },
  "71720": {
    DMA: 693,
  },
  "71721": {
    DMA: 693,
  },
  "71722": {
    DMA: 693,
  },
  "71724": {
    DMA: 628,
  },
  "71725": {
    DMA: 693,
  },
  "71726": {
    DMA: 693,
  },
  "71728": {
    DMA: 693,
  },
  "71730": {
    DMA: 628,
  },
  "71731": {
    DMA: 628,
  },
  "71740": {
    DMA: 612,
  },
  "71742": {
    DMA: 693,
  },
  "71743": {
    DMA: 693,
  },
  "71744": {
    DMA: 693,
  },
  "71745": {
    DMA: 693,
  },
  "71747": {
    DMA: 628,
  },
  "71748": {
    DMA: 693,
  },
  "71749": {
    DMA: 628,
  },
  "71750": {
    DMA: 628,
  },
  "71751": {
    DMA: 693,
  },
  "71752": {
    DMA: 612,
  },
  "71753": {
    DMA: 612,
  },
  "71754": {
    DMA: 612,
  },
  "71758": {
    DMA: 628,
  },
  "71759": {
    DMA: 628,
  },
  "71762": {
    DMA: 628,
  },
  "71763": {
    DMA: 693,
  },
  "71764": {
    DMA: 693,
  },
  "71765": {
    DMA: 628,
  },
  "71766": {
    DMA: 693,
  },
  "71768": {
    DMA: 628,
  },
  "71770": {
    DMA: 612,
  },
  "71772": {
    DMA: 693,
  },
  "71801": {
    DMA: 612,
  },
  "71802": {
    DMA: 612,
  },
  "71820": {
    DMA: 612,
  },
  "71822": {
    DMA: 612,
  },
  "71823": {
    DMA: 612,
  },
  "71825": {
    DMA: 612,
  },
  "71826": {
    DMA: 612,
  },
  "71827": {
    DMA: 612,
  },
  "71828": {
    DMA: 693,
  },
  "71831": {
    DMA: 612,
  },
  "71832": {
    DMA: 612,
  },
  "71833": {
    DMA: 612,
  },
  "71834": {
    DMA: 612,
  },
  "71835": {
    DMA: 693,
  },
  "71836": {
    DMA: 612,
  },
  "71837": {
    DMA: 612,
  },
  "71838": {
    DMA: 612,
  },
  "71839": {
    DMA: 612,
  },
  "71840": {
    DMA: 612,
  },
  "71841": {
    DMA: 612,
  },
  "71842": {
    DMA: 612,
  },
  "71844": {
    DMA: 693,
  },
  "71845": {
    DMA: 612,
  },
  "71846": {
    DMA: 612,
  },
  "71847": {
    DMA: 612,
  },
  "71851": {
    DMA: 612,
  },
  "71852": {
    DMA: 612,
  },
  "71853": {
    DMA: 612,
  },
  "71854": {
    DMA: 612,
  },
  "71855": {
    DMA: 612,
  },
  "71857": {
    DMA: 693,
  },
  "71858": {
    DMA: 693,
  },
  "71859": {
    DMA: 612,
  },
  "71860": {
    DMA: 612,
  },
  "71861": {
    DMA: 612,
  },
  "71862": {
    DMA: 612,
  },
  "71864": {
    DMA: 693,
  },
  "71865": {
    DMA: 612,
  },
  "71866": {
    DMA: 612,
  },
  "71901": {
    DMA: 693,
  },
  "71902": {
    DMA: 693,
  },
  "71903": {
    DMA: 693,
  },
  "71909": {
    DMA: 693,
  },
  "71910": {
    DMA: 693,
  },
  "71913": {
    DMA: 693,
  },
  "71914": {
    DMA: 693,
  },
  "71920": {
    DMA: 693,
  },
  "71921": {
    DMA: 693,
  },
  "71922": {
    DMA: 693,
  },
  "71923": {
    DMA: 693,
  },
  "71929": {
    DMA: 693,
  },
  "71932": {
    DMA: 693,
  },
  "71933": {
    DMA: 693,
  },
  "71935": {
    DMA: 693,
  },
  "71937": {
    DMA: 693,
  },
  "71940": {
    DMA: 693,
  },
  "71941": {
    DMA: 693,
  },
  "71942": {
    DMA: 693,
  },
  "71943": {
    DMA: 693,
  },
  "71944": {
    DMA: 693,
  },
  "71945": {
    DMA: 693,
  },
  "71949": {
    DMA: 693,
  },
  "71950": {
    DMA: 693,
  },
  "71951": {
    DMA: 693,
  },
  "71952": {
    DMA: 693,
  },
  "71953": {
    DMA: 693,
  },
  "71956": {
    DMA: 693,
  },
  "71957": {
    DMA: 693,
  },
  "71958": {
    DMA: 693,
  },
  "71959": {
    DMA: 693,
  },
  "71960": {
    DMA: 693,
  },
  "71961": {
    DMA: 693,
  },
  "71962": {
    DMA: 693,
  },
  "71964": {
    DMA: 693,
  },
  "71965": {
    DMA: 693,
  },
  "71966": {
    DMA: 693,
  },
  "71968": {
    DMA: 693,
  },
  "71969": {
    DMA: 693,
  },
  "71970": {
    DMA: 693,
  },
  "71971": {
    DMA: 612,
  },
  "71972": {
    DMA: 693,
  },
  "71973": {
    DMA: 693,
  },
  "71998": {
    DMA: 693,
  },
  "71999": {
    DMA: 693,
  },
  "72001": {
    DMA: 693,
  },
  "72002": {
    DMA: 693,
  },
  "72003": {
    DMA: 693,
  },
  "72004": {
    DMA: 693,
  },
  "72005": {
    DMA: 693,
  },
  "72006": {
    DMA: 693,
  },
  "72007": {
    DMA: 693,
  },
  "72010": {
    DMA: 693,
  },
  "72011": {
    DMA: 693,
  },
  "72012": {
    DMA: 693,
  },
  "72013": {
    DMA: 693,
  },
  "72014": {
    DMA: 693,
  },
  "72015": {
    DMA: 693,
  },
  "72016": {
    DMA: 693,
  },
  "72017": {
    DMA: 693,
  },
  "72018": {
    DMA: 693,
  },
  "72019": {
    DMA: 693,
  },
  "72020": {
    DMA: 693,
  },
  "72021": {
    DMA: 693,
  },
  "72022": {
    DMA: 693,
  },
  "72023": {
    DMA: 693,
  },
  "72024": {
    DMA: 693,
  },
  "72025": {
    DMA: 693,
  },
  "72026": {
    DMA: 693,
  },
  "72027": {
    DMA: 693,
  },
  "72028": {
    DMA: 693,
  },
  "72029": {
    DMA: 693,
  },
  "72030": {
    DMA: 693,
  },
  "72031": {
    DMA: 693,
  },
  "72032": {
    DMA: 693,
  },
  "72033": {
    DMA: 693,
  },
  "72034": {
    DMA: 693,
  },
  "72035": {
    DMA: 693,
  },
  "72036": {
    DMA: 693,
  },
  "72037": {
    DMA: 693,
  },
  "72038": {
    DMA: 693,
  },
  "72039": {
    DMA: 693,
  },
  "72040": {
    DMA: 693,
  },
  "72041": {
    DMA: 693,
  },
  "72042": {
    DMA: 693,
  },
  "72043": {
    DMA: 693,
  },
  "72044": {
    DMA: 693,
  },
  "72045": {
    DMA: 693,
  },
  "72046": {
    DMA: 693,
  },
  "72047": {
    DMA: 693,
  },
  "72048": {
    DMA: 693,
  },
  "72051": {
    DMA: 693,
  },
  "72052": {
    DMA: 693,
  },
  "72053": {
    DMA: 693,
  },
  "72055": {
    DMA: 693,
  },
  "72057": {
    DMA: 693,
  },
  "72058": {
    DMA: 693,
  },
  "72059": {
    DMA: 693,
  },
  "72060": {
    DMA: 693,
  },
  "72061": {
    DMA: 693,
  },
  "72063": {
    DMA: 693,
  },
  "72064": {
    DMA: 693,
  },
  "72065": {
    DMA: 693,
  },
  "72066": {
    DMA: 693,
  },
  "72067": {
    DMA: 693,
  },
  "72068": {
    DMA: 693,
  },
  "72069": {
    DMA: 693,
  },
  "72070": {
    DMA: 693,
  },
  "72072": {
    DMA: 693,
  },
  "72073": {
    DMA: 693,
  },
  "72074": {
    DMA: 693,
  },
  "72075": {
    DMA: 693,
  },
  "72076": {
    DMA: 693,
  },
  "72078": {
    DMA: 693,
  },
  "72079": {
    DMA: 693,
  },
  "72080": {
    DMA: 693,
  },
  "72081": {
    DMA: 693,
  },
  "72082": {
    DMA: 693,
  },
  "72083": {
    DMA: 693,
  },
  "72084": {
    DMA: 693,
  },
  "72085": {
    DMA: 693,
  },
  "72086": {
    DMA: 693,
  },
  "72087": {
    DMA: 693,
  },
  "72088": {
    DMA: 693,
  },
  "72089": {
    DMA: 693,
  },
  "72099": {
    DMA: 693,
  },
  "72101": {
    DMA: 693,
  },
  "72102": {
    DMA: 693,
  },
  "72103": {
    DMA: 693,
  },
  "72104": {
    DMA: 693,
  },
  "72105": {
    DMA: 693,
  },
  "72106": {
    DMA: 693,
  },
  "72107": {
    DMA: 693,
  },
  "72108": {
    DMA: 693,
  },
  "72110": {
    DMA: 693,
  },
  "72111": {
    DMA: 693,
  },
  "72112": {
    DMA: 693,
  },
  "72113": {
    DMA: 693,
  },
  "72114": {
    DMA: 693,
  },
  "72115": {
    DMA: 693,
  },
  "72116": {
    DMA: 693,
  },
  "72117": {
    DMA: 693,
  },
  "72118": {
    DMA: 693,
  },
  "72119": {
    DMA: 693,
  },
  "72120": {
    DMA: 693,
  },
  "72121": {
    DMA: 693,
  },
  "72122": {
    DMA: 693,
  },
  "72123": {
    DMA: 693,
  },
  "72124": {
    DMA: 693,
  },
  "72125": {
    DMA: 693,
  },
  "72126": {
    DMA: 693,
  },
  "72127": {
    DMA: 693,
  },
  "72128": {
    DMA: 693,
  },
  "72129": {
    DMA: 693,
  },
  "72130": {
    DMA: 693,
  },
  "72131": {
    DMA: 693,
  },
  "72132": {
    DMA: 693,
  },
  "72133": {
    DMA: 693,
  },
  "72134": {
    DMA: 693,
  },
  "72135": {
    DMA: 693,
  },
  "72136": {
    DMA: 693,
  },
  "72137": {
    DMA: 693,
  },
  "72139": {
    DMA: 693,
  },
  "72140": {
    DMA: 693,
  },
  "72141": {
    DMA: 693,
  },
  "72142": {
    DMA: 693,
  },
  "72143": {
    DMA: 693,
  },
  "72145": {
    DMA: 693,
  },
  "72149": {
    DMA: 693,
  },
  "72150": {
    DMA: 693,
  },
  "72152": {
    DMA: 693,
  },
  "72153": {
    DMA: 693,
  },
  "72156": {
    DMA: 693,
  },
  "72157": {
    DMA: 693,
  },
  "72158": {
    DMA: 693,
  },
  "72160": {
    DMA: 693,
  },
  "72164": {
    DMA: 693,
  },
  "72165": {
    DMA: 693,
  },
  "72166": {
    DMA: 693,
  },
  "72167": {
    DMA: 693,
  },
  "72168": {
    DMA: 693,
  },
  "72169": {
    DMA: 693,
  },
  "72170": {
    DMA: 693,
  },
  "72173": {
    DMA: 693,
  },
  "72175": {
    DMA: 693,
  },
  "72176": {
    DMA: 693,
  },
  "72178": {
    DMA: 693,
  },
  "72179": {
    DMA: 693,
  },
  "72180": {
    DMA: 693,
  },
  "72181": {
    DMA: 693,
  },
  "72182": {
    DMA: 693,
  },
  "72183": {
    DMA: 693,
  },
  "72189": {
    DMA: 693,
  },
  "72190": {
    DMA: 693,
  },
  "72198": {
    DMA: 693,
  },
  "72199": {
    DMA: 693,
  },
  "72201": {
    DMA: 693,
  },
  "72202": {
    DMA: 693,
  },
  "72203": {
    DMA: 693,
  },
  "72204": {
    DMA: 693,
  },
  "72205": {
    DMA: 693,
  },
  "72206": {
    DMA: 693,
  },
  "72207": {
    DMA: 693,
  },
  "72209": {
    DMA: 693,
  },
  "72210": {
    DMA: 693,
  },
  "72211": {
    DMA: 693,
  },
  "72212": {
    DMA: 693,
  },
  "72214": {
    DMA: 693,
  },
  "72215": {
    DMA: 693,
  },
  "72216": {
    DMA: 693,
  },
  "72217": {
    DMA: 693,
  },
  "72219": {
    DMA: 693,
  },
  "72221": {
    DMA: 693,
  },
  "72222": {
    DMA: 693,
  },
  "72223": {
    DMA: 693,
  },
  "72225": {
    DMA: 693,
  },
  "72227": {
    DMA: 693,
  },
  "72231": {
    DMA: 693,
  },
  "72255": {
    DMA: 693,
  },
  "72260": {
    DMA: 693,
  },
  "72295": {
    DMA: 693,
  },
  "72301": {
    DMA: 640,
  },
  "72303": {
    DMA: 640,
  },
  "72310": {
    DMA: 640,
  },
  "72311": {
    DMA: 640,
  },
  "72312": {
    DMA: 640,
  },
  "72313": {
    DMA: 640,
  },
  "72315": {
    DMA: 640,
  },
  "72316": {
    DMA: 640,
  },
  "72319": {
    DMA: 640,
  },
  "72320": {
    DMA: 640,
  },
  "72321": {
    DMA: 640,
  },
  "72322": {
    DMA: 640,
  },
  "72324": {
    DMA: 640,
  },
  "72325": {
    DMA: 640,
  },
  "72326": {
    DMA: 640,
  },
  "72327": {
    DMA: 640,
  },
  "72328": {
    DMA: 640,
  },
  "72329": {
    DMA: 640,
  },
  "72330": {
    DMA: 640,
  },
  "72331": {
    DMA: 640,
  },
  "72332": {
    DMA: 640,
  },
  "72333": {
    DMA: 640,
  },
  "72335": {
    DMA: 640,
  },
  "72336": {
    DMA: 640,
  },
  "72338": {
    DMA: 640,
  },
  "72339": {
    DMA: 640,
  },
  "72340": {
    DMA: 640,
  },
  "72341": {
    DMA: 640,
  },
  "72342": {
    DMA: 640,
  },
  "72346": {
    DMA: 640,
  },
  "72347": {
    DMA: 640,
  },
  "72348": {
    DMA: 640,
  },
  "72350": {
    DMA: 640,
  },
  "72351": {
    DMA: 640,
  },
  "72352": {
    DMA: 640,
  },
  "72353": {
    DMA: 640,
  },
  "72354": {
    DMA: 640,
  },
  "72355": {
    DMA: 640,
  },
  "72358": {
    DMA: 640,
  },
  "72359": {
    DMA: 640,
  },
  "72360": {
    DMA: 640,
  },
  "72364": {
    DMA: 640,
  },
  "72365": {
    DMA: 640,
  },
  "72366": {
    DMA: 640,
  },
  "72367": {
    DMA: 640,
  },
  "72368": {
    DMA: 640,
  },
  "72369": {
    DMA: 640,
  },
  "72370": {
    DMA: 640,
  },
  "72372": {
    DMA: 640,
  },
  "72373": {
    DMA: 640,
  },
  "72374": {
    DMA: 640,
  },
  "72376": {
    DMA: 640,
  },
  "72377": {
    DMA: 640,
  },
  "72379": {
    DMA: 693,
  },
  "72383": {
    DMA: 640,
  },
  "72384": {
    DMA: 640,
  },
  "72386": {
    DMA: 640,
  },
  "72387": {
    DMA: 640,
  },
  "72389": {
    DMA: 640,
  },
  "72390": {
    DMA: 640,
  },
  "72391": {
    DMA: 640,
  },
  "72392": {
    DMA: 640,
  },
  "72394": {
    DMA: 640,
  },
  "72395": {
    DMA: 640,
  },
  "72396": {
    DMA: 640,
  },
  "72401": {
    DMA: 734,
  },
  "72402": {
    DMA: 734,
  },
  "72403": {
    DMA: 734,
  },
  "72404": {
    DMA: 734,
  },
  "72405": {
    DMA: 734,
  },
  "72410": {
    DMA: 734,
  },
  "72411": {
    DMA: 734,
  },
  "72412": {
    DMA: 734,
  },
  "72413": {
    DMA: 734,
  },
  "72414": {
    DMA: 734,
  },
  "72415": {
    DMA: 734,
  },
  "72416": {
    DMA: 734,
  },
  "72417": {
    DMA: 734,
  },
  "72419": {
    DMA: 734,
  },
  "72421": {
    DMA: 734,
  },
  "72422": {
    DMA: 734,
  },
  "72424": {
    DMA: 734,
  },
  "72425": {
    DMA: 734,
  },
  "72426": {
    DMA: 640,
  },
  "72427": {
    DMA: 734,
  },
  "72428": {
    DMA: 640,
  },
  "72429": {
    DMA: 640,
  },
  "72430": {
    DMA: 734,
  },
  "72431": {
    DMA: 693,
  },
  "72432": {
    DMA: 640,
  },
  "72433": {
    DMA: 734,
  },
  "72434": {
    DMA: 734,
  },
  "72435": {
    DMA: 734,
  },
  "72436": {
    DMA: 734,
  },
  "72437": {
    DMA: 734,
  },
  "72438": {
    DMA: 640,
  },
  "72439": {
    DMA: 734,
  },
  "72440": {
    DMA: 734,
  },
  "72441": {
    DMA: 734,
  },
  "72442": {
    DMA: 640,
  },
  "72443": {
    DMA: 734,
  },
  "72444": {
    DMA: 734,
  },
  "72445": {
    DMA: 734,
  },
  "72447": {
    DMA: 734,
  },
  "72449": {
    DMA: 734,
  },
  "72450": {
    DMA: 734,
  },
  "72451": {
    DMA: 734,
  },
  "72453": {
    DMA: 734,
  },
  "72454": {
    DMA: 734,
  },
  "72455": {
    DMA: 734,
  },
  "72456": {
    DMA: 734,
  },
  "72457": {
    DMA: 734,
  },
  "72458": {
    DMA: 734,
  },
  "72459": {
    DMA: 734,
  },
  "72460": {
    DMA: 734,
  },
  "72461": {
    DMA: 734,
  },
  "72462": {
    DMA: 734,
  },
  "72464": {
    DMA: 734,
  },
  "72465": {
    DMA: 734,
  },
  "72466": {
    DMA: 734,
  },
  "72467": {
    DMA: 734,
  },
  "72469": {
    DMA: 734,
  },
  "72470": {
    DMA: 734,
  },
  "72471": {
    DMA: 693,
  },
  "72472": {
    DMA: 640,
  },
  "72473": {
    DMA: 693,
  },
  "72474": {
    DMA: 734,
  },
  "72475": {
    DMA: 640,
  },
  "72476": {
    DMA: 734,
  },
  "72478": {
    DMA: 734,
  },
  "72479": {
    DMA: 640,
  },
  "72482": {
    DMA: 734,
  },
  "72501": {
    DMA: 693,
  },
  "72503": {
    DMA: 693,
  },
  "72512": {
    DMA: 693,
  },
  "72513": {
    DMA: 734,
  },
  "72515": {
    DMA: 619,
  },
  "72517": {
    DMA: 693,
  },
  "72519": {
    DMA: 693,
  },
  "72520": {
    DMA: 619,
  },
  "72521": {
    DMA: 734,
  },
  "72522": {
    DMA: 693,
  },
  "72523": {
    DMA: 693,
  },
  "72524": {
    DMA: 693,
  },
  "72525": {
    DMA: 734,
  },
  "72526": {
    DMA: 693,
  },
  "72527": {
    DMA: 693,
  },
  "72528": {
    DMA: 693,
  },
  "72529": {
    DMA: 734,
  },
  "72530": {
    DMA: 693,
  },
  "72531": {
    DMA: 619,
  },
  "72532": {
    DMA: 734,
  },
  "72533": {
    DMA: 693,
  },
  "72534": {
    DMA: 693,
  },
  "72536": {
    DMA: 693,
  },
  "72537": {
    DMA: 619,
  },
  "72538": {
    DMA: 619,
  },
  "72539": {
    DMA: 619,
  },
  "72540": {
    DMA: 693,
  },
  "72542": {
    DMA: 734,
  },
  "72543": {
    DMA: 693,
  },
  "72544": {
    DMA: 619,
  },
  "72545": {
    DMA: 693,
  },
  "72546": {
    DMA: 693,
  },
  "72550": {
    DMA: 693,
  },
  "72553": {
    DMA: 693,
  },
  "72554": {
    DMA: 619,
  },
  "72555": {
    DMA: 693,
  },
  "72556": {
    DMA: 693,
  },
  "72560": {
    DMA: 693,
  },
  "72561": {
    DMA: 693,
  },
  "72562": {
    DMA: 693,
  },
  "72564": {
    DMA: 693,
  },
  "72565": {
    DMA: 693,
  },
  "72566": {
    DMA: 693,
  },
  "72567": {
    DMA: 693,
  },
  "72568": {
    DMA: 693,
  },
  "72569": {
    DMA: 734,
  },
  "72571": {
    DMA: 693,
  },
  "72572": {
    DMA: 734,
  },
  "72573": {
    DMA: 693,
  },
  "72575": {
    DMA: 693,
  },
  "72576": {
    DMA: 619,
  },
  "72577": {
    DMA: 734,
  },
  "72578": {
    DMA: 619,
  },
  "72579": {
    DMA: 693,
  },
  "72581": {
    DMA: 693,
  },
  "72583": {
    DMA: 619,
  },
  "72584": {
    DMA: 693,
  },
  "72585": {
    DMA: 693,
  },
  "72587": {
    DMA: 693,
  },
  "72601": {
    DMA: 619,
  },
  "72602": {
    DMA: 619,
  },
  "72611": {
    DMA: 619,
  },
  "72613": {
    DMA: 619,
  },
  "72615": {
    DMA: 619,
  },
  "72616": {
    DMA: 619,
  },
  "72617": {
    DMA: 619,
  },
  "72619": {
    DMA: 619,
  },
  "72623": {
    DMA: 619,
  },
  "72624": {
    DMA: 619,
  },
  "72626": {
    DMA: 619,
  },
  "72628": {
    DMA: 619,
  },
  "72629": {
    DMA: 693,
  },
  "72630": {
    DMA: 619,
  },
  "72631": {
    DMA: 619,
  },
  "72632": {
    DMA: 619,
  },
  "72633": {
    DMA: 619,
  },
  "72634": {
    DMA: 619,
  },
  "72635": {
    DMA: 619,
  },
  "72636": {
    DMA: 693,
  },
  "72638": {
    DMA: 619,
  },
  "72639": {
    DMA: 693,
  },
  "72640": {
    DMA: 619,
  },
  "72641": {
    DMA: 619,
  },
  "72642": {
    DMA: 619,
  },
  "72643": {
    DMA: 619,
  },
  "72644": {
    DMA: 619,
  },
  "72645": {
    DMA: 693,
  },
  "72648": {
    DMA: 619,
  },
  "72650": {
    DMA: 693,
  },
  "72651": {
    DMA: 619,
  },
  "72653": {
    DMA: 619,
  },
  "72654": {
    DMA: 619,
  },
  "72655": {
    DMA: 619,
  },
  "72657": {
    DMA: 693,
  },
  "72658": {
    DMA: 619,
  },
  "72659": {
    DMA: 619,
  },
  "72660": {
    DMA: 619,
  },
  "72661": {
    DMA: 619,
  },
  "72662": {
    DMA: 619,
  },
  "72663": {
    DMA: 693,
  },
  "72666": {
    DMA: 619,
  },
  "72668": {
    DMA: 619,
  },
  "72669": {
    DMA: 693,
  },
  "72670": {
    DMA: 619,
  },
  "72672": {
    DMA: 619,
  },
  "72675": {
    DMA: 693,
  },
  "72677": {
    DMA: 619,
  },
  "72679": {
    DMA: 693,
  },
  "72680": {
    DMA: 693,
  },
  "72682": {
    DMA: 619,
  },
  "72683": {
    DMA: 619,
  },
  "72685": {
    DMA: 619,
  },
  "72686": {
    DMA: 693,
  },
  "72687": {
    DMA: 619,
  },
  "72701": {
    DMA: 670,
  },
  "72702": {
    DMA: 670,
  },
  "72703": {
    DMA: 670,
  },
  "72704": {
    DMA: 670,
  },
  "72711": {
    DMA: 670,
  },
  "72712": {
    DMA: 670,
  },
  "72713": {
    DMA: 670,
  },
  "72714": {
    DMA: 670,
  },
  "72715": {
    DMA: 670,
  },
  "72716": {
    DMA: 670,
  },
  "72717": {
    DMA: 670,
  },
  "72718": {
    DMA: 670,
  },
  "72719": {
    DMA: 670,
  },
  "72721": {
    DMA: 670,
  },
  "72722": {
    DMA: 670,
  },
  "72727": {
    DMA: 670,
  },
  "72728": {
    DMA: 670,
  },
  "72729": {
    DMA: 670,
  },
  "72730": {
    DMA: 670,
  },
  "72732": {
    DMA: 670,
  },
  "72733": {
    DMA: 670,
  },
  "72734": {
    DMA: 670,
  },
  "72735": {
    DMA: 670,
  },
  "72736": {
    DMA: 670,
  },
  "72737": {
    DMA: 670,
  },
  "72738": {
    DMA: 670,
  },
  "72739": {
    DMA: 670,
  },
  "72740": {
    DMA: 670,
  },
  "72741": {
    DMA: 670,
  },
  "72742": {
    DMA: 670,
  },
  "72744": {
    DMA: 670,
  },
  "72745": {
    DMA: 670,
  },
  "72747": {
    DMA: 670,
  },
  "72749": {
    DMA: 670,
  },
  "72751": {
    DMA: 670,
  },
  "72752": {
    DMA: 670,
  },
  "72753": {
    DMA: 670,
  },
  "72756": {
    DMA: 670,
  },
  "72757": {
    DMA: 670,
  },
  "72758": {
    DMA: 670,
  },
  "72760": {
    DMA: 670,
  },
  "72761": {
    DMA: 670,
  },
  "72762": {
    DMA: 670,
  },
  "72764": {
    DMA: 670,
  },
  "72765": {
    DMA: 670,
  },
  "72766": {
    DMA: 670,
  },
  "72768": {
    DMA: 670,
  },
  "72769": {
    DMA: 670,
  },
  "72770": {
    DMA: 670,
  },
  "72773": {
    DMA: 670,
  },
  "72774": {
    DMA: 670,
  },
  "72776": {
    DMA: 670,
  },
  "72801": {
    DMA: 693,
  },
  "72802": {
    DMA: 693,
  },
  "72811": {
    DMA: 693,
  },
  "72812": {
    DMA: 693,
  },
  "72820": {
    DMA: 670,
  },
  "72821": {
    DMA: 670,
  },
  "72823": {
    DMA: 693,
  },
  "72824": {
    DMA: 693,
  },
  "72826": {
    DMA: 670,
  },
  "72827": {
    DMA: 693,
  },
  "72828": {
    DMA: 693,
  },
  "72829": {
    DMA: 693,
  },
  "72830": {
    DMA: 670,
  },
  "72832": {
    DMA: 670,
  },
  "72833": {
    DMA: 693,
  },
  "72834": {
    DMA: 693,
  },
  "72835": {
    DMA: 670,
  },
  "72837": {
    DMA: 693,
  },
  "72838": {
    DMA: 693,
  },
  "72839": {
    DMA: 670,
  },
  "72840": {
    DMA: 670,
  },
  "72841": {
    DMA: 670,
  },
  "72842": {
    DMA: 693,
  },
  "72843": {
    DMA: 693,
  },
  "72845": {
    DMA: 670,
  },
  "72846": {
    DMA: 670,
  },
  "72847": {
    DMA: 693,
  },
  "72851": {
    DMA: 670,
  },
  "72852": {
    DMA: 670,
  },
  "72853": {
    DMA: 693,
  },
  "72854": {
    DMA: 670,
  },
  "72855": {
    DMA: 670,
  },
  "72856": {
    DMA: 619,
  },
  "72857": {
    DMA: 693,
  },
  "72858": {
    DMA: 693,
  },
  "72860": {
    DMA: 693,
  },
  "72863": {
    DMA: 670,
  },
  "72865": {
    DMA: 670,
  },
  "72901": {
    DMA: 670,
  },
  "72902": {
    DMA: 670,
  },
  "72903": {
    DMA: 670,
  },
  "72904": {
    DMA: 670,
  },
  "72905": {
    DMA: 670,
  },
  "72906": {
    DMA: 670,
  },
  "72908": {
    DMA: 670,
  },
  "72913": {
    DMA: 670,
  },
  "72914": {
    DMA: 670,
  },
  "72916": {
    DMA: 670,
  },
  "72917": {
    DMA: 670,
  },
  "72918": {
    DMA: 670,
  },
  "72919": {
    DMA: 670,
  },
  "72921": {
    DMA: 670,
  },
  "72923": {
    DMA: 670,
  },
  "72926": {
    DMA: 670,
  },
  "72927": {
    DMA: 670,
  },
  "72928": {
    DMA: 670,
  },
  "72930": {
    DMA: 670,
  },
  "72932": {
    DMA: 670,
  },
  "72933": {
    DMA: 670,
  },
  "72934": {
    DMA: 670,
  },
  "72935": {
    DMA: 670,
  },
  "72936": {
    DMA: 670,
  },
  "72937": {
    DMA: 670,
  },
  "72938": {
    DMA: 670,
  },
  "72940": {
    DMA: 670,
  },
  "72941": {
    DMA: 670,
  },
  "72943": {
    DMA: 670,
  },
  "72944": {
    DMA: 670,
  },
  "72945": {
    DMA: 670,
  },
  "72946": {
    DMA: 670,
  },
  "72947": {
    DMA: 670,
  },
  "72948": {
    DMA: 670,
  },
  "72949": {
    DMA: 670,
  },
  "72950": {
    DMA: 670,
  },
  "72951": {
    DMA: 670,
  },
  "72952": {
    DMA: 670,
  },
  "72955": {
    DMA: 670,
  },
  "72956": {
    DMA: 670,
  },
  "72957": {
    DMA: 670,
  },
  "72958": {
    DMA: 670,
  },
  "72959": {
    DMA: 670,
  },
  "73001": {
    DMA: 650,
  },
  "73002": {
    DMA: 650,
  },
  "73003": {
    DMA: 650,
  },
  "73004": {
    DMA: 650,
  },
  "73005": {
    DMA: 650,
  },
  "73006": {
    DMA: 650,
  },
  "73007": {
    DMA: 650,
  },
  "73008": {
    DMA: 650,
  },
  "73009": {
    DMA: 650,
  },
  "73010": {
    DMA: 650,
  },
  "73011": {
    DMA: 650,
  },
  "73012": {
    DMA: 650,
  },
  "73013": {
    DMA: 650,
  },
  "73014": {
    DMA: 650,
  },
  "73015": {
    DMA: 650,
  },
  "73016": {
    DMA: 650,
  },
  "73017": {
    DMA: 650,
  },
  "73018": {
    DMA: 650,
  },
  "73019": {
    DMA: 650,
  },
  "73020": {
    DMA: 650,
  },
  "73021": {
    DMA: 650,
  },
  "73022": {
    DMA: 650,
  },
  "73023": {
    DMA: 650,
  },
  "73024": {
    DMA: 650,
  },
  "73025": {
    DMA: 650,
  },
  "73026": {
    DMA: 650,
  },
  "73027": {
    DMA: 650,
  },
  "73028": {
    DMA: 650,
  },
  "73029": {
    DMA: 650,
  },
  "73030": {
    DMA: 650,
  },
  "73031": {
    DMA: 650,
  },
  "73032": {
    DMA: 650,
  },
  "73033": {
    DMA: 650,
  },
  "73034": {
    DMA: 650,
  },
  "73036": {
    DMA: 650,
  },
  "73038": {
    DMA: 650,
  },
  "73039": {
    DMA: 650,
  },
  "73040": {
    DMA: 650,
  },
  "73041": {
    DMA: 650,
  },
  "73042": {
    DMA: 650,
  },
  "73043": {
    DMA: 650,
  },
  "73044": {
    DMA: 650,
  },
  "73045": {
    DMA: 650,
  },
  "73047": {
    DMA: 650,
  },
  "73048": {
    DMA: 650,
  },
  "73049": {
    DMA: 650,
  },
  "73050": {
    DMA: 650,
  },
  "73051": {
    DMA: 650,
  },
  "73052": {
    DMA: 650,
  },
  "73053": {
    DMA: 650,
  },
  "73054": {
    DMA: 650,
  },
  "73055": {
    DMA: 627,
  },
  "73056": {
    DMA: 650,
  },
  "73057": {
    DMA: 650,
  },
  "73058": {
    DMA: 650,
  },
  "73059": {
    DMA: 650,
  },
  "73061": {
    DMA: 650,
  },
  "73062": {
    DMA: 650,
  },
  "73063": {
    DMA: 650,
  },
  "73064": {
    DMA: 650,
  },
  "73065": {
    DMA: 650,
  },
  "73066": {
    DMA: 650,
  },
  "73067": {
    DMA: 650,
  },
  "73068": {
    DMA: 650,
  },
  "73069": {
    DMA: 650,
  },
  "73070": {
    DMA: 650,
  },
  "73071": {
    DMA: 650,
  },
  "73072": {
    DMA: 650,
  },
  "73073": {
    DMA: 650,
  },
  "73074": {
    DMA: 650,
  },
  "73075": {
    DMA: 650,
  },
  "73077": {
    DMA: 650,
  },
  "73078": {
    DMA: 650,
  },
  "73079": {
    DMA: 650,
  },
  "73080": {
    DMA: 650,
  },
  "73082": {
    DMA: 650,
  },
  "73083": {
    DMA: 650,
  },
  "73084": {
    DMA: 650,
  },
  "73085": {
    DMA: 650,
  },
  "73086": {
    DMA: 650,
  },
  "73089": {
    DMA: 650,
  },
  "73090": {
    DMA: 650,
  },
  "73092": {
    DMA: 650,
  },
  "73093": {
    DMA: 650,
  },
  "73094": {
    DMA: 650,
  },
  "73095": {
    DMA: 650,
  },
  "73096": {
    DMA: 650,
  },
  "73097": {
    DMA: 650,
  },
  "73098": {
    DMA: 650,
  },
  "73099": {
    DMA: 650,
  },
  "73101": {
    DMA: 650,
  },
  "73102": {
    DMA: 650,
  },
  "73103": {
    DMA: 650,
  },
  "73104": {
    DMA: 650,
  },
  "73105": {
    DMA: 650,
  },
  "73106": {
    DMA: 650,
  },
  "73107": {
    DMA: 650,
  },
  "73108": {
    DMA: 650,
  },
  "73109": {
    DMA: 650,
  },
  "73110": {
    DMA: 650,
  },
  "73111": {
    DMA: 650,
  },
  "73112": {
    DMA: 650,
  },
  "73113": {
    DMA: 650,
  },
  "73114": {
    DMA: 650,
  },
  "73115": {
    DMA: 650,
  },
  "73116": {
    DMA: 650,
  },
  "73117": {
    DMA: 650,
  },
  "73118": {
    DMA: 650,
  },
  "73119": {
    DMA: 650,
  },
  "73120": {
    DMA: 650,
  },
  "73121": {
    DMA: 650,
  },
  "73122": {
    DMA: 650,
  },
  "73123": {
    DMA: 650,
  },
  "73124": {
    DMA: 650,
  },
  "73125": {
    DMA: 650,
  },
  "73126": {
    DMA: 650,
  },
  "73127": {
    DMA: 650,
  },
  "73128": {
    DMA: 650,
  },
  "73129": {
    DMA: 650,
  },
  "73130": {
    DMA: 650,
  },
  "73131": {
    DMA: 650,
  },
  "73132": {
    DMA: 650,
  },
  "73134": {
    DMA: 650,
  },
  "73135": {
    DMA: 650,
  },
  "73136": {
    DMA: 650,
  },
  "73137": {
    DMA: 650,
  },
  "73139": {
    DMA: 650,
  },
  "73140": {
    DMA: 650,
  },
  "73141": {
    DMA: 650,
  },
  "73142": {
    DMA: 650,
  },
  "73143": {
    DMA: 650,
  },
  "73144": {
    DMA: 650,
  },
  "73145": {
    DMA: 650,
  },
  "73146": {
    DMA: 650,
  },
  "73147": {
    DMA: 650,
  },
  "73148": {
    DMA: 650,
  },
  "73149": {
    DMA: 650,
  },
  "73150": {
    DMA: 650,
  },
  "73151": {
    DMA: 650,
  },
  "73152": {
    DMA: 650,
  },
  "73153": {
    DMA: 650,
  },
  "73154": {
    DMA: 650,
  },
  "73155": {
    DMA: 650,
  },
  "73156": {
    DMA: 650,
  },
  "73157": {
    DMA: 650,
  },
  "73159": {
    DMA: 650,
  },
  "73160": {
    DMA: 650,
  },
  "73162": {
    DMA: 650,
  },
  "73163": {
    DMA: 650,
  },
  "73164": {
    DMA: 650,
  },
  "73165": {
    DMA: 650,
  },
  "73167": {
    DMA: 650,
  },
  "73169": {
    DMA: 650,
  },
  "73170": {
    DMA: 650,
  },
  "73172": {
    DMA: 650,
  },
  "73173": {
    DMA: 650,
  },
  "73178": {
    DMA: 650,
  },
  "73179": {
    DMA: 650,
  },
  "73184": {
    DMA: 650,
  },
  "73185": {
    DMA: 650,
  },
  "73189": {
    DMA: 650,
  },
  "73190": {
    DMA: 650,
  },
  "73193": {
    DMA: 650,
  },
  "73194": {
    DMA: 650,
  },
  "73195": {
    DMA: 650,
  },
  "73196": {
    DMA: 650,
  },
  "73197": {
    DMA: 650,
  },
  "73198": {
    DMA: 650,
  },
  "73199": {
    DMA: 650,
  },
  "73301": {
    DMA: 635,
  },
  "73344": {
    DMA: 635,
  },
  "73401": {
    DMA: 657,
  },
  "73402": {
    DMA: 657,
  },
  "73403": {
    DMA: 657,
  },
  "73425": {
    DMA: 627,
  },
  "73430": {
    DMA: 657,
  },
  "73432": {
    DMA: 657,
  },
  "73433": {
    DMA: 650,
  },
  "73434": {
    DMA: 627,
  },
  "73435": {
    DMA: 657,
  },
  "73436": {
    DMA: 657,
  },
  "73437": {
    DMA: 657,
  },
  "73438": {
    DMA: 657,
  },
  "73439": {
    DMA: 657,
  },
  "73440": {
    DMA: 657,
  },
  "73441": {
    DMA: 657,
  },
  "73442": {
    DMA: 627,
  },
  "73443": {
    DMA: 657,
  },
  "73444": {
    DMA: 657,
  },
  "73446": {
    DMA: 657,
  },
  "73447": {
    DMA: 657,
  },
  "73448": {
    DMA: 657,
  },
  "73449": {
    DMA: 657,
  },
  "73450": {
    DMA: 657,
  },
  "73451": {
    DMA: 650,
  },
  "73453": {
    DMA: 657,
  },
  "73454": {
    DMA: 650,
  },
  "73455": {
    DMA: 657,
  },
  "73456": {
    DMA: 627,
  },
  "73458": {
    DMA: 657,
  },
  "73459": {
    DMA: 657,
  },
  "73460": {
    DMA: 657,
  },
  "73461": {
    DMA: 657,
  },
  "73463": {
    DMA: 657,
  },
  "73481": {
    DMA: 657,
  },
  "73487": {
    DMA: 657,
  },
  "73488": {
    DMA: 657,
  },
  "73491": {
    DMA: 627,
  },
  "73501": {
    DMA: 627,
  },
  "73502": {
    DMA: 627,
  },
  "73503": {
    DMA: 627,
  },
  "73505": {
    DMA: 627,
  },
  "73506": {
    DMA: 627,
  },
  "73507": {
    DMA: 627,
  },
  "73520": {
    DMA: 627,
  },
  "73521": {
    DMA: 627,
  },
  "73522": {
    DMA: 627,
  },
  "73523": {
    DMA: 627,
  },
  "73526": {
    DMA: 627,
  },
  "73527": {
    DMA: 627,
  },
  "73528": {
    DMA: 627,
  },
  "73529": {
    DMA: 627,
  },
  "73530": {
    DMA: 627,
  },
  "73531": {
    DMA: 627,
  },
  "73532": {
    DMA: 627,
  },
  "73533": {
    DMA: 627,
  },
  "73534": {
    DMA: 627,
  },
  "73536": {
    DMA: 627,
  },
  "73537": {
    DMA: 627,
  },
  "73538": {
    DMA: 627,
  },
  "73539": {
    DMA: 627,
  },
  "73540": {
    DMA: 627,
  },
  "73541": {
    DMA: 627,
  },
  "73542": {
    DMA: 627,
  },
  "73543": {
    DMA: 627,
  },
  "73544": {
    DMA: 650,
  },
  "73546": {
    DMA: 627,
  },
  "73547": {
    DMA: 650,
  },
  "73548": {
    DMA: 627,
  },
  "73549": {
    DMA: 627,
  },
  "73550": {
    DMA: 650,
  },
  "73551": {
    DMA: 627,
  },
  "73552": {
    DMA: 627,
  },
  "73553": {
    DMA: 627,
  },
  "73554": {
    DMA: 650,
  },
  "73555": {
    DMA: 627,
  },
  "73556": {
    DMA: 627,
  },
  "73557": {
    DMA: 627,
  },
  "73558": {
    DMA: 627,
  },
  "73559": {
    DMA: 650,
  },
  "73560": {
    DMA: 627,
  },
  "73561": {
    DMA: 627,
  },
  "73562": {
    DMA: 627,
  },
  "73564": {
    DMA: 650,
  },
  "73565": {
    DMA: 627,
  },
  "73566": {
    DMA: 650,
  },
  "73567": {
    DMA: 627,
  },
  "73568": {
    DMA: 627,
  },
  "73569": {
    DMA: 627,
  },
  "73570": {
    DMA: 627,
  },
  "73571": {
    DMA: 650,
  },
  "73572": {
    DMA: 627,
  },
  "73573": {
    DMA: 627,
  },
  "73601": {
    DMA: 650,
  },
  "73620": {
    DMA: 650,
  },
  "73622": {
    DMA: 650,
  },
  "73624": {
    DMA: 650,
  },
  "73625": {
    DMA: 650,
  },
  "73626": {
    DMA: 650,
  },
  "73627": {
    DMA: 650,
  },
  "73628": {
    DMA: 650,
  },
  "73632": {
    DMA: 650,
  },
  "73638": {
    DMA: 650,
  },
  "73639": {
    DMA: 650,
  },
  "73641": {
    DMA: 650,
  },
  "73642": {
    DMA: 650,
  },
  "73644": {
    DMA: 650,
  },
  "73645": {
    DMA: 650,
  },
  "73646": {
    DMA: 650,
  },
  "73647": {
    DMA: 650,
  },
  "73648": {
    DMA: 650,
  },
  "73650": {
    DMA: 650,
  },
  "73651": {
    DMA: 650,
  },
  "73654": {
    DMA: 650,
  },
  "73655": {
    DMA: 650,
  },
  "73658": {
    DMA: 650,
  },
  "73659": {
    DMA: 650,
  },
  "73660": {
    DMA: 650,
  },
  "73661": {
    DMA: 650,
  },
  "73662": {
    DMA: 650,
  },
  "73663": {
    DMA: 650,
  },
  "73664": {
    DMA: 650,
  },
  "73666": {
    DMA: 650,
  },
  "73667": {
    DMA: 650,
  },
  "73668": {
    DMA: 650,
  },
  "73669": {
    DMA: 650,
  },
  "73673": {
    DMA: 650,
  },
  "73701": {
    DMA: 650,
  },
  "73702": {
    DMA: 650,
  },
  "73703": {
    DMA: 650,
  },
  "73705": {
    DMA: 650,
  },
  "73706": {
    DMA: 650,
  },
  "73716": {
    DMA: 650,
  },
  "73717": {
    DMA: 650,
  },
  "73718": {
    DMA: 650,
  },
  "73719": {
    DMA: 650,
  },
  "73720": {
    DMA: 650,
  },
  "73722": {
    DMA: 650,
  },
  "73724": {
    DMA: 650,
  },
  "73726": {
    DMA: 650,
  },
  "73727": {
    DMA: 650,
  },
  "73728": {
    DMA: 650,
  },
  "73729": {
    DMA: 650,
  },
  "73730": {
    DMA: 650,
  },
  "73731": {
    DMA: 650,
  },
  "73733": {
    DMA: 650,
  },
  "73734": {
    DMA: 650,
  },
  "73735": {
    DMA: 650,
  },
  "73736": {
    DMA: 650,
  },
  "73737": {
    DMA: 650,
  },
  "73738": {
    DMA: 650,
  },
  "73739": {
    DMA: 650,
  },
  "73741": {
    DMA: 650,
  },
  "73742": {
    DMA: 650,
  },
  "73743": {
    DMA: 650,
  },
  "73744": {
    DMA: 650,
  },
  "73746": {
    DMA: 650,
  },
  "73747": {
    DMA: 650,
  },
  "73749": {
    DMA: 650,
  },
  "73750": {
    DMA: 650,
  },
  "73753": {
    DMA: 650,
  },
  "73754": {
    DMA: 650,
  },
  "73755": {
    DMA: 650,
  },
  "73756": {
    DMA: 650,
  },
  "73757": {
    DMA: 650,
  },
  "73758": {
    DMA: 650,
  },
  "73759": {
    DMA: 650,
  },
  "73760": {
    DMA: 650,
  },
  "73761": {
    DMA: 650,
  },
  "73762": {
    DMA: 650,
  },
  "73763": {
    DMA: 650,
  },
  "73764": {
    DMA: 650,
  },
  "73766": {
    DMA: 650,
  },
  "73768": {
    DMA: 650,
  },
  "73770": {
    DMA: 650,
  },
  "73771": {
    DMA: 650,
  },
  "73772": {
    DMA: 650,
  },
  "73773": {
    DMA: 650,
  },
  "73801": {
    DMA: 650,
  },
  "73802": {
    DMA: 650,
  },
  "73832": {
    DMA: 650,
  },
  "73834": {
    DMA: 650,
  },
  "73835": {
    DMA: 650,
  },
  "73838": {
    DMA: 650,
  },
  "73840": {
    DMA: 650,
  },
  "73841": {
    DMA: 650,
  },
  "73842": {
    DMA: 650,
  },
  "73843": {
    DMA: 650,
  },
  "73844": {
    DMA: 634,
  },
  "73848": {
    DMA: 650,
  },
  "73851": {
    DMA: 650,
  },
  "73852": {
    DMA: 650,
  },
  "73853": {
    DMA: 650,
  },
  "73855": {
    DMA: 650,
  },
  "73857": {
    DMA: 650,
  },
  "73858": {
    DMA: 650,
  },
  "73859": {
    DMA: 650,
  },
  "73860": {
    DMA: 650,
  },
  "73901": {
    DMA: 634,
  },
  "73931": {
    DMA: 634,
  },
  "73932": {
    DMA: 634,
  },
  "73933": {
    DMA: 634,
  },
  "73937": {
    DMA: 634,
  },
  "73938": {
    DMA: 634,
  },
  "73939": {
    DMA: 634,
  },
  "73942": {
    DMA: 634,
  },
  "73944": {
    DMA: 634,
  },
  "73945": {
    DMA: 634,
  },
  "73946": {
    DMA: 634,
  },
  "73947": {
    DMA: 634,
  },
  "73949": {
    DMA: 634,
  },
  "73950": {
    DMA: 634,
  },
  "73951": {
    DMA: 634,
  },
  "73960": {
    DMA: 634,
  },
  "74001": {
    DMA: 671,
  },
  "74002": {
    DMA: 671,
  },
  "74003": {
    DMA: 671,
  },
  "74004": {
    DMA: 671,
  },
  "74005": {
    DMA: 671,
  },
  "74006": {
    DMA: 671,
  },
  "74008": {
    DMA: 671,
  },
  "74010": {
    DMA: 671,
  },
  "74011": {
    DMA: 671,
  },
  "74012": {
    DMA: 671,
  },
  "74013": {
    DMA: 671,
  },
  "74014": {
    DMA: 671,
  },
  "74015": {
    DMA: 671,
  },
  "74016": {
    DMA: 671,
  },
  "74017": {
    DMA: 671,
  },
  "74018": {
    DMA: 671,
  },
  "74019": {
    DMA: 671,
  },
  "74020": {
    DMA: 671,
  },
  "74021": {
    DMA: 671,
  },
  "74022": {
    DMA: 671,
  },
  "74023": {
    DMA: 650,
  },
  "74026": {
    DMA: 650,
  },
  "74027": {
    DMA: 671,
  },
  "74028": {
    DMA: 671,
  },
  "74029": {
    DMA: 671,
  },
  "74030": {
    DMA: 671,
  },
  "74031": {
    DMA: 671,
  },
  "74032": {
    DMA: 650,
  },
  "74033": {
    DMA: 671,
  },
  "74034": {
    DMA: 671,
  },
  "74035": {
    DMA: 671,
  },
  "74036": {
    DMA: 671,
  },
  "74037": {
    DMA: 671,
  },
  "74038": {
    DMA: 671,
  },
  "74039": {
    DMA: 671,
  },
  "74041": {
    DMA: 671,
  },
  "74042": {
    DMA: 671,
  },
  "74043": {
    DMA: 671,
  },
  "74044": {
    DMA: 671,
  },
  "74045": {
    DMA: 671,
  },
  "74046": {
    DMA: 671,
  },
  "74047": {
    DMA: 671,
  },
  "74048": {
    DMA: 671,
  },
  "74050": {
    DMA: 671,
  },
  "74051": {
    DMA: 671,
  },
  "74052": {
    DMA: 671,
  },
  "74053": {
    DMA: 671,
  },
  "74054": {
    DMA: 671,
  },
  "74055": {
    DMA: 671,
  },
  "74056": {
    DMA: 671,
  },
  "74058": {
    DMA: 671,
  },
  "74059": {
    DMA: 650,
  },
  "74060": {
    DMA: 671,
  },
  "74061": {
    DMA: 671,
  },
  "74062": {
    DMA: 650,
  },
  "74063": {
    DMA: 671,
  },
  "74066": {
    DMA: 671,
  },
  "74067": {
    DMA: 671,
  },
  "74068": {
    DMA: 671,
  },
  "74070": {
    DMA: 671,
  },
  "74071": {
    DMA: 671,
  },
  "74072": {
    DMA: 671,
  },
  "74073": {
    DMA: 671,
  },
  "74074": {
    DMA: 650,
  },
  "74075": {
    DMA: 650,
  },
  "74076": {
    DMA: 650,
  },
  "74077": {
    DMA: 650,
  },
  "74078": {
    DMA: 650,
  },
  "74079": {
    DMA: 650,
  },
  "74080": {
    DMA: 671,
  },
  "74081": {
    DMA: 671,
  },
  "74082": {
    DMA: 671,
  },
  "74083": {
    DMA: 671,
  },
  "74084": {
    DMA: 671,
  },
  "74085": {
    DMA: 650,
  },
  "74101": {
    DMA: 671,
  },
  "74102": {
    DMA: 671,
  },
  "74103": {
    DMA: 671,
  },
  "74104": {
    DMA: 671,
  },
  "74105": {
    DMA: 671,
  },
  "74106": {
    DMA: 671,
  },
  "74107": {
    DMA: 671,
  },
  "74108": {
    DMA: 671,
  },
  "74110": {
    DMA: 671,
  },
  "74112": {
    DMA: 671,
  },
  "74114": {
    DMA: 671,
  },
  "74115": {
    DMA: 671,
  },
  "74116": {
    DMA: 671,
  },
  "74117": {
    DMA: 671,
  },
  "74119": {
    DMA: 671,
  },
  "74120": {
    DMA: 671,
  },
  "74121": {
    DMA: 671,
  },
  "74126": {
    DMA: 671,
  },
  "74127": {
    DMA: 671,
  },
  "74128": {
    DMA: 671,
  },
  "74129": {
    DMA: 671,
  },
  "74130": {
    DMA: 671,
  },
  "74131": {
    DMA: 671,
  },
  "74132": {
    DMA: 671,
  },
  "74133": {
    DMA: 671,
  },
  "74134": {
    DMA: 671,
  },
  "74135": {
    DMA: 671,
  },
  "74136": {
    DMA: 671,
  },
  "74137": {
    DMA: 671,
  },
  "74141": {
    DMA: 671,
  },
  "74145": {
    DMA: 671,
  },
  "74146": {
    DMA: 671,
  },
  "74147": {
    DMA: 671,
  },
  "74148": {
    DMA: 671,
  },
  "74149": {
    DMA: 671,
  },
  "74150": {
    DMA: 671,
  },
  "74152": {
    DMA: 671,
  },
  "74153": {
    DMA: 671,
  },
  "74155": {
    DMA: 671,
  },
  "74156": {
    DMA: 671,
  },
  "74157": {
    DMA: 671,
  },
  "74158": {
    DMA: 671,
  },
  "74159": {
    DMA: 671,
  },
  "74169": {
    DMA: 671,
  },
  "74170": {
    DMA: 671,
  },
  "74171": {
    DMA: 671,
  },
  "74172": {
    DMA: 671,
  },
  "74182": {
    DMA: 671,
  },
  "74183": {
    DMA: 671,
  },
  "74184": {
    DMA: 671,
  },
  "74186": {
    DMA: 671,
  },
  "74187": {
    DMA: 671,
  },
  "74189": {
    DMA: 671,
  },
  "74192": {
    DMA: 671,
  },
  "74193": {
    DMA: 671,
  },
  "74194": {
    DMA: 671,
  },
  "74301": {
    DMA: 671,
  },
  "74330": {
    DMA: 671,
  },
  "74331": {
    DMA: 603,
  },
  "74332": {
    DMA: 671,
  },
  "74333": {
    DMA: 603,
  },
  "74335": {
    DMA: 603,
  },
  "74337": {
    DMA: 671,
  },
  "74338": {
    DMA: 671,
  },
  "74339": {
    DMA: 603,
  },
  "74340": {
    DMA: 671,
  },
  "74342": {
    DMA: 671,
  },
  "74343": {
    DMA: 603,
  },
  "74344": {
    DMA: 671,
  },
  "74345": {
    DMA: 671,
  },
  "74346": {
    DMA: 671,
  },
  "74347": {
    DMA: 671,
  },
  "74349": {
    DMA: 671,
  },
  "74350": {
    DMA: 671,
  },
  "74352": {
    DMA: 671,
  },
  "74354": {
    DMA: 603,
  },
  "74355": {
    DMA: 603,
  },
  "74358": {
    DMA: 603,
  },
  "74359": {
    DMA: 671,
  },
  "74360": {
    DMA: 603,
  },
  "74361": {
    DMA: 671,
  },
  "74362": {
    DMA: 671,
  },
  "74363": {
    DMA: 603,
  },
  "74364": {
    DMA: 671,
  },
  "74365": {
    DMA: 671,
  },
  "74366": {
    DMA: 671,
  },
  "74367": {
    DMA: 671,
  },
  "74368": {
    DMA: 671,
  },
  "74369": {
    DMA: 671,
  },
  "74370": {
    DMA: 603,
  },
  "74401": {
    DMA: 671,
  },
  "74402": {
    DMA: 671,
  },
  "74403": {
    DMA: 671,
  },
  "74421": {
    DMA: 671,
  },
  "74422": {
    DMA: 671,
  },
  "74423": {
    DMA: 671,
  },
  "74425": {
    DMA: 671,
  },
  "74426": {
    DMA: 671,
  },
  "74427": {
    DMA: 671,
  },
  "74428": {
    DMA: 671,
  },
  "74429": {
    DMA: 671,
  },
  "74430": {
    DMA: 671,
  },
  "74431": {
    DMA: 671,
  },
  "74432": {
    DMA: 671,
  },
  "74434": {
    DMA: 671,
  },
  "74435": {
    DMA: 670,
  },
  "74436": {
    DMA: 671,
  },
  "74437": {
    DMA: 671,
  },
  "74438": {
    DMA: 671,
  },
  "74439": {
    DMA: 671,
  },
  "74440": {
    DMA: 671,
  },
  "74441": {
    DMA: 671,
  },
  "74442": {
    DMA: 671,
  },
  "74444": {
    DMA: 671,
  },
  "74445": {
    DMA: 671,
  },
  "74446": {
    DMA: 671,
  },
  "74447": {
    DMA: 671,
  },
  "74450": {
    DMA: 671,
  },
  "74451": {
    DMA: 671,
  },
  "74452": {
    DMA: 671,
  },
  "74454": {
    DMA: 671,
  },
  "74455": {
    DMA: 671,
  },
  "74456": {
    DMA: 671,
  },
  "74457": {
    DMA: 671,
  },
  "74458": {
    DMA: 671,
  },
  "74459": {
    DMA: 671,
  },
  "74460": {
    DMA: 671,
  },
  "74461": {
    DMA: 671,
  },
  "74462": {
    DMA: 671,
  },
  "74463": {
    DMA: 671,
  },
  "74464": {
    DMA: 671,
  },
  "74465": {
    DMA: 671,
  },
  "74467": {
    DMA: 671,
  },
  "74468": {
    DMA: 671,
  },
  "74469": {
    DMA: 671,
  },
  "74470": {
    DMA: 671,
  },
  "74471": {
    DMA: 671,
  },
  "74472": {
    DMA: 671,
  },
  "74477": {
    DMA: 671,
  },
  "74501": {
    DMA: 671,
  },
  "74502": {
    DMA: 671,
  },
  "74521": {
    DMA: 657,
  },
  "74522": {
    DMA: 671,
  },
  "74523": {
    DMA: 657,
  },
  "74525": {
    DMA: 657,
  },
  "74528": {
    DMA: 671,
  },
  "74529": {
    DMA: 671,
  },
  "74530": {
    DMA: 657,
  },
  "74531": {
    DMA: 650,
  },
  "74533": {
    DMA: 657,
  },
  "74534": {
    DMA: 657,
  },
  "74535": {
    DMA: 657,
  },
  "74536": {
    DMA: 657,
  },
  "74538": {
    DMA: 657,
  },
  "74540": {
    DMA: 657,
  },
  "74542": {
    DMA: 657,
  },
  "74543": {
    DMA: 657,
  },
  "74545": {
    DMA: 671,
  },
  "74546": {
    DMA: 671,
  },
  "74547": {
    DMA: 671,
  },
  "74549": {
    DMA: 670,
  },
  "74552": {
    DMA: 671,
  },
  "74553": {
    DMA: 671,
  },
  "74554": {
    DMA: 671,
  },
  "74555": {
    DMA: 657,
  },
  "74556": {
    DMA: 657,
  },
  "74557": {
    DMA: 657,
  },
  "74558": {
    DMA: 657,
  },
  "74559": {
    DMA: 671,
  },
  "74560": {
    DMA: 671,
  },
  "74561": {
    DMA: 671,
  },
  "74562": {
    DMA: 657,
  },
  "74563": {
    DMA: 671,
  },
  "74565": {
    DMA: 671,
  },
  "74567": {
    DMA: 657,
  },
  "74569": {
    DMA: 657,
  },
  "74570": {
    DMA: 650,
  },
  "74571": {
    DMA: 671,
  },
  "74572": {
    DMA: 657,
  },
  "74574": {
    DMA: 657,
  },
  "74576": {
    DMA: 671,
  },
  "74577": {
    DMA: 670,
  },
  "74578": {
    DMA: 671,
  },
  "74601": {
    DMA: 650,
  },
  "74602": {
    DMA: 650,
  },
  "74604": {
    DMA: 650,
  },
  "74630": {
    DMA: 650,
  },
  "74631": {
    DMA: 650,
  },
  "74632": {
    DMA: 650,
  },
  "74633": {
    DMA: 671,
  },
  "74636": {
    DMA: 650,
  },
  "74637": {
    DMA: 671,
  },
  "74640": {
    DMA: 650,
  },
  "74641": {
    DMA: 650,
  },
  "74643": {
    DMA: 650,
  },
  "74644": {
    DMA: 650,
  },
  "74646": {
    DMA: 650,
  },
  "74647": {
    DMA: 650,
  },
  "74650": {
    DMA: 671,
  },
  "74651": {
    DMA: 650,
  },
  "74652": {
    DMA: 671,
  },
  "74653": {
    DMA: 650,
  },
  "74701": {
    DMA: 657,
  },
  "74702": {
    DMA: 657,
  },
  "74720": {
    DMA: 657,
  },
  "74721": {
    DMA: 657,
  },
  "74722": {
    DMA: 612,
  },
  "74723": {
    DMA: 657,
  },
  "74724": {
    DMA: 612,
  },
  "74726": {
    DMA: 657,
  },
  "74727": {
    DMA: 657,
  },
  "74728": {
    DMA: 612,
  },
  "74729": {
    DMA: 657,
  },
  "74730": {
    DMA: 657,
  },
  "74731": {
    DMA: 657,
  },
  "74733": {
    DMA: 657,
  },
  "74734": {
    DMA: 612,
  },
  "74735": {
    DMA: 657,
  },
  "74736": {
    DMA: 612,
  },
  "74737": {
    DMA: 612,
  },
  "74738": {
    DMA: 657,
  },
  "74740": {
    DMA: 612,
  },
  "74741": {
    DMA: 657,
  },
  "74743": {
    DMA: 657,
  },
  "74745": {
    DMA: 612,
  },
  "74747": {
    DMA: 657,
  },
  "74748": {
    DMA: 657,
  },
  "74750": {
    DMA: 612,
  },
  "74752": {
    DMA: 612,
  },
  "74753": {
    DMA: 657,
  },
  "74754": {
    DMA: 612,
  },
  "74755": {
    DMA: 612,
  },
  "74756": {
    DMA: 657,
  },
  "74759": {
    DMA: 657,
  },
  "74760": {
    DMA: 657,
  },
  "74761": {
    DMA: 657,
  },
  "74764": {
    DMA: 612,
  },
  "74766": {
    DMA: 612,
  },
  "74801": {
    DMA: 650,
  },
  "74802": {
    DMA: 650,
  },
  "74804": {
    DMA: 650,
  },
  "74818": {
    DMA: 650,
  },
  "74820": {
    DMA: 657,
  },
  "74821": {
    DMA: 657,
  },
  "74824": {
    DMA: 650,
  },
  "74825": {
    DMA: 657,
  },
  "74826": {
    DMA: 650,
  },
  "74827": {
    DMA: 650,
  },
  "74829": {
    DMA: 671,
  },
  "74830": {
    DMA: 650,
  },
  "74831": {
    DMA: 650,
  },
  "74832": {
    DMA: 650,
  },
  "74833": {
    DMA: 671,
  },
  "74834": {
    DMA: 650,
  },
  "74836": {
    DMA: 657,
  },
  "74837": {
    DMA: 650,
  },
  "74839": {
    DMA: 650,
  },
  "74840": {
    DMA: 650,
  },
  "74842": {
    DMA: 657,
  },
  "74843": {
    DMA: 657,
  },
  "74844": {
    DMA: 657,
  },
  "74845": {
    DMA: 671,
  },
  "74848": {
    DMA: 650,
  },
  "74849": {
    DMA: 650,
  },
  "74850": {
    DMA: 650,
  },
  "74851": {
    DMA: 650,
  },
  "74852": {
    DMA: 650,
  },
  "74854": {
    DMA: 650,
  },
  "74855": {
    DMA: 650,
  },
  "74856": {
    DMA: 657,
  },
  "74857": {
    DMA: 650,
  },
  "74859": {
    DMA: 671,
  },
  "74860": {
    DMA: 671,
  },
  "74864": {
    DMA: 650,
  },
  "74865": {
    DMA: 657,
  },
  "74866": {
    DMA: 650,
  },
  "74867": {
    DMA: 650,
  },
  "74868": {
    DMA: 650,
  },
  "74869": {
    DMA: 650,
  },
  "74871": {
    DMA: 657,
  },
  "74872": {
    DMA: 650,
  },
  "74873": {
    DMA: 650,
  },
  "74875": {
    DMA: 650,
  },
  "74878": {
    DMA: 650,
  },
  "74880": {
    DMA: 671,
  },
  "74881": {
    DMA: 650,
  },
  "74883": {
    DMA: 650,
  },
  "74884": {
    DMA: 650,
  },
  "74901": {
    DMA: 670,
  },
  "74902": {
    DMA: 670,
  },
  "74930": {
    DMA: 670,
  },
  "74931": {
    DMA: 671,
  },
  "74932": {
    DMA: 670,
  },
  "74935": {
    DMA: 670,
  },
  "74936": {
    DMA: 670,
  },
  "74937": {
    DMA: 670,
  },
  "74939": {
    DMA: 670,
  },
  "74940": {
    DMA: 670,
  },
  "74941": {
    DMA: 671,
  },
  "74942": {
    DMA: 670,
  },
  "74943": {
    DMA: 671,
  },
  "74944": {
    DMA: 671,
  },
  "74945": {
    DMA: 670,
  },
  "74946": {
    DMA: 670,
  },
  "74947": {
    DMA: 670,
  },
  "74948": {
    DMA: 670,
  },
  "74949": {
    DMA: 670,
  },
  "74951": {
    DMA: 670,
  },
  "74953": {
    DMA: 670,
  },
  "74954": {
    DMA: 670,
  },
  "74955": {
    DMA: 670,
  },
  "74956": {
    DMA: 670,
  },
  "74957": {
    DMA: 612,
  },
  "74959": {
    DMA: 670,
  },
  "74960": {
    DMA: 671,
  },
  "74962": {
    DMA: 670,
  },
  "74963": {
    DMA: 612,
  },
  "74964": {
    DMA: 671,
  },
  "74965": {
    DMA: 671,
  },
  "74966": {
    DMA: 670,
  },
  "75001": {
    DMA: 623,
  },
  "75002": {
    DMA: 623,
  },
  "75006": {
    DMA: 623,
  },
  "75007": {
    DMA: 623,
  },
  "75009": {
    DMA: 623,
  },
  "75010": {
    DMA: 623,
  },
  "75011": {
    DMA: 623,
  },
  "75013": {
    DMA: 623,
  },
  "75014": {
    DMA: 623,
  },
  "75015": {
    DMA: 623,
  },
  "75016": {
    DMA: 623,
  },
  "75017": {
    DMA: 623,
  },
  "75019": {
    DMA: 623,
  },
  "75020": {
    DMA: 657,
  },
  "75021": {
    DMA: 657,
  },
  "75022": {
    DMA: 623,
  },
  "75023": {
    DMA: 623,
  },
  "75024": {
    DMA: 623,
  },
  "75025": {
    DMA: 623,
  },
  "75026": {
    DMA: 623,
  },
  "75027": {
    DMA: 623,
  },
  "75028": {
    DMA: 623,
  },
  "75029": {
    DMA: 623,
  },
  "75030": {
    DMA: 623,
  },
  "75032": {
    DMA: 623,
  },
  "75033": {
    DMA: 623,
  },
  "75034": {
    DMA: 623,
  },
  "75035": {
    DMA: 623,
  },
  "75036": {
    DMA: 623,
  },
  "75037": {
    DMA: 623,
  },
  "75038": {
    DMA: 623,
  },
  "75039": {
    DMA: 623,
  },
  "75040": {
    DMA: 623,
  },
  "75041": {
    DMA: 623,
  },
  "75042": {
    DMA: 623,
  },
  "75043": {
    DMA: 623,
  },
  "75044": {
    DMA: 623,
  },
  "75045": {
    DMA: 623,
  },
  "75046": {
    DMA: 623,
  },
  "75047": {
    DMA: 623,
  },
  "75048": {
    DMA: 623,
  },
  "75049": {
    DMA: 623,
  },
  "75050": {
    DMA: 623,
  },
  "75051": {
    DMA: 623,
  },
  "75052": {
    DMA: 623,
  },
  "75053": {
    DMA: 623,
  },
  "75054": {
    DMA: 623,
  },
  "75056": {
    DMA: 623,
  },
  "75057": {
    DMA: 623,
  },
  "75058": {
    DMA: 657,
  },
  "75059": {
    DMA: 623,
  },
  "75060": {
    DMA: 623,
  },
  "75061": {
    DMA: 623,
  },
  "75062": {
    DMA: 623,
  },
  "75063": {
    DMA: 623,
  },
  "75064": {
    DMA: 623,
  },
  "75065": {
    DMA: 623,
  },
  "75067": {
    DMA: 623,
  },
  "75068": {
    DMA: 623,
  },
  "75069": {
    DMA: 623,
  },
  "75070": {
    DMA: 623,
  },
  "75071": {
    DMA: 623,
  },
  "75072": {
    DMA: 623,
  },
  "75074": {
    DMA: 623,
  },
  "75075": {
    DMA: 623,
  },
  "75076": {
    DMA: 657,
  },
  "75077": {
    DMA: 623,
  },
  "75078": {
    DMA: 623,
  },
  "75080": {
    DMA: 623,
  },
  "75081": {
    DMA: 623,
  },
  "75082": {
    DMA: 623,
  },
  "75083": {
    DMA: 623,
  },
  "75085": {
    DMA: 623,
  },
  "75086": {
    DMA: 623,
  },
  "75087": {
    DMA: 623,
  },
  "75088": {
    DMA: 623,
  },
  "75089": {
    DMA: 623,
  },
  "75090": {
    DMA: 657,
  },
  "75091": {
    DMA: 657,
  },
  "75092": {
    DMA: 657,
  },
  "75093": {
    DMA: 623,
  },
  "75094": {
    DMA: 623,
  },
  "75097": {
    DMA: 623,
  },
  "75098": {
    DMA: 623,
  },
  "75099": {
    DMA: 623,
  },
  "75101": {
    DMA: 623,
  },
  "75102": {
    DMA: 623,
  },
  "75103": {
    DMA: 623,
  },
  "75104": {
    DMA: 623,
  },
  "75105": {
    DMA: 623,
  },
  "75106": {
    DMA: 623,
  },
  "75109": {
    DMA: 623,
  },
  "75110": {
    DMA: 623,
  },
  "75114": {
    DMA: 623,
  },
  "75115": {
    DMA: 623,
  },
  "75116": {
    DMA: 623,
  },
  "75117": {
    DMA: 623,
  },
  "75118": {
    DMA: 623,
  },
  "75119": {
    DMA: 623,
  },
  "75120": {
    DMA: 623,
  },
  "75121": {
    DMA: 623,
  },
  "75123": {
    DMA: 623,
  },
  "75124": {
    DMA: 623,
  },
  "75125": {
    DMA: 623,
  },
  "75126": {
    DMA: 623,
  },
  "75127": {
    DMA: 623,
  },
  "75132": {
    DMA: 623,
  },
  "75134": {
    DMA: 623,
  },
  "75135": {
    DMA: 623,
  },
  "75137": {
    DMA: 623,
  },
  "75138": {
    DMA: 623,
  },
  "75140": {
    DMA: 623,
  },
  "75141": {
    DMA: 623,
  },
  "75142": {
    DMA: 623,
  },
  "75143": {
    DMA: 623,
  },
  "75144": {
    DMA: 623,
  },
  "75146": {
    DMA: 623,
  },
  "75147": {
    DMA: 623,
  },
  "75148": {
    DMA: 623,
  },
  "75149": {
    DMA: 623,
  },
  "75150": {
    DMA: 623,
  },
  "75151": {
    DMA: 623,
  },
  "75152": {
    DMA: 623,
  },
  "75153": {
    DMA: 623,
  },
  "75154": {
    DMA: 623,
  },
  "75155": {
    DMA: 623,
  },
  "75156": {
    DMA: 623,
  },
  "75157": {
    DMA: 623,
  },
  "75158": {
    DMA: 623,
  },
  "75159": {
    DMA: 623,
  },
  "75160": {
    DMA: 623,
  },
  "75161": {
    DMA: 623,
  },
  "75163": {
    DMA: 623,
  },
  "75164": {
    DMA: 623,
  },
  "75165": {
    DMA: 623,
  },
  "75166": {
    DMA: 623,
  },
  "75167": {
    DMA: 623,
  },
  "75168": {
    DMA: 623,
  },
  "75169": {
    DMA: 623,
  },
  "75172": {
    DMA: 623,
  },
  "75173": {
    DMA: 623,
  },
  "75180": {
    DMA: 623,
  },
  "75181": {
    DMA: 623,
  },
  "75182": {
    DMA: 623,
  },
  "75185": {
    DMA: 623,
  },
  "75187": {
    DMA: 623,
  },
  "75189": {
    DMA: 623,
  },
  "75201": {
    DMA: 623,
  },
  "75202": {
    DMA: 623,
  },
  "75203": {
    DMA: 623,
  },
  "75204": {
    DMA: 623,
  },
  "75205": {
    DMA: 623,
  },
  "75206": {
    DMA: 623,
  },
  "75207": {
    DMA: 623,
  },
  "75208": {
    DMA: 623,
  },
  "75209": {
    DMA: 623,
  },
  "75210": {
    DMA: 623,
  },
  "75211": {
    DMA: 623,
  },
  "75212": {
    DMA: 623,
  },
  "75214": {
    DMA: 623,
  },
  "75215": {
    DMA: 623,
  },
  "75216": {
    DMA: 623,
  },
  "75217": {
    DMA: 623,
  },
  "75218": {
    DMA: 623,
  },
  "75219": {
    DMA: 623,
  },
  "75220": {
    DMA: 623,
  },
  "75221": {
    DMA: 623,
  },
  "75222": {
    DMA: 623,
  },
  "75223": {
    DMA: 623,
  },
  "75224": {
    DMA: 623,
  },
  "75225": {
    DMA: 623,
  },
  "75226": {
    DMA: 623,
  },
  "75227": {
    DMA: 623,
  },
  "75228": {
    DMA: 623,
  },
  "75229": {
    DMA: 623,
  },
  "75230": {
    DMA: 623,
  },
  "75231": {
    DMA: 623,
  },
  "75232": {
    DMA: 623,
  },
  "75233": {
    DMA: 623,
  },
  "75234": {
    DMA: 623,
  },
  "75235": {
    DMA: 623,
  },
  "75236": {
    DMA: 623,
  },
  "75237": {
    DMA: 623,
  },
  "75238": {
    DMA: 623,
  },
  "75240": {
    DMA: 623,
  },
  "75241": {
    DMA: 623,
  },
  "75242": {
    DMA: 623,
  },
  "75243": {
    DMA: 623,
  },
  "75244": {
    DMA: 623,
  },
  "75245": {
    DMA: 623,
  },
  "75246": {
    DMA: 623,
  },
  "75247": {
    DMA: 623,
  },
  "75248": {
    DMA: 623,
  },
  "75249": {
    DMA: 623,
  },
  "75250": {
    DMA: 623,
  },
  "75251": {
    DMA: 623,
  },
  "75252": {
    DMA: 623,
  },
  "75253": {
    DMA: 623,
  },
  "75254": {
    DMA: 623,
  },
  "75258": {
    DMA: 623,
  },
  "75260": {
    DMA: 623,
  },
  "75261": {
    DMA: 623,
  },
  "75262": {
    DMA: 623,
  },
  "75263": {
    DMA: 623,
  },
  "75264": {
    DMA: 623,
  },
  "75265": {
    DMA: 623,
  },
  "75266": {
    DMA: 623,
  },
  "75267": {
    DMA: 623,
  },
  "75270": {
    DMA: 623,
  },
  "75275": {
    DMA: 623,
  },
  "75277": {
    DMA: 623,
  },
  "75283": {
    DMA: 623,
  },
  "75284": {
    DMA: 623,
  },
  "75285": {
    DMA: 623,
  },
  "75286": {
    DMA: 623,
  },
  "75287": {
    DMA: 623,
  },
  "75301": {
    DMA: 623,
  },
  "75303": {
    DMA: 623,
  },
  "75310": {
    DMA: 623,
  },
  "75312": {
    DMA: 623,
  },
  "75313": {
    DMA: 623,
  },
  "75315": {
    DMA: 623,
  },
  "75320": {
    DMA: 623,
  },
  "75323": {
    DMA: 623,
  },
  "75326": {
    DMA: 623,
  },
  "75334": {
    DMA: 623,
  },
  "75336": {
    DMA: 623,
  },
  "75339": {
    DMA: 623,
  },
  "75340": {
    DMA: 623,
  },
  "75342": {
    DMA: 623,
  },
  "75343": {
    DMA: 623,
  },
  "75344": {
    DMA: 623,
  },
  "75353": {
    DMA: 623,
  },
  "75354": {
    DMA: 623,
  },
  "75355": {
    DMA: 623,
  },
  "75356": {
    DMA: 623,
  },
  "75357": {
    DMA: 623,
  },
  "75358": {
    DMA: 623,
  },
  "75359": {
    DMA: 623,
  },
  "75360": {
    DMA: 623,
  },
  "75363": {
    DMA: 623,
  },
  "75364": {
    DMA: 623,
  },
  "75367": {
    DMA: 623,
  },
  "75368": {
    DMA: 623,
  },
  "75370": {
    DMA: 623,
  },
  "75371": {
    DMA: 623,
  },
  "75372": {
    DMA: 623,
  },
  "75373": {
    DMA: 623,
  },
  "75374": {
    DMA: 623,
  },
  "75376": {
    DMA: 623,
  },
  "75378": {
    DMA: 623,
  },
  "75379": {
    DMA: 623,
  },
  "75380": {
    DMA: 623,
  },
  "75381": {
    DMA: 623,
  },
  "75382": {
    DMA: 623,
  },
  "75386": {
    DMA: 623,
  },
  "75387": {
    DMA: 623,
  },
  "75388": {
    DMA: 623,
  },
  "75389": {
    DMA: 623,
  },
  "75390": {
    DMA: 623,
  },
  "75391": {
    DMA: 623,
  },
  "75392": {
    DMA: 623,
  },
  "75393": {
    DMA: 623,
  },
  "75394": {
    DMA: 623,
  },
  "75395": {
    DMA: 623,
  },
  "75396": {
    DMA: 623,
  },
  "75397": {
    DMA: 623,
  },
  "75398": {
    DMA: 623,
  },
  "75401": {
    DMA: 623,
  },
  "75402": {
    DMA: 623,
  },
  "75403": {
    DMA: 623,
  },
  "75404": {
    DMA: 623,
  },
  "75407": {
    DMA: 623,
  },
  "75409": {
    DMA: 623,
  },
  "75410": {
    DMA: 709,
  },
  "75411": {
    DMA: 623,
  },
  "75412": {
    DMA: 623,
  },
  "75413": {
    DMA: 623,
  },
  "75414": {
    DMA: 657,
  },
  "75415": {
    DMA: 623,
  },
  "75416": {
    DMA: 623,
  },
  "75417": {
    DMA: 623,
  },
  "75418": {
    DMA: 623,
  },
  "75420": {
    DMA: 623,
  },
  "75421": {
    DMA: 623,
  },
  "75422": {
    DMA: 623,
  },
  "75423": {
    DMA: 623,
  },
  "75424": {
    DMA: 623,
  },
  "75425": {
    DMA: 623,
  },
  "75426": {
    DMA: 623,
  },
  "75428": {
    DMA: 623,
  },
  "75429": {
    DMA: 623,
  },
  "75431": {
    DMA: 623,
  },
  "75432": {
    DMA: 623,
  },
  "75433": {
    DMA: 623,
  },
  "75434": {
    DMA: 623,
  },
  "75435": {
    DMA: 623,
  },
  "75436": {
    DMA: 623,
  },
  "75437": {
    DMA: 623,
  },
  "75438": {
    DMA: 623,
  },
  "75439": {
    DMA: 623,
  },
  "75440": {
    DMA: 623,
  },
  "75441": {
    DMA: 623,
  },
  "75442": {
    DMA: 623,
  },
  "75443": {
    DMA: 623,
  },
  "75444": {
    DMA: 709,
  },
  "75446": {
    DMA: 623,
  },
  "75447": {
    DMA: 623,
  },
  "75448": {
    DMA: 623,
  },
  "75449": {
    DMA: 623,
  },
  "75450": {
    DMA: 623,
  },
  "75451": {
    DMA: 709,
  },
  "75452": {
    DMA: 623,
  },
  "75453": {
    DMA: 623,
  },
  "75454": {
    DMA: 623,
  },
  "75455": {
    DMA: 612,
  },
  "75456": {
    DMA: 612,
  },
  "75457": {
    DMA: 709,
  },
  "75458": {
    DMA: 623,
  },
  "75459": {
    DMA: 657,
  },
  "75460": {
    DMA: 623,
  },
  "75461": {
    DMA: 623,
  },
  "75462": {
    DMA: 623,
  },
  "75468": {
    DMA: 623,
  },
  "75469": {
    DMA: 623,
  },
  "75470": {
    DMA: 623,
  },
  "75471": {
    DMA: 623,
  },
  "75472": {
    DMA: 623,
  },
  "75473": {
    DMA: 623,
  },
  "75474": {
    DMA: 623,
  },
  "75475": {
    DMA: 623,
  },
  "75476": {
    DMA: 623,
  },
  "75477": {
    DMA: 623,
  },
  "75478": {
    DMA: 623,
  },
  "75479": {
    DMA: 623,
  },
  "75480": {
    DMA: 709,
  },
  "75481": {
    DMA: 623,
  },
  "75482": {
    DMA: 623,
  },
  "75483": {
    DMA: 623,
  },
  "75485": {
    DMA: 623,
  },
  "75486": {
    DMA: 623,
  },
  "75487": {
    DMA: 709,
  },
  "75488": {
    DMA: 623,
  },
  "75489": {
    DMA: 657,
  },
  "75490": {
    DMA: 623,
  },
  "75491": {
    DMA: 657,
  },
  "75492": {
    DMA: 623,
  },
  "75493": {
    DMA: 612,
  },
  "75494": {
    DMA: 709,
  },
  "75495": {
    DMA: 657,
  },
  "75496": {
    DMA: 623,
  },
  "75497": {
    DMA: 709,
  },
  "75501": {
    DMA: 612,
  },
  "75503": {
    DMA: 612,
  },
  "75504": {
    DMA: 612,
  },
  "75505": {
    DMA: 612,
  },
  "75507": {
    DMA: 612,
  },
  "75550": {
    DMA: 623,
  },
  "75551": {
    DMA: 612,
  },
  "75554": {
    DMA: 623,
  },
  "75555": {
    DMA: 612,
  },
  "75556": {
    DMA: 612,
  },
  "75558": {
    DMA: 612,
  },
  "75559": {
    DMA: 612,
  },
  "75560": {
    DMA: 612,
  },
  "75561": {
    DMA: 612,
  },
  "75562": {
    DMA: 612,
  },
  "75563": {
    DMA: 612,
  },
  "75564": {
    DMA: 612,
  },
  "75565": {
    DMA: 612,
  },
  "75566": {
    DMA: 612,
  },
  "75567": {
    DMA: 612,
  },
  "75568": {
    DMA: 612,
  },
  "75569": {
    DMA: 612,
  },
  "75570": {
    DMA: 612,
  },
  "75571": {
    DMA: 612,
  },
  "75572": {
    DMA: 612,
  },
  "75573": {
    DMA: 612,
  },
  "75574": {
    DMA: 612,
  },
  "75599": {
    DMA: 612,
  },
  "75601": {
    DMA: 709,
  },
  "75602": {
    DMA: 709,
  },
  "75603": {
    DMA: 709,
  },
  "75604": {
    DMA: 709,
  },
  "75605": {
    DMA: 709,
  },
  "75606": {
    DMA: 709,
  },
  "75607": {
    DMA: 709,
  },
  "75608": {
    DMA: 709,
  },
  "75615": {
    DMA: 709,
  },
  "75630": {
    DMA: 612,
  },
  "75631": {
    DMA: 612,
  },
  "75633": {
    DMA: 612,
  },
  "75636": {
    DMA: 612,
  },
  "75637": {
    DMA: 612,
  },
  "75638": {
    DMA: 612,
  },
  "75639": {
    DMA: 612,
  },
  "75640": {
    DMA: 709,
  },
  "75641": {
    DMA: 709,
  },
  "75642": {
    DMA: 612,
  },
  "75643": {
    DMA: 612,
  },
  "75644": {
    DMA: 709,
  },
  "75645": {
    DMA: 709,
  },
  "75647": {
    DMA: 709,
  },
  "75650": {
    DMA: 612,
  },
  "75651": {
    DMA: 612,
  },
  "75652": {
    DMA: 709,
  },
  "75653": {
    DMA: 709,
  },
  "75654": {
    DMA: 709,
  },
  "75656": {
    DMA: 612,
  },
  "75657": {
    DMA: 612,
  },
  "75658": {
    DMA: 709,
  },
  "75659": {
    DMA: 612,
  },
  "75660": {
    DMA: 709,
  },
  "75661": {
    DMA: 612,
  },
  "75662": {
    DMA: 709,
  },
  "75663": {
    DMA: 709,
  },
  "75666": {
    DMA: 709,
  },
  "75667": {
    DMA: 709,
  },
  "75668": {
    DMA: 612,
  },
  "75669": {
    DMA: 612,
  },
  "75670": {
    DMA: 612,
  },
  "75671": {
    DMA: 612,
  },
  "75672": {
    DMA: 612,
  },
  "75680": {
    DMA: 709,
  },
  "75681": {
    DMA: 709,
  },
  "75682": {
    DMA: 709,
  },
  "75683": {
    DMA: 709,
  },
  "75684": {
    DMA: 709,
  },
  "75685": {
    DMA: 612,
  },
  "75686": {
    DMA: 709,
  },
  "75687": {
    DMA: 709,
  },
  "75688": {
    DMA: 612,
  },
  "75689": {
    DMA: 709,
  },
  "75691": {
    DMA: 709,
  },
  "75692": {
    DMA: 612,
  },
  "75693": {
    DMA: 709,
  },
  "75694": {
    DMA: 612,
  },
  "75701": {
    DMA: 709,
  },
  "75702": {
    DMA: 709,
  },
  "75703": {
    DMA: 709,
  },
  "75704": {
    DMA: 709,
  },
  "75705": {
    DMA: 709,
  },
  "75706": {
    DMA: 709,
  },
  "75707": {
    DMA: 709,
  },
  "75708": {
    DMA: 709,
  },
  "75709": {
    DMA: 709,
  },
  "75710": {
    DMA: 709,
  },
  "75711": {
    DMA: 709,
  },
  "75712": {
    DMA: 709,
  },
  "75713": {
    DMA: 709,
  },
  "75750": {
    DMA: 709,
  },
  "75751": {
    DMA: 623,
  },
  "75752": {
    DMA: 623,
  },
  "75754": {
    DMA: 623,
  },
  "75755": {
    DMA: 709,
  },
  "75756": {
    DMA: 623,
  },
  "75757": {
    DMA: 709,
  },
  "75758": {
    DMA: 623,
  },
  "75759": {
    DMA: 709,
  },
  "75760": {
    DMA: 709,
  },
  "75762": {
    DMA: 709,
  },
  "75763": {
    DMA: 623,
  },
  "75764": {
    DMA: 709,
  },
  "75765": {
    DMA: 709,
  },
  "75766": {
    DMA: 709,
  },
  "75770": {
    DMA: 623,
  },
  "75771": {
    DMA: 709,
  },
  "75772": {
    DMA: 709,
  },
  "75773": {
    DMA: 709,
  },
  "75778": {
    DMA: 623,
  },
  "75779": {
    DMA: 623,
  },
  "75780": {
    DMA: 709,
  },
  "75782": {
    DMA: 623,
  },
  "75783": {
    DMA: 709,
  },
  "75784": {
    DMA: 709,
  },
  "75785": {
    DMA: 709,
  },
  "75788": {
    DMA: 709,
  },
  "75789": {
    DMA: 709,
  },
  "75790": {
    DMA: 623,
  },
  "75791": {
    DMA: 709,
  },
  "75792": {
    DMA: 709,
  },
  "75797": {
    DMA: 709,
  },
  "75798": {
    DMA: 709,
  },
  "75799": {
    DMA: 709,
  },
  "75801": {
    DMA: 623,
  },
  "75802": {
    DMA: 623,
  },
  "75803": {
    DMA: 623,
  },
  "75831": {
    DMA: 625,
  },
  "75832": {
    DMA: 623,
  },
  "75833": {
    DMA: 625,
  },
  "75834": {
    DMA: 618,
  },
  "75835": {
    DMA: 709,
  },
  "75838": {
    DMA: 623,
  },
  "75839": {
    DMA: 623,
  },
  "75840": {
    DMA: 623,
  },
  "75844": {
    DMA: 709,
  },
  "75845": {
    DMA: 618,
  },
  "75846": {
    DMA: 625,
  },
  "75847": {
    DMA: 709,
  },
  "75848": {
    DMA: 623,
  },
  "75849": {
    DMA: 709,
  },
  "75850": {
    DMA: 625,
  },
  "75851": {
    DMA: 709,
  },
  "75852": {
    DMA: 625,
  },
  "75853": {
    DMA: 623,
  },
  "75855": {
    DMA: 625,
  },
  "75856": {
    DMA: 618,
  },
  "75858": {
    DMA: 709,
  },
  "75859": {
    DMA: 623,
  },
  "75860": {
    DMA: 623,
  },
  "75861": {
    DMA: 623,
  },
  "75862": {
    DMA: 618,
  },
  "75865": {
    DMA: 618,
  },
  "75880": {
    DMA: 623,
  },
  "75882": {
    DMA: 623,
  },
  "75884": {
    DMA: 623,
  },
  "75886": {
    DMA: 623,
  },
  "75901": {
    DMA: 709,
  },
  "75902": {
    DMA: 709,
  },
  "75903": {
    DMA: 709,
  },
  "75904": {
    DMA: 709,
  },
  "75915": {
    DMA: 709,
  },
  "75925": {
    DMA: 709,
  },
  "75926": {
    DMA: 618,
  },
  "75928": {
    DMA: 692,
  },
  "75929": {
    DMA: 709,
  },
  "75930": {
    DMA: 709,
  },
  "75931": {
    DMA: 692,
  },
  "75932": {
    DMA: 692,
  },
  "75933": {
    DMA: 692,
  },
  "75934": {
    DMA: 618,
  },
  "75935": {
    DMA: 612,
  },
  "75936": {
    DMA: 692,
  },
  "75937": {
    DMA: 709,
  },
  "75938": {
    DMA: 692,
  },
  "75939": {
    DMA: 618,
  },
  "75941": {
    DMA: 709,
  },
  "75942": {
    DMA: 692,
  },
  "75943": {
    DMA: 709,
  },
  "75944": {
    DMA: 709,
  },
  "75946": {
    DMA: 709,
  },
  "75948": {
    DMA: 709,
  },
  "75949": {
    DMA: 709,
  },
  "75951": {
    DMA: 692,
  },
  "75954": {
    DMA: 612,
  },
  "75956": {
    DMA: 692,
  },
  "75958": {
    DMA: 709,
  },
  "75959": {
    DMA: 709,
  },
  "75960": {
    DMA: 618,
  },
  "75961": {
    DMA: 709,
  },
  "75962": {
    DMA: 709,
  },
  "75963": {
    DMA: 709,
  },
  "75964": {
    DMA: 709,
  },
  "75965": {
    DMA: 709,
  },
  "75966": {
    DMA: 692,
  },
  "75968": {
    DMA: 709,
  },
  "75969": {
    DMA: 709,
  },
  "75972": {
    DMA: 709,
  },
  "75973": {
    DMA: 612,
  },
  "75974": {
    DMA: 612,
  },
  "75975": {
    DMA: 612,
  },
  "75976": {
    DMA: 709,
  },
  "75977": {
    DMA: 692,
  },
  "75978": {
    DMA: 709,
  },
  "75979": {
    DMA: 692,
  },
  "75980": {
    DMA: 709,
  },
  "75990": {
    DMA: 692,
  },
  "76001": {
    DMA: 623,
  },
  "76002": {
    DMA: 623,
  },
  "76003": {
    DMA: 623,
  },
  "76004": {
    DMA: 623,
  },
  "76005": {
    DMA: 623,
  },
  "76006": {
    DMA: 623,
  },
  "76007": {
    DMA: 623,
  },
  "76008": {
    DMA: 623,
  },
  "76009": {
    DMA: 623,
  },
  "76010": {
    DMA: 623,
  },
  "76011": {
    DMA: 623,
  },
  "76012": {
    DMA: 623,
  },
  "76013": {
    DMA: 623,
  },
  "76014": {
    DMA: 623,
  },
  "76015": {
    DMA: 623,
  },
  "76016": {
    DMA: 623,
  },
  "76017": {
    DMA: 623,
  },
  "76018": {
    DMA: 623,
  },
  "76019": {
    DMA: 623,
  },
  "76020": {
    DMA: 623,
  },
  "76021": {
    DMA: 623,
  },
  "76022": {
    DMA: 623,
  },
  "76023": {
    DMA: 623,
  },
  "76028": {
    DMA: 623,
  },
  "76031": {
    DMA: 623,
  },
  "76033": {
    DMA: 623,
  },
  "76034": {
    DMA: 623,
  },
  "76035": {
    DMA: 623,
  },
  "76036": {
    DMA: 623,
  },
  "76039": {
    DMA: 623,
  },
  "76040": {
    DMA: 623,
  },
  "76041": {
    DMA: 623,
  },
  "76043": {
    DMA: 623,
  },
  "76044": {
    DMA: 623,
  },
  "76048": {
    DMA: 623,
  },
  "76049": {
    DMA: 623,
  },
  "76050": {
    DMA: 623,
  },
  "76051": {
    DMA: 623,
  },
  "76052": {
    DMA: 623,
  },
  "76053": {
    DMA: 623,
  },
  "76054": {
    DMA: 623,
  },
  "76055": {
    DMA: 623,
  },
  "76058": {
    DMA: 623,
  },
  "76059": {
    DMA: 623,
  },
  "76060": {
    DMA: 623,
  },
  "76061": {
    DMA: 623,
  },
  "76063": {
    DMA: 623,
  },
  "76064": {
    DMA: 623,
  },
  "76065": {
    DMA: 623,
  },
  "76066": {
    DMA: 623,
  },
  "76067": {
    DMA: 623,
  },
  "76068": {
    DMA: 623,
  },
  "76070": {
    DMA: 623,
  },
  "76071": {
    DMA: 623,
  },
  "76073": {
    DMA: 623,
  },
  "76077": {
    DMA: 623,
  },
  "76078": {
    DMA: 623,
  },
  "76082": {
    DMA: 623,
  },
  "76084": {
    DMA: 623,
  },
  "76085": {
    DMA: 623,
  },
  "76086": {
    DMA: 623,
  },
  "76087": {
    DMA: 623,
  },
  "76088": {
    DMA: 623,
  },
  "76092": {
    DMA: 623,
  },
  "76093": {
    DMA: 623,
  },
  "76094": {
    DMA: 623,
  },
  "76095": {
    DMA: 623,
  },
  "76096": {
    DMA: 623,
  },
  "76097": {
    DMA: 623,
  },
  "76098": {
    DMA: 623,
  },
  "76099": {
    DMA: 623,
  },
  "76101": {
    DMA: 623,
  },
  "76102": {
    DMA: 623,
  },
  "76103": {
    DMA: 623,
  },
  "76104": {
    DMA: 623,
  },
  "76105": {
    DMA: 623,
  },
  "76106": {
    DMA: 623,
  },
  "76107": {
    DMA: 623,
  },
  "76108": {
    DMA: 623,
  },
  "76109": {
    DMA: 623,
  },
  "76110": {
    DMA: 623,
  },
  "76111": {
    DMA: 623,
  },
  "76112": {
    DMA: 623,
  },
  "76113": {
    DMA: 623,
  },
  "76114": {
    DMA: 623,
  },
  "76115": {
    DMA: 623,
  },
  "76116": {
    DMA: 623,
  },
  "76117": {
    DMA: 623,
  },
  "76118": {
    DMA: 623,
  },
  "76119": {
    DMA: 623,
  },
  "76120": {
    DMA: 623,
  },
  "76121": {
    DMA: 623,
  },
  "76122": {
    DMA: 623,
  },
  "76123": {
    DMA: 623,
  },
  "76124": {
    DMA: 623,
  },
  "76126": {
    DMA: 623,
  },
  "76127": {
    DMA: 623,
  },
  "76129": {
    DMA: 623,
  },
  "76130": {
    DMA: 623,
  },
  "76131": {
    DMA: 623,
  },
  "76132": {
    DMA: 623,
  },
  "76133": {
    DMA: 623,
  },
  "76134": {
    DMA: 623,
  },
  "76135": {
    DMA: 623,
  },
  "76136": {
    DMA: 623,
  },
  "76137": {
    DMA: 623,
  },
  "76140": {
    DMA: 623,
  },
  "76147": {
    DMA: 623,
  },
  "76148": {
    DMA: 623,
  },
  "76150": {
    DMA: 623,
  },
  "76155": {
    DMA: 623,
  },
  "76161": {
    DMA: 623,
  },
  "76162": {
    DMA: 623,
  },
  "76163": {
    DMA: 623,
  },
  "76164": {
    DMA: 623,
  },
  "76166": {
    DMA: 623,
  },
  "76177": {
    DMA: 623,
  },
  "76179": {
    DMA: 623,
  },
  "76180": {
    DMA: 623,
  },
  "76181": {
    DMA: 623,
  },
  "76182": {
    DMA: 623,
  },
  "76185": {
    DMA: 623,
  },
  "76190": {
    DMA: 623,
  },
  "76191": {
    DMA: 623,
  },
  "76192": {
    DMA: 623,
  },
  "76193": {
    DMA: 623,
  },
  "76195": {
    DMA: 623,
  },
  "76196": {
    DMA: 623,
  },
  "76197": {
    DMA: 623,
  },
  "76198": {
    DMA: 623,
  },
  "76199": {
    DMA: 623,
  },
  "76201": {
    DMA: 623,
  },
  "76202": {
    DMA: 623,
  },
  "76203": {
    DMA: 623,
  },
  "76204": {
    DMA: 623,
  },
  "76205": {
    DMA: 623,
  },
  "76206": {
    DMA: 623,
  },
  "76207": {
    DMA: 623,
  },
  "76208": {
    DMA: 623,
  },
  "76209": {
    DMA: 623,
  },
  "76210": {
    DMA: 623,
  },
  "76225": {
    DMA: 623,
  },
  "76226": {
    DMA: 623,
  },
  "76227": {
    DMA: 623,
  },
  "76228": {
    DMA: 627,
  },
  "76230": {
    DMA: 627,
  },
  "76233": {
    DMA: 657,
  },
  "76234": {
    DMA: 623,
  },
  "76238": {
    DMA: 623,
  },
  "76239": {
    DMA: 627,
  },
  "76240": {
    DMA: 623,
  },
  "76241": {
    DMA: 623,
  },
  "76244": {
    DMA: 623,
  },
  "76245": {
    DMA: 657,
  },
  "76246": {
    DMA: 623,
  },
  "76247": {
    DMA: 623,
  },
  "76248": {
    DMA: 623,
  },
  "76249": {
    DMA: 623,
  },
  "76250": {
    DMA: 623,
  },
  "76251": {
    DMA: 627,
  },
  "76252": {
    DMA: 623,
  },
  "76253": {
    DMA: 623,
  },
  "76255": {
    DMA: 627,
  },
  "76258": {
    DMA: 623,
  },
  "76259": {
    DMA: 623,
  },
  "76261": {
    DMA: 627,
  },
  "76262": {
    DMA: 623,
  },
  "76263": {
    DMA: 623,
  },
  "76264": {
    DMA: 657,
  },
  "76265": {
    DMA: 627,
  },
  "76266": {
    DMA: 623,
  },
  "76267": {
    DMA: 623,
  },
  "76268": {
    DMA: 657,
  },
  "76270": {
    DMA: 627,
  },
  "76271": {
    DMA: 657,
  },
  "76272": {
    DMA: 623,
  },
  "76273": {
    DMA: 657,
  },
  "76299": {
    DMA: 623,
  },
  "76301": {
    DMA: 627,
  },
  "76302": {
    DMA: 627,
  },
  "76305": {
    DMA: 627,
  },
  "76306": {
    DMA: 627,
  },
  "76307": {
    DMA: 627,
  },
  "76308": {
    DMA: 627,
  },
  "76309": {
    DMA: 627,
  },
  "76310": {
    DMA: 627,
  },
  "76311": {
    DMA: 627,
  },
  "76351": {
    DMA: 627,
  },
  "76352": {
    DMA: 627,
  },
  "76354": {
    DMA: 627,
  },
  "76357": {
    DMA: 627,
  },
  "76360": {
    DMA: 627,
  },
  "76363": {
    DMA: 662,
  },
  "76364": {
    DMA: 627,
  },
  "76365": {
    DMA: 627,
  },
  "76366": {
    DMA: 627,
  },
  "76367": {
    DMA: 627,
  },
  "76369": {
    DMA: 627,
  },
  "76370": {
    DMA: 627,
  },
  "76371": {
    DMA: 662,
  },
  "76372": {
    DMA: 627,
  },
  "76373": {
    DMA: 627,
  },
  "76374": {
    DMA: 627,
  },
  "76377": {
    DMA: 627,
  },
  "76379": {
    DMA: 627,
  },
  "76380": {
    DMA: 627,
  },
  "76384": {
    DMA: 627,
  },
  "76385": {
    DMA: 627,
  },
  "76388": {
    DMA: 662,
  },
  "76389": {
    DMA: 627,
  },
  "76401": {
    DMA: 623,
  },
  "76402": {
    DMA: 623,
  },
  "76424": {
    DMA: 662,
  },
  "76426": {
    DMA: 623,
  },
  "76427": {
    DMA: 623,
  },
  "76429": {
    DMA: 662,
  },
  "76430": {
    DMA: 662,
  },
  "76431": {
    DMA: 623,
  },
  "76432": {
    DMA: 662,
  },
  "76433": {
    DMA: 623,
  },
  "76435": {
    DMA: 662,
  },
  "76436": {
    DMA: 623,
  },
  "76437": {
    DMA: 662,
  },
  "76439": {
    DMA: 623,
  },
  "76442": {
    DMA: 623,
  },
  "76443": {
    DMA: 662,
  },
  "76444": {
    DMA: 623,
  },
  "76445": {
    DMA: 662,
  },
  "76446": {
    DMA: 623,
  },
  "76448": {
    DMA: 662,
  },
  "76449": {
    DMA: 623,
  },
  "76450": {
    DMA: 627,
  },
  "76452": {
    DMA: 623,
  },
  "76453": {
    DMA: 623,
  },
  "76454": {
    DMA: 662,
  },
  "76455": {
    DMA: 623,
  },
  "76457": {
    DMA: 623,
  },
  "76458": {
    DMA: 623,
  },
  "76459": {
    DMA: 623,
  },
  "76460": {
    DMA: 627,
  },
  "76461": {
    DMA: 623,
  },
  "76462": {
    DMA: 623,
  },
  "76463": {
    DMA: 623,
  },
  "76464": {
    DMA: 662,
  },
  "76465": {
    DMA: 623,
  },
  "76466": {
    DMA: 662,
  },
  "76467": {
    DMA: 623,
  },
  "76468": {
    DMA: 623,
  },
  "76469": {
    DMA: 662,
  },
  "76470": {
    DMA: 662,
  },
  "76471": {
    DMA: 662,
  },
  "76472": {
    DMA: 623,
  },
  "76474": {
    DMA: 623,
  },
  "76475": {
    DMA: 623,
  },
  "76476": {
    DMA: 623,
  },
  "76481": {
    DMA: 627,
  },
  "76483": {
    DMA: 662,
  },
  "76484": {
    DMA: 623,
  },
  "76485": {
    DMA: 623,
  },
  "76486": {
    DMA: 623,
  },
  "76487": {
    DMA: 623,
  },
  "76490": {
    DMA: 623,
  },
  "76491": {
    DMA: 662,
  },
  "76501": {
    DMA: 625,
  },
  "76502": {
    DMA: 625,
  },
  "76503": {
    DMA: 625,
  },
  "76504": {
    DMA: 625,
  },
  "76505": {
    DMA: 625,
  },
  "76508": {
    DMA: 625,
  },
  "76511": {
    DMA: 625,
  },
  "76513": {
    DMA: 625,
  },
  "76518": {
    DMA: 625,
  },
  "76519": {
    DMA: 625,
  },
  "76520": {
    DMA: 625,
  },
  "76522": {
    DMA: 625,
  },
  "76523": {
    DMA: 625,
  },
  "76524": {
    DMA: 625,
  },
  "76525": {
    DMA: 625,
  },
  "76526": {
    DMA: 625,
  },
  "76527": {
    DMA: 635,
  },
  "76528": {
    DMA: 625,
  },
  "76530": {
    DMA: 635,
  },
  "76531": {
    DMA: 623,
  },
  "76533": {
    DMA: 625,
  },
  "76534": {
    DMA: 625,
  },
  "76537": {
    DMA: 635,
  },
  "76538": {
    DMA: 625,
  },
  "76539": {
    DMA: 625,
  },
  "76540": {
    DMA: 625,
  },
  "76541": {
    DMA: 625,
  },
  "76542": {
    DMA: 625,
  },
  "76543": {
    DMA: 625,
  },
  "76544": {
    DMA: 625,
  },
  "76545": {
    DMA: 625,
  },
  "76546": {
    DMA: 625,
  },
  "76547": {
    DMA: 625,
  },
  "76548": {
    DMA: 625,
  },
  "76549": {
    DMA: 625,
  },
  "76550": {
    DMA: 625,
  },
  "76554": {
    DMA: 625,
  },
  "76556": {
    DMA: 625,
  },
  "76557": {
    DMA: 625,
  },
  "76558": {
    DMA: 625,
  },
  "76559": {
    DMA: 625,
  },
  "76561": {
    DMA: 625,
  },
  "76564": {
    DMA: 625,
  },
  "76565": {
    DMA: 623,
  },
  "76566": {
    DMA: 625,
  },
  "76567": {
    DMA: 625,
  },
  "76569": {
    DMA: 625,
  },
  "76570": {
    DMA: 625,
  },
  "76571": {
    DMA: 625,
  },
  "76573": {
    DMA: 635,
  },
  "76574": {
    DMA: 635,
  },
  "76577": {
    DMA: 625,
  },
  "76578": {
    DMA: 635,
  },
  "76579": {
    DMA: 625,
  },
  "76596": {
    DMA: 625,
  },
  "76597": {
    DMA: 625,
  },
  "76598": {
    DMA: 625,
  },
  "76599": {
    DMA: 625,
  },
  "76621": {
    DMA: 623,
  },
  "76622": {
    DMA: 623,
  },
  "76623": {
    DMA: 623,
  },
  "76624": {
    DMA: 625,
  },
  "76626": {
    DMA: 623,
  },
  "76627": {
    DMA: 623,
  },
  "76628": {
    DMA: 623,
  },
  "76629": {
    DMA: 625,
  },
  "76630": {
    DMA: 625,
  },
  "76631": {
    DMA: 623,
  },
  "76632": {
    DMA: 625,
  },
  "76633": {
    DMA: 625,
  },
  "76634": {
    DMA: 623,
  },
  "76635": {
    DMA: 625,
  },
  "76636": {
    DMA: 623,
  },
  "76637": {
    DMA: 623,
  },
  "76638": {
    DMA: 625,
  },
  "76639": {
    DMA: 623,
  },
  "76640": {
    DMA: 625,
  },
  "76641": {
    DMA: 623,
  },
  "76642": {
    DMA: 625,
  },
  "76643": {
    DMA: 625,
  },
  "76644": {
    DMA: 623,
  },
  "76645": {
    DMA: 623,
  },
  "76648": {
    DMA: 623,
  },
  "76649": {
    DMA: 623,
  },
  "76650": {
    DMA: 623,
  },
  "76651": {
    DMA: 623,
  },
  "76652": {
    DMA: 623,
  },
  "76653": {
    DMA: 625,
  },
  "76654": {
    DMA: 625,
  },
  "76655": {
    DMA: 625,
  },
  "76656": {
    DMA: 625,
  },
  "76657": {
    DMA: 625,
  },
  "76660": {
    DMA: 623,
  },
  "76661": {
    DMA: 625,
  },
  "76664": {
    DMA: 625,
  },
  "76665": {
    DMA: 623,
  },
  "76666": {
    DMA: 623,
  },
  "76667": {
    DMA: 625,
  },
  "76670": {
    DMA: 623,
  },
  "76671": {
    DMA: 623,
  },
  "76673": {
    DMA: 623,
  },
  "76676": {
    DMA: 623,
  },
  "76678": {
    DMA: 625,
  },
  "76679": {
    DMA: 623,
  },
  "76680": {
    DMA: 625,
  },
  "76681": {
    DMA: 623,
  },
  "76682": {
    DMA: 625,
  },
  "76684": {
    DMA: 625,
  },
  "76685": {
    DMA: 625,
  },
  "76686": {
    DMA: 625,
  },
  "76687": {
    DMA: 625,
  },
  "76689": {
    DMA: 623,
  },
  "76690": {
    DMA: 623,
  },
  "76691": {
    DMA: 625,
  },
  "76692": {
    DMA: 623,
  },
  "76693": {
    DMA: 623,
  },
  "76701": {
    DMA: 625,
  },
  "76702": {
    DMA: 625,
  },
  "76703": {
    DMA: 625,
  },
  "76704": {
    DMA: 625,
  },
  "76705": {
    DMA: 625,
  },
  "76706": {
    DMA: 625,
  },
  "76707": {
    DMA: 625,
  },
  "76708": {
    DMA: 625,
  },
  "76710": {
    DMA: 625,
  },
  "76711": {
    DMA: 625,
  },
  "76712": {
    DMA: 625,
  },
  "76714": {
    DMA: 625,
  },
  "76715": {
    DMA: 625,
  },
  "76716": {
    DMA: 625,
  },
  "76795": {
    DMA: 625,
  },
  "76797": {
    DMA: 625,
  },
  "76798": {
    DMA: 625,
  },
  "76799": {
    DMA: 625,
  },
  "76801": {
    DMA: 662,
  },
  "76802": {
    DMA: 662,
  },
  "76803": {
    DMA: 662,
  },
  "76804": {
    DMA: 662,
  },
  "76820": {
    DMA: 635,
  },
  "76821": {
    DMA: 662,
  },
  "76823": {
    DMA: 662,
  },
  "76824": {
    DMA: 625,
  },
  "76825": {
    DMA: 661,
  },
  "76827": {
    DMA: 662,
  },
  "76828": {
    DMA: 662,
  },
  "76831": {
    DMA: 635,
  },
  "76832": {
    DMA: 625,
  },
  "76834": {
    DMA: 662,
  },
  "76836": {
    DMA: 661,
  },
  "76837": {
    DMA: 661,
  },
  "76841": {
    DMA: 661,
  },
  "76842": {
    DMA: 635,
  },
  "76844": {
    DMA: 625,
  },
  "76845": {
    DMA: 662,
  },
  "76848": {
    DMA: 661,
  },
  "76849": {
    DMA: 661,
  },
  "76852": {
    DMA: 661,
  },
  "76853": {
    DMA: 625,
  },
  "76854": {
    DMA: 661,
  },
  "76855": {
    DMA: 661,
  },
  "76856": {
    DMA: 635,
  },
  "76857": {
    DMA: 662,
  },
  "76858": {
    DMA: 661,
  },
  "76859": {
    DMA: 661,
  },
  "76861": {
    DMA: 662,
  },
  "76862": {
    DMA: 661,
  },
  "76864": {
    DMA: 625,
  },
  "76865": {
    DMA: 662,
  },
  "76866": {
    DMA: 661,
  },
  "76869": {
    DMA: 635,
  },
  "76870": {
    DMA: 625,
  },
  "76871": {
    DMA: 625,
  },
  "76872": {
    DMA: 661,
  },
  "76873": {
    DMA: 662,
  },
  "76874": {
    DMA: 661,
  },
  "76875": {
    DMA: 662,
  },
  "76877": {
    DMA: 625,
  },
  "76878": {
    DMA: 662,
  },
  "76880": {
    DMA: 625,
  },
  "76882": {
    DMA: 662,
  },
  "76883": {
    DMA: 641,
  },
  "76884": {
    DMA: 662,
  },
  "76885": {
    DMA: 635,
  },
  "76886": {
    DMA: 661,
  },
  "76887": {
    DMA: 661,
  },
  "76888": {
    DMA: 662,
  },
  "76890": {
    DMA: 662,
  },
  "76901": {
    DMA: 661,
  },
  "76902": {
    DMA: 661,
  },
  "76903": {
    DMA: 661,
  },
  "76904": {
    DMA: 661,
  },
  "76905": {
    DMA: 661,
  },
  "76906": {
    DMA: 661,
  },
  "76908": {
    DMA: 661,
  },
  "76909": {
    DMA: 661,
  },
  "76930": {
    DMA: 661,
  },
  "76932": {
    DMA: 633,
  },
  "76933": {
    DMA: 661,
  },
  "76934": {
    DMA: 661,
  },
  "76935": {
    DMA: 661,
  },
  "76936": {
    DMA: 661,
  },
  "76937": {
    DMA: 661,
  },
  "76939": {
    DMA: 661,
  },
  "76940": {
    DMA: 661,
  },
  "76941": {
    DMA: 661,
  },
  "76943": {
    DMA: 661,
  },
  "76945": {
    DMA: 661,
  },
  "76949": {
    DMA: 661,
  },
  "76950": {
    DMA: 661,
  },
  "76951": {
    DMA: 661,
  },
  "76953": {
    DMA: 661,
  },
  "76955": {
    DMA: 661,
  },
  "76957": {
    DMA: 661,
  },
  "76958": {
    DMA: 661,
  },
  "77001": {
    DMA: 618,
  },
  "77002": {
    DMA: 618,
  },
  "77003": {
    DMA: 618,
  },
  "77004": {
    DMA: 618,
  },
  "77005": {
    DMA: 618,
  },
  "77006": {
    DMA: 618,
  },
  "77007": {
    DMA: 618,
  },
  "77008": {
    DMA: 618,
  },
  "77009": {
    DMA: 618,
  },
  "77010": {
    DMA: 618,
  },
  "77011": {
    DMA: 618,
  },
  "77012": {
    DMA: 618,
  },
  "77013": {
    DMA: 618,
  },
  "77014": {
    DMA: 618,
  },
  "77015": {
    DMA: 618,
  },
  "77016": {
    DMA: 618,
  },
  "77017": {
    DMA: 618,
  },
  "77018": {
    DMA: 618,
  },
  "77019": {
    DMA: 618,
  },
  "77020": {
    DMA: 618,
  },
  "77021": {
    DMA: 618,
  },
  "77022": {
    DMA: 618,
  },
  "77023": {
    DMA: 618,
  },
  "77024": {
    DMA: 618,
  },
  "77025": {
    DMA: 618,
  },
  "77026": {
    DMA: 618,
  },
  "77027": {
    DMA: 618,
  },
  "77028": {
    DMA: 618,
  },
  "77029": {
    DMA: 618,
  },
  "77030": {
    DMA: 618,
  },
  "77031": {
    DMA: 618,
  },
  "77032": {
    DMA: 618,
  },
  "77033": {
    DMA: 618,
  },
  "77034": {
    DMA: 618,
  },
  "77035": {
    DMA: 618,
  },
  "77036": {
    DMA: 618,
  },
  "77037": {
    DMA: 618,
  },
  "77038": {
    DMA: 618,
  },
  "77039": {
    DMA: 618,
  },
  "77040": {
    DMA: 618,
  },
  "77041": {
    DMA: 618,
  },
  "77042": {
    DMA: 618,
  },
  "77043": {
    DMA: 618,
  },
  "77044": {
    DMA: 618,
  },
  "77045": {
    DMA: 618,
  },
  "77046": {
    DMA: 618,
  },
  "77047": {
    DMA: 618,
  },
  "77048": {
    DMA: 618,
  },
  "77049": {
    DMA: 618,
  },
  "77050": {
    DMA: 618,
  },
  "77051": {
    DMA: 618,
  },
  "77052": {
    DMA: 618,
  },
  "77053": {
    DMA: 618,
  },
  "77054": {
    DMA: 618,
  },
  "77055": {
    DMA: 618,
  },
  "77056": {
    DMA: 618,
  },
  "77057": {
    DMA: 618,
  },
  "77058": {
    DMA: 618,
  },
  "77059": {
    DMA: 618,
  },
  "77060": {
    DMA: 618,
  },
  "77061": {
    DMA: 618,
  },
  "77062": {
    DMA: 618,
  },
  "77063": {
    DMA: 618,
  },
  "77064": {
    DMA: 618,
  },
  "77065": {
    DMA: 618,
  },
  "77066": {
    DMA: 618,
  },
  "77067": {
    DMA: 618,
  },
  "77068": {
    DMA: 618,
  },
  "77069": {
    DMA: 618,
  },
  "77070": {
    DMA: 618,
  },
  "77071": {
    DMA: 618,
  },
  "77072": {
    DMA: 618,
  },
  "77073": {
    DMA: 618,
  },
  "77074": {
    DMA: 618,
  },
  "77075": {
    DMA: 618,
  },
  "77076": {
    DMA: 618,
  },
  "77077": {
    DMA: 618,
  },
  "77078": {
    DMA: 618,
  },
  "77079": {
    DMA: 618,
  },
  "77080": {
    DMA: 618,
  },
  "77081": {
    DMA: 618,
  },
  "77082": {
    DMA: 618,
  },
  "77083": {
    DMA: 618,
  },
  "77084": {
    DMA: 618,
  },
  "77085": {
    DMA: 618,
  },
  "77086": {
    DMA: 618,
  },
  "77087": {
    DMA: 618,
  },
  "77088": {
    DMA: 618,
  },
  "77089": {
    DMA: 618,
  },
  "77090": {
    DMA: 618,
  },
  "77091": {
    DMA: 618,
  },
  "77092": {
    DMA: 618,
  },
  "77093": {
    DMA: 618,
  },
  "77094": {
    DMA: 618,
  },
  "77095": {
    DMA: 618,
  },
  "77096": {
    DMA: 618,
  },
  "77097": {
    DMA: 618,
  },
  "77098": {
    DMA: 618,
  },
  "77099": {
    DMA: 618,
  },
  "77201": {
    DMA: 618,
  },
  "77202": {
    DMA: 618,
  },
  "77203": {
    DMA: 618,
  },
  "77204": {
    DMA: 618,
  },
  "77205": {
    DMA: 618,
  },
  "77206": {
    DMA: 618,
  },
  "77207": {
    DMA: 618,
  },
  "77208": {
    DMA: 618,
  },
  "77209": {
    DMA: 618,
  },
  "77210": {
    DMA: 618,
  },
  "77212": {
    DMA: 618,
  },
  "77213": {
    DMA: 618,
  },
  "77215": {
    DMA: 618,
  },
  "77216": {
    DMA: 618,
  },
  "77217": {
    DMA: 618,
  },
  "77218": {
    DMA: 618,
  },
  "77219": {
    DMA: 618,
  },
  "77220": {
    DMA: 618,
  },
  "77221": {
    DMA: 618,
  },
  "77222": {
    DMA: 618,
  },
  "77223": {
    DMA: 618,
  },
  "77224": {
    DMA: 618,
  },
  "77225": {
    DMA: 618,
  },
  "77226": {
    DMA: 618,
  },
  "77227": {
    DMA: 618,
  },
  "77228": {
    DMA: 618,
  },
  "77229": {
    DMA: 618,
  },
  "77230": {
    DMA: 618,
  },
  "77231": {
    DMA: 618,
  },
  "77233": {
    DMA: 618,
  },
  "77234": {
    DMA: 618,
  },
  "77235": {
    DMA: 618,
  },
  "77236": {
    DMA: 618,
  },
  "77237": {
    DMA: 618,
  },
  "77238": {
    DMA: 618,
  },
  "77240": {
    DMA: 618,
  },
  "77241": {
    DMA: 618,
  },
  "77242": {
    DMA: 618,
  },
  "77243": {
    DMA: 618,
  },
  "77244": {
    DMA: 618,
  },
  "77245": {
    DMA: 618,
  },
  "77246": {
    DMA: 618,
  },
  "77247": {
    DMA: 618,
  },
  "77248": {
    DMA: 618,
  },
  "77249": {
    DMA: 618,
  },
  "77250": {
    DMA: 618,
  },
  "77251": {
    DMA: 618,
  },
  "77252": {
    DMA: 618,
  },
  "77253": {
    DMA: 618,
  },
  "77254": {
    DMA: 618,
  },
  "77255": {
    DMA: 618,
  },
  "77256": {
    DMA: 618,
  },
  "77257": {
    DMA: 618,
  },
  "77258": {
    DMA: 618,
  },
  "77259": {
    DMA: 618,
  },
  "77260": {
    DMA: 618,
  },
  "77261": {
    DMA: 618,
  },
  "77262": {
    DMA: 618,
  },
  "77263": {
    DMA: 618,
  },
  "77265": {
    DMA: 618,
  },
  "77266": {
    DMA: 618,
  },
  "77267": {
    DMA: 618,
  },
  "77268": {
    DMA: 618,
  },
  "77269": {
    DMA: 618,
  },
  "77270": {
    DMA: 618,
  },
  "77271": {
    DMA: 618,
  },
  "77272": {
    DMA: 618,
  },
  "77273": {
    DMA: 618,
  },
  "77274": {
    DMA: 618,
  },
  "77275": {
    DMA: 618,
  },
  "77276": {
    DMA: 618,
  },
  "77277": {
    DMA: 618,
  },
  "77278": {
    DMA: 618,
  },
  "77279": {
    DMA: 618,
  },
  "77280": {
    DMA: 618,
  },
  "77282": {
    DMA: 618,
  },
  "77284": {
    DMA: 618,
  },
  "77285": {
    DMA: 618,
  },
  "77286": {
    DMA: 618,
  },
  "77287": {
    DMA: 618,
  },
  "77288": {
    DMA: 618,
  },
  "77289": {
    DMA: 618,
  },
  "77290": {
    DMA: 618,
  },
  "77291": {
    DMA: 618,
  },
  "77292": {
    DMA: 618,
  },
  "77293": {
    DMA: 618,
  },
  "77294": {
    DMA: 618,
  },
  "77296": {
    DMA: 618,
  },
  "77297": {
    DMA: 618,
  },
  "77298": {
    DMA: 618,
  },
  "77299": {
    DMA: 618,
  },
  "77301": {
    DMA: 618,
  },
  "77302": {
    DMA: 618,
  },
  "77303": {
    DMA: 618,
  },
  "77304": {
    DMA: 618,
  },
  "77305": {
    DMA: 618,
  },
  "77306": {
    DMA: 618,
  },
  "77315": {
    DMA: 618,
  },
  "77316": {
    DMA: 618,
  },
  "77318": {
    DMA: 618,
  },
  "77320": {
    DMA: 618,
  },
  "77325": {
    DMA: 618,
  },
  "77326": {
    DMA: 618,
  },
  "77327": {
    DMA: 618,
  },
  "77328": {
    DMA: 618,
  },
  "77331": {
    DMA: 618,
  },
  "77332": {
    DMA: 618,
  },
  "77333": {
    DMA: 618,
  },
  "77334": {
    DMA: 618,
  },
  "77335": {
    DMA: 618,
  },
  "77336": {
    DMA: 618,
  },
  "77337": {
    DMA: 618,
  },
  "77338": {
    DMA: 618,
  },
  "77339": {
    DMA: 618,
  },
  "77340": {
    DMA: 618,
  },
  "77341": {
    DMA: 618,
  },
  "77342": {
    DMA: 618,
  },
  "77343": {
    DMA: 618,
  },
  "77344": {
    DMA: 618,
  },
  "77345": {
    DMA: 618,
  },
  "77346": {
    DMA: 618,
  },
  "77347": {
    DMA: 618,
  },
  "77348": {
    DMA: 618,
  },
  "77349": {
    DMA: 618,
  },
  "77350": {
    DMA: 618,
  },
  "77351": {
    DMA: 618,
  },
  "77353": {
    DMA: 618,
  },
  "77354": {
    DMA: 618,
  },
  "77355": {
    DMA: 618,
  },
  "77356": {
    DMA: 618,
  },
  "77357": {
    DMA: 618,
  },
  "77358": {
    DMA: 618,
  },
  "77359": {
    DMA: 618,
  },
  "77360": {
    DMA: 618,
  },
  "77362": {
    DMA: 618,
  },
  "77363": {
    DMA: 618,
  },
  "77364": {
    DMA: 618,
  },
  "77365": {
    DMA: 618,
  },
  "77367": {
    DMA: 618,
  },
  "77368": {
    DMA: 618,
  },
  "77369": {
    DMA: 618,
  },
  "77371": {
    DMA: 618,
  },
  "77372": {
    DMA: 618,
  },
  "77373": {
    DMA: 618,
  },
  "77374": {
    DMA: 692,
  },
  "77375": {
    DMA: 618,
  },
  "77376": {
    DMA: 692,
  },
  "77377": {
    DMA: 618,
  },
  "77378": {
    DMA: 618,
  },
  "77379": {
    DMA: 618,
  },
  "77380": {
    DMA: 618,
  },
  "77381": {
    DMA: 618,
  },
  "77382": {
    DMA: 618,
  },
  "77383": {
    DMA: 618,
  },
  "77384": {
    DMA: 618,
  },
  "77385": {
    DMA: 618,
  },
  "77386": {
    DMA: 618,
  },
  "77387": {
    DMA: 618,
  },
  "77388": {
    DMA: 618,
  },
  "77389": {
    DMA: 618,
  },
  "77391": {
    DMA: 618,
  },
  "77393": {
    DMA: 618,
  },
  "77396": {
    DMA: 618,
  },
  "77399": {
    DMA: 618,
  },
  "77401": {
    DMA: 618,
  },
  "77402": {
    DMA: 618,
  },
  "77404": {
    DMA: 618,
  },
  "77406": {
    DMA: 618,
  },
  "77407": {
    DMA: 618,
  },
  "77410": {
    DMA: 618,
  },
  "77411": {
    DMA: 618,
  },
  "77412": {
    DMA: 618,
  },
  "77413": {
    DMA: 618,
  },
  "77414": {
    DMA: 618,
  },
  "77415": {
    DMA: 618,
  },
  "77417": {
    DMA: 618,
  },
  "77418": {
    DMA: 618,
  },
  "77419": {
    DMA: 618,
  },
  "77420": {
    DMA: 618,
  },
  "77422": {
    DMA: 618,
  },
  "77423": {
    DMA: 618,
  },
  "77426": {
    DMA: 618,
  },
  "77428": {
    DMA: 618,
  },
  "77429": {
    DMA: 618,
  },
  "77430": {
    DMA: 618,
  },
  "77431": {
    DMA: 618,
  },
  "77432": {
    DMA: 618,
  },
  "77433": {
    DMA: 618,
  },
  "77434": {
    DMA: 618,
  },
  "77435": {
    DMA: 618,
  },
  "77436": {
    DMA: 618,
  },
  "77437": {
    DMA: 618,
  },
  "77440": {
    DMA: 618,
  },
  "77441": {
    DMA: 618,
  },
  "77442": {
    DMA: 618,
  },
  "77443": {
    DMA: 618,
  },
  "77444": {
    DMA: 618,
  },
  "77445": {
    DMA: 618,
  },
  "77446": {
    DMA: 618,
  },
  "77447": {
    DMA: 618,
  },
  "77448": {
    DMA: 618,
  },
  "77449": {
    DMA: 618,
  },
  "77450": {
    DMA: 618,
  },
  "77451": {
    DMA: 618,
  },
  "77452": {
    DMA: 618,
  },
  "77453": {
    DMA: 618,
  },
  "77454": {
    DMA: 618,
  },
  "77455": {
    DMA: 618,
  },
  "77456": {
    DMA: 618,
  },
  "77457": {
    DMA: 618,
  },
  "77458": {
    DMA: 618,
  },
  "77459": {
    DMA: 618,
  },
  "77460": {
    DMA: 618,
  },
  "77461": {
    DMA: 618,
  },
  "77463": {
    DMA: 618,
  },
  "77464": {
    DMA: 618,
  },
  "77465": {
    DMA: 618,
  },
  "77466": {
    DMA: 618,
  },
  "77467": {
    DMA: 618,
  },
  "77468": {
    DMA: 618,
  },
  "77469": {
    DMA: 618,
  },
  "77470": {
    DMA: 618,
  },
  "77471": {
    DMA: 618,
  },
  "77473": {
    DMA: 618,
  },
  "77474": {
    DMA: 618,
  },
  "77475": {
    DMA: 618,
  },
  "77476": {
    DMA: 618,
  },
  "77477": {
    DMA: 618,
  },
  "77478": {
    DMA: 618,
  },
  "77479": {
    DMA: 618,
  },
  "77480": {
    DMA: 618,
  },
  "77481": {
    DMA: 618,
  },
  "77482": {
    DMA: 618,
  },
  "77483": {
    DMA: 618,
  },
  "77484": {
    DMA: 618,
  },
  "77485": {
    DMA: 618,
  },
  "77486": {
    DMA: 618,
  },
  "77487": {
    DMA: 618,
  },
  "77488": {
    DMA: 618,
  },
  "77489": {
    DMA: 618,
  },
  "77491": {
    DMA: 618,
  },
  "77492": {
    DMA: 618,
  },
  "77493": {
    DMA: 618,
  },
  "77494": {
    DMA: 618,
  },
  "77496": {
    DMA: 618,
  },
  "77497": {
    DMA: 618,
  },
  "77498": {
    DMA: 618,
  },
  "77501": {
    DMA: 618,
  },
  "77502": {
    DMA: 618,
  },
  "77503": {
    DMA: 618,
  },
  "77504": {
    DMA: 618,
  },
  "77505": {
    DMA: 618,
  },
  "77506": {
    DMA: 618,
  },
  "77507": {
    DMA: 618,
  },
  "77508": {
    DMA: 618,
  },
  "77510": {
    DMA: 618,
  },
  "77511": {
    DMA: 618,
  },
  "77512": {
    DMA: 618,
  },
  "77514": {
    DMA: 618,
  },
  "77515": {
    DMA: 618,
  },
  "77516": {
    DMA: 618,
  },
  "77517": {
    DMA: 618,
  },
  "77518": {
    DMA: 618,
  },
  "77519": {
    DMA: 692,
  },
  "77520": {
    DMA: 618,
  },
  "77521": {
    DMA: 618,
  },
  "77522": {
    DMA: 618,
  },
  "77523": {
    DMA: 618,
  },
  "77530": {
    DMA: 618,
  },
  "77531": {
    DMA: 618,
  },
  "77532": {
    DMA: 618,
  },
  "77533": {
    DMA: 618,
  },
  "77534": {
    DMA: 618,
  },
  "77535": {
    DMA: 618,
  },
  "77536": {
    DMA: 618,
  },
  "77538": {
    DMA: 618,
  },
  "77539": {
    DMA: 618,
  },
  "77541": {
    DMA: 618,
  },
  "77542": {
    DMA: 618,
  },
  "77545": {
    DMA: 618,
  },
  "77546": {
    DMA: 618,
  },
  "77547": {
    DMA: 618,
  },
  "77549": {
    DMA: 618,
  },
  "77550": {
    DMA: 618,
  },
  "77551": {
    DMA: 618,
  },
  "77552": {
    DMA: 618,
  },
  "77553": {
    DMA: 618,
  },
  "77554": {
    DMA: 618,
  },
  "77555": {
    DMA: 618,
  },
  "77560": {
    DMA: 618,
  },
  "77561": {
    DMA: 618,
  },
  "77562": {
    DMA: 618,
  },
  "77563": {
    DMA: 618,
  },
  "77564": {
    DMA: 618,
  },
  "77565": {
    DMA: 618,
  },
  "77566": {
    DMA: 618,
  },
  "77568": {
    DMA: 618,
  },
  "77571": {
    DMA: 618,
  },
  "77572": {
    DMA: 618,
  },
  "77573": {
    DMA: 618,
  },
  "77574": {
    DMA: 618,
  },
  "77575": {
    DMA: 618,
  },
  "77577": {
    DMA: 618,
  },
  "77578": {
    DMA: 618,
  },
  "77580": {
    DMA: 618,
  },
  "77581": {
    DMA: 618,
  },
  "77582": {
    DMA: 618,
  },
  "77583": {
    DMA: 618,
  },
  "77584": {
    DMA: 618,
  },
  "77585": {
    DMA: 692,
  },
  "77586": {
    DMA: 618,
  },
  "77587": {
    DMA: 618,
  },
  "77588": {
    DMA: 618,
  },
  "77590": {
    DMA: 618,
  },
  "77591": {
    DMA: 618,
  },
  "77592": {
    DMA: 618,
  },
  "77597": {
    DMA: 618,
  },
  "77598": {
    DMA: 618,
  },
  "77611": {
    DMA: 692,
  },
  "77612": {
    DMA: 692,
  },
  "77613": {
    DMA: 692,
  },
  "77614": {
    DMA: 692,
  },
  "77615": {
    DMA: 692,
  },
  "77616": {
    DMA: 692,
  },
  "77617": {
    DMA: 618,
  },
  "77619": {
    DMA: 692,
  },
  "77622": {
    DMA: 692,
  },
  "77623": {
    DMA: 618,
  },
  "77624": {
    DMA: 692,
  },
  "77625": {
    DMA: 692,
  },
  "77626": {
    DMA: 692,
  },
  "77627": {
    DMA: 692,
  },
  "77629": {
    DMA: 692,
  },
  "77630": {
    DMA: 692,
  },
  "77631": {
    DMA: 692,
  },
  "77632": {
    DMA: 692,
  },
  "77639": {
    DMA: 692,
  },
  "77640": {
    DMA: 692,
  },
  "77641": {
    DMA: 692,
  },
  "77642": {
    DMA: 692,
  },
  "77643": {
    DMA: 692,
  },
  "77650": {
    DMA: 618,
  },
  "77651": {
    DMA: 692,
  },
  "77655": {
    DMA: 692,
  },
  "77656": {
    DMA: 692,
  },
  "77657": {
    DMA: 692,
  },
  "77659": {
    DMA: 692,
  },
  "77660": {
    DMA: 692,
  },
  "77661": {
    DMA: 618,
  },
  "77662": {
    DMA: 692,
  },
  "77663": {
    DMA: 692,
  },
  "77664": {
    DMA: 692,
  },
  "77665": {
    DMA: 618,
  },
  "77670": {
    DMA: 692,
  },
  "77701": {
    DMA: 692,
  },
  "77702": {
    DMA: 692,
  },
  "77703": {
    DMA: 692,
  },
  "77704": {
    DMA: 692,
  },
  "77705": {
    DMA: 692,
  },
  "77706": {
    DMA: 692,
  },
  "77707": {
    DMA: 692,
  },
  "77708": {
    DMA: 692,
  },
  "77709": {
    DMA: 692,
  },
  "77710": {
    DMA: 692,
  },
  "77713": {
    DMA: 692,
  },
  "77720": {
    DMA: 692,
  },
  "77725": {
    DMA: 692,
  },
  "77726": {
    DMA: 692,
  },
  "77801": {
    DMA: 625,
  },
  "77802": {
    DMA: 625,
  },
  "77803": {
    DMA: 625,
  },
  "77805": {
    DMA: 625,
  },
  "77806": {
    DMA: 625,
  },
  "77807": {
    DMA: 625,
  },
  "77808": {
    DMA: 625,
  },
  "77830": {
    DMA: 618,
  },
  "77831": {
    DMA: 618,
  },
  "77833": {
    DMA: 618,
  },
  "77834": {
    DMA: 618,
  },
  "77835": {
    DMA: 618,
  },
  "77836": {
    DMA: 625,
  },
  "77837": {
    DMA: 625,
  },
  "77838": {
    DMA: 625,
  },
  "77840": {
    DMA: 625,
  },
  "77841": {
    DMA: 625,
  },
  "77842": {
    DMA: 625,
  },
  "77843": {
    DMA: 625,
  },
  "77844": {
    DMA: 625,
  },
  "77845": {
    DMA: 625,
  },
  "77850": {
    DMA: 625,
  },
  "77852": {
    DMA: 625,
  },
  "77853": {
    DMA: 635,
  },
  "77855": {
    DMA: 625,
  },
  "77856": {
    DMA: 625,
  },
  "77857": {
    DMA: 625,
  },
  "77859": {
    DMA: 625,
  },
  "77861": {
    DMA: 618,
  },
  "77862": {
    DMA: 625,
  },
  "77863": {
    DMA: 625,
  },
  "77864": {
    DMA: 625,
  },
  "77865": {
    DMA: 625,
  },
  "77866": {
    DMA: 625,
  },
  "77867": {
    DMA: 625,
  },
  "77868": {
    DMA: 618,
  },
  "77869": {
    DMA: 618,
  },
  "77870": {
    DMA: 625,
  },
  "77871": {
    DMA: 625,
  },
  "77872": {
    DMA: 625,
  },
  "77873": {
    DMA: 618,
  },
  "77875": {
    DMA: 618,
  },
  "77876": {
    DMA: 618,
  },
  "77878": {
    DMA: 625,
  },
  "77879": {
    DMA: 625,
  },
  "77880": {
    DMA: 618,
  },
  "77881": {
    DMA: 625,
  },
  "77882": {
    DMA: 625,
  },
  "77901": {
    DMA: 626,
  },
  "77902": {
    DMA: 626,
  },
  "77903": {
    DMA: 626,
  },
  "77904": {
    DMA: 626,
  },
  "77905": {
    DMA: 626,
  },
  "77950": {
    DMA: 600,
  },
  "77951": {
    DMA: 626,
  },
  "77954": {
    DMA: 641,
  },
  "77957": {
    DMA: 618,
  },
  "77960": {
    DMA: 641,
  },
  "77961": {
    DMA: 618,
  },
  "77962": {
    DMA: 618,
  },
  "77963": {
    DMA: 641,
  },
  "77964": {
    DMA: 641,
  },
  "77967": {
    DMA: 641,
  },
  "77968": {
    DMA: 626,
  },
  "77969": {
    DMA: 618,
  },
  "77970": {
    DMA: 618,
  },
  "77971": {
    DMA: 618,
  },
  "77973": {
    DMA: 626,
  },
  "77974": {
    DMA: 641,
  },
  "77975": {
    DMA: 641,
  },
  "77976": {
    DMA: 626,
  },
  "77977": {
    DMA: 626,
  },
  "77978": {
    DMA: 618,
  },
  "77979": {
    DMA: 618,
  },
  "77982": {
    DMA: 618,
  },
  "77983": {
    DMA: 618,
  },
  "77984": {
    DMA: 641,
  },
  "77986": {
    DMA: 641,
  },
  "77987": {
    DMA: 641,
  },
  "77988": {
    DMA: 626,
  },
  "77989": {
    DMA: 641,
  },
  "77990": {
    DMA: 600,
  },
  "77991": {
    DMA: 618,
  },
  "77993": {
    DMA: 641,
  },
  "77994": {
    DMA: 641,
  },
  "77995": {
    DMA: 641,
  },
  "78001": {
    DMA: 641,
  },
  "78002": {
    DMA: 641,
  },
  "78003": {
    DMA: 641,
  },
  "78004": {
    DMA: 641,
  },
  "78005": {
    DMA: 641,
  },
  "78006": {
    DMA: 641,
  },
  "78007": {
    DMA: 641,
  },
  "78008": {
    DMA: 641,
  },
  "78009": {
    DMA: 641,
  },
  "78010": {
    DMA: 641,
  },
  "78011": {
    DMA: 641,
  },
  "78012": {
    DMA: 641,
  },
  "78013": {
    DMA: 641,
  },
  "78014": {
    DMA: 641,
  },
  "78015": {
    DMA: 641,
  },
  "78016": {
    DMA: 641,
  },
  "78017": {
    DMA: 641,
  },
  "78019": {
    DMA: 641,
  },
  "78021": {
    DMA: 641,
  },
  "78022": {
    DMA: 600,
  },
  "78023": {
    DMA: 641,
  },
  "78024": {
    DMA: 641,
  },
  "78025": {
    DMA: 641,
  },
  "78026": {
    DMA: 641,
  },
  "78027": {
    DMA: 641,
  },
  "78028": {
    DMA: 641,
  },
  "78029": {
    DMA: 641,
  },
  "78039": {
    DMA: 641,
  },
  "78040": {
    DMA: 749,
  },
  "78041": {
    DMA: 749,
  },
  "78042": {
    DMA: 749,
  },
  "78043": {
    DMA: 749,
  },
  "78044": {
    DMA: 749,
  },
  "78045": {
    DMA: 749,
  },
  "78046": {
    DMA: 749,
  },
  "78049": {
    DMA: 749,
  },
  "78050": {
    DMA: 641,
  },
  "78052": {
    DMA: 641,
  },
  "78054": {
    DMA: 641,
  },
  "78055": {
    DMA: 641,
  },
  "78056": {
    DMA: 641,
  },
  "78057": {
    DMA: 641,
  },
  "78058": {
    DMA: 641,
  },
  "78059": {
    DMA: 641,
  },
  "78060": {
    DMA: 600,
  },
  "78061": {
    DMA: 641,
  },
  "78062": {
    DMA: 641,
  },
  "78063": {
    DMA: 641,
  },
  "78064": {
    DMA: 641,
  },
  "78065": {
    DMA: 641,
  },
  "78066": {
    DMA: 641,
  },
  "78067": {
    DMA: 749,
  },
  "78069": {
    DMA: 641,
  },
  "78070": {
    DMA: 641,
  },
  "78071": {
    DMA: 600,
  },
  "78072": {
    DMA: 641,
  },
  "78073": {
    DMA: 641,
  },
  "78074": {
    DMA: 641,
  },
  "78075": {
    DMA: 600,
  },
  "78076": {
    DMA: 749,
  },
  "78101": {
    DMA: 641,
  },
  "78102": {
    DMA: 600,
  },
  "78104": {
    DMA: 600,
  },
  "78107": {
    DMA: 641,
  },
  "78108": {
    DMA: 641,
  },
  "78109": {
    DMA: 641,
  },
  "78111": {
    DMA: 641,
  },
  "78112": {
    DMA: 641,
  },
  "78113": {
    DMA: 641,
  },
  "78114": {
    DMA: 641,
  },
  "78115": {
    DMA: 641,
  },
  "78116": {
    DMA: 641,
  },
  "78117": {
    DMA: 641,
  },
  "78118": {
    DMA: 641,
  },
  "78119": {
    DMA: 641,
  },
  "78121": {
    DMA: 641,
  },
  "78122": {
    DMA: 641,
  },
  "78123": {
    DMA: 641,
  },
  "78124": {
    DMA: 641,
  },
  "78125": {
    DMA: 600,
  },
  "78130": {
    DMA: 641,
  },
  "78131": {
    DMA: 641,
  },
  "78132": {
    DMA: 641,
  },
  "78133": {
    DMA: 641,
  },
  "78135": {
    DMA: 641,
  },
  "78140": {
    DMA: 641,
  },
  "78141": {
    DMA: 641,
  },
  "78142": {
    DMA: 600,
  },
  "78143": {
    DMA: 641,
  },
  "78144": {
    DMA: 641,
  },
  "78145": {
    DMA: 600,
  },
  "78146": {
    DMA: 600,
  },
  "78147": {
    DMA: 641,
  },
  "78148": {
    DMA: 641,
  },
  "78150": {
    DMA: 641,
  },
  "78151": {
    DMA: 641,
  },
  "78152": {
    DMA: 641,
  },
  "78154": {
    DMA: 641,
  },
  "78155": {
    DMA: 641,
  },
  "78156": {
    DMA: 641,
  },
  "78159": {
    DMA: 641,
  },
  "78160": {
    DMA: 641,
  },
  "78161": {
    DMA: 641,
  },
  "78162": {
    DMA: 600,
  },
  "78163": {
    DMA: 641,
  },
  "78164": {
    DMA: 641,
  },
  "78201": {
    DMA: 641,
  },
  "78202": {
    DMA: 641,
  },
  "78203": {
    DMA: 641,
  },
  "78204": {
    DMA: 641,
  },
  "78205": {
    DMA: 641,
  },
  "78206": {
    DMA: 641,
  },
  "78207": {
    DMA: 641,
  },
  "78208": {
    DMA: 641,
  },
  "78209": {
    DMA: 641,
  },
  "78210": {
    DMA: 641,
  },
  "78211": {
    DMA: 641,
  },
  "78212": {
    DMA: 641,
  },
  "78213": {
    DMA: 641,
  },
  "78214": {
    DMA: 641,
  },
  "78215": {
    DMA: 641,
  },
  "78216": {
    DMA: 641,
  },
  "78217": {
    DMA: 641,
  },
  "78218": {
    DMA: 641,
  },
  "78219": {
    DMA: 641,
  },
  "78220": {
    DMA: 641,
  },
  "78221": {
    DMA: 641,
  },
  "78222": {
    DMA: 641,
  },
  "78223": {
    DMA: 641,
  },
  "78224": {
    DMA: 641,
  },
  "78225": {
    DMA: 641,
  },
  "78226": {
    DMA: 641,
  },
  "78227": {
    DMA: 641,
  },
  "78228": {
    DMA: 641,
  },
  "78229": {
    DMA: 641,
  },
  "78230": {
    DMA: 641,
  },
  "78231": {
    DMA: 641,
  },
  "78232": {
    DMA: 641,
  },
  "78233": {
    DMA: 641,
  },
  "78234": {
    DMA: 641,
  },
  "78235": {
    DMA: 641,
  },
  "78236": {
    DMA: 641,
  },
  "78237": {
    DMA: 641,
  },
  "78238": {
    DMA: 641,
  },
  "78239": {
    DMA: 641,
  },
  "78240": {
    DMA: 641,
  },
  "78241": {
    DMA: 641,
  },
  "78242": {
    DMA: 641,
  },
  "78243": {
    DMA: 641,
  },
  "78244": {
    DMA: 641,
  },
  "78245": {
    DMA: 641,
  },
  "78246": {
    DMA: 641,
  },
  "78247": {
    DMA: 641,
  },
  "78248": {
    DMA: 641,
  },
  "78249": {
    DMA: 641,
  },
  "78250": {
    DMA: 641,
  },
  "78251": {
    DMA: 641,
  },
  "78252": {
    DMA: 641,
  },
  "78253": {
    DMA: 641,
  },
  "78254": {
    DMA: 641,
  },
  "78255": {
    DMA: 641,
  },
  "78256": {
    DMA: 641,
  },
  "78257": {
    DMA: 641,
  },
  "78258": {
    DMA: 641,
  },
  "78259": {
    DMA: 641,
  },
  "78260": {
    DMA: 641,
  },
  "78261": {
    DMA: 641,
  },
  "78262": {
    DMA: 641,
  },
  "78263": {
    DMA: 641,
  },
  "78264": {
    DMA: 641,
  },
  "78265": {
    DMA: 641,
  },
  "78266": {
    DMA: 641,
  },
  "78268": {
    DMA: 641,
  },
  "78269": {
    DMA: 641,
  },
  "78270": {
    DMA: 641,
  },
  "78275": {
    DMA: 641,
  },
  "78278": {
    DMA: 641,
  },
  "78279": {
    DMA: 641,
  },
  "78280": {
    DMA: 641,
  },
  "78283": {
    DMA: 641,
  },
  "78284": {
    DMA: 641,
  },
  "78285": {
    DMA: 641,
  },
  "78286": {
    DMA: 641,
  },
  "78287": {
    DMA: 641,
  },
  "78288": {
    DMA: 641,
  },
  "78289": {
    DMA: 641,
  },
  "78291": {
    DMA: 641,
  },
  "78292": {
    DMA: 641,
  },
  "78293": {
    DMA: 641,
  },
  "78294": {
    DMA: 641,
  },
  "78295": {
    DMA: 641,
  },
  "78296": {
    DMA: 641,
  },
  "78297": {
    DMA: 641,
  },
  "78298": {
    DMA: 641,
  },
  "78299": {
    DMA: 641,
  },
  "78330": {
    DMA: 600,
  },
  "78332": {
    DMA: 600,
  },
  "78333": {
    DMA: 600,
  },
  "78335": {
    DMA: 600,
  },
  "78336": {
    DMA: 600,
  },
  "78338": {
    DMA: 600,
  },
  "78339": {
    DMA: 600,
  },
  "78340": {
    DMA: 600,
  },
  "78341": {
    DMA: 600,
  },
  "78342": {
    DMA: 600,
  },
  "78343": {
    DMA: 600,
  },
  "78344": {
    DMA: 749,
  },
  "78347": {
    DMA: 600,
  },
  "78349": {
    DMA: 600,
  },
  "78350": {
    DMA: 600,
  },
  "78351": {
    DMA: 600,
  },
  "78352": {
    DMA: 600,
  },
  "78353": {
    DMA: 600,
  },
  "78355": {
    DMA: 600,
  },
  "78357": {
    DMA: 600,
  },
  "78358": {
    DMA: 600,
  },
  "78359": {
    DMA: 600,
  },
  "78360": {
    DMA: 600,
  },
  "78361": {
    DMA: 600,
  },
  "78362": {
    DMA: 600,
  },
  "78363": {
    DMA: 600,
  },
  "78364": {
    DMA: 600,
  },
  "78368": {
    DMA: 600,
  },
  "78369": {
    DMA: 749,
  },
  "78370": {
    DMA: 600,
  },
  "78371": {
    DMA: 749,
  },
  "78372": {
    DMA: 600,
  },
  "78373": {
    DMA: 600,
  },
  "78374": {
    DMA: 600,
  },
  "78375": {
    DMA: 600,
  },
  "78376": {
    DMA: 600,
  },
  "78377": {
    DMA: 600,
  },
  "78379": {
    DMA: 600,
  },
  "78380": {
    DMA: 600,
  },
  "78381": {
    DMA: 600,
  },
  "78382": {
    DMA: 600,
  },
  "78383": {
    DMA: 600,
  },
  "78384": {
    DMA: 600,
  },
  "78385": {
    DMA: 600,
  },
  "78387": {
    DMA: 600,
  },
  "78389": {
    DMA: 600,
  },
  "78390": {
    DMA: 600,
  },
  "78391": {
    DMA: 600,
  },
  "78393": {
    DMA: 600,
  },
  "78401": {
    DMA: 600,
  },
  "78402": {
    DMA: 600,
  },
  "78403": {
    DMA: 600,
  },
  "78404": {
    DMA: 600,
  },
  "78405": {
    DMA: 600,
  },
  "78406": {
    DMA: 600,
  },
  "78407": {
    DMA: 600,
  },
  "78408": {
    DMA: 600,
  },
  "78409": {
    DMA: 600,
  },
  "78410": {
    DMA: 600,
  },
  "78411": {
    DMA: 600,
  },
  "78412": {
    DMA: 600,
  },
  "78413": {
    DMA: 600,
  },
  "78414": {
    DMA: 600,
  },
  "78415": {
    DMA: 600,
  },
  "78416": {
    DMA: 600,
  },
  "78417": {
    DMA: 600,
  },
  "78418": {
    DMA: 600,
  },
  "78419": {
    DMA: 600,
  },
  "78426": {
    DMA: 600,
  },
  "78427": {
    DMA: 600,
  },
  "78460": {
    DMA: 600,
  },
  "78461": {
    DMA: 600,
  },
  "78463": {
    DMA: 600,
  },
  "78465": {
    DMA: 600,
  },
  "78466": {
    DMA: 600,
  },
  "78467": {
    DMA: 600,
  },
  "78468": {
    DMA: 600,
  },
  "78469": {
    DMA: 600,
  },
  "78470": {
    DMA: 600,
  },
  "78471": {
    DMA: 600,
  },
  "78472": {
    DMA: 600,
  },
  "78473": {
    DMA: 600,
  },
  "78474": {
    DMA: 600,
  },
  "78475": {
    DMA: 600,
  },
  "78476": {
    DMA: 600,
  },
  "78477": {
    DMA: 600,
  },
  "78478": {
    DMA: 600,
  },
  "78480": {
    DMA: 600,
  },
  "78501": {
    DMA: 636,
  },
  "78502": {
    DMA: 636,
  },
  "78503": {
    DMA: 636,
  },
  "78504": {
    DMA: 636,
  },
  "78505": {
    DMA: 636,
  },
  "78516": {
    DMA: 636,
  },
  "78520": {
    DMA: 636,
  },
  "78521": {
    DMA: 636,
  },
  "78522": {
    DMA: 636,
  },
  "78523": {
    DMA: 636,
  },
  "78526": {
    DMA: 636,
  },
  "78535": {
    DMA: 636,
  },
  "78536": {
    DMA: 636,
  },
  "78537": {
    DMA: 636,
  },
  "78538": {
    DMA: 636,
  },
  "78539": {
    DMA: 636,
  },
  "78540": {
    DMA: 636,
  },
  "78541": {
    DMA: 636,
  },
  "78542": {
    DMA: 636,
  },
  "78543": {
    DMA: 636,
  },
  "78545": {
    DMA: 636,
  },
  "78547": {
    DMA: 636,
  },
  "78548": {
    DMA: 636,
  },
  "78549": {
    DMA: 636,
  },
  "78550": {
    DMA: 636,
  },
  "78551": {
    DMA: 636,
  },
  "78552": {
    DMA: 636,
  },
  "78553": {
    DMA: 636,
  },
  "78557": {
    DMA: 636,
  },
  "78558": {
    DMA: 636,
  },
  "78559": {
    DMA: 636,
  },
  "78560": {
    DMA: 636,
  },
  "78561": {
    DMA: 636,
  },
  "78562": {
    DMA: 636,
  },
  "78563": {
    DMA: 636,
  },
  "78564": {
    DMA: 749,
  },
  "78565": {
    DMA: 636,
  },
  "78566": {
    DMA: 636,
  },
  "78567": {
    DMA: 636,
  },
  "78568": {
    DMA: 636,
  },
  "78569": {
    DMA: 636,
  },
  "78570": {
    DMA: 636,
  },
  "78572": {
    DMA: 636,
  },
  "78573": {
    DMA: 636,
  },
  "78574": {
    DMA: 636,
  },
  "78575": {
    DMA: 636,
  },
  "78576": {
    DMA: 636,
  },
  "78577": {
    DMA: 636,
  },
  "78578": {
    DMA: 636,
  },
  "78579": {
    DMA: 636,
  },
  "78580": {
    DMA: 636,
  },
  "78582": {
    DMA: 636,
  },
  "78583": {
    DMA: 636,
  },
  "78584": {
    DMA: 636,
  },
  "78585": {
    DMA: 636,
  },
  "78586": {
    DMA: 636,
  },
  "78588": {
    DMA: 636,
  },
  "78589": {
    DMA: 636,
  },
  "78590": {
    DMA: 636,
  },
  "78591": {
    DMA: 636,
  },
  "78592": {
    DMA: 636,
  },
  "78593": {
    DMA: 636,
  },
  "78594": {
    DMA: 636,
  },
  "78595": {
    DMA: 636,
  },
  "78596": {
    DMA: 636,
  },
  "78597": {
    DMA: 636,
  },
  "78598": {
    DMA: 636,
  },
  "78599": {
    DMA: 636,
  },
  "78602": {
    DMA: 635,
  },
  "78604": {
    DMA: 641,
  },
  "78605": {
    DMA: 635,
  },
  "78606": {
    DMA: 635,
  },
  "78607": {
    DMA: 635,
  },
  "78608": {
    DMA: 635,
  },
  "78609": {
    DMA: 635,
  },
  "78610": {
    DMA: 635,
  },
  "78611": {
    DMA: 635,
  },
  "78612": {
    DMA: 635,
  },
  "78613": {
    DMA: 635,
  },
  "78614": {
    DMA: 641,
  },
  "78615": {
    DMA: 635,
  },
  "78616": {
    DMA: 635,
  },
  "78617": {
    DMA: 635,
  },
  "78618": {
    DMA: 635,
  },
  "78619": {
    DMA: 635,
  },
  "78620": {
    DMA: 635,
  },
  "78621": {
    DMA: 635,
  },
  "78622": {
    DMA: 635,
  },
  "78623": {
    DMA: 641,
  },
  "78624": {
    DMA: 635,
  },
  "78626": {
    DMA: 635,
  },
  "78627": {
    DMA: 635,
  },
  "78628": {
    DMA: 635,
  },
  "78629": {
    DMA: 641,
  },
  "78630": {
    DMA: 635,
  },
  "78631": {
    DMA: 635,
  },
  "78632": {
    DMA: 641,
  },
  "78633": {
    DMA: 635,
  },
  "78634": {
    DMA: 635,
  },
  "78635": {
    DMA: 635,
  },
  "78636": {
    DMA: 635,
  },
  "78638": {
    DMA: 641,
  },
  "78639": {
    DMA: 635,
  },
  "78640": {
    DMA: 635,
  },
  "78641": {
    DMA: 635,
  },
  "78642": {
    DMA: 635,
  },
  "78643": {
    DMA: 635,
  },
  "78644": {
    DMA: 635,
  },
  "78645": {
    DMA: 635,
  },
  "78646": {
    DMA: 635,
  },
  "78648": {
    DMA: 635,
  },
  "78650": {
    DMA: 635,
  },
  "78651": {
    DMA: 635,
  },
  "78652": {
    DMA: 635,
  },
  "78653": {
    DMA: 635,
  },
  "78654": {
    DMA: 635,
  },
  "78655": {
    DMA: 635,
  },
  "78656": {
    DMA: 635,
  },
  "78657": {
    DMA: 635,
  },
  "78658": {
    DMA: 641,
  },
  "78659": {
    DMA: 635,
  },
  "78660": {
    DMA: 635,
  },
  "78661": {
    DMA: 635,
  },
  "78662": {
    DMA: 635,
  },
  "78663": {
    DMA: 635,
  },
  "78664": {
    DMA: 635,
  },
  "78665": {
    DMA: 635,
  },
  "78666": {
    DMA: 635,
  },
  "78667": {
    DMA: 635,
  },
  "78669": {
    DMA: 635,
  },
  "78670": {
    DMA: 641,
  },
  "78671": {
    DMA: 635,
  },
  "78672": {
    DMA: 635,
  },
  "78673": {
    DMA: 635,
  },
  "78674": {
    DMA: 635,
  },
  "78675": {
    DMA: 635,
  },
  "78676": {
    DMA: 635,
  },
  "78677": {
    DMA: 641,
  },
  "78680": {
    DMA: 635,
  },
  "78681": {
    DMA: 635,
  },
  "78682": {
    DMA: 635,
  },
  "78683": {
    DMA: 635,
  },
  "78691": {
    DMA: 635,
  },
  "78701": {
    DMA: 635,
  },
  "78702": {
    DMA: 635,
  },
  "78703": {
    DMA: 635,
  },
  "78704": {
    DMA: 635,
  },
  "78705": {
    DMA: 635,
  },
  "78708": {
    DMA: 635,
  },
  "78709": {
    DMA: 635,
  },
  "78710": {
    DMA: 635,
  },
  "78711": {
    DMA: 635,
  },
  "78712": {
    DMA: 635,
  },
  "78713": {
    DMA: 635,
  },
  "78714": {
    DMA: 635,
  },
  "78715": {
    DMA: 635,
  },
  "78716": {
    DMA: 635,
  },
  "78717": {
    DMA: 635,
  },
  "78718": {
    DMA: 635,
  },
  "78719": {
    DMA: 635,
  },
  "78720": {
    DMA: 635,
  },
  "78721": {
    DMA: 635,
  },
  "78722": {
    DMA: 635,
  },
  "78723": {
    DMA: 635,
  },
  "78724": {
    DMA: 635,
  },
  "78725": {
    DMA: 635,
  },
  "78726": {
    DMA: 635,
  },
  "78727": {
    DMA: 635,
  },
  "78728": {
    DMA: 635,
  },
  "78729": {
    DMA: 635,
  },
  "78730": {
    DMA: 635,
  },
  "78731": {
    DMA: 635,
  },
  "78732": {
    DMA: 635,
  },
  "78733": {
    DMA: 635,
  },
  "78734": {
    DMA: 635,
  },
  "78735": {
    DMA: 635,
  },
  "78736": {
    DMA: 635,
  },
  "78737": {
    DMA: 635,
  },
  "78738": {
    DMA: 635,
  },
  "78739": {
    DMA: 635,
  },
  "78741": {
    DMA: 635,
  },
  "78742": {
    DMA: 635,
  },
  "78744": {
    DMA: 635,
  },
  "78745": {
    DMA: 635,
  },
  "78746": {
    DMA: 635,
  },
  "78747": {
    DMA: 635,
  },
  "78748": {
    DMA: 635,
  },
  "78749": {
    DMA: 635,
  },
  "78750": {
    DMA: 635,
  },
  "78751": {
    DMA: 635,
  },
  "78752": {
    DMA: 635,
  },
  "78753": {
    DMA: 635,
  },
  "78754": {
    DMA: 635,
  },
  "78755": {
    DMA: 635,
  },
  "78756": {
    DMA: 635,
  },
  "78757": {
    DMA: 635,
  },
  "78758": {
    DMA: 635,
  },
  "78759": {
    DMA: 635,
  },
  "78760": {
    DMA: 635,
  },
  "78761": {
    DMA: 635,
  },
  "78762": {
    DMA: 635,
  },
  "78763": {
    DMA: 635,
  },
  "78764": {
    DMA: 635,
  },
  "78765": {
    DMA: 635,
  },
  "78766": {
    DMA: 635,
  },
  "78767": {
    DMA: 635,
  },
  "78768": {
    DMA: 635,
  },
  "78769": {
    DMA: 635,
  },
  "78772": {
    DMA: 635,
  },
  "78773": {
    DMA: 635,
  },
  "78774": {
    DMA: 635,
  },
  "78778": {
    DMA: 635,
  },
  "78779": {
    DMA: 635,
  },
  "78780": {
    DMA: 635,
  },
  "78781": {
    DMA: 635,
  },
  "78783": {
    DMA: 635,
  },
  "78785": {
    DMA: 635,
  },
  "78786": {
    DMA: 635,
  },
  "78788": {
    DMA: 635,
  },
  "78789": {
    DMA: 635,
  },
  "78798": {
    DMA: 635,
  },
  "78799": {
    DMA: 635,
  },
  "78801": {
    DMA: 641,
  },
  "78802": {
    DMA: 641,
  },
  "78827": {
    DMA: 641,
  },
  "78828": {
    DMA: 641,
  },
  "78829": {
    DMA: 641,
  },
  "78830": {
    DMA: 641,
  },
  "78832": {
    DMA: 641,
  },
  "78833": {
    DMA: 641,
  },
  "78834": {
    DMA: 641,
  },
  "78836": {
    DMA: 641,
  },
  "78837": {
    DMA: 641,
  },
  "78838": {
    DMA: 641,
  },
  "78839": {
    DMA: 641,
  },
  "78840": {
    DMA: 641,
  },
  "78841": {
    DMA: 641,
  },
  "78842": {
    DMA: 641,
  },
  "78843": {
    DMA: 641,
  },
  "78847": {
    DMA: 641,
  },
  "78850": {
    DMA: 641,
  },
  "78851": {
    DMA: 633,
  },
  "78852": {
    DMA: 641,
  },
  "78853": {
    DMA: 641,
  },
  "78860": {
    DMA: 641,
  },
  "78861": {
    DMA: 641,
  },
  "78870": {
    DMA: 641,
  },
  "78871": {
    DMA: 641,
  },
  "78872": {
    DMA: 641,
  },
  "78873": {
    DMA: 641,
  },
  "78877": {
    DMA: 641,
  },
  "78879": {
    DMA: 641,
  },
  "78880": {
    DMA: 641,
  },
  "78881": {
    DMA: 641,
  },
  "78883": {
    DMA: 641,
  },
  "78884": {
    DMA: 641,
  },
  "78885": {
    DMA: 641,
  },
  "78886": {
    DMA: 641,
  },
  "78931": {
    DMA: 618,
  },
  "78932": {
    DMA: 635,
  },
  "78933": {
    DMA: 618,
  },
  "78934": {
    DMA: 618,
  },
  "78935": {
    DMA: 618,
  },
  "78938": {
    DMA: 635,
  },
  "78940": {
    DMA: 635,
  },
  "78941": {
    DMA: 635,
  },
  "78942": {
    DMA: 635,
  },
  "78943": {
    DMA: 618,
  },
  "78944": {
    DMA: 618,
  },
  "78945": {
    DMA: 635,
  },
  "78946": {
    DMA: 635,
  },
  "78947": {
    DMA: 635,
  },
  "78948": {
    DMA: 635,
  },
  "78949": {
    DMA: 635,
  },
  "78950": {
    DMA: 618,
  },
  "78951": {
    DMA: 618,
  },
  "78952": {
    DMA: 635,
  },
  "78953": {
    DMA: 635,
  },
  "78954": {
    DMA: 635,
  },
  "78956": {
    DMA: 635,
  },
  "78957": {
    DMA: 635,
  },
  "78959": {
    DMA: 641,
  },
  "78960": {
    DMA: 635,
  },
  "78961": {
    DMA: 635,
  },
  "78962": {
    DMA: 618,
  },
  "78963": {
    DMA: 635,
  },
  "79001": {
    DMA: 634,
  },
  "79002": {
    DMA: 634,
  },
  "79003": {
    DMA: 634,
  },
  "79005": {
    DMA: 634,
  },
  "79007": {
    DMA: 634,
  },
  "79008": {
    DMA: 634,
  },
  "79009": {
    DMA: 634,
  },
  "79010": {
    DMA: 634,
  },
  "79011": {
    DMA: 634,
  },
  "79012": {
    DMA: 634,
  },
  "79013": {
    DMA: 634,
  },
  "79014": {
    DMA: 634,
  },
  "79015": {
    DMA: 634,
  },
  "79016": {
    DMA: 634,
  },
  "79018": {
    DMA: 634,
  },
  "79019": {
    DMA: 634,
  },
  "79021": {
    DMA: 651,
  },
  "79022": {
    DMA: 634,
  },
  "79024": {
    DMA: 634,
  },
  "79025": {
    DMA: 634,
  },
  "79027": {
    DMA: 634,
  },
  "79029": {
    DMA: 634,
  },
  "79031": {
    DMA: 651,
  },
  "79032": {
    DMA: 651,
  },
  "79033": {
    DMA: 634,
  },
  "79034": {
    DMA: 634,
  },
  "79035": {
    DMA: 634,
  },
  "79036": {
    DMA: 634,
  },
  "79039": {
    DMA: 634,
  },
  "79040": {
    DMA: 634,
  },
  "79041": {
    DMA: 651,
  },
  "79042": {
    DMA: 634,
  },
  "79043": {
    DMA: 634,
  },
  "79044": {
    DMA: 634,
  },
  "79045": {
    DMA: 634,
  },
  "79046": {
    DMA: 634,
  },
  "79051": {
    DMA: 634,
  },
  "79052": {
    DMA: 634,
  },
  "79053": {
    DMA: 634,
  },
  "79054": {
    DMA: 634,
  },
  "79056": {
    DMA: 634,
  },
  "79057": {
    DMA: 634,
  },
  "79058": {
    DMA: 634,
  },
  "79059": {
    DMA: 634,
  },
  "79061": {
    DMA: 634,
  },
  "79062": {
    DMA: 634,
  },
  "79063": {
    DMA: 634,
  },
  "79064": {
    DMA: 651,
  },
  "79065": {
    DMA: 634,
  },
  "79066": {
    DMA: 634,
  },
  "79068": {
    DMA: 634,
  },
  "79070": {
    DMA: 634,
  },
  "79072": {
    DMA: 651,
  },
  "79073": {
    DMA: 651,
  },
  "79077": {
    DMA: 634,
  },
  "79078": {
    DMA: 634,
  },
  "79079": {
    DMA: 634,
  },
  "79080": {
    DMA: 634,
  },
  "79081": {
    DMA: 634,
  },
  "79082": {
    DMA: 651,
  },
  "79083": {
    DMA: 634,
  },
  "79084": {
    DMA: 634,
  },
  "79085": {
    DMA: 634,
  },
  "79086": {
    DMA: 634,
  },
  "79087": {
    DMA: 634,
  },
  "79088": {
    DMA: 634,
  },
  "79091": {
    DMA: 634,
  },
  "79092": {
    DMA: 634,
  },
  "79093": {
    DMA: 634,
  },
  "79094": {
    DMA: 634,
  },
  "79095": {
    DMA: 634,
  },
  "79096": {
    DMA: 634,
  },
  "79097": {
    DMA: 634,
  },
  "79098": {
    DMA: 634,
  },
  "79101": {
    DMA: 634,
  },
  "79102": {
    DMA: 634,
  },
  "79103": {
    DMA: 634,
  },
  "79104": {
    DMA: 634,
  },
  "79105": {
    DMA: 634,
  },
  "79106": {
    DMA: 634,
  },
  "79107": {
    DMA: 634,
  },
  "79108": {
    DMA: 634,
  },
  "79109": {
    DMA: 634,
  },
  "79110": {
    DMA: 634,
  },
  "79111": {
    DMA: 634,
  },
  "79114": {
    DMA: 634,
  },
  "79116": {
    DMA: 634,
  },
  "79117": {
    DMA: 634,
  },
  "79118": {
    DMA: 634,
  },
  "79119": {
    DMA: 634,
  },
  "79120": {
    DMA: 634,
  },
  "79121": {
    DMA: 634,
  },
  "79124": {
    DMA: 634,
  },
  "79159": {
    DMA: 634,
  },
  "79166": {
    DMA: 634,
  },
  "79168": {
    DMA: 634,
  },
  "79172": {
    DMA: 634,
  },
  "79174": {
    DMA: 634,
  },
  "79178": {
    DMA: 634,
  },
  "79185": {
    DMA: 634,
  },
  "79187": {
    DMA: 634,
  },
  "79189": {
    DMA: 634,
  },
  "79201": {
    DMA: 634,
  },
  "79220": {
    DMA: 651,
  },
  "79221": {
    DMA: 651,
  },
  "79223": {
    DMA: 634,
  },
  "79225": {
    DMA: 627,
  },
  "79226": {
    DMA: 634,
  },
  "79227": {
    DMA: 627,
  },
  "79229": {
    DMA: 651,
  },
  "79230": {
    DMA: 634,
  },
  "79231": {
    DMA: 651,
  },
  "79233": {
    DMA: 634,
  },
  "79234": {
    DMA: 651,
  },
  "79235": {
    DMA: 651,
  },
  "79236": {
    DMA: 627,
  },
  "79237": {
    DMA: 634,
  },
  "79239": {
    DMA: 634,
  },
  "79240": {
    DMA: 634,
  },
  "79241": {
    DMA: 651,
  },
  "79243": {
    DMA: 651,
  },
  "79244": {
    DMA: 651,
  },
  "79245": {
    DMA: 634,
  },
  "79247": {
    DMA: 627,
  },
  "79248": {
    DMA: 634,
  },
  "79250": {
    DMA: 651,
  },
  "79251": {
    DMA: 634,
  },
  "79252": {
    DMA: 627,
  },
  "79255": {
    DMA: 634,
  },
  "79256": {
    DMA: 651,
  },
  "79257": {
    DMA: 634,
  },
  "79258": {
    DMA: 651,
  },
  "79259": {
    DMA: 634,
  },
  "79261": {
    DMA: 634,
  },
  "79311": {
    DMA: 651,
  },
  "79312": {
    DMA: 651,
  },
  "79313": {
    DMA: 651,
  },
  "79314": {
    DMA: 651,
  },
  "79316": {
    DMA: 651,
  },
  "79320": {
    DMA: 618,
  },
  "79322": {
    DMA: 651,
  },
  "79323": {
    DMA: 651,
  },
  "79324": {
    DMA: 651,
  },
  "79325": {
    DMA: 634,
  },
  "79326": {
    DMA: 651,
  },
  "79329": {
    DMA: 651,
  },
  "79330": {
    DMA: 651,
  },
  "79331": {
    DMA: 651,
  },
  "79336": {
    DMA: 651,
  },
  "79338": {
    DMA: 651,
  },
  "79339": {
    DMA: 651,
  },
  "79342": {
    DMA: 651,
  },
  "79343": {
    DMA: 651,
  },
  "79344": {
    DMA: 651,
  },
  "79345": {
    DMA: 651,
  },
  "79346": {
    DMA: 651,
  },
  "79347": {
    DMA: 651,
  },
  "79350": {
    DMA: 651,
  },
  "79351": {
    DMA: 651,
  },
  "79353": {
    DMA: 651,
  },
  "79355": {
    DMA: 651,
  },
  "79356": {
    DMA: 651,
  },
  "79357": {
    DMA: 651,
  },
  "79358": {
    DMA: 651,
  },
  "79359": {
    DMA: 651,
  },
  "79360": {
    DMA: 651,
  },
  "79363": {
    DMA: 651,
  },
  "79364": {
    DMA: 651,
  },
  "79366": {
    DMA: 651,
  },
  "79367": {
    DMA: 651,
  },
  "79369": {
    DMA: 651,
  },
  "79370": {
    DMA: 651,
  },
  "79371": {
    DMA: 651,
  },
  "79372": {
    DMA: 651,
  },
  "79373": {
    DMA: 651,
  },
  "79376": {
    DMA: 651,
  },
  "79377": {
    DMA: 651,
  },
  "79378": {
    DMA: 651,
  },
  "79379": {
    DMA: 651,
  },
  "79380": {
    DMA: 651,
  },
  "79381": {
    DMA: 651,
  },
  "79382": {
    DMA: 651,
  },
  "79383": {
    DMA: 651,
  },
  "79401": {
    DMA: 651,
  },
  "79402": {
    DMA: 651,
  },
  "79403": {
    DMA: 651,
  },
  "79404": {
    DMA: 651,
  },
  "79405": {
    DMA: 651,
  },
  "79406": {
    DMA: 651,
  },
  "79407": {
    DMA: 651,
  },
  "79408": {
    DMA: 651,
  },
  "79409": {
    DMA: 651,
  },
  "79410": {
    DMA: 651,
  },
  "79411": {
    DMA: 651,
  },
  "79412": {
    DMA: 651,
  },
  "79413": {
    DMA: 651,
  },
  "79414": {
    DMA: 651,
  },
  "79415": {
    DMA: 651,
  },
  "79416": {
    DMA: 651,
  },
  "79423": {
    DMA: 651,
  },
  "79424": {
    DMA: 651,
  },
  "79430": {
    DMA: 651,
  },
  "79452": {
    DMA: 651,
  },
  "79453": {
    DMA: 651,
  },
  "79457": {
    DMA: 651,
  },
  "79464": {
    DMA: 651,
  },
  "79490": {
    DMA: 651,
  },
  "79491": {
    DMA: 651,
  },
  "79493": {
    DMA: 651,
  },
  "79499": {
    DMA: 651,
  },
  "79501": {
    DMA: 662,
  },
  "79502": {
    DMA: 662,
  },
  "79503": {
    DMA: 662,
  },
  "79504": {
    DMA: 662,
  },
  "79505": {
    DMA: 662,
  },
  "79506": {
    DMA: 662,
  },
  "79508": {
    DMA: 662,
  },
  "79510": {
    DMA: 662,
  },
  "79511": {
    DMA: 633,
  },
  "79512": {
    DMA: 662,
  },
  "79516": {
    DMA: 662,
  },
  "79517": {
    DMA: 662,
  },
  "79518": {
    DMA: 651,
  },
  "79519": {
    DMA: 662,
  },
  "79520": {
    DMA: 662,
  },
  "79521": {
    DMA: 662,
  },
  "79525": {
    DMA: 662,
  },
  "79526": {
    DMA: 662,
  },
  "79527": {
    DMA: 662,
  },
  "79528": {
    DMA: 651,
  },
  "79529": {
    DMA: 662,
  },
  "79530": {
    DMA: 662,
  },
  "79532": {
    DMA: 662,
  },
  "79533": {
    DMA: 662,
  },
  "79534": {
    DMA: 662,
  },
  "79535": {
    DMA: 662,
  },
  "79536": {
    DMA: 662,
  },
  "79537": {
    DMA: 662,
  },
  "79538": {
    DMA: 662,
  },
  "79539": {
    DMA: 662,
  },
  "79540": {
    DMA: 662,
  },
  "79541": {
    DMA: 662,
  },
  "79543": {
    DMA: 662,
  },
  "79544": {
    DMA: 662,
  },
  "79545": {
    DMA: 662,
  },
  "79546": {
    DMA: 662,
  },
  "79547": {
    DMA: 662,
  },
  "79548": {
    DMA: 662,
  },
  "79549": {
    DMA: 662,
  },
  "79550": {
    DMA: 662,
  },
  "79553": {
    DMA: 662,
  },
  "79556": {
    DMA: 662,
  },
  "79560": {
    DMA: 662,
  },
  "79561": {
    DMA: 662,
  },
  "79562": {
    DMA: 662,
  },
  "79563": {
    DMA: 662,
  },
  "79565": {
    DMA: 662,
  },
  "79566": {
    DMA: 662,
  },
  "79567": {
    DMA: 662,
  },
  "79601": {
    DMA: 662,
  },
  "79602": {
    DMA: 662,
  },
  "79603": {
    DMA: 662,
  },
  "79604": {
    DMA: 662,
  },
  "79605": {
    DMA: 662,
  },
  "79606": {
    DMA: 662,
  },
  "79607": {
    DMA: 662,
  },
  "79608": {
    DMA: 662,
  },
  "79697": {
    DMA: 662,
  },
  "79698": {
    DMA: 662,
  },
  "79699": {
    DMA: 662,
  },
  "79701": {
    DMA: 633,
  },
  "79702": {
    DMA: 633,
  },
  "79703": {
    DMA: 633,
  },
  "79704": {
    DMA: 633,
  },
  "79705": {
    DMA: 633,
  },
  "79706": {
    DMA: 633,
  },
  "79707": {
    DMA: 633,
  },
  "79708": {
    DMA: 633,
  },
  "79710": {
    DMA: 633,
  },
  "79711": {
    DMA: 633,
  },
  "79712": {
    DMA: 633,
  },
  "79713": {
    DMA: 633,
  },
  "79714": {
    DMA: 633,
  },
  "79718": {
    DMA: 633,
  },
  "79719": {
    DMA: 633,
  },
  "79720": {
    DMA: 633,
  },
  "79721": {
    DMA: 633,
  },
  "79730": {
    DMA: 633,
  },
  "79731": {
    DMA: 633,
  },
  "79733": {
    DMA: 633,
  },
  "79734": {
    DMA: 633,
  },
  "79735": {
    DMA: 633,
  },
  "79738": {
    DMA: 651,
  },
  "79739": {
    DMA: 633,
  },
  "79740": {
    DMA: 633,
  },
  "79741": {
    DMA: 633,
  },
  "79742": {
    DMA: 633,
  },
  "79743": {
    DMA: 633,
  },
  "79744": {
    DMA: 633,
  },
  "79745": {
    DMA: 633,
  },
  "79748": {
    DMA: 633,
  },
  "79749": {
    DMA: 633,
  },
  "79752": {
    DMA: 633,
  },
  "79754": {
    DMA: 633,
  },
  "79755": {
    DMA: 633,
  },
  "79756": {
    DMA: 633,
  },
  "79758": {
    DMA: 633,
  },
  "79759": {
    DMA: 633,
  },
  "79760": {
    DMA: 633,
  },
  "79761": {
    DMA: 633,
  },
  "79762": {
    DMA: 633,
  },
  "79763": {
    DMA: 633,
  },
  "79764": {
    DMA: 633,
  },
  "79765": {
    DMA: 633,
  },
  "79766": {
    DMA: 633,
  },
  "79768": {
    DMA: 633,
  },
  "79769": {
    DMA: 633,
  },
  "79770": {
    DMA: 633,
  },
  "79772": {
    DMA: 633,
  },
  "79776": {
    DMA: 633,
  },
  "79777": {
    DMA: 633,
  },
  "79778": {
    DMA: 633,
  },
  "79780": {
    DMA: 633,
  },
  "79781": {
    DMA: 633,
  },
  "79782": {
    DMA: 633,
  },
  "79783": {
    DMA: 633,
  },
  "79785": {
    DMA: 633,
  },
  "79786": {
    DMA: 633,
  },
  "79788": {
    DMA: 633,
  },
  "79789": {
    DMA: 633,
  },
  "79821": {
    DMA: 765,
  },
  "79830": {
    DMA: 633,
  },
  "79831": {
    DMA: 633,
  },
  "79832": {
    DMA: 633,
  },
  "79834": {
    DMA: 633,
  },
  "79835": {
    DMA: 765,
  },
  "79836": {
    DMA: 765,
  },
  "79837": {
    DMA: 765,
  },
  "79838": {
    DMA: 765,
  },
  "79839": {
    DMA: 765,
  },
  "79842": {
    DMA: 633,
  },
  "79843": {
    DMA: 633,
  },
  "79845": {
    DMA: 633,
  },
  "79846": {
    DMA: 633,
  },
  "79847": {
    DMA: 765,
  },
  "79848": {
    DMA: 633,
  },
  "79849": {
    DMA: 765,
  },
  "79851": {
    DMA: 765,
  },
  "79852": {
    DMA: 633,
  },
  "79853": {
    DMA: 765,
  },
  "79854": {
    DMA: 633,
  },
  "79855": {
    DMA: 765,
  },
  "79901": {
    DMA: 765,
  },
  "79902": {
    DMA: 765,
  },
  "79903": {
    DMA: 765,
  },
  "79904": {
    DMA: 765,
  },
  "79905": {
    DMA: 765,
  },
  "79906": {
    DMA: 765,
  },
  "79907": {
    DMA: 765,
  },
  "79908": {
    DMA: 765,
  },
  "79910": {
    DMA: 765,
  },
  "79911": {
    DMA: 765,
  },
  "79912": {
    DMA: 765,
  },
  "79913": {
    DMA: 765,
  },
  "79914": {
    DMA: 765,
  },
  "79915": {
    DMA: 765,
  },
  "79916": {
    DMA: 765,
  },
  "79917": {
    DMA: 765,
  },
  "79918": {
    DMA: 765,
  },
  "79920": {
    DMA: 765,
  },
  "79922": {
    DMA: 765,
  },
  "79923": {
    DMA: 765,
  },
  "79924": {
    DMA: 765,
  },
  "79925": {
    DMA: 765,
  },
  "79926": {
    DMA: 765,
  },
  "79927": {
    DMA: 765,
  },
  "79928": {
    DMA: 765,
  },
  "79929": {
    DMA: 765,
  },
  "79930": {
    DMA: 765,
  },
  "79931": {
    DMA: 765,
  },
  "79932": {
    DMA: 765,
  },
  "79934": {
    DMA: 765,
  },
  "79935": {
    DMA: 765,
  },
  "79936": {
    DMA: 765,
  },
  "79937": {
    DMA: 765,
  },
  "79938": {
    DMA: 765,
  },
  "79940": {
    DMA: 765,
  },
  "79941": {
    DMA: 765,
  },
  "79942": {
    DMA: 765,
  },
  "79943": {
    DMA: 765,
  },
  "79944": {
    DMA: 765,
  },
  "79945": {
    DMA: 765,
  },
  "79946": {
    DMA: 765,
  },
  "79947": {
    DMA: 765,
  },
  "79948": {
    DMA: 765,
  },
  "79949": {
    DMA: 765,
  },
  "79950": {
    DMA: 765,
  },
  "79951": {
    DMA: 765,
  },
  "79952": {
    DMA: 765,
  },
  "79953": {
    DMA: 765,
  },
  "79954": {
    DMA: 765,
  },
  "79955": {
    DMA: 765,
  },
  "79958": {
    DMA: 765,
  },
  "79960": {
    DMA: 765,
  },
  "79961": {
    DMA: 765,
  },
  "79968": {
    DMA: 765,
  },
  "79976": {
    DMA: 765,
  },
  "79978": {
    DMA: 765,
  },
  "79980": {
    DMA: 765,
  },
  "79990": {
    DMA: 765,
  },
  "79995": {
    DMA: 765,
  },
  "79996": {
    DMA: 765,
  },
  "79997": {
    DMA: 765,
  },
  "79998": {
    DMA: 765,
  },
  "79999": {
    DMA: 765,
  },
  "80001": {
    DMA: 751,
  },
  "80002": {
    DMA: 751,
  },
  "80003": {
    DMA: 751,
  },
  "80004": {
    DMA: 751,
  },
  "80005": {
    DMA: 751,
  },
  "80006": {
    DMA: 751,
  },
  "80007": {
    DMA: 751,
  },
  "80010": {
    DMA: 751,
  },
  "80011": {
    DMA: 751,
  },
  "80012": {
    DMA: 751,
  },
  "80013": {
    DMA: 751,
  },
  "80014": {
    DMA: 751,
  },
  "80015": {
    DMA: 751,
  },
  "80016": {
    DMA: 751,
  },
  "80017": {
    DMA: 751,
  },
  "80018": {
    DMA: 751,
  },
  "80019": {
    DMA: 751,
  },
  "80020": {
    DMA: 751,
  },
  "80021": {
    DMA: 751,
  },
  "80022": {
    DMA: 751,
  },
  "80023": {
    DMA: 751,
  },
  "80024": {
    DMA: 751,
  },
  "80025": {
    DMA: 751,
  },
  "80026": {
    DMA: 751,
  },
  "80027": {
    DMA: 751,
  },
  "80028": {
    DMA: 751,
  },
  "80030": {
    DMA: 751,
  },
  "80031": {
    DMA: 751,
  },
  "80033": {
    DMA: 751,
  },
  "80034": {
    DMA: 751,
  },
  "80035": {
    DMA: 751,
  },
  "80036": {
    DMA: 751,
  },
  "80037": {
    DMA: 751,
  },
  "80038": {
    DMA: 751,
  },
  "80040": {
    DMA: 751,
  },
  "80041": {
    DMA: 751,
  },
  "80042": {
    DMA: 751,
  },
  "80044": {
    DMA: 751,
  },
  "80045": {
    DMA: 751,
  },
  "80046": {
    DMA: 751,
  },
  "80047": {
    DMA: 751,
  },
  "80101": {
    DMA: 751,
  },
  "80102": {
    DMA: 751,
  },
  "80103": {
    DMA: 751,
  },
  "80104": {
    DMA: 751,
  },
  "80105": {
    DMA: 751,
  },
  "80106": {
    DMA: 752,
  },
  "80107": {
    DMA: 751,
  },
  "80108": {
    DMA: 751,
  },
  "80109": {
    DMA: 751,
  },
  "80110": {
    DMA: 751,
  },
  "80111": {
    DMA: 751,
  },
  "80112": {
    DMA: 751,
  },
  "80113": {
    DMA: 751,
  },
  "80116": {
    DMA: 751,
  },
  "80117": {
    DMA: 751,
  },
  "80118": {
    DMA: 751,
  },
  "80120": {
    DMA: 751,
  },
  "80121": {
    DMA: 751,
  },
  "80122": {
    DMA: 751,
  },
  "80123": {
    DMA: 751,
  },
  "80124": {
    DMA: 751,
  },
  "80125": {
    DMA: 751,
  },
  "80126": {
    DMA: 751,
  },
  "80127": {
    DMA: 751,
  },
  "80128": {
    DMA: 751,
  },
  "80129": {
    DMA: 751,
  },
  "80130": {
    DMA: 751,
  },
  "80131": {
    DMA: 751,
  },
  "80132": {
    DMA: 752,
  },
  "80133": {
    DMA: 752,
  },
  "80134": {
    DMA: 751,
  },
  "80135": {
    DMA: 751,
  },
  "80136": {
    DMA: 751,
  },
  "80137": {
    DMA: 751,
  },
  "80138": {
    DMA: 751,
  },
  "80150": {
    DMA: 751,
  },
  "80151": {
    DMA: 751,
  },
  "80155": {
    DMA: 751,
  },
  "80160": {
    DMA: 751,
  },
  "80161": {
    DMA: 751,
  },
  "80162": {
    DMA: 751,
  },
  "80163": {
    DMA: 751,
  },
  "80165": {
    DMA: 751,
  },
  "80166": {
    DMA: 751,
  },
  "80201": {
    DMA: 751,
  },
  "80202": {
    DMA: 751,
  },
  "80203": {
    DMA: 751,
  },
  "80204": {
    DMA: 751,
  },
  "80205": {
    DMA: 751,
  },
  "80206": {
    DMA: 751,
  },
  "80207": {
    DMA: 751,
  },
  "80208": {
    DMA: 751,
  },
  "80209": {
    DMA: 751,
  },
  "80210": {
    DMA: 751,
  },
  "80211": {
    DMA: 751,
  },
  "80212": {
    DMA: 751,
  },
  "80214": {
    DMA: 751,
  },
  "80215": {
    DMA: 751,
  },
  "80216": {
    DMA: 751,
  },
  "80217": {
    DMA: 751,
  },
  "80218": {
    DMA: 751,
  },
  "80219": {
    DMA: 751,
  },
  "80220": {
    DMA: 751,
  },
  "80221": {
    DMA: 751,
  },
  "80222": {
    DMA: 751,
  },
  "80223": {
    DMA: 751,
  },
  "80224": {
    DMA: 751,
  },
  "80225": {
    DMA: 751,
  },
  "80226": {
    DMA: 751,
  },
  "80227": {
    DMA: 751,
  },
  "80228": {
    DMA: 751,
  },
  "80229": {
    DMA: 751,
  },
  "80230": {
    DMA: 751,
  },
  "80231": {
    DMA: 751,
  },
  "80232": {
    DMA: 751,
  },
  "80233": {
    DMA: 751,
  },
  "80234": {
    DMA: 751,
  },
  "80235": {
    DMA: 751,
  },
  "80236": {
    DMA: 751,
  },
  "80237": {
    DMA: 751,
  },
  "80238": {
    DMA: 751,
  },
  "80239": {
    DMA: 751,
  },
  "80241": {
    DMA: 751,
  },
  "80243": {
    DMA: 751,
  },
  "80244": {
    DMA: 751,
  },
  "80246": {
    DMA: 751,
  },
  "80247": {
    DMA: 751,
  },
  "80248": {
    DMA: 751,
  },
  "80249": {
    DMA: 751,
  },
  "80250": {
    DMA: 751,
  },
  "80251": {
    DMA: 751,
  },
  "80252": {
    DMA: 751,
  },
  "80256": {
    DMA: 751,
  },
  "80257": {
    DMA: 751,
  },
  "80259": {
    DMA: 751,
  },
  "80260": {
    DMA: 751,
  },
  "80261": {
    DMA: 751,
  },
  "80262": {
    DMA: 751,
  },
  "80263": {
    DMA: 751,
  },
  "80264": {
    DMA: 751,
  },
  "80265": {
    DMA: 751,
  },
  "80266": {
    DMA: 751,
  },
  "80271": {
    DMA: 751,
  },
  "80273": {
    DMA: 751,
  },
  "80274": {
    DMA: 751,
  },
  "80279": {
    DMA: 751,
  },
  "80280": {
    DMA: 751,
  },
  "80281": {
    DMA: 751,
  },
  "80290": {
    DMA: 751,
  },
  "80291": {
    DMA: 751,
  },
  "80293": {
    DMA: 751,
  },
  "80294": {
    DMA: 751,
  },
  "80295": {
    DMA: 751,
  },
  "80299": {
    DMA: 751,
  },
  "80301": {
    DMA: 751,
  },
  "80302": {
    DMA: 751,
  },
  "80303": {
    DMA: 751,
  },
  "80304": {
    DMA: 751,
  },
  "80305": {
    DMA: 751,
  },
  "80306": {
    DMA: 751,
  },
  "80307": {
    DMA: 751,
  },
  "80308": {
    DMA: 751,
  },
  "80309": {
    DMA: 751,
  },
  "80310": {
    DMA: 751,
  },
  "80314": {
    DMA: 751,
  },
  "80321": {
    DMA: 751,
  },
  "80322": {
    DMA: 751,
  },
  "80323": {
    DMA: 751,
  },
  "80328": {
    DMA: 751,
  },
  "80329": {
    DMA: 751,
  },
  "80401": {
    DMA: 751,
  },
  "80402": {
    DMA: 751,
  },
  "80403": {
    DMA: 751,
  },
  "80419": {
    DMA: 751,
  },
  "80420": {
    DMA: 751,
  },
  "80421": {
    DMA: 751,
  },
  "80422": {
    DMA: 751,
  },
  "80423": {
    DMA: 751,
  },
  "80424": {
    DMA: 751,
  },
  "80425": {
    DMA: 751,
  },
  "80426": {
    DMA: 751,
  },
  "80427": {
    DMA: 751,
  },
  "80428": {
    DMA: 751,
  },
  "80429": {
    DMA: 751,
  },
  "80430": {
    DMA: 751,
  },
  "80432": {
    DMA: 751,
  },
  "80433": {
    DMA: 751,
  },
  "80434": {
    DMA: 751,
  },
  "80435": {
    DMA: 751,
  },
  "80436": {
    DMA: 751,
  },
  "80437": {
    DMA: 751,
  },
  "80438": {
    DMA: 751,
  },
  "80439": {
    DMA: 751,
  },
  "80440": {
    DMA: 751,
  },
  "80442": {
    DMA: 751,
  },
  "80443": {
    DMA: 751,
  },
  "80444": {
    DMA: 751,
  },
  "80446": {
    DMA: 751,
  },
  "80447": {
    DMA: 751,
  },
  "80448": {
    DMA: 751,
  },
  "80449": {
    DMA: 751,
  },
  "80451": {
    DMA: 751,
  },
  "80452": {
    DMA: 751,
  },
  "80453": {
    DMA: 751,
  },
  "80454": {
    DMA: 751,
  },
  "80455": {
    DMA: 751,
  },
  "80456": {
    DMA: 751,
  },
  "80457": {
    DMA: 751,
  },
  "80459": {
    DMA: 751,
  },
  "80461": {
    DMA: 751,
  },
  "80463": {
    DMA: 751,
  },
  "80465": {
    DMA: 751,
  },
  "80466": {
    DMA: 751,
  },
  "80467": {
    DMA: 751,
  },
  "80468": {
    DMA: 751,
  },
  "80469": {
    DMA: 751,
  },
  "80470": {
    DMA: 751,
  },
  "80471": {
    DMA: 751,
  },
  "80473": {
    DMA: 751,
  },
  "80474": {
    DMA: 751,
  },
  "80475": {
    DMA: 751,
  },
  "80476": {
    DMA: 751,
  },
  "80477": {
    DMA: 751,
  },
  "80478": {
    DMA: 751,
  },
  "80479": {
    DMA: 751,
  },
  "80480": {
    DMA: 751,
  },
  "80481": {
    DMA: 751,
  },
  "80482": {
    DMA: 751,
  },
  "80483": {
    DMA: 751,
  },
  "80487": {
    DMA: 751,
  },
  "80488": {
    DMA: 751,
  },
  "80497": {
    DMA: 751,
  },
  "80498": {
    DMA: 751,
  },
  "80501": {
    DMA: 751,
  },
  "80502": {
    DMA: 751,
  },
  "80503": {
    DMA: 751,
  },
  "80504": {
    DMA: 751,
  },
  "80510": {
    DMA: 751,
  },
  "80511": {
    DMA: 751,
  },
  "80512": {
    DMA: 751,
  },
  "80513": {
    DMA: 751,
  },
  "80514": {
    DMA: 751,
  },
  "80515": {
    DMA: 751,
  },
  "80516": {
    DMA: 751,
  },
  "80517": {
    DMA: 751,
  },
  "80520": {
    DMA: 751,
  },
  "80521": {
    DMA: 751,
  },
  "80522": {
    DMA: 751,
  },
  "80523": {
    DMA: 751,
  },
  "80524": {
    DMA: 751,
  },
  "80525": {
    DMA: 751,
  },
  "80526": {
    DMA: 751,
  },
  "80527": {
    DMA: 751,
  },
  "80528": {
    DMA: 751,
  },
  "80530": {
    DMA: 751,
  },
  "80532": {
    DMA: 751,
  },
  "80533": {
    DMA: 751,
  },
  "80534": {
    DMA: 751,
  },
  "80535": {
    DMA: 751,
  },
  "80536": {
    DMA: 751,
  },
  "80537": {
    DMA: 751,
  },
  "80538": {
    DMA: 751,
  },
  "80539": {
    DMA: 751,
  },
  "80540": {
    DMA: 751,
  },
  "80541": {
    DMA: 751,
  },
  "80542": {
    DMA: 751,
  },
  "80543": {
    DMA: 751,
  },
  "80544": {
    DMA: 751,
  },
  "80545": {
    DMA: 751,
  },
  "80546": {
    DMA: 751,
  },
  "80547": {
    DMA: 751,
  },
  "80549": {
    DMA: 751,
  },
  "80550": {
    DMA: 751,
  },
  "80551": {
    DMA: 751,
  },
  "80553": {
    DMA: 751,
  },
  "80601": {
    DMA: 751,
  },
  "80602": {
    DMA: 751,
  },
  "80603": {
    DMA: 751,
  },
  "80610": {
    DMA: 751,
  },
  "80611": {
    DMA: 751,
  },
  "80612": {
    DMA: 751,
  },
  "80614": {
    DMA: 751,
  },
  "80615": {
    DMA: 751,
  },
  "80620": {
    DMA: 751,
  },
  "80621": {
    DMA: 751,
  },
  "80622": {
    DMA: 751,
  },
  "80623": {
    DMA: 751,
  },
  "80624": {
    DMA: 751,
  },
  "80631": {
    DMA: 751,
  },
  "80632": {
    DMA: 751,
  },
  "80633": {
    DMA: 751,
  },
  "80634": {
    DMA: 751,
  },
  "80638": {
    DMA: 751,
  },
  "80639": {
    DMA: 751,
  },
  "80640": {
    DMA: 751,
  },
  "80642": {
    DMA: 751,
  },
  "80643": {
    DMA: 751,
  },
  "80644": {
    DMA: 751,
  },
  "80645": {
    DMA: 751,
  },
  "80646": {
    DMA: 751,
  },
  "80648": {
    DMA: 751,
  },
  "80649": {
    DMA: 751,
  },
  "80650": {
    DMA: 751,
  },
  "80651": {
    DMA: 751,
  },
  "80652": {
    DMA: 751,
  },
  "80653": {
    DMA: 751,
  },
  "80654": {
    DMA: 751,
  },
  "80701": {
    DMA: 751,
  },
  "80705": {
    DMA: 751,
  },
  "80720": {
    DMA: 751,
  },
  "80721": {
    DMA: 751,
  },
  "80722": {
    DMA: 751,
  },
  "80723": {
    DMA: 751,
  },
  "80726": {
    DMA: 751,
  },
  "80727": {
    DMA: 751,
  },
  "80728": {
    DMA: 751,
  },
  "80729": {
    DMA: 751,
  },
  "80731": {
    DMA: 751,
  },
  "80732": {
    DMA: 751,
  },
  "80733": {
    DMA: 751,
  },
  "80734": {
    DMA: 751,
  },
  "80735": {
    DMA: 751,
  },
  "80736": {
    DMA: 751,
  },
  "80737": {
    DMA: 751,
  },
  "80740": {
    DMA: 751,
  },
  "80741": {
    DMA: 751,
  },
  "80742": {
    DMA: 751,
  },
  "80743": {
    DMA: 751,
  },
  "80744": {
    DMA: 751,
  },
  "80745": {
    DMA: 751,
  },
  "80746": {
    DMA: 751,
  },
  "80747": {
    DMA: 751,
  },
  "80749": {
    DMA: 751,
  },
  "80750": {
    DMA: 751,
  },
  "80751": {
    DMA: 751,
  },
  "80754": {
    DMA: 751,
  },
  "80755": {
    DMA: 751,
  },
  "80757": {
    DMA: 751,
  },
  "80758": {
    DMA: 751,
  },
  "80759": {
    DMA: 751,
  },
  "80801": {
    DMA: 751,
  },
  "80802": {
    DMA: 751,
  },
  "80804": {
    DMA: 751,
  },
  "80805": {
    DMA: 751,
  },
  "80807": {
    DMA: 751,
  },
  "80808": {
    DMA: 752,
  },
  "80809": {
    DMA: 752,
  },
  "80810": {
    DMA: 751,
  },
  "80812": {
    DMA: 751,
  },
  "80813": {
    DMA: 752,
  },
  "80814": {
    DMA: 752,
  },
  "80815": {
    DMA: 751,
  },
  "80816": {
    DMA: 752,
  },
  "80817": {
    DMA: 752,
  },
  "80818": {
    DMA: 751,
  },
  "80819": {
    DMA: 752,
  },
  "80820": {
    DMA: 751,
  },
  "80821": {
    DMA: 751,
  },
  "80822": {
    DMA: 751,
  },
  "80823": {
    DMA: 751,
  },
  "80824": {
    DMA: 751,
  },
  "80825": {
    DMA: 751,
  },
  "80826": {
    DMA: 751,
  },
  "80827": {
    DMA: 751,
  },
  "80828": {
    DMA: 751,
  },
  "80829": {
    DMA: 752,
  },
  "80830": {
    DMA: 751,
  },
  "80831": {
    DMA: 752,
  },
  "80832": {
    DMA: 752,
  },
  "80833": {
    DMA: 752,
  },
  "80834": {
    DMA: 751,
  },
  "80835": {
    DMA: 751,
  },
  "80836": {
    DMA: 751,
  },
  "80840": {
    DMA: 752,
  },
  "80841": {
    DMA: 752,
  },
  "80860": {
    DMA: 752,
  },
  "80861": {
    DMA: 751,
  },
  "80862": {
    DMA: 751,
  },
  "80863": {
    DMA: 752,
  },
  "80864": {
    DMA: 752,
  },
  "80866": {
    DMA: 752,
  },
  "80901": {
    DMA: 752,
  },
  "80902": {
    DMA: 752,
  },
  "80903": {
    DMA: 752,
  },
  "80904": {
    DMA: 752,
  },
  "80905": {
    DMA: 752,
  },
  "80906": {
    DMA: 752,
  },
  "80907": {
    DMA: 752,
  },
  "80908": {
    DMA: 752,
  },
  "80909": {
    DMA: 752,
  },
  "80910": {
    DMA: 752,
  },
  "80911": {
    DMA: 752,
  },
  "80912": {
    DMA: 752,
  },
  "80913": {
    DMA: 752,
  },
  "80914": {
    DMA: 752,
  },
  "80915": {
    DMA: 752,
  },
  "80916": {
    DMA: 752,
  },
  "80917": {
    DMA: 752,
  },
  "80918": {
    DMA: 752,
  },
  "80919": {
    DMA: 752,
  },
  "80920": {
    DMA: 752,
  },
  "80921": {
    DMA: 752,
  },
  "80922": {
    DMA: 752,
  },
  "80923": {
    DMA: 752,
  },
  "80924": {
    DMA: 752,
  },
  "80925": {
    DMA: 752,
  },
  "80926": {
    DMA: 752,
  },
  "80927": {
    DMA: 752,
  },
  "80928": {
    DMA: 752,
  },
  "80929": {
    DMA: 752,
  },
  "80930": {
    DMA: 752,
  },
  "80931": {
    DMA: 752,
  },
  "80932": {
    DMA: 752,
  },
  "80933": {
    DMA: 752,
  },
  "80934": {
    DMA: 752,
  },
  "80935": {
    DMA: 752,
  },
  "80936": {
    DMA: 752,
  },
  "80937": {
    DMA: 752,
  },
  "80938": {
    DMA: 752,
  },
  "80939": {
    DMA: 752,
  },
  "80940": {
    DMA: 752,
  },
  "80941": {
    DMA: 752,
  },
  "80942": {
    DMA: 752,
  },
  "80943": {
    DMA: 752,
  },
  "80944": {
    DMA: 752,
  },
  "80945": {
    DMA: 752,
  },
  "80946": {
    DMA: 752,
  },
  "80947": {
    DMA: 752,
  },
  "80949": {
    DMA: 752,
  },
  "80950": {
    DMA: 752,
  },
  "80951": {
    DMA: 752,
  },
  "80960": {
    DMA: 752,
  },
  "80962": {
    DMA: 752,
  },
  "80970": {
    DMA: 752,
  },
  "80977": {
    DMA: 752,
  },
  "80995": {
    DMA: 752,
  },
  "80997": {
    DMA: 752,
  },
  "81001": {
    DMA: 752,
  },
  "81002": {
    DMA: 752,
  },
  "81003": {
    DMA: 752,
  },
  "81004": {
    DMA: 752,
  },
  "81005": {
    DMA: 752,
  },
  "81006": {
    DMA: 752,
  },
  "81007": {
    DMA: 752,
  },
  "81008": {
    DMA: 752,
  },
  "81009": {
    DMA: 752,
  },
  "81010": {
    DMA: 752,
  },
  "81011": {
    DMA: 752,
  },
  "81012": {
    DMA: 752,
  },
  "81019": {
    DMA: 752,
  },
  "81020": {
    DMA: 752,
  },
  "81021": {
    DMA: 752,
  },
  "81022": {
    DMA: 752,
  },
  "81023": {
    DMA: 752,
  },
  "81024": {
    DMA: 752,
  },
  "81025": {
    DMA: 752,
  },
  "81027": {
    DMA: 752,
  },
  "81029": {
    DMA: 752,
  },
  "81030": {
    DMA: 752,
  },
  "81033": {
    DMA: 752,
  },
  "81034": {
    DMA: 752,
  },
  "81036": {
    DMA: 752,
  },
  "81038": {
    DMA: 752,
  },
  "81039": {
    DMA: 752,
  },
  "81040": {
    DMA: 752,
  },
  "81041": {
    DMA: 751,
  },
  "81043": {
    DMA: 751,
  },
  "81044": {
    DMA: 752,
  },
  "81045": {
    DMA: 752,
  },
  "81046": {
    DMA: 752,
  },
  "81047": {
    DMA: 751,
  },
  "81049": {
    DMA: 752,
  },
  "81050": {
    DMA: 752,
  },
  "81052": {
    DMA: 751,
  },
  "81054": {
    DMA: 752,
  },
  "81055": {
    DMA: 752,
  },
  "81057": {
    DMA: 752,
  },
  "81058": {
    DMA: 752,
  },
  "81059": {
    DMA: 752,
  },
  "81062": {
    DMA: 752,
  },
  "81063": {
    DMA: 752,
  },
  "81064": {
    DMA: 752,
  },
  "81067": {
    DMA: 752,
  },
  "81069": {
    DMA: 752,
  },
  "81071": {
    DMA: 752,
  },
  "81073": {
    DMA: 752,
  },
  "81075": {
    DMA: 751,
  },
  "81076": {
    DMA: 752,
  },
  "81077": {
    DMA: 752,
  },
  "81081": {
    DMA: 752,
  },
  "81082": {
    DMA: 752,
  },
  "81084": {
    DMA: 752,
  },
  "81087": {
    DMA: 752,
  },
  "81089": {
    DMA: 752,
  },
  "81090": {
    DMA: 752,
  },
  "81091": {
    DMA: 752,
  },
  "81092": {
    DMA: 751,
  },
  "81101": {
    DMA: 751,
  },
  "81102": {
    DMA: 751,
  },
  "81120": {
    DMA: 751,
  },
  "81121": {
    DMA: 751,
  },
  "81122": {
    DMA: 790,
  },
  "81123": {
    DMA: 751,
  },
  "81124": {
    DMA: 751,
  },
  "81125": {
    DMA: 751,
  },
  "81126": {
    DMA: 751,
  },
  "81127": {
    DMA: 751,
  },
  "81128": {
    DMA: 751,
  },
  "81129": {
    DMA: 751,
  },
  "81130": {
    DMA: 751,
  },
  "81131": {
    DMA: 751,
  },
  "81132": {
    DMA: 751,
  },
  "81133": {
    DMA: 751,
  },
  "81134": {
    DMA: 751,
  },
  "81135": {
    DMA: 751,
  },
  "81136": {
    DMA: 751,
  },
  "81137": {
    DMA: 790,
  },
  "81138": {
    DMA: 751,
  },
  "81140": {
    DMA: 751,
  },
  "81141": {
    DMA: 751,
  },
  "81143": {
    DMA: 751,
  },
  "81144": {
    DMA: 751,
  },
  "81146": {
    DMA: 751,
  },
  "81147": {
    DMA: 751,
  },
  "81148": {
    DMA: 751,
  },
  "81149": {
    DMA: 751,
  },
  "81151": {
    DMA: 751,
  },
  "81152": {
    DMA: 751,
  },
  "81153": {
    DMA: 751,
  },
  "81154": {
    DMA: 751,
  },
  "81155": {
    DMA: 751,
  },
  "81157": {
    DMA: 751,
  },
  "81201": {
    DMA: 751,
  },
  "81210": {
    DMA: 751,
  },
  "81211": {
    DMA: 751,
  },
  "81212": {
    DMA: 752,
  },
  "81215": {
    DMA: 752,
  },
  "81220": {
    DMA: 773,
  },
  "81221": {
    DMA: 752,
  },
  "81222": {
    DMA: 752,
  },
  "81223": {
    DMA: 752,
  },
  "81224": {
    DMA: 751,
  },
  "81225": {
    DMA: 751,
  },
  "81226": {
    DMA: 752,
  },
  "81227": {
    DMA: 751,
  },
  "81228": {
    DMA: 751,
  },
  "81230": {
    DMA: 751,
  },
  "81231": {
    DMA: 751,
  },
  "81232": {
    DMA: 752,
  },
  "81233": {
    DMA: 752,
  },
  "81235": {
    DMA: 751,
  },
  "81236": {
    DMA: 751,
  },
  "81237": {
    DMA: 751,
  },
  "81239": {
    DMA: 751,
  },
  "81240": {
    DMA: 752,
  },
  "81241": {
    DMA: 751,
  },
  "81242": {
    DMA: 751,
  },
  "81243": {
    DMA: 751,
  },
  "81244": {
    DMA: 752,
  },
  "81247": {
    DMA: 751,
  },
  "81248": {
    DMA: 751,
  },
  "81251": {
    DMA: 751,
  },
  "81252": {
    DMA: 752,
  },
  "81253": {
    DMA: 752,
  },
  "81290": {
    DMA: 752,
  },
  "81301": {
    DMA: 790,
  },
  "81302": {
    DMA: 790,
  },
  "81303": {
    DMA: 790,
  },
  "81320": {
    DMA: 751,
  },
  "81321": {
    DMA: 790,
  },
  "81323": {
    DMA: 790,
  },
  "81324": {
    DMA: 751,
  },
  "81325": {
    DMA: 751,
  },
  "81326": {
    DMA: 790,
  },
  "81327": {
    DMA: 790,
  },
  "81328": {
    DMA: 790,
  },
  "81329": {
    DMA: 790,
  },
  "81330": {
    DMA: 790,
  },
  "81331": {
    DMA: 790,
  },
  "81332": {
    DMA: 751,
  },
  "81334": {
    DMA: 790,
  },
  "81335": {
    DMA: 790,
  },
  "81401": {
    DMA: 773,
  },
  "81402": {
    DMA: 773,
  },
  "81403": {
    DMA: 773,
  },
  "81410": {
    DMA: 751,
  },
  "81411": {
    DMA: 773,
  },
  "81413": {
    DMA: 751,
  },
  "81414": {
    DMA: 751,
  },
  "81415": {
    DMA: 751,
  },
  "81416": {
    DMA: 751,
  },
  "81418": {
    DMA: 751,
  },
  "81419": {
    DMA: 751,
  },
  "81420": {
    DMA: 751,
  },
  "81422": {
    DMA: 773,
  },
  "81423": {
    DMA: 751,
  },
  "81424": {
    DMA: 773,
  },
  "81425": {
    DMA: 773,
  },
  "81426": {
    DMA: 751,
  },
  "81427": {
    DMA: 751,
  },
  "81428": {
    DMA: 751,
  },
  "81429": {
    DMA: 773,
  },
  "81430": {
    DMA: 751,
  },
  "81431": {
    DMA: 773,
  },
  "81432": {
    DMA: 751,
  },
  "81433": {
    DMA: 751,
  },
  "81434": {
    DMA: 751,
  },
  "81435": {
    DMA: 751,
  },
  "81501": {
    DMA: 773,
  },
  "81502": {
    DMA: 773,
  },
  "81503": {
    DMA: 773,
  },
  "81504": {
    DMA: 773,
  },
  "81505": {
    DMA: 773,
  },
  "81506": {
    DMA: 773,
  },
  "81507": {
    DMA: 773,
  },
  "81520": {
    DMA: 773,
  },
  "81521": {
    DMA: 773,
  },
  "81522": {
    DMA: 773,
  },
  "81523": {
    DMA: 773,
  },
  "81524": {
    DMA: 773,
  },
  "81525": {
    DMA: 773,
  },
  "81526": {
    DMA: 773,
  },
  "81527": {
    DMA: 773,
  },
  "81601": {
    DMA: 751,
  },
  "81602": {
    DMA: 751,
  },
  "81610": {
    DMA: 751,
  },
  "81611": {
    DMA: 751,
  },
  "81612": {
    DMA: 751,
  },
  "81615": {
    DMA: 751,
  },
  "81620": {
    DMA: 751,
  },
  "81621": {
    DMA: 751,
  },
  "81623": {
    DMA: 751,
  },
  "81624": {
    DMA: 773,
  },
  "81625": {
    DMA: 751,
  },
  "81626": {
    DMA: 751,
  },
  "81630": {
    DMA: 773,
  },
  "81631": {
    DMA: 751,
  },
  "81632": {
    DMA: 751,
  },
  "81633": {
    DMA: 751,
  },
  "81635": {
    DMA: 751,
  },
  "81636": {
    DMA: 751,
  },
  "81637": {
    DMA: 751,
  },
  "81638": {
    DMA: 751,
  },
  "81639": {
    DMA: 751,
  },
  "81640": {
    DMA: 751,
  },
  "81641": {
    DMA: 751,
  },
  "81642": {
    DMA: 751,
  },
  "81643": {
    DMA: 773,
  },
  "81645": {
    DMA: 751,
  },
  "81646": {
    DMA: 773,
  },
  "81647": {
    DMA: 751,
  },
  "81648": {
    DMA: 751,
  },
  "81649": {
    DMA: 751,
  },
  "81650": {
    DMA: 751,
  },
  "81652": {
    DMA: 751,
  },
  "81653": {
    DMA: 751,
  },
  "81654": {
    DMA: 751,
  },
  "81655": {
    DMA: 751,
  },
  "81656": {
    DMA: 751,
  },
  "81657": {
    DMA: 751,
  },
  "81658": {
    DMA: 751,
  },
  "82001": {
    DMA: 759,
  },
  "82002": {
    DMA: 759,
  },
  "82003": {
    DMA: 759,
  },
  "82005": {
    DMA: 759,
  },
  "82006": {
    DMA: 759,
  },
  "82007": {
    DMA: 759,
  },
  "82008": {
    DMA: 759,
  },
  "82009": {
    DMA: 759,
  },
  "82010": {
    DMA: 759,
  },
  "82050": {
    DMA: 759,
  },
  "82051": {
    DMA: 751,
  },
  "82052": {
    DMA: 751,
  },
  "82053": {
    DMA: 759,
  },
  "82054": {
    DMA: 759,
  },
  "82055": {
    DMA: 751,
  },
  "82058": {
    DMA: 751,
  },
  "82059": {
    DMA: 759,
  },
  "82060": {
    DMA: 759,
  },
  "82061": {
    DMA: 759,
  },
  "82063": {
    DMA: 751,
  },
  "82070": {
    DMA: 751,
  },
  "82071": {
    DMA: 751,
  },
  "82072": {
    DMA: 751,
  },
  "82073": {
    DMA: 751,
  },
  "82081": {
    DMA: 759,
  },
  "82082": {
    DMA: 759,
  },
  "82083": {
    DMA: 751,
  },
  "82084": {
    DMA: 751,
  },
  "82190": {
    DMA: 756,
  },
  "82201": {
    DMA: 751,
  },
  "82210": {
    DMA: 751,
  },
  "82212": {
    DMA: 759,
  },
  "82213": {
    DMA: 751,
  },
  "82214": {
    DMA: 751,
  },
  "82215": {
    DMA: 751,
  },
  "82217": {
    DMA: 759,
  },
  "82218": {
    DMA: 759,
  },
  "82219": {
    DMA: 759,
  },
  "82221": {
    DMA: 759,
  },
  "82222": {
    DMA: 751,
  },
  "82223": {
    DMA: 759,
  },
  "82224": {
    DMA: 767,
  },
  "82225": {
    DMA: 751,
  },
  "82227": {
    DMA: 751,
  },
  "82229": {
    DMA: 767,
  },
  "82240": {
    DMA: 759,
  },
  "82242": {
    DMA: 751,
  },
  "82243": {
    DMA: 759,
  },
  "82244": {
    DMA: 759,
  },
  "82301": {
    DMA: 751,
  },
  "82310": {
    DMA: 767,
  },
  "82321": {
    DMA: 751,
  },
  "82322": {
    DMA: 770,
  },
  "82323": {
    DMA: 751,
  },
  "82324": {
    DMA: 751,
  },
  "82325": {
    DMA: 751,
  },
  "82327": {
    DMA: 751,
  },
  "82329": {
    DMA: 751,
  },
  "82331": {
    DMA: 751,
  },
  "82332": {
    DMA: 751,
  },
  "82334": {
    DMA: 751,
  },
  "82335": {
    DMA: 751,
  },
  "82336": {
    DMA: 770,
  },
  "82401": {
    DMA: 767,
  },
  "82410": {
    DMA: 756,
  },
  "82411": {
    DMA: 756,
  },
  "82412": {
    DMA: 756,
  },
  "82414": {
    DMA: 756,
  },
  "82420": {
    DMA: 756,
  },
  "82421": {
    DMA: 756,
  },
  "82422": {
    DMA: 756,
  },
  "82423": {
    DMA: 756,
  },
  "82426": {
    DMA: 756,
  },
  "82428": {
    DMA: 756,
  },
  "82430": {
    DMA: 767,
  },
  "82431": {
    DMA: 756,
  },
  "82432": {
    DMA: 756,
  },
  "82433": {
    DMA: 756,
  },
  "82434": {
    DMA: 756,
  },
  "82435": {
    DMA: 756,
  },
  "82440": {
    DMA: 756,
  },
  "82441": {
    DMA: 756,
  },
  "82442": {
    DMA: 767,
  },
  "82443": {
    DMA: 767,
  },
  "82450": {
    DMA: 756,
  },
  "82501": {
    DMA: 767,
  },
  "82510": {
    DMA: 767,
  },
  "82512": {
    DMA: 767,
  },
  "82513": {
    DMA: 767,
  },
  "82514": {
    DMA: 767,
  },
  "82515": {
    DMA: 767,
  },
  "82516": {
    DMA: 767,
  },
  "82520": {
    DMA: 767,
  },
  "82523": {
    DMA: 767,
  },
  "82524": {
    DMA: 767,
  },
  "82601": {
    DMA: 767,
  },
  "82602": {
    DMA: 767,
  },
  "82604": {
    DMA: 767,
  },
  "82605": {
    DMA: 767,
  },
  "82609": {
    DMA: 767,
  },
  "82615": {
    DMA: 751,
  },
  "82620": {
    DMA: 767,
  },
  "82630": {
    DMA: 767,
  },
  "82633": {
    DMA: 767,
  },
  "82635": {
    DMA: 767,
  },
  "82636": {
    DMA: 767,
  },
  "82637": {
    DMA: 767,
  },
  "82638": {
    DMA: 767,
  },
  "82639": {
    DMA: 751,
  },
  "82640": {
    DMA: 751,
  },
  "82642": {
    DMA: 767,
  },
  "82643": {
    DMA: 767,
  },
  "82644": {
    DMA: 767,
  },
  "82646": {
    DMA: 767,
  },
  "82648": {
    DMA: 767,
  },
  "82649": {
    DMA: 767,
  },
  "82701": {
    DMA: 764,
  },
  "82710": {
    DMA: 764,
  },
  "82711": {
    DMA: 764,
  },
  "82712": {
    DMA: 764,
  },
  "82714": {
    DMA: 764,
  },
  "82715": {
    DMA: 764,
  },
  "82716": {
    DMA: 751,
  },
  "82717": {
    DMA: 751,
  },
  "82718": {
    DMA: 751,
  },
  "82720": {
    DMA: 764,
  },
  "82721": {
    DMA: 764,
  },
  "82723": {
    DMA: 764,
  },
  "82725": {
    DMA: 751,
  },
  "82727": {
    DMA: 751,
  },
  "82729": {
    DMA: 764,
  },
  "82730": {
    DMA: 764,
  },
  "82731": {
    DMA: 751,
  },
  "82732": {
    DMA: 751,
  },
  "82801": {
    DMA: 764,
  },
  "82831": {
    DMA: 764,
  },
  "82832": {
    DMA: 764,
  },
  "82833": {
    DMA: 764,
  },
  "82834": {
    DMA: 751,
  },
  "82835": {
    DMA: 764,
  },
  "82836": {
    DMA: 764,
  },
  "82837": {
    DMA: 764,
  },
  "82838": {
    DMA: 764,
  },
  "82839": {
    DMA: 764,
  },
  "82840": {
    DMA: 751,
  },
  "82842": {
    DMA: 764,
  },
  "82844": {
    DMA: 764,
  },
  "82845": {
    DMA: 764,
  },
  "82901": {
    DMA: 770,
  },
  "82902": {
    DMA: 770,
  },
  "82922": {
    DMA: 770,
  },
  "82923": {
    DMA: 770,
  },
  "82925": {
    DMA: 770,
  },
  "82929": {
    DMA: 770,
  },
  "82930": {
    DMA: 770,
  },
  "82931": {
    DMA: 770,
  },
  "82932": {
    DMA: 770,
  },
  "82933": {
    DMA: 770,
  },
  "82934": {
    DMA: 770,
  },
  "82935": {
    DMA: 770,
  },
  "82936": {
    DMA: 770,
  },
  "82937": {
    DMA: 770,
  },
  "82938": {
    DMA: 770,
  },
  "82939": {
    DMA: 770,
  },
  "82941": {
    DMA: 770,
  },
  "82942": {
    DMA: 770,
  },
  "82943": {
    DMA: 770,
  },
  "82944": {
    DMA: 770,
  },
  "82945": {
    DMA: 770,
  },
  "83001": {
    DMA: 758,
  },
  "83002": {
    DMA: 758,
  },
  "83011": {
    DMA: 758,
  },
  "83012": {
    DMA: 758,
  },
  "83013": {
    DMA: 758,
  },
  "83014": {
    DMA: 758,
  },
  "83025": {
    DMA: 758,
  },
  "83101": {
    DMA: 770,
  },
  "83110": {
    DMA: 770,
  },
  "83111": {
    DMA: 770,
  },
  "83112": {
    DMA: 770,
  },
  "83113": {
    DMA: 770,
  },
  "83114": {
    DMA: 770,
  },
  "83115": {
    DMA: 770,
  },
  "83116": {
    DMA: 770,
  },
  "83118": {
    DMA: 770,
  },
  "83119": {
    DMA: 770,
  },
  "83120": {
    DMA: 770,
  },
  "83121": {
    DMA: 770,
  },
  "83122": {
    DMA: 770,
  },
  "83123": {
    DMA: 770,
  },
  "83124": {
    DMA: 770,
  },
  "83126": {
    DMA: 770,
  },
  "83127": {
    DMA: 770,
  },
  "83128": {
    DMA: 770,
  },
  "83201": {
    DMA: 758,
  },
  "83202": {
    DMA: 758,
  },
  "83203": {
    DMA: 758,
  },
  "83204": {
    DMA: 758,
  },
  "83205": {
    DMA: 758,
  },
  "83206": {
    DMA: 758,
  },
  "83209": {
    DMA: 758,
  },
  "83210": {
    DMA: 758,
  },
  "83211": {
    DMA: 758,
  },
  "83212": {
    DMA: 758,
  },
  "83213": {
    DMA: 758,
  },
  "83214": {
    DMA: 758,
  },
  "83215": {
    DMA: 758,
  },
  "83217": {
    DMA: 758,
  },
  "83218": {
    DMA: 758,
  },
  "83220": {
    DMA: 770,
  },
  "83221": {
    DMA: 758,
  },
  "83223": {
    DMA: 770,
  },
  "83226": {
    DMA: 758,
  },
  "83227": {
    DMA: 758,
  },
  "83228": {
    DMA: 770,
  },
  "83229": {
    DMA: 758,
  },
  "83230": {
    DMA: 758,
  },
  "83232": {
    DMA: 770,
  },
  "83233": {
    DMA: 770,
  },
  "83234": {
    DMA: 758,
  },
  "83235": {
    DMA: 758,
  },
  "83236": {
    DMA: 758,
  },
  "83237": {
    DMA: 770,
  },
  "83238": {
    DMA: 770,
  },
  "83239": {
    DMA: 770,
  },
  "83241": {
    DMA: 758,
  },
  "83243": {
    DMA: 770,
  },
  "83244": {
    DMA: 758,
  },
  "83245": {
    DMA: 758,
  },
  "83246": {
    DMA: 758,
  },
  "83250": {
    DMA: 758,
  },
  "83251": {
    DMA: 758,
  },
  "83252": {
    DMA: 770,
  },
  "83253": {
    DMA: 758,
  },
  "83254": {
    DMA: 770,
  },
  "83255": {
    DMA: 758,
  },
  "83256": {
    DMA: 758,
  },
  "83261": {
    DMA: 770,
  },
  "83262": {
    DMA: 758,
  },
  "83263": {
    DMA: 770,
  },
  "83271": {
    DMA: 758,
  },
  "83272": {
    DMA: 770,
  },
  "83274": {
    DMA: 758,
  },
  "83276": {
    DMA: 758,
  },
  "83277": {
    DMA: 758,
  },
  "83278": {
    DMA: 758,
  },
  "83281": {
    DMA: 758,
  },
  "83283": {
    DMA: 770,
  },
  "83285": {
    DMA: 758,
  },
  "83286": {
    DMA: 770,
  },
  "83287": {
    DMA: 770,
  },
  "83301": {
    DMA: 760,
  },
  "83302": {
    DMA: 760,
  },
  "83303": {
    DMA: 760,
  },
  "83311": {
    DMA: 760,
  },
  "83312": {
    DMA: 760,
  },
  "83313": {
    DMA: 760,
  },
  "83314": {
    DMA: 760,
  },
  "83316": {
    DMA: 760,
  },
  "83318": {
    DMA: 760,
  },
  "83320": {
    DMA: 760,
  },
  "83321": {
    DMA: 760,
  },
  "83322": {
    DMA: 757,
  },
  "83323": {
    DMA: 760,
  },
  "83324": {
    DMA: 760,
  },
  "83325": {
    DMA: 760,
  },
  "83327": {
    DMA: 757,
  },
  "83328": {
    DMA: 760,
  },
  "83330": {
    DMA: 760,
  },
  "83332": {
    DMA: 760,
  },
  "83333": {
    DMA: 760,
  },
  "83334": {
    DMA: 760,
  },
  "83335": {
    DMA: 760,
  },
  "83336": {
    DMA: 760,
  },
  "83337": {
    DMA: 757,
  },
  "83338": {
    DMA: 760,
  },
  "83340": {
    DMA: 760,
  },
  "83341": {
    DMA: 760,
  },
  "83342": {
    DMA: 760,
  },
  "83343": {
    DMA: 760,
  },
  "83344": {
    DMA: 760,
  },
  "83346": {
    DMA: 760,
  },
  "83347": {
    DMA: 760,
  },
  "83348": {
    DMA: 760,
  },
  "83349": {
    DMA: 760,
  },
  "83350": {
    DMA: 760,
  },
  "83352": {
    DMA: 760,
  },
  "83353": {
    DMA: 760,
  },
  "83354": {
    DMA: 760,
  },
  "83355": {
    DMA: 760,
  },
  "83401": {
    DMA: 758,
  },
  "83402": {
    DMA: 758,
  },
  "83403": {
    DMA: 758,
  },
  "83404": {
    DMA: 758,
  },
  "83405": {
    DMA: 758,
  },
  "83406": {
    DMA: 758,
  },
  "83414": {
    DMA: 758,
  },
  "83415": {
    DMA: 758,
  },
  "83420": {
    DMA: 758,
  },
  "83421": {
    DMA: 758,
  },
  "83422": {
    DMA: 758,
  },
  "83423": {
    DMA: 758,
  },
  "83424": {
    DMA: 758,
  },
  "83425": {
    DMA: 758,
  },
  "83427": {
    DMA: 758,
  },
  "83428": {
    DMA: 758,
  },
  "83429": {
    DMA: 758,
  },
  "83431": {
    DMA: 758,
  },
  "83433": {
    DMA: 758,
  },
  "83434": {
    DMA: 758,
  },
  "83435": {
    DMA: 758,
  },
  "83436": {
    DMA: 758,
  },
  "83438": {
    DMA: 758,
  },
  "83440": {
    DMA: 758,
  },
  "83441": {
    DMA: 758,
  },
  "83442": {
    DMA: 758,
  },
  "83443": {
    DMA: 758,
  },
  "83444": {
    DMA: 758,
  },
  "83445": {
    DMA: 758,
  },
  "83446": {
    DMA: 758,
  },
  "83448": {
    DMA: 758,
  },
  "83449": {
    DMA: 758,
  },
  "83450": {
    DMA: 758,
  },
  "83451": {
    DMA: 758,
  },
  "83452": {
    DMA: 758,
  },
  "83454": {
    DMA: 758,
  },
  "83455": {
    DMA: 758,
  },
  "83460": {
    DMA: 758,
  },
  "83462": {
    DMA: 758,
  },
  "83463": {
    DMA: 758,
  },
  "83464": {
    DMA: 758,
  },
  "83465": {
    DMA: 758,
  },
  "83466": {
    DMA: 758,
  },
  "83467": {
    DMA: 758,
  },
  "83468": {
    DMA: 758,
  },
  "83469": {
    DMA: 758,
  },
  "83501": {
    DMA: 881,
  },
  "83520": {
    DMA: 881,
  },
  "83522": {
    DMA: 881,
  },
  "83523": {
    DMA: 881,
  },
  "83524": {
    DMA: 881,
  },
  "83525": {
    DMA: 881,
  },
  "83526": {
    DMA: 881,
  },
  "83530": {
    DMA: 881,
  },
  "83531": {
    DMA: 881,
  },
  "83533": {
    DMA: 881,
  },
  "83535": {
    DMA: 881,
  },
  "83536": {
    DMA: 881,
  },
  "83537": {
    DMA: 881,
  },
  "83539": {
    DMA: 881,
  },
  "83540": {
    DMA: 881,
  },
  "83541": {
    DMA: 881,
  },
  "83542": {
    DMA: 881,
  },
  "83543": {
    DMA: 881,
  },
  "83544": {
    DMA: 881,
  },
  "83545": {
    DMA: 881,
  },
  "83546": {
    DMA: 881,
  },
  "83547": {
    DMA: 881,
  },
  "83548": {
    DMA: 881,
  },
  "83549": {
    DMA: 881,
  },
  "83552": {
    DMA: 881,
  },
  "83553": {
    DMA: 881,
  },
  "83554": {
    DMA: 881,
  },
  "83555": {
    DMA: 881,
  },
  "83601": {
    DMA: 757,
  },
  "83602": {
    DMA: 757,
  },
  "83604": {
    DMA: 757,
  },
  "83605": {
    DMA: 757,
  },
  "83606": {
    DMA: 757,
  },
  "83607": {
    DMA: 757,
  },
  "83610": {
    DMA: 757,
  },
  "83611": {
    DMA: 757,
  },
  "83612": {
    DMA: 757,
  },
  "83615": {
    DMA: 757,
  },
  "83616": {
    DMA: 757,
  },
  "83617": {
    DMA: 757,
  },
  "83619": {
    DMA: 757,
  },
  "83622": {
    DMA: 757,
  },
  "83623": {
    DMA: 757,
  },
  "83624": {
    DMA: 757,
  },
  "83626": {
    DMA: 757,
  },
  "83627": {
    DMA: 757,
  },
  "83628": {
    DMA: 757,
  },
  "83629": {
    DMA: 757,
  },
  "83630": {
    DMA: 757,
  },
  "83631": {
    DMA: 757,
  },
  "83632": {
    DMA: 757,
  },
  "83633": {
    DMA: 757,
  },
  "83634": {
    DMA: 757,
  },
  "83635": {
    DMA: 757,
  },
  "83636": {
    DMA: 757,
  },
  "83637": {
    DMA: 757,
  },
  "83638": {
    DMA: 757,
  },
  "83639": {
    DMA: 757,
  },
  "83641": {
    DMA: 757,
  },
  "83642": {
    DMA: 757,
  },
  "83643": {
    DMA: 757,
  },
  "83644": {
    DMA: 757,
  },
  "83645": {
    DMA: 757,
  },
  "83646": {
    DMA: 757,
  },
  "83647": {
    DMA: 757,
  },
  "83648": {
    DMA: 757,
  },
  "83650": {
    DMA: 757,
  },
  "83651": {
    DMA: 757,
  },
  "83652": {
    DMA: 757,
  },
  "83653": {
    DMA: 757,
  },
  "83654": {
    DMA: 757,
  },
  "83655": {
    DMA: 757,
  },
  "83656": {
    DMA: 757,
  },
  "83657": {
    DMA: 757,
  },
  "83660": {
    DMA: 757,
  },
  "83661": {
    DMA: 757,
  },
  "83666": {
    DMA: 757,
  },
  "83669": {
    DMA: 757,
  },
  "83670": {
    DMA: 757,
  },
  "83671": {
    DMA: 881,
  },
  "83672": {
    DMA: 757,
  },
  "83676": {
    DMA: 757,
  },
  "83677": {
    DMA: 757,
  },
  "83680": {
    DMA: 757,
  },
  "83686": {
    DMA: 757,
  },
  "83687": {
    DMA: 757,
  },
  "83701": {
    DMA: 757,
  },
  "83702": {
    DMA: 757,
  },
  "83703": {
    DMA: 757,
  },
  "83704": {
    DMA: 757,
  },
  "83705": {
    DMA: 757,
  },
  "83706": {
    DMA: 757,
  },
  "83707": {
    DMA: 757,
  },
  "83708": {
    DMA: 757,
  },
  "83709": {
    DMA: 757,
  },
  "83711": {
    DMA: 757,
  },
  "83712": {
    DMA: 757,
  },
  "83713": {
    DMA: 757,
  },
  "83714": {
    DMA: 757,
  },
  "83715": {
    DMA: 757,
  },
  "83716": {
    DMA: 757,
  },
  "83717": {
    DMA: 757,
  },
  "83719": {
    DMA: 757,
  },
  "83720": {
    DMA: 757,
  },
  "83721": {
    DMA: 757,
  },
  "83722": {
    DMA: 757,
  },
  "83724": {
    DMA: 757,
  },
  "83725": {
    DMA: 757,
  },
  "83726": {
    DMA: 757,
  },
  "83727": {
    DMA: 757,
  },
  "83728": {
    DMA: 757,
  },
  "83729": {
    DMA: 757,
  },
  "83730": {
    DMA: 757,
  },
  "83731": {
    DMA: 757,
  },
  "83732": {
    DMA: 757,
  },
  "83733": {
    DMA: 757,
  },
  "83735": {
    DMA: 757,
  },
  "83756": {
    DMA: 757,
  },
  "83757": {
    DMA: 757,
  },
  "83799": {
    DMA: 757,
  },
  "83801": {
    DMA: 881,
  },
  "83802": {
    DMA: 881,
  },
  "83803": {
    DMA: 881,
  },
  "83804": {
    DMA: 881,
  },
  "83805": {
    DMA: 881,
  },
  "83806": {
    DMA: 881,
  },
  "83808": {
    DMA: 881,
  },
  "83809": {
    DMA: 881,
  },
  "83810": {
    DMA: 881,
  },
  "83811": {
    DMA: 881,
  },
  "83812": {
    DMA: 881,
  },
  "83813": {
    DMA: 881,
  },
  "83814": {
    DMA: 881,
  },
  "83815": {
    DMA: 881,
  },
  "83816": {
    DMA: 881,
  },
  "83821": {
    DMA: 881,
  },
  "83822": {
    DMA: 881,
  },
  "83823": {
    DMA: 881,
  },
  "83824": {
    DMA: 881,
  },
  "83825": {
    DMA: 881,
  },
  "83826": {
    DMA: 881,
  },
  "83827": {
    DMA: 881,
  },
  "83830": {
    DMA: 881,
  },
  "83832": {
    DMA: 881,
  },
  "83833": {
    DMA: 881,
  },
  "83834": {
    DMA: 881,
  },
  "83835": {
    DMA: 881,
  },
  "83836": {
    DMA: 881,
  },
  "83837": {
    DMA: 881,
  },
  "83839": {
    DMA: 881,
  },
  "83840": {
    DMA: 881,
  },
  "83841": {
    DMA: 881,
  },
  "83842": {
    DMA: 881,
  },
  "83843": {
    DMA: 881,
  },
  "83844": {
    DMA: 881,
  },
  "83845": {
    DMA: 881,
  },
  "83846": {
    DMA: 881,
  },
  "83847": {
    DMA: 881,
  },
  "83848": {
    DMA: 881,
  },
  "83849": {
    DMA: 881,
  },
  "83850": {
    DMA: 881,
  },
  "83851": {
    DMA: 881,
  },
  "83852": {
    DMA: 881,
  },
  "83853": {
    DMA: 881,
  },
  "83854": {
    DMA: 881,
  },
  "83855": {
    DMA: 881,
  },
  "83856": {
    DMA: 881,
  },
  "83857": {
    DMA: 881,
  },
  "83858": {
    DMA: 881,
  },
  "83860": {
    DMA: 881,
  },
  "83861": {
    DMA: 881,
  },
  "83864": {
    DMA: 881,
  },
  "83865": {
    DMA: 881,
  },
  "83866": {
    DMA: 881,
  },
  "83867": {
    DMA: 881,
  },
  "83868": {
    DMA: 881,
  },
  "83869": {
    DMA: 881,
  },
  "83870": {
    DMA: 881,
  },
  "83871": {
    DMA: 881,
  },
  "83872": {
    DMA: 881,
  },
  "83873": {
    DMA: 881,
  },
  "83874": {
    DMA: 881,
  },
  "83876": {
    DMA: 881,
  },
  "83877": {
    DMA: 881,
  },
  "84001": {
    DMA: 770,
  },
  "84002": {
    DMA: 770,
  },
  "84003": {
    DMA: 770,
  },
  "84004": {
    DMA: 770,
  },
  "84005": {
    DMA: 770,
  },
  "84006": {
    DMA: 770,
  },
  "84007": {
    DMA: 770,
  },
  "84008": {
    DMA: 770,
  },
  "84009": {
    DMA: 770,
  },
  "84010": {
    DMA: 770,
  },
  "84011": {
    DMA: 770,
  },
  "84013": {
    DMA: 770,
  },
  "84014": {
    DMA: 770,
  },
  "84015": {
    DMA: 770,
  },
  "84016": {
    DMA: 770,
  },
  "84017": {
    DMA: 770,
  },
  "84018": {
    DMA: 770,
  },
  "84020": {
    DMA: 770,
  },
  "84021": {
    DMA: 770,
  },
  "84022": {
    DMA: 770,
  },
  "84023": {
    DMA: 770,
  },
  "84024": {
    DMA: 770,
  },
  "84025": {
    DMA: 770,
  },
  "84026": {
    DMA: 770,
  },
  "84027": {
    DMA: 770,
  },
  "84028": {
    DMA: 770,
  },
  "84029": {
    DMA: 770,
  },
  "84031": {
    DMA: 770,
  },
  "84032": {
    DMA: 770,
  },
  "84033": {
    DMA: 770,
  },
  "84034": {
    DMA: 770,
  },
  "84035": {
    DMA: 770,
  },
  "84036": {
    DMA: 770,
  },
  "84037": {
    DMA: 770,
  },
  "84038": {
    DMA: 770,
  },
  "84039": {
    DMA: 770,
  },
  "84040": {
    DMA: 770,
  },
  "84041": {
    DMA: 770,
  },
  "84042": {
    DMA: 770,
  },
  "84043": {
    DMA: 770,
  },
  "84044": {
    DMA: 770,
  },
  "84045": {
    DMA: 770,
  },
  "84046": {
    DMA: 770,
  },
  "84047": {
    DMA: 770,
  },
  "84049": {
    DMA: 770,
  },
  "84050": {
    DMA: 770,
  },
  "84051": {
    DMA: 770,
  },
  "84052": {
    DMA: 770,
  },
  "84053": {
    DMA: 770,
  },
  "84054": {
    DMA: 770,
  },
  "84055": {
    DMA: 770,
  },
  "84056": {
    DMA: 770,
  },
  "84057": {
    DMA: 770,
  },
  "84058": {
    DMA: 770,
  },
  "84059": {
    DMA: 770,
  },
  "84060": {
    DMA: 770,
  },
  "84061": {
    DMA: 770,
  },
  "84062": {
    DMA: 770,
  },
  "84063": {
    DMA: 770,
  },
  "84064": {
    DMA: 770,
  },
  "84065": {
    DMA: 770,
  },
  "84066": {
    DMA: 770,
  },
  "84067": {
    DMA: 770,
  },
  "84068": {
    DMA: 770,
  },
  "84069": {
    DMA: 770,
  },
  "84070": {
    DMA: 770,
  },
  "84071": {
    DMA: 770,
  },
  "84072": {
    DMA: 770,
  },
  "84073": {
    DMA: 770,
  },
  "84074": {
    DMA: 770,
  },
  "84075": {
    DMA: 770,
  },
  "84076": {
    DMA: 770,
  },
  "84078": {
    DMA: 770,
  },
  "84079": {
    DMA: 770,
  },
  "84080": {
    DMA: 770,
  },
  "84081": {
    DMA: 770,
  },
  "84082": {
    DMA: 770,
  },
  "84083": {
    DMA: 770,
  },
  "84084": {
    DMA: 770,
  },
  "84085": {
    DMA: 770,
  },
  "84086": {
    DMA: 770,
  },
  "84087": {
    DMA: 770,
  },
  "84088": {
    DMA: 770,
  },
  "84089": {
    DMA: 770,
  },
  "84090": {
    DMA: 770,
  },
  "84091": {
    DMA: 770,
  },
  "84092": {
    DMA: 770,
  },
  "84093": {
    DMA: 770,
  },
  "84094": {
    DMA: 770,
  },
  "84095": {
    DMA: 770,
  },
  "84096": {
    DMA: 770,
  },
  "84097": {
    DMA: 770,
  },
  "84098": {
    DMA: 770,
  },
  "84101": {
    DMA: 770,
  },
  "84102": {
    DMA: 770,
  },
  "84103": {
    DMA: 770,
  },
  "84104": {
    DMA: 770,
  },
  "84105": {
    DMA: 770,
  },
  "84106": {
    DMA: 770,
  },
  "84107": {
    DMA: 770,
  },
  "84108": {
    DMA: 770,
  },
  "84109": {
    DMA: 770,
  },
  "84110": {
    DMA: 770,
  },
  "84111": {
    DMA: 770,
  },
  "84112": {
    DMA: 770,
  },
  "84113": {
    DMA: 770,
  },
  "84114": {
    DMA: 770,
  },
  "84115": {
    DMA: 770,
  },
  "84116": {
    DMA: 770,
  },
  "84117": {
    DMA: 770,
  },
  "84118": {
    DMA: 770,
  },
  "84119": {
    DMA: 770,
  },
  "84120": {
    DMA: 770,
  },
  "84121": {
    DMA: 770,
  },
  "84122": {
    DMA: 770,
  },
  "84123": {
    DMA: 770,
  },
  "84124": {
    DMA: 770,
  },
  "84125": {
    DMA: 770,
  },
  "84126": {
    DMA: 770,
  },
  "84127": {
    DMA: 770,
  },
  "84128": {
    DMA: 770,
  },
  "84129": {
    DMA: 770,
  },
  "84130": {
    DMA: 770,
  },
  "84131": {
    DMA: 770,
  },
  "84132": {
    DMA: 770,
  },
  "84133": {
    DMA: 770,
  },
  "84134": {
    DMA: 770,
  },
  "84136": {
    DMA: 770,
  },
  "84138": {
    DMA: 770,
  },
  "84139": {
    DMA: 770,
  },
  "84141": {
    DMA: 770,
  },
  "84143": {
    DMA: 770,
  },
  "84144": {
    DMA: 770,
  },
  "84145": {
    DMA: 770,
  },
  "84147": {
    DMA: 770,
  },
  "84148": {
    DMA: 770,
  },
  "84150": {
    DMA: 770,
  },
  "84151": {
    DMA: 770,
  },
  "84152": {
    DMA: 770,
  },
  "84157": {
    DMA: 770,
  },
  "84158": {
    DMA: 770,
  },
  "84165": {
    DMA: 770,
  },
  "84170": {
    DMA: 770,
  },
  "84171": {
    DMA: 770,
  },
  "84180": {
    DMA: 770,
  },
  "84184": {
    DMA: 770,
  },
  "84189": {
    DMA: 770,
  },
  "84190": {
    DMA: 770,
  },
  "84199": {
    DMA: 770,
  },
  "84201": {
    DMA: 770,
  },
  "84244": {
    DMA: 770,
  },
  "84301": {
    DMA: 770,
  },
  "84302": {
    DMA: 770,
  },
  "84304": {
    DMA: 770,
  },
  "84305": {
    DMA: 770,
  },
  "84306": {
    DMA: 770,
  },
  "84307": {
    DMA: 770,
  },
  "84308": {
    DMA: 770,
  },
  "84309": {
    DMA: 770,
  },
  "84310": {
    DMA: 770,
  },
  "84311": {
    DMA: 770,
  },
  "84312": {
    DMA: 770,
  },
  "84313": {
    DMA: 770,
  },
  "84314": {
    DMA: 770,
  },
  "84315": {
    DMA: 770,
  },
  "84316": {
    DMA: 770,
  },
  "84317": {
    DMA: 770,
  },
  "84318": {
    DMA: 770,
  },
  "84319": {
    DMA: 770,
  },
  "84320": {
    DMA: 770,
  },
  "84321": {
    DMA: 770,
  },
  "84322": {
    DMA: 770,
  },
  "84323": {
    DMA: 770,
  },
  "84324": {
    DMA: 770,
  },
  "84325": {
    DMA: 770,
  },
  "84326": {
    DMA: 770,
  },
  "84327": {
    DMA: 770,
  },
  "84328": {
    DMA: 770,
  },
  "84329": {
    DMA: 770,
  },
  "84330": {
    DMA: 770,
  },
  "84331": {
    DMA: 770,
  },
  "84332": {
    DMA: 770,
  },
  "84333": {
    DMA: 770,
  },
  "84334": {
    DMA: 770,
  },
  "84335": {
    DMA: 770,
  },
  "84336": {
    DMA: 770,
  },
  "84337": {
    DMA: 770,
  },
  "84338": {
    DMA: 770,
  },
  "84339": {
    DMA: 770,
  },
  "84340": {
    DMA: 770,
  },
  "84341": {
    DMA: 770,
  },
  "84401": {
    DMA: 770,
  },
  "84402": {
    DMA: 770,
  },
  "84403": {
    DMA: 770,
  },
  "84404": {
    DMA: 770,
  },
  "84405": {
    DMA: 770,
  },
  "84407": {
    DMA: 770,
  },
  "84408": {
    DMA: 770,
  },
  "84409": {
    DMA: 770,
  },
  "84412": {
    DMA: 770,
  },
  "84414": {
    DMA: 770,
  },
  "84415": {
    DMA: 770,
  },
  "84501": {
    DMA: 770,
  },
  "84510": {
    DMA: 770,
  },
  "84511": {
    DMA: 770,
  },
  "84512": {
    DMA: 770,
  },
  "84513": {
    DMA: 770,
  },
  "84515": {
    DMA: 770,
  },
  "84516": {
    DMA: 770,
  },
  "84518": {
    DMA: 770,
  },
  "84520": {
    DMA: 770,
  },
  "84521": {
    DMA: 770,
  },
  "84522": {
    DMA: 770,
  },
  "84523": {
    DMA: 770,
  },
  "84525": {
    DMA: 770,
  },
  "84526": {
    DMA: 770,
  },
  "84528": {
    DMA: 770,
  },
  "84529": {
    DMA: 770,
  },
  "84530": {
    DMA: 770,
  },
  "84531": {
    DMA: 770,
  },
  "84532": {
    DMA: 770,
  },
  "84533": {
    DMA: 770,
  },
  "84534": {
    DMA: 770,
  },
  "84535": {
    DMA: 770,
  },
  "84536": {
    DMA: 770,
  },
  "84537": {
    DMA: 770,
  },
  "84539": {
    DMA: 770,
  },
  "84540": {
    DMA: 770,
  },
  "84542": {
    DMA: 770,
  },
  "84601": {
    DMA: 770,
  },
  "84602": {
    DMA: 770,
  },
  "84603": {
    DMA: 770,
  },
  "84604": {
    DMA: 770,
  },
  "84605": {
    DMA: 770,
  },
  "84606": {
    DMA: 770,
  },
  "84620": {
    DMA: 770,
  },
  "84621": {
    DMA: 770,
  },
  "84622": {
    DMA: 770,
  },
  "84623": {
    DMA: 770,
  },
  "84624": {
    DMA: 770,
  },
  "84626": {
    DMA: 770,
  },
  "84627": {
    DMA: 770,
  },
  "84628": {
    DMA: 770,
  },
  "84629": {
    DMA: 770,
  },
  "84630": {
    DMA: 770,
  },
  "84631": {
    DMA: 770,
  },
  "84632": {
    DMA: 770,
  },
  "84633": {
    DMA: 770,
  },
  "84634": {
    DMA: 770,
  },
  "84635": {
    DMA: 770,
  },
  "84636": {
    DMA: 770,
  },
  "84637": {
    DMA: 770,
  },
  "84638": {
    DMA: 770,
  },
  "84639": {
    DMA: 770,
  },
  "84640": {
    DMA: 770,
  },
  "84642": {
    DMA: 770,
  },
  "84643": {
    DMA: 770,
  },
  "84644": {
    DMA: 770,
  },
  "84645": {
    DMA: 770,
  },
  "84646": {
    DMA: 770,
  },
  "84647": {
    DMA: 770,
  },
  "84648": {
    DMA: 770,
  },
  "84649": {
    DMA: 770,
  },
  "84651": {
    DMA: 770,
  },
  "84652": {
    DMA: 770,
  },
  "84653": {
    DMA: 770,
  },
  "84654": {
    DMA: 770,
  },
  "84655": {
    DMA: 770,
  },
  "84656": {
    DMA: 770,
  },
  "84657": {
    DMA: 770,
  },
  "84660": {
    DMA: 770,
  },
  "84662": {
    DMA: 770,
  },
  "84663": {
    DMA: 770,
  },
  "84664": {
    DMA: 770,
  },
  "84665": {
    DMA: 770,
  },
  "84667": {
    DMA: 770,
  },
  "84701": {
    DMA: 770,
  },
  "84710": {
    DMA: 770,
  },
  "84711": {
    DMA: 770,
  },
  "84712": {
    DMA: 770,
  },
  "84713": {
    DMA: 770,
  },
  "84714": {
    DMA: 770,
  },
  "84715": {
    DMA: 770,
  },
  "84716": {
    DMA: 770,
  },
  "84717": {
    DMA: 770,
  },
  "84718": {
    DMA: 770,
  },
  "84719": {
    DMA: 770,
  },
  "84720": {
    DMA: 770,
  },
  "84721": {
    DMA: 770,
  },
  "84722": {
    DMA: 770,
  },
  "84723": {
    DMA: 770,
  },
  "84724": {
    DMA: 770,
  },
  "84725": {
    DMA: 770,
  },
  "84726": {
    DMA: 770,
  },
  "84728": {
    DMA: 770,
  },
  "84729": {
    DMA: 770,
  },
  "84730": {
    DMA: 770,
  },
  "84731": {
    DMA: 770,
  },
  "84732": {
    DMA: 770,
  },
  "84733": {
    DMA: 770,
  },
  "84734": {
    DMA: 770,
  },
  "84735": {
    DMA: 770,
  },
  "84736": {
    DMA: 770,
  },
  "84737": {
    DMA: 770,
  },
  "84738": {
    DMA: 770,
  },
  "84739": {
    DMA: 770,
  },
  "84740": {
    DMA: 770,
  },
  "84741": {
    DMA: 770,
  },
  "84742": {
    DMA: 770,
  },
  "84743": {
    DMA: 770,
  },
  "84744": {
    DMA: 770,
  },
  "84745": {
    DMA: 770,
  },
  "84746": {
    DMA: 770,
  },
  "84747": {
    DMA: 770,
  },
  "84749": {
    DMA: 770,
  },
  "84750": {
    DMA: 770,
  },
  "84751": {
    DMA: 770,
  },
  "84752": {
    DMA: 770,
  },
  "84753": {
    DMA: 770,
  },
  "84754": {
    DMA: 770,
  },
  "84755": {
    DMA: 770,
  },
  "84756": {
    DMA: 770,
  },
  "84757": {
    DMA: 770,
  },
  "84758": {
    DMA: 770,
  },
  "84759": {
    DMA: 770,
  },
  "84760": {
    DMA: 770,
  },
  "84761": {
    DMA: 770,
  },
  "84762": {
    DMA: 770,
  },
  "84763": {
    DMA: 770,
  },
  "84764": {
    DMA: 770,
  },
  "84765": {
    DMA: 770,
  },
  "84766": {
    DMA: 770,
  },
  "84767": {
    DMA: 770,
  },
  "84770": {
    DMA: 770,
  },
  "84771": {
    DMA: 770,
  },
  "84772": {
    DMA: 770,
  },
  "84773": {
    DMA: 770,
  },
  "84774": {
    DMA: 770,
  },
  "84775": {
    DMA: 770,
  },
  "84776": {
    DMA: 770,
  },
  "84779": {
    DMA: 770,
  },
  "84780": {
    DMA: 770,
  },
  "84781": {
    DMA: 770,
  },
  "84782": {
    DMA: 770,
  },
  "84783": {
    DMA: 770,
  },
  "84784": {
    DMA: 770,
  },
  "84790": {
    DMA: 770,
  },
  "84791": {
    DMA: 770,
  },
  "85001": {
    DMA: 753,
  },
  "85002": {
    DMA: 753,
  },
  "85003": {
    DMA: 753,
  },
  "85004": {
    DMA: 753,
  },
  "85005": {
    DMA: 753,
  },
  "85006": {
    DMA: 753,
  },
  "85007": {
    DMA: 753,
  },
  "85008": {
    DMA: 753,
  },
  "85009": {
    DMA: 753,
  },
  "85010": {
    DMA: 753,
  },
  "85011": {
    DMA: 753,
  },
  "85012": {
    DMA: 753,
  },
  "85013": {
    DMA: 753,
  },
  "85014": {
    DMA: 753,
  },
  "85015": {
    DMA: 753,
  },
  "85016": {
    DMA: 753,
  },
  "85017": {
    DMA: 753,
  },
  "85018": {
    DMA: 753,
  },
  "85019": {
    DMA: 753,
  },
  "85020": {
    DMA: 753,
  },
  "85021": {
    DMA: 753,
  },
  "85022": {
    DMA: 753,
  },
  "85023": {
    DMA: 753,
  },
  "85024": {
    DMA: 753,
  },
  "85025": {
    DMA: 753,
  },
  "85026": {
    DMA: 753,
  },
  "85027": {
    DMA: 753,
  },
  "85028": {
    DMA: 753,
  },
  "85029": {
    DMA: 753,
  },
  "85030": {
    DMA: 753,
  },
  "85031": {
    DMA: 753,
  },
  "85032": {
    DMA: 753,
  },
  "85033": {
    DMA: 753,
  },
  "85034": {
    DMA: 753,
  },
  "85035": {
    DMA: 753,
  },
  "85036": {
    DMA: 753,
  },
  "85037": {
    DMA: 753,
  },
  "85038": {
    DMA: 753,
  },
  "85039": {
    DMA: 753,
  },
  "85040": {
    DMA: 753,
  },
  "85041": {
    DMA: 753,
  },
  "85042": {
    DMA: 753,
  },
  "85043": {
    DMA: 753,
  },
  "85044": {
    DMA: 753,
  },
  "85045": {
    DMA: 753,
  },
  "85046": {
    DMA: 753,
  },
  "85048": {
    DMA: 753,
  },
  "85050": {
    DMA: 753,
  },
  "85051": {
    DMA: 753,
  },
  "85053": {
    DMA: 753,
  },
  "85054": {
    DMA: 753,
  },
  "85055": {
    DMA: 753,
  },
  "85060": {
    DMA: 753,
  },
  "85061": {
    DMA: 753,
  },
  "85062": {
    DMA: 753,
  },
  "85063": {
    DMA: 753,
  },
  "85064": {
    DMA: 753,
  },
  "85065": {
    DMA: 753,
  },
  "85066": {
    DMA: 753,
  },
  "85067": {
    DMA: 753,
  },
  "85068": {
    DMA: 753,
  },
  "85069": {
    DMA: 753,
  },
  "85070": {
    DMA: 753,
  },
  "85071": {
    DMA: 753,
  },
  "85072": {
    DMA: 753,
  },
  "85073": {
    DMA: 753,
  },
  "85074": {
    DMA: 753,
  },
  "85075": {
    DMA: 753,
  },
  "85076": {
    DMA: 753,
  },
  "85077": {
    DMA: 753,
  },
  "85078": {
    DMA: 753,
  },
  "85079": {
    DMA: 753,
  },
  "85080": {
    DMA: 753,
  },
  "85082": {
    DMA: 753,
  },
  "85083": {
    DMA: 753,
  },
  "85085": {
    DMA: 753,
  },
  "85086": {
    DMA: 753,
  },
  "85087": {
    DMA: 753,
  },
  "85096": {
    DMA: 753,
  },
  "85097": {
    DMA: 753,
  },
  "85098": {
    DMA: 753,
  },
  "85099": {
    DMA: 753,
  },
  "85117": {
    DMA: 753,
  },
  "85118": {
    DMA: 753,
  },
  "85119": {
    DMA: 753,
  },
  "85120": {
    DMA: 753,
  },
  "85121": {
    DMA: 753,
  },
  "85122": {
    DMA: 753,
  },
  "85123": {
    DMA: 753,
  },
  "85127": {
    DMA: 753,
  },
  "85128": {
    DMA: 753,
  },
  "85130": {
    DMA: 753,
  },
  "85131": {
    DMA: 753,
  },
  "85132": {
    DMA: 753,
  },
  "85135": {
    DMA: 753,
  },
  "85137": {
    DMA: 753,
  },
  "85138": {
    DMA: 753,
  },
  "85139": {
    DMA: 753,
  },
  "85140": {
    DMA: 753,
  },
  "85141": {
    DMA: 753,
  },
  "85142": {
    DMA: 753,
  },
  "85143": {
    DMA: 753,
  },
  "85145": {
    DMA: 753,
  },
  "85147": {
    DMA: 753,
  },
  "85172": {
    DMA: 753,
  },
  "85173": {
    DMA: 753,
  },
  "85178": {
    DMA: 753,
  },
  "85190": {
    DMA: 753,
  },
  "85191": {
    DMA: 753,
  },
  "85192": {
    DMA: 753,
  },
  "85193": {
    DMA: 753,
  },
  "85194": {
    DMA: 753,
  },
  "85201": {
    DMA: 753,
  },
  "85202": {
    DMA: 753,
  },
  "85203": {
    DMA: 753,
  },
  "85204": {
    DMA: 753,
  },
  "85205": {
    DMA: 753,
  },
  "85206": {
    DMA: 753,
  },
  "85207": {
    DMA: 753,
  },
  "85208": {
    DMA: 753,
  },
  "85209": {
    DMA: 753,
  },
  "85210": {
    DMA: 753,
  },
  "85211": {
    DMA: 753,
  },
  "85212": {
    DMA: 753,
  },
  "85213": {
    DMA: 753,
  },
  "85214": {
    DMA: 753,
  },
  "85215": {
    DMA: 753,
  },
  "85216": {
    DMA: 753,
  },
  "85217": {
    DMA: 753,
  },
  "85218": {
    DMA: 753,
  },
  "85219": {
    DMA: 753,
  },
  "85220": {
    DMA: 753,
  },
  "85221": {
    DMA: 753,
  },
  "85222": {
    DMA: 753,
  },
  "85223": {
    DMA: 753,
  },
  "85224": {
    DMA: 753,
  },
  "85225": {
    DMA: 753,
  },
  "85226": {
    DMA: 753,
  },
  "85227": {
    DMA: 753,
  },
  "85228": {
    DMA: 753,
  },
  "85230": {
    DMA: 753,
  },
  "85231": {
    DMA: 753,
  },
  "85232": {
    DMA: 753,
  },
  "85233": {
    DMA: 753,
  },
  "85234": {
    DMA: 753,
  },
  "85235": {
    DMA: 753,
  },
  "85236": {
    DMA: 753,
  },
  "85237": {
    DMA: 753,
  },
  "85238": {
    DMA: 753,
  },
  "85239": {
    DMA: 753,
  },
  "85240": {
    DMA: 753,
  },
  "85241": {
    DMA: 753,
  },
  "85242": {
    DMA: 753,
  },
  "85243": {
    DMA: 753,
  },
  "85244": {
    DMA: 753,
  },
  "85245": {
    DMA: 753,
  },
  "85246": {
    DMA: 753,
  },
  "85247": {
    DMA: 753,
  },
  "85248": {
    DMA: 753,
  },
  "85249": {
    DMA: 753,
  },
  "85250": {
    DMA: 753,
  },
  "85251": {
    DMA: 753,
  },
  "85252": {
    DMA: 753,
  },
  "85253": {
    DMA: 753,
  },
  "85254": {
    DMA: 753,
  },
  "85255": {
    DMA: 753,
  },
  "85256": {
    DMA: 753,
  },
  "85257": {
    DMA: 753,
  },
  "85258": {
    DMA: 753,
  },
  "85259": {
    DMA: 753,
  },
  "85260": {
    DMA: 753,
  },
  "85261": {
    DMA: 753,
  },
  "85262": {
    DMA: 753,
  },
  "85263": {
    DMA: 753,
  },
  "85264": {
    DMA: 753,
  },
  "85266": {
    DMA: 753,
  },
  "85267": {
    DMA: 753,
  },
  "85268": {
    DMA: 753,
  },
  "85269": {
    DMA: 753,
  },
  "85271": {
    DMA: 753,
  },
  "85272": {
    DMA: 753,
  },
  "85273": {
    DMA: 753,
  },
  "85274": {
    DMA: 753,
  },
  "85275": {
    DMA: 753,
  },
  "85277": {
    DMA: 753,
  },
  "85278": {
    DMA: 753,
  },
  "85279": {
    DMA: 753,
  },
  "85280": {
    DMA: 753,
  },
  "85281": {
    DMA: 753,
  },
  "85282": {
    DMA: 753,
  },
  "85283": {
    DMA: 753,
  },
  "85284": {
    DMA: 753,
  },
  "85285": {
    DMA: 753,
  },
  "85286": {
    DMA: 753,
  },
  "85287": {
    DMA: 753,
  },
  "85288": {
    DMA: 753,
  },
  "85289": {
    DMA: 753,
  },
  "85290": {
    DMA: 753,
  },
  "85291": {
    DMA: 753,
  },
  "85292": {
    DMA: 753,
  },
  "85293": {
    DMA: 753,
  },
  "85294": {
    DMA: 753,
  },
  "85295": {
    DMA: 753,
  },
  "85296": {
    DMA: 753,
  },
  "85297": {
    DMA: 753,
  },
  "85298": {
    DMA: 753,
  },
  "85299": {
    DMA: 753,
  },
  "85301": {
    DMA: 753,
  },
  "85302": {
    DMA: 753,
  },
  "85303": {
    DMA: 753,
  },
  "85304": {
    DMA: 753,
  },
  "85305": {
    DMA: 753,
  },
  "85306": {
    DMA: 753,
  },
  "85307": {
    DMA: 753,
  },
  "85308": {
    DMA: 753,
  },
  "85309": {
    DMA: 753,
  },
  "85310": {
    DMA: 753,
  },
  "85311": {
    DMA: 753,
  },
  "85312": {
    DMA: 753,
  },
  "85313": {
    DMA: 753,
  },
  "85318": {
    DMA: 753,
  },
  "85320": {
    DMA: 753,
  },
  "85321": {
    DMA: 789,
  },
  "85322": {
    DMA: 753,
  },
  "85323": {
    DMA: 753,
  },
  "85324": {
    DMA: 753,
  },
  "85325": {
    DMA: 753,
  },
  "85326": {
    DMA: 753,
  },
  "85327": {
    DMA: 753,
  },
  "85328": {
    DMA: 753,
  },
  "85329": {
    DMA: 753,
  },
  "85331": {
    DMA: 753,
  },
  "85332": {
    DMA: 753,
  },
  "85333": {
    DMA: 771,
  },
  "85334": {
    DMA: 753,
  },
  "85335": {
    DMA: 753,
  },
  "85336": {
    DMA: 771,
  },
  "85337": {
    DMA: 753,
  },
  "85338": {
    DMA: 753,
  },
  "85339": {
    DMA: 753,
  },
  "85340": {
    DMA: 753,
  },
  "85341": {
    DMA: 789,
  },
  "85342": {
    DMA: 753,
  },
  "85343": {
    DMA: 753,
  },
  "85344": {
    DMA: 753,
  },
  "85345": {
    DMA: 753,
  },
  "85346": {
    DMA: 753,
  },
  "85347": {
    DMA: 771,
  },
  "85348": {
    DMA: 753,
  },
  "85349": {
    DMA: 771,
  },
  "85350": {
    DMA: 771,
  },
  "85351": {
    DMA: 753,
  },
  "85352": {
    DMA: 771,
  },
  "85353": {
    DMA: 753,
  },
  "85354": {
    DMA: 753,
  },
  "85355": {
    DMA: 753,
  },
  "85356": {
    DMA: 771,
  },
  "85357": {
    DMA: 753,
  },
  "85358": {
    DMA: 753,
  },
  "85359": {
    DMA: 753,
  },
  "85360": {
    DMA: 753,
  },
  "85361": {
    DMA: 753,
  },
  "85362": {
    DMA: 753,
  },
  "85363": {
    DMA: 753,
  },
  "85364": {
    DMA: 771,
  },
  "85365": {
    DMA: 771,
  },
  "85366": {
    DMA: 771,
  },
  "85367": {
    DMA: 771,
  },
  "85369": {
    DMA: 771,
  },
  "85371": {
    DMA: 753,
  },
  "85372": {
    DMA: 753,
  },
  "85373": {
    DMA: 753,
  },
  "85374": {
    DMA: 753,
  },
  "85375": {
    DMA: 753,
  },
  "85376": {
    DMA: 753,
  },
  "85377": {
    DMA: 753,
  },
  "85378": {
    DMA: 753,
  },
  "85379": {
    DMA: 753,
  },
  "85380": {
    DMA: 753,
  },
  "85381": {
    DMA: 753,
  },
  "85382": {
    DMA: 753,
  },
  "85383": {
    DMA: 753,
  },
  "85385": {
    DMA: 753,
  },
  "85387": {
    DMA: 753,
  },
  "85388": {
    DMA: 753,
  },
  "85390": {
    DMA: 753,
  },
  "85392": {
    DMA: 753,
  },
  "85395": {
    DMA: 753,
  },
  "85396": {
    DMA: 753,
  },
  "85501": {
    DMA: 753,
  },
  "85502": {
    DMA: 753,
  },
  "85530": {
    DMA: 753,
  },
  "85531": {
    DMA: 753,
  },
  "85532": {
    DMA: 753,
  },
  "85533": {
    DMA: 753,
  },
  "85534": {
    DMA: 753,
  },
  "85535": {
    DMA: 753,
  },
  "85536": {
    DMA: 753,
  },
  "85539": {
    DMA: 753,
  },
  "85540": {
    DMA: 753,
  },
  "85541": {
    DMA: 753,
  },
  "85542": {
    DMA: 753,
  },
  "85543": {
    DMA: 753,
  },
  "85544": {
    DMA: 753,
  },
  "85545": {
    DMA: 753,
  },
  "85546": {
    DMA: 753,
  },
  "85547": {
    DMA: 753,
  },
  "85548": {
    DMA: 753,
  },
  "85550": {
    DMA: 753,
  },
  "85551": {
    DMA: 753,
  },
  "85552": {
    DMA: 753,
  },
  "85553": {
    DMA: 753,
  },
  "85554": {
    DMA: 753,
  },
  "85601": {
    DMA: 789,
  },
  "85602": {
    DMA: 789,
  },
  "85603": {
    DMA: 789,
  },
  "85605": {
    DMA: 789,
  },
  "85606": {
    DMA: 789,
  },
  "85607": {
    DMA: 789,
  },
  "85608": {
    DMA: 789,
  },
  "85609": {
    DMA: 789,
  },
  "85610": {
    DMA: 789,
  },
  "85611": {
    DMA: 789,
  },
  "85613": {
    DMA: 789,
  },
  "85614": {
    DMA: 789,
  },
  "85615": {
    DMA: 789,
  },
  "85616": {
    DMA: 789,
  },
  "85617": {
    DMA: 789,
  },
  "85618": {
    DMA: 753,
  },
  "85619": {
    DMA: 789,
  },
  "85620": {
    DMA: 789,
  },
  "85621": {
    DMA: 789,
  },
  "85622": {
    DMA: 789,
  },
  "85623": {
    DMA: 753,
  },
  "85624": {
    DMA: 789,
  },
  "85625": {
    DMA: 789,
  },
  "85626": {
    DMA: 789,
  },
  "85627": {
    DMA: 789,
  },
  "85628": {
    DMA: 789,
  },
  "85629": {
    DMA: 789,
  },
  "85630": {
    DMA: 789,
  },
  "85631": {
    DMA: 753,
  },
  "85632": {
    DMA: 789,
  },
  "85633": {
    DMA: 789,
  },
  "85634": {
    DMA: 789,
  },
  "85635": {
    DMA: 789,
  },
  "85636": {
    DMA: 789,
  },
  "85637": {
    DMA: 789,
  },
  "85638": {
    DMA: 789,
  },
  "85639": {
    DMA: 789,
  },
  "85640": {
    DMA: 789,
  },
  "85641": {
    DMA: 789,
  },
  "85643": {
    DMA: 789,
  },
  "85644": {
    DMA: 789,
  },
  "85645": {
    DMA: 789,
  },
  "85646": {
    DMA: 789,
  },
  "85648": {
    DMA: 789,
  },
  "85650": {
    DMA: 789,
  },
  "85652": {
    DMA: 789,
  },
  "85653": {
    DMA: 789,
  },
  "85654": {
    DMA: 789,
  },
  "85655": {
    DMA: 789,
  },
  "85658": {
    DMA: 789,
  },
  "85662": {
    DMA: 789,
  },
  "85670": {
    DMA: 789,
  },
  "85671": {
    DMA: 789,
  },
  "85701": {
    DMA: 789,
  },
  "85702": {
    DMA: 789,
  },
  "85703": {
    DMA: 789,
  },
  "85704": {
    DMA: 789,
  },
  "85705": {
    DMA: 789,
  },
  "85706": {
    DMA: 789,
  },
  "85707": {
    DMA: 789,
  },
  "85708": {
    DMA: 789,
  },
  "85709": {
    DMA: 789,
  },
  "85710": {
    DMA: 789,
  },
  "85711": {
    DMA: 789,
  },
  "85712": {
    DMA: 789,
  },
  "85713": {
    DMA: 789,
  },
  "85714": {
    DMA: 789,
  },
  "85715": {
    DMA: 789,
  },
  "85716": {
    DMA: 789,
  },
  "85717": {
    DMA: 789,
  },
  "85718": {
    DMA: 789,
  },
  "85719": {
    DMA: 789,
  },
  "85720": {
    DMA: "#N/A",
  },
  "85721": {
    DMA: 789,
  },
  "85722": {
    DMA: "#N/A",
  },
  "85723": {
    DMA: 789,
  },
  "85724": {
    DMA: 789,
  },
  "85725": {
    DMA: 789,
  },
  "85726": {
    DMA: 789,
  },
  "85728": {
    DMA: 789,
  },
  "85730": {
    DMA: 789,
  },
  "85731": {
    DMA: 789,
  },
  "85732": {
    DMA: 789,
  },
  "85733": {
    DMA: 789,
  },
  "85734": {
    DMA: 789,
  },
  "85735": {
    DMA: 789,
  },
  "85736": {
    DMA: 789,
  },
  "85737": {
    DMA: 789,
  },
  "85738": {
    DMA: 789,
  },
  "85739": {
    DMA: 789,
  },
  "85740": {
    DMA: 789,
  },
  "85741": {
    DMA: 789,
  },
  "85742": {
    DMA: 789,
  },
  "85743": {
    DMA: 789,
  },
  "85744": {
    DMA: 789,
  },
  "85745": {
    DMA: 789,
  },
  "85746": {
    DMA: 789,
  },
  "85747": {
    DMA: 789,
  },
  "85748": {
    DMA: 789,
  },
  "85749": {
    DMA: 789,
  },
  "85750": {
    DMA: 789,
  },
  "85751": {
    DMA: 789,
  },
  "85752": {
    DMA: 789,
  },
  "85754": {
    DMA: 789,
  },
  "85755": {
    DMA: 789,
  },
  "85756": {
    DMA: 789,
  },
  "85757": {
    DMA: 789,
  },
  "85775": {
    DMA: 789,
  },
  "85777": {
    DMA: 789,
  },
  "85901": {
    DMA: 753,
  },
  "85902": {
    DMA: 753,
  },
  "85911": {
    DMA: 753,
  },
  "85912": {
    DMA: 753,
  },
  "85920": {
    DMA: 790,
  },
  "85922": {
    DMA: 753,
  },
  "85923": {
    DMA: 753,
  },
  "85924": {
    DMA: 790,
  },
  "85925": {
    DMA: 790,
  },
  "85926": {
    DMA: 753,
  },
  "85927": {
    DMA: 790,
  },
  "85928": {
    DMA: 753,
  },
  "85929": {
    DMA: 753,
  },
  "85930": {
    DMA: 790,
  },
  "85931": {
    DMA: 753,
  },
  "85932": {
    DMA: 790,
  },
  "85933": {
    DMA: 753,
  },
  "85934": {
    DMA: 753,
  },
  "85935": {
    DMA: 753,
  },
  "85936": {
    DMA: 790,
  },
  "85937": {
    DMA: 753,
  },
  "85938": {
    DMA: 790,
  },
  "85939": {
    DMA: 753,
  },
  "85940": {
    DMA: 790,
  },
  "85941": {
    DMA: 753,
  },
  "85942": {
    DMA: 753,
  },
  "86001": {
    DMA: 753,
  },
  "86002": {
    DMA: 753,
  },
  "86003": {
    DMA: 753,
  },
  "86004": {
    DMA: 753,
  },
  "86005": {
    DMA: 753,
  },
  "86011": {
    DMA: 753,
  },
  "86015": {
    DMA: 753,
  },
  "86016": {
    DMA: 753,
  },
  "86017": {
    DMA: 753,
  },
  "86018": {
    DMA: 753,
  },
  "86020": {
    DMA: 753,
  },
  "86021": {
    DMA: 753,
  },
  "86022": {
    DMA: 753,
  },
  "86023": {
    DMA: 753,
  },
  "86024": {
    DMA: 753,
  },
  "86025": {
    DMA: 753,
  },
  "86028": {
    DMA: 790,
  },
  "86029": {
    DMA: 753,
  },
  "86030": {
    DMA: 753,
  },
  "86031": {
    DMA: 753,
  },
  "86032": {
    DMA: 753,
  },
  "86033": {
    DMA: 753,
  },
  "86034": {
    DMA: 753,
  },
  "86035": {
    DMA: 753,
  },
  "86036": {
    DMA: 753,
  },
  "86038": {
    DMA: 753,
  },
  "86039": {
    DMA: 753,
  },
  "86040": {
    DMA: 753,
  },
  "86042": {
    DMA: 753,
  },
  "86043": {
    DMA: 753,
  },
  "86044": {
    DMA: 753,
  },
  "86045": {
    DMA: 753,
  },
  "86046": {
    DMA: 753,
  },
  "86047": {
    DMA: 753,
  },
  "86052": {
    DMA: 753,
  },
  "86053": {
    DMA: 753,
  },
  "86054": {
    DMA: 753,
  },
  "86301": {
    DMA: 753,
  },
  "86302": {
    DMA: 753,
  },
  "86303": {
    DMA: 753,
  },
  "86304": {
    DMA: 753,
  },
  "86305": {
    DMA: 753,
  },
  "86312": {
    DMA: 753,
  },
  "86313": {
    DMA: 753,
  },
  "86314": {
    DMA: 753,
  },
  "86315": {
    DMA: 753,
  },
  "86320": {
    DMA: 753,
  },
  "86321": {
    DMA: 753,
  },
  "86322": {
    DMA: 753,
  },
  "86323": {
    DMA: 753,
  },
  "86324": {
    DMA: 753,
  },
  "86325": {
    DMA: 753,
  },
  "86326": {
    DMA: 753,
  },
  "86327": {
    DMA: 753,
  },
  "86329": {
    DMA: 753,
  },
  "86330": {
    DMA: 753,
  },
  "86331": {
    DMA: 753,
  },
  "86332": {
    DMA: 753,
  },
  "86333": {
    DMA: 753,
  },
  "86334": {
    DMA: 753,
  },
  "86335": {
    DMA: 753,
  },
  "86336": {
    DMA: 753,
  },
  "86337": {
    DMA: 753,
  },
  "86338": {
    DMA: 753,
  },
  "86339": {
    DMA: 753,
  },
  "86340": {
    DMA: 753,
  },
  "86341": {
    DMA: 753,
  },
  "86342": {
    DMA: 753,
  },
  "86343": {
    DMA: 753,
  },
  "86351": {
    DMA: 753,
  },
  "86401": {
    DMA: 753,
  },
  "86402": {
    DMA: 753,
  },
  "86403": {
    DMA: 753,
  },
  "86404": {
    DMA: 753,
  },
  "86405": {
    DMA: 753,
  },
  "86406": {
    DMA: 753,
  },
  "86409": {
    DMA: 753,
  },
  "86411": {
    DMA: 753,
  },
  "86412": {
    DMA: 753,
  },
  "86413": {
    DMA: 753,
  },
  "86426": {
    DMA: 753,
  },
  "86427": {
    DMA: 753,
  },
  "86429": {
    DMA: 753,
  },
  "86430": {
    DMA: 753,
  },
  "86431": {
    DMA: 753,
  },
  "86432": {
    DMA: 753,
  },
  "86433": {
    DMA: 753,
  },
  "86434": {
    DMA: 753,
  },
  "86435": {
    DMA: 753,
  },
  "86436": {
    DMA: 753,
  },
  "86437": {
    DMA: 753,
  },
  "86438": {
    DMA: 753,
  },
  "86439": {
    DMA: 753,
  },
  "86440": {
    DMA: 753,
  },
  "86441": {
    DMA: 753,
  },
  "86442": {
    DMA: 753,
  },
  "86443": {
    DMA: 753,
  },
  "86444": {
    DMA: 753,
  },
  "86445": {
    DMA: 753,
  },
  "86446": {
    DMA: 753,
  },
  "86502": {
    DMA: 790,
  },
  "86503": {
    DMA: 790,
  },
  "86504": {
    DMA: 790,
  },
  "86505": {
    DMA: 790,
  },
  "86506": {
    DMA: 790,
  },
  "86507": {
    DMA: 790,
  },
  "86508": {
    DMA: 790,
  },
  "86510": {
    DMA: 753,
  },
  "86511": {
    DMA: 790,
  },
  "86512": {
    DMA: 790,
  },
  "86514": {
    DMA: 790,
  },
  "86515": {
    DMA: 790,
  },
  "86520": {
    DMA: 753,
  },
  "86535": {
    DMA: 790,
  },
  "86538": {
    DMA: 790,
  },
  "86540": {
    DMA: 790,
  },
  "86544": {
    DMA: 790,
  },
  "86545": {
    DMA: 790,
  },
  "86547": {
    DMA: 790,
  },
  "86555": {
    DMA: 789,
  },
  "86556": {
    DMA: 790,
  },
  "87001": {
    DMA: 790,
  },
  "87002": {
    DMA: 790,
  },
  "87004": {
    DMA: 790,
  },
  "87005": {
    DMA: 790,
  },
  "87006": {
    DMA: 790,
  },
  "87007": {
    DMA: 790,
  },
  "87008": {
    DMA: 790,
  },
  "87009": {
    DMA: 790,
  },
  "87010": {
    DMA: 790,
  },
  "87011": {
    DMA: 790,
  },
  "87012": {
    DMA: 790,
  },
  "87013": {
    DMA: 790,
  },
  "87014": {
    DMA: 790,
  },
  "87015": {
    DMA: 790,
  },
  "87016": {
    DMA: 790,
  },
  "87017": {
    DMA: 790,
  },
  "87018": {
    DMA: 790,
  },
  "87020": {
    DMA: 790,
  },
  "87021": {
    DMA: 790,
  },
  "87022": {
    DMA: 790,
  },
  "87023": {
    DMA: 790,
  },
  "87024": {
    DMA: 790,
  },
  "87025": {
    DMA: 790,
  },
  "87026": {
    DMA: 790,
  },
  "87027": {
    DMA: 790,
  },
  "87028": {
    DMA: 790,
  },
  "87029": {
    DMA: 790,
  },
  "87031": {
    DMA: 790,
  },
  "87032": {
    DMA: 790,
  },
  "87034": {
    DMA: 790,
  },
  "87035": {
    DMA: 790,
  },
  "87036": {
    DMA: 790,
  },
  "87037": {
    DMA: 790,
  },
  "87038": {
    DMA: 790,
  },
  "87040": {
    DMA: 790,
  },
  "87041": {
    DMA: 790,
  },
  "87042": {
    DMA: 790,
  },
  "87043": {
    DMA: 790,
  },
  "87044": {
    DMA: 790,
  },
  "87045": {
    DMA: 790,
  },
  "87046": {
    DMA: 790,
  },
  "87047": {
    DMA: 790,
  },
  "87048": {
    DMA: 790,
  },
  "87049": {
    DMA: 790,
  },
  "87051": {
    DMA: 790,
  },
  "87052": {
    DMA: 790,
  },
  "87053": {
    DMA: 790,
  },
  "87056": {
    DMA: 790,
  },
  "87059": {
    DMA: 790,
  },
  "87060": {
    DMA: 790,
  },
  "87061": {
    DMA: 790,
  },
  "87062": {
    DMA: 790,
  },
  "87063": {
    DMA: 790,
  },
  "87064": {
    DMA: 790,
  },
  "87068": {
    DMA: 790,
  },
  "87070": {
    DMA: 790,
  },
  "87072": {
    DMA: 790,
  },
  "87083": {
    DMA: 790,
  },
  "87101": {
    DMA: 790,
  },
  "87102": {
    DMA: 790,
  },
  "87103": {
    DMA: 790,
  },
  "87104": {
    DMA: 790,
  },
  "87105": {
    DMA: 790,
  },
  "87106": {
    DMA: 790,
  },
  "87107": {
    DMA: 790,
  },
  "87108": {
    DMA: 790,
  },
  "87109": {
    DMA: 790,
  },
  "87110": {
    DMA: 790,
  },
  "87111": {
    DMA: 790,
  },
  "87112": {
    DMA: 790,
  },
  "87113": {
    DMA: 790,
  },
  "87114": {
    DMA: 790,
  },
  "87115": {
    DMA: 790,
  },
  "87116": {
    DMA: 790,
  },
  "87117": {
    DMA: 790,
  },
  "87119": {
    DMA: 790,
  },
  "87120": {
    DMA: 790,
  },
  "87121": {
    DMA: 790,
  },
  "87122": {
    DMA: 790,
  },
  "87123": {
    DMA: 790,
  },
  "87124": {
    DMA: 790,
  },
  "87125": {
    DMA: 790,
  },
  "87131": {
    DMA: 790,
  },
  "87144": {
    DMA: 790,
  },
  "87151": {
    DMA: 790,
  },
  "87153": {
    DMA: 790,
  },
  "87154": {
    DMA: 790,
  },
  "87158": {
    DMA: 790,
  },
  "87165": {
    DMA: 790,
  },
  "87174": {
    DMA: 790,
  },
  "87176": {
    DMA: 790,
  },
  "87181": {
    DMA: 790,
  },
  "87184": {
    DMA: 790,
  },
  "87185": {
    DMA: 790,
  },
  "87187": {
    DMA: 790,
  },
  "87190": {
    DMA: 790,
  },
  "87191": {
    DMA: 790,
  },
  "87192": {
    DMA: 790,
  },
  "87193": {
    DMA: 790,
  },
  "87194": {
    DMA: 790,
  },
  "87195": {
    DMA: 790,
  },
  "87196": {
    DMA: 790,
  },
  "87197": {
    DMA: 790,
  },
  "87198": {
    DMA: 790,
  },
  "87199": {
    DMA: 790,
  },
  "87301": {
    DMA: 790,
  },
  "87302": {
    DMA: 790,
  },
  "87305": {
    DMA: 790,
  },
  "87310": {
    DMA: 790,
  },
  "87311": {
    DMA: 790,
  },
  "87312": {
    DMA: 790,
  },
  "87313": {
    DMA: 790,
  },
  "87315": {
    DMA: 790,
  },
  "87316": {
    DMA: 790,
  },
  "87317": {
    DMA: 790,
  },
  "87319": {
    DMA: 790,
  },
  "87320": {
    DMA: 790,
  },
  "87321": {
    DMA: 790,
  },
  "87322": {
    DMA: 790,
  },
  "87323": {
    DMA: 790,
  },
  "87325": {
    DMA: 790,
  },
  "87326": {
    DMA: 790,
  },
  "87327": {
    DMA: 790,
  },
  "87328": {
    DMA: 790,
  },
  "87347": {
    DMA: 790,
  },
  "87357": {
    DMA: 790,
  },
  "87364": {
    DMA: 790,
  },
  "87365": {
    DMA: 790,
  },
  "87375": {
    DMA: 790,
  },
  "87401": {
    DMA: 790,
  },
  "87402": {
    DMA: 790,
  },
  "87410": {
    DMA: 790,
  },
  "87412": {
    DMA: 790,
  },
  "87413": {
    DMA: 790,
  },
  "87415": {
    DMA: 790,
  },
  "87416": {
    DMA: 790,
  },
  "87417": {
    DMA: 790,
  },
  "87418": {
    DMA: 790,
  },
  "87419": {
    DMA: 790,
  },
  "87420": {
    DMA: 790,
  },
  "87421": {
    DMA: 790,
  },
  "87455": {
    DMA: 790,
  },
  "87461": {
    DMA: 790,
  },
  "87499": {
    DMA: 790,
  },
  "87501": {
    DMA: 790,
  },
  "87502": {
    DMA: 790,
  },
  "87503": {
    DMA: 790,
  },
  "87504": {
    DMA: 790,
  },
  "87505": {
    DMA: 790,
  },
  "87506": {
    DMA: 790,
  },
  "87507": {
    DMA: 790,
  },
  "87508": {
    DMA: 790,
  },
  "87509": {
    DMA: 790,
  },
  "87510": {
    DMA: 790,
  },
  "87511": {
    DMA: 790,
  },
  "87512": {
    DMA: 790,
  },
  "87513": {
    DMA: 790,
  },
  "87514": {
    DMA: 790,
  },
  "87515": {
    DMA: 790,
  },
  "87516": {
    DMA: 790,
  },
  "87517": {
    DMA: 790,
  },
  "87518": {
    DMA: 790,
  },
  "87519": {
    DMA: 790,
  },
  "87520": {
    DMA: 790,
  },
  "87521": {
    DMA: 790,
  },
  "87522": {
    DMA: 790,
  },
  "87523": {
    DMA: 790,
  },
  "87524": {
    DMA: 790,
  },
  "87525": {
    DMA: 790,
  },
  "87527": {
    DMA: 790,
  },
  "87528": {
    DMA: 790,
  },
  "87529": {
    DMA: 790,
  },
  "87530": {
    DMA: 790,
  },
  "87531": {
    DMA: 790,
  },
  "87532": {
    DMA: 790,
  },
  "87533": {
    DMA: 790,
  },
  "87535": {
    DMA: 790,
  },
  "87537": {
    DMA: 790,
  },
  "87538": {
    DMA: 790,
  },
  "87539": {
    DMA: 790,
  },
  "87540": {
    DMA: 790,
  },
  "87543": {
    DMA: 790,
  },
  "87544": {
    DMA: 790,
  },
  "87545": {
    DMA: 790,
  },
  "87547": {
    DMA: 790,
  },
  "87548": {
    DMA: 790,
  },
  "87549": {
    DMA: 790,
  },
  "87551": {
    DMA: 790,
  },
  "87552": {
    DMA: 790,
  },
  "87553": {
    DMA: 790,
  },
  "87554": {
    DMA: 790,
  },
  "87556": {
    DMA: 790,
  },
  "87557": {
    DMA: 790,
  },
  "87558": {
    DMA: 790,
  },
  "87560": {
    DMA: 790,
  },
  "87562": {
    DMA: 790,
  },
  "87564": {
    DMA: 790,
  },
  "87565": {
    DMA: 790,
  },
  "87566": {
    DMA: 790,
  },
  "87567": {
    DMA: 790,
  },
  "87569": {
    DMA: 790,
  },
  "87571": {
    DMA: 790,
  },
  "87573": {
    DMA: 790,
  },
  "87574": {
    DMA: 790,
  },
  "87575": {
    DMA: 790,
  },
  "87576": {
    DMA: 790,
  },
  "87577": {
    DMA: 790,
  },
  "87578": {
    DMA: 790,
  },
  "87579": {
    DMA: 790,
  },
  "87580": {
    DMA: 790,
  },
  "87581": {
    DMA: 790,
  },
  "87582": {
    DMA: 790,
  },
  "87583": {
    DMA: 790,
  },
  "87592": {
    DMA: 790,
  },
  "87594": {
    DMA: 790,
  },
  "87654": {
    DMA: 790,
  },
  "87701": {
    DMA: 790,
  },
  "87710": {
    DMA: 790,
  },
  "87711": {
    DMA: 790,
  },
  "87712": {
    DMA: 790,
  },
  "87713": {
    DMA: 790,
  },
  "87714": {
    DMA: 790,
  },
  "87715": {
    DMA: 790,
  },
  "87718": {
    DMA: 790,
  },
  "87722": {
    DMA: 790,
  },
  "87723": {
    DMA: 790,
  },
  "87724": {
    DMA: 790,
  },
  "87728": {
    DMA: 790,
  },
  "87729": {
    DMA: 790,
  },
  "87730": {
    DMA: 790,
  },
  "87731": {
    DMA: 790,
  },
  "87732": {
    DMA: 790,
  },
  "87733": {
    DMA: 790,
  },
  "87734": {
    DMA: 790,
  },
  "87735": {
    DMA: 790,
  },
  "87736": {
    DMA: 790,
  },
  "87740": {
    DMA: 790,
  },
  "87742": {
    DMA: 790,
  },
  "87743": {
    DMA: 790,
  },
  "87745": {
    DMA: 790,
  },
  "87746": {
    DMA: 790,
  },
  "87747": {
    DMA: 790,
  },
  "87749": {
    DMA: 790,
  },
  "87750": {
    DMA: 790,
  },
  "87752": {
    DMA: 790,
  },
  "87753": {
    DMA: 790,
  },
  "87801": {
    DMA: 790,
  },
  "87820": {
    DMA: 790,
  },
  "87821": {
    DMA: 790,
  },
  "87823": {
    DMA: 790,
  },
  "87824": {
    DMA: 790,
  },
  "87825": {
    DMA: 790,
  },
  "87827": {
    DMA: 790,
  },
  "87828": {
    DMA: 790,
  },
  "87829": {
    DMA: 790,
  },
  "87830": {
    DMA: 790,
  },
  "87831": {
    DMA: 790,
  },
  "87832": {
    DMA: 790,
  },
  "87901": {
    DMA: 790,
  },
  "87930": {
    DMA: 790,
  },
  "87931": {
    DMA: 790,
  },
  "87933": {
    DMA: 790,
  },
  "87935": {
    DMA: 790,
  },
  "87936": {
    DMA: 765,
  },
  "87937": {
    DMA: 765,
  },
  "87939": {
    DMA: 790,
  },
  "87940": {
    DMA: 765,
  },
  "87941": {
    DMA: 765,
  },
  "87942": {
    DMA: 790,
  },
  "87943": {
    DMA: 790,
  },
  "88001": {
    DMA: 765,
  },
  "88002": {
    DMA: 765,
  },
  "88003": {
    DMA: 765,
  },
  "88004": {
    DMA: 765,
  },
  "88005": {
    DMA: 765,
  },
  "88006": {
    DMA: 765,
  },
  "88007": {
    DMA: 765,
  },
  "88008": {
    DMA: 765,
  },
  "88009": {
    DMA: 790,
  },
  "88011": {
    DMA: 765,
  },
  "88012": {
    DMA: 765,
  },
  "88013": {
    DMA: 765,
  },
  "88020": {
    DMA: 790,
  },
  "88021": {
    DMA: 765,
  },
  "88022": {
    DMA: 790,
  },
  "88023": {
    DMA: 790,
  },
  "88024": {
    DMA: 765,
  },
  "88025": {
    DMA: 790,
  },
  "88026": {
    DMA: 790,
  },
  "88027": {
    DMA: 765,
  },
  "88028": {
    DMA: 790,
  },
  "88029": {
    DMA: 790,
  },
  "88030": {
    DMA: 790,
  },
  "88031": {
    DMA: 790,
  },
  "88032": {
    DMA: 765,
  },
  "88033": {
    DMA: 765,
  },
  "88034": {
    DMA: 790,
  },
  "88036": {
    DMA: 790,
  },
  "88038": {
    DMA: 790,
  },
  "88039": {
    DMA: 790,
  },
  "88040": {
    DMA: 790,
  },
  "88041": {
    DMA: 790,
  },
  "88042": {
    DMA: 790,
  },
  "88043": {
    DMA: 790,
  },
  "88044": {
    DMA: 765,
  },
  "88045": {
    DMA: 790,
  },
  "88046": {
    DMA: 765,
  },
  "88047": {
    DMA: 765,
  },
  "88048": {
    DMA: 765,
  },
  "88049": {
    DMA: 790,
  },
  "88051": {
    DMA: 790,
  },
  "88052": {
    DMA: 765,
  },
  "88053": {
    DMA: 790,
  },
  "88054": {
    DMA: 765,
  },
  "88055": {
    DMA: 790,
  },
  "88056": {
    DMA: 790,
  },
  "88058": {
    DMA: 765,
  },
  "88061": {
    DMA: 790,
  },
  "88062": {
    DMA: 790,
  },
  "88063": {
    DMA: 765,
  },
  "88065": {
    DMA: 790,
  },
  "88072": {
    DMA: 765,
  },
  "88081": {
    DMA: 765,
  },
  "88101": {
    DMA: 634,
  },
  "88102": {
    DMA: 634,
  },
  "88103": {
    DMA: 634,
  },
  "88112": {
    DMA: 634,
  },
  "88113": {
    DMA: 634,
  },
  "88114": {
    DMA: 790,
  },
  "88115": {
    DMA: 634,
  },
  "88116": {
    DMA: 634,
  },
  "88118": {
    DMA: 634,
  },
  "88119": {
    DMA: 790,
  },
  "88120": {
    DMA: 634,
  },
  "88121": {
    DMA: 634,
  },
  "88122": {
    DMA: 634,
  },
  "88123": {
    DMA: 634,
  },
  "88124": {
    DMA: 634,
  },
  "88125": {
    DMA: 634,
  },
  "88126": {
    DMA: 634,
  },
  "88130": {
    DMA: 634,
  },
  "88132": {
    DMA: 634,
  },
  "88133": {
    DMA: 634,
  },
  "88134": {
    DMA: 790,
  },
  "88135": {
    DMA: 634,
  },
  "88136": {
    DMA: 790,
  },
  "88201": {
    DMA: 790,
  },
  "88202": {
    DMA: 790,
  },
  "88203": {
    DMA: 790,
  },
  "88210": {
    DMA: 790,
  },
  "88211": {
    DMA: 790,
  },
  "88213": {
    DMA: 790,
  },
  "88220": {
    DMA: 790,
  },
  "88221": {
    DMA: 790,
  },
  "88230": {
    DMA: 790,
  },
  "88231": {
    DMA: 790,
  },
  "88232": {
    DMA: 790,
  },
  "88240": {
    DMA: 790,
  },
  "88241": {
    DMA: 790,
  },
  "88242": {
    DMA: 790,
  },
  "88244": {
    DMA: 790,
  },
  "88250": {
    DMA: 790,
  },
  "88252": {
    DMA: 790,
  },
  "88253": {
    DMA: 790,
  },
  "88254": {
    DMA: 790,
  },
  "88255": {
    DMA: 790,
  },
  "88256": {
    DMA: 790,
  },
  "88260": {
    DMA: 790,
  },
  "88262": {
    DMA: 790,
  },
  "88263": {
    DMA: 790,
  },
  "88264": {
    DMA: 790,
  },
  "88265": {
    DMA: 790,
  },
  "88267": {
    DMA: 790,
  },
  "88268": {
    DMA: 790,
  },
  "88301": {
    DMA: 790,
  },
  "88310": {
    DMA: 790,
  },
  "88311": {
    DMA: 790,
  },
  "88312": {
    DMA: 790,
  },
  "88314": {
    DMA: 790,
  },
  "88316": {
    DMA: 790,
  },
  "88317": {
    DMA: 790,
  },
  "88318": {
    DMA: 790,
  },
  "88321": {
    DMA: 790,
  },
  "88323": {
    DMA: 790,
  },
  "88324": {
    DMA: 790,
  },
  "88325": {
    DMA: 790,
  },
  "88330": {
    DMA: 790,
  },
  "88336": {
    DMA: 790,
  },
  "88337": {
    DMA: 790,
  },
  "88338": {
    DMA: 790,
  },
  "88339": {
    DMA: 790,
  },
  "88340": {
    DMA: 790,
  },
  "88341": {
    DMA: 790,
  },
  "88342": {
    DMA: 790,
  },
  "88343": {
    DMA: 790,
  },
  "88344": {
    DMA: 790,
  },
  "88345": {
    DMA: 790,
  },
  "88346": {
    DMA: 790,
  },
  "88347": {
    DMA: 790,
  },
  "88348": {
    DMA: 790,
  },
  "88349": {
    DMA: 790,
  },
  "88350": {
    DMA: 790,
  },
  "88351": {
    DMA: 790,
  },
  "88352": {
    DMA: 790,
  },
  "88353": {
    DMA: 790,
  },
  "88354": {
    DMA: 790,
  },
  "88355": {
    DMA: 790,
  },
  "88401": {
    DMA: 634,
  },
  "88410": {
    DMA: 634,
  },
  "88411": {
    DMA: 634,
  },
  "88414": {
    DMA: 634,
  },
  "88415": {
    DMA: 634,
  },
  "88416": {
    DMA: 790,
  },
  "88417": {
    DMA: 790,
  },
  "88418": {
    DMA: 634,
  },
  "88419": {
    DMA: 634,
  },
  "88421": {
    DMA: 790,
  },
  "88422": {
    DMA: 634,
  },
  "88424": {
    DMA: 634,
  },
  "88426": {
    DMA: 634,
  },
  "88427": {
    DMA: 634,
  },
  "88430": {
    DMA: 634,
  },
  "88431": {
    DMA: 790,
  },
  "88433": {
    DMA: 634,
  },
  "88434": {
    DMA: 634,
  },
  "88435": {
    DMA: 790,
  },
  "88436": {
    DMA: 634,
  },
  "88439": {
    DMA: 790,
  },
  "88510": {
    DMA: 765,
  },
  "88511": {
    DMA: 765,
  },
  "88512": {
    DMA: 765,
  },
  "88513": {
    DMA: 765,
  },
  "88514": {
    DMA: 765,
  },
  "88515": {
    DMA: 765,
  },
  "88516": {
    DMA: 765,
  },
  "88517": {
    DMA: 765,
  },
  "88518": {
    DMA: 765,
  },
  "88519": {
    DMA: 765,
  },
  "88520": {
    DMA: 765,
  },
  "88521": {
    DMA: 765,
  },
  "88523": {
    DMA: 765,
  },
  "88524": {
    DMA: 765,
  },
  "88525": {
    DMA: 765,
  },
  "88526": {
    DMA: 765,
  },
  "88527": {
    DMA: 765,
  },
  "88528": {
    DMA: 765,
  },
  "88529": {
    DMA: 765,
  },
  "88530": {
    DMA: 765,
  },
  "88531": {
    DMA: 765,
  },
  "88532": {
    DMA: 765,
  },
  "88533": {
    DMA: 765,
  },
  "88534": {
    DMA: 765,
  },
  "88535": {
    DMA: 765,
  },
  "88536": {
    DMA: 765,
  },
  "88538": {
    DMA: 765,
  },
  "88539": {
    DMA: 765,
  },
  "88540": {
    DMA: 765,
  },
  "88541": {
    DMA: 765,
  },
  "88542": {
    DMA: 765,
  },
  "88543": {
    DMA: 765,
  },
  "88544": {
    DMA: 765,
  },
  "88545": {
    DMA: 765,
  },
  "88546": {
    DMA: 765,
  },
  "88547": {
    DMA: 765,
  },
  "88548": {
    DMA: 765,
  },
  "88549": {
    DMA: 765,
  },
  "88550": {
    DMA: 765,
  },
  "88553": {
    DMA: 765,
  },
  "88554": {
    DMA: 765,
  },
  "88555": {
    DMA: 765,
  },
  "88556": {
    DMA: 765,
  },
  "88557": {
    DMA: 765,
  },
  "88558": {
    DMA: 765,
  },
  "88559": {
    DMA: 765,
  },
  "88560": {
    DMA: 765,
  },
  "88561": {
    DMA: 765,
  },
  "88562": {
    DMA: 765,
  },
  "88563": {
    DMA: 765,
  },
  "88565": {
    DMA: 765,
  },
  "88566": {
    DMA: 765,
  },
  "88567": {
    DMA: 765,
  },
  "88568": {
    DMA: 765,
  },
  "88569": {
    DMA: 765,
  },
  "88570": {
    DMA: 765,
  },
  "88571": {
    DMA: 765,
  },
  "88572": {
    DMA: 765,
  },
  "88573": {
    DMA: 765,
  },
  "88574": {
    DMA: 765,
  },
  "88575": {
    DMA: 765,
  },
  "88576": {
    DMA: 765,
  },
  "88577": {
    DMA: 765,
  },
  "88578": {
    DMA: 765,
  },
  "88579": {
    DMA: 765,
  },
  "88580": {
    DMA: 765,
  },
  "88581": {
    DMA: 765,
  },
  "88582": {
    DMA: 765,
  },
  "88583": {
    DMA: 765,
  },
  "88584": {
    DMA: 765,
  },
  "88585": {
    DMA: 765,
  },
  "88586": {
    DMA: 765,
  },
  "88587": {
    DMA: 765,
  },
  "88588": {
    DMA: 765,
  },
  "88589": {
    DMA: 765,
  },
  "88590": {
    DMA: 765,
  },
  "88595": {
    DMA: 765,
  },
  "88888": {
    DMA: 511,
  },
  "88901": {
    DMA: 839,
  },
  "88905": {
    DMA: 839,
  },
  "89001": {
    DMA: 839,
  },
  "89002": {
    DMA: 839,
  },
  "89003": {
    DMA: 839,
  },
  "89004": {
    DMA: 839,
  },
  "89005": {
    DMA: 839,
  },
  "89006": {
    DMA: 839,
  },
  "89007": {
    DMA: 839,
  },
  "89008": {
    DMA: 839,
  },
  "89009": {
    DMA: 839,
  },
  "89010": {
    DMA: 811,
  },
  "89011": {
    DMA: 839,
  },
  "89012": {
    DMA: 839,
  },
  "89013": {
    DMA: 811,
  },
  "89014": {
    DMA: 839,
  },
  "89015": {
    DMA: 839,
  },
  "89016": {
    DMA: 839,
  },
  "89017": {
    DMA: 839,
  },
  "89018": {
    DMA: 839,
  },
  "89019": {
    DMA: 839,
  },
  "89020": {
    DMA: 839,
  },
  "89021": {
    DMA: 839,
  },
  "89022": {
    DMA: 839,
  },
  "89023": {
    DMA: 839,
  },
  "89024": {
    DMA: 839,
  },
  "89025": {
    DMA: 839,
  },
  "89026": {
    DMA: 839,
  },
  "89027": {
    DMA: 839,
  },
  "89028": {
    DMA: 839,
  },
  "89029": {
    DMA: 839,
  },
  "89030": {
    DMA: 839,
  },
  "89031": {
    DMA: 839,
  },
  "89032": {
    DMA: 839,
  },
  "89033": {
    DMA: 839,
  },
  "89034": {
    DMA: 839,
  },
  "89036": {
    DMA: 839,
  },
  "89037": {
    DMA: 839,
  },
  "89039": {
    DMA: 839,
  },
  "89040": {
    DMA: 839,
  },
  "89041": {
    DMA: 839,
  },
  "89042": {
    DMA: 839,
  },
  "89043": {
    DMA: 839,
  },
  "89044": {
    DMA: 839,
  },
  "89045": {
    DMA: 839,
  },
  "89046": {
    DMA: 839,
  },
  "89047": {
    DMA: 811,
  },
  "89048": {
    DMA: 839,
  },
  "89049": {
    DMA: 839,
  },
  "89052": {
    DMA: 839,
  },
  "89053": {
    DMA: 839,
  },
  "89054": {
    DMA: 839,
  },
  "89060": {
    DMA: 839,
  },
  "89061": {
    DMA: 839,
  },
  "89067": {
    DMA: 839,
  },
  "89070": {
    DMA: 839,
  },
  "89074": {
    DMA: 839,
  },
  "89077": {
    DMA: 839,
  },
  "89081": {
    DMA: 839,
  },
  "89084": {
    DMA: 839,
  },
  "89085": {
    DMA: 839,
  },
  "89086": {
    DMA: 839,
  },
  "89087": {
    DMA: 839,
  },
  "89101": {
    DMA: 839,
  },
  "89102": {
    DMA: 839,
  },
  "89103": {
    DMA: 839,
  },
  "89104": {
    DMA: 839,
  },
  "89105": {
    DMA: 839,
  },
  "89106": {
    DMA: 839,
  },
  "89107": {
    DMA: 839,
  },
  "89108": {
    DMA: 839,
  },
  "89109": {
    DMA: 839,
  },
  "89110": {
    DMA: 839,
  },
  "89111": {
    DMA: 839,
  },
  "89112": {
    DMA: 839,
  },
  "89113": {
    DMA: 839,
  },
  "89114": {
    DMA: 839,
  },
  "89115": {
    DMA: 839,
  },
  "89116": {
    DMA: 839,
  },
  "89117": {
    DMA: 839,
  },
  "89118": {
    DMA: 839,
  },
  "89119": {
    DMA: 839,
  },
  "89120": {
    DMA: 839,
  },
  "89121": {
    DMA: 839,
  },
  "89122": {
    DMA: 839,
  },
  "89123": {
    DMA: 839,
  },
  "89124": {
    DMA: 839,
  },
  "89125": {
    DMA: 839,
  },
  "89126": {
    DMA: 839,
  },
  "89127": {
    DMA: 839,
  },
  "89128": {
    DMA: 839,
  },
  "89129": {
    DMA: 839,
  },
  "89130": {
    DMA: 839,
  },
  "89131": {
    DMA: 839,
  },
  "89132": {
    DMA: 839,
  },
  "89133": {
    DMA: 839,
  },
  "89134": {
    DMA: 839,
  },
  "89135": {
    DMA: 839,
  },
  "89136": {
    DMA: 839,
  },
  "89137": {
    DMA: 839,
  },
  "89138": {
    DMA: 839,
  },
  "89139": {
    DMA: 839,
  },
  "89140": {
    DMA: 839,
  },
  "89141": {
    DMA: 839,
  },
  "89142": {
    DMA: 839,
  },
  "89143": {
    DMA: 839,
  },
  "89144": {
    DMA: 839,
  },
  "89145": {
    DMA: 839,
  },
  "89146": {
    DMA: 839,
  },
  "89147": {
    DMA: 839,
  },
  "89148": {
    DMA: 839,
  },
  "89149": {
    DMA: 839,
  },
  "89150": {
    DMA: 839,
  },
  "89151": {
    DMA: 839,
  },
  "89152": {
    DMA: 839,
  },
  "89153": {
    DMA: 839,
  },
  "89154": {
    DMA: 839,
  },
  "89155": {
    DMA: 839,
  },
  "89156": {
    DMA: 839,
  },
  "89157": {
    DMA: 839,
  },
  "89158": {
    DMA: 839,
  },
  "89159": {
    DMA: 839,
  },
  "89160": {
    DMA: 839,
  },
  "89161": {
    DMA: 839,
  },
  "89162": {
    DMA: 839,
  },
  "89163": {
    DMA: 839,
  },
  "89164": {
    DMA: 839,
  },
  "89165": {
    DMA: 839,
  },
  "89166": {
    DMA: 839,
  },
  "89169": {
    DMA: 839,
  },
  "89170": {
    DMA: 839,
  },
  "89173": {
    DMA: 839,
  },
  "89177": {
    DMA: 839,
  },
  "89178": {
    DMA: 839,
  },
  "89179": {
    DMA: 839,
  },
  "89180": {
    DMA: 839,
  },
  "89183": {
    DMA: 839,
  },
  "89185": {
    DMA: 839,
  },
  "89191": {
    DMA: 839,
  },
  "89193": {
    DMA: 839,
  },
  "89195": {
    DMA: 839,
  },
  "89199": {
    DMA: 839,
  },
  "89301": {
    DMA: 770,
  },
  "89310": {
    DMA: 811,
  },
  "89311": {
    DMA: 770,
  },
  "89314": {
    DMA: 770,
  },
  "89315": {
    DMA: 770,
  },
  "89316": {
    DMA: 770,
  },
  "89317": {
    DMA: 770,
  },
  "89318": {
    DMA: 770,
  },
  "89319": {
    DMA: 770,
  },
  "89402": {
    DMA: 811,
  },
  "89403": {
    DMA: 811,
  },
  "89404": {
    DMA: 811,
  },
  "89405": {
    DMA: 811,
  },
  "89406": {
    DMA: 811,
  },
  "89407": {
    DMA: 811,
  },
  "89408": {
    DMA: 811,
  },
  "89409": {
    DMA: 839,
  },
  "89410": {
    DMA: 811,
  },
  "89411": {
    DMA: 811,
  },
  "89412": {
    DMA: 811,
  },
  "89413": {
    DMA: 811,
  },
  "89414": {
    DMA: 811,
  },
  "89415": {
    DMA: 811,
  },
  "89418": {
    DMA: 811,
  },
  "89419": {
    DMA: 811,
  },
  "89420": {
    DMA: 811,
  },
  "89421": {
    DMA: 811,
  },
  "89422": {
    DMA: 811,
  },
  "89423": {
    DMA: 811,
  },
  "89424": {
    DMA: 811,
  },
  "89425": {
    DMA: 811,
  },
  "89426": {
    DMA: 811,
  },
  "89427": {
    DMA: 811,
  },
  "89428": {
    DMA: 811,
  },
  "89429": {
    DMA: 811,
  },
  "89430": {
    DMA: 811,
  },
  "89431": {
    DMA: 811,
  },
  "89432": {
    DMA: 811,
  },
  "89433": {
    DMA: 811,
  },
  "89434": {
    DMA: 811,
  },
  "89435": {
    DMA: 811,
  },
  "89436": {
    DMA: 811,
  },
  "89437": {
    DMA: 811,
  },
  "89438": {
    DMA: 811,
  },
  "89439": {
    DMA: 811,
  },
  "89440": {
    DMA: 811,
  },
  "89441": {
    DMA: 811,
  },
  "89442": {
    DMA: 811,
  },
  "89444": {
    DMA: 811,
  },
  "89445": {
    DMA: 811,
  },
  "89446": {
    DMA: 811,
  },
  "89447": {
    DMA: 811,
  },
  "89448": {
    DMA: 811,
  },
  "89449": {
    DMA: 811,
  },
  "89450": {
    DMA: 811,
  },
  "89451": {
    DMA: 811,
  },
  "89452": {
    DMA: 811,
  },
  "89460": {
    DMA: 811,
  },
  "89496": {
    DMA: 811,
  },
  "89501": {
    DMA: 811,
  },
  "89502": {
    DMA: 811,
  },
  "89503": {
    DMA: 811,
  },
  "89504": {
    DMA: 811,
  },
  "89505": {
    DMA: 811,
  },
  "89506": {
    DMA: 811,
  },
  "89507": {
    DMA: 811,
  },
  "89508": {
    DMA: 811,
  },
  "89509": {
    DMA: 811,
  },
  "89510": {
    DMA: 811,
  },
  "89511": {
    DMA: 811,
  },
  "89512": {
    DMA: 811,
  },
  "89513": {
    DMA: 811,
  },
  "89515": {
    DMA: 811,
  },
  "89519": {
    DMA: 811,
  },
  "89520": {
    DMA: 811,
  },
  "89521": {
    DMA: 811,
  },
  "89523": {
    DMA: 811,
  },
  "89533": {
    DMA: 811,
  },
  "89555": {
    DMA: 811,
  },
  "89557": {
    DMA: 811,
  },
  "89570": {
    DMA: 811,
  },
  "89595": {
    DMA: 811,
  },
  "89599": {
    DMA: 811,
  },
  "89701": {
    DMA: 811,
  },
  "89702": {
    DMA: 811,
  },
  "89703": {
    DMA: 811,
  },
  "89704": {
    DMA: 811,
  },
  "89705": {
    DMA: 811,
  },
  "89706": {
    DMA: 811,
  },
  "89711": {
    DMA: 811,
  },
  "89712": {
    DMA: 811,
  },
  "89713": {
    DMA: 811,
  },
  "89714": {
    DMA: 811,
  },
  "89721": {
    DMA: 811,
  },
  "89801": {
    DMA: 770,
  },
  "89802": {
    DMA: 770,
  },
  "89803": {
    DMA: 770,
  },
  "89815": {
    DMA: 770,
  },
  "89820": {
    DMA: 811,
  },
  "89821": {
    DMA: 770,
  },
  "89822": {
    DMA: 770,
  },
  "89823": {
    DMA: 770,
  },
  "89824": {
    DMA: 770,
  },
  "89825": {
    DMA: 770,
  },
  "89826": {
    DMA: 770,
  },
  "89828": {
    DMA: 770,
  },
  "89830": {
    DMA: 770,
  },
  "89831": {
    DMA: 770,
  },
  "89832": {
    DMA: 770,
  },
  "89833": {
    DMA: 770,
  },
  "89834": {
    DMA: 770,
  },
  "89835": {
    DMA: 770,
  },
  "89883": {
    DMA: 770,
  },
  "90001": {
    DMA: 803,
  },
  "90002": {
    DMA: 803,
  },
  "90003": {
    DMA: 803,
  },
  "90004": {
    DMA: 803,
  },
  "90005": {
    DMA: 803,
  },
  "90006": {
    DMA: 803,
  },
  "90007": {
    DMA: 803,
  },
  "90008": {
    DMA: 803,
  },
  "90009": {
    DMA: 803,
  },
  "90010": {
    DMA: 803,
  },
  "90011": {
    DMA: 803,
  },
  "90012": {
    DMA: 803,
  },
  "90013": {
    DMA: 803,
  },
  "90014": {
    DMA: 803,
  },
  "90015": {
    DMA: 803,
  },
  "90016": {
    DMA: 803,
  },
  "90017": {
    DMA: 803,
  },
  "90018": {
    DMA: 803,
  },
  "90019": {
    DMA: 803,
  },
  "90020": {
    DMA: 803,
  },
  "90021": {
    DMA: 803,
  },
  "90022": {
    DMA: 803,
  },
  "90023": {
    DMA: 803,
  },
  "90024": {
    DMA: 803,
  },
  "90025": {
    DMA: 803,
  },
  "90026": {
    DMA: 803,
  },
  "90027": {
    DMA: 803,
  },
  "90028": {
    DMA: 803,
  },
  "90029": {
    DMA: 803,
  },
  "90030": {
    DMA: 803,
  },
  "90031": {
    DMA: 803,
  },
  "90032": {
    DMA: 803,
  },
  "90033": {
    DMA: 803,
  },
  "90034": {
    DMA: 803,
  },
  "90035": {
    DMA: 803,
  },
  "90036": {
    DMA: 803,
  },
  "90037": {
    DMA: 803,
  },
  "90038": {
    DMA: 803,
  },
  "90039": {
    DMA: 803,
  },
  "90040": {
    DMA: 803,
  },
  "90041": {
    DMA: 803,
  },
  "90042": {
    DMA: 803,
  },
  "90043": {
    DMA: 803,
  },
  "90044": {
    DMA: 803,
  },
  "90045": {
    DMA: 803,
  },
  "90046": {
    DMA: 803,
  },
  "90047": {
    DMA: 803,
  },
  "90048": {
    DMA: 803,
  },
  "90049": {
    DMA: 803,
  },
  "90050": {
    DMA: 803,
  },
  "90051": {
    DMA: 803,
  },
  "90052": {
    DMA: 803,
  },
  "90053": {
    DMA: 803,
  },
  "90054": {
    DMA: 803,
  },
  "90055": {
    DMA: 803,
  },
  "90056": {
    DMA: 803,
  },
  "90057": {
    DMA: 803,
  },
  "90058": {
    DMA: 803,
  },
  "90059": {
    DMA: 803,
  },
  "90060": {
    DMA: 803,
  },
  "90061": {
    DMA: 803,
  },
  "90062": {
    DMA: 803,
  },
  "90063": {
    DMA: 803,
  },
  "90064": {
    DMA: 803,
  },
  "90065": {
    DMA: 803,
  },
  "90066": {
    DMA: 803,
  },
  "90067": {
    DMA: 803,
  },
  "90068": {
    DMA: 803,
  },
  "90069": {
    DMA: 803,
  },
  "90070": {
    DMA: 803,
  },
  "90071": {
    DMA: 803,
  },
  "90072": {
    DMA: 803,
  },
  "90073": {
    DMA: 803,
  },
  "90074": {
    DMA: 803,
  },
  "90075": {
    DMA: 803,
  },
  "90076": {
    DMA: 803,
  },
  "90077": {
    DMA: 803,
  },
  "90078": {
    DMA: 803,
  },
  "90079": {
    DMA: 803,
  },
  "90080": {
    DMA: 803,
  },
  "90081": {
    DMA: 803,
  },
  "90082": {
    DMA: 803,
  },
  "90083": {
    DMA: 803,
  },
  "90084": {
    DMA: 803,
  },
  "90086": {
    DMA: 803,
  },
  "90087": {
    DMA: 803,
  },
  "90088": {
    DMA: 803,
  },
  "90089": {
    DMA: 803,
  },
  "90090": {
    DMA: 803,
  },
  "90091": {
    DMA: 803,
  },
  "90093": {
    DMA: 803,
  },
  "90094": {
    DMA: 803,
  },
  "90095": {
    DMA: 803,
  },
  "90096": {
    DMA: 803,
  },
  "90099": {
    DMA: 803,
  },
  "90101": {
    DMA: 803,
  },
  "90102": {
    DMA: 803,
  },
  "90103": {
    DMA: 803,
  },
  "90134": {
    DMA: 803,
  },
  "90189": {
    DMA: 803,
  },
  "90201": {
    DMA: 803,
  },
  "90202": {
    DMA: 803,
  },
  "90209": {
    DMA: 803,
  },
  "90210": {
    DMA: 803,
  },
  "90211": {
    DMA: 803,
  },
  "90212": {
    DMA: 803,
  },
  "90213": {
    DMA: 803,
  },
  "90220": {
    DMA: 803,
  },
  "90221": {
    DMA: 803,
  },
  "90222": {
    DMA: 803,
  },
  "90223": {
    DMA: 803,
  },
  "90224": {
    DMA: 803,
  },
  "90230": {
    DMA: 803,
  },
  "90231": {
    DMA: 803,
  },
  "90232": {
    DMA: 803,
  },
  "90233": {
    DMA: 803,
  },
  "90239": {
    DMA: 803,
  },
  "90240": {
    DMA: 803,
  },
  "90241": {
    DMA: 803,
  },
  "90242": {
    DMA: 803,
  },
  "90245": {
    DMA: 803,
  },
  "90247": {
    DMA: 803,
  },
  "90248": {
    DMA: 803,
  },
  "90249": {
    DMA: 803,
  },
  "90250": {
    DMA: 803,
  },
  "90251": {
    DMA: 803,
  },
  "90254": {
    DMA: 803,
  },
  "90255": {
    DMA: 803,
  },
  "90260": {
    DMA: 803,
  },
  "90261": {
    DMA: 803,
  },
  "90262": {
    DMA: 803,
  },
  "90263": {
    DMA: 803,
  },
  "90264": {
    DMA: 803,
  },
  "90265": {
    DMA: 803,
  },
  "90266": {
    DMA: 803,
  },
  "90267": {
    DMA: 803,
  },
  "90270": {
    DMA: 803,
  },
  "90272": {
    DMA: 803,
  },
  "90274": {
    DMA: 803,
  },
  "90275": {
    DMA: 803,
  },
  "90277": {
    DMA: 803,
  },
  "90278": {
    DMA: 803,
  },
  "90280": {
    DMA: 803,
  },
  "90290": {
    DMA: 803,
  },
  "90291": {
    DMA: 803,
  },
  "90292": {
    DMA: 803,
  },
  "90293": {
    DMA: 803,
  },
  "90294": {
    DMA: 803,
  },
  "90295": {
    DMA: 803,
  },
  "90296": {
    DMA: 803,
  },
  "90301": {
    DMA: 803,
  },
  "90302": {
    DMA: 803,
  },
  "90303": {
    DMA: 803,
  },
  "90304": {
    DMA: 803,
  },
  "90305": {
    DMA: 803,
  },
  "90306": {
    DMA: 803,
  },
  "90307": {
    DMA: 803,
  },
  "90308": {
    DMA: 803,
  },
  "90309": {
    DMA: 803,
  },
  "90310": {
    DMA: 803,
  },
  "90311": {
    DMA: 803,
  },
  "90312": {
    DMA: 803,
  },
  "90313": {
    DMA: 803,
  },
  "90397": {
    DMA: 803,
  },
  "90398": {
    DMA: 803,
  },
  "90401": {
    DMA: 803,
  },
  "90402": {
    DMA: 803,
  },
  "90403": {
    DMA: 803,
  },
  "90404": {
    DMA: 803,
  },
  "90405": {
    DMA: 803,
  },
  "90406": {
    DMA: 803,
  },
  "90407": {
    DMA: 803,
  },
  "90408": {
    DMA: 803,
  },
  "90409": {
    DMA: 803,
  },
  "90410": {
    DMA: 803,
  },
  "90411": {
    DMA: 803,
  },
  "90501": {
    DMA: 803,
  },
  "90502": {
    DMA: 803,
  },
  "90503": {
    DMA: 803,
  },
  "90504": {
    DMA: 803,
  },
  "90505": {
    DMA: 803,
  },
  "90506": {
    DMA: 803,
  },
  "90507": {
    DMA: 803,
  },
  "90508": {
    DMA: 803,
  },
  "90509": {
    DMA: 803,
  },
  "90510": {
    DMA: 803,
  },
  "90601": {
    DMA: 803,
  },
  "90602": {
    DMA: 803,
  },
  "90603": {
    DMA: 803,
  },
  "90604": {
    DMA: 803,
  },
  "90605": {
    DMA: 803,
  },
  "90606": {
    DMA: 803,
  },
  "90607": {
    DMA: 803,
  },
  "90608": {
    DMA: 803,
  },
  "90609": {
    DMA: 803,
  },
  "90610": {
    DMA: 803,
  },
  "90612": {
    DMA: 803,
  },
  "90620": {
    DMA: 803,
  },
  "90621": {
    DMA: 803,
  },
  "90622": {
    DMA: 803,
  },
  "90623": {
    DMA: 803,
  },
  "90624": {
    DMA: 803,
  },
  "90630": {
    DMA: 803,
  },
  "90631": {
    DMA: 803,
  },
  "90632": {
    DMA: 803,
  },
  "90633": {
    DMA: 803,
  },
  "90637": {
    DMA: 803,
  },
  "90638": {
    DMA: 803,
  },
  "90639": {
    DMA: 803,
  },
  "90640": {
    DMA: 803,
  },
  "90650": {
    DMA: 803,
  },
  "90651": {
    DMA: 803,
  },
  "90652": {
    DMA: 803,
  },
  "90659": {
    DMA: 803,
  },
  "90660": {
    DMA: 803,
  },
  "90661": {
    DMA: 803,
  },
  "90662": {
    DMA: 803,
  },
  "90670": {
    DMA: 803,
  },
  "90671": {
    DMA: 803,
  },
  "90680": {
    DMA: 803,
  },
  "90701": {
    DMA: 803,
  },
  "90702": {
    DMA: 803,
  },
  "90703": {
    DMA: 803,
  },
  "90704": {
    DMA: 803,
  },
  "90706": {
    DMA: 803,
  },
  "90707": {
    DMA: 803,
  },
  "90710": {
    DMA: 803,
  },
  "90711": {
    DMA: 803,
  },
  "90712": {
    DMA: 803,
  },
  "90713": {
    DMA: 803,
  },
  "90714": {
    DMA: 803,
  },
  "90715": {
    DMA: 803,
  },
  "90716": {
    DMA: 803,
  },
  "90717": {
    DMA: 803,
  },
  "90720": {
    DMA: 803,
  },
  "90721": {
    DMA: 803,
  },
  "90723": {
    DMA: 803,
  },
  "90731": {
    DMA: 803,
  },
  "90732": {
    DMA: 803,
  },
  "90733": {
    DMA: 803,
  },
  "90734": {
    DMA: 803,
  },
  "90740": {
    DMA: 803,
  },
  "90742": {
    DMA: 803,
  },
  "90743": {
    DMA: 803,
  },
  "90744": {
    DMA: 803,
  },
  "90745": {
    DMA: 803,
  },
  "90746": {
    DMA: 803,
  },
  "90747": {
    DMA: 803,
  },
  "90748": {
    DMA: 803,
  },
  "90749": {
    DMA: 803,
  },
  "90755": {
    DMA: 803,
  },
  "90801": {
    DMA: 803,
  },
  "90802": {
    DMA: 803,
  },
  "90803": {
    DMA: 803,
  },
  "90804": {
    DMA: 803,
  },
  "90805": {
    DMA: 803,
  },
  "90806": {
    DMA: 803,
  },
  "90807": {
    DMA: 803,
  },
  "90808": {
    DMA: 803,
  },
  "90809": {
    DMA: 803,
  },
  "90810": {
    DMA: 803,
  },
  "90813": {
    DMA: 803,
  },
  "90814": {
    DMA: 803,
  },
  "90815": {
    DMA: 803,
  },
  "90822": {
    DMA: 803,
  },
  "90831": {
    DMA: 803,
  },
  "90832": {
    DMA: 803,
  },
  "90833": {
    DMA: 803,
  },
  "90834": {
    DMA: 803,
  },
  "90835": {
    DMA: 803,
  },
  "90840": {
    DMA: 803,
  },
  "90842": {
    DMA: 803,
  },
  "90844": {
    DMA: 803,
  },
  "90845": {
    DMA: 803,
  },
  "90846": {
    DMA: 803,
  },
  "90847": {
    DMA: 803,
  },
  "90848": {
    DMA: 803,
  },
  "90853": {
    DMA: 803,
  },
  "90888": {
    DMA: 803,
  },
  "90895": {
    DMA: 803,
  },
  "90899": {
    DMA: 803,
  },
  "91001": {
    DMA: 803,
  },
  "91003": {
    DMA: 803,
  },
  "91006": {
    DMA: 803,
  },
  "91007": {
    DMA: 803,
  },
  "91008": {
    DMA: 803,
  },
  "91009": {
    DMA: 803,
  },
  "91010": {
    DMA: 803,
  },
  "91011": {
    DMA: 803,
  },
  "91012": {
    DMA: 803,
  },
  "91016": {
    DMA: 803,
  },
  "91017": {
    DMA: 803,
  },
  "91020": {
    DMA: 803,
  },
  "91021": {
    DMA: 803,
  },
  "91023": {
    DMA: 803,
  },
  "91024": {
    DMA: 803,
  },
  "91025": {
    DMA: 803,
  },
  "91030": {
    DMA: 803,
  },
  "91031": {
    DMA: 803,
  },
  "91040": {
    DMA: 803,
  },
  "91041": {
    DMA: 803,
  },
  "91042": {
    DMA: 803,
  },
  "91043": {
    DMA: 803,
  },
  "91046": {
    DMA: 803,
  },
  "91066": {
    DMA: 803,
  },
  "91077": {
    DMA: 803,
  },
  "91101": {
    DMA: 803,
  },
  "91102": {
    DMA: 803,
  },
  "91103": {
    DMA: 803,
  },
  "91104": {
    DMA: 803,
  },
  "91105": {
    DMA: 803,
  },
  "91106": {
    DMA: 803,
  },
  "91107": {
    DMA: 803,
  },
  "91108": {
    DMA: 803,
  },
  "91109": {
    DMA: 803,
  },
  "91110": {
    DMA: 803,
  },
  "91114": {
    DMA: 803,
  },
  "91115": {
    DMA: 803,
  },
  "91116": {
    DMA: 803,
  },
  "91117": {
    DMA: 803,
  },
  "91118": {
    DMA: 803,
  },
  "91121": {
    DMA: 803,
  },
  "91123": {
    DMA: 803,
  },
  "91124": {
    DMA: 803,
  },
  "91125": {
    DMA: 803,
  },
  "91126": {
    DMA: 803,
  },
  "91129": {
    DMA: 803,
  },
  "91131": {
    DMA: 803,
  },
  "91182": {
    DMA: 803,
  },
  "91184": {
    DMA: 803,
  },
  "91185": {
    DMA: 803,
  },
  "91188": {
    DMA: 803,
  },
  "91189": {
    DMA: 803,
  },
  "91191": {
    DMA: 803,
  },
  "91199": {
    DMA: 803,
  },
  "91201": {
    DMA: 803,
  },
  "91202": {
    DMA: 803,
  },
  "91203": {
    DMA: 803,
  },
  "91204": {
    DMA: 803,
  },
  "91205": {
    DMA: 803,
  },
  "91206": {
    DMA: 803,
  },
  "91207": {
    DMA: 803,
  },
  "91208": {
    DMA: 803,
  },
  "91209": {
    DMA: 803,
  },
  "91210": {
    DMA: 803,
  },
  "91214": {
    DMA: 803,
  },
  "91221": {
    DMA: 803,
  },
  "91222": {
    DMA: 803,
  },
  "91224": {
    DMA: 803,
  },
  "91225": {
    DMA: 803,
  },
  "91226": {
    DMA: 803,
  },
  "91301": {
    DMA: 803,
  },
  "91302": {
    DMA: 803,
  },
  "91303": {
    DMA: 803,
  },
  "91304": {
    DMA: 803,
  },
  "91305": {
    DMA: 803,
  },
  "91306": {
    DMA: 803,
  },
  "91307": {
    DMA: 803,
  },
  "91308": {
    DMA: 803,
  },
  "91309": {
    DMA: 803,
  },
  "91310": {
    DMA: 803,
  },
  "91311": {
    DMA: 803,
  },
  "91313": {
    DMA: 803,
  },
  "91316": {
    DMA: 803,
  },
  "91319": {
    DMA: 803,
  },
  "91320": {
    DMA: 803,
  },
  "91321": {
    DMA: 803,
  },
  "91322": {
    DMA: 803,
  },
  "91324": {
    DMA: 803,
  },
  "91325": {
    DMA: 803,
  },
  "91326": {
    DMA: 803,
  },
  "91327": {
    DMA: 803,
  },
  "91328": {
    DMA: 803,
  },
  "91329": {
    DMA: 803,
  },
  "91330": {
    DMA: 803,
  },
  "91331": {
    DMA: 803,
  },
  "91333": {
    DMA: 803,
  },
  "91334": {
    DMA: 803,
  },
  "91335": {
    DMA: 803,
  },
  "91337": {
    DMA: 803,
  },
  "91340": {
    DMA: 803,
  },
  "91341": {
    DMA: 803,
  },
  "91342": {
    DMA: 803,
  },
  "91343": {
    DMA: 803,
  },
  "91344": {
    DMA: 803,
  },
  "91345": {
    DMA: 803,
  },
  "91346": {
    DMA: 803,
  },
  "91350": {
    DMA: 803,
  },
  "91351": {
    DMA: 803,
  },
  "91352": {
    DMA: 803,
  },
  "91353": {
    DMA: 803,
  },
  "91354": {
    DMA: 803,
  },
  "91355": {
    DMA: 803,
  },
  "91356": {
    DMA: 803,
  },
  "91357": {
    DMA: 803,
  },
  "91358": {
    DMA: 803,
  },
  "91359": {
    DMA: 803,
  },
  "91360": {
    DMA: 803,
  },
  "91361": {
    DMA: 803,
  },
  "91362": {
    DMA: 803,
  },
  "91363": {
    DMA: 803,
  },
  "91364": {
    DMA: 803,
  },
  "91365": {
    DMA: 803,
  },
  "91367": {
    DMA: 803,
  },
  "91371": {
    DMA: 803,
  },
  "91372": {
    DMA: 803,
  },
  "91376": {
    DMA: 803,
  },
  "91377": {
    DMA: 803,
  },
  "91380": {
    DMA: 803,
  },
  "91381": {
    DMA: 803,
  },
  "91382": {
    DMA: 803,
  },
  "91383": {
    DMA: 803,
  },
  "91384": {
    DMA: 803,
  },
  "91385": {
    DMA: 803,
  },
  "91386": {
    DMA: 803,
  },
  "91387": {
    DMA: 803,
  },
  "91388": {
    DMA: 803,
  },
  "91390": {
    DMA: 803,
  },
  "91392": {
    DMA: 803,
  },
  "91393": {
    DMA: 803,
  },
  "91394": {
    DMA: 803,
  },
  "91395": {
    DMA: 803,
  },
  "91396": {
    DMA: 803,
  },
  "91399": {
    DMA: 803,
  },
  "91401": {
    DMA: 803,
  },
  "91402": {
    DMA: 803,
  },
  "91403": {
    DMA: 803,
  },
  "91404": {
    DMA: 803,
  },
  "91405": {
    DMA: 803,
  },
  "91406": {
    DMA: 803,
  },
  "91407": {
    DMA: 803,
  },
  "91408": {
    DMA: 803,
  },
  "91409": {
    DMA: 803,
  },
  "91410": {
    DMA: 803,
  },
  "91411": {
    DMA: 803,
  },
  "91412": {
    DMA: 803,
  },
  "91413": {
    DMA: 803,
  },
  "91416": {
    DMA: 803,
  },
  "91423": {
    DMA: 803,
  },
  "91426": {
    DMA: 803,
  },
  "91436": {
    DMA: 803,
  },
  "91470": {
    DMA: 803,
  },
  "91482": {
    DMA: 803,
  },
  "91495": {
    DMA: 803,
  },
  "91496": {
    DMA: 803,
  },
  "91497": {
    DMA: 803,
  },
  "91499": {
    DMA: 803,
  },
  "91501": {
    DMA: 803,
  },
  "91502": {
    DMA: 803,
  },
  "91503": {
    DMA: 803,
  },
  "91504": {
    DMA: 803,
  },
  "91505": {
    DMA: 803,
  },
  "91506": {
    DMA: 803,
  },
  "91507": {
    DMA: 803,
  },
  "91508": {
    DMA: 803,
  },
  "91510": {
    DMA: 803,
  },
  "91521": {
    DMA: 803,
  },
  "91522": {
    DMA: 803,
  },
  "91523": {
    DMA: 803,
  },
  "91526": {
    DMA: 803,
  },
  "91601": {
    DMA: 803,
  },
  "91602": {
    DMA: 803,
  },
  "91603": {
    DMA: 803,
  },
  "91604": {
    DMA: 803,
  },
  "91605": {
    DMA: 803,
  },
  "91606": {
    DMA: 803,
  },
  "91607": {
    DMA: 803,
  },
  "91608": {
    DMA: 803,
  },
  "91609": {
    DMA: 803,
  },
  "91610": {
    DMA: 803,
  },
  "91611": {
    DMA: 803,
  },
  "91612": {
    DMA: 803,
  },
  "91614": {
    DMA: 803,
  },
  "91615": {
    DMA: 803,
  },
  "91616": {
    DMA: 803,
  },
  "91617": {
    DMA: 803,
  },
  "91618": {
    DMA: 803,
  },
  "91701": {
    DMA: 803,
  },
  "91702": {
    DMA: 803,
  },
  "91706": {
    DMA: 803,
  },
  "91708": {
    DMA: 803,
  },
  "91709": {
    DMA: 803,
  },
  "91710": {
    DMA: 803,
  },
  "91711": {
    DMA: 803,
  },
  "91714": {
    DMA: 803,
  },
  "91715": {
    DMA: 803,
  },
  "91716": {
    DMA: 803,
  },
  "91722": {
    DMA: 803,
  },
  "91723": {
    DMA: 803,
  },
  "91724": {
    DMA: 803,
  },
  "91729": {
    DMA: 803,
  },
  "91730": {
    DMA: 803,
  },
  "91731": {
    DMA: 803,
  },
  "91732": {
    DMA: 803,
  },
  "91733": {
    DMA: 803,
  },
  "91734": {
    DMA: 803,
  },
  "91735": {
    DMA: 803,
  },
  "91737": {
    DMA: 803,
  },
  "91739": {
    DMA: 803,
  },
  "91740": {
    DMA: 803,
  },
  "91741": {
    DMA: 803,
  },
  "91743": {
    DMA: 803,
  },
  "91744": {
    DMA: 803,
  },
  "91745": {
    DMA: 803,
  },
  "91746": {
    DMA: 803,
  },
  "91747": {
    DMA: 803,
  },
  "91748": {
    DMA: 803,
  },
  "91749": {
    DMA: 803,
  },
  "91750": {
    DMA: 803,
  },
  "91752": {
    DMA: 804,
  },
  "91754": {
    DMA: 803,
  },
  "91755": {
    DMA: 803,
  },
  "91756": {
    DMA: 803,
  },
  "91758": {
    DMA: 803,
  },
  "91759": {
    DMA: 803,
  },
  "91761": {
    DMA: 803,
  },
  "91762": {
    DMA: 803,
  },
  "91763": {
    DMA: 803,
  },
  "91764": {
    DMA: 803,
  },
  "91765": {
    DMA: 803,
  },
  "91766": {
    DMA: 803,
  },
  "91767": {
    DMA: 803,
  },
  "91768": {
    DMA: 803,
  },
  "91769": {
    DMA: 803,
  },
  "91770": {
    DMA: 803,
  },
  "91771": {
    DMA: 803,
  },
  "91772": {
    DMA: 803,
  },
  "91773": {
    DMA: 803,
  },
  "91775": {
    DMA: 803,
  },
  "91776": {
    DMA: 803,
  },
  "91778": {
    DMA: 803,
  },
  "91780": {
    DMA: 803,
  },
  "91784": {
    DMA: 803,
  },
  "91785": {
    DMA: 803,
  },
  "91786": {
    DMA: 803,
  },
  "91788": {
    DMA: 803,
  },
  "91789": {
    DMA: 803,
  },
  "91790": {
    DMA: 803,
  },
  "91791": {
    DMA: 803,
  },
  "91792": {
    DMA: 803,
  },
  "91793": {
    DMA: 803,
  },
  "91795": {
    DMA: 803,
  },
  "91797": {
    DMA: 803,
  },
  "91798": {
    DMA: 803,
  },
  "91799": {
    DMA: 803,
  },
  "91801": {
    DMA: 803,
  },
  "91802": {
    DMA: 803,
  },
  "91803": {
    DMA: 803,
  },
  "91804": {
    DMA: 803,
  },
  "91841": {
    DMA: 803,
  },
  "91896": {
    DMA: 803,
  },
  "91899": {
    DMA: 803,
  },
  "91901": {
    DMA: 825,
  },
  "91902": {
    DMA: 825,
  },
  "91903": {
    DMA: 825,
  },
  "91905": {
    DMA: 825,
  },
  "91906": {
    DMA: 825,
  },
  "91908": {
    DMA: 825,
  },
  "91909": {
    DMA: 825,
  },
  "91910": {
    DMA: 825,
  },
  "91911": {
    DMA: 825,
  },
  "91912": {
    DMA: 825,
  },
  "91913": {
    DMA: 825,
  },
  "91914": {
    DMA: 825,
  },
  "91915": {
    DMA: 825,
  },
  "91916": {
    DMA: 825,
  },
  "91917": {
    DMA: 825,
  },
  "91921": {
    DMA: 825,
  },
  "91931": {
    DMA: 825,
  },
  "91932": {
    DMA: 825,
  },
  "91933": {
    DMA: 825,
  },
  "91934": {
    DMA: 825,
  },
  "91935": {
    DMA: 825,
  },
  "91941": {
    DMA: 825,
  },
  "91942": {
    DMA: 825,
  },
  "91943": {
    DMA: 825,
  },
  "91944": {
    DMA: 825,
  },
  "91945": {
    DMA: 825,
  },
  "91946": {
    DMA: 825,
  },
  "91947": {
    DMA: 825,
  },
  "91948": {
    DMA: 825,
  },
  "91950": {
    DMA: 825,
  },
  "91951": {
    DMA: 825,
  },
  "91962": {
    DMA: 825,
  },
  "91963": {
    DMA: 825,
  },
  "91976": {
    DMA: 825,
  },
  "91977": {
    DMA: 825,
  },
  "91978": {
    DMA: 825,
  },
  "91979": {
    DMA: 825,
  },
  "91980": {
    DMA: 825,
  },
  "91987": {
    DMA: 825,
  },
  "91990": {
    DMA: 825,
  },
  "92003": {
    DMA: 825,
  },
  "92004": {
    DMA: 825,
  },
  "92007": {
    DMA: 825,
  },
  "92008": {
    DMA: 825,
  },
  "92009": {
    DMA: 825,
  },
  "92010": {
    DMA: 825,
  },
  "92011": {
    DMA: 825,
  },
  "92013": {
    DMA: 825,
  },
  "92014": {
    DMA: 825,
  },
  "92018": {
    DMA: 825,
  },
  "92019": {
    DMA: 825,
  },
  "92020": {
    DMA: 825,
  },
  "92021": {
    DMA: 825,
  },
  "92022": {
    DMA: 825,
  },
  "92023": {
    DMA: 825,
  },
  "92024": {
    DMA: 825,
  },
  "92025": {
    DMA: 825,
  },
  "92026": {
    DMA: 825,
  },
  "92027": {
    DMA: 825,
  },
  "92028": {
    DMA: 825,
  },
  "92029": {
    DMA: 825,
  },
  "92030": {
    DMA: 825,
  },
  "92033": {
    DMA: 825,
  },
  "92036": {
    DMA: 825,
  },
  "92037": {
    DMA: 825,
  },
  "92038": {
    DMA: 825,
  },
  "92039": {
    DMA: 825,
  },
  "92040": {
    DMA: 825,
  },
  "92046": {
    DMA: 825,
  },
  "92049": {
    DMA: 825,
  },
  "92051": {
    DMA: 825,
  },
  "92052": {
    DMA: 825,
  },
  "92054": {
    DMA: 825,
  },
  "92055": {
    DMA: 825,
  },
  "92056": {
    DMA: 825,
  },
  "92057": {
    DMA: 825,
  },
  "92058": {
    DMA: 825,
  },
  "92059": {
    DMA: 825,
  },
  "92060": {
    DMA: 825,
  },
  "92061": {
    DMA: 825,
  },
  "92064": {
    DMA: 825,
  },
  "92065": {
    DMA: 825,
  },
  "92066": {
    DMA: 825,
  },
  "92067": {
    DMA: 825,
  },
  "92068": {
    DMA: 825,
  },
  "92069": {
    DMA: 825,
  },
  "92070": {
    DMA: 825,
  },
  "92071": {
    DMA: 825,
  },
  "92072": {
    DMA: 825,
  },
  "92074": {
    DMA: 825,
  },
  "92075": {
    DMA: 825,
  },
  "92078": {
    DMA: 825,
  },
  "92079": {
    DMA: 825,
  },
  "92081": {
    DMA: 825,
  },
  "92082": {
    DMA: 825,
  },
  "92083": {
    DMA: 825,
  },
  "92084": {
    DMA: 825,
  },
  "92085": {
    DMA: 825,
  },
  "92086": {
    DMA: 825,
  },
  "92088": {
    DMA: 825,
  },
  "92090": {
    DMA: 825,
  },
  "92091": {
    DMA: 825,
  },
  "92092": {
    DMA: 825,
  },
  "92093": {
    DMA: 825,
  },
  "92096": {
    DMA: 825,
  },
  "92101": {
    DMA: 825,
  },
  "92102": {
    DMA: 825,
  },
  "92103": {
    DMA: 825,
  },
  "92104": {
    DMA: 825,
  },
  "92105": {
    DMA: 825,
  },
  "92106": {
    DMA: 825,
  },
  "92107": {
    DMA: 825,
  },
  "92108": {
    DMA: 825,
  },
  "92109": {
    DMA: 825,
  },
  "92110": {
    DMA: 825,
  },
  "92111": {
    DMA: 825,
  },
  "92112": {
    DMA: 825,
  },
  "92113": {
    DMA: 825,
  },
  "92114": {
    DMA: 825,
  },
  "92115": {
    DMA: 825,
  },
  "92116": {
    DMA: 825,
  },
  "92117": {
    DMA: 825,
  },
  "92118": {
    DMA: 825,
  },
  "92119": {
    DMA: 825,
  },
  "92120": {
    DMA: 825,
  },
  "92121": {
    DMA: 825,
  },
  "92122": {
    DMA: 825,
  },
  "92123": {
    DMA: 825,
  },
  "92124": {
    DMA: 825,
  },
  "92126": {
    DMA: 825,
  },
  "92127": {
    DMA: 825,
  },
  "92128": {
    DMA: 825,
  },
  "92129": {
    DMA: 825,
  },
  "92130": {
    DMA: 825,
  },
  "92131": {
    DMA: 825,
  },
  "92132": {
    DMA: 825,
  },
  "92133": {
    DMA: 825,
  },
  "92134": {
    DMA: 825,
  },
  "92135": {
    DMA: 825,
  },
  "92136": {
    DMA: 825,
  },
  "92137": {
    DMA: 825,
  },
  "92138": {
    DMA: 825,
  },
  "92139": {
    DMA: 825,
  },
  "92140": {
    DMA: 825,
  },
  "92142": {
    DMA: 825,
  },
  "92143": {
    DMA: 825,
  },
  "92145": {
    DMA: 825,
  },
  "92147": {
    DMA: 825,
  },
  "92149": {
    DMA: 825,
  },
  "92150": {
    DMA: 825,
  },
  "92152": {
    DMA: 825,
  },
  "92153": {
    DMA: 825,
  },
  "92154": {
    DMA: 825,
  },
  "92155": {
    DMA: 825,
  },
  "92158": {
    DMA: 825,
  },
  "92159": {
    DMA: 825,
  },
  "92160": {
    DMA: 825,
  },
  "92161": {
    DMA: 825,
  },
  "92162": {
    DMA: 825,
  },
  "92163": {
    DMA: 825,
  },
  "92164": {
    DMA: 825,
  },
  "92165": {
    DMA: 825,
  },
  "92166": {
    DMA: 825,
  },
  "92167": {
    DMA: 825,
  },
  "92168": {
    DMA: 825,
  },
  "92169": {
    DMA: 825,
  },
  "92170": {
    DMA: 825,
  },
  "92171": {
    DMA: 825,
  },
  "92172": {
    DMA: 825,
  },
  "92173": {
    DMA: 825,
  },
  "92174": {
    DMA: 825,
  },
  "92175": {
    DMA: 825,
  },
  "92176": {
    DMA: 825,
  },
  "92177": {
    DMA: 825,
  },
  "92178": {
    DMA: 825,
  },
  "92179": {
    DMA: 825,
  },
  "92182": {
    DMA: 825,
  },
  "92184": {
    DMA: 825,
  },
  "92186": {
    DMA: 825,
  },
  "92187": {
    DMA: 825,
  },
  "92190": {
    DMA: 825,
  },
  "92191": {
    DMA: 825,
  },
  "92192": {
    DMA: 825,
  },
  "92193": {
    DMA: 825,
  },
  "92194": {
    DMA: 825,
  },
  "92195": {
    DMA: 825,
  },
  "92196": {
    DMA: 825,
  },
  "92197": {
    DMA: 825,
  },
  "92198": {
    DMA: 825,
  },
  "92199": {
    DMA: 825,
  },
  "92201": {
    DMA: 804,
  },
  "92202": {
    DMA: 804,
  },
  "92203": {
    DMA: 804,
  },
  "92210": {
    DMA: 804,
  },
  "92211": {
    DMA: 804,
  },
  "92220": {
    DMA: 804,
  },
  "92222": {
    DMA: 771,
  },
  "92223": {
    DMA: 804,
  },
  "92225": {
    DMA: 804,
  },
  "92226": {
    DMA: 804,
  },
  "92227": {
    DMA: 771,
  },
  "92230": {
    DMA: 804,
  },
  "92231": {
    DMA: 771,
  },
  "92232": {
    DMA: 771,
  },
  "92233": {
    DMA: 771,
  },
  "92234": {
    DMA: 804,
  },
  "92235": {
    DMA: 804,
  },
  "92236": {
    DMA: 804,
  },
  "92239": {
    DMA: 804,
  },
  "92240": {
    DMA: 804,
  },
  "92241": {
    DMA: 804,
  },
  "92242": {
    DMA: 803,
  },
  "92243": {
    DMA: 771,
  },
  "92244": {
    DMA: 771,
  },
  "92247": {
    DMA: 804,
  },
  "92248": {
    DMA: 804,
  },
  "92249": {
    DMA: 771,
  },
  "92250": {
    DMA: 771,
  },
  "92251": {
    DMA: 771,
  },
  "92252": {
    DMA: 803,
  },
  "92253": {
    DMA: 804,
  },
  "92254": {
    DMA: 804,
  },
  "92255": {
    DMA: 804,
  },
  "92256": {
    DMA: 803,
  },
  "92257": {
    DMA: 771,
  },
  "92258": {
    DMA: 804,
  },
  "92259": {
    DMA: 771,
  },
  "92260": {
    DMA: 804,
  },
  "92261": {
    DMA: 804,
  },
  "92262": {
    DMA: 804,
  },
  "92263": {
    DMA: 804,
  },
  "92264": {
    DMA: 804,
  },
  "92266": {
    DMA: 771,
  },
  "92267": {
    DMA: 803,
  },
  "92268": {
    DMA: 803,
  },
  "92270": {
    DMA: 804,
  },
  "92273": {
    DMA: 771,
  },
  "92274": {
    DMA: 804,
  },
  "92275": {
    DMA: 771,
  },
  "92276": {
    DMA: 804,
  },
  "92277": {
    DMA: 803,
  },
  "92278": {
    DMA: 803,
  },
  "92280": {
    DMA: 803,
  },
  "92281": {
    DMA: 771,
  },
  "92282": {
    DMA: 804,
  },
  "92283": {
    DMA: 771,
  },
  "92284": {
    DMA: 803,
  },
  "92285": {
    DMA: 803,
  },
  "92286": {
    DMA: 803,
  },
  "92292": {
    DMA: 804,
  },
  "92301": {
    DMA: 803,
  },
  "92304": {
    DMA: 803,
  },
  "92305": {
    DMA: 803,
  },
  "92307": {
    DMA: 803,
  },
  "92308": {
    DMA: 803,
  },
  "92309": {
    DMA: 803,
  },
  "92310": {
    DMA: 803,
  },
  "92311": {
    DMA: 803,
  },
  "92312": {
    DMA: 803,
  },
  "92313": {
    DMA: 803,
  },
  "92314": {
    DMA: 803,
  },
  "92315": {
    DMA: 803,
  },
  "92316": {
    DMA: 803,
  },
  "92317": {
    DMA: 803,
  },
  "92318": {
    DMA: 803,
  },
  "92320": {
    DMA: 804,
  },
  "92321": {
    DMA: 803,
  },
  "92322": {
    DMA: 803,
  },
  "92323": {
    DMA: 803,
  },
  "92324": {
    DMA: 803,
  },
  "92325": {
    DMA: 803,
  },
  "92326": {
    DMA: 803,
  },
  "92327": {
    DMA: 803,
  },
  "92328": {
    DMA: 803,
  },
  "92329": {
    DMA: 803,
  },
  "92331": {
    DMA: 803,
  },
  "92332": {
    DMA: 803,
  },
  "92333": {
    DMA: 803,
  },
  "92334": {
    DMA: 803,
  },
  "92335": {
    DMA: 803,
  },
  "92336": {
    DMA: 803,
  },
  "92337": {
    DMA: 803,
  },
  "92338": {
    DMA: 803,
  },
  "92339": {
    DMA: 803,
  },
  "92340": {
    DMA: 803,
  },
  "92341": {
    DMA: 803,
  },
  "92342": {
    DMA: 803,
  },
  "92344": {
    DMA: 803,
  },
  "92345": {
    DMA: 803,
  },
  "92346": {
    DMA: 803,
  },
  "92347": {
    DMA: 803,
  },
  "92350": {
    DMA: 803,
  },
  "92352": {
    DMA: 803,
  },
  "92354": {
    DMA: 803,
  },
  "92356": {
    DMA: 803,
  },
  "92357": {
    DMA: 803,
  },
  "92358": {
    DMA: 803,
  },
  "92359": {
    DMA: 803,
  },
  "92363": {
    DMA: 803,
  },
  "92364": {
    DMA: 803,
  },
  "92365": {
    DMA: 803,
  },
  "92366": {
    DMA: 803,
  },
  "92368": {
    DMA: 803,
  },
  "92369": {
    DMA: 803,
  },
  "92371": {
    DMA: 803,
  },
  "92372": {
    DMA: 803,
  },
  "92373": {
    DMA: 803,
  },
  "92374": {
    DMA: 803,
  },
  "92375": {
    DMA: 803,
  },
  "92376": {
    DMA: 803,
  },
  "92377": {
    DMA: 803,
  },
  "92378": {
    DMA: 803,
  },
  "92382": {
    DMA: 803,
  },
  "92384": {
    DMA: 803,
  },
  "92385": {
    DMA: 803,
  },
  "92386": {
    DMA: 803,
  },
  "92389": {
    DMA: 803,
  },
  "92391": {
    DMA: 803,
  },
  "92392": {
    DMA: 803,
  },
  "92393": {
    DMA: 803,
  },
  "92394": {
    DMA: 803,
  },
  "92395": {
    DMA: 803,
  },
  "92397": {
    DMA: 803,
  },
  "92398": {
    DMA: 803,
  },
  "92399": {
    DMA: 803,
  },
  "92401": {
    DMA: 803,
  },
  "92402": {
    DMA: 803,
  },
  "92403": {
    DMA: 803,
  },
  "92404": {
    DMA: 803,
  },
  "92405": {
    DMA: 803,
  },
  "92406": {
    DMA: 803,
  },
  "92407": {
    DMA: 803,
  },
  "92408": {
    DMA: 803,
  },
  "92410": {
    DMA: 803,
  },
  "92411": {
    DMA: 803,
  },
  "92412": {
    DMA: 803,
  },
  "92413": {
    DMA: 803,
  },
  "92414": {
    DMA: 803,
  },
  "92415": {
    DMA: 803,
  },
  "92418": {
    DMA: 803,
  },
  "92423": {
    DMA: 803,
  },
  "92424": {
    DMA: 803,
  },
  "92427": {
    DMA: 803,
  },
  "92501": {
    DMA: 804,
  },
  "92502": {
    DMA: 804,
  },
  "92503": {
    DMA: 804,
  },
  "92504": {
    DMA: 804,
  },
  "92505": {
    DMA: 804,
  },
  "92506": {
    DMA: 804,
  },
  "92507": {
    DMA: 804,
  },
  "92508": {
    DMA: 804,
  },
  "92509": {
    DMA: 804,
  },
  "92513": {
    DMA: 804,
  },
  "92514": {
    DMA: 804,
  },
  "92515": {
    DMA: 804,
  },
  "92516": {
    DMA: 804,
  },
  "92517": {
    DMA: 804,
  },
  "92518": {
    DMA: 804,
  },
  "92519": {
    DMA: 804,
  },
  "92521": {
    DMA: 804,
  },
  "92522": {
    DMA: 804,
  },
  "92530": {
    DMA: 804,
  },
  "92531": {
    DMA: 804,
  },
  "92532": {
    DMA: 804,
  },
  "92536": {
    DMA: 804,
  },
  "92539": {
    DMA: 804,
  },
  "92543": {
    DMA: 804,
  },
  "92544": {
    DMA: 804,
  },
  "92545": {
    DMA: 804,
  },
  "92546": {
    DMA: 804,
  },
  "92548": {
    DMA: 804,
  },
  "92549": {
    DMA: 804,
  },
  "92551": {
    DMA: 804,
  },
  "92552": {
    DMA: 804,
  },
  "92553": {
    DMA: 804,
  },
  "92554": {
    DMA: 804,
  },
  "92555": {
    DMA: 804,
  },
  "92556": {
    DMA: 804,
  },
  "92557": {
    DMA: 804,
  },
  "92561": {
    DMA: 804,
  },
  "92562": {
    DMA: 804,
  },
  "92563": {
    DMA: 804,
  },
  "92564": {
    DMA: 804,
  },
  "92567": {
    DMA: 804,
  },
  "92570": {
    DMA: 804,
  },
  "92571": {
    DMA: 804,
  },
  "92572": {
    DMA: 804,
  },
  "92581": {
    DMA: 804,
  },
  "92582": {
    DMA: 804,
  },
  "92583": {
    DMA: 804,
  },
  "92584": {
    DMA: 804,
  },
  "92585": {
    DMA: 804,
  },
  "92586": {
    DMA: 804,
  },
  "92587": {
    DMA: 804,
  },
  "92589": {
    DMA: 804,
  },
  "92590": {
    DMA: 804,
  },
  "92591": {
    DMA: 804,
  },
  "92592": {
    DMA: 804,
  },
  "92593": {
    DMA: 804,
  },
  "92595": {
    DMA: 804,
  },
  "92596": {
    DMA: 804,
  },
  "92599": {
    DMA: 804,
  },
  "92602": {
    DMA: 803,
  },
  "92603": {
    DMA: 803,
  },
  "92604": {
    DMA: 803,
  },
  "92605": {
    DMA: 803,
  },
  "92606": {
    DMA: 803,
  },
  "92607": {
    DMA: 803,
  },
  "92609": {
    DMA: 803,
  },
  "92610": {
    DMA: 803,
  },
  "92612": {
    DMA: 803,
  },
  "92614": {
    DMA: 803,
  },
  "92615": {
    DMA: 803,
  },
  "92616": {
    DMA: 803,
  },
  "92617": {
    DMA: 803,
  },
  "92618": {
    DMA: 803,
  },
  "92619": {
    DMA: 803,
  },
  "92620": {
    DMA: 803,
  },
  "92623": {
    DMA: 803,
  },
  "92624": {
    DMA: 803,
  },
  "92625": {
    DMA: 803,
  },
  "92626": {
    DMA: 803,
  },
  "92627": {
    DMA: 803,
  },
  "92628": {
    DMA: 803,
  },
  "92629": {
    DMA: 803,
  },
  "92630": {
    DMA: 803,
  },
  "92637": {
    DMA: 803,
  },
  "92646": {
    DMA: 803,
  },
  "92647": {
    DMA: 803,
  },
  "92648": {
    DMA: 803,
  },
  "92649": {
    DMA: 803,
  },
  "92650": {
    DMA: 803,
  },
  "92651": {
    DMA: 803,
  },
  "92652": {
    DMA: 803,
  },
  "92653": {
    DMA: 803,
  },
  "92654": {
    DMA: 803,
  },
  "92655": {
    DMA: 803,
  },
  "92656": {
    DMA: 803,
  },
  "92657": {
    DMA: 803,
  },
  "92658": {
    DMA: 803,
  },
  "92659": {
    DMA: 803,
  },
  "92660": {
    DMA: 803,
  },
  "92661": {
    DMA: 803,
  },
  "92662": {
    DMA: 803,
  },
  "92663": {
    DMA: 803,
  },
  "92672": {
    DMA: 803,
  },
  "92673": {
    DMA: 803,
  },
  "92674": {
    DMA: 803,
  },
  "92675": {
    DMA: 803,
  },
  "92676": {
    DMA: 803,
  },
  "92677": {
    DMA: 803,
  },
  "92678": {
    DMA: 803,
  },
  "92679": {
    DMA: 803,
  },
  "92683": {
    DMA: 803,
  },
  "92684": {
    DMA: 803,
  },
  "92685": {
    DMA: 803,
  },
  "92688": {
    DMA: 803,
  },
  "92690": {
    DMA: 803,
  },
  "92691": {
    DMA: 803,
  },
  "92692": {
    DMA: 803,
  },
  "92693": {
    DMA: 803,
  },
  "92694": {
    DMA: 803,
  },
  "92697": {
    DMA: 803,
  },
  "92698": {
    DMA: 803,
  },
  "92701": {
    DMA: 803,
  },
  "92702": {
    DMA: 803,
  },
  "92703": {
    DMA: 803,
  },
  "92704": {
    DMA: 803,
  },
  "92705": {
    DMA: 803,
  },
  "92706": {
    DMA: 803,
  },
  "92707": {
    DMA: 803,
  },
  "92708": {
    DMA: 803,
  },
  "92709": {
    DMA: 803,
  },
  "92710": {
    DMA: 803,
  },
  "92711": {
    DMA: 803,
  },
  "92712": {
    DMA: 803,
  },
  "92725": {
    DMA: 803,
  },
  "92728": {
    DMA: 803,
  },
  "92735": {
    DMA: 803,
  },
  "92780": {
    DMA: 803,
  },
  "92781": {
    DMA: 803,
  },
  "92782": {
    DMA: 803,
  },
  "92799": {
    DMA: 803,
  },
  "92801": {
    DMA: 803,
  },
  "92802": {
    DMA: 803,
  },
  "92803": {
    DMA: 803,
  },
  "92804": {
    DMA: 803,
  },
  "92805": {
    DMA: 803,
  },
  "92806": {
    DMA: 803,
  },
  "92807": {
    DMA: 803,
  },
  "92808": {
    DMA: 803,
  },
  "92809": {
    DMA: 803,
  },
  "92811": {
    DMA: 803,
  },
  "92812": {
    DMA: 803,
  },
  "92814": {
    DMA: 803,
  },
  "92815": {
    DMA: 803,
  },
  "92816": {
    DMA: 803,
  },
  "92817": {
    DMA: 803,
  },
  "92821": {
    DMA: 803,
  },
  "92822": {
    DMA: 803,
  },
  "92823": {
    DMA: 803,
  },
  "92825": {
    DMA: 803,
  },
  "92831": {
    DMA: 803,
  },
  "92832": {
    DMA: 803,
  },
  "92833": {
    DMA: 803,
  },
  "92834": {
    DMA: 803,
  },
  "92835": {
    DMA: 803,
  },
  "92836": {
    DMA: 803,
  },
  "92837": {
    DMA: 803,
  },
  "92838": {
    DMA: 803,
  },
  "92840": {
    DMA: 803,
  },
  "92841": {
    DMA: 803,
  },
  "92842": {
    DMA: 803,
  },
  "92843": {
    DMA: 803,
  },
  "92844": {
    DMA: 803,
  },
  "92845": {
    DMA: 803,
  },
  "92846": {
    DMA: 803,
  },
  "92850": {
    DMA: 803,
  },
  "92856": {
    DMA: 803,
  },
  "92857": {
    DMA: 803,
  },
  "92859": {
    DMA: 803,
  },
  "92860": {
    DMA: 804,
  },
  "92861": {
    DMA: 803,
  },
  "92862": {
    DMA: 803,
  },
  "92863": {
    DMA: 803,
  },
  "92864": {
    DMA: 803,
  },
  "92865": {
    DMA: 803,
  },
  "92866": {
    DMA: 803,
  },
  "92867": {
    DMA: 803,
  },
  "92868": {
    DMA: 803,
  },
  "92869": {
    DMA: 803,
  },
  "92870": {
    DMA: 803,
  },
  "92871": {
    DMA: 803,
  },
  "92877": {
    DMA: 804,
  },
  "92878": {
    DMA: 804,
  },
  "92879": {
    DMA: 804,
  },
  "92880": {
    DMA: 804,
  },
  "92881": {
    DMA: 804,
  },
  "92882": {
    DMA: 804,
  },
  "92883": {
    DMA: 804,
  },
  "92885": {
    DMA: 803,
  },
  "92886": {
    DMA: 803,
  },
  "92887": {
    DMA: 803,
  },
  "92899": {
    DMA: 803,
  },
  "93001": {
    DMA: 803,
  },
  "93002": {
    DMA: 803,
  },
  "93003": {
    DMA: 803,
  },
  "93004": {
    DMA: 803,
  },
  "93005": {
    DMA: 803,
  },
  "93006": {
    DMA: 803,
  },
  "93007": {
    DMA: 803,
  },
  "93009": {
    DMA: 803,
  },
  "93010": {
    DMA: 803,
  },
  "93011": {
    DMA: 803,
  },
  "93012": {
    DMA: 803,
  },
  "93013": {
    DMA: 855,
  },
  "93014": {
    DMA: 855,
  },
  "93015": {
    DMA: 803,
  },
  "93016": {
    DMA: 803,
  },
  "93020": {
    DMA: 803,
  },
  "93021": {
    DMA: 803,
  },
  "93022": {
    DMA: 803,
  },
  "93023": {
    DMA: 803,
  },
  "93024": {
    DMA: 803,
  },
  "93030": {
    DMA: 803,
  },
  "93031": {
    DMA: 803,
  },
  "93032": {
    DMA: 803,
  },
  "93033": {
    DMA: 803,
  },
  "93034": {
    DMA: 803,
  },
  "93035": {
    DMA: 803,
  },
  "93036": {
    DMA: 803,
  },
  "93040": {
    DMA: 803,
  },
  "93041": {
    DMA: 803,
  },
  "93042": {
    DMA: 803,
  },
  "93043": {
    DMA: 803,
  },
  "93044": {
    DMA: 803,
  },
  "93060": {
    DMA: 803,
  },
  "93061": {
    DMA: 803,
  },
  "93062": {
    DMA: 803,
  },
  "93063": {
    DMA: 803,
  },
  "93064": {
    DMA: 803,
  },
  "93065": {
    DMA: 803,
  },
  "93066": {
    DMA: 803,
  },
  "93067": {
    DMA: 855,
  },
  "93093": {
    DMA: 803,
  },
  "93094": {
    DMA: 803,
  },
  "93099": {
    DMA: 803,
  },
  "93101": {
    DMA: 855,
  },
  "93102": {
    DMA: 855,
  },
  "93103": {
    DMA: 855,
  },
  "93105": {
    DMA: 855,
  },
  "93106": {
    DMA: 855,
  },
  "93107": {
    DMA: 855,
  },
  "93108": {
    DMA: 855,
  },
  "93109": {
    DMA: 855,
  },
  "93110": {
    DMA: 855,
  },
  "93111": {
    DMA: 855,
  },
  "93116": {
    DMA: 855,
  },
  "93117": {
    DMA: 855,
  },
  "93118": {
    DMA: 855,
  },
  "93120": {
    DMA: 855,
  },
  "93121": {
    DMA: 855,
  },
  "93130": {
    DMA: 855,
  },
  "93140": {
    DMA: 855,
  },
  "93150": {
    DMA: 855,
  },
  "93160": {
    DMA: 855,
  },
  "93190": {
    DMA: 855,
  },
  "93199": {
    DMA: 855,
  },
  "93201": {
    DMA: 866,
  },
  "93202": {
    DMA: 866,
  },
  "93203": {
    DMA: 800,
  },
  "93204": {
    DMA: 866,
  },
  "93205": {
    DMA: 800,
  },
  "93206": {
    DMA: 800,
  },
  "93207": {
    DMA: 866,
  },
  "93208": {
    DMA: 866,
  },
  "93210": {
    DMA: 866,
  },
  "93212": {
    DMA: 866,
  },
  "93215": {
    DMA: 800,
  },
  "93216": {
    DMA: 800,
  },
  "93218": {
    DMA: 866,
  },
  "93219": {
    DMA: 866,
  },
  "93220": {
    DMA: 800,
  },
  "93221": {
    DMA: 866,
  },
  "93222": {
    DMA: 800,
  },
  "93223": {
    DMA: 866,
  },
  "93224": {
    DMA: 800,
  },
  "93225": {
    DMA: 800,
  },
  "93226": {
    DMA: 800,
  },
  "93227": {
    DMA: 866,
  },
  "93230": {
    DMA: 866,
  },
  "93232": {
    DMA: 866,
  },
  "93234": {
    DMA: 866,
  },
  "93235": {
    DMA: 866,
  },
  "93237": {
    DMA: 866,
  },
  "93238": {
    DMA: 800,
  },
  "93239": {
    DMA: 866,
  },
  "93240": {
    DMA: 800,
  },
  "93241": {
    DMA: 800,
  },
  "93242": {
    DMA: 866,
  },
  "93243": {
    DMA: 800,
  },
  "93244": {
    DMA: 866,
  },
  "93245": {
    DMA: 866,
  },
  "93246": {
    DMA: 866,
  },
  "93247": {
    DMA: 866,
  },
  "93249": {
    DMA: 800,
  },
  "93250": {
    DMA: 800,
  },
  "93251": {
    DMA: 800,
  },
  "93252": {
    DMA: 800,
  },
  "93254": {
    DMA: 855,
  },
  "93255": {
    DMA: 800,
  },
  "93256": {
    DMA: 866,
  },
  "93257": {
    DMA: 866,
  },
  "93258": {
    DMA: 866,
  },
  "93260": {
    DMA: 866,
  },
  "93261": {
    DMA: 866,
  },
  "93262": {
    DMA: 866,
  },
  "93263": {
    DMA: 800,
  },
  "93265": {
    DMA: 866,
  },
  "93266": {
    DMA: 866,
  },
  "93267": {
    DMA: 866,
  },
  "93268": {
    DMA: 800,
  },
  "93270": {
    DMA: 866,
  },
  "93271": {
    DMA: 866,
  },
  "93272": {
    DMA: 866,
  },
  "93274": {
    DMA: 866,
  },
  "93275": {
    DMA: 866,
  },
  "93276": {
    DMA: 800,
  },
  "93277": {
    DMA: 866,
  },
  "93278": {
    DMA: 866,
  },
  "93279": {
    DMA: 866,
  },
  "93280": {
    DMA: 800,
  },
  "93282": {
    DMA: 866,
  },
  "93283": {
    DMA: 800,
  },
  "93285": {
    DMA: 800,
  },
  "93286": {
    DMA: 866,
  },
  "93287": {
    DMA: 800,
  },
  "93290": {
    DMA: 866,
  },
  "93291": {
    DMA: 866,
  },
  "93292": {
    DMA: 866,
  },
  "93301": {
    DMA: 800,
  },
  "93302": {
    DMA: 800,
  },
  "93303": {
    DMA: 800,
  },
  "93304": {
    DMA: 800,
  },
  "93305": {
    DMA: 800,
  },
  "93306": {
    DMA: 800,
  },
  "93307": {
    DMA: 800,
  },
  "93308": {
    DMA: 800,
  },
  "93309": {
    DMA: 800,
  },
  "93311": {
    DMA: 800,
  },
  "93312": {
    DMA: 800,
  },
  "93313": {
    DMA: 800,
  },
  "93314": {
    DMA: 800,
  },
  "93380": {
    DMA: 800,
  },
  "93381": {
    DMA: 800,
  },
  "93382": {
    DMA: 800,
  },
  "93383": {
    DMA: 800,
  },
  "93384": {
    DMA: 800,
  },
  "93385": {
    DMA: 800,
  },
  "93386": {
    DMA: 800,
  },
  "93387": {
    DMA: 800,
  },
  "93388": {
    DMA: 800,
  },
  "93389": {
    DMA: 800,
  },
  "93390": {
    DMA: 800,
  },
  "93401": {
    DMA: 855,
  },
  "93402": {
    DMA: 855,
  },
  "93403": {
    DMA: 855,
  },
  "93405": {
    DMA: 855,
  },
  "93406": {
    DMA: 855,
  },
  "93407": {
    DMA: 855,
  },
  "93408": {
    DMA: 855,
  },
  "93409": {
    DMA: 855,
  },
  "93410": {
    DMA: 855,
  },
  "93412": {
    DMA: 855,
  },
  "93420": {
    DMA: 855,
  },
  "93421": {
    DMA: 855,
  },
  "93422": {
    DMA: 855,
  },
  "93423": {
    DMA: 855,
  },
  "93424": {
    DMA: 855,
  },
  "93426": {
    DMA: 828,
  },
  "93427": {
    DMA: 855,
  },
  "93428": {
    DMA: 855,
  },
  "93429": {
    DMA: 855,
  },
  "93430": {
    DMA: 855,
  },
  "93432": {
    DMA: 855,
  },
  "93433": {
    DMA: 855,
  },
  "93434": {
    DMA: 855,
  },
  "93435": {
    DMA: 855,
  },
  "93436": {
    DMA: 855,
  },
  "93437": {
    DMA: 855,
  },
  "93438": {
    DMA: 855,
  },
  "93440": {
    DMA: 855,
  },
  "93441": {
    DMA: 855,
  },
  "93442": {
    DMA: 855,
  },
  "93443": {
    DMA: 855,
  },
  "93444": {
    DMA: 855,
  },
  "93445": {
    DMA: 855,
  },
  "93446": {
    DMA: 855,
  },
  "93447": {
    DMA: 855,
  },
  "93448": {
    DMA: 855,
  },
  "93449": {
    DMA: 855,
  },
  "93450": {
    DMA: 828,
  },
  "93451": {
    DMA: 855,
  },
  "93452": {
    DMA: 855,
  },
  "93453": {
    DMA: 855,
  },
  "93454": {
    DMA: 855,
  },
  "93455": {
    DMA: 855,
  },
  "93456": {
    DMA: 855,
  },
  "93457": {
    DMA: 855,
  },
  "93458": {
    DMA: 855,
  },
  "93460": {
    DMA: 855,
  },
  "93461": {
    DMA: 855,
  },
  "93463": {
    DMA: 855,
  },
  "93464": {
    DMA: 855,
  },
  "93465": {
    DMA: 855,
  },
  "93475": {
    DMA: 855,
  },
  "93483": {
    DMA: 855,
  },
  "93501": {
    DMA: 800,
  },
  "93502": {
    DMA: 800,
  },
  "93504": {
    DMA: 800,
  },
  "93505": {
    DMA: 800,
  },
  "93510": {
    DMA: 803,
  },
  "93512": {
    DMA: 811,
  },
  "93513": {
    DMA: 803,
  },
  "93514": {
    DMA: 803,
  },
  "93515": {
    DMA: 803,
  },
  "93516": {
    DMA: 800,
  },
  "93517": {
    DMA: 811,
  },
  "93518": {
    DMA: 800,
  },
  "93519": {
    DMA: 800,
  },
  "93522": {
    DMA: 803,
  },
  "93523": {
    DMA: 800,
  },
  "93524": {
    DMA: 800,
  },
  "93526": {
    DMA: 803,
  },
  "93527": {
    DMA: 800,
  },
  "93528": {
    DMA: 800,
  },
  "93529": {
    DMA: 811,
  },
  "93530": {
    DMA: 803,
  },
  "93531": {
    DMA: 800,
  },
  "93532": {
    DMA: 803,
  },
  "93534": {
    DMA: 803,
  },
  "93535": {
    DMA: 803,
  },
  "93536": {
    DMA: 803,
  },
  "93539": {
    DMA: 803,
  },
  "93541": {
    DMA: 811,
  },
  "93542": {
    DMA: 803,
  },
  "93543": {
    DMA: 803,
  },
  "93544": {
    DMA: 803,
  },
  "93545": {
    DMA: 803,
  },
  "93546": {
    DMA: 811,
  },
  "93549": {
    DMA: 803,
  },
  "93550": {
    DMA: 803,
  },
  "93551": {
    DMA: 803,
  },
  "93552": {
    DMA: 803,
  },
  "93553": {
    DMA: 803,
  },
  "93554": {
    DMA: 800,
  },
  "93555": {
    DMA: 800,
  },
  "93556": {
    DMA: 800,
  },
  "93558": {
    DMA: 803,
  },
  "93560": {
    DMA: 800,
  },
  "93561": {
    DMA: 800,
  },
  "93562": {
    DMA: 803,
  },
  "93563": {
    DMA: 803,
  },
  "93581": {
    DMA: 800,
  },
  "93584": {
    DMA: 803,
  },
  "93586": {
    DMA: 803,
  },
  "93590": {
    DMA: 803,
  },
  "93591": {
    DMA: 803,
  },
  "93592": {
    DMA: 803,
  },
  "93596": {
    DMA: 800,
  },
  "93599": {
    DMA: 803,
  },
  "93601": {
    DMA: 866,
  },
  "93602": {
    DMA: 866,
  },
  "93603": {
    DMA: 866,
  },
  "93604": {
    DMA: 866,
  },
  "93605": {
    DMA: 866,
  },
  "93606": {
    DMA: 866,
  },
  "93607": {
    DMA: 866,
  },
  "93608": {
    DMA: 866,
  },
  "93609": {
    DMA: 866,
  },
  "93610": {
    DMA: 866,
  },
  "93611": {
    DMA: 866,
  },
  "93612": {
    DMA: 866,
  },
  "93613": {
    DMA: 866,
  },
  "93614": {
    DMA: 866,
  },
  "93615": {
    DMA: 866,
  },
  "93616": {
    DMA: 866,
  },
  "93618": {
    DMA: 866,
  },
  "93619": {
    DMA: 866,
  },
  "93620": {
    DMA: 866,
  },
  "93621": {
    DMA: 866,
  },
  "93622": {
    DMA: 866,
  },
  "93623": {
    DMA: 866,
  },
  "93624": {
    DMA: 866,
  },
  "93625": {
    DMA: 866,
  },
  "93626": {
    DMA: 866,
  },
  "93627": {
    DMA: 866,
  },
  "93628": {
    DMA: 866,
  },
  "93630": {
    DMA: 866,
  },
  "93631": {
    DMA: 866,
  },
  "93633": {
    DMA: 866,
  },
  "93634": {
    DMA: 866,
  },
  "93635": {
    DMA: 866,
  },
  "93636": {
    DMA: 866,
  },
  "93637": {
    DMA: 866,
  },
  "93638": {
    DMA: 866,
  },
  "93639": {
    DMA: 866,
  },
  "93640": {
    DMA: 866,
  },
  "93641": {
    DMA: 866,
  },
  "93642": {
    DMA: 866,
  },
  "93643": {
    DMA: 866,
  },
  "93644": {
    DMA: 866,
  },
  "93645": {
    DMA: 866,
  },
  "93646": {
    DMA: 866,
  },
  "93647": {
    DMA: 866,
  },
  "93648": {
    DMA: 866,
  },
  "93649": {
    DMA: 866,
  },
  "93650": {
    DMA: 866,
  },
  "93651": {
    DMA: 866,
  },
  "93652": {
    DMA: 866,
  },
  "93653": {
    DMA: 866,
  },
  "93654": {
    DMA: 866,
  },
  "93656": {
    DMA: 866,
  },
  "93657": {
    DMA: 866,
  },
  "93660": {
    DMA: 866,
  },
  "93661": {
    DMA: 866,
  },
  "93662": {
    DMA: 866,
  },
  "93664": {
    DMA: 866,
  },
  "93665": {
    DMA: 866,
  },
  "93666": {
    DMA: 866,
  },
  "93667": {
    DMA: 866,
  },
  "93668": {
    DMA: 866,
  },
  "93669": {
    DMA: 866,
  },
  "93670": {
    DMA: 866,
  },
  "93673": {
    DMA: 866,
  },
  "93675": {
    DMA: 866,
  },
  "93701": {
    DMA: 866,
  },
  "93702": {
    DMA: 866,
  },
  "93703": {
    DMA: 866,
  },
  "93704": {
    DMA: 866,
  },
  "93705": {
    DMA: 866,
  },
  "93706": {
    DMA: 866,
  },
  "93707": {
    DMA: 866,
  },
  "93708": {
    DMA: 866,
  },
  "93709": {
    DMA: 866,
  },
  "93710": {
    DMA: 866,
  },
  "93711": {
    DMA: 866,
  },
  "93712": {
    DMA: 866,
  },
  "93714": {
    DMA: 866,
  },
  "93715": {
    DMA: 866,
  },
  "93716": {
    DMA: 866,
  },
  "93717": {
    DMA: 866,
  },
  "93718": {
    DMA: 866,
  },
  "93720": {
    DMA: 866,
  },
  "93721": {
    DMA: 866,
  },
  "93722": {
    DMA: 866,
  },
  "93723": {
    DMA: 866,
  },
  "93724": {
    DMA: 866,
  },
  "93725": {
    DMA: 866,
  },
  "93726": {
    DMA: 866,
  },
  "93727": {
    DMA: 866,
  },
  "93728": {
    DMA: 866,
  },
  "93729": {
    DMA: 866,
  },
  "93730": {
    DMA: 866,
  },
  "93737": {
    DMA: 866,
  },
  "93740": {
    DMA: 866,
  },
  "93741": {
    DMA: 866,
  },
  "93744": {
    DMA: 866,
  },
  "93745": {
    DMA: 866,
  },
  "93747": {
    DMA: 866,
  },
  "93750": {
    DMA: 866,
  },
  "93755": {
    DMA: 866,
  },
  "93760": {
    DMA: 866,
  },
  "93761": {
    DMA: 866,
  },
  "93764": {
    DMA: 866,
  },
  "93765": {
    DMA: 866,
  },
  "93771": {
    DMA: 866,
  },
  "93772": {
    DMA: 866,
  },
  "93773": {
    DMA: 866,
  },
  "93774": {
    DMA: 866,
  },
  "93775": {
    DMA: 866,
  },
  "93776": {
    DMA: 866,
  },
  "93777": {
    DMA: 866,
  },
  "93778": {
    DMA: 866,
  },
  "93779": {
    DMA: 866,
  },
  "93780": {
    DMA: 866,
  },
  "93784": {
    DMA: 866,
  },
  "93786": {
    DMA: 866,
  },
  "93790": {
    DMA: 866,
  },
  "93791": {
    DMA: 866,
  },
  "93792": {
    DMA: 866,
  },
  "93793": {
    DMA: 866,
  },
  "93794": {
    DMA: 866,
  },
  "93844": {
    DMA: 866,
  },
  "93888": {
    DMA: 866,
  },
  "93901": {
    DMA: 828,
  },
  "93902": {
    DMA: 828,
  },
  "93905": {
    DMA: 828,
  },
  "93906": {
    DMA: 828,
  },
  "93907": {
    DMA: 828,
  },
  "93908": {
    DMA: 828,
  },
  "93912": {
    DMA: 828,
  },
  "93915": {
    DMA: 828,
  },
  "93920": {
    DMA: 828,
  },
  "93921": {
    DMA: 828,
  },
  "93922": {
    DMA: 828,
  },
  "93923": {
    DMA: 828,
  },
  "93924": {
    DMA: 828,
  },
  "93925": {
    DMA: 828,
  },
  "93926": {
    DMA: 828,
  },
  "93927": {
    DMA: 828,
  },
  "93928": {
    DMA: 828,
  },
  "93930": {
    DMA: 828,
  },
  "93932": {
    DMA: 828,
  },
  "93933": {
    DMA: 828,
  },
  "93940": {
    DMA: 828,
  },
  "93942": {
    DMA: 828,
  },
  "93943": {
    DMA: 828,
  },
  "93944": {
    DMA: 828,
  },
  "93950": {
    DMA: 828,
  },
  "93953": {
    DMA: 828,
  },
  "93954": {
    DMA: 828,
  },
  "93955": {
    DMA: 828,
  },
  "93960": {
    DMA: 828,
  },
  "93962": {
    DMA: 828,
  },
  "94002": {
    DMA: 807,
  },
  "94005": {
    DMA: 807,
  },
  "94010": {
    DMA: 807,
  },
  "94011": {
    DMA: 807,
  },
  "94013": {
    DMA: 807,
  },
  "94014": {
    DMA: 807,
  },
  "94015": {
    DMA: 807,
  },
  "94016": {
    DMA: 807,
  },
  "94017": {
    DMA: 807,
  },
  "94018": {
    DMA: 807,
  },
  "94019": {
    DMA: 807,
  },
  "94020": {
    DMA: 807,
  },
  "94021": {
    DMA: 807,
  },
  "94022": {
    DMA: 807,
  },
  "94023": {
    DMA: 807,
  },
  "94024": {
    DMA: 807,
  },
  "94025": {
    DMA: 807,
  },
  "94026": {
    DMA: 807,
  },
  "94027": {
    DMA: 807,
  },
  "94028": {
    DMA: 807,
  },
  "94030": {
    DMA: 807,
  },
  "94035": {
    DMA: 807,
  },
  "94037": {
    DMA: 807,
  },
  "94038": {
    DMA: 807,
  },
  "94039": {
    DMA: 807,
  },
  "94040": {
    DMA: 807,
  },
  "94041": {
    DMA: 807,
  },
  "94042": {
    DMA: 807,
  },
  "94043": {
    DMA: 807,
  },
  "94044": {
    DMA: 807,
  },
  "94060": {
    DMA: 807,
  },
  "94061": {
    DMA: 807,
  },
  "94062": {
    DMA: 807,
  },
  "94063": {
    DMA: 807,
  },
  "94064": {
    DMA: 807,
  },
  "94065": {
    DMA: 807,
  },
  "94066": {
    DMA: 807,
  },
  "94070": {
    DMA: 807,
  },
  "94074": {
    DMA: 807,
  },
  "94080": {
    DMA: 807,
  },
  "94083": {
    DMA: 807,
  },
  "94085": {
    DMA: 807,
  },
  "94086": {
    DMA: 807,
  },
  "94087": {
    DMA: 807,
  },
  "94088": {
    DMA: 807,
  },
  "94089": {
    DMA: 807,
  },
  "94101": {
    DMA: 807,
  },
  "94102": {
    DMA: 807,
  },
  "94103": {
    DMA: 807,
  },
  "94104": {
    DMA: 807,
  },
  "94105": {
    DMA: 807,
  },
  "94106": {
    DMA: 807,
  },
  "94107": {
    DMA: 807,
  },
  "94108": {
    DMA: 807,
  },
  "94109": {
    DMA: 807,
  },
  "94110": {
    DMA: 807,
  },
  "94111": {
    DMA: 807,
  },
  "94112": {
    DMA: 807,
  },
  "94114": {
    DMA: 807,
  },
  "94115": {
    DMA: 807,
  },
  "94116": {
    DMA: 807,
  },
  "94117": {
    DMA: 807,
  },
  "94118": {
    DMA: 807,
  },
  "94119": {
    DMA: 807,
  },
  "94120": {
    DMA: 807,
  },
  "94121": {
    DMA: 807,
  },
  "94122": {
    DMA: 807,
  },
  "94123": {
    DMA: 807,
  },
  "94124": {
    DMA: 807,
  },
  "94125": {
    DMA: 807,
  },
  "94126": {
    DMA: 807,
  },
  "94127": {
    DMA: 807,
  },
  "94128": {
    DMA: 807,
  },
  "94129": {
    DMA: 807,
  },
  "94130": {
    DMA: 807,
  },
  "94131": {
    DMA: 807,
  },
  "94132": {
    DMA: 807,
  },
  "94133": {
    DMA: 807,
  },
  "94134": {
    DMA: 807,
  },
  "94135": {
    DMA: 807,
  },
  "94136": {
    DMA: 807,
  },
  "94137": {
    DMA: 807,
  },
  "94138": {
    DMA: 807,
  },
  "94139": {
    DMA: 807,
  },
  "94140": {
    DMA: 807,
  },
  "94141": {
    DMA: 807,
  },
  "94142": {
    DMA: 807,
  },
  "94143": {
    DMA: 807,
  },
  "94144": {
    DMA: 807,
  },
  "94145": {
    DMA: 807,
  },
  "94146": {
    DMA: 807,
  },
  "94147": {
    DMA: 807,
  },
  "94150": {
    DMA: 807,
  },
  "94151": {
    DMA: 807,
  },
  "94152": {
    DMA: 807,
  },
  "94153": {
    DMA: 807,
  },
  "94154": {
    DMA: 807,
  },
  "94155": {
    DMA: 807,
  },
  "94156": {
    DMA: 807,
  },
  "94158": {
    DMA: 807,
  },
  "94159": {
    DMA: 807,
  },
  "94160": {
    DMA: 807,
  },
  "94161": {
    DMA: 807,
  },
  "94162": {
    DMA: 807,
  },
  "94163": {
    DMA: 807,
  },
  "94164": {
    DMA: 807,
  },
  "94171": {
    DMA: 807,
  },
  "94172": {
    DMA: 807,
  },
  "94175": {
    DMA: 807,
  },
  "94177": {
    DMA: 807,
  },
  "94188": {
    DMA: 807,
  },
  "94199": {
    DMA: 807,
  },
  "94203": {
    DMA: 862,
  },
  "94204": {
    DMA: 862,
  },
  "94205": {
    DMA: 862,
  },
  "94206": {
    DMA: 862,
  },
  "94207": {
    DMA: 862,
  },
  "94208": {
    DMA: 862,
  },
  "94209": {
    DMA: 862,
  },
  "94211": {
    DMA: 862,
  },
  "94229": {
    DMA: 862,
  },
  "94230": {
    DMA: 862,
  },
  "94232": {
    DMA: 862,
  },
  "94234": {
    DMA: 862,
  },
  "94235": {
    DMA: 862,
  },
  "94236": {
    DMA: 862,
  },
  "94237": {
    DMA: 862,
  },
  "94239": {
    DMA: 862,
  },
  "94240": {
    DMA: 862,
  },
  "94244": {
    DMA: 862,
  },
  "94245": {
    DMA: 862,
  },
  "94246": {
    DMA: 862,
  },
  "94247": {
    DMA: 862,
  },
  "94248": {
    DMA: 862,
  },
  "94249": {
    DMA: 862,
  },
  "94250": {
    DMA: 862,
  },
  "94252": {
    DMA: 862,
  },
  "94254": {
    DMA: 862,
  },
  "94256": {
    DMA: 862,
  },
  "94257": {
    DMA: 862,
  },
  "94258": {
    DMA: 862,
  },
  "94259": {
    DMA: 862,
  },
  "94261": {
    DMA: 862,
  },
  "94262": {
    DMA: 862,
  },
  "94263": {
    DMA: 862,
  },
  "94267": {
    DMA: 862,
  },
  "94268": {
    DMA: 862,
  },
  "94269": {
    DMA: 862,
  },
  "94271": {
    DMA: 862,
  },
  "94273": {
    DMA: 862,
  },
  "94274": {
    DMA: 862,
  },
  "94277": {
    DMA: 862,
  },
  "94278": {
    DMA: 862,
  },
  "94279": {
    DMA: 862,
  },
  "94280": {
    DMA: 862,
  },
  "94282": {
    DMA: 862,
  },
  "94283": {
    DMA: 862,
  },
  "94284": {
    DMA: 862,
  },
  "94285": {
    DMA: 862,
  },
  "94286": {
    DMA: 862,
  },
  "94287": {
    DMA: 862,
  },
  "94288": {
    DMA: 862,
  },
  "94289": {
    DMA: 862,
  },
  "94290": {
    DMA: 862,
  },
  "94291": {
    DMA: 862,
  },
  "94293": {
    DMA: 862,
  },
  "94294": {
    DMA: 862,
  },
  "94295": {
    DMA: 862,
  },
  "94296": {
    DMA: 862,
  },
  "94297": {
    DMA: 862,
  },
  "94298": {
    DMA: 862,
  },
  "94299": {
    DMA: 862,
  },
  "94301": {
    DMA: 807,
  },
  "94302": {
    DMA: 807,
  },
  "94303": {
    DMA: 807,
  },
  "94304": {
    DMA: 807,
  },
  "94305": {
    DMA: 807,
  },
  "94306": {
    DMA: 807,
  },
  "94309": {
    DMA: 807,
  },
  "94401": {
    DMA: 807,
  },
  "94402": {
    DMA: 807,
  },
  "94403": {
    DMA: 807,
  },
  "94404": {
    DMA: 807,
  },
  "94497": {
    DMA: 807,
  },
  "94501": {
    DMA: 807,
  },
  "94502": {
    DMA: 807,
  },
  "94503": {
    DMA: 807,
  },
  "94505": {
    DMA: 807,
  },
  "94506": {
    DMA: 807,
  },
  "94507": {
    DMA: 807,
  },
  "94508": {
    DMA: 807,
  },
  "94509": {
    DMA: 807,
  },
  "94510": {
    DMA: 862,
  },
  "94511": {
    DMA: 807,
  },
  "94512": {
    DMA: 862,
  },
  "94513": {
    DMA: 807,
  },
  "94514": {
    DMA: 807,
  },
  "94515": {
    DMA: 807,
  },
  "94516": {
    DMA: 807,
  },
  "94517": {
    DMA: 807,
  },
  "94518": {
    DMA: 807,
  },
  "94519": {
    DMA: 807,
  },
  "94520": {
    DMA: 807,
  },
  "94521": {
    DMA: 807,
  },
  "94522": {
    DMA: 807,
  },
  "94523": {
    DMA: 807,
  },
  "94524": {
    DMA: 807,
  },
  "94525": {
    DMA: 807,
  },
  "94526": {
    DMA: 807,
  },
  "94527": {
    DMA: 807,
  },
  "94528": {
    DMA: 807,
  },
  "94529": {
    DMA: 807,
  },
  "94530": {
    DMA: 807,
  },
  "94531": {
    DMA: 807,
  },
  "94533": {
    DMA: 862,
  },
  "94534": {
    DMA: 862,
  },
  "94535": {
    DMA: 862,
  },
  "94536": {
    DMA: 807,
  },
  "94537": {
    DMA: 807,
  },
  "94538": {
    DMA: 807,
  },
  "94539": {
    DMA: 807,
  },
  "94540": {
    DMA: 807,
  },
  "94541": {
    DMA: 807,
  },
  "94542": {
    DMA: 807,
  },
  "94543": {
    DMA: 807,
  },
  "94544": {
    DMA: 807,
  },
  "94545": {
    DMA: 807,
  },
  "94546": {
    DMA: 807,
  },
  "94547": {
    DMA: 807,
  },
  "94548": {
    DMA: 807,
  },
  "94549": {
    DMA: 807,
  },
  "94550": {
    DMA: 807,
  },
  "94551": {
    DMA: 807,
  },
  "94552": {
    DMA: 807,
  },
  "94553": {
    DMA: 807,
  },
  "94555": {
    DMA: 807,
  },
  "94556": {
    DMA: 807,
  },
  "94557": {
    DMA: 807,
  },
  "94558": {
    DMA: 807,
  },
  "94559": {
    DMA: 807,
  },
  "94560": {
    DMA: 807,
  },
  "94561": {
    DMA: 807,
  },
  "94562": {
    DMA: 807,
  },
  "94563": {
    DMA: 807,
  },
  "94564": {
    DMA: 807,
  },
  "94565": {
    DMA: 807,
  },
  "94566": {
    DMA: 807,
  },
  "94567": {
    DMA: 807,
  },
  "94568": {
    DMA: 807,
  },
  "94569": {
    DMA: 807,
  },
  "94570": {
    DMA: 807,
  },
  "94571": {
    DMA: 862,
  },
  "94572": {
    DMA: 807,
  },
  "94573": {
    DMA: 807,
  },
  "94574": {
    DMA: 807,
  },
  "94575": {
    DMA: 807,
  },
  "94576": {
    DMA: 807,
  },
  "94577": {
    DMA: 807,
  },
  "94578": {
    DMA: 807,
  },
  "94579": {
    DMA: 807,
  },
  "94580": {
    DMA: 807,
  },
  "94581": {
    DMA: 807,
  },
  "94582": {
    DMA: 807,
  },
  "94583": {
    DMA: 807,
  },
  "94585": {
    DMA: 862,
  },
  "94586": {
    DMA: 807,
  },
  "94587": {
    DMA: 807,
  },
  "94588": {
    DMA: 807,
  },
  "94589": {
    DMA: 862,
  },
  "94590": {
    DMA: 862,
  },
  "94591": {
    DMA: 862,
  },
  "94592": {
    DMA: 862,
  },
  "94595": {
    DMA: 807,
  },
  "94596": {
    DMA: 807,
  },
  "94597": {
    DMA: 807,
  },
  "94598": {
    DMA: 807,
  },
  "94599": {
    DMA: 807,
  },
  "94601": {
    DMA: 807,
  },
  "94602": {
    DMA: 807,
  },
  "94603": {
    DMA: 807,
  },
  "94604": {
    DMA: 807,
  },
  "94605": {
    DMA: 807,
  },
  "94606": {
    DMA: 807,
  },
  "94607": {
    DMA: 807,
  },
  "94608": {
    DMA: 807,
  },
  "94609": {
    DMA: 807,
  },
  "94610": {
    DMA: 807,
  },
  "94611": {
    DMA: 807,
  },
  "94612": {
    DMA: 807,
  },
  "94613": {
    DMA: 807,
  },
  "94614": {
    DMA: 807,
  },
  "94615": {
    DMA: 807,
  },
  "94617": {
    DMA: 807,
  },
  "94618": {
    DMA: 807,
  },
  "94619": {
    DMA: 807,
  },
  "94620": {
    DMA: 807,
  },
  "94621": {
    DMA: 807,
  },
  "94622": {
    DMA: 807,
  },
  "94623": {
    DMA: 807,
  },
  "94624": {
    DMA: 807,
  },
  "94625": {
    DMA: 807,
  },
  "94649": {
    DMA: 807,
  },
  "94659": {
    DMA: 807,
  },
  "94660": {
    DMA: 807,
  },
  "94661": {
    DMA: 807,
  },
  "94662": {
    DMA: 807,
  },
  "94666": {
    DMA: 807,
  },
  "94701": {
    DMA: 807,
  },
  "94702": {
    DMA: 807,
  },
  "94703": {
    DMA: 807,
  },
  "94704": {
    DMA: 807,
  },
  "94705": {
    DMA: 807,
  },
  "94706": {
    DMA: 807,
  },
  "94707": {
    DMA: 807,
  },
  "94708": {
    DMA: 807,
  },
  "94709": {
    DMA: 807,
  },
  "94710": {
    DMA: 807,
  },
  "94712": {
    DMA: 807,
  },
  "94720": {
    DMA: 807,
  },
  "94801": {
    DMA: 807,
  },
  "94802": {
    DMA: 807,
  },
  "94803": {
    DMA: 807,
  },
  "94804": {
    DMA: 807,
  },
  "94805": {
    DMA: 807,
  },
  "94806": {
    DMA: 807,
  },
  "94807": {
    DMA: 807,
  },
  "94808": {
    DMA: 807,
  },
  "94820": {
    DMA: 807,
  },
  "94850": {
    DMA: 807,
  },
  "94901": {
    DMA: 807,
  },
  "94903": {
    DMA: 807,
  },
  "94904": {
    DMA: 807,
  },
  "94912": {
    DMA: 807,
  },
  "94913": {
    DMA: 807,
  },
  "94914": {
    DMA: 807,
  },
  "94915": {
    DMA: 807,
  },
  "94920": {
    DMA: 807,
  },
  "94922": {
    DMA: 807,
  },
  "94923": {
    DMA: 807,
  },
  "94924": {
    DMA: 807,
  },
  "94925": {
    DMA: 807,
  },
  "94926": {
    DMA: 807,
  },
  "94927": {
    DMA: 807,
  },
  "94928": {
    DMA: 807,
  },
  "94929": {
    DMA: 807,
  },
  "94930": {
    DMA: 807,
  },
  "94931": {
    DMA: 807,
  },
  "94933": {
    DMA: 807,
  },
  "94937": {
    DMA: 807,
  },
  "94938": {
    DMA: 807,
  },
  "94939": {
    DMA: 807,
  },
  "94940": {
    DMA: 807,
  },
  "94941": {
    DMA: 807,
  },
  "94942": {
    DMA: 807,
  },
  "94945": {
    DMA: 807,
  },
  "94946": {
    DMA: 807,
  },
  "94947": {
    DMA: 807,
  },
  "94948": {
    DMA: 807,
  },
  "94949": {
    DMA: 807,
  },
  "94950": {
    DMA: 807,
  },
  "94951": {
    DMA: 807,
  },
  "94952": {
    DMA: 807,
  },
  "94953": {
    DMA: 807,
  },
  "94954": {
    DMA: 807,
  },
  "94955": {
    DMA: 807,
  },
  "94956": {
    DMA: 807,
  },
  "94957": {
    DMA: 807,
  },
  "94960": {
    DMA: 807,
  },
  "94963": {
    DMA: 807,
  },
  "94964": {
    DMA: 807,
  },
  "94965": {
    DMA: 807,
  },
  "94966": {
    DMA: 807,
  },
  "94970": {
    DMA: 807,
  },
  "94971": {
    DMA: 807,
  },
  "94972": {
    DMA: 807,
  },
  "94973": {
    DMA: 807,
  },
  "94974": {
    DMA: 807,
  },
  "94975": {
    DMA: 807,
  },
  "94976": {
    DMA: 807,
  },
  "94977": {
    DMA: 807,
  },
  "94978": {
    DMA: 807,
  },
  "94979": {
    DMA: 807,
  },
  "94998": {
    DMA: 807,
  },
  "94999": {
    DMA: 807,
  },
  "95001": {
    DMA: 828,
  },
  "95002": {
    DMA: 807,
  },
  "95003": {
    DMA: 828,
  },
  "95004": {
    DMA: 828,
  },
  "95005": {
    DMA: 828,
  },
  "95006": {
    DMA: 828,
  },
  "95007": {
    DMA: 828,
  },
  "95008": {
    DMA: 807,
  },
  "95009": {
    DMA: 807,
  },
  "95010": {
    DMA: 828,
  },
  "95011": {
    DMA: 807,
  },
  "95012": {
    DMA: 828,
  },
  "95013": {
    DMA: 807,
  },
  "95014": {
    DMA: 807,
  },
  "95015": {
    DMA: 807,
  },
  "95017": {
    DMA: 828,
  },
  "95018": {
    DMA: 828,
  },
  "95019": {
    DMA: 828,
  },
  "95020": {
    DMA: 807,
  },
  "95021": {
    DMA: 807,
  },
  "95023": {
    DMA: 828,
  },
  "95024": {
    DMA: 828,
  },
  "95026": {
    DMA: 807,
  },
  "95030": {
    DMA: 807,
  },
  "95031": {
    DMA: 807,
  },
  "95032": {
    DMA: 807,
  },
  "95033": {
    DMA: 828,
  },
  "95035": {
    DMA: 807,
  },
  "95036": {
    DMA: 807,
  },
  "95037": {
    DMA: 807,
  },
  "95038": {
    DMA: 807,
  },
  "95039": {
    DMA: 828,
  },
  "95041": {
    DMA: 828,
  },
  "95042": {
    DMA: 807,
  },
  "95043": {
    DMA: 828,
  },
  "95044": {
    DMA: 807,
  },
  "95045": {
    DMA: 828,
  },
  "95046": {
    DMA: 807,
  },
  "95050": {
    DMA: 807,
  },
  "95051": {
    DMA: 807,
  },
  "95052": {
    DMA: 807,
  },
  "95053": {
    DMA: 807,
  },
  "95054": {
    DMA: 807,
  },
  "95055": {
    DMA: 807,
  },
  "95056": {
    DMA: 807,
  },
  "95060": {
    DMA: 828,
  },
  "95061": {
    DMA: 828,
  },
  "95062": {
    DMA: 828,
  },
  "95063": {
    DMA: 828,
  },
  "95064": {
    DMA: 828,
  },
  "95065": {
    DMA: 828,
  },
  "95066": {
    DMA: 828,
  },
  "95067": {
    DMA: 828,
  },
  "95070": {
    DMA: 807,
  },
  "95071": {
    DMA: 807,
  },
  "95073": {
    DMA: 828,
  },
  "95075": {
    DMA: 828,
  },
  "95076": {
    DMA: 828,
  },
  "95077": {
    DMA: 828,
  },
  "95101": {
    DMA: 807,
  },
  "95103": {
    DMA: 807,
  },
  "95106": {
    DMA: 807,
  },
  "95108": {
    DMA: 807,
  },
  "95109": {
    DMA: 807,
  },
  "95110": {
    DMA: 807,
  },
  "95111": {
    DMA: 807,
  },
  "95112": {
    DMA: 807,
  },
  "95113": {
    DMA: 807,
  },
  "95115": {
    DMA: 807,
  },
  "95116": {
    DMA: 807,
  },
  "95117": {
    DMA: 807,
  },
  "95118": {
    DMA: 807,
  },
  "95119": {
    DMA: 807,
  },
  "95120": {
    DMA: 807,
  },
  "95121": {
    DMA: 807,
  },
  "95122": {
    DMA: 807,
  },
  "95123": {
    DMA: 807,
  },
  "95124": {
    DMA: 807,
  },
  "95125": {
    DMA: 807,
  },
  "95126": {
    DMA: 807,
  },
  "95127": {
    DMA: 807,
  },
  "95128": {
    DMA: 807,
  },
  "95129": {
    DMA: 807,
  },
  "95130": {
    DMA: 807,
  },
  "95131": {
    DMA: 807,
  },
  "95132": {
    DMA: 807,
  },
  "95133": {
    DMA: 807,
  },
  "95134": {
    DMA: 807,
  },
  "95135": {
    DMA: 807,
  },
  "95136": {
    DMA: 807,
  },
  "95138": {
    DMA: 807,
  },
  "95139": {
    DMA: 807,
  },
  "95140": {
    DMA: 807,
  },
  "95141": {
    DMA: 807,
  },
  "95148": {
    DMA: 807,
  },
  "95150": {
    DMA: 807,
  },
  "95151": {
    DMA: 807,
  },
  "95152": {
    DMA: 807,
  },
  "95153": {
    DMA: 807,
  },
  "95154": {
    DMA: 807,
  },
  "95155": {
    DMA: 807,
  },
  "95156": {
    DMA: 807,
  },
  "95157": {
    DMA: 807,
  },
  "95158": {
    DMA: 807,
  },
  "95159": {
    DMA: 807,
  },
  "95160": {
    DMA: 807,
  },
  "95161": {
    DMA: 807,
  },
  "95164": {
    DMA: 807,
  },
  "95170": {
    DMA: 807,
  },
  "95172": {
    DMA: 807,
  },
  "95173": {
    DMA: 807,
  },
  "95190": {
    DMA: 807,
  },
  "95191": {
    DMA: 807,
  },
  "95192": {
    DMA: 807,
  },
  "95193": {
    DMA: 807,
  },
  "95194": {
    DMA: 807,
  },
  "95196": {
    DMA: 807,
  },
  "95201": {
    DMA: 862,
  },
  "95202": {
    DMA: 862,
  },
  "95203": {
    DMA: 862,
  },
  "95204": {
    DMA: 862,
  },
  "95205": {
    DMA: 862,
  },
  "95206": {
    DMA: 862,
  },
  "95207": {
    DMA: 862,
  },
  "95208": {
    DMA: 862,
  },
  "95209": {
    DMA: 862,
  },
  "95210": {
    DMA: 862,
  },
  "95211": {
    DMA: 862,
  },
  "95212": {
    DMA: 862,
  },
  "95213": {
    DMA: 862,
  },
  "95214": {
    DMA: 862,
  },
  "95215": {
    DMA: 862,
  },
  "95219": {
    DMA: 862,
  },
  "95220": {
    DMA: 862,
  },
  "95221": {
    DMA: 862,
  },
  "95222": {
    DMA: 862,
  },
  "95223": {
    DMA: 862,
  },
  "95224": {
    DMA: 862,
  },
  "95225": {
    DMA: 862,
  },
  "95226": {
    DMA: 862,
  },
  "95227": {
    DMA: 862,
  },
  "95228": {
    DMA: 862,
  },
  "95229": {
    DMA: 862,
  },
  "95230": {
    DMA: 862,
  },
  "95231": {
    DMA: 862,
  },
  "95232": {
    DMA: 862,
  },
  "95233": {
    DMA: 862,
  },
  "95234": {
    DMA: 862,
  },
  "95236": {
    DMA: 862,
  },
  "95237": {
    DMA: 862,
  },
  "95240": {
    DMA: 862,
  },
  "95241": {
    DMA: 862,
  },
  "95242": {
    DMA: 862,
  },
  "95245": {
    DMA: 862,
  },
  "95246": {
    DMA: 862,
  },
  "95247": {
    DMA: 862,
  },
  "95248": {
    DMA: 862,
  },
  "95249": {
    DMA: 862,
  },
  "95250": {
    DMA: 862,
  },
  "95251": {
    DMA: 862,
  },
  "95252": {
    DMA: 862,
  },
  "95253": {
    DMA: 862,
  },
  "95254": {
    DMA: 862,
  },
  "95255": {
    DMA: 862,
  },
  "95257": {
    DMA: 862,
  },
  "95258": {
    DMA: 862,
  },
  "95267": {
    DMA: 862,
  },
  "95269": {
    DMA: 862,
  },
  "95296": {
    DMA: 862,
  },
  "95297": {
    DMA: 862,
  },
  "95301": {
    DMA: 866,
  },
  "95303": {
    DMA: 866,
  },
  "95304": {
    DMA: 862,
  },
  "95305": {
    DMA: 862,
  },
  "95306": {
    DMA: 866,
  },
  "95307": {
    DMA: 862,
  },
  "95309": {
    DMA: 862,
  },
  "95310": {
    DMA: 862,
  },
  "95311": {
    DMA: 866,
  },
  "95312": {
    DMA: 866,
  },
  "95313": {
    DMA: 862,
  },
  "95314": {
    DMA: 862,
  },
  "95315": {
    DMA: 866,
  },
  "95316": {
    DMA: 862,
  },
  "95317": {
    DMA: 866,
  },
  "95318": {
    DMA: 866,
  },
  "95319": {
    DMA: 862,
  },
  "95320": {
    DMA: 862,
  },
  "95321": {
    DMA: 862,
  },
  "95322": {
    DMA: 866,
  },
  "95323": {
    DMA: 862,
  },
  "95324": {
    DMA: 866,
  },
  "95325": {
    DMA: 866,
  },
  "95326": {
    DMA: 862,
  },
  "95327": {
    DMA: 862,
  },
  "95328": {
    DMA: 862,
  },
  "95329": {
    DMA: 862,
  },
  "95330": {
    DMA: 862,
  },
  "95333": {
    DMA: 866,
  },
  "95334": {
    DMA: 866,
  },
  "95335": {
    DMA: 862,
  },
  "95336": {
    DMA: 862,
  },
  "95337": {
    DMA: 862,
  },
  "95338": {
    DMA: 866,
  },
  "95340": {
    DMA: 866,
  },
  "95341": {
    DMA: 866,
  },
  "95343": {
    DMA: 866,
  },
  "95344": {
    DMA: 866,
  },
  "95345": {
    DMA: 866,
  },
  "95346": {
    DMA: 862,
  },
  "95347": {
    DMA: 862,
  },
  "95348": {
    DMA: 866,
  },
  "95350": {
    DMA: 862,
  },
  "95351": {
    DMA: 862,
  },
  "95352": {
    DMA: 862,
  },
  "95353": {
    DMA: 862,
  },
  "95354": {
    DMA: 862,
  },
  "95355": {
    DMA: 862,
  },
  "95356": {
    DMA: 862,
  },
  "95357": {
    DMA: 862,
  },
  "95358": {
    DMA: 862,
  },
  "95360": {
    DMA: 862,
  },
  "95361": {
    DMA: 862,
  },
  "95363": {
    DMA: 862,
  },
  "95364": {
    DMA: 862,
  },
  "95365": {
    DMA: 866,
  },
  "95366": {
    DMA: 862,
  },
  "95367": {
    DMA: 862,
  },
  "95368": {
    DMA: 862,
  },
  "95369": {
    DMA: 866,
  },
  "95370": {
    DMA: 862,
  },
  "95372": {
    DMA: 862,
  },
  "95373": {
    DMA: 862,
  },
  "95374": {
    DMA: 866,
  },
  "95375": {
    DMA: 862,
  },
  "95376": {
    DMA: 862,
  },
  "95377": {
    DMA: 862,
  },
  "95378": {
    DMA: 862,
  },
  "95379": {
    DMA: 862,
  },
  "95380": {
    DMA: 862,
  },
  "95381": {
    DMA: 862,
  },
  "95382": {
    DMA: 862,
  },
  "95383": {
    DMA: 862,
  },
  "95385": {
    DMA: 862,
  },
  "95386": {
    DMA: 862,
  },
  "95387": {
    DMA: 862,
  },
  "95388": {
    DMA: 866,
  },
  "95389": {
    DMA: 866,
  },
  "95391": {
    DMA: 862,
  },
  "95397": {
    DMA: 862,
  },
  "95401": {
    DMA: 807,
  },
  "95402": {
    DMA: 807,
  },
  "95403": {
    DMA: 807,
  },
  "95404": {
    DMA: 807,
  },
  "95405": {
    DMA: 807,
  },
  "95406": {
    DMA: 807,
  },
  "95407": {
    DMA: 807,
  },
  "95409": {
    DMA: 807,
  },
  "95410": {
    DMA: 807,
  },
  "95412": {
    DMA: 807,
  },
  "95415": {
    DMA: 807,
  },
  "95416": {
    DMA: 807,
  },
  "95417": {
    DMA: 807,
  },
  "95418": {
    DMA: 807,
  },
  "95419": {
    DMA: 807,
  },
  "95420": {
    DMA: 807,
  },
  "95421": {
    DMA: 807,
  },
  "95422": {
    DMA: 807,
  },
  "95423": {
    DMA: 807,
  },
  "95424": {
    DMA: 807,
  },
  "95425": {
    DMA: 807,
  },
  "95426": {
    DMA: 807,
  },
  "95427": {
    DMA: 807,
  },
  "95428": {
    DMA: 807,
  },
  "95429": {
    DMA: 807,
  },
  "95430": {
    DMA: 807,
  },
  "95431": {
    DMA: 807,
  },
  "95432": {
    DMA: 807,
  },
  "95433": {
    DMA: 807,
  },
  "95435": {
    DMA: 807,
  },
  "95436": {
    DMA: 807,
  },
  "95437": {
    DMA: 807,
  },
  "95439": {
    DMA: 807,
  },
  "95441": {
    DMA: 807,
  },
  "95442": {
    DMA: 807,
  },
  "95443": {
    DMA: 807,
  },
  "95444": {
    DMA: 807,
  },
  "95445": {
    DMA: 807,
  },
  "95446": {
    DMA: 807,
  },
  "95448": {
    DMA: 807,
  },
  "95449": {
    DMA: 807,
  },
  "95450": {
    DMA: 807,
  },
  "95451": {
    DMA: 807,
  },
  "95452": {
    DMA: 807,
  },
  "95453": {
    DMA: 807,
  },
  "95454": {
    DMA: 807,
  },
  "95456": {
    DMA: 807,
  },
  "95457": {
    DMA: 807,
  },
  "95458": {
    DMA: 807,
  },
  "95459": {
    DMA: 807,
  },
  "95460": {
    DMA: 807,
  },
  "95461": {
    DMA: 807,
  },
  "95462": {
    DMA: 807,
  },
  "95463": {
    DMA: 807,
  },
  "95464": {
    DMA: 807,
  },
  "95465": {
    DMA: 807,
  },
  "95466": {
    DMA: 807,
  },
  "95467": {
    DMA: 807,
  },
  "95468": {
    DMA: 807,
  },
  "95469": {
    DMA: 807,
  },
  "95470": {
    DMA: 807,
  },
  "95471": {
    DMA: 807,
  },
  "95472": {
    DMA: 807,
  },
  "95473": {
    DMA: 807,
  },
  "95476": {
    DMA: 807,
  },
  "95480": {
    DMA: 807,
  },
  "95481": {
    DMA: 807,
  },
  "95482": {
    DMA: 807,
  },
  "95485": {
    DMA: 807,
  },
  "95486": {
    DMA: 807,
  },
  "95487": {
    DMA: 807,
  },
  "95488": {
    DMA: 807,
  },
  "95490": {
    DMA: 807,
  },
  "95492": {
    DMA: 807,
  },
  "95493": {
    DMA: 807,
  },
  "95494": {
    DMA: 807,
  },
  "95497": {
    DMA: 807,
  },
  "95501": {
    DMA: 802,
  },
  "95502": {
    DMA: 802,
  },
  "95503": {
    DMA: 802,
  },
  "95511": {
    DMA: 802,
  },
  "95514": {
    DMA: 802,
  },
  "95518": {
    DMA: 802,
  },
  "95519": {
    DMA: 802,
  },
  "95521": {
    DMA: 802,
  },
  "95524": {
    DMA: 802,
  },
  "95525": {
    DMA: 802,
  },
  "95526": {
    DMA: 802,
  },
  "95527": {
    DMA: 868,
  },
  "95528": {
    DMA: 802,
  },
  "95531": {
    DMA: 802,
  },
  "95532": {
    DMA: 802,
  },
  "95534": {
    DMA: 802,
  },
  "95536": {
    DMA: 802,
  },
  "95537": {
    DMA: 802,
  },
  "95538": {
    DMA: 802,
  },
  "95540": {
    DMA: 802,
  },
  "95542": {
    DMA: 802,
  },
  "95543": {
    DMA: 802,
  },
  "95545": {
    DMA: 802,
  },
  "95546": {
    DMA: 802,
  },
  "95547": {
    DMA: 802,
  },
  "95548": {
    DMA: 802,
  },
  "95549": {
    DMA: 802,
  },
  "95550": {
    DMA: 802,
  },
  "95551": {
    DMA: 802,
  },
  "95552": {
    DMA: 868,
  },
  "95553": {
    DMA: 802,
  },
  "95554": {
    DMA: 802,
  },
  "95555": {
    DMA: 802,
  },
  "95556": {
    DMA: 802,
  },
  "95558": {
    DMA: 802,
  },
  "95559": {
    DMA: 802,
  },
  "95560": {
    DMA: 802,
  },
  "95562": {
    DMA: 802,
  },
  "95563": {
    DMA: 868,
  },
  "95564": {
    DMA: 802,
  },
  "95565": {
    DMA: 802,
  },
  "95567": {
    DMA: 802,
  },
  "95568": {
    DMA: 813,
  },
  "95569": {
    DMA: 802,
  },
  "95570": {
    DMA: 802,
  },
  "95571": {
    DMA: 802,
  },
  "95573": {
    DMA: 802,
  },
  "95585": {
    DMA: 807,
  },
  "95587": {
    DMA: 807,
  },
  "95589": {
    DMA: 802,
  },
  "95595": {
    DMA: 868,
  },
  "95601": {
    DMA: 862,
  },
  "95602": {
    DMA: 862,
  },
  "95603": {
    DMA: 862,
  },
  "95604": {
    DMA: 862,
  },
  "95605": {
    DMA: 862,
  },
  "95606": {
    DMA: 862,
  },
  "95607": {
    DMA: 862,
  },
  "95608": {
    DMA: 862,
  },
  "95609": {
    DMA: 862,
  },
  "95610": {
    DMA: 862,
  },
  "95611": {
    DMA: 862,
  },
  "95612": {
    DMA: 862,
  },
  "95613": {
    DMA: 862,
  },
  "95614": {
    DMA: 862,
  },
  "95615": {
    DMA: 862,
  },
  "95616": {
    DMA: 862,
  },
  "95617": {
    DMA: 862,
  },
  "95618": {
    DMA: 862,
  },
  "95619": {
    DMA: 862,
  },
  "95620": {
    DMA: 862,
  },
  "95621": {
    DMA: 862,
  },
  "95623": {
    DMA: 862,
  },
  "95624": {
    DMA: 862,
  },
  "95625": {
    DMA: 862,
  },
  "95626": {
    DMA: 862,
  },
  "95627": {
    DMA: 862,
  },
  "95628": {
    DMA: 862,
  },
  "95629": {
    DMA: 862,
  },
  "95630": {
    DMA: 862,
  },
  "95631": {
    DMA: 862,
  },
  "95632": {
    DMA: 862,
  },
  "95633": {
    DMA: 862,
  },
  "95634": {
    DMA: 862,
  },
  "95635": {
    DMA: 862,
  },
  "95636": {
    DMA: 862,
  },
  "95637": {
    DMA: 862,
  },
  "95638": {
    DMA: 862,
  },
  "95639": {
    DMA: 862,
  },
  "95640": {
    DMA: 862,
  },
  "95641": {
    DMA: 862,
  },
  "95642": {
    DMA: 862,
  },
  "95644": {
    DMA: 862,
  },
  "95645": {
    DMA: 862,
  },
  "95646": {
    DMA: 811,
  },
  "95648": {
    DMA: 862,
  },
  "95650": {
    DMA: 862,
  },
  "95651": {
    DMA: 862,
  },
  "95652": {
    DMA: 862,
  },
  "95653": {
    DMA: 862,
  },
  "95654": {
    DMA: 862,
  },
  "95655": {
    DMA: 862,
  },
  "95656": {
    DMA: 862,
  },
  "95658": {
    DMA: 862,
  },
  "95659": {
    DMA: 862,
  },
  "95660": {
    DMA: 862,
  },
  "95661": {
    DMA: 862,
  },
  "95662": {
    DMA: 862,
  },
  "95663": {
    DMA: 862,
  },
  "95664": {
    DMA: 862,
  },
  "95665": {
    DMA: 862,
  },
  "95666": {
    DMA: 862,
  },
  "95667": {
    DMA: 862,
  },
  "95668": {
    DMA: 862,
  },
  "95669": {
    DMA: 862,
  },
  "95670": {
    DMA: 862,
  },
  "95671": {
    DMA: 862,
  },
  "95672": {
    DMA: 862,
  },
  "95673": {
    DMA: 862,
  },
  "95674": {
    DMA: 862,
  },
  "95675": {
    DMA: 862,
  },
  "95676": {
    DMA: 862,
  },
  "95677": {
    DMA: 862,
  },
  "95678": {
    DMA: 862,
  },
  "95679": {
    DMA: 862,
  },
  "95680": {
    DMA: 862,
  },
  "95681": {
    DMA: 862,
  },
  "95682": {
    DMA: 862,
  },
  "95683": {
    DMA: 862,
  },
  "95684": {
    DMA: 862,
  },
  "95685": {
    DMA: 862,
  },
  "95686": {
    DMA: 862,
  },
  "95687": {
    DMA: 862,
  },
  "95688": {
    DMA: 862,
  },
  "95689": {
    DMA: 862,
  },
  "95690": {
    DMA: 862,
  },
  "95691": {
    DMA: 862,
  },
  "95692": {
    DMA: 862,
  },
  "95693": {
    DMA: 862,
  },
  "95694": {
    DMA: 862,
  },
  "95695": {
    DMA: 862,
  },
  "95696": {
    DMA: 862,
  },
  "95697": {
    DMA: 862,
  },
  "95698": {
    DMA: 862,
  },
  "95699": {
    DMA: 862,
  },
  "95701": {
    DMA: 862,
  },
  "95703": {
    DMA: 862,
  },
  "95709": {
    DMA: 862,
  },
  "95712": {
    DMA: 862,
  },
  "95713": {
    DMA: 862,
  },
  "95714": {
    DMA: 862,
  },
  "95715": {
    DMA: 862,
  },
  "95717": {
    DMA: 862,
  },
  "95720": {
    DMA: 862,
  },
  "95721": {
    DMA: 862,
  },
  "95722": {
    DMA: 862,
  },
  "95724": {
    DMA: 862,
  },
  "95726": {
    DMA: 862,
  },
  "95728": {
    DMA: 862,
  },
  "95735": {
    DMA: 862,
  },
  "95736": {
    DMA: 862,
  },
  "95741": {
    DMA: 862,
  },
  "95742": {
    DMA: 862,
  },
  "95746": {
    DMA: 862,
  },
  "95747": {
    DMA: 862,
  },
  "95757": {
    DMA: 862,
  },
  "95758": {
    DMA: 862,
  },
  "95759": {
    DMA: 862,
  },
  "95762": {
    DMA: 862,
  },
  "95763": {
    DMA: 862,
  },
  "95765": {
    DMA: 862,
  },
  "95776": {
    DMA: 862,
  },
  "95798": {
    DMA: 862,
  },
  "95799": {
    DMA: 862,
  },
  "95811": {
    DMA: 862,
  },
  "95812": {
    DMA: 862,
  },
  "95813": {
    DMA: 862,
  },
  "95814": {
    DMA: 862,
  },
  "95815": {
    DMA: 862,
  },
  "95816": {
    DMA: 862,
  },
  "95817": {
    DMA: 862,
  },
  "95818": {
    DMA: 862,
  },
  "95819": {
    DMA: 862,
  },
  "95820": {
    DMA: 862,
  },
  "95821": {
    DMA: 862,
  },
  "95822": {
    DMA: 862,
  },
  "95823": {
    DMA: 862,
  },
  "95824": {
    DMA: 862,
  },
  "95825": {
    DMA: 862,
  },
  "95826": {
    DMA: 862,
  },
  "95827": {
    DMA: 862,
  },
  "95828": {
    DMA: 862,
  },
  "95829": {
    DMA: 862,
  },
  "95830": {
    DMA: 862,
  },
  "95831": {
    DMA: 862,
  },
  "95832": {
    DMA: 862,
  },
  "95833": {
    DMA: 862,
  },
  "95834": {
    DMA: 862,
  },
  "95835": {
    DMA: 862,
  },
  "95836": {
    DMA: 862,
  },
  "95837": {
    DMA: 862,
  },
  "95838": {
    DMA: 862,
  },
  "95840": {
    DMA: 862,
  },
  "95841": {
    DMA: 862,
  },
  "95842": {
    DMA: 862,
  },
  "95843": {
    DMA: 862,
  },
  "95851": {
    DMA: 862,
  },
  "95852": {
    DMA: 862,
  },
  "95853": {
    DMA: 862,
  },
  "95860": {
    DMA: 862,
  },
  "95864": {
    DMA: 862,
  },
  "95865": {
    DMA: 862,
  },
  "95866": {
    DMA: 862,
  },
  "95867": {
    DMA: 862,
  },
  "95887": {
    DMA: 862,
  },
  "95894": {
    DMA: 862,
  },
  "95899": {
    DMA: 862,
  },
  "95901": {
    DMA: 862,
  },
  "95903": {
    DMA: 862,
  },
  "95910": {
    DMA: 862,
  },
  "95912": {
    DMA: 862,
  },
  "95913": {
    DMA: 868,
  },
  "95914": {
    DMA: 868,
  },
  "95915": {
    DMA: 862,
  },
  "95916": {
    DMA: 868,
  },
  "95917": {
    DMA: 868,
  },
  "95918": {
    DMA: 862,
  },
  "95919": {
    DMA: 862,
  },
  "95920": {
    DMA: 868,
  },
  "95922": {
    DMA: 862,
  },
  "95923": {
    DMA: 862,
  },
  "95924": {
    DMA: 862,
  },
  "95925": {
    DMA: 862,
  },
  "95926": {
    DMA: 868,
  },
  "95927": {
    DMA: 868,
  },
  "95928": {
    DMA: 868,
  },
  "95929": {
    DMA: 868,
  },
  "95930": {
    DMA: 868,
  },
  "95932": {
    DMA: 862,
  },
  "95934": {
    DMA: 862,
  },
  "95935": {
    DMA: 862,
  },
  "95936": {
    DMA: 862,
  },
  "95937": {
    DMA: 862,
  },
  "95938": {
    DMA: 868,
  },
  "95939": {
    DMA: 868,
  },
  "95940": {
    DMA: 868,
  },
  "95941": {
    DMA: 868,
  },
  "95942": {
    DMA: 868,
  },
  "95943": {
    DMA: 868,
  },
  "95944": {
    DMA: 862,
  },
  "95945": {
    DMA: 862,
  },
  "95946": {
    DMA: 862,
  },
  "95947": {
    DMA: 862,
  },
  "95948": {
    DMA: 868,
  },
  "95949": {
    DMA: 862,
  },
  "95950": {
    DMA: 862,
  },
  "95951": {
    DMA: 868,
  },
  "95953": {
    DMA: 862,
  },
  "95954": {
    DMA: 868,
  },
  "95955": {
    DMA: 862,
  },
  "95956": {
    DMA: 862,
  },
  "95957": {
    DMA: 862,
  },
  "95958": {
    DMA: 868,
  },
  "95959": {
    DMA: 862,
  },
  "95960": {
    DMA: 862,
  },
  "95961": {
    DMA: 862,
  },
  "95962": {
    DMA: 862,
  },
  "95963": {
    DMA: 868,
  },
  "95965": {
    DMA: 868,
  },
  "95966": {
    DMA: 868,
  },
  "95967": {
    DMA: 868,
  },
  "95968": {
    DMA: 868,
  },
  "95969": {
    DMA: 868,
  },
  "95970": {
    DMA: 862,
  },
  "95971": {
    DMA: 862,
  },
  "95972": {
    DMA: 862,
  },
  "95973": {
    DMA: 868,
  },
  "95974": {
    DMA: 868,
  },
  "95975": {
    DMA: 862,
  },
  "95976": {
    DMA: 868,
  },
  "95977": {
    DMA: 862,
  },
  "95978": {
    DMA: 868,
  },
  "95979": {
    DMA: 862,
  },
  "95980": {
    DMA: 862,
  },
  "95981": {
    DMA: 862,
  },
  "95982": {
    DMA: 862,
  },
  "95983": {
    DMA: 862,
  },
  "95984": {
    DMA: 862,
  },
  "95986": {
    DMA: 862,
  },
  "95987": {
    DMA: 862,
  },
  "95988": {
    DMA: 868,
  },
  "95991": {
    DMA: 862,
  },
  "95992": {
    DMA: 862,
  },
  "95993": {
    DMA: 862,
  },
  "96001": {
    DMA: 868,
  },
  "96002": {
    DMA: 868,
  },
  "96003": {
    DMA: 868,
  },
  "96006": {
    DMA: 868,
  },
  "96007": {
    DMA: 868,
  },
  "96008": {
    DMA: 868,
  },
  "96009": {
    DMA: 811,
  },
  "96010": {
    DMA: 868,
  },
  "96011": {
    DMA: 868,
  },
  "96013": {
    DMA: 868,
  },
  "96014": {
    DMA: 813,
  },
  "96015": {
    DMA: 868,
  },
  "96016": {
    DMA: 868,
  },
  "96017": {
    DMA: 868,
  },
  "96019": {
    DMA: 868,
  },
  "96020": {
    DMA: 862,
  },
  "96021": {
    DMA: 868,
  },
  "96022": {
    DMA: 868,
  },
  "96023": {
    DMA: 813,
  },
  "96024": {
    DMA: 868,
  },
  "96025": {
    DMA: 813,
  },
  "96027": {
    DMA: 813,
  },
  "96028": {
    DMA: 868,
  },
  "96029": {
    DMA: 868,
  },
  "96031": {
    DMA: 813,
  },
  "96032": {
    DMA: 813,
  },
  "96033": {
    DMA: 868,
  },
  "96034": {
    DMA: 813,
  },
  "96035": {
    DMA: 868,
  },
  "96037": {
    DMA: 813,
  },
  "96038": {
    DMA: 813,
  },
  "96039": {
    DMA: 813,
  },
  "96040": {
    DMA: 868,
  },
  "96041": {
    DMA: 868,
  },
  "96044": {
    DMA: 813,
  },
  "96046": {
    DMA: 868,
  },
  "96047": {
    DMA: 868,
  },
  "96048": {
    DMA: 868,
  },
  "96049": {
    DMA: 868,
  },
  "96050": {
    DMA: 813,
  },
  "96051": {
    DMA: 868,
  },
  "96052": {
    DMA: 868,
  },
  "96054": {
    DMA: 868,
  },
  "96055": {
    DMA: 868,
  },
  "96056": {
    DMA: 811,
  },
  "96057": {
    DMA: 813,
  },
  "96058": {
    DMA: 813,
  },
  "96059": {
    DMA: 868,
  },
  "96061": {
    DMA: 868,
  },
  "96062": {
    DMA: 868,
  },
  "96063": {
    DMA: 868,
  },
  "96064": {
    DMA: 813,
  },
  "96065": {
    DMA: 868,
  },
  "96067": {
    DMA: 813,
  },
  "96068": {
    DMA: 811,
  },
  "96069": {
    DMA: 868,
  },
  "96070": {
    DMA: 868,
  },
  "96071": {
    DMA: 868,
  },
  "96073": {
    DMA: 868,
  },
  "96074": {
    DMA: 868,
  },
  "96075": {
    DMA: 868,
  },
  "96076": {
    DMA: 868,
  },
  "96078": {
    DMA: 868,
  },
  "96079": {
    DMA: 868,
  },
  "96080": {
    DMA: 868,
  },
  "96084": {
    DMA: 868,
  },
  "96085": {
    DMA: 813,
  },
  "96086": {
    DMA: 813,
  },
  "96087": {
    DMA: 868,
  },
  "96088": {
    DMA: 868,
  },
  "96089": {
    DMA: 868,
  },
  "96090": {
    DMA: 868,
  },
  "96091": {
    DMA: 868,
  },
  "96092": {
    DMA: 868,
  },
  "96093": {
    DMA: 868,
  },
  "96094": {
    DMA: 813,
  },
  "96095": {
    DMA: 868,
  },
  "96096": {
    DMA: 868,
  },
  "96097": {
    DMA: 813,
  },
  "96099": {
    DMA: 868,
  },
  "96101": {
    DMA: 868,
  },
  "96103": {
    DMA: 862,
  },
  "96104": {
    DMA: 868,
  },
  "96105": {
    DMA: 862,
  },
  "96106": {
    DMA: 862,
  },
  "96107": {
    DMA: 811,
  },
  "96108": {
    DMA: 868,
  },
  "96109": {
    DMA: 811,
  },
  "96110": {
    DMA: 868,
  },
  "96111": {
    DMA: 862,
  },
  "96112": {
    DMA: 868,
  },
  "96113": {
    DMA: 811,
  },
  "96114": {
    DMA: 811,
  },
  "96115": {
    DMA: 868,
  },
  "96116": {
    DMA: 868,
  },
  "96117": {
    DMA: 811,
  },
  "96118": {
    DMA: 862,
  },
  "96119": {
    DMA: 811,
  },
  "96120": {
    DMA: 811,
  },
  "96121": {
    DMA: 811,
  },
  "96122": {
    DMA: 862,
  },
  "96123": {
    DMA: 811,
  },
  "96124": {
    DMA: 862,
  },
  "96125": {
    DMA: 862,
  },
  "96126": {
    DMA: 862,
  },
  "96127": {
    DMA: 811,
  },
  "96128": {
    DMA: 811,
  },
  "96129": {
    DMA: 862,
  },
  "96130": {
    DMA: 811,
  },
  "96132": {
    DMA: 811,
  },
  "96133": {
    DMA: 811,
  },
  "96134": {
    DMA: 813,
  },
  "96135": {
    DMA: 862,
  },
  "96136": {
    DMA: 811,
  },
  "96137": {
    DMA: 811,
  },
  "96140": {
    DMA: 862,
  },
  "96141": {
    DMA: 862,
  },
  "96142": {
    DMA: 862,
  },
  "96143": {
    DMA: 862,
  },
  "96145": {
    DMA: 862,
  },
  "96146": {
    DMA: 862,
  },
  "96148": {
    DMA: 862,
  },
  "96150": {
    DMA: 862,
  },
  "96151": {
    DMA: 862,
  },
  "96152": {
    DMA: 862,
  },
  "96154": {
    DMA: 862,
  },
  "96155": {
    DMA: 862,
  },
  "96156": {
    DMA: 862,
  },
  "96157": {
    DMA: 862,
  },
  "96158": {
    DMA: 862,
  },
  "96160": {
    DMA: 862,
  },
  "96161": {
    DMA: 862,
  },
  "96162": {
    DMA: 862,
  },
  "96201": {
    DMA: "MIL",
  },
  "96202": {
    DMA: "MIL",
  },
  "96203": {
    DMA: "MIL",
  },
  "96204": {
    DMA: "MIL",
  },
  "96205": {
    DMA: "MIL",
  },
  "96206": {
    DMA: "MIL",
  },
  "96207": {
    DMA: "MIL",
  },
  "96208": {
    DMA: "MIL",
  },
  "96209": {
    DMA: "MIL",
  },
  "96210": {
    DMA: "MIL",
  },
  "96212": {
    DMA: "MIL",
  },
  "96213": {
    DMA: "MIL",
  },
  "96214": {
    DMA: "MIL",
  },
  "96215": {
    DMA: "MIL",
  },
  "96217": {
    DMA: "MIL",
  },
  "96218": {
    DMA: "MIL",
  },
  "96219": {
    DMA: "MIL",
  },
  "96220": {
    DMA: "MIL",
  },
  "96221": {
    DMA: "MIL",
  },
  "96224": {
    DMA: "MIL",
  },
  "96251": {
    DMA: "MIL",
  },
  "96257": {
    DMA: "MIL",
  },
  "96258": {
    DMA: "MIL",
  },
  "96259": {
    DMA: "MIL",
  },
  "96260": {
    DMA: "MIL",
  },
  "96262": {
    DMA: "MIL",
  },
  "96264": {
    DMA: "MIL",
  },
  "96266": {
    DMA: "MIL",
  },
  "96267": {
    DMA: "MIL",
  },
  "96269": {
    DMA: "MIL",
  },
  "96271": {
    DMA: "MIL",
  },
  "96273": {
    DMA: "MIL",
  },
  "96275": {
    DMA: "MIL",
  },
  "96276": {
    DMA: "MIL",
  },
  "96278": {
    DMA: "MIL",
  },
  "96283": {
    DMA: "MIL",
  },
  "96284": {
    DMA: "MIL",
  },
  "96297": {
    DMA: "MIL",
  },
  "96301": {
    DMA: "MIL",
  },
  "96303": {
    DMA: "MIL",
  },
  "96306": {
    DMA: "MIL",
  },
  "96309": {
    DMA: "MIL",
  },
  "96310": {
    DMA: "MIL",
  },
  "96311": {
    DMA: "MIL",
  },
  "96313": {
    DMA: "MIL",
  },
  "96315": {
    DMA: "MIL",
  },
  "96319": {
    DMA: "MIL",
  },
  "96321": {
    DMA: "MIL",
  },
  "96322": {
    DMA: "MIL",
  },
  "96323": {
    DMA: "MIL",
  },
  "96326": {
    DMA: "MIL",
  },
  "96328": {
    DMA: "MIL",
  },
  "96330": {
    DMA: "MIL",
  },
  "96331": {
    DMA: "MIL",
  },
  "96336": {
    DMA: "MIL",
  },
  "96337": {
    DMA: "MIL",
  },
  "96338": {
    DMA: "MIL",
  },
  "96339": {
    DMA: "MIL",
  },
  "96343": {
    DMA: "MIL",
  },
  "96346": {
    DMA: "MIL",
  },
  "96347": {
    DMA: "MIL",
  },
  "96348": {
    DMA: "MIL",
  },
  "96349": {
    DMA: "MIL",
  },
  "96350": {
    DMA: "MIL",
  },
  "96351": {
    DMA: "MIL",
  },
  "96362": {
    DMA: "MIL",
  },
  "96365": {
    DMA: "MIL",
  },
  "96367": {
    DMA: "MIL",
  },
  "96368": {
    DMA: "MIL",
  },
  "96370": {
    DMA: "MIL",
  },
  "96371": {
    DMA: "MIL",
  },
  "96372": {
    DMA: "MIL",
  },
  "96373": {
    DMA: "MIL",
  },
  "96374": {
    DMA: "MIL",
  },
  "96375": {
    DMA: "MIL",
  },
  "96376": {
    DMA: "MIL",
  },
  "96377": {
    DMA: "MIL",
  },
  "96378": {
    DMA: "MIL",
  },
  "96379": {
    DMA: "MIL",
  },
  "96380": {
    DMA: "MIL",
  },
  "96382": {
    DMA: "MIL",
  },
  "96384": {
    DMA: "MIL",
  },
  "96385": {
    DMA: "MIL",
  },
  "96386": {
    DMA: "MIL",
  },
  "96387": {
    DMA: "MIL",
  },
  "96388": {
    DMA: "MIL",
  },
  "96389": {
    DMA: "MIL",
  },
  "96400": {
    DMA: "MIL",
  },
  "96401": {
    DMA: "MIL",
  },
  "96426": {
    DMA: "MIL",
  },
  "96427": {
    DMA: "MIL",
  },
  "96444": {
    DMA: "MIL",
  },
  "96447": {
    DMA: "MIL",
  },
  "96501": {
    DMA: "MIL",
  },
  "96502": {
    DMA: "MIL",
  },
  "96503": {
    DMA: "MIL",
  },
  "96504": {
    DMA: "MIL",
  },
  "96505": {
    DMA: "MIL",
  },
  "96507": {
    DMA: "MIL",
  },
  "96510": {
    DMA: "MIL",
  },
  "96511": {
    DMA: "MIL",
  },
  "96515": {
    DMA: "MIL",
  },
  "96516": {
    DMA: "MIL",
  },
  "96517": {
    DMA: "MIL",
  },
  "96518": {
    DMA: "MIL",
  },
  "96520": {
    DMA: "MIL",
  },
  "96521": {
    DMA: "MIL",
  },
  "96522": {
    DMA: "MIL",
  },
  "96530": {
    DMA: "MIL",
  },
  "96531": {
    DMA: "MIL",
  },
  "96532": {
    DMA: "MIL",
  },
  "96534": {
    DMA: "MIL",
  },
  "96535": {
    DMA: "MIL",
  },
  "96536": {
    DMA: "MIL",
  },
  "96537": {
    DMA: "MIL",
  },
  "96538": {
    DMA: "MIL",
  },
  "96539": {
    DMA: "MIL",
  },
  "96540": {
    DMA: "MIL",
  },
  "96541": {
    DMA: "MIL",
  },
  "96542": {
    DMA: "MIL",
  },
  "96543": {
    DMA: "MIL",
  },
  "96544": {
    DMA: "MIL",
  },
  "96546": {
    DMA: "MIL",
  },
  "96547": {
    DMA: "MIL",
  },
  "96548": {
    DMA: "MIL",
  },
  "96549": {
    DMA: "MIL",
  },
  "96550": {
    DMA: "MIL",
  },
  "96551": {
    DMA: "MIL",
  },
  "96552": {
    DMA: "MIL",
  },
  "96553": {
    DMA: "MIL",
  },
  "96554": {
    DMA: "MIL",
  },
  "96555": {
    DMA: "MIL",
  },
  "96557": {
    DMA: "MIL",
  },
  "96562": {
    DMA: "MIL",
  },
  "96577": {
    DMA: "MIL",
  },
  "96578": {
    DMA: "MIL",
  },
  "96595": {
    DMA: "MIL",
  },
  "96598": {
    DMA: "MIL",
  },
  "96599": {
    DMA: "MIL",
  },
  "96601": {
    DMA: "MIL",
  },
  "96602": {
    DMA: "MIL",
  },
  "96603": {
    DMA: "MIL",
  },
  "96604": {
    DMA: "MIL",
  },
  "96605": {
    DMA: "MIL",
  },
  "96606": {
    DMA: "MIL",
  },
  "96607": {
    DMA: "MIL",
  },
  "96608": {
    DMA: "MIL",
  },
  "96609": {
    DMA: "MIL",
  },
  "96610": {
    DMA: "MIL",
  },
  "96611": {
    DMA: "MIL",
  },
  "96612": {
    DMA: "MIL",
  },
  "96613": {
    DMA: "MIL",
  },
  "96614": {
    DMA: "MIL",
  },
  "96615": {
    DMA: "MIL",
  },
  "96616": {
    DMA: "MIL",
  },
  "96617": {
    DMA: "MIL",
  },
  "96619": {
    DMA: "MIL",
  },
  "96620": {
    DMA: "MIL",
  },
  "96621": {
    DMA: "MIL",
  },
  "96622": {
    DMA: "MIL",
  },
  "96624": {
    DMA: "MIL",
  },
  "96628": {
    DMA: "MIL",
  },
  "96629": {
    DMA: "MIL",
  },
  "96631": {
    DMA: "MIL",
  },
  "96632": {
    DMA: "MIL",
  },
  "96633": {
    DMA: "MIL",
  },
  "96634": {
    DMA: "MIL",
  },
  "96641": {
    DMA: "MIL",
  },
  "96642": {
    DMA: "MIL",
  },
  "96643": {
    DMA: "MIL",
  },
  "96644": {
    DMA: "MIL",
  },
  "96645": {
    DMA: "MIL",
  },
  "96649": {
    DMA: "MIL",
  },
  "96650": {
    DMA: "MIL",
  },
  "96657": {
    DMA: "MIL",
  },
  "96660": {
    DMA: "MIL",
  },
  "96661": {
    DMA: "MIL",
  },
  "96662": {
    DMA: "MIL",
  },
  "96663": {
    DMA: "MIL",
  },
  "96664": {
    DMA: "MIL",
  },
  "96665": {
    DMA: "MIL",
  },
  "96666": {
    DMA: "MIL",
  },
  "96667": {
    DMA: "MIL",
  },
  "96668": {
    DMA: "MIL",
  },
  "96669": {
    DMA: "MIL",
  },
  "96670": {
    DMA: "MIL",
  },
  "96671": {
    DMA: "MIL",
  },
  "96672": {
    DMA: "MIL",
  },
  "96673": {
    DMA: "MIL",
  },
  "96674": {
    DMA: "MIL",
  },
  "96675": {
    DMA: "MIL",
  },
  "96677": {
    DMA: "MIL",
  },
  "96678": {
    DMA: "MIL",
  },
  "96679": {
    DMA: "MIL",
  },
  "96681": {
    DMA: "MIL",
  },
  "96682": {
    DMA: "MIL",
  },
  "96683": {
    DMA: "MIL",
  },
  "96686": {
    DMA: "MIL",
  },
  "96687": {
    DMA: "MIL",
  },
  "96691": {
    DMA: "MIL",
  },
  "96692": {
    DMA: "MIL",
  },
  "96693": {
    DMA: "MIL",
  },
  "96694": {
    DMA: "MIL",
  },
  "96695": {
    DMA: "MIL",
  },
  "96696": {
    DMA: "MIL",
  },
  "96698": {
    DMA: "MIL",
  },
  "96701": {
    DMA: 744,
  },
  "96703": {
    DMA: 744,
  },
  "96704": {
    DMA: 744,
  },
  "96705": {
    DMA: 744,
  },
  "96706": {
    DMA: 744,
  },
  "96707": {
    DMA: 744,
  },
  "96708": {
    DMA: 744,
  },
  "96709": {
    DMA: 744,
  },
  "96710": {
    DMA: 744,
  },
  "96712": {
    DMA: 744,
  },
  "96713": {
    DMA: 744,
  },
  "96714": {
    DMA: 744,
  },
  "96715": {
    DMA: 744,
  },
  "96716": {
    DMA: 744,
  },
  "96717": {
    DMA: 744,
  },
  "96718": {
    DMA: 744,
  },
  "96719": {
    DMA: 744,
  },
  "96720": {
    DMA: 744,
  },
  "96721": {
    DMA: 744,
  },
  "96722": {
    DMA: 744,
  },
  "96725": {
    DMA: 744,
  },
  "96726": {
    DMA: 744,
  },
  "96727": {
    DMA: 744,
  },
  "96728": {
    DMA: 744,
  },
  "96729": {
    DMA: 744,
  },
  "96730": {
    DMA: 744,
  },
  "96731": {
    DMA: 744,
  },
  "96732": {
    DMA: 744,
  },
  "96733": {
    DMA: 744,
  },
  "96734": {
    DMA: 744,
  },
  "96737": {
    DMA: 744,
  },
  "96738": {
    DMA: 744,
  },
  "96739": {
    DMA: 744,
  },
  "96740": {
    DMA: 744,
  },
  "96741": {
    DMA: 744,
  },
  "96742": {
    DMA: 744,
  },
  "96743": {
    DMA: 744,
  },
  "96744": {
    DMA: 744,
  },
  "96745": {
    DMA: 744,
  },
  "96746": {
    DMA: 744,
  },
  "96747": {
    DMA: 744,
  },
  "96748": {
    DMA: 744,
  },
  "96749": {
    DMA: 744,
  },
  "96750": {
    DMA: 744,
  },
  "96751": {
    DMA: 744,
  },
  "96752": {
    DMA: 744,
  },
  "96753": {
    DMA: 744,
  },
  "96754": {
    DMA: 744,
  },
  "96755": {
    DMA: 744,
  },
  "96756": {
    DMA: 744,
  },
  "96757": {
    DMA: 744,
  },
  "96759": {
    DMA: 744,
  },
  "96760": {
    DMA: 744,
  },
  "96761": {
    DMA: 744,
  },
  "96762": {
    DMA: 744,
  },
  "96763": {
    DMA: 744,
  },
  "96764": {
    DMA: 744,
  },
  "96765": {
    DMA: 744,
  },
  "96766": {
    DMA: 744,
  },
  "96767": {
    DMA: 744,
  },
  "96768": {
    DMA: 744,
  },
  "96769": {
    DMA: 744,
  },
  "96770": {
    DMA: 744,
  },
  "96771": {
    DMA: 744,
  },
  "96772": {
    DMA: 744,
  },
  "96773": {
    DMA: 744,
  },
  "96774": {
    DMA: 744,
  },
  "96776": {
    DMA: 744,
  },
  "96777": {
    DMA: 744,
  },
  "96778": {
    DMA: 744,
  },
  "96779": {
    DMA: 744,
  },
  "96780": {
    DMA: 744,
  },
  "96781": {
    DMA: 744,
  },
  "96782": {
    DMA: 744,
  },
  "96783": {
    DMA: 744,
  },
  "96784": {
    DMA: 744,
  },
  "96785": {
    DMA: 744,
  },
  "96786": {
    DMA: 744,
  },
  "96788": {
    DMA: 744,
  },
  "96789": {
    DMA: 744,
  },
  "96790": {
    DMA: 744,
  },
  "96791": {
    DMA: 744,
  },
  "96792": {
    DMA: 744,
  },
  "96793": {
    DMA: 744,
  },
  "96795": {
    DMA: 744,
  },
  "96796": {
    DMA: 744,
  },
  "96797": {
    DMA: 744,
  },
  "96799": {
    DMA: 744,
  },
  "96801": {
    DMA: 744,
  },
  "96802": {
    DMA: 744,
  },
  "96803": {
    DMA: 744,
  },
  "96804": {
    DMA: 744,
  },
  "96805": {
    DMA: 744,
  },
  "96806": {
    DMA: 744,
  },
  "96807": {
    DMA: 744,
  },
  "96808": {
    DMA: 744,
  },
  "96809": {
    DMA: 744,
  },
  "96810": {
    DMA: 744,
  },
  "96811": {
    DMA: 744,
  },
  "96812": {
    DMA: 744,
  },
  "96813": {
    DMA: 744,
  },
  "96814": {
    DMA: 744,
  },
  "96815": {
    DMA: 744,
  },
  "96816": {
    DMA: 744,
  },
  "96817": {
    DMA: 744,
  },
  "96818": {
    DMA: 744,
  },
  "96819": {
    DMA: 744,
  },
  "96820": {
    DMA: 744,
  },
  "96821": {
    DMA: 744,
  },
  "96822": {
    DMA: 744,
  },
  "96823": {
    DMA: 744,
  },
  "96824": {
    DMA: 744,
  },
  "96825": {
    DMA: 744,
  },
  "96826": {
    DMA: 744,
  },
  "96827": {
    DMA: 744,
  },
  "96828": {
    DMA: 744,
  },
  "96830": {
    DMA: 744,
  },
  "96835": {
    DMA: 744,
  },
  "96836": {
    DMA: 744,
  },
  "96837": {
    DMA: 744,
  },
  "96838": {
    DMA: 744,
  },
  "96839": {
    DMA: 744,
  },
  "96840": {
    DMA: 744,
  },
  "96841": {
    DMA: 744,
  },
  "96843": {
    DMA: 744,
  },
  "96844": {
    DMA: 744,
  },
  "96846": {
    DMA: 744,
  },
  "96847": {
    DMA: 744,
  },
  "96848": {
    DMA: 744,
  },
  "96849": {
    DMA: 744,
  },
  "96850": {
    DMA: 744,
  },
  "96853": {
    DMA: 744,
  },
  "96854": {
    DMA: 744,
  },
  "96857": {
    DMA: 744,
  },
  "96858": {
    DMA: 744,
  },
  "96859": {
    DMA: 744,
  },
  "96860": {
    DMA: 744,
  },
  "96861": {
    DMA: 744,
  },
  "96863": {
    DMA: 744,
  },
  "96898": {
    DMA: 744,
  },
  "96910": {
    DMA: "GU1",
  },
  "96912": {
    DMA: "GU1",
  },
  "96913": {
    DMA: "GU1",
  },
  "96915": {
    DMA: "GU1",
  },
  "96916": {
    DMA: "GU1",
  },
  "96917": {
    DMA: "GU1",
  },
  "96919": {
    DMA: "GU1",
  },
  "96921": {
    DMA: "GU1",
  },
  "96923": {
    DMA: "GU1",
  },
  "96928": {
    DMA: "GU1",
  },
  "96929": {
    DMA: "GU1",
  },
  "96931": {
    DMA: "GU1",
  },
  "96932": {
    DMA: "GU1",
  },
  "96939": {
    DMA: "GU1",
  },
  "96940": {
    DMA: "GU1",
  },
  "96941": {
    DMA: "GU1",
  },
  "96942": {
    DMA: "GU1",
  },
  "96943": {
    DMA: "GU1",
  },
  "96944": {
    DMA: "GU1",
  },
  "96950": {
    DMA: "GU1",
  },
  "96951": {
    DMA: "GU1",
  },
  "96952": {
    DMA: "GU1",
  },
  "96960": {
    DMA: "GU1",
  },
  "96970": {
    DMA: "GU1",
  },
  "97001": {
    DMA: 820,
  },
  "97002": {
    DMA: 820,
  },
  "97003": {
    DMA: 820,
  },
  "97004": {
    DMA: 820,
  },
  "97005": {
    DMA: 820,
  },
  "97006": {
    DMA: 820,
  },
  "97007": {
    DMA: 820,
  },
  "97008": {
    DMA: 820,
  },
  "97009": {
    DMA: 820,
  },
  "97010": {
    DMA: 820,
  },
  "97011": {
    DMA: 820,
  },
  "97013": {
    DMA: 820,
  },
  "97014": {
    DMA: 820,
  },
  "97015": {
    DMA: 820,
  },
  "97016": {
    DMA: 820,
  },
  "97017": {
    DMA: 820,
  },
  "97018": {
    DMA: 820,
  },
  "97019": {
    DMA: 820,
  },
  "97020": {
    DMA: 820,
  },
  "97021": {
    DMA: 820,
  },
  "97022": {
    DMA: 820,
  },
  "97023": {
    DMA: 820,
  },
  "97024": {
    DMA: 820,
  },
  "97026": {
    DMA: 820,
  },
  "97027": {
    DMA: 820,
  },
  "97028": {
    DMA: 820,
  },
  "97029": {
    DMA: 820,
  },
  "97030": {
    DMA: 820,
  },
  "97031": {
    DMA: 820,
  },
  "97032": {
    DMA: 820,
  },
  "97033": {
    DMA: 820,
  },
  "97034": {
    DMA: 820,
  },
  "97035": {
    DMA: 820,
  },
  "97036": {
    DMA: 820,
  },
  "97037": {
    DMA: 820,
  },
  "97038": {
    DMA: 820,
  },
  "97039": {
    DMA: 820,
  },
  "97040": {
    DMA: 820,
  },
  "97041": {
    DMA: 820,
  },
  "97042": {
    DMA: 820,
  },
  "97044": {
    DMA: 820,
  },
  "97045": {
    DMA: 820,
  },
  "97048": {
    DMA: 820,
  },
  "97049": {
    DMA: 820,
  },
  "97050": {
    DMA: 820,
  },
  "97051": {
    DMA: 820,
  },
  "97053": {
    DMA: 820,
  },
  "97054": {
    DMA: 820,
  },
  "97055": {
    DMA: 820,
  },
  "97056": {
    DMA: 820,
  },
  "97057": {
    DMA: 820,
  },
  "97058": {
    DMA: 820,
  },
  "97060": {
    DMA: 820,
  },
  "97062": {
    DMA: 820,
  },
  "97063": {
    DMA: 820,
  },
  "97064": {
    DMA: 820,
  },
  "97065": {
    DMA: 820,
  },
  "97067": {
    DMA: 820,
  },
  "97068": {
    DMA: 820,
  },
  "97070": {
    DMA: 820,
  },
  "97071": {
    DMA: 820,
  },
  "97075": {
    DMA: 820,
  },
  "97076": {
    DMA: 820,
  },
  "97077": {
    DMA: 820,
  },
  "97078": {
    DMA: 820,
  },
  "97079": {
    DMA: 820,
  },
  "97080": {
    DMA: 820,
  },
  "97086": {
    DMA: 820,
  },
  "97089": {
    DMA: 820,
  },
  "97101": {
    DMA: 820,
  },
  "97102": {
    DMA: 820,
  },
  "97103": {
    DMA: 820,
  },
  "97106": {
    DMA: 820,
  },
  "97107": {
    DMA: 820,
  },
  "97108": {
    DMA: 820,
  },
  "97109": {
    DMA: 820,
  },
  "97110": {
    DMA: 820,
  },
  "97111": {
    DMA: 820,
  },
  "97112": {
    DMA: 820,
  },
  "97113": {
    DMA: 820,
  },
  "97114": {
    DMA: 820,
  },
  "97115": {
    DMA: 820,
  },
  "97116": {
    DMA: 820,
  },
  "97117": {
    DMA: 820,
  },
  "97118": {
    DMA: 820,
  },
  "97119": {
    DMA: 820,
  },
  "97121": {
    DMA: 820,
  },
  "97122": {
    DMA: 820,
  },
  "97123": {
    DMA: 820,
  },
  "97124": {
    DMA: 820,
  },
  "97125": {
    DMA: 820,
  },
  "97127": {
    DMA: 820,
  },
  "97128": {
    DMA: 820,
  },
  "97129": {
    DMA: 820,
  },
  "97130": {
    DMA: 820,
  },
  "97131": {
    DMA: 820,
  },
  "97132": {
    DMA: 820,
  },
  "97133": {
    DMA: 820,
  },
  "97134": {
    DMA: 820,
  },
  "97135": {
    DMA: 820,
  },
  "97136": {
    DMA: 820,
  },
  "97137": {
    DMA: 820,
  },
  "97138": {
    DMA: 820,
  },
  "97140": {
    DMA: 820,
  },
  "97141": {
    DMA: 820,
  },
  "97143": {
    DMA: 820,
  },
  "97144": {
    DMA: 820,
  },
  "97145": {
    DMA: 820,
  },
  "97146": {
    DMA: 820,
  },
  "97147": {
    DMA: 820,
  },
  "97148": {
    DMA: 820,
  },
  "97149": {
    DMA: 820,
  },
  "97201": {
    DMA: 820,
  },
  "97202": {
    DMA: 820,
  },
  "97203": {
    DMA: 820,
  },
  "97204": {
    DMA: 820,
  },
  "97205": {
    DMA: 820,
  },
  "97206": {
    DMA: 820,
  },
  "97207": {
    DMA: 820,
  },
  "97208": {
    DMA: 820,
  },
  "97209": {
    DMA: 820,
  },
  "97210": {
    DMA: 820,
  },
  "97211": {
    DMA: 820,
  },
  "97212": {
    DMA: 820,
  },
  "97213": {
    DMA: 820,
  },
  "97214": {
    DMA: 820,
  },
  "97215": {
    DMA: 820,
  },
  "97216": {
    DMA: 820,
  },
  "97217": {
    DMA: 820,
  },
  "97218": {
    DMA: 820,
  },
  "97219": {
    DMA: 820,
  },
  "97220": {
    DMA: 820,
  },
  "97221": {
    DMA: 820,
  },
  "97222": {
    DMA: 820,
  },
  "97223": {
    DMA: 820,
  },
  "97224": {
    DMA: 820,
  },
  "97225": {
    DMA: 820,
  },
  "97227": {
    DMA: 820,
  },
  "97228": {
    DMA: 820,
  },
  "97229": {
    DMA: 820,
  },
  "97230": {
    DMA: 820,
  },
  "97231": {
    DMA: 820,
  },
  "97232": {
    DMA: 820,
  },
  "97233": {
    DMA: 820,
  },
  "97236": {
    DMA: 820,
  },
  "97238": {
    DMA: 820,
  },
  "97239": {
    DMA: 820,
  },
  "97240": {
    DMA: 820,
  },
  "97242": {
    DMA: 820,
  },
  "97250": {
    DMA: 820,
  },
  "97251": {
    DMA: 820,
  },
  "97252": {
    DMA: 820,
  },
  "97253": {
    DMA: 820,
  },
  "97254": {
    DMA: 820,
  },
  "97255": {
    DMA: 820,
  },
  "97256": {
    DMA: 820,
  },
  "97258": {
    DMA: 820,
  },
  "97259": {
    DMA: 820,
  },
  "97266": {
    DMA: 820,
  },
  "97267": {
    DMA: 820,
  },
  "97268": {
    DMA: 820,
  },
  "97269": {
    DMA: 820,
  },
  "97271": {
    DMA: 820,
  },
  "97272": {
    DMA: 820,
  },
  "97280": {
    DMA: 820,
  },
  "97281": {
    DMA: 820,
  },
  "97282": {
    DMA: 820,
  },
  "97283": {
    DMA: 820,
  },
  "97286": {
    DMA: 820,
  },
  "97290": {
    DMA: 820,
  },
  "97291": {
    DMA: 820,
  },
  "97292": {
    DMA: 820,
  },
  "97293": {
    DMA: 820,
  },
  "97294": {
    DMA: 820,
  },
  "97296": {
    DMA: 820,
  },
  "97298": {
    DMA: 820,
  },
  "97299": {
    DMA: 820,
  },
  "97301": {
    DMA: 820,
  },
  "97302": {
    DMA: 820,
  },
  "97303": {
    DMA: 820,
  },
  "97304": {
    DMA: 820,
  },
  "97305": {
    DMA: 820,
  },
  "97306": {
    DMA: 820,
  },
  "97307": {
    DMA: 820,
  },
  "97308": {
    DMA: 820,
  },
  "97309": {
    DMA: 820,
  },
  "97310": {
    DMA: 820,
  },
  "97311": {
    DMA: 820,
  },
  "97312": {
    DMA: 820,
  },
  "97313": {
    DMA: 820,
  },
  "97314": {
    DMA: 820,
  },
  "97317": {
    DMA: 820,
  },
  "97321": {
    DMA: 820,
  },
  "97322": {
    DMA: 820,
  },
  "97324": {
    DMA: 801,
  },
  "97325": {
    DMA: 820,
  },
  "97326": {
    DMA: 801,
  },
  "97327": {
    DMA: 820,
  },
  "97329": {
    DMA: 820,
  },
  "97330": {
    DMA: 801,
  },
  "97331": {
    DMA: 801,
  },
  "97333": {
    DMA: 801,
  },
  "97335": {
    DMA: 820,
  },
  "97336": {
    DMA: 820,
  },
  "97338": {
    DMA: 820,
  },
  "97339": {
    DMA: 801,
  },
  "97341": {
    DMA: 820,
  },
  "97342": {
    DMA: 820,
  },
  "97343": {
    DMA: 820,
  },
  "97344": {
    DMA: 820,
  },
  "97345": {
    DMA: 820,
  },
  "97346": {
    DMA: 820,
  },
  "97347": {
    DMA: 820,
  },
  "97348": {
    DMA: 820,
  },
  "97350": {
    DMA: 820,
  },
  "97351": {
    DMA: 820,
  },
  "97352": {
    DMA: 820,
  },
  "97355": {
    DMA: 820,
  },
  "97357": {
    DMA: 820,
  },
  "97358": {
    DMA: 820,
  },
  "97360": {
    DMA: 820,
  },
  "97361": {
    DMA: 820,
  },
  "97362": {
    DMA: 820,
  },
  "97364": {
    DMA: 820,
  },
  "97365": {
    DMA: 820,
  },
  "97366": {
    DMA: 820,
  },
  "97367": {
    DMA: 820,
  },
  "97368": {
    DMA: 820,
  },
  "97369": {
    DMA: 820,
  },
  "97370": {
    DMA: 801,
  },
  "97371": {
    DMA: 820,
  },
  "97372": {
    DMA: 820,
  },
  "97373": {
    DMA: 820,
  },
  "97374": {
    DMA: 820,
  },
  "97375": {
    DMA: 820,
  },
  "97376": {
    DMA: 820,
  },
  "97377": {
    DMA: 820,
  },
  "97378": {
    DMA: 820,
  },
  "97380": {
    DMA: 820,
  },
  "97381": {
    DMA: 820,
  },
  "97383": {
    DMA: 820,
  },
  "97384": {
    DMA: 820,
  },
  "97385": {
    DMA: 820,
  },
  "97386": {
    DMA: 820,
  },
  "97388": {
    DMA: 820,
  },
  "97389": {
    DMA: 820,
  },
  "97390": {
    DMA: 820,
  },
  "97391": {
    DMA: 820,
  },
  "97392": {
    DMA: 820,
  },
  "97394": {
    DMA: 820,
  },
  "97396": {
    DMA: 820,
  },
  "97401": {
    DMA: 801,
  },
  "97402": {
    DMA: 801,
  },
  "97403": {
    DMA: 801,
  },
  "97404": {
    DMA: 801,
  },
  "97405": {
    DMA: 801,
  },
  "97406": {
    DMA: 813,
  },
  "97407": {
    DMA: 801,
  },
  "97408": {
    DMA: 801,
  },
  "97409": {
    DMA: 801,
  },
  "97410": {
    DMA: 801,
  },
  "97411": {
    DMA: 801,
  },
  "97412": {
    DMA: 801,
  },
  "97413": {
    DMA: 801,
  },
  "97414": {
    DMA: 801,
  },
  "97415": {
    DMA: 813,
  },
  "97416": {
    DMA: 801,
  },
  "97417": {
    DMA: 801,
  },
  "97419": {
    DMA: 801,
  },
  "97420": {
    DMA: 801,
  },
  "97423": {
    DMA: 801,
  },
  "97424": {
    DMA: 801,
  },
  "97425": {
    DMA: 813,
  },
  "97426": {
    DMA: 801,
  },
  "97427": {
    DMA: 801,
  },
  "97428": {
    DMA: 801,
  },
  "97429": {
    DMA: 801,
  },
  "97430": {
    DMA: 801,
  },
  "97431": {
    DMA: 801,
  },
  "97432": {
    DMA: 801,
  },
  "97434": {
    DMA: 801,
  },
  "97435": {
    DMA: 801,
  },
  "97436": {
    DMA: 801,
  },
  "97437": {
    DMA: 801,
  },
  "97438": {
    DMA: 801,
  },
  "97439": {
    DMA: 801,
  },
  "97440": {
    DMA: 801,
  },
  "97441": {
    DMA: 801,
  },
  "97442": {
    DMA: 801,
  },
  "97443": {
    DMA: 801,
  },
  "97444": {
    DMA: 813,
  },
  "97446": {
    DMA: 820,
  },
  "97447": {
    DMA: 801,
  },
  "97448": {
    DMA: 801,
  },
  "97449": {
    DMA: 801,
  },
  "97450": {
    DMA: 813,
  },
  "97451": {
    DMA: 801,
  },
  "97452": {
    DMA: 801,
  },
  "97453": {
    DMA: 801,
  },
  "97454": {
    DMA: 801,
  },
  "97455": {
    DMA: 801,
  },
  "97456": {
    DMA: 801,
  },
  "97457": {
    DMA: 801,
  },
  "97458": {
    DMA: 801,
  },
  "97459": {
    DMA: 801,
  },
  "97461": {
    DMA: 801,
  },
  "97462": {
    DMA: 801,
  },
  "97463": {
    DMA: 801,
  },
  "97464": {
    DMA: 813,
  },
  "97465": {
    DMA: 813,
  },
  "97466": {
    DMA: 801,
  },
  "97467": {
    DMA: 801,
  },
  "97469": {
    DMA: 801,
  },
  "97470": {
    DMA: 801,
  },
  "97471": {
    DMA: 801,
  },
  "97472": {
    DMA: 801,
  },
  "97473": {
    DMA: 801,
  },
  "97475": {
    DMA: 801,
  },
  "97476": {
    DMA: 813,
  },
  "97477": {
    DMA: 801,
  },
  "97478": {
    DMA: 801,
  },
  "97479": {
    DMA: 801,
  },
  "97480": {
    DMA: 801,
  },
  "97481": {
    DMA: 801,
  },
  "97482": {
    DMA: 801,
  },
  "97484": {
    DMA: 801,
  },
  "97486": {
    DMA: 801,
  },
  "97487": {
    DMA: 801,
  },
  "97488": {
    DMA: 801,
  },
  "97489": {
    DMA: 801,
  },
  "97490": {
    DMA: 801,
  },
  "97491": {
    DMA: 813,
  },
  "97492": {
    DMA: 801,
  },
  "97493": {
    DMA: 801,
  },
  "97494": {
    DMA: 801,
  },
  "97495": {
    DMA: 801,
  },
  "97496": {
    DMA: 801,
  },
  "97497": {
    DMA: 813,
  },
  "97498": {
    DMA: 820,
  },
  "97499": {
    DMA: 801,
  },
  "97501": {
    DMA: 813,
  },
  "97502": {
    DMA: 813,
  },
  "97503": {
    DMA: 813,
  },
  "97504": {
    DMA: 813,
  },
  "97520": {
    DMA: 813,
  },
  "97522": {
    DMA: 813,
  },
  "97523": {
    DMA: 813,
  },
  "97524": {
    DMA: 813,
  },
  "97525": {
    DMA: 813,
  },
  "97526": {
    DMA: 813,
  },
  "97527": {
    DMA: 813,
  },
  "97528": {
    DMA: 813,
  },
  "97530": {
    DMA: 813,
  },
  "97531": {
    DMA: 813,
  },
  "97532": {
    DMA: 813,
  },
  "97533": {
    DMA: 813,
  },
  "97534": {
    DMA: 813,
  },
  "97535": {
    DMA: 813,
  },
  "97536": {
    DMA: 813,
  },
  "97537": {
    DMA: 813,
  },
  "97538": {
    DMA: 813,
  },
  "97539": {
    DMA: 813,
  },
  "97540": {
    DMA: 813,
  },
  "97541": {
    DMA: 813,
  },
  "97543": {
    DMA: 813,
  },
  "97544": {
    DMA: 813,
  },
  "97601": {
    DMA: 813,
  },
  "97602": {
    DMA: 813,
  },
  "97603": {
    DMA: 813,
  },
  "97604": {
    DMA: 813,
  },
  "97620": {
    DMA: 813,
  },
  "97621": {
    DMA: 813,
  },
  "97622": {
    DMA: 813,
  },
  "97623": {
    DMA: 813,
  },
  "97624": {
    DMA: 813,
  },
  "97625": {
    DMA: 813,
  },
  "97626": {
    DMA: 813,
  },
  "97627": {
    DMA: 813,
  },
  "97630": {
    DMA: 813,
  },
  "97632": {
    DMA: 813,
  },
  "97633": {
    DMA: 813,
  },
  "97634": {
    DMA: 813,
  },
  "97635": {
    DMA: 813,
  },
  "97636": {
    DMA: 813,
  },
  "97637": {
    DMA: 813,
  },
  "97638": {
    DMA: 813,
  },
  "97639": {
    DMA: 813,
  },
  "97640": {
    DMA: 813,
  },
  "97641": {
    DMA: 813,
  },
  "97701": {
    DMA: 821,
  },
  "97702": {
    DMA: 821,
  },
  "97703": {
    DMA: 821,
  },
  "97707": {
    DMA: 821,
  },
  "97708": {
    DMA: 821,
  },
  "97709": {
    DMA: 821,
  },
  "97710": {
    DMA: 820,
  },
  "97711": {
    DMA: 820,
  },
  "97712": {
    DMA: 821,
  },
  "97720": {
    DMA: 820,
  },
  "97721": {
    DMA: 820,
  },
  "97722": {
    DMA: 820,
  },
  "97730": {
    DMA: 820,
  },
  "97731": {
    DMA: 813,
  },
  "97732": {
    DMA: 820,
  },
  "97733": {
    DMA: 813,
  },
  "97734": {
    DMA: 820,
  },
  "97735": {
    DMA: 813,
  },
  "97736": {
    DMA: 820,
  },
  "97737": {
    DMA: 813,
  },
  "97738": {
    DMA: 820,
  },
  "97739": {
    DMA: 821,
  },
  "97741": {
    DMA: 820,
  },
  "97750": {
    DMA: 820,
  },
  "97751": {
    DMA: 820,
  },
  "97752": {
    DMA: 820,
  },
  "97753": {
    DMA: 820,
  },
  "97754": {
    DMA: 820,
  },
  "97756": {
    DMA: 821,
  },
  "97758": {
    DMA: 820,
  },
  "97759": {
    DMA: 821,
  },
  "97760": {
    DMA: 820,
  },
  "97761": {
    DMA: 820,
  },
  "97801": {
    DMA: 810,
  },
  "97810": {
    DMA: 810,
  },
  "97812": {
    DMA: 820,
  },
  "97813": {
    DMA: 810,
  },
  "97814": {
    DMA: 820,
  },
  "97817": {
    DMA: 820,
  },
  "97818": {
    DMA: 820,
  },
  "97819": {
    DMA: 820,
  },
  "97820": {
    DMA: 820,
  },
  "97823": {
    DMA: 820,
  },
  "97824": {
    DMA: 820,
  },
  "97825": {
    DMA: 820,
  },
  "97826": {
    DMA: 810,
  },
  "97827": {
    DMA: 820,
  },
  "97828": {
    DMA: 881,
  },
  "97830": {
    DMA: 820,
  },
  "97833": {
    DMA: 820,
  },
  "97834": {
    DMA: 820,
  },
  "97835": {
    DMA: 810,
  },
  "97836": {
    DMA: 820,
  },
  "97837": {
    DMA: 820,
  },
  "97838": {
    DMA: 810,
  },
  "97839": {
    DMA: 820,
  },
  "97840": {
    DMA: 820,
  },
  "97841": {
    DMA: 820,
  },
  "97842": {
    DMA: 881,
  },
  "97843": {
    DMA: 820,
  },
  "97844": {
    DMA: 820,
  },
  "97845": {
    DMA: 820,
  },
  "97846": {
    DMA: 881,
  },
  "97848": {
    DMA: 820,
  },
  "97850": {
    DMA: 820,
  },
  "97856": {
    DMA: 820,
  },
  "97857": {
    DMA: 881,
  },
  "97859": {
    DMA: 810,
  },
  "97861": {
    DMA: 820,
  },
  "97862": {
    DMA: 810,
  },
  "97864": {
    DMA: 820,
  },
  "97865": {
    DMA: 820,
  },
  "97867": {
    DMA: 820,
  },
  "97868": {
    DMA: 810,
  },
  "97869": {
    DMA: 820,
  },
  "97870": {
    DMA: 820,
  },
  "97873": {
    DMA: 820,
  },
  "97874": {
    DMA: 820,
  },
  "97875": {
    DMA: 810,
  },
  "97876": {
    DMA: 820,
  },
  "97877": {
    DMA: 820,
  },
  "97880": {
    DMA: 810,
  },
  "97882": {
    DMA: 810,
  },
  "97883": {
    DMA: 820,
  },
  "97884": {
    DMA: 820,
  },
  "97885": {
    DMA: 881,
  },
  "97886": {
    DMA: 810,
  },
  "97901": {
    DMA: 757,
  },
  "97902": {
    DMA: 757,
  },
  "97903": {
    DMA: 757,
  },
  "97904": {
    DMA: 820,
  },
  "97905": {
    DMA: 820,
  },
  "97906": {
    DMA: 757,
  },
  "97907": {
    DMA: 820,
  },
  "97908": {
    DMA: 757,
  },
  "97909": {
    DMA: 757,
  },
  "97910": {
    DMA: 757,
  },
  "97911": {
    DMA: 757,
  },
  "97913": {
    DMA: 757,
  },
  "97914": {
    DMA: 757,
  },
  "97917": {
    DMA: 757,
  },
  "97918": {
    DMA: 757,
  },
  "97920": {
    DMA: 757,
  },
  "98001": {
    DMA: 819,
  },
  "98002": {
    DMA: 819,
  },
  "98003": {
    DMA: 819,
  },
  "98004": {
    DMA: 819,
  },
  "98005": {
    DMA: 819,
  },
  "98006": {
    DMA: 819,
  },
  "98007": {
    DMA: 819,
  },
  "98008": {
    DMA: 819,
  },
  "98009": {
    DMA: 819,
  },
  "98010": {
    DMA: 819,
  },
  "98011": {
    DMA: 819,
  },
  "98012": {
    DMA: 819,
  },
  "98013": {
    DMA: 819,
  },
  "98014": {
    DMA: 819,
  },
  "98015": {
    DMA: 819,
  },
  "98019": {
    DMA: 819,
  },
  "98020": {
    DMA: 819,
  },
  "98021": {
    DMA: 819,
  },
  "98022": {
    DMA: 819,
  },
  "98023": {
    DMA: 819,
  },
  "98024": {
    DMA: 819,
  },
  "98025": {
    DMA: 819,
  },
  "98026": {
    DMA: 819,
  },
  "98027": {
    DMA: 819,
  },
  "98028": {
    DMA: 819,
  },
  "98029": {
    DMA: 819,
  },
  "98030": {
    DMA: 819,
  },
  "98031": {
    DMA: 819,
  },
  "98032": {
    DMA: 819,
  },
  "98033": {
    DMA: 819,
  },
  "98034": {
    DMA: 819,
  },
  "98035": {
    DMA: 819,
  },
  "98036": {
    DMA: 819,
  },
  "98037": {
    DMA: 819,
  },
  "98038": {
    DMA: 819,
  },
  "98039": {
    DMA: 819,
  },
  "98040": {
    DMA: 819,
  },
  "98041": {
    DMA: 819,
  },
  "98042": {
    DMA: 819,
  },
  "98043": {
    DMA: 819,
  },
  "98045": {
    DMA: 819,
  },
  "98046": {
    DMA: 819,
  },
  "98047": {
    DMA: 819,
  },
  "98050": {
    DMA: 819,
  },
  "98051": {
    DMA: 819,
  },
  "98052": {
    DMA: 819,
  },
  "98053": {
    DMA: 819,
  },
  "98054": {
    DMA: 819,
  },
  "98055": {
    DMA: 819,
  },
  "98056": {
    DMA: 819,
  },
  "98057": {
    DMA: 819,
  },
  "98058": {
    DMA: 819,
  },
  "98059": {
    DMA: 819,
  },
  "98061": {
    DMA: 819,
  },
  "98062": {
    DMA: 819,
  },
  "98063": {
    DMA: 819,
  },
  "98064": {
    DMA: 819,
  },
  "98065": {
    DMA: 819,
  },
  "98068": {
    DMA: 810,
  },
  "98070": {
    DMA: 819,
  },
  "98071": {
    DMA: 819,
  },
  "98072": {
    DMA: 819,
  },
  "98073": {
    DMA: 819,
  },
  "98074": {
    DMA: 819,
  },
  "98075": {
    DMA: 819,
  },
  "98077": {
    DMA: 819,
  },
  "98082": {
    DMA: 819,
  },
  "98083": {
    DMA: 819,
  },
  "98087": {
    DMA: 819,
  },
  "98089": {
    DMA: 819,
  },
  "98092": {
    DMA: 819,
  },
  "98093": {
    DMA: 819,
  },
  "98101": {
    DMA: 819,
  },
  "98102": {
    DMA: 819,
  },
  "98103": {
    DMA: 819,
  },
  "98104": {
    DMA: 819,
  },
  "98105": {
    DMA: 819,
  },
  "98106": {
    DMA: 819,
  },
  "98107": {
    DMA: 819,
  },
  "98108": {
    DMA: 819,
  },
  "98109": {
    DMA: 819,
  },
  "98110": {
    DMA: 819,
  },
  "98111": {
    DMA: 819,
  },
  "98112": {
    DMA: 819,
  },
  "98113": {
    DMA: 819,
  },
  "98114": {
    DMA: 819,
  },
  "98115": {
    DMA: 819,
  },
  "98116": {
    DMA: 819,
  },
  "98117": {
    DMA: 819,
  },
  "98118": {
    DMA: 819,
  },
  "98119": {
    DMA: 819,
  },
  "98121": {
    DMA: 819,
  },
  "98122": {
    DMA: 819,
  },
  "98124": {
    DMA: 819,
  },
  "98125": {
    DMA: 819,
  },
  "98126": {
    DMA: 819,
  },
  "98127": {
    DMA: 819,
  },
  "98129": {
    DMA: 819,
  },
  "98131": {
    DMA: 819,
  },
  "98132": {
    DMA: 819,
  },
  "98133": {
    DMA: 819,
  },
  "98134": {
    DMA: 819,
  },
  "98136": {
    DMA: 819,
  },
  "98138": {
    DMA: 819,
  },
  "98139": {
    DMA: 819,
  },
  "98141": {
    DMA: 819,
  },
  "98144": {
    DMA: 819,
  },
  "98145": {
    DMA: 819,
  },
  "98146": {
    DMA: 819,
  },
  "98148": {
    DMA: 819,
  },
  "98151": {
    DMA: 819,
  },
  "98154": {
    DMA: 819,
  },
  "98155": {
    DMA: 819,
  },
  "98158": {
    DMA: 819,
  },
  "98160": {
    DMA: 819,
  },
  "98161": {
    DMA: 819,
  },
  "98164": {
    DMA: 819,
  },
  "98165": {
    DMA: 819,
  },
  "98166": {
    DMA: 819,
  },
  "98168": {
    DMA: 819,
  },
  "98170": {
    DMA: 819,
  },
  "98171": {
    DMA: 819,
  },
  "98174": {
    DMA: 819,
  },
  "98175": {
    DMA: 819,
  },
  "98177": {
    DMA: 819,
  },
  "98178": {
    DMA: 819,
  },
  "98181": {
    DMA: 819,
  },
  "98184": {
    DMA: 819,
  },
  "98185": {
    DMA: 819,
  },
  "98188": {
    DMA: 819,
  },
  "98189": {
    DMA: 819,
  },
  "98190": {
    DMA: 819,
  },
  "98191": {
    DMA: 819,
  },
  "98194": {
    DMA: 819,
  },
  "98195": {
    DMA: 819,
  },
  "98198": {
    DMA: 819,
  },
  "98199": {
    DMA: 819,
  },
  "98201": {
    DMA: 819,
  },
  "98203": {
    DMA: 819,
  },
  "98204": {
    DMA: 819,
  },
  "98205": {
    DMA: 819,
  },
  "98206": {
    DMA: 819,
  },
  "98207": {
    DMA: 819,
  },
  "98208": {
    DMA: 819,
  },
  "98213": {
    DMA: 819,
  },
  "98220": {
    DMA: 819,
  },
  "98221": {
    DMA: 819,
  },
  "98222": {
    DMA: 819,
  },
  "98223": {
    DMA: 819,
  },
  "98224": {
    DMA: 819,
  },
  "98225": {
    DMA: 819,
  },
  "98226": {
    DMA: 819,
  },
  "98227": {
    DMA: 819,
  },
  "98228": {
    DMA: 819,
  },
  "98229": {
    DMA: 819,
  },
  "98230": {
    DMA: 819,
  },
  "98231": {
    DMA: 819,
  },
  "98232": {
    DMA: 819,
  },
  "98233": {
    DMA: 819,
  },
  "98235": {
    DMA: 819,
  },
  "98236": {
    DMA: 819,
  },
  "98237": {
    DMA: 819,
  },
  "98238": {
    DMA: 819,
  },
  "98239": {
    DMA: 819,
  },
  "98240": {
    DMA: 819,
  },
  "98241": {
    DMA: 819,
  },
  "98243": {
    DMA: 819,
  },
  "98244": {
    DMA: 819,
  },
  "98245": {
    DMA: 819,
  },
  "98247": {
    DMA: 819,
  },
  "98248": {
    DMA: 819,
  },
  "98249": {
    DMA: 819,
  },
  "98250": {
    DMA: 819,
  },
  "98251": {
    DMA: 819,
  },
  "98252": {
    DMA: 819,
  },
  "98253": {
    DMA: 819,
  },
  "98255": {
    DMA: 819,
  },
  "98256": {
    DMA: 819,
  },
  "98257": {
    DMA: 819,
  },
  "98258": {
    DMA: 819,
  },
  "98259": {
    DMA: 819,
  },
  "98260": {
    DMA: 819,
  },
  "98261": {
    DMA: 819,
  },
  "98262": {
    DMA: 819,
  },
  "98263": {
    DMA: 819,
  },
  "98264": {
    DMA: 819,
  },
  "98266": {
    DMA: 819,
  },
  "98267": {
    DMA: 819,
  },
  "98270": {
    DMA: 819,
  },
  "98271": {
    DMA: 819,
  },
  "98272": {
    DMA: 819,
  },
  "98273": {
    DMA: 819,
  },
  "98274": {
    DMA: 819,
  },
  "98275": {
    DMA: 819,
  },
  "98276": {
    DMA: 819,
  },
  "98277": {
    DMA: 819,
  },
  "98278": {
    DMA: 819,
  },
  "98279": {
    DMA: 819,
  },
  "98280": {
    DMA: 819,
  },
  "98281": {
    DMA: 819,
  },
  "98282": {
    DMA: 819,
  },
  "98283": {
    DMA: 819,
  },
  "98284": {
    DMA: 819,
  },
  "98286": {
    DMA: 819,
  },
  "98287": {
    DMA: 819,
  },
  "98288": {
    DMA: 819,
  },
  "98290": {
    DMA: 819,
  },
  "98291": {
    DMA: 819,
  },
  "98292": {
    DMA: 819,
  },
  "98293": {
    DMA: 819,
  },
  "98294": {
    DMA: 819,
  },
  "98295": {
    DMA: 819,
  },
  "98296": {
    DMA: 819,
  },
  "98297": {
    DMA: 819,
  },
  "98303": {
    DMA: 819,
  },
  "98304": {
    DMA: 819,
  },
  "98305": {
    DMA: 819,
  },
  "98310": {
    DMA: 819,
  },
  "98311": {
    DMA: 819,
  },
  "98312": {
    DMA: 819,
  },
  "98314": {
    DMA: 819,
  },
  "98315": {
    DMA: 819,
  },
  "98320": {
    DMA: 819,
  },
  "98321": {
    DMA: 819,
  },
  "98322": {
    DMA: 819,
  },
  "98323": {
    DMA: 819,
  },
  "98324": {
    DMA: 819,
  },
  "98325": {
    DMA: 819,
  },
  "98326": {
    DMA: 819,
  },
  "98327": {
    DMA: 819,
  },
  "98328": {
    DMA: 819,
  },
  "98329": {
    DMA: 819,
  },
  "98330": {
    DMA: 819,
  },
  "98331": {
    DMA: 819,
  },
  "98332": {
    DMA: 819,
  },
  "98333": {
    DMA: 819,
  },
  "98335": {
    DMA: 819,
  },
  "98336": {
    DMA: 819,
  },
  "98337": {
    DMA: 819,
  },
  "98338": {
    DMA: 819,
  },
  "98339": {
    DMA: 819,
  },
  "98340": {
    DMA: 819,
  },
  "98342": {
    DMA: 819,
  },
  "98343": {
    DMA: 819,
  },
  "98344": {
    DMA: 819,
  },
  "98345": {
    DMA: 819,
  },
  "98346": {
    DMA: 819,
  },
  "98348": {
    DMA: 819,
  },
  "98349": {
    DMA: 819,
  },
  "98350": {
    DMA: 819,
  },
  "98351": {
    DMA: 819,
  },
  "98352": {
    DMA: 819,
  },
  "98353": {
    DMA: 819,
  },
  "98354": {
    DMA: 819,
  },
  "98355": {
    DMA: 819,
  },
  "98356": {
    DMA: 819,
  },
  "98357": {
    DMA: 819,
  },
  "98358": {
    DMA: 819,
  },
  "98359": {
    DMA: 819,
  },
  "98360": {
    DMA: 819,
  },
  "98361": {
    DMA: 819,
  },
  "98362": {
    DMA: 819,
  },
  "98363": {
    DMA: 819,
  },
  "98364": {
    DMA: 819,
  },
  "98365": {
    DMA: 819,
  },
  "98366": {
    DMA: 819,
  },
  "98367": {
    DMA: 819,
  },
  "98368": {
    DMA: 819,
  },
  "98370": {
    DMA: 819,
  },
  "98371": {
    DMA: 819,
  },
  "98372": {
    DMA: 819,
  },
  "98373": {
    DMA: 819,
  },
  "98374": {
    DMA: 819,
  },
  "98375": {
    DMA: 819,
  },
  "98376": {
    DMA: 819,
  },
  "98377": {
    DMA: 819,
  },
  "98378": {
    DMA: 819,
  },
  "98380": {
    DMA: 819,
  },
  "98381": {
    DMA: 819,
  },
  "98382": {
    DMA: 819,
  },
  "98383": {
    DMA: 819,
  },
  "98384": {
    DMA: 819,
  },
  "98385": {
    DMA: 819,
  },
  "98386": {
    DMA: 819,
  },
  "98387": {
    DMA: 819,
  },
  "98388": {
    DMA: 819,
  },
  "98390": {
    DMA: 819,
  },
  "98391": {
    DMA: 819,
  },
  "98392": {
    DMA: 819,
  },
  "98393": {
    DMA: 819,
  },
  "98394": {
    DMA: 819,
  },
  "98395": {
    DMA: 819,
  },
  "98396": {
    DMA: 819,
  },
  "98397": {
    DMA: 819,
  },
  "98398": {
    DMA: 819,
  },
  "98401": {
    DMA: 819,
  },
  "98402": {
    DMA: 819,
  },
  "98403": {
    DMA: 819,
  },
  "98404": {
    DMA: 819,
  },
  "98405": {
    DMA: 819,
  },
  "98406": {
    DMA: 819,
  },
  "98407": {
    DMA: 819,
  },
  "98408": {
    DMA: 819,
  },
  "98409": {
    DMA: 819,
  },
  "98411": {
    DMA: 819,
  },
  "98412": {
    DMA: 819,
  },
  "98413": {
    DMA: 819,
  },
  "98415": {
    DMA: 819,
  },
  "98416": {
    DMA: 819,
  },
  "98417": {
    DMA: 819,
  },
  "98418": {
    DMA: 819,
  },
  "98419": {
    DMA: 819,
  },
  "98421": {
    DMA: 819,
  },
  "98422": {
    DMA: 819,
  },
  "98424": {
    DMA: 819,
  },
  "98430": {
    DMA: 819,
  },
  "98431": {
    DMA: 819,
  },
  "98433": {
    DMA: 819,
  },
  "98438": {
    DMA: 819,
  },
  "98439": {
    DMA: 819,
  },
  "98442": {
    DMA: 819,
  },
  "98443": {
    DMA: 819,
  },
  "98444": {
    DMA: 819,
  },
  "98445": {
    DMA: 819,
  },
  "98446": {
    DMA: 819,
  },
  "98447": {
    DMA: 819,
  },
  "98448": {
    DMA: 819,
  },
  "98450": {
    DMA: 819,
  },
  "98455": {
    DMA: 819,
  },
  "98460": {
    DMA: 819,
  },
  "98464": {
    DMA: 819,
  },
  "98465": {
    DMA: 819,
  },
  "98466": {
    DMA: 819,
  },
  "98467": {
    DMA: 819,
  },
  "98471": {
    DMA: 819,
  },
  "98477": {
    DMA: 819,
  },
  "98481": {
    DMA: 819,
  },
  "98490": {
    DMA: 819,
  },
  "98492": {
    DMA: 819,
  },
  "98493": {
    DMA: 819,
  },
  "98496": {
    DMA: 819,
  },
  "98497": {
    DMA: 819,
  },
  "98498": {
    DMA: 819,
  },
  "98499": {
    DMA: 819,
  },
  "98501": {
    DMA: 819,
  },
  "98502": {
    DMA: 819,
  },
  "98503": {
    DMA: 819,
  },
  "98504": {
    DMA: 819,
  },
  "98505": {
    DMA: 819,
  },
  "98506": {
    DMA: 819,
  },
  "98507": {
    DMA: 819,
  },
  "98508": {
    DMA: 819,
  },
  "98509": {
    DMA: 819,
  },
  "98511": {
    DMA: 819,
  },
  "98512": {
    DMA: 819,
  },
  "98513": {
    DMA: 819,
  },
  "98516": {
    DMA: 819,
  },
  "98520": {
    DMA: 819,
  },
  "98522": {
    DMA: 819,
  },
  "98524": {
    DMA: 819,
  },
  "98526": {
    DMA: 819,
  },
  "98527": {
    DMA: 819,
  },
  "98528": {
    DMA: 819,
  },
  "98530": {
    DMA: 819,
  },
  "98531": {
    DMA: 819,
  },
  "98532": {
    DMA: 819,
  },
  "98533": {
    DMA: 819,
  },
  "98535": {
    DMA: 819,
  },
  "98536": {
    DMA: 819,
  },
  "98537": {
    DMA: 819,
  },
  "98538": {
    DMA: 819,
  },
  "98539": {
    DMA: 819,
  },
  "98540": {
    DMA: 819,
  },
  "98541": {
    DMA: 819,
  },
  "98542": {
    DMA: 819,
  },
  "98544": {
    DMA: 819,
  },
  "98546": {
    DMA: 819,
  },
  "98547": {
    DMA: 819,
  },
  "98548": {
    DMA: 819,
  },
  "98550": {
    DMA: 819,
  },
  "98552": {
    DMA: 819,
  },
  "98554": {
    DMA: 819,
  },
  "98555": {
    DMA: 819,
  },
  "98556": {
    DMA: 819,
  },
  "98557": {
    DMA: 819,
  },
  "98558": {
    DMA: 819,
  },
  "98559": {
    DMA: 819,
  },
  "98560": {
    DMA: 819,
  },
  "98561": {
    DMA: 819,
  },
  "98562": {
    DMA: 819,
  },
  "98563": {
    DMA: 819,
  },
  "98564": {
    DMA: 819,
  },
  "98565": {
    DMA: 819,
  },
  "98566": {
    DMA: 819,
  },
  "98568": {
    DMA: 819,
  },
  "98569": {
    DMA: 819,
  },
  "98570": {
    DMA: 819,
  },
  "98571": {
    DMA: 819,
  },
  "98572": {
    DMA: 819,
  },
  "98575": {
    DMA: 819,
  },
  "98576": {
    DMA: 819,
  },
  "98577": {
    DMA: 819,
  },
  "98579": {
    DMA: 819,
  },
  "98580": {
    DMA: 819,
  },
  "98581": {
    DMA: 820,
  },
  "98582": {
    DMA: 819,
  },
  "98583": {
    DMA: 819,
  },
  "98584": {
    DMA: 819,
  },
  "98585": {
    DMA: 819,
  },
  "98586": {
    DMA: 819,
  },
  "98587": {
    DMA: 819,
  },
  "98588": {
    DMA: 819,
  },
  "98589": {
    DMA: 819,
  },
  "98590": {
    DMA: 819,
  },
  "98591": {
    DMA: 819,
  },
  "98592": {
    DMA: 819,
  },
  "98593": {
    DMA: 819,
  },
  "98595": {
    DMA: 819,
  },
  "98596": {
    DMA: 819,
  },
  "98597": {
    DMA: 819,
  },
  "98599": {
    DMA: 819,
  },
  "98601": {
    DMA: 820,
  },
  "98602": {
    DMA: 820,
  },
  "98603": {
    DMA: 820,
  },
  "98604": {
    DMA: 820,
  },
  "98605": {
    DMA: 820,
  },
  "98606": {
    DMA: 820,
  },
  "98607": {
    DMA: 820,
  },
  "98609": {
    DMA: 820,
  },
  "98610": {
    DMA: 820,
  },
  "98611": {
    DMA: 820,
  },
  "98612": {
    DMA: 820,
  },
  "98613": {
    DMA: 820,
  },
  "98614": {
    DMA: 819,
  },
  "98616": {
    DMA: 820,
  },
  "98617": {
    DMA: 820,
  },
  "98619": {
    DMA: 820,
  },
  "98620": {
    DMA: 820,
  },
  "98621": {
    DMA: 820,
  },
  "98622": {
    DMA: 820,
  },
  "98623": {
    DMA: 820,
  },
  "98624": {
    DMA: 819,
  },
  "98625": {
    DMA: 820,
  },
  "98626": {
    DMA: 820,
  },
  "98628": {
    DMA: 820,
  },
  "98629": {
    DMA: 820,
  },
  "98631": {
    DMA: 819,
  },
  "98632": {
    DMA: 820,
  },
  "98635": {
    DMA: 820,
  },
  "98637": {
    DMA: 819,
  },
  "98638": {
    DMA: 819,
  },
  "98639": {
    DMA: 820,
  },
  "98640": {
    DMA: 819,
  },
  "98641": {
    DMA: 819,
  },
  "98642": {
    DMA: 820,
  },
  "98643": {
    DMA: 820,
  },
  "98644": {
    DMA: 819,
  },
  "98645": {
    DMA: 820,
  },
  "98647": {
    DMA: 820,
  },
  "98648": {
    DMA: 820,
  },
  "98649": {
    DMA: 820,
  },
  "98650": {
    DMA: 820,
  },
  "98651": {
    DMA: 820,
  },
  "98660": {
    DMA: 820,
  },
  "98661": {
    DMA: 820,
  },
  "98662": {
    DMA: 820,
  },
  "98663": {
    DMA: 820,
  },
  "98664": {
    DMA: 820,
  },
  "98665": {
    DMA: 820,
  },
  "98666": {
    DMA: 820,
  },
  "98667": {
    DMA: 820,
  },
  "98668": {
    DMA: 820,
  },
  "98670": {
    DMA: 820,
  },
  "98671": {
    DMA: 820,
  },
  "98672": {
    DMA: 820,
  },
  "98673": {
    DMA: 820,
  },
  "98674": {
    DMA: 820,
  },
  "98675": {
    DMA: 820,
  },
  "98682": {
    DMA: 820,
  },
  "98683": {
    DMA: 820,
  },
  "98684": {
    DMA: 820,
  },
  "98685": {
    DMA: 820,
  },
  "98686": {
    DMA: 820,
  },
  "98687": {
    DMA: 820,
  },
  "98801": {
    DMA: 819,
  },
  "98802": {
    DMA: 819,
  },
  "98807": {
    DMA: 819,
  },
  "98811": {
    DMA: 819,
  },
  "98812": {
    DMA: 881,
  },
  "98813": {
    DMA: 819,
  },
  "98814": {
    DMA: 881,
  },
  "98815": {
    DMA: 819,
  },
  "98816": {
    DMA: 819,
  },
  "98817": {
    DMA: 819,
  },
  "98819": {
    DMA: 881,
  },
  "98821": {
    DMA: 819,
  },
  "98822": {
    DMA: 819,
  },
  "98823": {
    DMA: 881,
  },
  "98824": {
    DMA: 881,
  },
  "98826": {
    DMA: 819,
  },
  "98827": {
    DMA: 881,
  },
  "98828": {
    DMA: 819,
  },
  "98829": {
    DMA: 881,
  },
  "98830": {
    DMA: 819,
  },
  "98831": {
    DMA: 819,
  },
  "98832": {
    DMA: 881,
  },
  "98833": {
    DMA: 881,
  },
  "98834": {
    DMA: 881,
  },
  "98836": {
    DMA: 819,
  },
  "98837": {
    DMA: 881,
  },
  "98840": {
    DMA: 881,
  },
  "98841": {
    DMA: 881,
  },
  "98843": {
    DMA: 819,
  },
  "98844": {
    DMA: 881,
  },
  "98845": {
    DMA: 819,
  },
  "98846": {
    DMA: 881,
  },
  "98847": {
    DMA: 819,
  },
  "98848": {
    DMA: 881,
  },
  "98849": {
    DMA: 881,
  },
  "98850": {
    DMA: 819,
  },
  "98851": {
    DMA: 881,
  },
  "98852": {
    DMA: 819,
  },
  "98853": {
    DMA: 881,
  },
  "98855": {
    DMA: 881,
  },
  "98856": {
    DMA: 881,
  },
  "98857": {
    DMA: 881,
  },
  "98858": {
    DMA: 819,
  },
  "98859": {
    DMA: 881,
  },
  "98860": {
    DMA: 881,
  },
  "98862": {
    DMA: 881,
  },
  "98901": {
    DMA: 810,
  },
  "98902": {
    DMA: 810,
  },
  "98903": {
    DMA: 810,
  },
  "98904": {
    DMA: 810,
  },
  "98907": {
    DMA: 810,
  },
  "98908": {
    DMA: 810,
  },
  "98909": {
    DMA: 810,
  },
  "98920": {
    DMA: 810,
  },
  "98921": {
    DMA: 810,
  },
  "98922": {
    DMA: 810,
  },
  "98923": {
    DMA: 810,
  },
  "98925": {
    DMA: 810,
  },
  "98926": {
    DMA: 810,
  },
  "98929": {
    DMA: 810,
  },
  "98930": {
    DMA: 810,
  },
  "98932": {
    DMA: 810,
  },
  "98933": {
    DMA: 810,
  },
  "98934": {
    DMA: 810,
  },
  "98935": {
    DMA: 810,
  },
  "98936": {
    DMA: 810,
  },
  "98937": {
    DMA: 810,
  },
  "98938": {
    DMA: 810,
  },
  "98939": {
    DMA: 810,
  },
  "98940": {
    DMA: 810,
  },
  "98941": {
    DMA: 810,
  },
  "98942": {
    DMA: 810,
  },
  "98943": {
    DMA: 810,
  },
  "98944": {
    DMA: 810,
  },
  "98946": {
    DMA: 810,
  },
  "98947": {
    DMA: 810,
  },
  "98948": {
    DMA: 810,
  },
  "98950": {
    DMA: 810,
  },
  "98951": {
    DMA: 810,
  },
  "98952": {
    DMA: 810,
  },
  "98953": {
    DMA: 810,
  },
  "99001": {
    DMA: 881,
  },
  "99003": {
    DMA: 881,
  },
  "99004": {
    DMA: 881,
  },
  "99005": {
    DMA: 881,
  },
  "99006": {
    DMA: 881,
  },
  "99008": {
    DMA: 881,
  },
  "99009": {
    DMA: 881,
  },
  "99011": {
    DMA: 881,
  },
  "99012": {
    DMA: 881,
  },
  "99013": {
    DMA: 881,
  },
  "99014": {
    DMA: 881,
  },
  "99016": {
    DMA: 881,
  },
  "99017": {
    DMA: 881,
  },
  "99018": {
    DMA: 881,
  },
  "99019": {
    DMA: 881,
  },
  "99020": {
    DMA: 881,
  },
  "99021": {
    DMA: 881,
  },
  "99022": {
    DMA: 881,
  },
  "99023": {
    DMA: 881,
  },
  "99025": {
    DMA: 881,
  },
  "99026": {
    DMA: 881,
  },
  "99027": {
    DMA: 881,
  },
  "99029": {
    DMA: 881,
  },
  "99030": {
    DMA: 881,
  },
  "99031": {
    DMA: 881,
  },
  "99032": {
    DMA: 881,
  },
  "99033": {
    DMA: 881,
  },
  "99034": {
    DMA: 881,
  },
  "99036": {
    DMA: 881,
  },
  "99037": {
    DMA: 881,
  },
  "99039": {
    DMA: 881,
  },
  "99040": {
    DMA: 881,
  },
  "99101": {
    DMA: 881,
  },
  "99102": {
    DMA: 881,
  },
  "99103": {
    DMA: 881,
  },
  "99104": {
    DMA: 881,
  },
  "99105": {
    DMA: 881,
  },
  "99107": {
    DMA: 881,
  },
  "99109": {
    DMA: 881,
  },
  "99110": {
    DMA: 881,
  },
  "99111": {
    DMA: 881,
  },
  "99113": {
    DMA: 881,
  },
  "99114": {
    DMA: 881,
  },
  "99115": {
    DMA: 881,
  },
  "99116": {
    DMA: 881,
  },
  "99117": {
    DMA: 881,
  },
  "99118": {
    DMA: 881,
  },
  "99119": {
    DMA: 881,
  },
  "99121": {
    DMA: 881,
  },
  "99122": {
    DMA: 881,
  },
  "99123": {
    DMA: 881,
  },
  "99124": {
    DMA: 881,
  },
  "99125": {
    DMA: 881,
  },
  "99126": {
    DMA: 881,
  },
  "99128": {
    DMA: 881,
  },
  "99129": {
    DMA: 881,
  },
  "99130": {
    DMA: 881,
  },
  "99131": {
    DMA: 881,
  },
  "99133": {
    DMA: 881,
  },
  "99134": {
    DMA: 881,
  },
  "99135": {
    DMA: 881,
  },
  "99136": {
    DMA: 881,
  },
  "99137": {
    DMA: 881,
  },
  "99138": {
    DMA: 881,
  },
  "99139": {
    DMA: 881,
  },
  "99140": {
    DMA: 881,
  },
  "99141": {
    DMA: 881,
  },
  "99143": {
    DMA: 881,
  },
  "99144": {
    DMA: 881,
  },
  "99146": {
    DMA: 881,
  },
  "99147": {
    DMA: 881,
  },
  "99148": {
    DMA: 881,
  },
  "99149": {
    DMA: 881,
  },
  "99150": {
    DMA: 881,
  },
  "99151": {
    DMA: 881,
  },
  "99152": {
    DMA: 881,
  },
  "99153": {
    DMA: 881,
  },
  "99154": {
    DMA: 881,
  },
  "99155": {
    DMA: 881,
  },
  "99156": {
    DMA: 881,
  },
  "99157": {
    DMA: 881,
  },
  "99158": {
    DMA: 881,
  },
  "99159": {
    DMA: 881,
  },
  "99160": {
    DMA: 881,
  },
  "99161": {
    DMA: 881,
  },
  "99163": {
    DMA: 881,
  },
  "99164": {
    DMA: 881,
  },
  "99165": {
    DMA: 881,
  },
  "99166": {
    DMA: 881,
  },
  "99167": {
    DMA: 881,
  },
  "99169": {
    DMA: 881,
  },
  "99170": {
    DMA: 881,
  },
  "99171": {
    DMA: 881,
  },
  "99173": {
    DMA: 881,
  },
  "99174": {
    DMA: 881,
  },
  "99176": {
    DMA: 881,
  },
  "99179": {
    DMA: 881,
  },
  "99180": {
    DMA: 881,
  },
  "99181": {
    DMA: 881,
  },
  "99185": {
    DMA: 881,
  },
  "99201": {
    DMA: 881,
  },
  "99202": {
    DMA: 881,
  },
  "99203": {
    DMA: 881,
  },
  "99204": {
    DMA: 881,
  },
  "99205": {
    DMA: 881,
  },
  "99206": {
    DMA: 881,
  },
  "99207": {
    DMA: 881,
  },
  "99208": {
    DMA: 881,
  },
  "99209": {
    DMA: 881,
  },
  "99210": {
    DMA: 881,
  },
  "99211": {
    DMA: 881,
  },
  "99212": {
    DMA: 881,
  },
  "99213": {
    DMA: 881,
  },
  "99214": {
    DMA: 881,
  },
  "99215": {
    DMA: 881,
  },
  "99216": {
    DMA: 881,
  },
  "99217": {
    DMA: 881,
  },
  "99218": {
    DMA: 881,
  },
  "99219": {
    DMA: 881,
  },
  "99220": {
    DMA: 881,
  },
  "99223": {
    DMA: 881,
  },
  "99224": {
    DMA: 881,
  },
  "99228": {
    DMA: 881,
  },
  "99251": {
    DMA: 881,
  },
  "99252": {
    DMA: 881,
  },
  "99256": {
    DMA: 881,
  },
  "99258": {
    DMA: 881,
  },
  "99260": {
    DMA: 881,
  },
  "99299": {
    DMA: 881,
  },
  "99301": {
    DMA: 810,
  },
  "99302": {
    DMA: 810,
  },
  "99320": {
    DMA: 810,
  },
  "99321": {
    DMA: 881,
  },
  "99322": {
    DMA: 820,
  },
  "99323": {
    DMA: 810,
  },
  "99324": {
    DMA: 810,
  },
  "99326": {
    DMA: 810,
  },
  "99328": {
    DMA: 881,
  },
  "99329": {
    DMA: 810,
  },
  "99330": {
    DMA: 810,
  },
  "99333": {
    DMA: 881,
  },
  "99335": {
    DMA: 810,
  },
  "99336": {
    DMA: 810,
  },
  "99337": {
    DMA: 810,
  },
  "99338": {
    DMA: 810,
  },
  "99341": {
    DMA: 881,
  },
  "99343": {
    DMA: 810,
  },
  "99344": {
    DMA: 881,
  },
  "99345": {
    DMA: 810,
  },
  "99346": {
    DMA: 810,
  },
  "99347": {
    DMA: 881,
  },
  "99348": {
    DMA: 810,
  },
  "99349": {
    DMA: 881,
  },
  "99350": {
    DMA: 810,
  },
  "99352": {
    DMA: 810,
  },
  "99353": {
    DMA: 810,
  },
  "99354": {
    DMA: 810,
  },
  "99356": {
    DMA: 820,
  },
  "99357": {
    DMA: 881,
  },
  "99359": {
    DMA: 881,
  },
  "99360": {
    DMA: 810,
  },
  "99361": {
    DMA: 810,
  },
  "99362": {
    DMA: 810,
  },
  "99363": {
    DMA: 810,
  },
  "99371": {
    DMA: 881,
  },
  "99401": {
    DMA: 881,
  },
  "99402": {
    DMA: 881,
  },
  "99403": {
    DMA: 881,
  },
  "99501": {
    DMA: 743,
  },
  "99502": {
    DMA: 743,
  },
  "99503": {
    DMA: 743,
  },
  "99504": {
    DMA: 743,
  },
  "99505": {
    DMA: 743,
  },
  "99506": {
    DMA: 743,
  },
  "99507": {
    DMA: 743,
  },
  "99508": {
    DMA: 743,
  },
  "99509": {
    DMA: 743,
  },
  "99510": {
    DMA: 743,
  },
  "99511": {
    DMA: 743,
  },
  "99513": {
    DMA: 743,
  },
  "99514": {
    DMA: 743,
  },
  "99515": {
    DMA: 743,
  },
  "99516": {
    DMA: 743,
  },
  "99517": {
    DMA: 743,
  },
  "99518": {
    DMA: 743,
  },
  "99519": {
    DMA: 743,
  },
  "99520": {
    DMA: 743,
  },
  "99521": {
    DMA: 743,
  },
  "99522": {
    DMA: 743,
  },
  "99523": {
    DMA: 743,
  },
  "99524": {
    DMA: 743,
  },
  "99529": {
    DMA: 743,
  },
  "99530": {
    DMA: 743,
  },
  "99540": {
    DMA: 743,
  },
  "99545": {
    DMA: 743,
  },
  "99546": {
    DMA: 743,
  },
  "99547": {
    DMA: 743,
  },
  "99548": {
    DMA: 743,
  },
  "99549": {
    DMA: 743,
  },
  "99550": {
    DMA: 743,
  },
  "99551": {
    DMA: 743,
  },
  "99552": {
    DMA: 743,
  },
  "99553": {
    DMA: 743,
  },
  "99554": {
    DMA: 743,
  },
  "99555": {
    DMA: 743,
  },
  "99556": {
    DMA: 743,
  },
  "99557": {
    DMA: 743,
  },
  "99558": {
    DMA: 743,
  },
  "99559": {
    DMA: 743,
  },
  "99561": {
    DMA: 743,
  },
  "99563": {
    DMA: 743,
  },
  "99564": {
    DMA: 743,
  },
  "99565": {
    DMA: 743,
  },
  "99566": {
    DMA: 743,
  },
  "99567": {
    DMA: 743,
  },
  "99568": {
    DMA: 743,
  },
  "99569": {
    DMA: 743,
  },
  "99571": {
    DMA: 743,
  },
  "99572": {
    DMA: 743,
  },
  "99573": {
    DMA: 743,
  },
  "99574": {
    DMA: 743,
  },
  "99575": {
    DMA: 743,
  },
  "99576": {
    DMA: 743,
  },
  "99577": {
    DMA: 743,
  },
  "99578": {
    DMA: 743,
  },
  "99579": {
    DMA: 743,
  },
  "99580": {
    DMA: 743,
  },
  "99581": {
    DMA: 743,
  },
  "99583": {
    DMA: 743,
  },
  "99585": {
    DMA: 743,
  },
  "99586": {
    DMA: 743,
  },
  "99587": {
    DMA: 743,
  },
  "99588": {
    DMA: 743,
  },
  "99589": {
    DMA: 743,
  },
  "99590": {
    DMA: 743,
  },
  "99591": {
    DMA: 743,
  },
  "99599": {
    DMA: 743,
  },
  "99602": {
    DMA: 743,
  },
  "99603": {
    DMA: 743,
  },
  "99604": {
    DMA: 743,
  },
  "99605": {
    DMA: 743,
  },
  "99606": {
    DMA: 743,
  },
  "99607": {
    DMA: 743,
  },
  "99608": {
    DMA: 743,
  },
  "99609": {
    DMA: 743,
  },
  "99610": {
    DMA: 743,
  },
  "99611": {
    DMA: 743,
  },
  "99612": {
    DMA: 743,
  },
  "99613": {
    DMA: 743,
  },
  "99614": {
    DMA: 743,
  },
  "99615": {
    DMA: 743,
  },
  "99619": {
    DMA: 743,
  },
  "99620": {
    DMA: 743,
  },
  "99621": {
    DMA: 743,
  },
  "99622": {
    DMA: 743,
  },
  "99623": {
    DMA: 743,
  },
  "99624": {
    DMA: 743,
  },
  "99625": {
    DMA: 743,
  },
  "99626": {
    DMA: 743,
  },
  "99627": {
    DMA: 743,
  },
  "99628": {
    DMA: 743,
  },
  "99629": {
    DMA: 743,
  },
  "99630": {
    DMA: 743,
  },
  "99631": {
    DMA: 743,
  },
  "99632": {
    DMA: 743,
  },
  "99633": {
    DMA: 743,
  },
  "99634": {
    DMA: 743,
  },
  "99635": {
    DMA: 743,
  },
  "99636": {
    DMA: 743,
  },
  "99637": {
    DMA: 743,
  },
  "99638": {
    DMA: 743,
  },
  "99639": {
    DMA: 743,
  },
  "99640": {
    DMA: 743,
  },
  "99641": {
    DMA: 743,
  },
  "99643": {
    DMA: 743,
  },
  "99644": {
    DMA: 743,
  },
  "99645": {
    DMA: 743,
  },
  "99647": {
    DMA: 743,
  },
  "99648": {
    DMA: 743,
  },
  "99649": {
    DMA: 743,
  },
  "99650": {
    DMA: 743,
  },
  "99651": {
    DMA: 743,
  },
  "99652": {
    DMA: 743,
  },
  "99653": {
    DMA: 743,
  },
  "99654": {
    DMA: 743,
  },
  "99655": {
    DMA: 743,
  },
  "99656": {
    DMA: 743,
  },
  "99657": {
    DMA: 743,
  },
  "99658": {
    DMA: 743,
  },
  "99659": {
    DMA: 743,
  },
  "99660": {
    DMA: 743,
  },
  "99661": {
    DMA: 743,
  },
  "99662": {
    DMA: 743,
  },
  "99663": {
    DMA: 743,
  },
  "99664": {
    DMA: 743,
  },
  "99665": {
    DMA: 743,
  },
  "99666": {
    DMA: 743,
  },
  "99667": {
    DMA: 743,
  },
  "99668": {
    DMA: 743,
  },
  "99669": {
    DMA: 743,
  },
  "99670": {
    DMA: 743,
  },
  "99671": {
    DMA: 743,
  },
  "99672": {
    DMA: 743,
  },
  "99674": {
    DMA: 743,
  },
  "99675": {
    DMA: 743,
  },
  "99676": {
    DMA: 743,
  },
  "99677": {
    DMA: 743,
  },
  "99678": {
    DMA: 743,
  },
  "99679": {
    DMA: 743,
  },
  "99680": {
    DMA: 743,
  },
  "99681": {
    DMA: 743,
  },
  "99682": {
    DMA: 743,
  },
  "99683": {
    DMA: 743,
  },
  "99684": {
    DMA: 743,
  },
  "99685": {
    DMA: 743,
  },
  "99686": {
    DMA: 743,
  },
  "99687": {
    DMA: 743,
  },
  "99688": {
    DMA: 743,
  },
  "99689": {
    DMA: 743,
  },
  "99690": {
    DMA: 743,
  },
  "99691": {
    DMA: 743,
  },
  "99692": {
    DMA: 743,
  },
  "99693": {
    DMA: 743,
  },
  "99694": {
    DMA: 743,
  },
  "99695": {
    DMA: 743,
  },
  "99697": {
    DMA: 743,
  },
  "99701": {
    DMA: 743,
  },
  "99702": {
    DMA: 743,
  },
  "99703": {
    DMA: 743,
  },
  "99704": {
    DMA: 743,
  },
  "99705": {
    DMA: 743,
  },
  "99706": {
    DMA: 743,
  },
  "99707": {
    DMA: 743,
  },
  "99708": {
    DMA: 743,
  },
  "99709": {
    DMA: 743,
  },
  "99710": {
    DMA: 743,
  },
  "99711": {
    DMA: 743,
  },
  "99712": {
    DMA: 743,
  },
  "99714": {
    DMA: 743,
  },
  "99716": {
    DMA: 743,
  },
  "99720": {
    DMA: 743,
  },
  "99721": {
    DMA: 743,
  },
  "99722": {
    DMA: 743,
  },
  "99723": {
    DMA: 743,
  },
  "99724": {
    DMA: 743,
  },
  "99725": {
    DMA: 743,
  },
  "99726": {
    DMA: 743,
  },
  "99727": {
    DMA: 743,
  },
  "99729": {
    DMA: 743,
  },
  "99730": {
    DMA: 743,
  },
  "99731": {
    DMA: 743,
  },
  "99732": {
    DMA: 743,
  },
  "99733": {
    DMA: 743,
  },
  "99734": {
    DMA: 743,
  },
  "99736": {
    DMA: 743,
  },
  "99737": {
    DMA: 743,
  },
  "99738": {
    DMA: 743,
  },
  "99739": {
    DMA: 743,
  },
  "99740": {
    DMA: 743,
  },
  "99741": {
    DMA: 743,
  },
  "99742": {
    DMA: 743,
  },
  "99743": {
    DMA: 743,
  },
  "99744": {
    DMA: 743,
  },
  "99745": {
    DMA: 743,
  },
  "99746": {
    DMA: 743,
  },
  "99747": {
    DMA: 743,
  },
  "99748": {
    DMA: 743,
  },
  "99749": {
    DMA: 743,
  },
  "99750": {
    DMA: 743,
  },
  "99751": {
    DMA: 743,
  },
  "99752": {
    DMA: 743,
  },
  "99753": {
    DMA: 743,
  },
  "99754": {
    DMA: 743,
  },
  "99755": {
    DMA: 743,
  },
  "99756": {
    DMA: 743,
  },
  "99757": {
    DMA: 743,
  },
  "99758": {
    DMA: 743,
  },
  "99759": {
    DMA: 743,
  },
  "99760": {
    DMA: 743,
  },
  "99761": {
    DMA: 743,
  },
  "99762": {
    DMA: 743,
  },
  "99763": {
    DMA: 743,
  },
  "99764": {
    DMA: 743,
  },
  "99765": {
    DMA: 743,
  },
  "99766": {
    DMA: 743,
  },
  "99767": {
    DMA: 743,
  },
  "99768": {
    DMA: 743,
  },
  "99769": {
    DMA: 743,
  },
  "99770": {
    DMA: 743,
  },
  "99771": {
    DMA: 743,
  },
  "99772": {
    DMA: 743,
  },
  "99773": {
    DMA: 743,
  },
  "99774": {
    DMA: 743,
  },
  "99775": {
    DMA: 745,
  },
  "99776": {
    DMA: 745,
  },
  "99777": {
    DMA: 745,
  },
  "99778": {
    DMA: 745,
  },
  "99779": {
    DMA: 745,
  },
  "99780": {
    DMA: 745,
  },
  "99781": {
    DMA: 745,
  },
  "99782": {
    DMA: 745,
  },
  "99783": {
    DMA: 745,
  },
  "99784": {
    DMA: 745,
  },
  "99785": {
    DMA: 745,
  },
  "99786": {
    DMA: 745,
  },
  "99788": {
    DMA: 745,
  },
  "99789": {
    DMA: 745,
  },
  "99790": {
    DMA: 745,
  },
  "99791": {
    DMA: 745,
  },
  "99801": {
    DMA: 747,
  },
  "99802": {
    DMA: 747,
  },
  "99803": {
    DMA: 747,
  },
  "99811": {
    DMA: 747,
  },
  "99812": {
    DMA: 747,
  },
  "99820": {
    DMA: 747,
  },
  "99821": {
    DMA: 747,
  },
  "99824": {
    DMA: 747,
  },
  "99825": {
    DMA: 747,
  },
  "99826": {
    DMA: 747,
  },
  "99827": {
    DMA: 747,
  },
  "99829": {
    DMA: 747,
  },
  "99830": {
    DMA: 747,
  },
  "99832": {
    DMA: 747,
  },
  "99833": {
    DMA: 747,
  },
  "99835": {
    DMA: 747,
  },
  "99836": {
    DMA: 747,
  },
  "99840": {
    DMA: 747,
  },
  "99841": {
    DMA: 747,
  },
  "99850": {
    DMA: 747,
  },
  "99901": {
    DMA: 747,
  },
  "99903": {
    DMA: 747,
  },
  "99918": {
    DMA: 747,
  },
  "99919": {
    DMA: 747,
  },
  "99921": {
    DMA: 747,
  },
  "99922": {
    DMA: 747,
  },
  "99923": {
    DMA: 747,
  },
  "99925": {
    DMA: 747,
  },
  "99926": {
    DMA: 747,
  },
  "99927": {
    DMA: 747,
  },
  "99928": {
    DMA: 747,
  },
  "99929": {
    DMA: 747,
  },
  "99950": {
    DMA: 747,
  },
  "09001": {
    DMA: "MIL",
  },
  "09002": {
    DMA: "MIL",
  },
  "09003": {
    DMA: "MIL",
  },
  "09004": {
    DMA: "MIL",
  },
  "09005": {
    DMA: "MIL",
  },
  "09006": {
    DMA: "MIL",
  },
  "09007": {
    DMA: "MIL",
  },
  "09008": {
    DMA: "MIL",
  },
  "09009": {
    DMA: "MIL",
  },
  "09010": {
    DMA: "MIL",
  },
  "09011": {
    DMA: "MIL",
  },
  "09012": {
    DMA: "MIL",
  },
  "09013": {
    DMA: "MIL",
  },
  "09014": {
    DMA: "MIL",
  },
  "09015": {
    DMA: "MIL",
  },
  "09016": {
    DMA: "MIL",
  },
  "09017": {
    DMA: "MIL",
  },
  "09018": {
    DMA: "MIL",
  },
  "09020": {
    DMA: "MIL",
  },
  "09021": {
    DMA: "MIL",
  },
  "09028": {
    DMA: "MIL",
  },
  "09031": {
    DMA: "MIL",
  },
  "09033": {
    DMA: "MIL",
  },
  "09034": {
    DMA: "MIL",
  },
  "09036": {
    DMA: "MIL",
  },
  "09038": {
    DMA: "MIL",
  },
  "09042": {
    DMA: "MIL",
  },
  "09044": {
    DMA: "MIL",
  },
  "09045": {
    DMA: "MIL",
  },
  "09046": {
    DMA: "MIL",
  },
  "09049": {
    DMA: "MIL",
  },
  "09051": {
    DMA: "MIL",
  },
  "09053": {
    DMA: "MIL",
  },
  "09054": {
    DMA: "MIL",
  },
  "09055": {
    DMA: "MIL",
  },
  "09056": {
    DMA: "MIL",
  },
  "09058": {
    DMA: "MIL",
  },
  "09059": {
    DMA: "MIL",
  },
  "09060": {
    DMA: "MIL",
  },
  "09063": {
    DMA: "MIL",
  },
  "09067": {
    DMA: "MIL",
  },
  "09068": {
    DMA: "MIL",
  },
  "09069": {
    DMA: "MIL",
  },
  "09074": {
    DMA: "MIL",
  },
  "09075": {
    DMA: "MIL",
  },
  "09076": {
    DMA: "MIL",
  },
  "09079": {
    DMA: "MIL",
  },
  "09080": {
    DMA: "MIL",
  },
  "09081": {
    DMA: "MIL",
  },
  "09086": {
    DMA: "MIL",
  },
  "09088": {
    DMA: "MIL",
  },
  "09089": {
    DMA: "MIL",
  },
  "09090": {
    DMA: "MIL",
  },
  "09092": {
    DMA: "MIL",
  },
  "09094": {
    DMA: "MIL",
  },
  "09095": {
    DMA: "MIL",
  },
  "09096": {
    DMA: "MIL",
  },
  "09099": {
    DMA: "MIL",
  },
  "09100": {
    DMA: "MIL",
  },
  "09101": {
    DMA: "MIL",
  },
  "09102": {
    DMA: "MIL",
  },
  "09103": {
    DMA: "MIL",
  },
  "09104": {
    DMA: "MIL",
  },
  "09107": {
    DMA: "MIL",
  },
  "09110": {
    DMA: "MIL",
  },
  "09112": {
    DMA: "MIL",
  },
  "09113": {
    DMA: "MIL",
  },
  "09114": {
    DMA: "MIL",
  },
  "09115": {
    DMA: "MIL",
  },
  "09116": {
    DMA: "MIL",
  },
  "09123": {
    DMA: "MIL",
  },
  "09125": {
    DMA: "MIL",
  },
  "09126": {
    DMA: "MIL",
  },
  "09128": {
    DMA: "MIL",
  },
  "09131": {
    DMA: "MIL",
  },
  "09135": {
    DMA: "MIL",
  },
  "09136": {
    DMA: "MIL",
  },
  "09137": {
    DMA: "MIL",
  },
  "09138": {
    DMA: "MIL",
  },
  "09139": {
    DMA: "MIL",
  },
  "09140": {
    DMA: "MIL",
  },
  "09142": {
    DMA: "MIL",
  },
  "09143": {
    DMA: "MIL",
  },
  "09154": {
    DMA: "MIL",
  },
  "09161": {
    DMA: "MIL",
  },
  "09165": {
    DMA: "MIL",
  },
  "09166": {
    DMA: "MIL",
  },
  "09169": {
    DMA: "MIL",
  },
  "09172": {
    DMA: "MIL",
  },
  "09173": {
    DMA: "MIL",
  },
  "09177": {
    DMA: "MIL",
  },
  "09180": {
    DMA: "MIL",
  },
  "09182": {
    DMA: "MIL",
  },
  "09183": {
    DMA: "MIL",
  },
  "09185": {
    DMA: "MIL",
  },
  "09186": {
    DMA: "MIL",
  },
  "09201": {
    DMA: "MIL",
  },
  "09211": {
    DMA: "MIL",
  },
  "09212": {
    DMA: "MIL",
  },
  "09214": {
    DMA: "MIL",
  },
  "09225": {
    DMA: "MIL",
  },
  "09226": {
    DMA: "MIL",
  },
  "09227": {
    DMA: "MIL",
  },
  "09229": {
    DMA: "MIL",
  },
  "09237": {
    DMA: "MIL",
  },
  "09240": {
    DMA: "MIL",
  },
  "09242": {
    DMA: "MIL",
  },
  "09244": {
    DMA: "MIL",
  },
  "09245": {
    DMA: "MIL",
  },
  "09250": {
    DMA: "MIL",
  },
  "09252": {
    DMA: "MIL",
  },
  "09261": {
    DMA: "MIL",
  },
  "09262": {
    DMA: "MIL",
  },
  "09263": {
    DMA: "MIL",
  },
  "09264": {
    DMA: "MIL",
  },
  "09267": {
    DMA: "MIL",
  },
  "09300": {
    DMA: "MIL",
  },
  "09302": {
    DMA: "MIL",
  },
  "09303": {
    DMA: "MIL",
  },
  "09304": {
    DMA: "MIL",
  },
  "09305": {
    DMA: "MIL",
  },
  "09306": {
    DMA: "MIL",
  },
  "09307": {
    DMA: "MIL",
  },
  "09308": {
    DMA: "MIL",
  },
  "09309": {
    DMA: "MIL",
  },
  "09314": {
    DMA: "MIL",
  },
  "09315": {
    DMA: "MIL",
  },
  "09316": {
    DMA: "MIL",
  },
  "09317": {
    DMA: "MIL",
  },
  "09318": {
    DMA: "MIL",
  },
  "09319": {
    DMA: "MIL",
  },
  "09320": {
    DMA: "MIL",
  },
  "09321": {
    DMA: "MIL",
  },
  "09322": {
    DMA: "MIL",
  },
  "09323": {
    DMA: "MIL",
  },
  "09324": {
    DMA: "MIL",
  },
  "09327": {
    DMA: "MIL",
  },
  "09328": {
    DMA: "MIL",
  },
  "09330": {
    DMA: "MIL",
  },
  "09331": {
    DMA: "MIL",
  },
  "09332": {
    DMA: "MIL",
  },
  "09333": {
    DMA: "MIL",
  },
  "09334": {
    DMA: "MIL",
  },
  "09336": {
    DMA: "MIL",
  },
  "09337": {
    DMA: "MIL",
  },
  "09338": {
    DMA: "MIL",
  },
  "09339": {
    DMA: "MIL",
  },
  "09340": {
    DMA: "MIL",
  },
  "09342": {
    DMA: "MIL",
  },
  "09343": {
    DMA: "MIL",
  },
  "09344": {
    DMA: "MIL",
  },
  "09346": {
    DMA: "MIL",
  },
  "09347": {
    DMA: "MIL",
  },
  "09348": {
    DMA: "MIL",
  },
  "09350": {
    DMA: "MIL",
  },
  "09351": {
    DMA: "MIL",
  },
  "09352": {
    DMA: "MIL",
  },
  "09353": {
    DMA: "MIL",
  },
  "09354": {
    DMA: "MIL",
  },
  "09355": {
    DMA: "MIL",
  },
  "09356": {
    DMA: "MIL",
  },
  "09357": {
    DMA: "MIL",
  },
  "09358": {
    DMA: "MIL",
  },
  "09359": {
    DMA: "MIL",
  },
  "09360": {
    DMA: "MIL",
  },
  "09361": {
    DMA: "MIL",
  },
  "09362": {
    DMA: "MIL",
  },
  "09364": {
    DMA: "MIL",
  },
  "09365": {
    DMA: "MIL",
  },
  "09366": {
    DMA: "MIL",
  },
  "09367": {
    DMA: "MIL",
  },
  "09368": {
    DMA: "MIL",
  },
  "09370": {
    DMA: "MIL",
  },
  "09371": {
    DMA: "MIL",
  },
  "09374": {
    DMA: "MIL",
  },
  "09375": {
    DMA: "MIL",
  },
  "09378": {
    DMA: "MIL",
  },
  "09380": {
    DMA: "MIL",
  },
  "09381": {
    DMA: "MIL",
  },
  "09382": {
    DMA: "MIL",
  },
  "09383": {
    DMA: "MIL",
  },
  "09384": {
    DMA: "MIL",
  },
  "09386": {
    DMA: "MIL",
  },
  "09387": {
    DMA: "MIL",
  },
  "09388": {
    DMA: "MIL",
  },
  "09389": {
    DMA: "MIL",
  },
  "09390": {
    DMA: "MIL",
  },
  "09391": {
    DMA: "MIL",
  },
  "09393": {
    DMA: "MIL",
  },
  "09396": {
    DMA: "MIL",
  },
  "09397": {
    DMA: "MIL",
  },
  "09399": {
    DMA: "MIL",
  },
  "09401": {
    DMA: "MIL",
  },
  "09402": {
    DMA: "MIL",
  },
  "09403": {
    DMA: "MIL",
  },
  "09421": {
    DMA: "MIL",
  },
  "09447": {
    DMA: "MIL",
  },
  "09454": {
    DMA: "MIL",
  },
  "09456": {
    DMA: "MIL",
  },
  "09459": {
    DMA: "MIL",
  },
  "09461": {
    DMA: "MIL",
  },
  "09463": {
    DMA: "MIL",
  },
  "09464": {
    DMA: "MIL",
  },
  "09468": {
    DMA: "MIL",
  },
  "09469": {
    DMA: "MIL",
  },
  "09470": {
    DMA: "MIL",
  },
  "09494": {
    DMA: "MIL",
  },
  "09496": {
    DMA: "MIL",
  },
  "09497": {
    DMA: "MIL",
  },
  "09533": {
    DMA: "MIL",
  },
  "09541": {
    DMA: "MIL",
  },
  "09542": {
    DMA: "MIL",
  },
  "09544": {
    DMA: "MIL",
  },
  "09545": {
    DMA: "MIL",
  },
  "09600": {
    DMA: "MIL",
  },
  "09602": {
    DMA: "MIL",
  },
  "09603": {
    DMA: "MIL",
  },
  "09604": {
    DMA: "MIL",
  },
  "09605": {
    DMA: "MIL",
  },
  "09606": {
    DMA: "MIL",
  },
  "09610": {
    DMA: "MIL",
  },
  "09611": {
    DMA: "MIL",
  },
  "09613": {
    DMA: "MIL",
  },
  "09630": {
    DMA: "MIL",
  },
  "09633": {
    DMA: "MIL",
  },
  "09634": {
    DMA: "MIL",
  },
  "09643": {
    DMA: "MIL",
  },
  "09647": {
    DMA: "MIL",
  },
  "09702": {
    DMA: "MIL",
  },
  "09703": {
    DMA: "MIL",
  },
  "09704": {
    DMA: "MIL",
  },
  "09705": {
    DMA: "MIL",
  },
  "09706": {
    DMA: "MIL",
  },
  "09708": {
    DMA: "MIL",
  },
  "09711": {
    DMA: "MIL",
  },
  "09713": {
    DMA: "MIL",
  },
  "09714": {
    DMA: "MIL",
  },
  "09717": {
    DMA: "MIL",
  },
  "09719": {
    DMA: "MIL",
  },
  "09720": {
    DMA: "MIL",
  },
  "09722": {
    DMA: "MIL",
  },
  "09724": {
    DMA: "MIL",
  },
  "09725": {
    DMA: "MIL",
  },
  "09732": {
    DMA: "MIL",
  },
  "09735": {
    DMA: "MIL",
  },
  "09740": {
    DMA: "MIL",
  },
  "09743": {
    DMA: "MIL",
  },
  "09745": {
    DMA: "MIL",
  },
  "09746": {
    DMA: "MIL",
  },
  "09749": {
    DMA: "MIL",
  },
  "09751": {
    DMA: "MIL",
  },
  "09752": {
    DMA: "MIL",
  },
  "09753": {
    DMA: "MIL",
  },
  "09754": {
    DMA: "MIL",
  },
  "09755": {
    DMA: "MIL",
  },
  "09756": {
    DMA: "MIL",
  },
  "09757": {
    DMA: "MIL",
  },
  "09758": {
    DMA: "MIL",
  },
  "09760": {
    DMA: "MIL",
  },
  "09771": {
    DMA: "MIL",
  },
  "09780": {
    DMA: "MIL",
  },
  "09789": {
    DMA: "MIL",
  },
  "09790": {
    DMA: "MIL",
  },
  "09798": {
    DMA: "MIL",
  },
  "09800": {
    DMA: "MIL",
  },
  "09801": {
    DMA: "MIL",
  },
  "09803": {
    DMA: "MIL",
  },
  "09804": {
    DMA: "MIL",
  },
  "09807": {
    DMA: "MIL",
  },
  "09810": {
    DMA: "MIL",
  },
  "09815": {
    DMA: "MIL",
  },
  "09818": {
    DMA: "MIL",
  },
  "09819": {
    DMA: "MIL",
  },
  "09821": {
    DMA: "MIL",
  },
  "09822": {
    DMA: "MIL",
  },
  "09824": {
    DMA: "MIL",
  },
  "09829": {
    DMA: "MIL",
  },
  "09832": {
    DMA: "MIL",
  },
  "09833": {
    DMA: "MIL",
  },
  "09835": {
    DMA: "MIL",
  },
  "09839": {
    DMA: "MIL",
  },
  "09843": {
    DMA: "MIL",
  },
  "09848": {
    DMA: "MIL",
  },
  "09851": {
    DMA: "MIL",
  },
  "09852": {
    DMA: "MIL",
  },
  "09853": {
    DMA: "MIL",
  },
  "09855": {
    DMA: "MIL",
  },
  "09858": {
    DMA: "MIL",
  },
  "09861": {
    DMA: "MIL",
  },
  "09863": {
    DMA: "MIL",
  },
  "09868": {
    DMA: "MIL",
  },
  "09876": {
    DMA: "MIL",
  },
  "09877": {
    DMA: "MIL",
  },
  "09888": {
    DMA: "MIL",
  },
  "09890": {
    DMA: "MIL",
  },
  "09898": {
    DMA: "MIL",
  },
  "09901": {
    DMA: "MIL",
  },
  "09903": {
    DMA: "MIL",
  },
  "09904": {
    DMA: "MIL",
  },
  "09908": {
    DMA: "MIL",
  },
  "09909": {
    DMA: "MIL",
  },
  "09910": {
    DMA: "MIL",
  },
  "09160": {
    DMA: "MIL",
  },
  "09170": {
    DMA: "MIL",
  },
  "09171": {
    DMA: "MIL",
  },
  "09174": {
    DMA: "MIL",
  },
  "09175": {
    DMA: "MIL",
  },
  "09176": {
    DMA: "MIL",
  },
  "09178": {
    DMA: "MIL",
  },
  "09203": {
    DMA: "MIL",
  },
  "09213": {
    DMA: "MIL",
  },
  "09265": {
    DMA: "MIL",
  },
  "09276": {
    DMA: "MIL",
  },
  "09277": {
    DMA: "MIL",
  },
  "09278": {
    DMA: "MIL",
  },
  "09279": {
    DMA: "MIL",
  },
  "09280": {
    DMA: "MIL",
  },
  "09283": {
    DMA: "MIL",
  },
  "09285": {
    DMA: "MIL",
  },
  "09287": {
    DMA: "MIL",
  },
  "09289": {
    DMA: "MIL",
  },
  "09290": {
    DMA: "MIL",
  },
  "09291": {
    DMA: "MIL",
  },
  "09292": {
    DMA: "MIL",
  },
  "09301": {
    DMA: "MIL",
  },
  "09310": {
    DMA: "MIL",
  },
  "09311": {
    DMA: "MIL",
  },
  "09312": {
    DMA: "MIL",
  },
  "09467": {
    DMA: "MIL",
  },
  "09487": {
    DMA: "MIL",
  },
  "09488": {
    DMA: "MIL",
  },
  "09489": {
    DMA: "MIL",
  },
  "09490": {
    DMA: "MIL",
  },
  "09491": {
    DMA: "MIL",
  },
  "09498": {
    DMA: "MIL",
  },
  "09601": {
    DMA: "MIL",
  },
  "09614": {
    DMA: "MIL",
  },
  "09624": {
    DMA: "MIL",
  },
  "09642": {
    DMA: "MIL",
  },
  "09701": {
    DMA: "MIL",
  },
  "09707": {
    DMA: "MIL",
  },
  "09709": {
    DMA: "MIL",
  },
  "09710": {
    DMA: "MIL",
  },
  "09715": {
    DMA: "MIL",
  },
  "09716": {
    DMA: "MIL",
  },
  "09718": {
    DMA: "MIL",
  },
  "09721": {
    DMA: "MIL",
  },
  "09723": {
    DMA: "MIL",
  },
  "09726": {
    DMA: "MIL",
  },
  "09727": {
    DMA: "MIL",
  },
  "09728": {
    DMA: "MIL",
  },
  "09730": {
    DMA: "MIL",
  },
  "09731": {
    DMA: "MIL",
  },
  "09734": {
    DMA: "MIL",
  },
  "09736": {
    DMA: "MIL",
  },
  "09737": {
    DMA: "MIL",
  },
  "09738": {
    DMA: "MIL",
  },
  "09739": {
    DMA: "MIL",
  },
  "09741": {
    DMA: "MIL",
  },
  "09742": {
    DMA: "MIL",
  },
  "09744": {
    DMA: "MIL",
  },
  "09748": {
    DMA: "MIL",
  },
  "09750": {
    DMA: "MIL",
  },
  "09759": {
    DMA: "MIL",
  },
  "09762": {
    DMA: "MIL",
  },
  "09769": {
    DMA: "MIL",
  },
  "09777": {
    DMA: "MIL",
  },
  "09802": {
    DMA: "MIL",
  },
  "09806": {
    DMA: "MIL",
  },
  "09808": {
    DMA: "MIL",
  },
  "09809": {
    DMA: "MIL",
  },
  "09811": {
    DMA: "MIL",
  },
  "09812": {
    DMA: "MIL",
  },
  "09813": {
    DMA: "MIL",
  },
  "09814": {
    DMA: "MIL",
  },
  "09816": {
    DMA: "MIL",
  },
  "09817": {
    DMA: "MIL",
  },
  "09820": {
    DMA: "MIL",
  },
  "09823": {
    DMA: "MIL",
  },
  "09825": {
    DMA: "MIL",
  },
  "09826": {
    DMA: "MIL",
  },
  "09827": {
    DMA: "MIL",
  },
  "09828": {
    DMA: "MIL",
  },
  "09830": {
    DMA: "MIL",
  },
  "09831": {
    DMA: "MIL",
  },
  "09836": {
    DMA: "MIL",
  },
  "09842": {
    DMA: "MIL",
  },
  "09844": {
    DMA: "MIL",
  },
  "09845": {
    DMA: "MIL",
  },
  "09846": {
    DMA: "MIL",
  },
  "09847": {
    DMA: "MIL",
  },
  "09854": {
    DMA: "MIL",
  },
  "09856": {
    DMA: "MIL",
  },
  "09857": {
    DMA: "MIL",
  },
  "09860": {
    DMA: "MIL",
  },
  "09862": {
    DMA: "MIL",
  },
  "09864": {
    DMA: "MIL",
  },
  "09867": {
    DMA: "MIL",
  },
  "09869": {
    DMA: "MIL",
  },
  "09870": {
    DMA: "MIL",
  },
  "09871": {
    DMA: "MIL",
  },
  "09872": {
    DMA: "MIL",
  },
  "09873": {
    DMA: "MIL",
  },
  "09874": {
    DMA: "MIL",
  },
  "09875": {
    DMA: "MIL",
  },
  "09880": {
    DMA: "MIL",
  },
  "09892": {
    DMA: "MIL",
  },
  "09895": {
    DMA: "MIL",
  },
  "09974": {
    DMA: "MIL",
  },
  "09975": {
    DMA: "MIL",
  },
  "09976": {
    DMA: "MIL",
  },
  "09977": {
    DMA: "MIL",
  },
  "09978": {
    DMA: "MIL",
  },
  "09204": {
    DMA: "MIL",
  },
  "09216": {
    DMA: "MIL",
  },
  "09241": {
    DMA: "MIL",
  },
  "09266": {
    DMA: "MIL",
  },
  "09313": {
    DMA: "MIL",
  },
  "09363": {
    DMA: "MIL",
  },
  "09369": {
    DMA: "MIL",
  },
  "09372": {
    DMA: "MIL",
  },
  "09373": {
    DMA: "MIL",
  },
  "09376": {
    DMA: "MIL",
  },
  "09377": {
    DMA: "MIL",
  },
  "09379": {
    DMA: "MIL",
  },
  "09394": {
    DMA: "MIL",
  },
  "09409": {
    DMA: "MIL",
  },
  "09410": {
    DMA: "MIL",
  },
  "09420": {
    DMA: "MIL",
  },
  "09499": {
    DMA: "MIL",
  },
  "09501": {
    DMA: "MIL",
  },
  "09502": {
    DMA: "MIL",
  },
  "09503": {
    DMA: "MIL",
  },
  "09504": {
    DMA: "MIL",
  },
  "09505": {
    DMA: "MIL",
  },
  "09506": {
    DMA: "MIL",
  },
  "09507": {
    DMA: "MIL",
  },
  "09508": {
    DMA: "MIL",
  },
  "09509": {
    DMA: "MIL",
  },
  "09510": {
    DMA: "MIL",
  },
  "09511": {
    DMA: "MIL",
  },
  "09512": {
    DMA: "MIL",
  },
  "09513": {
    DMA: "MIL",
  },
  "09514": {
    DMA: "MIL",
  },
  "09516": {
    DMA: "MIL",
  },
  "09517": {
    DMA: "MIL",
  },
  "09520": {
    DMA: "MIL",
  },
  "09522": {
    DMA: "MIL",
  },
  "09523": {
    DMA: "MIL",
  },
  "09524": {
    DMA: "MIL",
  },
  "09532": {
    DMA: "MIL",
  },
  "09534": {
    DMA: "MIL",
  },
  "09543": {
    DMA: "MIL",
  },
  "09549": {
    DMA: "MIL",
  },
  "09550": {
    DMA: "MIL",
  },
  "09554": {
    DMA: "MIL",
  },
  "09556": {
    DMA: "MIL",
  },
  "09557": {
    DMA: "MIL",
  },
  "09564": {
    DMA: "MIL",
  },
  "09565": {
    DMA: "MIL",
  },
  "09566": {
    DMA: "MIL",
  },
  "09567": {
    DMA: "MIL",
  },
  "09568": {
    DMA: "MIL",
  },
  "09569": {
    DMA: "MIL",
  },
  "09570": {
    DMA: "MIL",
  },
  "09573": {
    DMA: "MIL",
  },
  "09574": {
    DMA: "MIL",
  },
  "09575": {
    DMA: "MIL",
  },
  "09576": {
    DMA: "MIL",
  },
  "09577": {
    DMA: "MIL",
  },
  "09578": {
    DMA: "MIL",
  },
  "09579": {
    DMA: "MIL",
  },
  "09581": {
    DMA: "MIL",
  },
  "09582": {
    DMA: "MIL",
  },
  "09583": {
    DMA: "MIL",
  },
  "09586": {
    DMA: "MIL",
  },
  "09587": {
    DMA: "MIL",
  },
  "09588": {
    DMA: "MIL",
  },
  "09589": {
    DMA: "MIL",
  },
  "09590": {
    DMA: "MIL",
  },
  "09591": {
    DMA: "MIL",
  },
  "09592": {
    DMA: "MIL",
  },
  "09593": {
    DMA: "MIL",
  },
  "09594": {
    DMA: "MIL",
  },
  "09595": {
    DMA: "MIL",
  },
  "09596": {
    DMA: "MIL",
  },
  "09599": {
    DMA: "MIL",
  },
  "09607": {
    DMA: "MIL",
  },
  "09608": {
    DMA: "MIL",
  },
  "09609": {
    DMA: "MIL",
  },
  "09612": {
    DMA: "MIL",
  },
  "09617": {
    DMA: "MIL",
  },
  "09618": {
    DMA: "MIL",
  },
  "09619": {
    DMA: "MIL",
  },
  "09620": {
    DMA: "MIL",
  },
  "09621": {
    DMA: "MIL",
  },
  "09622": {
    DMA: "MIL",
  },
  "09623": {
    DMA: "MIL",
  },
  "09625": {
    DMA: "MIL",
  },
  "09626": {
    DMA: "MIL",
  },
  "09627": {
    DMA: "MIL",
  },
  "09631": {
    DMA: "MIL",
  },
  "09636": {
    DMA: "MIL",
  },
  "09644": {
    DMA: "MIL",
  },
  "09645": {
    DMA: "MIL",
  },
  "09648": {
    DMA: "MIL",
  },
  "09649": {
    DMA: "MIL",
  },
  "09712": {
    DMA: "MIL",
  },
  "09729": {
    DMA: "MIL",
  },
  "09733": {
    DMA: "MIL",
  },
  "09747": {
    DMA: "MIL",
  },
  "09761": {
    DMA: "MIL",
  },
  "09805": {
    DMA: "MIL",
  },
  "09834": {
    DMA: "MIL",
  },
  "09837": {
    DMA: "MIL",
  },
  "09838": {
    DMA: "MIL",
  },
  "09840": {
    DMA: "MIL",
  },
  "09841": {
    DMA: "MIL",
  },
  "09859": {
    DMA: "MIL",
  },
  "09865": {
    DMA: "MIL",
  },
  "09902": {
    DMA: "MIL",
  },
  "06801": {
    DMA: "CT2",
  },
  "06404": {
    DMA: "CT2",
  },
  "06601": {
    DMA: "CT2",
  },
  "06602": {
    DMA: "CT2",
  },
  "06604": {
    DMA: "CT2",
  },
  "06605": {
    DMA: "CT2",
  },
  "06606": {
    DMA: "CT2",
  },
  "06607": {
    DMA: "CT2",
  },
  "06608": {
    DMA: "CT2",
  },
  "06610": {
    DMA: "CT2",
  },
  "06650": {
    DMA: "CT2",
  },
  "06673": {
    DMA: "CT2",
  },
  "06699": {
    DMA: "CT2",
  },
  "06804": {
    DMA: "CT2",
  },
  "06807": {
    DMA: "CT2",
  },
  "06810": {
    DMA: "CT2",
  },
  "06811": {
    DMA: "CT2",
  },
  "06813": {
    DMA: "CT2",
  },
  "06814": {
    DMA: "CT2",
  },
  "06816": {
    DMA: "CT2",
  },
  "06817": {
    DMA: "CT2",
  },
  "06820": {
    DMA: "CT2",
  },
  "06612": {
    DMA: "CT2",
  },
  "06824": {
    DMA: "CT2",
  },
  "06825": {
    DMA: "CT2",
  },
  "06828": {
    DMA: "CT2",
  },
  "06829": {
    DMA: "CT2",
  },
  "06838": {
    DMA: "CT2",
  },
  "06830": {
    DMA: "CT2",
  },
  "06831": {
    DMA: "CT2",
  },
  "06832": {
    DMA: "CT2",
  },
  "06836": {
    DMA: "CT2",
  },
  "06440": {
    DMA: "CT2",
  },
  "06468": {
    DMA: "CT2",
  },
  "06840": {
    DMA: "CT2",
  },
  "06842": {
    DMA: "CT2",
  },
  "06812": {
    DMA: "CT2",
  },
  "06470": {
    DMA: "CT2",
  },
  "06850": {
    DMA: "CT2",
  },
  "06851": {
    DMA: "CT2",
  },
  "06852": {
    DMA: "CT2",
  },
  "06853": {
    DMA: "CT2",
  },
  "06854": {
    DMA: "CT2",
  },
  "06855": {
    DMA: "CT2",
  },
  "06856": {
    DMA: "CT2",
  },
  "06857": {
    DMA: "CT2",
  },
  "06858": {
    DMA: "CT2",
  },
  "06859": {
    DMA: "CT2",
  },
  "06860": {
    DMA: "CT2",
  },
  "06870": {
    DMA: "CT2",
  },
  "06896": {
    DMA: "CT2",
  },
  "06875": {
    DMA: "CT2",
  },
  "06876": {
    DMA: "CT2",
  },
  "06877": {
    DMA: "CT2",
  },
  "06879": {
    DMA: "CT2",
  },
  "06878": {
    DMA: "CT2",
  },
  "06482": {
    DMA: "CT2",
  },
  "06484": {
    DMA: "CT2",
  },
  "06784": {
    DMA: "CT2",
  },
  "06890": {
    DMA: "CT2",
  },
  "06901": {
    DMA: "CT2",
  },
  "06902": {
    DMA: "CT2",
  },
  "06903": {
    DMA: "CT2",
  },
  "06904": {
    DMA: "CT2",
  },
  "06905": {
    DMA: "CT2",
  },
  "06906": {
    DMA: "CT2",
  },
  "06907": {
    DMA: "CT2",
  },
  "06910": {
    DMA: "CT2",
  },
  "06911": {
    DMA: "CT2",
  },
  "06912": {
    DMA: "CT2",
  },
  "06913": {
    DMA: "CT2",
  },
  "06914": {
    DMA: "CT2",
  },
  "06920": {
    DMA: "CT2",
  },
  "06921": {
    DMA: "CT2",
  },
  "06922": {
    DMA: "CT2",
  },
  "06925": {
    DMA: "CT2",
  },
  "06926": {
    DMA: "CT2",
  },
  "06927": {
    DMA: "CT2",
  },
  "06928": {
    DMA: "CT2",
  },
  "06491": {
    DMA: "CT2",
  },
  "06497": {
    DMA: "CT2",
  },
  "06614": {
    DMA: "CT2",
  },
  "06615": {
    DMA: "CT2",
  },
  "06611": {
    DMA: "CT2",
  },
  "06883": {
    DMA: "CT2",
  },
  "06880": {
    DMA: "CT2",
  },
  "06881": {
    DMA: "CT2",
  },
  "06888": {
    DMA: "CT2",
  },
  "06889": {
    DMA: "CT2",
  },
  "06897": {
    DMA: "CT2",
  },
  "06001": {
    DMA: "CT2",
  },
  "06037": {
    DMA: "CT2",
  },
  "06002": {
    DMA: "CT2",
  },
  "06010": {
    DMA: "CT2",
  },
  "06011": {
    DMA: "CT2",
  },
  "06016": {
    DMA: "CT2",
  },
  "06013": {
    DMA: "CT2",
  },
  "06019": {
    DMA: "CT2",
  },
  "06020": {
    DMA: "CT2",
  },
  "06022": {
    DMA: "CT2",
  },
  "06023": {
    DMA: "CT2",
  },
  "06025": {
    DMA: "CT2",
  },
  "06026": {
    DMA: "CT2",
  },
  "06108": {
    DMA: "CT2",
  },
  "06118": {
    DMA: "CT2",
  },
  "06128": {
    DMA: "CT2",
  },
  "06138": {
    DMA: "CT2",
  },
  "06027": {
    DMA: "CT2",
  },
  "06088": {
    DMA: "CT2",
  },
  "06028": {
    DMA: "CT2",
  },
  "06082": {
    DMA: "CT2",
  },
  "06083": {
    DMA: "CT2",
  },
  "06030": {
    DMA: "CT2",
  },
  "06032": {
    DMA: "CT2",
  },
  "06034": {
    DMA: "CT2",
  },
  "06033": {
    DMA: "CT2",
  },
  "06035": {
    DMA: "CT2",
  },
  "06101": {
    DMA: "CT2",
  },
  "06102": {
    DMA: "CT2",
  },
  "06103": {
    DMA: "CT2",
  },
  "06104": {
    DMA: "CT2",
  },
  "06105": {
    DMA: "CT2",
  },
  "06106": {
    DMA: "CT2",
  },
  "06112": {
    DMA: "CT2",
  },
  "06114": {
    DMA: "CT2",
  },
  "06115": {
    DMA: "CT2",
  },
  "06120": {
    DMA: "CT2",
  },
  "06123": {
    DMA: "CT2",
  },
  "06126": {
    DMA: "CT2",
  },
  "06132": {
    DMA: "CT2",
  },
  "06134": {
    DMA: "CT2",
  },
  "06140": {
    DMA: "CT2",
  },
  "06141": {
    DMA: "CT2",
  },
  "06142": {
    DMA: "CT2",
  },
  "06143": {
    DMA: "CT2",
  },
  "06144": {
    DMA: "CT2",
  },
  "06145": {
    DMA: "CT2",
  },
  "06146": {
    DMA: "CT2",
  },
  "06147": {
    DMA: "CT2",
  },
  "06150": {
    DMA: "CT2",
  },
  "06151": {
    DMA: "CT2",
  },
  "06152": {
    DMA: "CT2",
  },
  "06153": {
    DMA: "CT2",
  },
  "06154": {
    DMA: "CT2",
  },
  "06155": {
    DMA: "CT2",
  },
  "06156": {
    DMA: "CT2",
  },
  "06160": {
    DMA: "CT2",
  },
  "06161": {
    DMA: "CT2",
  },
  "06167": {
    DMA: "CT2",
  },
  "06176": {
    DMA: "CT2",
  },
  "06180": {
    DMA: "CT2",
  },
  "06183": {
    DMA: "CT2",
  },
  "06199": {
    DMA: "CT2",
  },
  "06040": {
    DMA: "CT2",
  },
  "06041": {
    DMA: "CT2",
  },
  "06042": {
    DMA: "CT2",
  },
  "06045": {
    DMA: "CT2",
  },
  "06444": {
    DMA: "CT2",
  },
  "06447": {
    DMA: "CT2",
  },
  "06467": {
    DMA: "CT2",
  },
  "06050": {
    DMA: "CT2",
  },
  "06051": {
    DMA: "CT2",
  },
  "06052": {
    DMA: "CT2",
  },
  "06053": {
    DMA: "CT2",
  },
  "06111": {
    DMA: "CT2",
  },
  "06131": {
    DMA: "CT2",
  },
  "06059": {
    DMA: "CT2",
  },
  "06060": {
    DMA: "CT2",
  },
  "06062": {
    DMA: "CT2",
  },
  "06479": {
    DMA: "CT2",
  },
  "06064": {
    DMA: "CT2",
  },
  "06065": {
    DMA: "CT2",
  },
  "06067": {
    DMA: "CT2",
  },
  "06070": {
    DMA: "CT2",
  },
  "06073": {
    DMA: "CT2",
  },
  "06074": {
    DMA: "CT2",
  },
  "06489": {
    DMA: "CT2",
  },
  "06078": {
    DMA: "CT2",
  },
  "06080": {
    DMA: "CT2",
  },
  "06081": {
    DMA: "CT2",
  },
  "06085": {
    DMA: "CT2",
  },
  "06087": {
    DMA: "CT2",
  },
  "06089": {
    DMA: "CT2",
  },
  "06090": {
    DMA: "CT2",
  },
  "06107": {
    DMA: "CT2",
  },
  "06110": {
    DMA: "CT2",
  },
  "06117": {
    DMA: "CT2",
  },
  "06119": {
    DMA: "CT2",
  },
  "06127": {
    DMA: "CT2",
  },
  "06133": {
    DMA: "CT2",
  },
  "06137": {
    DMA: "CT2",
  },
  "06091": {
    DMA: "CT2",
  },
  "06092": {
    DMA: "CT2",
  },
  "06093": {
    DMA: "CT2",
  },
  "06109": {
    DMA: "CT2",
  },
  "06129": {
    DMA: "CT2",
  },
  "06006": {
    DMA: "CT2",
  },
  "06095": {
    DMA: "CT2",
  },
  "06096": {
    DMA: "CT2",
  },
  "06750": {
    DMA: "CT2",
  },
  "06063": {
    DMA: "CT2",
  },
  "06751": {
    DMA: "CT2",
  },
  "06752": {
    DMA: "CT2",
  },
  "06018": {
    DMA: "CT2",
  },
  "06021": {
    DMA: "CT2",
  },
  "06753": {
    DMA: "CT2",
  },
  "06754": {
    DMA: "CT2",
  },
  "06024": {
    DMA: "CT2",
  },
  "06031": {
    DMA: "CT2",
  },
  "06755": {
    DMA: "CT2",
  },
  "06756": {
    DMA: "CT2",
  },
  "06791": {
    DMA: "CT2",
  },
  "06757": {
    DMA: "CT2",
  },
  "06758": {
    DMA: "CT2",
  },
  "06039": {
    DMA: "CT2",
  },
  "06759": {
    DMA: "CT2",
  },
  "06763": {
    DMA: "CT2",
  },
  "06057": {
    DMA: "CT2",
  },
  "06776": {
    DMA: "CT2",
  },
  "06777": {
    DMA: "CT2",
  },
  "06058": {
    DMA: "CT2",
  },
  "06778": {
    DMA: "CT2",
  },
  "06779": {
    DMA: "CT2",
  },
  "06781": {
    DMA: "CT2",
  },
  "06061": {
    DMA: "CT2",
  },
  "06782": {
    DMA: "CT2",
  },
  "06783": {
    DMA: "CT2",
  },
  "06068": {
    DMA: "CT2",
  },
  "06069": {
    DMA: "CT2",
  },
  "06785": {
    DMA: "CT2",
  },
  "06079": {
    DMA: "CT2",
  },
  "06786": {
    DMA: "CT2",
  },
  "06787": {
    DMA: "CT2",
  },
  "06790": {
    DMA: "CT2",
  },
  "06792": {
    DMA: "CT2",
  },
  "06793": {
    DMA: "CT2",
  },
  "06794": {
    DMA: "CT2",
  },
  "06795": {
    DMA: "CT2",
  },
  "06796": {
    DMA: "CT2",
  },
  "06094": {
    DMA: "CT2",
  },
  "06098": {
    DMA: "CT2",
  },
  "06798": {
    DMA: "CT2",
  },
  "06409": {
    DMA: "CT2",
  },
  "06412": {
    DMA: "CT2",
  },
  "06413": {
    DMA: "CT2",
  },
  "06414": {
    DMA: "CT2",
  },
  "06416": {
    DMA: "CT2",
  },
  "06417": {
    DMA: "CT2",
  },
  "06422": {
    DMA: "CT2",
  },
  "06423": {
    DMA: "CT2",
  },
  "06424": {
    DMA: "CT2",
  },
  "06426": {
    DMA: "CT2",
  },
  "06438": {
    DMA: "CT2",
  },
  "06441": {
    DMA: "CT2",
  },
  "06442": {
    DMA: "CT2",
  },
  "06419": {
    DMA: "CT2",
  },
  "06456": {
    DMA: "CT2",
  },
  "06455": {
    DMA: "CT2",
  },
  "06457": {
    DMA: "CT2",
  },
  "06459": {
    DMA: "CT2",
  },
  "06469": {
    DMA: "CT2",
  },
  "06475": {
    DMA: "CT2",
  },
  "06480": {
    DMA: "CT2",
  },
  "06481": {
    DMA: "CT2",
  },
  "06498": {
    DMA: "CT2",
  },
  "06401": {
    DMA: "CT2",
  },
  "06403": {
    DMA: "CT2",
  },
  "06524": {
    DMA: "CT2",
  },
  "06405": {
    DMA: "CT2",
  },
  "06408": {
    DMA: "CT2",
  },
  "06410": {
    DMA: "CT2",
  },
  "06411": {
    DMA: "CT2",
  },
  "06418": {
    DMA: "CT2",
  },
  "06512": {
    DMA: "CT2",
  },
  "06437": {
    DMA: "CT2",
  },
  "06514": {
    DMA: "CT2",
  },
  "06517": {
    DMA: "CT2",
  },
  "06518": {
    DMA: "CT2",
  },
  "06443": {
    DMA: "CT2",
  },
  "06450": {
    DMA: "CT2",
  },
  "06451": {
    DMA: "CT2",
  },
  "06454": {
    DMA: "CT2",
  },
  "06762": {
    DMA: "CT2",
  },
  "06460": {
    DMA: "CT2",
  },
  "06461": {
    DMA: "CT2",
  },
  "06770": {
    DMA: "CT2",
  },
  "06501": {
    DMA: "CT2",
  },
  "06502": {
    DMA: "CT2",
  },
  "06503": {
    DMA: "CT2",
  },
  "06504": {
    DMA: "CT2",
  },
  "06505": {
    DMA: "CT2",
  },
  "06506": {
    DMA: "CT2",
  },
  "06507": {
    DMA: "CT2",
  },
  "06508": {
    DMA: "CT2",
  },
  "06509": {
    DMA: "CT2",
  },
  "06510": {
    DMA: "CT2",
  },
  "06511": {
    DMA: "CT2",
  },
  "06513": {
    DMA: "CT2",
  },
  "06515": {
    DMA: "CT2",
  },
  "06519": {
    DMA: "CT2",
  },
  "06520": {
    DMA: "CT2",
  },
  "06521": {
    DMA: "CT2",
  },
  "06530": {
    DMA: "CT2",
  },
  "06531": {
    DMA: "CT2",
  },
  "06532": {
    DMA: "CT2",
  },
  "06533": {
    DMA: "CT2",
  },
  "06534": {
    DMA: "CT2",
  },
  "06535": {
    DMA: "CT2",
  },
  "06536": {
    DMA: "CT2",
  },
  "06537": {
    DMA: "CT2",
  },
  "06538": {
    DMA: "CT2",
  },
  "06540": {
    DMA: "CT2",
  },
  "06471": {
    DMA: "CT2",
  },
  "06473": {
    DMA: "CT2",
  },
  "06472": {
    DMA: "CT2",
  },
  "06477": {
    DMA: "CT2",
  },
  "06478": {
    DMA: "CT2",
  },
  "06712": {
    DMA: "CT2",
  },
  "06483": {
    DMA: "CT2",
  },
  "06487": {
    DMA: "CT2",
  },
  "06488": {
    DMA: "CT2",
  },
  "06492": {
    DMA: "CT2",
  },
  "06493": {
    DMA: "CT2",
  },
  "06494": {
    DMA: "CT2",
  },
  "06495": {
    DMA: "CT2",
  },
  "06701": {
    DMA: "CT2",
  },
  "06702": {
    DMA: "CT2",
  },
  "06703": {
    DMA: "CT2",
  },
  "06704": {
    DMA: "CT2",
  },
  "06705": {
    DMA: "CT2",
  },
  "06706": {
    DMA: "CT2",
  },
  "06708": {
    DMA: "CT2",
  },
  "06710": {
    DMA: "CT2",
  },
  "06720": {
    DMA: "CT2",
  },
  "06721": {
    DMA: "CT2",
  },
  "06722": {
    DMA: "CT2",
  },
  "06723": {
    DMA: "CT2",
  },
  "06724": {
    DMA: "CT2",
  },
  "06725": {
    DMA: "CT2",
  },
  "06726": {
    DMA: "CT2",
  },
  "06749": {
    DMA: "CT2",
  },
  "06516": {
    DMA: "CT2",
  },
  "06716": {
    DMA: "CT2",
  },
  "06525": {
    DMA: "CT2",
  },
  "06330": {
    DMA: "CT2",
  },
  "06334": {
    DMA: "CT2",
  },
  "06415": {
    DMA: "CT2",
  },
  "06333": {
    DMA: "CT2",
  },
  "06335": {
    DMA: "CT2",
  },
  "06336": {
    DMA: "CT2",
  },
  "06340": {
    DMA: "CT2",
  },
  "06349": {
    DMA: "CT2",
  },
  "06439": {
    DMA: "CT2",
  },
  "06350": {
    DMA: "CT2",
  },
  "06351": {
    DMA: "CT2",
  },
  "06249": {
    DMA: "CT2",
  },
  "06339": {
    DMA: "CT2",
  },
  "06338": {
    DMA: "CT2",
  },
  "06353": {
    DMA: "CT2",
  },
  "06355": {
    DMA: "CT2",
  },
  "06320": {
    DMA: "CT2",
  },
  "06357": {
    DMA: "CT2",
  },
  "06254": {
    DMA: "CT2",
  },
  "06359": {
    DMA: "CT2",
  },
  "06474": {
    DMA: "CT2",
  },
  "06360": {
    DMA: "CT2",
  },
  "06370": {
    DMA: "CT2",
  },
  "06371": {
    DMA: "CT2",
  },
  "06372": {
    DMA: "CT2",
  },
  "06379": {
    DMA: "CT2",
  },
  "06365": {
    DMA: "CT2",
  },
  "06375": {
    DMA: "CT2",
  },
  "06420": {
    DMA: "CT2",
  },
  "06376": {
    DMA: "CT2",
  },
  "06378": {
    DMA: "CT2",
  },
  "06380": {
    DMA: "CT2",
  },
  "06382": {
    DMA: "CT2",
  },
  "06383": {
    DMA: "CT2",
  },
  "06384": {
    DMA: "CT2",
  },
  "06385": {
    DMA: "CT2",
  },
  "06386": {
    DMA: "CT2",
  },
  "06388": {
    DMA: "CT2",
  },
  "06389": {
    DMA: "CT2",
  },
  "06231": {
    DMA: "CT2",
  },
  "06232": {
    DMA: "CT2",
  },
  "06043": {
    DMA: "CT2",
  },
  "06237": {
    DMA: "CT2",
  },
  "06238": {
    DMA: "CT2",
  },
  "06029": {
    DMA: "CT2",
  },
  "06248": {
    DMA: "CT2",
  },
  "06250": {
    DMA: "CT2",
  },
  "06251": {
    DMA: "CT2",
  },
  "06071": {
    DMA: "CT2",
  },
  "06072": {
    DMA: "CT2",
  },
  "06265": {
    DMA: "CT2",
  },
  "06075": {
    DMA: "CT2",
  },
  "06076": {
    DMA: "CT2",
  },
  "06077": {
    DMA: "CT2",
  },
  "06268": {
    DMA: "CT2",
  },
  "06269": {
    DMA: "CT2",
  },
  "06084": {
    DMA: "CT2",
  },
  "06066": {
    DMA: "CT2",
  },
  "06279": {
    DMA: "CT2",
  },
  "06230": {
    DMA: "CT2",
  },
  "06278": {
    DMA: "CT2",
  },
  "06233": {
    DMA: "CT2",
  },
  "06234": {
    DMA: "CT2",
  },
  "06331": {
    DMA: "CT2",
  },
  "06332": {
    DMA: "CT2",
  },
  "06235": {
    DMA: "CT2",
  },
  "06239": {
    DMA: "CT2",
  },
  "06241": {
    DMA: "CT2",
  },
  "06243": {
    DMA: "CT2",
  },
  "06244": {
    DMA: "CT2",
  },
  "06242": {
    DMA: "CT2",
  },
  "06245": {
    DMA: "CT2",
  },
  "06246": {
    DMA: "CT2",
  },
  "06247": {
    DMA: "CT2",
  },
  "06354": {
    DMA: "CT2",
  },
  "06255": {
    DMA: "CT2",
  },
  "06256": {
    DMA: "CT2",
  },
  "06373": {
    DMA: "CT2",
  },
  "06374": {
    DMA: "CT2",
  },
  "06258": {
    DMA: "CT2",
  },
  "06259": {
    DMA: "CT2",
  },
  "06260": {
    DMA: "CT2",
  },
  "06262": {
    DMA: "CT2",
  },
  "06263": {
    DMA: "CT2",
  },
  "06264": {
    DMA: "CT2",
  },
  "06266": {
    DMA: "CT2",
  },
  "06267": {
    DMA: "CT2",
  },
  "06377": {
    DMA: "CT2",
  },
  "06277": {
    DMA: "CT2",
  },
  "06387": {
    DMA: "CT2",
  },
  "06226": {
    DMA: "CT2",
  },
  "06280": {
    DMA: "CT2",
  },
  "06281": {
    DMA: "CT2",
  },
  "06282": {
    DMA: "CT2",
  },
  "02630": {
    DMA: "MA1",
  },
  "02631": {
    DMA: "MA1",
  },
  "02532": {
    DMA: "MA1",
  },
  "02542": {
    DMA: "MA1",
  },
  "02534": {
    DMA: "MA1",
  },
  "02632": {
    DMA: "MA1",
  },
  "02634": {
    DMA: "MA1",
  },
  "02636": {
    DMA: "MA1",
  },
  "02633": {
    DMA: "MA1",
  },
  "02635": {
    DMA: "MA1",
  },
  "02637": {
    DMA: "MA1",
  },
  "02638": {
    DMA: "MA1",
  },
  "02639": {
    DMA: "MA1",
  },
  "02641": {
    DMA: "MA1",
  },
  "02536": {
    DMA: "MA1",
  },
  "02643": {
    DMA: "MA1",
  },
  "02537": {
    DMA: "MA1",
  },
  "02642": {
    DMA: "MA1",
  },
  "02540": {
    DMA: "MA1",
  },
  "02541": {
    DMA: "MA1",
  },
  "02644": {
    DMA: "MA1",
  },
  "02645": {
    DMA: "MA1",
  },
  "02646": {
    DMA: "MA1",
  },
  "02601": {
    DMA: "MA1",
  },
  "02647": {
    DMA: "MA1",
  },
  "02648": {
    DMA: "MA1",
  },
  "02649": {
    DMA: "MA1",
  },
  "02553": {
    DMA: "MA1",
  },
  "02650": {
    DMA: "MA1",
  },
  "02651": {
    DMA: "MA1",
  },
  "02556": {
    DMA: "MA1",
  },
  "02652": {
    DMA: "MA1",
  },
  "02653": {
    DMA: "MA1",
  },
  "02655": {
    DMA: "MA1",
  },
  "02559": {
    DMA: "MA1",
  },
  "02657": {
    DMA: "MA1",
  },
  "02561": {
    DMA: "MA1",
  },
  "02562": {
    DMA: "MA1",
  },
  "02563": {
    DMA: "MA1",
  },
  "02565": {
    DMA: "MA1",
  },
  "02659": {
    DMA: "MA1",
  },
  "02660": {
    DMA: "MA1",
  },
  "02661": {
    DMA: "MA1",
  },
  "02662": {
    DMA: "MA1",
  },
  "02663": {
    DMA: "MA1",
  },
  "02664": {
    DMA: "MA1",
  },
  "02666": {
    DMA: "MA1",
  },
  "02667": {
    DMA: "MA1",
  },
  "02668": {
    DMA: "MA1",
  },
  "02669": {
    DMA: "MA1",
  },
  "02670": {
    DMA: "MA1",
  },
  "02574": {
    DMA: "MA1",
  },
  "02671": {
    DMA: "MA1",
  },
  "02672": {
    DMA: "MA1",
  },
  "02673": {
    DMA: "MA1",
  },
  "02543": {
    DMA: "MA1",
  },
  "02675": {
    DMA: "MA1",
  },
  "01220": {
    DMA: "MA1",
  },
  "01222": {
    DMA: "MA1",
  },
  "01223": {
    DMA: "MA1",
  },
  "01224": {
    DMA: "MA1",
  },
  "01225": {
    DMA: "MA1",
  },
  "01226": {
    DMA: "MA1",
  },
  "01227": {
    DMA: "MA1",
  },
  "01343": {
    DMA: "MA1",
  },
  "01029": {
    DMA: "MA1",
  },
  "01229": {
    DMA: "MA1",
  },
  "01230": {
    DMA: "MA1",
  },
  "01235": {
    DMA: "MA1",
  },
  "01236": {
    DMA: "MA1",
  },
  "01237": {
    DMA: "MA1",
  },
  "01238": {
    DMA: "MA1",
  },
  "01240": {
    DMA: "MA1",
  },
  "01242": {
    DMA: "MA1",
  },
  "01244": {
    DMA: "MA1",
  },
  "01245": {
    DMA: "MA1",
  },
  "01247": {
    DMA: "MA1",
  },
  "01252": {
    DMA: "MA1",
  },
  "01253": {
    DMA: "MA1",
  },
  "01201": {
    DMA: "MA1",
  },
  "01202": {
    DMA: "MA1",
  },
  "01203": {
    DMA: "MA1",
  },
  "01254": {
    DMA: "MA1",
  },
  "01255": {
    DMA: "MA1",
  },
  "01256": {
    DMA: "MA1",
  },
  "01257": {
    DMA: "MA1",
  },
  "01258": {
    DMA: "MA1",
  },
  "01260": {
    DMA: "MA1",
  },
  "01259": {
    DMA: "MA1",
  },
  "01262": {
    DMA: "MA1",
  },
  "01263": {
    DMA: "MA1",
  },
  "01264": {
    DMA: "MA1",
  },
  "01266": {
    DMA: "MA1",
  },
  "01267": {
    DMA: "MA1",
  },
  "01270": {
    DMA: "MA1",
  },
  "02743": {
    DMA: "MA1",
  },
  "02702": {
    DMA: "MA1",
  },
  "02703": {
    DMA: "MA1",
  },
  "02763": {
    DMA: "MA1",
  },
  "02779": {
    DMA: "MA1",
  },
  "02712": {
    DMA: "MA1",
  },
  "02714": {
    DMA: "MA1",
  },
  "02715": {
    DMA: "MA1",
  },
  "02717": {
    DMA: "MA1",
  },
  "02031": {
    DMA: "MA1",
  },
  "02718": {
    DMA: "MA1",
  },
  "02334": {
    DMA: "MA1",
  },
  "02719": {
    DMA: "MA1",
  },
  "02720": {
    DMA: "MA1",
  },
  "02721": {
    DMA: "MA1",
  },
  "02722": {
    DMA: "MA1",
  },
  "02723": {
    DMA: "MA1",
  },
  "02724": {
    DMA: "MA1",
  },
  "02048": {
    DMA: "MA1",
  },
  "02740": {
    DMA: "MA1",
  },
  "02741": {
    DMA: "MA1",
  },
  "02742": {
    DMA: "MA1",
  },
  "02744": {
    DMA: "MA1",
  },
  "02745": {
    DMA: "MA1",
  },
  "02746": {
    DMA: "MA1",
  },
  "02760": {
    DMA: "MA1",
  },
  "02761": {
    DMA: "MA1",
  },
  "02747": {
    DMA: "MA1",
  },
  "02764": {
    DMA: "MA1",
  },
  "02356": {
    DMA: "MA1",
  },
  "02357": {
    DMA: "MA1",
  },
  "02766": {
    DMA: "MA1",
  },
  "02767": {
    DMA: "MA1",
  },
  "02768": {
    DMA: "MA1",
  },
  "02769": {
    DMA: "MA1",
  },
  "02771": {
    DMA: "MA1",
  },
  "02725": {
    DMA: "MA1",
  },
  "02726": {
    DMA: "MA1",
  },
  "02748": {
    DMA: "MA1",
  },
  "02375": {
    DMA: "MA1",
  },
  "02777": {
    DMA: "MA1",
  },
  "02780": {
    DMA: "MA1",
  },
  "02783": {
    DMA: "MA1",
  },
  "02790": {
    DMA: "MA1",
  },
  "02791": {
    DMA: "MA1",
  },
  "02535": {
    DMA: "MA1",
  },
  "02713": {
    DMA: "MA1",
  },
  "02539": {
    DMA: "MA1",
  },
  "02552": {
    DMA: "MA1",
  },
  "02557": {
    DMA: "MA1",
  },
  "02568": {
    DMA: "MA1",
  },
  "02573": {
    DMA: "MA1",
  },
  "02575": {
    DMA: "MA1",
  },
  "01913": {
    DMA: "MA1",
  },
  "01810": {
    DMA: "MA1",
  },
  "01812": {
    DMA: "MA1",
  },
  "01899": {
    DMA: "MA1",
  },
  "05501": {
    DMA: "MA1",
  },
  "05544": {
    DMA: "MA1",
  },
  "01915": {
    DMA: "MA1",
  },
  "01921": {
    DMA: "MA1",
  },
  "01922": {
    DMA: "MA1",
  },
  "01923": {
    DMA: "MA1",
  },
  "01929": {
    DMA: "MA1",
  },
  "01833": {
    DMA: "MA1",
  },
  "01930": {
    DMA: "MA1",
  },
  "01931": {
    DMA: "MA1",
  },
  "01834": {
    DMA: "MA1",
  },
  "01936": {
    DMA: "MA1",
  },
  "01937": {
    DMA: "MA1",
  },
  "01830": {
    DMA: "MA1",
  },
  "01831": {
    DMA: "MA1",
  },
  "01832": {
    DMA: "MA1",
  },
  "01835": {
    DMA: "MA1",
  },
  "01938": {
    DMA: "MA1",
  },
  "01840": {
    DMA: "MA1",
  },
  "01841": {
    DMA: "MA1",
  },
  "01842": {
    DMA: "MA1",
  },
  "01843": {
    DMA: "MA1",
  },
  "01901": {
    DMA: "MA1",
  },
  "01902": {
    DMA: "MA1",
  },
  "01903": {
    DMA: "MA1",
  },
  "01904": {
    DMA: "MA1",
  },
  "01905": {
    DMA: "MA1",
  },
  "01910": {
    DMA: "MA1",
  },
  "01940": {
    DMA: "MA1",
  },
  "01944": {
    DMA: "MA1",
  },
  "01945": {
    DMA: "MA1",
  },
  "01860": {
    DMA: "MA1",
  },
  "01844": {
    DMA: "MA1",
  },
  "01949": {
    DMA: "MA1",
  },
  "01908": {
    DMA: "MA1",
  },
  "01951": {
    DMA: "MA1",
  },
  "01950": {
    DMA: "MA1",
  },
  "01845": {
    DMA: "MA1",
  },
  "01960": {
    DMA: "MA1",
  },
  "01961": {
    DMA: "MA1",
  },
  "01965": {
    DMA: "MA1",
  },
  "01966": {
    DMA: "MA1",
  },
  "01969": {
    DMA: "MA1",
  },
  "01970": {
    DMA: "MA1",
  },
  "01971": {
    DMA: "MA1",
  },
  "01952": {
    DMA: "MA1",
  },
  "01906": {
    DMA: "MA1",
  },
  "01982": {
    DMA: "MA1",
  },
  "01907": {
    DMA: "MA1",
  },
  "01983": {
    DMA: "MA1",
  },
  "01984": {
    DMA: "MA1",
  },
  "01885": {
    DMA: "MA1",
  },
  "01985": {
    DMA: "MA1",
  },
  "01330": {
    DMA: "MA1",
  },
  "01337": {
    DMA: "MA1",
  },
  "01338": {
    DMA: "MA1",
  },
  "01339": {
    DMA: "MA1",
  },
  "01340": {
    DMA: "MA1",
  },
  "01341": {
    DMA: "MA1",
  },
  "01342": {
    DMA: "MA1",
  },
  "01344": {
    DMA: "MA1",
  },
  "01354": {
    DMA: "MA1",
  },
  "01301": {
    DMA: "MA1",
  },
  "01302": {
    DMA: "MA1",
  },
  "01346": {
    DMA: "MA1",
  },
  "01347": {
    DMA: "MA1",
  },
  "01054": {
    DMA: "MA1",
  },
  "01349": {
    DMA: "MA1",
  },
  "01350": {
    DMA: "MA1",
  },
  "01351": {
    DMA: "MA1",
  },
  "01355": {
    DMA: "MA1",
  },
  "01360": {
    DMA: "MA1",
  },
  "01364": {
    DMA: "MA1",
  },
  "01367": {
    DMA: "MA1",
  },
  "01370": {
    DMA: "MA1",
  },
  "01072": {
    DMA: "MA1",
  },
  "01373": {
    DMA: "MA1",
  },
  "01375": {
    DMA: "MA1",
  },
  "01376": {
    DMA: "MA1",
  },
  "01378": {
    DMA: "MA1",
  },
  "01379": {
    DMA: "MA1",
  },
  "01380": {
    DMA: "MA1",
  },
  "01093": {
    DMA: "MA1",
  },
  "01001": {
    DMA: "MA1",
  },
  "01008": {
    DMA: "MA1",
  },
  "01009": {
    DMA: "MA1",
  },
  "01010": {
    DMA: "MA1",
  },
  "01011": {
    DMA: "MA1",
  },
  "01013": {
    DMA: "MA1",
  },
  "01014": {
    DMA: "MA1",
  },
  "01020": {
    DMA: "MA1",
  },
  "01021": {
    DMA: "MA1",
  },
  "01022": {
    DMA: "MA1",
  },
  "01028": {
    DMA: "MA1",
  },
  "01030": {
    DMA: "MA1",
  },
  "01034": {
    DMA: "MA1",
  },
  "01036": {
    DMA: "MA1",
  },
  "01521": {
    DMA: "MA1",
  },
  "01040": {
    DMA: "MA1",
  },
  "01041": {
    DMA: "MA1",
  },
  "01151": {
    DMA: "MA1",
  },
  "01106": {
    DMA: "MA1",
  },
  "01116": {
    DMA: "MA1",
  },
  "01056": {
    DMA: "MA1",
  },
  "01057": {
    DMA: "MA1",
  },
  "01069": {
    DMA: "MA1",
  },
  "01071": {
    DMA: "MA1",
  },
  "01077": {
    DMA: "MA1",
  },
  "01101": {
    DMA: "MA1",
  },
  "01102": {
    DMA: "MA1",
  },
  "01103": {
    DMA: "MA1",
  },
  "01104": {
    DMA: "MA1",
  },
  "01105": {
    DMA: "MA1",
  },
  "01107": {
    DMA: "MA1",
  },
  "01108": {
    DMA: "MA1",
  },
  "01109": {
    DMA: "MA1",
  },
  "01111": {
    DMA: "MA1",
  },
  "01115": {
    DMA: "MA1",
  },
  "01118": {
    DMA: "MA1",
  },
  "01119": {
    DMA: "MA1",
  },
  "01128": {
    DMA: "MA1",
  },
  "01129": {
    DMA: "MA1",
  },
  "01133": {
    DMA: "MA1",
  },
  "01138": {
    DMA: "MA1",
  },
  "01139": {
    DMA: "MA1",
  },
  "01144": {
    DMA: "MA1",
  },
  "01152": {
    DMA: "MA1",
  },
  "01195": {
    DMA: "MA1",
  },
  "01199": {
    DMA: "MA1",
  },
  "01079": {
    DMA: "MA1",
  },
  "01080": {
    DMA: "MA1",
  },
  "01081": {
    DMA: "MA1",
  },
  "01089": {
    DMA: "MA1",
  },
  "01090": {
    DMA: "MA1",
  },
  "01085": {
    DMA: "MA1",
  },
  "01086": {
    DMA: "MA1",
  },
  "01095": {
    DMA: "MA1",
  },
  "01097": {
    DMA: "MA1",
  },
  "01002": {
    DMA: "MA1",
  },
  "01003": {
    DMA: "MA1",
  },
  "01004": {
    DMA: "MA1",
  },
  "01007": {
    DMA: "MA1",
  },
  "01012": {
    DMA: "MA1",
  },
  "01026": {
    DMA: "MA1",
  },
  "01027": {
    DMA: "MA1",
  },
  "01062": {
    DMA: "MA1",
  },
  "01032": {
    DMA: "MA1",
  },
  "01033": {
    DMA: "MA1",
  },
  "01035": {
    DMA: "MA1",
  },
  "01038": {
    DMA: "MA1",
  },
  "01039": {
    DMA: "MA1",
  },
  "01050": {
    DMA: "MA1",
  },
  "01053": {
    DMA: "MA1",
  },
  "01243": {
    DMA: "MA1",
  },
  "01059": {
    DMA: "MA1",
  },
  "01066": {
    DMA: "MA1",
  },
  "01060": {
    DMA: "MA1",
  },
  "01061": {
    DMA: "MA1",
  },
  "01063": {
    DMA: "MA1",
  },
  "01070": {
    DMA: "MA1",
  },
  "01075": {
    DMA: "MA1",
  },
  "01073": {
    DMA: "MA1",
  },
  "01082": {
    DMA: "MA1",
  },
  "01084": {
    DMA: "MA1",
  },
  "01088": {
    DMA: "MA1",
  },
  "01096": {
    DMA: "MA1",
  },
  "01098": {
    DMA: "MA1",
  },
  "01718": {
    DMA: "MA1",
  },
  "01720": {
    DMA: "MA1",
  },
  "02474": {
    DMA: "MA1",
  },
  "02476": {
    DMA: "MA1",
  },
  "02475": {
    DMA: "MA1",
  },
  "01431": {
    DMA: "MA1",
  },
  "01721": {
    DMA: "MA1",
  },
  "02466": {
    DMA: "MA1",
  },
  "01432": {
    DMA: "MA1",
  },
  "01730": {
    DMA: "MA1",
  },
  "02478": {
    DMA: "MA1",
  },
  "01821": {
    DMA: "MA1",
  },
  "01822": {
    DMA: "MA1",
  },
  "01719": {
    DMA: "MA1",
  },
  "01803": {
    DMA: "MA1",
  },
  "01805": {
    DMA: "MA1",
  },
  "02138": {
    DMA: "MA1",
  },
  "02139": {
    DMA: "MA1",
  },
  "02140": {
    DMA: "MA1",
  },
  "02141": {
    DMA: "MA1",
  },
  "02142": {
    DMA: "MA1",
  },
  "02238": {
    DMA: "MA1",
  },
  "02239": {
    DMA: "MA1",
  },
  "01741": {
    DMA: "MA1",
  },
  "01824": {
    DMA: "MA1",
  },
  "02467": {
    DMA: "MA1",
  },
  "01742": {
    DMA: "MA1",
  },
  "01826": {
    DMA: "MA1",
  },
  "01827": {
    DMA: "MA1",
  },
  "02149": {
    DMA: "MA1",
  },
  "01701": {
    DMA: "MA1",
  },
  "01702": {
    DMA: "MA1",
  },
  "01703": {
    DMA: "MA1",
  },
  "01704": {
    DMA: "MA1",
  },
  "01705": {
    DMA: "MA1",
  },
  "01450": {
    DMA: "MA1",
  },
  "01470": {
    DMA: "MA1",
  },
  "01471": {
    DMA: "MA1",
  },
  "01731": {
    DMA: "MA1",
  },
  "01746": {
    DMA: "MA1",
  },
  "01748": {
    DMA: "MA1",
  },
  "01749": {
    DMA: "MA1",
  },
  "02420": {
    DMA: "MA1",
  },
  "02421": {
    DMA: "MA1",
  },
  "01773": {
    DMA: "MA1",
  },
  "01460": {
    DMA: "MA1",
  },
  "01850": {
    DMA: "MA1",
  },
  "01851": {
    DMA: "MA1",
  },
  "01852": {
    DMA: "MA1",
  },
  "01853": {
    DMA: "MA1",
  },
  "01854": {
    DMA: "MA1",
  },
  "02148": {
    DMA: "MA1",
  },
  "01752": {
    DMA: "MA1",
  },
  "01754": {
    DMA: "MA1",
  },
  "02153": {
    DMA: "MA1",
  },
  "02155": {
    DMA: "MA1",
  },
  "02176": {
    DMA: "MA1",
  },
  "01760": {
    DMA: "MA1",
  },
  "02456": {
    DMA: "MA1",
  },
  "02458": {
    DMA: "MA1",
  },
  "02459": {
    DMA: "MA1",
  },
  "02461": {
    DMA: "MA1",
  },
  "02462": {
    DMA: "MA1",
  },
  "02464": {
    DMA: "MA1",
  },
  "02460": {
    DMA: "MA1",
  },
  "02495": {
    DMA: "MA1",
  },
  "01862": {
    DMA: "MA1",
  },
  "01863": {
    DMA: "MA1",
  },
  "01864": {
    DMA: "MA1",
  },
  "01889": {
    DMA: "MA1",
  },
  "02455": {
    DMA: "MA1",
  },
  "01865": {
    DMA: "MA1",
  },
  "01463": {
    DMA: "MA1",
  },
  "01866": {
    DMA: "MA1",
  },
  "01867": {
    DMA: "MA1",
  },
  "01770": {
    DMA: "MA1",
  },
  "01464": {
    DMA: "MA1",
  },
  "02143": {
    DMA: "MA1",
  },
  "02144": {
    DMA: "MA1",
  },
  "02145": {
    DMA: "MA1",
  },
  "02180": {
    DMA: "MA1",
  },
  "01775": {
    DMA: "MA1",
  },
  "01776": {
    DMA: "MA1",
  },
  "01876": {
    DMA: "MA1",
  },
  "01469": {
    DMA: "MA1",
  },
  "01879": {
    DMA: "MA1",
  },
  "02468": {
    DMA: "MA1",
  },
  "01880": {
    DMA: "MA1",
  },
  "02451": {
    DMA: "MA1",
  },
  "02452": {
    DMA: "MA1",
  },
  "02453": {
    DMA: "MA1",
  },
  "02454": {
    DMA: "MA1",
  },
  "02471": {
    DMA: "MA1",
  },
  "02472": {
    DMA: "MA1",
  },
  "02477": {
    DMA: "MA1",
  },
  "02479": {
    DMA: "MA1",
  },
  "01778": {
    DMA: "MA1",
  },
  "01472": {
    DMA: "MA1",
  },
  "02156": {
    DMA: "MA1",
  },
  "02465": {
    DMA: "MA1",
  },
  "01474": {
    DMA: "MA1",
  },
  "01886": {
    DMA: "MA1",
  },
  "02493": {
    DMA: "MA1",
  },
  "01887": {
    DMA: "MA1",
  },
  "01890": {
    DMA: "MA1",
  },
  "01801": {
    DMA: "MA1",
  },
  "01806": {
    DMA: "MA1",
  },
  "01807": {
    DMA: "MA1",
  },
  "01808": {
    DMA: "MA1",
  },
  "01813": {
    DMA: "MA1",
  },
  "01815": {
    DMA: "MA1",
  },
  "01888": {
    DMA: "MA1",
  },
  "01784": {
    DMA: "MA1",
  },
  "02554": {
    DMA: "MA1",
  },
  "02584": {
    DMA: "MA1",
  },
  "02564": {
    DMA: "MA1",
  },
  "02322": {
    DMA: "MA1",
  },
  "02457": {
    DMA: "MA1",
  },
  "02019": {
    DMA: "MA1",
  },
  "02184": {
    DMA: "MA1",
  },
  "02185": {
    DMA: "MA1",
  },
  "02445": {
    DMA: "MA1",
  },
  "02446": {
    DMA: "MA1",
  },
  "02447": {
    DMA: "MA1",
  },
  "02021": {
    DMA: "MA1",
  },
  "02025": {
    DMA: "MA1",
  },
  "02026": {
    DMA: "MA1",
  },
  "02027": {
    DMA: "MA1",
  },
  "02030": {
    DMA: "MA1",
  },
  "02032": {
    DMA: "MA1",
  },
  "02189": {
    DMA: "MA1",
  },
  "02035": {
    DMA: "MA1",
  },
  "02038": {
    DMA: "MA1",
  },
  "02343": {
    DMA: "MA1",
  },
  "02052": {
    DMA: "MA1",
  },
  "02053": {
    DMA: "MA1",
  },
  "02054": {
    DMA: "MA1",
  },
  "02186": {
    DMA: "MA1",
  },
  "02187": {
    DMA: "MA1",
  },
  "02492": {
    DMA: "MA1",
  },
  "02494": {
    DMA: "MA1",
  },
  "02056": {
    DMA: "MA1",
  },
  "02191": {
    DMA: "MA1",
  },
  "02062": {
    DMA: "MA1",
  },
  "02762": {
    DMA: "MA1",
  },
  "02169": {
    DMA: "MA1",
  },
  "02170": {
    DMA: "MA1",
  },
  "02171": {
    DMA: "MA1",
  },
  "02269": {
    DMA: "MA1",
  },
  "02368": {
    DMA: "MA1",
  },
  "02067": {
    DMA: "MA1",
  },
  "02070": {
    DMA: "MA1",
  },
  "02071": {
    DMA: "MA1",
  },
  "02190": {
    DMA: "MA1",
  },
  "02072": {
    DMA: "MA1",
  },
  "02081": {
    DMA: "MA1",
  },
  "02482": {
    DMA: "MA1",
  },
  "02481": {
    DMA: "MA1",
  },
  "02090": {
    DMA: "MA1",
  },
  "02188": {
    DMA: "MA1",
  },
  "02093": {
    DMA: "MA1",
  },
  "02351": {
    DMA: "MA1",
  },
  "02018": {
    DMA: "MA1",
  },
  "02020": {
    DMA: "MA1",
  },
  "02324": {
    DMA: "MA1",
  },
  "02325": {
    DMA: "MA1",
  },
  "02301": {
    DMA: "MA1",
  },
  "02302": {
    DMA: "MA1",
  },
  "02303": {
    DMA: "MA1",
  },
  "02304": {
    DMA: "MA1",
  },
  "02305": {
    DMA: "MA1",
  },
  "02327": {
    DMA: "MA1",
  },
  "02330": {
    DMA: "MA1",
  },
  "02331": {
    DMA: "MA1",
  },
  "02332": {
    DMA: "MA1",
  },
  "02333": {
    DMA: "MA1",
  },
  "02538": {
    DMA: "MA1",
  },
  "02337": {
    DMA: "MA1",
  },
  "02041": {
    DMA: "MA1",
  },
  "02040": {
    DMA: "MA1",
  },
  "02338": {
    DMA: "MA1",
  },
  "02339": {
    DMA: "MA1",
  },
  "02340": {
    DMA: "MA1",
  },
  "02341": {
    DMA: "MA1",
  },
  "02043": {
    DMA: "MA1",
  },
  "02044": {
    DMA: "MA1",
  },
  "02045": {
    DMA: "MA1",
  },
  "02047": {
    DMA: "MA1",
  },
  "02364": {
    DMA: "MA1",
  },
  "02347": {
    DMA: "MA1",
  },
  "02348": {
    DMA: "MA1",
  },
  "02345": {
    DMA: "MA1",
  },
  "02738": {
    DMA: "MA1",
  },
  "02050": {
    DMA: "MA1",
  },
  "02051": {
    DMA: "MA1",
  },
  "02739": {
    DMA: "MA1",
  },
  "02344": {
    DMA: "MA1",
  },
  "02346": {
    DMA: "MA1",
  },
  "02349": {
    DMA: "MA1",
  },
  "02055": {
    DMA: "MA1",
  },
  "02350": {
    DMA: "MA1",
  },
  "02355": {
    DMA: "MA1",
  },
  "02059": {
    DMA: "MA1",
  },
  "02358": {
    DMA: "MA1",
  },
  "02060": {
    DMA: "MA1",
  },
  "02061": {
    DMA: "MA1",
  },
  "02065": {
    DMA: "MA1",
  },
  "02558": {
    DMA: "MA1",
  },
  "02359": {
    DMA: "MA1",
  },
  "02360": {
    DMA: "MA1",
  },
  "02361": {
    DMA: "MA1",
  },
  "02362": {
    DMA: "MA1",
  },
  "02367": {
    DMA: "MA1",
  },
  "02770": {
    DMA: "MA1",
  },
  "02370": {
    DMA: "MA1",
  },
  "02066": {
    DMA: "MA1",
  },
  "02366": {
    DMA: "MA1",
  },
  "02571": {
    DMA: "MA1",
  },
  "02379": {
    DMA: "MA1",
  },
  "02576": {
    DMA: "MA1",
  },
  "02381": {
    DMA: "MA1",
  },
  "02382": {
    DMA: "MA1",
  },
  "02134": {
    DMA: "MA1",
  },
  "02108": {
    DMA: "MA1",
  },
  "02109": {
    DMA: "MA1",
  },
  "02110": {
    DMA: "MA1",
  },
  "02111": {
    DMA: "MA1",
  },
  "02112": {
    DMA: "MA1",
  },
  "02113": {
    DMA: "MA1",
  },
  "02114": {
    DMA: "MA1",
  },
  "02115": {
    DMA: "MA1",
  },
  "02116": {
    DMA: "MA1",
  },
  "02117": {
    DMA: "MA1",
  },
  "02118": {
    DMA: "MA1",
  },
  "02123": {
    DMA: "MA1",
  },
  "02133": {
    DMA: "MA1",
  },
  "02163": {
    DMA: "MA1",
  },
  "02196": {
    DMA: "MA1",
  },
  "02199": {
    DMA: "MA1",
  },
  "02201": {
    DMA: "MA1",
  },
  "02203": {
    DMA: "MA1",
  },
  "02204": {
    DMA: "MA1",
  },
  "02205": {
    DMA: "MA1",
  },
  "02206": {
    DMA: "MA1",
  },
  "02207": {
    DMA: "MA1",
  },
  "02210": {
    DMA: "MA1",
  },
  "02211": {
    DMA: "MA1",
  },
  "02212": {
    DMA: "MA1",
  },
  "02215": {
    DMA: "MA1",
  },
  "02216": {
    DMA: "MA1",
  },
  "02217": {
    DMA: "MA1",
  },
  "02222": {
    DMA: "MA1",
  },
  "02241": {
    DMA: "MA1",
  },
  "02266": {
    DMA: "MA1",
  },
  "02283": {
    DMA: "MA1",
  },
  "02284": {
    DMA: "MA1",
  },
  "02293": {
    DMA: "MA1",
  },
  "02295": {
    DMA: "MA1",
  },
  "02297": {
    DMA: "MA1",
  },
  "02298": {
    DMA: "MA1",
  },
  "02135": {
    DMA: "MA1",
  },
  "02129": {
    DMA: "MA1",
  },
  "02150": {
    DMA: "MA1",
  },
  "02121": {
    DMA: "MA1",
  },
  "02122": {
    DMA: "MA1",
  },
  "02125": {
    DMA: "MA1",
  },
  "02124": {
    DMA: "MA1",
  },
  "02128": {
    DMA: "MA1",
  },
  "02228": {
    DMA: "MA1",
  },
  "02136": {
    DMA: "MA1",
  },
  "02130": {
    DMA: "MA1",
  },
  "02126": {
    DMA: "MA1",
  },
  "02137": {
    DMA: "MA1",
  },
  "02151": {
    DMA: "MA1",
  },
  "02131": {
    DMA: "MA1",
  },
  "02119": {
    DMA: "MA1",
  },
  "02120": {
    DMA: "MA1",
  },
  "02127": {
    DMA: "MA1",
  },
  "02132": {
    DMA: "MA1",
  },
  "02152": {
    DMA: "MA1",
  },
  "01430": {
    DMA: "MA1",
  },
  "01331": {
    DMA: "MA1",
  },
  "01501": {
    DMA: "MA1",
  },
  "01436": {
    DMA: "MA1",
  },
  "01005": {
    DMA: "MA1",
  },
  "01503": {
    DMA: "MA1",
  },
  "01504": {
    DMA: "MA1",
  },
  "01740": {
    DMA: "MA1",
  },
  "01505": {
    DMA: "MA1",
  },
  "01506": {
    DMA: "MA1",
  },
  "01507": {
    DMA: "MA1",
  },
  "01508": {
    DMA: "MA1",
  },
  "01509": {
    DMA: "MA1",
  },
  "01611": {
    DMA: "MA1",
  },
  "01510": {
    DMA: "MA1",
  },
  "01434": {
    DMA: "MA1",
  },
  "01516": {
    DMA: "MA1",
  },
  "01571": {
    DMA: "MA1",
  },
  "01515": {
    DMA: "MA1",
  },
  "01517": {
    DMA: "MA1",
  },
  "01438": {
    DMA: "MA1",
  },
  "01745": {
    DMA: "MA1",
  },
  "01518": {
    DMA: "MA1",
  },
  "01420": {
    DMA: "MA1",
  },
  "01440": {
    DMA: "MA1",
  },
  "01031": {
    DMA: "MA1",
  },
  "01519": {
    DMA: "MA1",
  },
  "01037": {
    DMA: "MA1",
  },
  "01451": {
    DMA: "MA1",
  },
  "01520": {
    DMA: "MA1",
  },
  "01747": {
    DMA: "MA1",
  },
  "01452": {
    DMA: "MA1",
  },
  "01522": {
    DMA: "MA1",
  },
  "01523": {
    DMA: "MA1",
  },
  "01524": {
    DMA: "MA1",
  },
  "01453": {
    DMA: "MA1",
  },
  "01525": {
    DMA: "MA1",
  },
  "01462": {
    DMA: "MA1",
  },
  "01526": {
    DMA: "MA1",
  },
  "01756": {
    DMA: "MA1",
  },
  "01757": {
    DMA: "MA1",
  },
  "01527": {
    DMA: "MA1",
  },
  "01529": {
    DMA: "MA1",
  },
  "01531": {
    DMA: "MA1",
  },
  "01535": {
    DMA: "MA1",
  },
  "01536": {
    DMA: "MA1",
  },
  "01537": {
    DMA: "MA1",
  },
  "01538": {
    DMA: "MA1",
  },
  "01532": {
    DMA: "MA1",
  },
  "01534": {
    DMA: "MA1",
  },
  "01068": {
    DMA: "MA1",
  },
  "01540": {
    DMA: "MA1",
  },
  "01612": {
    DMA: "MA1",
  },
  "01366": {
    DMA: "MA1",
  },
  "01541": {
    DMA: "MA1",
  },
  "01542": {
    DMA: "MA1",
  },
  "01368": {
    DMA: "MA1",
  },
  "01543": {
    DMA: "MA1",
  },
  "01545": {
    DMA: "MA1",
  },
  "01546": {
    DMA: "MA1",
  },
  "01074": {
    DMA: "MA1",
  },
  "01560": {
    DMA: "MA1",
  },
  "01561": {
    DMA: "MA1",
  },
  "01772": {
    DMA: "MA1",
  },
  "01550": {
    DMA: "MA1",
  },
  "01562": {
    DMA: "MA1",
  },
  "01564": {
    DMA: "MA1",
  },
  "01467": {
    DMA: "MA1",
  },
  "01566": {
    DMA: "MA1",
  },
  "01590": {
    DMA: "MA1",
  },
  "01468": {
    DMA: "MA1",
  },
  "01568": {
    DMA: "MA1",
  },
  "01569": {
    DMA: "MA1",
  },
  "01083": {
    DMA: "MA1",
  },
  "01570": {
    DMA: "MA1",
  },
  "01583": {
    DMA: "MA1",
  },
  "01585": {
    DMA: "MA1",
  },
  "01586": {
    DMA: "MA1",
  },
  "01092": {
    DMA: "MA1",
  },
  "01580": {
    DMA: "MA1",
  },
  "01581": {
    DMA: "MA1",
  },
  "01582": {
    DMA: "MA1",
  },
  "01441": {
    DMA: "MA1",
  },
  "01473": {
    DMA: "MA1",
  },
  "01094": {
    DMA: "MA1",
  },
  "01588": {
    DMA: "MA1",
  },
  "01475": {
    DMA: "MA1",
  },
  "01477": {
    DMA: "MA1",
  },
  "01601": {
    DMA: "MA1",
  },
  "01602": {
    DMA: "MA1",
  },
  "01603": {
    DMA: "MA1",
  },
  "01604": {
    DMA: "MA1",
  },
  "01605": {
    DMA: "MA1",
  },
  "01606": {
    DMA: "MA1",
  },
  "01607": {
    DMA: "MA1",
  },
  "01608": {
    DMA: "MA1",
  },
  "01609": {
    DMA: "MA1",
  },
  "01610": {
    DMA: "MA1",
  },
  "01613": {
    DMA: "MA1",
  },
  "01614": {
    DMA: "MA1",
  },
  "01615": {
    DMA: "MA1",
  },
  "01653": {
    DMA: "MA1",
  },
  "01654": {
    DMA: "MA1",
  },
  "01655": {
    DMA: "MA1",
  },
  "04210": {
    DMA: "ME1",
  },
  "04211": {
    DMA: "ME1",
  },
  "04212": {
    DMA: "ME1",
  },
  "04223": {
    DMA: "ME1",
  },
  "04222": {
    DMA: "ME1",
  },
  "04228": {
    DMA: "ME1",
  },
  "04230": {
    DMA: "ME1",
  },
  "04236": {
    DMA: "ME1",
  },
  "04263": {
    DMA: "ME1",
  },
  "04240": {
    DMA: "ME1",
  },
  "04241": {
    DMA: "ME1",
  },
  "04243": {
    DMA: "ME1",
  },
  "04250": {
    DMA: "ME1",
  },
  "04252": {
    DMA: "ME1",
  },
  "04253": {
    DMA: "ME1",
  },
  "04254": {
    DMA: "ME1",
  },
  "04256": {
    DMA: "ME1",
  },
  "04258": {
    DMA: "ME1",
  },
  "04266": {
    DMA: "ME1",
  },
  "04274": {
    DMA: "ME1",
  },
  "04280": {
    DMA: "ME1",
  },
  "04282": {
    DMA: "ME1",
  },
  "04288": {
    DMA: "ME1",
  },
  "04291": {
    DMA: "ME1",
  },
  "04732": {
    DMA: "ME1",
  },
  "04733": {
    DMA: "ME1",
  },
  "04734": {
    DMA: "ME1",
  },
  "04735": {
    DMA: "ME1",
  },
  "04736": {
    DMA: "ME1",
  },
  "04737": {
    DMA: "ME1",
  },
  "04738": {
    DMA: "ME1",
  },
  "04739": {
    DMA: "ME1",
  },
  "04740": {
    DMA: "ME1",
  },
  "04741": {
    DMA: "ME1",
  },
  "04742": {
    DMA: "ME1",
  },
  "04743": {
    DMA: "ME1",
  },
  "04744": {
    DMA: "ME1",
  },
  "04745": {
    DMA: "ME1",
  },
  "04746": {
    DMA: "ME1",
  },
  "04730": {
    DMA: "ME1",
  },
  "04747": {
    DMA: "ME1",
  },
  "04750": {
    DMA: "ME1",
  },
  "04751": {
    DMA: "ME1",
  },
  "04756": {
    DMA: "ME1",
  },
  "04757": {
    DMA: "ME1",
  },
  "04758": {
    DMA: "ME1",
  },
  "04760": {
    DMA: "ME1",
  },
  "04761": {
    DMA: "ME1",
  },
  "04762": {
    DMA: "ME1",
  },
  "04763": {
    DMA: "ME1",
  },
  "04471": {
    DMA: "ME1",
  },
  "04764": {
    DMA: "ME1",
  },
  "04766": {
    DMA: "ME1",
  },
  "04768": {
    DMA: "ME1",
  },
  "04769": {
    DMA: "ME1",
  },
  "04772": {
    DMA: "ME1",
  },
  "04773": {
    DMA: "ME1",
  },
  "04774": {
    DMA: "ME1",
  },
  "04775": {
    DMA: "ME1",
  },
  "04776": {
    DMA: "ME1",
  },
  "04779": {
    DMA: "ME1",
  },
  "04780": {
    DMA: "ME1",
  },
  "04783": {
    DMA: "ME1",
  },
  "04785": {
    DMA: "ME1",
  },
  "04781": {
    DMA: "ME1",
  },
  "04786": {
    DMA: "ME1",
  },
  "04787": {
    DMA: "ME1",
  },
  "04497": {
    DMA: "ME1",
  },
  "04003": {
    DMA: "ME1",
  },
  "04009": {
    DMA: "ME1",
  },
  "04011": {
    DMA: "ME1",
  },
  "04013": {
    DMA: "ME1",
  },
  "04107": {
    DMA: "ME1",
  },
  "04015": {
    DMA: "ME1",
  },
  "04017": {
    DMA: "ME1",
  },
  "04019": {
    DMA: "ME1",
  },
  "04021": {
    DMA: "ME1",
  },
  "04110": {
    DMA: "ME1",
  },
  "04024": {
    DMA: "ME1",
  },
  "04105": {
    DMA: "ME1",
  },
  "04032": {
    DMA: "ME1",
  },
  "04033": {
    DMA: "ME1",
  },
  "04034": {
    DMA: "ME1",
  },
  "04038": {
    DMA: "ME1",
  },
  "04039": {
    DMA: "ME1",
  },
  "04079": {
    DMA: "ME1",
  },
  "04040": {
    DMA: "ME1",
  },
  "04050": {
    DMA: "ME1",
  },
  "04055": {
    DMA: "ME1",
  },
  "04260": {
    DMA: "ME1",
  },
  "04057": {
    DMA: "ME1",
  },
  "04097": {
    DMA: "ME1",
  },
  "04066": {
    DMA: "ME1",
  },
  "04108": {
    DMA: "ME1",
  },
  "04101": {
    DMA: "ME1",
  },
  "04102": {
    DMA: "ME1",
  },
  "04103": {
    DMA: "ME1",
  },
  "04104": {
    DMA: "ME1",
  },
  "04109": {
    DMA: "ME1",
  },
  "04112": {
    DMA: "ME1",
  },
  "04122": {
    DMA: "ME1",
  },
  "04123": {
    DMA: "ME1",
  },
  "04124": {
    DMA: "ME1",
  },
  "04069": {
    DMA: "ME1",
  },
  "04071": {
    DMA: "ME1",
  },
  "04070": {
    DMA: "ME1",
  },
  "04074": {
    DMA: "ME1",
  },
  "04029": {
    DMA: "ME1",
  },
  "04075": {
    DMA: "ME1",
  },
  "04077": {
    DMA: "ME1",
  },
  "04078": {
    DMA: "ME1",
  },
  "04106": {
    DMA: "ME1",
  },
  "04116": {
    DMA: "ME1",
  },
  "04082": {
    DMA: "ME1",
  },
  "04084": {
    DMA: "ME1",
  },
  "04085": {
    DMA: "ME1",
  },
  "04091": {
    DMA: "ME1",
  },
  "04092": {
    DMA: "ME1",
  },
  "04098": {
    DMA: "ME1",
  },
  "04062": {
    DMA: "ME1",
  },
  "04096": {
    DMA: "ME1",
  },
  "04225": {
    DMA: "ME1",
  },
  "04234": {
    DMA: "ME1",
  },
  "04936": {
    DMA: "ME1",
  },
  "04938": {
    DMA: "ME1",
  },
  "04940": {
    DMA: "ME1",
  },
  "04239": {
    DMA: "ME1",
  },
  "04947": {
    DMA: "ME1",
  },
  "04955": {
    DMA: "ME1",
  },
  "04956": {
    DMA: "ME1",
  },
  "04262": {
    DMA: "ME1",
  },
  "04964": {
    DMA: "ME1",
  },
  "04966": {
    DMA: "ME1",
  },
  "04970": {
    DMA: "ME1",
  },
  "04982": {
    DMA: "ME1",
  },
  "04983": {
    DMA: "ME1",
  },
  "04984": {
    DMA: "ME1",
  },
  "04285": {
    DMA: "ME1",
  },
  "04992": {
    DMA: "ME1",
  },
  "04294": {
    DMA: "ME1",
  },
  "04408": {
    DMA: "ME1",
  },
  "04609": {
    DMA: "ME1",
  },
  "04653": {
    DMA: "ME1",
  },
  "04612": {
    DMA: "ME1",
  },
  "04613": {
    DMA: "ME1",
  },
  "04614": {
    DMA: "ME1",
  },
  "04616": {
    DMA: "ME1",
  },
  "04617": {
    DMA: "ME1",
  },
  "04416": {
    DMA: "ME1",
  },
  "04420": {
    DMA: "ME1",
  },
  "04421": {
    DMA: "ME1",
  },
  "04624": {
    DMA: "ME1",
  },
  "04625": {
    DMA: "ME1",
  },
  "04627": {
    DMA: "ME1",
  },
  "04629": {
    DMA: "ME1",
  },
  "04431": {
    DMA: "ME1",
  },
  "04605": {
    DMA: "ME1",
  },
  "04634": {
    DMA: "ME1",
  },
  "04635": {
    DMA: "ME1",
  },
  "04607": {
    DMA: "ME1",
  },
  "04640": {
    DMA: "ME1",
  },
  "04642": {
    DMA: "ME1",
  },
  "04644": {
    DMA: "ME1",
  },
  "04646": {
    DMA: "ME1",
  },
  "04650": {
    DMA: "ME1",
  },
  "04660": {
    DMA: "ME1",
  },
  "04662": {
    DMA: "ME1",
  },
  "04472": {
    DMA: "ME1",
  },
  "04476": {
    DMA: "ME1",
  },
  "04669": {
    DMA: "ME1",
  },
  "04672": {
    DMA: "ME1",
  },
  "04673": {
    DMA: "ME1",
  },
  "04674": {
    DMA: "ME1",
  },
  "04675": {
    DMA: "ME1",
  },
  "04676": {
    DMA: "ME1",
  },
  "04677": {
    DMA: "ME1",
  },
  "04679": {
    DMA: "ME1",
  },
  "04681": {
    DMA: "ME1",
  },
  "04664": {
    DMA: "ME1",
  },
  "04683": {
    DMA: "ME1",
  },
  "04684": {
    DMA: "ME1",
  },
  "04685": {
    DMA: "ME1",
  },
  "04693": {
    DMA: "ME1",
  },
  "04910": {
    DMA: "ME1",
  },
  "04330": {
    DMA: "ME1",
  },
  "04332": {
    DMA: "ME1",
  },
  "04333": {
    DMA: "ME1",
  },
  "04336": {
    DMA: "ME1",
  },
  "04338": {
    DMA: "ME1",
  },
  "04917": {
    DMA: "ME1",
  },
  "04918": {
    DMA: "ME1",
  },
  "04926": {
    DMA: "ME1",
  },
  "04927": {
    DMA: "ME1",
  },
  "04935": {
    DMA: "ME1",
  },
  "04343": {
    DMA: "ME1",
  },
  "04344": {
    DMA: "ME1",
  },
  "04345": {
    DMA: "ME1",
  },
  "04347": {
    DMA: "ME1",
  },
  "04349": {
    DMA: "ME1",
  },
  "04350": {
    DMA: "ME1",
  },
  "04351": {
    DMA: "ME1",
  },
  "04259": {
    DMA: "ME1",
  },
  "04352": {
    DMA: "ME1",
  },
  "04265": {
    DMA: "ME1",
  },
  "04962": {
    DMA: "ME1",
  },
  "04963": {
    DMA: "ME1",
  },
  "04346": {
    DMA: "ME1",
  },
  "04355": {
    DMA: "ME1",
  },
  "04358": {
    DMA: "ME1",
  },
  "04359": {
    DMA: "ME1",
  },
  "04989": {
    DMA: "ME1",
  },
  "04360": {
    DMA: "ME1",
  },
  "04901": {
    DMA: "ME1",
  },
  "04903": {
    DMA: "ME1",
  },
  "04284": {
    DMA: "ME1",
  },
  "04363": {
    DMA: "ME1",
  },
  "04364": {
    DMA: "ME1",
  },
  "04843": {
    DMA: "ME1",
  },
  "04563": {
    DMA: "ME1",
  },
  "04547": {
    DMA: "ME1",
  },
  "04846": {
    DMA: "ME1",
  },
  "04847": {
    DMA: "ME1",
  },
  "04645": {
    DMA: "ME1",
  },
  "04851": {
    DMA: "ME1",
  },
  "04853": {
    DMA: "ME1",
  },
  "04854": {
    DMA: "ME1",
  },
  "04855": {
    DMA: "ME1",
  },
  "04841": {
    DMA: "ME1",
  },
  "04856": {
    DMA: "ME1",
  },
  "04858": {
    DMA: "ME1",
  },
  "04859": {
    DMA: "ME1",
  },
  "04860": {
    DMA: "ME1",
  },
  "04861": {
    DMA: "ME1",
  },
  "04862": {
    DMA: "ME1",
  },
  "04863": {
    DMA: "ME1",
  },
  "04864": {
    DMA: "ME1",
  },
  "04574": {
    DMA: "ME1",
  },
  "04865": {
    DMA: "ME1",
  },
  "04535": {
    DMA: "ME1",
  },
  "04537": {
    DMA: "ME1",
  },
  "04538": {
    DMA: "ME1",
  },
  "04551": {
    DMA: "ME1",
  },
  "04539": {
    DMA: "ME1",
  },
  "04541": {
    DMA: "ME1",
  },
  "04341": {
    DMA: "ME1",
  },
  "04543": {
    DMA: "ME1",
  },
  "04342": {
    DMA: "ME1",
  },
  "04544": {
    DMA: "ME1",
  },
  "04556": {
    DMA: "ME1",
  },
  "04549": {
    DMA: "ME1",
  },
  "04348": {
    DMA: "ME1",
  },
  "04852": {
    DMA: "ME1",
  },
  "04554": {
    DMA: "ME1",
  },
  "04553": {
    DMA: "ME1",
  },
  "04555": {
    DMA: "ME1",
  },
  "04558": {
    DMA: "ME1",
  },
  "04564": {
    DMA: "ME1",
  },
  "04568": {
    DMA: "ME1",
  },
  "04576": {
    DMA: "ME1",
  },
  "04570": {
    DMA: "ME1",
  },
  "04571": {
    DMA: "ME1",
  },
  "04572": {
    DMA: "ME1",
  },
  "04573": {
    DMA: "ME1",
  },
  "04575": {
    DMA: "ME1",
  },
  "04353": {
    DMA: "ME1",
  },
  "04578": {
    DMA: "ME1",
  },
  "04216": {
    DMA: "ME1",
  },
  "04217": {
    DMA: "ME1",
  },
  "04010": {
    DMA: "ME1",
  },
  "04219": {
    DMA: "ME1",
  },
  "04220": {
    DMA: "ME1",
  },
  "04221": {
    DMA: "ME1",
  },
  "04016": {
    DMA: "ME1",
  },
  "04022": {
    DMA: "ME1",
  },
  "04224": {
    DMA: "ME1",
  },
  "04226": {
    DMA: "ME1",
  },
  "04227": {
    DMA: "ME1",
  },
  "04037": {
    DMA: "ME1",
  },
  "04255": {
    DMA: "ME1",
  },
  "04237": {
    DMA: "ME1",
  },
  "04238": {
    DMA: "ME1",
  },
  "04041": {
    DMA: "ME1",
  },
  "04051": {
    DMA: "ME1",
  },
  "04257": {
    DMA: "ME1",
  },
  "04261": {
    DMA: "ME1",
  },
  "04267": {
    DMA: "ME1",
  },
  "04268": {
    DMA: "ME1",
  },
  "04270": {
    DMA: "ME1",
  },
  "04271": {
    DMA: "ME1",
  },
  "04290": {
    DMA: "ME1",
  },
  "04068": {
    DMA: "ME1",
  },
  "04275": {
    DMA: "ME1",
  },
  "04276": {
    DMA: "ME1",
  },
  "04281": {
    DMA: "ME1",
  },
  "04231": {
    DMA: "ME1",
  },
  "04292": {
    DMA: "ME1",
  },
  "04088": {
    DMA: "ME1",
  },
  "04286": {
    DMA: "ME1",
  },
  "04289": {
    DMA: "ME1",
  },
  "04401": {
    DMA: "ME1",
  },
  "04402": {
    DMA: "ME1",
  },
  "04410": {
    DMA: "ME1",
  },
  "04411": {
    DMA: "ME1",
  },
  "04412": {
    DMA: "ME1",
  },
  "04417": {
    DMA: "ME1",
  },
  "04419": {
    DMA: "ME1",
  },
  "04422": {
    DMA: "ME1",
  },
  "04928": {
    DMA: "ME1",
  },
  "04427": {
    DMA: "ME1",
  },
  "04930": {
    DMA: "ME1",
  },
  "04932": {
    DMA: "ME1",
  },
  "04430": {
    DMA: "ME1",
  },
  "04933": {
    DMA: "ME1",
  },
  "04428": {
    DMA: "ME1",
  },
  "04434": {
    DMA: "ME1",
  },
  "04435": {
    DMA: "ME1",
  },
  "04939": {
    DMA: "ME1",
  },
  "04418": {
    DMA: "ME1",
  },
  "04444": {
    DMA: "ME1",
  },
  "04429": {
    DMA: "ME1",
  },
  "04448": {
    DMA: "ME1",
  },
  "04449": {
    DMA: "ME1",
  },
  "04450": {
    DMA: "ME1",
  },
  "04451": {
    DMA: "ME1",
  },
  "04453": {
    DMA: "ME1",
  },
  "04455": {
    DMA: "ME1",
  },
  "04456": {
    DMA: "ME1",
  },
  "04457": {
    DMA: "ME1",
  },
  "04459": {
    DMA: "ME1",
  },
  "04460": {
    DMA: "ME1",
  },
  "04461": {
    DMA: "ME1",
  },
  "04462": {
    DMA: "ME1",
  },
  "04953": {
    DMA: "ME1",
  },
  "04467": {
    DMA: "ME1",
  },
  "04468": {
    DMA: "ME1",
  },
  "04469": {
    DMA: "ME1",
  },
  "04473": {
    DMA: "ME1",
  },
  "04474": {
    DMA: "ME1",
  },
  "04475": {
    DMA: "ME1",
  },
  "04765": {
    DMA: "ME1",
  },
  "04969": {
    DMA: "ME1",
  },
  "04487": {
    DMA: "ME1",
  },
  "04777": {
    DMA: "ME1",
  },
  "04488": {
    DMA: "ME1",
  },
  "04489": {
    DMA: "ME1",
  },
  "04493": {
    DMA: "ME1",
  },
  "04495": {
    DMA: "ME1",
  },
  "04406": {
    DMA: "ME1",
  },
  "04414": {
    DMA: "ME1",
  },
  "04415": {
    DMA: "ME1",
  },
  "04426": {
    DMA: "ME1",
  },
  "04441": {
    DMA: "ME1",
  },
  "04442": {
    DMA: "ME1",
  },
  "04443": {
    DMA: "ME1",
  },
  "04463": {
    DMA: "ME1",
  },
  "04464": {
    DMA: "ME1",
  },
  "04479": {
    DMA: "ME1",
  },
  "04481": {
    DMA: "ME1",
  },
  "04485": {
    DMA: "ME1",
  },
  "04530": {
    DMA: "ME1",
  },
  "04287": {
    DMA: "ME1",
  },
  "04008": {
    DMA: "ME1",
  },
  "04548": {
    DMA: "ME1",
  },
  "04562": {
    DMA: "ME1",
  },
  "04357": {
    DMA: "ME1",
  },
  "04565": {
    DMA: "ME1",
  },
  "04086": {
    DMA: "ME1",
  },
  "04579": {
    DMA: "ME1",
  },
  "04911": {
    DMA: "ME1",
  },
  "04912": {
    DMA: "ME1",
  },
  "04920": {
    DMA: "ME1",
  },
  "04923": {
    DMA: "ME1",
  },
  "04924": {
    DMA: "ME1",
  },
  "04925": {
    DMA: "ME1",
  },
  "04929": {
    DMA: "ME1",
  },
  "04937": {
    DMA: "ME1",
  },
  "04942": {
    DMA: "ME1",
  },
  "04943": {
    DMA: "ME1",
  },
  "04944": {
    DMA: "ME1",
  },
  "04945": {
    DMA: "ME1",
  },
  "04950": {
    DMA: "ME1",
  },
  "04954": {
    DMA: "ME1",
  },
  "04961": {
    DMA: "ME1",
  },
  "04957": {
    DMA: "ME1",
  },
  "04958": {
    DMA: "ME1",
  },
  "04965": {
    DMA: "ME1",
  },
  "04967": {
    DMA: "ME1",
  },
  "04478": {
    DMA: "ME1",
  },
  "04971": {
    DMA: "ME1",
  },
  "04975": {
    DMA: "ME1",
  },
  "04976": {
    DMA: "ME1",
  },
  "04978": {
    DMA: "ME1",
  },
  "04979": {
    DMA: "ME1",
  },
  "04985": {
    DMA: "ME1",
  },
  "04915": {
    DMA: "ME1",
  },
  "04921": {
    DMA: "ME1",
  },
  "04922": {
    DMA: "ME1",
  },
  "04438": {
    DMA: "ME1",
  },
  "04941": {
    DMA: "ME1",
  },
  "04848": {
    DMA: "ME1",
  },
  "04949": {
    DMA: "ME1",
  },
  "04849": {
    DMA: "ME1",
  },
  "04850": {
    DMA: "ME1",
  },
  "04951": {
    DMA: "ME1",
  },
  "04952": {
    DMA: "ME1",
  },
  "04354": {
    DMA: "ME1",
  },
  "04972": {
    DMA: "ME1",
  },
  "04973": {
    DMA: "ME1",
  },
  "04974": {
    DMA: "ME1",
  },
  "04981": {
    DMA: "ME1",
  },
  "04986": {
    DMA: "ME1",
  },
  "04987": {
    DMA: "ME1",
  },
  "04988": {
    DMA: "ME1",
  },
  "04496": {
    DMA: "ME1",
  },
  "04606": {
    DMA: "ME1",
  },
  "04694": {
    DMA: "ME1",
  },
  "04611": {
    DMA: "ME1",
  },
  "04413": {
    DMA: "ME1",
  },
  "04619": {
    DMA: "ME1",
  },
  "04622": {
    DMA: "ME1",
  },
  "04623": {
    DMA: "ME1",
  },
  "04626": {
    DMA: "ME1",
  },
  "04424": {
    DMA: "ME1",
  },
  "04628": {
    DMA: "ME1",
  },
  "04630": {
    DMA: "ME1",
  },
  "04631": {
    DMA: "ME1",
  },
  "04637": {
    DMA: "ME1",
  },
  "04643": {
    DMA: "ME1",
  },
  "04648": {
    DMA: "ME1",
  },
  "04649": {
    DMA: "ME1",
  },
  "04454": {
    DMA: "ME1",
  },
  "04652": {
    DMA: "ME1",
  },
  "04654": {
    DMA: "ME1",
  },
  "04655": {
    DMA: "ME1",
  },
  "04657": {
    DMA: "ME1",
  },
  "04658": {
    DMA: "ME1",
  },
  "04666": {
    DMA: "ME1",
  },
  "04667": {
    DMA: "ME1",
  },
  "04668": {
    DMA: "ME1",
  },
  "04671": {
    DMA: "ME1",
  },
  "04680": {
    DMA: "ME1",
  },
  "04490": {
    DMA: "ME1",
  },
  "04491": {
    DMA: "ME1",
  },
  "04492": {
    DMA: "ME1",
  },
  "04686": {
    DMA: "ME1",
  },
  "04691": {
    DMA: "ME1",
  },
  "04001": {
    DMA: "ME1",
  },
  "04002": {
    DMA: "ME1",
  },
  "04004": {
    DMA: "ME1",
  },
  "03901": {
    DMA: "ME1",
  },
  "04005": {
    DMA: "ME1",
  },
  "04007": {
    DMA: "ME1",
  },
  "04006": {
    DMA: "ME1",
  },
  "04093": {
    DMA: "ME1",
  },
  "03902": {
    DMA: "ME1",
  },
  "04014": {
    DMA: "ME1",
  },
  "04020": {
    DMA: "ME1",
  },
  "04028": {
    DMA: "ME1",
  },
  "04030": {
    DMA: "ME1",
  },
  "03903": {
    DMA: "ME1",
  },
  "04042": {
    DMA: "ME1",
  },
  "04043": {
    DMA: "ME1",
  },
  "04046": {
    DMA: "ME1",
  },
  "03904": {
    DMA: "ME1",
  },
  "03905": {
    DMA: "ME1",
  },
  "04027": {
    DMA: "ME1",
  },
  "04048": {
    DMA: "ME1",
  },
  "04049": {
    DMA: "ME1",
  },
  "04054": {
    DMA: "ME1",
  },
  "04056": {
    DMA: "ME1",
  },
  "03906": {
    DMA: "ME1",
  },
  "04061": {
    DMA: "ME1",
  },
  "04063": {
    DMA: "ME1",
  },
  "03907": {
    DMA: "ME1",
  },
  "04064": {
    DMA: "ME1",
  },
  "04047": {
    DMA: "ME1",
  },
  "04072": {
    DMA: "ME1",
  },
  "04073": {
    DMA: "ME1",
  },
  "04076": {
    DMA: "ME1",
  },
  "03908": {
    DMA: "ME1",
  },
  "04083": {
    DMA: "ME1",
  },
  "04087": {
    DMA: "ME1",
  },
  "04090": {
    DMA: "ME1",
  },
  "04094": {
    DMA: "ME1",
  },
  "04095": {
    DMA: "ME1",
  },
  "03909": {
    DMA: "ME1",
  },
  "03910": {
    DMA: "ME1",
  },
  "03911": {
    DMA: "ME1",
  },
  "03809": {
    DMA: "NH1",
  },
  "03810": {
    DMA: "NH1",
  },
  "03218": {
    DMA: "NH1",
  },
  "03220": {
    DMA: "NH1",
  },
  "03225": {
    DMA: "NH1",
  },
  "03226": {
    DMA: "NH1",
  },
  "03249": {
    DMA: "NH1",
  },
  "03237": {
    DMA: "NH1",
  },
  "03837": {
    DMA: "NH1",
  },
  "03246": {
    DMA: "NH1",
  },
  "03247": {
    DMA: "NH1",
  },
  "03252": {
    DMA: "NH1",
  },
  "03253": {
    DMA: "NH1",
  },
  "03256": {
    DMA: "NH1",
  },
  "03269": {
    DMA: "NH1",
  },
  "03298": {
    DMA: "NH1",
  },
  "03299": {
    DMA: "NH1",
  },
  "03289": {
    DMA: "NH1",
  },
  "03812": {
    DMA: "NH1",
  },
  "03813": {
    DMA: "NH1",
  },
  "03814": {
    DMA: "NH1",
  },
  "03227": {
    DMA: "NH1",
  },
  "03816": {
    DMA: "NH1",
  },
  "03817": {
    DMA: "NH1",
  },
  "03818": {
    DMA: "NH1",
  },
  "03830": {
    DMA: "NH1",
  },
  "03832": {
    DMA: "NH1",
  },
  "03882": {
    DMA: "NH1",
  },
  "03836": {
    DMA: "NH1",
  },
  "03838": {
    DMA: "NH1",
  },
  "03845": {
    DMA: "NH1",
  },
  "03846": {
    DMA: "NH1",
  },
  "03847": {
    DMA: "NH1",
  },
  "03849": {
    DMA: "NH1",
  },
  "03850": {
    DMA: "NH1",
  },
  "03853": {
    DMA: "NH1",
  },
  "03254": {
    DMA: "NH1",
  },
  "03860": {
    DMA: "NH1",
  },
  "03259": {
    DMA: "NH1",
  },
  "03864": {
    DMA: "NH1",
  },
  "03872": {
    DMA: "NH1",
  },
  "03875": {
    DMA: "NH1",
  },
  "03883": {
    DMA: "NH1",
  },
  "03886": {
    DMA: "NH1",
  },
  "03890": {
    DMA: "NH1",
  },
  "03894": {
    DMA: "NH1",
  },
  "03896": {
    DMA: "NH1",
  },
  "03897": {
    DMA: "NH1",
  },
  "03602": {
    DMA: "NH1",
  },
  "03441": {
    DMA: "NH1",
  },
  "03443": {
    DMA: "NH1",
  },
  "03604": {
    DMA: "NH1",
  },
  "03444": {
    DMA: "NH1",
  },
  "03447": {
    DMA: "NH1",
  },
  "03448": {
    DMA: "NH1",
  },
  "03450": {
    DMA: "NH1",
  },
  "03451": {
    DMA: "NH1",
  },
  "03452": {
    DMA: "NH1",
  },
  "03431": {
    DMA: "NH1",
  },
  "03435": {
    DMA: "NH1",
  },
  "03455": {
    DMA: "NH1",
  },
  "03456": {
    DMA: "NH1",
  },
  "03457": {
    DMA: "NH1",
  },
  "03609": {
    DMA: "NH1",
  },
  "03461": {
    DMA: "NH1",
  },
  "03462": {
    DMA: "NH1",
  },
  "03464": {
    DMA: "NH1",
  },
  "03445": {
    DMA: "NH1",
  },
  "03446": {
    DMA: "NH1",
  },
  "03465": {
    DMA: "NH1",
  },
  "03608": {
    DMA: "NH1",
  },
  "03466": {
    DMA: "NH1",
  },
  "03469": {
    DMA: "NH1",
  },
  "03467": {
    DMA: "NH1",
  },
  "03470": {
    DMA: "NH1",
  },
  "03570": {
    DMA: "NH1",
  },
  "03575": {
    DMA: "NH1",
  },
  "03576": {
    DMA: "NH1",
  },
  "03579": {
    DMA: "NH1",
  },
  "03581": {
    DMA: "NH1",
  },
  "03582": {
    DMA: "NH1",
  },
  "03583": {
    DMA: "NH1",
  },
  "03584": {
    DMA: "NH1",
  },
  "03588": {
    DMA: "NH1",
  },
  "03589": {
    DMA: "NH1",
  },
  "03590": {
    DMA: "NH1",
  },
  "03592": {
    DMA: "NH1",
  },
  "03593": {
    DMA: "NH1",
  },
  "03595": {
    DMA: "NH1",
  },
  "03597": {
    DMA: "NH1",
  },
  "03598": {
    DMA: "NH1",
  },
  "03217": {
    DMA: "NH1",
  },
  "03740": {
    DMA: "NH1",
  },
  "03574": {
    DMA: "NH1",
  },
  "03222": {
    DMA: "NH1",
  },
  "03223": {
    DMA: "NH1",
  },
  "03741": {
    DMA: "NH1",
  },
  "03748": {
    DMA: "NH1",
  },
  "03749": {
    DMA: "NH1",
  },
  "03750": {
    DMA: "NH1",
  },
  "03580": {
    DMA: "NH1",
  },
  "03238": {
    DMA: "NH1",
  },
  "03240": {
    DMA: "NH1",
  },
  "03755": {
    DMA: "NH1",
  },
  "03765": {
    DMA: "NH1",
  },
  "03241": {
    DMA: "NH1",
  },
  "03245": {
    DMA: "NH1",
  },
  "03756": {
    DMA: "NH1",
  },
  "03766": {
    DMA: "NH1",
  },
  "03251": {
    DMA: "NH1",
  },
  "03585": {
    DMA: "NH1",
  },
  "03561": {
    DMA: "NH1",
  },
  "03768": {
    DMA: "NH1",
  },
  "03769": {
    DMA: "NH1",
  },
  "03771": {
    DMA: "NH1",
  },
  "03774": {
    DMA: "NH1",
  },
  "03262": {
    DMA: "NH1",
  },
  "03777": {
    DMA: "NH1",
  },
  "03779": {
    DMA: "NH1",
  },
  "03780": {
    DMA: "NH1",
  },
  "03264": {
    DMA: "NH1",
  },
  "03266": {
    DMA: "NH1",
  },
  "03274": {
    DMA: "NH1",
  },
  "03586": {
    DMA: "NH1",
  },
  "03285": {
    DMA: "NH1",
  },
  "03279": {
    DMA: "NH1",
  },
  "03215": {
    DMA: "NH1",
  },
  "03282": {
    DMA: "NH1",
  },
  "03784": {
    DMA: "NH1",
  },
  "03293": {
    DMA: "NH1",
  },
  "03785": {
    DMA: "NH1",
  },
  "03031": {
    DMA: "NH1",
  },
  "03440": {
    DMA: "NH1",
  },
  "03110": {
    DMA: "NH1",
  },
  "03442": {
    DMA: "NH1",
  },
  "03033": {
    DMA: "NH1",
  },
  "03043": {
    DMA: "NH1",
  },
  "03045": {
    DMA: "NH1",
  },
  "03047": {
    DMA: "NH1",
  },
  "03048": {
    DMA: "NH1",
  },
  "03449": {
    DMA: "NH1",
  },
  "03244": {
    DMA: "NH1",
  },
  "03049": {
    DMA: "NH1",
  },
  "03051": {
    DMA: "NH1",
  },
  "03052": {
    DMA: "NH1",
  },
  "03082": {
    DMA: "NH1",
  },
  "03101": {
    DMA: "NH1",
  },
  "03102": {
    DMA: "NH1",
  },
  "03103": {
    DMA: "NH1",
  },
  "03104": {
    DMA: "NH1",
  },
  "03105": {
    DMA: "NH1",
  },
  "03107": {
    DMA: "NH1",
  },
  "03108": {
    DMA: "NH1",
  },
  "03109": {
    DMA: "NH1",
  },
  "03111": {
    DMA: "NH1",
  },
  "03054": {
    DMA: "NH1",
  },
  "03055": {
    DMA: "NH1",
  },
  "03057": {
    DMA: "NH1",
  },
  "03060": {
    DMA: "NH1",
  },
  "03061": {
    DMA: "NH1",
  },
  "03062": {
    DMA: "NH1",
  },
  "03063": {
    DMA: "NH1",
  },
  "03064": {
    DMA: "NH1",
  },
  "03070": {
    DMA: "NH1",
  },
  "03071": {
    DMA: "NH1",
  },
  "03076": {
    DMA: "NH1",
  },
  "03458": {
    DMA: "NH1",
  },
  "03084": {
    DMA: "NH1",
  },
  "03281": {
    DMA: "NH1",
  },
  "03468": {
    DMA: "NH1",
  },
  "03086": {
    DMA: "NH1",
  },
  "03216": {
    DMA: "NH1",
  },
  "03304": {
    DMA: "NH1",
  },
  "03221": {
    DMA: "NH1",
  },
  "03224": {
    DMA: "NH1",
  },
  "03258": {
    DMA: "NH1",
  },
  "03301": {
    DMA: "NH1",
  },
  "03302": {
    DMA: "NH1",
  },
  "03303": {
    DMA: "NH1",
  },
  "03305": {
    DMA: "NH1",
  },
  "03229": {
    DMA: "NH1",
  },
  "03230": {
    DMA: "NH1",
  },
  "03046": {
    DMA: "NH1",
  },
  "03231": {
    DMA: "NH1",
  },
  "03233": {
    DMA: "NH1",
  },
  "03234": {
    DMA: "NH1",
  },
  "03235": {
    DMA: "NH1",
  },
  "03242": {
    DMA: "NH1",
  },
  "03243": {
    DMA: "NH1",
  },
  "03106": {
    DMA: "NH1",
  },
  "03307": {
    DMA: "NH1",
  },
  "03257": {
    DMA: "NH1",
  },
  "03255": {
    DMA: "NH1",
  },
  "03260": {
    DMA: "NH1",
  },
  "03263": {
    DMA: "NH1",
  },
  "03268": {
    DMA: "NH1",
  },
  "03272": {
    DMA: "NH1",
  },
  "03273": {
    DMA: "NH1",
  },
  "03275": {
    DMA: "NH1",
  },
  "03276": {
    DMA: "NH1",
  },
  "03278": {
    DMA: "NH1",
  },
  "03287": {
    DMA: "NH1",
  },
  "03811": {
    DMA: "NH1",
  },
  "03032": {
    DMA: "NH1",
  },
  "03034": {
    DMA: "NH1",
  },
  "03036": {
    DMA: "NH1",
  },
  "03819": {
    DMA: "NH1",
  },
  "03037": {
    DMA: "NH1",
  },
  "03038": {
    DMA: "NH1",
  },
  "03040": {
    DMA: "NH1",
  },
  "03041": {
    DMA: "NH1",
  },
  "03826": {
    DMA: "NH1",
  },
  "03827": {
    DMA: "NH1",
  },
  "03042": {
    DMA: "NH1",
  },
  "03833": {
    DMA: "NH1",
  },
  "03044": {
    DMA: "NH1",
  },
  "03840": {
    DMA: "NH1",
  },
  "03841": {
    DMA: "NH1",
  },
  "03842": {
    DMA: "NH1",
  },
  "03843": {
    DMA: "NH1",
  },
  "03844": {
    DMA: "NH1",
  },
  "03848": {
    DMA: "NH1",
  },
  "03053": {
    DMA: "NH1",
  },
  "03854": {
    DMA: "NH1",
  },
  "03856": {
    DMA: "NH1",
  },
  "03805": {
    DMA: "NH1",
  },
  "03857": {
    DMA: "NH1",
  },
  "03858": {
    DMA: "NH1",
  },
  "03859": {
    DMA: "NH1",
  },
  "03862": {
    DMA: "NH1",
  },
  "03073": {
    DMA: "NH1",
  },
  "03261": {
    DMA: "NH1",
  },
  "03290": {
    DMA: "NH1",
  },
  "03865": {
    DMA: "NH1",
  },
  "03801": {
    DMA: "NH1",
  },
  "03802": {
    DMA: "NH1",
  },
  "03803": {
    DMA: "NH1",
  },
  "03804": {
    DMA: "NH1",
  },
  "03077": {
    DMA: "NH1",
  },
  "03870": {
    DMA: "NH1",
  },
  "03871": {
    DMA: "NH1",
  },
  "03079": {
    DMA: "NH1",
  },
  "03873": {
    DMA: "NH1",
  },
  "03874": {
    DMA: "NH1",
  },
  "03885": {
    DMA: "NH1",
  },
  "03291": {
    DMA: "NH1",
  },
  "03087": {
    DMA: "NH1",
  },
  "03825": {
    DMA: "NH1",
  },
  "03815": {
    DMA: "NH1",
  },
  "03820": {
    DMA: "NH1",
  },
  "03821": {
    DMA: "NH1",
  },
  "03822": {
    DMA: "NH1",
  },
  "03824": {
    DMA: "NH1",
  },
  "03835": {
    DMA: "NH1",
  },
  "03861": {
    DMA: "NH1",
  },
  "03823": {
    DMA: "NH1",
  },
  "03851": {
    DMA: "NH1",
  },
  "03852": {
    DMA: "NH1",
  },
  "03855": {
    DMA: "NH1",
  },
  "03839": {
    DMA: "NH1",
  },
  "03866": {
    DMA: "NH1",
  },
  "03867": {
    DMA: "NH1",
  },
  "03868": {
    DMA: "NH1",
  },
  "03869": {
    DMA: "NH1",
  },
  "03878": {
    DMA: "NH1",
  },
  "03884": {
    DMA: "NH1",
  },
  "03887": {
    DMA: "NH1",
  },
  "03601": {
    DMA: "NH1",
  },
  "03603": {
    DMA: "NH1",
  },
  "03743": {
    DMA: "NH1",
  },
  "03745": {
    DMA: "NH1",
  },
  "03746": {
    DMA: "NH1",
  },
  "03751": {
    DMA: "NH1",
  },
  "03752": {
    DMA: "NH1",
  },
  "03753": {
    DMA: "NH1",
  },
  "03754": {
    DMA: "NH1",
  },
  "03605": {
    DMA: "NH1",
  },
  "03770": {
    DMA: "NH1",
  },
  "03773": {
    DMA: "NH1",
  },
  "03781": {
    DMA: "NH1",
  },
  "03607": {
    DMA: "NH1",
  },
  "03284": {
    DMA: "NH1",
  },
  "03782": {
    DMA: "NH1",
  },
  "03280": {
    DMA: "NH1",
  },
  "08201": {
    DMA: "NJ1",
  },
  "08205": {
    DMA: "NJ1",
  },
  "08401": {
    DMA: "NJ1",
  },
  "08404": {
    DMA: "NJ1",
  },
  "08405": {
    DMA: "NJ1",
  },
  "08203": {
    DMA: "NJ1",
  },
  "08310": {
    DMA: "NJ1",
  },
  "08213": {
    DMA: "NJ1",
  },
  "08317": {
    DMA: "NJ1",
  },
  "08215": {
    DMA: "NJ1",
  },
  "08234": {
    DMA: "NJ1",
  },
  "08217": {
    DMA: "NJ1",
  },
  "08319": {
    DMA: "NJ1",
  },
  "08037": {
    DMA: "NJ1",
  },
  "08326": {
    DMA: "NJ1",
  },
  "08220": {
    DMA: "NJ1",
  },
  "08221": {
    DMA: "NJ1",
  },
  "08403": {
    DMA: "NJ1",
  },
  "08402": {
    DMA: "NJ1",
  },
  "08330": {
    DMA: "NJ1",
  },
  "08340": {
    DMA: "NJ1",
  },
  "08341": {
    DMA: "NJ1",
  },
  "08342": {
    DMA: "NJ1",
  },
  "08346": {
    DMA: "NJ1",
  },
  "08225": {
    DMA: "NJ1",
  },
  "08231": {
    DMA: "NJ1",
  },
  "08232": {
    DMA: "NJ1",
  },
  "08240": {
    DMA: "NJ1",
  },
  "08241": {
    DMA: "NJ1",
  },
  "08350": {
    DMA: "NJ1",
  },
  "08244": {
    DMA: "NJ1",
  },
  "08406": {
    DMA: "NJ1",
  },
  "07401": {
    DMA: "NJ1",
  },
  "07620": {
    DMA: "NJ1",
  },
  "07621": {
    DMA: "NJ1",
  },
  "07603": {
    DMA: "NJ1",
  },
  "07072": {
    DMA: "NJ1",
  },
  "07010": {
    DMA: "NJ1",
  },
  "07624": {
    DMA: "NJ1",
  },
  "07626": {
    DMA: "NJ1",
  },
  "07627": {
    DMA: "NJ1",
  },
  "07628": {
    DMA: "NJ1",
  },
  "07073": {
    DMA: "NJ1",
  },
  "07020": {
    DMA: "NJ1",
  },
  "07407": {
    DMA: "NJ1",
  },
  "07630": {
    DMA: "NJ1",
  },
  "07631": {
    DMA: "NJ1",
  },
  "07632": {
    DMA: "NJ1",
  },
  "07410": {
    DMA: "NJ1",
  },
  "07022": {
    DMA: "NJ1",
  },
  "07024": {
    DMA: "NJ1",
  },
  "07417": {
    DMA: "NJ1",
  },
  "07026": {
    DMA: "NJ1",
  },
  "07452": {
    DMA: "NJ1",
  },
  "07601": {
    DMA: "NJ1",
  },
  "07602": {
    DMA: "NJ1",
  },
  "07640": {
    DMA: "NJ1",
  },
  "07604": {
    DMA: "NJ1",
  },
  "07641": {
    DMA: "NJ1",
  },
  "07642": {
    DMA: "NJ1",
  },
  "07423": {
    DMA: "NJ1",
  },
  "07605": {
    DMA: "NJ1",
  },
  "07643": {
    DMA: "NJ1",
  },
  "07644": {
    DMA: "NJ1",
  },
  "07071": {
    DMA: "NJ1",
  },
  "07430": {
    DMA: "NJ1",
  },
  "07495": {
    DMA: "NJ1",
  },
  "07607": {
    DMA: "NJ1",
  },
  "07432": {
    DMA: "NJ1",
  },
  "07645": {
    DMA: "NJ1",
  },
  "07074": {
    DMA: "NJ1",
  },
  "07646": {
    DMA: "NJ1",
  },
  "07031": {
    DMA: "NJ1",
  },
  "07647": {
    DMA: "NJ1",
  },
  "07648": {
    DMA: "NJ1",
  },
  "07436": {
    DMA: "NJ1",
  },
  "07649": {
    DMA: "NJ1",
  },
  "07650": {
    DMA: "NJ1",
  },
  "07652": {
    DMA: "NJ1",
  },
  "07653": {
    DMA: "NJ1",
  },
  "07656": {
    DMA: "NJ1",
  },
  "07446": {
    DMA: "NJ1",
  },
  "07657": {
    DMA: "NJ1",
  },
  "07660": {
    DMA: "NJ1",
  },
  "07450": {
    DMA: "NJ1",
  },
  "07451": {
    DMA: "NJ1",
  },
  "07661": {
    DMA: "NJ1",
  },
  "07662": {
    DMA: "NJ1",
  },
  "07070": {
    DMA: "NJ1",
  },
  "07663": {
    DMA: "NJ1",
  },
  "07458": {
    DMA: "NJ1",
  },
  "07606": {
    DMA: "NJ1",
  },
  "07666": {
    DMA: "NJ1",
  },
  "07670": {
    DMA: "NJ1",
  },
  "07608": {
    DMA: "NJ1",
  },
  "07699": {
    DMA: "NJ1",
  },
  "07676": {
    DMA: "NJ1",
  },
  "07463": {
    DMA: "NJ1",
  },
  "07057": {
    DMA: "NJ1",
  },
  "07675": {
    DMA: "NJ1",
  },
  "07075": {
    DMA: "NJ1",
  },
  "07677": {
    DMA: "NJ1",
  },
  "07481": {
    DMA: "NJ1",
  },
  "08010": {
    DMA: "NJ1",
  },
  "08011": {
    DMA: "NJ1",
  },
  "08505": {
    DMA: "NJ1",
  },
  "08015": {
    DMA: "NJ1",
  },
  "08016": {
    DMA: "NJ1",
  },
  "08019": {
    DMA: "NJ1",
  },
  "08515": {
    DMA: "NJ1",
  },
  "08022": {
    DMA: "NJ1",
  },
  "08511": {
    DMA: "NJ1",
  },
  "08518": {
    DMA: "NJ1",
  },
  "08036": {
    DMA: "NJ1",
  },
  "08041": {
    DMA: "NJ1",
  },
  "08640": {
    DMA: "NJ1",
  },
  "08641": {
    DMA: "NJ1",
  },
  "08042": {
    DMA: "NJ1",
  },
  "08048": {
    DMA: "NJ1",
  },
  "08052": {
    DMA: "NJ1",
  },
  "08053": {
    DMA: "NJ1",
  },
  "08055": {
    DMA: "NJ1",
  },
  "08057": {
    DMA: "NJ1",
  },
  "08060": {
    DMA: "NJ1",
  },
  "08054": {
    DMA: "NJ1",
  },
  "08224": {
    DMA: "NJ1",
  },
  "08064": {
    DMA: "NJ1",
  },
  "08065": {
    DMA: "NJ1",
  },
  "08068": {
    DMA: "NJ1",
  },
  "08073": {
    DMA: "NJ1",
  },
  "08075": {
    DMA: "NJ1",
  },
  "08076": {
    DMA: "NJ1",
  },
  "08077": {
    DMA: "NJ1",
  },
  "08554": {
    DMA: "NJ1",
  },
  "08088": {
    DMA: "NJ1",
  },
  "08046": {
    DMA: "NJ1",
  },
  "08562": {
    DMA: "NJ1",
  },
  "08004": {
    DMA: "NJ1",
  },
  "08106": {
    DMA: "NJ1",
  },
  "08007": {
    DMA: "NJ1",
  },
  "08031": {
    DMA: "NJ1",
  },
  "08099": {
    DMA: "NJ1",
  },
  "08009": {
    DMA: "NJ1",
  },
  "08012": {
    DMA: "NJ1",
  },
  "08101": {
    DMA: "NJ1",
  },
  "08102": {
    DMA: "NJ1",
  },
  "08103": {
    DMA: "NJ1",
  },
  "08104": {
    DMA: "NJ1",
  },
  "08105": {
    DMA: "NJ1",
  },
  "08018": {
    DMA: "NJ1",
  },
  "08002": {
    DMA: "NJ1",
  },
  "08003": {
    DMA: "NJ1",
  },
  "08034": {
    DMA: "NJ1",
  },
  "08021": {
    DMA: "NJ1",
  },
  "08108": {
    DMA: "NJ1",
  },
  "08026": {
    DMA: "NJ1",
  },
  "08029": {
    DMA: "NJ1",
  },
  "08030": {
    DMA: "NJ1",
  },
  "08035": {
    DMA: "NJ1",
  },
  "08033": {
    DMA: "NJ1",
  },
  "08045": {
    DMA: "NJ1",
  },
  "08049": {
    DMA: "NJ1",
  },
  "08109": {
    DMA: "NJ1",
  },
  "08059": {
    DMA: "NJ1",
  },
  "08107": {
    DMA: "NJ1",
  },
  "08110": {
    DMA: "NJ1",
  },
  "08078": {
    DMA: "NJ1",
  },
  "08081": {
    DMA: "NJ1",
  },
  "08083": {
    DMA: "NJ1",
  },
  "08084": {
    DMA: "NJ1",
  },
  "08043": {
    DMA: "NJ1",
  },
  "08089": {
    DMA: "NJ1",
  },
  "08091": {
    DMA: "NJ1",
  },
  "08095": {
    DMA: "NJ1",
  },
  "08202": {
    DMA: "NJ1",
  },
  "08204": {
    DMA: "NJ1",
  },
  "08210": {
    DMA: "NJ1",
  },
  "08212": {
    DMA: "NJ1",
  },
  "08214": {
    DMA: "NJ1",
  },
  "08218": {
    DMA: "NJ1",
  },
  "08219": {
    DMA: "NJ1",
  },
  "08223": {
    DMA: "NJ1",
  },
  "08226": {
    DMA: "NJ1",
  },
  "08230": {
    DMA: "NJ1",
  },
  "08242": {
    DMA: "NJ1",
  },
  "08243": {
    DMA: "NJ1",
  },
  "08245": {
    DMA: "NJ1",
  },
  "08246": {
    DMA: "NJ1",
  },
  "08247": {
    DMA: "NJ1",
  },
  "08248": {
    DMA: "NJ1",
  },
  "08250": {
    DMA: "NJ1",
  },
  "08251": {
    DMA: "NJ1",
  },
  "08252": {
    DMA: "NJ1",
  },
  "08260": {
    DMA: "NJ1",
  },
  "08270": {
    DMA: "NJ1",
  },
  "08302": {
    DMA: "NJ1",
  },
  "08311": {
    DMA: "NJ1",
  },
  "08313": {
    DMA: "NJ1",
  },
  "08314": {
    DMA: "NJ1",
  },
  "08315": {
    DMA: "NJ1",
  },
  "08316": {
    DMA: "NJ1",
  },
  "08320": {
    DMA: "NJ1",
  },
  "08321": {
    DMA: "NJ1",
  },
  "08323": {
    DMA: "NJ1",
  },
  "08324": {
    DMA: "NJ1",
  },
  "08327": {
    DMA: "NJ1",
  },
  "08329": {
    DMA: "NJ1",
  },
  "08332": {
    DMA: "NJ1",
  },
  "08345": {
    DMA: "NJ1",
  },
  "08348": {
    DMA: "NJ1",
  },
  "08349": {
    DMA: "NJ1",
  },
  "08352": {
    DMA: "NJ1",
  },
  "08353": {
    DMA: "NJ1",
  },
  "08360": {
    DMA: "NJ1",
  },
  "08361": {
    DMA: "NJ1",
  },
  "08362": {
    DMA: "NJ1",
  },
  "07109": {
    DMA: "NJ1",
  },
  "07003": {
    DMA: "NJ1",
  },
  "07006": {
    DMA: "NJ1",
  },
  "07007": {
    DMA: "NJ1",
  },
  "07009": {
    DMA: "NJ1",
  },
  "07017": {
    DMA: "NJ1",
  },
  "07018": {
    DMA: "NJ1",
  },
  "07019": {
    DMA: "NJ1",
  },
  "07021": {
    DMA: "NJ1",
  },
  "07004": {
    DMA: "NJ1",
  },
  "07028": {
    DMA: "NJ1",
  },
  "07111": {
    DMA: "NJ1",
  },
  "07039": {
    DMA: "NJ1",
  },
  "07040": {
    DMA: "NJ1",
  },
  "07041": {
    DMA: "NJ1",
  },
  "07042": {
    DMA: "NJ1",
  },
  "07043": {
    DMA: "NJ1",
  },
  "07101": {
    DMA: "NJ1",
  },
  "07102": {
    DMA: "NJ1",
  },
  "07103": {
    DMA: "NJ1",
  },
  "07104": {
    DMA: "NJ1",
  },
  "07105": {
    DMA: "NJ1",
  },
  "07106": {
    DMA: "NJ1",
  },
  "07107": {
    DMA: "NJ1",
  },
  "07108": {
    DMA: "NJ1",
  },
  "07112": {
    DMA: "NJ1",
  },
  "07114": {
    DMA: "NJ1",
  },
  "07175": {
    DMA: "NJ1",
  },
  "07182": {
    DMA: "NJ1",
  },
  "07184": {
    DMA: "NJ1",
  },
  "07188": {
    DMA: "NJ1",
  },
  "07189": {
    DMA: "NJ1",
  },
  "07191": {
    DMA: "NJ1",
  },
  "07192": {
    DMA: "NJ1",
  },
  "07193": {
    DMA: "NJ1",
  },
  "07194": {
    DMA: "NJ1",
  },
  "07195": {
    DMA: "NJ1",
  },
  "07198": {
    DMA: "NJ1",
  },
  "07199": {
    DMA: "NJ1",
  },
  "07110": {
    DMA: "NJ1",
  },
  "07050": {
    DMA: "NJ1",
  },
  "07051": {
    DMA: "NJ1",
  },
  "07068": {
    DMA: "NJ1",
  },
  "07078": {
    DMA: "NJ1",
  },
  "07079": {
    DMA: "NJ1",
  },
  "07044": {
    DMA: "NJ1",
  },
  "07052": {
    DMA: "NJ1",
  },
  "08014": {
    DMA: "NJ1",
  },
  "08020": {
    DMA: "NJ1",
  },
  "08312": {
    DMA: "NJ1",
  },
  "08025": {
    DMA: "NJ1",
  },
  "08322": {
    DMA: "NJ1",
  },
  "08027": {
    DMA: "NJ1",
  },
  "08028": {
    DMA: "NJ1",
  },
  "08032": {
    DMA: "NJ1",
  },
  "08039": {
    DMA: "NJ1",
  },
  "08328": {
    DMA: "NJ1",
  },
  "08051": {
    DMA: "NJ1",
  },
  "08056": {
    DMA: "NJ1",
  },
  "08343": {
    DMA: "NJ1",
  },
  "08061": {
    DMA: "NJ1",
  },
  "08062": {
    DMA: "NJ1",
  },
  "08063": {
    DMA: "NJ1",
  },
  "08344": {
    DMA: "NJ1",
  },
  "08066": {
    DMA: "NJ1",
  },
  "08071": {
    DMA: "NJ1",
  },
  "08074": {
    DMA: "NJ1",
  },
  "08080": {
    DMA: "NJ1",
  },
  "08085": {
    DMA: "NJ1",
  },
  "08086": {
    DMA: "NJ1",
  },
  "08090": {
    DMA: "NJ1",
  },
  "08093": {
    DMA: "NJ1",
  },
  "08094": {
    DMA: "NJ1",
  },
  "08096": {
    DMA: "NJ1",
  },
  "08097": {
    DMA: "NJ1",
  },
  "07002": {
    DMA: "NJ1",
  },
  "07029": {
    DMA: "NJ1",
  },
  "07030": {
    DMA: "NJ1",
  },
  "07097": {
    DMA: "NJ1",
  },
  "07302": {
    DMA: "NJ1",
  },
  "07303": {
    DMA: "NJ1",
  },
  "07304": {
    DMA: "NJ1",
  },
  "07305": {
    DMA: "NJ1",
  },
  "07306": {
    DMA: "NJ1",
  },
  "07307": {
    DMA: "NJ1",
  },
  "07308": {
    DMA: "NJ1",
  },
  "07309": {
    DMA: "NJ1",
  },
  "07310": {
    DMA: "NJ1",
  },
  "07311": {
    DMA: "NJ1",
  },
  "07395": {
    DMA: "NJ1",
  },
  "07399": {
    DMA: "NJ1",
  },
  "07032": {
    DMA: "NJ1",
  },
  "07099": {
    DMA: "NJ1",
  },
  "07047": {
    DMA: "NJ1",
  },
  "07094": {
    DMA: "NJ1",
  },
  "07096": {
    DMA: "NJ1",
  },
  "07087": {
    DMA: "NJ1",
  },
  "07086": {
    DMA: "NJ1",
  },
  "07093": {
    DMA: "NJ1",
  },
  "08801": {
    DMA: "NJ1",
  },
  "08802": {
    DMA: "NJ1",
  },
  "08803": {
    DMA: "NJ1",
  },
  "08804": {
    DMA: "NJ1",
  },
  "07830": {
    DMA: "NJ1",
  },
  "08809": {
    DMA: "NJ1",
  },
  "08822": {
    DMA: "NJ1",
  },
  "08825": {
    DMA: "NJ1",
  },
  "08826": {
    DMA: "NJ1",
  },
  "08827": {
    DMA: "NJ1",
  },
  "08829": {
    DMA: "NJ1",
  },
  "08530": {
    DMA: "NJ1",
  },
  "08833": {
    DMA: "NJ1",
  },
  "08834": {
    DMA: "NJ1",
  },
  "08848": {
    DMA: "NJ1",
  },
  "08858": {
    DMA: "NJ1",
  },
  "08867": {
    DMA: "NJ1",
  },
  "07979": {
    DMA: "NJ1",
  },
  "08868": {
    DMA: "NJ1",
  },
  "08870": {
    DMA: "NJ1",
  },
  "08551": {
    DMA: "NJ1",
  },
  "08556": {
    DMA: "NJ1",
  },
  "08557": {
    DMA: "NJ1",
  },
  "08885": {
    DMA: "NJ1",
  },
  "08559": {
    DMA: "NJ1",
  },
  "08887": {
    DMA: "NJ1",
  },
  "08888": {
    DMA: "NJ1",
  },
  "08889": {
    DMA: "NJ1",
  },
  "08512": {
    DMA: "NJ1",
  },
  "08520": {
    DMA: "NJ1",
  },
  "08525": {
    DMA: "NJ1",
  },
  "08648": {
    DMA: "NJ1",
  },
  "08534": {
    DMA: "NJ1",
  },
  "08540": {
    DMA: "NJ1",
  },
  "08541": {
    DMA: "NJ1",
  },
  "08542": {
    DMA: "NJ1",
  },
  "08543": {
    DMA: "NJ1",
  },
  "08544": {
    DMA: "NJ1",
  },
  "08550": {
    DMA: "NJ1",
  },
  "08691": {
    DMA: "NJ1",
  },
  "08560": {
    DMA: "NJ1",
  },
  "08601": {
    DMA: "NJ1",
  },
  "08602": {
    DMA: "NJ1",
  },
  "08603": {
    DMA: "NJ1",
  },
  "08604": {
    DMA: "NJ1",
  },
  "08605": {
    DMA: "NJ1",
  },
  "08606": {
    DMA: "NJ1",
  },
  "08607": {
    DMA: "NJ1",
  },
  "08608": {
    DMA: "NJ1",
  },
  "08609": {
    DMA: "NJ1",
  },
  "08610": {
    DMA: "NJ1",
  },
  "08611": {
    DMA: "NJ1",
  },
  "08618": {
    DMA: "NJ1",
  },
  "08619": {
    DMA: "NJ1",
  },
  "08620": {
    DMA: "NJ1",
  },
  "08625": {
    DMA: "NJ1",
  },
  "08628": {
    DMA: "NJ1",
  },
  "08629": {
    DMA: "NJ1",
  },
  "08638": {
    DMA: "NJ1",
  },
  "08645": {
    DMA: "NJ1",
  },
  "08646": {
    DMA: "NJ1",
  },
  "08647": {
    DMA: "NJ1",
  },
  "08650": {
    DMA: "NJ1",
  },
  "08666": {
    DMA: "NJ1",
  },
  "08690": {
    DMA: "NJ1",
  },
  "08695": {
    DMA: "NJ1",
  },
  "08561": {
    DMA: "NJ1",
  },
  "07001": {
    DMA: "NJ1",
  },
  "07008": {
    DMA: "NJ1",
  },
  "07067": {
    DMA: "NJ1",
  },
  "08810": {
    DMA: "NJ1",
  },
  "08812": {
    DMA: "NJ1",
  },
  "08816": {
    DMA: "NJ1",
  },
  "08817": {
    DMA: "NJ1",
  },
  "08818": {
    DMA: "NJ1",
  },
  "08820": {
    DMA: "NJ1",
  },
  "08837": {
    DMA: "NJ1",
  },
  "08899": {
    DMA: "NJ1",
  },
  "08863": {
    DMA: "NJ1",
  },
  "08828": {
    DMA: "NJ1",
  },
  "08904": {
    DMA: "NJ1",
  },
  "08830": {
    DMA: "NJ1",
  },
  "08832": {
    DMA: "NJ1",
  },
  "08824": {
    DMA: "NJ1",
  },
  "08840": {
    DMA: "NJ1",
  },
  "08846": {
    DMA: "NJ1",
  },
  "08850": {
    DMA: "NJ1",
  },
  "08852": {
    DMA: "NJ1",
  },
  "08831": {
    DMA: "NJ1",
  },
  "08901": {
    DMA: "NJ1",
  },
  "08903": {
    DMA: "NJ1",
  },
  "08905": {
    DMA: "NJ1",
  },
  "08906": {
    DMA: "NJ1",
  },
  "08922": {
    DMA: "NJ1",
  },
  "08933": {
    DMA: "NJ1",
  },
  "08988": {
    DMA: "NJ1",
  },
  "08989": {
    DMA: "NJ1",
  },
  "08902": {
    DMA: "NJ1",
  },
  "08857": {
    DMA: "NJ1",
  },
  "08859": {
    DMA: "NJ1",
  },
  "08861": {
    DMA: "NJ1",
  },
  "08862": {
    DMA: "NJ1",
  },
  "08854": {
    DMA: "NJ1",
  },
  "08855": {
    DMA: "NJ1",
  },
  "08536": {
    DMA: "NJ1",
  },
  "07064": {
    DMA: "NJ1",
  },
  "08871": {
    DMA: "NJ1",
  },
  "08872": {
    DMA: "NJ1",
  },
  "07077": {
    DMA: "NJ1",
  },
  "08879": {
    DMA: "NJ1",
  },
  "07080": {
    DMA: "NJ1",
  },
  "08882": {
    DMA: "NJ1",
  },
  "08884": {
    DMA: "NJ1",
  },
  "07095": {
    DMA: "NJ1",
  },
  "07710": {
    DMA: "NJ1",
  },
  "07711": {
    DMA: "NJ1",
  },
  "08501": {
    DMA: "NJ1",
  },
  "08720": {
    DMA: "NJ1",
  },
  "07712": {
    DMA: "NJ1",
  },
  "07716": {
    DMA: "NJ1",
  },
  "07717": {
    DMA: "NJ1",
  },
  "07718": {
    DMA: "NJ1",
  },
  "07715": {
    DMA: "NJ1",
  },
  "07719": {
    DMA: "NJ1",
  },
  "07720": {
    DMA: "NJ1",
  },
  "08730": {
    DMA: "NJ1",
  },
  "07721": {
    DMA: "NJ1",
  },
  "07722": {
    DMA: "NJ1",
  },
  "08514": {
    DMA: "NJ1",
  },
  "07723": {
    DMA: "NJ1",
  },
  "07724": {
    DMA: "NJ1",
  },
  "07799": {
    DMA: "NJ1",
  },
  "07726": {
    DMA: "NJ1",
  },
  "07704": {
    DMA: "NJ1",
  },
  "07727": {
    DMA: "NJ1",
  },
  "07703": {
    DMA: "NJ1",
  },
  "07728": {
    DMA: "NJ1",
  },
  "07730": {
    DMA: "NJ1",
  },
  "07732": {
    DMA: "NJ1",
  },
  "07733": {
    DMA: "NJ1",
  },
  "07731": {
    DMA: "NJ1",
  },
  "08526": {
    DMA: "NJ1",
  },
  "07734": {
    DMA: "NJ1",
  },
  "07735": {
    DMA: "NJ1",
  },
  "07737": {
    DMA: "NJ1",
  },
  "07738": {
    DMA: "NJ1",
  },
  "07739": {
    DMA: "NJ1",
  },
  "07740": {
    DMA: "NJ1",
  },
  "08736": {
    DMA: "NJ1",
  },
  "07746": {
    DMA: "NJ1",
  },
  "07747": {
    DMA: "NJ1",
  },
  "07748": {
    DMA: "NJ1",
  },
  "08510": {
    DMA: "NJ1",
  },
  "08535": {
    DMA: "NJ1",
  },
  "07750": {
    DMA: "NJ1",
  },
  "07751": {
    DMA: "NJ1",
  },
  "07752": {
    DMA: "NJ1",
  },
  "07753": {
    DMA: "NJ1",
  },
  "07754": {
    DMA: "NJ1",
  },
  "07755": {
    DMA: "NJ1",
  },
  "07756": {
    DMA: "NJ1",
  },
  "07757": {
    DMA: "NJ1",
  },
  "07758": {
    DMA: "NJ1",
  },
  "07701": {
    DMA: "NJ1",
  },
  "07709": {
    DMA: "NJ1",
  },
  "08555": {
    DMA: "NJ1",
  },
  "07760": {
    DMA: "NJ1",
  },
  "08750": {
    DMA: "NJ1",
  },
  "07702": {
    DMA: "NJ1",
  },
  "07762": {
    DMA: "NJ1",
  },
  "07763": {
    DMA: "NJ1",
  },
  "07764": {
    DMA: "NJ1",
  },
  "07765": {
    DMA: "NJ1",
  },
  "07005": {
    DMA: "NJ1",
  },
  "07926": {
    DMA: "NJ1",
  },
  "07828": {
    DMA: "NJ1",
  },
  "07405": {
    DMA: "NJ1",
  },
  "07927": {
    DMA: "NJ1",
  },
  "07928": {
    DMA: "NJ1",
  },
  "07930": {
    DMA: "NJ1",
  },
  "07961": {
    DMA: "NJ1",
  },
  "07834": {
    DMA: "NJ1",
  },
  "07801": {
    DMA: "NJ1",
  },
  "07802": {
    DMA: "NJ1",
  },
  "07936": {
    DMA: "NJ1",
  },
  "07836": {
    DMA: "NJ1",
  },
  "07932": {
    DMA: "NJ1",
  },
  "07933": {
    DMA: "NJ1",
  },
  "07935": {
    DMA: "NJ1",
  },
  "07842": {
    DMA: "NJ1",
  },
  "07845": {
    DMA: "NJ1",
  },
  "07847": {
    DMA: "NJ1",
  },
  "07034": {
    DMA: "NJ1",
  },
  "07849": {
    DMA: "NJ1",
  },
  "07850": {
    DMA: "NJ1",
  },
  "07852": {
    DMA: "NJ1",
  },
  "07035": {
    DMA: "NJ1",
  },
  "07853": {
    DMA: "NJ1",
  },
  "07940": {
    DMA: "NJ1",
  },
  "07945": {
    DMA: "NJ1",
  },
  "07946": {
    DMA: "NJ1",
  },
  "07803": {
    DMA: "NJ1",
  },
  "07045": {
    DMA: "NJ1",
  },
  "07950": {
    DMA: "NJ1",
  },
  "07960": {
    DMA: "NJ1",
  },
  "07962": {
    DMA: "NJ1",
  },
  "07963": {
    DMA: "NJ1",
  },
  "07856": {
    DMA: "NJ1",
  },
  "07970": {
    DMA: "NJ1",
  },
  "07878": {
    DMA: "NJ1",
  },
  "07046": {
    DMA: "NJ1",
  },
  "07857": {
    DMA: "NJ1",
  },
  "07976": {
    DMA: "NJ1",
  },
  "07438": {
    DMA: "NJ1",
  },
  "07054": {
    DMA: "NJ1",
  },
  "07440": {
    DMA: "NJ1",
  },
  "07806": {
    DMA: "NJ1",
  },
  "07058": {
    DMA: "NJ1",
  },
  "07444": {
    DMA: "NJ1",
  },
  "07869": {
    DMA: "NJ1",
  },
  "07457": {
    DMA: "NJ1",
  },
  "07866": {
    DMA: "NJ1",
  },
  "07870": {
    DMA: "NJ1",
  },
  "07980": {
    DMA: "NJ1",
  },
  "07876": {
    DMA: "NJ1",
  },
  "07082": {
    DMA: "NJ1",
  },
  "07885": {
    DMA: "NJ1",
  },
  "07981": {
    DMA: "NJ1",
  },
  "07983": {
    DMA: "NJ1",
  },
  "07999": {
    DMA: "NJ1",
  },
  "08005": {
    DMA: "NJ1",
  },
  "08006": {
    DMA: "NJ1",
  },
  "08721": {
    DMA: "NJ1",
  },
  "08008": {
    DMA: "NJ1",
  },
  "08722": {
    DMA: "NJ1",
  },
  "08723": {
    DMA: "NJ1",
  },
  "08724": {
    DMA: "NJ1",
  },
  "08731": {
    DMA: "NJ1",
  },
  "08732": {
    DMA: "NJ1",
  },
  "08527": {
    DMA: "NJ1",
  },
  "08733": {
    DMA: "NJ1",
  },
  "08701": {
    DMA: "NJ1",
  },
  "08734": {
    DMA: "NJ1",
  },
  "08735": {
    DMA: "NJ1",
  },
  "08050": {
    DMA: "NJ1",
  },
  "08759": {
    DMA: "NJ1",
  },
  "08738": {
    DMA: "NJ1",
  },
  "08533": {
    DMA: "NJ1",
  },
  "08739": {
    DMA: "NJ1",
  },
  "08740": {
    DMA: "NJ1",
  },
  "08741": {
    DMA: "NJ1",
  },
  "08742": {
    DMA: "NJ1",
  },
  "08751": {
    DMA: "NJ1",
  },
  "08752": {
    DMA: "NJ1",
  },
  "08753": {
    DMA: "NJ1",
  },
  "08754": {
    DMA: "NJ1",
  },
  "08755": {
    DMA: "NJ1",
  },
  "08756": {
    DMA: "NJ1",
  },
  "08757": {
    DMA: "NJ1",
  },
  "08087": {
    DMA: "NJ1",
  },
  "08758": {
    DMA: "NJ1",
  },
  "08092": {
    DMA: "NJ1",
  },
  "07403": {
    DMA: "NJ1",
  },
  "07011": {
    DMA: "NJ1",
  },
  "07012": {
    DMA: "NJ1",
  },
  "07013": {
    DMA: "NJ1",
  },
  "07014": {
    DMA: "NJ1",
  },
  "07015": {
    DMA: "NJ1",
  },
  "07508": {
    DMA: "NJ1",
  },
  "07538": {
    DMA: "NJ1",
  },
  "07420": {
    DMA: "NJ1",
  },
  "07506": {
    DMA: "NJ1",
  },
  "07507": {
    DMA: "NJ1",
  },
  "07421": {
    DMA: "NJ1",
  },
  "07424": {
    DMA: "NJ1",
  },
  "07435": {
    DMA: "NJ1",
  },
  "07055": {
    DMA: "NJ1",
  },
  "07501": {
    DMA: "NJ1",
  },
  "07502": {
    DMA: "NJ1",
  },
  "07503": {
    DMA: "NJ1",
  },
  "07504": {
    DMA: "NJ1",
  },
  "07505": {
    DMA: "NJ1",
  },
  "07509": {
    DMA: "NJ1",
  },
  "07510": {
    DMA: "NJ1",
  },
  "07513": {
    DMA: "NJ1",
  },
  "07514": {
    DMA: "NJ1",
  },
  "07522": {
    DMA: "NJ1",
  },
  "07524": {
    DMA: "NJ1",
  },
  "07533": {
    DMA: "NJ1",
  },
  "07543": {
    DMA: "NJ1",
  },
  "07544": {
    DMA: "NJ1",
  },
  "07442": {
    DMA: "NJ1",
  },
  "07456": {
    DMA: "NJ1",
  },
  "07511": {
    DMA: "NJ1",
  },
  "07512": {
    DMA: "NJ1",
  },
  "07465": {
    DMA: "NJ1",
  },
  "07470": {
    DMA: "NJ1",
  },
  "07474": {
    DMA: "NJ1",
  },
  "07477": {
    DMA: "NJ1",
  },
  "07480": {
    DMA: "NJ1",
  },
  "08001": {
    DMA: "NJ1",
  },
  "08023": {
    DMA: "NJ1",
  },
  "08318": {
    DMA: "NJ1",
  },
  "08038": {
    DMA: "NJ1",
  },
  "08347": {
    DMA: "NJ1",
  },
  "08067": {
    DMA: "NJ1",
  },
  "08069": {
    DMA: "NJ1",
  },
  "08070": {
    DMA: "NJ1",
  },
  "08072": {
    DMA: "NJ1",
  },
  "08079": {
    DMA: "NJ1",
  },
  "08098": {
    DMA: "NJ1",
  },
  "07920": {
    DMA: "NJ1",
  },
  "07921": {
    DMA: "NJ1",
  },
  "08502": {
    DMA: "NJ1",
  },
  "07924": {
    DMA: "NJ1",
  },
  "08504": {
    DMA: "NJ1",
  },
  "08805": {
    DMA: "NJ1",
  },
  "08807": {
    DMA: "NJ1",
  },
  "07931": {
    DMA: "NJ1",
  },
  "08821": {
    DMA: "NJ1",
  },
  "08823": {
    DMA: "NJ1",
  },
  "07934": {
    DMA: "NJ1",
  },
  "08844": {
    DMA: "NJ1",
  },
  "08528": {
    DMA: "NJ1",
  },
  "07938": {
    DMA: "NJ1",
  },
  "07939": {
    DMA: "NJ1",
  },
  "08835": {
    DMA: "NJ1",
  },
  "08836": {
    DMA: "NJ1",
  },
  "08853": {
    DMA: "NJ1",
  },
  "07977": {
    DMA: "NJ1",
  },
  "07978": {
    DMA: "NJ1",
  },
  "08869": {
    DMA: "NJ1",
  },
  "08553": {
    DMA: "NJ1",
  },
  "08558": {
    DMA: "NJ1",
  },
  "08873": {
    DMA: "NJ1",
  },
  "08875": {
    DMA: "NJ1",
  },
  "08876": {
    DMA: "NJ1",
  },
  "08880": {
    DMA: "NJ1",
  },
  "07059": {
    DMA: "NJ1",
  },
  "07069": {
    DMA: "NJ1",
  },
  "08890": {
    DMA: "NJ1",
  },
  "07821": {
    DMA: "NJ1",
  },
  "07822": {
    DMA: "NJ1",
  },
  "07826": {
    DMA: "NJ1",
  },
  "07890": {
    DMA: "NJ1",
  },
  "07416": {
    DMA: "NJ1",
  },
  "07837": {
    DMA: "NJ1",
  },
  "07418": {
    DMA: "NJ1",
  },
  "07839": {
    DMA: "NJ1",
  },
  "07419": {
    DMA: "NJ1",
  },
  "07422": {
    DMA: "NJ1",
  },
  "07843": {
    DMA: "NJ1",
  },
  "07848": {
    DMA: "NJ1",
  },
  "07851": {
    DMA: "NJ1",
  },
  "07428": {
    DMA: "NJ1",
  },
  "07855": {
    DMA: "NJ1",
  },
  "07827": {
    DMA: "NJ1",
  },
  "07860": {
    DMA: "NJ1",
  },
  "07439": {
    DMA: "NJ1",
  },
  "07871": {
    DMA: "NJ1",
  },
  "07874": {
    DMA: "NJ1",
  },
  "07875": {
    DMA: "NJ1",
  },
  "07460": {
    DMA: "NJ1",
  },
  "07461": {
    DMA: "NJ1",
  },
  "07877": {
    DMA: "NJ1",
  },
  "07879": {
    DMA: "NJ1",
  },
  "07462": {
    DMA: "NJ1",
  },
  "07881": {
    DMA: "NJ1",
  },
  "07922": {
    DMA: "NJ1",
  },
  "07066": {
    DMA: "NJ1",
  },
  "07016": {
    DMA: "NJ1",
  },
  "07201": {
    DMA: "NJ1",
  },
  "07202": {
    DMA: "NJ1",
  },
  "07207": {
    DMA: "NJ1",
  },
  "07208": {
    DMA: "NJ1",
  },
  "07206": {
    DMA: "NJ1",
  },
  "07023": {
    DMA: "NJ1",
  },
  "07027": {
    DMA: "NJ1",
  },
  "07205": {
    DMA: "NJ1",
  },
  "07033": {
    DMA: "NJ1",
  },
  "07036": {
    DMA: "NJ1",
  },
  "07092": {
    DMA: "NJ1",
  },
  "07974": {
    DMA: "NJ1",
  },
  "07060": {
    DMA: "NJ1",
  },
  "07061": {
    DMA: "NJ1",
  },
  "07062": {
    DMA: "NJ1",
  },
  "07063": {
    DMA: "NJ1",
  },
  "07065": {
    DMA: "NJ1",
  },
  "07203": {
    DMA: "NJ1",
  },
  "07204": {
    DMA: "NJ1",
  },
  "07076": {
    DMA: "NJ1",
  },
  "07081": {
    DMA: "NJ1",
  },
  "07901": {
    DMA: "NJ1",
  },
  "07902": {
    DMA: "NJ1",
  },
  "07083": {
    DMA: "NJ1",
  },
  "07088": {
    DMA: "NJ1",
  },
  "07090": {
    DMA: "NJ1",
  },
  "07091": {
    DMA: "NJ1",
  },
  "07820": {
    DMA: "NJ1",
  },
  "07823": {
    DMA: "NJ1",
  },
  "07825": {
    DMA: "NJ1",
  },
  "08808": {
    DMA: "NJ1",
  },
  "07829": {
    DMA: "NJ1",
  },
  "07831": {
    DMA: "NJ1",
  },
  "07832": {
    DMA: "NJ1",
  },
  "07833": {
    DMA: "NJ1",
  },
  "07838": {
    DMA: "NJ1",
  },
  "07840": {
    DMA: "NJ1",
  },
  "07844": {
    DMA: "NJ1",
  },
  "07846": {
    DMA: "NJ1",
  },
  "07863": {
    DMA: "NJ1",
  },
  "08865": {
    DMA: "NJ1",
  },
  "07865": {
    DMA: "NJ1",
  },
  "08886": {
    DMA: "NJ1",
  },
  "07880": {
    DMA: "NJ1",
  },
  "07882": {
    DMA: "NJ1",
  },
  "08644": {
    DMA: "NJ1",
  },
  "06390": {
    DMA: 501,
  },
  "00501": {
    DMA: 501,
  },
  "00544": {
    DMA: 501,
  },
  "00601": {
    DMA: "PR1",
  },
  "00602": {
    DMA: "PR1",
  },
  "00603": {
    DMA: "PR1",
  },
  "00690": {
    DMA: "PR1",
  },
  "00703": {
    DMA: "PR1",
  },
  "00705": {
    DMA: "PR1",
  },
  "00786": {
    DMA: "PR1",
  },
  "00610": {
    DMA: "PR1",
  },
  "00612": {
    DMA: "PR1",
  },
  "00616": {
    DMA: "PR1",
  },
  "00652": {
    DMA: "PR1",
  },
  "00688": {
    DMA: "PR1",
  },
  "00714": {
    DMA: "PR1",
  },
  "00617": {
    DMA: "PR1",
  },
  "00794": {
    DMA: "PR1",
  },
  "00958": {
    DMA: "PR1",
  },
  "00956": {
    DMA: "PR1",
  },
  "00957": {
    DMA: "PR1",
  },
  "00959": {
    DMA: "PR1",
  },
  "00960": {
    DMA: "PR1",
  },
  "00961": {
    DMA: "PR1",
  },
  "00622": {
    DMA: "PR1",
  },
  "00623": {
    DMA: "PR1",
  },
  "00725": {
    DMA: "PR1",
  },
  "00727": {
    DMA: "PR1",
  },
  "00627": {
    DMA: "PR1",
  },
  "00729": {
    DMA: "PR1",
  },
  "00981": {
    DMA: "PR1",
  },
  "00984": {
    DMA: "PR1",
  },
  "00986": {
    DMA: "PR1",
  },
  "00988": {
    DMA: "PR1",
  },
  "00979": {
    DMA: "PR1",
  },
  "00982": {
    DMA: "PR1",
  },
  "00983": {
    DMA: "PR1",
  },
  "00985": {
    DMA: "PR1",
  },
  "00987": {
    DMA: "PR1",
  },
  "00963": {
    DMA: "PR1",
  },
  "00962": {
    DMA: "PR1",
  },
  "00736": {
    DMA: "PR1",
  },
  "00735": {
    DMA: "PR1",
  },
  "00638": {
    DMA: "PR1",
  },
  "00739": {
    DMA: "PR1",
  },
  "00769": {
    DMA: "PR1",
  },
  "00782": {
    DMA: "PR1",
  },
  "00783": {
    DMA: "PR1",
  },
  "00775": {
    DMA: "PR1",
  },
  "00646": {
    DMA: "PR1",
  },
  "00950": {
    DMA: "PR1",
  },
  "00738": {
    DMA: "PR1",
  },
  "00740": {
    DMA: "PR1",
  },
  "00650": {
    DMA: "PR1",
  },
  "00647": {
    DMA: "PR1",
  },
  "00653": {
    DMA: "PR1",
  },
  "00784": {
    DMA: "PR1",
  },
  "00656": {
    DMA: "PR1",
  },
  "00934": {
    DMA: "PR1",
  },
  "00965": {
    DMA: "PR1",
  },
  "00966": {
    DMA: "PR1",
  },
  "00968": {
    DMA: "PR1",
  },
  "00969": {
    DMA: "PR1",
  },
  "00971": {
    DMA: "PR1",
  },
  "00778": {
    DMA: "PR1",
  },
  "00659": {
    DMA: "PR1",
  },
  "00660": {
    DMA: "PR1",
  },
  "00791": {
    DMA: "PR1",
  },
  "00741": {
    DMA: "PR1",
  },
  "00662": {
    DMA: "PR1",
  },
  "00664": {
    DMA: "PR1",
  },
  "00795": {
    DMA: "PR1",
  },
  "00777": {
    DMA: "PR1",
  },
  "00667": {
    DMA: "PR1",
  },
  "00631": {
    DMA: "PR1",
  },
  "00669": {
    DMA: "PR1",
  },
  "00670": {
    DMA: "PR1",
  },
  "00771": {
    DMA: "PR1",
  },
  "00772": {
    DMA: "PR1",
  },
  "00773": {
    DMA: "PR1",
  },
  "00674": {
    DMA: "PR1",
  },
  "00606": {
    DMA: "PR1",
  },
  "00707": {
    DMA: "PR1",
  },
  "00680": {
    DMA: "PR1",
  },
  "00682": {
    DMA: "PR1",
  },
  "00676": {
    DMA: "PR1",
  },
  "00687": {
    DMA: "PR1",
  },
  "00718": {
    DMA: "PR1",
  },
  "00719": {
    DMA: "PR1",
  },
  "00720": {
    DMA: "PR1",
  },
  "00723": {
    DMA: "PR1",
  },
  "00624": {
    DMA: "PR1",
  },
  "00780": {
    DMA: "PR1",
  },
  "00715": {
    DMA: "PR1",
  },
  "00716": {
    DMA: "PR1",
  },
  "00717": {
    DMA: "PR1",
  },
  "00728": {
    DMA: "PR1",
  },
  "00730": {
    DMA: "PR1",
  },
  "00731": {
    DMA: "PR1",
  },
  "00678": {
    DMA: "PR1",
  },
  "00677": {
    DMA: "PR1",
  },
  "00745": {
    DMA: "PR1",
  },
  "00637": {
    DMA: "PR1",
  },
  "00704": {
    DMA: "PR1",
  },
  "00751": {
    DMA: "PR1",
  },
  "00636": {
    DMA: "PR1",
  },
  "00683": {
    DMA: "PR1",
  },
  "00978": {
    DMA: "PR1",
  },
  "00929": {
    DMA: "PR1",
  },
  "00931": {
    DMA: "PR1",
  },
  "00933": {
    DMA: "PR1",
  },
  "00935": {
    DMA: "PR1",
  },
  "00937": {
    DMA: "PR1",
  },
  "00939": {
    DMA: "PR1",
  },
  "00955": {
    DMA: "PR1",
  },
  "00975": {
    DMA: "PR1",
  },
  "00901": {
    DMA: "PR1",
  },
  "00906": {
    DMA: "PR1",
  },
  "00907": {
    DMA: "PR1",
  },
  "00909": {
    DMA: "PR1",
  },
  "00911": {
    DMA: "PR1",
  },
  "00912": {
    DMA: "PR1",
  },
  "00913": {
    DMA: "PR1",
  },
  "00915": {
    DMA: "PR1",
  },
  "00917": {
    DMA: "PR1",
  },
  "00918": {
    DMA: "PR1",
  },
  "00920": {
    DMA: "PR1",
  },
  "00921": {
    DMA: "PR1",
  },
  "00923": {
    DMA: "PR1",
  },
  "00924": {
    DMA: "PR1",
  },
  "00925": {
    DMA: "PR1",
  },
  "00926": {
    DMA: "PR1",
  },
  "00927": {
    DMA: "PR1",
  },
  "00936": {
    DMA: "PR1",
  },
  "00754": {
    DMA: "PR1",
  },
  "00685": {
    DMA: "PR1",
  },
  "00757": {
    DMA: "PR1",
  },
  "00954": {
    DMA: "PR1",
  },
  "00953": {
    DMA: "PR1",
  },
  "00952": {
    DMA: "PR1",
  },
  "00949": {
    DMA: "PR1",
  },
  "00951": {
    DMA: "PR1",
  },
  "00976": {
    DMA: "PR1",
  },
  "00611": {
    DMA: "PR1",
  },
  "00641": {
    DMA: "PR1",
  },
  "00692": {
    DMA: "PR1",
  },
  "00693": {
    DMA: "PR1",
  },
  "00694": {
    DMA: "PR1",
  },
  "00765": {
    DMA: "PR1",
  },
  "00766": {
    DMA: "PR1",
  },
  "00767": {
    DMA: "PR1",
  },
  "00698": {
    DMA: "PR1",
  },
  "00604": {
    DMA: "PR1",
  },
  "00605": {
    DMA: "PR1",
  },
  "00613": {
    DMA: "PR1",
  },
  "00614": {
    DMA: "PR1",
  },
  "00726": {
    DMA: "PR1",
  },
  "00737": {
    DMA: "PR1",
  },
  "00785": {
    DMA: "PR1",
  },
  "00970": {
    DMA: "PR1",
  },
  "00792": {
    DMA: "PR1",
  },
  "00681": {
    DMA: "PR1",
  },
  "00721": {
    DMA: "PR1",
  },
  "00732": {
    DMA: "PR1",
  },
  "00733": {
    DMA: "PR1",
  },
  "00734": {
    DMA: "PR1",
  },
  "00744": {
    DMA: "PR1",
  },
  "00742": {
    DMA: "PR1",
  },
  "00902": {
    DMA: "PR1",
  },
  "00908": {
    DMA: "PR1",
  },
  "00910": {
    DMA: "PR1",
  },
  "00914": {
    DMA: "PR1",
  },
  "00916": {
    DMA: "PR1",
  },
  "00919": {
    DMA: "PR1",
  },
  "00922": {
    DMA: "PR1",
  },
  "00928": {
    DMA: "PR1",
  },
  "00930": {
    DMA: "PR1",
  },
  "00940": {
    DMA: "PR1",
  },
  "00977": {
    DMA: "PR1",
  },
  "02806": {
    DMA: "RI1",
  },
  "02809": {
    DMA: "RI1",
  },
  "02885": {
    DMA: "RI1",
  },
  "02816": {
    DMA: "RI1",
  },
  "02818": {
    DMA: "RI1",
  },
  "02827": {
    DMA: "RI1",
  },
  "02886": {
    DMA: "RI1",
  },
  "02887": {
    DMA: "RI1",
  },
  "02888": {
    DMA: "RI1",
  },
  "02889": {
    DMA: "RI1",
  },
  "02817": {
    DMA: "RI1",
  },
  "02893": {
    DMA: "RI1",
  },
  "02801": {
    DMA: "RI1",
  },
  "02835": {
    DMA: "RI1",
  },
  "02837": {
    DMA: "RI1",
  },
  "02842": {
    DMA: "RI1",
  },
  "02840": {
    DMA: "RI1",
  },
  "02841": {
    DMA: "RI1",
  },
  "02871": {
    DMA: "RI1",
  },
  "02872": {
    DMA: "RI1",
  },
  "02878": {
    DMA: "RI1",
  },
  "02802": {
    DMA: "RI1",
  },
  "02863": {
    DMA: "RI1",
  },
  "02814": {
    DMA: "RI1",
  },
  "02815": {
    DMA: "RI1",
  },
  "02910": {
    DMA: "RI1",
  },
  "02920": {
    DMA: "RI1",
  },
  "02921": {
    DMA: "RI1",
  },
  "02864": {
    DMA: "RI1",
  },
  "02914": {
    DMA: "RI1",
  },
  "02823": {
    DMA: "RI1",
  },
  "02824": {
    DMA: "RI1",
  },
  "02825": {
    DMA: "RI1",
  },
  "02826": {
    DMA: "RI1",
  },
  "02828": {
    DMA: "RI1",
  },
  "02829": {
    DMA: "RI1",
  },
  "02830": {
    DMA: "RI1",
  },
  "02831": {
    DMA: "RI1",
  },
  "02919": {
    DMA: "RI1",
  },
  "02865": {
    DMA: "RI1",
  },
  "02838": {
    DMA: "RI1",
  },
  "02839": {
    DMA: "RI1",
  },
  "02911": {
    DMA: "RI1",
  },
  "02857": {
    DMA: "RI1",
  },
  "02896": {
    DMA: "RI1",
  },
  "02858": {
    DMA: "RI1",
  },
  "02859": {
    DMA: "RI1",
  },
  "02860": {
    DMA: "RI1",
  },
  "02861": {
    DMA: "RI1",
  },
  "02862": {
    DMA: "RI1",
  },
  "02901": {
    DMA: "RI1",
  },
  "02902": {
    DMA: "RI1",
  },
  "02903": {
    DMA: "RI1",
  },
  "02904": {
    DMA: "RI1",
  },
  "02905": {
    DMA: "RI1",
  },
  "02906": {
    DMA: "RI1",
  },
  "02907": {
    DMA: "RI1",
  },
  "02908": {
    DMA: "RI1",
  },
  "02909": {
    DMA: "RI1",
  },
  "02912": {
    DMA: "RI1",
  },
  "02918": {
    DMA: "RI1",
  },
  "02940": {
    DMA: "RI1",
  },
  "02915": {
    DMA: "RI1",
  },
  "02916": {
    DMA: "RI1",
  },
  "02876": {
    DMA: "RI1",
  },
  "02917": {
    DMA: "RI1",
  },
  "02895": {
    DMA: "RI1",
  },
  "02804": {
    DMA: "RI1",
  },
  "02807": {
    DMA: "RI1",
  },
  "02808": {
    DMA: "RI1",
  },
  "02812": {
    DMA: "RI1",
  },
  "02813": {
    DMA: "RI1",
  },
  "02822": {
    DMA: "RI1",
  },
  "02832": {
    DMA: "RI1",
  },
  "02833": {
    DMA: "RI1",
  },
  "02836": {
    DMA: "RI1",
  },
  "02881": {
    DMA: "RI1",
  },
  "02882": {
    DMA: "RI1",
  },
  "02852": {
    DMA: "RI1",
  },
  "02854": {
    DMA: "RI1",
  },
  "02883": {
    DMA: "RI1",
  },
  "02873": {
    DMA: "RI1",
  },
  "02874": {
    DMA: "RI1",
  },
  "02875": {
    DMA: "RI1",
  },
  "02877": {
    DMA: "RI1",
  },
  "02879": {
    DMA: "RI1",
  },
  "02880": {
    DMA: "RI1",
  },
  "02892": {
    DMA: "RI1",
  },
  "02891": {
    DMA: "RI1",
  },
  "02894": {
    DMA: "RI1",
  },
  "02898": {
    DMA: "RI1",
  },
  "00820": {
    DMA: "VI1",
  },
  "00821": {
    DMA: "VI1",
  },
  "00822": {
    DMA: "VI1",
  },
  "00823": {
    DMA: "VI1",
  },
  "00824": {
    DMA: "VI1",
  },
  "00840": {
    DMA: "VI1",
  },
  "00841": {
    DMA: "VI1",
  },
  "00850": {
    DMA: "VI1",
  },
  "00851": {
    DMA: "VI1",
  },
  "00830": {
    DMA: "VI1",
  },
  "00831": {
    DMA: "VI1",
  },
  "00801": {
    DMA: "VI1",
  },
  "00802": {
    DMA: "VI1",
  },
  "00803": {
    DMA: "VI1",
  },
  "00804": {
    DMA: "VI1",
  },
  "00805": {
    DMA: "VI1",
  },
  "05734": {
    DMA: "VT1",
  },
  "05443": {
    DMA: "VT1",
  },
  "05740": {
    DMA: "VT1",
  },
  "05456": {
    DMA: "VT1",
  },
  "05747": {
    DMA: "VT1",
  },
  "05748": {
    DMA: "VT1",
  },
  "05753": {
    DMA: "VT1",
  },
  "05469": {
    DMA: "VT1",
  },
  "05472": {
    DMA: "VT1",
  },
  "05473": {
    DMA: "VT1",
  },
  "05760": {
    DMA: "VT1",
  },
  "05766": {
    DMA: "VT1",
  },
  "05769": {
    DMA: "VT1",
  },
  "05770": {
    DMA: "VT1",
  },
  "05487": {
    DMA: "VT1",
  },
  "05491": {
    DMA: "VT1",
  },
  "05778": {
    DMA: "VT1",
  },
  "05250": {
    DMA: "VT1",
  },
  "05201": {
    DMA: "VT1",
  },
  "05340": {
    DMA: "VT1",
  },
  "05251": {
    DMA: "VT1",
  },
  "05252": {
    DMA: "VT1",
  },
  "05253": {
    DMA: "VT1",
  },
  "05254": {
    DMA: "VT1",
  },
  "05255": {
    DMA: "VT1",
  },
  "05257": {
    DMA: "VT1",
  },
  "05260": {
    DMA: "VT1",
  },
  "05152": {
    DMA: "VT1",
  },
  "05261": {
    DMA: "VT1",
  },
  "05350": {
    DMA: "VT1",
  },
  "05768": {
    DMA: "VT1",
  },
  "05262": {
    DMA: "VT1",
  },
  "05352": {
    DMA: "VT1",
  },
  "05776": {
    DMA: "VT1",
  },
  "05821": {
    DMA: "VT1",
  },
  "05828": {
    DMA: "VT1",
  },
  "05832": {
    DMA: "VT1",
  },
  "05836": {
    DMA: "VT1",
  },
  "05042": {
    DMA: "VT1",
  },
  "05838": {
    DMA: "VT1",
  },
  "05046": {
    DMA: "VT1",
  },
  "05843": {
    DMA: "VT1",
  },
  "05848": {
    DMA: "VT1",
  },
  "05849": {
    DMA: "VT1",
  },
  "05850": {
    DMA: "VT1",
  },
  "05851": {
    DMA: "VT1",
  },
  "05050": {
    DMA: "VT1",
  },
  "05861": {
    DMA: "VT1",
  },
  "05862": {
    DMA: "VT1",
  },
  "05819": {
    DMA: "VT1",
  },
  "05863": {
    DMA: "VT1",
  },
  "05866": {
    DMA: "VT1",
  },
  "05069": {
    DMA: "VT1",
  },
  "05867": {
    DMA: "VT1",
  },
  "05871": {
    DMA: "VT1",
  },
  "05873": {
    DMA: "VT1",
  },
  "05401": {
    DMA: "VT1",
  },
  "05402": {
    DMA: "VT1",
  },
  "05405": {
    DMA: "VT1",
  },
  "05406": {
    DMA: "VT1",
  },
  "05408": {
    DMA: "VT1",
  },
  "05445": {
    DMA: "VT1",
  },
  "05439": {
    DMA: "VT1",
  },
  "05446": {
    DMA: "VT1",
  },
  "05449": {
    DMA: "VT1",
  },
  "05451": {
    DMA: "VT1",
  },
  "05452": {
    DMA: "VT1",
  },
  "05453": {
    DMA: "VT1",
  },
  "05461": {
    DMA: "VT1",
  },
  "05462": {
    DMA: "VT1",
  },
  "05465": {
    DMA: "VT1",
  },
  "05466": {
    DMA: "VT1",
  },
  "05468": {
    DMA: "VT1",
  },
  "05477": {
    DMA: "VT1",
  },
  "05482": {
    DMA: "VT1",
  },
  "05403": {
    DMA: "VT1",
  },
  "05407": {
    DMA: "VT1",
  },
  "05489": {
    DMA: "VT1",
  },
  "05490": {
    DMA: "VT1",
  },
  "05494": {
    DMA: "VT1",
  },
  "05495": {
    DMA: "VT1",
  },
  "05404": {
    DMA: "VT1",
  },
  "05901": {
    DMA: "VT1",
  },
  "05902": {
    DMA: "VT1",
  },
  "05903": {
    DMA: "VT1",
  },
  "05824": {
    DMA: "VT1",
  },
  "05837": {
    DMA: "VT1",
  },
  "05904": {
    DMA: "VT1",
  },
  "05840": {
    DMA: "VT1",
  },
  "05905": {
    DMA: "VT1",
  },
  "05846": {
    DMA: "VT1",
  },
  "05906": {
    DMA: "VT1",
  },
  "05858": {
    DMA: "VT1",
  },
  "05907": {
    DMA: "VT1",
  },
  "05441": {
    DMA: "VT1",
  },
  "05444": {
    DMA: "VT1",
  },
  "05447": {
    DMA: "VT1",
  },
  "05448": {
    DMA: "VT1",
  },
  "05450": {
    DMA: "VT1",
  },
  "05479": {
    DMA: "VT1",
  },
  "05454": {
    DMA: "VT1",
  },
  "05455": {
    DMA: "VT1",
  },
  "05457": {
    DMA: "VT1",
  },
  "05459": {
    DMA: "VT1",
  },
  "05460": {
    DMA: "VT1",
  },
  "05470": {
    DMA: "VT1",
  },
  "05471": {
    DMA: "VT1",
  },
  "05476": {
    DMA: "VT1",
  },
  "05478": {
    DMA: "VT1",
  },
  "05481": {
    DMA: "VT1",
  },
  "05483": {
    DMA: "VT1",
  },
  "05485": {
    DMA: "VT1",
  },
  "05488": {
    DMA: "VT1",
  },
  "05440": {
    DMA: "VT1",
  },
  "05458": {
    DMA: "VT1",
  },
  "05463": {
    DMA: "VT1",
  },
  "05474": {
    DMA: "VT1",
  },
  "05486": {
    DMA: "VT1",
  },
  "05442": {
    DMA: "VT1",
  },
  "05652": {
    DMA: "VT1",
  },
  "05653": {
    DMA: "VT1",
  },
  "05655": {
    DMA: "VT1",
  },
  "05464": {
    DMA: "VT1",
  },
  "05656": {
    DMA: "VT1",
  },
  "05657": {
    DMA: "VT1",
  },
  "05661": {
    DMA: "VT1",
  },
  "05662": {
    DMA: "VT1",
  },
  "05665": {
    DMA: "VT1",
  },
  "05672": {
    DMA: "VT1",
  },
  "05492": {
    DMA: "VT1",
  },
  "05680": {
    DMA: "VT1",
  },
  "05033": {
    DMA: "VT1",
  },
  "05036": {
    DMA: "VT1",
  },
  "05038": {
    DMA: "VT1",
  },
  "05039": {
    DMA: "VT1",
  },
  "05040": {
    DMA: "VT1",
  },
  "05041": {
    DMA: "VT1",
  },
  "05043": {
    DMA: "VT1",
  },
  "05045": {
    DMA: "VT1",
  },
  "05051": {
    DMA: "VT1",
  },
  "05054": {
    DMA: "VT1",
  },
  "05058": {
    DMA: "VT1",
  },
  "05060": {
    DMA: "VT1",
  },
  "05061": {
    DMA: "VT1",
  },
  "05070": {
    DMA: "VT1",
  },
  "05072": {
    DMA: "VT1",
  },
  "05074": {
    DMA: "VT1",
  },
  "05075": {
    DMA: "VT1",
  },
  "05076": {
    DMA: "VT1",
  },
  "05077": {
    DMA: "VT1",
  },
  "05079": {
    DMA: "VT1",
  },
  "05675": {
    DMA: "VT1",
  },
  "05081": {
    DMA: "VT1",
  },
  "05083": {
    DMA: "VT1",
  },
  "05085": {
    DMA: "VT1",
  },
  "05086": {
    DMA: "VT1",
  },
  "05679": {
    DMA: "VT1",
  },
  "05820": {
    DMA: "VT1",
  },
  "05822": {
    DMA: "VT1",
  },
  "05875": {
    DMA: "VT1",
  },
  "05823": {
    DMA: "VT1",
  },
  "05825": {
    DMA: "VT1",
  },
  "05826": {
    DMA: "VT1",
  },
  "05827": {
    DMA: "VT1",
  },
  "05829": {
    DMA: "VT1",
  },
  "05830": {
    DMA: "VT1",
  },
  "05833": {
    DMA: "VT1",
  },
  "05839": {
    DMA: "VT1",
  },
  "05841": {
    DMA: "VT1",
  },
  "05842": {
    DMA: "VT1",
  },
  "05845": {
    DMA: "VT1",
  },
  "05847": {
    DMA: "VT1",
  },
  "05853": {
    DMA: "VT1",
  },
  "05855": {
    DMA: "VT1",
  },
  "05857": {
    DMA: "VT1",
  },
  "05859": {
    DMA: "VT1",
  },
  "05860": {
    DMA: "VT1",
  },
  "05868": {
    DMA: "VT1",
  },
  "05872": {
    DMA: "VT1",
  },
  "05874": {
    DMA: "VT1",
  },
  "05730": {
    DMA: "VT1",
  },
  "05731": {
    DMA: "VT1",
  },
  "05732": {
    DMA: "VT1",
  },
  "05733": {
    DMA: "VT1",
  },
  "05735": {
    DMA: "VT1",
  },
  "05736": {
    DMA: "VT1",
  },
  "05737": {
    DMA: "VT1",
  },
  "05738": {
    DMA: "VT1",
  },
  "05739": {
    DMA: "VT1",
  },
  "05741": {
    DMA: "VT1",
  },
  "05742": {
    DMA: "VT1",
  },
  "05743": {
    DMA: "VT1",
  },
  "05744": {
    DMA: "VT1",
  },
  "05745": {
    DMA: "VT1",
  },
  "05750": {
    DMA: "VT1",
  },
  "05751": {
    DMA: "VT1",
  },
  "05757": {
    DMA: "VT1",
  },
  "05758": {
    DMA: "VT1",
  },
  "05759": {
    DMA: "VT1",
  },
  "05761": {
    DMA: "VT1",
  },
  "05762": {
    DMA: "VT1",
  },
  "05763": {
    DMA: "VT1",
  },
  "05764": {
    DMA: "VT1",
  },
  "05765": {
    DMA: "VT1",
  },
  "05701": {
    DMA: "VT1",
  },
  "05702": {
    DMA: "VT1",
  },
  "05773": {
    DMA: "VT1",
  },
  "05774": {
    DMA: "VT1",
  },
  "05775": {
    DMA: "VT1",
  },
  "05777": {
    DMA: "VT1",
  },
  "05640": {
    DMA: "VT1",
  },
  "05641": {
    DMA: "VT1",
  },
  "05647": {
    DMA: "VT1",
  },
  "05648": {
    DMA: "VT1",
  },
  "05649": {
    DMA: "VT1",
  },
  "05650": {
    DMA: "VT1",
  },
  "05651": {
    DMA: "VT1",
  },
  "05654": {
    DMA: "VT1",
  },
  "05658": {
    DMA: "VT1",
  },
  "05601": {
    DMA: "VT1",
  },
  "05602": {
    DMA: "VT1",
  },
  "05603": {
    DMA: "VT1",
  },
  "05604": {
    DMA: "VT1",
  },
  "05609": {
    DMA: "VT1",
  },
  "05620": {
    DMA: "VT1",
  },
  "05633": {
    DMA: "VT1",
  },
  "05660": {
    DMA: "VT1",
  },
  "05666": {
    DMA: "VT1",
  },
  "05663": {
    DMA: "VT1",
  },
  "05664": {
    DMA: "VT1",
  },
  "05667": {
    DMA: "VT1",
  },
  "05669": {
    DMA: "VT1",
  },
  "05670": {
    DMA: "VT1",
  },
  "05673": {
    DMA: "VT1",
  },
  "05674": {
    DMA: "VT1",
  },
  "05671": {
    DMA: "VT1",
  },
  "05676": {
    DMA: "VT1",
  },
  "05677": {
    DMA: "VT1",
  },
  "05678": {
    DMA: "VT1",
  },
  "05681": {
    DMA: "VT1",
  },
  "05682": {
    DMA: "VT1",
  },
  "05101": {
    DMA: "VT1",
  },
  "05301": {
    DMA: "VT1",
  },
  "05302": {
    DMA: "VT1",
  },
  "05303": {
    DMA: "VT1",
  },
  "05304": {
    DMA: "VT1",
  },
  "05141": {
    DMA: "VT1",
  },
  "05341": {
    DMA: "VT1",
  },
  "05146": {
    DMA: "VT1",
  },
  "05342": {
    DMA: "VT1",
  },
  "05343": {
    DMA: "VT1",
  },
  "05148": {
    DMA: "VT1",
  },
  "05344": {
    DMA: "VT1",
  },
  "05345": {
    DMA: "VT1",
  },
  "05346": {
    DMA: "VT1",
  },
  "05154": {
    DMA: "VT1",
  },
  "05155": {
    DMA: "VT1",
  },
  "05351": {
    DMA: "VT1",
  },
  "05353": {
    DMA: "VT1",
  },
  "05354": {
    DMA: "VT1",
  },
  "05355": {
    DMA: "VT1",
  },
  "05356": {
    DMA: "VT1",
  },
  "05357": {
    DMA: "VT1",
  },
  "05358": {
    DMA: "VT1",
  },
  "05359": {
    DMA: "VT1",
  },
  "05360": {
    DMA: "VT1",
  },
  "05158": {
    DMA: "VT1",
  },
  "05159": {
    DMA: "VT1",
  },
  "05361": {
    DMA: "VT1",
  },
  "05362": {
    DMA: "VT1",
  },
  "05363": {
    DMA: "VT1",
  },
  "05030": {
    DMA: "VT1",
  },
  "05031": {
    DMA: "VT1",
  },
  "05032": {
    DMA: "VT1",
  },
  "05034": {
    DMA: "VT1",
  },
  "05035": {
    DMA: "VT1",
  },
  "05037": {
    DMA: "VT1",
  },
  "05142": {
    DMA: "VT1",
  },
  "05143": {
    DMA: "VT1",
  },
  "05144": {
    DMA: "VT1",
  },
  "05746": {
    DMA: "VT1",
  },
  "05047": {
    DMA: "VT1",
  },
  "05048": {
    DMA: "VT1",
  },
  "05049": {
    DMA: "VT1",
  },
  "05149": {
    DMA: "VT1",
  },
  "05052": {
    DMA: "VT1",
  },
  "05053": {
    DMA: "VT1",
  },
  "05150": {
    DMA: "VT1",
  },
  "05055": {
    DMA: "VT1",
  },
  "05151": {
    DMA: "VT1",
  },
  "05056": {
    DMA: "VT1",
  },
  "05153": {
    DMA: "VT1",
  },
  "05059": {
    DMA: "VT1",
  },
  "05062": {
    DMA: "VT1",
  },
  "05767": {
    DMA: "VT1",
  },
  "05065": {
    DMA: "VT1",
  },
  "05067": {
    DMA: "VT1",
  },
  "05068": {
    DMA: "VT1",
  },
  "05071": {
    DMA: "VT1",
  },
  "05156": {
    DMA: "VT1",
  },
  "05772": {
    DMA: "VT1",
  },
  "05073": {
    DMA: "VT1",
  },
  "05084": {
    DMA: "VT1",
  },
  "05161": {
    DMA: "VT1",
  },
  "05001": {
    DMA: "VT1",
  },
  "05009": {
    DMA: "VT1",
  },
  "05088": {
    DMA: "VT1",
  },
  "05089": {
    DMA: "VT1",
  },
  "05091": {
    DMA: "VT1",
  },
};
